
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9fb6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9fb6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8JYDX", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");
var $ab6076c88a029044$exports = {};
$ab6076c88a029044$exports = JSON.parse('{"search":{"en":"Search","es":"Buscar","pt":"Pesquisar"},"label":{"en":"Label","es":"Etiqueta","pt":"Etiqueta"},"showmore":{"en":"Show more","es":"Mostrar m\xe1s","pt":"Mostrar mais"},"all":{"en":"ALL","es":"TODOS","PT":"TODOS"},"moreinfo":{"en":"More information","es":"M\xe1s informaci\xf3n"},"user":{"en":"User","es":"Usuario"},"homelocrel":{"en":"..","es":"../es"},"flaglang":{"en":"\uD83C\uDDEC\uD83C\uDDE7 EN","es":"\uD83C\uDDEA\uD83C\uDDF8 ES"},"spinnerLoading":{"en":"Loading data...","es":"Cargando datos..."},"spinnerInfo":{"en":"We are querying our fancy databases.","es":"Estamos haciendo consultas nuestras molonas bases de datos."},"ntrees":{"en":" trees in this area","es":" \xe1rboles en esta zona"},"questtext":{"en":"Please answer a questionnaire<br>to help us to improve.","es":"Responde a un cuestionario<br>para ayudarnos a mejorar.","pt":"Quer responder a um question\xe1rio<br>para nos ajudar a melhorar?"},"questurl":{"en":"https://docs.google.com/forms/d/e/1FAIpQLSdj2YL-1yZFMFBi0dWHDnlOKp5oWg_58DkM7fAWykSgmONKZw/viewform?usp=sf_link","es":"https://docs.google.com/forms/d/e/1FAIpQLSdjLezgl169v5nCY2Y1bLskDimEy_rbDwO4GhMdQ2YdKijmPg/viewform?usp=sf_link"},"yes":{"en":"Yes","es":"S\xed","pt":"Sim"},"no":{"en":"No","es":"No","pt":"N\xe3o"},"later":{"en":"Maybe later","es":"M\xe1s tarde","pt":"Talvez mais tarde"},"errorEndpointTitle":{"en":"Data provider not accessible","es":"No puede accederse al proveedor de datos","pt":"Provedor de dados n\xe3o acess\xedvel"},"errorEndpointText":{"en":"The data provider is temporarily not accessible. \\t\\t\\tWe apologize for the inconvenience and recommend to try later.","es":"El proveedor de datos est\xe1 temporalmente no disponible. \\t\\t\\tLamentamos este inconveniente y recomendamos que pruebe m\xe1s tarde.","pt":"Servidor de dados est\xe1 temporariamente indispon\xedvel. \\t\\t\\tPedimos desculpas pelo transtorno e recomendamos que tente mais tarde."},"close":{"en":"Close","es":"Cerrar","pt":"Fechar"},"errorEducatreeTitle":{"en":"The tree does not exist","es":"No existe el \xe1rbol"},"errorEducatreeText":{"en":"There is no tree with identifier ","es":"No existe un \xe1rbol con identificador "},"zoomin":{"en":"Zoom in","es":"M\xe1s zoom","pt":"Aproximar"},"zoomout":{"en":"Zoom out","es":"Menos zoom","pt":"Afastar"},"mylocation":{"en":"My location","es":"Mi localizaci\xf3n","pt":"Minha localiza\xe7\xe3o"},"viewIFN":{"en":"View IFN trees","es":"Ver \xe1rboles IFN"},"refresh":{"en":"Refresh data","es":"Refrescar datos"},"esri":{"en":"Esri layer","es":"Capa Esri"},"downloadData":{"en":"Download data","es":"Descargar datos"},"tour":{"en":"Tour","es":"Tour"},"fullmap":{"en":"Full map","es":"Mapa completo"},"download":{"en":"Download","es":"Descargar"},"cancelPolygon":{"en":"Cancel polygon","es":"Cancelar pol\xedgono"},"finish":{"en":"Finish","es":"Terminar"},"finishPolygon":{"en":"Finish polygon","es":"Terminar pol\xedgono"},"deleteLastPoint":{"en":"Delete last point","es":"Borrar \xfaltimo punto"},"deleteLastPointDrawn":{"en":"Delete last point drawn","es":"Borrar \xfaltimo punto dibujado"},"startPolygon":{"en":"Click to start drawing the polygon.","es":"Clica para empezar a dibujar el pol\xedgono."},"contPolygon":{"en":"Click to continue drawing the polygon.","es":"Clica para continuar dibujando el pol\xedgono."},"endPolygon":{"en":"Click first point to close the polygon.","es":"Clica el primer punto para cerrar el pol\xedgono."},"errorPolygon":{"en":"<strong>Error:</strong> polygon lines cannot cross!","es":"<strong>Error:</strong> \xa1no pueden cruzarse las l\xedneas del pol\xedgono!"},"downloadMessage":{"en":"You will retrieve tree data within the polygon you have just drawn.","es":"Obtendr\xe1s los datos de los \xe1rboles en el pol\xedgono que acabas de dibujar."},"downloadMessagePrev":{"en":"You will get a file with the trees located within the currently visible area of the map:","es":"Obtendr\xe1s un fichero con los \xe1rboles comprendidos en la zona visible del mapa:"},"downloadChoices":{"en":"Choose what to download:","es":"Elige qu\xe9 quieres descargar:"},"checkTrees":{"en":"Summarized reports of EducaWood trees","es":"Fichas resumidas de \xe1rboles de EducaWood"},"checkAnnotations":{"en":"All annotations of EducaWood trees","es":"Todas las anotaciones de los \xe1rboles de EducaWood"},"downloadClusterNote":{"en":"Downloaded data may include tree clusters if the zoom is too low.","es":"Los datos descargados pueden incluir agrupaciones de \xe1rboles si el zoom es demasiado bajo."},"downloadNothing":{"en":"Nothing to download!","es":"\xa1No hay nada que descargar!"},"downloadNoFormat":{"en":"No format selected!","es":"\xa1No hay formato seleccionado!"},"downloadFormatChoose":{"en":"Choose your preferred data format:","es":"Elige el formato de datos:"},"downloadingTrees":{"en":"Downloading EducaWood trees","es":"Descargando \xe1rboles de EducaWood"},"treesDownloaded":{"en":"EducaWood trees downloaded","es":"\xc1rboles de EducaWood descargados"},"noTreesDownloaded":{"en":"No EducaWood trees to download","es":"No hab\xeda \xe1rboles de EducaWood para descargar"},"educawoodTrees":{"en":"EducaWood trees","es":"\xe1rboles de EducaWood"},"educawoodClusters":{"en":"tree clusters","es":"agrupaciones de \xe1rboles"},"downloadingAnnotations":{"en":"Downloading annotations of EducaWood trees","es":"Descargando anotaciones de \xe1rboles de EducaWood"},"educawoodAnnotations":{"en":"annotations of EducaWood trees","es":"anotaciones de \xe1rboles de EducaWood"},"noAnnotationsDownloaded":{"en":"No annotations of EducaWood trees to download","es":"No hab\xeda anotaciones de \xe1rboles de EducaWood para descargar"},"downloadSuccess":{"en":"Download successful","es":"Descarga de datos exitosa"},"toastDownload":{"en":"Wait until all data has been retrieved.","es":"Espera a que acabe de recuperar los datos."},"toastDownloadPolygon":{"en":"Draw a polygon for the data download","es":"Dibuja un pol\xedgono para la descarga de datos"},"toastZoom":{"en":"You need to zoom in to create trees.","es":"Para crear \xe1rboles tienes que aumentar el zoom."},"toastUser":{"en":"You need to sign up (top-right button) to create trees.","es":"Necesitas iniciar sesi\xf3n (bot\xf3n superior derecha) para crear \xe1rboles."},"toastCreateTree":{"en":"Push the map location where the new tree is situated.","es":"Pulsa la posici\xf3n del mapa en la que el nuevo \xe1rbol est\xe1 situado."},"home":{"en":"Home","es":"Inicio","pt":"In\xedcio"},"map":{"en":"Map","es":"Mapa"},"lastTrees":{"en":"Last trees","es":"\xdaltimos \xe1rboles"},"color0":{"en":"Green","es":"Verde","pt":"Verde"},"color1":{"en":"Gray","es":"Gris","pt":"Cinzento"},"color2":{"en":"Blue gray","es":"Gris azulado","pt":"Cinzento azulado"},"color3":{"en":"Orange","es":"Naranja","pt":"Laranja"},"color4":{"en":"Blue","es":"Azul","pt":"Azul"},"color5":{"en":"Pink","es":"Rosa","pt":"Rosa"},"color6":{"en":"Purple","es":"Violeta","pt":"Roxo"},"color7":{"en":"Indigo","es":"A\xf1il","pt":"Azul \xedndigo"},"color8":{"en":"Cyan","es":"Celeste","pt":"Ciano"},"color9":{"en":"Brown","es":"Marr\xf3n","pt":"Castanho"},"searchplace":{"en":"Search place...","es":"Buscar lugar...","pt":"Pesquisar lugar..."},"noplacesfound":{"en":"No places matched","es":"No hay lugares que coincidan","pt":"Nenhum lugar encontrado"},"population":{"en":"Population","es":"Poblaci\xf3n","pt":"Popula\xe7\xe3o"},"PPLC":{"en":"Capital of a country","es":"Capital de pa\xeds","pt":"Capital de pa\xeds"},"PPLA":{"en":"Seat of an autonomous region","es":"Capital de comunidad aut\xf3noma","pt":"Capital de uma regi\xe3o aut\xf3noma"},"PPLA2":{"en":"Seat of a province","es":"Capital de provincia","pt":"Capital de uma prov\xedncia"},"PPLA3":{"en":"Municipality","es":"Municipio","pt":"Munic\xedpio"},"PPLA4":{"en":"Populated place","es":"Poblaci\xf3n","pt":"Povoa\xe7\xe3o"},"PPL":{"en":"Populated place","es":"Poblaci\xf3n","pt":"Povoa\xe7\xe3o"},"FRST":{"en":"Forest","es":"Bosque","pt":"Floresta"},"HLL":{"en":"Hill","es":"Cerro","pt":"Colina"},"HLLS":{"en":"Hills","es":"Cerros","pt":"Colinas"},"MT":{"en":"Mountain","es":"Monta\xf1a","pt":"Montanha"},"MTS":{"en":"Mountains","es":"Monta\xf1as","pt":"Montanhas"},"PRK":{"en":"Park","es":"Parque","pt":"Parque"},"RDGE":{"en":"Ridge","es":"Sierra","pt":"Cume"},"RES":{"en":"Reserve","es":"Reserva","pt":"Reserva"},"RESF":{"en":"Forest reserve","es":"Reserva forestal","pt":"Reserva florestal"},"RESN":{"en":"Nature reserve","es":"Reserva natural","pt":"Reserva natural"},"RESW":{"en":"Wildlife reserve","es":"Reserva natural","pt":"Reserva natural"},"VAL":{"en":"Valley","es":"Valle","pt":"Vale"},"VALG":{"en":"Hanging valley","es":"Valle glaciar","pt":"Vale glaciar"},"taxonfilter":{"en":"Taxon","es":"Tax\xf3n","pt":"T\xe1xon"},"filter":{"en":"Filter","es":"Filtrar","pt":"Filtro"},"filtering":{"en":"Filtering","es":"Filtrando","pt":"Filtrando"},"removefilter":{"en":"Remove filter","es":"Quitar filtro","pt":"Remover filtro"},"searchtaxon":{"en":"Search taxon...","es":"Buscar tax\xf3n...","pt":"Pesquisar t\xe1xon..."},"notaxonfound":{"en":"No taxon matched","es":"No hay taxones que coincidan","pt":"N\xe3o h\xe1 taxa que coincidam"},"taxonid":{"es":"Tax\xf3n con id ","pt":"T\xe1xon com id "},"nomci":{"en":"Scientific names","es":"Nombres cient\xedficos","pt":"Nomes cient\xedficos"},"taxoninfo":{"en":"Taxon info","es":"Informaci\xf3n de tax\xf3n","pt":"Informa\xe7\xe3o de t\xe1xon"},"speciesinfo":{"en":"Species info","es":"Informaci\xf3n de especies","pt":"Informa\xe7\xe3o de esp\xe9cie"},"species":{"en":"Species","es":"Especie","pt":"Esp\xe9cie"},"genus":{"en":"Genus","es":"G\xe9nero","pt":"G\xe9nero"},"family":{"en":"Family","es":"Familia","pt":"Fam\xedlia"},"class":{"en":"Class","es":"Clase","pt":"Classe"},"importtaxon":{"en":"Import taxon","es":"Importar tax\xf3n"},"typesomething":{"en":"Type something.","es":"Escribe algo."},"typesomethingmore":{"en":"Type something more.","es":"Escribe algo m\xe1s."},"notaxonsfound":{"en":"No taxons found","es":"No se encontraron taxones"},"obtainingtaxons":{"en":"Obtaining taxons...","es":"Recuperando taxones..."},"tryanotherstring":{"en":"Try another string.","es":"Prueba con otra cadena."},"selectataxon":{"en":"Select a taxon.","es":"Selecciona un tax\xf3n."},"obtainingtaxondata":{"en":"Obtaining taxon data...","es":"Recuperando los datos del tax\xf3n..."},"readytoimport":{"en":"Ready to import.","es":"Listo para importar."},"taxonalreadyimported":{"en":"<b style=\\"color:red;\\">Taxon already imported!</b>","es":"<b style=\\"color:red;\\">\xa1El tax\xf3n ya ha sido importado!</b>"},"importingthetaxon":{"en":"Importing the taxon. Please wait...","es":"Importando el tax\xf3n. Por favor, espera..."},"taxonimported":{"en":"Taxon imported.","es":"Tax\xf3n importado."},"taxonimportingerror":{"en":"Error importing the taxon","es":"Error al importar el tax\xf3n"},"createtree":{"en":"Create tree","es":"Crear \xe1rbol"},"newtree":{"en":"New tree","es":"Nuevo \xe1rbol"},"formopt":{"en":"All form elements are optional.","es":"Todos los elementos del formulario son opcionales."},"signupToCreate":{"en":"Sign in to create trees.","es":"Inicia sesi\xf3n para crear \xe1rboles."},"location":{"en":"Location","es":"Localizaci\xf3n"},"position":{"en":"Position (WGS 84)","es":"Posici\xf3n (WGS 84)"},"dragmarker":{"en":"Drag the red marker to change the location of the new tree.","es":"Desplaza el marcador rojo para cambiar la localizaci\xf3n del nuevo \xe1rbol."},"mapclue":{"en":"Drag the map to change the position of the tree (red marker).","es":"Desplaza el mapa para cambiar la posici\xf3n del \xe1rbol (marcador rojo)."},"treenick":{"en":"Tree nick","es":"Apodo \xe1rbol"},"treetaxon":{"en":"Tree taxon","es":"Tax\xf3n \xe1rbol"},"photo":{"en":"Photo","es":"Foto"},"nophoto":{"en":"No tree photo.","es":"No hay foto del \xe1rbol."},"photouploaded":{"en":"Tree photo uploaded.","es":"Foto del \xe1rbol subida."},"partplanselection":{"en":"Select the part of the tree in the photo","es":"Selecciona la parte del \xe1rbol en la foto"},"heightm":{"en":"Height (m)","es":"Altura (m)"},"enterheightm":{"en":"Tree height in meters","es":"Altura del \xe1rbol en metros"},"diametermm":{"en":"Diameter (mm)","es":"Di\xe1metro (mm)"},"enterdiametermm":{"en":"Tree diameter at breast height in millimeters","es":"Di\xe1metro del \xe1rbol a la altura del pecho en mil\xedmetros"},"perimetermm":{"en":"Perimeter (mm)","es":"Per\xedmetro (mm)"},"enterperimetermm":{"en":"Tree perimeter at breast height in millimeters","es":"Per\xedmetro del \xe1rbol a la altura del pecho en mil\xedmetros"},"treeobservation":{"en":"Observation","es":"Observaci\xf3n"},"yourobservation":{"en":"Your observation","es":"Tu observaci\xf3n"},"cancel":{"en":"Cancel","es":"Cancelar"},"treeStatus":{"en":"Tree status","es":"Estado \xe1rbol"},"treestatusselection":{"en":"Select tree status","es":"Selecciona el estado del \xe1rbol"},"AliveTreeAnnotation":{"en":"Alive tree","es":"\xc1rbol vivo"},"DecliningTreeAnnotation":{"en":"Declining tree","es":"\xc1rbol en declive"},"DeadTreeAnnotation":{"en":"Dead tree","es":"\xc1rbol muerto"},"DeadTreeWithBarkAnnotation":{"en":"Dead tree with bark","es":"\xc1rbol muerto con corteza"},"DeadTreeWithLooseBarkAnnotation":{"en":"Dead tree with loose bark","es":"\xc1rbol muerto con corteza suelta"},"DeadTreeWithNoBarkAnnotation":{"en":"Dead tree with no bark","es":"\xc1rbol muerto sin corteza"},"DecomposedTreeAnnotation":{"en":"Decomposed dead tree","es":"\xc1rbol descompuesto"},"StumpAnnotation":{"en":"Stump","es":"Toc\xf3n"},"uploadingphoto":{"en":"Uploading photo...","es":"Subiendo foto..."},"uploadingphotoerror":{"en":"Error uploading the photo","es":"Error al subir la foto"},"deletingphotoerror":{"en":"Error deleting the photo","es":"Error al borrar la foto"},"creatingtree":{"en":"Creating the tree...","es":"Creando el \xe1rbol..."},"treecreationerror":{"en":"Error creating the tree","es":"Error al crear el \xe1rbol"},"treecreationsuccess":{"en":"The tree has been created","es":"Se ha creado el \xe1rbol"},"pleasewait":{"en":"Please wait.","es":"Por favor, espere"},"back":{"en":"Go back","es":"Volver"},"viewtree":{"en":"View tree","es":"Ver \xe1rbol"},"newAnnotation":{"en":"New annotation","es":"Nueva anotaci\xf3n"},"createAnnotation":{"en":"Create annotation","es":"Crear anotaci\xf3n"},"noAnnotation":{"en":"No annotation.","es":"No hay anotaci\xf3n."},"sameAnnotation":{"en":"Same annotation as the current value.","es":"Misma anotaci\xf3n que el valor actual."},"outOfRangeAnnotation":{"en":"Out of range annotation.","es":"Anotaci\xf3n fuera de rango."},"deleteAnnotation":{"en":"Delete annotation","es":"Borrar anotaci\xf3n"},"deleteAnnotationInfo":{"en":"Are you sure that you want to delete this annotation? This action cannot be reversed.","es":"\xbfEst\xe1s seguro de que quieres borrar esta anotaci\xf3n? Esta acci\xf3n no puede revertirse."},"deletingAnnotation":{"en":"Deleting the annotation...","es":"Borrando la anotaci\xf3n..."},"deleteAnnotationError":{"en":"Error deleting the annotation","es":"Error al borrar la anotaci\xf3n"},"deleteAnnotationSuccess":{"en":"The annotation has been deleted","es":"Se ha borrado la anotaci\xf3n"},"creatingannotation":{"en":"Creating the annotation...","es":"Creando la anotaci\xf3n..."},"treeannotationerror":{"en":"Error creating the annotation","es":"Error al crear la anotaci\xf3n"},"treeannotationsuccess":{"en":"The annotation has been created","es":"Se ha creado la anotaci\xf3n"},"formerPositions":{"en":"Former positions","es":"Posiciones anteriores"},"formerTreeTaxons":{"en":"Former taxons","es":"Taxones anteriores"},"formerTreeStatus":{"en":"Former statuses","es":"Estados anteriores"},"formerHeights":{"en":"Former heights","es":"Alturas anteriores"},"formerDiameters":{"en":"Former diameters","es":"Di\xe1metros anteriores"},"observations":{"en":"Observations","es":"Observaciones"},"moreobservations":{"en":"More observations","es":"M\xe1s observaciones"},"delete":{"en":"Delete","es":"Borrar"},"deleteTree":{"en":"Delete the tree","es":"Borrar el \xe1rbol"},"deleteTreeInfo":{"en":"Are you sure that you want to delete this tree and all its associated data? This action cannot be reversed.","es":"\xbfEst\xe1s seguro de que quieres borrar este \xe1rbol y todos sus datos? Esta acci\xf3n no puede revertirse."},"deletingtree":{"en":"Deleting the tree...","es":"Borrando el \xe1rbol..."},"treedeletionerror":{"en":"Error deleting the tree","es":"Error al borrar el \xe1rbol"},"treedeletionsuccess":{"en":"The tree has been deleted","es":"Se ha borrado el \xe1rbol"},"tree":{"en":"Tree","es":"\xc1rbol","pt":"\xc1rvore"},"trees":{"en":"trees","es":"\xe1rboles","pt":"\xe1rvores"},"height":{"en":"Height","es":"Altura","pt":"Altura"},"diameter":{"en":"Diameter","es":"Di\xe1metro","pt":"Di\xe2metro"},"created":{"en":"Created","es":"Creaci\xf3n"},"createdBy":{"en":"Created by ","es":"Creado por ","pt":"Criado por "},"annotatedBy":{"en":"Annotated by ","es":"Anotado por "},"createdByIFN":{"en":"Source IFNv3","es":"Fuente IFNv3","pt":"Fonte IFNv3"},"onDate":{"en":" on ","es":" el "},"ofTree":{"en":" of","es":" del"},"createdOn":{"en":"Created on ","es":"Creado el "},"creator":{"en":"Creator ","es":"Creador"},"annotationType":{"en":"Type","es":"Tipo"},"date":{"en":"Date","es":"Fecha"},"annotator":{"en":"Annotator","es":"Anotador"},"annotatedOn":{"en":"Annotated on ","es":"Anotado el "},"noCreatedTrees":{"en":"No created trees","es":"Ning\xfan \xe1rbol creado"},"noAnnotations":{"en":"No annotations","es":"Ninguna anotaci\xf3n"},"lastCreatedTrees":{"en":"Last created trees","es":"\xdaltimos \xe1rboles creados"},"lastAnnotations":{"en":"Last annotations","es":"\xdaltimas anotaciones"},"page":{"en":"Page","es":"P\xe1gina"},"latitude":{"en":"lat","es":"lat"},"longitude":{"en":"lng","es":"lng"},"signin":{"en":"Sign in","es":"Inicia sesi\xf3n"},"signout":{"en":"Sign out","es":"Salir"},"viewProfile":{"en":"View profile","es":"Ver perfil"},"newNick":{"en":"New nick","es":"Nuevo apodo"},"newTreeNick":{"en":"New tree nick","es":"Nuevo apodo del \xe1rbol"},"changeNick":{"en":"Change nick","es":"Cambiar apodo"},"change":{"en":"Change","es":"Cambiar"},"newNickTip":{"en":"Your cool new nick...","es":"Tu nuevo apodo..."},"newTreeNickTip":{"en":"A cool nick for this tree...","es":"Un apodo para este \xe1rbol..."},"noNick":{"en":"No nick.","es":"No hay apodo."},"nickTooshort":{"en":"Nick too short.","es":"Apodo demasiado corto."},"nickToolong":{"en":"Nick too long.","es":"Apodo demasiado largo."},"checkingNick":{"en":"Checking the nick...","es":"Comprobando el apodo..."},"nickTaken":{"en":"Nick already taken.","es":"Apodo ya cogido."},"changeNickSuccess":{"en":"Nick changed","es":"Apodo cambiado"},"changeNickFailure":{"en":"Nick change failed","es":"Fall\xf3 el cambio de apodo"},"changeTreeNickSuccess":{"en":"Tree nick changed","es":"Apodo de \xe1rbol cambiado"},"changeTreeNickFailure":{"en":"Tree nick change failed","es":"Fall\xf3 el cambio de apodo del \xe1rbol"},"errorUserTitle":{"en":"The user does not exist","es":"No existe el usuario"},"errorUserText":{"en":"There is no user with identifier ","es":"No existe un usuario con identificador "},"userActive":{"en":"\uD83D\uDCC5 active since ","es":"\uD83D\uDCC5 activo desde "},"isMaster":{"en":"\uD83D\uDE0E is master","es":"\uD83D\uDE0E es m\xe1ster"},"cannotAnnotate":{"en":"\uD83D\uDC80 cannot annotate","es":"\uD83D\uDC80 no puede anotar"},"oneTreeCreated":{"en":"\uD83C\uDF33 creator of one tree","es":"\uD83C\uDF33 creador de un \xe1rbol"},"multipleTreesCreated":{"en":"\uD83C\uDF33 creator of %d trees","es":"\uD83C\uDF33 creador de %d \xe1rboles"},"oneAnnotation":{"en":"\uD83C\uDF32 creator of one annotation","es":"\uD83C\uDF32 creador de una anotaci\xf3n"},"multipleAnnotations":{"en":"\uD83C\uDF32 creator of %d annotations","es":"\uD83C\uDF32 creador de %d anotaciones"},"local":{"en":"en","es":"es","pt":"pt"},"tourTitle0":{"en":"Welcome","es":"Bienvenido"},"tourText0":{"en":"Welcome to EducaWood! There are a lot of things you can do with this application. Let\'s review the map controls.<br><br><i>You can exit this tour at any time by pushing the \'X\'.</i>","es":"\xa1Bienvenido a EducaWood! Hay muchas cosas que puedes hacer con esta aplicaci\xf3n. Empecemos revisando los controles.<br><br><i>Puedes salir de este tour en cualquier momento pulsando la \'X\'.</i>"},"tourTitle1":{"en":"The map","es":"El mapa"},"tourText1":{"en":"This is the main screen of EducaWood. Most of the actions in the application are initiated in this view.<br>You can use the touchscreen (or the mouse in PCs) for panning and zooming the map.","es":"\xc9sta es la pantalla principal de EducaWood. La mayor\xeda de las acciones posibles se inician aqu\xed.<br>Puedes usar la pantalla t\xe1ctil (o el rat\xf3n si es un PC) para mover el mapa o para hacer zoom."},"tourTitle2":{"en":"Zoom buttons","es":"Botones de zoom"},"tourText2":{"en":"You can also use these buttons for zooming in or out.","es":"Tambi\xe9n puedes usar estos botones para controlar el nivel de zoom."},"tourTitle3":{"en":"My location","es":"Mi localizaci\xf3n"},"tourText3":{"en":"Push this button to center the map in your current location. Please note that you need to grant permission to your browser.<br>In case of success, a blue dot will mark your location in the map (precision can vary).<br>Push the button again to remove the blue dot.","es":"Pulsa este bot\xf3n para centrar el mapa en tu posici\xf3n actual. Ten en cuenta que necesitas dar permiso al navegador para obtener tu posici\xf3n. En caso de \xe9xito, un punto azul marcar\xe1 tu posici\xf3n en el mapa (la precisi\xf3n puede variar).<br>Pulsa de nuevo el bot\xf3n para esconder el punto azul."},"tourTitle4":{"en":"Your profile","es":"Tu perfil"},"tourText4":{"en":"This is your avatar in EducaWood. Push it to view your profile or to sign out.","es":"\xc9ste es tu avatar en EducaWood. Pulsa en \xe9l para ver tu perfil o para cerrar la sesi\xf3n."},"tourTitle5":{"en":"Sign in","es":"Inicia sesi\xf3n"},"tourText5":{"en":"Push to sign in (a Google account is needed). This allows you to create and annotate trees in EducaWood.","es":"Pulsa para iniciar sesi\xf3n (requiere una cuenta de Google). Esto te permite crear y anotar \xe1rboles en EducaWood."},"tourTitle6":{"en":"Create trees","es":"Crea \xe1rboles"},"tourText6":{"en":"Push to create a new tree.<br>This button is only enabled if (1) you have signed in and (2) the zoom level is high enough.<br>After clicking this button, push the map location where the new tree will be created.","es":"Pulsa para crear un \xe1rbol.<br>El bot\xf3n s\xf3lo estar\xe1 habilitado si (1) has iniciado sesi\xf3n y (2) el nivel de zoom es suficientemente alto.<br>Tras clickar este bot\xf3n, pulsa la localizaci\xf3n del mapa en la que quieres crear el \xe1rbol."},"tourTitle7":{"en":"View IFN trees","es":"Ver \xe1rboles IFN"},"tourText7":{"en":"Push to show the IFN trees in the map view.<br>IFN is the official Spanish inventory of trees, so this functionality is only useful in Spain.","es":"Pulsa para mostrar los \xe1rboles del IFN en la vista del mapa.<br>IFN es el inventario oficial espa\xf1ol de \xe1rboles, por lo que esta funcionalidad s\xf3lo es \xfatil en Espa\xf1a."},"tourTitle7a":{"en":"Change map layer","es":"Cambia la capa del mapa"},"tourText7a":{"en":"Push to switch between the maps from OpenStreetMap and Esri.","es":"Pulsa para alternar entre los mapas de OpenStreetMap y Esri."},"tourTitle8":{"en":"Refresh data","es":"Refrescar datos"},"tourText8":{"en":"Push to force the application to gather fresh tree data from the server.<br>This is only needed to get the last minute updates, i.e. to obtain the trees that have just been created in the map view.","es":"Pulsa para obligar a la aplicaci\xf3n a recuperar los \xfaltimos datos de \xe1rboles del servidor.<br>Esto s\xf3lo hace falta para obtener las actualizaciones del \xfaltimo minuto, es decir, los \xe1rboles que acaban de crearse en la vista del mapa."},"tourTitle9":{"en":"Download data","es":"Descarga de datos"},"tourText9":{"en":"Download tree data in the visible area of the map.","es":"Descarga los datos de \xe1rboles de la zona visible del mapa."},"tourTitle10":{"en":"Filter taxon","es":"Filtrar tax\xf3n"},"tourText10":{"en":"Filter the trees in the map by taxon.","es":"Filtra los \xe1rboles en el mapa por tax\xf3n."},"tourTitle11":{"en":"Taxa names","es":"Nombres de taxones"},"tourText11":{"en":"Toggle button to choose between scientific or vulgar taxon names.","es":"Bot\xf3n para elegir entre nombres taxon\xf3micos cient\xedficos o vulgares."},"tourTitle12":{"en":"Search places","es":"Buscar lugares"},"tourText12":{"en":"Center the map in a specific a place by typing its name.","es":"Centra el mapa en el lugar deseado al teclear su nombre."},"tourTitle13":{"en":"More options","es":"M\xe1s opciones"},"tourText13":{"en":"Push to go to the landing or the last trees pages.","es":"Pulsa para ir a las p\xe1ginas de inicio o a la de \xfaltimos \xe1rboles creados."},"tourTitle14":{"en":"The end","es":"Hemos terminado"},"tourText14":{"en":"That\'s all for now. Enjoy EducaWood!","es":"Esto es todo por ahora. \xa1Disfruta de EducaWood!"},"tourExit":{"en":"Exit","es":"Salir"},"tourNext":{"en":"Next","es":"Siguiente"},"tourBack":{"en":"Back","es":"Atr\xe1s"},"tourDone":{"en":"Done","es":"Hecho"}}');


/*
   Copyright 2023, Guillermo Vega-Gorgojo
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at
       http://www.apache.org/licenses/LICENSE-2.0
   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");


var $2q7Wm = parcelRequire("2q7Wm");

var $6KOho = parcelRequire("6KOho");

// GENERACIÓN DEL ID
// nanoid: https://github.com/ai/nanoid/
// versión de https://cdn.jsdelivr.net/npm/nanoid/nanoid.js
let $96abbdd7193a3c4b$var$nanoid = (t = 21)=>crypto.getRandomValues(new Uint8Array(t)).reduce((t, e)=>t += (e &= 63) < 36 ? e.toString(36) : e < 62 ? (e - 26).toString(36).toUpperCase() : e > 62 ? "-" : "_", "");
function $96abbdd7193a3c4b$export$567fc7097e064344(length) {
    let id = $96abbdd7193a3c4b$var$nanoid(length);
    // no permito que el id empiece por '-' (ver qnames https://en.wikipedia.org/wiki/QName)
    if (id.startsWith("-")) id = id.replace("-", "_");
    return id;
}
// PARSING LOCATIONS
function $96abbdd7193a3c4b$export$6f6326edee345e29(cad) {
    const cachos = cad.split(",");
    if (cachos.length == 3) {
        const latpars = cachos[0];
        const lngpars = cachos[1];
        const zpars = cachos[2].split("z")[0];
        // compruebo que los valores estén bien antes de reajustar
        if (!isNaN(Number(latpars))) {
            if (!isNaN(Number(lngpars))) {
                if (Number.isInteger(Number(zpars))) {
                    if (Number(latpars) >= -90 && Number(latpars) <= 90) {
                        // LOCALIZACIÓN CORRECTA
                        let obj = {
                            lat: Number(latpars),
                            lng: Number(lngpars),
                            z: Number(zpars)
                        };
                        return obj;
                    }
                }
            }
        }
    }
    // si no consigo hacer el parsing con éxito
    return null;
}
function $96abbdd7193a3c4b$export$4a32c72e9ff1d1e0(loc) {
    // aquí no hago comprobaciones del objeto loc
    return loc.lat.toFixed(6) + "," + loc.lng.toFixed(6) + "," + loc.z + "z";
}
// LENGUAJE Y LITERALES
// obtengo lenguaje preferido
function $96abbdd7193a3c4b$export$350964a2fface462() {
    let lang = localStorage.getItem("lang");
    if (!lang) {
        // elijo automáticamente a partir del lenguaje del navegador
        const preflangs = window.navigator.languages || [
            window.navigator.language || window.navigator.userLanguage
        ];
        for (let ltag of preflangs){
            const langev = ltag.substring(0, 2);
            if ((0, $2q7Wm.default).contains((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).langs, langev)) {
                lang = langev;
                break;
            }
        }
        if (!lang) lang = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).langs[0]; // inglés
    }
    return lang;
}
// la uso para comprobar si cadgrande incluye cadpeq utilizando cadenas normalizadas
function $96abbdd7193a3c4b$export$bc11d730045994ef(cadgrande, cadpeq) {
    // normalizo cadenas según: https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
    // adicionalmente las pongo en minúsculas para comparar
    var cgnorm = cadgrande.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    var cpnorm = cadpeq.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    return cgnorm.indexOf(cpnorm);
}
function $96abbdd7193a3c4b$export$177dc95d91ec95d1(litobj, def) {
    // si no está definido el objeto, valor por defecto
    if (litobj == undefined) return def;
    // 5/3/21 si es un array, convierto a un objeto
    if (Array.isArray(litobj)) {
        let aux = {};
        for(let i = 0; i < litobj.length; i++){
            const el = litobj[i];
            if (typeof el === "object") {
                // incluyo en aux los pares clave-valor
                const claves = Object.keys(el);
                for(let j = 0; j < claves.length; j++){
                    const clave = claves[j];
                    aux[clave] = el[clave];
                }
            } else aux[(0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).nolang] = el;
        }
        // cambio el objeto a analizar
        litobj = aux;
    } else if (typeof litobj !== "object") {
        let aux = {};
        aux[(0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).nolang] = litobj;
        litobj = aux;
    }
    // 2023-11 permito elegir el idioma
    let lang = $96abbdd7193a3c4b$export$350964a2fface462();
    // devuelvo la cadena en el lenguaje elegido si existe
    if (litobj[lang]) return litobj[lang];
    // en otro caso devuelvo la cadena sin etiqueta de idioma
    if (litobj[(0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).nolang]) return litobj[(0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).nolang];
    // pruebo en latín...
    if (litobj["la"]) return litobj["la"];
    // cadena por defecto en otro caso...
    if (def) return def;
    // pruebo con el resto de lenguas de la configuración
    for (let ltag of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).langs){
        if (ltag !== lang && litobj[ltag]) return litobj[ltag];
    }
    // nada que hacer...
    return undefined;
}
function $96abbdd7193a3c4b$export$1690e12b840569b9(obj) {
    let cad = null;
    if (obj.latWGS84 && obj.lngWGS84) cad = $96abbdd7193a3c4b$export$177dc95d91ec95d1((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).latitude) + " " + obj.latWGS84.toFixed(6) + ", " + $96abbdd7193a3c4b$export$177dc95d91ec95d1((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).longitude) + " " + obj.lngWGS84.toFixed(6); // + " (WGS 84)";
    return cad;
}
function $96abbdd7193a3c4b$export$4d0c182344beaa87(obj, pref) {
    let cad = null;
    if (obj.creator) {
        cad = pref + $96abbdd7193a3c4b$export$6efd817d0963408a(obj, true);
        // fecha
        const fecha = $96abbdd7193a3c4b$export$aa350b96d91cd94(obj);
        if (fecha) cad += $96abbdd7193a3c4b$export$177dc95d91ec95d1((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).onDate) + fecha;
    }
    return cad;
}
function $96abbdd7193a3c4b$export$6efd817d0963408a(obj, conhiperenlace) {
    const target = obj.creator ? obj.creator : obj;
    if (target) {
        const criri = target.iri ? $96abbdd7193a3c4b$export$177dc95d91ec95d1(target.iri) : $96abbdd7193a3c4b$export$177dc95d91ec95d1(target);
        const uid = criri.lastIndexOf("/") === -1 ? criri : criri.substring(criri.lastIndexOf("/") + 1);
        // cojo primero el nick en Datos.usuarios[uid] (por si actualizó su nick),
        // en segunda opción el nick del objeto y si no, el uid
        let cr = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid].nick ? $96abbdd7193a3c4b$export$177dc95d91ec95d1((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid].nick) : target.nick ? $96abbdd7193a3c4b$export$177dc95d91ec95d1(target.nick) : uid;
        if (cr.length > 15) cr = cr.substring(0, 12) + "\u2026";
        if (conhiperenlace) cr = '<a class="pagusuario" uid="' + uid + '" href="/user/' + uid + '">' + cr + "</a>";
        return cr;
    }
    return null;
}
function $96abbdd7193a3c4b$export$f91175dce0722b24(obj) {
    const target = obj.creator ? obj.creator : obj;
    if (target) {
        const criri = target.iri ? $96abbdd7193a3c4b$export$177dc95d91ec95d1(target.iri) : $96abbdd7193a3c4b$export$177dc95d91ec95d1(target);
        const uid = criri.lastIndexOf("/") === -1 ? criri : criri.substring(criri.lastIndexOf("/") + 1);
        const crobj = {
            id: uid
        };
        // si hay nick lo incluyo
        const nick = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid].nick ? $96abbdd7193a3c4b$export$177dc95d91ec95d1((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid].nick) : target.nick ? $96abbdd7193a3c4b$export$177dc95d91ec95d1(target.nick) : null;
        if (nick) crobj.nick = nick;
        return crobj;
    }
    return null;
}
function $96abbdd7193a3c4b$export$aa350b96d91cd94(obj) {
    const fecha = obj.created ? obj.created : obj;
    if (fecha) {
        const dops = {
            year: "numeric",
            month: "long",
            day: "numeric"
        };
        if (fecha != undefined && !isNaN(Date.parse(fecha))) return new Date(Date.parse(fecha)).toLocaleDateString($96abbdd7193a3c4b$export$177dc95d91ec95d1((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).local), dops);
    }
    return null;
}
function $96abbdd7193a3c4b$export$daf0fdd0a2e008c2(obj) {
    const fecha = obj.created ? obj.created : obj;
    if (fecha && !isNaN(Date.parse(fecha))) return new Date(Date.parse(fecha)).toLocaleDateString($96abbdd7193a3c4b$export$177dc95d91ec95d1((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).local));
    return null;
}
// extracción primer elemento válido siguiendo las claves en keys
// la dificultad está en que el objeto puede tener elementos que sean objetos o arrays
function $96abbdd7193a3c4b$export$92cb375194bc8a33(obj, keys, decomposelastarray) {
    // cojo primer elemento
    const subobj = obj[keys[0]];
    if (keys.length == 1) {
        // hemos llegado al final (hoja)
        if (decomposelastarray && Array.isArray(subobj)) // si el elemento final es un array y nos piden descomponerlo, nos quedamos con el primer elemento y a volar
        return subobj[0];
        else return subobj;
    } else {
        const newkeys = (0, $2q7Wm.default).rest(keys);
        if (Array.isArray(subobj)) {
            // caso delicado, toca iterar por cada elemento del array a ver si hay suerte y alguno lo consigue
            for(let j = 0; j < subobj.length; j++){
                let res = $96abbdd7193a3c4b$export$92cb375194bc8a33(subobj[j], newkeys);
                if (res != null) return res; // lo conseguimos			
            }
            // no hubo suerte...
            return null;
        } else if (typeof subobj === "object") // aplicamos recursión, sin más
        return $96abbdd7193a3c4b$export$92cb375194bc8a33(subobj, newkeys);
        else return null;
    }
}
// aquí no queremos uno, sino que cogemos todos (DEVUELVE SIEMPRE UN ARRAY)
function $96abbdd7193a3c4b$export$326843c69d38a183(obj, keys) {
    // cojo primer elemento
    const subobj = obj[keys[0]];
    if (keys.length == 1) {
        // hemos llegado al final (hoja)
        if (subobj == undefined) return [];
        else if (Array.isArray(subobj)) return subobj;
        else return [
            subobj
        ];
    } else {
        const newkeys = (0, $2q7Wm.default).rest(keys);
        if (Array.isArray(subobj)) {
            // caso delicado, toca iterar por cada elemento del array
            let subels = []; // aquí metemos los subelementos que nos van valiendo
            for(let j = 0; j < subobj.length; j++){
                let parcels = $96abbdd7193a3c4b$export$326843c69d38a183(subobj[j], newkeys);
                if (parcels.length > 0) subels = subels.concat(parcels);
            }
            return subels;
        } else if (typeof subobj === "object") // aplicamos recursión, sin más
        return $96abbdd7193a3c4b$export$326843c69d38a183(subobj, newkeys);
        else return [];
    }
}
function $96abbdd7193a3c4b$export$56b19e10c1699553(uri) {
    // extraigo la última parte de la uri
    let lit = "";
    if (uri.split("#").length > 1) lit = uri.split("#")[uri.split("#").length - 1];
    else {
        lit = uri.split("/")[uri.split("/").length - 1];
        if (lit === "") lit = uri.split("/")[uri.split("/").length - 2];
    }
    // sustituyo - y _ por espacio
    lit = lit.replace(/-/g, " ");
    lit = lit.replace(/_/g, " ");
    return lit;
}
function $96abbdd7193a3c4b$export$57fe19e45e887809(lit) {
    if (lit != undefined && lit.length > 0) return lit.charAt(0).toUpperCase() + lit.slice(1);
    else return lit;
}
function $96abbdd7193a3c4b$export$e1dbea550ef5ab44(lit) {
    if (lit != undefined && lit.length > 0) return lit.charAt(0).toLowerCase() + lit.slice(1);
    else return lit;
}
///////////////
// CONFIG MODAL
function $96abbdd7193a3c4b$export$859065cca4d855fc(opciones, titulo, body, footer) {
    // inicializo el header con el título 	
    let header = '<h1 id="mimodaltitle" class="modal-title fs-5">' + titulo + "</h1>";
    // si hay opciones...
    if (opciones) {
        // tamaño grande o no
        if (opciones.lg) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalDialog").addClass("modal-lg");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalDialog").removeClass("modal-lg");
        // centrado vertical o no
        if (opciones.vertcent) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalDialog").addClass("modal-dialog-centered");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalDialog").removeClass("modal-dialog-centered");
        // combino static con la preparación del header
        if (opciones.static) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodal").attr("data-bs-backdrop", "static");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodal").attr("data-bs-keyboard", false);
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodal").removeAttr("data-bs-backdrop");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodal").removeAttr("data-bs-keyboard");
            header += '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>';
        }
        // no body?		
        if (opciones.nobody) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").addClass("d-none");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").removeClass("d-none");
        // no footer?		
        if (opciones.nofooter) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalFooter").addClass("d-none");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalFooter").removeClass("d-none");
        // spinner o no
        if (opciones.spinner) {
            let mibody = '<div class="col-1"> 						<div class="spinner-border text-secondary" role="status"> 							<span class="visually-hidden">Loading...</span> 	  					</div> 					</div>';
            if (opciones.spinnerMessage) mibody += '<div class="col ms-3">' + opciones.spinnerMessage + "</div>";
            // pongo el body
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").html(mibody);
            // y activo bodyrow para alinear el spinner (aunque no esté en las opciones)
            opciones.bodyrow = true;
        }
        // row en el body o no
        if (opciones.bodyrow) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").addClass("row");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").removeClass("row");
    }
    // si hay título, pongo el header que he preparado
    if (titulo) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalHeader").html(header);
    // si hay body...
    if (body) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").html(body);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalBody").removeClass("d-none");
    }
    // si hay footer...
    if (footer) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalFooter").html(footer);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimodalFooter").removeClass("d-none");
    }
}


/*********************
*** TEMPLATES FILE ***
**********************/ let $646ceeeec66fabd8$export$f3d44414f0a0d0b1, $646ceeeec66fabd8$export$900677b7c5ee40b7, $646ceeeec66fabd8$export$fafd45cc9f2ab26c, $646ceeeec66fabd8$export$502b32cc8ed2e37e, $646ceeeec66fabd8$export$217f5a5fe852abe6, $646ceeeec66fabd8$export$cbaf9c974071f389, $646ceeeec66fabd8$export$1cfea2c3e1d7bf94, $646ceeeec66fabd8$export$df6117506e1c4c3b, $646ceeeec66fabd8$export$27eb5f8cf2bf64a7, $646ceeeec66fabd8$export$d15beb852fc82fa2, $646ceeeec66fabd8$export$f3dc3f942ad7cadb, $646ceeeec66fabd8$export$170c21d6f8f459cf, $646ceeeec66fabd8$export$afb205d6a878a5e7, $646ceeeec66fabd8$export$d4de91556d149ac6, $646ceeeec66fabd8$export$dd1b8137336daa0c, $646ceeeec66fabd8$export$43bbd40c30a74965, $646ceeeec66fabd8$export$3fc5053bf2a10407, $646ceeeec66fabd8$export$ab832a4d4ceb9113, $646ceeeec66fabd8$export$ce041e830841d411, $646ceeeec66fabd8$export$9fac9ed2fe46e816, $646ceeeec66fabd8$export$eaebbbf45ac961b6, $646ceeeec66fabd8$export$af3959eda01cc433, $646ceeeec66fabd8$export$62b82cd57460378a, $646ceeeec66fabd8$export$a76d078e0f25e96f, $646ceeeec66fabd8$export$96346f251ef3b3fb, $646ceeeec66fabd8$export$c75e99c9076bb133;
var $ed7d554f2efd67ad$exports = {};
$ed7d554f2efd67ad$exports = new URL("../logoEW.e13d3a0a.svg", import.meta.url).toString();


let $646ceeeec66fabd8$var$urlLogo = new URL($ed7d554f2efd67ad$exports);
function $646ceeeec66fabd8$export$5e43259f1480bd05() {
    $646ceeeec66fabd8$export$f3d44414f0a0d0b1 = '<div id="tarjeta" class="card-body mitarjeta p-1" > 	<div class="d-flex flex-row"> 		<div class="dropdown"> 			<button id ="bot_inicio" class="btn btn-outline-secondary" type="button" 				data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-list"></i> 			</button> 			<ul class="dropdown-menu"> 				<li><a id="tarjeta-home" class="dropdown-item home" href="#">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).home) + '</a></li> 				<li><a id="tarjeta-lasttrees" class="dropdown-item lasttrees" href="#">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastTrees) + '</a></li> 			    <li><hr class="dropdown-divider"></li> 			    <li><a class="dropdown-item lang" tag="en" href="#">\uD83C\uDDEC\uD83C\uDDE7 EN</a></li> 				<li><a class="dropdown-item lang" tag="es" href="#">\uD83C\uDDEA\uD83C\uDDF8 ES</a></li> 			</ul> 		</div> 		<div class="btn-group"> 			<button id="bot_taxones" class="text-nowrap btn btn-outline-secondary ms-1" type="button" disabled> 				' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonfilter) + '</button> 			<input id="mapchecknomci" type="checkbox" class="btn-check nomci" id="btn-check" autocomplete="off" {{#nomci}}checked{{/nomci}} > 			<label id="bot_mapnomci" class="btn btn-outline-secondary" for="mapchecknomci"><i class="bi bi-mortarboard-fill"></i></label> 		</div> 		<div id="lugares_heading" class="flex-fill ms-1 me-1 me-sm-0 d-none"> 			<input id="in_lugares" autocomplete="off" type="search" class="form-control " 				placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchplace) + '" aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchplace) + '"> 		</div> 		<div class="ms-auto usuario d-block d-sm-none d-flex align-items-center"></div> 	</div> 	<div id="sugelugares" class="list-group mt-2 d-none"></div> 	<div id="taxones_subheading"></div> 	<div id="taxones_block" class="taxones_block list-group overflow-auto mt-1 pe-1 pe-sm-2 d-none" style="max-height:50vh;"></div> 	<div id="filtro_taxon" class="d-none"> 		<div class="d-flex align-items-center border mt-1"> 			<div id="div_label_filtro_taxon" class="ms-2"></div> 			<div class="ms-auto"> 				<button id="bot_info_filtro_taxon" class="btn btn-sm" type="button" turi="" > 					<i class="bi bi-info-circle-fill"></i> 				</button> 			</div> 			<div class="me-2"> 				<button id="bot_color_filtro" class="btn btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false"> 					<i class="bi bi-droplet-fill"></i> 				</button> 				<ul class="dropdown-menu" aria-labelledby="dropdownMenu"> 					<li><a class="dropdown-item dropdown_color_taxon" href="#" cind="5">Pink</a></li> 					<li><a class="dropdown-item dropdown_color_taxon" href="#" cind="6">Purple</a></li> 					<li><a class="dropdown-item dropdown_color_taxon" href="#" cind="7">Indigo</a></li> 					<li><a class="dropdown-item dropdown_color_taxon" href="#" cind="8">Cyan</a></li> 					<li><a class="dropdown-item dropdown_color_taxon" href="#" cind="9">Brown</a></li> 				</ul> 			</div> 			<div id="bot_quitar_taxon" class="me-2 pb-1"> 				<button type="button" class="btn-close" aria-label="Close"></button> 			</div> 		</div> 	</div> 	<div id="mibarradiv" class="progress mt-1 d-none" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"> 		<div id="mibarra" class="progress-bar progress-bar-striped progress-bar-animated bg-secondary" style="width: 0%" >0%</div> 		<div id="mibarra_loading" class="text-center text-dark" style="width: 100%">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).spinnerLoading) + "</div>     </div> </div>";
    $646ceeeec66fabd8$export$900677b7c5ee40b7 = '{{#activar}} 		{{#esformulario}}<div class="input-group my-1">{{/esformulario}} 		<input autocomplete="off" type="search" class="in_taxon form-control{{^esformulario}} my-1{{/esformulario}}" 				 placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchtaxon) + '" aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchtaxon) + '"> 		{{#esformulario}}<button id="importTaxonButton" type="button" class="btn btn-outline-primary">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).importtaxon) + '</button></div>{{/esformulario}} 	{{/activar}} 	<div class="sugetaxones list-group"></div>';
    $646ceeeec66fabd8$export$fafd45cc9f2ab26c = '{{#sugerencias}} 		<button class="list-group-item list-group-item-action bot_suge_taxon" type="button" spuri="{{uri}}"> 			{{#nc}}<i>{{/nc}}{{{labelshown}}}{{#nc}}</i>{{/nc}}<span class="badge rounded-pill text-bg-secondary float-end me-0">{{nclasses}} S</span> 			<span class="badge rounded-pill text-bg-secondary float-end me-1">{{nindivs}}</span> 		</button> 	{{/sugerencias}} 	{{#nosugerencias}} 		<button type="button" class="list-group-item list-group-item-action py-2 bot_suge_taxon" disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).notaxonfound) + "</button> 	{{/nosugerencias}}";
    $646ceeeec66fabd8$export$502b32cc8ed2e37e = '{{#.}} 		<div class="{{^esconder}}d-flex {{/esconder}}bd-highlight border-bottom border-left border-right taxon {{#esconder}}d-none{{/esconder}}" indice="{{indice}}"> 			{{#botonesconder}} 				<div><span>{{{indentspace}}}</span><span><button type="button" class="btn btn-outline-secondary btn-sm showmore">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).showmore) + '</button></span></div> 			{{/botonesconder}} 			{{^botonesconder}} 				<div class="flex-grow-1"> 					<button class="list-group-item list-group-item-action border-0 bot_sel_taxon" type="button" spuri="{{uri}}"> 						{{{indentspace}}}{{#nc}}<i>{{/nc}}{{label}}{{#nc}}</i>{{/nc}} 						<span class="badge rounded-pill text-bg-secondary float-end me-0">{{nclasses}} S</span> 						<span class="badge rounded-pill text-bg-secondary float-end me-1">{{nindivs}}</span> 					</button> 				</div> 				<div class="p-1"> 					<button class="btn btn-outline-secondary btn-sm bot_expandir_taxon {{#nosubclasses}}invisible{{/nosubclasses}}" 						type="button" data-placement="top"><i class="bi bi-chevron-right"></i> 					</button> 				</div> 			{{/botonesconder}} 		</div> 	{{/.}}';
    $646ceeeec66fabd8$export$217f5a5fe852abe6 = '{{#sugerencias}} 		<button type="button" class="list-group-item list-group-item-action py-2 bot_suge_lugar" id="{{id}}">{{{name}}}</button> 	{{/sugerencias}} 	{{#nosugerencias}} 		<button type="button" class="list-group-item list-group-item-action py-2" disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noplacesfound) + "</button> 	{{/nosugerencias}}";
    $646ceeeec66fabd8$export$cbaf9c974071f389 = '{{#sugerencias}} 		<button type="button" wdiri="{{{wdiri}}}" class="list-group-item list-group-item-action py-2 bot_suge_taxonWD"><i>{{{title}}}</i><br><small>{{{desc}}}</small></button> 	{{/sugerencias}} 	{{#nosugerencias}} 		<button type="button" class="list-group-item list-group-item-action py-2" disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).notaxonsfound) + "</button> 	{{/nosugerencias}}";
    $646ceeeec66fabd8$export$1cfea2c3e1d7bf94 = '<div class="container-fluid"> 		{{#hayimagen}} 			<div class="row"> 				<div class="col-sm-5"> 		{{/hayimagen}} 					<h5 class="text-muted">{{tipo}}</h5> 		{{#hayimagen}} 			{{^multimages}} 					<img class="img-fluid mt-1 mb-2" src="{{{image}}}"> 			{{/multimages}} 			{{#multimages}} 				<div id="carouselPopupTaxon" class="carousel slide" data-bs-ride="carousel"> 					<div class="carousel-inner"> 						{{#image}} 							<div class="carousel-item {{#active}}active{{/active}}"> 								<img src="{{{src}}}" > 							</div> 						{{/image}} 					</div> 					<button class="carousel-control-prev" type="button" data-bs-target="#carouselPopupTaxon" data-bs-slide="prev"> 						<span class="carousel-control-prev-icon" aria-hidden="true"></span> 						<span class="visually-hidden">Previous</span> 					</button> 					<button class="carousel-control-next" type="button" data-bs-target="#carouselPopupTaxon" data-bs-slide="next"> 						<span class="carousel-control-next-icon" aria-hidden="true"></span> 						<span class="visually-hidden">Next</span> 					</button>   				</div> 			{{/multimages}} 				</div> 				<div class="col-sm-7"> 		{{/hayimagen}} 					{{#resumen}} 						<p>{{resumen}}</p> 					{{/resumen}} 					{{#gbifPage}} 						<a href="{{{.}}}" target="_blank" 							class="btn btn-secondary btn-sm">GBIF</a> 					{{/gbifPage}} 					{{#wikidataPage}} 						<a href="{{{.}}}" target="_blank" 							class="btn btn-secondary btn-sm">Wikidata</a> 					{{/wikidataPage}} 					{{#wikipediaPage}} 						<a href="{{{.}}}" target="_blank" 							class="btn btn-secondary btn-sm">Wikipedia</a> 					{{/wikipediaPage}} 					{{#wikispeciesPage}} 						<a href="{{{.}}}" target="_blank" 							class="btn btn-secondary btn-sm">WikiSpecies</a> 					{{/wikispeciesPage}} 		{{#hayimagen}} 				</div> 			</div> 		{{/hayimagen}} 	</div>';
    $646ceeeec66fabd8$export$df6117506e1c4c3b = '<div style="max-width: 180px;"> 		{{#image}}<img class="card-img-top" src="{{{.}}}" width="180px">{{/image}} 		{{#multimages}} 			<div id="carouselPopupTree" class="carousel slide" data-bs-ride="carousel"> 				<div class="carousel-inner"> 					{{#images}} 						<div class="carousel-item {{#active}}active{{/active}}"> 							<img src="{{{srcimg}}}" width="180px" class="d-block w-100"> 						</div> 					{{/images}} 				</div> 				<button class="carousel-control-prev" type="button" data-bs-target="#carouselPopupTree" data-bs-slide="prev"> 					<span class="carousel-control-prev-icon" aria-hidden="true"></span> 					<span class="visually-hidden">Previous</span> 				</button> 				<button class="carousel-control-next" type="button" data-bs-target="#carouselPopupTree" data-bs-slide="next"> 					<span class="carousel-control-next-icon" aria-hidden="true"></span> 					<span class="visually-hidden">Next</span> 				</button>   			</div> 		{{/multimages}}			{{#nick}}<h6>{{.}}</h6>{{/nick}} 		{{#taxon}}<h6 class="card-subtitle text-muted">{{{.}}}</h6>{{/taxon}} 		{{#desc}}<p class="my-1 my-sm-2 card-text">{{{.}}}</p>{{/desc}} 		{{#creator}}<p class="my-1 my-sm-2 text-muted">{{{.}}}</p>{{/creator}} 		<div style="display: flex; justify-content: center;"> 			<button etid="{{{etid}}}" class="educatree btn btn-secondary" type="button">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).moreinfo) + "</button> 		</div> 	</div>";
    $646ceeeec66fabd8$export$27eb5f8cf2bf64a7 = '<div class="d-flex flex-row bd-highlight m-5"> 		<div class="p-3 bd-highlight"><div class="spinner-border" role="status" aria-hidden="true"></div></div> 		<div class="ml-5 bd-highlight"><div><h3 id="titleSpinner">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).spinnerLoading) + '</h3><p id="infoSpinner" class="font-weight-light">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).spinnerInfo) + "</p></div></div> 	</div>";
    $646ceeeec66fabd8$export$d15beb852fc82fa2 = '<nav class="navbar navbar-expand-md" style="background-color: #DCEDC8;"> 		<div class="container-fluid"> 			<a class="navbar-brand d-none d-md-block" href="#"> 				<img src="' + $646ceeeec66fabd8$var$urlLogo + '" alt="EducaWood" height="40"> 			</a> 			<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"> 				<span class="navbar-toggler-icon"></span> 			</button> 			<div class="collapse navbar-collapse" id="navbarNav"> 				<ul class="navbar-nav"> 					<li class="nav-item"> 						<a class="nav-link home" href="#">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).home) + '</a> 					</li> 					<li class="nav-item"> 						<a class="nav-link map" href="#">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).map) + '</a> 					</li> 					<li class="nav-item"> 						<a class="nav-link lasttrees {{#enPagLastrees}}active{{/enPagLastrees}}" {{#enPagLastrees}}aria-current="page"{{/enPagLastrees}} href="#">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastTrees) + '</a> 					</li> 					<li class="nav-item dropdown"> 						<a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).flaglang) + '</a> 						<ul class="dropdown-menu"> 							<li><a class="dropdown-item lang" tag="en" href="#">\uD83C\uDDEC\uD83C\uDDE7 EN</a></li> 							<li><a class="dropdown-item lang" tag="es" href="#">\uD83C\uDDEA\uD83C\uDDF8 ES</a></li> 						</ul> 					</li> 				</ul> 			</div> 			<a class="navbar-brand d-block d-md-none" href="#"> 				<img src="' + $646ceeeec66fabd8$var$urlLogo + '" alt="EducaWood" height="28"> 			</a> 			{{^usuario}} 			<button class="nav-item btn btn-light usersignin" type="button"><i class="bi bi-box-arrow-in-right"></i></button> 			{{/usuario}} 			{{#usuario}} 			<div class="nav-item dropstart"> 				<button class="btn p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="border-color: transparent;"> 					<img class="avatar avatar-32 avatar-sm-48 bg-light rounded-circle text-white {{^usuarioImg}}p-1 p-sm-2{{/usuarioImg}}" 						src="{{#usuarioImg}}{{{.}}}{{/usuarioImg}}{{^usuarioImg}}https://raw.githubusercontent.com/twbs/icons/main/icons/person.svg{{/usuarioImg}}" 						referrerpolicy="no-referrer"> 				</button> 				<ul class="dropdown-menu"> 					<li><a href="#" class="dropdown-item userprofile">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewProfile) + '</a></li> 					<li><a href="#" class="dropdown-item usersignout">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).signout) + "</a></li> 				</ul> 			</div> 			{{/usuario}} 		</div> 	</nav>";
    $646ceeeec66fabd8$export$f3dc3f942ad7cadb = $646ceeeec66fabd8$export$d15beb852fc82fa2 + '<div class="container pb-4"> 		<div class="container-fluid"> 			<div class="row justify-content-lg-center mt-4 p-0"> 				<div class="col-lg-8 p-0"> 					<div class="card text-center p-0"> 						<div class="card-header"> 							<h5 class="col card-title">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newtree) + '</h5> 						</div> 						<div class="card-body p-0"> 							<div id="mapaedutree" style="height: 300px;"> 								<div id="overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 9999;"> 									<div class="d-flex justify-content-center align-items-center overlay-backdrop" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);"> 										<div class="spinner-border" role="status"> 											<span class="visually-hidden">Loading...</span> 										</div> 									</div> 								</div> 							</div> 							<div id="mapclue" class="form-text d-none">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).mapclue) + '</div> 						</div> 					</div> 				</div> 			</div> 			<div class="row justify-content-lg-center"> 				<form id="createTreeForm" class="col-lg-8 py-4"> 					<!-- POSITION --> 					<div class="pb-4 row"> 						<label for="inputPosition" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).position) + '</label> 						<div class="col-md-9"> 							<div class="input-group"> 								<input id="inputPosition" type="text" class="form-control" value="" disabled readonly> 							</div> 						</div> 					</div> 					<!-- NICK --> 					<div class="pb-4 row"> 						<label for="inputTreeNick" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treenick) + '</label> 						<div class="col-md-9"> 							<div class="input-group"> 								<input id="inputTreeNick" type="text" class="form-control" value="" minlength="3" maxlength="30" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newTreeNickTip) + '"> 							</div> 							<div id="statusNick" class="form-text">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick) + '</div> 						</div> 					</div> 					<!-- TREE TAXON --> 					<div class="pb-4 row"> 						<label for="inputTreeTaxonEd" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treetaxon) + '</label> 						<div class="col-md-9"> 							<div class="input-group"> 								<button id="setTreeTaxonEd" class="btn btn-outline-secondary" type="button">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonfilter) + '</button> 								<input id="inputTreeTaxonEd" type="text" class="form-control taxon" placeholder="" aria-describedby="handlerSetTreeTaxonEd" disabled readonly> 								<button class="btn btn-outline-secondary d-none delete" type="button" id="deleteTreeTaxon"><i class="bi bi-x-lg"></i></button> 								<button id="infoTaxonDbpedia" class="btn btn-outline-secondary d-none dbpedia" type="button" turi="" > 									<i class="bi bi-info-circle-fill"></i> 								</button> 								<input id="crchecknomci" type="checkbox" class="btn-check nomci" id="btn-check" autocomplete="off"> 								<label class="btn btn-outline-secondary" for="crchecknomci"><i class="bi bi-mortarboard-fill"></i></label> 							</div> 							<div id="taxones_subheading_newtree" class="d-none"></div> 							<div id="taxones_block_newtree" class="taxones_block list-group overflow-auto mt-1 d-none pe-1 pe-sm-2" style="max-height:50vh;"></div> 						</div> 					</div> 					<!-- TREE STATUS --> 					<div class="pb-4 row"> 						<label for="selectTreeStatus" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeStatus) + '</label> 						<div class="col-md-9"> 							<div class="input-group"> 								<select id="selectTreeStatus" class="form-select" 									aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treestatusselection) + '"></select> 								<button class="btn btn-outline-secondary" type="button" id="botTreeStatusInfo"><i class="bi bi-info-circle-fill"></i></button> 							</div> 						</div> 					</div> 					<!-- TREE PHOTO --> 					<div class="pb-4 row"> 						<label for="treePhoto" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).photo) + '</label> 						<div class="col-md-9"> 							<div class="input-group"> 								<input id="treePhoto" class="form-control" type="file" accept="image/*" 									{{#esMovil}}{{#camera}}capture="environment"{{/camera}}{{/esMovil}} > 								<button class="btn btn-outline-secondary d-none" type="button" id="deleteTreePhoto"><i class="bi bi-x-lg"></i></button> 								{{#esMovil}} 									<input id="checkCamera" type="checkbox" class="btn-check camera" id="btn-check" autocomplete="off" {{#camera}}checked{{/camera}}> 									<label class="btn btn-outline-secondary" for="checkCamera"><i class="bi bi-camera-fill"></i></label> 								{{/esMovil}} 							</div> 							<select id="selectTreePartPhoto" class="d-none form-select mt-1" 								aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).partplanselection) + '"></select> 							<input type="hidden" id="resizedTreePhoto"> 							<div class="form-text"><span id="textTreePhoto">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nophoto) + '</span><img id="treeThumbnail" class="d-none ms-3 mt-1" src="" width="80px"></div> 						</div> 					</div> 					<!-- TREE HEIGHT --> 					<div class="pb-4 row"> 						<label for="treeHeight" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).heightm) + '</label> 						<div class="col-md-9"> 							<input type="number" class="form-control" id="treeHeight" step="any" min="0" max="150" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterheightm) + '"> 						</div> 					</div> 					<!-- TREE DIAMETER --> 					<div class="pb-4 row"> 						<label id="labelTreeDiameter" for="treeDiameter" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diametermm) + '</label> 						<div class="col-md-9"> 							<div class="input-group"> 								<input id="treeDiameter" type="number" class="form-control" step="1" min="0" max="20000" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterdiametermm) + '"> 								<input id="checkPerimeter" type="checkbox" class="btn-check perimeter" id="btn-check" autocomplete="off"> 								<label class="btn btn-outline-secondary" for="checkPerimeter"><i class="bi bi-circle"></i></label> 							</div> 						</div> 		  			</div> 					<!-- TREE OBSERVATION --> 					<div class="pb-4 row"> 						<label id="labelTreeObservation for="treeObservation" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeobservation) + '</label> 						<div class="col-md-9"> 							<div class="input-group"> 								<textarea class="form-control" id="treeObservation" autocomplete="off" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).yourobservation) + '" minlength="5" maxlength="500"></textarea> 							</div> 						</div> 		  			</div> 					<div class="form-text pb-4">{{^usuario}}<strong>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).signupToCreate) + "<strong>{{/usuario}}{{#usuario}}" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formopt) + '{{/usuario}}</div> 					<div class="d-flex"> 						<button id="goBackButton" type="button" class="me-auto btn btn-secondary">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> 						<button id="createTreeButton" type="submit" class="btn btn-primary" {{^usuario}}disabled{{/usuario}}>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createtree) + "</button> 					</div> 				</form> 			</div> 		</div> 	</div>";
    $646ceeeec66fabd8$export$170c21d6f8f459cf = '<option value="" selected>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treestatusselection) + '</option> 	{{#.}} 		<option value="{{{iri}}}">{{{pref}}}{{label}}</option> 	{{/.}}';
    $646ceeeec66fabd8$export$afb205d6a878a5e7 = '<option value="" selected>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).partplanselection) + '</option> 	{{#.}} 		<option value="{{{uri}}}">{{label}}</option> 	{{/.}}';
    $646ceeeec66fabd8$export$d4de91556d149ac6 = '<div class="dropdown"> 		<button class="btn p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="border-color: transparent;"> 			<img class="avatar avatar-32 avatar-sm-48 bg-light rounded-circle text-white {{^img}}p-1 p-sm-2{{/img}}"     			src="{{#img}}{{{.}}}{{/img}}{{^img}}https://raw.githubusercontent.com/twbs/icons/main/icons/person.svg{{/img}}"     			referrerpolicy="no-referrer"> 		</button> 		<ul class="dropdown-menu"> 			<li><a href="#" class="dropdown-item userprofile">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewProfile) + '</a></li> 			<li><a href="#" class="dropdown-item usersignout">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).signout) + "</a></li> 		</ul> 	</div>";
    $646ceeeec66fabd8$export$dd1b8137336daa0c = $646ceeeec66fabd8$export$d15beb852fc82fa2 + '<div class="container pb-4"> 		<div class="container-fluid"> 			<div class="row justify-content-lg-center mt-4 p-0"> 				<div class="col-lg-8 p-0"> 					<div class="card text-center p-0"> 						<div class="card-header"> 							<h5 class="col card-title">{{{title}}}</h5> 							{{#treeCreator}}<p class="col card-text">{{{.}}}</p>{{/treeCreator}} 							{{#removable}}<button id="changeTreeNick" type="button" class="btn btn-primary mt-1">{{nickButtonLabel}}</button>{{/removable}} 						</div> 						<div class="card-body p-0"> 							<div id="mapaedutree" style="height: 300px;"> 								<div id="overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 9999;"> 									<div class="d-flex justify-content-center align-items-center overlay-backdrop" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);"> 										<div class="spinner-border" role="status"> 											<span class="visually-hidden">Loading...</span> 										</div> 									</div> 								</div> 							</div> 						</div> 					</div> 				</div> 			</div> 			<div class="row justify-content-lg-center"> 				<div class="col-lg-8 py-4 px-0 px-sm-3"> 					<!-- POSITION --> 					<div class="row"> 						<label for="inputPosition" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).position) + '</label> 						<div class="col-md-9"> 							<div class="input-group"> 								<input id="inputPosition" type="text" class="form-control" value="{{position.value}}" disabled readonly> 							</div> 						</div> 					</div> 					<div class="row pt-1 justify-content-between"> 						{{#editable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-primary position create" type="button"><i class="bi bi-plus-lg"></i></button> 						</div> 						{{/editable}} 						<div class="form-text col text-end {{#position.removable}}px-0{{/position.removable}}">{{{position.creator}}}</div> 						{{#position.removable}} 						<div class="btn-group col-auto" role="group"> 							<button class="col-auto btn btn-outline-danger position delete" iri="{{{position.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 						</div> 						{{/position.removable}} 					</div> 					{{#hasFormerPositions}} 					<div class="row pt-1 justify-content-end"> 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePositions" 								aria-expanded="false" aria-controls="collapsePositions">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formerPositions) + '</button> 						</div> 					</div> 					<div id="collapsePositions" class="collapse pt-1"> 						{{#formerPositions}} 						<div class="row"> 							<div class="col-md-3"></div> 							<div class="col-md-9"> 								<div class="input-group"> 									<input id="inputPosition" type="text" class="form-control" value="{{value}}" disabled readonly> 								</div> 							</div> 						</div> 						<div class="row py-1 justify-content-between"> 							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> 							{{#removable}} 							<div class="btn-group col-auto" role="group"> 								<button class="col-auto btn btn-outline-danger position delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 							</div> 							{{/removable}} 						</div> 						{{/formerPositions}} 					</div> 					{{/hasFormerPositions}} 					<!-- TREE TAXON --> 					{{#treeTaxon}} 					<div class="row pt-4"> 						<label for="viewTreeTaxon" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treetaxon) + '</label> 						{{#treeTaxon.value}} 						<div class="col-md-9"> 							<div class="input-group"> 								<input id="viewTreeTaxon" type="text" class="form-control taxon" iri="{{{treeTaxon.value}}}" disabled readonly> 								{{#treeTaxon.wikidata}} 								<button id="viewInfoTaxonDbpedia" class="btn btn-outline-secondary dbpedia" type="button" turi="{{{treeTaxon.value}}}" > 									<i class="bi bi-info-circle-fill"></i> 								</button> 								{{/treeTaxon.wikidata}} 								<input id="viewchecknomci" type="checkbox" class="btn-check nomci" id="btn-check" autocomplete="off"> 								<label class="btn btn-outline-secondary" for="viewchecknomci"><i class="bi bi-mortarboard-fill"></i></label> 							</div> 						</div> 						{{/treeTaxon.value}} 					</div> 					<div class="row pt-1 justify-content-between"> 						{{#editable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-primary treeTaxon create" type="button"><i class="bi bi-plus-lg"></i></button> 						</div> 						{{/editable}} 						<div class="form-text col text-end {{#treeTaxon.removable}}px-0{{/treeTaxon.removable}}">{{{treeTaxon.creator}}}</div> 						{{#treeTaxon.removable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-danger treeTaxon delete" iri="{{{treeTaxon.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 						</div> 						{{/treeTaxon.removable}} 					</div> 					{{#hasFormerTaxa}} 					<div class="row pt-1 justify-content-end"> 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTaxa" 								aria-expanded="false" aria-controls="collapseTaxa">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formerTreeTaxons) + '</button> 						</div> 					</div> 					<div id="collapseTaxa" class="collapse pt-1"> 						{{#formerTaxa}} 						<div class="row"> 							<div class="col-md-3"></div> 							<div class="col-md-9"> 								<div class="input-group"> 									<input type="text" class="form-control taxon" iri="{{{value}}}" disabled readonly> 									{{#wikidata}} 									<button class="btn btn-outline-secondary dbpedia" type="button" turi="{{{value}}}" > 										<i class="bi bi-info-circle-fill"></i> 									</button> 									{{/wikidata}} 								</div> 							</div> 						</div> 						<div class="row py-1 justify-content-between"> 							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> 							{{#removable}} 							<div class="btn-group col-auto" role="group"> 								<button class="col-auto btn btn-outline-danger treeTaxon delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 							</div> 							{{/removable}} 						</div> 						{{/formerTaxa}} 					</div> 					{{/hasFormerTaxa}} 					{{/treeTaxon}} 					<!-- TREE STATUS --> 					{{#treeStatus}} 					<div class="row pt-4"> 						<label for="inputTreeStatus" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeStatus) + '</label> 						{{#treeStatus.value}} 						<div class="col-md-9"> 							<div class="input-group"> 								<input id="inputTreeStatus" type="text" class="form-control" value="{{treeStatus.value}}" disabled readonly> 								<button id="botTreeStatusInfo" class="btn btn-outline-secondary" type="button"><i class="bi bi-info-circle-fill"></i></button> 							</div> 						</div> 						{{/treeStatus.value}} 					</div> 					<div class="row pt-1 justify-content-between"> 						{{#editable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-primary treeStatus create" type="button"><i class="bi bi-plus-lg"></i></button> 						</div> 						{{/editable}} 						<div class="form-text col text-end {{#treeStatus.removable}}px-0{{/treeStatus.removable}}">{{{treeStatus.creator}}}</div> 						{{#treeStatus.removable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-danger treeStatus delete" iri="{{{treeStatus.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 						</div> 						{{/treeStatus.removable}} 					</div> 					{{#hasFormerStatus}} 					<div class="row pt-1 justify-content-end"> 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseStatus" 								aria-expanded="false" aria-controls="collapseStatus">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formerTreeStatus) + '</button> 						</div> 					</div> 					<div id="collapseStatus" class="collapse pt-1"> 						{{#formerStatus}} 						<div class="row"> 							<div class="col-md-3"></div> 							<div class="col-md-9"> 								<div class="input-group"> 									<input type="text" class="form-control" value="{{value}}" disabled readonly> 								</div> 							</div> 						</div> 						<div class="row py-1 justify-content-between"> 							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> 							{{#removable}} 							<div class="btn-group col-auto" role="group"> 								<button class="col-auto btn btn-outline-danger treeStatus delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 							</div> 							{{/removable}} 						</div> 						{{/formerStatus}} 					</div> 					{{/hasFormerStatus}} 					{{/treeStatus}} 					<!-- PHOTOS --> 					{{#photoLabel}} 					<div class="row pt-4"> 						<label class="col-md-3 col-form-label">{{photoLabel}}</label> 					</div> 					{{#hasPhotos}} 					<div id="miCarrusel" class="row carousel slide"> 						{{^onePhoto}} 						<div class="carousel-indicators" style="margin-left: 0;"> 							{{#photos}} 							<button type="button" data-bs-target="#miCarrusel" data-bs-slide-to="{{index}}" {{#first}}class="active"{{/first}}></button> 							{{/photos}} 					  	</div> 						{{/onePhoto}} 						<div class="carousel-inner"> 							{{#photos}} 							<div class="carousel-item {{#first}}active{{/first}}"> 								<img src="{{{src}}}" class="d-block w-100"> 								{{#plantPart}} 								<div class="carousel-caption d-block"> 									<p>{{plantPart}}</p> 								</div> 								{{/plantPart}} 							</div> 							{{/photos}} 						</div> 						{{^onePhoto}} 					 	<button class="carousel-control-prev" type="button" data-bs-target="#miCarrusel" data-bs-slide="prev"> 							<span class="carousel-control-prev-icon" aria-hidden="true"></span> 							<span class="visually-hidden">Previous</span> 					  	</button> 					  	<button class="carousel-control-next" type="button" data-bs-target="#miCarrusel" data-bs-slide="next"> 							<span class="carousel-control-next-icon" aria-hidden="true"></span> 							<span class="visually-hidden">Next</span> 					  	</button> 						{{/onePhoto}} 					</div> 					{{/hasPhotos}} 					{{#photos}} 					<div class="row pt-1 justify-content-between photoCreator {{^first}}d-none{{/first}}" index="{{index}}"> 						{{#editable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-primary photo create" type="button"><i class="bi bi-plus-lg"></i></button> 						</div> 						{{/editable}} 						<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> 						{{#removable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-danger photo delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 						</div> 						{{/removable}} 					</div> 					{{/photos}} 					{{^hasPhotos}} 					{{#editable}} 					<div class="row pt-1 justify-content-between"> 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-primary photo create" type="button"><i class="bi bi-plus-lg"></i></button> 						</div> 					</div> 					{{/editable}} 					{{/hasPhotos}} 					{{/photoLabel}} 					<!-- HEIGHT --> 					{{#height}} 					<div class="row pt-4"> 						<label for="inputHeight" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).heightm) + '</label> 						{{#height.value}} 						<div class="col-md-9"> 							<div class="input-group"> 								<input id="inputHeight" type="text" class="form-control" value="{{height.value}}" disabled readonly> 							</div> 						</div> 						{{/height.value}} 					</div> 					<div class="row pt-1 justify-content-between"> 						{{#editable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-primary height create" type="button"><i class="bi bi-plus-lg"></i></button> 						</div> 						{{/editable}} 						<div class="form-text col text-end {{#height.removable}}px-0{{/height.removable}}">{{{height.creator}}}</div> 						{{#height.removable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-danger height delete" iri="{{{height.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 						</div> 						{{/height.removable}} 					</div> 					{{#hasFormerHeight}} 					<div class="row pt-1 justify-content-end"> 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseHeight" 								aria-expanded="false" aria-controls="collapseHeight">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formerHeights) + '</button> 						</div> 					</div> 					<div id="collapseHeight" class="collapse pt-1"> 						{{#formerHeights}} 						<div class="row"> 							<div class="col-md-3"></div> 							<div class="col-md-9"> 								<div class="input-group"> 									<input type="text" class="form-control" value="{{value}}" disabled readonly> 								</div> 							</div> 						</div> 						<div class="row py-1 justify-content-between"> 							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> 							{{#removable}} 							<div class="btn-group col-auto" role="group"> 								<button class="col-auto btn btn-outline-danger height delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 							</div> 							{{/removable}} 						</div> 						{{/formerHeights}} 					</div> 					{{/hasFormerHeight}} 					{{/height}} 					<!-- DIAMETER --> 					{{#diameter}} 					<div class="row pt-4"> 						<label for="inputDiameter" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diametermm) + '</label> 						{{#diameter.value}} 						<div class="col-md-9"> 							<div class="input-group"> 								<input id="inputDiameter" type="text" class="form-control" value="{{diameter.value}}" disabled readonly> 							</div> 						</div> 						{{/diameter.value}} 					</div> 					<div class="row pt-1 justify-content-between"> 						{{#editable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-primary diameter create" type="button"><i class="bi bi-plus-lg"></i></button> 						</div> 						{{/editable}} 						<div class="form-text col text-end {{#diameter.removable}}px-0{{/diameter.removable}}">{{{diameter.creator}}}</div> 						{{#diameter.removable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-danger diameter delete" iri="{{{diameter.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 						</div> 						{{/diameter.removable}} 					</div> 					{{#hasFormerDiameter}} 					<div class="row pt-1 justify-content-end"> 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDiameter" 								aria-expanded="false" aria-controls="collapseDiameter">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).formerDiameters) + '</button> 						</div> 					</div> 					<div id="collapseDiameter" class="collapse pt-1"> 						{{#formerDiameters}} 						<div class="row"> 							<div class="col-md-3"></div> 							<div class="col-md-9"> 								<div class="input-group"> 									<input type="text" class="form-control" value="{{value}}" disabled readonly> 								</div> 							</div> 						</div> 						<div class="row py-1 justify-content-between"> 							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> 							{{#removable}} 							<div class="btn-group col-auto" role="group"> 								<button class="col-auto btn btn-outline-danger diameter delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 							</div> 							{{/removable}} 						</div> 						{{/formerDiameters}} 					</div> 					{{/hasFormerDiameter}} 					{{/diameter}} 					<!-- OBSERVACIONES --> 					{{#observation}} 					<div class="row pt-4"> 						<label for="inputObservation" class="col-md-3 col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).observations) + '</label> 						{{#observation.value}} 						<div class="col-md-9"> 							<div class="input-group"> 								<textarea id="inputObservation" class="form-control" disabled readonly>{{{observation.value}}}</textarea> 							</div> 						</div> 						{{/observation.value}} 					</div> 					<div class="row pt-1 justify-content-between"> 						{{#editable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-primary observation create" type="button"><i class="bi bi-plus-lg"></i></button> 						</div> 						{{/editable}} 						<div class="form-text col text-end {{#observation.removable}}px-0{{/observation.removable}}">{{{observation.creator}}}</div> 						{{#observation.removable}} 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-danger observation delete" iri="{{{observation.iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 						</div> 						{{/observation.removable}} 					</div> 					{{#hasMoreObservations}} 					<div class="row pt-1 justify-content-end"> 						<div class="btn-group col-auto" role="group"> 							<button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseObservation" 								aria-expanded="false" aria-controls="collapseObservation">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).moreobservations) + '</button> 						</div> 					</div> 					<div id="collapseObservation" class="collapse pt-1"> 						{{#moreObservations}} 						<div class="row"> 							<div class="col-md-3"></div> 							<div class="col-md-9"> 								<div class="input-group"> 									<textarea class="form-control" disabled readonly>{{{value}}}</textarea> 								</div> 							</div> 						</div> 						<div class="row py-1 justify-content-between"> 							<div class="form-text col text-end {{#removable}}px-0{{/removable}}">{{{creator}}}</div> 							{{#removable}} 							<div class="btn-group col-auto" role="group"> 								<button class="col-auto btn btn-outline-danger observation delete" iri="{{{iri}}}" type="button"><i class="bi bi-x-lg"></i></button> 							</div> 							{{/removable}} 						</div> 						{{/moreObservations}} 					</div> 					{{/hasMoreObservations}} 					{{/observation}} 					<!-- BACK AND DELETE BUTTONS --> 					<div class="d-flex pt-5"> 						<button type="button" class="btn btn-secondary goBack">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button> 						{{#removable}} 						<button id="deleteEducaTree" type="button" class="ms-auto btn btn-danger">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteTree) + "</button> 						{{/removable}} 					</div> 				</div> 			</div> 		</div> 	</div>";
    $646ceeeec66fabd8$export$43bbd40c30a74965 = {
        position: '<div id="mapaAnn" style="height: 300px;"> 			<div id="overlayAnn" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 9999;"> 				<div class="d-flex justify-content-center align-items-center overlay-backdrop" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);"> 					<div class="spinner-border" role="status"> 						<span class="visually-hidden">Loading...</span> 					</div> 				</div> 			</div> 		</div> 		<div id="mapclueAnn" class="form-text d-none">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).mapclue) + '</div> 		<label for="inputPositionAnn" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).position) + '</label> 		<input id="inputPositionAnn" type="text" class="form-control" value="" disabled readonly> 		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation) + "</div>",
        treeTaxon: '<label for="inputTreeTaxonEd" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treetaxon) + '</label> 		<div class="row"> 			<div class="input-group"> 				<button id="setTreeTaxonEd" class="btn btn-outline-secondary" type="button">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonfilter) + '</button> 				<input id="inputTreeTaxonEd" type="text" class="form-control taxon" placeholder="" aria-describedby="handlerSetTreeTaxonEd" disabled readonly> 				<button class="btn btn-outline-secondary d-none delete" type="button" id="deleteTreeTaxon"><i class="bi bi-x-lg"></i></button> 				<input id="anchecknomci" type="checkbox" class="btn-check nomci" id="btn-check" autocomplete="off"> 				<label class="btn btn-outline-secondary" for="anchecknomci"><i class="bi bi-mortarboard-fill"></i></label> 			</div> 			<div id="taxones_subheading_newtree" class="d-none"></div> 			<div id="taxones_block_newtree" class="taxones_block list-group overflow-auto mt-1 d-none pe-1 pe-sm-2" style="max-height:50vh;"></div> 		</div> 		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation) + "</div>",
        treeStatus: '<label for="selectTreeStatus" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeStatus) + '</label> 		<select id="selectTreeStatus" class="form-select" aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treestatusselection) + '"></select> 		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation) + "</div>",
        photo: '<label for="treePhoto" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).photo) + '</label> 		<div class="input-group"> 			<input id="treePhoto" class="form-control" type="file" accept="image/*" 				{{#esMovil}}{{#camera}}capture="environment"{{/camera}}{{/esMovil}} > 			<button class="btn btn-outline-secondary d-none" type="button" id="deleteTreePhoto"><i class="bi bi-x-lg"></i></button> 			{{#esMovil}} 				<input id="checkCamera" type="checkbox" class="btn-check camera" id="btn-check" autocomplete="off" {{#camera}}checked{{/camera}}> 				<label class="btn btn-outline-secondary" for="checkCamera"><i class="bi bi-camera-fill"></i></label> 			{{/esMovil}} 		</div> 		<select id="selectTreePartPhoto" class="d-none form-select mt-1" 				aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).partplanselection) + '"></select> 		<input type="hidden" id="resizedTreePhoto"> 		<div class="form-text"><span id="textTreePhoto">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nophoto) + '</span><img id="treeThumbnail" class="d-none ms-3 mt-1" src="" width="80px"></div>',
        height: '<label for="treeHeight" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).heightm) + '</label> 		<input id="treeHeight" type="number" class="form-control" step="any" min="0" max="150" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterheightm) + '"> 		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation) + "</div>",
        diameter: '<label id="labelTreeDiameter" for="treeDiameter" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diametermm) + '</label> 		<div class="input-group"> 			<input id="treeDiameter" type="number" class="form-control" step="1" min="0" max="20000" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterdiametermm) + '"> 			<input id="checkPerimeter" type="checkbox" class="btn-check perimeter" id="btn-check" autocomplete="off"> 			<label class="btn btn-outline-secondary" for="checkPerimeter"><i class="bi bi-circle"></i></label> 		</div> 		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation) + "</div>",
        observation: '<label for="observation" class="col-form-label">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeobservation) + '</label> 		<textarea class="form-control" id="observation" autocomplete="off" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).yourobservation) + '" minlength="5" maxlength="500"></textarea> 		<div id="statusAnnotation" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation) + "</div>",
        importTaxon: '<label for="importTaxon" class="col-form-label"></label> 		<div class="row"> 			<div class="input-group"> 				<input id="in_importTaxon" autocomplete="off" type="search" class="form-control" 					 placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchtaxon) + '" aria-label="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchtaxon) + '" wdiri="" > 				<button id="clearImportTaxon" class="btn btn-outline-secondary d-none" type="button"><i class="bi bi-x-lg"></i></button> 			</div> 			<div id="sugetaxonesWD" class="list-group mt-2 mx-2 d-none"></div> 		</div> 		<div id="infoTaxonImportar" class="row d-none mt-2"></div> 		<div class="d-flex align-items-center mt-2"> 			<div id="spinnerImport" class="spinner-border me-2 d-none" role="status"></div> 			<div id="statusImportTaxon" class="form-text">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomething) + "</div> 		</div>"
    };
    $646ceeeec66fabd8$export$3fc5053bf2a10407 = {
        creacionExito: '<button type="button" class="btn btn-secondary goBack" 			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button> 		<button type="button" class="btn btn-primary cargarURL" 			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewtree) + "</button>",
        creacionError: '<button type="button" class="btn btn-secondary goBack" 			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + "</button>",
        confirmarBorradoArbol: '<button type="button" class="btn btn-secondary" 			data-bs-dismiss="modal" aria-label="Close" ">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> 		<button id="procesarBorradoArbol" type="button" class="btn btn-danger">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).delete) + "</button>",
        borradoArbolExito: '<button type="button" class="btn btn-secondary goBack" 			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + "</button>",
        borradoArbolError: '<button type="button" class="btn btn-secondary goBack" 			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button> 		<button type="button" class="btn btn-danger" 			data-bs-dismiss="modal" aria-label="Close">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).close) + "</button>",
        crearAnotacion: '<button type="button" class="btn btn-secondary" 			data-bs-dismiss="modal" aria-label="Close" ">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> 		<button id="botcreatemodalannotation" type="button" class="btn btn-primary" 			disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createAnnotation) + "</button>",
        anotacionExito: '<button id="botAnotacionExito" type="button" class="btn btn-secondary" 			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).close) + "</button>",
        anotacionError: '<button type="button" class="btn btn-secondary" 			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).close) + "</button>",
        confirmarBorradoAnotacion: '<button type="button" class="btn btn-secondary" 			data-bs-dismiss="modal" aria-label="Close" ">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> 		<button id="botonBorradoAnotacion" type="button" class="btn btn-danger">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).delete) + "</button>",
        cambiarNick: '<button type="button" class="btn btn-secondary" 			data-bs-dismiss="modal" aria-label="Close" ">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> 		<button id="botonCambioNick" type="button" class="btn btn-primary" disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).change) + "</button>",
        nickCambiado: '<button type="button" class="btn btn-secondary" 			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).close) + "</button>",
        treeNickCambiado: '<button type="button" class="btn btn-secondary" 			data-bs-dismiss="modal">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).close) + "</button>",
        descargaDatos: '<button id="downloadClose" type="button" class="btn btn-secondary" 			data-bs-dismiss="modal" aria-label="Close" ">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> 		<button id="downloadData" type="button" class="btn btn-primary" disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).download) + "</button>",
        importarTaxon: '<button type="button" class="btn btn-secondary" 			data-bs-dismiss="modal" aria-label="Close" ">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel) + '</button> 		<button id="botimporttaxonwikidata" type="button" class="btn btn-primary" 			disabled>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).importtaxon) + "</button>"
    };
    $646ceeeec66fabd8$export$ce041e830841d411 = "<div> 		<p>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadMessage) + "</p> 		<span>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadChoices) + '</span> 		<div class="form-check"> 			<input class="form-check-input check-download trees" type="checkbox" value="" id="checkTrees"> 			<label class="form-check-label" for="checkTrees">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).checkTrees) + '</label> 		</div> 		<div class="form-check"> 			<input class="form-check-input check-download annotations" type="checkbox" value="" id="checkAnnotations"> 			<label class="form-check-label" for="checkAnnotations">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).checkAnnotations) + '</label> 		</div> 		<div id="downloadClusterNote"><small><i>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadClusterNote) + '</i></small></div> 		<div id="downloadNothing"><strong>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadNothing) + "</strong></div> 		<br><div>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadFormatChoose) + '</div> 		<input type="radio" class="btn-check downloadRadio" name="format" id="GeoJSON" autocomplete="off"> 		<label class="btn btn-outline-primary" for="GeoJSON">GeoJSON</label> 		<input type="radio" class="btn-check downloadRadio" name="format" id="CSV" autocomplete="off"> 		<label class="btn btn-outline-primary" for="CSV">CSV</label> 		<input type="radio" class="btn-check downloadRadio" name="format" id="KML" autocomplete="off"> 		<label class="btn btn-outline-primary" for="KML">KML</label> 		<div id="downloadNoFormat"><strong>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadNoFormat) + "</strong></div> 	</div>";
    $646ceeeec66fabd8$export$9fac9ed2fe46e816 = '<div> 		<div id="downloadingTrees" class="d-none"><i class="bi bi-arrow-right-circle"></i> 			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadingTrees) + '</span> 		</div> 		<div id="treesDownloaded" class="d-none"><i class="bi bi-check-lg"></i> 			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treesDownloaded) + '</span> 		</div> 		<div id="noTreesDownloaded" class="d-none"><i class="bi bi-info-circle"></i> 			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noTreesDownloaded) + '</span> 		</div> 		<div id="downloadingAnnotations" class="d-none"><i class="bi bi-arrow-right-circle"></i> 			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadingAnnotations) + '</span> 		</div> 		<div id="annotationsDownloaded" class="d-none"><i class="bi bi-check-lg"></i> 			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotationsDownloaded) + '</span> 		</div> 		<div id="noAnnotationsDownloaded" class="d-none"><i class="bi bi-info-circle"></i> 			<span class="ms-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotationsDownloaded) + '</span> 		</div> 		<div id="mibarradescarga_div" class="progress my-1" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"> 			<div id="mibarradescarga" class="progress-bar progress-bar-striped progress-bar-animated bg-primary" style="width: 0%" >0%</div> 		</div> 		<div id="imgDownload" class="d-none mt-1"><img src="./downloadData.png" class="d-block w-100"></div> 	</div>';
    $646ceeeec66fabd8$export$ab832a4d4ceb9113 = '<img id="imgTreeDeletion" src="./treeDeletion.png" class="d-block w-100">';
    $646ceeeec66fabd8$export$eaebbbf45ac961b6 = '<button class="btn btn-outline-secondary d-block d-sm-none usersignin" type="button"><i class="bi bi-box-arrow-in-right"></i></button> 	<button class="btn btn-light d-none d-sm-block usersignin" type="button"><i class="bi bi-box-arrow-in-right"></i></button>';
    $646ceeeec66fabd8$export$af3959eda01cc433 = '<input id="newNick" type="text" class="form-control" minlength="3" maxlength="20" placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newNickTip) + '"> 	<div id="statusNick" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick) + '</div> 	<img id="imgNewNick" src="./newNick.png" class="d-none d-block w-100">';
    $646ceeeec66fabd8$export$62b82cd57460378a = '<input id="newTreeNick" type="text" class="form-control" minlength="3" maxlength="30" 			placeholder="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newTreeNickTip) + '"> 	<div id="statusNick" class="form-text pt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick) + '</div> 	<img id="imgNewTreeNick" src="./newNick.png" class="d-none d-block w-100">';
    $646ceeeec66fabd8$export$a76d078e0f25e96f = $646ceeeec66fabd8$export$d15beb852fc82fa2 + '<div class="container pb-4"> 		<div class="row"> 			<div class="col-md-6 mt-4 mx-auto"> 				<!-- TARJETA USUARIO --> 				<div class="card text-center"> 					<div class="card-header d-flex justify-content-center"> 						<img class="card-img-top avatar avatar-128 bg-light rounded-circle text-white {{^img}}p-1 p-sm-2{{/img}}" 							src="{{#img}}{{{.}}}{{/img}}{{^img}}https://raw.githubusercontent.com/twbs/icons/main/icons/person.svg{{/img}}" 							referrerpolicy="no-referrer"> 					</div> 					<div class="card-body"> 						<h5 class="card-title">{{{name}}}</h5> 						{{#activeLabel}}<p class="card-text">{{.}}</p>{{/activeLabel}} 						{{#master}}<p class="card-text">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).isMaster) + '</p>{{/master}} 						{{#cannotAnnotate}}<p class="card-text">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cannotAnnotate) + '</p>{{/cannotAnnotate}} 						{{#edutreesLabel}}<p class="card-text">{{.}}</p>{{/edutreesLabel}} 						{{#annotationsLabel}}<p class="card-text">{{.}}</p>{{/annotationsLabel}} 						{{#nickButtonLabel}}<button id="changeNick" type="button" class="btn btn-primary mt-1">{{.}}</button>{{/nickButtonLabel}} 					</div> 				</div> 				<!-- BOT\xd3N ATR\xc1S DISPS GRANDES --> 				<div class="d-none d-md-block col my-4 mx-auto"> 					<div class="d-flex ms-0"> 						<button type="button" class="ms-0 btn btn-secondary goback">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + '</button> 					</div> 				</div> 			</div> 			<!-- ACORDE\xd3N --> 			<div class="col-md-6 my-4 mx-auto"> 				<div class="accordion" id="accordionTrees"> 					<div class="accordion-item"> 						<h2 class="accordion-header"> 							<button class="accordion-button {{#showann}}collapsed{{/showann}}" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCreated" 								aria-expanded="{{^showann}}true{{/showann}}{{#showann}}false{{/showann}}" aria-controls="collapseCreated">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastCreatedTrees) + '</button> 						</h2> 						<div id="collapseCreated" class="accordion-collapse collapse {{^showann}}show{{/showann}}" data-bs-parent="#accordionTrees"> 							<div class="accordion-body {{#hayUltedutrees}}pt-0{{/hayUltedutrees}} {{^hayUltedutrees}}pb-0{{/hayUltedutrees}}"> 								{{^hayUltedutrees}}<p>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noCreatedTrees) + '</p>{{/hayUltedutrees}} 								{{#hayUltedutrees}} 								<div class="d-flex align-items-center justify-content-between my-2"> 									<h6 class="text-muted mt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).page) + ' #{{pagUltedutrees}}</h6> 									<span class="btn-group" role="group"> 										<button class="btn btn-outline-secondary pagina prev created" type="button" {{^hayUltedutreesPrev}}disabled{{/hayUltedutreesPrev}}><i class="bi bi-chevron-left"></i></button> 										<button class="btn btn-outline-secondary pagina sig created" type="button" {{^hayUltedutreesSig}}disabled{{/hayUltedutreesSig}}><i class="bi bi-chevron-right"></i></button> 									</span> 								</div> 								<ul class="list-group"> 									{{#ultedutrees}} 									<li class="list-group-item">{{{.}}}</li> 									{{/ultedutrees}} 								</ul> 								{{/hayUltedutrees}} 							</div> 						</div> 					</div> 					<div class="accordion-item"> 						<h2 class="accordion-header"> 							<button class="accordion-button {{^showann}}collapsed{{/showann}}" type="button" data-bs-toggle="collapse" 								data-bs-target="#collapseAnnotated" aria-expanded="{{^showann}}false{{/showann}}{{#showann}}true{{/showann}}" aria-controls="collapseAnnotated"> 								' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastAnnotations) + '</button> 						</h2> 						<div id="collapseAnnotated" class="accordion-collapse collapse {{#showann}}show{{/showann}}" data-bs-parent="#accordionTrees"> 							<div class="accordion-body {{#hayUltanns}}pt-0{{/hayUltanns}} {{^hayUltanns}}pb-0{{/hayUltanns}}"> 								{{^hayUltanns}}<p>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotations) + '</p>{{/hayUltanns}} 								{{#hayUltanns}} 								<div class="d-flex align-items-center justify-content-between my-2"> 									<h6 class="text-muted mt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).page) + ' #{{pagUltanns}}</h6> 									<span class="btn-group" role="group"> 										<button class="btn btn-outline-secondary pagina prev annotated" type="button" {{^hayUltannsPrev}}disabled{{/hayUltannsPrev}}><i class="bi bi-chevron-left"></i></button> 										<button class="btn btn-outline-secondary pagina sig annotated" type="button" {{^hayUltannsSig}}disabled{{/hayUltannsSig}}><i class="bi bi-chevron-right"></i></button> 									</span> 								</div> 								<ul class="list-group"> 									{{#ultanns}} 									<li class="list-group-item">{{{.}}}</li> 									{{/ultanns}} 								</ul> 								{{/hayUltanns}} 							</div> 						</div> 					</div> 				</div>	 			</div> 		</div> 		<!-- BACK BUTTON (SMALL) --> 		<div class="d-block d-md-none row"> 			<div class="col mb-4 mx-auto"> 				<div class="d-flex ms-0"> 					<button type="button" class="ms-0 btn btn-secondary goback">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + "</button> 				</div> 			</div> 		</div> 	</div>";
    $646ceeeec66fabd8$export$96346f251ef3b3fb = $646ceeeec66fabd8$export$d15beb852fc82fa2 + '<div class="container pb-4"> 		<!-- ACORDE\xd3N --> 		<div class="col-md-8 my-4 mx-auto"> 			<div class="accordion" id="accordionTrees"> 				<div class="accordion-item"> 					<h2 class="accordion-header"> 						<button class="accordion-button {{#showann}}collapsed{{/showann}}" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCreated" 							aria-expanded="{{^showann}}true{{/showann}}{{#showann}}false{{/showann}}" aria-controls="collapseCreated">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastCreatedTrees) + '</button> 					</h2> 					<div id="collapseCreated" class="accordion-collapse collapse {{^showann}}show{{/showann}}" data-bs-parent="#accordionTrees"> 						<div class="accordion-body {{#hayUltedutrees}}pt-0 px-2 px-md-4{{/hayUltedutrees}} pb-0"> 							{{^hayUltedutrees}}<p>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noCreatedTrees) + '</p>{{/hayUltedutrees}} 							{{#hayUltedutrees}} 							<div class="d-flex align-items-center justify-content-between my-2"> 								<h6 class="text-muted mt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).page) + ' #{{pagUltedutrees}}</h6> 								<span class="btn-group" role="group"> 									<button class="btn btn-outline-secondary pagina prev created" type="button" {{^hayUltedutreesPrev}}disabled{{/hayUltedutreesPrev}}><i class="bi bi-chevron-left"></i></button> 									<button class="btn btn-outline-secondary pagina sig created" type="button" {{^hayUltedutreesSig}}disabled{{/hayUltedutreesSig}}><i class="bi bi-chevron-right"></i></button> 								</span> 							</div> 							<div> 								<table class="table table-striped"> 									<thead> 										<tr> 											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + '</th> 											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).created) + '</th> 											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).creator) + '</th> 										</tr> 									</thead> 									<tbody class="table-group-divider"> 										{{#ultedutrees}} 										<tr> 											<td><a href="{{{treeHref}}}" etid="{{{etid}}}" class="educatree">{{treeLabel}}</a></td> 											<td>{{created}}</td> 											<td><a href="{{{userHref}}}" uid="{{{uid}}}" class="pagusuario">{{userLabel}}</a> </td> 										</tr> 										{{/ultedutrees}} 									</tbody> 								</table> 							</div> 							{{/hayUltedutrees}} 						</div> 					</div> 				</div> 				<div class="accordion-item"> 					<h2 class="accordion-header"> 						<button class="accordion-button {{^showann}}collapsed{{/showann}}" type="button" data-bs-toggle="collapse" 							data-bs-target="#collapseAnnotated" aria-expanded="{{^showann}}false{{/showann}}{{#showann}}true{{/showann}}" aria-controls="collapseAnnotated"> 							' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastAnnotations) + '</button> 					</h2> 					<div id="collapseAnnotated" class="accordion-collapse collapse {{#showann}}show{{/showann}}" data-bs-parent="#accordionTrees"> 						<div class="accordion-body {{#hayUltanns}}pt-0 px-2 px-md-4{{/hayUltanns}} pb-0"> 							{{^hayUltanns}}<p>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotations) + '</p>{{/hayUltanns}} 							{{#hayUltanns}} 							<div class="d-flex align-items-center justify-content-between my-2"> 								<h6 class="text-muted mt-2">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).page) + ' #{{pagUltanns}}</h6> 								<span class="btn-group" role="group"> 									<button class="btn btn-outline-secondary pagina prev annotated" type="button" {{^hayUltannsPrev}}disabled{{/hayUltannsPrev}}><i class="bi bi-chevron-left"></i></button> 									<button class="btn btn-outline-secondary pagina sig annotated" type="button" {{^hayUltannsSig}}disabled{{/hayUltannsSig}}><i class="bi bi-chevron-right"></i></button> 								</span> 							</div> 							<div> 								<table class="table table-striped"> 									<thead> 										<tr> 											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + '</th> 											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotationType) + '</th> 											<th scope="col">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotator) + '</th> 										</tr> 									</thead> 									<tbody class="table-group-divider"> 										{{#ultanns}} 										<tr> 											<td><a href="{{{treeHref}}}" etid="{{{etid}}}" class="educatree">{{treeLabel}}</a></td> 											<td>{{annotationType}}</td> 											<td><a href="{{{userHref}}}" uid="{{{uid}}}" class="pagusuario">{{userLabel}}</a>' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).onDate) + '{{annotated}}</td> 										</tr> 										{{/ultanns}} 									</tbody> 								</table> 							</div> 							{{/hayUltanns}} 						</div> 					</div> 				</div> 			</div>	 		</div> 		<!-- BACK BUTTON --> 		<div class="col-sm-8 my-4 mx-auto"> 			<div class="d-flex ms-0"> 				<button id="goBackButton" type="button" class="ms-0 btn btn-secondary">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).back) + "</button> 			</div> 		</div> 	</div>";
    $646ceeeec66fabd8$export$c75e99c9076bb133 = '<div id="questalert" class="alert alert-light ms-2 ms-md-2 mb-4 p-2 alert-dismissible fade show" role="alert"> 		<p class="mb-1">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).questtext) + '</p> 		<button id="questbotyes" type="button" questurl="' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).questurl) + '" class="btn btn-outline-secondary btn-sm">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).yes) + '</button>		<button id="questbotno" type="button" class="btn btn-outline-secondary btn-sm">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).no) + '</button>		<button id="questbotlater" type="button" class="btn btn-outline-secondary btn-sm">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).later) + "</button>	</div>";
}











var $8JYDX = parcelRequire("8JYDX");
var $73221a8bfd8f0132$exports = {};

/*!
Copyright (c) 2016 Dominik Moritz

This file is part of the leaflet locate control. It is licensed under the MIT license.
You can find the project at: https://github.com/domoritz/leaflet-locatecontrol
*/ (function(factory, window1) {
    // see https://github.com/Leaflet/Leaflet/blob/master/PLUGIN-GUIDE.md#module-loaders
    // for details on how to structure a leaflet plugin.
    // define an AMD module that relies on 'leaflet'
    if (typeof define === "function" && define.amd) define([
        "leaflet"
    ], factory);
    else if (true) {
        if (typeof window1 !== "undefined" && window1.L) $73221a8bfd8f0132$exports = factory(L);
        else $73221a8bfd8f0132$exports = factory((parcelRequire("8JYDX")));
    }
    // attach your plugin to the global 'L' variable
    if (typeof window1 !== "undefined" && window1.L) window1.L.Control.Locate = factory(L);
})(function(L1) {
    const LDomUtilApplyClassesMethod = (method, element, classNames)=>{
        classNames = classNames.split(" ");
        classNames.forEach(function(className) {
            L1.DomUtil[method].call(this, element, className);
        });
    };
    const addClasses = (el, names)=>LDomUtilApplyClassesMethod("addClass", el, names);
    const removeClasses = (el, names)=>LDomUtilApplyClassesMethod("removeClass", el, names);
    /**
   * Compatible with L.Circle but a true marker instead of a path
   */ const LocationMarker = L1.Marker.extend({
        initialize (latlng, options) {
            L1.Util.setOptions(this, options);
            this._latlng = latlng;
            this.createIcon();
        },
        /**
     * Create a styled circle location marker
     */ createIcon () {
            const opt = this.options;
            let style = "";
            if (opt.color !== undefined) style += `stroke:${opt.color};`;
            if (opt.weight !== undefined) style += `stroke-width:${opt.weight};`;
            if (opt.fillColor !== undefined) style += `fill:${opt.fillColor};`;
            if (opt.fillOpacity !== undefined) style += `fill-opacity:${opt.fillOpacity};`;
            if (opt.opacity !== undefined) style += `opacity:${opt.opacity};`;
            const icon = this._getIconSVG(opt, style);
            this._locationIcon = L1.divIcon({
                className: icon.className,
                html: icon.svg,
                iconSize: [
                    icon.w,
                    icon.h
                ]
            });
            this.setIcon(this._locationIcon);
        },
        /**
     * Return the raw svg for the shape
     *
     * Split so can be easily overridden
     */ _getIconSVG (options, style) {
            const r = options.radius;
            const w = options.weight;
            const s = r + w;
            const s2 = s * 2;
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${s2}" height="${s2}" version="1.1" viewBox="-${s} -${s} ${s2} ${s2}">` + '<circle r="' + r + '" style="' + style + '" />' + "</svg>";
            return {
                className: "leaflet-control-locate-location",
                svg: svg,
                w: s2,
                h: s2
            };
        },
        setStyle (style) {
            L1.Util.setOptions(this, style);
            this.createIcon();
        }
    });
    const CompassMarker = LocationMarker.extend({
        initialize (latlng, heading, options) {
            L1.Util.setOptions(this, options);
            this._latlng = latlng;
            this._heading = heading;
            this.createIcon();
        },
        setHeading (heading) {
            this._heading = heading;
        },
        /**
     * Create a styled arrow compass marker
     */ _getIconSVG (options, style) {
            const r = options.radius;
            const w = options.width + options.weight;
            const h = (r + options.depth + options.weight) * 2;
            const path = `M0,0 l${options.width / 2},${options.depth} l-${w},0 z`;
            const svgstyle = `transform: rotate(${this._heading}deg)`;
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" version="1.1" viewBox="-${w / 2} 0 ${w} ${h}" style="${svgstyle}">` + '<path d="' + path + '" style="' + style + '" />' + "</svg>";
            return {
                className: "leaflet-control-locate-heading",
                svg: svg,
                w: w,
                h: h
            };
        }
    });
    const LocateControl = L1.Control.extend({
        options: {
            /** Position of the control */ position: "topleft",
            /** The layer that the user's location should be drawn on. By default creates a new layer. */ layer: undefined,
            /**
       * Automatically sets the map view (zoom and pan) to the user's location as it updates.
       * While the map is following the user's location, the control is in the `following` state,
       * which changes the style of the control and the circle marker.
       *
       * Possible values:
       *  - false: never updates the map view when location changes.
       *  - 'once': set the view when the location is first determined
       *  - 'always': always updates the map view when location changes.
       *              The map view follows the user's location.
       *  - 'untilPan': like 'always', except stops updating the
       *                view if the user has manually panned the map.
       *                The map view follows the user's location until she pans.
       *  - 'untilPanOrZoom': (default) like 'always', except stops updating the
       *                view if the user has manually panned the map.
       *                The map view follows the user's location until she pans.
       */ setView: "untilPanOrZoom",
            /** Keep the current map zoom level when setting the view and only pan. */ keepCurrentZoomLevel: false,
            /** After activating the plugin by clicking on the icon, zoom to the selected zoom level, even when keepCurrentZoomLevel is true. Set to 'false' to disable this feature. */ initialZoomLevel: false,
            /**
       * This callback can be used to override the viewport tracking
       * This function should return a LatLngBounds object.
       *
       * For example to extend the viewport to ensure that a particular LatLng is visible:
       *
       * getLocationBounds: function(locationEvent) {
       *    return locationEvent.bounds.extend([-33.873085, 151.219273]);
       * },
       */ getLocationBounds (locationEvent) {
                return locationEvent.bounds;
            },
            /** Smooth pan and zoom to the location of the marker. Only works in Leaflet 1.0+. */ flyTo: false,
            /**
       * The user location can be inside and outside the current view when the user clicks on the
       * control that is already active. Both cases can be configures separately.
       * Possible values are:
       *  - 'setView': zoom and pan to the current location
       *  - 'stop': stop locating and remove the location marker
       */ clickBehavior: {
                /** What should happen if the user clicks on the control while the location is within the current view. */ inView: "stop",
                /** What should happen if the user clicks on the control while the location is outside the current view. */ outOfView: "setView",
                /**
         * What should happen if the user clicks on the control while the location is within the current view
         * and we could be following but are not. Defaults to a special value which inherits from 'inView';
         */ inViewNotFollowing: "inView"
            },
            /**
       * If set, save the map bounds just before centering to the user's
       * location. When control is disabled, set the view back to the
       * bounds that were saved.
       */ returnToPrevBounds: false,
            /**
       * Keep a cache of the location after the user deactivates the control. If set to false, the user has to wait
       * until the locate API returns a new location before they see where they are again.
       */ cacheLocation: true,
            /** If set, a circle that shows the location accuracy is drawn. */ drawCircle: true,
            /** If set, the marker at the users' location is drawn. */ drawMarker: true,
            /** If set and supported then show the compass heading */ showCompass: true,
            /** The class to be used to create the marker. For example L.CircleMarker or L.Marker */ markerClass: LocationMarker,
            /** The class us be used to create the compass bearing arrow */ compassClass: CompassMarker,
            /** Accuracy circle style properties. NOTE these styles should match the css animations styles */ circleStyle: {
                className: "leaflet-control-locate-circle",
                color: "#136AEC",
                fillColor: "#136AEC",
                fillOpacity: 0.15,
                weight: 0
            },
            /** Inner marker style properties. Only works if your marker class supports `setStyle`. */ markerStyle: {
                className: "leaflet-control-locate-marker",
                color: "#fff",
                fillColor: "#2A93EE",
                fillOpacity: 1,
                weight: 3,
                opacity: 1,
                radius: 9
            },
            /** Compass */ compassStyle: {
                fillColor: "#2A93EE",
                fillOpacity: 1,
                weight: 0,
                color: "#fff",
                opacity: 1,
                radius: 9,
                width: 9,
                depth: 6 // Length of the arrow
            },
            /**
       * Changes to accuracy circle and inner marker while following.
       * It is only necessary to provide the properties that should change.
       */ followCircleStyle: {},
            followMarkerStyle: {
            },
            followCompassStyle: {},
            /** The CSS class for the icon. For example fa-location-arrow or fa-map-marker */ icon: "leaflet-control-locate-location-arrow",
            iconLoading: "leaflet-control-locate-spinner",
            /** The element to be created for icons. For example span or i */ iconElementTag: "span",
            /** The element to be created for the text. For example small or span */ textElementTag: "small",
            /** Padding around the accuracy circle. */ circlePadding: [
                0,
                0
            ],
            /** Use metric units. */ metric: true,
            /**
       * This callback can be used in case you would like to override button creation behavior.
       * This is useful for DOM manipulation frameworks such as angular etc.
       * This function should return an object with HtmlElement for the button (link property) and the icon (icon property).
       */ createButtonCallback (container, options) {
                const link = L1.DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single", container);
                link.title = options.strings.title;
                link.href = "#";
                link.setAttribute("role", "button");
                const icon = L1.DomUtil.create(options.iconElementTag, options.icon, link);
                if (options.strings.text !== undefined) {
                    const text = L1.DomUtil.create(options.textElementTag, "leaflet-locate-text", link);
                    text.textContent = options.strings.text;
                    link.classList.add("leaflet-locate-text-active");
                    link.parentNode.style.display = "flex";
                    if (options.icon.length > 0) icon.classList.add("leaflet-locate-icon");
                }
                return {
                    link: link,
                    icon: icon
                };
            },
            /** This event is called in case of any location error that is not a time out error. */ onLocationError (err, control) {
                alert(err.message);
            },
            /**
       * This event is called when the user's location is outside the bounds set on the map.
       * The event is called repeatedly when the location changes.
       */ onLocationOutsideMapBounds (control) {
                control.stop();
                alert(control.options.strings.outsideMapBoundsMsg);
            },
            /** Display a pop-up when the user click on the inner marker. */ showPopup: true,
            strings: {
                title: "Show me where I am",
                metersUnit: "meters",
                feetUnit: "feet",
                popup: "You are within {distance} {unit} from this point",
                outsideMapBoundsMsg: "You seem located outside the boundaries of the map"
            },
            /** The default options passed to leaflets locate method. */ locateOptions: {
                maxZoom: Infinity,
                watch: true,
                setView: false // have to set this to false because we have to
            }
        },
        initialize (options) {
            // set default options if nothing is set (merge one step deep)
            for(const i in options)if (typeof this.options[i] === "object") L1.extend(this.options[i], options[i]);
            else this.options[i] = options[i];
            // extend the follow marker style and circle from the normal style
            this.options.followMarkerStyle = L1.extend({}, this.options.markerStyle, this.options.followMarkerStyle);
            this.options.followCircleStyle = L1.extend({}, this.options.circleStyle, this.options.followCircleStyle);
            this.options.followCompassStyle = L1.extend({}, this.options.compassStyle, this.options.followCompassStyle);
        },
        /**
     * Add control to map. Returns the container for the control.
     */ onAdd (map) {
            const container = L1.DomUtil.create("div", "leaflet-control-locate leaflet-bar leaflet-control");
            this._container = container;
            this._map = map;
            this._layer = this.options.layer || new L1.LayerGroup();
            this._layer.addTo(map);
            this._event = undefined;
            this._compassHeading = null;
            this._prevBounds = null;
            const linkAndIcon = this.options.createButtonCallback(container, this.options);
            this._link = linkAndIcon.link;
            this._icon = linkAndIcon.icon;
            L1.DomEvent.on(this._link, "click", function(ev) {
                L1.DomEvent.stopPropagation(ev);
                L1.DomEvent.preventDefault(ev);
                this._onClick();
            }, this).on(this._link, "dblclick", L1.DomEvent.stopPropagation);
            this._resetVariables();
            this._map.on("unload", this._unload, this);
            return container;
        },
        /**
     * This method is called when the user clicks on the control.
     */ _onClick () {
            this._justClicked = true;
            const wasFollowing = this._isFollowing();
            this._userPanned = false;
            this._userZoomed = false;
            if (this._active && !this._event) // click while requesting
            this.stop();
            else if (this._active) {
                const behaviors = this.options.clickBehavior;
                let behavior = behaviors.outOfView;
                if (this._map.getBounds().contains(this._event.latlng)) behavior = wasFollowing ? behaviors.inView : behaviors.inViewNotFollowing;
                // Allow inheriting from another behavior
                if (behaviors[behavior]) behavior = behaviors[behavior];
                switch(behavior){
                    case "setView":
                        this.setView();
                        break;
                    case "stop":
                        this.stop();
                        if (this.options.returnToPrevBounds) {
                            const f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                            f.bind(this._map)(this._prevBounds);
                        }
                        break;
                }
            } else {
                if (this.options.returnToPrevBounds) this._prevBounds = this._map.getBounds();
                this.start();
            }
            this._updateContainerStyle();
        },
        /**
     * Starts the plugin:
     * - activates the engine
     * - draws the marker (if coordinates available)
     */ start () {
            this._activate();
            if (this._event) {
                this._drawMarker(this._map);
                // if we already have a location but the user clicked on the control
                if (this.options.setView) this.setView();
            }
            this._updateContainerStyle();
        },
        /**
     * Stops the plugin:
     * - deactivates the engine
     * - reinitializes the button
     * - removes the marker
     */ stop () {
            this._deactivate();
            this._cleanClasses();
            this._resetVariables();
            this._removeMarker();
        },
        /**
     * Keep the control active but stop following the location
     */ stopFollowing () {
            this._userPanned = true;
            this._updateContainerStyle();
            this._drawMarker();
        },
        /**
     * This method launches the location engine.
     * It is called before the marker is updated,
     * event if it does not mean that the event will be ready.
     *
     * Override it if you want to add more functionalities.
     * It should set the this._active to true and do nothing if
     * this._active is true.
     */ _activate () {
            if (this._active || !this._map) return;
            this._map.locate(this.options.locateOptions);
            this._map.fire("locateactivate", this);
            this._active = true;
            // bind event listeners
            this._map.on("locationfound", this._onLocationFound, this);
            this._map.on("locationerror", this._onLocationError, this);
            this._map.on("dragstart", this._onDrag, this);
            this._map.on("zoomstart", this._onZoom, this);
            this._map.on("zoomend", this._onZoomEnd, this);
            if (this.options.showCompass) {
                const oriAbs = "ondeviceorientationabsolute" in window;
                if (oriAbs || "ondeviceorientation" in window) {
                    const _this = this;
                    const deviceorientation = function() {
                        L1.DomEvent.on(window, oriAbs ? "deviceorientationabsolute" : "deviceorientation", _this._onDeviceOrientation, _this);
                    };
                    if (DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission === "function") DeviceOrientationEvent.requestPermission().then(function(permissionState) {
                        if (permissionState === "granted") deviceorientation();
                    });
                    else deviceorientation();
                }
            }
        },
        /**
     * Called to stop the location engine.
     *
     * Override it to shutdown any functionalities you added on start.
     */ _deactivate () {
            if (!this._active || !this._map) return;
            this._map.stopLocate();
            this._map.fire("locatedeactivate", this);
            this._active = false;
            if (!this.options.cacheLocation) this._event = undefined;
            // unbind event listeners
            this._map.off("locationfound", this._onLocationFound, this);
            this._map.off("locationerror", this._onLocationError, this);
            this._map.off("dragstart", this._onDrag, this);
            this._map.off("zoomstart", this._onZoom, this);
            this._map.off("zoomend", this._onZoomEnd, this);
            if (this.options.showCompass) {
                this._compassHeading = null;
                if ("ondeviceorientationabsolute" in window) L1.DomEvent.off(window, "deviceorientationabsolute", this._onDeviceOrientation, this);
                else if ("ondeviceorientation" in window) L1.DomEvent.off(window, "deviceorientation", this._onDeviceOrientation, this);
            }
        },
        /**
     * Zoom (unless we should keep the zoom level) and an to the current view.
     */ setView () {
            this._drawMarker();
            if (this._isOutsideMapBounds()) {
                this._event = undefined; // clear the current location so we can get back into the bounds
                this.options.onLocationOutsideMapBounds(this);
            } else {
                if (this._justClicked && this.options.initialZoomLevel !== false) {
                    var f = this.options.flyTo ? this._map.flyTo : this._map.setView;
                    f.bind(this._map)([
                        this._event.latitude,
                        this._event.longitude
                    ], this.options.initialZoomLevel);
                } else if (this.options.keepCurrentZoomLevel) {
                    var f = this.options.flyTo ? this._map.flyTo : this._map.panTo;
                    f.bind(this._map)([
                        this._event.latitude,
                        this._event.longitude
                    ]);
                } else {
                    var f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                    // Ignore zoom events while setting the viewport as these would stop following
                    this._ignoreEvent = true;
                    f.bind(this._map)(this.options.getLocationBounds(this._event), {
                        padding: this.options.circlePadding,
                        maxZoom: this.options.initialZoomLevel || this.options.locateOptions.maxZoom
                    });
                    L1.Util.requestAnimFrame(function() {
                        // Wait until after the next animFrame because the flyTo can be async
                        this._ignoreEvent = false;
                    }, this);
                }
            }
        },
        /**
     *
     */ _drawCompass () {
            if (!this._event) return;
            const latlng = this._event.latlng;
            if (this.options.showCompass && latlng && this._compassHeading !== null) {
                const cStyle = this._isFollowing() ? this.options.followCompassStyle : this.options.compassStyle;
                if (!this._compass) this._compass = new this.options.compassClass(latlng, this._compassHeading, cStyle).addTo(this._layer);
                else {
                    this._compass.setLatLng(latlng);
                    this._compass.setHeading(this._compassHeading);
                    // If the compassClass can be updated with setStyle, update it.
                    if (this._compass.setStyle) this._compass.setStyle(cStyle);
                }
            //
            }
            if (this._compass && (!this.options.showCompass || this._compassHeading === null)) {
                this._compass.removeFrom(this._layer);
                this._compass = null;
            }
        },
        /**
     * Draw the marker and accuracy circle on the map.
     *
     * Uses the event retrieved from onLocationFound from the map.
     */ _drawMarker () {
            if (this._event.accuracy === undefined) this._event.accuracy = 0;
            const radius = this._event.accuracy;
            const latlng = this._event.latlng;
            // circle with the radius of the location's accuracy
            if (this.options.drawCircle) {
                const style = this._isFollowing() ? this.options.followCircleStyle : this.options.circleStyle;
                if (!this._circle) this._circle = L1.circle(latlng, radius, style).addTo(this._layer);
                else this._circle.setLatLng(latlng).setRadius(radius).setStyle(style);
            }
            let distance;
            let unit;
            if (this.options.metric) {
                distance = radius.toFixed(0);
                unit = this.options.strings.metersUnit;
            } else {
                distance = (radius * 3.2808399).toFixed(0);
                unit = this.options.strings.feetUnit;
            }
            // small inner marker
            if (this.options.drawMarker) {
                const mStyle = this._isFollowing() ? this.options.followMarkerStyle : this.options.markerStyle;
                if (!this._marker) this._marker = new this.options.markerClass(latlng, mStyle).addTo(this._layer);
                else {
                    this._marker.setLatLng(latlng);
                    // If the markerClass can be updated with setStyle, update it.
                    if (this._marker.setStyle) this._marker.setStyle(mStyle);
                }
            }
            this._drawCompass();
            const t = this.options.strings.popup;
            function getPopupText() {
                if (typeof t === "string") return L1.Util.template(t, {
                    distance: distance,
                    unit: unit
                });
                else if (typeof t === "function") return t({
                    distance: distance,
                    unit: unit
                });
                else return t;
            }
            if (this.options.showPopup && t && this._marker) this._marker.bindPopup(getPopupText())._popup.setLatLng(latlng);
            if (this.options.showPopup && t && this._compass) this._compass.bindPopup(getPopupText())._popup.setLatLng(latlng);
        },
        /**
     * Remove the marker from map.
     */ _removeMarker () {
            this._layer.clearLayers();
            this._marker = undefined;
            this._circle = undefined;
        },
        /**
     * Unload the plugin and all event listeners.
     * Kind of the opposite of onAdd.
     */ _unload () {
            this.stop();
            this._map.off("unload", this._unload, this);
        },
        /**
     * Sets the compass heading
     */ _setCompassHeading (angle) {
            if (!isNaN(parseFloat(angle)) && isFinite(angle)) {
                angle = Math.round(angle);
                this._compassHeading = angle;
                L1.Util.requestAnimFrame(this._drawCompass, this);
            } else this._compassHeading = null;
        },
        /**
     * If the compass fails calibration just fail safely and remove the compass
     */ _onCompassNeedsCalibration () {
            this._setCompassHeading();
        },
        /**
     * Process and normalise compass events
     */ _onDeviceOrientation (e) {
            if (!this._active) return;
            if (e.webkitCompassHeading) // iOS
            this._setCompassHeading(e.webkitCompassHeading);
            else if (e.absolute && e.alpha) // Android
            this._setCompassHeading(360 - e.alpha);
        },
        /**
     * Calls deactivate and dispatches an error.
     */ _onLocationError (err) {
            // ignore time out error if the location is watched
            if (err.code == 3 && this.options.locateOptions.watch) return;
            this.stop();
            this.options.onLocationError(err, this);
        },
        /**
     * Stores the received event and updates the marker.
     */ _onLocationFound (e) {
            // no need to do anything if the location has not changed
            if (this._event && this._event.latlng.lat === e.latlng.lat && this._event.latlng.lng === e.latlng.lng && this._event.accuracy === e.accuracy) return;
            if (!this._active) // we may have a stray event
            return;
            this._event = e;
            this._drawMarker();
            this._updateContainerStyle();
            switch(this.options.setView){
                case "once":
                    if (this._justClicked) this.setView();
                    break;
                case "untilPan":
                    if (!this._userPanned) this.setView();
                    break;
                case "untilPanOrZoom":
                    if (!this._userPanned && !this._userZoomed) this.setView();
                    break;
                case "always":
                    this.setView();
                    break;
                case false:
                    break;
            }
            this._justClicked = false;
        },
        /**
     * When the user drags. Need a separate event so we can bind and unbind event listeners.
     */ _onDrag () {
            // only react to drags once we have a location
            if (this._event && !this._ignoreEvent) {
                this._userPanned = true;
                this._updateContainerStyle();
                this._drawMarker();
            }
        },
        /**
     * When the user zooms. Need a separate event so we can bind and unbind event listeners.
     */ _onZoom () {
            // only react to drags once we have a location
            if (this._event && !this._ignoreEvent) {
                this._userZoomed = true;
                this._updateContainerStyle();
                this._drawMarker();
            }
        },
        /**
     * After a zoom ends update the compass and handle sideways zooms
     */ _onZoomEnd () {
            if (this._event) this._drawCompass();
            if (this._event && !this._ignoreEvent) // If we have zoomed in and out and ended up sideways treat it as a pan
            {
                if (this._marker && !this._map.getBounds().pad(-0.3).contains(this._marker.getLatLng())) {
                    this._userPanned = true;
                    this._updateContainerStyle();
                    this._drawMarker();
                }
            }
        },
        /**
     * Compute whether the map is following the user location with pan and zoom.
     */ _isFollowing () {
            if (!this._active) return false;
            if (this.options.setView === "always") return true;
            else if (this.options.setView === "untilPan") return !this._userPanned;
            else if (this.options.setView === "untilPanOrZoom") return !this._userPanned && !this._userZoomed;
        },
        /**
     * Check if location is in map bounds
     */ _isOutsideMapBounds () {
            if (this._event === undefined) return false;
            return this._map.options.maxBounds && !this._map.options.maxBounds.contains(this._event.latlng);
        },
        /**
     * Toggles button class between following and active.
     */ _updateContainerStyle () {
            if (!this._container) return;
            if (this._active && !this._event) // active but don't have a location yet
            this._setClasses("requesting");
            else if (this._isFollowing()) this._setClasses("following");
            else if (this._active) this._setClasses("active");
            else this._cleanClasses();
        },
        /**
     * Sets the CSS classes for the state.
     */ _setClasses (state) {
            if (state == "requesting") {
                removeClasses(this._container, "active following");
                addClasses(this._container, "requesting");
                removeClasses(this._icon, this.options.icon);
                addClasses(this._icon, this.options.iconLoading);
            } else if (state == "active") {
                removeClasses(this._container, "requesting following");
                addClasses(this._container, "active");
                removeClasses(this._icon, this.options.iconLoading);
                addClasses(this._icon, this.options.icon);
            } else if (state == "following") {
                removeClasses(this._container, "requesting");
                addClasses(this._container, "active following");
                removeClasses(this._icon, this.options.iconLoading);
                addClasses(this._icon, this.options.icon);
            }
        },
        /**
     * Removes all classes from button.
     */ _cleanClasses () {
            L1.DomUtil.removeClass(this._container, "requesting");
            L1.DomUtil.removeClass(this._container, "active");
            L1.DomUtil.removeClass(this._container, "following");
            removeClasses(this._icon, this.options.iconLoading);
            addClasses(this._icon, this.options.icon);
        },
        /**
     * Reinitializes state variables.
     */ _resetVariables () {
            // whether locate is active or not
            this._active = false;
            // true if the control was clicked for the first time
            // we need this so we can pan and zoom once we have the location
            this._justClicked = false;
            // true if the user has panned the map after clicking the control
            this._userPanned = false;
            // true if the user has zoomed the map after clicking the control
            this._userZoomed = false;
        }
    });
    L1.control.locate = (options)=>new L1.Control.Locate(options);
    return LocateControl;
}, window);



var $6KOho = parcelRequire("6KOho");

var $dktVJ = parcelRequire("dktVJ");

/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $fhN3L = parcelRequire("fhN3L");

var $6AR8M = parcelRequire("6AR8M");

var $6KOho = parcelRequire("6KOho");
var $d486cd8337e91fbc$exports = {};
(function(global, factory) {
    $d486cd8337e91fbc$exports = factory();
})($d486cd8337e91fbc$exports, function() {
    "use strict";
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === "[object Array]";
    };
    function isFunction(object) {
        return typeof object === "function";
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? "array" : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === "object" && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== "object" && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;"
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ""; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === "string") tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error("Invalid tags: " + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
            closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp("\\s*" + escapeRegExp("}" + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += " ";
                }
                tokens.push([
                    "text",
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === "\n") {
                    stripSpace();
                    indentation = "";
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || "name";
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === "=") {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === "{") {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = "&";
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error("Unclosed tag at " + scanner.pos);
            if (type == ">") token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === "#" || type === "^") sections.push(token);
            else if (type === "/") {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === "name" || type === "{" || type === "&") nonSpace = true;
            else if (type === "=") // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === "text" && lastToken && lastToken[0] === "text") {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case "#":
                case "^":
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case "/":
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === "";
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return "";
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = "";
                break;
            case 0:
                match = "";
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            ".": this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf(".") > 0) {
                    intermediateValue = context.view;
                    names = name.split(".");
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== "undefined") this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ":" + (tags || mustache.tags).join(":");
        var isCacheEnabled = typeof cache1 !== "undefined";
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = "";
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === "#") value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === "^") value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === ">") value = this.renderPartial(token, context, partials, config);
            else if (symbol === "&") value = this.unescapedValue(token, context);
            else if (symbol === "name") value = this.escapedValue(token, context, config);
            else if (symbol === "text") value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = "";
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === "object" || typeof value === "string" || typeof value === "number") buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== "string") throw new Error("Cannot use higher-order sections without the original template");
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, "");
        var partialByNl = partial.split("\n");
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join("\n");
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === "number" && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === "object") return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === "object" && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: "mustache.js",
        version: "4.2.0",
        tags: [
            "{{",
            "}}"
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== "string") throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + "argument for mustache#render(template, view, partials)");
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});



var $dktVJ = parcelRequire("dktVJ");

/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");

var $2q7Wm = parcelRequire("2q7Wm");
var $e916d1c05dbae7b7$exports = {};
let $e916d1c05dbae7b7$var$numberRegexp = /[-+]?([0-9]*\.[0-9]+|[0-9]+)([eE][-+]?[0-9]+)?/;
// Matches sequences like '100 100' or '100 100 100'.
let $e916d1c05dbae7b7$var$coordFormat = new RegExp("^" + $e916d1c05dbae7b7$var$numberRegexp.source + "(\\s" + $e916d1c05dbae7b7$var$numberRegexp.source + "){1,}");
/**
 * Parse WKT and return GeoJSON.
 * @param wkt
 * @return {?Object} A GeoJSON geometry object
 */ const $e916d1c05dbae7b7$var$parse = (wkt)=>{
    let parts = wkt.split(";");
    let _ = parts.pop();
    let srid = (parts.shift() || "").split("=").pop();
    let i = 0;
    function $(re) {
        let match = _.substring(i).match(re);
        if (!match) return null;
        else {
            i += match[0].length;
            return match[0];
        }
    }
    function crs(obj) {
        if (obj && srid.match(/\d+/)) obj.crs = {
            type: "name",
            properties: {
                name: "urn:ogc:def:crs:EPSG::" + srid
            }
        };
        return obj;
    }
    function white() {
        $(/^\s*/);
    }
    function multicoords() {
        white();
        let depth = 0;
        let rings = [];
        let stack = [
            rings
        ];
        let pointer = rings;
        let elem;
        while(elem = $(/^(\()/) || $(/^(\))/) || $(/^(,)/) || $($e916d1c05dbae7b7$var$coordFormat)){
            if (elem === "(") {
                stack.push(pointer);
                pointer = [];
                stack[stack.length - 1].push(pointer);
                depth++;
            } else if (elem === ")") {
                // For the case: Polygon(), ...
                if (pointer.length === 0) return null;
                pointer = stack.pop();
                // the stack was empty, input was malformed
                if (!pointer) return null;
                depth--;
                if (depth === 0) break;
            } else if (elem === ",") {
                pointer = [];
                stack[stack.length - 1].push(pointer);
            } else if (!elem.split(/\s/g).some(isNaN)) Array.prototype.push.apply(pointer, elem.split(/\s/g).map(parseFloat));
            else return null;
            white();
        }
        if (depth !== 0) return null;
        return rings;
    }
    function coords() {
        let list = [];
        let item;
        let pt;
        while(pt = $($e916d1c05dbae7b7$var$coordFormat) || $(/^(,)/)){
            if (pt === ",") {
                list.push(item);
                item = [];
            } else if (!pt.split(/\s/g).some(isNaN)) {
                if (!item) item = [];
                Array.prototype.push.apply(item, pt.split(/\s/g).map(parseFloat));
            }
            white();
        }
        if (item) list.push(item);
        else return null;
        return list.length ? list : null;
    }
    function point() {
        if (!$(/^(point(\sz)?)/i)) return null;
        white();
        if (!$(/^(\()/)) return null;
        let c = coords();
        if (!c) return null;
        white();
        if (!$(/^(\))/)) return null;
        return {
            type: "Point",
            coordinates: c[0]
        };
    }
    function multipoint() {
        if (!$(/^(multipoint(\sz)?)/i)) return null;
        white();
        let newCoordsFormat = _.substring(_.indexOf("(") + 1, _.length - 1).replace(/\(/g, "").replace(/\)/g, "");
        _ = "MULTIPOINT (" + newCoordsFormat + ")";
        let c = multicoords();
        if (!c) return null;
        white();
        return {
            type: "MultiPoint",
            coordinates: c
        };
    }
    function multilinestring() {
        if (!$(/^(multilinestring(\sz)?)/i)) return null;
        white();
        let c = multicoords();
        if (!c) return null;
        white();
        return {
            type: "MultiLineString",
            coordinates: c
        };
    }
    function linestring() {
        if (!$(/^(linestring(\sz)?)/i)) return null;
        white();
        if (!$(/^(\()/)) return null;
        let c = coords();
        if (!c) return null;
        if (!$(/^(\))/)) return null;
        return {
            type: "LineString",
            coordinates: c
        };
    }
    function polygon() {
        if (!$(/^(polygon(\sz)?)/i)) return null;
        white();
        let c = multicoords();
        if (!c) return null;
        return {
            type: "Polygon",
            coordinates: c
        };
    }
    function multipolygon() {
        if (!$(/^(multipolygon(\sz)?)/i)) return null;
        white();
        let c = multicoords();
        if (!c) return null;
        return {
            type: "MultiPolygon",
            coordinates: c
        };
    }
    function geometrycollection() {
        let geometries = [];
        let geometry;
        if (!$(/^(geometrycollection)/i)) return null;
        white();
        if (!$(/^(\()/)) return null;
        while(geometry = root()){
            geometries.push(geometry);
            white();
            $(/^(,)/);
            white();
        }
        if (!$(/^(\))/)) return null;
        return {
            type: "GeometryCollection",
            geometries: geometries
        };
    }
    function root() {
        return point() || linestring() || polygon() || multipoint() || multilinestring() || multipolygon() || geometrycollection();
    }
    return crs(root());
};
/**
 * Stringifies a GeoJSON object into WKT
 */ const $e916d1c05dbae7b7$var$stringify = (geoJSON)=>{
    if (geoJSON.type === "Feature") geoJSON = geoJSON.geometry;
    function pairWKT(c) {
        return c.join(" ");
    }
    function ringWKT(r) {
        return r.map(pairWKT).join(", ");
    }
    function ringsWKT(r) {
        return r.map(ringWKT).map(wrapParens).join(", ");
    }
    function multiRingsWKT(r) {
        return r.map(ringsWKT).map(wrapParens).join(", ");
    }
    function wrapParens(s) {
        return "(" + s + ")";
    }
    let gJ = geoJSON;
    switch(gJ.type){
        case "Point":
            if (gJ.coordinates && gJ.coordinates.length === 3) return "POINT Z (" + pairWKT(gJ.coordinates) + ")";
            else return "POINT (" + pairWKT(gJ.coordinates) + ")";
        case "LineString":
            if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0].length === 3) return "LINESTRING Z (" + ringWKT(gJ.coordinates) + ")";
            else return "LINESTRING (" + ringWKT(gJ.coordinates) + ")";
        case "Polygon":
            if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0][0] && gJ.coordinates[0][0].length === 3) return "POLYGON Z (" + ringsWKT(gJ.coordinates) + ")";
            else return "POLYGON (" + ringsWKT(gJ.coordinates) + ")";
        case "MultiPoint":
            if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0].length === 3) return "MULTIPOINT Z (" + ringWKT(gJ.coordinates) + ")";
            else return "MULTIPOINT (" + ringWKT(gJ.coordinates) + ")";
        case "MultiLineString":
            if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0][0] && gJ.coordinates[0][0].length === 3) return "MULTILINESTRING Z (" + ringsWKT(gJ.coordinates) + ")";
            else return "MULTILINESTRING (" + ringsWKT(gJ.coordinates) + ")";
        case "MultiPolygon":
            if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0][0] && gJ.coordinates[0][0] && gJ.coordinates[0][0][0].length === 3) return "MULTIPOLYGON Z (" + multiRingsWKT(gJ.coordinates) + ")";
            else return "MULTIPOLYGON (" + multiRingsWKT(gJ.coordinates) + ")";
        case "GeometryCollection":
            return "GEOMETRYCOLLECTION (" + gJ.geometries.map($e916d1c05dbae7b7$var$stringify).join(", ") + ")";
        default:
            throw new Error("stringify requires a valid GeoJSON Feature or geometry object as input");
    }
};
$e916d1c05dbae7b7$exports = {
    parse: $e916d1c05dbae7b7$var$parse,
    stringify: $e916d1c05dbae7b7$var$stringify
};



/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");

parcelRequire("8JYDX");
/*
 Leaflet.draw 1.0.4, a plugin that adds drawing and editing tools to Leaflet powered maps.
 (c) 2012-2017, Jacob Toye, Jon West, Smartrak, Leaflet

 https://github.com/Leaflet/Leaflet.draw
 http://leafletjs.com
 */ !function(t, e, i) {
    function o(t, e) {
        for(; (t = t.parentElement) && !t.classList.contains(e););
        return t;
    }
    L.drawVersion = "1.0.4", L.Draw = {}, L.drawLocal = {
        draw: {
            toolbar: {
                actions: {
                    title: "Cancel drawing",
                    text: "Cancel"
                },
                finish: {
                    title: "Finish drawing",
                    text: "Finish"
                },
                undo: {
                    title: "Delete last point drawn",
                    text: "Delete last point"
                },
                buttons: {
                    polyline: "Draw a polyline",
                    polygon: "Draw a polygon",
                    rectangle: "Draw a rectangle",
                    circle: "Draw a circle",
                    marker: "Draw a marker",
                    circlemarker: "Draw a circlemarker"
                }
            },
            handlers: {
                circle: {
                    tooltip: {
                        start: "Click and drag to draw circle."
                    },
                    radius: "Radius"
                },
                circlemarker: {
                    tooltip: {
                        start: "Click map to place circle marker."
                    }
                },
                marker: {
                    tooltip: {
                        start: "Click map to place marker."
                    }
                },
                polygon: {
                    tooltip: {
                        start: "Click to start drawing shape.",
                        cont: "Click to continue drawing shape.",
                        end: "Click first point to close this shape."
                    }
                },
                polyline: {
                    error: "<strong>Error:</strong> shape edges cannot cross!",
                    tooltip: {
                        start: "Click to start drawing line.",
                        cont: "Click to continue drawing line.",
                        end: "Click last point to finish line."
                    }
                },
                rectangle: {
                    tooltip: {
                        start: "Click and drag to draw rectangle."
                    }
                },
                simpleshape: {
                    tooltip: {
                        end: "Release mouse to finish drawing."
                    }
                }
            }
        },
        edit: {
            toolbar: {
                actions: {
                    save: {
                        title: "Save changes",
                        text: "Save"
                    },
                    cancel: {
                        title: "Cancel editing, discards all changes",
                        text: "Cancel"
                    },
                    clearAll: {
                        title: "Clear all layers",
                        text: "Clear All"
                    }
                },
                buttons: {
                    edit: "Edit layers",
                    editDisabled: "No layers to edit",
                    remove: "Delete layers",
                    removeDisabled: "No layers to delete"
                }
            },
            handlers: {
                edit: {
                    tooltip: {
                        text: "Drag handles or markers to edit features.",
                        subtext: "Click cancel to undo changes."
                    }
                },
                remove: {
                    tooltip: {
                        text: "Click on a feature to remove."
                    }
                }
            }
        }
    }, L.Draw.Event = {}, L.Draw.Event.CREATED = "draw:created", L.Draw.Event.EDITED = "draw:edited", L.Draw.Event.DELETED = "draw:deleted", L.Draw.Event.DRAWSTART = "draw:drawstart", L.Draw.Event.DRAWSTOP = "draw:drawstop", L.Draw.Event.DRAWVERTEX = "draw:drawvertex", L.Draw.Event.EDITSTART = "draw:editstart", L.Draw.Event.EDITMOVE = "draw:editmove", L.Draw.Event.EDITRESIZE = "draw:editresize", L.Draw.Event.EDITVERTEX = "draw:editvertex", L.Draw.Event.EDITSTOP = "draw:editstop", L.Draw.Event.DELETESTART = "draw:deletestart", L.Draw.Event.DELETESTOP = "draw:deletestop", L.Draw.Event.TOOLBAROPENED = "draw:toolbaropened", L.Draw.Event.TOOLBARCLOSED = "draw:toolbarclosed", L.Draw.Event.MARKERCONTEXT = "draw:markercontext", L.Draw = L.Draw || {}, L.Draw.Feature = L.Handler.extend({
        initialize: function(t, e) {
            this._map = t, this._container = t._container, this._overlayPane = t._panes.overlayPane, this._popupPane = t._panes.popupPane, e && e.shapeOptions && (e.shapeOptions = L.Util.extend({}, this.options.shapeOptions, e.shapeOptions)), L.setOptions(this, e);
            var i = L.version.split(".");
            1 === parseInt(i[0], 10) && parseInt(i[1], 10) >= 2 ? L.Draw.Feature.include(L.Evented.prototype) : L.Draw.Feature.include(L.Mixin.Events);
        },
        enable: function() {
            this._enabled || (L.Handler.prototype.enable.call(this), this.fire("enabled", {
                handler: this.type
            }), this._map.fire(L.Draw.Event.DRAWSTART, {
                layerType: this.type
            }));
        },
        disable: function() {
            this._enabled && (L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.DRAWSTOP, {
                layerType: this.type
            }), this.fire("disabled", {
                handler: this.type
            }));
        },
        addHooks: function() {
            var t = this._map;
            t && (L.DomUtil.disableTextSelection(), t.getContainer().focus(), this._tooltip = new L.Draw.Tooltip(this._map), L.DomEvent.on(this._container, "keyup", this._cancelDrawing, this));
        },
        removeHooks: function() {
            this._map && (L.DomUtil.enableTextSelection(), this._tooltip.dispose(), this._tooltip = null, L.DomEvent.off(this._container, "keyup", this._cancelDrawing, this));
        },
        setOptions: function(t) {
            L.setOptions(this, t);
        },
        _fireCreatedEvent: function(t) {
            this._map.fire(L.Draw.Event.CREATED, {
                layer: t,
                layerType: this.type
            });
        },
        _cancelDrawing: function(t) {
            27 === t.keyCode && (this._map.fire("draw:canceled", {
                layerType: this.type
            }), this.disable());
        }
    }), L.Draw.Polyline = L.Draw.Feature.extend({
        statics: {
            TYPE: "polyline"
        },
        Poly: L.Polyline,
        options: {
            allowIntersection: !0,
            repeatMode: !1,
            drawError: {
                color: "#b00b00",
                timeout: 2500
            },
            icon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon"
            }),
            touchIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"
            }),
            guidelineDistance: 20,
            maxGuideLineLength: 4e3,
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !1,
                clickable: !0
            },
            metric: !0,
            feet: !0,
            nautic: !1,
            showLength: !0,
            zIndexOffset: 2e3,
            factor: 1,
            maxPoints: 0
        },
        initialize: function(t, e) {
            L.Browser.touch && (this.options.icon = this.options.touchIcon), this.options.drawError.message = L.drawLocal.draw.handlers.polyline.error, e && e.drawError && (e.drawError = L.Util.extend({}, this.options.drawError, e.drawError)), this.type = L.Draw.Polyline.TYPE, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function() {
            L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._markers = [], this._markerGroup = new L.LayerGroup, this._map.addLayer(this._markerGroup), this._poly = new L.Polyline([], this.options.shapeOptions), this._tooltip.updateContent(this._getTooltipText()), this._mouseMarker || (this._mouseMarker = L.marker(this._map.getCenter(), {
                icon: L.divIcon({
                    className: "leaflet-mouse-marker",
                    iconAnchor: [
                        20,
                        20
                    ],
                    iconSize: [
                        40,
                        40
                    ]
                }),
                opacity: 0,
                zIndexOffset: this.options.zIndexOffset
            })), this._mouseMarker.on("mouseout", this._onMouseOut, this).on("mousemove", this._onMouseMove, this).on("mousedown", this._onMouseDown, this).on("mouseup", this._onMouseUp, this).addTo(this._map), this._map.on("mouseup", this._onMouseUp, this).on("mousemove", this._onMouseMove, this).on("zoomlevelschange", this._onZoomEnd, this).on("touchstart", this._onTouch, this).on("zoomend", this._onZoomEnd, this));
        },
        removeHooks: function() {
            L.Draw.Feature.prototype.removeHooks.call(this), this._clearHideErrorTimeout(), this._cleanUpShape(), this._map.removeLayer(this._markerGroup), delete this._markerGroup, delete this._markers, this._map.removeLayer(this._poly), delete this._poly, this._mouseMarker.off("mousedown", this._onMouseDown, this).off("mouseout", this._onMouseOut, this).off("mouseup", this._onMouseUp, this).off("mousemove", this._onMouseMove, this), this._map.removeLayer(this._mouseMarker), delete this._mouseMarker, this._clearGuides(), this._map.off("mouseup", this._onMouseUp, this).off("mousemove", this._onMouseMove, this).off("zoomlevelschange", this._onZoomEnd, this).off("zoomend", this._onZoomEnd, this).off("touchstart", this._onTouch, this).off("click", this._onTouch, this);
        },
        deleteLastVertex: function() {
            if (!(this._markers.length <= 1)) {
                var t = this._markers.pop(), e = this._poly, i = e.getLatLngs(), o = i.splice(-1, 1)[0];
                this._poly.setLatLngs(i), this._markerGroup.removeLayer(t), e.getLatLngs().length < 2 && this._map.removeLayer(e), this._vertexChanged(o, !1);
            }
        },
        addVertex: function(t) {
            if (this._markers.length >= 2 && !this.options.allowIntersection && this._poly.newLatLngIntersects(t)) return void this._showErrorTooltip();
            this._errorShown && this._hideErrorTooltip(), this._markers.push(this._createMarker(t)), this._poly.addLatLng(t), 2 === this._poly.getLatLngs().length && this._map.addLayer(this._poly), this._vertexChanged(t, !0);
        },
        completeShape: function() {
            this._markers.length <= 1 || !this._shapeIsValid() || (this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable());
        },
        _finishShape: function() {
            var t = this._poly._defaultShape ? this._poly._defaultShape() : this._poly.getLatLngs(), e = this._poly.newLatLngIntersects(t[t.length - 1]);
            if (!this.options.allowIntersection && e || !this._shapeIsValid()) return void this._showErrorTooltip();
            this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
        },
        _shapeIsValid: function() {
            return !0;
        },
        _onZoomEnd: function() {
            null !== this._markers && this._updateGuide();
        },
        _onMouseMove: function(t) {
            var e = this._map.mouseEventToLayerPoint(t.originalEvent), i = this._map.layerPointToLatLng(e);
            this._currentLatLng = i, this._updateTooltip(i), this._updateGuide(e), this._mouseMarker.setLatLng(i), L.DomEvent.preventDefault(t.originalEvent);
        },
        _vertexChanged: function(t, e) {
            this._map.fire(L.Draw.Event.DRAWVERTEX, {
                layers: this._markerGroup
            }), this._updateFinishHandler(), this._updateRunningMeasure(t, e), this._clearGuides(), this._updateTooltip();
        },
        _onMouseDown: function(t) {
            if (!this._clickHandled && !this._touchHandled && !this._disableMarkers) {
                this._onMouseMove(t), this._clickHandled = !0, this._disableNewMarkers();
                var e = t.originalEvent, i = e.clientX, o = e.clientY;
                this._startPoint.call(this, i, o);
            }
        },
        _startPoint: function(t, e) {
            this._mouseDownOrigin = L.point(t, e);
        },
        _onMouseUp: function(t) {
            var e = t.originalEvent, i = e.clientX, o = e.clientY;
            this._endPoint.call(this, i, o, t), this._clickHandled = null;
        },
        _endPoint: function(e, i, o) {
            if (this._mouseDownOrigin) {
                var a = L.point(e, i).distanceTo(this._mouseDownOrigin), n = this._calculateFinishDistance(o.latlng);
                this.options.maxPoints > 1 && this.options.maxPoints == this._markers.length + 1 ? (this.addVertex(o.latlng), this._finishShape()) : n < 10 && L.Browser.touch ? this._finishShape() : Math.abs(a) < 9 * (t.devicePixelRatio || 1) && this.addVertex(o.latlng), this._enableNewMarkers();
            }
            this._mouseDownOrigin = null;
        },
        _onTouch: function(t) {
            var e, i, o = t.originalEvent;
            !o.touches || !o.touches[0] || this._clickHandled || this._touchHandled || this._disableMarkers || (e = o.touches[0].clientX, i = o.touches[0].clientY, this._disableNewMarkers(), this._touchHandled = !0, this._startPoint.call(this, e, i), this._endPoint.call(this, e, i, t), this._touchHandled = null), this._clickHandled = null;
        },
        _onMouseOut: function() {
            this._tooltip && this._tooltip._onMouseOut.call(this._tooltip);
        },
        _calculateFinishDistance: function(t) {
            var e;
            if (this._markers.length > 0) {
                var i;
                if (this.type === L.Draw.Polyline.TYPE) i = this._markers[this._markers.length - 1];
                else {
                    if (this.type !== L.Draw.Polygon.TYPE) return 1 / 0;
                    i = this._markers[0];
                }
                var o = this._map.latLngToContainerPoint(i.getLatLng()), a = new L.Marker(t, {
                    icon: this.options.icon,
                    zIndexOffset: 2 * this.options.zIndexOffset
                }), n = this._map.latLngToContainerPoint(a.getLatLng());
                e = o.distanceTo(n);
            } else e = 1 / 0;
            return e;
        },
        _updateFinishHandler: function() {
            var t = this._markers.length;
            t > 1 && this._markers[t - 1].on("click", this._finishShape, this), t > 2 && this._markers[t - 2].off("click", this._finishShape, this);
        },
        _createMarker: function(t) {
            var e = new L.Marker(t, {
                icon: this.options.icon,
                zIndexOffset: 2 * this.options.zIndexOffset
            });
            return this._markerGroup.addLayer(e), e;
        },
        _updateGuide: function(t) {
            var e = this._markers ? this._markers.length : 0;
            e > 0 && (t = t || this._map.latLngToLayerPoint(this._currentLatLng), this._clearGuides(), this._drawGuide(this._map.latLngToLayerPoint(this._markers[e - 1].getLatLng()), t));
        },
        _updateTooltip: function(t) {
            var e = this._getTooltipText();
            t && this._tooltip.updatePosition(t), this._errorShown || this._tooltip.updateContent(e);
        },
        _drawGuide: function(t, e) {
            var i, o, a, n = Math.floor(Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2))), s = this.options.guidelineDistance, r = this.options.maxGuideLineLength, l = n > r ? n - r : s;
            for(this._guidesContainer || (this._guidesContainer = L.DomUtil.create("div", "leaflet-draw-guides", this._overlayPane)); l < n; l += this.options.guidelineDistance)i = l / n, o = {
                x: Math.floor(t.x * (1 - i) + i * e.x),
                y: Math.floor(t.y * (1 - i) + i * e.y)
            }, a = L.DomUtil.create("div", "leaflet-draw-guide-dash", this._guidesContainer), a.style.backgroundColor = this._errorShown ? this.options.drawError.color : this.options.shapeOptions.color, L.DomUtil.setPosition(a, o);
        },
        _updateGuideColor: function(t) {
            if (this._guidesContainer) for(var e = 0, i = this._guidesContainer.childNodes.length; e < i; e++)this._guidesContainer.childNodes[e].style.backgroundColor = t;
        },
        _clearGuides: function() {
            if (this._guidesContainer) for(; this._guidesContainer.firstChild;)this._guidesContainer.removeChild(this._guidesContainer.firstChild);
        },
        _getTooltipText: function() {
            var t, e, i = this.options.showLength;
            return 0 === this._markers.length ? t = {
                text: L.drawLocal.draw.handlers.polyline.tooltip.start
            } : (e = i ? this._getMeasurementString() : "", t = 1 === this._markers.length ? {
                text: L.drawLocal.draw.handlers.polyline.tooltip.cont,
                subtext: e
            } : {
                text: L.drawLocal.draw.handlers.polyline.tooltip.end,
                subtext: e
            }), t;
        },
        _updateRunningMeasure: function(t, e) {
            var i, o, a = this._markers.length;
            1 === this._markers.length ? this._measurementRunningTotal = 0 : (i = a - (e ? 2 : 1), o = L.GeometryUtil.isVersion07x() ? t.distanceTo(this._markers[i].getLatLng()) * (this.options.factor || 1) : this._map.distance(t, this._markers[i].getLatLng()) * (this.options.factor || 1), this._measurementRunningTotal += o * (e ? 1 : -1));
        },
        _getMeasurementString: function() {
            var t, e = this._currentLatLng, i = this._markers[this._markers.length - 1].getLatLng();
            return t = L.GeometryUtil.isVersion07x() ? i && e && e.distanceTo ? this._measurementRunningTotal + e.distanceTo(i) * (this.options.factor || 1) : this._measurementRunningTotal || 0 : i && e ? this._measurementRunningTotal + this._map.distance(e, i) * (this.options.factor || 1) : this._measurementRunningTotal || 0, L.GeometryUtil.readableDistance(t, this.options.metric, this.options.feet, this.options.nautic, this.options.precision);
        },
        _showErrorTooltip: function() {
            this._errorShown = !0, this._tooltip.showAsError().updateContent({
                text: this.options.drawError.message
            }), this._updateGuideColor(this.options.drawError.color), this._poly.setStyle({
                color: this.options.drawError.color
            }), this._clearHideErrorTimeout(), this._hideErrorTimeout = setTimeout(L.Util.bind(this._hideErrorTooltip, this), this.options.drawError.timeout);
        },
        _hideErrorTooltip: function() {
            this._errorShown = !1, this._clearHideErrorTimeout(), this._tooltip.removeError().updateContent(this._getTooltipText()), this._updateGuideColor(this.options.shapeOptions.color), this._poly.setStyle({
                color: this.options.shapeOptions.color
            });
        },
        _clearHideErrorTimeout: function() {
            this._hideErrorTimeout && (clearTimeout(this._hideErrorTimeout), this._hideErrorTimeout = null);
        },
        _disableNewMarkers: function() {
            this._disableMarkers = !0;
        },
        _enableNewMarkers: function() {
            setTimeout((function() {
                this._disableMarkers = !1;
            }).bind(this), 50);
        },
        _cleanUpShape: function() {
            this._markers.length > 1 && this._markers[this._markers.length - 1].off("click", this._finishShape, this);
        },
        _fireCreatedEvent: function() {
            var t = new this.Poly(this._poly.getLatLngs(), this.options.shapeOptions);
            L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        }
    }), L.Draw.Polygon = L.Draw.Polyline.extend({
        statics: {
            TYPE: "polygon"
        },
        Poly: L.Polygon,
        options: {
            showArea: !1,
            showLength: !1,
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !0,
                fillColor: null,
                fillOpacity: .2,
                clickable: !0
            },
            metric: !0,
            feet: !0,
            nautic: !1,
            precision: {}
        },
        initialize: function(t, e) {
            L.Draw.Polyline.prototype.initialize.call(this, t, e), this.type = L.Draw.Polygon.TYPE;
        },
        _updateFinishHandler: function() {
            var t = this._markers.length;
            1 === t && this._markers[0].on("click", this._finishShape, this), t > 2 && (this._markers[t - 1].on("dblclick", this._finishShape, this), t > 3 && this._markers[t - 2].off("dblclick", this._finishShape, this));
        },
        _getTooltipText: function() {
            var t, e;
            return 0 === this._markers.length ? t = L.drawLocal.draw.handlers.polygon.tooltip.start : this._markers.length < 3 ? (t = L.drawLocal.draw.handlers.polygon.tooltip.cont, e = this._getMeasurementString()) : (t = L.drawLocal.draw.handlers.polygon.tooltip.end, e = this._getMeasurementString()), {
                text: t,
                subtext: e
            };
        },
        _getMeasurementString: function() {
            var t = this._area, e = "";
            return t || this.options.showLength ? (this.options.showLength && (e = L.Draw.Polyline.prototype._getMeasurementString.call(this)), t && (e += "<br>" + L.GeometryUtil.readableArea(t, this.options.metric, this.options.precision)), e) : null;
        },
        _shapeIsValid: function() {
            return this._markers.length >= 3;
        },
        _vertexChanged: function(t, e) {
            var i;
            !this.options.allowIntersection && this.options.showArea && (i = this._poly.getLatLngs(), this._area = L.GeometryUtil.geodesicArea(i)), L.Draw.Polyline.prototype._vertexChanged.call(this, t, e);
        },
        _cleanUpShape: function() {
            var t = this._markers.length;
            t > 0 && (this._markers[0].off("click", this._finishShape, this), t > 2 && this._markers[t - 1].off("dblclick", this._finishShape, this));
        }
    }), L.SimpleShape = {}, L.Draw.SimpleShape = L.Draw.Feature.extend({
        options: {
            repeatMode: !1
        },
        initialize: function(t, e) {
            this._endLabelText = L.drawLocal.draw.handlers.simpleshape.tooltip.end, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function() {
            L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._mapDraggable = this._map.dragging.enabled(), this._mapDraggable && this._map.dragging.disable(), this._container.style.cursor = "crosshair", this._tooltip.updateContent({
                text: this._initialLabelText
            }), this._map.on("mousedown", this._onMouseDown, this).on("mousemove", this._onMouseMove, this).on("touchstart", this._onMouseDown, this).on("touchmove", this._onMouseMove, this), e.addEventListener("touchstart", L.DomEvent.preventDefault, {
                passive: !1
            }));
        },
        removeHooks: function() {
            L.Draw.Feature.prototype.removeHooks.call(this), this._map && (this._mapDraggable && this._map.dragging.enable(), this._container.style.cursor = "", this._map.off("mousedown", this._onMouseDown, this).off("mousemove", this._onMouseMove, this).off("touchstart", this._onMouseDown, this).off("touchmove", this._onMouseMove, this), L.DomEvent.off(e, "mouseup", this._onMouseUp, this), L.DomEvent.off(e, "touchend", this._onMouseUp, this), e.removeEventListener("touchstart", L.DomEvent.preventDefault), this._shape && (this._map.removeLayer(this._shape), delete this._shape)), this._isDrawing = !1;
        },
        _getTooltipText: function() {
            return {
                text: this._endLabelText
            };
        },
        _onMouseDown: function(t) {
            this._isDrawing = !0, this._startLatLng = t.latlng, L.DomEvent.on(e, "mouseup", this._onMouseUp, this).on(e, "touchend", this._onMouseUp, this).preventDefault(t.originalEvent);
        },
        _onMouseMove: function(t) {
            var e = t.latlng;
            this._tooltip.updatePosition(e), this._isDrawing && (this._tooltip.updateContent(this._getTooltipText()), this._drawShape(e));
        },
        _onMouseUp: function() {
            this._shape && this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
        }
    }), L.Draw.Rectangle = L.Draw.SimpleShape.extend({
        statics: {
            TYPE: "rectangle"
        },
        options: {
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !0,
                fillColor: null,
                fillOpacity: .2,
                clickable: !0
            },
            showArea: !0,
            metric: !0
        },
        initialize: function(t, e) {
            this.type = L.Draw.Rectangle.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.rectangle.tooltip.start, L.Draw.SimpleShape.prototype.initialize.call(this, t, e);
        },
        disable: function() {
            this._enabled && (this._isCurrentlyTwoClickDrawing = !1, L.Draw.SimpleShape.prototype.disable.call(this));
        },
        _onMouseUp: function(t) {
            if (!this._shape && !this._isCurrentlyTwoClickDrawing) return void (this._isCurrentlyTwoClickDrawing = !0);
            this._isCurrentlyTwoClickDrawing && !o(t.target, "leaflet-pane") || L.Draw.SimpleShape.prototype._onMouseUp.call(this);
        },
        _drawShape: function(t) {
            this._shape ? this._shape.setBounds(new L.LatLngBounds(this._startLatLng, t)) : (this._shape = new L.Rectangle(new L.LatLngBounds(this._startLatLng, t), this.options.shapeOptions), this._map.addLayer(this._shape));
        },
        _fireCreatedEvent: function() {
            var t = new L.Rectangle(this._shape.getBounds(), this.options.shapeOptions);
            L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this, t);
        },
        _getTooltipText: function() {
            var t, e, i, o = L.Draw.SimpleShape.prototype._getTooltipText.call(this), a = this._shape, n = this.options.showArea;
            return a && (t = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs(), e = L.GeometryUtil.geodesicArea(t), i = n ? L.GeometryUtil.readableArea(e, this.options.metric) : ""), {
                text: o.text,
                subtext: i
            };
        }
    }), L.Draw.Marker = L.Draw.Feature.extend({
        statics: {
            TYPE: "marker"
        },
        options: {
            icon: new L.Icon.Default,
            repeatMode: !1,
            zIndexOffset: 2e3
        },
        initialize: function(t, e) {
            this.type = L.Draw.Marker.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.marker.tooltip.start, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        addHooks: function() {
            L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._tooltip.updateContent({
                text: this._initialLabelText
            }), this._mouseMarker || (this._mouseMarker = L.marker(this._map.getCenter(), {
                icon: L.divIcon({
                    className: "leaflet-mouse-marker",
                    iconAnchor: [
                        20,
                        20
                    ],
                    iconSize: [
                        40,
                        40
                    ]
                }),
                opacity: 0,
                zIndexOffset: this.options.zIndexOffset
            })), this._mouseMarker.on("click", this._onClick, this).addTo(this._map), this._map.on("mousemove", this._onMouseMove, this), this._map.on("click", this._onTouch, this));
        },
        removeHooks: function() {
            L.Draw.Feature.prototype.removeHooks.call(this), this._map && (this._map.off("click", this._onClick, this).off("click", this._onTouch, this), this._marker && (this._marker.off("click", this._onClick, this), this._map.removeLayer(this._marker), delete this._marker), this._mouseMarker.off("click", this._onClick, this), this._map.removeLayer(this._mouseMarker), delete this._mouseMarker, this._map.off("mousemove", this._onMouseMove, this));
        },
        _onMouseMove: function(t) {
            var e = t.latlng;
            this._tooltip.updatePosition(e), this._mouseMarker.setLatLng(e), this._marker ? (e = this._mouseMarker.getLatLng(), this._marker.setLatLng(e)) : (this._marker = this._createMarker(e), this._marker.on("click", this._onClick, this), this._map.on("click", this._onClick, this).addLayer(this._marker));
        },
        _createMarker: function(t) {
            return new L.Marker(t, {
                icon: this.options.icon,
                zIndexOffset: this.options.zIndexOffset
            });
        },
        _onClick: function() {
            this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
        },
        _onTouch: function(t) {
            this._onMouseMove(t), this._onClick();
        },
        _fireCreatedEvent: function() {
            var t = new L.Marker.Touch(this._marker.getLatLng(), {
                icon: this.options.icon
            });
            L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        }
    }), L.Draw.CircleMarker = L.Draw.Marker.extend({
        statics: {
            TYPE: "circlemarker"
        },
        options: {
            stroke: !0,
            color: "#3388ff",
            weight: 4,
            opacity: .5,
            fill: !0,
            fillColor: null,
            fillOpacity: .2,
            clickable: !0,
            zIndexOffset: 2e3
        },
        initialize: function(t, e) {
            this.type = L.Draw.CircleMarker.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.circlemarker.tooltip.start, L.Draw.Feature.prototype.initialize.call(this, t, e);
        },
        _fireCreatedEvent: function() {
            var t = new L.CircleMarker(this._marker.getLatLng(), this.options);
            L.Draw.Feature.prototype._fireCreatedEvent.call(this, t);
        },
        _createMarker: function(t) {
            return new L.CircleMarker(t, this.options);
        }
    }), L.Draw.Circle = L.Draw.SimpleShape.extend({
        statics: {
            TYPE: "circle"
        },
        options: {
            shapeOptions: {
                stroke: !0,
                color: "#3388ff",
                weight: 4,
                opacity: .5,
                fill: !0,
                fillColor: null,
                fillOpacity: .2,
                clickable: !0
            },
            showRadius: !0,
            metric: !0,
            feet: !0,
            nautic: !1
        },
        initialize: function(t, e) {
            this.type = L.Draw.Circle.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.circle.tooltip.start, L.Draw.SimpleShape.prototype.initialize.call(this, t, e);
        },
        _drawShape: function(t) {
            if (L.GeometryUtil.isVersion07x()) var e = this._startLatLng.distanceTo(t);
            else var e = this._map.distance(this._startLatLng, t);
            this._shape ? this._shape.setRadius(e) : (this._shape = new L.Circle(this._startLatLng, e, this.options.shapeOptions), this._map.addLayer(this._shape));
        },
        _fireCreatedEvent: function() {
            var t = new L.Circle(this._startLatLng, this._shape.getRadius(), this.options.shapeOptions);
            L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this, t);
        },
        _onMouseMove: function(t) {
            var e, i = t.latlng, o = this.options.showRadius, a = this.options.metric;
            if (this._tooltip.updatePosition(i), this._isDrawing) {
                this._drawShape(i), e = this._shape.getRadius().toFixed(1);
                var n = "";
                o && (n = L.drawLocal.draw.handlers.circle.radius + ": " + L.GeometryUtil.readableDistance(e, a, this.options.feet, this.options.nautic)), this._tooltip.updateContent({
                    text: this._endLabelText,
                    subtext: n
                });
            }
        }
    }), L.Edit = L.Edit || {}, L.Edit.Marker = L.Handler.extend({
        initialize: function(t, e) {
            this._marker = t, L.setOptions(this, e);
        },
        addHooks: function() {
            var t = this._marker;
            t.dragging.enable(), t.on("dragend", this._onDragEnd, t), this._toggleMarkerHighlight();
        },
        removeHooks: function() {
            var t = this._marker;
            t.dragging.disable(), t.off("dragend", this._onDragEnd, t), this._toggleMarkerHighlight();
        },
        _onDragEnd: function(t) {
            var e = t.target;
            e.edited = !0, this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: e
            });
        },
        _toggleMarkerHighlight: function() {
            var t = this._marker._icon;
            t && (t.style.display = "none", L.DomUtil.hasClass(t, "leaflet-edit-marker-selected") ? (L.DomUtil.removeClass(t, "leaflet-edit-marker-selected"), this._offsetMarker(t, -4)) : (L.DomUtil.addClass(t, "leaflet-edit-marker-selected"), this._offsetMarker(t, 4)), t.style.display = "");
        },
        _offsetMarker: function(t, e) {
            var i = parseInt(t.style.marginTop, 10) - e, o = parseInt(t.style.marginLeft, 10) - e;
            t.style.marginTop = i + "px", t.style.marginLeft = o + "px";
        }
    }), L.Marker.addInitHook(function() {
        L.Edit.Marker && (this.editing = new L.Edit.Marker(this), this.options.editable && this.editing.enable());
    }), L.Edit = L.Edit || {}, L.Edit.Poly = L.Handler.extend({
        initialize: function(t) {
            this.latlngs = [
                t._latlngs
            ], t._holes && (this.latlngs = this.latlngs.concat(t._holes)), this._poly = t, this._poly.on("revert-edited", this._updateLatLngs, this);
        },
        _defaultShape: function() {
            return L.Polyline._flat ? L.Polyline._flat(this._poly._latlngs) ? this._poly._latlngs : this._poly._latlngs[0] : this._poly._latlngs;
        },
        _eachVertexHandler: function(t) {
            for(var e = 0; e < this._verticesHandlers.length; e++)t(this._verticesHandlers[e]);
        },
        addHooks: function() {
            this._initHandlers(), this._eachVertexHandler(function(t) {
                t.addHooks();
            });
        },
        removeHooks: function() {
            this._eachVertexHandler(function(t) {
                t.removeHooks();
            });
        },
        updateMarkers: function() {
            this._eachVertexHandler(function(t) {
                t.updateMarkers();
            });
        },
        _initHandlers: function() {
            this._verticesHandlers = [];
            for(var t = 0; t < this.latlngs.length; t++)this._verticesHandlers.push(new L.Edit.PolyVerticesEdit(this._poly, this.latlngs[t], this._poly.options.poly));
        },
        _updateLatLngs: function(t) {
            this.latlngs = [
                t.layer._latlngs
            ], t.layer._holes && (this.latlngs = this.latlngs.concat(t.layer._holes));
        }
    }), L.Edit.PolyVerticesEdit = L.Handler.extend({
        options: {
            icon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon"
            }),
            touchIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"
            }),
            drawError: {
                color: "#b00b00",
                timeout: 1e3
            }
        },
        initialize: function(t, e, i) {
            L.Browser.touch && (this.options.icon = this.options.touchIcon), this._poly = t, i && i.drawError && (i.drawError = L.Util.extend({}, this.options.drawError, i.drawError)), this._latlngs = e, L.setOptions(this, i);
        },
        _defaultShape: function() {
            return L.Polyline._flat ? L.Polyline._flat(this._latlngs) ? this._latlngs : this._latlngs[0] : this._latlngs;
        },
        addHooks: function() {
            var t = this._poly, e = t._path;
            t instanceof L.Polygon || (t.options.fill = !1, t.options.editing && (t.options.editing.fill = !1)), e && t.options.editing && t.options.editing.className && (t.options.original.className && t.options.original.className.split(" ").forEach(function(t) {
                L.DomUtil.removeClass(e, t);
            }), t.options.editing.className.split(" ").forEach(function(t) {
                L.DomUtil.addClass(e, t);
            })), t.setStyle(t.options.editing), this._poly._map && (this._map = this._poly._map, this._markerGroup || this._initMarkers(), this._poly._map.addLayer(this._markerGroup));
        },
        removeHooks: function() {
            var t = this._poly, e = t._path;
            e && t.options.editing && t.options.editing.className && (t.options.editing.className.split(" ").forEach(function(t) {
                L.DomUtil.removeClass(e, t);
            }), t.options.original.className && t.options.original.className.split(" ").forEach(function(t) {
                L.DomUtil.addClass(e, t);
            })), t.setStyle(t.options.original), t._map && (t._map.removeLayer(this._markerGroup), delete this._markerGroup, delete this._markers);
        },
        updateMarkers: function() {
            this._markerGroup.clearLayers(), this._initMarkers();
        },
        _initMarkers: function() {
            this._markerGroup || (this._markerGroup = new L.LayerGroup), this._markers = [];
            var t, e, i, o, a = this._defaultShape();
            for(t = 0, i = a.length; t < i; t++)o = this._createMarker(a[t], t), o.on("click", this._onMarkerClick, this), o.on("contextmenu", this._onContextMenu, this), this._markers.push(o);
            var n, s;
            for(t = 0, e = i - 1; t < i; e = t++)(0 !== t || L.Polygon && this._poly instanceof L.Polygon) && (n = this._markers[e], s = this._markers[t], this._createMiddleMarker(n, s), this._updatePrevNext(n, s));
        },
        _createMarker: function(t, e) {
            var i = new L.Marker.Touch(t, {
                draggable: !0,
                icon: this.options.icon
            });
            return i._origLatLng = t, i._index = e, i.on("dragstart", this._onMarkerDragStart, this).on("drag", this._onMarkerDrag, this).on("dragend", this._fireEdit, this).on("touchmove", this._onTouchMove, this).on("touchend", this._fireEdit, this).on("MSPointerMove", this._onTouchMove, this).on("MSPointerUp", this._fireEdit, this), this._markerGroup.addLayer(i), i;
        },
        _onMarkerDragStart: function() {
            this._poly.fire("editstart");
        },
        _spliceLatLngs: function() {
            var t = this._defaultShape(), e = [].splice.apply(t, arguments);
            return this._poly._convertLatLngs(t, !0), this._poly.redraw(), e;
        },
        _removeMarker: function(t) {
            var e = t._index;
            this._markerGroup.removeLayer(t), this._markers.splice(e, 1), this._spliceLatLngs(e, 1), this._updateIndexes(e, -1), t.off("dragstart", this._onMarkerDragStart, this).off("drag", this._onMarkerDrag, this).off("dragend", this._fireEdit, this).off("touchmove", this._onMarkerDrag, this).off("touchend", this._fireEdit, this).off("click", this._onMarkerClick, this).off("MSPointerMove", this._onTouchMove, this).off("MSPointerUp", this._fireEdit, this);
        },
        _fireEdit: function() {
            this._poly.edited = !0, this._poly.fire("edit"), this._poly._map.fire(L.Draw.Event.EDITVERTEX, {
                layers: this._markerGroup,
                poly: this._poly
            });
        },
        _onMarkerDrag: function(t) {
            var e = t.target, i = this._poly, o = L.LatLngUtil.cloneLatLng(e._origLatLng);
            if (L.extend(e._origLatLng, e._latlng), i.options.poly) {
                var a = i._map._editTooltip;
                if (!i.options.poly.allowIntersection && i.intersects()) {
                    L.extend(e._origLatLng, o), e.setLatLng(o);
                    var n = i.options.color;
                    i.setStyle({
                        color: this.options.drawError.color
                    }), a && a.updateContent({
                        text: L.drawLocal.draw.handlers.polyline.error
                    }), setTimeout(function() {
                        i.setStyle({
                            color: n
                        }), a && a.updateContent({
                            text: L.drawLocal.edit.handlers.edit.tooltip.text,
                            subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
                        });
                    }, 1e3);
                }
            }
            e._middleLeft && e._middleLeft.setLatLng(this._getMiddleLatLng(e._prev, e)), e._middleRight && e._middleRight.setLatLng(this._getMiddleLatLng(e, e._next)), this._poly._bounds._southWest = L.latLng(1 / 0, 1 / 0), this._poly._bounds._northEast = L.latLng(-1 / 0, -1 / 0);
            var s = this._poly.getLatLngs();
            this._poly._convertLatLngs(s, !0), this._poly.redraw(), this._poly.fire("editdrag");
        },
        _onMarkerClick: function(t) {
            var e = L.Polygon && this._poly instanceof L.Polygon ? 4 : 3, i = t.target;
            this._defaultShape().length < e || (this._removeMarker(i), this._updatePrevNext(i._prev, i._next), i._middleLeft && this._markerGroup.removeLayer(i._middleLeft), i._middleRight && this._markerGroup.removeLayer(i._middleRight), i._prev && i._next ? this._createMiddleMarker(i._prev, i._next) : i._prev ? i._next || (i._prev._middleRight = null) : i._next._middleLeft = null, this._fireEdit());
        },
        _onContextMenu: function(t) {
            var e = t.target;
            this._poly;
            this._poly._map.fire(L.Draw.Event.MARKERCONTEXT, {
                marker: e,
                layers: this._markerGroup,
                poly: this._poly
            }), L.DomEvent.stopPropagation;
        },
        _onTouchMove: function(t) {
            var e = this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]), i = this._map.layerPointToLatLng(e), o = t.target;
            L.extend(o._origLatLng, i), o._middleLeft && o._middleLeft.setLatLng(this._getMiddleLatLng(o._prev, o)), o._middleRight && o._middleRight.setLatLng(this._getMiddleLatLng(o, o._next)), this._poly.redraw(), this.updateMarkers();
        },
        _updateIndexes: function(t, e) {
            this._markerGroup.eachLayer(function(i) {
                i._index > t && (i._index += e);
            });
        },
        _createMiddleMarker: function(t, e) {
            var i, o, a, n = this._getMiddleLatLng(t, e), s = this._createMarker(n);
            s.setOpacity(.6), t._middleRight = e._middleLeft = s, o = function() {
                s.off("touchmove", o, this);
                var a = e._index;
                s._index = a, s.off("click", i, this).on("click", this._onMarkerClick, this), n.lat = s.getLatLng().lat, n.lng = s.getLatLng().lng, this._spliceLatLngs(a, 0, n), this._markers.splice(a, 0, s), s.setOpacity(1), this._updateIndexes(a, 1), e._index++, this._updatePrevNext(t, s), this._updatePrevNext(s, e), this._poly.fire("editstart");
            }, a = function() {
                s.off("dragstart", o, this), s.off("dragend", a, this), s.off("touchmove", o, this), this._createMiddleMarker(t, s), this._createMiddleMarker(s, e);
            }, i = function() {
                o.call(this), a.call(this), this._fireEdit();
            }, s.on("click", i, this).on("dragstart", o, this).on("dragend", a, this).on("touchmove", o, this), this._markerGroup.addLayer(s);
        },
        _updatePrevNext: function(t, e) {
            t && (t._next = e), e && (e._prev = t);
        },
        _getMiddleLatLng: function(t, e) {
            var i = this._poly._map, o = i.project(t.getLatLng()), a = i.project(e.getLatLng());
            return i.unproject(o._add(a)._divideBy(2));
        }
    }), L.Polyline.addInitHook(function() {
        this.editing || (L.Edit.Poly && (this.editing = new L.Edit.Poly(this), this.options.editable && this.editing.enable()), this.on("add", function() {
            this.editing && this.editing.enabled() && this.editing.addHooks();
        }), this.on("remove", function() {
            this.editing && this.editing.enabled() && this.editing.removeHooks();
        }));
    }), L.Edit = L.Edit || {}, L.Edit.SimpleShape = L.Handler.extend({
        options: {
            moveIcon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-move"
            }),
            resizeIcon: new L.DivIcon({
                iconSize: new L.Point(8, 8),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-resize"
            }),
            touchMoveIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-move leaflet-touch-icon"
            }),
            touchResizeIcon: new L.DivIcon({
                iconSize: new L.Point(20, 20),
                className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-resize leaflet-touch-icon"
            })
        },
        initialize: function(t, e) {
            L.Browser.touch && (this.options.moveIcon = this.options.touchMoveIcon, this.options.resizeIcon = this.options.touchResizeIcon), this._shape = t, L.Util.setOptions(this, e);
        },
        addHooks: function() {
            var t = this._shape;
            this._shape._map && (this._map = this._shape._map, t.setStyle(t.options.editing), t._map && (this._map = t._map, this._markerGroup || this._initMarkers(), this._map.addLayer(this._markerGroup)));
        },
        removeHooks: function() {
            var t = this._shape;
            if (t.setStyle(t.options.original), t._map) {
                this._unbindMarker(this._moveMarker);
                for(var e = 0, i = this._resizeMarkers.length; e < i; e++)this._unbindMarker(this._resizeMarkers[e]);
                this._resizeMarkers = null, this._map.removeLayer(this._markerGroup), delete this._markerGroup;
            }
            this._map = null;
        },
        updateMarkers: function() {
            this._markerGroup.clearLayers(), this._initMarkers();
        },
        _initMarkers: function() {
            this._markerGroup || (this._markerGroup = new L.LayerGroup), this._createMoveMarker(), this._createResizeMarker();
        },
        _createMoveMarker: function() {},
        _createResizeMarker: function() {},
        _createMarker: function(t, e) {
            var i = new L.Marker.Touch(t, {
                draggable: !0,
                icon: e,
                zIndexOffset: 10
            });
            return this._bindMarker(i), this._markerGroup.addLayer(i), i;
        },
        _bindMarker: function(t) {
            t.on("dragstart", this._onMarkerDragStart, this).on("drag", this._onMarkerDrag, this).on("dragend", this._onMarkerDragEnd, this).on("touchstart", this._onTouchStart, this).on("touchmove", this._onTouchMove, this).on("MSPointerMove", this._onTouchMove, this).on("touchend", this._onTouchEnd, this).on("MSPointerUp", this._onTouchEnd, this);
        },
        _unbindMarker: function(t) {
            t.off("dragstart", this._onMarkerDragStart, this).off("drag", this._onMarkerDrag, this).off("dragend", this._onMarkerDragEnd, this).off("touchstart", this._onTouchStart, this).off("touchmove", this._onTouchMove, this).off("MSPointerMove", this._onTouchMove, this).off("touchend", this._onTouchEnd, this).off("MSPointerUp", this._onTouchEnd, this);
        },
        _onMarkerDragStart: function(t) {
            t.target.setOpacity(0), this._shape.fire("editstart");
        },
        _fireEdit: function() {
            this._shape.edited = !0, this._shape.fire("edit");
        },
        _onMarkerDrag: function(t) {
            var e = t.target, i = e.getLatLng();
            e === this._moveMarker ? this._move(i) : this._resize(i), this._shape.redraw(), this._shape.fire("editdrag");
        },
        _onMarkerDragEnd: function(t) {
            t.target.setOpacity(1), this._fireEdit();
        },
        _onTouchStart: function(t) {
            if (L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this, t), "function" == typeof this._getCorners) {
                var e = this._getCorners(), i = t.target, o = i._cornerIndex;
                i.setOpacity(0), this._oppositeCorner = e[(o + 2) % 4], this._toggleCornerMarkers(0, o);
            }
            this._shape.fire("editstart");
        },
        _onTouchMove: function(t) {
            var e = this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]), i = this._map.layerPointToLatLng(e);
            return t.target === this._moveMarker ? this._move(i) : this._resize(i), this._shape.redraw(), !1;
        },
        _onTouchEnd: function(t) {
            t.target.setOpacity(1), this.updateMarkers(), this._fireEdit();
        },
        _move: function() {},
        _resize: function() {}
    }), L.Edit = L.Edit || {}, L.Edit.Rectangle = L.Edit.SimpleShape.extend({
        _createMoveMarker: function() {
            var t = this._shape.getBounds(), e = t.getCenter();
            this._moveMarker = this._createMarker(e, this.options.moveIcon);
        },
        _createResizeMarker: function() {
            var t = this._getCorners();
            this._resizeMarkers = [];
            for(var e = 0, i = t.length; e < i; e++)this._resizeMarkers.push(this._createMarker(t[e], this.options.resizeIcon)), this._resizeMarkers[e]._cornerIndex = e;
        },
        _onMarkerDragStart: function(t) {
            L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this, t);
            var e = this._getCorners(), i = t.target, o = i._cornerIndex;
            this._oppositeCorner = e[(o + 2) % 4], this._toggleCornerMarkers(0, o);
        },
        _onMarkerDragEnd: function(t) {
            var e, i, o = t.target;
            o === this._moveMarker && (e = this._shape.getBounds(), i = e.getCenter(), o.setLatLng(i)), this._toggleCornerMarkers(1), this._repositionCornerMarkers(), L.Edit.SimpleShape.prototype._onMarkerDragEnd.call(this, t);
        },
        _move: function(t) {
            for(var e, i = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs(), o = this._shape.getBounds(), a = o.getCenter(), n = [], s = 0, r = i.length; s < r; s++)e = [
                i[s].lat - a.lat,
                i[s].lng - a.lng
            ], n.push([
                t.lat + e[0],
                t.lng + e[1]
            ]);
            this._shape.setLatLngs(n), this._repositionCornerMarkers(), this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: this._shape
            });
        },
        _resize: function(t) {
            var e;
            this._shape.setBounds(L.latLngBounds(t, this._oppositeCorner)), e = this._shape.getBounds(), this._moveMarker.setLatLng(e.getCenter()), this._map.fire(L.Draw.Event.EDITRESIZE, {
                layer: this._shape
            });
        },
        _getCorners: function() {
            var t = this._shape.getBounds();
            return [
                t.getNorthWest(),
                t.getNorthEast(),
                t.getSouthEast(),
                t.getSouthWest()
            ];
        },
        _toggleCornerMarkers: function(t) {
            for(var e = 0, i = this._resizeMarkers.length; e < i; e++)this._resizeMarkers[e].setOpacity(t);
        },
        _repositionCornerMarkers: function() {
            for(var t = this._getCorners(), e = 0, i = this._resizeMarkers.length; e < i; e++)this._resizeMarkers[e].setLatLng(t[e]);
        }
    }), L.Rectangle.addInitHook(function() {
        L.Edit.Rectangle && (this.editing = new L.Edit.Rectangle(this), this.options.editable && this.editing.enable());
    }), L.Edit = L.Edit || {}, L.Edit.CircleMarker = L.Edit.SimpleShape.extend({
        _createMoveMarker: function() {
            var t = this._shape.getLatLng();
            this._moveMarker = this._createMarker(t, this.options.moveIcon);
        },
        _createResizeMarker: function() {
            this._resizeMarkers = [];
        },
        _move: function(t) {
            if (this._resizeMarkers.length) {
                var e = this._getResizeMarkerPoint(t);
                this._resizeMarkers[0].setLatLng(e);
            }
            this._shape.setLatLng(t), this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: this._shape
            });
        }
    }), L.CircleMarker.addInitHook(function() {
        L.Edit.CircleMarker && (this.editing = new L.Edit.CircleMarker(this), this.options.editable && this.editing.enable()), this.on("add", function() {
            this.editing && this.editing.enabled() && this.editing.addHooks();
        }), this.on("remove", function() {
            this.editing && this.editing.enabled() && this.editing.removeHooks();
        });
    }), L.Edit = L.Edit || {}, L.Edit.Circle = L.Edit.CircleMarker.extend({
        _createResizeMarker: function() {
            var t = this._shape.getLatLng(), e = this._getResizeMarkerPoint(t);
            this._resizeMarkers = [], this._resizeMarkers.push(this._createMarker(e, this.options.resizeIcon));
        },
        _getResizeMarkerPoint: function(t) {
            var e = this._shape._radius * Math.cos(Math.PI / 4), i = this._map.project(t);
            return this._map.unproject([
                i.x + e,
                i.y - e
            ]);
        },
        _resize: function(t) {
            var e = this._moveMarker.getLatLng();
            L.GeometryUtil.isVersion07x() ? radius = e.distanceTo(t) : radius = this._map.distance(e, t), this._shape.setRadius(radius), this._map.editTooltip && this._map._editTooltip.updateContent({
                text: L.drawLocal.edit.handlers.edit.tooltip.subtext + "<br />" + L.drawLocal.edit.handlers.edit.tooltip.text,
                subtext: L.drawLocal.draw.handlers.circle.radius + ": " + L.GeometryUtil.readableDistance(radius, !0, this.options.feet, this.options.nautic)
            }), this._shape.setRadius(radius), this._map.fire(L.Draw.Event.EDITRESIZE, {
                layer: this._shape
            });
        }
    }), L.Circle.addInitHook(function() {
        L.Edit.Circle && (this.editing = new L.Edit.Circle(this), this.options.editable && this.editing.enable());
    }), L.Map.mergeOptions({
        touchExtend: !0
    }), L.Map.TouchExtend = L.Handler.extend({
        initialize: function(t) {
            this._map = t, this._container = t._container, this._pane = t._panes.overlayPane;
        },
        addHooks: function() {
            L.DomEvent.on(this._container, "touchstart", this._onTouchStart, this), L.DomEvent.on(this._container, "touchend", this._onTouchEnd, this), L.DomEvent.on(this._container, "touchmove", this._onTouchMove, this), this._detectIE() ? (L.DomEvent.on(this._container, "MSPointerDown", this._onTouchStart, this), L.DomEvent.on(this._container, "MSPointerUp", this._onTouchEnd, this), L.DomEvent.on(this._container, "MSPointerMove", this._onTouchMove, this), L.DomEvent.on(this._container, "MSPointerCancel", this._onTouchCancel, this)) : (L.DomEvent.on(this._container, "touchcancel", this._onTouchCancel, this), L.DomEvent.on(this._container, "touchleave", this._onTouchLeave, this));
        },
        removeHooks: function() {
            L.DomEvent.off(this._container, "touchstart", this._onTouchStart, this), L.DomEvent.off(this._container, "touchend", this._onTouchEnd, this), L.DomEvent.off(this._container, "touchmove", this._onTouchMove, this), this._detectIE() ? (L.DomEvent.off(this._container, "MSPointerDown", this._onTouchStart, this), L.DomEvent.off(this._container, "MSPointerUp", this._onTouchEnd, this), L.DomEvent.off(this._container, "MSPointerMove", this._onTouchMove, this), L.DomEvent.off(this._container, "MSPointerCancel", this._onTouchCancel, this)) : (L.DomEvent.off(this._container, "touchcancel", this._onTouchCancel, this), L.DomEvent.off(this._container, "touchleave", this._onTouchLeave, this));
        },
        _touchEvent: function(t, e) {
            var i = {};
            if (void 0 !== t.touches) {
                if (!t.touches.length) return;
                i = t.touches[0];
            } else {
                if ("touch" !== t.pointerType) return;
                if (i = t, !this._filterClick(t)) return;
            }
            var o = this._map.mouseEventToContainerPoint(i), a = this._map.mouseEventToLayerPoint(i), n = this._map.layerPointToLatLng(a);
            this._map.fire(e, {
                latlng: n,
                layerPoint: a,
                containerPoint: o,
                pageX: i.pageX,
                pageY: i.pageY,
                originalEvent: t
            });
        },
        _filterClick: function(t) {
            var e = t.timeStamp || t.originalEvent.timeStamp, i = L.DomEvent._lastClick && e - L.DomEvent._lastClick;
            return i && i > 100 && i < 500 || t.target._simulatedClick && !t._simulated ? (L.DomEvent.stop(t), !1) : (L.DomEvent._lastClick = e, !0);
        },
        _onTouchStart: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchstart");
        },
        _onTouchEnd: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchend");
        },
        _onTouchCancel: function(t) {
            if (this._map._loaded) {
                var e = "touchcancel";
                this._detectIE() && (e = "pointercancel"), this._touchEvent(t, e);
            }
        },
        _onTouchLeave: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchleave");
        },
        _onTouchMove: function(t) {
            if (this._map._loaded) this._touchEvent(t, "touchmove");
        },
        _detectIE: function() {
            var e = t.navigator.userAgent, i = e.indexOf("MSIE ");
            if (i > 0) return parseInt(e.substring(i + 5, e.indexOf(".", i)), 10);
            if (e.indexOf("Trident/") > 0) {
                var o = e.indexOf("rv:");
                return parseInt(e.substring(o + 3, e.indexOf(".", o)), 10);
            }
            var a = e.indexOf("Edge/");
            return a > 0 && parseInt(e.substring(a + 5, e.indexOf(".", a)), 10);
        }
    }), L.Map.addInitHook("addHandler", "touchExtend", L.Map.TouchExtend), L.Marker.Touch = L.Marker.extend({
        _initInteraction: function() {
            return this.addInteractiveTarget ? L.Marker.prototype._initInteraction.apply(this) : this._initInteractionLegacy();
        },
        _initInteractionLegacy: function() {
            if (this.options.clickable) {
                var t = this._icon, e = [
                    "dblclick",
                    "mousedown",
                    "mouseover",
                    "mouseout",
                    "contextmenu",
                    "touchstart",
                    "touchend",
                    "touchmove"
                ];
                this._detectIE ? e.concat([
                    "MSPointerDown",
                    "MSPointerUp",
                    "MSPointerMove",
                    "MSPointerCancel"
                ]) : e.concat([
                    "touchcancel"
                ]), L.DomUtil.addClass(t, "leaflet-clickable"), L.DomEvent.on(t, "click", this._onMouseClick, this), L.DomEvent.on(t, "keypress", this._onKeyPress, this);
                for(var i = 0; i < e.length; i++)L.DomEvent.on(t, e[i], this._fireMouseEvent, this);
                L.Handler.MarkerDrag && (this.dragging = new L.Handler.MarkerDrag(this), this.options.draggable && this.dragging.enable());
            }
        },
        _detectIE: function() {
            var e = t.navigator.userAgent, i = e.indexOf("MSIE ");
            if (i > 0) return parseInt(e.substring(i + 5, e.indexOf(".", i)), 10);
            if (e.indexOf("Trident/") > 0) {
                var o = e.indexOf("rv:");
                return parseInt(e.substring(o + 3, e.indexOf(".", o)), 10);
            }
            var a = e.indexOf("Edge/");
            return a > 0 && parseInt(e.substring(a + 5, e.indexOf(".", a)), 10);
        }
    }), L.LatLngUtil = {
        cloneLatLngs: function(t) {
            for(var e = [], i = 0, o = t.length; i < o; i++)Array.isArray(t[i]) ? e.push(L.LatLngUtil.cloneLatLngs(t[i])) : e.push(this.cloneLatLng(t[i]));
            return e;
        },
        cloneLatLng: function(t) {
            return L.latLng(t.lat, t.lng);
        }
    }, function() {
        var t = {
            km: 2,
            ha: 2,
            m: 0,
            mi: 2,
            ac: 2,
            yd: 0,
            ft: 0,
            nm: 2
        };
        L.GeometryUtil = L.extend(L.GeometryUtil || {}, {
            geodesicArea: function(t) {
                var e, i, o = t.length, a = 0, n = Math.PI / 180;
                if (o > 2) {
                    for(var s = 0; s < o; s++)e = t[s], i = t[(s + 1) % o], a += (i.lng - e.lng) * n * (2 + Math.sin(e.lat * n) + Math.sin(i.lat * n));
                    a = 6378137 * a * 6378137 / 2;
                }
                return Math.abs(a);
            },
            formattedNumber: function(t, e) {
                var i = parseFloat(t).toFixed(e), o = L.drawLocal.format && L.drawLocal.format.numeric, a = o && o.delimiters, n = a && a.thousands, s = a && a.decimal;
                if (n || s) {
                    var r = i.split(".");
                    i = n ? r[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + n) : r[0], s = s || ".", r.length > 1 && (i = i + s + r[1]);
                }
                return i;
            },
            readableArea: function(e, i, o) {
                var a, n, o = L.Util.extend({}, t, o);
                return i ? (n = [
                    "ha",
                    "m"
                ], type = typeof i, "string" === type ? n = [
                    i
                ] : "boolean" !== type && (n = i), a = e >= 1e6 && -1 !== n.indexOf("km") ? L.GeometryUtil.formattedNumber(1e-6 * e, o.km) + " km\xb2" : e >= 1e4 && -1 !== n.indexOf("ha") ? L.GeometryUtil.formattedNumber(1e-4 * e, o.ha) + " ha" : L.GeometryUtil.formattedNumber(e, o.m) + " m\xb2") : (e /= .836127, a = e >= 3097600 ? L.GeometryUtil.formattedNumber(e / 3097600, o.mi) + " mi\xb2" : e >= 4840 ? L.GeometryUtil.formattedNumber(e / 4840, o.ac) + " acres" : L.GeometryUtil.formattedNumber(e, o.yd) + " yd\xb2"), a;
            },
            readableDistance: function(e, i, o, a, n) {
                var s, n = L.Util.extend({}, t, n);
                switch(i ? "string" == typeof i ? i : "metric" : o ? "feet" : a ? "nauticalMile" : "yards"){
                    case "metric":
                        s = e > 1e3 ? L.GeometryUtil.formattedNumber(e / 1e3, n.km) + " km" : L.GeometryUtil.formattedNumber(e, n.m) + " m";
                        break;
                    case "feet":
                        e *= 3.28083, s = L.GeometryUtil.formattedNumber(e, n.ft) + " ft";
                        break;
                    case "nauticalMile":
                        e *= .53996, s = L.GeometryUtil.formattedNumber(e / 1e3, n.nm) + " nm";
                        break;
                    case "yards":
                    default:
                        e *= 1.09361, s = e > 1760 ? L.GeometryUtil.formattedNumber(e / 1760, n.mi) + " miles" : L.GeometryUtil.formattedNumber(e, n.yd) + " yd";
                }
                return s;
            },
            isVersion07x: function() {
                var t = L.version.split(".");
                return 0 === parseInt(t[0], 10) && 7 === parseInt(t[1], 10);
            }
        });
    }(), L.Util.extend(L.LineUtil, {
        segmentsIntersect: function(t, e, i, o) {
            return this._checkCounterclockwise(t, i, o) !== this._checkCounterclockwise(e, i, o) && this._checkCounterclockwise(t, e, i) !== this._checkCounterclockwise(t, e, o);
        },
        _checkCounterclockwise: function(t, e, i) {
            return (i.y - t.y) * (e.x - t.x) > (e.y - t.y) * (i.x - t.x);
        }
    }), L.Polyline.include({
        intersects: function() {
            var t, e, i, o = this._getProjectedPoints(), a = o ? o.length : 0;
            if (this._tooFewPointsForIntersection()) return !1;
            for(t = a - 1; t >= 3; t--)if (e = o[t - 1], i = o[t], this._lineSegmentsIntersectsRange(e, i, t - 2)) return !0;
            return !1;
        },
        newLatLngIntersects: function(t, e) {
            return !!this._map && this.newPointIntersects(this._map.latLngToLayerPoint(t), e);
        },
        newPointIntersects: function(t, e) {
            var i = this._getProjectedPoints(), o = i ? i.length : 0, a = i ? i[o - 1] : null, n = o - 2;
            return !this._tooFewPointsForIntersection(1) && this._lineSegmentsIntersectsRange(a, t, n, e ? 1 : 0);
        },
        _tooFewPointsForIntersection: function(t) {
            var e = this._getProjectedPoints(), i = e ? e.length : 0;
            return i += t || 0, !e || i <= 3;
        },
        _lineSegmentsIntersectsRange: function(t, e, i, o) {
            var a, n, s = this._getProjectedPoints();
            o = o || 0;
            for(var r = i; r > o; r--)if (a = s[r - 1], n = s[r], L.LineUtil.segmentsIntersect(t, e, a, n)) return !0;
            return !1;
        },
        _getProjectedPoints: function() {
            if (!this._defaultShape) return this._originalPoints;
            for(var t = [], e = this._defaultShape(), i = 0; i < e.length; i++)t.push(this._map.latLngToLayerPoint(e[i]));
            return t;
        }
    }), L.Polygon.include({
        intersects: function() {
            var t, e, i, o, a = this._getProjectedPoints();
            return !this._tooFewPointsForIntersection() && (!!L.Polyline.prototype.intersects.call(this) || (t = a.length, e = a[0], i = a[t - 1], o = t - 2, this._lineSegmentsIntersectsRange(i, e, o, 1)));
        }
    }), L.Control.Draw = L.Control.extend({
        options: {
            position: "topleft",
            draw: {},
            edit: !1
        },
        initialize: function(t) {
            if (L.version < "0.7") throw new Error("Leaflet.draw 0.2.3+ requires Leaflet 0.7.0+. Download latest from https://github.com/Leaflet/Leaflet/");
            L.Control.prototype.initialize.call(this, t);
            var e;
            this._toolbars = {}, L.DrawToolbar && this.options.draw && (e = new L.DrawToolbar(this.options.draw), this._toolbars[L.DrawToolbar.TYPE] = e, this._toolbars[L.DrawToolbar.TYPE].on("enable", this._toolbarEnabled, this)), L.EditToolbar && this.options.edit && (e = new L.EditToolbar(this.options.edit), this._toolbars[L.EditToolbar.TYPE] = e, this._toolbars[L.EditToolbar.TYPE].on("enable", this._toolbarEnabled, this)), L.toolbar = this;
        },
        onAdd: function(t) {
            var e, i = L.DomUtil.create("div", "leaflet-draw"), o = !1;
            for(var a in this._toolbars)this._toolbars.hasOwnProperty(a) && (e = this._toolbars[a].addToolbar(t)) && (o || (L.DomUtil.hasClass(e, "leaflet-draw-toolbar-top") || L.DomUtil.addClass(e.childNodes[0], "leaflet-draw-toolbar-top"), o = !0), i.appendChild(e));
            return i;
        },
        onRemove: function() {
            for(var t in this._toolbars)this._toolbars.hasOwnProperty(t) && this._toolbars[t].removeToolbar();
        },
        setDrawingOptions: function(t) {
            for(var e in this._toolbars)this._toolbars[e] instanceof L.DrawToolbar && this._toolbars[e].setOptions(t);
        },
        _toolbarEnabled: function(t) {
            var e = t.target;
            for(var i in this._toolbars)this._toolbars[i] !== e && this._toolbars[i].disable();
        }
    }), L.Map.mergeOptions({
        drawControlTooltips: !0,
        drawControl: !1
    }), L.Map.addInitHook(function() {
        this.options.drawControl && (this.drawControl = new L.Control.Draw, this.addControl(this.drawControl));
    }), L.Toolbar = L.Class.extend({
        initialize: function(t) {
            L.setOptions(this, t), this._modes = {}, this._actionButtons = [], this._activeMode = null;
            var e = L.version.split(".");
            1 === parseInt(e[0], 10) && parseInt(e[1], 10) >= 2 ? L.Toolbar.include(L.Evented.prototype) : L.Toolbar.include(L.Mixin.Events);
        },
        enabled: function() {
            return null !== this._activeMode;
        },
        disable: function() {
            this.enabled() && this._activeMode.handler.disable();
        },
        addToolbar: function(t) {
            var e, i = L.DomUtil.create("div", "leaflet-draw-section"), o = 0, a = this._toolbarClass || "", n = this.getModeHandlers(t);
            for(this._toolbarContainer = L.DomUtil.create("div", "leaflet-draw-toolbar leaflet-bar"), this._map = t, e = 0; e < n.length; e++)n[e].enabled && this._initModeHandler(n[e].handler, this._toolbarContainer, o++, a, n[e].title);
            if (o) return this._lastButtonIndex = --o, this._actionsContainer = L.DomUtil.create("ul", "leaflet-draw-actions"), i.appendChild(this._toolbarContainer), i.appendChild(this._actionsContainer), i;
        },
        removeToolbar: function() {
            for(var t in this._modes)this._modes.hasOwnProperty(t) && (this._disposeButton(this._modes[t].button, this._modes[t].handler.enable, this._modes[t].handler), this._modes[t].handler.disable(), this._modes[t].handler.off("enabled", this._handlerActivated, this).off("disabled", this._handlerDeactivated, this));
            this._modes = {};
            for(var e = 0, i = this._actionButtons.length; e < i; e++)this._disposeButton(this._actionButtons[e].button, this._actionButtons[e].callback, this);
            this._actionButtons = [], this._actionsContainer = null;
        },
        _initModeHandler: function(t, e, i, o, a) {
            var n = t.type;
            this._modes[n] = {}, this._modes[n].handler = t, this._modes[n].button = this._createButton({
                type: n,
                title: a,
                className: o + "-" + n,
                container: e,
                callback: this._modes[n].handler.enable,
                context: this._modes[n].handler
            }), this._modes[n].buttonIndex = i, this._modes[n].handler.on("enabled", this._handlerActivated, this).on("disabled", this._handlerDeactivated, this);
        },
        _detectIOS: function() {
            return /iPad|iPhone|iPod/.test(navigator.userAgent) && !t.MSStream;
        },
        _createButton: function(t) {
            var e = L.DomUtil.create("a", t.className || "", t.container), i = L.DomUtil.create("span", "sr-only", t.container);
            e.href = "#", e.appendChild(i), t.title && (e.title = t.title, i.innerHTML = t.title), t.text && (e.innerHTML = t.text, i.innerHTML = t.text);
            var o = this._detectIOS() ? "touchstart" : "click";
            return L.DomEvent.on(e, "click", L.DomEvent.stopPropagation).on(e, "mousedown", L.DomEvent.stopPropagation).on(e, "dblclick", L.DomEvent.stopPropagation).on(e, "touchstart", L.DomEvent.stopPropagation).on(e, "click", L.DomEvent.preventDefault).on(e, o, t.callback, t.context), e;
        },
        _disposeButton: function(t, e) {
            var i = this._detectIOS() ? "touchstart" : "click";
            L.DomEvent.off(t, "click", L.DomEvent.stopPropagation).off(t, "mousedown", L.DomEvent.stopPropagation).off(t, "dblclick", L.DomEvent.stopPropagation).off(t, "touchstart", L.DomEvent.stopPropagation).off(t, "click", L.DomEvent.preventDefault).off(t, i, e);
        },
        _handlerActivated: function(t) {
            this.disable(), this._activeMode = this._modes[t.handler], L.DomUtil.addClass(this._activeMode.button, "leaflet-draw-toolbar-button-enabled"), this._showActionsToolbar(), this.fire("enable");
        },
        _handlerDeactivated: function() {
            this._hideActionsToolbar(), L.DomUtil.removeClass(this._activeMode.button, "leaflet-draw-toolbar-button-enabled"), this._activeMode = null, this.fire("disable");
        },
        _createActions: function(t) {
            var e, i, o, a, n = this._actionsContainer, s = this.getActions(t), r = s.length;
            for(i = 0, o = this._actionButtons.length; i < o; i++)this._disposeButton(this._actionButtons[i].button, this._actionButtons[i].callback);
            for(this._actionButtons = []; n.firstChild;)n.removeChild(n.firstChild);
            for(var l = 0; l < r; l++)"enabled" in s[l] && !s[l].enabled || (e = L.DomUtil.create("li", "", n), a = this._createButton({
                title: s[l].title,
                text: s[l].text,
                container: e,
                callback: s[l].callback,
                context: s[l].context
            }), this._actionButtons.push({
                button: a,
                callback: s[l].callback
            }));
        },
        _showActionsToolbar: function() {
            var t = this._activeMode.buttonIndex, e = this._lastButtonIndex, i = this._activeMode.button.offsetTop - 1;
            this._createActions(this._activeMode.handler), this._actionsContainer.style.top = i + "px", 0 === t && (L.DomUtil.addClass(this._toolbarContainer, "leaflet-draw-toolbar-notop"), L.DomUtil.addClass(this._actionsContainer, "leaflet-draw-actions-top")), t === e && (L.DomUtil.addClass(this._toolbarContainer, "leaflet-draw-toolbar-nobottom"), L.DomUtil.addClass(this._actionsContainer, "leaflet-draw-actions-bottom")), this._actionsContainer.style.display = "block", this._map.fire(L.Draw.Event.TOOLBAROPENED);
        },
        _hideActionsToolbar: function() {
            this._actionsContainer.style.display = "none", L.DomUtil.removeClass(this._toolbarContainer, "leaflet-draw-toolbar-notop"), L.DomUtil.removeClass(this._toolbarContainer, "leaflet-draw-toolbar-nobottom"), L.DomUtil.removeClass(this._actionsContainer, "leaflet-draw-actions-top"), L.DomUtil.removeClass(this._actionsContainer, "leaflet-draw-actions-bottom"), this._map.fire(L.Draw.Event.TOOLBARCLOSED);
        }
    }), L.Draw = L.Draw || {}, L.Draw.Tooltip = L.Class.extend({
        initialize: function(t) {
            this._map = t, this._popupPane = t._panes.popupPane, this._visible = !1, this._container = t.options.drawControlTooltips ? L.DomUtil.create("div", "leaflet-draw-tooltip", this._popupPane) : null, this._singleLineLabel = !1, this._map.on("mouseout", this._onMouseOut, this);
        },
        dispose: function() {
            this._map.off("mouseout", this._onMouseOut, this), this._container && (this._popupPane.removeChild(this._container), this._container = null);
        },
        updateContent: function(t) {
            return this._container ? (t.subtext = t.subtext || "", 0 !== t.subtext.length || this._singleLineLabel ? t.subtext.length > 0 && this._singleLineLabel && (L.DomUtil.removeClass(this._container, "leaflet-draw-tooltip-single"), this._singleLineLabel = !1) : (L.DomUtil.addClass(this._container, "leaflet-draw-tooltip-single"), this._singleLineLabel = !0), this._container.innerHTML = (t.subtext.length > 0 ? '<span class="leaflet-draw-tooltip-subtext">' + t.subtext + "</span><br />" : "") + "<span>" + t.text + "</span>", t.text || t.subtext ? (this._visible = !0, this._container.style.visibility = "inherit") : (this._visible = !1, this._container.style.visibility = "hidden"), this) : this;
        },
        updatePosition: function(t) {
            var e = this._map.latLngToLayerPoint(t), i = this._container;
            return this._container && (this._visible && (i.style.visibility = "inherit"), L.DomUtil.setPosition(i, e)), this;
        },
        showAsError: function() {
            return this._container && L.DomUtil.addClass(this._container, "leaflet-error-draw-tooltip"), this;
        },
        removeError: function() {
            return this._container && L.DomUtil.removeClass(this._container, "leaflet-error-draw-tooltip"), this;
        },
        _onMouseOut: function() {
            this._container && (this._container.style.visibility = "hidden");
        }
    }), L.DrawToolbar = L.Toolbar.extend({
        statics: {
            TYPE: "draw"
        },
        options: {
            polyline: {},
            polygon: {},
            rectangle: {},
            circle: {},
            marker: {},
            circlemarker: {}
        },
        initialize: function(t) {
            for(var e in this.options)this.options.hasOwnProperty(e) && t[e] && (t[e] = L.extend({}, this.options[e], t[e]));
            this._toolbarClass = "leaflet-draw-draw", L.Toolbar.prototype.initialize.call(this, t);
        },
        getModeHandlers: function(t) {
            return [
                {
                    enabled: this.options.polyline,
                    handler: new L.Draw.Polyline(t, this.options.polyline),
                    title: L.drawLocal.draw.toolbar.buttons.polyline
                },
                {
                    enabled: this.options.polygon,
                    handler: new L.Draw.Polygon(t, this.options.polygon),
                    title: L.drawLocal.draw.toolbar.buttons.polygon
                },
                {
                    enabled: this.options.rectangle,
                    handler: new L.Draw.Rectangle(t, this.options.rectangle),
                    title: L.drawLocal.draw.toolbar.buttons.rectangle
                },
                {
                    enabled: this.options.circle,
                    handler: new L.Draw.Circle(t, this.options.circle),
                    title: L.drawLocal.draw.toolbar.buttons.circle
                },
                {
                    enabled: this.options.marker,
                    handler: new L.Draw.Marker(t, this.options.marker),
                    title: L.drawLocal.draw.toolbar.buttons.marker
                },
                {
                    enabled: this.options.circlemarker,
                    handler: new L.Draw.CircleMarker(t, this.options.circlemarker),
                    title: L.drawLocal.draw.toolbar.buttons.circlemarker
                }
            ];
        },
        getActions: function(t) {
            return [
                {
                    enabled: t.completeShape,
                    title: L.drawLocal.draw.toolbar.finish.title,
                    text: L.drawLocal.draw.toolbar.finish.text,
                    callback: t.completeShape,
                    context: t
                },
                {
                    enabled: t.deleteLastVertex,
                    title: L.drawLocal.draw.toolbar.undo.title,
                    text: L.drawLocal.draw.toolbar.undo.text,
                    callback: t.deleteLastVertex,
                    context: t
                },
                {
                    title: L.drawLocal.draw.toolbar.actions.title,
                    text: L.drawLocal.draw.toolbar.actions.text,
                    callback: this.disable,
                    context: this
                }
            ];
        },
        setOptions: function(t) {
            L.setOptions(this, t);
            for(var e in this._modes)this._modes.hasOwnProperty(e) && t.hasOwnProperty(e) && this._modes[e].handler.setOptions(t[e]);
        }
    }), L.EditToolbar = L.Toolbar.extend({
        statics: {
            TYPE: "edit"
        },
        options: {
            edit: {
                selectedPathOptions: {
                    dashArray: "10, 10",
                    fill: !0,
                    fillColor: "#fe57a1",
                    fillOpacity: .1,
                    maintainColor: !1
                }
            },
            remove: {},
            poly: null,
            featureGroup: null
        },
        initialize: function(t) {
            t.edit && (void 0 === t.edit.selectedPathOptions && (t.edit.selectedPathOptions = this.options.edit.selectedPathOptions), t.edit.selectedPathOptions = L.extend({}, this.options.edit.selectedPathOptions, t.edit.selectedPathOptions)), t.remove && (t.remove = L.extend({}, this.options.remove, t.remove)), t.poly && (t.poly = L.extend({}, this.options.poly, t.poly)), this._toolbarClass = "leaflet-draw-edit", L.Toolbar.prototype.initialize.call(this, t), this._selectedFeatureCount = 0;
        },
        getModeHandlers: function(t) {
            var e = this.options.featureGroup;
            return [
                {
                    enabled: this.options.edit,
                    handler: new L.EditToolbar.Edit(t, {
                        featureGroup: e,
                        selectedPathOptions: this.options.edit.selectedPathOptions,
                        poly: this.options.poly
                    }),
                    title: L.drawLocal.edit.toolbar.buttons.edit
                },
                {
                    enabled: this.options.remove,
                    handler: new L.EditToolbar.Delete(t, {
                        featureGroup: e
                    }),
                    title: L.drawLocal.edit.toolbar.buttons.remove
                }
            ];
        },
        getActions: function(t) {
            var e = [
                {
                    title: L.drawLocal.edit.toolbar.actions.save.title,
                    text: L.drawLocal.edit.toolbar.actions.save.text,
                    callback: this._save,
                    context: this
                },
                {
                    title: L.drawLocal.edit.toolbar.actions.cancel.title,
                    text: L.drawLocal.edit.toolbar.actions.cancel.text,
                    callback: this.disable,
                    context: this
                }
            ];
            return t.removeAllLayers && e.push({
                title: L.drawLocal.edit.toolbar.actions.clearAll.title,
                text: L.drawLocal.edit.toolbar.actions.clearAll.text,
                callback: this._clearAllLayers,
                context: this
            }), e;
        },
        addToolbar: function(t) {
            var e = L.Toolbar.prototype.addToolbar.call(this, t);
            return this._checkDisabled(), this.options.featureGroup.on("layeradd layerremove", this._checkDisabled, this), e;
        },
        removeToolbar: function() {
            this.options.featureGroup.off("layeradd layerremove", this._checkDisabled, this), L.Toolbar.prototype.removeToolbar.call(this);
        },
        disable: function() {
            this.enabled() && (this._activeMode.handler.revertLayers(), L.Toolbar.prototype.disable.call(this));
        },
        _save: function() {
            this._activeMode.handler.save(), this._activeMode && this._activeMode.handler.disable();
        },
        _clearAllLayers: function() {
            this._activeMode.handler.removeAllLayers(), this._activeMode && this._activeMode.handler.disable();
        },
        _checkDisabled: function() {
            var t, e = this.options.featureGroup, i = 0 !== e.getLayers().length;
            this.options.edit && (t = this._modes[L.EditToolbar.Edit.TYPE].button, i ? L.DomUtil.removeClass(t, "leaflet-disabled") : L.DomUtil.addClass(t, "leaflet-disabled"), t.setAttribute("title", i ? L.drawLocal.edit.toolbar.buttons.edit : L.drawLocal.edit.toolbar.buttons.editDisabled)), this.options.remove && (t = this._modes[L.EditToolbar.Delete.TYPE].button, i ? L.DomUtil.removeClass(t, "leaflet-disabled") : L.DomUtil.addClass(t, "leaflet-disabled"), t.setAttribute("title", i ? L.drawLocal.edit.toolbar.buttons.remove : L.drawLocal.edit.toolbar.buttons.removeDisabled));
        }
    }), L.EditToolbar.Edit = L.Handler.extend({
        statics: {
            TYPE: "edit"
        },
        initialize: function(t, e) {
            if (L.Handler.prototype.initialize.call(this, t), L.setOptions(this, e), this._featureGroup = e.featureGroup, !(this._featureGroup instanceof L.FeatureGroup)) throw new Error("options.featureGroup must be a L.FeatureGroup");
            this._uneditedLayerProps = {}, this.type = L.EditToolbar.Edit.TYPE;
            var i = L.version.split(".");
            1 === parseInt(i[0], 10) && parseInt(i[1], 10) >= 2 ? L.EditToolbar.Edit.include(L.Evented.prototype) : L.EditToolbar.Edit.include(L.Mixin.Events);
        },
        enable: function() {
            !this._enabled && this._hasAvailableLayers() && (this.fire("enabled", {
                handler: this.type
            }), this._map.fire(L.Draw.Event.EDITSTART, {
                handler: this.type
            }), L.Handler.prototype.enable.call(this), this._featureGroup.on("layeradd", this._enableLayerEdit, this).on("layerremove", this._disableLayerEdit, this));
        },
        disable: function() {
            this._enabled && (this._featureGroup.off("layeradd", this._enableLayerEdit, this).off("layerremove", this._disableLayerEdit, this), L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.EDITSTOP, {
                handler: this.type
            }), this.fire("disabled", {
                handler: this.type
            }));
        },
        addHooks: function() {
            var t = this._map;
            t && (t.getContainer().focus(), this._featureGroup.eachLayer(this._enableLayerEdit, this), this._tooltip = new L.Draw.Tooltip(this._map), this._tooltip.updateContent({
                text: L.drawLocal.edit.handlers.edit.tooltip.text,
                subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
            }), t._editTooltip = this._tooltip, this._updateTooltip(), this._map.on("mousemove", this._onMouseMove, this).on("touchmove", this._onMouseMove, this).on("MSPointerMove", this._onMouseMove, this).on(L.Draw.Event.EDITVERTEX, this._updateTooltip, this));
        },
        removeHooks: function() {
            this._map && (this._featureGroup.eachLayer(this._disableLayerEdit, this), this._uneditedLayerProps = {}, this._tooltip.dispose(), this._tooltip = null, this._map.off("mousemove", this._onMouseMove, this).off("touchmove", this._onMouseMove, this).off("MSPointerMove", this._onMouseMove, this).off(L.Draw.Event.EDITVERTEX, this._updateTooltip, this));
        },
        revertLayers: function() {
            this._featureGroup.eachLayer(function(t) {
                this._revertLayer(t);
            }, this);
        },
        save: function() {
            var t = new L.LayerGroup;
            this._featureGroup.eachLayer(function(e) {
                e.edited && (t.addLayer(e), e.edited = !1);
            }), this._map.fire(L.Draw.Event.EDITED, {
                layers: t
            });
        },
        _backupLayer: function(t) {
            var e = L.Util.stamp(t);
            this._uneditedLayerProps[e] || (t instanceof L.Polyline || t instanceof L.Polygon || t instanceof L.Rectangle ? this._uneditedLayerProps[e] = {
                latlngs: L.LatLngUtil.cloneLatLngs(t.getLatLngs())
            } : t instanceof L.Circle ? this._uneditedLayerProps[e] = {
                latlng: L.LatLngUtil.cloneLatLng(t.getLatLng()),
                radius: t.getRadius()
            } : (t instanceof L.Marker || t instanceof L.CircleMarker) && (this._uneditedLayerProps[e] = {
                latlng: L.LatLngUtil.cloneLatLng(t.getLatLng())
            }));
        },
        _getTooltipText: function() {
            return {
                text: L.drawLocal.edit.handlers.edit.tooltip.text,
                subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext
            };
        },
        _updateTooltip: function() {
            this._tooltip.updateContent(this._getTooltipText());
        },
        _revertLayer: function(t) {
            var e = L.Util.stamp(t);
            t.edited = !1, this._uneditedLayerProps.hasOwnProperty(e) && (t instanceof L.Polyline || t instanceof L.Polygon || t instanceof L.Rectangle ? t.setLatLngs(this._uneditedLayerProps[e].latlngs) : t instanceof L.Circle ? (t.setLatLng(this._uneditedLayerProps[e].latlng), t.setRadius(this._uneditedLayerProps[e].radius)) : (t instanceof L.Marker || t instanceof L.CircleMarker) && t.setLatLng(this._uneditedLayerProps[e].latlng), t.fire("revert-edited", {
                layer: t
            }));
        },
        _enableLayerEdit: function(t) {
            var e, i, o = t.layer || t.target || t;
            this._backupLayer(o), this.options.poly && (i = L.Util.extend({}, this.options.poly), o.options.poly = i), this.options.selectedPathOptions && (e = L.Util.extend({}, this.options.selectedPathOptions), e.maintainColor && (e.color = o.options.color, e.fillColor = o.options.fillColor), o.options.original = L.extend({}, o.options), o.options.editing = e), o instanceof L.Marker ? (o.editing && o.editing.enable(), o.dragging.enable(), o.on("dragend", this._onMarkerDragEnd).on("touchmove", this._onTouchMove, this).on("MSPointerMove", this._onTouchMove, this).on("touchend", this._onMarkerDragEnd, this).on("MSPointerUp", this._onMarkerDragEnd, this)) : o.editing.enable();
        },
        _disableLayerEdit: function(t) {
            var e = t.layer || t.target || t;
            e.edited = !1, e.editing && e.editing.disable(), delete e.options.editing, delete e.options.original, this._selectedPathOptions && (e instanceof L.Marker ? this._toggleMarkerHighlight(e) : (e.setStyle(e.options.previousOptions), delete e.options.previousOptions)), e instanceof L.Marker ? (e.dragging.disable(), e.off("dragend", this._onMarkerDragEnd, this).off("touchmove", this._onTouchMove, this).off("MSPointerMove", this._onTouchMove, this).off("touchend", this._onMarkerDragEnd, this).off("MSPointerUp", this._onMarkerDragEnd, this)) : e.editing.disable();
        },
        _onMouseMove: function(t) {
            this._tooltip.updatePosition(t.latlng);
        },
        _onMarkerDragEnd: function(t) {
            var e = t.target;
            e.edited = !0, this._map.fire(L.Draw.Event.EDITMOVE, {
                layer: e
            });
        },
        _onTouchMove: function(t) {
            var e = t.originalEvent.changedTouches[0], i = this._map.mouseEventToLayerPoint(e), o = this._map.layerPointToLatLng(i);
            t.target.setLatLng(o);
        },
        _hasAvailableLayers: function() {
            return 0 !== this._featureGroup.getLayers().length;
        }
    }), L.EditToolbar.Delete = L.Handler.extend({
        statics: {
            TYPE: "remove"
        },
        initialize: function(t, e) {
            if (L.Handler.prototype.initialize.call(this, t), L.Util.setOptions(this, e), this._deletableLayers = this.options.featureGroup, !(this._deletableLayers instanceof L.FeatureGroup)) throw new Error("options.featureGroup must be a L.FeatureGroup");
            this.type = L.EditToolbar.Delete.TYPE;
            var i = L.version.split(".");
            1 === parseInt(i[0], 10) && parseInt(i[1], 10) >= 2 ? L.EditToolbar.Delete.include(L.Evented.prototype) : L.EditToolbar.Delete.include(L.Mixin.Events);
        },
        enable: function() {
            !this._enabled && this._hasAvailableLayers() && (this.fire("enabled", {
                handler: this.type
            }), this._map.fire(L.Draw.Event.DELETESTART, {
                handler: this.type
            }), L.Handler.prototype.enable.call(this), this._deletableLayers.on("layeradd", this._enableLayerDelete, this).on("layerremove", this._disableLayerDelete, this));
        },
        disable: function() {
            this._enabled && (this._deletableLayers.off("layeradd", this._enableLayerDelete, this).off("layerremove", this._disableLayerDelete, this), L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.DELETESTOP, {
                handler: this.type
            }), this.fire("disabled", {
                handler: this.type
            }));
        },
        addHooks: function() {
            var t = this._map;
            t && (t.getContainer().focus(), this._deletableLayers.eachLayer(this._enableLayerDelete, this), this._deletedLayers = new L.LayerGroup, this._tooltip = new L.Draw.Tooltip(this._map), this._tooltip.updateContent({
                text: L.drawLocal.edit.handlers.remove.tooltip.text
            }), this._map.on("mousemove", this._onMouseMove, this));
        },
        removeHooks: function() {
            this._map && (this._deletableLayers.eachLayer(this._disableLayerDelete, this), this._deletedLayers = null, this._tooltip.dispose(), this._tooltip = null, this._map.off("mousemove", this._onMouseMove, this));
        },
        revertLayers: function() {
            this._deletedLayers.eachLayer(function(t) {
                this._deletableLayers.addLayer(t), t.fire("revert-deleted", {
                    layer: t
                });
            }, this);
        },
        save: function() {
            this._map.fire(L.Draw.Event.DELETED, {
                layers: this._deletedLayers
            });
        },
        removeAllLayers: function() {
            this._deletableLayers.eachLayer(function(t) {
                this._removeLayer({
                    layer: t
                });
            }, this), this.save();
        },
        _enableLayerDelete: function(t) {
            (t.layer || t.target || t).on("click", this._removeLayer, this);
        },
        _disableLayerDelete: function(t) {
            var e = t.layer || t.target || t;
            e.off("click", this._removeLayer, this), this._deletedLayers.removeLayer(e);
        },
        _removeLayer: function(t) {
            var e = t.layer || t.target || t;
            this._deletableLayers.removeLayer(e), this._deletedLayers.addLayer(e), e.fire("deleted");
        },
        _onMouseMove: function(t) {
            this._tooltip.updatePosition(t.latlng);
        },
        _hasAvailableLayers: function() {
            return 0 !== this._deletableLayers.getLayers().length;
        }
    });
}(window, document);



var $2q7Wm = parcelRequire("2q7Wm");

var $6KOho = parcelRequire("6KOho");

/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");

var $8JYDX = parcelRequire("8JYDX");

/////////////////
// CÁLCULO CELDAS
// obtengo el lado de cada celda (dependiente del zoom) a partir de la referencia:
// config.zDegreesStep4 es el número de grados para zoom 4
function $0a5d75214fa44e03$export$c7c0bc1741de0bee(zoom) {
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).cellSide[zoom]) {
        const potencia = Math.pow(2, zoom - 4);
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).cellSide[zoom] = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zDegreesStep4 / potencia;
    }
    return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).cellSide[zoom];
}
// a partir de unos bounds genero la malla que lo envuelve para el zoom z
function $0a5d75214fa44e03$export$85a47b3ccce199ed(bounds, z) {
    // recupero zoom
    const zoom = z ? z : Sesion.zoom;
    // recupero cellSide
    const cellSide = $0a5d75214fa44e03$export$c7c0bc1741de0bee(zoom);
    // preparo grid
    const grid = {
        "cellN": Math.floor(bounds.getNorth() / cellSide),
        "cellS": Math.floor(bounds.getSouth() / cellSide),
        "cellE": Math.floor(bounds.getEast() / cellSide),
        "cellW": Math.floor(bounds.getWest() / cellSide)
    };
    // devuelvo grid
    return grid;
}
// los bounds de un grid
function $0a5d75214fa44e03$export$bcb885fb505ac675(grid, z) {
    // recupero zoom
    const zoom = z ? z : Sesion.zoom;
    // recupero cellSide
    const cellSide = $0a5d75214fa44e03$export$c7c0bc1741de0bee(zoom);
    // devuelvo objeto bounds en formato Leaflet
    return (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds([
        [
            grid.cellS * cellSide,
            grid.cellW * cellSide
        ],
        [
            (grid.cellN + 1) * cellSide,
            (grid.cellE + 1) * cellSide
        ] // E			
    ]);
}
// los bounds de una celda
function $0a5d75214fa44e03$export$4e23e15d2ccb71f7(cellX, cellY, z) {
    // recupero zoom
    const zoom = z ? z : Sesion.zoom;
    // recupero cellSide
    const cellSide = $0a5d75214fa44e03$export$c7c0bc1741de0bee(zoom);
    // devuelvo objeto bounds en formato Leaflet
    return (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds([
        [
            cellY * cellSide,
            cellX * cellSide
        ],
        [
            (cellY + 1) * cellSide,
            (cellX + 1) * cellSide
        ] // E			
    ]);
}
// para una celda dada obtengo el grid para cada nivel de zoom
function $0a5d75214fa44e03$export$bed42eae0b34c43c(cellX, cellY, z, zvalidos) {
    // primero recupero los bounds de la celda
    let bounds = $0a5d75214fa44e03$export$4e23e15d2ccb71f7(cellX, cellY, z);
    // para evitar el efecto borde, contraigo ligeramente los bounds (1 por diez mil)
    const red = (bounds.getEast() - bounds.getWest()) / 10000;
    bounds = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds([
        [
            bounds.getSouth() + red,
            bounds.getWest() + red
        ],
        [
            bounds.getNorth() - red,
            bounds.getEast() - red
        ] // E
    ]);
    // preparo un objeto con el grid para cada nivel de zoom
    let ocgm = {};
    for(let i = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).minZoom; i <= (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).maxZoom; i++)if (zvalidos == undefined || zvalidos[i]) ocgm[i] = $0a5d75214fa44e03$export$85a47b3ccce199ed(bounds, i);
    return ocgm;
}



/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $7xvHX = parcelRequire("7xvHX");

var $gMVVg = parcelRequire("gMVVg");

var $eryG9 = parcelRequire("eryG9");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $df9a6d7fd06616c9$var$DEFAULT_HOST = "firebasestorage.googleapis.com";
/**
 * The key in Firebase config json for the storage bucket.
 */ const $df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY = "storageBucket";
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $df9a6d7fd06616c9$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $df9a6d7fd06616c9$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const $df9a6d7fd06616c9$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $df9a6d7fd06616c9$export$697502632950e9d3 extends (0, $gMVVg.FirebaseError) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super($df9a6d7fd06616c9$var$prependCode(code), `Firebase Storage: ${message} (${$df9a6d7fd06616c9$var$prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $df9a6d7fd06616c9$export$697502632950e9d3.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $df9a6d7fd06616c9$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $df9a6d7fd06616c9$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($df9a6d7fd06616c9$export$54592d666d6ce114 || ($df9a6d7fd06616c9$export$54592d666d6ce114 = {}));
function $df9a6d7fd06616c9$var$prependCode(code) {
    return "storage/" + code;
}
function $df9a6d7fd06616c9$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNKNOWN, message);
}
function $df9a6d7fd06616c9$var$objectNotFound(path) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $df9a6d7fd06616c9$var$quotaExceeded(bucket) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + "https://firebase.google.com/pricing/.");
}
function $df9a6d7fd06616c9$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $df9a6d7fd06616c9$var$unauthorizedApp() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNAUTHORIZED_APP, "This app does not have permission to access Firebase Storage on this project.");
}
function $df9a6d7fd06616c9$var$unauthorized(path) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $df9a6d7fd06616c9$var$retryLimitExceeded() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, "Max retry time for operation exceeded, please try again.");
}
function $df9a6d7fd06616c9$var$canceled() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.CANCELED, "User canceled the upload/download.");
}
function $df9a6d7fd06616c9$var$invalidUrl(url) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $df9a6d7fd06616c9$var$invalidDefaultBucket(bucket) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $df9a6d7fd06616c9$var$noDefaultBucket() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $df9a6d7fd06616c9$var$cannotSliceBlob() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.CANNOT_SLICE_BLOB, "Cannot slice blob for upload. Please retry the upload.");
}
function $df9a6d7fd06616c9$var$serverFileWrongSize() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, "Server recorded incorrect upload file size, please retry the upload.");
}
function $df9a6d7fd06616c9$var$noDownloadURL() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.NO_DOWNLOAD_URL, "The given file does not have any download URLs.");
}
function $df9a6d7fd06616c9$var$missingPolyFill(polyFill) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$8f74d9881d1936fd(message) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $df9a6d7fd06616c9$var$appDeleted() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.APP_DELETED, "The Firebase app was deleted.");
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $df9a6d7fd06616c9$export$61f54cdc36500ad(name) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $df9a6d7fd06616c9$var$invalidFormat(format, message) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $df9a6d7fd06616c9$var$internalError(message) {
    throw new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INTERNAL_ERROR, "Internal error: " + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $df9a6d7fd06616c9$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return "/b/" + encode(this.bucket) + "/o/" + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return "/b/" + encode(this.bucket) + "/o";
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $df9a6d7fd06616c9$export$adb98fff6714334(bucketString, "");
        }
        if (bucketLocation.path === "") return bucketLocation;
        else throw $df9a6d7fd06616c9$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = "([A-Za-z0-9.\\-_]+)";
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === "/") loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = "(/(.*))?$";
        const gsRegex = new RegExp("^gs://" + bucketDomain + gsPath, "i");
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = "v[A-Za-z0-9_]+";
        const firebaseStorageHost = host.replace(/[.]/g, "\\.");
        const firebaseStoragePath = "(/([^?#]*).*)?$";
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, "i");
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $df9a6d7fd06616c9$var$DEFAULT_HOST ? "(?:storage.googleapis.com|storage.cloud.google.com)" : host;
        const cloudStoragePath = "([^?#]*)";
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, "i");
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = "";
                location = new $df9a6d7fd06616c9$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $df9a6d7fd06616c9$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $df9a6d7fd06616c9$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $df9a6d7fd06616c9$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $df9a6d7fd06616c9$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $df9a6d7fd06616c9$var$isFunction(p) {
    return typeof p === "function";
}
function $df9a6d7fd06616c9$var$isNonArrayObject(p) {
    return typeof p === "object" && !Array.isArray(p);
}
function $df9a6d7fd06616c9$var$isString(p) {
    return typeof p === "string" || p instanceof String;
}
function $df9a6d7fd06616c9$var$isNativeBlob(p) {
    return $df9a6d7fd06616c9$var$isNativeBlobDefined() && p instanceof Blob;
}
function $df9a6d7fd06616c9$var$isNativeBlobDefined() {
    return typeof Blob !== "undefined";
}
function $df9a6d7fd06616c9$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $df9a6d7fd06616c9$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $df9a6d7fd06616c9$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $df9a6d7fd06616c9$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = "?";
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + "=" + encode(params[key]);
        queryPart = queryPart + nextPart + "&";
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error codes for requests made by the the XhrIo wrapper.
 */ var $df9a6d7fd06616c9$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($df9a6d7fd06616c9$var$ErrorCode || ($df9a6d7fd06616c9$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $df9a6d7fd06616c9$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $df9a6d7fd06616c9$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $df9a6d7fd06616c9$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || $df9a6d7fd06616c9$var$isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === $df9a6d7fd06616c9$var$ErrorCode.ABORT;
                    backoffCallback(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $df9a6d7fd06616c9$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($df9a6d7fd06616c9$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $df9a6d7fd06616c9$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $df9a6d7fd06616c9$var$appDeleted() : $df9a6d7fd06616c9$var$canceled();
                    reject(err);
                } else {
                    const err = $df9a6d7fd06616c9$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $df9a6d7fd06616c9$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $df9a6d7fd06616c9$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $df9a6d7fd06616c9$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $df9a6d7fd06616c9$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers["Authorization"] = "Firebase " + authToken;
}
function $df9a6d7fd06616c9$var$addVersionHeader_(headers, firebaseVersion) {
    headers["X-Firebase-Storage-Version"] = "webjs/" + (firebaseVersion !== null && firebaseVersion !== void 0 ? firebaseVersion : "AppManager");
}
function $df9a6d7fd06616c9$var$addGmpidHeader_(headers, appId) {
    if (appId) headers["X-Firebase-GMPID"] = appId;
}
function $df9a6d7fd06616c9$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers["X-Firebase-AppCheck"] = appCheckToken;
}
function $df9a6d7fd06616c9$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true) {
    const queryPart = $df9a6d7fd06616c9$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $df9a6d7fd06616c9$var$addGmpidHeader_(headers, appId);
    $df9a6d7fd06616c9$var$addAuthHeader_(headers, authToken);
    $df9a6d7fd06616c9$var$addVersionHeader_(headers, firebaseVersion);
    $df9a6d7fd06616c9$var$addAppCheckHeader_(headers, appCheckToken);
    return new $df9a6d7fd06616c9$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$getBlobBuilder() {
    if (typeof BlobBuilder !== "undefined") return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== "undefined") return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $df9a6d7fd06616c9$var$getBlob$1(...args) {
    const BlobBuilder1 = $df9a6d7fd06616c9$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($df9a6d7fd06616c9$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $df9a6d7fd06616c9$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $df9a6d7fd06616c9$var$decodeBase64(encoded) {
    if (typeof atob === "undefined") throw $df9a6d7fd06616c9$var$missingPolyFill("base-64");
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $df9a6d7fd06616c9$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: "raw",
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: "base64",
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: "base64url",
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: "data_url"
};
class $df9a6d7fd06616c9$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$utf8Bytes_(stringData));
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64:
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64URL:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$base64Bytes_(format, stringData));
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$dataURLBytes_(stringData), $df9a6d7fd06616c9$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $df9a6d7fd06616c9$var$unknown();
}
function $df9a6d7fd06616c9$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $df9a6d7fd06616c9$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $df9a6d7fd06616c9$var$invalidFormat($df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL, "Malformed data URL.");
    }
    return $df9a6d7fd06616c9$var$utf8Bytes_(decoded);
}
function $df9a6d7fd06616c9$var$base64Bytes_(format, value) {
    switch(format){
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf("-") !== -1;
                const hasUnder = value.indexOf("_") !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? "-" : "_";
                    throw $df9a6d7fd06616c9$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf("+") !== -1;
                const hasSlash = value.indexOf("/") !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? "+" : "/";
                    throw $df9a6d7fd06616c9$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, "+").replace(/_/g, "/");
                break;
            }
    }
    let bytes;
    try {
        bytes = $df9a6d7fd06616c9$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes("polyfill")) throw e;
        throw $df9a6d7fd06616c9$var$invalidFormat(format, "Invalid character found");
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $df9a6d7fd06616c9$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $df9a6d7fd06616c9$var$invalidFormat($df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $df9a6d7fd06616c9$var$endsWith(middle, ";base64");
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(",") + 1);
    }
}
function $df9a6d7fd06616c9$var$dataURLBytes_(dataUrl) {
    const parts = new $df9a6d7fd06616c9$var$DataURLParts(dataUrl);
    if (parts.base64) return $df9a6d7fd06616c9$var$base64Bytes_($df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $df9a6d7fd06616c9$var$percentEncodedBytes_(parts.rest);
}
function $df9a6d7fd06616c9$var$dataURLContentType_(dataUrl) {
    const parts = new $df9a6d7fd06616c9$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $df9a6d7fd06616c9$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $df9a6d7fd06616c9$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = "";
        if ($df9a6d7fd06616c9$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($df9a6d7fd06616c9$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $df9a6d7fd06616c9$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($df9a6d7fd06616c9$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $df9a6d7fd06616c9$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7($df9a6d7fd06616c9$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($df9a6d7fd06616c9$var$isString(val)) return $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0($df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $df9a6d7fd06616c9$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($df9a6d7fd06616c9$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $df9a6d7fd06616c9$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf("/");
    if (index === -1) return "";
    const newPath = path.slice(0, index);
    return newPath;
}
function $df9a6d7fd06616c9$var$child(path, childPath) {
    const canonicalChildPath = childPath.split("/").filter((component)=>component.length > 0).join("/");
    if (path.length === 0) return canonicalChildPath;
    else return path + "/" + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $df9a6d7fd06616c9$var$lastComponent(path) {
    const index = path.lastIndexOf("/", path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$noXform_(metadata, value) {
    return value;
}
class $df9a6d7fd06616c9$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $df9a6d7fd06616c9$var$noXform_;
    }
}
let $df9a6d7fd06616c9$var$mappings_ = null;
function $df9a6d7fd06616c9$var$xformPath(fullPath) {
    if (!$df9a6d7fd06616c9$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $df9a6d7fd06616c9$var$lastComponent(fullPath);
}
function $df9a6d7fd06616c9$var$getMappings() {
    if ($df9a6d7fd06616c9$var$mappings_) return $df9a6d7fd06616c9$var$mappings_;
    const mappings = [];
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("bucket"));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("generation"));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("metageneration"));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("name", "fullPath", true));
    function mappingsXformPath(_metadata, fullPath) {
        return $df9a6d7fd06616c9$var$xformPath(fullPath);
    }
    const nameMapping = new $df9a6d7fd06616c9$var$Mapping("name");
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $df9a6d7fd06616c9$var$Mapping("size");
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("timeCreated"));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("updated"));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("md5Hash", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("cacheControl", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("contentDisposition", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("contentEncoding", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("contentLanguage", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("contentType", null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping("metadata", "customMetadata", true));
    $df9a6d7fd06616c9$var$mappings_ = mappings;
    return $df9a6d7fd06616c9$var$mappings_;
}
function $df9a6d7fd06616c9$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata["bucket"];
        const path = metadata["fullPath"];
        const loc = new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, "ref", {
        get: generateRef
    });
}
function $df9a6d7fd06616c9$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata["type"] = "file";
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $df9a6d7fd06616c9$var$addRef(metadata, service);
    return metadata;
}
function $df9a6d7fd06616c9$var$fromResourceString(service, resourceString, mappings) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $df9a6d7fd06616c9$var$fromResource(service, resource, mappings);
}
function $df9a6d7fd06616c9$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$df9a6d7fd06616c9$var$isString(obj["downloadTokens"])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj["downloadTokens"];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(",");
    const urls = tokensList.map((token)=>{
        const bucket = metadata["bucket"];
        const path = metadata["fullPath"];
        const urlPart = "/b/" + encode(bucket) + "/o/" + encode(path);
        const base = $df9a6d7fd06616c9$var$makeUrl(urlPart, host, protocol);
        const queryString = $df9a6d7fd06616c9$var$makeQueryString({
            alt: "media",
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $df9a6d7fd06616c9$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $df9a6d7fd06616c9$var$PREFIXES_KEY = "prefixes";
const $df9a6d7fd06616c9$var$ITEMS_KEY = "items";
function $df9a6d7fd06616c9$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource["nextPageToken"]
    };
    if (resource[$df9a6d7fd06616c9$var$PREFIXES_KEY]) for (const path of resource[$df9a6d7fd06616c9$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, "");
        const reference = service._makeStorageReference(new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$df9a6d7fd06616c9$var$ITEMS_KEY]) for (const item of resource[$df9a6d7fd06616c9$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, item["name"]));
        listResult.items.push(reference);
    }
    return listResult;
}
function $df9a6d7fd06616c9$var$fromResponseString(service, bucket, resourceString) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $df9a6d7fd06616c9$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $df9a6d7fd06616c9$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $df9a6d7fd06616c9$var$handlerCheck(cndn) {
    if (!cndn) throw $df9a6d7fd06616c9$var$unknown();
}
function $df9a6d7fd06616c9$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $df9a6d7fd06616c9$var$fromResourceString(service, text, mappings);
        $df9a6d7fd06616c9$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $df9a6d7fd06616c9$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $df9a6d7fd06616c9$var$fromResponseString(service, bucket, text);
        $df9a6d7fd06616c9$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $df9a6d7fd06616c9$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $df9a6d7fd06616c9$var$fromResourceString(service, text, mappings);
        $df9a6d7fd06616c9$var$handlerCheck(metadata !== null);
        return $df9a6d7fd06616c9$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $df9a6d7fd06616c9$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes("Firebase App Check token is invalid")) newErr = $df9a6d7fd06616c9$var$unauthorizedApp();
            else newErr = $df9a6d7fd06616c9$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $df9a6d7fd06616c9$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $df9a6d7fd06616c9$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $df9a6d7fd06616c9$var$objectErrorHandler(location) {
    const shared = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $df9a6d7fd06616c9$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $df9a6d7fd06616c9$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams["prefix"] = "";
    else urlParams["prefix"] = location.path + "/";
    if (delimiter && delimiter.length > 0) urlParams["delimiter"] = delimiter;
    if (pageToken) urlParams["pageToken"] = pageToken;
    if (maxResults) urlParams["maxResults"] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol) + "?alt=media";
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers["Range"] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $df9a6d7fd06616c9$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "GET";
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "PATCH";
    const body = $df9a6d7fd06616c9$var$toResourceString(metadata, mappings);
    const headers = {
        "Content-Type": "application/json; charset=utf-8"
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "DELETE";
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$determineContentType_(metadata, blob) {
    return metadata && metadata["contentType"] || blob && blob.type() || "application/octet-stream";
}
function $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone["fullPath"] = location.path;
    metadataClone["size"] = blob.size();
    if (!metadataClone["contentType"]) metadataClone["contentType"] = $df9a6d7fd06616c9$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $df9a6d7fd06616c9$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        "X-Goog-Upload-Protocol": "multipart"
    };
    function genBoundary() {
        let str = "";
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers["Content-Type"] = "multipart/related; boundary=" + boundary;
    const metadata_ = $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $df9a6d7fd06616c9$var$toResourceString(metadata_, mappings);
    const preBlobPart = "--" + boundary + "\r\n" + "Content-Type: application/json; charset=utf-8\r\n\r\n" + metadataString + "\r\n--" + boundary + "\r\n" + "Content-Type: " + metadata_["contentType"] + "\r\n\r\n";
    const postBlobPart = "\r\n--" + boundary + "--";
    const body = $df9a6d7fd06616c9$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $df9a6d7fd06616c9$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_["fullPath"]
    };
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $df9a6d7fd06616c9$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader("X-Goog-Upload-Status");
    } catch (e) {
        $df9a6d7fd06616c9$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        "active"
    ];
    $df9a6d7fd06616c9$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $df9a6d7fd06616c9$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload["fullPath"]
    };
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = "POST";
    const headers = {
        "X-Goog-Upload-Protocol": "resumable",
        "X-Goog-Upload-Command": "start",
        "X-Goog-Upload-Header-Content-Length": `${blob.size()}`,
        "X-Goog-Upload-Header-Content-Type": metadataForUpload["contentType"],
        "Content-Type": "application/json; charset=utf-8"
    };
    const body = $df9a6d7fd06616c9$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $df9a6d7fd06616c9$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader("X-Goog-Upload-URL");
        } catch (e) {
            $df9a6d7fd06616c9$var$handlerCheck(false);
        }
        $df9a6d7fd06616c9$var$handlerCheck($df9a6d7fd06616c9$var$isString(url));
        return url;
    }
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $df9a6d7fd06616c9$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        "X-Goog-Upload-Command": "query"
    };
    function handler(xhr) {
        const status = $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader("X-Goog-Upload-Size-Received");
        } catch (e) {
            $df9a6d7fd06616c9$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $df9a6d7fd06616c9$var$handlerCheck(false);
        const size = Number(sizeString);
        $df9a6d7fd06616c9$var$handlerCheck(!isNaN(size));
        return new $df9a6d7fd06616c9$var$ResumableUploadStatus(size, blob.size(), status === "final");
    }
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $df9a6d7fd06616c9$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $df9a6d7fd06616c9$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $df9a6d7fd06616c9$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = "";
    if (bytesToUpload === 0) uploadCommand = "finalize";
    else if (bytesLeft === bytesToUpload) uploadCommand = "upload, finalize";
    else uploadCommand = "upload";
    const headers = {
        "X-Goog-Upload-Command": uploadCommand,
        "X-Goog-Upload-Offset": `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $df9a6d7fd06616c9$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, [
            "active",
            "final"
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === "final") metadata = $df9a6d7fd06616c9$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $df9a6d7fd06616c9$var$ResumableUploadStatus(newCurrent, size, uploadStatus === "final", metadata);
    }
    const method = "POST";
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $df9a6d7fd06616c9$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: "state_changed"
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $df9a6d7fd06616c9$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: "running",
    /** The task was paused by the user. */ PAUSED: "paused",
    /** The task completed successfully. */ SUCCESS: "success",
    /** The task was canceled. */ CANCELED: "canceled",
    /** The task failed with an error. */ ERROR: "error"
};
function $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $df9a6d7fd06616c9$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $df9a6d7fd06616c9$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error !== null && error !== void 0 ? error : undefined;
            this.complete = complete !== null && complete !== void 0 ? complete : undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $df9a6d7fd06616c9$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $df9a6d7fd06616c9$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $df9a6d7fd06616c9$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener("abort", ()=>{
                this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener("error", ()=>{
                this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener("load", ()=>{
                resolve();
            });
        });
    }
    send(url, method, body, headers) {
        if (this.sent_) throw $df9a6d7fd06616c9$var$internalError("cannot .send() more than once");
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError("cannot .getErrorCode() before sending");
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError("cannot .getStatus() before sending");
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError("cannot .getResponse() before sending");
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError("cannot .getErrorText() before sending");
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener("progress", listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener("progress", listener);
    }
}
class $df9a6d7fd06616c9$var$XhrTextConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "text";
    }
}
function $df9a6d7fd06616c9$var$newTextConnection() {
    return $df9a6d7fd06616c9$var$textFactoryOverride ? $df9a6d7fd06616c9$var$textFactoryOverride() : new $df9a6d7fd06616c9$var$XhrTextConnection();
}
class $df9a6d7fd06616c9$var$XhrBytesConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "arraybuffer";
    }
}
function $df9a6d7fd06616c9$var$newBytesConnection() {
    return new $df9a6d7fd06616c9$var$XhrBytesConnection();
}
class $df9a6d7fd06616c9$var$XhrBlobConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = "blob";
    }
}
function $df9a6d7fd06616c9$var$newBlobConnection() {
    return new $df9a6d7fd06616c9$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $df9a6d7fd06616c9$export$86a2a9b92406a048 {
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $df9a6d7fd06616c9$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals($df9a6d7fd06616c9$export$54592d666d6ce114.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if ($df9a6d7fd06616c9$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $df9a6d7fd06616c9$var$retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, $df9a6d7fd06616c9$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals($df9a6d7fd06616c9$export$54592d666d6ce114.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $df9a6d7fd06616c9$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $df9a6d7fd06616c9$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $df9a6d7fd06616c9$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new $df9a6d7fd06616c9$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state)){
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS:
                    $df9a6d7fd06616c9$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED:
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $df9a6d7fd06616c9$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.RUNNING:
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $df9a6d7fd06616c9$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $df9a6d7fd06616c9$var$async(observer.complete.bind(observer))();
                break;
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED:
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $df9a6d7fd06616c9$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $df9a6d7fd06616c9$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $df9a6d7fd06616c9$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $df9a6d7fd06616c9$export$adb98fff6714334) this._location = location;
        else this._location = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return "gs://" + this._location.bucket + "/" + this._location.path;
    }
    _newRef(service, location) {
        return new $df9a6d7fd06616c9$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $df9a6d7fd06616c9$export$adb98fff6714334(this._location.bucket, "");
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $df9a6d7fd06616c9$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $df9a6d7fd06616c9$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $df9a6d7fd06616c9$export$adb98fff6714334(this._location.bucket, newPath);
        return new $df9a6d7fd06616c9$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === "") throw $df9a6d7fd06616c9$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $df9a6d7fd06616c9$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot("getBytes");
    const requestInfo = $df9a6d7fd06616c9$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $df9a6d7fd06616c9$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot("getBlob");
    const requestInfo = $df9a6d7fd06616c9$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot("uploadBytes");
    const requestInfo = $df9a6d7fd06616c9$var$multipartUpload(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings(), new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $df9a6d7fd06616c9$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot("uploadBytesResumable");
    return new $df9a6d7fd06616c9$export$86a2a9b92406a048(ref, new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$var$uploadString$1(ref, value, format = $df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot("uploadString");
    const data = $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = Object.assign({}, metadata);
    if (metadataClone["contentType"] == null && data.contentType != null) metadataClone["contentType"] = data.contentType;
    return $df9a6d7fd06616c9$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $df9a6d7fd06616c9$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $df9a6d7fd06616c9$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $df9a6d7fd06616c9$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === "number") $df9a6d7fd06616c9$var$validateNumber("options.maxResults", /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $df9a6d7fd06616c9$var$list$2(ref.storage, ref._location, /*delimiter= */ "/", op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $df9a6d7fd06616c9$var$getMetadata$1(ref) {
    ref._throwIfRoot("getMetadata");
    const requestInfo = $df9a6d7fd06616c9$var$getMetadata$2(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $df9a6d7fd06616c9$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot("updateMetadata");
    const requestInfo = $df9a6d7fd06616c9$var$updateMetadata$2(ref.storage, ref._location, metadata, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $df9a6d7fd06616c9$var$getDownloadURL$1(ref) {
    ref._throwIfRoot("getDownloadURL");
    const requestInfo = $df9a6d7fd06616c9$var$getDownloadUrl(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection).then((url)=>{
        if (url === null) throw $df9a6d7fd06616c9$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $df9a6d7fd06616c9$var$deleteObject$1(ref) {
    ref._throwIfRoot("deleteObject");
    const requestInfo = $df9a6d7fd06616c9$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $df9a6d7fd06616c9$var$_getChild$1(ref, childPath) {
    const newPath = $df9a6d7fd06616c9$var$child(ref._location.path, childPath);
    const location = new $df9a6d7fd06616c9$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $df9a6d7fd06616c9$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $df9a6d7fd06616c9$var$refFromURL(service, url) {
    return new $df9a6d7fd06616c9$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $df9a6d7fd06616c9$var$refFromPath(ref, path) {
    if (ref instanceof $df9a6d7fd06616c9$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $df9a6d7fd06616c9$var$noDefaultBucket();
        const reference = new $df9a6d7fd06616c9$var$Reference(service, service._bucket);
        if (path != null) return $df9a6d7fd06616c9$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $df9a6d7fd06616c9$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $df9a6d7fd06616c9$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $df9a6d7fd06616c9$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $df9a6d7fd06616c9$var$FirebaseStorageImpl) return $df9a6d7fd06616c9$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $df9a6d7fd06616c9$export$8f74d9881d1936fd("To use ref(service, url), the first argument must be a Storage instance.");
    } else return $df9a6d7fd06616c9$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $df9a6d7fd06616c9$var$extractBucket(host, config) {
    const bucketString = config === null || config === void 0 ? void 0 : config[$df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $df9a6d7fd06616c9$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    storage._protocol = "http";
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === "string" ? mockUserToken : (0, $gMVVg.createMockUserToken)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $df9a6d7fd06616c9$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $df9a6d7fd06616c9$var$DEFAULT_HOST;
        this._protocol = "https";
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $df9a6d7fd06616c9$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $df9a6d7fd06616c9$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $df9a6d7fd06616c9$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $df9a6d7fd06616c9$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $df9a6d7fd06616c9$var$validateNumber("time", /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $df9a6d7fd06616c9$var$validateNumber("time", /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $df9a6d7fd06616c9$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = $df9a6d7fd06616c9$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $df9a6d7fd06616c9$var$FailRequest($df9a6d7fd06616c9$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $df9a6d7fd06616c9$var$name = "@firebase/storage";
const $df9a6d7fd06616c9$var$version = "0.12.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $df9a6d7fd06616c9$var$STORAGE_TYPE = "storage";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $df9a6d7fd06616c9$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $gMVVg.getModularInstance)(ref);
    return $df9a6d7fd06616c9$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $gMVVg.getModularInstance)(ref);
    return $df9a6d7fd06616c9$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $gMVVg.getModularInstance)(ref);
    return $df9a6d7fd06616c9$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $df9a6d7fd06616c9$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $gMVVg.getModularInstance)(ref);
    return $df9a6d7fd06616c9$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retreived, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $df9a6d7fd06616c9$export$8548546c0aa631e6(ref) {
    ref = (0, $gMVVg.getModularInstance)(ref);
    return $df9a6d7fd06616c9$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $df9a6d7fd06616c9$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $gMVVg.getModularInstance)(ref);
    return $df9a6d7fd06616c9$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $df9a6d7fd06616c9$export$8837f4fc672e936d(ref, options) {
    ref = (0, $gMVVg.getModularInstance)(ref);
    return $df9a6d7fd06616c9$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $df9a6d7fd06616c9$export$6a265a7d315dec03(ref) {
    ref = (0, $gMVVg.getModularInstance)(ref);
    return $df9a6d7fd06616c9$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $gMVVg.getModularInstance)(ref);
    return $df9a6d7fd06616c9$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $df9a6d7fd06616c9$export$39c5ed4ec960eade(ref) {
    ref = (0, $gMVVg.getModularInstance)(ref);
    return $df9a6d7fd06616c9$var$deleteObject$1(ref);
}
function $df9a6d7fd06616c9$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $gMVVg.getModularInstance)(serviceOrRef);
    return $df9a6d7fd06616c9$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$9acd24c0fce96a85(ref, childPath) {
    return $df9a6d7fd06616c9$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $df9a6d7fd06616c9$export$fbd9b57a66480737(app = (0, $7xvHX.getApp)(), bucketUrl) {
    app = (0, $gMVVg.getModularInstance)(app);
    const storageProvider = (0, $7xvHX._getProvider)(app, $df9a6d7fd06616c9$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, $gMVVg.getDefaultEmulatorHostnameAndPort)("storage");
    if (emulator) $df9a6d7fd06616c9$export$9850e656f954b889(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $df9a6d7fd06616c9$export$9850e656f954b889(storage, host, port, options = {}) {
    $df9a6d7fd06616c9$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $df9a6d7fd06616c9$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $gMVVg.getModularInstance)(ref);
    return $df9a6d7fd06616c9$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $df9a6d7fd06616c9$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error("getStream() is only supported by NodeJS builds");
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $df9a6d7fd06616c9$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider("app").getImmediate();
    const authProvider = container.getProvider("auth-internal");
    const appCheckProvider = container.getProvider("app-check-internal");
    return new $df9a6d7fd06616c9$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $7xvHX.SDK_VERSION));
}
function $df9a6d7fd06616c9$var$registerStorage() {
    (0, $7xvHX._registerComponent)(new (0, $eryG9.Component)($df9a6d7fd06616c9$var$STORAGE_TYPE, $df9a6d7fd06616c9$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $7xvHX.registerVersion)($df9a6d7fd06616c9$var$name, $df9a6d7fd06616c9$var$version, "");
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $7xvHX.registerVersion)($df9a6d7fd06616c9$var$name, $df9a6d7fd06616c9$var$version, "esm2017");
}
$df9a6d7fd06616c9$var$registerStorage();





var $6KOho = parcelRequire("6KOho");


var $2q7Wm = parcelRequire("2q7Wm");

var $dktVJ = parcelRequire("dktVJ");

var $8JYDX = parcelRequire("8JYDX");




/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");




var $6KOho = parcelRequire("6KOho");

var $dktVJ = parcelRequire("dktVJ");

var $8JYDX = parcelRequire("8JYDX");





/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $6KOho = parcelRequire("6KOho");

var $2q7Wm = parcelRequire("2q7Wm");


var $dktVJ = parcelRequire("dktVJ");



/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");




var $6KOho = parcelRequire("6KOho");


var $2q7Wm = parcelRequire("2q7Wm");

var $dktVJ = parcelRequire("dktVJ");

var $8JYDX = parcelRequire("8JYDX");






/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $7xvHX = parcelRequire("7xvHX");

var $5Z2ef = parcelRequire("5Z2ef");

var $gMVVg = parcelRequire("gMVVg");

var $eryG9 = parcelRequire("eryG9");

var $7xvHX = parcelRequire("7xvHX");

var $eryG9 = parcelRequire("eryG9");

var $gMVVg = parcelRequire("gMVVg");

var $iItpQ = parcelRequire("iItpQ");
const $1ee9b91e988771f9$var$name = "@firebase/installations";
const $1ee9b91e988771f9$var$version = "0.6.5";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS = 10000;
const $1ee9b91e988771f9$var$PACKAGE_VERSION = `w:${$1ee9b91e988771f9$var$version}`;
const $1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION = "FIS_v2";
const $1ee9b91e988771f9$var$INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
const $1ee9b91e988771f9$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $1ee9b91e988771f9$var$SERVICE = "installations";
const $1ee9b91e988771f9$var$SERVICE_NAME = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: "Firebase Installation is not registered.",
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: "Firebase Installation not found.",
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: "Could not process request. Application offline.",
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $1ee9b91e988771f9$var$ERROR_FACTORY = new (0, $gMVVg.ErrorFactory)($1ee9b91e988771f9$var$SERVICE, $1ee9b91e988771f9$var$SERVICE_NAME, $1ee9b91e988771f9$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $1ee9b91e988771f9$var$isServerError(error) {
    return error instanceof (0, $gMVVg.FirebaseError) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$1ee9b91e988771f9$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $1ee9b91e988771f9$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $1ee9b91e988771f9$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $1ee9b91e988771f9$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $1ee9b91e988771f9$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $1ee9b91e988771f9$var$getHeaders(appConfig);
    headers.append("Authorization", $1ee9b91e988771f9$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $1ee9b91e988771f9$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $1ee9b91e988771f9$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace("s", "000"));
}
function $1ee9b91e988771f9$var$getAuthorizationHeader(refreshToken) {
    return `${$1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig);
    const headers = $1ee9b91e988771f9$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $1ee9b91e988771f9$var$PACKAGE_VERSION
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $1ee9b91e988771f9$var$getErrorFromResponse("Create Installation", response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $1ee9b91e988771f9$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $1ee9b91e988771f9$var$INVALID_FID = "";
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $1ee9b91e988771f9$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $1ee9b91e988771f9$var$encode(fidByteArray);
        return $1ee9b91e988771f9$var$VALID_FID_PATTERN.test(fid) ? fid : $1ee9b91e988771f9$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $1ee9b91e988771f9$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $1ee9b91e988771f9$var$encode(fidByteArray) {
    const b64String = $1ee9b91e988771f9$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $1ee9b91e988771f9$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $1ee9b91e988771f9$var$fidChanged(appConfig, fid) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    $1ee9b91e988771f9$var$callFidChangeCallbacks(key, fid);
    $1ee9b91e988771f9$var$broadcastFidChange(key, fid);
}
function $1ee9b91e988771f9$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $1ee9b91e988771f9$var$getBroadcastChannel();
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    let callbackSet = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $1ee9b91e988771f9$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $1ee9b91e988771f9$var$removeCallback(appConfig, callback) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const callbackSet = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $1ee9b91e988771f9$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $1ee9b91e988771f9$var$closeBroadcastChannel();
}
function $1ee9b91e988771f9$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $1ee9b91e988771f9$var$broadcastFidChange(key, fid) {
    const channel = $1ee9b91e988771f9$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $1ee9b91e988771f9$var$closeBroadcastChannel();
}
let $1ee9b91e988771f9$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $1ee9b91e988771f9$var$getBroadcastChannel() {
    if (!$1ee9b91e988771f9$var$broadcastChannel && "BroadcastChannel" in self) {
        $1ee9b91e988771f9$var$broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        $1ee9b91e988771f9$var$broadcastChannel.onmessage = (e)=>{
            $1ee9b91e988771f9$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $1ee9b91e988771f9$var$broadcastChannel;
}
function $1ee9b91e988771f9$var$closeBroadcastChannel() {
    if ($1ee9b91e988771f9$var$fidChangeCallbacks.size === 0 && $1ee9b91e988771f9$var$broadcastChannel) {
        $1ee9b91e988771f9$var$broadcastChannel.close();
        $1ee9b91e988771f9$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$DATABASE_NAME = "firebase-installations-database";
const $1ee9b91e988771f9$var$DATABASE_VERSION = 1;
const $1ee9b91e988771f9$var$OBJECT_STORE_NAME = "firebase-installations-store";
let $1ee9b91e988771f9$var$dbPromise = null;
function $1ee9b91e988771f9$var$getDbPromise() {
    if (!$1ee9b91e988771f9$var$dbPromise) $1ee9b91e988771f9$var$dbPromise = (0, $iItpQ.openDB)($1ee9b91e988771f9$var$DATABASE_NAME, $1ee9b91e988771f9$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $1ee9b91e988771f9$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $1ee9b91e988771f9$var$set(appConfig, value) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, "readwrite");
    const objectStore = tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $1ee9b91e988771f9$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $1ee9b91e988771f9$var$remove(appConfig) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $1ee9b91e988771f9$var$update(appConfig, updateFn) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, "readwrite");
    const store = tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $1ee9b91e988771f9$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $1ee9b91e988771f9$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $1ee9b91e988771f9$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $1ee9b91e988771f9$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $1ee9b91e988771f9$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $1ee9b91e988771f9$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $1ee9b91e988771f9$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $1ee9b91e988771f9$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $1ee9b91e988771f9$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $1ee9b91e988771f9$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $1ee9b91e988771f9$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $1ee9b91e988771f9$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $1ee9b91e988771f9$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $1ee9b91e988771f9$var$createInstallationRequest(installations, installationEntry);
        return $1ee9b91e988771f9$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($1ee9b91e988771f9$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID can not be used" error.
        // Generate a new ID next time.
        await $1ee9b91e988771f9$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $1ee9b91e988771f9$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $1ee9b91e988771f9$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $1ee9b91e988771f9$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $1ee9b91e988771f9$var$sleep(100);
        entry = await $1ee9b91e988771f9$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $1ee9b91e988771f9$var$updateInstallationRequest(appConfig) {
    return $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $1ee9b91e988771f9$var$clearTimedOutRequest(oldEntry);
    });
}
function $1ee9b91e988771f9$var$clearTimedOutRequest(entry) {
    if ($1ee9b91e988771f9$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $1ee9b91e988771f9$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $1ee9b91e988771f9$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $1ee9b91e988771f9$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $1ee9b91e988771f9$var$getErrorFromResponse("Generate Auth Token", response);
}
function $1ee9b91e988771f9$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $1ee9b91e988771f9$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $1ee9b91e988771f9$var$update(installations.appConfig, (oldEntry)=>{
        if (!$1ee9b91e988771f9$var$isEntryRegistered(oldEntry)) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $1ee9b91e988771f9$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $1ee9b91e988771f9$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $1ee9b91e988771f9$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $1ee9b91e988771f9$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $1ee9b91e988771f9$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $1ee9b91e988771f9$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $1ee9b91e988771f9$var$sleep(100);
        entry = await $1ee9b91e988771f9$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $1ee9b91e988771f9$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $1ee9b91e988771f9$var$updateAuthTokenRequest(appConfig) {
    return $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (!$1ee9b91e988771f9$var$isEntryRegistered(oldEntry)) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($1ee9b91e988771f9$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $1ee9b91e988771f9$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $1ee9b91e988771f9$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $1ee9b91e988771f9$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($1ee9b91e988771f9$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $1ee9b91e988771f9$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $1ee9b91e988771f9$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $1ee9b91e988771f9$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $1ee9b91e988771f9$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$1ee9b91e988771f9$var$isAuthTokenExpired(authToken);
}
function $1ee9b91e988771f9$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $1ee9b91e988771f9$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $1ee9b91e988771f9$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $1ee9b91e988771f9$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $1ee9b91e988771f9$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $1ee9b91e988771f9$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $1ee9b91e988771f9$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $1ee9b91e988771f9$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $1ee9b91e988771f9$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: "DELETE",
        headers: headers
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $1ee9b91e988771f9$var$getErrorFromResponse("Delete Installation", response);
}
function $1ee9b91e988771f9$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $1ee9b91e988771f9$var$deleteInstallationRequest(appConfig, entry);
                await $1ee9b91e988771f9$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $1ee9b91e988771f9$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $1ee9b91e988771f9$var$addCallback(appConfig, callback);
    return ()=>{
        $1ee9b91e988771f9$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $1ee9b91e988771f9$export$9bfc115e43431ff5(app = (0, $7xvHX.getApp)()) {
    const installationsImpl = (0, $7xvHX._getProvider)(app, "installations").getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$extractAppConfig(app) {
    if (!app || !app.options) throw $1ee9b91e988771f9$var$getMissingValueError("App Configuration");
    if (!app.name) throw $1ee9b91e988771f9$var$getMissingValueError("App Name");
    // Required app config keys
    const configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $1ee9b91e988771f9$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $1ee9b91e988771f9$var$getMissingValueError(valueName) {
    return $1ee9b91e988771f9$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$INSTALLATIONS_NAME = "installations";
const $1ee9b91e988771f9$var$INSTALLATIONS_NAME_INTERNAL = "installations-internal";
const $1ee9b91e988771f9$var$publicFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $1ee9b91e988771f9$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $7xvHX._getProvider)(app, "heartbeat");
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $1ee9b91e988771f9$var$internalFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $7xvHX._getProvider)(app, $1ee9b91e988771f9$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$1ee9b91e988771f9$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$1ee9b91e988771f9$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $1ee9b91e988771f9$var$registerInstallations() {
    (0, $7xvHX._registerComponent)(new (0, $eryG9.Component)($1ee9b91e988771f9$var$INSTALLATIONS_NAME, $1ee9b91e988771f9$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $7xvHX._registerComponent)(new (0, $eryG9.Component)($1ee9b91e988771f9$var$INSTALLATIONS_NAME_INTERNAL, $1ee9b91e988771f9$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $1ee9b91e988771f9$var$registerInstallations();
(0, $7xvHX.registerVersion)($1ee9b91e988771f9$var$name, $1ee9b91e988771f9$var$version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, $7xvHX.registerVersion)($1ee9b91e988771f9$var$name, $1ee9b91e988771f9$var$version, "esm2017");


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $0d15f034d14801d0$var$ANALYTICS_TYPE = "analytics";
// Key to attach FID to in gtag params.
const $0d15f034d14801d0$var$GA_FID_KEY = "firebase_id";
const $0d15f034d14801d0$var$ORIGIN_KEY = "origin";
const $0d15f034d14801d0$var$FETCH_TIMEOUT_MILLIS = 60000;
const $0d15f034d14801d0$var$DYNAMIC_CONFIG_URL = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig";
const $0d15f034d14801d0$var$GTAG_URL = "https://www.googletagmanager.com/gtag/js";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0d15f034d14801d0$var$logger = new (0, $5Z2ef.Logger)("@firebase/analytics");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0d15f034d14801d0$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-intialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: "Firebase Analytics Interop Component failed to instantiate: {$reason}",
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}",
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: "Trusted Types detected an invalid gtag resource: {$gtagURL}."
};
const $0d15f034d14801d0$var$ERROR_FACTORY = new (0, $gMVVg.ErrorFactory)("analytics", "Analytics", $0d15f034d14801d0$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $0d15f034d14801d0$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($0d15f034d14801d0$var$GTAG_URL)) {
        const err = $0d15f034d14801d0$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $0d15f034d14801d0$var$logger.warn(err.message);
        return "";
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $0d15f034d14801d0$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $0d15f034d14801d0$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $0d15f034d14801d0$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $0d15f034d14801d0$var$createTrustedTypesPolicy("firebase-js-sdk-policy", {
        createScriptURL: $0d15f034d14801d0$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement("script");
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$0d15f034d14801d0$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $0d15f034d14801d0$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $0d15f034d14801d0$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $0d15f034d14801d0$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $0d15f034d14801d0$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $0d15f034d14801d0$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams["send_to"]) {
            let gaSendToList = gtagParams["send_to"];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $0d15f034d14801d0$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $0d15f034d14801d0$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $0d15f034d14801d0$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $0d15f034d14801d0$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $0d15f034d14801d0$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [gtagParams] = args;
                gtagCore("consent" /* GtagCommand.CONSENT */ , "update", gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $0d15f034d14801d0$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $0d15f034d14801d0$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === "function") // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $0d15f034d14801d0$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $0d15f034d14801d0$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName("script");
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($0d15f034d14801d0$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $0d15f034d14801d0$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $0d15f034d14801d0$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $0d15f034d14801d0$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $0d15f034d14801d0$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $0d15f034d14801d0$var$defaultRetryData = new $0d15f034d14801d0$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $0d15f034d14801d0$var$getHeaders(apiKey) {
    return new Headers({
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $0d15f034d14801d0$var$fetchDynamicConfig(appFields) {
    var _a;
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: "GET",
        headers: $0d15f034d14801d0$var$getHeaders(apiKey)
    };
    const appUrl = $0d15f034d14801d0$var$DYNAMIC_CONFIG_URL.replace("{app-id}", appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = "";
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $0d15f034d14801d0$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $0d15f034d14801d0$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $0d15f034d14801d0$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $0d15f034d14801d0$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $0d15f034d14801d0$var$FETCH_TIMEOUT_MILLIS);
    return $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $0d15f034d14801d0$var$defaultRetryData // for testing
) {
    var _a;
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $0d15f034d14801d0$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $0d15f034d14801d0$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $0d15f034d14801d0$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$0d15f034d14801d0$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $0d15f034d14801d0$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $gMVVg.calculateBackoffMillis)(backoffCount, retryData.intervalMillis, $0d15f034d14801d0$var$LONG_RETRY_FACTOR) : (0, $gMVVg.calculateBackoffMillis)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $0d15f034d14801d0$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $0d15f034d14801d0$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($0d15f034d14801d0$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $0d15f034d14801d0$var$isRetriableError(e) {
    if (!(e instanceof (0, $gMVVg.FirebaseError)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData["httpStatus"]);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $0d15f034d14801d0$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $0d15f034d14801d0$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $0d15f034d14801d0$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            "send_to": measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $0d15f034d14801d0$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            "screen_name": screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "screen_name": screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $0d15f034d14801d0$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            "user_id": id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "user_id": id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $0d15f034d14801d0$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "user_properties": properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $0d15f034d14801d0$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, "client_id", (clientId)=>{
            if (!clientId) reject($0d15f034d14801d0$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $0d15f034d14801d0$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $0d15f034d14801d0$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $0d15f034d14801d0$var$_setConsentDefaultForInit(consentSettings) {
    $0d15f034d14801d0$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $0d15f034d14801d0$var$_setDefaultEventParametersForInit(customParams) {
    $0d15f034d14801d0$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0d15f034d14801d0$var$validateIndexedDB() {
    if (!(0, $gMVVg.isIndexedDBAvailable)()) {
        $0d15f034d14801d0$var$logger.warn($0d15f034d14801d0$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: "IndexedDB is not available in this environment."
        }).message);
        return false;
    } else try {
        await (0, $gMVVg.validateIndexedDBOpenable)();
    } catch (e) {
        $0d15f034d14801d0$var$logger.warn($0d15f034d14801d0$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $0d15f034d14801d0$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = $0d15f034d14801d0$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $0d15f034d14801d0$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $0d15f034d14801d0$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$0d15f034d14801d0$var$findGtagScriptOnPage(dataLayerName)) $0d15f034d14801d0$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($0d15f034d14801d0$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , "default", $0d15f034d14801d0$var$defaultConsentSettingsForInit);
        $0d15f034d14801d0$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore("js", new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$0d15f034d14801d0$var$ORIGIN_KEY] = "firebase";
    configProperties.update = true;
    if (fid != null) configProperties[$0d15f034d14801d0$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($0d15f034d14801d0$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $0d15f034d14801d0$var$defaultEventParametersForInit);
        $0d15f034d14801d0$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $0d15f034d14801d0$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $0d15f034d14801d0$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $0d15f034d14801d0$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $0d15f034d14801d0$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $0d15f034d14801d0$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $0d15f034d14801d0$var$dataLayerName = "dataLayer";
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $0d15f034d14801d0$var$gtagName = "gtag";
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $0d15f034d14801d0$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $0d15f034d14801d0$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $0d15f034d14801d0$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $0d15f034d14801d0$export$a5a6e0b888b2c992(options) {
    if ($0d15f034d14801d0$var$globalInitDone) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $0d15f034d14801d0$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $0d15f034d14801d0$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $0d15f034d14801d0$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $gMVVg.isBrowserExtension)()) mismatchedEnvMessages.push("This is a browser extension environment.");
    if (!(0, $gMVVg.areCookiesEnabled)()) mismatchedEnvMessages.push("Cookies are not available.");
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(" ");
        const err = $0d15f034d14801d0$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $0d15f034d14801d0$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $0d15f034d14801d0$var$factory(app, installations, options) {
    $0d15f034d14801d0$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $0d15f034d14801d0$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($0d15f034d14801d0$var$initializationPromisesMap[appId] != null) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$0d15f034d14801d0$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $0d15f034d14801d0$var$getOrCreateDataLayer($0d15f034d14801d0$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $0d15f034d14801d0$var$wrapOrCreateGtag($0d15f034d14801d0$var$initializationPromisesMap, $0d15f034d14801d0$var$dynamicConfigPromisesList, $0d15f034d14801d0$var$measurementIdToAppId, $0d15f034d14801d0$var$dataLayerName, $0d15f034d14801d0$var$gtagName);
        $0d15f034d14801d0$var$wrappedGtagFunction = wrappedGtag;
        $0d15f034d14801d0$var$gtagCoreFunction = gtagCore;
        $0d15f034d14801d0$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $0d15f034d14801d0$var$initializationPromisesMap[appId] = $0d15f034d14801d0$var$_initializeAnalytics(app, $0d15f034d14801d0$var$dynamicConfigPromisesList, $0d15f034d14801d0$var$measurementIdToAppId, installations, $0d15f034d14801d0$var$gtagCoreFunction, $0d15f034d14801d0$var$dataLayerName, options);
    const analyticsInstance = new $0d15f034d14801d0$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $0d15f034d14801d0$export$b0297573c90085aa(app = (0, $7xvHX.getApp)()) {
    app = (0, $gMVVg.getModularInstance)(app);
    // Dependencies
    const analyticsProvider = (0, $7xvHX._getProvider)(app, $0d15f034d14801d0$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $0d15f034d14801d0$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $0d15f034d14801d0$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $7xvHX._getProvider)(app, $0d15f034d14801d0$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $gMVVg.deepEqual)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $0d15f034d14801d0$export$48c17662a6902497() {
    if ((0, $gMVVg.isBrowserExtension)()) return false;
    if (!(0, $gMVVg.areCookiesEnabled)()) return false;
    if (!(0, $gMVVg.isIndexedDBAvailable)()) return false;
    try {
        const isDBOpenable = await (0, $gMVVg.validateIndexedDBOpenable)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $0d15f034d14801d0$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    $0d15f034d14801d0$var$setCurrentScreen$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $0d15f034d14801d0$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    return $0d15f034d14801d0$var$internalGetGoogleAnalyticsClientId($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $0d15f034d14801d0$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    $0d15f034d14801d0$var$setUserId$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $0d15f034d14801d0$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    $0d15f034d14801d0$var$setUserProperties$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $0d15f034d14801d0$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    $0d15f034d14801d0$var$setAnalyticsCollectionEnabled$1($0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $0d15f034d14801d0$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($0d15f034d14801d0$var$wrappedGtagFunction) $0d15f034d14801d0$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $0d15f034d14801d0$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $0d15f034d14801d0$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    $0d15f034d14801d0$var$logEvent$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $0d15f034d14801d0$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($0d15f034d14801d0$var$wrappedGtagFunction) $0d15f034d14801d0$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , "update", consentSettings);
    else $0d15f034d14801d0$var$_setConsentDefaultForInit(consentSettings);
}
const $0d15f034d14801d0$var$name = "@firebase/analytics";
const $0d15f034d14801d0$var$version = "0.10.1";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ function $0d15f034d14801d0$var$registerAnalytics() {
    (0, $7xvHX._registerComponent)(new (0, $eryG9.Component)($0d15f034d14801d0$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider("app").getImmediate();
        const installations = container.getProvider("installations-internal").getImmediate();
        return $0d15f034d14801d0$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $7xvHX._registerComponent)(new (0, $eryG9.Component)("analytics-internal", internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $7xvHX.registerVersion)($0d15f034d14801d0$var$name, $0d15f034d14801d0$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $7xvHX.registerVersion)($0d15f034d14801d0$var$name, $0d15f034d14801d0$var$version, "esm2017");
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($0d15f034d14801d0$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$0d15f034d14801d0$export$5e9eec8001665ac5(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw $0d15f034d14801d0$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$0d15f034d14801d0$var$registerAnalytics();







let $067277e156f7a571$var$analytics;
let $067277e156f7a571$var$eventData = undefined;
function $067277e156f7a571$export$626fff8d65416420() {
    $067277e156f7a571$var$eventData = {};
    // inicializo content_type, content_id, crafts_reqs, num_cells, cached_cells y taxon
    $067277e156f7a571$var$eventData.content_type = "map";
    $067277e156f7a571$var$eventData.content_id = (0, $96abbdd7193a3c4b$export$4a32c72e9ff1d1e0)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc);
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon) $067277e156f7a571$var$eventData.taxon = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon;
    $067277e156f7a571$var$eventData.crafts_reqs = 0;
    $067277e156f7a571$var$eventData.num_cells = 0;
    $067277e156f7a571$var$eventData.cached_cells = 0;
    // timestamp in milliseconds
    $067277e156f7a571$var$eventData.init = Date.now();
}
function $067277e156f7a571$export$639f48199cd2287d(initData) {
    $067277e156f7a571$var$eventData = {};
    // inicializo lo que me pase
    for(const key in initData)$067277e156f7a571$var$eventData[key] = initData[key];
    // inicializo crafts_reqs
    $067277e156f7a571$var$eventData.crafts_reqs = 0;
    // timestamp in milliseconds
    $067277e156f7a571$var$eventData.init = Date.now();
}
// común a cualquier evento para incrementar crafts_reqs o lo que haga falta
function $067277e156f7a571$export$2db6ab9500fc86e(key, amount) {
    if ($067277e156f7a571$var$eventData != undefined) {
        if ($067277e156f7a571$var$eventData[key] != undefined) $067277e156f7a571$var$eventData[key] += amount;
    }
}
// común a eventos select_content de mapa y de contenidos medibles
function $067277e156f7a571$export$6adbd77fe07ba13(eventName) {
    if ($067277e156f7a571$var$eventData != undefined) {
        // timestamp de fin en milisegundos
        $067277e156f7a571$var$eventData.end = Date.now(); // timestamp in milliseconds 		
        // calculo latencia y elimino init y end
        $067277e156f7a571$var$eventData.latency_ms = $067277e156f7a571$var$eventData.end - $067277e156f7a571$var$eventData.init;
        delete $067277e156f7a571$var$eventData.end;
        delete $067277e156f7a571$var$eventData.init;
        // envío el evento (por defecto evento 'select_content')
        const en = eventName ? eventName : "select_content";
        $067277e156f7a571$export$7329bcdc3edcd90e(en, $067277e156f7a571$var$eventData);
    }
}
// caso especial para timeout del mapa
function $067277e156f7a571$export$cfc545666c0ce6d8() {
    if ($067277e156f7a571$var$eventData != undefined) {
        // cambio el content_type
        $067277e156f7a571$var$eventData.content_type = "map_timeout";
        // pongo por latencia el timeout y elimino init y end
        $067277e156f7a571$var$eventData.latency_ms = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout;
        delete $067277e156f7a571$var$eventData.end;
        delete $067277e156f7a571$var$eventData.init;
        // envío el evento
        $067277e156f7a571$export$7329bcdc3edcd90e("select_content", $067277e156f7a571$var$eventData);
    }
}
// mando evento
function $067277e156f7a571$export$7329bcdc3edcd90e(eventName, edata) {
    //console.log("- Enviando a GA evento de tipo " + eventName + " - Datos evento:")
    //console.log(eventData);
    if (!$067277e156f7a571$var$analytics) $067277e156f7a571$var$analytics = (0, $0d15f034d14801d0$export$b0297573c90085aa)((0, $c0304d280c7b00cb$export$54387eca9e368edc)());
    (0, $0d15f034d14801d0$export$5e9eec8001665ac5)($067277e156f7a571$var$analytics, eventName, edata);
}




/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");

var $8JYDX = parcelRequire("8JYDX");

var $2q7Wm = parcelRequire("2q7Wm");


// ICONOS
let $7b115b3c2cee4b53$var$iconos = {};
var $9f14872bebbe7c83$exports = {};
$9f14872bebbe7c83$exports = new URL("../marker-icon-2x-blue.67802419.png", import.meta.url).toString();


var $7aaaad4976c57f6c$exports = {};
$7aaaad4976c57f6c$exports = new URL("../marker-shadow.27763997.png", import.meta.url).toString();


var $0d4211d0d1717205$exports = {};
$0d4211d0d1717205$exports = new URL("../diana.26ceab4d.png", import.meta.url).toString();


function $7b115b3c2cee4b53$export$a207d0a28bdc4e1b() {
    // genero icono genérico de arbol
    $7b115b3c2cee4b53$var$iconos.arbol = {};
    $7b115b3c2cee4b53$var$iconos.arbol.edu = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeicon);
    $7b115b3c2cee4b53$var$iconos.arbol.ifn = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeicon + "_i");
    for (const cind of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).coltxinds){
        $7b115b3c2cee4b53$var$iconos.arbol[cind + "edu"] = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeicon + cind);
        $7b115b3c2cee4b53$var$iconos.arbol[cind + "ifn"] = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeicon + cind + "_i");
    }
    // genero iconos por familia
    for(const furi in (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons){
        // inicializo objeto
        $7b115b3c2cee4b53$var$iconos[furi] = {};
        // iconos educatree e ifn
        $7b115b3c2cee4b53$var$iconos[furi].edu = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons[furi]);
        $7b115b3c2cee4b53$var$iconos[furi].ifn = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons[furi] + "_i");
        // iconos de colores
        for (const cind of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).coltxinds){
            $7b115b3c2cee4b53$var$iconos[furi][cind + "edu"] = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons[furi] + cind);
            $7b115b3c2cee4b53$var$iconos[furi][cind + "ifn"] = $7b115b3c2cee4b53$var$generaIconoArbol((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons[furi] + cind + "_i");
        }
    }
    // genero icono de lugar
    // a partir de https://github.com/pointhi/leaflet-color-markers
    $7b115b3c2cee4b53$var$iconos.lugar = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Icon({
        iconUrl: new URL($9f14872bebbe7c83$exports),
        shadowUrl: new URL($7aaaad4976c57f6c$exports),
        iconSize: [
            25,
            41
        ],
        iconAnchor: [
            12,
            41
        ],
        popupAnchor: [
            1,
            -34
        ],
        shadowSize: [
            41,
            41
        ]
    });
    // genero icono de diana
    // a partir de https://icons.getbootstrap.com/icons/bullseye/
    $7b115b3c2cee4b53$var$iconos.diana = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Icon({
        iconUrl: new URL($0d4211d0d1717205$exports),
        iconSize: [
            40,
            40
        ],
        iconAnchor: [
            20,
            20
        ]
    });
    // inicializo iconos de especies
    $7b115b3c2cee4b53$var$iconos.especies = {};
}
var $1423d80935bc1d40$exports = {};
$1423d80935bc1d40$exports = new URL("../frondosa.e154cd66.png", import.meta.url).toString();


function $7b115b3c2cee4b53$var$generaIconoArbol(nfich) {
    // tengo que generar de forma muy rara la URL de la imagen por culpa de Parcel: https://github.com/parcel-bundler/parcel/issues/3056
    let urlarb = new URL($1423d80935bc1d40$exports); // url estática
    urlarb.pathname = nfich + ".png"; // y cambio aquí el pathname
    return (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).icon({
        iconUrl: urlarb,
        iconSize: [
            80,
            80
        ],
        iconAnchor: [
            40,
            76
        ],
        tooltipAnchor: [
            15,
            -35
        ],
        popupAnchor: [
            1,
            -55
        ]
    });
}
function $7b115b3c2cee4b53$export$b839616475ae6ec3() {
    return $7b115b3c2cee4b53$var$iconos.lugar;
}
function $7b115b3c2cee4b53$export$757419e715bb5039() {
    return $7b115b3c2cee4b53$var$iconos.diana;
}
function $7b115b3c2cee4b53$export$6274df672a45c12d(arb, conColor) {
    // lo primero es ver qué tipo de icono toca
    let icono = $7b115b3c2cee4b53$var$iconos.arbol; // valor por defecto
    const spuri = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
    if (spuri != undefined) {
        // si no está definido el icono de la especie, lo calculo
        if ($7b115b3c2cee4b53$var$iconos.especies[spuri] == undefined) {
            let icaux = $7b115b3c2cee4b53$var$iconos.arbol; // valor por defecto
            // analizamos las familias
            for(const furi in (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).familyicons)// compruebo si está incluido spuri en la lista de uris expandida de la familia
            if ((0, $2q7Wm.default).contains((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[furi].expuris, spuri)) icaux = $7b115b3c2cee4b53$var$iconos[furi]; // ¡es de la familia!
            // guardo para luego
            $7b115b3c2cee4b53$var$iconos.especies[spuri] = icaux;
        }
        // asigno el icono
        icono = $7b115b3c2cee4b53$var$iconos.especies[spuri];
    }
    // preparo sufijo para elegir el icono
    let suf = arb.iri != undefined ? "edu" : "ifn"; // educatree o ifn
    if (conColor || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon != undefined) suf = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txcolor + suf;
    // y devuelvo el icono
    return icono[suf];
}


let $27fe9e683b34e1a0$export$c37f872725571dfc, $27fe9e683b34e1a0$var$Minimapann, $27fe9e683b34e1a0$var$Minitilelayer;
async function $27fe9e683b34e1a0$export$c2e76fbffb5b7346() {
    // obtengo iri del árbol
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // pongo spinner con mensaje de cargando	
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html((0, $646ceeeec66fabd8$export$27eb5f8cf2bf64a7));
    window.scrollTo(0, 0);
    // inicializo el evento para enviar a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: "tree",
        content_id: iri,
        crafts_reqs: 0
    });
    // pido datos a CRAFTS del educatree
    await (0, $174d363c054274ef$export$92baecf29370dcf)(iri);
    //console.log(Datos.educatrees[iri]);
    // hago el render
    $27fe9e683b34e1a0$export$d096c03518bc83df();
}
async function $27fe9e683b34e1a0$export$d096c03518bc83df() {
    // obtengo iri del árbol
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // detecto llamada espúrea por la autenticación
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri]) return;
    // si no hay posición asumo que el educatree no existe...	
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position == undefined) {
        $27fe9e683b34e1a0$var$educatreeNoExiste();
        return;
    }
    // obtengo info del usuario
    const usiri = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid : null;
    const isMaster = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid].isMasterAnnotator;
    const cannotAnnotate = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid].cannotAnnotate;
    // 0) preparo objeto para el render del árbol
    let objet = {
        etid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid,
        title: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + " " + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid,
        nickButtonLabel: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeNick) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newNick),
        treeCreator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createdBy)),
        editable: !cannotAnnotate,
        removable: isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].creator === usiri),
        usuario: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario != undefined,
        usuarioImg: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL : null
    };
    // NOTA: permito siempre borrar al creador del árbol (aunque haya anotaciones de otros)
    // si hay nick reajusto título de la página
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick) document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick) + " - EducaWood";
    // position
    objet.position = {
        iri: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.iri,
        value: (0, $96abbdd7193a3c4b$export$1690e12b840569b9)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position),
        creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy))
    };
    // posiciones previas
    objet.formerPositions = [];
    const fpels = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
        "positionAnnotations"
    ]);
    for (const fpel of fpels)if (fpel.iri !== objet.position.iri) objet.formerPositions.push({
        iri: fpel.iri,
        value: (0, $96abbdd7193a3c4b$export$1690e12b840569b9)(fpel),
        creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(fpel, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
        created: fpel.created,
        removable: isMaster || fpel.creator && (fpel.creator.iri === usiri || fpel.creator === usiri)
    });
    objet.formerPositions = (0, $2q7Wm.default).sortBy(objet.formerPositions, function(obj) {
        return new Date(obj.created);
    }).reverse();
    objet.hasFormerPositions = objet.formerPositions.length > 0;
    // ajusto removable de position (especial porque no puede haber árbol sin posición)
    objet.position.removable = objet.hasFormerPositions && (isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.creator === usiri));
    // tree taxon
    if (objet.editable) objet.treeTaxon = {}; // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species) {
        objet.treeTaxon = {
            iri: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.iri,
            value: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species.iri,
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            removable: isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.creator === usiri)
        };
        /* TODO previo
		if (Datos.educatrees[iri].species.species.dbpedia)
			objet.treeTaxon.dbr = Datos.educatrees[iri].species.species.dbpedia;*/ // 2023-11 ahora detecto si hay datos de wikidata en las especies
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species.iri].wikidata) objet.treeTaxon.wikidata = true;
        // taxones previos
        objet.formerTaxa = [];
        const ftxels = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "speciesAnnotations"
        ]);
        for (const ftxel of ftxels)if (ftxel.iri !== objet.treeTaxon.iri) {
            let objtx = {
                iri: ftxel.iri,
                value: ftxel.species.iri,
                creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(ftxel, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
                created: ftxel.created,
                removable: isMaster || ftxel.creator && (ftxel.creator.iri === usiri || ftxel.creator === usiri)
            };
            /* TODO previo
				if (ftxel.species.dbpedia)
					objtx.dbr = ftxel.species.dbpedia;*/ // 2023-11 ahora detecto si hay datos de wikidata en las especies
            if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ftxel.species.iri].wikidata) objtx.wikidata = true;
            objet.formerTaxa.push(objtx);
        }
        objet.formerTaxa = (0, $2q7Wm.default).sortBy(objet.formerTaxa, function(obj) {
            return new Date(obj.created);
        }).reverse();
        objet.hasFormerTaxa = objet.formerTaxa.length > 0;
    }
    // tree status
    if (objet.editable) objet.treeStatus = {}; // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.treeStatus) {
        const ts = (0, $2q7Wm.default).find((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles, function(el) {
            return el.iri === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.treeStatus;
        });
        if (ts) objet.treeStatus = {
            iri: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.iri,
            value: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(ts.label),
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            removable: isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.creator === usiri)
        };
        // status previos
        objet.formerStatus = [];
        const ftsels = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "treeStatusAnnotations"
        ]);
        for (const ftsel of ftsels)if (ftsel.iri !== objet.treeStatus.iri) {
            const tsel = (0, $2q7Wm.default).find((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles, function(el) {
                return el.iri === ftsel.treeStatus;
            });
            if (tsel) objet.formerStatus.push({
                iri: ftsel.iri,
                value: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(tsel.label),
                creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(ftsel, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
                created: ftsel.created,
                removable: isMaster || ftsel.creator && (ftsel.creator.iri === usiri || ftsel.creator === usiri)
            });
        }
        objet.formerStatus = (0, $2q7Wm.default).sortBy(objet.formerStatus, function(obj) {
            return new Date(obj.created);
        }).reverse();
        objet.hasFormerStatus = objet.formerStatus.length > 0;
    }
    // photos
    if (objet.editable) objet.photoLabel = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).photo); // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].imageAnnotations) {
        objet.hasPhotos = true;
        objet.photoLabel = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).photo);
        objet.photos = [];
        const photos = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "imageAnnotations"
        ]);
        if (photos.length > 1) objet.photoLabel += "s"; // plural
        else objet.onePhoto = true; // para quitar congtroles de navegación
        for(let i = 0; i < photos.length; i++){
            let phobj = {};
            phobj.index = i;
            if (i == 0) phobj.first = true;
            phobj.iri = photos[i].iri;
            phobj.src = photos[i].image.imageURL;
            if (photos[i].image.plantPart && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[photos[i].image.plantPart]) phobj.plantPart = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[photos[i].image.plantPart].label);
            phobj.creator = (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(photos[i], (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy));
            phobj.removable = isMaster || photos[i].creator && (photos[i].creator.iri === usiri || photos[i].creator === usiri);
            objet.photos.push(phobj);
        }
    }
    // height
    if (objet.editable) objet.height = {}; // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.meters) {
        objet.height = {
            iri: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.iri,
            value: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.meters,
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            removable: isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.creator === usiri)
        };
        // alturas previas
        objet.formerHeights = [];
        const fhels = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "heightAnnotations"
        ]);
        for (const fhel of fhels)if (fhel.iri !== objet.height.iri) objet.formerHeights.push({
            iri: fhel.iri,
            value: fhel.meters,
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(fhel, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            created: fhel.created,
            removable: isMaster || fhel.creator && (fhel.creator.iri === usiri || fhel.creator === usiri)
        });
        objet.formerHeights = (0, $2q7Wm.default).sortBy(objet.formerHeights, function(obj) {
            return new Date(obj.created);
        }).reverse();
        objet.hasFormerHeight = objet.formerHeights.length > 0;
    }
    // diameter
    if (objet.editable) objet.diameter = {}; // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.millimeters) {
        objet.diameter = {
            iri: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.iri,
            value: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.millimeters,
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            removable: isMaster || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.creator && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.creator.iri === usiri || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.creator === usiri)
        };
        // diámetros previos
        objet.formerDiameters = [];
        const fdels = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "diameterAnnotations"
        ]);
        for (const fdel of fdels)if (fdel.iri !== objet.diameter.iri) objet.formerDiameters.push({
            iri: fdel.iri,
            value: fdel.millimeters,
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(fdel, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            created: fdel.created,
            removable: isMaster || fdel.creator && (fdel.creator.iri === usiri || fdel.creator === usiri)
        });
        objet.formerDiameters = (0, $2q7Wm.default).sortBy(objet.formerDiameters, function(obj) {
            return new Date(obj.created);
        }).reverse();
        objet.hasFormerDiameter = objet.formerDiameters.length > 0;
    }
    // observaciones	
    if (objet.editable) objet.observation = {}; // para mostrar la etiqueta y editar incluso si no hay valor
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations) {
        let obss = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
            "observations"
        ]);
        // elimino las observaciones sin texto o con menos de 3 caracteres
        obss = (0, $2q7Wm.default).filter(obss, function(obs) {
            return obs.text && (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(obs.text).length > 3;
        });
        obss = (0, $2q7Wm.default).sortBy(obss, function(obj) {
            return new Date(obj.created);
        }).reverse();
        // pongo observación primera
        objet.observation = {
            iri: obss[0].iri,
            value: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(obss[0].text),
            creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(obss[0], (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
            removable: isMaster || obss[0].creator && (obss[0].creator.iri === usiri || obss[0].creator === usiri)
        };
        // observaciones anteriores
        if (obss.length > 1) {
            objet.hasMoreObservations = true;
            objet.moreObservations = [];
            for(let i = 1; i < obss.length; i++)objet.moreObservations.push({
                iri: obss[i].iri,
                value: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(obss[i].text),
                creator: (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(obss[i], (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedBy)),
                removable: isMaster || obss[i].creator && (obss[i].creator.iri === usiri || obss[i].creator === usiri)
            });
        }
    }
    //console.log(objet);
    // 1) hago el rendering
    const htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$dd1b8137336daa0c), objet);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(htmlcontent);
    // envío GA evento ver página árbol
    (0, $067277e156f7a571$export$6adbd77fe07ba13)();
    console.info("P\xe1gina \xe1rbol cargada: " + iri);
    // listener goBack
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
    // listener borrarArbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteEducaTree").click($27fe9e683b34e1a0$var$handlerDeleteEducatree);
    // pongo listeners a clickViewprofile, clickSignin y clickSignout
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").click((0, $c0304d280c7b00cb$export$f98b6673fafc0e20));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignin").click((0, $c0304d280c7b00cb$export$9ffe63492d76c086));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").click((0, $c0304d280c7b00cb$export$daa0a882204fd973));
    // listener a cambiar el nick del árbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#changeTreeNick").click($27fe9e683b34e1a0$var$changeTreeNick);
    // listener ayuda treeStatusInfo
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botTreeStatusInfo").click((0, $3a9989d46007ef73$export$4ee351339f0443f3));
    // 2) ajustes taxón y fotos	
    // tree taxon => ajusto nomci, hago rendering del taxón y pongo handler del popver del taxón
    // ajusto nomci 
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#viewchecknomci").prop("checked", (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#viewchecknomci").change((0, $1ee989753a15371d$export$d67e2296dd6db17d));
    // llamo a visualizarTaxonFormulario para que haga el rendering del taxón (incluye el listener para mostrar popover)
    (0, $1ee989753a15371d$export$5dba38aff426bd77)();
    // photos => detecto cambios en el carrusel para mostrar la info de creación apropiada
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miCarrusel").on("slid.bs.carousel", function() {
        let indice = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).find(".carousel-item.active").index();
        // ajusto visibilidad creadores imágenes (con sus botones de borrado y edición, claro)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".photoCreator").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".photoCreator").filter('[index="' + indice + '"]').removeClass("d-none");
    });
    // 3) listeners de creación y borrado de anotaciones
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".create").click($27fe9e683b34e1a0$var$handlerNewAnnotation);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".delete").click($27fe9e683b34e1a0$var$handlerDeleteAnnotation);
    // 4) ajusto coordenadas y cargo mapa
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.latWGS84;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.lngWGS84;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.z = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMiniMapa;
    // preparo primero los bounds para que no se vaya a Cuenca
    const offset = 0.0004; // 1km es aproximadamente 0,008 grados en WGS84
    const bounds = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds((0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat - offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng - 3 * offset), (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat + offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng + 3 * offset)); //northEast	
    // meto tap: false, que parece es una fuente de problemas	
    $27fe9e683b34e1a0$export$c37f872725571dfc = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).map("mapaedutree", {
        maxBounds: bounds,
        maxBoundsViscosity: 1.0,
        zoomControl: false,
        tap: false,
        scrollWheelZoom: "center",
        preferCanvas: true
    }).setView([
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
    ], (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMiniMapa);
    // cargo el tile layer que corresponda
    const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(true);
    $27fe9e683b34e1a0$var$Minitilelayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).tileLayer(url, opts).addTo($27fe9e683b34e1a0$export$c37f872725571dfc);
    // muestro escala del mapa
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.scale({
        imperial: false,
        position: "bottomright"
    }).addTo($27fe9e683b34e1a0$export$c37f872725571dfc); // sin la escala imperial
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile) (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.zoom({
        position: "bottomright",
        zoomInTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomin),
        zoomOutTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomout)
    }).addTo($27fe9e683b34e1a0$export$c37f872725571dfc);
    // Disable dragging
    $27fe9e683b34e1a0$export$c37f872725571dfc.dragging.disable();
    // cargo botones esri y volverMapa
    (0, $c853be3628706c6e$export$a54a51eb35d48691)($27fe9e683b34e1a0$export$c37f872725571dfc, [
        $27fe9e683b34e1a0$export$c37f872725571dfc,
        (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee)
    ], [
        $27fe9e683b34e1a0$var$Minitilelayer,
        (0, $ffd94e1d81f19b1c$export$6573f87b6f05c3d2)
    ], true);
    // 5) pido ifntrees y edutrees del mapa y pinto
    await (0, $3a9989d46007ef73$export$d3be837b79c08382)($27fe9e683b34e1a0$export$c37f872725571dfc, bounds);
    // pongo color al educatree
    const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri];
    // obtengo icono con color
    const aicon = (0, $7b115b3c2cee4b53$export$6274df672a45c12d)(arb, true);
    // y se lo asigno
    if ($27fe9e683b34e1a0$export$c37f872725571dfc.arbsPintados[iri]) $27fe9e683b34e1a0$export$c37f872725571dfc.arbsPintados[iri].setIcon(aicon);
    //quito el overlay con el que escondía el mapa y habilito el dragging
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#overlay").addClass("d-none");
    $27fe9e683b34e1a0$export$c37f872725571dfc.dragging.enable();
}
///////////////////////
// CREACIÓN ANOTACIONES
function $27fe9e683b34e1a0$var$handlerNewAnnotation() {
    // recupero iri
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // inicialización modal
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true,
        nobody: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newAnnotation), null, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).crearAnotacion);
    // detecto el tipo de anotación y cargo el body correspondiente
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("position")) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).position, null);
        // pinto posición
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputPositionAnn").val((0, $96abbdd7193a3c4b$export$1690e12b840569b9)({
            latWGS84: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
            lngWGS84: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
        }));
        // espero a que el modal se haya mostrado
        document.getElementById("mimodal").addEventListener("shown.bs.modal", async function() {
            // preparo primero los bounds para que no se vaya a Cuenca
            const offset = 0.0004; // 1km es aproximadamente 0,008 grados en WGS84
            const bounds = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds((0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat - offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng - 2.5 * offset), (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat + offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng + 2.5 * offset)); //northEast	
            // meto tap: false, que parece es una fuente de problemas
            // meto scrollWheelZoom: 'center' para que no dé saltos raros la diana al cambiar el zoom
            $27fe9e683b34e1a0$var$Minimapann = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).map("mapaAnn", {
                maxBounds: bounds,
                maxBoundsViscosity: 1.0,
                zoomControl: false,
                tap: false,
                scrollWheelZoom: "center",
                preferCanvas: true
            }).setView([
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
            ], (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMiniMapa);
            // cargo el tile layer que corresponda
            const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(true);
            const minianntl = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).tileLayer(url, opts).addTo($27fe9e683b34e1a0$var$Minimapann);
            // muestro escala del mapa
            (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.scale({
                imperial: false,
                position: "bottomright"
            }).addTo($27fe9e683b34e1a0$var$Minimapann); // sin la escala imperial
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile) (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.zoom({
                position: "bottomright",
                zoomInTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomin),
                zoomOutTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomout)
            }).addTo($27fe9e683b34e1a0$var$Minimapann);
            // Disable dragging
            $27fe9e683b34e1a0$var$Minimapann.dragging.disable();
            // cargo botón esri
            (0, $c853be3628706c6e$export$a54a51eb35d48691)($27fe9e683b34e1a0$var$Minimapann, [
                $27fe9e683b34e1a0$var$Minimapann,
                $27fe9e683b34e1a0$export$c37f872725571dfc,
                (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee)
            ], [
                minianntl,
                $27fe9e683b34e1a0$var$Minitilelayer,
                (0, $ffd94e1d81f19b1c$export$6573f87b6f05c3d2)
            ]);
            // 3) pido ifntrees y edutrees del mapa y pinto
            await (0, $3a9989d46007ef73$export$d3be837b79c08382)($27fe9e683b34e1a0$var$Minimapann, bounds);
            // 4) al acabar hago múltiples ajustes
            // quito el icono del árbol
            $27fe9e683b34e1a0$var$Minimapann.removeLayer($27fe9e683b34e1a0$var$Minimapann.arbsPintados[iri]);
            // quito el overlay con el que escondía el mapa, pongo la pista y habilito el dragging
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#overlayAnn").addClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mapclueAnn").removeClass("d-none");
            $27fe9e683b34e1a0$var$Minimapann.dragging.enable();
            // 5) pinto marcador de diana
            const diana = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).marker([
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
            ], {
                icon: (0, $7b115b3c2cee4b53$export$757419e715bb5039)(),
                zIndexOffset: 100
            }).addTo($27fe9e683b34e1a0$var$Minimapann);
            // 6) detecto eventos "move" y ajusto la diana	
            $27fe9e683b34e1a0$var$Minimapann.on("move", function(event) {
                const center = $27fe9e683b34e1a0$var$Minimapann.getCenter(); // Get the new center position of the map
                diana.setLatLng(center); // Set the marker position to the new center
            });
            // como hay muchos eventos 'move', actualizo cosas sólo con 'moveend'
            $27fe9e683b34e1a0$var$Minimapann.on("moveend", function(event) {
                const center = $27fe9e683b34e1a0$var$Minimapann.getCenter(); // Get the new center position of the map
                diana.setLatLng(center); // Set the marker position to the new center
                // ajusto texto
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputPositionAnn").val((0, $96abbdd7193a3c4b$export$1690e12b840569b9)({
                    latWGS84: center.lat,
                    lngWGS84: center.lng
                }));
                // detecto si hay cambio respecto a lo anterior
                if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.latWGS84.toFixed(6) === center.lat.toFixed(6) && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].position.lngWGS84.toFixed(6) === center.lng.toFixed(6)) {
                    // console.log("Misma posición que antes (!)");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
                } else {
                    //console.log("Todo OK");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
                }
            });
        }, {
            once: true
        }); // para que sólo se ejecute una vez
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("treeTaxon")) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).treeTaxon, null);
        // ajusto nomci 
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#anchecknomci").prop("checked", (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#anchecknomci").change((0, $1ee989753a15371d$export$d67e2296dd6db17d));
        // listeners taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").click((0, $1ee989753a15371d$export$2d3916a1f0ae58c1));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreeTaxon").click((0, $1ee989753a15371d$export$e644c8daeec4ef49));
        // detecto cambio en treeTaxon
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").change(function() {
            const ttiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").attr("iri");
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (!ttiri) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species && ttiri === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species.iri) //console.log("Misma iri que antes (!)");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
            else {
                //console.log("Todo OK");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
            }
        });
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("treeStatus")) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).treeStatus, null);
        // cargo tipos de estado del árbol en #selectTreeStatus
        let testarb = [];
        for (const el of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles)testarb.push({
            "iri": el.iri,
            "label": (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(el.label),
            "pref": el.pref
        });
        const htmltest = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$170c21d6f8f459cf), testarb);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreeStatus").html(htmltest);
        // detecto cambio en selectTreeStatus	
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreeStatus").change(function() {
            const tstiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreeStatus").val();
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (!tstiri) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.treeStatus && tstiri === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus.treeStatus) //console.log("Misma iri que antes (!)");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
            else {
                //console.log("Todo OK");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
            }
        });
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("photo")) {
        // preparo el anotador
        const oa = {
            esMovil: (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile,
            camera: localStorage.getItem("camera") === "false" ? false : true // por defecto true
        };
        const htmlann = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$43bbd40c30a74965).photo, oa);
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, htmlann, null);
        // listener de la foto => compresión en #resizedTreePhoto y muestro thumbnail
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treePhoto").change((0, $3a9989d46007ef73$export$3a52a69d9f94a42b)); // más actualización estado anotación
        // listener borrar foto (antes de subir a Firebase)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreePhoto").click((0, $3a9989d46007ef73$export$e7db0c08a7276967));
        // cargo partes de árboles fotos en #selectTreePartPhoto
        let parbfotos = [];
        for(const paf in (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto)parbfotos.push({
            "uri": paf,
            "label": (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[paf].label)
        });
        const htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$afb205d6a878a5e7), parbfotos);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreePartPhoto").html(htmlcontent);
        // cambio de modo a cámara (sólo valdrá para móvil)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkCamera").change((0, $3a9989d46007ef73$export$cd64dd1ec39c266d));
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("height")) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).height, null);
        // listener de cambio de altura
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeHeight").change(function() {
            const alt = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeHeight").val());
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (!alt) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else if (alt < 0 || alt > 150) //console.log("Fuera de rango");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).outOfRangeAnnotation));
            else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.meters && alt === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height.meters) //console.log("Misma altura que antes (!)");				
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
            else {
                //console.log("Todo OK");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
            }
        });
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("diameter")) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).diameter, null);
        // listener de medida de perímetro
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").change((0, $3a9989d46007ef73$export$1db9de3e81675e92));
        // listener de cambio de perímetro		
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").change(function() {
            let diam = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").val());
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (!diam) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else {
                // reajuste por el modo perímetro
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").prop("checked")) diam = Number((diam / Math.PI).toFixed(0));
                if (diam < 0 || diam > 20000) //console.log("Fuera de rango");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).outOfRangeAnnotation));
                else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.millimeters && diam === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter.millimeters) //console.log("Mismo diámetro que antes (!)");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
                else {
                    //console.log("Todo OK");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
                }
            }
        });
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("observation")) {
        // pongo body adecuado en el modal
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, null, (0, $646ceeeec66fabd8$export$43bbd40c30a74965).observation, null);
        // listener de cambio de altura
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#observation").on("input", function() {
            const obs = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#observation").val();
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (obs.length == 0) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else if (obs.length < 5) //console.log("Fuera de rango");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomethingmore));
            else {
                //console.log("Todo OK");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
            }
        });
    } else return; // no debería llegar aquí, pero por si acaso
    // muestro el modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    // handler al botón de procesar anotación
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").click($27fe9e683b34e1a0$export$a8fce3b21dbb0466);
}
var $795f01c4ed991fa9$exports = {};
$795f01c4ed991fa9$exports = new URL("../treeAnnotation.a013dcdd.png", import.meta.url).toString();


async function $27fe9e683b34e1a0$export$a8fce3b21dbb0466() {
    // recupero iri del árbol
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // constantes de anotación
    const annid = (0, $96abbdd7193a3c4b$export$567fc7097e064344)(12);
    const ahora = new Date().toISOString();
    const creador = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid;
    // inicializo tipo de anotación y anniri para el evento a GA
    let tipoann = null;
    let anniri = null;
    // preparo clones
    const tobjclon = JSON.parse(JSON.stringify((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri]));
    const bobjclon = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] ? JSON.parse(JSON.stringify((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri])) : null; // puede no existir	
    // inicializo patch
    const patch = [];
    // detecto tipo de anotación
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mapaAnn").length) {
        tipoann = "position_annotation";
        //console.log("Anotación de posición");		
        const center = $27fe9e683b34e1a0$var$Minimapann.getCenter();
        const posann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/posann/" + annid,
            creator: creador,
            created: ahora,
            latWGS84: center.lat,
            lngWGS84: center.lng,
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/PositionAnnotation"
        };
        anniri = posann.iri;
        // preparo patch con la nueva anotación de posición	
        patch.push({
            op: "replace",
            path: "/position",
            value: posann
        });
        // preparo el path adecuado en el array de posiciones 
        // (debería existir Datos.educatrees[iri].positionAnnotations, pero por si acaso)
        const pospath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].positionAnnotations ? "/positionAnnotations/-" : "/positionAnnotations";
        patch.push({
            op: "add",
            path: pospath,
            value: posann.iri
        });
        // reajusto clones
        tobjclon.position = posann;
        tobjclon.positionAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].positionAnnotations ? posann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].positionAnnotations) ? [
            posann,
            ...tobjclon.positionAnnotations
        ] : [
            posann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].positionAnnotations
        ];
        if (bobjclon) {
            bobjclon.lat = center.lat;
            bobjclon.lng = center.lng;
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").length) {
        tipoann = "taxon_annotation";
        //console.log("Anotación de taxón");
        const ttiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").attr("iri");
        const ttann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/spann/" + annid,
            creator: creador,
            created: ahora,
            species: ttiri,
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/SpeciesAnnotation"
        };
        anniri = ttann.iri;
        // preparo patch con la nueva anotación de taxón
        const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species ? "replace" : "add";
        patch.push({
            op: oper,
            path: "/species",
            value: ttann
        });
        // preparo el path adecuado en el array de taxones
        const ttpath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].speciesAnnotations ? "/speciesAnnotations/-" : "/speciesAnnotations";
        patch.push({
            op: "add",
            path: ttpath,
            value: ttann.iri
        });
        // reajusto clones (aquí más complejo para incorporar la info de especie)
        const ttannclon = JSON.parse(JSON.stringify(ttann));
        ttannclon.species = {
            iri: ttiri,
            scientificName: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ttiri].scientificName,
            vulgarName: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ttiri].vulgarName,
            dbpedia: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ttiri].dbpedia,
            wikipediaPage: (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ttiri].wikipediaPage
        };
        tobjclon.species = ttannclon;
        tobjclon.speciesAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].speciesAnnotations ? ttannclon : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].speciesAnnotations) ? [
            ttannclon,
            ...tobjclon.speciesAnnotations
        ] : [
            ttannclon,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].speciesAnnotations
        ];
        if (bobjclon) bobjclon.species = ttiri;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreeStatus").length) {
        tipoann = "status_annotation";
        //console.log("Anotación de estado de árbol");
        const tstiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreeStatus").val();
        const tstann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/treestann/" + annid,
            creator: creador,
            created: ahora,
            treeStatus: tstiri
        };
        anniri = tstann.iri;
        // preparo patch con la nueva anotación de tree status
        const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatus ? "replace" : "add";
        patch.push({
            op: oper,
            path: "/treeStatus",
            value: tstann
        });
        // preparo el path adecuado en el array de taxones
        const tstpath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatusAnnotations ? "/treeStatusAnnotations/-" : "/treeStatusAnnotations";
        patch.push({
            op: "add",
            path: tstpath,
            value: tstann.iri
        });
        // reajusto clones
        tobjclon.treeStatus = tstann;
        tobjclon.treeStatusAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatusAnnotations ? tstann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatusAnnotations) ? [
            tstann,
            ...tobjclon.treeStatusAnnotations
        ] : [
            tstann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].treeStatusAnnotations
        ];
        if (bobjclon) bobjclon.treeStatus = tstiri;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treePhoto").length) {
        tipoann = "photo_annotation";
        //console.log("Anotación de foto");			
        // guardo primero en Firebase
        const imgDataUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#resizedTreePhoto").val();
        let imgFirebasePath = "images/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid + "/" + annid + ".png";
        let imgDownloadURL = null;
        // Get a reference to the storage service, which is used to create references in your storage bucket		
        const storage = (0, $df9a6d7fd06616c9$export$fbd9b57a66480737)((0, $c0304d280c7b00cb$export$54387eca9e368edc)());
        // Create a storage reference from our storage service
        //const storageRef = storage.ref();
        // preparo referencia a imagen para guardar
        const imgRef = (0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)(storage, imgFirebasePath);
        // recupero el tree part para que no se borre con el spinner
        const tppiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreePartPhoto").val();
        // pongo spinner (porque aquí hay que esperar y en el resto de casos no)
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true,
            spinner: true,
            spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).pleasewait),
            nofooter: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).creatingannotation), null, null);
        // guardo foto del árbol
        try {
            const snapshot = await (0, $df9a6d7fd06616c9$export$d885b2eb178808b3)(imgRef, imgDataUrl, "data_url");
            imgDownloadURL = await (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(snapshot.ref);
            // mando evento de creación de foto en firebase a GA
            (0, $067277e156f7a571$export$7329bcdc3edcd90e)("create_content", {
                content_type: "photo",
                content_id: imgDownloadURL,
                uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid
            });
            console.info("Foto subida a Firebase: " + imgDownloadURL);
        } catch (error) {
            console.error("Error: " + error.message);
            const be = "<code>" + error + "</code>";
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).uploadingphotoerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
            return; // terminamos
        }
        // ahora voy con la anotación
        const fotann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/imgann/" + annid,
            creator: creador,
            created: ahora,
            image: {
                iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/img/" + annid,
                imageURL: imgDownloadURL,
                firebasePath: imgFirebasePath,
                types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/Image"
            },
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/ImageAnnotation"
        };
        anniri = fotann.iri;
        // si ha seleccionado el tipo de foto...
        if (tppiri !== "") fotann.image.plantPart = tppiri;
        // preparo el path adecuado en el array de fotos
        const fotpath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].imageAnnotations ? "/imageAnnotations/-" : "/imageAnnotations";
        patch.push({
            op: "add",
            path: fotpath,
            value: fotann
        });
        // reajusto clones
        tobjclon.imageAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].imageAnnotations ? fotann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].imageAnnotations) ? [
            fotann,
            ...tobjclon.imageAnnotations
        ] : [
            fotann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].imageAnnotations
        ];
        if (bobjclon) bobjclon.images = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].images ? imgDownloadURL : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].images) ? [
            imgDownloadURL,
            ...bobjclon.images
        ] : [
            imgDownloadURL,
            bobjclon.images
        ];
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeHeight").length) {
        tipoann = "height_annotation";
        //console.log("Anotación de altura");
        const alt = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeHeight").val());
        const altann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/heightann/" + annid,
            creator: creador,
            created: ahora,
            meters: alt,
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/HeightAnnotation"
        };
        anniri = altann.iri;
        // preparo patch con la nueva anotación de altura
        const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].height ? "replace" : "add";
        patch.push({
            op: oper,
            path: "/height",
            value: altann
        });
        // preparo el path adecuado en el array de taxones
        const altpath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].heightAnnotations ? "/heightAnnotations/-" : "/heightAnnotations";
        patch.push({
            op: "add",
            path: altpath,
            value: altann.iri
        });
        // reajusto clones
        tobjclon.height = altann;
        tobjclon.heightAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].heightAnnotations ? altann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].heightAnnotations) ? [
            altann,
            ...tobjclon.heightAnnotations
        ] : [
            altann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].heightAnnotations
        ];
        if (bobjclon) bobjclon.height = alt;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").length) {
        tipoann = "diameter_annotation";
        //console.log("Anotación de diámetro");
        let diam = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").val());
        // reajuste por el modo perímetro
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").prop("checked")) diam = Number((diam / Math.PI).toFixed(0));
        const diann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/diamann/" + annid,
            creator: creador,
            created: ahora,
            millimeters: diam,
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/DiameterAnnotation"
        };
        anniri = diann.iri;
        // preparo patch con la nueva anotación de diámetro
        const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameter ? "replace" : "add";
        patch.push({
            op: oper,
            path: "/diameter",
            value: diann
        });
        // preparo el path adecuado en el array de diámetros
        const dipath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameterAnnotations ? "/diameterAnnotations/-" : "/diameterAnnotations";
        patch.push({
            op: "add",
            path: dipath,
            value: diann.iri
        });
        // reajusto clones
        tobjclon.diameter = diann;
        tobjclon.diameterAnnotations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameterAnnotations ? diann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameterAnnotations) ? [
            diann,
            ...tobjclon.diameterAnnotations
        ] : [
            diann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].diameterAnnotations
        ];
        if (bobjclon) bobjclon.dbh = diam;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#observation").length) {
        tipoann = "observation_annotation";
        //console.log("Anotación de altura");
        const obs = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#observation").val();
        const obsann = {
            iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/observann/" + annid,
            creator: creador,
            created: ahora,
            text: {
                [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: obs
            },
            types: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/ObservationAnnotation"
        };
        anniri = obsann.iri;
        // preparo el path adecuado en el array de observaciones
        const obspath = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations ? "/observations/-" : "/observations";
        patch.push({
            op: "add",
            path: obspath,
            value: obsann
        });
        // reajusto clones
        tobjclon.observations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations ? obsann : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations) ? [
            obsann,
            ...tobjclon.observations
        ] : [
            obsann,
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations
        ];
        if (bobjclon) bobjclon.observations = !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations ? {
            [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: obs
        } : Array.isArray((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].observations) ? [
            {
                [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: obs
            },
            ...bobjclon.observations
        ] : [
            {
                [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: obs
            },
            bobjclon.observations
        ];
    } else return; // no debería llegar aquí, pero por si acaso
    //console.log(patch);
    // inicializo evento de creación de anotación a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: tipoann,
        content_id: anniri,
        tree_id: iri,
        uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
        crafts_reqs: 0
    });
    // hago la llamada para procesar el patch
    try {
        // pongo spinner (porque aquí hay que esperar y en el resto de casos no)
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true,
            spinner: true,
            spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).pleasewait),
            nofooter: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).creatingannotation), null, null);
        await (0, $174d363c054274ef$export$f78fa04d07774c6b)(iri, patch, tobjclon, bobjclon);
        // envío datos creación de anotación a GA
        (0, $067277e156f7a571$export$6adbd77fe07ba13)("create_content");
        console.info("Anotaci\xf3n creada con IRI: " + anniri); // log
    } catch (err) {
        console.error(err.message);
        // actualizo modal
        const be = "<code>" + err.message + "<br>" + JSON.stringify(err.error) + "</code>";
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeannotationerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
        return; // terminamos
    }
    // ajustes finales footer
    // /app/images/treeAnnotation.png
    const htmlbody = '<img id="imgTreeAnnotation" src="" class="d-block w-100">';
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeannotationsuccess), htmlbody, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionExito);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeAnnotation").attr("src", new URL($795f01c4ed991fa9$exports));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botAnotacionExito").click($27fe9e683b34e1a0$export$d096c03518bc83df);
}
var $0c87ecbfdd68bccf$exports = {};
$0c87ecbfdd68bccf$exports = new URL("../treeAnnotationRemoval.2300bcbb.png", import.meta.url).toString();


///////////////////////
// BORRADO ANOTACIONES
function $27fe9e683b34e1a0$var$handlerDeleteAnnotation() {
    // recupero iri del árbol
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    const edutree = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri];
    // recupero iri de la anotación
    const anniri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("iri");
    //console.log(anniri);
    if (!anniri) return; // no debería llegar aquí, pero por si acaso
    // inicializo tipo de anotación para el evento a GA
    let tipoann = null;
    // preparo clones
    const tobjclon = JSON.parse(JSON.stringify(edutree));
    const bobjclon = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] ? JSON.parse(JSON.stringify((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri])) : null; // puede no existir	
    // inicializo patch
    const patch = [];
    // inicializo objetos a borrar para el dataManager 
    // (siempre 1, salvo en el caso de la foto en la que son 2)
    const objsborrar = [];
    // inicializo path de firebase a borrar para el caso de una imagen
    let pathFirebaseBorrar = null;
    // preparo patch y ajusto clones por tipo de anotación a borrar
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("position")) {
        tipoann = "position_annotation";
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: "PositionAnnotation"
        });
        // llamada para preparar patch y ajustar tobjclon
        $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, "position", "positionAnnotations", anniri, patch, tobjclon);
        // reajuste clon básico
        if (bobjclon) {
            if (tobjclon.position) {
                bobjclon.lat = tobjclon.position.latWGS84;
                bobjclon.lng = tobjclon.position.lngWGS84;
            } else {
                delete bobjclon.lat;
                delete bobjclon.lng;
            }
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("treeTaxon")) {
        tipoann = "taxon_annotation";
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: "SpeciesAnnotation"
        });
        // llamada para preparar patch y ajustar tobjclon
        $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, "species", "speciesAnnotations", anniri, patch, tobjclon);
        // reajuste clon básico
        if (bobjclon) {
            if (tobjclon.species) bobjclon.species = tobjclon.species.species.iri;
            else delete bobjclon.species;
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("treeStatus")) {
        tipoann = "status_annotation";
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: "TreeStatusAnnotation"
        });
        // llamada para preparar patch y ajustar tobjclon
        $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, "treeStatus", "treeStatusAnnotations", anniri, patch, tobjclon);
        // reajuste clon básico
        if (bobjclon) {
            if (tobjclon.treeStatus) bobjclon.treeStatus = tobjclon.treeStatus.treeStatus;
            else delete bobjclon.treeStatus;
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("photo")) {
        tipoann = "photo_annotation";
        // caso especial
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: "ImageAnnotation"
        });
        // analizo anotaciones
        if (edutree.imageAnnotations) {
            let imageURL = null; // localizo para borrar en bobjclon
            // si es un array...
            if (Array.isArray(edutree.imageAnnotations)) {
                // localizo índice anotación
                const indice = (0, $2q7Wm.default).findIndex(edutree.imageAnnotations, {
                    iri: anniri
                });
                if (indice != -1) {
                    // marco para borrar
                    patch.push({
                        op: "remove",
                        path: "/imageAnnotations/" + indice
                    });
                    // localizo también la imagen a borrar
                    if (edutree.imageAnnotations[indice].image) {
                        objsborrar.push({
                            iri: edutree.imageAnnotations[indice].image.iri,
                            id: "Image"
                        });
                        imageURL = edutree.imageAnnotations[indice].image.imageURL;
                        // extraigo pathFirebaseBorrar
                        if (edutree.imageAnnotations[indice].image.firebasePath) pathFirebaseBorrar = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(edutree.imageAnnotations[indice].image.firebasePath);
                    }
                    // borro del clon
                    tobjclon.imageAnnotations.splice(indice, 1);
                }
            } else if (edutree.imageAnnotations.iri === anniri) {
                // marco para borrar
                patch.push({
                    op: "remove",
                    path: "/imageAnnotations"
                });
                // localizo también la imagen a borrar
                if (edutree.imageAnnotations.image) {
                    objsborrar.push({
                        iri: edutree.imageAnnotations.image.iri,
                        id: "Image"
                    });
                    imageURL = edutree.imageAnnotations.image.imageURL;
                    // extraigo pathFirebaseBorrar
                    if (edutree.imageAnnotations.image.firebasePath) pathFirebaseBorrar = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(edutree.imageAnnotations.image.firebasePath);
                }
                // borro del clon
                delete tobjclon.imageAnnotations;
            }
            // reajuste clon básico
            if (imageURL && bobjclon && bobjclon.images) {
                // si es un array...
                if (Array.isArray(bobjclon.images)) bobjclon.images = (0, $2q7Wm.default).without(bobjclon.images, imageURL);
                else if (bobjclon.images === imageURL) delete bobjclon.images;
            }
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("height")) {
        tipoann = "height_annotation";
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: "HeightAnnotation"
        });
        // llamada para preparar patch y ajustar tobjclon
        $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, "height", "heightAnnotations", anniri, patch, tobjclon);
        // reajuste clon básico
        if (bobjclon) {
            if (tobjclon.height) bobjclon.height = tobjclon.height.meters;
            else delete bobjclon.height;
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("diameter")) {
        tipoann = "diameter_annotation";
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: "DiameterAnnotation"
        });
        // llamada para preparar patch y ajustar tobjclon
        $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, "diameter", "diameterAnnotations", anniri, patch, tobjclon);
        // reajuste clon básico
        if (bobjclon) {
            if (tobjclon.diameter) bobjclon.dbh = tobjclon.diameter.millimeters;
            else delete bobjclon.dbh;
        }
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("observation")) {
        tipoann = "observation_annotation";
        // incluyo la anotación a borrar
        objsborrar.push({
            iri: anniri,
            id: "ObservationAnnotation"
        });
        // analizo anotaciones
        if (edutree.observations) {
            // si es un array...
            if (Array.isArray(edutree.observations)) {
                // localizo índice anotación
                const indice = (0, $2q7Wm.default).findIndex(edutree.observations, {
                    iri: anniri
                });
                if (indice != -1) {
                    // marco para borrar
                    patch.push({
                        op: "remove",
                        path: "/observations/" + indice
                    });
                    // borro del clon
                    tobjclon.observations.splice(indice, 1);
                    // compruebo si hay que borrar el array del clon por estar vacío
                    if (tobjclon.observations.length == 0) delete tobjclon.observations;
                }
            } else if (edutree.observations.iri === anniri) {
                // marco para borrar
                patch.push({
                    op: "remove",
                    path: "/observations"
                });
                // borro del clon
                delete tobjclon.observations;
            }
        }
        // reajuste clon básico
        if (bobjclon) {
            delete bobjclon.observations;
            // genero a partir de las observaciones de tobjclon
            if (tobjclon.observations) {
                bobjclon.observations = [];
                for (let obs of tobjclon.observations)bobjclon.observations.push(obs.text);
            }
        }
    } else return; // no debería llegar aquí, pero por si acaso
    // inicialización modal con petición de confirmación
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteAnnotation), (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteAnnotationInfo), (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).confirmarBorradoAnotacion);
    // muestro el modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    // handler de borrado de anotación
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonBorradoAnotacion").click(async function() {
        //console.log("Borrando anotación " +anniri+ " del árbol " + iri);		
        //console.log(patch);
        // inicializo evento de borrado de anotación a GA
        (0, $067277e156f7a571$export$639f48199cd2287d)({
            content_type: tipoann,
            content_id: anniri,
            tree_id: iri,
            uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
            crafts_reqs: 0
        });
        // hago la llamada para borrar la anotación
        try {
            // pongo spinner (porque aquí hay que esperar y en el resto de casos no)
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true,
                spinner: true,
                spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).pleasewait),
                nofooter: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deletingAnnotation), null, null);
            await (0, $174d363c054274ef$export$e2dbe74809c0905f)(iri, patch, objsborrar, tobjclon, bobjclon);
            // envío datos borrado de anotación a GA
            (0, $067277e156f7a571$export$6adbd77fe07ba13)("delete_content");
            console.info("Anotaci\xf3n borrada con IRI: " + anniri); // log
        } catch (err) {
            console.error(err.message);
            // actualizo modal
            const be = "<code>" + err.message + "\n" + JSON.stringify(err.error) + "</code>";
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeannotationerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
            return; // terminamos
        }
        // si hay que borrar la imagen en Firebase...
        if (pathFirebaseBorrar) {
            const storage = (0, $df9a6d7fd06616c9$export$fbd9b57a66480737)((0, $c0304d280c7b00cb$export$54387eca9e368edc)());
            // Create a storage reference from our storage service
            //const storageRef = storage.ref();
            // ref a la imagen
            const imgRef = (0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)(storage, pathFirebaseBorrar);
            // borro foto del árbol
            try {
                // compruebo primero que exista
                const imgDownloadURL = await (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(imgRef);
                //console.log('File exists at: ' + imgDownloadURL);
                // ahora borro
                // cuidado con las reglas de seguridad de Firebase storage
                // para el borrado simplemente pongo que sea un usuario autenticado
                // para permitir así que un usuario de tipo máster pueda borrar fotos
                // creadas por otros usuarios
                await (0, $df9a6d7fd06616c9$export$39c5ed4ec960eade)(imgRef);
                // mando evento de borrado de foto en firebase a GA
                (0, $067277e156f7a571$export$7329bcdc3edcd90e)("delete_content", {
                    content_type: "photo",
                    content_id: imgDownloadURL,
                    uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid
                });
                console.info("Foto borrada de Firebase: " + imgDownloadURL);
            } catch (error) {
                if (error.code === "storage/object-not-found") console.error("File does not exist.");
                else {
                    console.error("Error: " + error.message);
                    // ajustes finales modal
                    const be = "<code>" + error + "</code>";
                    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                        static: true,
                        vertcent: true
                    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deletingphotoerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionExito);
                    // pongo el footer de anotación de éxito porque así ha sido, sólo ha fallado el borrado de la foto						
                    return; // terminamos
                }
            }
        }
        // ajustes finales footer
        // /app/images/treeAnnotationRemoval.png
        const htmlbody = '<img id="imgTreeAnnotationRemoval" src="" class="d-block w-100">';
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteAnnotationSuccess), htmlbody, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionExito);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeAnnotationRemoval").attr("src", new URL($0c87ecbfdd68bccf$exports));
        // y al cerrar renderizamos de nuevo...
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botAnotacionExito").click($27fe9e683b34e1a0$export$d096c03518bc83df);
    });
}
function $27fe9e683b34e1a0$var$ajustarPatchClonBorradoAnotacion(edutree, annprim, anotaciones, anniri, patch, tobjclon) {
    // preinicializo posición de reemplazo 
    let reemplazo = null;
    // analizo anotaciones
    if (edutree[anotaciones]) {
        // si es un array...
        if (Array.isArray(edutree[anotaciones])) {
            // localizo índice anotación
            const indice = (0, $2q7Wm.default).findIndex(edutree[anotaciones], {
                iri: anniri
            });
            if (indice != -1) {
                // marco para borrar
                patch.push({
                    op: "remove",
                    path: "/" + anotaciones + "/" + indice
                });
                // borro del clon
                tobjclon[anotaciones].splice(indice, 1);
            }
            // obtengo reemplazo (si lo hay)
            if (tobjclon[anotaciones].length > 0) reemplazo = (0, $2q7Wm.default).sortBy(tobjclon[anotaciones], function(obj) {
                return new Date(obj.created);
            }).reverse()[0];
            // compruebo si hay que borrar el array del clon por estar vacío
            // (importante para preparar bien los patches, ya que es diferente asignar un valor, 
            // ej. "/speciesAnnotations" que meter al final de un array existente, ej. "/speciesAnnotations/-")
            if (tobjclon[anotaciones].length == 0) delete tobjclon[anotaciones];
        } else if (edutree[anotaciones] && edutree[anotaciones].iri === anniri) {
            // marco para borrar
            patch.push({
                op: "remove",
                path: "/" + anotaciones
            });
            // borro del clon
            delete tobjclon[anotaciones];
        }
    }
    // analizo la anotación primaria
    if (edutree[annprim] && edutree[annprim].iri === anniri) {
        if (reemplazo) {
            // marco para reemplazar
            patch.push({
                op: "replace",
                path: "/" + annprim,
                value: reemplazo.iri
            });
            // reemplazo en el clon
            tobjclon[annprim] = reemplazo;
        } else {
            // marco para borrar
            patch.push({
                op: "remove",
                path: "/" + annprim
            });
            // borro en el clon
            delete tobjclon[annprim];
        }
    }
}
///////////////////////
// BORRADO ÁRBOL
function $27fe9e683b34e1a0$var$handlerDeleteEducatree() {
    // preparo contenido modal
    let tit = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteTree);
    let body = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteTreeInfo);
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        static: true
    }, tit, body, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).confirmarBorradoArbol);
    // muestro modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    // handler procesarBorradoArbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#procesarBorradoArbol").click($27fe9e683b34e1a0$var$procesarBorradoArbol);
}
var $bc9fbb7804fbf992$exports = {};
$bc9fbb7804fbf992$exports = new URL("../treeDeletion.82359302.png", import.meta.url).toString();


async function $27fe9e683b34e1a0$var$procesarBorradoArbol() {
    // recupero iri del árbol
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // inicializo evento de borrado de árbol a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: "tree",
        content_id: iri,
        uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
        crafts_reqs: 0
    });
    // actualizo modal
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        static: true,
        spinner: true,
        spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).pleasewait),
        nofooter: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deletingtree), null, null);
    // cojo datos de las imágenes para borrar en Firebase, pero borro siempre antes el LOD
    // al ser strings sin etiqueta de idioma, los paths se guardan como objetos con clave "nolang"
    const pathsFirebaseBorrar = (0, $96abbdd7193a3c4b$export$326843c69d38a183)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri], [
        "imageAnnotations",
        "image",
        "firebasePath"
    ]);
    // hago la petición para borrar el árbol
    try {
        await (0, $174d363c054274ef$export$c4e23ce322fddcd9)(iri); // aquí se hace el borrado y la sincronización con el mapa si tiene éxito
        // envío datos borrado del árbol a GA
        (0, $067277e156f7a571$export$6adbd77fe07ba13)("delete_content");
        console.info("\xc1rbol borrado con IRI: " + iri); // log
    } catch (err) {
        console.error(err.message);
        // actualizo modal
        const be = "<code>" + err.message + "\n" + JSON.stringify(err.error) + "</code>";
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treedeletionerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).borradoArbolError);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
        return; // terminamos
    }
    // borro las imágenes que haya en Firebase
    if (pathsFirebaseBorrar.length > 0) {
        const storage = (0, $df9a6d7fd06616c9$export$fbd9b57a66480737)((0, $c0304d280c7b00cb$export$54387eca9e368edc)());
        // Create a storage reference from our storage service
        //const storageRef = storage.ref();
        // voy imagen por imagen
        for (const pathobj of pathsFirebaseBorrar){
            const path = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(pathobj);
            const imgRef = (0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)(storage, path);
            // borro foto del árbol
            try {
                // compruebo primero que exista
                const imgDownloadURL = await (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(imgRef);
                //console.log('File exists at: ' + imgDownloadURL);
                // ahora borro
                // cuidado con las reglas de seguridad de Firebase storage
                // para el borrado simplemente pongo que sea un usuario autenticado
                // para permitir así que un usuario de tipo máster pueda borrar fotos
                // creadas por otros usuarios
                await (0, $df9a6d7fd06616c9$export$39c5ed4ec960eade)(imgRef);
                // mando evento de borrado de foto en firebase a GA
                (0, $067277e156f7a571$export$7329bcdc3edcd90e)("delete_content", {
                    content_type: "photo",
                    content_id: imgDownloadURL,
                    uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid
                });
                console.info("Foto borrada de Firebase: " + imgDownloadURL);
            } catch (error) {
                if (error.code === "storage/object-not-found") console.error("File does not exist.");
                else {
                    console.error("Error: " + error.message);
                    // ajustes finales modal
                    const be = "<code>" + error + "</code>";
                    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                        static: true,
                        vertcent: true
                    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deletingphotoerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).borradoArbolExito);
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
                    // pongo el footer de borrado de éxito porque así ha sido, sólo ha fallado el borrado de la foto						
                    return; // terminamos
                }
            }
        }
    }
    // ajustes finales modal
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treedeletionsuccess), (0, $646ceeeec66fabd8$export$ab832a4d4ceb9113), (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).borradoArbolExito);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeDeletion").attr("src", new URL($bc9fbb7804fbf992$exports));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
}
function $27fe9e683b34e1a0$var$educatreeNoExiste() {
    // pongo página en blanco
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html("");
    // pongo un modal para avisar de que no se puede explorar el inventario
    const body = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorEducatreeText) + ' "' + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid + '".';
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        nofooter: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorEducatreeTitle), body, null);
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    // handler al esconderse
    document.getElementById("mimodal").addEventListener("hidden.bs.modal", (event)=>{
        // voy para atrás
        (0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f)();
    }, {
        "once": true
    });
}
var $b77e1f82c366e25b$exports = {};
$b77e1f82c366e25b$exports = new URL("../newNick.4a7f00f8.png", import.meta.url).toString();


function $27fe9e683b34e1a0$var$changeTreeNick() {
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    // preparo contenido modal
    let tit = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newTreeNick);
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        static: true
    }, tit, (0, $646ceeeec66fabd8$export$62b82cd57460378a), (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).cambiarNick);
    // muestro modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    // listener de cambio de nick del árbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newTreeNick").change(function() {
        const newtreenick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newTreeNick").val();
        // preinicializo
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").removeClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").prop("disabled", true);
        if (!newtreenick) //console.log("No hay nada");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick));
        else if (newtreenick.length < 3) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickTooshort));
        else if (newtreenick.length > 30) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickToolong));
        else {
            //console.log("Todo OK");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").addClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").prop("disabled", false);
        }
    });
    // listener del botón de cambio de nick
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").click(async function() {
        // desabilito la entrada y quito el footer
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newTreeNick").prop("disabled", true);
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            vertcent: true,
            static: true,
            nofooter: true
        }, null, null, null);
        // recupero el nick
        const newtreenick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newTreeNick").val();
        // inicializo evento nuevo nick a GA
        (0, $067277e156f7a571$export$639f48199cd2287d)({
            value: newtreenick,
            crafts_reqs: 0
        });
        // vamos con el cambio
        try {
            // preparo patch con el cambio de nick
            const patch = [];
            const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick ? "replace" : "add";
            patch.push({
                op: oper,
                path: "/nick",
                value: newtreenick
            });
            //console.log(patch);
            await (0, $174d363c054274ef$export$56e5489c2f38300e)(iri, patch);
            // envío evento nuevo nick a GA
            (0, $067277e156f7a571$export$6adbd77fe07ba13)("new_nick");
            console.info("Nick del \xe1rbol cambiado: " + newtreenick);
        } catch (err) {
            console.error(err.message);
            // actualizo modal
            const be = "<code>" + err.message + "\n" + JSON.stringify(err.error) + "</code>";
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeTreeNickFailure), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
            return; // terminamos
        }
        // modal de éxito
        // escondo campos y muestro imagen
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newTreeNick").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgNewTreeNick").attr("src", new URL($b77e1f82c366e25b$exports));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgNewTreeNick").removeClass("d-none");
        //const htmlbody = '<img src="/app/images/newNick.png" class="d-block w-100">';
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            vertcent: true,
            static: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeTreeNickSuccess), null, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).treeNickCambiado);
        // listener cierre modal
        document.getElementById("mimodal").addEventListener("hidden.bs.modal", (event)=>{
            $27fe9e683b34e1a0$export$d096c03518bc83df();
        }, {
            once: true
        });
    });
}


/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $2q7Wm = parcelRequire("2q7Wm");


var $6KOho = parcelRequire("6KOho");









///////////////////
// PÁGINA lasttrees
///////////////////
async function $82a71c896f160eac$export$eca36acb6faff6b4(noborrarcache) {
    // pongo spinner con mensaje de cargando	
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html((0, $646ceeeec66fabd8$export$27eb5f8cf2bf64a7));
    window.scrollTo(0, 0);
    // inicializo el evento para enviar a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: "lasttrees",
        crafts_reqs: 0
    });
    // pido datos a CRAFTS de las páginas de últimos educatrees
    const pe = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe : 0; // por defecto la 0
    const pae = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae : 0; // por defecto la 0
    await (0, $174d363c054274ef$export$5f671086e5404234)(pe, pae);
    // si están mal ajustadas las páginas (por no tener resultados y no ser 0), reajusto la URL
    let actualizar = false;
    if (pe > 0 && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global[pe].length == 0) {
        delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe;
        actualizar = true;
    }
    if (pae > 0 && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global[pae].length == 0) {
        delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae;
        actualizar = true;
    }
    if (actualizar) {
        //console.log("URL nueva: "+obtenerURL());
        // actualizo URL
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
        // y lllamo de nuevo al método para que obtenga los datos de nuevo
        $82a71c896f160eac$export$eca36acb6faff6b4(true);
        return;
    }
    // caso normal: hago el render
    $82a71c896f160eac$export$afe524c3a091be69();
}
async function $82a71c896f160eac$export$afe524c3a091be69() {
    // detecto llamada espúrea por la autenticación
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global || !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global) return;
    // obtengo info páginas
    const pe = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe : 0; // por defecto la 0
    const pae = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae : 0; // por defecto la 0
    // preparo objeto plantilla
    const objltt = {
        usuario: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario != undefined,
        usuarioImg: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL : null,
        enPagLastrees: true,
        showann: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.showann
    };
    // ultEducatrees
    const uet = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global[pe];
    objltt.hayUltedutrees = uet.length > 0;
    objltt.hayUltedutreesPrev = pe > 0;
    objltt.hayUltedutreesSig = uet.length > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).page;
    objltt.pagUltedutrees = pe + 1;
    objltt.ultedutrees = [];
    for(let i = 0; i < uet.length && i < (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).page; i++){
        const uetel = uet[i];
        const etid = uetel.iri.split("/")[uetel.iri.split("/").length - 1];
        // cojo primero el nick en Datos.educatrees[iri] (por si actualizó su nick),
        // en segunda opción el nick del objeto y si no, el etid
        let etl = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri].nick) : uetel.nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(uetel.nick) : etid;
        etl = etl.length > 14 ? etl.substring(0, 10) + "\u2026" : etl;
        const uid = uetel.creator.iri.split("/")[uetel.creator.iri.split("/").length - 1];
        objltt.ultedutrees.push({
            etid: etid,
            treeLabel: etl,
            treeHref: "/tree/" + etid,
            created: (0, $96abbdd7193a3c4b$export$aa350b96d91cd94)(uetel),
            userHref: "/user/" + uid,
            uid: uid,
            userLabel: (0, $96abbdd7193a3c4b$export$6efd817d0963408a)(uetel)
        });
    }
    // ultAnotaciones
    const uaet = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global[pae];
    objltt.hayUltanns = uaet.length > 0;
    objltt.hayUltannsPrev = pae > 0;
    objltt.hayUltannsSig = uaet.length > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).page;
    objltt.pagUltanns = pae + 1;
    objltt.ultanns = [];
    for(let i = 0; i < uaet.length && i < (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).page; i++){
        const uaetel = uaet[i];
        const etid = uaetel.iri.split("/")[uaetel.iri.split("/").length - 1];
        // cojo primero el nick en Datos.educatrees[iri] (por si actualizó su nick),
        // en segunda opción el nick del objeto y si no, el etid
        let etl = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri].nick) : uaetel.nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(uaetel.nick) : etid;
        etl = etl.length > 14 ? etl.substring(0, 10) + "\u2026" : etl;
        const uid = uaetel.creator.iri.split("/")[uaetel.creator.iri.split("/").length - 1];
        const atl = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).annotationTypeLabels[uaetel.type];
        const typeLabel = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(atl, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).annotationTypeLabels.pordefecto));
        objltt.ultanns.push({
            etid: etid,
            treeLabel: etl,
            treeHref: "/tree/" + etid,
            annotationType: typeLabel,
            annotated: (0, $96abbdd7193a3c4b$export$aa350b96d91cd94)(uaetel),
            userHref: "/user/" + uid,
            uid: uid,
            userLabel: (0, $96abbdd7193a3c4b$export$6efd817d0963408a)(uaetel)
        });
    }
    // renderizo
    const htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$96346f251ef3b3fb), objltt);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(htmlcontent);
    // envío GA evento ver página lasttrees
    (0, $067277e156f7a571$export$6adbd77fe07ba13)();
    console.info("P\xe1gina lasttrees cargada");
    // pongo listener del botón de volver
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#goBackButton").on("click", (0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
    // pongo listeners a clickViewprofile, clickSignin y clickSignout
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").click((0, $c0304d280c7b00cb$export$f98b6673fafc0e20));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignin").click((0, $c0304d280c7b00cb$export$9ffe63492d76c086));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").click((0, $c0304d280c7b00cb$export$daa0a882204fd973));
    // handlers de páginas
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".pagina").click(function() {
        // detecto target de la página
        let target = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("created") ? "pe" : "pae";
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.showann = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("annotated");
        // detecto si retrocedo o avanzo
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("prev")) {
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]--;
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target] == 0) delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target];
        } else if (!(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target] = 1;
        else (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]++;
        // actualizo URL
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
        // y cargo la URL para que obtenga los datos de nuevo
        $82a71c896f160eac$export$eca36acb6faff6b4(true);
    });
}
// ÁRBOLES
function $82a71c896f160eac$export$b07097befa6136ca(objcelda) {
    // sólo hago el rendering si me toca (objcelda.idtimeout es el mismo que Sesion.idTimeoutActualizar)
    if (objcelda.idtimeout == (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar) {
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas[objcelda.et] == undefined) {
            // referencia a la celda
            const celda = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[objcelda.et];
            // objeto bounds de la celda (se usa en un par de sitios)
            const bounds = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(objcelda.cellX, objcelda.cellY, objcelda.zoom);
            // detecto si hay cluster, ajustando etiqueta y z-index
            let etCluster = null;
            let zCluster = null;
            if (celda.edu.mmil || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.ifn.mmil) {
                etCluster = "+1K";
                zCluster = 1000;
            } else if (celda.edu.ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.edu.ntrees + celda.ifn.ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold) {
                etCluster = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn ? celda.edu.ntrees + celda.ifn.ntrees : celda.edu.ntrees;
                zCluster = etCluster;
            }
            // LIMPIEZA CASO ZOOM-OUT (si toca cluster borramos los marcadores que aglutina)
            if (objcelda.zoomout && etCluster) {
                // borrado de árboles en la celda
                let aborrar = [];
                (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.eachLayer(function(a) {
                    if (bounds.contains(a.getLatLng())) // guardo el árbol
                    aborrar.push(a);
                });
                for(let i = 0; i < aborrar.length; i++){
                    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.removeLayer(aborrar[i]);
                    // borro también el árbol de Sesion.arbsPintados
                    delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[aborrar[i].uri];
                }
            }
            // CLUSTERS
            if (etCluster != undefined) {
                // pongo el cluster en la localización de un árbol de la celda o si no hay en el centro de la celda
                const mLatLng = celda.edu.locCluster ? L.latLng(celda.edu.locCluster.lat, (0, $69f04ba581843b2d$export$a4829058f9fe1646)(celda.edu.locCluster.lng, objcelda.cellX, objcelda.zoom)) : (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.ifn.locCluster ? L.latLng(celda.ifn.locCluster.lat, (0, $69f04ba581843b2d$export$a4829058f9fe1646)(celda.ifn.locCluster.lng, objcelda.cellX, objcelda.zoom)) : bounds.getCenter();
                // preparo icono
                const micon = new L.divIcon({
                    html: '<div class="marcadorTexto"><span>' + etCluster + "</span></div>",
                    className: "",
                    iconSize: [
                        52,
                        52
                    ],
                    iconAnchor: [
                        26,
                        26
                    ],
                    tooltipAnchor: [
                        12,
                        0
                    ] // point from which tooltips will "open", relative to the icon anchor
                });
                // creo marcador y añado a la capa de clusters
                const cpint = L.marker(mLatLng, {
                    icon: micon,
                    zIndexOffset: zCluster
                }).addTo((0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs);
                // ajusto cursor y handler de click con +3 de zoom
                $82a71c896f160eac$export$19f9855b4b37efc4(cpint);
                // añado tooltip si no es táctil
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).hayTooltips) cpint.bindTooltip(etCluster + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).ntrees));
            // (no ajusto condicionalmente el tooltip porque me da un error al clickar tras un unbindTooltip)
            } else {
                // no es un cluster, agrego los dos arrays de árboles y los trato de manera indiferente
                const alltrees = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.ifn.trees ? celda.edu.trees ? celda.ifn.trees.concat(celda.edu.trees) : celda.ifn.trees : celda.edu.trees ? celda.edu.trees : [];
                // pinto árbol a árbol
                for (const turi of alltrees)// sólo pinto árbol si no estaba libre (para evitar efectos borde entre celdas)
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[turi] == undefined) {
                    // recupero el árbol
                    const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi];
                    // obtengo icono
                    const aicon = (0, $7b115b3c2cee4b53$export$6274df672a45c12d)(arb);
                    // reajuste de longitud por el antimeridiano
                    const lng = (0, $69f04ba581843b2d$export$a4829058f9fe1646)(arb.lng, objcelda.cellX, objcelda.zoom);
                    // pinto el marcador del árbol
                    let apint = L.marker([
                        arb.lat,
                        lng
                    ], {
                        icon: aicon
                    }).addTo((0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs);
                    // le añado también la uri (para poder borrarlo en caso de zoom out)
                    apint.uri = turi;
                    // y lo guardo
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[turi] = apint;
                    // pongo tooltips si es un ifntree (siempre)
                    // (no lo ajustaré condicionalmente con el modo de edición porque me da un error al clickar tras un unbindTooltip)
                    if (arb.iri == undefined) apint.bindTooltip($82a71c896f160eac$export$924c9d361ba12beb(arb));
                    // ajusto el cursor y el popup
                    $82a71c896f160eac$export$1f29254b983d0b7(turi);
                }
            }
            // actualizo las celdas pintadas
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas[objcelda.et] = true;
        }
    }
}
function $82a71c896f160eac$export$19f9855b4b37efc4(cpint) {
    // actúo según esté en modo de creación de árbol o no
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol) {
        // cursor edición
        cpint.getElement().style.cursor = "crosshair";
        // fuera click handler
        cpint.off("click");
    } else {
        // cursor normal
        cpint.getElement().style.cursor = "";
        // pongo handler con +3 de zoom al hacer click
        cpint.on("click", function(e) {
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).flyTo(cpint.getLatLng(), (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom + 3);
        });
    }
}
function $82a71c896f160eac$export$1f29254b983d0b7(auri) {
    // recupero árbol y árbol pintado
    const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[auri];
    const apint = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[auri];
    if (arb != undefined && apint != undefined) {
        // actúo según esté en modo de creación de árbol o no
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol) {
            // cursor edición
            apint.getElement().style.cursor = "crosshair";
            // fuera popup para edutrees
            if (arb.iri != undefined) apint.unbindPopup();
        } else {
            // cursor normal
            apint.getElement().style.cursor = "";
            // añado popup para edutrees
            if (arb.iri != undefined) {
                // añado popup
                apint.bindPopup($82a71c896f160eac$var$popupArbol(arb));
                // detecto si hay un error en la carga de la imagen y en tal caso la escondo (gracias, ChatGPT)
                apint.on("popupopen", function(e) {
                    const img = e.popup._contentNode.querySelector("img");
                    if (img) img.addEventListener("error", function() {
                        img.style.display = "none";
                        console.warn("Fallo al cargar esta imagen: " + img.src);
                    });
                });
            }
        } // else Sesion.creandoArbol == false
    }
}
// TOOLTIPS
function $82a71c896f160eac$export$924c9d361ba12beb(arb) {
    return arb.iri == undefined ? $82a71c896f160eac$var$tooltipIfntree(arb) : $82a71c896f160eac$var$tooltipEdutree(arb);
}
function $82a71c896f160eac$var$tooltipIfntree(arb) {
    let tooltip = "<strong>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + " " + (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(arb.uri) + "</strong>";
    tooltip += "<br><i>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createdByIFN) + "</i>";
    const espuri = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
    // especie
    if (espuri != undefined && espuri != null && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName != undefined) {
        let nesp = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(espuri)));
        // si hay nombre científico...
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) nesp = "<i>" + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].scientificName, nesp)) + "</i>";
        tooltip += "<br>" + nesp;
    }
    // altura
    if (arb.heightM != undefined) tooltip += "<br>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).height) + ": " + Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.heightM)).toFixed(2) + "m";
    // diámetro
    if (arb.dbh1mm && arb.dbh2mm) {
        // calculo media aritmética
        const dbh = ((arb.dbh1mm + arb.dbh2mm) / 2).toFixed(0);
        tooltip += "<br>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diameter) + ": " + dbh + "mm";
    }
    return tooltip;
}
function $82a71c896f160eac$var$tooltipEdutree(arb) {
    let tooltip = "<strong>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + " " + (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(arb.iri) + "</strong>";
    if (arb.creator != undefined) tooltip += "<br><i>" + (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(arb, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createdBy)) + "</i>";
    const espuri = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
    // especie
    if (espuri != undefined && espuri != null && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName != undefined) {
        let nesp = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(espuri)));
        // si hay nombre científico...
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) nesp = "<i>" + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].scientificName, nesp)) + "</i>";
        tooltip += "<br>" + nesp;
    }
    // altura
    if (arb.height != undefined) tooltip += "<br>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).height) + ": " + Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.height)).toFixed(2) + "m";
    // diámetro
    if (arb.dbh != undefined) tooltip += "<br>" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diameter) + ": " + Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.dbh)).toFixed(0) + "mm";
    return tooltip;
}
// POPUPS
function $82a71c896f160eac$var$popupArbol(arb) {
    // preparo objeto para el popup con Mustache
    let pobj = {
        "iri": arb.iri,
        "etid": arb.iri.split("/").pop()
    };
    // nick
    if (arb.nick) pobj.nick = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.nick);
    // taxón
    const espuri = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
    if (espuri != undefined && espuri != null && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName != undefined) {
        let nesp = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(espuri)));
        // si hay nombre científico...
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) nesp = "<i>" + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].scientificName, nesp)) + "</i>";
        pobj.taxon = nesp;
    }
    // recupero todas las imágenes
    const images = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(arb, [
        "images"
    ]);
    if (images.length) {
        if (images.length == 1) pobj.image = images[0];
        else {
            pobj.multimages = true;
            pobj.images = [];
            const inda = Math.floor(Math.random() * images.length);
            for(let i = 0; i < images.length; i++){
                let obji = {
                    srcimg: images[i]
                };
                if (i == inda) obji.active = true;
                pobj.images.push(obji);
            }
        }
    }
    // voy con la descripción
    pobj.desc = "";
    // treeStatus
    if (arb.treeStatus) {
        const ts = (0, $2q7Wm.default).find((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles, function(el) {
            return el.iri === arb.treeStatus;
        });
        if (ts) pobj.desc += (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(ts.label) + "<br>";
    }
    // altura
    if (arb.height) pobj.desc += (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).height) + ": " + Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.height)).toFixed(2) + "m<br>";
    // diámetro
    if (arb.dbh) pobj.desc += (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diameter) + ": " + Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.dbh)).toFixed(0) + "mm<br>";
    // reajusto cadena descripción para quitar el <br> final
    const libr = pobj.desc.lastIndexOf("<br>");
    if (libr !== -1) pobj.desc = pobj.desc.substring(0, libr);
    // creador y fecha
    pobj.creator = (0, $96abbdd7193a3c4b$export$4d0c182344beaa87)(arb, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createdBy));
    // devuelvo el html...
    return (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$df6117506e1c4c3b), pobj);
}


/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $6KOho = parcelRequire("6KOho");





/////////////////////
// RENDER DEL CAJETÍN
function $d1e0875cf0f68e21$export$24073cf807c9abc3(mostrar) {
    if (mostrar && (0, $ffd94e1d81f19b1c$export$c398d137cd63b259) != null) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#lugares_heading").removeClass("d-none");
    else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#lugares_heading").addClass("d-none");
}
///////////////////////////
// OBTENCIÓN DE SUGERENCIAS
async function $d1e0875cf0f68e21$export$a80214d90d6317cd(entrada) {
    try {
        // hago la llamada a solr y espero resultados
        const datos = await (0, $ffd94e1d81f19b1c$export$c398d137cd63b259).getSuggestions(entrada);
        // extraigo sugerencias del idioma adecuado
        const sugidioma = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.suggesters);
        let keys = Object.keys(datos.suggest[sugidioma]);
        if (keys.length > 0) return datos.suggest[sugidioma][keys[0]];
        else return {
            "numFound": 0
        };
    } catch (err) {
        reject(err);
    }
}
/////////////////////
// RENDER SUGERENCIAS
function $d1e0875cf0f68e21$export$49f32269b97f95f9(resultados) {
    // objeto sugerencias
    let sinfo = {};
    sinfo.sugerencias = [];
    // formateo las sugerencias
    if (resultados.numFound == 0) sinfo.nosugerencias = true;
    else for(let ind = 0; ind < resultados.suggestions.length; ind++)sinfo.sugerencias.push({
        "id": resultados.suggestions[ind].payload,
        "name": resultados.suggestions[ind].term // la sugerencia
    });
    // muestro sugerencias
    let cont = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$217f5a5fe852abe6), sinfo);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").html(cont);
    // handler de los botones de sugerencias de lugares
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_suge_lugar").click(async function() {
        // obtengo id de la sugerencia
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("id");
        // pedimos la información del lugar
        const datos = await (0, $ffd94e1d81f19b1c$export$c398d137cd63b259).getDocument(id);
        // si hay algo, vamos al primero
        if (datos.response.numFound > 0) $d1e0875cf0f68e21$var$seleccionarLugar(datos.response.docs[0]);
    });
    // inicializo focus
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = -1;
}
///////////////
// AJUSTE FOCUS
function $d1e0875cf0f68e21$export$41334320f2c99869() {
    // Sesion.lugarfocus = 0; => cajetín entrada
    // Sesion.lugarfocus = i; => num de sugerencia
    // obtengo número de sugerencias
    const ns = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").children(":enabled").length;
    // reajusto índice del focus si hace falta
    if (ns == 0) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = -1;
    else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus >= ns) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = 0;
    else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus < 0) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = ns - 1;
    // y ahora las cosas visuales
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").children().removeClass("active");
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus >= 0) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").children().eq((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus).addClass("active");
}
////////////////////
// SELECCIONAR LUGAR
function $d1e0875cf0f68e21$var$seleccionarLugar(lugar) {
    // obtengo la etiqueta de idioma apropiada
    const lab = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.labels);
    // pongo nombre	en la entrada
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_lugares").val(lugar[lab]);
    // escondo la lista de sugerencias
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").addClass("d-none");
    // inicializo focus
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = -1;
    // si había marcador de lugar, lo quito
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker != null) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker.remove();
    // pongo tooltip y marcador en el lugar
    let tooltip = "<strong>" + lugar[lab] + "</strong>";
    // coordenadas
    const coords = [
        lugar.lat,
        lugar.long
    ];
    // pongo marcador
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker = L.marker(coords, {
        icon: (0, $7b115b3c2cee4b53$export$b839616475ae6ec3)()
    }).bindTooltip(tooltip).addTo((0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee));
    /*
	// pongo tooltip y marcador en el lugar
	let tooltip = '<strong>'+lugar.name+'</strong>';
	// pongo el tipo de lugar
	tooltip += '<br>' + getLiteral(dict[lugar.feature_code]);
	// población
	if (lugar.population > 0)
		tooltip += '<br>'+getLiteral(dict.population)+': '+Number(lugar.population).toLocaleString();
	// coordenadas
	const coords = [lugar.latitude, lugar.longitude];
	// pongo marcador
	Sesion.lugarmarker = L.marker(coords, {icon: Iconos.lugar})
		.bindTooltip(tooltip)
		.addTo(Mimapa);*/ // guardo lugar en la sesión (para poder hacer un zoom si se pulsa intro en la entrada)
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugar = lugar;
    // mando evento de selección de lugar a GA
    (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
        content_type: "place_selection",
        content_id: lugar[lab]
    });
    // navegamos al municipio
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).flyTo(coords, (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zLugar, {
        animate: true,
        duration: 1
    });
}




function $1ee989753a15371d$export$fa0799b379eb3758(types) {
    if (!types) return undefined;
    // inicializaciones
    let suri = undefined;
    let nexpuris = null;
    // convierto en array si hace falta
    let arsp = Array.isArray(types) ? types : [
        types
    ];
    // evalúo cada uno de los tipos disponibles
    for (let evtype of arsp){
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[evtype] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[evtype].expuris) // aquí tengo uno válido, miro si es mejor que lo que tenía
        {
            if (nexpuris == null || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[evtype].expuris.length < nexpuris) {
                suri = evtype;
                nexpuris = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[evtype].expuris.length;
            }
        }
    }
    // devuelvo suri
    return suri;
}
function $1ee989753a15371d$export$d67e2296dd6db17d() {
    // guardo valor (en memoria y en local storage para recordarlo entre sesiones)
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci = this.checked;
    localStorage.setItem("nomci", (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci); // guardará "true" o "false"
    // ajusto todos los switches de nombres científicos desactivando
    // los change listeners de manera temporal (gracias, chatGPT)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".nomci").off("change").prop("checked", (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci).on("change", $1ee989753a15371d$export$d67e2296dd6db17d);
    // renderizado taxón (formularios)
    $1ee989753a15371d$export$5dba38aff426bd77();
    // etiqueta filtro de taxón (panel del mapa)
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon) {
        // pongo etiqueta
        const label = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci ? "<i>" + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon].scientificName)) + "</i>" : (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon)));
        const et = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).filtering) + " <strong>" + label + "</strong>";
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#div_label_filtro_taxon").html(et);
    }
    // ¡hay que cambiar el valor de todo!
    // cambio las etiquetas de todas las especies en la lista
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".taxones_block").find("[spuri]").each(function() {
        // obtengo la especie
        const spuri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("spuri");
        // nombre vulgar y científico
        const nvul = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri] ? (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(spuri))) : (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$56b19e10c1699553)(spuri));
        const ncie = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri] ? "<i>" + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].scientificName, nvul)) + "</i>" : "<i>" + nvul + "</i>";
        // hago reemplazo en el markup del botón
        const oldmarkup = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).html();
        const newmarkup = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci ? oldmarkup.replace(nvul, ncie) : oldmarkup.replace(ncie, nvul);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).html(newmarkup);
    });
    // en teselas actualizo los popups
    //ajustarCursorPopupsTeselas(Object.keys(Sesion.tessPintadas));
    // en el mapa actualizo tooltips ifntrees y popups de edutrees (según el modo edición)
    for(const turi in (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados){
        // ajuste popup según modo edición
        (0, $82a71c896f160eac$export$1f29254b983d0b7)(turi);
        // tooltip sólo para ifntrees
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi].uri) {
            const tooltip = (0, $82a71c896f160eac$export$924c9d361ba12beb)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi]);
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[turi].bindTooltip(tooltip);
        }
    }
    // si hay minimapa pongo tooltips a todos los árboles
    if ((0, $27fe9e683b34e1a0$export$c37f872725571dfc) && (0, $27fe9e683b34e1a0$export$c37f872725571dfc).arbsPintados) for(const turi in (0, $27fe9e683b34e1a0$export$c37f872725571dfc).arbsPintados)(0, $27fe9e683b34e1a0$export$c37f872725571dfc).arbsPintados[turi].bindTooltip((0, $82a71c896f160eac$export$924c9d361ba12beb)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi]));
    if ((0, $3a9989d46007ef73$export$c37f872725571dfc) && (0, $3a9989d46007ef73$export$c37f872725571dfc).arbsPintados) for(const turi in (0, $3a9989d46007ef73$export$c37f872725571dfc).arbsPintados)(0, $3a9989d46007ef73$export$c37f872725571dfc).arbsPintados[turi].bindTooltip((0, $82a71c896f160eac$export$924c9d361ba12beb)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi]));
}
////////////////////////////////
// VISUALIZACIÓN FILTRO TAXÓN (modo mapa)
// sólo se llama desde cargarURL
////////////////////////////////
function $1ee989753a15371d$export$99e344fe0d6549db() {
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon == undefined) // escondo el contenido
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#filtro_taxon").addClass("d-none");
    else {
        // pongo etiqueta
        const label = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci ? "<i>" + (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon].scientificName)) + "</i>" : (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon)));
        const et = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).filtering) + " <strong>" + label + "</strong>";
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#div_label_filtro_taxon").html(et);
        // si hay info de wikidata hago visible el botón de info
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon].wikidata) {
            // incluyo uri de la especie
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_info_filtro_taxon").attr("turi", (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon);
            // incluyo uri de DBpedia
            //$("#bot_info_filtro_taxon").attr("dbr", Datos.especies[Sesion.estado.taxon].dbpedia);
            // quito popover que hubiera
            //$("#bot_info_filtro_taxon").popover('dispose');	TODO: comprobar que esto no vale
            // botón de info visible
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_info_filtro_taxon").removeClass("d-none");
        } else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_info_filtro_taxon").addClass("d-none");
        // hago visible el filtro
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#filtro_taxon").removeClass("d-none");
    }
}
////////////////////////////////////
// VISUALIZACIÓN TAXÓN (formulario)
////////////////////////////////////
function $1ee989753a15371d$export$5dba38aff426bd77() {
    // actualizo todas las entradas de clase taxón
    let $taxonInputs = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("input").filter(".taxon");
    $taxonInputs.each(function() {
        // cojo el botón de la dbpedia de este elemento (puede no existir)
        const $dbbut = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).siblings(".dbpedia");
        // cojo el botón de delete de este elemento (puede no existir)
        const $delbut = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).siblings(".delete");
        // obtengo uri del taxón	
        let turi = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("iri");
        // preparo etiqueta
        const label = turi ? (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi] ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci ? (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi].scientificName)) : (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(turi))) : (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$56b19e10c1699553)(turi)) : "";
        // ajusto itálica	
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("style", "font-style:italic");
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).removeAttr("style");
        // pongo etiqueta
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val(label);
        // muestro o escondo el botón de borrar
        if ($delbut) {
            if (turi) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreeTaxon").removeClass("d-none");
            else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreeTaxon").addClass("d-none");
        }
        // trato con el botón de info de taxón a dbpedia
        if ($dbbut) {
            $dbbut.off("click"); // desactivo handlers previos
            // muestro o escondo el botón 
            if (turi && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi].wikidata) {
                // incluyo uri de la especie
                $dbbut.attr("turi", turi);
                // quito popover que hubiera
                //$dbbut.popover('dispose');	TODO: comprobar que esto no vale
                // botón de info visible
                $dbbut.removeClass("d-none");
                // handler del popover taxón con info de DBpedia
                $dbbut.click($1ee989753a15371d$export$2c4bbd56989782d8);
            } else $dbbut.addClass("d-none");
        }
    });
}
//////////////////////////
// HANDLER setTreeTaxon (modo formulario)
// el handler está puesto directamente en el formulario creationEducatreeForm
function $1ee989753a15371d$export$2d3916a1f0ae58c1() {
    // obtengo nuevo estado del botón
    const activar = !(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").hasClass("active");
    // pongo el botón activo o no
    if (activar) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").addClass("active");
    else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").removeClass("active");
    // render de la selección de taxón
    $1ee989753a15371d$var$renderSeleccionTaxon(activar, true);
}
//////////////////////////
// HANDLER deleteTreeTaxon (modo formulario)
function $1ee989753a15371d$export$e644c8daeec4ef49() {
    // borro iri y lanzo evento de "change" para poder hacer validación en las anotaciones
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").removeAttr("iri").trigger("change");
    // visualizo y a volar
    $1ee989753a15371d$export$5dba38aff426bd77();
}
//////////////////////////
// HANDLER FILTRAR TAXÓN (modo mapa)
function $1ee989753a15371d$export$79e952b071e79fc8() {
    // obtengo nuevo estado del botón
    const activar = !(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").hasClass("active");
    // pongo el botón activo o no
    if (activar) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").addClass("active");
    else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").removeClass("active");
    // render de la selección de taxón
    $1ee989753a15371d$var$renderSeleccionTaxon(activar);
}
//////////////////////////
// RENDER SELECCIÓN TAXÓN
function $1ee989753a15371d$var$renderSeleccionTaxon(activar, esformulario) {
    // RENDER ENTRADA LUGARES (para que no interfiera)
    if (!esformulario) (0, $d1e0875cf0f68e21$export$24073cf807c9abc3)(!activar);
    // selecciono los divs apropiados según el modo
    const $divbus = esformulario ? (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_subheading_newtree") : (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_subheading");
    const $divnav = esformulario ? (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block_newtree") : (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block");
    // BÚSQUEDA CON ENTRADA DE TEXTO Y SUGERENCIAS DE TIPOS DE SITIOS
    if (activar) {
        // rendering del subheading
        const content = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$900677b7c5ee40b7), {
            "activar": activar,
            "esformulario": esformulario
        });
        $divbus.html(content);
        $divbus.removeClass("d-none");
        // listener de handlerImportTaxon
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#importTaxonButton").click($1ee989753a15371d$var$handlerImportTaxon);
        // handler de buscar taxon...
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".in_taxon").on("keyup search", function(e) {
            //console.log("Caracter: " + e.which);
            // trato las teclas de arriba, abajo y enter			
            if (e.which == 13) {
                // actúo según el focus
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus == -1) // si hay al menos una sugerencia (y habilitada) voy a la primera
                {
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".sugetaxones").children(":enabled").length > 0) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".sugetaxones").children(":enabled").eq(0).click();
                } else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".sugetaxones").children().eq((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus).click();
            } else if (e.which == 40) {
                // incremento focus
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus++;
                $1ee989753a15371d$var$ajustarTaxonfocus();
            } else if (e.which == 38) {
                // decremento focus
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus--;
                $1ee989753a15371d$var$ajustarTaxonfocus();
            } else {
                const entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
                // analizo la cadena de entrada
                if (entrada.length < 1) {
                    $divnav.removeClass("d-none");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".sugetaxones").html("");
                } else {
                    $divnav.addClass("d-none");
                    // obtengo sugerencias de tipos de sitios
                    const suges = $1ee989753a15371d$var$sugeTaxones(entrada);
                    // renderizo las sugerencias
                    $1ee989753a15371d$var$renderSugeTaxones(entrada, suges);
                }
            }
        });
    } else $divbus.addClass("d-none");
    // NAVEGACIÓN ONTOLOGÍA DE TIPOS
    if (activar) {
        $divnav.removeClass("d-none");
        // ¿caso inicial?
        if ($divnav.html() == "") {
            // preparo datos para mostrar
            let btaxainfo = [];
            // analizo los taxones top
            for (const spuri of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).especiesTop){
                // obtengo información del objeto para formatear
                let spinfo = $1ee989753a15371d$var$getInfoSpecies(spuri);
                // incluyo también el indice
                spinfo.indice = 0;
                spinfo.indentspace = "";
                // añado
                btaxainfo.push(spinfo);
            }
            // sort elements
            btaxainfo = (0, $2q7Wm.default).sortBy(btaxainfo, "label").reverse();
            //btaxainfo = _.sortBy(btaxainfo, function(el) { return (+el.nclasses*100 + +el.allindivs); });
            btaxainfo = (0, $2q7Wm.default).sortBy(btaxainfo, "score");
            btaxainfo = btaxainfo.reverse();
            // generate the mark-up
            const content = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$502b32cc8ed2e37e), btaxainfo);
            // pongo el contenido
            $divnav.html(content);
            // HANDLERS
            // handler de seleccionar taxón
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_sel_taxon").click($1ee989753a15371d$var$handlerSeleccionarTaxon);
            // handler de expandir taxón
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_expandir_taxon").click($1ee989753a15371d$var$handlerExpandTaxon);
            // handler de showmore
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".showmore").click($1ee989753a15371d$var$handlerShowmore);
        } else $divnav.removeClass("d-none");
    } else $divnav.addClass("d-none");
}
//////////////////////
// HANDLER SUGERENCIAS
//////////////////////
function $1ee989753a15371d$var$sugeTaxones(entrada) {
    let sugerencias = [];
    // sólo actúo si la entrada no es una cadena vacía
    if (entrada.length > 0) {
        // obtengo las uris de las especies ordenadas alfabéticamente
        const espuris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies).sort();
        // evalúo cada especie si vale
        for (let espuri of espuris){
            // primero veo si descarto la especie: : sólo considero si tiene datos de wikidata y UN NOMBRE CIENTÍFICO DIFERENTE AL DEL PADRE
            let descarte = false;
            if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].wikidata) descarte = true;
            else {
                for (let supiri of (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].superclasses)if ((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[supiri].scientificName) === (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].scientificName)) descarte = true;
            }
            if (!descarte) {
                // obtengo etiqueta de la especie (por defecto nombre vulgar)
                let labesp = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(espuri));
                // si hay nombre científico...		
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) labesp = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[espuri].scientificName, labesp));
                // si coincide, a las sugerencias
                if ((0, $96abbdd7193a3c4b$export$bc11d730045994ef)(labesp, entrada) > -1) sugerencias.push(espuri);
            }
        }
    }
    return sugerencias;
}
function $1ee989753a15371d$var$renderSugeTaxones(entrada, sugerencias) {
    // preparo sugerencias
    let sinfo = {};
    sinfo.sugerencias = [];
    // obtengo las sugerencias si la entrada no está vacía
    if (sugerencias.length == 0) sinfo.nosugerencias = true;
    else for (let suge of sugerencias){
        // obtengo información del objeto para formatear
        let spinfo = $1ee989753a15371d$var$getInfoSpecies(suge);
        // índice en el que hubo match
        const ind = (0, $96abbdd7193a3c4b$export$bc11d730045994ef)(spinfo.label, entrada);
        // formateo el nombre a mostrar con negritas
        spinfo.labelshown = "";
        if (ind > 0) spinfo.labelshown += spinfo.label.substr(0, ind);
        spinfo.labelshown += "<strong>" + spinfo.label.substr(ind, entrada.length) + "</strong>";
        spinfo.labelshown += spinfo.label.substr(ind + entrada.length);
        /* siempre se añade
			// añado el objeto SÓLO SI TIENE INDIVIDUOS
			if (spinfo.allindivs > 0)
				sinfo.sugerencias.push(spinfo);*/ sinfo.sugerencias.push(spinfo);
    }
    // ordeno sugerencias por número de individuos y subclases
    //sinfo.sugerencias = _.sortBy(sinfo.sugerencias, function(el) { return (+el.nclasses*100 + +el.allindivs); });
    // ordeno por popularidad en Wikidata
    sinfo.sugerencias = (0, $2q7Wm.default).sortBy(sinfo.sugerencias, "score");
    sinfo.sugerencias = sinfo.sugerencias.reverse();
    // corto número de sugerencias
    sinfo.sugerencias = sinfo.sugerencias.slice(0, (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).numsugs);
    // muestro sugerencias
    const cont = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$fafd45cc9f2ab26c), sinfo);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".sugetaxones").html(cont);
    // handler de los botones de sugerencias
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_suge_taxon").click($1ee989753a15371d$var$handlerSeleccionarTaxon);
    // inicializo focus
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = -1;
}
function $1ee989753a15371d$var$ajustarTaxonfocus(esWD) {
    const idel = esWD ? "#sugetaxonesWD" : ".sugetaxones";
    // Sesion.txfocus = 0; => cajetín entrada
    // Sesion.txfocus = i; => num de sugerencia
    // obtengo número de sugerencias que no están deshabilitadas
    const ns = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(idel).children(":enabled").length;
    //if (ns == 1 && $("#sugetaxones").children().eq(0)  )// corrección por si no es una sugerencia real
    // reajusto índice del focus si hace falta
    if (ns == 0) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = -1;
    else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus >= ns) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = 0;
    else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus < 0) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = ns - 1;
    // y ahora las cosas visuales
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(idel).children().removeClass("active");
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus >= 0) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(idel).children().eq((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus).addClass("active");
}
/////////////////////////////
// HANDLER NAVEGACIÓN TAXONES
/////////////////////////////
function $1ee989753a15371d$var$handlerExpandTaxon() {
    // obtengo i para el icono
    let $i = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).find("i");
    let $div = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).closest(".taxon");
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("active")) {
        // desactivo botón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).removeClass("active");
        // pongo otro icono
        $i.removeClass("bi-chevron-down");
        $i.addClass("bi-chevron-right");
        // itero para quitar los elementos de la lista
        const indice = +$div.attr("indice");
        do {
            var $nextdiv = $div.next();
            var fin = true;
            if (+$nextdiv.attr("indice") > indice) {
                $nextdiv.remove();
                fin = false;
            }
        }while (!fin);
    } else {
        // activo botón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).addClass("active");
        // pongo otro icono
        $i.removeClass("bi-chevron-right");
        $i.addClass("bi-chevron-down");
        // get uri of the class and prepare indentspace
        const spuri = $div.find(".bot_sel_taxon").attr("spuri");
        const newindice = +$div.attr("indice") + 1;
        let indentspace = "";
        for(let ind = 0; ind < newindice; ind++)indentspace += "&nbsp;&nbsp;&nbsp;&nbsp;";
        // generate aux object for the template
        let scobj = [];
        for (let subspuri of (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].subclasses){
            // obtengo información del objeto para formatear
            let subspinfo = $1ee989753a15371d$var$getInfoSpecies(subspuri);
            // incluyo también el indent
            subspinfo.indice = newindice;
            subspinfo.indentspace = indentspace;
            // sólo inserto si tiene datos de wikidata y UN NOMBRE CIENTÍFICO DIFERENTE AL DEL PADRE
            if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[subspuri].wikidata && (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[subspuri].scientificName) !== (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].scientificName)) scobj.push(subspinfo);
        }
        // sort elements
        scobj = (0, $2q7Wm.default).sortBy(scobj, "label").reverse();
        //scobj = _.sortBy(scobj, function(el) { return (+el.nclasses*100 + +el.allindivs); });
        scobj = (0, $2q7Wm.default).sortBy(scobj, "score");
        scobj = scobj.reverse();
        // show more button
        if (scobj.length > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).hidemax) {
            // include fake element for the button
            scobj.splice((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).hidebegin, 0, {
                "botonesconder": true,
                "indice": newindice,
                "indentspace": indentspace + "&nbsp;&nbsp;&nbsp;&nbsp;"
            });
            for(let ind = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).hidebegin + 1; ind < scobj.length; ind++)scobj[ind].esconder = true;
        }
        // generate content and add	to the DOM
        const newcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$502b32cc8ed2e37e), scobj);
        $div.after(newcontent);
        // handler de seleccionar taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_sel_taxon").off("click");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_sel_taxon").click($1ee989753a15371d$var$handlerSeleccionarTaxon);
        // recreate handlers of the expand/collapse buttons
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_expandir_taxon").off("click");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_expandir_taxon").click($1ee989753a15371d$var$handlerExpandTaxon);
        // recreate handlers of the showmore buttons
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".showmore").click($1ee989753a15371d$var$handlerShowmore);
    }
}
function $1ee989753a15371d$var$handlerShowmore() {
    let $div = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).closest(".taxon");
    const indice = +$div.attr("indice");
    // show elements
    let $aux = $div;
    let fin;
    do {
        $aux = $aux.next();
        fin = true;
        if (+$aux.attr("indice") == indice && $aux.hasClass("d-none")) {
            $aux.removeClass("d-none");
            $aux.addClass("d-flex");
            fin = false;
        }
    }while (!fin);
    // remove show more button
    $div.remove();
}
// para formatear las especies
function $1ee989753a15371d$var$getInfoSpecies(spuri) {
    // recupero especie
    const sp = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri];
    // el objeto a devolver
    let spinfo = {};
    // incluyo la uri
    spinfo.uri = spuri;
    // por defecto nombre vulgar
    spinfo.label = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(sp.vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(spuri)));
    // si hay nombre científico...		
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci) {
        spinfo.nc = true;
        spinfo.label = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(sp.scientificName, spinfo.label));
    }
    // info número de clases
    spinfo.nclasses = 0;
    for (let suburi of (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].subclasses)// sólo inserto si tiene datos de wikidata y UN NOMBRE CIENTÍFICO DIFERENTE AL DEL PADRE
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suburi] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suburi].wikidata && (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suburi].scientificName) !== (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].scientificName)) spinfo.nclasses++;
    if (spinfo.nclasses == 0) spinfo.nosubclasses = true;
    // calculo el score
    spinfo.score = 0;
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata.sitelinks) spinfo.score += 3 * +(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata.sitelinks;
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata.statements) spinfo.score += +(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[spuri].wikidata.statements;
    // devuelvo el objeto
    return spinfo;
}
//////////////////////////
// HANDLER SELECCIÓN TAXÓN (común a mapa y formulario)
//////////////////////////
function $1ee989753a15371d$var$handlerSeleccionarTaxon() {
    // obtengo uri del taxon
    const turi = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("spuri");
    // vamos a la selección del taxón
    $1ee989753a15371d$export$17cdb3d0a52387b4(turi);
    // click en botón de seleccionar taxón para cerrar el panel correspondiente
    let $bot = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones");
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === "newtree" || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === "tree") $bot = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd");
    $bot.click();
}
function $1ee989753a15371d$export$17cdb3d0a52387b4(turi) {
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === "newtree" || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === "tree") {
        // guardo IRI y lanzo evento de "change" para poder hacer validación en las anotaciones
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").attr("iri", turi).trigger("change");
        // renderizado
        $1ee989753a15371d$export$5dba38aff426bd77();
    } else {
        // mando evento de filtro de taxón a GA		
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
            content_type: "taxon_filter",
            content_id: turi
        });
        // pongo el taxón en la sesión y reajusto URL
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon = turi;
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
        // cargo la URL
        (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
    }
}
/////////////////////
// HANDLER INFO TAXÓN
/////////////////////
function $1ee989753a15371d$export$2c4bbd56989782d8() {
    // obtengo uri del taxón
    const turi = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("turi");
    // 2023-11 ahora siempre tengo la info a mostrar del taxón, no hay que pedirla al vuelo
    // objeto taxón
    let taxon = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[turi];
    // preparo objeto del modal
    let popobj = {};
    // imagen
    if (taxon.wikidata.image) {
        popobj.hayimagen = true;
        let imgsaux = Array.isArray(taxon.wikidata.image) ? taxon.wikidata.image : [
            taxon.wikidata.image
        ];
        popobj.image = [];
        let first = true;
        for (let img of imgsaux){
            // ajusto tamaño para que tarde menos en recuperarla
            const imgsrc = img.startsWith("http://commons.wikimedia.org/wiki/Special:FilePath") && img.indexOf("?") === -1 ? img + "?width=300" : img;
            popobj.image.push({
                src: imgsrc,
                active: first
            });
            first = false;
        }
        if (popobj.image.length == 1) popobj.image = popobj.image[0].src;
        else popobj.multimages = true;
    }
    // resumen
    if (taxon.wikidata.comment) popobj.resumen = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(taxon.wikidata.comment);
    // nombre científico
    const label = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(taxon.vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(turi)));
    popobj.nomci = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(taxon.scientificName, label));
    // gbifPage
    if (taxon.wikidata && taxon.wikidata.gbifPage) popobj.gbifPage = taxon.wikidata.gbifPage;
    // wikidataPage
    if (taxon.wikidata) popobj.wikidataPage = taxon.wikidata.iri;
    // wikipediaPage
    if (taxon.wikipediaPage) popobj.wikipediaPage = taxon.wikipediaPage;
    // wikispeciesPage
    if (taxon.wikispeciesPage) popobj.wikispeciesPage = taxon.wikispeciesPage;
    // indico tipo: especie, género, familia o clase
    if (taxon.nivel == 0) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).species);
    else if (taxon.nivel == 1) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).genus);
    else if (taxon.nivel == 2) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).family);
    else if (taxon.nivel == 3) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).class);
    // preparo contenido modal
    let tit = "<i>" + popobj.nomci + "</i>";
    let htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$1cfea2c3e1d7bf94), popobj);
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        lg: true,
        nofooter: true
    }, tit, htmlcontent, null);
    // muestro modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    // mando evento de info taxón a GA		
    (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
        content_type: "infoTaxon",
        content_id: turi
    });
}
/////////////////////
// HANDLER IMPORT TAXÓN
/////////////////////
// 2023-11-1 NUEVO
function $1ee989753a15371d$var$handlerImportTaxon() {
    // inicialización modal con su body y todo
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).importtaxon), (0, $646ceeeec66fabd8$export$43bbd40c30a74965).importTaxon, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).importarTaxon);
    // muestro el modal sólo en modo newtree
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === "newtree") {
        const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
        mimodal.show();
    }
    // (en modo anotación ya lo tengo abierto y no hay que mostrarlo)
    // listener de importar
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botimporttaxonwikidata").click($1ee989753a15371d$var$importTaxon);
    // detecto cambios en la entrada de importar taxón
    // "search" es para detectar si el usuario hizo click en la X del formulario (clear button)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").on("keyup search", async function(e) {
        // trato las teclas de arriba, abajo y enter			
        if (e.which == 13) // sólo actúo si hay al menos una sugerencia (y habilitada)
        {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").children(":enabled").length > 0) {
                // si no había ninguna sugerencia seleccionada activo la primera
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus == -1) {
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = 0;
                    $1ee989753a15371d$var$ajustarTaxonfocus(true);
                }
                // y ahora vamos al taxón seleccionado
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").children(":enabled").eq((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus).click();
            }
        } else if (e.which == 40) {
            // incremento focus
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus++;
            $1ee989753a15371d$var$ajustarTaxonfocus(true);
        } else if (e.which == 38) {
            // decremento focus
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus--;
            $1ee989753a15371d$var$ajustarTaxonfocus(true);
        } else if (e.which != undefined) {
            // actúo según la entrada
            const entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
            if (entrada.length == 0) {
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").html("");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomething));
            } else if (entrada.length < 3) {
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").html("");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomethingmore));
            } else {
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").removeClass("d-none");
                //const sugtaxones = await 
                $1ee989753a15371d$var$obtenerSugerenciasTaxonesWD(entrada);
                // mando evento GA si la entrada > 2
                if (entrada.length > 2) (0, $067277e156f7a571$export$7329bcdc3edcd90e)("search", {
                    search_term: entrada,
                    content_type: "taxons"
                });
            }
        } else {
            // caso de la X del formulario... (quito las sugerencias)
            let entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
            if (entrada.length == 0) {
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").html("");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomething));
            }
        }
    }).focusin(function() {
        // vuelve el focus, muestro las sugerencias si hay algo
        let entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
        if (entrada.length > 2) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").removeClass("d-none");
    }).focusout(function() {
        // si pierde el focus escondemos las sugerencias tras un delay
        // el delay es importante para que se pueda clickar un botón antes de eliminar las sugerencias
        setTimeout(function() {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").is(":focus")) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").addClass("d-none");
        }, 300);
    });
    // handler del botón "clearImportTaxon"
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#clearImportTaxon").click(function() {
        // reajusto tamaño del diálogo
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        });
        // quito el taxón del textbox 
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").val("").attr("wdiri", "").prop("disabled", false);
        // habilito y escondo botón "clearImportTaxon"
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#clearImportTaxon").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomething));
        // escondo datos del taxón mostrado		
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#infoTaxonImportar").addClass("d-none");
    });
}
async function $1ee989753a15371d$var$obtenerSugerenciasTaxonesWD(entrada) {
    // inicialización API de búsqueda de texto de Wikidata
    const otwd = {
        lang: (0, $96abbdd7193a3c4b$export$350964a2fface462)(),
        limit: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).limitWD,
        input: entrada
    };
    const urlpet = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).tempTextWD, otwd);
    // spinner y mensaje
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").removeClass("d-none");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).obtainingtaxons));
    try {
        // pido sugerencias a la API de texto de Wikidata		
        if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).urlAPIWD[urlpet]) {
            console.debug(urlpet);
            const response = await fetch(urlpet);
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).urlAPIWD[urlpet] = await response.json();
        }
        let datos = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).urlAPIWD[urlpet];
        // pido los taxones válidos al punto SPARQL de WD y consolido datos
        const taxons = await (0, $174d363c054274ef$export$ad969a5713b03ee4)(datos.search);
        // sólo sigo si coincide la entrada del cajetín de texto con entrada
        const entcaj = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").val();
        if (entrada === entcaj) {
            // preparo array de resultados con la respuesta
            let resultados = [];
            for (let tx of taxons){
                let res = (0, $2q7Wm.default).clone((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[tx]);
                // le meto un score para el sorting
                res.score = 3 * (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[tx].sitelinks + +(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[tx].statements;
                // extra de 300 si es una especie (la detecto porque el nombre tiene dos términos en vez de uno de género o familia)
                if (res.label.split(" ").length == 2) res.score += 300;
                // incluyo en los resultados
                resultados.push(res);
            }
            // ordeno resultados y aplico límite
            resultados = (0, $2q7Wm.default).sortBy(resultados, "score").reverse();
            resultados = resultados.slice(0, (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).numsugs);
            // compruebo heurístico de escribir más para desambiguar
            const heurTypeMore = entcaj.length < 5 && datos.search.length == (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).limitWD;
            // visualizo			
            $1ee989753a15371d$var$renderSugerenciasTaxonesWD(resultados, heurTypeMore);
        }
    } catch (error) {
        console.error("Error fetching data: ", error);
    }
}
function $1ee989753a15371d$var$renderSugerenciasTaxonesWD(resultados, heurTypeMore) {
    // quito spinner
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").addClass("d-none");
    // objeto sugerencias
    let sinfo = {};
    sinfo.sugerencias = [];
    // formateo las sugerencias
    if (resultados.length == 0) {
        sinfo.nosugerencias = true;
        if (heurTypeMore) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).typesomethingmore));
        else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tryanotherstring));
    } else {
        for (let res of resultados)sinfo.sugerencias.push({
            "title": res.label,
            "desc": res.description,
            "wdiri": res.iri
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).selectataxon));
    }
    // muestro sugerencias
    let cont = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$cbaf9c974071f389), sinfo);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").html(cont);
    // handler de los botones de sugerencias de taxones
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".bot_suge_taxonWD").click(async function() {
        // extraigo el taxón
        const wdiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("wdiri");
        // pongo el taxón en el textbox, incluyo wdiri, deshabilito, muestro botón "clearImportTaxon" y quito sugerencias
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").val((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri].label).attr("wdiri", wdiri).prop("disabled", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#clearImportTaxon").removeClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").html("");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugetaxonesWD").addClass("d-none");
        // spinner y mensaje
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").removeClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).obtainingtaxondata));
        // consigo datos del taxón (si no está)
        try {
            await (0, $174d363c054274ef$export$2389aabfa4796a70)(wdiri);
        } catch (err) {
            console.error(err.message);
            // actualizo modal
            const be = "<code>" + err.message + "<br>" + JSON.stringify(err.error) + "</code>";
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonimportingerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
            return; // terminamos
        }
        // spinner y mensaje
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).readytoimport));
        // preparo info del taxón para visualizar
        const txWD = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri];
        let popobj = {};
        // imagen
        if (txWD.image) {
            popobj.hayimagen = true;
            let imgsaux = Array.isArray(txWD.image) ? txWD.image : [
                txWD.image
            ];
            popobj.image = [];
            let first = true;
            for (let img of imgsaux){
                const imgsrc = img.startsWith("http://commons.wikimedia.org/wiki/Special:FilePath") && img.indexOf("?") === -1 ? img + "?width=300" : img;
                popobj.image.push({
                    src: imgsrc,
                    active: first
                });
                first = false;
            }
            if (popobj.image.length == 1) popobj.image = popobj.image[0].src;
            else popobj.multimages = true;
        }
        // resumen
        if (txWD.comment) popobj.resumen = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(txWD.comment);
        // nombre científico
        const label = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(txWD.vulgarName, (0, $96abbdd7193a3c4b$export$56b19e10c1699553)(wdiri)));
        popobj.nomci = (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(txWD.scientificName, label));
        // wikidataPage
        popobj.wikidataPage = wdiri;
        // wikipediaPage
        if (txWD.gbifPage) popobj.gbifPage = txWD.gbifPage;
        // wikipediaPage
        if (txWD.wikipediaPage) popobj.wikipediaPage = txWD.wikipediaPage;
        // wikispeciesPage
        if (txWD.wikispeciesPage) popobj.wikispeciesPage = txWD.wikispeciesPage;
        // indico tipo: especie, género o familia
        if (txWD.isSpecies) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).species);
        else if (txWD.family) popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).genus);
        else popobj.tipo = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).family);
        // renderizo
        let htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$1cfea2c3e1d7bf94), popobj);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#infoTaxonImportar").html(htmlcontent);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#infoTaxonImportar").removeClass("d-none");
        // reajusto tamaño del diálogo
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true,
            lg: true
        });
        // compruebo si existe el taxón
        const txuris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies);
        const txexiste = (0, $2q7Wm.default).find(txuris, function(txuri) {
            return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata.iri === wdiri;
        });
        // si existe, deshabilito el botón de importar, si existe lo habilito
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botimporttaxonwikidata").prop("disabled", !(txexiste == undefined));
        // y si existe, cambio el mensaje adicionalmente
        if (txexiste) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonalreadyimported));
    });
    // inicializo focus
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txfocus = -1;
}
async function $1ee989753a15371d$var$importTaxon() {
    // ACTULIZACIÓN GUI
    // escondo el botón de quitar el taxón
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#clearImportTaxon").addClass("d-none"); //.prop('disabled', true);
    // escondo el contenido de info
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#infoTaxonImportar").addClass("d-none");
    // pongo spinner y mensaje
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").removeClass("d-none");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).importingthetaxon));
    // actualizo modal para quitar el footer y ajustar tamaño
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true,
        nofooter: true
    });
    // recupero los datos del recurso de Wikidata a importar
    const wdiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_importTaxon").attr("wdiri");
    const txWD = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri];
    // cojo todos los taxones (para comprobar si hay que traer más cosas)	
    const txuris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies);
    // preparo entradas para crear los objetos
    let entradas = [];
    // cada entrada consta de estos campos: iriWD, txWD, iri, iriPadre, pedir (varias desconocidas)
    // durante varios pasos completaremos estos datos desde arriba (familia) hasta abajo (especie)
    if (txWD.family) entradas.push({
        iriWD: txWD.family
    });
    if (txWD.genus) entradas.push({
        iriWD: txWD.genus
    });
    entradas.push({
        iriWD: wdiri,
        txWD: txWD
    });
    // extraigo los txWD de cada entrada
    // (pediré datos de WD que puede que no necesite, pero es un mal menor => máximo una petición para gen y otra para fam)
    for (let ent of entradas){
        if (!ent.txWD && (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[ent.iriWD] || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[ent.iriWD].pending)) await (0, $174d363c054274ef$export$2389aabfa4796a70)(ent.iriWD);
        if (!ent.txWD) ent.txWD = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[ent.iriWD];
    }
    // aquí ya tengo completo iriWD y txWD en todas, completo resto de campos
    for (let ent of entradas){
        const iri = (0, $2q7Wm.default).find(txuris, function(txuri) {
            return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata.iri === ent.iriWD;
        });
        if (iri) ent.pedir = false;
        else {
            // hay que pedir, completo datos en campos restantes
            ent.pedir = true;
            ent.iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/taxon/" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(ent.txWD.scientificName).replace(" ", "_");
            if (!ent.txWD.family) ent.iriPadre = ent.txWD.isConifer ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).especiesTop[0] : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).especiesTop[1];
            else {
                // necesitaré buscar entre las especies a partir de iriPadreWD
                const iriPadreWD = ent.txWD.genus ? ent.txWD.genus : ent.txWD.family;
                ent.iriPadre = (0, $2q7Wm.default).find(txuris, function(txuri) {
                    return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].wikidata.iri === iriPadreWD;
                });
                if (!ent.iriPadre) {
                    const scPadre = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[iriPadreWD].scientificName;
                    ent.iriPadre = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/taxon/" + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(scPadre).replace(" ", "_");
                }
            }
        }
    }
    // en este punto compruebo que siguen sin existir los taxones a crear 
    // (para evitar que se creen dos veces, aunque esto no debería suponer un problema)
    const irisWDcomprobar = (0, $2q7Wm.default).pluck(entradas, "iriWD");
    const irisWDexisten = await (0, $174d363c054274ef$export$5e6ebc4b1b859630)(irisWDcomprobar);
    // genero array de objetos con los recursos a crear
    let objetosCrear = [];
    let irisWDCrear = [];
    for (let ent of entradas)if (ent.pedir && !(0, $2q7Wm.default).contains(irisWDexisten, function(iri) {
        return ent.iriWD;
    })) objetosCrear.push($1ee989753a15371d$var$prepareTaxonObjectWD(ent.iri, ent.iriWD, ent.iriPadre));
    // hago las llamadas para crear las especies
    try {
        for (let oc of objetosCrear){
            // inicializo evento de creación de taxón a GA
            (0, $067277e156f7a571$export$639f48199cd2287d)({
                content_type: "taxon",
                content_id: oc.iri,
                uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
                crafts_reqs: 0
            });
            // aquí sólo se hace el PUT a CRAFTS, el ajuste de datos se realiza en esta misma función 		
            await (0, $174d363c054274ef$export$f4b4fb77e87b331a)(oc);
            // envío datos creación de la especie a GA			
            (0, $067277e156f7a571$export$6adbd77fe07ba13)("create_content");
            console.info("Tax\xf3n creado con IRI: " + oc.iri); // log
        }
    } catch (err) {
        console.error(err.message);
        // actualizo modal
        const be = "<code>" + err.message + "<br>" + JSON.stringify(err.error) + "</code>";
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonimportingerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
        return; // terminamos
    }
    // ya están creados, incluyo nuevos taxones en Datos.especies
    // (esto lo hago incluso si fueron creados por otro usuario en el interlapso)
    for (let ent of entradas)if (ent.pedir) (0, $174d363c054274ef$export$25fe61d80318b90d)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies, ent.iri);
    for (let ent of entradas)if (ent.pedir) {
        //console.log("iri: " + ent.iri + " - iriPadre: " + ent.iriPadre);
        // guardo subclase
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iriPadre].subclasses.push(ent.iri);
        // guardo superclase
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].superclasses.push(ent.iriPadre);
        // guardo resto de datos
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].scientificName = ent.txWD.scientificName;
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].vulgarName = ent.txWD.vulgarName;
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].wikipediaPage = ent.txWD.wikipediaPage;
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].wikispeciesPage = ent.txWD.wikispeciesPage;
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[ent.iri].wikidata = {
            iri: ent.iriWD,
            image: ent.txWD.image,
            gbifPage: ent.txWD.gbifPage,
            sitelinks: ent.txWD.sitelinks,
            statements: ent.txWD.statements,
            comment: ent.txWD.comment
        };
    }
    // regenero las especies expandidas
    (0, $174d363c054274ef$export$14ba48f8fbb8469)(true);
    // por último, vuelvo a la tarea anterior
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path === "newtree") {
        // informo en el diálogo
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusImportTaxon").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonimported));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#spinnerImport").addClass("d-none");
        // actualizo modal para mostrar el footer
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, null, null, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
        // hago la selección del taxón (por fin)
        // ojo: uso la iri de la última entrada
        $1ee989753a15371d$export$17cdb3d0a52387b4(entradas[entradas.length - 1].iri);
        // click en botón de seleccionar taxón para cerrar el panel correspondiente
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").click();
    } else {
        // estoy anotando un taxón, rehago el diálogo
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true,
            nobody: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newAnnotation), (0, $646ceeeec66fabd8$export$43bbd40c30a74965).treeTaxon, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).crearAnotacion);
        // handler al botón de procesar anotación
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").click((0, $27fe9e683b34e1a0$export$a8fce3b21dbb0466));
        // ajusto nomci 
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#anchecknomci").prop("checked", (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#anchecknomci").change($1ee989753a15371d$export$d67e2296dd6db17d);
        // detecto cambio en treeTaxon
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").change(function() {
            const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
            const ttiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").attr("iri");
            // preinicializo
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
            if (!ttiri) //console.log("No hay nada");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noAnnotation));
            else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species && ttiri === (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].species.species.iri) //console.log("Misma iri que antes (!)");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).sameAnnotation));
            else {
                //console.log("Todo OK");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusAnnotation").addClass("d-none");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
            }
        });
        // hago la selección del taxón (por fin)
        // ojo: uso la iri de la última entrada
        $1ee989753a15371d$export$17cdb3d0a52387b4(entradas[entradas.length - 1].iri);
    }
    // borro el contenido de la navegación de taxones
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block_newtree").html("");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block").html("");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block").addClass("d-none");
}
function $1ee989753a15371d$var$prepareTaxonObjectWD(iri, iriWD, iriPadre) {
    // recupero info del taxón de Wikidata
    const txWD = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[iriWD];
    if (!txWD) return undefined;
    // preparo objeto a devolver
    let txobj = {
        "iri": iri,
        "creator": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
        "created": new Date().toISOString(),
        "types": [
            "http://www.w3.org/2002/07/owl#Class",
            "http://www.w3.org/2000/01/rdf-schema#Class",
            txWD.isSpecies ? "https://datos.iepnb.es/def/sector-publico/medio-ambiente/ifn/Species" : txWD.family ? "https://datos.iepnb.es/def/sector-publico/medio-ambiente/ifn/Genus" : "https://datos.iepnb.es/def/sector-publico/medio-ambiente/ifn/Family"
        ],
        "subclasses": [
            iriPadre,
            txWD.iri
        ],
        "scientificName": (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(txWD.scientificName)
    };
    // fusiono vulgarName y label en vulgarName
    //txobj.vulgarName = fuseItems(txWD.vulgarName, txWD.label);
    if (txWD.vulgarName) txobj.vulgarName = txWD.vulgarName;
    if (txWD.wikipediaPage) txobj.wikipediaPage = txWD.wikipediaPage;
    if (txWD.wikispeciesPage) txobj.wikispeciesPage = txWD.wikispeciesPage;
    // y devuelvo
    return txobj;
}





/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
/*! shepherd.js 11.2.0 */ var $398b6f99c6877d63$var$isMergeableObject = function isMergeableObject(value) {
    return $398b6f99c6877d63$var$isNonNullObject(value) && !$398b6f99c6877d63$var$isSpecial(value);
};
function $398b6f99c6877d63$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $398b6f99c6877d63$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $398b6f99c6877d63$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $398b6f99c6877d63$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $398b6f99c6877d63$var$REACT_ELEMENT_TYPE = $398b6f99c6877d63$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $398b6f99c6877d63$var$isReactElement(value) {
    return value.$$typeof === $398b6f99c6877d63$var$REACT_ELEMENT_TYPE;
}
function $398b6f99c6877d63$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $398b6f99c6877d63$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $398b6f99c6877d63$var$deepmerge($398b6f99c6877d63$var$emptyTarget(value), value, options) : value;
}
function $398b6f99c6877d63$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $398b6f99c6877d63$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $398b6f99c6877d63$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $398b6f99c6877d63$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $398b6f99c6877d63$var$deepmerge;
}
function $398b6f99c6877d63$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $398b6f99c6877d63$var$getKeys(target) {
    return Object.keys(target).concat($398b6f99c6877d63$var$getEnumerableOwnPropertySymbols(target));
}
function $398b6f99c6877d63$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $398b6f99c6877d63$var$propertyIsUnsafe(target, key) {
    return $398b6f99c6877d63$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}
function $398b6f99c6877d63$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $398b6f99c6877d63$var$getKeys(target).forEach(function(key) {
        destination[key] = $398b6f99c6877d63$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $398b6f99c6877d63$var$getKeys(source).forEach(function(key) {
        if ($398b6f99c6877d63$var$propertyIsUnsafe(target, key)) return;
        if ($398b6f99c6877d63$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $398b6f99c6877d63$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $398b6f99c6877d63$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $398b6f99c6877d63$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $398b6f99c6877d63$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $398b6f99c6877d63$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $398b6f99c6877d63$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $398b6f99c6877d63$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $398b6f99c6877d63$var$mergeObject(target, source, options);
}
$398b6f99c6877d63$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $398b6f99c6877d63$var$deepmerge(prev, next, options);
    }, {});
};
var $398b6f99c6877d63$var$deepmerge_1 = $398b6f99c6877d63$var$deepmerge;
var $398b6f99c6877d63$var$cjs = $398b6f99c6877d63$var$deepmerge_1;
/**
 * Checks if `value` is classified as an `Element`.
 * @param {*} value The param to check if it is an Element
 */ function $398b6f99c6877d63$var$isElement$1(value) {
    return value instanceof Element;
}
/**
 * Checks if `value` is classified as an `HTMLElement`.
 * @param {*} value The param to check if it is an HTMLElement
 */ function $398b6f99c6877d63$var$isHTMLElement$1(value) {
    return value instanceof HTMLElement;
}
/**
 * Checks if `value` is classified as a `Function` object.
 * @param {*} value The param to check if it is a function
 */ function $398b6f99c6877d63$var$isFunction(value) {
    return typeof value === "function";
}
/**
 * Checks if `value` is classified as a `String` object.
 * @param {*} value The param to check if it is a string
 */ function $398b6f99c6877d63$var$isString(value) {
    return typeof value === "string";
}
/**
 * Checks if `value` is undefined.
 * @param {*} value The param to check if it is undefined
 */ function $398b6f99c6877d63$var$isUndefined(value) {
    return value === undefined;
}
class $398b6f99c6877d63$var$Evented {
    on(event, handler, ctx, once = false) {
        if ($398b6f99c6877d63$var$isUndefined(this.bindings)) this.bindings = {};
        if ($398b6f99c6877d63$var$isUndefined(this.bindings[event])) this.bindings[event] = [];
        this.bindings[event].push({
            handler: handler,
            ctx: ctx,
            once: once
        });
        return this;
    }
    once(event, handler, ctx) {
        return this.on(event, handler, ctx, true);
    }
    off(event, handler) {
        if ($398b6f99c6877d63$var$isUndefined(this.bindings) || $398b6f99c6877d63$var$isUndefined(this.bindings[event])) return this;
        if ($398b6f99c6877d63$var$isUndefined(handler)) delete this.bindings[event];
        else this.bindings[event].forEach((binding, index)=>{
            if (binding.handler === handler) this.bindings[event].splice(index, 1);
        });
        return this;
    }
    trigger(event, ...args) {
        if (!$398b6f99c6877d63$var$isUndefined(this.bindings) && this.bindings[event]) this.bindings[event].forEach((binding, index)=>{
            const { ctx: ctx, handler: handler, once: once } = binding;
            const context = ctx || this;
            handler.apply(context, args);
            if (once) this.bindings[event].splice(index, 1);
        });
        return this;
    }
}
/**
 * Binds all the methods on a JS Class to the `this` context of the class.
 * Adapted from https://github.com/sindresorhus/auto-bind
 * @param {object} self The `this` context of the class
 * @return {object} The `this` context of the class
 */ function $398b6f99c6877d63$var$autoBind(self) {
    const keys = Object.getOwnPropertyNames(self.constructor.prototype);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const val = self[key];
        if (key !== "constructor" && typeof val === "function") self[key] = val.bind(self);
    }
    return self;
}
/**
 * Sets up the handler to determine if we should advance the tour
 * @param {string} selector
 * @param {Step} step The step instance
 * @return {Function}
 * @private
 */ function $398b6f99c6877d63$var$_setupAdvanceOnHandler(selector, step) {
    return (event)=>{
        if (step.isOpen()) {
            const targetIsEl = step.el && event.currentTarget === step.el;
            const targetIsSelector = !$398b6f99c6877d63$var$isUndefined(selector) && event.currentTarget.matches(selector);
            if (targetIsSelector || targetIsEl) step.tour.next();
        }
    };
}
/**
 * Bind the event handler for advanceOn
 * @param {Step} step The step instance
 */ function $398b6f99c6877d63$var$bindAdvance(step) {
    // An empty selector matches the step element
    const { event: event, selector: selector } = step.options.advanceOn || {};
    if (event) {
        const handler = $398b6f99c6877d63$var$_setupAdvanceOnHandler(selector, step);
        // TODO: this should also bind/unbind on show/hide
        let el;
        try {
            el = document.querySelector(selector);
        } catch (e) {
        // TODO
        }
        if (!$398b6f99c6877d63$var$isUndefined(selector) && !el) return console.error(`No element was found for the selector supplied to advanceOn: ${selector}`);
        else if (el) {
            el.addEventListener(event, handler);
            step.on("destroy", ()=>{
                return el.removeEventListener(event, handler);
            });
        } else {
            document.body.addEventListener(event, handler, true);
            step.on("destroy", ()=>{
                return document.body.removeEventListener(event, handler, true);
            });
        }
    } else return console.error("advanceOn was defined, but no event name was passed.");
}
/**
 * Ensure class prefix ends in `-`
 * @param {string} prefix The prefix to prepend to the class names generated by nano-css
 * @return {string} The prefix ending in `-`
 */ function $398b6f99c6877d63$var$normalizePrefix(prefix) {
    if (!$398b6f99c6877d63$var$isString(prefix) || prefix === "") return "";
    return prefix.charAt(prefix.length - 1) !== "-" ? `${prefix}-` : prefix;
}
/**
 * Resolves attachTo options, converting element option value to a qualified HTMLElement.
 * @param {Step} step The step instance
 * @returns {{}|{element, on}}
 * `element` is a qualified HTML Element
 * `on` is a string position value
 */ function $398b6f99c6877d63$var$parseAttachTo(step) {
    const options = step.options.attachTo || {};
    const returnOpts = Object.assign({}, options);
    if ($398b6f99c6877d63$var$isFunction(returnOpts.element)) // Bind the callback to step so that it has access to the object, to enable running additional logic
    returnOpts.element = returnOpts.element.call(step);
    if ($398b6f99c6877d63$var$isString(returnOpts.element)) {
        // Can't override the element in user opts reference because we can't
        // guarantee that the element will exist in the future.
        try {
            returnOpts.element = document.querySelector(returnOpts.element);
        } catch (e) {
        // TODO
        }
        if (!returnOpts.element) console.error(`The element for this Shepherd step was not found ${options.element}`);
    }
    return returnOpts;
}
/**
 * Checks if the step should be centered or not. Does not trigger attachTo.element evaluation, making it a pure
 * alternative for the deprecated step.isCentered() method.
 * @param resolvedAttachToOptions
 * @returns {boolean}
 */ function $398b6f99c6877d63$var$shouldCenterStep(resolvedAttachToOptions) {
    if (resolvedAttachToOptions === undefined || resolvedAttachToOptions === null) return true;
    return !resolvedAttachToOptions.element || !resolvedAttachToOptions.on;
}
/**
 * Create a unique id for steps, tours, modals, etc
 * @return {string}
 */ function $398b6f99c6877d63$var$uuid() {
    let d = Date.now();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
}
function $398b6f99c6877d63$var$_extends() {
    $398b6f99c6877d63$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $398b6f99c6877d63$var$_extends.apply(this, arguments);
}
function $398b6f99c6877d63$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $398b6f99c6877d63$var$min = Math.min;
const $398b6f99c6877d63$var$max = Math.max;
const $398b6f99c6877d63$var$round = Math.round;
const $398b6f99c6877d63$var$floor = Math.floor;
const $398b6f99c6877d63$var$createCoords = (v)=>({
        x: v,
        y: v
    });
const $398b6f99c6877d63$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $398b6f99c6877d63$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $398b6f99c6877d63$var$clamp(start, value, end) {
    return $398b6f99c6877d63$var$max(start, $398b6f99c6877d63$var$min(value, end));
}
function $398b6f99c6877d63$var$evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $398b6f99c6877d63$var$getSide(placement) {
    return placement.split("-")[0];
}
function $398b6f99c6877d63$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $398b6f99c6877d63$var$getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function $398b6f99c6877d63$var$getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function $398b6f99c6877d63$var$getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes($398b6f99c6877d63$var$getSide(placement)) ? "y" : "x";
}
function $398b6f99c6877d63$var$getAlignmentAxis(placement) {
    return $398b6f99c6877d63$var$getOppositeAxis($398b6f99c6877d63$var$getSideAxis(placement));
}
function $398b6f99c6877d63$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $398b6f99c6877d63$var$getAlignment(placement);
    const alignmentAxis = $398b6f99c6877d63$var$getAlignmentAxis(placement);
    const length = $398b6f99c6877d63$var$getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $398b6f99c6877d63$var$getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $398b6f99c6877d63$var$getOppositePlacement(mainAlignmentSide)
    ];
}
function $398b6f99c6877d63$var$getExpandedPlacements(placement) {
    const oppositePlacement = $398b6f99c6877d63$var$getOppositePlacement(placement);
    return [
        $398b6f99c6877d63$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $398b6f99c6877d63$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $398b6f99c6877d63$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>$398b6f99c6877d63$var$oppositeAlignmentMap[alignment]);
}
function $398b6f99c6877d63$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $398b6f99c6877d63$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = $398b6f99c6877d63$var$getAlignment(placement);
    let list = $398b6f99c6877d63$var$getSideList($398b6f99c6877d63$var$getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($398b6f99c6877d63$var$getOppositeAlignmentPlacement));
    }
    return list;
}
function $398b6f99c6877d63$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$398b6f99c6877d63$var$oppositeSideMap[side]);
}
function $398b6f99c6877d63$var$expandPaddingObject(padding) {
    return $398b6f99c6877d63$var$_extends({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $398b6f99c6877d63$var$getPaddingObject(padding) {
    return typeof padding !== "number" ? $398b6f99c6877d63$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $398b6f99c6877d63$var$rectToClientRect(rect) {
    return $398b6f99c6877d63$var$_extends({}, rect, {
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}
const $398b6f99c6877d63$var$_excluded2 = [
    "mainAxis",
    "crossAxis",
    "fallbackPlacements",
    "fallbackStrategy",
    "fallbackAxisSideDirection",
    "flipAlignment"
], $398b6f99c6877d63$var$_excluded4 = [
    "mainAxis",
    "crossAxis",
    "limiter"
];
function $398b6f99c6877d63$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = $398b6f99c6877d63$var$getSideAxis(placement);
    const alignmentAxis = $398b6f99c6877d63$var$getAlignmentAxis(placement);
    const alignLength = $398b6f99c6877d63$var$getAxisLength(alignmentAxis);
    const side = $398b6f99c6877d63$var$getSide(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($398b6f99c6877d63$var$getAlignment(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $398b6f99c6877d63$var$computePosition$1 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $398b6f99c6877d63$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = $398b6f99c6877d63$var$_extends({}, middlewareData, {
            [name]: $398b6f99c6877d63$var$_extends({}, middlewareData[name], data)
        });
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $398b6f99c6877d63$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $398b6f99c6877d63$var$detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = $398b6f99c6877d63$var$evaluate(options, state);
    const paddingObject = $398b6f99c6877d63$var$getPaddingObject(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $398b6f99c6877d63$var$rectToClientRect(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? $398b6f99c6877d63$var$_extends({}, rects.floating, {
        x: x,
        y: y
    }) : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = $398b6f99c6877d63$var$rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $398b6f99c6877d63$var$arrow = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = $398b6f99c6877d63$var$evaluate(options, state) || {};
            if (element == null) return {};
            const paddingObject = $398b6f99c6877d63$var$getPaddingObject(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = $398b6f99c6877d63$var$getAlignmentAxis(placement);
            const length = $398b6f99c6877d63$var$getAxisLength(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = $398b6f99c6877d63$var$min(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = $398b6f99c6877d63$var$min(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = $398b6f99c6877d63$var$clamp(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. This stops `shift()` from taking action, but can
            // be worked around by calling it again after the `arrow()` if desired.
            const shouldAddOffset = $398b6f99c6877d63$var$getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? min$1 - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset + alignmentOffset
                }
            };
        }
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $398b6f99c6877d63$var$flip = function flip(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate2 = $398b6f99c6877d63$var$evaluate(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true } = _evaluate2, detectOverflowOptions = $398b6f99c6877d63$var$_objectWithoutPropertiesLoose(_evaluate2, $398b6f99c6877d63$var$_excluded2);
            const side = $398b6f99c6877d63$var$getSide(placement);
            const isBasePlacement = $398b6f99c6877d63$var$getSide(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $398b6f99c6877d63$var$getOppositePlacement(initialPlacement)
            ] : $398b6f99c6877d63$var$getExpandedPlacements(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...$398b6f99c6877d63$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $398b6f99c6877d63$var$detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = $398b6f99c6877d63$var$getAlignmentSides(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $398b6f99c6877d63$var$shift = function shift(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const _evaluate4 = $398b6f99c6877d63$var$evaluate(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate4, detectOverflowOptions = $398b6f99c6877d63$var$_objectWithoutPropertiesLoose(_evaluate4, $398b6f99c6877d63$var$_excluded4);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $398b6f99c6877d63$var$detectOverflow(state, detectOverflowOptions);
            const crossAxis = $398b6f99c6877d63$var$getSideAxis($398b6f99c6877d63$var$getSide(placement));
            const mainAxis = $398b6f99c6877d63$var$getOppositeAxis(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $398b6f99c6877d63$var$clamp(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $398b6f99c6877d63$var$clamp(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn($398b6f99c6877d63$var$_extends({}, state, {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return $398b6f99c6877d63$var$_extends({}, limitedCoords, {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $398b6f99c6877d63$var$limitShift = function limitShift(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = $398b6f99c6877d63$var$evaluate(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = $398b6f99c6877d63$var$getSideAxis(placement);
            const mainAxis = $398b6f99c6877d63$var$getOppositeAxis(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = $398b6f99c6877d63$var$evaluate(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : $398b6f99c6877d63$var$_extends({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes($398b6f99c6877d63$var$getSide(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
function $398b6f99c6877d63$var$getNodeName(node) {
    if ($398b6f99c6877d63$var$isNode(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $398b6f99c6877d63$var$getWindow(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $398b6f99c6877d63$var$getDocumentElement(node) {
    var _ref;
    return (_ref = ($398b6f99c6877d63$var$isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $398b6f99c6877d63$var$isNode(value) {
    return value instanceof Node || value instanceof $398b6f99c6877d63$var$getWindow(value).Node;
}
function $398b6f99c6877d63$var$isElement(value) {
    return value instanceof Element || value instanceof $398b6f99c6877d63$var$getWindow(value).Element;
}
function $398b6f99c6877d63$var$isHTMLElement(value) {
    return value instanceof HTMLElement || value instanceof $398b6f99c6877d63$var$getWindow(value).HTMLElement;
}
function $398b6f99c6877d63$var$isShadowRoot(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $398b6f99c6877d63$var$getWindow(value).ShadowRoot;
}
function $398b6f99c6877d63$var$isOverflowElement(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $398b6f99c6877d63$var$getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $398b6f99c6877d63$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($398b6f99c6877d63$var$getNodeName(element));
}
function $398b6f99c6877d63$var$isContainingBlock(element) {
    const webkit = $398b6f99c6877d63$var$isWebKit();
    const css = $398b6f99c6877d63$var$getComputedStyle(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $398b6f99c6877d63$var$getContainingBlock(element) {
    let currentNode = $398b6f99c6877d63$var$getParentNode(element);
    while($398b6f99c6877d63$var$isHTMLElement(currentNode) && !$398b6f99c6877d63$var$isLastTraversableNode(currentNode)){
        if ($398b6f99c6877d63$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = $398b6f99c6877d63$var$getParentNode(currentNode);
    }
    return null;
}
function $398b6f99c6877d63$var$isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $398b6f99c6877d63$var$isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($398b6f99c6877d63$var$getNodeName(node));
}
function $398b6f99c6877d63$var$getComputedStyle(element) {
    return $398b6f99c6877d63$var$getWindow(element).getComputedStyle(element);
}
function $398b6f99c6877d63$var$getNodeScroll(element) {
    if ($398b6f99c6877d63$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $398b6f99c6877d63$var$getParentNode(node) {
    if ($398b6f99c6877d63$var$getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $398b6f99c6877d63$var$isShadowRoot(node) && node.host || // Fallback.
    $398b6f99c6877d63$var$getDocumentElement(node);
    return $398b6f99c6877d63$var$isShadowRoot(result) ? result.host : result;
}
function $398b6f99c6877d63$var$getNearestOverflowAncestor(node) {
    const parentNode = $398b6f99c6877d63$var$getParentNode(node);
    if ($398b6f99c6877d63$var$isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($398b6f99c6877d63$var$isHTMLElement(parentNode) && $398b6f99c6877d63$var$isOverflowElement(parentNode)) return parentNode;
    return $398b6f99c6877d63$var$getNearestOverflowAncestor(parentNode);
}
function $398b6f99c6877d63$var$getOverflowAncestors(node, list) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    const scrollableAncestor = $398b6f99c6877d63$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $398b6f99c6877d63$var$getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $398b6f99c6877d63$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
    return list.concat(scrollableAncestor, $398b6f99c6877d63$var$getOverflowAncestors(scrollableAncestor));
}
function $398b6f99c6877d63$var$getCssDimensions(element) {
    const css = $398b6f99c6877d63$var$getComputedStyle(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = $398b6f99c6877d63$var$isHTMLElement(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = $398b6f99c6877d63$var$round(width) !== offsetWidth || $398b6f99c6877d63$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $398b6f99c6877d63$var$unwrapElement(element) {
    return !$398b6f99c6877d63$var$isElement(element) ? element.contextElement : element;
}
function $398b6f99c6877d63$var$getScale(element) {
    const domElement = $398b6f99c6877d63$var$unwrapElement(element);
    if (!$398b6f99c6877d63$var$isHTMLElement(domElement)) return $398b6f99c6877d63$var$createCoords(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $398b6f99c6877d63$var$getCssDimensions(domElement);
    let x = ($ ? $398b6f99c6877d63$var$round(rect.width) : rect.width) / width;
    let y = ($ ? $398b6f99c6877d63$var$round(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $398b6f99c6877d63$var$noOffsets = /*#__PURE__*/ $398b6f99c6877d63$var$createCoords(0);
function $398b6f99c6877d63$var$getVisualOffsets(element) {
    const win = $398b6f99c6877d63$var$getWindow(element);
    if (!$398b6f99c6877d63$var$isWebKit() || !win.visualViewport) return $398b6f99c6877d63$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $398b6f99c6877d63$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== $398b6f99c6877d63$var$getWindow(element)) return false;
    return isFixed;
}
function $398b6f99c6877d63$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $398b6f99c6877d63$var$unwrapElement(element);
    let scale = $398b6f99c6877d63$var$createCoords(1);
    if (includeScale) {
        if (offsetParent) {
            if ($398b6f99c6877d63$var$isElement(offsetParent)) scale = $398b6f99c6877d63$var$getScale(offsetParent);
        } else scale = $398b6f99c6877d63$var$getScale(element);
    }
    const visualOffsets = $398b6f99c6877d63$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $398b6f99c6877d63$var$getVisualOffsets(domElement) : $398b6f99c6877d63$var$createCoords(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = $398b6f99c6877d63$var$getWindow(domElement);
        const offsetWin = offsetParent && $398b6f99c6877d63$var$isElement(offsetParent) ? $398b6f99c6877d63$var$getWindow(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $398b6f99c6877d63$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = $398b6f99c6877d63$var$getComputedStyle(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = $398b6f99c6877d63$var$getWindow(currentIFrame).frameElement;
        }
    }
    return $398b6f99c6877d63$var$rectToClientRect({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $398b6f99c6877d63$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = $398b6f99c6877d63$var$isHTMLElement(offsetParent);
    const documentElement = $398b6f99c6877d63$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = $398b6f99c6877d63$var$createCoords(1);
    const offsets = $398b6f99c6877d63$var$createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($398b6f99c6877d63$var$getNodeName(offsetParent) !== "body" || $398b6f99c6877d63$var$isOverflowElement(documentElement)) scroll = $398b6f99c6877d63$var$getNodeScroll(offsetParent);
        if ($398b6f99c6877d63$var$isHTMLElement(offsetParent)) {
            const offsetRect = $398b6f99c6877d63$var$getBoundingClientRect(offsetParent);
            scale = $398b6f99c6877d63$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $398b6f99c6877d63$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $398b6f99c6877d63$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $398b6f99c6877d63$var$getBoundingClientRect($398b6f99c6877d63$var$getDocumentElement(element)).left + $398b6f99c6877d63$var$getNodeScroll(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $398b6f99c6877d63$var$getDocumentRect(element) {
    const html = $398b6f99c6877d63$var$getDocumentElement(element);
    const scroll = $398b6f99c6877d63$var$getNodeScroll(element);
    const body = element.ownerDocument.body;
    const width = $398b6f99c6877d63$var$max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = $398b6f99c6877d63$var$max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $398b6f99c6877d63$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($398b6f99c6877d63$var$getComputedStyle(body).direction === "rtl") x += $398b6f99c6877d63$var$max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $398b6f99c6877d63$var$getViewportRect(element, strategy) {
    const win = $398b6f99c6877d63$var$getWindow(element);
    const html = $398b6f99c6877d63$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = $398b6f99c6877d63$var$isWebKit();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $398b6f99c6877d63$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $398b6f99c6877d63$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $398b6f99c6877d63$var$isHTMLElement(element) ? $398b6f99c6877d63$var$getScale(element) : $398b6f99c6877d63$var$createCoords(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $398b6f99c6877d63$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $398b6f99c6877d63$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $398b6f99c6877d63$var$getDocumentRect($398b6f99c6877d63$var$getDocumentElement(element));
    else if ($398b6f99c6877d63$var$isElement(clippingAncestor)) rect = $398b6f99c6877d63$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $398b6f99c6877d63$var$getVisualOffsets(element);
        rect = $398b6f99c6877d63$var$_extends({}, clippingAncestor, {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return $398b6f99c6877d63$var$rectToClientRect(rect);
}
function $398b6f99c6877d63$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = $398b6f99c6877d63$var$getParentNode(element);
    if (parentNode === stopNode || !$398b6f99c6877d63$var$isElement(parentNode) || $398b6f99c6877d63$var$isLastTraversableNode(parentNode)) return false;
    return $398b6f99c6877d63$var$getComputedStyle(parentNode).position === "fixed" || $398b6f99c6877d63$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $398b6f99c6877d63$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = $398b6f99c6877d63$var$getOverflowAncestors(element).filter((el)=>$398b6f99c6877d63$var$isElement(el) && $398b6f99c6877d63$var$getNodeName(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = $398b6f99c6877d63$var$getComputedStyle(element).position === "fixed";
    let currentNode = elementIsFixed ? $398b6f99c6877d63$var$getParentNode(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while($398b6f99c6877d63$var$isElement(currentNode) && !$398b6f99c6877d63$var$isLastTraversableNode(currentNode)){
        const computedStyle = $398b6f99c6877d63$var$getComputedStyle(currentNode);
        const currentNodeIsContaining = $398b6f99c6877d63$var$isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || $398b6f99c6877d63$var$isOverflowElement(currentNode) && !currentNodeIsContaining && $398b6f99c6877d63$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = $398b6f99c6877d63$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $398b6f99c6877d63$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $398b6f99c6877d63$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $398b6f99c6877d63$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $398b6f99c6877d63$var$max(rect.top, accRect.top);
        accRect.right = $398b6f99c6877d63$var$min(rect.right, accRect.right);
        accRect.bottom = $398b6f99c6877d63$var$min(rect.bottom, accRect.bottom);
        accRect.left = $398b6f99c6877d63$var$max(rect.left, accRect.left);
        return accRect;
    }, $398b6f99c6877d63$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $398b6f99c6877d63$var$getDimensions(element) {
    return $398b6f99c6877d63$var$getCssDimensions(element);
}
function $398b6f99c6877d63$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $398b6f99c6877d63$var$isHTMLElement(offsetParent);
    const documentElement = $398b6f99c6877d63$var$getDocumentElement(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $398b6f99c6877d63$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = $398b6f99c6877d63$var$createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($398b6f99c6877d63$var$getNodeName(offsetParent) !== "body" || $398b6f99c6877d63$var$isOverflowElement(documentElement)) scroll = $398b6f99c6877d63$var$getNodeScroll(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $398b6f99c6877d63$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $398b6f99c6877d63$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $398b6f99c6877d63$var$getTrueOffsetParent(element, polyfill) {
    if (!$398b6f99c6877d63$var$isHTMLElement(element) || $398b6f99c6877d63$var$getComputedStyle(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $398b6f99c6877d63$var$getOffsetParent(element, polyfill) {
    const window1 = $398b6f99c6877d63$var$getWindow(element);
    if (!$398b6f99c6877d63$var$isHTMLElement(element)) return window1;
    let offsetParent = $398b6f99c6877d63$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && $398b6f99c6877d63$var$isTableElement(offsetParent) && $398b6f99c6877d63$var$getComputedStyle(offsetParent).position === "static")offsetParent = $398b6f99c6877d63$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ($398b6f99c6877d63$var$getNodeName(offsetParent) === "html" || $398b6f99c6877d63$var$getNodeName(offsetParent) === "body" && $398b6f99c6877d63$var$getComputedStyle(offsetParent).position === "static" && !$398b6f99c6877d63$var$isContainingBlock(offsetParent))) return window1;
    return offsetParent || $398b6f99c6877d63$var$getContainingBlock(element) || window1;
}
const $398b6f99c6877d63$var$getElementRects = async function getElementRects(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $398b6f99c6877d63$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $398b6f99c6877d63$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: $398b6f99c6877d63$var$_extends({
            x: 0,
            y: 0
        }, await getDimensionsFn(floating))
    };
};
function $398b6f99c6877d63$var$isRTL(element) {
    return $398b6f99c6877d63$var$getComputedStyle(element).direction === "rtl";
}
const $398b6f99c6877d63$var$platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $398b6f99c6877d63$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $398b6f99c6877d63$var$getDocumentElement,
    getClippingRect: $398b6f99c6877d63$var$getClippingRect,
    getOffsetParent: $398b6f99c6877d63$var$getOffsetParent,
    getElementRects: $398b6f99c6877d63$var$getElementRects,
    getClientRects: $398b6f99c6877d63$var$getClientRects,
    getDimensions: $398b6f99c6877d63$var$getDimensions,
    getScale: $398b6f99c6877d63$var$getScale,
    isElement: $398b6f99c6877d63$var$isElement,
    isRTL: $398b6f99c6877d63$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $398b6f99c6877d63$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = $398b6f99c6877d63$var$getDocumentElement(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = $398b6f99c6877d63$var$floor(top);
        const insetRight = $398b6f99c6877d63$var$floor(root.clientWidth - (left + width));
        const insetBottom = $398b6f99c6877d63$var$floor(root.clientHeight - (top + height));
        const insetLeft = $398b6f99c6877d63$var$floor(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: $398b6f99c6877d63$var$max(0, $398b6f99c6877d63$var$min(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, $398b6f99c6877d63$var$_extends({}, options, {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $398b6f99c6877d63$var$autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $398b6f99c6877d63$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? $398b6f99c6877d63$var$getOverflowAncestors(referenceEl) : [],
        ...$398b6f99c6877d63$var$getOverflowAncestors(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $398b6f99c6877d63$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $398b6f99c6877d63$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $398b6f99c6877d63$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $398b6f99c6877d63$var$computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = $398b6f99c6877d63$var$_extends({
        platform: $398b6f99c6877d63$var$platform
    }, options);
    const platformWithCache = $398b6f99c6877d63$var$_extends({}, mergedOptions.platform, {
        _c: cache
    });
    return $398b6f99c6877d63$var$computePosition$1(reference, floating, $398b6f99c6877d63$var$_extends({}, mergedOptions, {
        platform: platformWithCache
    }));
};
/**
 * Floating UI Options
 *
 * @typedef {object} FloatingUIOptions
 */ /**
 * Determines options for the tooltip and initializes event listeners.
 *
 * @param {Step} step The step instance
 *
 * @return {FloatingUIOptions}
 */ function $398b6f99c6877d63$var$setupTooltip(step) {
    if (step.cleanup) step.cleanup();
    const attachToOptions = step._getResolvedAttachToOptions();
    let target = attachToOptions.element;
    const floatingUIOptions = $398b6f99c6877d63$var$getFloatingUIOptions(attachToOptions, step);
    const shouldCenter = $398b6f99c6877d63$var$shouldCenterStep(attachToOptions);
    if (shouldCenter) {
        target = document.body;
        const content = step.shepherdElementComponent.getElement();
        content.classList.add("shepherd-centered");
    }
    step.cleanup = $398b6f99c6877d63$var$autoUpdate(target, step.el, ()=>{
        // The element might have already been removed by the end of the tour.
        if (!step.el) {
            step.cleanup();
            return;
        }
        $398b6f99c6877d63$var$setPosition(target, step, floatingUIOptions, shouldCenter);
    });
    step.target = attachToOptions.element;
    return floatingUIOptions;
}
/**
 * Merge tooltip options handling nested keys.
 *
 * @param tourOptions - The default tour options.
 * @param options - Step specific options.
 *
 * @return {floatingUIOptions: FloatingUIOptions}
 */ function $398b6f99c6877d63$var$mergeTooltipConfig(tourOptions, options) {
    return {
        floatingUIOptions: $398b6f99c6877d63$var$cjs(tourOptions.floatingUIOptions || {}, options.floatingUIOptions || {})
    };
}
/**
 * Cleanup function called when the step is closed/destroyed.
 *
 * @param {Step} step
 */ function $398b6f99c6877d63$var$destroyTooltip(step) {
    if (step.cleanup) step.cleanup();
    step.cleanup = null;
}
/**
 *
 * @return {Promise<*>}
 */ function $398b6f99c6877d63$var$setPosition(target, step, floatingUIOptions, shouldCenter) {
    return $398b6f99c6877d63$var$computePosition(target, step.el, floatingUIOptions).then($398b6f99c6877d63$var$floatingUIposition(step, shouldCenter))// Wait before forcing focus.
    .then((step)=>new Promise((resolve)=>{
            setTimeout(()=>resolve(step), 300);
        }))// Replaces focusAfterRender modifier.
    .then((step)=>{
        if (step && step.el) step.el.focus({
            preventScroll: true
        });
    });
}
/**
 *
 * @param step
 * @param shouldCenter
 * @return {function({x: *, y: *, placement: *, middlewareData: *}): Promise<unknown>}
 */ function $398b6f99c6877d63$var$floatingUIposition(step, shouldCenter) {
    return ({ x: x, y: y, placement: placement, middlewareData: middlewareData })=>{
        if (!step.el) return step;
        if (shouldCenter) Object.assign(step.el.style, {
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)"
        });
        else Object.assign(step.el.style, {
            position: "absolute",
            left: `${x}px`,
            top: `${y}px`
        });
        step.el.dataset.popperPlacement = placement;
        $398b6f99c6877d63$var$placeArrow(step.el, middlewareData);
        return step;
    };
}
/**
 *
 * @param el
 * @param middlewareData
 */ function $398b6f99c6877d63$var$placeArrow(el, middlewareData) {
    const arrowEl = el.querySelector(".shepherd-arrow");
    if (arrowEl && middlewareData.arrow) {
        const { x: arrowX, y: arrowY } = middlewareData.arrow;
        Object.assign(arrowEl.style, {
            left: arrowX != null ? `${arrowX}px` : "",
            top: arrowY != null ? `${arrowY}px` : ""
        });
    }
}
/**
 * Gets the `Floating UI` options from a set of base `attachTo` options
 * @param attachToOptions
 * @param {Step} step The step instance
 * @return {Object}
 * @private
 */ function $398b6f99c6877d63$var$getFloatingUIOptions(attachToOptions, step) {
    const options = {
        strategy: "absolute",
        middleware: []
    };
    const arrowEl = $398b6f99c6877d63$var$addArrow(step);
    const shouldCenter = $398b6f99c6877d63$var$shouldCenterStep(attachToOptions);
    if (!shouldCenter) {
        options.middleware.push($398b6f99c6877d63$var$flip(), // Replicate PopperJS default behavior.
        $398b6f99c6877d63$var$shift({
            limiter: $398b6f99c6877d63$var$limitShift(),
            crossAxis: true
        }));
        if (arrowEl) options.middleware.push($398b6f99c6877d63$var$arrow({
            element: arrowEl
        }));
        options.placement = attachToOptions.on;
    }
    return $398b6f99c6877d63$var$cjs(step.options.floatingUIOptions || {}, options);
}
/**
 * @param {Step} step
 * @return {HTMLElement|false|null}
 */ function $398b6f99c6877d63$var$addArrow(step) {
    if (step.options.arrow && step.el) return step.el.querySelector(".shepherd-arrow");
    return false;
}
function $398b6f99c6877d63$var$noop() {}
function $398b6f99c6877d63$var$assign(tar, src) {
    // @ts-ignore
    for(const k in src)tar[k] = src[k];
    return tar;
}
function $398b6f99c6877d63$var$run(fn) {
    return fn();
}
function $398b6f99c6877d63$var$blank_object() {
    return Object.create(null);
}
function $398b6f99c6877d63$var$run_all(fns) {
    fns.forEach($398b6f99c6877d63$var$run);
}
function $398b6f99c6877d63$var$is_function(thing) {
    return typeof thing === "function";
}
function $398b6f99c6877d63$var$safe_not_equal(a, b) {
    return a != a ? b == b : a !== b || a && typeof a === "object" || typeof a === "function";
}
function $398b6f99c6877d63$var$is_empty(obj) {
    return Object.keys(obj).length === 0;
}
function $398b6f99c6877d63$var$append(target, node) {
    target.appendChild(node);
}
function $398b6f99c6877d63$var$insert(target, node, anchor) {
    target.insertBefore(node, anchor || null);
}
function $398b6f99c6877d63$var$detach(node) {
    if (node.parentNode) node.parentNode.removeChild(node);
}
function $398b6f99c6877d63$var$destroy_each(iterations, detaching) {
    for(let i = 0; i < iterations.length; i += 1)if (iterations[i]) iterations[i].d(detaching);
}
function $398b6f99c6877d63$var$element(name) {
    return document.createElement(name);
}
function $398b6f99c6877d63$var$svg_element(name) {
    return document.createElementNS("http://www.w3.org/2000/svg", name);
}
function $398b6f99c6877d63$var$text(data) {
    return document.createTextNode(data);
}
function $398b6f99c6877d63$var$space() {
    return $398b6f99c6877d63$var$text(" ");
}
function $398b6f99c6877d63$var$empty() {
    return $398b6f99c6877d63$var$text("");
}
function $398b6f99c6877d63$var$listen(node, event, handler, options) {
    node.addEventListener(event, handler, options);
    return ()=>node.removeEventListener(event, handler, options);
}
function $398b6f99c6877d63$var$attr(node, attribute, value) {
    if (value == null) node.removeAttribute(attribute);
    else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}
/**
 * List of attributes that should always be set through the attr method,
 * because updating them through the property setter doesn't work reliably.
 * In the example of `width`/`height`, the problem is that the setter only
 * accepts numeric values, but the attribute can also be set to a string like `50%`.
 * If this list becomes too big, rethink this approach.
 */ const $398b6f99c6877d63$var$always_set_through_set_attribute = [
    "width",
    "height"
];
function $398b6f99c6877d63$var$set_attributes(node, attributes) {
    // @ts-ignore
    const descriptors = Object.getOwnPropertyDescriptors(node.__proto__);
    for(const key in attributes){
        if (attributes[key] == null) node.removeAttribute(key);
        else if (key === "style") node.style.cssText = attributes[key];
        else if (key === "__value") node.value = node[key] = attributes[key];
        else if (descriptors[key] && descriptors[key].set && $398b6f99c6877d63$var$always_set_through_set_attribute.indexOf(key) === -1) node[key] = attributes[key];
        else $398b6f99c6877d63$var$attr(node, key, attributes[key]);
    }
}
function $398b6f99c6877d63$var$children(element) {
    return Array.from(element.childNodes);
}
function $398b6f99c6877d63$var$toggle_class(element, name, toggle) {
    element.classList[toggle ? "add" : "remove"](name);
}
let $398b6f99c6877d63$var$current_component;
function $398b6f99c6877d63$var$set_current_component(component) {
    $398b6f99c6877d63$var$current_component = component;
}
function $398b6f99c6877d63$var$get_current_component() {
    if (!$398b6f99c6877d63$var$current_component) throw new Error("Function called outside component initialization");
    return $398b6f99c6877d63$var$current_component;
}
/**
 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
 * it can be called from an external module).
 *
 * `onMount` does not run inside a [server-side component](/docs#run-time-server-side-component-api).
 *
 * https://svelte.dev/docs#run-time-svelte-onmount
 */ function $398b6f99c6877d63$var$onMount(fn) {
    $398b6f99c6877d63$var$get_current_component().$$.on_mount.push(fn);
}
/**
 * Schedules a callback to run immediately after the component has been updated.
 *
 * The first time the callback runs will be after the initial `onMount`
 */ function $398b6f99c6877d63$var$afterUpdate(fn) {
    $398b6f99c6877d63$var$get_current_component().$$.after_update.push(fn);
}
const $398b6f99c6877d63$var$dirty_components = [];
const $398b6f99c6877d63$var$binding_callbacks = [];
let $398b6f99c6877d63$var$render_callbacks = [];
const $398b6f99c6877d63$var$flush_callbacks = [];
const $398b6f99c6877d63$var$resolved_promise = /* @__PURE__ */ Promise.resolve();
let $398b6f99c6877d63$var$update_scheduled = false;
function $398b6f99c6877d63$var$schedule_update() {
    if (!$398b6f99c6877d63$var$update_scheduled) {
        $398b6f99c6877d63$var$update_scheduled = true;
        $398b6f99c6877d63$var$resolved_promise.then($398b6f99c6877d63$var$flush);
    }
}
function $398b6f99c6877d63$var$add_render_callback(fn) {
    $398b6f99c6877d63$var$render_callbacks.push(fn);
}
// flush() calls callbacks in this order:
// 1. All beforeUpdate callbacks, in order: parents before children
// 2. All bind:this callbacks, in reverse order: children before parents.
// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
//    for afterUpdates called during the initial onMount, which are called in
//    reverse order: children before parents.
// Since callbacks might update component values, which could trigger another
// call to flush(), the following steps guard against this:
// 1. During beforeUpdate, any updated components will be added to the
//    dirty_components array and will cause a reentrant call to flush(). Because
//    the flush index is kept outside the function, the reentrant call will pick
//    up where the earlier call left off and go through all dirty components. The
//    current_component value is saved and restored so that the reentrant call will
//    not interfere with the "parent" flush() call.
// 2. bind:this callbacks cannot trigger new flush() calls.
// 3. During afterUpdate, any updated components will NOT have their afterUpdate
//    callback called a second time; the seen_callbacks set, outside the flush()
//    function, guarantees this behavior.
const $398b6f99c6877d63$var$seen_callbacks = new Set();
let $398b6f99c6877d63$var$flushidx = 0; // Do *not* move this inside the flush() function
function $398b6f99c6877d63$var$flush() {
    // Do not reenter flush while dirty components are updated, as this can
    // result in an infinite loop. Instead, let the inner flush handle it.
    // Reentrancy is ok afterwards for bindings etc.
    if ($398b6f99c6877d63$var$flushidx !== 0) return;
    const saved_component = $398b6f99c6877d63$var$current_component;
    do {
        // first, call beforeUpdate functions
        // and update components
        try {
            while($398b6f99c6877d63$var$flushidx < $398b6f99c6877d63$var$dirty_components.length){
                const component = $398b6f99c6877d63$var$dirty_components[$398b6f99c6877d63$var$flushidx];
                $398b6f99c6877d63$var$flushidx++;
                $398b6f99c6877d63$var$set_current_component(component);
                $398b6f99c6877d63$var$update(component.$$);
            }
        } catch (e) {
            // reset dirty state to not end up in a deadlocked state and then rethrow
            $398b6f99c6877d63$var$dirty_components.length = 0;
            $398b6f99c6877d63$var$flushidx = 0;
            throw e;
        }
        $398b6f99c6877d63$var$set_current_component(null);
        $398b6f99c6877d63$var$dirty_components.length = 0;
        $398b6f99c6877d63$var$flushidx = 0;
        while($398b6f99c6877d63$var$binding_callbacks.length)$398b6f99c6877d63$var$binding_callbacks.pop()();
        // then, once components are updated, call
        // afterUpdate functions. This may cause
        // subsequent updates...
        for(let i = 0; i < $398b6f99c6877d63$var$render_callbacks.length; i += 1){
            const callback = $398b6f99c6877d63$var$render_callbacks[i];
            if (!$398b6f99c6877d63$var$seen_callbacks.has(callback)) {
                // ...so guard against infinite loops
                $398b6f99c6877d63$var$seen_callbacks.add(callback);
                callback();
            }
        }
        $398b6f99c6877d63$var$render_callbacks.length = 0;
    }while ($398b6f99c6877d63$var$dirty_components.length);
    while($398b6f99c6877d63$var$flush_callbacks.length)$398b6f99c6877d63$var$flush_callbacks.pop()();
    $398b6f99c6877d63$var$update_scheduled = false;
    $398b6f99c6877d63$var$seen_callbacks.clear();
    $398b6f99c6877d63$var$set_current_component(saved_component);
}
function $398b6f99c6877d63$var$update($$) {
    if ($$.fragment !== null) {
        $$.update();
        $398b6f99c6877d63$var$run_all($$.before_update);
        const dirty = $$.dirty;
        $$.dirty = [
            -1
        ];
        $$.fragment && $$.fragment.p($$.ctx, dirty);
        $$.after_update.forEach($398b6f99c6877d63$var$add_render_callback);
    }
}
/**
 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
 */ function $398b6f99c6877d63$var$flush_render_callbacks(fns) {
    const filtered = [];
    const targets = [];
    $398b6f99c6877d63$var$render_callbacks.forEach((c)=>fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
    targets.forEach((c)=>c());
    $398b6f99c6877d63$var$render_callbacks = filtered;
}
const $398b6f99c6877d63$var$outroing = new Set();
let $398b6f99c6877d63$var$outros;
function $398b6f99c6877d63$var$group_outros() {
    $398b6f99c6877d63$var$outros = {
        r: 0,
        c: [],
        p: $398b6f99c6877d63$var$outros // parent group
    };
}
function $398b6f99c6877d63$var$check_outros() {
    if (!$398b6f99c6877d63$var$outros.r) $398b6f99c6877d63$var$run_all($398b6f99c6877d63$var$outros.c);
    $398b6f99c6877d63$var$outros = $398b6f99c6877d63$var$outros.p;
}
function $398b6f99c6877d63$var$transition_in(block, local) {
    if (block && block.i) {
        $398b6f99c6877d63$var$outroing.delete(block);
        block.i(local);
    }
}
function $398b6f99c6877d63$var$transition_out(block, local, detach, callback) {
    if (block && block.o) {
        if ($398b6f99c6877d63$var$outroing.has(block)) return;
        $398b6f99c6877d63$var$outroing.add(block);
        $398b6f99c6877d63$var$outros.c.push(()=>{
            $398b6f99c6877d63$var$outroing.delete(block);
            if (callback) {
                if (detach) block.d(1);
                callback();
            }
        });
        block.o(local);
    } else if (callback) callback();
}
function $398b6f99c6877d63$var$get_spread_update(levels, updates) {
    const update = {};
    const to_null_out = {};
    const accounted_for = {
        $$scope: 1
    };
    let i = levels.length;
    while(i--){
        const o = levels[i];
        const n = updates[i];
        if (n) {
            for(const key in o)if (!(key in n)) to_null_out[key] = 1;
            for(const key in n)if (!accounted_for[key]) {
                update[key] = n[key];
                accounted_for[key] = 1;
            }
            levels[i] = n;
        } else for(const key in o)accounted_for[key] = 1;
    }
    for(const key in to_null_out)if (!(key in update)) update[key] = undefined;
    return update;
}
function $398b6f99c6877d63$var$create_component(block) {
    block && block.c();
}
function $398b6f99c6877d63$var$mount_component(component, target, anchor, customElement) {
    const { fragment: fragment, after_update: after_update } = component.$$;
    fragment && fragment.m(target, anchor);
    if (!customElement) // onMount happens before the initial afterUpdate
    $398b6f99c6877d63$var$add_render_callback(()=>{
        const new_on_destroy = component.$$.on_mount.map($398b6f99c6877d63$var$run).filter($398b6f99c6877d63$var$is_function);
        // if the component was destroyed immediately
        // it will update the `$$.on_destroy` reference to `null`.
        // the destructured on_destroy may still reference to the old array
        if (component.$$.on_destroy) component.$$.on_destroy.push(...new_on_destroy);
        else // Edge case - component was destroyed immediately,
        // most likely as a result of a binding initialising
        $398b6f99c6877d63$var$run_all(new_on_destroy);
        component.$$.on_mount = [];
    });
    after_update.forEach($398b6f99c6877d63$var$add_render_callback);
}
function $398b6f99c6877d63$var$destroy_component(component, detaching) {
    const $$ = component.$$;
    if ($$.fragment !== null) {
        $398b6f99c6877d63$var$flush_render_callbacks($$.after_update);
        $398b6f99c6877d63$var$run_all($$.on_destroy);
        $$.fragment && $$.fragment.d(detaching);
        // TODO null out other refs, including component.$$ (but need to
        // preserve final state?)
        $$.on_destroy = $$.fragment = null;
        $$.ctx = [];
    }
}
function $398b6f99c6877d63$var$make_dirty(component, i) {
    if (component.$$.dirty[0] === -1) {
        $398b6f99c6877d63$var$dirty_components.push(component);
        $398b6f99c6877d63$var$schedule_update();
        component.$$.dirty.fill(0);
    }
    component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
function $398b6f99c6877d63$var$init(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [
    -1
]) {
    const parent_component = $398b6f99c6877d63$var$current_component;
    $398b6f99c6877d63$var$set_current_component(component);
    const $$ = component.$$ = {
        fragment: null,
        ctx: [],
        props: // state
        props,
        update: $398b6f99c6877d63$var$noop,
        not_equal: not_equal,
        bound: $398b6f99c6877d63$var$blank_object(),
        // lifecycle
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
        // everything else
        callbacks: $398b6f99c6877d63$var$blank_object(),
        dirty: dirty,
        skip_bound: false,
        root: options.target || parent_component.$$.root
    };
    append_styles && append_styles($$.root);
    let ready = false;
    $$.ctx = instance ? instance(component, options.props || {}, (i, ret, ...rest)=>{
        const value = rest.length ? rest[0] : ret;
        if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
            if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
            if (ready) $398b6f99c6877d63$var$make_dirty(component, i);
        }
        return ret;
    }) : [];
    $$.update();
    ready = true;
    $398b6f99c6877d63$var$run_all($$.before_update);
    // `false` as a special case of no DOM component
    $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
    if (options.target) {
        if (options.hydrate) {
            const nodes = $398b6f99c6877d63$var$children(options.target);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $$.fragment && $$.fragment.l(nodes);
            nodes.forEach($398b6f99c6877d63$var$detach);
        } else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $$.fragment && $$.fragment.c();
        if (options.intro) $398b6f99c6877d63$var$transition_in(component.$$.fragment);
        $398b6f99c6877d63$var$mount_component(component, options.target, options.anchor, options.customElement);
        $398b6f99c6877d63$var$flush();
    }
    $398b6f99c6877d63$var$set_current_component(parent_component);
}
/**
 * Base class for Svelte components. Used when dev=false.
 */ class $398b6f99c6877d63$var$SvelteComponent {
    $destroy() {
        $398b6f99c6877d63$var$destroy_component(this, 1);
        this.$destroy = $398b6f99c6877d63$var$noop;
    }
    $on(type, callback) {
        if (!$398b6f99c6877d63$var$is_function(callback)) return $398b6f99c6877d63$var$noop;
        const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return ()=>{
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !$398b6f99c6877d63$var$is_empty($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
}
/* src/js/components/shepherd-button.svelte generated by Svelte v3.59.2 */ function $398b6f99c6877d63$var$create_fragment$8(ctx) {
    let button;
    let button_aria_label_value;
    let button_class_value;
    let mounted;
    let dispose;
    return {
        c () {
            button = $398b6f99c6877d63$var$element("button");
            $398b6f99c6877d63$var$attr(button, "aria-label", button_aria_label_value = /*label*/ ctx[3] ? /*label*/ ctx[3] : null);
            $398b6f99c6877d63$var$attr(button, "class", button_class_value = `${ctx[1] || ""} shepherd-button ${ctx[4] ? "shepherd-button-secondary" : ""}`);
            button.disabled = /*disabled*/ ctx[2];
            $398b6f99c6877d63$var$attr(button, "tabindex", "0");
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$insert(target, button, anchor);
            button.innerHTML = /*text*/ ctx[5];
            if (!mounted) {
                dispose = $398b6f99c6877d63$var$listen(button, "click", function() {
                    if ($398b6f99c6877d63$var$is_function(/*action*/ ctx[0])) /*action*/ ctx[0].apply(this, arguments);
                });
                mounted = true;
            }
        },
        p (new_ctx, [dirty]) {
            ctx = new_ctx;
            if (dirty & /*text*/ 32) button.innerHTML = /*text*/ ctx[5];
            if (dirty & /*label*/ 8 && button_aria_label_value !== (button_aria_label_value = /*label*/ ctx[3] ? /*label*/ ctx[3] : null)) $398b6f99c6877d63$var$attr(button, "aria-label", button_aria_label_value);
            if (dirty & /*classes, secondary*/ 18 && button_class_value !== (button_class_value = `${ctx[1] || ""} shepherd-button ${ctx[4] ? "shepherd-button-secondary" : ""}`)) $398b6f99c6877d63$var$attr(button, "class", button_class_value);
            if (dirty & /*disabled*/ 4) button.disabled = /*disabled*/ ctx[2];
        },
        i: $398b6f99c6877d63$var$noop,
        o: $398b6f99c6877d63$var$noop,
        d (detaching) {
            if (detaching) $398b6f99c6877d63$var$detach(button);
            mounted = false;
            dispose();
        }
    };
}
function $398b6f99c6877d63$var$instance$8($$self, $$props, $$invalidate) {
    let { config: config, step: step } = $$props;
    let action, classes, disabled, label, secondary, text;
    function getConfigOption(option) {
        if ($398b6f99c6877d63$var$isFunction(option)) return option = option.call(step);
        return option;
    }
    $$self.$$set = ($$props)=>{
        if ("config" in $$props) $$invalidate(6, config = $$props.config);
        if ("step" in $$props) $$invalidate(7, step = $$props.step);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*config, step*/ 192) {
            $$invalidate(0, action = config.action ? config.action.bind(step.tour) : null);
            $$invalidate(1, classes = config.classes);
            $$invalidate(2, disabled = config.disabled ? getConfigOption(config.disabled) : false);
            $$invalidate(3, label = config.label ? getConfigOption(config.label) : null);
            $$invalidate(4, secondary = config.secondary);
            $$invalidate(5, text = config.text ? getConfigOption(config.text) : null);
        }
    };
    return [
        action,
        classes,
        disabled,
        label,
        secondary,
        text,
        config,
        step
    ];
}
class $398b6f99c6877d63$var$Shepherd_button extends $398b6f99c6877d63$var$SvelteComponent {
    constructor(options){
        super();
        $398b6f99c6877d63$var$init(this, options, $398b6f99c6877d63$var$instance$8, $398b6f99c6877d63$var$create_fragment$8, $398b6f99c6877d63$var$safe_not_equal, {
            config: 6,
            step: 7
        });
    }
}
/* src/js/components/shepherd-footer.svelte generated by Svelte v3.59.2 */ function $398b6f99c6877d63$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[2] = list[i];
    return child_ctx;
}
// (24:4) {#if buttons}
function $398b6f99c6877d63$var$create_if_block$3(ctx) {
    let each_1_anchor;
    let current;
    let each_value = /*buttons*/ ctx[1];
    let each_blocks = [];
    for(let i = 0; i < each_value.length; i += 1)each_blocks[i] = $398b6f99c6877d63$var$create_each_block($398b6f99c6877d63$var$get_each_context(ctx, each_value, i));
    const out = (i)=>$398b6f99c6877d63$var$transition_out(each_blocks[i], 1, 1, ()=>{
            each_blocks[i] = null;
        });
    return {
        c () {
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            each_1_anchor = $398b6f99c6877d63$var$empty();
        },
        m (target, anchor) {
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            $398b6f99c6877d63$var$insert(target, each_1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty & /*buttons, step*/ 3) {
                each_value = /*buttons*/ ctx[1];
                let i;
                for(i = 0; i < each_value.length; i += 1){
                    const child_ctx = $398b6f99c6877d63$var$get_each_context(ctx, each_value, i);
                    if (each_blocks[i]) {
                        each_blocks[i].p(child_ctx, dirty);
                        $398b6f99c6877d63$var$transition_in(each_blocks[i], 1);
                    } else {
                        each_blocks[i] = $398b6f99c6877d63$var$create_each_block(child_ctx);
                        each_blocks[i].c();
                        $398b6f99c6877d63$var$transition_in(each_blocks[i], 1);
                        each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
                    }
                }
                $398b6f99c6877d63$var$group_outros();
                for(i = each_value.length; i < each_blocks.length; i += 1)out(i);
                $398b6f99c6877d63$var$check_outros();
            }
        },
        i (local) {
            if (current) return;
            for(let i = 0; i < each_value.length; i += 1)$398b6f99c6877d63$var$transition_in(each_blocks[i]);
            current = true;
        },
        o (local) {
            each_blocks = each_blocks.filter(Boolean);
            for(let i = 0; i < each_blocks.length; i += 1)$398b6f99c6877d63$var$transition_out(each_blocks[i]);
            current = false;
        },
        d (detaching) {
            $398b6f99c6877d63$var$destroy_each(each_blocks, detaching);
            if (detaching) $398b6f99c6877d63$var$detach(each_1_anchor);
        }
    };
}
// (25:8) {#each buttons as config}
function $398b6f99c6877d63$var$create_each_block(ctx) {
    let shepherdbutton;
    let current;
    shepherdbutton = new $398b6f99c6877d63$var$Shepherd_button({
        props: {
            config: /*config*/ ctx[2],
            step: /*step*/ ctx[0]
        }
    });
    return {
        c () {
            $398b6f99c6877d63$var$create_component(shepherdbutton.$$.fragment);
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$mount_component(shepherdbutton, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdbutton_changes = {};
            if (dirty & /*buttons*/ 2) shepherdbutton_changes.config = /*config*/ ctx[2];
            if (dirty & /*step*/ 1) shepherdbutton_changes.step = /*step*/ ctx[0];
            shepherdbutton.$set(shepherdbutton_changes);
        },
        i (local) {
            if (current) return;
            $398b6f99c6877d63$var$transition_in(shepherdbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            $398b6f99c6877d63$var$transition_out(shepherdbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $398b6f99c6877d63$var$destroy_component(shepherdbutton, detaching);
        }
    };
}
function $398b6f99c6877d63$var$create_fragment$7(ctx) {
    let footer;
    let current;
    let if_block = /*buttons*/ ctx[1] && $398b6f99c6877d63$var$create_if_block$3(ctx);
    return {
        c () {
            footer = $398b6f99c6877d63$var$element("footer");
            if (if_block) if_block.c();
            $398b6f99c6877d63$var$attr(footer, "class", "shepherd-footer");
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$insert(target, footer, anchor);
            if (if_block) if_block.m(footer, null);
            current = true;
        },
        p (ctx, [dirty]) {
            if (/*buttons*/ ctx[1]) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty & /*buttons*/ 2) $398b6f99c6877d63$var$transition_in(if_block, 1);
                } else {
                    if_block = $398b6f99c6877d63$var$create_if_block$3(ctx);
                    if_block.c();
                    $398b6f99c6877d63$var$transition_in(if_block, 1);
                    if_block.m(footer, null);
                }
            } else if (if_block) {
                $398b6f99c6877d63$var$group_outros();
                $398b6f99c6877d63$var$transition_out(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                $398b6f99c6877d63$var$check_outros();
            }
        },
        i (local) {
            if (current) return;
            $398b6f99c6877d63$var$transition_in(if_block);
            current = true;
        },
        o (local) {
            $398b6f99c6877d63$var$transition_out(if_block);
            current = false;
        },
        d (detaching) {
            if (detaching) $398b6f99c6877d63$var$detach(footer);
            if (if_block) if_block.d();
        }
    };
}
function $398b6f99c6877d63$var$instance$7($$self, $$props, $$invalidate) {
    let buttons;
    let { step: step } = $$props;
    $$self.$$set = ($$props)=>{
        if ("step" in $$props) $$invalidate(0, step = $$props.step);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*step*/ 1) $$invalidate(1, buttons = step.options.buttons);
    };
    return [
        step,
        buttons
    ];
}
class $398b6f99c6877d63$var$Shepherd_footer extends $398b6f99c6877d63$var$SvelteComponent {
    constructor(options){
        super();
        $398b6f99c6877d63$var$init(this, options, $398b6f99c6877d63$var$instance$7, $398b6f99c6877d63$var$create_fragment$7, $398b6f99c6877d63$var$safe_not_equal, {
            step: 0
        });
    }
}
/* src/js/components/shepherd-cancel-icon.svelte generated by Svelte v3.59.2 */ function $398b6f99c6877d63$var$create_fragment$6(ctx) {
    let button;
    let span;
    let button_aria_label_value;
    let mounted;
    let dispose;
    return {
        c () {
            button = $398b6f99c6877d63$var$element("button");
            span = $398b6f99c6877d63$var$element("span");
            span.textContent = "\xd7";
            $398b6f99c6877d63$var$attr(span, "aria-hidden", "true");
            $398b6f99c6877d63$var$attr(button, "aria-label", button_aria_label_value = /*cancelIcon*/ ctx[0].label ? /*cancelIcon*/ ctx[0].label : "Close Tour");
            $398b6f99c6877d63$var$attr(button, "class", "shepherd-cancel-icon");
            $398b6f99c6877d63$var$attr(button, "type", "button");
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$insert(target, button, anchor);
            $398b6f99c6877d63$var$append(button, span);
            if (!mounted) {
                dispose = $398b6f99c6877d63$var$listen(button, "click", /*handleCancelClick*/ ctx[1]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (dirty & /*cancelIcon*/ 1 && button_aria_label_value !== (button_aria_label_value = /*cancelIcon*/ ctx[0].label ? /*cancelIcon*/ ctx[0].label : "Close Tour")) $398b6f99c6877d63$var$attr(button, "aria-label", button_aria_label_value);
        },
        i: $398b6f99c6877d63$var$noop,
        o: $398b6f99c6877d63$var$noop,
        d (detaching) {
            if (detaching) $398b6f99c6877d63$var$detach(button);
            mounted = false;
            dispose();
        }
    };
}
function $398b6f99c6877d63$var$instance$6($$self, $$props, $$invalidate) {
    let { cancelIcon: cancelIcon, step: step } = $$props;
    /**
  * Add a click listener to the cancel link that cancels the tour
  */ const handleCancelClick = (e)=>{
        e.preventDefault();
        step.cancel();
    };
    $$self.$$set = ($$props)=>{
        if ("cancelIcon" in $$props) $$invalidate(0, cancelIcon = $$props.cancelIcon);
        if ("step" in $$props) $$invalidate(2, step = $$props.step);
    };
    return [
        cancelIcon,
        handleCancelClick,
        step
    ];
}
class $398b6f99c6877d63$var$Shepherd_cancel_icon extends $398b6f99c6877d63$var$SvelteComponent {
    constructor(options){
        super();
        $398b6f99c6877d63$var$init(this, options, $398b6f99c6877d63$var$instance$6, $398b6f99c6877d63$var$create_fragment$6, $398b6f99c6877d63$var$safe_not_equal, {
            cancelIcon: 0,
            step: 2
        });
    }
}
/* src/js/components/shepherd-title.svelte generated by Svelte v3.59.2 */ function $398b6f99c6877d63$var$create_fragment$5(ctx) {
    let h3;
    return {
        c () {
            h3 = $398b6f99c6877d63$var$element("h3");
            $398b6f99c6877d63$var$attr(h3, "id", /*labelId*/ ctx[1]);
            $398b6f99c6877d63$var$attr(h3, "class", "shepherd-title");
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$insert(target, h3, anchor);
            /*h3_binding*/ ctx[3](h3);
        },
        p (ctx, [dirty]) {
            if (dirty & /*labelId*/ 2) $398b6f99c6877d63$var$attr(h3, "id", /*labelId*/ ctx[1]);
        },
        i: $398b6f99c6877d63$var$noop,
        o: $398b6f99c6877d63$var$noop,
        d (detaching) {
            if (detaching) $398b6f99c6877d63$var$detach(h3);
            /*h3_binding*/ ctx[3](null);
        }
    };
}
function $398b6f99c6877d63$var$instance$5($$self, $$props, $$invalidate) {
    let { labelId: labelId, element: element, title: title } = $$props;
    $398b6f99c6877d63$var$afterUpdate(()=>{
        if ($398b6f99c6877d63$var$isFunction(title)) $$invalidate(2, title = title());
        $$invalidate(0, element.innerHTML = title, element);
    });
    function h3_binding($$value) {
        $398b6f99c6877d63$var$binding_callbacks[$$value ? "unshift" : "push"](()=>{
            element = $$value;
            $$invalidate(0, element);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("labelId" in $$props) $$invalidate(1, labelId = $$props.labelId);
        if ("element" in $$props) $$invalidate(0, element = $$props.element);
        if ("title" in $$props) $$invalidate(2, title = $$props.title);
    };
    return [
        element,
        labelId,
        title,
        h3_binding
    ];
}
class $398b6f99c6877d63$var$Shepherd_title extends $398b6f99c6877d63$var$SvelteComponent {
    constructor(options){
        super();
        $398b6f99c6877d63$var$init(this, options, $398b6f99c6877d63$var$instance$5, $398b6f99c6877d63$var$create_fragment$5, $398b6f99c6877d63$var$safe_not_equal, {
            labelId: 1,
            element: 0,
            title: 2
        });
    }
}
/* src/js/components/shepherd-header.svelte generated by Svelte v3.59.2 */ function $398b6f99c6877d63$var$create_if_block_1$1(ctx) {
    let shepherdtitle;
    let current;
    shepherdtitle = new $398b6f99c6877d63$var$Shepherd_title({
        props: {
            labelId: /*labelId*/ ctx[0],
            title: /*title*/ ctx[2]
        }
    });
    return {
        c () {
            $398b6f99c6877d63$var$create_component(shepherdtitle.$$.fragment);
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$mount_component(shepherdtitle, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdtitle_changes = {};
            if (dirty & /*labelId*/ 1) shepherdtitle_changes.labelId = /*labelId*/ ctx[0];
            if (dirty & /*title*/ 4) shepherdtitle_changes.title = /*title*/ ctx[2];
            shepherdtitle.$set(shepherdtitle_changes);
        },
        i (local) {
            if (current) return;
            $398b6f99c6877d63$var$transition_in(shepherdtitle.$$.fragment, local);
            current = true;
        },
        o (local) {
            $398b6f99c6877d63$var$transition_out(shepherdtitle.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $398b6f99c6877d63$var$destroy_component(shepherdtitle, detaching);
        }
    };
}
// (39:4) {#if cancelIcon && cancelIcon.enabled}
function $398b6f99c6877d63$var$create_if_block$2(ctx) {
    let shepherdcancelicon;
    let current;
    shepherdcancelicon = new $398b6f99c6877d63$var$Shepherd_cancel_icon({
        props: {
            cancelIcon: /*cancelIcon*/ ctx[3],
            step: /*step*/ ctx[1]
        }
    });
    return {
        c () {
            $398b6f99c6877d63$var$create_component(shepherdcancelicon.$$.fragment);
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$mount_component(shepherdcancelicon, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdcancelicon_changes = {};
            if (dirty & /*cancelIcon*/ 8) shepherdcancelicon_changes.cancelIcon = /*cancelIcon*/ ctx[3];
            if (dirty & /*step*/ 2) shepherdcancelicon_changes.step = /*step*/ ctx[1];
            shepherdcancelicon.$set(shepherdcancelicon_changes);
        },
        i (local) {
            if (current) return;
            $398b6f99c6877d63$var$transition_in(shepherdcancelicon.$$.fragment, local);
            current = true;
        },
        o (local) {
            $398b6f99c6877d63$var$transition_out(shepherdcancelicon.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $398b6f99c6877d63$var$destroy_component(shepherdcancelicon, detaching);
        }
    };
}
function $398b6f99c6877d63$var$create_fragment$4(ctx) {
    let header;
    let t;
    let current;
    let if_block0 = /*title*/ ctx[2] && $398b6f99c6877d63$var$create_if_block_1$1(ctx);
    let if_block1 = /*cancelIcon*/ ctx[3] && /*cancelIcon*/ ctx[3].enabled && $398b6f99c6877d63$var$create_if_block$2(ctx);
    return {
        c () {
            header = $398b6f99c6877d63$var$element("header");
            if (if_block0) if_block0.c();
            t = $398b6f99c6877d63$var$space();
            if (if_block1) if_block1.c();
            $398b6f99c6877d63$var$attr(header, "class", "shepherd-header");
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$insert(target, header, anchor);
            if (if_block0) if_block0.m(header, null);
            $398b6f99c6877d63$var$append(header, t);
            if (if_block1) if_block1.m(header, null);
            current = true;
        },
        p (ctx, [dirty]) {
            if (/*title*/ ctx[2]) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*title*/ 4) $398b6f99c6877d63$var$transition_in(if_block0, 1);
                } else {
                    if_block0 = $398b6f99c6877d63$var$create_if_block_1$1(ctx);
                    if_block0.c();
                    $398b6f99c6877d63$var$transition_in(if_block0, 1);
                    if_block0.m(header, t);
                }
            } else if (if_block0) {
                $398b6f99c6877d63$var$group_outros();
                $398b6f99c6877d63$var$transition_out(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $398b6f99c6877d63$var$check_outros();
            }
            if (/*cancelIcon*/ ctx[3] && /*cancelIcon*/ ctx[3].enabled) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*cancelIcon*/ 8) $398b6f99c6877d63$var$transition_in(if_block1, 1);
                } else {
                    if_block1 = $398b6f99c6877d63$var$create_if_block$2(ctx);
                    if_block1.c();
                    $398b6f99c6877d63$var$transition_in(if_block1, 1);
                    if_block1.m(header, null);
                }
            } else if (if_block1) {
                $398b6f99c6877d63$var$group_outros();
                $398b6f99c6877d63$var$transition_out(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $398b6f99c6877d63$var$check_outros();
            }
        },
        i (local) {
            if (current) return;
            $398b6f99c6877d63$var$transition_in(if_block0);
            $398b6f99c6877d63$var$transition_in(if_block1);
            current = true;
        },
        o (local) {
            $398b6f99c6877d63$var$transition_out(if_block0);
            $398b6f99c6877d63$var$transition_out(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) $398b6f99c6877d63$var$detach(header);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
        }
    };
}
function $398b6f99c6877d63$var$instance$4($$self, $$props, $$invalidate) {
    let { labelId: labelId, step: step } = $$props;
    let title, cancelIcon;
    $$self.$$set = ($$props)=>{
        if ("labelId" in $$props) $$invalidate(0, labelId = $$props.labelId);
        if ("step" in $$props) $$invalidate(1, step = $$props.step);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*step*/ 2) {
            $$invalidate(2, title = step.options.title);
            $$invalidate(3, cancelIcon = step.options.cancelIcon);
        }
    };
    return [
        labelId,
        step,
        title,
        cancelIcon
    ];
}
class $398b6f99c6877d63$var$Shepherd_header extends $398b6f99c6877d63$var$SvelteComponent {
    constructor(options){
        super();
        $398b6f99c6877d63$var$init(this, options, $398b6f99c6877d63$var$instance$4, $398b6f99c6877d63$var$create_fragment$4, $398b6f99c6877d63$var$safe_not_equal, {
            labelId: 0,
            step: 1
        });
    }
}
/* src/js/components/shepherd-text.svelte generated by Svelte v3.59.2 */ function $398b6f99c6877d63$var$create_fragment$3(ctx) {
    let div;
    return {
        c () {
            div = $398b6f99c6877d63$var$element("div");
            $398b6f99c6877d63$var$attr(div, "class", "shepherd-text");
            $398b6f99c6877d63$var$attr(div, "id", /*descriptionId*/ ctx[1]);
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$insert(target, div, anchor);
            /*div_binding*/ ctx[3](div);
        },
        p (ctx, [dirty]) {
            if (dirty & /*descriptionId*/ 2) $398b6f99c6877d63$var$attr(div, "id", /*descriptionId*/ ctx[1]);
        },
        i: $398b6f99c6877d63$var$noop,
        o: $398b6f99c6877d63$var$noop,
        d (detaching) {
            if (detaching) $398b6f99c6877d63$var$detach(div);
            /*div_binding*/ ctx[3](null);
        }
    };
}
function $398b6f99c6877d63$var$instance$3($$self, $$props, $$invalidate) {
    let { descriptionId: descriptionId, element: element, step: step } = $$props;
    $398b6f99c6877d63$var$afterUpdate(()=>{
        let { text: text } = step.options;
        if ($398b6f99c6877d63$var$isFunction(text)) text = text.call(step);
        if ($398b6f99c6877d63$var$isHTMLElement$1(text)) element.appendChild(text);
        else $$invalidate(0, element.innerHTML = text, element);
    });
    function div_binding($$value) {
        $398b6f99c6877d63$var$binding_callbacks[$$value ? "unshift" : "push"](()=>{
            element = $$value;
            $$invalidate(0, element);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("descriptionId" in $$props) $$invalidate(1, descriptionId = $$props.descriptionId);
        if ("element" in $$props) $$invalidate(0, element = $$props.element);
        if ("step" in $$props) $$invalidate(2, step = $$props.step);
    };
    return [
        element,
        descriptionId,
        step,
        div_binding
    ];
}
class $398b6f99c6877d63$var$Shepherd_text extends $398b6f99c6877d63$var$SvelteComponent {
    constructor(options){
        super();
        $398b6f99c6877d63$var$init(this, options, $398b6f99c6877d63$var$instance$3, $398b6f99c6877d63$var$create_fragment$3, $398b6f99c6877d63$var$safe_not_equal, {
            descriptionId: 1,
            element: 0,
            step: 2
        });
    }
}
/* src/js/components/shepherd-content.svelte generated by Svelte v3.59.2 */ function $398b6f99c6877d63$var$create_if_block_2(ctx) {
    let shepherdheader;
    let current;
    shepherdheader = new $398b6f99c6877d63$var$Shepherd_header({
        props: {
            labelId: /*labelId*/ ctx[1],
            step: /*step*/ ctx[2]
        }
    });
    return {
        c () {
            $398b6f99c6877d63$var$create_component(shepherdheader.$$.fragment);
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$mount_component(shepherdheader, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdheader_changes = {};
            if (dirty & /*labelId*/ 2) shepherdheader_changes.labelId = /*labelId*/ ctx[1];
            if (dirty & /*step*/ 4) shepherdheader_changes.step = /*step*/ ctx[2];
            shepherdheader.$set(shepherdheader_changes);
        },
        i (local) {
            if (current) return;
            $398b6f99c6877d63$var$transition_in(shepherdheader.$$.fragment, local);
            current = true;
        },
        o (local) {
            $398b6f99c6877d63$var$transition_out(shepherdheader.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $398b6f99c6877d63$var$destroy_component(shepherdheader, detaching);
        }
    };
}
// (28:2) {#if !isUndefined(step.options.text)}
function $398b6f99c6877d63$var$create_if_block_1(ctx) {
    let shepherdtext;
    let current;
    shepherdtext = new $398b6f99c6877d63$var$Shepherd_text({
        props: {
            descriptionId: /*descriptionId*/ ctx[0],
            step: /*step*/ ctx[2]
        }
    });
    return {
        c () {
            $398b6f99c6877d63$var$create_component(shepherdtext.$$.fragment);
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$mount_component(shepherdtext, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdtext_changes = {};
            if (dirty & /*descriptionId*/ 1) shepherdtext_changes.descriptionId = /*descriptionId*/ ctx[0];
            if (dirty & /*step*/ 4) shepherdtext_changes.step = /*step*/ ctx[2];
            shepherdtext.$set(shepherdtext_changes);
        },
        i (local) {
            if (current) return;
            $398b6f99c6877d63$var$transition_in(shepherdtext.$$.fragment, local);
            current = true;
        },
        o (local) {
            $398b6f99c6877d63$var$transition_out(shepherdtext.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $398b6f99c6877d63$var$destroy_component(shepherdtext, detaching);
        }
    };
}
// (35:2) {#if Array.isArray(step.options.buttons) && step.options.buttons.length}
function $398b6f99c6877d63$var$create_if_block$1(ctx) {
    let shepherdfooter;
    let current;
    shepherdfooter = new $398b6f99c6877d63$var$Shepherd_footer({
        props: {
            step: /*step*/ ctx[2]
        }
    });
    return {
        c () {
            $398b6f99c6877d63$var$create_component(shepherdfooter.$$.fragment);
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$mount_component(shepherdfooter, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const shepherdfooter_changes = {};
            if (dirty & /*step*/ 4) shepherdfooter_changes.step = /*step*/ ctx[2];
            shepherdfooter.$set(shepherdfooter_changes);
        },
        i (local) {
            if (current) return;
            $398b6f99c6877d63$var$transition_in(shepherdfooter.$$.fragment, local);
            current = true;
        },
        o (local) {
            $398b6f99c6877d63$var$transition_out(shepherdfooter.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $398b6f99c6877d63$var$destroy_component(shepherdfooter, detaching);
        }
    };
}
function $398b6f99c6877d63$var$create_fragment$2(ctx) {
    let div;
    let show_if_2 = !$398b6f99c6877d63$var$isUndefined(/*step*/ ctx[2].options.title) || /*step*/ ctx[2].options.cancelIcon && /*step*/ ctx[2].options.cancelIcon.enabled;
    let t0;
    let show_if_1 = !$398b6f99c6877d63$var$isUndefined(/*step*/ ctx[2].options.text);
    let t1;
    let show_if = Array.isArray(/*step*/ ctx[2].options.buttons) && /*step*/ ctx[2].options.buttons.length;
    let current;
    let if_block0 = show_if_2 && $398b6f99c6877d63$var$create_if_block_2(ctx);
    let if_block1 = show_if_1 && $398b6f99c6877d63$var$create_if_block_1(ctx);
    let if_block2 = show_if && $398b6f99c6877d63$var$create_if_block$1(ctx);
    return {
        c () {
            div = $398b6f99c6877d63$var$element("div");
            if (if_block0) if_block0.c();
            t0 = $398b6f99c6877d63$var$space();
            if (if_block1) if_block1.c();
            t1 = $398b6f99c6877d63$var$space();
            if (if_block2) if_block2.c();
            $398b6f99c6877d63$var$attr(div, "class", "shepherd-content");
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$insert(target, div, anchor);
            if (if_block0) if_block0.m(div, null);
            $398b6f99c6877d63$var$append(div, t0);
            if (if_block1) if_block1.m(div, null);
            $398b6f99c6877d63$var$append(div, t1);
            if (if_block2) if_block2.m(div, null);
            current = true;
        },
        p (ctx, [dirty]) {
            if (dirty & /*step*/ 4) show_if_2 = !$398b6f99c6877d63$var$isUndefined(/*step*/ ctx[2].options.title) || /*step*/ ctx[2].options.cancelIcon && /*step*/ ctx[2].options.cancelIcon.enabled;
            if (show_if_2) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*step*/ 4) $398b6f99c6877d63$var$transition_in(if_block0, 1);
                } else {
                    if_block0 = $398b6f99c6877d63$var$create_if_block_2(ctx);
                    if_block0.c();
                    $398b6f99c6877d63$var$transition_in(if_block0, 1);
                    if_block0.m(div, t0);
                }
            } else if (if_block0) {
                $398b6f99c6877d63$var$group_outros();
                $398b6f99c6877d63$var$transition_out(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $398b6f99c6877d63$var$check_outros();
            }
            if (dirty & /*step*/ 4) show_if_1 = !$398b6f99c6877d63$var$isUndefined(/*step*/ ctx[2].options.text);
            if (show_if_1) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*step*/ 4) $398b6f99c6877d63$var$transition_in(if_block1, 1);
                } else {
                    if_block1 = $398b6f99c6877d63$var$create_if_block_1(ctx);
                    if_block1.c();
                    $398b6f99c6877d63$var$transition_in(if_block1, 1);
                    if_block1.m(div, t1);
                }
            } else if (if_block1) {
                $398b6f99c6877d63$var$group_outros();
                $398b6f99c6877d63$var$transition_out(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $398b6f99c6877d63$var$check_outros();
            }
            if (dirty & /*step*/ 4) show_if = Array.isArray(/*step*/ ctx[2].options.buttons) && /*step*/ ctx[2].options.buttons.length;
            if (show_if) {
                if (if_block2) {
                    if_block2.p(ctx, dirty);
                    if (dirty & /*step*/ 4) $398b6f99c6877d63$var$transition_in(if_block2, 1);
                } else {
                    if_block2 = $398b6f99c6877d63$var$create_if_block$1(ctx);
                    if_block2.c();
                    $398b6f99c6877d63$var$transition_in(if_block2, 1);
                    if_block2.m(div, null);
                }
            } else if (if_block2) {
                $398b6f99c6877d63$var$group_outros();
                $398b6f99c6877d63$var$transition_out(if_block2, 1, 1, ()=>{
                    if_block2 = null;
                });
                $398b6f99c6877d63$var$check_outros();
            }
        },
        i (local) {
            if (current) return;
            $398b6f99c6877d63$var$transition_in(if_block0);
            $398b6f99c6877d63$var$transition_in(if_block1);
            $398b6f99c6877d63$var$transition_in(if_block2);
            current = true;
        },
        o (local) {
            $398b6f99c6877d63$var$transition_out(if_block0);
            $398b6f99c6877d63$var$transition_out(if_block1);
            $398b6f99c6877d63$var$transition_out(if_block2);
            current = false;
        },
        d (detaching) {
            if (detaching) $398b6f99c6877d63$var$detach(div);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            if (if_block2) if_block2.d();
        }
    };
}
function $398b6f99c6877d63$var$instance$2($$self, $$props, $$invalidate) {
    let { descriptionId: descriptionId, labelId: labelId, step: step } = $$props;
    $$self.$$set = ($$props)=>{
        if ("descriptionId" in $$props) $$invalidate(0, descriptionId = $$props.descriptionId);
        if ("labelId" in $$props) $$invalidate(1, labelId = $$props.labelId);
        if ("step" in $$props) $$invalidate(2, step = $$props.step);
    };
    return [
        descriptionId,
        labelId,
        step
    ];
}
class $398b6f99c6877d63$var$Shepherd_content extends $398b6f99c6877d63$var$SvelteComponent {
    constructor(options){
        super();
        $398b6f99c6877d63$var$init(this, options, $398b6f99c6877d63$var$instance$2, $398b6f99c6877d63$var$create_fragment$2, $398b6f99c6877d63$var$safe_not_equal, {
            descriptionId: 0,
            labelId: 1,
            step: 2
        });
    }
}
/* src/js/components/shepherd-element.svelte generated by Svelte v3.59.2 */ function $398b6f99c6877d63$var$create_if_block(ctx) {
    let div;
    return {
        c () {
            div = $398b6f99c6877d63$var$element("div");
            $398b6f99c6877d63$var$attr(div, "class", "shepherd-arrow");
            $398b6f99c6877d63$var$attr(div, "data-popper-arrow", "");
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$insert(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $398b6f99c6877d63$var$detach(div);
        }
    };
}
function $398b6f99c6877d63$var$create_fragment$1(ctx) {
    let div;
    let t;
    let shepherdcontent;
    let div_aria_describedby_value;
    let div_aria_labelledby_value;
    let current;
    let mounted;
    let dispose;
    let if_block = /*step*/ ctx[4].options.arrow && /*step*/ ctx[4].options.attachTo && /*step*/ ctx[4].options.attachTo.element && /*step*/ ctx[4].options.attachTo.on && $398b6f99c6877d63$var$create_if_block();
    shepherdcontent = new $398b6f99c6877d63$var$Shepherd_content({
        props: {
            descriptionId: /*descriptionId*/ ctx[2],
            labelId: /*labelId*/ ctx[3],
            step: /*step*/ ctx[4]
        }
    });
    let div_levels = [
        {
            "aria-describedby": div_aria_describedby_value = !$398b6f99c6877d63$var$isUndefined(/*step*/ ctx[4].options.text) ? /*descriptionId*/ ctx[2] : null
        },
        {
            "aria-labelledby": div_aria_labelledby_value = /*step*/ ctx[4].options.title ? /*labelId*/ ctx[3] : null
        },
        /*dataStepId*/ ctx[1],
        {
            role: "dialog"
        },
        {
            tabindex: "0"
        }
    ];
    let div_data = {};
    for(let i = 0; i < div_levels.length; i += 1)div_data = $398b6f99c6877d63$var$assign(div_data, div_levels[i]);
    return {
        c () {
            div = $398b6f99c6877d63$var$element("div");
            if (if_block) if_block.c();
            t = $398b6f99c6877d63$var$space();
            $398b6f99c6877d63$var$create_component(shepherdcontent.$$.fragment);
            $398b6f99c6877d63$var$set_attributes(div, div_data);
            $398b6f99c6877d63$var$toggle_class(div, "shepherd-has-cancel-icon", /*hasCancelIcon*/ ctx[5]);
            $398b6f99c6877d63$var$toggle_class(div, "shepherd-has-title", /*hasTitle*/ ctx[6]);
            $398b6f99c6877d63$var$toggle_class(div, "shepherd-element", true);
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$insert(target, div, anchor);
            if (if_block) if_block.m(div, null);
            $398b6f99c6877d63$var$append(div, t);
            $398b6f99c6877d63$var$mount_component(shepherdcontent, div, null);
            /*div_binding*/ ctx[13](div);
            current = true;
            if (!mounted) {
                dispose = $398b6f99c6877d63$var$listen(div, "keydown", /*handleKeyDown*/ ctx[7]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (/*step*/ ctx[4].options.arrow && /*step*/ ctx[4].options.attachTo && /*step*/ ctx[4].options.attachTo.element && /*step*/ ctx[4].options.attachTo.on) {
                if (if_block) ;
                else {
                    if_block = $398b6f99c6877d63$var$create_if_block();
                    if_block.c();
                    if_block.m(div, t);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
            const shepherdcontent_changes = {};
            if (dirty & /*descriptionId*/ 4) shepherdcontent_changes.descriptionId = /*descriptionId*/ ctx[2];
            if (dirty & /*labelId*/ 8) shepherdcontent_changes.labelId = /*labelId*/ ctx[3];
            if (dirty & /*step*/ 16) shepherdcontent_changes.step = /*step*/ ctx[4];
            shepherdcontent.$set(shepherdcontent_changes);
            $398b6f99c6877d63$var$set_attributes(div, div_data = $398b6f99c6877d63$var$get_spread_update(div_levels, [
                (!current || dirty & /*step, descriptionId*/ 20 && div_aria_describedby_value !== (div_aria_describedby_value = !$398b6f99c6877d63$var$isUndefined(/*step*/ ctx[4].options.text) ? /*descriptionId*/ ctx[2] : null)) && {
                    "aria-describedby": div_aria_describedby_value
                },
                (!current || dirty & /*step, labelId*/ 24 && div_aria_labelledby_value !== (div_aria_labelledby_value = /*step*/ ctx[4].options.title ? /*labelId*/ ctx[3] : null)) && {
                    "aria-labelledby": div_aria_labelledby_value
                },
                dirty & /*dataStepId*/ 2 && /*dataStepId*/ ctx[1],
                {
                    role: "dialog"
                },
                {
                    tabindex: "0"
                }
            ]));
            $398b6f99c6877d63$var$toggle_class(div, "shepherd-has-cancel-icon", /*hasCancelIcon*/ ctx[5]);
            $398b6f99c6877d63$var$toggle_class(div, "shepherd-has-title", /*hasTitle*/ ctx[6]);
            $398b6f99c6877d63$var$toggle_class(div, "shepherd-element", true);
        },
        i (local) {
            if (current) return;
            $398b6f99c6877d63$var$transition_in(shepherdcontent.$$.fragment, local);
            current = true;
        },
        o (local) {
            $398b6f99c6877d63$var$transition_out(shepherdcontent.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $398b6f99c6877d63$var$detach(div);
            if (if_block) if_block.d();
            $398b6f99c6877d63$var$destroy_component(shepherdcontent);
            /*div_binding*/ ctx[13](null);
            mounted = false;
            dispose();
        }
    };
}
const $398b6f99c6877d63$var$KEY_TAB = 9;
const $398b6f99c6877d63$var$KEY_ESC = 27;
const $398b6f99c6877d63$var$LEFT_ARROW = 37;
const $398b6f99c6877d63$var$RIGHT_ARROW = 39;
function $398b6f99c6877d63$var$getClassesArray(classes) {
    return classes.split(" ").filter((className)=>!!className.length);
}
function $398b6f99c6877d63$var$instance$1($$self, $$props, $$invalidate) {
    let { classPrefix: classPrefix, element: element, descriptionId: descriptionId, firstFocusableElement: firstFocusableElement, focusableElements: focusableElements, labelId: labelId, lastFocusableElement: lastFocusableElement, step: step, dataStepId: dataStepId } = $$props;
    let hasCancelIcon, hasTitle, classes;
    const getElement = ()=>element;
    $398b6f99c6877d63$var$onMount(()=>{
        // Get all elements that are focusable
        $$invalidate(1, dataStepId = {
            [`data-${classPrefix}shepherd-step-id`]: step.id
        });
        $$invalidate(9, focusableElements = element.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'));
        $$invalidate(8, firstFocusableElement = focusableElements[0]);
        $$invalidate(10, lastFocusableElement = focusableElements[focusableElements.length - 1]);
    });
    $398b6f99c6877d63$var$afterUpdate(()=>{
        if (classes !== step.options.classes) updateDynamicClasses();
    });
    function updateDynamicClasses() {
        removeClasses(classes);
        classes = step.options.classes;
        addClasses(classes);
    }
    function removeClasses(classes) {
        if ($398b6f99c6877d63$var$isString(classes)) {
            const oldClasses = $398b6f99c6877d63$var$getClassesArray(classes);
            if (oldClasses.length) element.classList.remove(...oldClasses);
        }
    }
    function addClasses(classes) {
        if ($398b6f99c6877d63$var$isString(classes)) {
            const newClasses = $398b6f99c6877d63$var$getClassesArray(classes);
            if (newClasses.length) element.classList.add(...newClasses);
        }
    }
    /**
  * Setup keydown events to allow closing the modal with ESC
  *
  * Borrowed from this great post! https://bitsofco.de/accessible-modal-dialog/
  *
  * @private
  */ const handleKeyDown = (e)=>{
        const { tour: tour } = step;
        switch(e.keyCode){
            case $398b6f99c6877d63$var$KEY_TAB:
                if (focusableElements.length === 0) {
                    e.preventDefault();
                    break;
                }
                // Backward tab
                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableElement || document.activeElement.classList.contains("shepherd-element")) {
                        e.preventDefault();
                        lastFocusableElement.focus();
                    }
                } else if (document.activeElement === lastFocusableElement) {
                    e.preventDefault();
                    firstFocusableElement.focus();
                }
                break;
            case $398b6f99c6877d63$var$KEY_ESC:
                if (tour.options.exitOnEsc) {
                    e.stopPropagation();
                    step.cancel();
                }
                break;
            case $398b6f99c6877d63$var$LEFT_ARROW:
                if (tour.options.keyboardNavigation) {
                    e.stopPropagation();
                    tour.back();
                }
                break;
            case $398b6f99c6877d63$var$RIGHT_ARROW:
                if (tour.options.keyboardNavigation) {
                    e.stopPropagation();
                    tour.next();
                }
                break;
        }
    };
    function div_binding($$value) {
        $398b6f99c6877d63$var$binding_callbacks[$$value ? "unshift" : "push"](()=>{
            element = $$value;
            $$invalidate(0, element);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("classPrefix" in $$props) $$invalidate(11, classPrefix = $$props.classPrefix);
        if ("element" in $$props) $$invalidate(0, element = $$props.element);
        if ("descriptionId" in $$props) $$invalidate(2, descriptionId = $$props.descriptionId);
        if ("firstFocusableElement" in $$props) $$invalidate(8, firstFocusableElement = $$props.firstFocusableElement);
        if ("focusableElements" in $$props) $$invalidate(9, focusableElements = $$props.focusableElements);
        if ("labelId" in $$props) $$invalidate(3, labelId = $$props.labelId);
        if ("lastFocusableElement" in $$props) $$invalidate(10, lastFocusableElement = $$props.lastFocusableElement);
        if ("step" in $$props) $$invalidate(4, step = $$props.step);
        if ("dataStepId" in $$props) $$invalidate(1, dataStepId = $$props.dataStepId);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*step*/ 16) {
            $$invalidate(5, hasCancelIcon = step.options && step.options.cancelIcon && step.options.cancelIcon.enabled);
            $$invalidate(6, hasTitle = step.options && step.options.title);
        }
    };
    return [
        element,
        dataStepId,
        descriptionId,
        labelId,
        step,
        hasCancelIcon,
        hasTitle,
        handleKeyDown,
        firstFocusableElement,
        focusableElements,
        lastFocusableElement,
        classPrefix,
        getElement,
        div_binding
    ];
}
class $398b6f99c6877d63$var$Shepherd_element extends $398b6f99c6877d63$var$SvelteComponent {
    constructor(options){
        super();
        $398b6f99c6877d63$var$init(this, options, $398b6f99c6877d63$var$instance$1, $398b6f99c6877d63$var$create_fragment$1, $398b6f99c6877d63$var$safe_not_equal, {
            classPrefix: 11,
            element: 0,
            descriptionId: 2,
            firstFocusableElement: 8,
            focusableElements: 9,
            labelId: 3,
            lastFocusableElement: 10,
            step: 4,
            dataStepId: 1,
            getElement: 12
        });
    }
    get getElement() {
        return this.$$.ctx[12];
    }
}
/**
 * A class representing steps to be added to a tour.
 * @extends {Evented}
 */ class $398b6f99c6877d63$var$Step extends $398b6f99c6877d63$var$Evented {
    /**
   * Create a step
   * @param {Tour} tour The tour for the step
   * @param {object} options The options for the step
   * @param {boolean} options.arrow Whether to display the arrow for the tooltip or not. Defaults to `true`.
   * @param {object} options.attachTo The element the step should be attached to on the page.
   * An object with properties `element` and `on`.
   *
   * ```js
   * const step = new Step(tour, {
   *   attachTo: { element: '.some .selector-path', on: 'left' },
   *   ...moreOptions
   * });
   * ```
   *
   * If you don’t specify an `attachTo` the element will appear in the middle of the screen. The same will happen if your `attachTo.element` callback returns `null`, `undefined`, or a selector that does not exist in the DOM.
   * If you omit the `on` portion of `attachTo`, the element will still be highlighted, but the tooltip will appear
   * in the middle of the screen, without an arrow pointing to the target.
   * If the element to highlight does not yet exist while instantiating tour steps, you may use lazy evaluation by supplying a function to `attachTo.element`. The function will be called in the `before-show` phase.
   * @param {string|HTMLElement|function} options.attachTo.element An element selector string, DOM element, or a function (returning a selector, a DOM element, `null` or `undefined`).
   * @param {string} options.attachTo.on The optional direction to place the FloatingUI tooltip relative to the element.
   *   - Possible string values: 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end'
   * @param {Object} options.advanceOn An action on the page which should advance shepherd to the next step.
   * It should be an object with a string `selector` and an `event` name
   * ```js
   * const step = new Step(tour, {
   *   advanceOn: { selector: '.some .selector-path', event: 'click' },
   *   ...moreOptions
   * });
   * ```
   * `event` doesn’t have to be an event inside the tour, it can be any event fired on any element on the page.
   * You can also always manually advance the Tour by calling `myTour.next()`.
   * @param {function} options.beforeShowPromise A function that returns a promise.
   * When the promise resolves, the rest of the `show` code for the step will execute.
   * @param {Object[]} options.buttons An array of buttons to add to the step. These will be rendered in a
   * footer below the main body text.
   * @param {function} options.buttons.button.action A function executed when the button is clicked on.
   * It is automatically bound to the `tour` the step is associated with, so things like `this.next` will
   * work inside the action.
   * You can use action to skip steps or navigate to specific steps, with something like:
   * ```js
   * action() {
   *   return this.show('some_step_name');
   * }
   * ```
   * @param {string} options.buttons.button.classes Extra classes to apply to the `<a>`
   * @param {boolean} options.buttons.button.disabled Should the button be disabled?
   * @param {string} options.buttons.button.label The aria-label text of the button
   * @param {boolean} options.buttons.button.secondary If true, a shepherd-button-secondary class is applied to the button
   * @param {string} options.buttons.button.text The HTML text of the button
   * @param {boolean} options.canClickTarget A boolean, that when set to false, will set `pointer-events: none` on the target
   * @param {object} options.cancelIcon Options for the cancel icon
   * @param {boolean} options.cancelIcon.enabled Should a cancel “✕” be shown in the header of the step?
   * @param {string} options.cancelIcon.label The label to add for `aria-label`
   * @param {string} options.classes A string of extra classes to add to the step's content element.
   * @param {string} options.highlightClass An extra class to apply to the `attachTo` element when it is
   * highlighted (that is, when its step is active). You can then target that selector in your CSS.
   * @param {string} options.id The string to use as the `id` for the step.
   * @param {number} options.modalOverlayOpeningPadding An amount of padding to add around the modal overlay opening
   * @param {number | { topLeft: number, bottomLeft: number, bottomRight: number, topRight: number }} options.modalOverlayOpeningRadius An amount of border radius to add around the modal overlay opening
   * @param {object} options.floatingUIOptions Extra options to pass to FloatingUI
   * @param {boolean|Object} options.scrollTo Should the element be scrolled to when this step is shown? If true, uses the default `scrollIntoView`,
   * if an object, passes that object as the params to `scrollIntoView` i.e. `{behavior: 'smooth', block: 'center'}`
   * @param {function} options.scrollToHandler A function that lets you override the default scrollTo behavior and
   * define a custom action to do the scrolling, and possibly other logic.
   * @param {function} options.showOn A function that, when it returns `true`, will show the step.
   * If it returns false, the step will be skipped.
   * @param {string} options.text The text in the body of the step. It can be one of three types:
   * ```
   * - HTML string
   * - `HTMLElement` object
   * - `Function` to be executed when the step is built. It must return one the two options above.
   * ```
   * @param {string} options.title The step's title. It becomes an `h3` at the top of the step. It can be one of two types:
   * ```
   * - HTML string
   * - `Function` to be executed when the step is built. It must return HTML string.
   * ```
   * @param {object} options.when You can define `show`, `hide`, etc events inside `when`. For example:
   * ```js
   * when: {
   *   show: function() {
   *     window.scrollTo(0, 0);
   *   }
   * }
   * ```
   * @return {Step} The newly created Step instance
   */ constructor(tour, options = {}){
        super(tour, options);
        this.tour = tour;
        this.classPrefix = this.tour.options ? $398b6f99c6877d63$var$normalizePrefix(this.tour.options.classPrefix) : "";
        this.styles = tour.styles;
        /**
     * Resolved attachTo options. Due to lazy evaluation, we only resolve the options during `before-show` phase.
     * Do not use this directly, use the _getResolvedAttachToOptions method instead.
     * @type {null|{}|{element, to}}
     * @private
     */ this._resolvedAttachTo = null;
        $398b6f99c6877d63$var$autoBind(this);
        this._setOptions(options);
        return this;
    }
    /**
   * Cancel the tour
   * Triggers the `cancel` event
   */ cancel() {
        this.tour.cancel();
        this.trigger("cancel");
    }
    /**
   * Complete the tour
   * Triggers the `complete` event
   */ complete() {
        this.tour.complete();
        this.trigger("complete");
    }
    /**
   * Remove the step, delete the step's element, and destroy the FloatingUI instance for the step.
   * Triggers `destroy` event
   */ destroy() {
        $398b6f99c6877d63$var$destroyTooltip(this);
        if ($398b6f99c6877d63$var$isHTMLElement$1(this.el)) {
            this.el.remove();
            this.el = null;
        }
        this._updateStepTargetOnHide();
        this.trigger("destroy");
    }
    /**
   * Returns the tour for the step
   * @return {Tour} The tour instance
   */ getTour() {
        return this.tour;
    }
    /**
   * Hide the step
   */ hide() {
        this.tour.modal.hide();
        this.trigger("before-hide");
        if (this.el) this.el.hidden = true;
        this._updateStepTargetOnHide();
        this.trigger("hide");
    }
    /**
   * Resolves attachTo options.
   * @returns {{}|{element, on}}
   * @private
   */ _resolveAttachToOptions() {
        this._resolvedAttachTo = $398b6f99c6877d63$var$parseAttachTo(this);
        return this._resolvedAttachTo;
    }
    /**
   * A selector for resolved attachTo options.
   * @returns {{}|{element, on}}
   * @private
   */ _getResolvedAttachToOptions() {
        if (this._resolvedAttachTo === null) return this._resolveAttachToOptions();
        return this._resolvedAttachTo;
    }
    /**
   * Check if the step is open and visible
   * @return {boolean} True if the step is open and visible
   */ isOpen() {
        return Boolean(this.el && !this.el.hidden);
    }
    /**
   * Wraps `_show` and ensures `beforeShowPromise` resolves before calling show
   * @return {*|Promise}
   */ show() {
        if ($398b6f99c6877d63$var$isFunction(this.options.beforeShowPromise)) return Promise.resolve(this.options.beforeShowPromise()).then(()=>this._show());
        return Promise.resolve(this._show());
    }
    /**
   * Updates the options of the step.
   *
   * @param {Object} options The options for the step
   */ updateStepOptions(options) {
        Object.assign(this.options, options);
        if (this.shepherdElementComponent) this.shepherdElementComponent.$set({
            step: this
        });
    }
    /**
   * Returns the element for the step
   * @return {HTMLElement|null|undefined} The element instance. undefined if it has never been shown, null if it has been destroyed
   */ getElement() {
        return this.el;
    }
    /**
   * Returns the target for the step
   * @return {HTMLElement|null|undefined} The element instance. undefined if it has never been shown, null if query string has not been found
   */ getTarget() {
        return this.target;
    }
    /**
   * Creates Shepherd element for step based on options
   *
   * @return {Element} The DOM element for the step tooltip
   * @private
   */ _createTooltipContent() {
        const descriptionId = `${this.id}-description`;
        const labelId = `${this.id}-label`;
        this.shepherdElementComponent = new $398b6f99c6877d63$var$Shepherd_element({
            target: this.tour.options.stepsContainer || document.body,
            props: {
                classPrefix: this.classPrefix,
                descriptionId: descriptionId,
                labelId: labelId,
                step: this,
                styles: this.styles
            }
        });
        return this.shepherdElementComponent.getElement();
    }
    /**
   * If a custom scrollToHandler is defined, call that, otherwise do the generic
   * scrollIntoView call.
   *
   * @param {boolean|Object} scrollToOptions If true, uses the default `scrollIntoView`,
   * if an object, passes that object as the params to `scrollIntoView` i.e. `{ behavior: 'smooth', block: 'center' }`
   * @private
   */ _scrollTo(scrollToOptions) {
        const { element: element } = this._getResolvedAttachToOptions();
        if ($398b6f99c6877d63$var$isFunction(this.options.scrollToHandler)) this.options.scrollToHandler(element);
        else if ($398b6f99c6877d63$var$isElement$1(element) && typeof element.scrollIntoView === "function") element.scrollIntoView(scrollToOptions);
    }
    /**
   * _getClassOptions gets all possible classes for the step
   * @param {Object} stepOptions The step specific options
   * @returns {String} unique string from array of classes
   * @private
   */ _getClassOptions(stepOptions) {
        const defaultStepOptions = this.tour && this.tour.options && this.tour.options.defaultStepOptions;
        const stepClasses = stepOptions.classes ? stepOptions.classes : "";
        const defaultStepOptionsClasses = defaultStepOptions && defaultStepOptions.classes ? defaultStepOptions.classes : "";
        const allClasses = [
            ...stepClasses.split(" "),
            ...defaultStepOptionsClasses.split(" ")
        ];
        const uniqClasses = new Set(allClasses);
        return Array.from(uniqClasses).join(" ").trim();
    }
    /**
   * Sets the options for the step, maps `when` to events, sets up buttons
   * @param {Object} options The options for the step
   * @private
   */ _setOptions(options = {}) {
        let tourOptions = this.tour && this.tour.options && this.tour.options.defaultStepOptions;
        tourOptions = $398b6f99c6877d63$var$cjs({}, tourOptions || {});
        this.options = Object.assign({
            arrow: true
        }, tourOptions, options, $398b6f99c6877d63$var$mergeTooltipConfig(tourOptions, options));
        const { when: when } = this.options;
        this.options.classes = this._getClassOptions(options);
        this.destroy();
        this.id = this.options.id || `step-${$398b6f99c6877d63$var$uuid()}`;
        if (when) Object.keys(when).forEach((event)=>{
            this.on(event, when[event], this);
        });
    }
    /**
   * Create the element and set up the FloatingUI instance
   * @private
   */ _setupElements() {
        if (!$398b6f99c6877d63$var$isUndefined(this.el)) this.destroy();
        this.el = this._createTooltipContent();
        if (this.options.advanceOn) $398b6f99c6877d63$var$bindAdvance(this);
        // The tooltip implementation details are handled outside of the Step
        // object.
        $398b6f99c6877d63$var$setupTooltip(this);
    }
    /**
   * Triggers `before-show`, generates the tooltip DOM content,
   * sets up a FloatingUI instance for the tooltip, then triggers `show`.
   * @private
   */ _show() {
        this.trigger("before-show");
        // Force resolve to make sure the options are updated on subsequent shows.
        this._resolveAttachToOptions();
        this._setupElements();
        if (!this.tour.modal) this.tour._setupModal();
        this.tour.modal.setupForStep(this);
        this._styleTargetElementForStep(this);
        this.el.hidden = false;
        // start scrolling to target before showing the step
        if (this.options.scrollTo) setTimeout(()=>{
            this._scrollTo(this.options.scrollTo);
        });
        this.el.hidden = false;
        const content = this.shepherdElementComponent.getElement();
        const target = this.target || document.body;
        target.classList.add(`${this.classPrefix}shepherd-enabled`);
        target.classList.add(`${this.classPrefix}shepherd-target`);
        content.classList.add("shepherd-enabled");
        this.trigger("show");
    }
    /**
   * Modulates the styles of the passed step's target element, based on the step's options and
   * the tour's `modal` option, to visually emphasize the element
   *
   * @param step The step object that attaches to the element
   * @private
   */ _styleTargetElementForStep(step) {
        const targetElement = step.target;
        if (!targetElement) return;
        if (step.options.highlightClass) targetElement.classList.add(step.options.highlightClass);
        targetElement.classList.remove("shepherd-target-click-disabled");
        if (step.options.canClickTarget === false) targetElement.classList.add("shepherd-target-click-disabled");
    }
    /**
   * When a step is hidden, remove the highlightClass and 'shepherd-enabled'
   * and 'shepherd-target' classes
   * @private
   */ _updateStepTargetOnHide() {
        const target = this.target || document.body;
        if (this.options.highlightClass) target.classList.remove(this.options.highlightClass);
        target.classList.remove("shepherd-target-click-disabled", `${this.classPrefix}shepherd-enabled`, `${this.classPrefix}shepherd-target`);
    }
}
/**
 * Cleanup the steps and set pointerEvents back to 'auto'
 * @param tour The tour object
 */ function $398b6f99c6877d63$var$cleanupSteps(tour) {
    if (tour) {
        const { steps: steps } = tour;
        steps.forEach((step)=>{
            if (step.options && step.options.canClickTarget === false && step.options.attachTo) {
                if (step.target instanceof HTMLElement) step.target.classList.remove("shepherd-target-click-disabled");
            }
        });
    }
}
/**
 * Generates the svg path data for a rounded rectangle overlay
 * @param {Object} dimension - Dimensions of rectangle.
 * @param {number} width - Width.
 * @param {number} height - Height.
 * @param {number} [x=0] - Offset from top left corner in x axis. default 0.
 * @param {number} [y=0] - Offset from top left corner in y axis. default 0.
 * @param {number | { topLeft: number, topRight: number, bottomRight: number, bottomLeft: number }} [r=0] - Corner Radius. Keep this smaller than half of width or height.
 * @returns {string} - Rounded rectangle overlay path data.
 */ function $398b6f99c6877d63$var$makeOverlayPath({ width: width, height: height, x: x = 0, y: y = 0, r: r = 0 }) {
    const { innerWidth: w, innerHeight: h } = window;
    const { topLeft: topLeft = 0, topRight: topRight = 0, bottomRight: bottomRight = 0, bottomLeft: bottomLeft = 0 } = typeof r === "number" ? {
        topLeft: r,
        topRight: r,
        bottomRight: r,
        bottomLeft: r
    } : r;
    return `M${w},${h}\
H0\
V0\
H${w}\
V${h}\
Z\
M${x + topLeft},${y}\
a${topLeft},${topLeft},0,0,0-${topLeft},${topLeft}\
V${height + y - bottomLeft}\
a${bottomLeft},${bottomLeft},0,0,0,${bottomLeft},${bottomLeft}\
H${width + x - bottomRight}\
a${bottomRight},${bottomRight},0,0,0,${bottomRight}-${bottomRight}\
V${y + topRight}\
a${topRight},${topRight},0,0,0-${topRight}-${topRight}\
Z`;
}
/* src/js/components/shepherd-modal.svelte generated by Svelte v3.59.2 */ function $398b6f99c6877d63$var$create_fragment(ctx) {
    let svg;
    let path;
    let svg_class_value;
    let mounted;
    let dispose;
    return {
        c () {
            svg = $398b6f99c6877d63$var$svg_element("svg");
            path = $398b6f99c6877d63$var$svg_element("path");
            $398b6f99c6877d63$var$attr(path, "d", /*pathDefinition*/ ctx[2]);
            $398b6f99c6877d63$var$attr(svg, "class", svg_class_value = `${ctx[1] ? "shepherd-modal-is-visible" : ""} shepherd-modal-overlay-container`);
        },
        m (target, anchor) {
            $398b6f99c6877d63$var$insert(target, svg, anchor);
            $398b6f99c6877d63$var$append(svg, path);
            /*svg_binding*/ ctx[11](svg);
            if (!mounted) {
                dispose = $398b6f99c6877d63$var$listen(svg, "touchmove", /*_preventModalOverlayTouch*/ ctx[3]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (dirty & /*pathDefinition*/ 4) $398b6f99c6877d63$var$attr(path, "d", /*pathDefinition*/ ctx[2]);
            if (dirty & /*modalIsVisible*/ 2 && svg_class_value !== (svg_class_value = `${ctx[1] ? "shepherd-modal-is-visible" : ""} shepherd-modal-overlay-container`)) $398b6f99c6877d63$var$attr(svg, "class", svg_class_value);
        },
        i: $398b6f99c6877d63$var$noop,
        o: $398b6f99c6877d63$var$noop,
        d (detaching) {
            if (detaching) $398b6f99c6877d63$var$detach(svg);
            /*svg_binding*/ ctx[11](null);
            mounted = false;
            dispose();
        }
    };
}
function $398b6f99c6877d63$var$_getScrollParent(element) {
    if (!element) return null;
    const isHtmlElement = element instanceof HTMLElement;
    const overflowY = isHtmlElement && window.getComputedStyle(element).overflowY;
    const isScrollable = overflowY !== "hidden" && overflowY !== "visible";
    if (isScrollable && element.scrollHeight >= element.clientHeight) return element;
    return $398b6f99c6877d63$var$_getScrollParent(element.parentElement);
}
/**
 * Get the visible height of the target element relative to its scrollParent.
 * If there is no scroll parent, the height of the element is returned.
 *
 * @param {HTMLElement} element The target element
 * @param {HTMLElement} [scrollParent] The scrollable parent element
 * @returns {{y: number, height: number}}
 * @private
 */ function $398b6f99c6877d63$var$_getVisibleHeight(element, scrollParent) {
    const elementRect = element.getBoundingClientRect();
    let top = elementRect.y || elementRect.top;
    let bottom = elementRect.bottom || top + elementRect.height;
    if (scrollParent) {
        const scrollRect = scrollParent.getBoundingClientRect();
        const scrollTop = scrollRect.y || scrollRect.top;
        const scrollBottom = scrollRect.bottom || scrollTop + scrollRect.height;
        top = Math.max(top, scrollTop);
        bottom = Math.min(bottom, scrollBottom);
    }
    const height = Math.max(bottom - top, 0); // Default to 0 if height is negative
    return {
        y: top,
        height: height
    };
}
function $398b6f99c6877d63$var$instance($$self, $$props, $$invalidate) {
    let { element: element, openingProperties: openingProperties } = $$props;
    $398b6f99c6877d63$var$uuid();
    let modalIsVisible = false;
    let rafId = undefined;
    let pathDefinition;
    closeModalOpening();
    const getElement = ()=>element;
    function closeModalOpening() {
        $$invalidate(4, openingProperties = {
            width: 0,
            height: 0,
            x: 0,
            y: 0,
            r: 0
        });
    }
    function hide() {
        $$invalidate(1, modalIsVisible = false);
        // Ensure we cleanup all event listeners when we hide the modal
        _cleanupStepEventListeners();
    }
    function positionModal(modalOverlayOpeningPadding = 0, modalOverlayOpeningRadius = 0, scrollParent, targetElement) {
        if (targetElement) {
            const { y: y, height: height } = $398b6f99c6877d63$var$_getVisibleHeight(targetElement, scrollParent);
            const { x: x, width: width, left: left } = targetElement.getBoundingClientRect();
            // getBoundingClientRect is not consistent. Some browsers use x and y, while others use left and top
            $$invalidate(4, openingProperties = {
                width: width + modalOverlayOpeningPadding * 2,
                height: height + modalOverlayOpeningPadding * 2,
                x: (x || left) - modalOverlayOpeningPadding,
                y: y - modalOverlayOpeningPadding,
                r: modalOverlayOpeningRadius
            });
        } else closeModalOpening();
    }
    function setupForStep(step) {
        // Ensure we move listeners from the previous step, before we setup new ones
        _cleanupStepEventListeners();
        if (step.tour.options.useModalOverlay) {
            _styleForStep(step);
            show();
        } else hide();
    }
    function show() {
        $$invalidate(1, modalIsVisible = true);
    }
    const _preventModalBodyTouch = (e)=>{
        e.preventDefault();
    };
    const _preventModalOverlayTouch = (e)=>{
        e.stopPropagation();
    };
    /**
  * Add touchmove event listener
  * @private
  */ function _addStepEventListeners() {
        // Prevents window from moving on touch.
        window.addEventListener("touchmove", _preventModalBodyTouch, {
            passive: false
        });
    }
    /**
  * Cancel the requestAnimationFrame loop and remove touchmove event listeners
  * @private
  */ function _cleanupStepEventListeners() {
        if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = undefined;
        }
        window.removeEventListener("touchmove", _preventModalBodyTouch, {
            passive: false
        });
    }
    /**
  * Style the modal for the step
  * @param {Step} step The step to style the opening for
  * @private
  */ function _styleForStep(step) {
        const { modalOverlayOpeningPadding: modalOverlayOpeningPadding, modalOverlayOpeningRadius: modalOverlayOpeningRadius } = step.options;
        const scrollParent = $398b6f99c6877d63$var$_getScrollParent(step.target);
        // Setup recursive function to call requestAnimationFrame to update the modal opening position
        const rafLoop = ()=>{
            rafId = undefined;
            positionModal(modalOverlayOpeningPadding, modalOverlayOpeningRadius, scrollParent, step.target);
            rafId = requestAnimationFrame(rafLoop);
        };
        rafLoop();
        _addStepEventListeners();
    }
    function svg_binding($$value) {
        $398b6f99c6877d63$var$binding_callbacks[$$value ? "unshift" : "push"](()=>{
            element = $$value;
            $$invalidate(0, element);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("element" in $$props) $$invalidate(0, element = $$props.element);
        if ("openingProperties" in $$props) $$invalidate(4, openingProperties = $$props.openingProperties);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*openingProperties*/ 16) $$invalidate(2, pathDefinition = $398b6f99c6877d63$var$makeOverlayPath(openingProperties));
    };
    return [
        element,
        modalIsVisible,
        pathDefinition,
        _preventModalOverlayTouch,
        openingProperties,
        getElement,
        closeModalOpening,
        hide,
        positionModal,
        setupForStep,
        show,
        svg_binding
    ];
}
class $398b6f99c6877d63$var$Shepherd_modal extends $398b6f99c6877d63$var$SvelteComponent {
    constructor(options){
        super();
        $398b6f99c6877d63$var$init(this, options, $398b6f99c6877d63$var$instance, $398b6f99c6877d63$var$create_fragment, $398b6f99c6877d63$var$safe_not_equal, {
            element: 0,
            openingProperties: 4,
            getElement: 5,
            closeModalOpening: 6,
            hide: 7,
            positionModal: 8,
            setupForStep: 9,
            show: 10
        });
    }
    get getElement() {
        return this.$$.ctx[5];
    }
    get closeModalOpening() {
        return this.$$.ctx[6];
    }
    get hide() {
        return this.$$.ctx[7];
    }
    get positionModal() {
        return this.$$.ctx[8];
    }
    get setupForStep() {
        return this.$$.ctx[9];
    }
    get show() {
        return this.$$.ctx[10];
    }
}
const $398b6f99c6877d63$export$2e2bcd8739ae039 = new $398b6f99c6877d63$var$Evented();
/**
 * Class representing the site tour
 * @extends {Evented}
 */ class $398b6f99c6877d63$var$Tour extends $398b6f99c6877d63$var$Evented {
    /**
   * @param {Object} options The options for the tour
   * @param {boolean | function(): boolean | Promise<boolean> | function(): Promise<boolean>} options.confirmCancel If true, will issue a `window.confirm` before cancelling.
   * If it is a function(support Async Function), it will be called and wait for the return value, and will only be cancelled if the value returned is true
   * @param {string} options.confirmCancelMessage The message to display in the `window.confirm` dialog
   * @param {string} options.classPrefix The prefix to add to the `shepherd-enabled` and `shepherd-target` class names as well as the `data-shepherd-step-id`.
   * @param {Object} options.defaultStepOptions Default options for Steps ({@link Step#constructor}), created through `addStep`
   * @param {boolean} options.exitOnEsc Exiting the tour with the escape key will be enabled unless this is explicitly
   * set to false.
   * @param {boolean} options.keyboardNavigation Navigating the tour via left and right arrow keys will be enabled
   * unless this is explicitly set to false.
   * @param {HTMLElement} options.stepsContainer An optional container element for the steps.
   * If not set, the steps will be appended to `document.body`.
   * @param {HTMLElement} options.modalContainer An optional container element for the modal.
   * If not set, the modal will be appended to `document.body`.
   * @param {object[] | Step[]} options.steps An array of step options objects or Step instances to initialize the tour with
   * @param {string} options.tourName An optional "name" for the tour. This will be appended to the the tour's
   * dynamically generated `id` property.
   * @param {boolean} options.useModalOverlay Whether or not steps should be placed above a darkened
   * modal overlay. If true, the overlay will create an opening around the target element so that it
   * can remain interactive
   * @returns {Tour}
   */ constructor(options = {}){
        super(options);
        $398b6f99c6877d63$var$autoBind(this);
        const defaultTourOptions = {
            exitOnEsc: true,
            keyboardNavigation: true
        };
        this.options = Object.assign({}, defaultTourOptions, options);
        this.classPrefix = $398b6f99c6877d63$var$normalizePrefix(this.options.classPrefix);
        this.steps = [];
        this.addSteps(this.options.steps);
        // Pass these events onto the global Shepherd object
        const events = [
            "active",
            "cancel",
            "complete",
            "inactive",
            "show",
            "start"
        ];
        events.map((event)=>{
            ((e)=>{
                this.on(e, (opts)=>{
                    opts = opts || {};
                    opts.tour = this;
                    $398b6f99c6877d63$export$2e2bcd8739ae039.trigger(e, opts);
                });
            })(event);
        });
        this._setTourID();
        return this;
    }
    /**
   * Adds a new step to the tour
   * @param {Object|Step} options An object containing step options or a Step instance
   * @param {number} index The optional index to insert the step at. If undefined, the step
   * is added to the end of the array.
   * @return {Step} The newly added step
   */ addStep(options, index) {
        let step = options;
        if (!(step instanceof $398b6f99c6877d63$var$Step)) step = new $398b6f99c6877d63$var$Step(this, step);
        else step.tour = this;
        if (!$398b6f99c6877d63$var$isUndefined(index)) this.steps.splice(index, 0, step);
        else this.steps.push(step);
        return step;
    }
    /**
   * Add multiple steps to the tour
   * @param {Array<object> | Array<Step>} steps The steps to add to the tour
   */ addSteps(steps) {
        if (Array.isArray(steps)) steps.forEach((step)=>{
            this.addStep(step);
        });
        return this;
    }
    /**
   * Go to the previous step in the tour
   */ back() {
        const index = this.steps.indexOf(this.currentStep);
        this.show(index - 1, false);
    }
    /**
   * Calls _done() triggering the 'cancel' event
   * If `confirmCancel` is true, will show a window.confirm before cancelling
   * If `confirmCancel` is a function, will call it and wait for the return value,
   * and only cancel when the value returned is true
   */ async cancel() {
        if (this.options.confirmCancel) {
            const confirmCancelIsFunction = typeof this.options.confirmCancel === "function";
            const cancelMessage = this.options.confirmCancelMessage || "Are you sure you want to stop the tour?";
            const stopTour = confirmCancelIsFunction ? await this.options.confirmCancel() : window.confirm(cancelMessage);
            if (stopTour) this._done("cancel");
        } else this._done("cancel");
    }
    /**
   * Calls _done() triggering the `complete` event
   */ complete() {
        this._done("complete");
    }
    /**
   * Gets the step from a given id
   * @param {Number|String} id The id of the step to retrieve
   * @return {Step} The step corresponding to the `id`
   */ getById(id) {
        return this.steps.find((step)=>{
            return step.id === id;
        });
    }
    /**
   * Gets the current step
   * @returns {Step|null}
   */ getCurrentStep() {
        return this.currentStep;
    }
    /**
   * Hide the current step
   */ hide() {
        const currentStep = this.getCurrentStep();
        if (currentStep) return currentStep.hide();
    }
    /**
   * Check if the tour is active
   * @return {boolean}
   */ isActive() {
        return $398b6f99c6877d63$export$2e2bcd8739ae039.activeTour === this;
    }
    /**
   * Go to the next step in the tour
   * If we are at the end, call `complete`
   */ next() {
        const index = this.steps.indexOf(this.currentStep);
        if (index === this.steps.length - 1) this.complete();
        else this.show(index + 1, true);
    }
    /**
   * Removes the step from the tour
   * @param {String} name The id for the step to remove
   */ removeStep(name) {
        const current = this.getCurrentStep();
        // Find the step, destroy it and remove it from this.steps
        this.steps.some((step, i)=>{
            if (step.id === name) {
                if (step.isOpen()) step.hide();
                step.destroy();
                this.steps.splice(i, 1);
                return true;
            }
        });
        if (current && current.id === name) {
            this.currentStep = undefined;
            // If we have steps left, show the first one, otherwise just cancel the tour
            this.steps.length ? this.show(0) : this.cancel();
        }
    }
    /**
   * Show a specific step in the tour
   * @param {Number|String} key The key to look up the step by
   * @param {Boolean} forward True if we are going forward, false if backward
   */ show(key = 0, forward = true) {
        const step = $398b6f99c6877d63$var$isString(key) ? this.getById(key) : this.steps[key];
        if (step) {
            this._updateStateBeforeShow();
            const shouldSkipStep = $398b6f99c6877d63$var$isFunction(step.options.showOn) && !step.options.showOn();
            // If `showOn` returns false, we want to skip the step, otherwise, show the step like normal
            if (shouldSkipStep) this._skipStep(step, forward);
            else {
                this.trigger("show", {
                    step: step,
                    previous: this.currentStep
                });
                this.currentStep = step;
                step.show();
            }
        }
    }
    /**
   * Start the tour
   */ start() {
        this.trigger("start");
        // Save the focused element before the tour opens
        this.focusedElBeforeOpen = document.activeElement;
        this.currentStep = null;
        this._setupModal();
        this._setupActiveTour();
        this.next();
    }
    /**
   * Called whenever the tour is cancelled or completed, basically anytime we exit the tour
   * @param {String} event The event name to trigger
   * @private
   */ _done(event) {
        const index = this.steps.indexOf(this.currentStep);
        if (Array.isArray(this.steps)) this.steps.forEach((step)=>step.destroy());
        $398b6f99c6877d63$var$cleanupSteps(this);
        this.trigger(event, {
            index: index
        });
        $398b6f99c6877d63$export$2e2bcd8739ae039.activeTour = null;
        this.trigger("inactive", {
            tour: this
        });
        if (this.modal) this.modal.hide();
        if (event === "cancel" || event === "complete") {
            if (this.modal) {
                const modalContainer = document.querySelector(".shepherd-modal-overlay-container");
                if (modalContainer) modalContainer.remove();
            }
        }
        // Focus the element that was focused before the tour started
        if ($398b6f99c6877d63$var$isHTMLElement$1(this.focusedElBeforeOpen)) this.focusedElBeforeOpen.focus();
    }
    /**
   * Make this tour "active"
   * @private
   */ _setupActiveTour() {
        this.trigger("active", {
            tour: this
        });
        $398b6f99c6877d63$export$2e2bcd8739ae039.activeTour = this;
    }
    /**
   * _setupModal create the modal container and instance
   * @private
   */ _setupModal() {
        this.modal = new $398b6f99c6877d63$var$Shepherd_modal({
            target: this.options.modalContainer || document.body,
            props: {
                classPrefix: this.classPrefix,
                styles: this.styles
            }
        });
    }
    /**
   * Called when `showOn` evaluates to false, to skip the step or complete the tour if it's the last step
   * @param {Step} step The step to skip
   * @param {Boolean} forward True if we are going forward, false if backward
   * @private
   */ _skipStep(step, forward) {
        const index = this.steps.indexOf(step);
        if (index === this.steps.length - 1) this.complete();
        else {
            const nextIndex = forward ? index + 1 : index - 1;
            this.show(nextIndex, forward);
        }
    }
    /**
   * Before showing, hide the current step and if the tour is not
   * already active, call `this._setupActiveTour`.
   * @private
   */ _updateStateBeforeShow() {
        if (this.currentStep) this.currentStep.hide();
        if (!this.isActive()) this._setupActiveTour();
    }
    /**
   * Sets this.id to `${tourName}--${uuid}`
   * @private
   */ _setTourID() {
        const tourName = this.options.tourName || "tour";
        this.id = `${tourName}--${$398b6f99c6877d63$var$uuid()}`;
    }
}
const $398b6f99c6877d63$var$isServerSide = typeof window === "undefined";
class $398b6f99c6877d63$var$NoOp {
    constructor(){}
}
if ($398b6f99c6877d63$var$isServerSide) Object.assign($398b6f99c6877d63$export$2e2bcd8739ae039, {
    Tour: $398b6f99c6877d63$var$NoOp,
    Step: $398b6f99c6877d63$var$NoOp
});
else Object.assign($398b6f99c6877d63$export$2e2bcd8739ae039, {
    Tour: $398b6f99c6877d63$var$Tour,
    Step: $398b6f99c6877d63$var$Step
});




function $2fa03f5d455d6f0a$export$cdda91dfb91997f3() {
    // marco como completado el tour para que no recargue todo el rato el tour
    localStorage.setItem("tourCompletado", true); // cuidado, que setItem sólo guarda strings
    // creo tour
    const tour = new (0, $398b6f99c6877d63$export$2e2bcd8739ae039).Tour({
        useModalOverlay: true,
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            //classes: 'class-1 class-2',
            scrollTo: {
                behavior: "smooth",
                block: "center"
            }
        }
    });
    // creo los pasos del tour
    //'Welcome',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle0),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText0),
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourExit),
                classes: "shepherd-button-secondary",
                action () {
                    return this.complete();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action: tour.next
            }
        ]
    });
    // "The map",
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle1),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText1),
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action: tour.next
            }
        ]
    });
    //'Zoom',
    if (!L.Browser.mobile) tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle2),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText2),
        classes: "mb-3",
        attachTo: {
            element: ".leaflet-control-zoom",
            on: "top-start"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Mi localización',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle3),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText3),
        classes: "mb-3",
        attachTo: {
            element: ".leaflet-control-locate",
            on: "top-start"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    // obtengo el elemento visible de clase usuario
    const usuarioElements = document.querySelectorAll(".usuario");
    // Iterate through the elements to find the visible one
    let visibleUsuarioElement = null;
    usuarioElements.forEach((element)=>{
        const style = getComputedStyle(element);
        if (style.display !== "none" && style.visibility !== "hidden") {
            visibleUsuarioElement = element;
            return;
        }
    });
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario) //'Your profile',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle4),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText4),
        classes: "mt-3",
        attachTo: {
            element: visibleUsuarioElement,
            on: "bottom"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    else //'Sign in',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle5),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText5),
        classes: "mt-3",
        attachTo: {
            element: visibleUsuarioElement,
            on: "bottom"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Create tree',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle6),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText6),
        classes: "mb-3",
        attachTo: {
            element: ".createtree",
            on: "top-start"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'View IFN trees',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle7),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText7),
        classes: "mb-3",
        attachTo: {
            element: ".verifn",
            on: "top-start"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Choose map layer',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle7a),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText7a),
        classes: "mb-3",
        attachTo: {
            element: ".esri",
            on: "top-start"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Refresh data',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle8),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText8),
        classes: "mb-3",
        attachTo: {
            element: ".refresh",
            on: "top-start"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Download data',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle9),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText9),
        classes: "mb-3",
        attachTo: {
            element: ".download",
            on: "top-start"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Filter taxon',	
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle10),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText10),
        classes: "mt-3",
        attachTo: {
            element: "#bot_taxones",
            on: "bottom"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'Scientific names',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle11),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText11),
        classes: "mt-3",
        attachTo: {
            element: "#bot_mapnomci",
            on: "bottom"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    if (0, $ffd94e1d81f19b1c$export$c398d137cd63b259) //'Search places',	
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle12),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText12),
        classes: "mt-3",
        attachTo: {
            element: "#lugares_heading",
            on: "bottom"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'More options',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle13),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText13),
        classes: "mt-3",
        attachTo: {
            element: "#bot_inicio",
            on: "bottom"
        },
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourNext),
                action () {
                    return this.next();
                }
            }
        ]
    });
    //'The end',
    tour.addStep({
        title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourTitle14),
        text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourText14),
        buttons: [
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourBack),
                classes: "shepherd-button-secondary",
                action () {
                    return this.back();
                }
            },
            {
                text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tourDone),
                action () {
                    return this.complete();
                }
            }
        ]
    });
    // lanzo...
    tour.start();
}


/*
   Copyright 2023, Guillermo Vega-Gorgojo

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");



var $2q7Wm = parcelRequire("2q7Wm");

var $6KOho = parcelRequire("6KOho");

var $dktVJ = parcelRequire("dktVJ");
var $cd948d9b215c1263$exports = {};

var $hPtJY = parcelRequire("hPtJY");
!function(t, e) {
    e($cd948d9b215c1263$exports);
}($cd948d9b215c1263$exports, function(t) {
    "use strict";
    var e = 6371008.8, n = {
        centimeters: 637100880,
        centimetres: 637100880,
        degrees: 57.22891354143274,
        feet: 20902260.511392,
        inches: 39.37 * e,
        kilometers: 6371.0088,
        kilometres: 6371.0088,
        meters: e,
        metres: e,
        miles: 3958.761333810546,
        millimeters: 6371008800,
        millimetres: 6371008800,
        nauticalmiles: e / 1852,
        radians: 1,
        yards: 6967335.223679999
    }, r = {
        centimeters: 100,
        centimetres: 100,
        degrees: 1 / 111325,
        feet: 3.28084,
        inches: 39.37,
        kilometers: .001,
        kilometres: .001,
        meters: 1,
        metres: 1,
        miles: 1 / 1609.344,
        millimeters: 1e3,
        millimetres: 1e3,
        nauticalmiles: 1 / 1852,
        radians: 1 / e,
        yards: 1.0936133
    }, i = {
        acres: 247105e-9,
        centimeters: 1e4,
        centimetres: 1e4,
        feet: 10.763910417,
        hectares: 1e-4,
        inches: 1550.003100006,
        kilometers: 1e-6,
        kilometres: 1e-6,
        meters: 1,
        metres: 1,
        miles: 386e-9,
        millimeters: 1e6,
        millimetres: 1e6,
        yards: 1.195990046
    };
    function o(t, e, n) {
        void 0 === n && (n = {});
        var r = {
            type: "Feature"
        };
        return (0 === n.id || n.id) && (r.id = n.id), n.bbox && (r.bbox = n.bbox), r.properties = e || {}, r.geometry = t, r;
    }
    function s(t, e, n) {
        switch(t){
            case "Point":
                return a(e).geometry;
            case "LineString":
                return h(e).geometry;
            case "Polygon":
                return l(e).geometry;
            case "MultiPoint":
                return d(e).geometry;
            case "MultiLineString":
                return g(e).geometry;
            case "MultiPolygon":
                return y(e).geometry;
            default:
                throw new Error(t + " is invalid");
        }
    }
    function a(t, e, n) {
        if (void 0 === n && (n = {}), !t) throw new Error("coordinates is required");
        if (!Array.isArray(t)) throw new Error("coordinates must be an Array");
        if (t.length < 2) throw new Error("coordinates must be at least 2 numbers long");
        if (!C(t[0]) || !C(t[1])) throw new Error("coordinates must contain numbers");
        return o({
            type: "Point",
            coordinates: t
        }, e, n);
    }
    function u(t, e, n) {
        return void 0 === n && (n = {}), f(t.map(function(t) {
            return a(t, e);
        }), n);
    }
    function l(t, e, n) {
        void 0 === n && (n = {});
        for(var r = 0, i = t; r < i.length; r++){
            var s = i[r];
            if (s.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
            for(var a = 0; a < s[s.length - 1].length; a++)if (s[s.length - 1][a] !== s[0][a]) throw new Error("First and last Position are not equivalent.");
        }
        return o({
            type: "Polygon",
            coordinates: t
        }, e, n);
    }
    function c(t, e, n) {
        return void 0 === n && (n = {}), f(t.map(function(t) {
            return l(t, e);
        }), n);
    }
    function h(t, e, n) {
        if (void 0 === n && (n = {}), t.length < 2) throw new Error("coordinates must be an array of two or more positions");
        return o({
            type: "LineString",
            coordinates: t
        }, e, n);
    }
    function p(t, e, n) {
        return void 0 === n && (n = {}), f(t.map(function(t) {
            return h(t, e);
        }), n);
    }
    function f(t, e) {
        void 0 === e && (e = {});
        var n = {
            type: "FeatureCollection"
        };
        return e.id && (n.id = e.id), e.bbox && (n.bbox = e.bbox), n.features = t, n;
    }
    function g(t, e, n) {
        return void 0 === n && (n = {}), o({
            type: "MultiLineString",
            coordinates: t
        }, e, n);
    }
    function d(t, e, n) {
        return void 0 === n && (n = {}), o({
            type: "MultiPoint",
            coordinates: t
        }, e, n);
    }
    function y(t, e, n) {
        return void 0 === n && (n = {}), o({
            type: "MultiPolygon",
            coordinates: t
        }, e, n);
    }
    function v(t, e, n) {
        return void 0 === n && (n = {}), o({
            type: "GeometryCollection",
            geometries: t
        }, e, n);
    }
    function _(t, e) {
        if (void 0 === e && (e = 0), e && !(e >= 0)) throw new Error("precision must be a positive number");
        var n = Math.pow(10, e || 0);
        return Math.round(t * n) / n;
    }
    function m(t, e) {
        void 0 === e && (e = "kilometers");
        var r = n[e];
        if (!r) throw new Error(e + " units is invalid");
        return t * r;
    }
    function x(t, e) {
        void 0 === e && (e = "kilometers");
        var r = n[e];
        if (!r) throw new Error(e + " units is invalid");
        return t / r;
    }
    function E(t, e) {
        return w(x(t, e));
    }
    function b(t) {
        var e = t % 360;
        return e < 0 && (e += 360), e;
    }
    function w(t) {
        return 180 * (t % (2 * Math.PI)) / Math.PI;
    }
    function I(t) {
        return t % 360 * Math.PI / 180;
    }
    function N(t, e, n) {
        if (void 0 === e && (e = "kilometers"), void 0 === n && (n = "kilometers"), !(t >= 0)) throw new Error("length must be a positive number");
        return m(x(t, e), n);
    }
    function S(t, e, n) {
        if (void 0 === e && (e = "meters"), void 0 === n && (n = "kilometers"), !(t >= 0)) throw new Error("area must be a positive number");
        var r = i[e];
        if (!r) throw new Error("invalid original units");
        var o = i[n];
        if (!o) throw new Error("invalid final units");
        return t / r * o;
    }
    function C(t) {
        return !isNaN(t) && null !== t && !Array.isArray(t);
    }
    function P(t) {
        return !!t && t.constructor === Object;
    }
    function M(t) {
        if (!t) throw new Error("bbox is required");
        if (!Array.isArray(t)) throw new Error("bbox must be an Array");
        if (4 !== t.length && 6 !== t.length) throw new Error("bbox must be an Array of 4 or 6 numbers");
        t.forEach(function(t) {
            if (!C(t)) throw new Error("bbox must only contain numbers");
        });
    }
    function L(t) {
        if (!t) throw new Error("id is required");
        if (-1 === [
            "string",
            "number"
        ].indexOf(typeof t)) throw new Error("id must be a number or a string");
    }
    var O = Object.freeze({
        __proto__: null,
        earthRadius: e,
        factors: n,
        unitsFactors: r,
        areaFactors: i,
        feature: o,
        geometry: s,
        point: a,
        points: u,
        polygon: l,
        polygons: c,
        lineString: h,
        lineStrings: p,
        featureCollection: f,
        multiLineString: g,
        multiPoint: d,
        multiPolygon: y,
        geometryCollection: v,
        round: _,
        radiansToLength: m,
        lengthToRadians: x,
        lengthToDegrees: E,
        bearingToAzimuth: b,
        radiansToDegrees: w,
        degreesToRadians: I,
        convertLength: N,
        convertArea: S,
        isNumber: C,
        isObject: P,
        validateBBox: M,
        validateId: L
    });
    function R(t, e, n) {
        if (null !== t) for(var r, i, o, s, a, u, l, c, h = 0, p = 0, f = t.type, g = "FeatureCollection" === f, d = "Feature" === f, y = g ? t.features.length : 1, v = 0; v < y; v++){
            a = (c = !!(l = g ? t.features[v].geometry : d ? t.geometry : t) && "GeometryCollection" === l.type) ? l.geometries.length : 1;
            for(var _ = 0; _ < a; _++){
                var m = 0, x = 0;
                if (null !== (s = c ? l.geometries[_] : l)) {
                    u = s.coordinates;
                    var E = s.type;
                    switch(h = !n || "Polygon" !== E && "MultiPolygon" !== E ? 0 : 1, E){
                        case null:
                            break;
                        case "Point":
                            if (!1 === e(u, p, v, m, x)) return !1;
                            p++, m++;
                            break;
                        case "LineString":
                        case "MultiPoint":
                            for(r = 0; r < u.length; r++){
                                if (!1 === e(u[r], p, v, m, x)) return !1;
                                p++, "MultiPoint" === E && m++;
                            }
                            "LineString" === E && m++;
                            break;
                        case "Polygon":
                        case "MultiLineString":
                            for(r = 0; r < u.length; r++){
                                for(i = 0; i < u[r].length - h; i++){
                                    if (!1 === e(u[r][i], p, v, m, x)) return !1;
                                    p++;
                                }
                                "MultiLineString" === E && m++, "Polygon" === E && x++;
                            }
                            "Polygon" === E && m++;
                            break;
                        case "MultiPolygon":
                            for(r = 0; r < u.length; r++){
                                for(x = 0, i = 0; i < u[r].length; i++){
                                    for(o = 0; o < u[r][i].length - h; o++){
                                        if (!1 === e(u[r][i][o], p, v, m, x)) return !1;
                                        p++;
                                    }
                                    x++;
                                }
                                m++;
                            }
                            break;
                        case "GeometryCollection":
                            for(r = 0; r < s.geometries.length; r++)if (!1 === R(s.geometries[r], e, n)) return !1;
                            break;
                        default:
                            throw new Error("Unknown Geometry Type");
                    }
                }
            }
        }
    }
    function T(t, e, n, r) {
        var i = n;
        return R(t, function(t, r, o, s, a) {
            i = 0 === r && void 0 === n ? t : e(i, t, r, o, s, a);
        }, r), i;
    }
    function A(t, e) {
        var n;
        switch(t.type){
            case "FeatureCollection":
                for(n = 0; n < t.features.length && !1 !== e(t.features[n].properties, n); n++);
                break;
            case "Feature":
                e(t.properties, 0);
        }
    }
    function D(t, e, n) {
        var r = n;
        return A(t, function(t, i) {
            r = 0 === i && void 0 === n ? t : e(r, t, i);
        }), r;
    }
    function F(t, e) {
        if ("Feature" === t.type) e(t, 0);
        else if ("FeatureCollection" === t.type) for(var n = 0; n < t.features.length && !1 !== e(t.features[n], n); n++);
    }
    function k(t, e, n) {
        var r = n;
        return F(t, function(t, i) {
            r = 0 === i && void 0 === n ? t : e(r, t, i);
        }), r;
    }
    function G(t) {
        var e = [];
        return R(t, function(t) {
            e.push(t);
        }), e;
    }
    function q(t, e) {
        var n, r, i, o, s, a, u, l, c, h, p = 0, f = "FeatureCollection" === t.type, g = "Feature" === t.type, d = f ? t.features.length : 1;
        for(n = 0; n < d; n++){
            for(a = f ? t.features[n].geometry : g ? t.geometry : t, l = f ? t.features[n].properties : g ? t.properties : {}, c = f ? t.features[n].bbox : g ? t.bbox : void 0, h = f ? t.features[n].id : g ? t.id : void 0, s = (u = !!a && "GeometryCollection" === a.type) ? a.geometries.length : 1, i = 0; i < s; i++)if (null !== (o = u ? a.geometries[i] : a)) switch(o.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (!1 === e(o, p, l, c, h)) return !1;
                    break;
                case "GeometryCollection":
                    for(r = 0; r < o.geometries.length; r++)if (!1 === e(o.geometries[r], p, l, c, h)) return !1;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
            else if (!1 === e(null, p, l, c, h)) return !1;
            p++;
        }
    }
    function B(t, e, n) {
        var r = n;
        return q(t, function(t, i, o, s, a) {
            r = 0 === i && void 0 === n ? t : e(r, t, i, o, s, a);
        }), r;
    }
    function z(t, e) {
        q(t, function(t, n, r, i, s) {
            var a, u = null === t ? null : t.type;
            switch(u){
                case null:
                case "Point":
                case "LineString":
                case "Polygon":
                    return !1 !== e(o(t, r, {
                        bbox: i,
                        id: s
                    }), n, 0) && void 0;
            }
            switch(u){
                case "MultiPoint":
                    a = "Point";
                    break;
                case "MultiLineString":
                    a = "LineString";
                    break;
                case "MultiPolygon":
                    a = "Polygon";
            }
            for(var l = 0; l < t.coordinates.length; l++){
                var c = t.coordinates[l];
                if (!1 === e(o({
                    type: a,
                    coordinates: c
                }, r), n, l)) return !1;
            }
        });
    }
    function j(t, e, n) {
        var r = n;
        return z(t, function(t, i, o) {
            r = 0 === i && 0 === o && void 0 === n ? t : e(r, t, i, o);
        }), r;
    }
    function U(t, e) {
        z(t, function(t, n, r) {
            var i = 0;
            if (t.geometry) {
                var o = t.geometry.type;
                if ("Point" !== o && "MultiPoint" !== o) {
                    var s, a = 0, u = 0, l = 0;
                    return !1 !== R(t, function(o, c, p, f, g) {
                        if (void 0 === s || n > a || f > u || g > l) return s = o, a = n, u = f, l = g, void (i = 0);
                        var d = h([
                            s,
                            o
                        ], t.properties);
                        if (!1 === e(d, n, r, g, i)) return !1;
                        i++, s = o;
                    }) && void 0;
                }
            }
        });
    }
    function V(t, e, n) {
        var r = n, i = !1;
        return U(t, function(t, o, s, a, u) {
            r = !1 === i && void 0 === n ? t : e(r, t, o, s, a, u), i = !0;
        }), r;
    }
    function X(t, e) {
        if (!t) throw new Error("geojson is required");
        z(t, function(t, n, r) {
            if (null !== t.geometry) {
                var i = t.geometry.type, o = t.geometry.coordinates;
                switch(i){
                    case "LineString":
                        if (!1 === e(t, n, r, 0, 0)) return !1;
                        break;
                    case "Polygon":
                        for(var s = 0; s < o.length; s++)if (!1 === e(h(o[s], t.properties), n, r, s)) return !1;
                }
            }
        });
    }
    function Y(t, e, n) {
        var r = n;
        return X(t, function(t, i, o, s) {
            r = 0 === i && void 0 === n ? t : e(r, t, i, o, s);
        }), r;
    }
    function H(t, e) {
        if (!P(e = e || {})) throw new Error("options is invalid");
        var n, r = e.featureIndex || 0, i = e.multiFeatureIndex || 0, o = e.geometryIndex || 0, s = e.segmentIndex || 0, a = e.properties;
        switch(t.type){
            case "FeatureCollection":
                r < 0 && (r = t.features.length + r), a = a || t.features[r].properties, n = t.features[r].geometry;
                break;
            case "Feature":
                a = a || t.properties, n = t.geometry;
                break;
            case "Point":
            case "MultiPoint":
                return null;
            case "LineString":
            case "Polygon":
            case "MultiLineString":
            case "MultiPolygon":
                n = t;
                break;
            default:
                throw new Error("geojson is invalid");
        }
        if (null === n) return null;
        var u = n.coordinates;
        switch(n.type){
            case "Point":
            case "MultiPoint":
                return null;
            case "LineString":
                return s < 0 && (s = u.length + s - 1), h([
                    u[s],
                    u[s + 1]
                ], a, e);
            case "Polygon":
                return o < 0 && (o = u.length + o), s < 0 && (s = u[o].length + s - 1), h([
                    u[o][s],
                    u[o][s + 1]
                ], a, e);
            case "MultiLineString":
                return i < 0 && (i = u.length + i), s < 0 && (s = u[i].length + s - 1), h([
                    u[i][s],
                    u[i][s + 1]
                ], a, e);
            case "MultiPolygon":
                return i < 0 && (i = u.length + i), o < 0 && (o = u[i].length + o), s < 0 && (s = u[i][o].length - s - 1), h([
                    u[i][o][s],
                    u[i][o][s + 1]
                ], a, e);
        }
        throw new Error("geojson is invalid");
    }
    function W(t, e) {
        if (!P(e = e || {})) throw new Error("options is invalid");
        var n, r = e.featureIndex || 0, i = e.multiFeatureIndex || 0, o = e.geometryIndex || 0, s = e.coordIndex || 0, u = e.properties;
        switch(t.type){
            case "FeatureCollection":
                r < 0 && (r = t.features.length + r), u = u || t.features[r].properties, n = t.features[r].geometry;
                break;
            case "Feature":
                u = u || t.properties, n = t.geometry;
                break;
            case "Point":
            case "MultiPoint":
                return null;
            case "LineString":
            case "Polygon":
            case "MultiLineString":
            case "MultiPolygon":
                n = t;
                break;
            default:
                throw new Error("geojson is invalid");
        }
        if (null === n) return null;
        var l = n.coordinates;
        switch(n.type){
            case "Point":
                return a(l, u, e);
            case "MultiPoint":
                return i < 0 && (i = l.length + i), a(l[i], u, e);
            case "LineString":
                return s < 0 && (s = l.length + s), a(l[s], u, e);
            case "Polygon":
                return o < 0 && (o = l.length + o), s < 0 && (s = l[o].length + s), a(l[o][s], u, e);
            case "MultiLineString":
                return i < 0 && (i = l.length + i), s < 0 && (s = l[i].length + s), a(l[i][s], u, e);
            case "MultiPolygon":
                return i < 0 && (i = l.length + i), o < 0 && (o = l[i].length + o), s < 0 && (s = l[i][o].length - s), a(l[i][o][s], u, e);
        }
        throw new Error("geojson is invalid");
    }
    var J = Object.freeze({
        __proto__: null,
        coordAll: G,
        coordEach: R,
        coordReduce: T,
        featureEach: F,
        featureReduce: k,
        findPoint: W,
        findSegment: H,
        flattenEach: z,
        flattenReduce: j,
        geomEach: q,
        geomReduce: B,
        lineEach: X,
        lineReduce: Y,
        propEach: A,
        propReduce: D,
        segmentEach: U,
        segmentReduce: V
    });
    function Z(t) {
        var e = [
            1 / 0,
            1 / 0,
            -1 / 0,
            -1 / 0
        ];
        return R(t, function(t) {
            e[0] > t[0] && (e[0] = t[0]), e[1] > t[1] && (e[1] = t[1]), e[2] < t[0] && (e[2] = t[0]), e[3] < t[1] && (e[3] = t[1]);
        }), e;
    }
    function K(t) {
        if (!t) throw new Error("coord is required");
        if (!Array.isArray(t)) {
            if ("Feature" === t.type && null !== t.geometry && "Point" === t.geometry.type) return t.geometry.coordinates;
            if ("Point" === t.type) return t.coordinates;
        }
        if (Array.isArray(t) && t.length >= 2 && !Array.isArray(t[0]) && !Array.isArray(t[1])) return t;
        throw new Error("coord must be GeoJSON Point or an Array of numbers");
    }
    function Q(t) {
        if (Array.isArray(t)) return t;
        if ("Feature" === t.type) {
            if (null !== t.geometry) return t.geometry.coordinates;
        } else if (t.coordinates) return t.coordinates;
        throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
    }
    function $(t) {
        if (t.length > 1 && C(t[0]) && C(t[1])) return !0;
        if (Array.isArray(t[0]) && t[0].length) return $(t[0]);
        throw new Error("coordinates must only contain numbers");
    }
    function tt(t, e, n) {
        if (!e || !n) throw new Error("type and name required");
        if (!t || t.type !== e) throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + t.type);
    }
    function et(t, e, n) {
        if (!t) throw new Error("No feature passed");
        if (!n) throw new Error(".featureOf() requires a name");
        if (!t || "Feature" !== t.type || !t.geometry) throw new Error("Invalid input to " + n + ", Feature with geometry required");
        if (!t.geometry || t.geometry.type !== e) throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + t.geometry.type);
    }
    function nt(t, e, n) {
        if (!t) throw new Error("No featureCollection passed");
        if (!n) throw new Error(".collectionOf() requires a name");
        if (!t || "FeatureCollection" !== t.type) throw new Error("Invalid input to " + n + ", FeatureCollection required");
        for(var r = 0, i = t.features; r < i.length; r++){
            var o = i[r];
            if (!o || "Feature" !== o.type || !o.geometry) throw new Error("Invalid input to " + n + ", Feature with geometry required");
            if (!o.geometry || o.geometry.type !== e) throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + o.geometry.type);
        }
    }
    function rt(t) {
        return "Feature" === t.type ? t.geometry : t;
    }
    function it(t, e) {
        return "FeatureCollection" === t.type ? "FeatureCollection" : "GeometryCollection" === t.type ? "GeometryCollection" : "Feature" === t.type && null !== t.geometry ? t.geometry.type : t.type;
    }
    Z.default = Z;
    var ot = Object.freeze({
        __proto__: null,
        getCoord: K,
        getCoords: Q,
        containsNumber: $,
        geojsonType: tt,
        featureOf: et,
        collectionOf: nt,
        getGeom: rt,
        getType: it
    }), st = Object.getOwnPropertySymbols, at = Object.prototype.hasOwnProperty, ut = Object.prototype.propertyIsEnumerable;
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */ function lt(t) {
        if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(t);
    }
    var ct = function() {
        try {
            if (!Object.assign) return !1;
            var t = new String("abc");
            if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;
            for(var e = {}, n = 0; n < 10; n++)e["_" + String.fromCharCode(n)] = n;
            if ("0123456789" !== Object.getOwnPropertyNames(e).map(function(t) {
                return e[t];
            }).join("")) return !1;
            var r = {};
            return "abcdefghijklmnopqrst".split("").forEach(function(t) {
                r[t] = t;
            }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
        } catch (t) {
            return !1;
        }
    }() ? Object.assign : function(t, e) {
        for(var n, r, i = lt(t), o = 1; o < arguments.length; o++){
            for(var s in n = Object(arguments[o]))at.call(n, s) && (i[s] = n[s]);
            if (st) {
                r = st(n);
                for(var a = 0; a < r.length; a++)ut.call(n, r[a]) && (i[r[a]] = n[r[a]]);
            }
        }
        return i;
    }, ht = {
        successCallback: null,
        verbose: !1
    }, pt = {};
    /**
     * @license GNU Affero General Public License.
     * Copyright (c) 2015, 2015 Ronny Lorenz <ronny@tbi.univie.ac.at>
     * v. 1.2.0
     * https://github.com/RaumZeit/MarchingSquares.js
     *
     * MarchingSquaresJS is free software: you can redistribute it and/or modify
     * it under the terms of the GNU Affero General Public License as published by
     * the Free Software Foundation, either version 3 of the License, or
     * (at your option) any later version.
     *
     * MarchingSquaresJS is distributed in the hope that it will be useful,
     * but WITHOUT ANY WARRANTY; without even the implied warranty of
     * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
     * GNU Affero General Public License for more details.
     *
     * As additional permission under GNU Affero General Public License version 3
     * section 7, third-party projects (personal or commercial) may distribute,
     * include, or link against UNMODIFIED VERSIONS of MarchingSquaresJS without the
     * requirement that said third-party project for that reason alone becomes
     * subject to any requirement of the GNU Affero General Public License version 3.
     * Any modifications to MarchingSquaresJS, however, must be shared with the public
     * and made available.
     *
     * In summary this:
     * - allows you to use MarchingSquaresJS at no cost
     * - allows you to use MarchingSquaresJS for both personal and commercial purposes
     * - allows you to distribute UNMODIFIED VERSIONS of MarchingSquaresJS under any
     *   license as long as this license notice is included
     * - enables you to keep the source code of your program that uses MarchingSquaresJS
     *   undisclosed
     * - forces you to share any modifications you have made to MarchingSquaresJS,
     *   e.g. bug-fixes
     *
     * You should have received a copy of the GNU Affero General Public License
     * along with MarchingSquaresJS.  If not, see <http://www.gnu.org/licenses/>.
     */ function ft(t, e, n) {
        n = n || {};
        for(var r = Object.keys(ht), i = 0; i < r.length; i++){
            var o = r[i], s = n[o];
            s = null != s ? s : ht[o], pt[o] = s;
        }
        pt.verbose && console.log("MarchingSquaresJS-isoContours: computing isocontour for " + e);
        var a = function(t) {
            var e = [], n = 0, r = 1e-7;
            return t.cells.forEach(function(i, o) {
                i.forEach(function(i, s) {
                    if (void 0 !== i && 5 !== (f = i).cval && 10 !== f.cval && !dt(i)) {
                        var a = function(t, e, n) {
                            var r, i, o = t.length, s = [], a = [
                                0,
                                0,
                                1,
                                1,
                                0,
                                0,
                                0,
                                0,
                                -1,
                                0,
                                1,
                                1,
                                -1,
                                0,
                                -1,
                                0
                            ], u = [
                                0,
                                -1,
                                0,
                                0,
                                1,
                                1,
                                1,
                                1,
                                0,
                                -1,
                                0,
                                0,
                                0,
                                -1,
                                0,
                                0
                            ], l = [
                                "none",
                                "left",
                                "bottom",
                                "left",
                                "right",
                                "none",
                                "bottom",
                                "left",
                                "top",
                                "top",
                                "none",
                                "top",
                                "right",
                                "right",
                                "bottom",
                                "none"
                            ], c = [
                                "none",
                                "bottom",
                                "right",
                                "right",
                                "top",
                                "top",
                                "top",
                                "top",
                                "left",
                                "bottom",
                                "right",
                                "right",
                                "left",
                                "bottom",
                                "left",
                                "none"
                            ], h = t[e][n], p = h.cval, f = l[p], g = vt(h, f);
                            s.push([
                                n + g[0],
                                e + g[1]
                            ]), f = c[p], g = vt(h, f), s.push([
                                n + g[0],
                                e + g[1]
                            ]), yt(h);
                            var d = n + a[p], y = e + u[p], v = p;
                            for(; d >= 0 && y >= 0 && y < o && (d != n || y != e) && void 0 !== (h = t[y][d]);){
                                if (0 === (p = h.cval) || 15 === p) return {
                                    path: s,
                                    info: "mergeable"
                                };
                                f = c[p], r = a[p], i = u[p], 5 !== p && 10 !== p || (5 === p ? h.flipped ? -1 === u[v] ? (f = "left", r = -1, i = 0) : (f = "right", r = 1, i = 0) : -1 === a[v] && (f = "bottom", r = 0, i = -1) : 10 === p && (h.flipped ? -1 === a[v] ? (f = "top", r = 0, i = 1) : (f = "bottom", r = 0, i = -1) : 1 === u[v] && (f = "left", r = -1, i = 0))), g = vt(h, f), s.push([
                                    d + g[0],
                                    y + g[1]
                                ]), yt(h), d += r, y += i, v = p;
                            }
                            return {
                                path: s,
                                info: "closed"
                            };
                        }(t.cells, o, s), u = !1;
                        if ("mergeable" === a.info) {
                            for(var l = a.path[a.path.length - 1][0], c = a.path[a.path.length - 1][1], h = n - 1; h >= 0; h--)if (Math.abs(e[h][0][0] - l) <= r && Math.abs(e[h][0][1] - c) <= r) {
                                for(var p = a.path.length - 2; p >= 0; --p)e[h].unshift(a.path[p]);
                                u = !0;
                                break;
                            }
                        }
                        u || (e[n++] = a.path);
                    }
                    var f;
                });
            }), e;
        }(function(t, e) {
            for(var n = t.length - 1, r = t[0].length - 1, i = {
                rows: n,
                cols: r,
                cells: []
            }, o = 0; o < n; ++o){
                i.cells[o] = [];
                for(var s = 0; s < r; ++s){
                    var a = 0, u = t[o + 1][s], l = t[o + 1][s + 1], c = t[o][s + 1], h = t[o][s];
                    if (!(isNaN(u) || isNaN(l) || isNaN(c) || isNaN(h))) {
                        a |= u >= e ? 8 : 0, a |= l >= e ? 4 : 0, a |= c >= e ? 2 : 0;
                        var p, f, g, d, y = !1;
                        if (5 === (a |= h >= e ? 1 : 0) || 10 === a) {
                            var v = (u + l + c + h) / 4;
                            5 === a && v < e ? (a = 10, y = !0) : 10 === a && v < e && (a = 5, y = !0);
                        }
                        if (0 !== a && 15 !== a) p = f = g = d = .5, 1 === a ? (g = 1 - gt(e, u, h), f = 1 - gt(e, c, h)) : 2 === a ? (f = gt(e, h, c), d = 1 - gt(e, l, c)) : 3 === a ? (g = 1 - gt(e, u, h), d = 1 - gt(e, l, c)) : 4 === a ? (p = gt(e, u, l), d = gt(e, c, l)) : 5 === a ? (p = gt(e, u, l), d = gt(e, c, l), f = 1 - gt(e, c, h), g = 1 - gt(e, u, h)) : 6 === a ? (f = gt(e, h, c), p = gt(e, u, l)) : 7 === a ? (g = 1 - gt(e, u, h), p = gt(e, u, l)) : 8 === a ? (g = gt(e, h, u), p = 1 - gt(e, l, u)) : 9 === a ? (f = 1 - gt(e, c, h), p = 1 - gt(e, l, u)) : 10 === a ? (p = 1 - gt(e, l, u), d = 1 - gt(e, l, c), f = gt(e, h, c), g = gt(e, h, u)) : 11 === a ? (p = 1 - gt(e, l, u), d = 1 - gt(e, l, c)) : 12 === a ? (g = gt(e, h, u), d = gt(e, c, l)) : 13 === a ? (f = 1 - gt(e, c, h), d = gt(e, c, l)) : 14 === a ? (g = gt(e, h, u), f = gt(e, h, c)) : console.log("MarchingSquaresJS-isoContours: Illegal cval detected: " + a), i.cells[o][s] = {
                            cval: a,
                            flipped: y,
                            top: p,
                            right: d,
                            bottom: f,
                            left: g
                        };
                    }
                }
            }
            return i;
        }(t, e));
        return "function" == typeof pt.successCallback && pt.successCallback(a), a;
    }
    function gt(t, e, n) {
        return (t - e) / (n - e);
    }
    function dt(t) {
        return 0 === t.cval || 15 === t.cval;
    }
    function yt(t) {
        dt(t) || 5 === t.cval || 10 === t.cval || (t.cval = 15);
    }
    function vt(t, e) {
        return "top" === e ? [
            t.top,
            1
        ] : "bottom" === e ? [
            t.bottom,
            0
        ] : "right" === e ? [
            1,
            t.right
        ] : "left" === e ? [
            0,
            t.left
        ] : void 0;
    }
    function _t(t, e) {
        if (!P(e = e || {})) throw new Error("options is invalid");
        var n = e.zProperty || "elevation", r = e.flip, i = e.flags;
        nt(t, "Point", "input must contain Points");
        for(var o = function(t, e) {
            var n = {};
            return F(t, function(t) {
                var e = Q(t)[1];
                n[e] || (n[e] = []), n[e].push(t);
            }), Object.keys(n).map(function(t) {
                return n[t].sort(function(t, e) {
                    return Q(t)[0] - Q(e)[0];
                });
            }).sort(function(t, n) {
                return e ? Q(t[0])[1] - Q(n[0])[1] : Q(n[0])[1] - Q(t[0])[1];
            });
        }(t, r), s = [], a = 0; a < o.length; a++){
            for(var u = o[a], l = [], c = 0; c < u.length; c++){
                var h = u[c];
                h.properties[n] ? l.push(h.properties[n]) : l.push(0), !0 === i && (h.properties.matrixPosition = [
                    a,
                    c
                ]);
            }
            s.push(l);
        }
        return s;
    }
    var mt = Et, xt = Et;
    function Et(t, e, n, r, i) {
        bt(t, e, n || 0, r || t.length - 1, i || It);
    }
    function bt(t, e, n, r, i) {
        for(; r > n;){
            if (r - n > 600) {
                var o = r - n + 1, s = e - n + 1, a = Math.log(o), u = .5 * Math.exp(2 * a / 3), l = .5 * Math.sqrt(a * u * (o - u) / o) * (s - o / 2 < 0 ? -1 : 1);
                bt(t, e, Math.max(n, Math.floor(e - s * u / o + l)), Math.min(r, Math.floor(e + (o - s) * u / o + l)), i);
            }
            var c = t[e], h = n, p = r;
            for(wt(t, n, e), i(t[r], c) > 0 && wt(t, n, r); h < p;){
                for(wt(t, h, p), h++, p--; i(t[h], c) < 0;)h++;
                for(; i(t[p], c) > 0;)p--;
            }
            0 === i(t[n], c) ? wt(t, n, p) : wt(t, ++p, r), p <= e && (n = p + 1), e <= p && (r = p - 1);
        }
    }
    function wt(t, e, n) {
        var r = t[e];
        t[e] = t[n], t[n] = r;
    }
    function It(t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
    }
    mt.default = xt;
    var Nt = Ct, St = Ct;
    function Ct(t, e) {
        if (!(this instanceof Ct)) return new Ct(t, e);
        this._maxEntries = Math.max(4, t || 9), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), e && this._initFormat(e), this.clear();
    }
    function Pt(t, e, n) {
        if (!n) return e.indexOf(t);
        for(var r = 0; r < e.length; r++)if (n(t, e[r])) return r;
        return -1;
    }
    function Mt(t, e) {
        Lt(t, 0, t.children.length, e, t);
    }
    function Lt(t, e, n, r, i) {
        i || (i = Gt(null)), i.minX = 1 / 0, i.minY = 1 / 0, i.maxX = -1 / 0, i.maxY = -1 / 0;
        for(var o, s = e; s < n; s++)o = t.children[s], Ot(i, t.leaf ? r(o) : o);
        return i;
    }
    function Ot(t, e) {
        return t.minX = Math.min(t.minX, e.minX), t.minY = Math.min(t.minY, e.minY), t.maxX = Math.max(t.maxX, e.maxX), t.maxY = Math.max(t.maxY, e.maxY), t;
    }
    function Rt(t, e) {
        return t.minX - e.minX;
    }
    function Tt(t, e) {
        return t.minY - e.minY;
    }
    function At(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function Dt(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function Ft(t, e) {
        return t.minX <= e.minX && t.minY <= e.minY && e.maxX <= t.maxX && e.maxY <= t.maxY;
    }
    function kt(t, e) {
        return e.minX <= t.maxX && e.minY <= t.maxY && e.maxX >= t.minX && e.maxY >= t.minY;
    }
    function Gt(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function qt(t, e, n, r, i) {
        for(var o, s = [
            e,
            n
        ]; s.length;)(n = s.pop()) - (e = s.pop()) <= r || (o = e + Math.ceil((n - e) / r / 2) * r, mt(t, o, e, n, i), s.push(e, o, o, n));
    }
    function Bt(t) {
        var e = {
            exports: {}
        };
        return t(e, e.exports), e.exports;
    }
    Ct.prototype = {
        all: function() {
            return this._all(this.data, []);
        },
        search: function(t) {
            var e = this.data, n = [], r = this.toBBox;
            if (!kt(t, e)) return n;
            for(var i, o, s, a, u = []; e;){
                for(i = 0, o = e.children.length; i < o; i++)s = e.children[i], kt(t, a = e.leaf ? r(s) : s) && (e.leaf ? n.push(s) : Ft(t, a) ? this._all(s, n) : u.push(s));
                e = u.pop();
            }
            return n;
        },
        collides: function(t) {
            var e = this.data, n = this.toBBox;
            if (!kt(t, e)) return !1;
            for(var r, i, o, s, a = []; e;){
                for(r = 0, i = e.children.length; r < i; r++)if (o = e.children[r], kt(t, s = e.leaf ? n(o) : o)) {
                    if (e.leaf || Ft(t, s)) return !0;
                    a.push(o);
                }
                e = a.pop();
            }
            return !1;
        },
        load: function(t) {
            if (!t || !t.length) return this;
            if (t.length < this._minEntries) {
                for(var e = 0, n = t.length; e < n; e++)this.insert(t[e]);
                return this;
            }
            var r = this._build(t.slice(), 0, t.length - 1, 0);
            if (this.data.children.length) {
                if (this.data.height === r.height) this._splitRoot(this.data, r);
                else {
                    if (this.data.height < r.height) {
                        var i = this.data;
                        this.data = r, r = i;
                    }
                    this._insert(r, this.data.height - r.height - 1, !0);
                }
            } else this.data = r;
            return this;
        },
        insert: function(t) {
            return t && this._insert(t, this.data.height - 1), this;
        },
        clear: function() {
            return this.data = Gt([]), this;
        },
        remove: function(t, e) {
            if (!t) return this;
            for(var n, r, i, o, s = this.data, a = this.toBBox(t), u = [], l = []; s || u.length;){
                if (s || (s = u.pop(), r = u[u.length - 1], n = l.pop(), o = !0), s.leaf && -1 !== (i = Pt(t, s.children, e))) return s.children.splice(i, 1), u.push(s), this._condense(u), this;
                o || s.leaf || !Ft(s, a) ? r ? (n++, s = r.children[n], o = !1) : s = null : (u.push(s), l.push(n), n = 0, r = s, s = s.children[0]);
            }
            return this;
        },
        toBBox: function(t) {
            return t;
        },
        compareMinX: Rt,
        compareMinY: Tt,
        toJSON: function() {
            return this.data;
        },
        fromJSON: function(t) {
            return this.data = t, this;
        },
        _all: function(t, e) {
            for(var n = []; t;)t.leaf ? e.push.apply(e, t.children) : n.push.apply(n, t.children), t = n.pop();
            return e;
        },
        _build: function(t, e, n, r) {
            var i, o = n - e + 1, s = this._maxEntries;
            if (o <= s) return Mt(i = Gt(t.slice(e, n + 1)), this.toBBox), i;
            r || (r = Math.ceil(Math.log(o) / Math.log(s)), s = Math.ceil(o / Math.pow(s, r - 1))), (i = Gt([])).leaf = !1, i.height = r;
            var a, u, l, c, h = Math.ceil(o / s), p = h * Math.ceil(Math.sqrt(s));
            for(qt(t, e, n, p, this.compareMinX), a = e; a <= n; a += p)for(qt(t, a, l = Math.min(a + p - 1, n), h, this.compareMinY), u = a; u <= l; u += h)c = Math.min(u + h - 1, l), i.children.push(this._build(t, u, c, r - 1));
            return Mt(i, this.toBBox), i;
        },
        _chooseSubtree: function(t, e, n, r) {
            for(var i, o, s, a, u, l, c, h, p, f; r.push(e), !e.leaf && r.length - 1 !== n;){
                for(c = h = 1 / 0, i = 0, o = e.children.length; i < o; i++)u = At(s = e.children[i]), p = t, f = s, (l = (Math.max(f.maxX, p.maxX) - Math.min(f.minX, p.minX)) * (Math.max(f.maxY, p.maxY) - Math.min(f.minY, p.minY)) - u) < h ? (h = l, c = u < c ? u : c, a = s) : l === h && u < c && (c = u, a = s);
                e = a || e.children[0];
            }
            return e;
        },
        _insert: function(t, e, n) {
            var r = this.toBBox, i = n ? t : r(t), o = [], s = this._chooseSubtree(i, this.data, e, o);
            for(s.children.push(t), Ot(s, i); e >= 0 && o[e].children.length > this._maxEntries;)this._split(o, e), e--;
            this._adjustParentBBoxes(i, o, e);
        },
        _split: function(t, e) {
            var n = t[e], r = n.children.length, i = this._minEntries;
            this._chooseSplitAxis(n, i, r);
            var o = this._chooseSplitIndex(n, i, r), s = Gt(n.children.splice(o, n.children.length - o));
            s.height = n.height, s.leaf = n.leaf, Mt(n, this.toBBox), Mt(s, this.toBBox), e ? t[e - 1].children.push(s) : this._splitRoot(n, s);
        },
        _splitRoot: function(t, e) {
            this.data = Gt([
                t,
                e
            ]), this.data.height = t.height + 1, this.data.leaf = !1, Mt(this.data, this.toBBox);
        },
        _chooseSplitIndex: function(t, e, n) {
            var r, i, o, s, a, u, l, c, h, p, f, g, d, y;
            for(u = l = 1 / 0, r = e; r <= n - e; r++)i = Lt(t, 0, r, this.toBBox), o = Lt(t, r, n, this.toBBox), h = i, p = o, f = void 0, g = void 0, d = void 0, y = void 0, f = Math.max(h.minX, p.minX), g = Math.max(h.minY, p.minY), d = Math.min(h.maxX, p.maxX), y = Math.min(h.maxY, p.maxY), s = Math.max(0, d - f) * Math.max(0, y - g), a = At(i) + At(o), s < u ? (u = s, c = r, l = a < l ? a : l) : s === u && a < l && (l = a, c = r);
            return c;
        },
        _chooseSplitAxis: function(t, e, n) {
            var r = t.leaf ? this.compareMinX : Rt, i = t.leaf ? this.compareMinY : Tt;
            this._allDistMargin(t, e, n, r) < this._allDistMargin(t, e, n, i) && t.children.sort(r);
        },
        _allDistMargin: function(t, e, n, r) {
            t.children.sort(r);
            var i, o, s = this.toBBox, a = Lt(t, 0, e, s), u = Lt(t, n - e, n, s), l = Dt(a) + Dt(u);
            for(i = e; i < n - e; i++)o = t.children[i], Ot(a, t.leaf ? s(o) : o), l += Dt(a);
            for(i = n - e - 1; i >= e; i--)o = t.children[i], Ot(u, t.leaf ? s(o) : o), l += Dt(u);
            return l;
        },
        _adjustParentBBoxes: function(t, e, n) {
            for(var r = n; r >= 0; r--)Ot(e[r], t);
        },
        _condense: function(t) {
            for(var e, n = t.length - 1; n >= 0; n--)0 === t[n].children.length ? n > 0 ? (e = t[n - 1].children).splice(e.indexOf(t[n]), 1) : this.clear() : Mt(t[n], this.toBBox);
        },
        _initFormat: function(t) {
            var e = [
                "return a",
                " - b",
                ";"
            ];
            this.compareMinX = new Function("a", "b", e.join(t[0])), this.compareMinY = new Function("a", "b", e.join(t[1])), this.toBBox = new Function("a", "return {minX: a" + t[0] + ", minY: a" + t[1] + ", maxX: a" + t[2] + ", maxY: a" + t[3] + "};");
        }
    }, Nt.default = St;
    var zt = function(t, e, n) {
        var r = t * e, i = jt * t, o = i - (i - t), s = t - o, a = jt * e, u = a - (a - e), l = e - u, c = s * l - (r - o * u - s * u - o * l);
        if (n) return n[0] = c, n[1] = r, n;
        return [
            c,
            r
        ];
    }, jt = +(Math.pow(2, 27) + 1);
    var Ut = function(t, e) {
        var n = 0 | t.length, r = 0 | e.length;
        if (1 === n && 1 === r) return function(t, e) {
            var n = t + e, r = n - t, i = t - (n - r) + (e - r);
            if (i) return [
                i,
                n
            ];
            return [
                n
            ];
        }(t[0], e[0]);
        var i, o, s = new Array(n + r), a = 0, u = 0, l = 0, c = Math.abs, h = t[u], p = c(h), f = e[l], g = c(f);
        p < g ? (o = h, (u += 1) < n && (h = t[u], p = c(h))) : (o = f, (l += 1) < r && (f = e[l], g = c(f)));
        u < n && p < g || l >= r ? (i = h, (u += 1) < n && (h = t[u], p = c(h))) : (i = f, (l += 1) < r && (f = e[l], g = c(f)));
        var d, y, v = i + o, _ = v - i, m = o - _, x = m, E = v;
        for(; u < n && l < r;)p < g ? (i = h, (u += 1) < n && (h = t[u], p = c(h))) : (i = f, (l += 1) < r && (f = e[l], g = c(f))), (m = (o = x) - (_ = (v = i + o) - i)) && (s[a++] = m), x = E - ((d = E + v) - (y = d - E)) + (v - y), E = d;
        for(; u < n;)(m = (o = x) - (_ = (v = (i = h) + o) - i)) && (s[a++] = m), x = E - ((d = E + v) - (y = d - E)) + (v - y), E = d, (u += 1) < n && (h = t[u]);
        for(; l < r;)(m = (o = x) - (_ = (v = (i = f) + o) - i)) && (s[a++] = m), x = E - ((d = E + v) - (y = d - E)) + (v - y), E = d, (l += 1) < r && (f = e[l]);
        x && (s[a++] = x);
        E && (s[a++] = E);
        a || (s[a++] = 0);
        return s.length = a, s;
    };
    var Vt = function(t, e, n) {
        var r = t + e, i = r - t, o = e - i, s = t - (r - i);
        if (n) return n[0] = s + o, n[1] = r, n;
        return [
            s + o,
            r
        ];
    };
    var Xt = function(t, e) {
        var n = t.length;
        if (1 === n) {
            var r = zt(t[0], e);
            return r[0] ? r : [
                r[1]
            ];
        }
        var i = new Array(2 * n), o = [
            .1,
            .1
        ], s = [
            .1,
            .1
        ], a = 0;
        zt(t[0], e, o), o[0] && (i[a++] = o[0]);
        for(var u = 1; u < n; ++u){
            zt(t[u], e, s);
            var l = o[1];
            Vt(l, s[0], o), o[0] && (i[a++] = o[0]);
            var c = s[1], h = o[1], p = c + h, f = h - (p - c);
            o[1] = p, f && (i[a++] = f);
        }
        o[1] && (i[a++] = o[1]);
        0 === a && (i[a++] = 0);
        return i.length = a, i;
    };
    var Yt = function(t, e) {
        var n = 0 | t.length, r = 0 | e.length;
        if (1 === n && 1 === r) return function(t, e) {
            var n = t + e, r = n - t, i = t - (n - r) + (e - r);
            if (i) return [
                i,
                n
            ];
            return [
                n
            ];
        }(t[0], -e[0]);
        var i, o, s = new Array(n + r), a = 0, u = 0, l = 0, c = Math.abs, h = t[u], p = c(h), f = -e[l], g = c(f);
        p < g ? (o = h, (u += 1) < n && (h = t[u], p = c(h))) : (o = f, (l += 1) < r && (f = -e[l], g = c(f)));
        u < n && p < g || l >= r ? (i = h, (u += 1) < n && (h = t[u], p = c(h))) : (i = f, (l += 1) < r && (f = -e[l], g = c(f)));
        var d, y, v = i + o, _ = v - i, m = o - _, x = m, E = v;
        for(; u < n && l < r;)p < g ? (i = h, (u += 1) < n && (h = t[u], p = c(h))) : (i = f, (l += 1) < r && (f = -e[l], g = c(f))), (m = (o = x) - (_ = (v = i + o) - i)) && (s[a++] = m), x = E - ((d = E + v) - (y = d - E)) + (v - y), E = d;
        for(; u < n;)(m = (o = x) - (_ = (v = (i = h) + o) - i)) && (s[a++] = m), x = E - ((d = E + v) - (y = d - E)) + (v - y), E = d, (u += 1) < n && (h = t[u]);
        for(; l < r;)(m = (o = x) - (_ = (v = (i = f) + o) - i)) && (s[a++] = m), x = E - ((d = E + v) - (y = d - E)) + (v - y), E = d, (l += 1) < r && (f = -e[l]);
        x && (s[a++] = x);
        E && (s[a++] = E);
        a || (s[a++] = 0);
        return s.length = a, s;
    };
    var Ht = Bt(function(t) {
        function e(t, e) {
            for(var n = new Array(t.length - 1), r = 1; r < t.length; ++r)for(var i = n[r - 1] = new Array(t.length - 1), o = 0, s = 0; o < t.length; ++o)o !== e && (i[s++] = t[r][o]);
            return n;
        }
        function n(t) {
            if (1 === t.length) return t[0];
            if (2 === t.length) return [
                "sum(",
                t[0],
                ",",
                t[1],
                ")"
            ].join("");
            var e = t.length >> 1;
            return [
                "sum(",
                n(t.slice(0, e)),
                ",",
                n(t.slice(e)),
                ")"
            ].join("");
        }
        function r(t) {
            if (2 === t.length) return [
                [
                    "sum(prod(",
                    t[0][0],
                    ",",
                    t[1][1],
                    "),prod(-",
                    t[0][1],
                    ",",
                    t[1][0],
                    "))"
                ].join("")
            ];
            for(var i = [], o = 0; o < t.length; ++o)i.push([
                "scale(",
                n(r(e(t, o))),
                ",",
                (s = o, 1 & s ? "-" : ""),
                t[0][o],
                ")"
            ].join(""));
            var s;
            return i;
        }
        function i(t) {
            for(var i = [], o = [], s = function(t) {
                for(var e = new Array(t), n = 0; n < t; ++n){
                    e[n] = new Array(t);
                    for(var r = 0; r < t; ++r)e[n][r] = [
                        "m",
                        r,
                        "[",
                        t - n - 1,
                        "]"
                    ].join("");
                }
                return e;
            }(t), a = [], u = 0; u < t; ++u)0 == (1 & u) ? i.push.apply(i, r(e(s, u))) : o.push.apply(o, r(e(s, u))), a.push("m" + u);
            var l = n(i), c = n(o), h = "orientation" + t + "Exact", p = [
                "function ",
                h,
                "(",
                a.join(),
                "){var p=",
                l,
                ",n=",
                c,
                ",d=sub(p,n);return d[d.length-1];};return ",
                h
            ].join("");
            return new Function("sum", "prod", "scale", "sub", p)(Ut, zt, Xt, Yt);
        }
        var o = i(3), s = i(4), a = [
            function() {
                return 0;
            },
            function() {
                return 0;
            },
            function(t, e) {
                return e[0] - t[0];
            },
            function(t, e, n) {
                var r, i = (t[1] - n[1]) * (e[0] - n[0]), s = (t[0] - n[0]) * (e[1] - n[1]), a = i - s;
                if (i > 0) {
                    if (s <= 0) return a;
                    r = i + s;
                } else {
                    if (!(i < 0)) return a;
                    if (s >= 0) return a;
                    r = -(i + s);
                }
                var u = 33306690738754716e-32 * r;
                return a >= u || a <= -u ? a : o(t, e, n);
            },
            function(t, e, n, r) {
                var i = t[0] - r[0], o = e[0] - r[0], a = n[0] - r[0], u = t[1] - r[1], l = e[1] - r[1], c = n[1] - r[1], h = t[2] - r[2], p = e[2] - r[2], f = n[2] - r[2], g = o * c, d = a * l, y = a * u, v = i * c, _ = i * l, m = o * u, x = h * (g - d) + p * (y - v) + f * (_ - m), E = 7771561172376103e-31 * ((Math.abs(g) + Math.abs(d)) * Math.abs(h) + (Math.abs(y) + Math.abs(v)) * Math.abs(p) + (Math.abs(_) + Math.abs(m)) * Math.abs(f));
                return x > E || -x > E ? x : s(t, e, n, r);
            }
        ];
        function u(t) {
            var e = a[t.length];
            return e || (e = a[t.length] = i(t.length)), e.apply(void 0, t);
        }
        !function() {
            for(; a.length <= 5;)a.push(i(a.length));
            for(var e = [], n = [
                "slow"
            ], r = 0; r <= 5; ++r)e.push("a" + r), n.push("o" + r);
            var o = [
                "function getOrientation(",
                e.join(),
                "){switch(arguments.length){case 0:case 1:return 0;"
            ];
            for(r = 2; r <= 5; ++r)o.push("case ", r, ":return o", r, "(", e.slice(0, r).join(), ");");
            o.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return getOrientation"), n.push(o.join(""));
            var s = Function.apply(void 0, n);
            for(t.exports = s.apply(void 0, [
                u
            ].concat(a)), r = 0; r <= 5; ++r)t.exports[r] = a[r];
        }();
    }), Wt = function(t) {
        var e = t.length;
        if (e < 3) {
            for(var n = new Array(e), r = 0; r < e; ++r)n[r] = r;
            return 2 === e && t[0][0] === t[1][0] && t[0][1] === t[1][1] ? [
                0
            ] : n;
        }
        var i = new Array(e);
        for(r = 0; r < e; ++r)i[r] = r;
        i.sort(function(e, n) {
            var r = t[e][0] - t[n][0];
            return r || t[e][1] - t[n][1];
        });
        var o = [
            i[0],
            i[1]
        ], s = [
            i[0],
            i[1]
        ];
        for(r = 2; r < e; ++r){
            for(var a = i[r], u = t[a], l = o.length; l > 1 && Jt(t[o[l - 2]], t[o[l - 1]], u) <= 0;)l -= 1, o.pop();
            for(o.push(a), l = s.length; l > 1 && Jt(t[s[l - 2]], t[s[l - 1]], u) >= 0;)l -= 1, s.pop();
            s.push(a);
        }
        n = new Array(s.length + o.length - 2);
        for(var c = 0, h = (r = 0, o.length); r < h; ++r)n[c++] = o[r];
        for(var p = s.length - 2; p > 0; --p)n[c++] = s[p];
        return n;
    }, Jt = Ht[3];
    var Zt = Qt, Kt = Qt;
    function Qt(t, e) {
        if (!(this instanceof Qt)) return new Qt(t, e);
        if (this.data = t || [], this.length = this.data.length, this.compare = e || $t, this.length > 0) for(var n = (this.length >> 1) - 1; n >= 0; n--)this._down(n);
    }
    function $t(t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
    }
    Qt.prototype = {
        push: function(t) {
            this.data.push(t), this.length++, this._up(this.length - 1);
        },
        pop: function() {
            if (0 !== this.length) {
                var t = this.data[0];
                return this.length--, this.length > 0 && (this.data[0] = this.data[this.length], this._down(0)), this.data.pop(), t;
            }
        },
        peek: function() {
            return this.data[0];
        },
        _up: function(t) {
            for(var e = this.data, n = this.compare, r = e[t]; t > 0;){
                var i = t - 1 >> 1, o = e[i];
                if (n(r, o) >= 0) break;
                e[t] = o, t = i;
            }
            e[t] = r;
        },
        _down: function(t) {
            for(var e = this.data, n = this.compare, r = this.length >> 1, i = e[t]; t < r;){
                var o = 1 + (t << 1), s = o + 1, a = e[o];
                if (s < this.length && n(e[s], a) < 0 && (o = s, a = e[s]), n(a, i) >= 0) break;
                e[t] = a, t = o;
            }
            e[t] = i;
        }
    }, Zt.default = Kt;
    var te = function(t, e) {
        for(var n = t[0], r = t[1], i = !1, o = 0, s = e.length - 1; o < e.length; s = o++){
            var a = e[o][0], u = e[o][1], l = e[s][0], c = e[s][1];
            u > r != c > r && n < (l - a) * (r - u) / (c - u) + a && (i = !i);
        }
        return i;
    }, ee = Ht[3], ne = ie, re = ie;
    function ie(t, e, n) {
        e = Math.max(0, void 0 === e ? 2 : e), n = n || 0;
        for(var r, i = function(t) {
            for(var e = t[0], n = t[0], r = t[0], i = t[0], o = 0; o < t.length; o++){
                var s = t[o];
                s[0] < e[0] && (e = s), s[0] > r[0] && (r = s), s[1] < n[1] && (n = s), s[1] > i[1] && (i = s);
            }
            var a = [
                e,
                n,
                r,
                i
            ], u = a.slice();
            for(o = 0; o < t.length; o++)te(t[o], a) || u.push(t[o]);
            var l = Wt(u), c = [];
            for(o = 0; o < l.length; o++)c.push(u[l[o]]);
            return c;
        }(t), o = Nt(16, [
            "[0]",
            "[1]",
            "[0]",
            "[1]"
        ]).load(t), s = [], a = 0; a < i.length; a++){
            var u = i[a];
            o.remove(u), r = he(u, r), s.push(r);
        }
        var l = Nt(16);
        for(a = 0; a < s.length; a++)l.insert(ce(s[a]));
        for(var c = e * e, h = n * n; s.length;){
            var p = s.shift(), f = p.p, g = p.next.p, d = pe(f, g);
            if (!(d < h)) {
                var y = d / c;
                (u = oe(o, p.prev.p, f, g, p.next.next.p, y, l)) && Math.min(pe(u, f), pe(u, g)) <= y && (s.push(p), s.push(he(u, p)), o.remove(u), l.remove(p), l.insert(ce(p)), l.insert(ce(p.next)));
            }
        }
        p = r;
        var v = [];
        do v.push(p.p), p = p.next;
        while (p !== r);
        return v.push(p.p), v;
    }
    function oe(t, e, n, r, i, o, s) {
        for(var a = new Zt(null, se), u = t.data; u;){
            for(var l = 0; l < u.children.length; l++){
                var c = u.children[l], h = u.leaf ? fe(c, n, r) : ae(n, r, c);
                h > o || a.push({
                    node: c,
                    dist: h
                });
            }
            for(; a.length && !a.peek().node.children;){
                var p = a.pop(), f = p.node, g = fe(f, e, n), d = fe(f, r, i);
                if (p.dist < g && p.dist < d && le(n, f, s) && le(r, f, s)) return f;
            }
            (u = a.pop()) && (u = u.node);
        }
        return null;
    }
    function se(t, e) {
        return t.dist - e.dist;
    }
    function ae(t, e, n) {
        if (ue(t, n) || ue(e, n)) return 0;
        var r = ge(t[0], t[1], e[0], e[1], n.minX, n.minY, n.maxX, n.minY);
        if (0 === r) return 0;
        var i = ge(t[0], t[1], e[0], e[1], n.minX, n.minY, n.minX, n.maxY);
        if (0 === i) return 0;
        var o = ge(t[0], t[1], e[0], e[1], n.maxX, n.minY, n.maxX, n.maxY);
        if (0 === o) return 0;
        var s = ge(t[0], t[1], e[0], e[1], n.minX, n.maxY, n.maxX, n.maxY);
        return 0 === s ? 0 : Math.min(r, i, o, s);
    }
    function ue(t, e) {
        return t[0] >= e.minX && t[0] <= e.maxX && t[1] >= e.minY && t[1] <= e.maxY;
    }
    function le(t, e, n) {
        for(var r, i, o, s, a = Math.min(t[0], e[0]), u = Math.min(t[1], e[1]), l = Math.max(t[0], e[0]), c = Math.max(t[1], e[1]), h = n.search({
            minX: a,
            minY: u,
            maxX: l,
            maxY: c
        }), p = 0; p < h.length; p++)if (r = h[p].p, i = h[p].next.p, o = t, r !== (s = e) && i !== o && ee(r, i, o) > 0 != ee(r, i, s) > 0 && ee(o, s, r) > 0 != ee(o, s, i) > 0) return !1;
        return !0;
    }
    function ce(t) {
        var e = t.p, n = t.next.p;
        return t.minX = Math.min(e[0], n[0]), t.minY = Math.min(e[1], n[1]), t.maxX = Math.max(e[0], n[0]), t.maxY = Math.max(e[1], n[1]), t;
    }
    function he(t, e) {
        var n = {
            p: t,
            prev: null,
            next: null,
            minX: 0,
            minY: 0,
            maxX: 0,
            maxY: 0
        };
        return e ? (n.next = e.next, n.prev = e, e.next.prev = n, e.next = n) : (n.prev = n, n.next = n), n;
    }
    function pe(t, e) {
        var n = t[0] - e[0], r = t[1] - e[1];
        return n * n + r * r;
    }
    function fe(t, e, n) {
        var r = e[0], i = e[1], o = n[0] - r, s = n[1] - i;
        if (0 !== o || 0 !== s) {
            var a = ((t[0] - r) * o + (t[1] - i) * s) / (o * o + s * s);
            a > 1 ? (r = n[0], i = n[1]) : a > 0 && (r += o * a, i += s * a);
        }
        return (o = t[0] - r) * o + (s = t[1] - i) * s;
    }
    function ge(t, e, n, r, i, o, s, a) {
        var u, l, c, h, p = n - t, f = r - e, g = s - i, d = a - o, y = t - i, v = e - o, _ = p * p + f * f, m = p * g + f * d, x = g * g + d * d, E = p * y + f * v, b = g * y + d * v, w = _ * x - m * m, I = w, N = w;
        0 === w ? (l = 0, I = 1, h = b, N = x) : (h = _ * b - m * E, (l = m * b - x * E) < 0 ? (l = 0, h = b, N = x) : l > I && (l = I, h = b + m, N = x)), h < 0 ? (h = 0, -E < 0 ? l = 0 : -E > _ ? l = I : (l = -E, I = _)) : h > N && (h = N, -E + m < 0 ? l = 0 : -E + m > _ ? l = I : (l = -E + m, I = _));
        var S = (1 - (c = 0 === h ? 0 : h / N)) * i + c * s - ((1 - (u = 0 === l ? 0 : l / I)) * t + u * n), C = (1 - c) * o + c * a - ((1 - u) * e + u * r);
        return S * S + C * C;
    }
    function de(t, e) {
        void 0 === e && (e = {}), e.concavity = e.concavity || 1 / 0;
        var n = [];
        if (R(t, function(t) {
            n.push([
                t[0],
                t[1]
            ]);
        }), !n.length) return null;
        var r = ne(n, e.concavity);
        return r.length > 3 ? l([
            r
        ]) : null;
    }
    function ye(t, e, n) {
        if (void 0 === n && (n = {}), !t) throw new Error("point is required");
        if (!e) throw new Error("polygon is required");
        var r = K(t), i = rt(e), o = i.type, s = e.bbox, a = i.coordinates;
        if (s && !1 === function(t, e) {
            return e[0] <= t[0] && e[1] <= t[1] && e[2] >= t[0] && e[3] >= t[1];
        }(r, s)) return !1;
        "Polygon" === o && (a = [
            a
        ]);
        for(var u = !1, l = 0; l < a.length && !u; l++)if (ve(r, a[l][0], n.ignoreBoundary)) {
            for(var c = !1, h = 1; h < a[l].length && !c;)ve(r, a[l][h], !n.ignoreBoundary) && (c = !0), h++;
            c || (u = !0);
        }
        return u;
    }
    function ve(t, e, n) {
        var r = !1;
        e[0][0] === e[e.length - 1][0] && e[0][1] === e[e.length - 1][1] && (e = e.slice(0, e.length - 1));
        for(var i = 0, o = e.length - 1; i < e.length; o = i++){
            var s = e[i][0], a = e[i][1], u = e[o][0], l = e[o][1];
            if (t[1] * (s - u) + a * (u - t[0]) + l * (t[0] - s) == 0 && (s - t[0]) * (u - t[0]) <= 0 && (a - t[1]) * (l - t[1]) <= 0) return !n;
            a > t[1] != l > t[1] && t[0] < (u - s) * (t[1] - a) / (l - a) + s && (r = !r);
        }
        return r;
    }
    function _e(t, e) {
        var n = [];
        return F(t, function(t) {
            var r = !1;
            if ("Point" === t.geometry.type) q(e, function(e) {
                ye(t, e) && (r = !0);
            }), r && n.push(t);
            else {
                if ("MultiPoint" !== t.geometry.type) throw new Error("Input geometry must be a Point or MultiPoint");
                var i = [];
                q(e, function(e) {
                    R(t, function(t) {
                        ye(t, e) && (r = !0, i.push(t));
                    });
                }), r && n.push(d(i));
            }
        }), f(n);
    }
    function me(t, e, n) {
        void 0 === n && (n = {});
        var r = K(t), i = K(e), o = I(i[1] - r[1]), s = I(i[0] - r[0]), a = I(r[1]), u = I(i[1]), l = Math.pow(Math.sin(o / 2), 2) + Math.pow(Math.sin(s / 2), 2) * Math.cos(a) * Math.cos(u);
        return m(2 * Math.atan2(Math.sqrt(l), Math.sqrt(1 - l)), n.units);
    }
    function xe(t, e) {
        var n = !1;
        return f((function(t) {
            if (t.length < 3) return [];
            t.sort(be);
            var e, n, r, i, o, s, a = t.length - 1, u = t[a].x, l = t[0].x, c = t[a].y, h = c, p = 1e-12;
            for(; a--;)t[a].y < c && (c = t[a].y), t[a].y > h && (h = t[a].y);
            var f, g = l - u, d = h - c, y = g > d ? g : d, v = .5 * (l + u), _ = .5 * (h + c), m = [
                new Ee({
                    __sentinel: !0,
                    x: v - 20 * y,
                    y: _ - y
                }, {
                    __sentinel: !0,
                    x: v,
                    y: _ + 20 * y
                }, {
                    __sentinel: !0,
                    x: v + 20 * y,
                    y: _ - y
                })
            ], x = [], E = [];
            a = t.length;
            for(; a--;){
                for(E.length = 0, f = m.length; f--;)(g = t[a].x - m[f].x) > 0 && g * g > m[f].r ? (x.push(m[f]), m.splice(f, 1)) : g * g + (d = t[a].y - m[f].y) * d > m[f].r || (E.push(m[f].a, m[f].b, m[f].b, m[f].c, m[f].c, m[f].a), m.splice(f, 1));
                for(we(E), f = E.length; f;)n = E[--f], e = E[--f], r = t[a], i = n.x - e.x, o = n.y - e.y, s = 2 * (i * (r.y - n.y) - o * (r.x - n.x)), Math.abs(s) > p && m.push(new Ee(e, n, r));
            }
            Array.prototype.push.apply(x, m), a = x.length;
            for(; a--;)(x[a].a.__sentinel || x[a].b.__sentinel || x[a].c.__sentinel) && x.splice(a, 1);
            return x;
        })(t.features.map(function(t) {
            var r = {
                x: t.geometry.coordinates[0],
                y: t.geometry.coordinates[1]
            };
            return e ? r.z = t.properties[e] : 3 === t.geometry.coordinates.length && (n = !0, r.z = t.geometry.coordinates[2]), r;
        })).map(function(t) {
            var e = [
                t.a.x,
                t.a.y
            ], r = [
                t.b.x,
                t.b.y
            ], i = [
                t.c.x,
                t.c.y
            ], o = {};
            return n ? (e.push(t.a.z), r.push(t.b.z), i.push(t.c.z)) : o = {
                a: t.a.z,
                b: t.b.z,
                c: t.c.z
            }, l([
                [
                    e,
                    r,
                    i,
                    e
                ]
            ], o);
        }));
    }
    ne.default = re;
    var Ee = function(t, e, n) {
        this.a = t, this.b = e, this.c = n;
        var r, i, o = e.x - t.x, s = e.y - t.y, a = n.x - t.x, u = n.y - t.y, l = o * (t.x + e.x) + s * (t.y + e.y), c = a * (t.x + n.x) + u * (t.y + n.y), h = 2 * (o * (n.y - e.y) - s * (n.x - e.x));
        this.x = (u * l - s * c) / h, this.y = (o * c - a * l) / h, r = this.x - t.x, i = this.y - t.y, this.r = r * r + i * i;
    };
    function be(t, e) {
        return e.x - t.x;
    }
    function we(t) {
        var e, n, r, i, o, s = t.length;
        t: for(; s;)for(n = t[--s], e = t[--s], r = s; r;)if (o = t[--r], e === (i = t[--r]) && n === o || e === o && n === i) {
            t.splice(s, 2), t.splice(r, 2), s -= 2;
            continue t;
        }
    }
    function Ie(t) {
        if (!t) throw new Error("geojson is required");
        switch(t.type){
            case "Feature":
                return Ne(t);
            case "FeatureCollection":
                return function(t) {
                    var e = {
                        type: "FeatureCollection"
                    };
                    return Object.keys(t).forEach(function(n) {
                        switch(n){
                            case "type":
                            case "features":
                                return;
                            default:
                                e[n] = t[n];
                        }
                    }), e.features = t.features.map(function(t) {
                        return Ne(t);
                    }), e;
                }(t);
            case "Point":
            case "LineString":
            case "Polygon":
            case "MultiPoint":
            case "MultiLineString":
            case "MultiPolygon":
            case "GeometryCollection":
                return Ce(t);
            default:
                throw new Error("unknown GeoJSON type");
        }
    }
    function Ne(t) {
        var e = {
            type: "Feature"
        };
        return Object.keys(t).forEach(function(n) {
            switch(n){
                case "type":
                case "properties":
                case "geometry":
                    return;
                default:
                    e[n] = t[n];
            }
        }), e.properties = Se(t.properties), e.geometry = Ce(t.geometry), e;
    }
    function Se(t) {
        var e = {};
        return t ? (Object.keys(t).forEach(function(n) {
            var r = t[n];
            "object" == typeof r ? null === r ? e[n] = null : Array.isArray(r) ? e[n] = r.map(function(t) {
                return t;
            }) : e[n] = Se(r) : e[n] = r;
        }), e) : e;
    }
    function Ce(t) {
        var e = {
            type: t.type
        };
        return t.bbox && (e.bbox = t.bbox), "GeometryCollection" === t.type ? (e.geometries = t.geometries.map(function(t) {
            return Ce(t);
        }), e) : (e.coordinates = Pe(t.coordinates), e);
    }
    function Pe(t) {
        var e = t;
        return "object" != typeof e[0] ? e.slice() : e.map(function(t) {
            return Pe(t);
        });
    }
    function Me(t, e) {
        if (void 0 === e && (e = {}), !P(e = e || {})) throw new Error("options is invalid");
        var n = e.mutate;
        if ("FeatureCollection" !== it(t)) throw new Error("geojson must be a FeatureCollection");
        if (!t.features.length) throw new Error("geojson is empty");
        !1 !== n && void 0 !== n || (t = Ie(t));
        var r = [], i = Y(t, function(t, e) {
            var n = function(t, e) {
                var n, r = t.geometry.coordinates, i = e.geometry.coordinates, o = Le(r[0]), s = Le(r[r.length - 1]), a = Le(i[0]), u = Le(i[i.length - 1]);
                if (o === u) n = i.concat(r.slice(1));
                else if (a === s) n = r.concat(i.slice(1));
                else if (o === a) n = r.slice(1).reverse().concat(i);
                else {
                    if (s !== u) return null;
                    n = r.concat(i.reverse().slice(1));
                }
                return h(n);
            }(t, e);
            return n || (r.push(t), e);
        });
        return i && r.push(i), r.length ? 1 === r.length ? r[0] : g(r.map(function(t) {
            return t.coordinates;
        })) : null;
    }
    function Le(t) {
        return t[0].toString() + "," + t[1].toString();
    }
    function Oe(t) {
        return t;
    }
    function Re(t, e) {
        var n = function(t) {
            if (null == t) return Oe;
            var e, n, r = t.scale[0], i = t.scale[1], o = t.translate[0], s = t.translate[1];
            return function(t, a) {
                a || (e = n = 0);
                var u = 2, l = t.length, c = new Array(l);
                for(c[0] = (e += t[0]) * r + o, c[1] = (n += t[1]) * i + s; u < l;)c[u] = t[u], ++u;
                return c;
            };
        }(t.transform), r = t.arcs;
        function i(t, e) {
            e.length && e.pop();
            for(var i = r[t < 0 ? ~t : t], o = 0, s = i.length; o < s; ++o)e.push(n(i[o], o));
            t < 0 && function(t, e) {
                for(var n, r = t.length, i = r - e; i < --r;)n = t[i], t[i++] = t[r], t[r] = n;
            }(e, s);
        }
        function o(t) {
            return n(t);
        }
        function s(t) {
            for(var e = [], n = 0, r = t.length; n < r; ++n)i(t[n], e);
            return e.length < 2 && e.push(e[0]), e;
        }
        function a(t) {
            for(var e = s(t); e.length < 4;)e.push(e[0]);
            return e;
        }
        function u(t) {
            return t.map(a);
        }
        return function t(e) {
            var n, r = e.type;
            switch(r){
                case "GeometryCollection":
                    return {
                        type: r,
                        geometries: e.geometries.map(t)
                    };
                case "Point":
                    n = o(e.coordinates);
                    break;
                case "MultiPoint":
                    n = e.coordinates.map(o);
                    break;
                case "LineString":
                    n = s(e.arcs);
                    break;
                case "MultiLineString":
                    n = e.arcs.map(s);
                    break;
                case "Polygon":
                    n = u(e.arcs);
                    break;
                case "MultiPolygon":
                    n = e.arcs.map(u);
                    break;
                default:
                    return null;
            }
            return {
                type: r,
                coordinates: n
            };
        }(e);
    }
    function Te(t, e) {
        var n = {}, r = {}, i = {}, o = [], s = -1;
        function a(t, e) {
            for(var r in t){
                var i = t[r];
                delete e[i.start], delete i.start, delete i.end, i.forEach(function(t) {
                    n[t < 0 ? ~t : t] = 1;
                }), o.push(i);
            }
        }
        return e.forEach(function(n, r) {
            var i, o = t.arcs[n < 0 ? ~n : n];
            o.length < 3 && !o[1][0] && !o[1][1] && (i = e[++s], e[s] = n, e[r] = i);
        }), e.forEach(function(e) {
            var n, o, s = function(e) {
                var n, r = t.arcs[e < 0 ? ~e : e], i = r[0];
                t.transform ? (n = [
                    0,
                    0
                ], r.forEach(function(t) {
                    n[0] += t[0], n[1] += t[1];
                })) : n = r[r.length - 1];
                return e < 0 ? [
                    n,
                    i
                ] : [
                    i,
                    n
                ];
            }(e), a = s[0], u = s[1];
            if (n = i[a]) {
                if (delete i[n.end], n.push(e), n.end = u, o = r[u]) {
                    delete r[o.start];
                    var l = o === n ? n : n.concat(o);
                    r[l.start = n.start] = i[l.end = o.end] = l;
                } else r[n.start] = i[n.end] = n;
            } else if (n = r[u]) {
                if (delete r[n.start], n.unshift(e), n.start = a, o = i[a]) {
                    delete i[o.end];
                    var c = o === n ? n : o.concat(n);
                    r[c.start = o.start] = i[c.end = n.end] = c;
                } else r[n.start] = i[n.end] = n;
            } else r[(n = [
                e
            ]).start = a] = i[n.end = u] = n;
        }), a(i, r), a(r, i), e.forEach(function(t) {
            n[t < 0 ? ~t : t] || o.push([
                t
            ]);
        }), o;
    }
    function Ae(t, e) {
        var n = {}, r = [], i = [];
        function o(t) {
            t.forEach(function(e) {
                e.forEach(function(e) {
                    (n[e = e < 0 ? ~e : e] || (n[e] = [])).push(t);
                });
            }), r.push(t);
        }
        function s(e) {
            return function(t) {
                for(var e, n = -1, r = t.length, i = t[r - 1], o = 0; ++n < r;)e = i, i = t[n], o += e[0] * i[1] - e[1] * i[0];
                return Math.abs(o);
            }(Re(t, {
                type: "Polygon",
                arcs: [
                    e
                ]
            }).coordinates[0]);
        }
        return e.forEach(function t(e) {
            switch(e.type){
                case "GeometryCollection":
                    e.geometries.forEach(t);
                    break;
                case "Polygon":
                    o(e.arcs);
                    break;
                case "MultiPolygon":
                    e.arcs.forEach(o);
            }
        }), r.forEach(function(t) {
            if (!t._) {
                var e = [], r = [
                    t
                ];
                for(t._ = 1, i.push(e); t = r.pop();)e.push(t), t.forEach(function(t) {
                    t.forEach(function(t) {
                        n[t < 0 ? ~t : t].forEach(function(t) {
                            t._ || (t._ = 1, r.push(t));
                        });
                    });
                });
            }
        }), r.forEach(function(t) {
            delete t._;
        }), {
            type: "MultiPolygon",
            arcs: i.map(function(e) {
                var r, i = [];
                if (e.forEach(function(t) {
                    t.forEach(function(t) {
                        t.forEach(function(t) {
                            n[t < 0 ? ~t : t].length < 2 && i.push(t);
                        });
                    });
                }), (r = (i = Te(t, i)).length) > 1) for(var o, a, u = 1, l = s(i[0]); u < r; ++u)(o = s(i[u])) > l && (a = i[0], i[0] = i[u], i[u] = a, l = o);
                return i;
            }).filter(function(t) {
                return t.length > 0;
            })
        };
    }
    var De = Object.prototype.hasOwnProperty;
    function Fe(t, e, n, r, i, o) {
        3 === arguments.length && (r = o = Array, i = null);
        for(var s = new r(t = 1 << Math.max(4, Math.ceil(Math.log(t) / Math.LN2))), a = new o(t), u = t - 1, l = 0; l < t; ++l)s[l] = i;
        function c(r, o) {
            for(var l = e(r) & u, c = s[l], h = 0; c != i;){
                if (n(c, r)) return a[l] = o;
                if (++h >= t) throw new Error("full hashmap");
                c = s[l = l + 1 & u];
            }
            return s[l] = r, a[l] = o, o;
        }
        function h(r, o) {
            for(var l = e(r) & u, c = s[l], h = 0; c != i;){
                if (n(c, r)) return a[l];
                if (++h >= t) throw new Error("full hashmap");
                c = s[l = l + 1 & u];
            }
            return s[l] = r, a[l] = o, o;
        }
        function p(r, o) {
            for(var l = e(r) & u, c = s[l], h = 0; c != i;){
                if (n(c, r)) return a[l];
                if (++h >= t) break;
                c = s[l = l + 1 & u];
            }
            return o;
        }
        function f() {
            for(var t = [], e = 0, n = s.length; e < n; ++e){
                var r = s[e];
                r != i && t.push(r);
            }
            return t;
        }
        return {
            set: c,
            maybeSet: h,
            get: p,
            keys: f
        };
    }
    function ke(t, e) {
        return t[0] === e[0] && t[1] === e[1];
    }
    var Ge = new ArrayBuffer(16), qe = new Float64Array(Ge), Be = new Uint32Array(Ge);
    function ze(t) {
        qe[0] = t[0], qe[1] = t[1];
        var e = Be[0] ^ Be[1];
        return 2147483647 & (e = e << 5 ^ e >> 7 ^ Be[2] ^ Be[3]);
    }
    function je(t) {
        var e, n, r, i, o = t.coordinates, s = t.lines, a = t.rings, u = function() {
            for(var t = Fe(1.4 * o.length, E, b, Int32Array, -1, Int32Array), e = new Int32Array(o.length), n = 0, r = o.length; n < r; ++n)e[n] = t.maybeSet(n, n);
            return e;
        }(), l = new Int32Array(o.length), c = new Int32Array(o.length), h = new Int32Array(o.length), p = new Int8Array(o.length), f = 0;
        for(e = 0, n = o.length; e < n; ++e)l[e] = c[e] = h[e] = -1;
        for(e = 0, n = s.length; e < n; ++e){
            var g = s[e], d = g[0], y = g[1];
            for(r = u[d], i = u[++d], ++f, p[r] = 1; ++d <= y;)x(e, r, r = i, i = u[d]);
            ++f, p[i] = 1;
        }
        for(e = 0, n = o.length; e < n; ++e)l[e] = -1;
        for(e = 0, n = a.length; e < n; ++e){
            var v = a[e], _ = v[0] + 1, m = v[1];
            for(x(e, u[m - 1], r = u[_ - 1], i = u[_]); ++_ <= m;)x(e, r, r = i, i = u[_]);
        }
        function x(t, e, n, r) {
            if (l[n] !== t) {
                l[n] = t;
                var i = c[n];
                if (i >= 0) {
                    var o = h[n];
                    i === e && o === r || i === r && o === e || (++f, p[n] = 1);
                } else c[n] = e, h[n] = r;
            }
        }
        function E(t) {
            return ze(o[t]);
        }
        function b(t, e) {
            return ke(o[t], o[e]);
        }
        l = c = h = null;
        var w, I = function(t, e, n, r, i) {
            3 === arguments.length && (r = Array, i = null);
            for(var o = new r(t = 1 << Math.max(4, Math.ceil(Math.log(t) / Math.LN2))), s = t - 1, a = 0; a < t; ++a)o[a] = i;
            function u(r) {
                for(var a = e(r) & s, u = o[a], l = 0; u != i;){
                    if (n(u, r)) return !0;
                    if (++l >= t) throw new Error("full hashset");
                    u = o[a = a + 1 & s];
                }
                return o[a] = r, !0;
            }
            function l(r) {
                for(var a = e(r) & s, u = o[a], l = 0; u != i;){
                    if (n(u, r)) return !0;
                    if (++l >= t) break;
                    u = o[a = a + 1 & s];
                }
                return !1;
            }
            function c() {
                for(var t = [], e = 0, n = o.length; e < n; ++e){
                    var r = o[e];
                    r != i && t.push(r);
                }
                return t;
            }
            return {
                add: u,
                has: l,
                values: c
            };
        }(1.4 * f, ze, ke);
        for(e = 0, n = o.length; e < n; ++e)p[w = u[e]] && I.add(o[w]);
        return I;
    }
    function Ue(t, e, n, r) {
        Ve(t, e, n), Ve(t, e, e + r), Ve(t, e + r, n);
    }
    function Ve(t, e, n) {
        for(var r, i = e + (n-- - e >> 1); e < i; ++e, --n)r = t[e], t[e] = t[n], t[n] = r;
    }
    function Xe(t) {
        var e, n, r = {};
        for(e in t)r[e] = null == (n = t[e]) ? {
            type: null
        } : ("FeatureCollection" === n.type ? Ye : "Feature" === n.type ? He : We)(n);
        return r;
    }
    function Ye(t) {
        var e = {
            type: "GeometryCollection",
            geometries: t.features.map(He)
        };
        return null != t.bbox && (e.bbox = t.bbox), e;
    }
    function He(t) {
        var e, n = We(t.geometry);
        for(e in null != t.id && (n.id = t.id), null != t.bbox && (n.bbox = t.bbox), t.properties){
            n.properties = t.properties;
            break;
        }
        return n;
    }
    function We(t) {
        if (null == t) return {
            type: null
        };
        var e = "GeometryCollection" === t.type ? {
            type: "GeometryCollection",
            geometries: t.geometries.map(We)
        } : "Point" === t.type || "MultiPoint" === t.type ? {
            type: t.type,
            coordinates: t.coordinates
        } : {
            type: t.type,
            arcs: t.coordinates
        };
        return null != t.bbox && (e.bbox = t.bbox), e;
    }
    function Je(t, e) {
        var n = function(t) {
            var e = 1 / 0, n = 1 / 0, r = -1 / 0, i = -1 / 0;
            function o(t) {
                null != t && De.call(s, t.type) && s[t.type](t);
            }
            var s = {
                GeometryCollection: function(t) {
                    t.geometries.forEach(o);
                },
                Point: function(t) {
                    a(t.coordinates);
                },
                MultiPoint: function(t) {
                    t.coordinates.forEach(a);
                },
                LineString: function(t) {
                    u(t.arcs);
                },
                MultiLineString: function(t) {
                    t.arcs.forEach(u);
                },
                Polygon: function(t) {
                    t.arcs.forEach(u);
                },
                MultiPolygon: function(t) {
                    t.arcs.forEach(l);
                }
            };
            function a(t) {
                var o = t[0], s = t[1];
                o < e && (e = o), o > r && (r = o), s < n && (n = s), s > i && (i = s);
            }
            function u(t) {
                t.forEach(a);
            }
            function l(t) {
                t.forEach(u);
            }
            for(var c in t)o(t[c]);
            return r >= e && i >= n ? [
                e,
                n,
                r,
                i
            ] : void 0;
        }(t = Xe(t)), r = e > 0 && n && function(t, e, n) {
            var r = e[0], i = e[1], o = e[2], s = e[3], a = o - r ? (n - 1) / (o - r) : 1, u = s - i ? (n - 1) / (s - i) : 1;
            function l(t) {
                return [
                    Math.round((t[0] - r) * a),
                    Math.round((t[1] - i) * u)
                ];
            }
            function c(t, e) {
                for(var n, o, s, l, c, h = -1, p = 0, f = t.length, g = new Array(f); ++h < f;)n = t[h], l = Math.round((n[0] - r) * a), c = Math.round((n[1] - i) * u), l === o && c === s || (g[p++] = [
                    o = l,
                    s = c
                ]);
                for(g.length = p; p < e;)p = g.push([
                    g[0][0],
                    g[0][1]
                ]);
                return g;
            }
            function h(t) {
                return c(t, 2);
            }
            function p(t) {
                return c(t, 4);
            }
            function f(t) {
                return t.map(p);
            }
            function g(t) {
                null != t && De.call(d, t.type) && d[t.type](t);
            }
            var d = {
                GeometryCollection: function(t) {
                    t.geometries.forEach(g);
                },
                Point: function(t) {
                    t.coordinates = l(t.coordinates);
                },
                MultiPoint: function(t) {
                    t.coordinates = t.coordinates.map(l);
                },
                LineString: function(t) {
                    t.arcs = h(t.arcs);
                },
                MultiLineString: function(t) {
                    t.arcs = t.arcs.map(h);
                },
                Polygon: function(t) {
                    t.arcs = f(t.arcs);
                },
                MultiPolygon: function(t) {
                    t.arcs = t.arcs.map(f);
                }
            };
            for(var y in t)g(t[y]);
            return {
                scale: [
                    1 / a,
                    1 / u
                ],
                translate: [
                    r,
                    i
                ]
            };
        }(t, n, e), i = function(t) {
            var e, n, r, i, o = t.coordinates, s = t.lines, a = t.rings, u = s.length + a.length;
            for(delete t.lines, delete t.rings, r = 0, i = s.length; r < i; ++r)for(e = s[r]; e = e.next;)++u;
            for(r = 0, i = a.length; r < i; ++r)for(n = a[r]; n = n.next;)++u;
            var l = Fe(2 * u * 1.4, ze, ke), c = t.arcs = [];
            for(r = 0, i = s.length; r < i; ++r){
                e = s[r];
                do h(e);
                while (e = e.next);
            }
            for(r = 0, i = a.length; r < i; ++r)if ((n = a[r]).next) do h(n);
            while (n = n.next);
            else p(n);
            function h(t) {
                var e, n, r, i, s, a, u, h;
                if (r = l.get(e = o[t[0]])) {
                    for(u = 0, h = r.length; u < h; ++u)if (f(i = r[u], t)) return t[0] = i[0], void (t[1] = i[1]);
                }
                if (s = l.get(n = o[t[1]])) {
                    for(u = 0, h = s.length; u < h; ++u)if (g(a = s[u], t)) return t[1] = a[0], void (t[0] = a[1]);
                }
                r ? r.push(t) : l.set(e, [
                    t
                ]), s ? s.push(t) : l.set(n, [
                    t
                ]), c.push(t);
            }
            function p(t) {
                var e, n, r, i, s;
                if (n = l.get(o[t[0]])) for(i = 0, s = n.length; i < s; ++i){
                    if (d(r = n[i], t)) return t[0] = r[0], void (t[1] = r[1]);
                    if (y(r, t)) return t[0] = r[1], void (t[1] = r[0]);
                }
                if (n = l.get(e = o[t[0] + v(t)])) for(i = 0, s = n.length; i < s; ++i){
                    if (d(r = n[i], t)) return t[0] = r[0], void (t[1] = r[1]);
                    if (y(r, t)) return t[0] = r[1], void (t[1] = r[0]);
                }
                n ? n.push(t) : l.set(e, [
                    t
                ]), c.push(t);
            }
            function f(t, e) {
                var n = t[0], r = e[0], i = t[1];
                if (n - i != r - e[1]) return !1;
                for(; n <= i; ++n, ++r)if (!ke(o[n], o[r])) return !1;
                return !0;
            }
            function g(t, e) {
                var n = t[0], r = e[0], i = t[1], s = e[1];
                if (n - i != r - s) return !1;
                for(; n <= i; ++n, --s)if (!ke(o[n], o[s])) return !1;
                return !0;
            }
            function d(t, e) {
                var n = t[0], r = e[0], i = t[1] - n;
                if (i !== e[1] - r) return !1;
                for(var s = v(t), a = v(e), u = 0; u < i; ++u)if (!ke(o[n + (u + s) % i], o[r + (u + a) % i])) return !1;
                return !0;
            }
            function y(t, e) {
                var n = t[0], r = e[0], i = t[1], s = e[1], a = i - n;
                if (a !== s - r) return !1;
                for(var u = v(t), l = a - v(e), c = 0; c < a; ++c)if (!ke(o[n + (c + u) % a], o[s - (c + l) % a])) return !1;
                return !0;
            }
            function v(t) {
                for(var e = t[0], n = t[1], r = e, i = r, s = o[r]; ++r < n;){
                    var a = o[r];
                    (a[0] < s[0] || a[0] === s[0] && a[1] < s[1]) && (i = r, s = a);
                }
                return i - e;
            }
            return t;
        }(function(t) {
            var e, n, r, i = je(t), o = t.coordinates, s = t.lines, a = t.rings;
            for(n = 0, r = s.length; n < r; ++n)for(var u = s[n], l = u[0], c = u[1]; ++l < c;)i.has(o[l]) && (e = {
                0: l,
                1: u[1]
            }, u[1] = l, u = u.next = e);
            for(n = 0, r = a.length; n < r; ++n)for(var h = a[n], p = h[0], f = p, g = h[1], d = i.has(o[p]); ++f < g;)i.has(o[f]) && (d ? (e = {
                0: f,
                1: h[1]
            }, h[1] = f, h = h.next = e) : (Ue(o, p, g, g - f), o[g] = o[p], d = !0, f = p));
            return t;
        }(function(t) {
            var e = -1, n = [], r = [], i = [];
            function o(t) {
                t && De.call(s, t.type) && s[t.type](t);
            }
            var s = {
                GeometryCollection: function(t) {
                    t.geometries.forEach(o);
                },
                LineString: function(t) {
                    t.arcs = a(t.arcs);
                },
                MultiLineString: function(t) {
                    t.arcs = t.arcs.map(a);
                },
                Polygon: function(t) {
                    t.arcs = t.arcs.map(u);
                },
                MultiPolygon: function(t) {
                    t.arcs = t.arcs.map(l);
                }
            };
            function a(t) {
                for(var r = 0, o = t.length; r < o; ++r)i[++e] = t[r];
                var s = {
                    0: e - o + 1,
                    1: e
                };
                return n.push(s), s;
            }
            function u(t) {
                for(var n = 0, o = t.length; n < o; ++n)i[++e] = t[n];
                var s = {
                    0: e - o + 1,
                    1: e
                };
                return r.push(s), s;
            }
            function l(t) {
                return t.map(u);
            }
            for(var c in t)o(t[c]);
            return {
                type: "Topology",
                coordinates: i,
                lines: n,
                rings: r,
                objects: t
            };
        }(t))), o = i.coordinates, s = Fe(1.4 * i.arcs.length, Ze, Ke);
        function a(t) {
            t && De.call(u, t.type) && u[t.type](t);
        }
        t = i.objects, i.bbox = n, i.arcs = i.arcs.map(function(t, e) {
            return s.set(t, e), o.slice(t[0], t[1] + 1);
        }), delete i.coordinates, o = null;
        var u = {
            GeometryCollection: function(t) {
                t.geometries.forEach(a);
            },
            LineString: function(t) {
                t.arcs = l(t.arcs);
            },
            MultiLineString: function(t) {
                t.arcs = t.arcs.map(l);
            },
            Polygon: function(t) {
                t.arcs = t.arcs.map(l);
            },
            MultiPolygon: function(t) {
                t.arcs = t.arcs.map(c);
            }
        };
        function l(t) {
            var e = [];
            do {
                var n = s.get(t);
                e.push(t[0] < t[1] ? n : ~n);
            }while (t = t.next);
            return e;
        }
        function c(t) {
            return t.map(l);
        }
        for(var h in t)a(t[h]);
        return r && (i.transform = r, i.arcs = function(t) {
            for(var e = -1, n = t.length; ++e < n;){
                for(var r, i, o = t[e], s = 0, a = 1, u = o.length, l = o[0], c = l[0], h = l[1]; ++s < u;)r = (l = o[s])[0], i = l[1], r === c && i === h || (o[a++] = [
                    r - c,
                    i - h
                ], c = r, h = i);
                1 === a && (o[a++] = [
                    0,
                    0
                ]), o.length = a;
            }
            return t;
        }(i.arcs)), i;
    }
    function Ze(t) {
        var e, n = t[0], r = t[1];
        return r < n && (e = n, n = r, r = e), n + 31 * r;
    }
    function Ke(t, e) {
        var n, r = t[0], i = t[1], o = e[0], s = e[1];
        return i < r && (n = r, r = i, i = n), s < o && (n = o, o = s, s = n), r === o && i === s;
    }
    function Qe(t, e) {
        if (void 0 === e && (e = {}), "FeatureCollection" !== it(t)) throw new Error("geojson must be a FeatureCollection");
        if (!t.features.length) throw new Error("geojson is empty");
        !1 !== e.mutate && void 0 !== e.mutate || (t = Ie(t));
        var n = [];
        z(t, function(t) {
            n.push(t.geometry);
        });
        var r = Je({
            geoms: v(n).geometry
        });
        return function(t) {
            return Re(t, Ae.apply(this, arguments));
        }(r, r.objects.geoms.geometries);
    }
    function $e(t, e) {
        if (void 0 === e && (e = {}), !P(e = e || {})) throw new Error("options is invalid");
        var n = e.mutate;
        if ("FeatureCollection" !== it(t)) throw new Error("geojson must be a FeatureCollection");
        if (!t.features.length) throw new Error("geojson is empty");
        !1 !== n && void 0 !== n || (t = Ie(t));
        var r = function(t) {
            var e = {};
            z(t, function(t) {
                e[t.geometry.type] = !0;
            });
            var n = Object.keys(e);
            if (1 === n.length) return n[0];
            return null;
        }(t);
        if (!r) throw new Error("geojson must be homogenous");
        var i = t;
        switch(r){
            case "LineString":
                return Me(i, e);
            case "Polygon":
                return Qe(i, e);
            default:
                throw new Error(r + " is not supported");
        }
    }
    function tn(t, e) {
        void 0 === e && (e = {});
        var n = "object" == typeof e ? e.mutate : e;
        if (!t) throw new Error("geojson is required");
        var r = it(t), i = [];
        switch(r){
            case "LineString":
                i = en(t);
                break;
            case "MultiLineString":
            case "Polygon":
                Q(t).forEach(function(t) {
                    i.push(en(t));
                });
                break;
            case "MultiPolygon":
                Q(t).forEach(function(t) {
                    var e = [];
                    t.forEach(function(t) {
                        e.push(en(t));
                    }), i.push(e);
                });
                break;
            case "Point":
                return t;
            case "MultiPoint":
                var s = {};
                Q(t).forEach(function(t) {
                    var e = t.join("-");
                    Object.prototype.hasOwnProperty.call(s, e) || (i.push(t), s[e] = !0);
                });
                break;
            default:
                throw new Error(r + " geometry not supported");
        }
        return t.coordinates ? !0 === n ? (t.coordinates = i, t) : {
            type: r,
            coordinates: i
        } : !0 === n ? (t.geometry.coordinates = i, t) : o({
            type: r,
            coordinates: i
        }, t.properties, {
            bbox: t.bbox,
            id: t.id
        });
    }
    function en(t) {
        var e = Q(t);
        if (2 === e.length && !nn(e[0], e[1])) return e;
        var n = [], r = e.length - 1, i = n.length;
        n.push(e[0]);
        for(var o = 1; o < r; o++){
            var s = n[n.length - 1];
            e[o][0] === s[0] && e[o][1] === s[1] || (n.push(e[o]), (i = n.length) > 2 && rn(n[i - 3], n[i - 1], n[i - 2]) && n.splice(n.length - 2, 1));
        }
        if (n.push(e[e.length - 1]), i = n.length, nn(e[0], e[e.length - 1]) && i < 4) throw new Error("invalid polygon");
        return rn(n[i - 3], n[i - 1], n[i - 2]) && n.splice(n.length - 2, 1), n;
    }
    function nn(t, e) {
        return t[0] === e[0] && t[1] === e[1];
    }
    function rn(t, e, n) {
        var r = n[0], i = n[1], o = t[0], s = t[1], a = e[0], u = e[1], l = a - o, c = u - s;
        return 0 === (r - o) * c - (i - s) * l && (Math.abs(l) >= Math.abs(c) ? l > 0 ? o <= r && r <= a : a <= r && r <= o : c > 0 ? s <= i && i <= u : u <= i && i <= s);
    }
    function on(t, e, n) {
        var r = e.x, i = e.y, o = n.x - r, s = n.y - i;
        if (0 !== o || 0 !== s) {
            var a = ((t.x - r) * o + (t.y - i) * s) / (o * o + s * s);
            a > 1 ? (r = n.x, i = n.y) : a > 0 && (r += o * a, i += s * a);
        }
        return (o = t.x - r) * o + (s = t.y - i) * s;
    }
    function sn(t, e, n, r, i) {
        for(var o, s = r, a = e + 1; a < n; a++){
            var u = on(t[a], t[e], t[n]);
            u > s && (o = a, s = u);
        }
        s > r && (o - e > 1 && sn(t, e, o, r, i), i.push(t[o]), n - o > 1 && sn(t, o, n, r, i));
    }
    function an(t, e) {
        var n = t.length - 1, r = [
            t[0]
        ];
        return sn(t, 0, n, e, r), r.push(t[n]), r;
    }
    function un(t, e, n) {
        if (t.length <= 2) return t;
        var r = void 0 !== e ? e * e : 1;
        return t = an(t = n ? t : function(t, e) {
            for(var n, r, i, o, s, a = t[0], u = [
                a
            ], l = 1, c = t.length; l < c; l++)n = t[l], i = a, o = void 0, s = void 0, o = (r = n).x - i.x, s = r.y - i.y, o * o + s * s > e && (u.push(n), a = n);
            return a !== n && u.push(n), u;
        }(t, r), r);
    }
    function ln(t, e, n) {
        return un(t.map(function(t) {
            return {
                x: t[0],
                y: t[1],
                z: t[2]
            };
        }), e, n).map(function(t) {
            return t.z ? [
                t.x,
                t.y,
                t.z
            ] : [
                t.x,
                t.y
            ];
        });
    }
    function cn(t, e, n) {
        return t.map(function(t) {
            var r = t.map(function(t) {
                return {
                    x: t[0],
                    y: t[1]
                };
            });
            if (r.length < 4) throw new Error("invalid polygon");
            for(var i = un(r, e, n).map(function(t) {
                return [
                    t.x,
                    t.y
                ];
            }); !hn(i);)i = un(r, e -= .01 * e, n).map(function(t) {
                return [
                    t.x,
                    t.y
                ];
            });
            return i[i.length - 1][0] === i[0][0] && i[i.length - 1][1] === i[0][1] || i.push(i[0]), i;
        });
    }
    function hn(t) {
        return !(t.length < 3) && !(3 === t.length && t[2][0] === t[0][0] && t[2][1] === t[0][1]);
    }
    var pn = function() {
        function t(t) {
            this.points = t.points || [], this.duration = t.duration || 1e4, this.sharpness = t.sharpness || .85, this.centers = [], this.controls = [], this.stepLength = t.stepLength || 60, this.length = this.points.length, this.delay = 0;
            for(var e = 0; e < this.length; e++)this.points[e].z = this.points[e].z || 0;
            for(e = 0; e < this.length - 1; e++){
                var n = this.points[e], r = this.points[e + 1];
                this.centers.push({
                    x: (n.x + r.x) / 2,
                    y: (n.y + r.y) / 2,
                    z: (n.z + r.z) / 2
                });
            }
            this.controls.push([
                this.points[0],
                this.points[0]
            ]);
            for(e = 0; e < this.centers.length - 1; e++){
                var i = this.points[e + 1].x - (this.centers[e].x + this.centers[e + 1].x) / 2, o = this.points[e + 1].y - (this.centers[e].y + this.centers[e + 1].y) / 2, s = this.points[e + 1].z - (this.centers[e].y + this.centers[e + 1].z) / 2;
                this.controls.push([
                    {
                        x: (1 - this.sharpness) * this.points[e + 1].x + this.sharpness * (this.centers[e].x + i),
                        y: (1 - this.sharpness) * this.points[e + 1].y + this.sharpness * (this.centers[e].y + o),
                        z: (1 - this.sharpness) * this.points[e + 1].z + this.sharpness * (this.centers[e].z + s)
                    },
                    {
                        x: (1 - this.sharpness) * this.points[e + 1].x + this.sharpness * (this.centers[e + 1].x + i),
                        y: (1 - this.sharpness) * this.points[e + 1].y + this.sharpness * (this.centers[e + 1].y + o),
                        z: (1 - this.sharpness) * this.points[e + 1].z + this.sharpness * (this.centers[e + 1].z + s)
                    }
                ]);
            }
            return this.controls.push([
                this.points[this.length - 1],
                this.points[this.length - 1]
            ]), this.steps = this.cacheSteps(this.stepLength), this;
        }
        return t.prototype.cacheSteps = function(t) {
            var e = [], n = this.pos(0);
            e.push(0);
            for(var r = 0; r < this.duration; r += 10){
                var i = this.pos(r);
                Math.sqrt((i.x - n.x) * (i.x - n.x) + (i.y - n.y) * (i.y - n.y) + (i.z - n.z) * (i.z - n.z)) > t && (e.push(r), n = i);
            }
            return e;
        }, t.prototype.vector = function(t) {
            var e = this.pos(t + 10), n = this.pos(t - 10);
            return {
                angle: 180 * Math.atan2(e.y - n.y, e.x - n.x) / 3.14,
                speed: Math.sqrt((n.x - e.x) * (n.x - e.x) + (n.y - e.y) * (n.y - e.y) + (n.z - e.z) * (n.z - e.z))
            };
        }, t.prototype.pos = function(t) {
            var e = t - this.delay;
            e < 0 && (e = 0), e > this.duration && (e = this.duration - 1);
            var n = e / this.duration;
            if (n >= 1) return this.points[this.length - 1];
            var r = Math.floor((this.points.length - 1) * n);
            return function(t, e, n, r, i) {
                var o = function(t) {
                    var e = t * t;
                    return [
                        e * t,
                        3 * e * (1 - t),
                        3 * t * (1 - t) * (1 - t),
                        (1 - t) * (1 - t) * (1 - t)
                    ];
                }(t);
                return {
                    x: i.x * o[0] + r.x * o[1] + n.x * o[2] + e.x * o[3],
                    y: i.y * o[0] + r.y * o[1] + n.y * o[2] + e.y * o[3],
                    z: i.z * o[0] + r.z * o[1] + n.z * o[2] + e.z * o[3]
                };
            }((this.length - 1) * n - r, this.points[r], this.controls[r][1], this.controls[r + 1][0], this.points[r + 1]);
        }, t;
    }();
    function fn(t, e) {
        void 0 === e && (e = {});
        for(var n = e.resolution || 1e4, r = e.sharpness || .85, i = [], o = rt(t).coordinates.map(function(t) {
            return {
                x: t[0],
                y: t[1]
            };
        }), s = new pn({
            duration: n,
            points: o,
            sharpness: r
        }), a = function(t) {
            var e = s.pos(t);
            Math.floor(t / 100) % 2 == 0 && i.push([
                e.x,
                e.y
            ]);
        }, u = 0; u < s.duration; u += 10)a(u);
        return a(s.duration), h(i, e.properties);
    }
    function gn(t, e) {
        void 0 === e && (e = {});
        var n = Number(t[0]), r = Number(t[1]), i = Number(t[2]), o = Number(t[3]);
        if (6 === t.length) throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
        var s = [
            n,
            r
        ];
        return l([
            [
                s,
                [
                    i,
                    r
                ],
                [
                    i,
                    o
                ],
                [
                    n,
                    o
                ],
                s
            ]
        ], e.properties, {
            bbox: t,
            id: e.id
        });
    }
    function dn(t) {
        return gn(Z(t));
    }
    function yn(t) {
        var e = t[0], n = t[1], r = t[2], i = t[3];
        if (me(t.slice(0, 2), [
            r,
            n
        ]) >= me(t.slice(0, 2), [
            e,
            i
        ])) {
            var o = (n + i) / 2;
            return [
                e,
                o - (r - e) / 2,
                r,
                o + (r - e) / 2
            ];
        }
        var s = (e + r) / 2;
        return [
            s - (i - n) / 2,
            n,
            s + (i - n) / 2,
            i
        ];
    }
    function vn(t, e, n, r) {
        void 0 === r && (r = {});
        var i = K(t), o = I(i[0]), s = I(i[1]), u = I(n), l = x(e, r.units), c = Math.asin(Math.sin(s) * Math.cos(l) + Math.cos(s) * Math.sin(l) * Math.cos(u));
        return a([
            w(o + Math.atan2(Math.sin(u) * Math.sin(l) * Math.cos(s), Math.cos(l) - Math.sin(s) * Math.sin(c))),
            w(c)
        ], r.properties);
    }
    function _n(t, e, n) {
        void 0 === n && (n = {});
        for(var r = n.steps || 64, i = n.properties ? n.properties : !Array.isArray(t) && "Feature" === t.type && t.properties ? t.properties : {}, o = [], s = 0; s < r; s++)o.push(vn(t, e, -360 * s / r, n).geometry.coordinates);
        return o.push(o[0]), l([
            o
        ], i);
    }
    function mn(t, e, n) {
        if (void 0 === n && (n = {}), !0 === n.final) return function(t, e) {
            var n = mn(e, t);
            return n = (n + 180) % 360;
        }(t, e);
        var r = K(t), i = K(e), o = I(r[0]), s = I(i[0]), a = I(r[1]), u = I(i[1]), l = Math.sin(s - o) * Math.cos(u), c = Math.cos(a) * Math.sin(u) - Math.sin(a) * Math.cos(u) * Math.cos(s - o);
        return w(Math.atan2(l, c));
    }
    function xn(t, e) {
        void 0 === e && (e = {});
        var n = Z(t);
        return a([
            (n[0] + n[2]) / 2,
            (n[1] + n[3]) / 2
        ], e.properties, e);
    }
    function En(t, e) {
        void 0 === e && (e = {});
        var n = 0, r = 0, i = 0;
        return R(t, function(t) {
            n += t[0], r += t[1], i++;
        }, !0), a([
            n / i,
            r / i
        ], e.properties);
    }
    function bn(t) {
        var e = [];
        return "FeatureCollection" === t.type ? F(t, function(t) {
            R(t, function(n) {
                e.push(a(n, t.properties));
            });
        }) : R(t, function(n) {
            e.push(a(n, t.properties));
        }), f(e);
    }
    var wn = Nn, In = Nn;
    function Nn(t, e, n) {
        n = n || 2;
        var r, i, o, s, a, u, l, c = e && e.length, h = c ? e[0] * n : t.length, p = Sn(t, 0, h, n, !0), f = [];
        if (!p) return f;
        if (c && (p = function(t, e, n, r) {
            var i, o, s, a = [];
            for(i = 0, o = e.length; i < o; i++)(s = Sn(t, e[i] * r, i < o - 1 ? e[i + 1] * r : t.length, r, !1)) === s.next && (s.steiner = !0), a.push(Fn(s));
            for(a.sort(Tn), i = 0; i < a.length; i++)An(a[i], n), n = Cn(n, n.next);
            return n;
        }(t, e, p, n)), t.length > 80 * n) {
            r = o = t[0], i = s = t[1];
            for(var g = n; g < h; g += n)(a = t[g]) < r && (r = a), (u = t[g + 1]) < i && (i = u), a > o && (o = a), u > s && (s = u);
            l = 0 !== (l = Math.max(o - r, s - i)) ? 1 / l : 0;
        }
        return Pn(p, f, n, r, i, l), f;
    }
    function Sn(t, e, n, r, i) {
        var o, s;
        if (i === Hn(t, e, n, r) > 0) for(o = e; o < n; o += r)s = Vn(o, t[o], t[o + 1], s);
        else for(o = n - r; o >= e; o -= r)s = Vn(o, t[o], t[o + 1], s);
        return s && Bn(s, s.next) && (Xn(s), s = s.next), s;
    }
    function Cn(t, e) {
        if (!t) return t;
        e || (e = t);
        var n, r = t;
        do if (n = !1, r.steiner || !Bn(r, r.next) && 0 !== qn(r.prev, r, r.next)) r = r.next;
        else {
            if (Xn(r), (r = e = r.prev) === r.next) break;
            n = !0;
        }
        while (n || r !== e);
        return e;
    }
    function Pn(t, e, n, r, i, o, s) {
        if (t) {
            !s && o && function(t, e, n, r) {
                var i = t;
                do null === i.z && (i.z = Dn(i.x, i.y, e, n, r)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                while (i !== t);
                i.prevZ.nextZ = null, i.prevZ = null, function(t) {
                    var e, n, r, i, o, s, a, u, l = 1;
                    do {
                        for(n = t, t = null, o = null, s = 0; n;){
                            for(s++, r = n, a = 0, e = 0; e < l && (a++, r = r.nextZ); e++);
                            for(u = l; a > 0 || u > 0 && r;)0 !== a && (0 === u || !r || n.z <= r.z) ? (i = n, n = n.nextZ, a--) : (i = r, r = r.nextZ, u--), o ? o.nextZ = i : t = i, i.prevZ = o, o = i;
                            n = r;
                        }
                        o.nextZ = null, l *= 2;
                    }while (s > 1);
                }(i);
            }(t, r, i, o);
            for(var a, u, l = t; t.prev !== t.next;)if (a = t.prev, u = t.next, o ? Ln(t, r, i, o) : Mn(t)) e.push(a.i / n), e.push(t.i / n), e.push(u.i / n), Xn(t), t = u.next, l = u.next;
            else if ((t = u) === l) {
                s ? 1 === s ? Pn(t = On(t, e, n), e, n, r, i, o, 2) : 2 === s && Rn(t, e, n, r, i, o) : Pn(Cn(t), e, n, r, i, o, 1);
                break;
            }
        }
    }
    function Mn(t) {
        var e = t.prev, n = t, r = t.next;
        if (qn(e, n, r) >= 0) return !1;
        for(var i = t.next.next; i !== t.prev;){
            if (kn(e.x, e.y, n.x, n.y, r.x, r.y, i.x, i.y) && qn(i.prev, i, i.next) >= 0) return !1;
            i = i.next;
        }
        return !0;
    }
    function Ln(t, e, n, r) {
        var i = t.prev, o = t, s = t.next;
        if (qn(i, o, s) >= 0) return !1;
        for(var a = i.x < o.x ? i.x < s.x ? i.x : s.x : o.x < s.x ? o.x : s.x, u = i.y < o.y ? i.y < s.y ? i.y : s.y : o.y < s.y ? o.y : s.y, l = i.x > o.x ? i.x > s.x ? i.x : s.x : o.x > s.x ? o.x : s.x, c = i.y > o.y ? i.y > s.y ? i.y : s.y : o.y > s.y ? o.y : s.y, h = Dn(a, u, e, n, r), p = Dn(l, c, e, n, r), f = t.prevZ, g = t.nextZ; f && f.z >= h && g && g.z <= p;){
            if (f !== t.prev && f !== t.next && kn(i.x, i.y, o.x, o.y, s.x, s.y, f.x, f.y) && qn(f.prev, f, f.next) >= 0) return !1;
            if (f = f.prevZ, g !== t.prev && g !== t.next && kn(i.x, i.y, o.x, o.y, s.x, s.y, g.x, g.y) && qn(g.prev, g, g.next) >= 0) return !1;
            g = g.nextZ;
        }
        for(; f && f.z >= h;){
            if (f !== t.prev && f !== t.next && kn(i.x, i.y, o.x, o.y, s.x, s.y, f.x, f.y) && qn(f.prev, f, f.next) >= 0) return !1;
            f = f.prevZ;
        }
        for(; g && g.z <= p;){
            if (g !== t.prev && g !== t.next && kn(i.x, i.y, o.x, o.y, s.x, s.y, g.x, g.y) && qn(g.prev, g, g.next) >= 0) return !1;
            g = g.nextZ;
        }
        return !0;
    }
    function On(t, e, n) {
        var r = t;
        do {
            var i = r.prev, o = r.next.next;
            !Bn(i, o) && zn(i, r, r.next, o) && jn(i, o) && jn(o, i) && (e.push(i.i / n), e.push(r.i / n), e.push(o.i / n), Xn(r), Xn(r.next), r = t = o), r = r.next;
        }while (r !== t);
        return r;
    }
    function Rn(t, e, n, r, i, o) {
        var s = t;
        do {
            for(var a = s.next.next; a !== s.prev;){
                if (s.i !== a.i && Gn(s, a)) {
                    var u = Un(s, a);
                    return s = Cn(s, s.next), u = Cn(u, u.next), Pn(s, e, n, r, i, o), void Pn(u, e, n, r, i, o);
                }
                a = a.next;
            }
            s = s.next;
        }while (s !== t);
    }
    function Tn(t, e) {
        return t.x - e.x;
    }
    function An(t, e) {
        if (e = function(t, e) {
            var n, r = e, i = t.x, o = t.y, s = -1 / 0;
            do {
                if (o <= r.y && o >= r.next.y && r.next.y !== r.y) {
                    var a = r.x + (o - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                    if (a <= i && a > s) {
                        if (s = a, a === i) {
                            if (o === r.y) return r;
                            if (o === r.next.y) return r.next;
                        }
                        n = r.x < r.next.x ? r : r.next;
                    }
                }
                r = r.next;
            }while (r !== e);
            if (!n) return null;
            if (i === s) return n.prev;
            var u, l = n, c = n.x, h = n.y, p = 1 / 0;
            r = n.next;
            for(; r !== l;)i >= r.x && r.x >= c && i !== r.x && kn(o < h ? i : s, o, c, h, o < h ? s : i, o, r.x, r.y) && ((u = Math.abs(o - r.y) / (i - r.x)) < p || u === p && r.x > n.x) && jn(r, t) && (n = r, p = u), r = r.next;
            return n;
        }(t, e)) {
            var n = Un(e, t);
            Cn(n, n.next);
        }
    }
    function Dn(t, e, n, r, i) {
        return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = 32767 * (t - n) * i) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - r) * i) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
    }
    function Fn(t) {
        var e = t, n = t;
        do e.x < n.x && (n = e), e = e.next;
        while (e !== t);
        return n;
    }
    function kn(t, e, n, r, i, o, s, a) {
        return (i - s) * (e - a) - (t - s) * (o - a) >= 0 && (t - s) * (r - a) - (n - s) * (e - a) >= 0 && (n - s) * (o - a) - (i - s) * (r - a) >= 0;
    }
    function Gn(t, e) {
        return t.next.i !== e.i && t.prev.i !== e.i && !function(t, e) {
            var n = t;
            do {
                if (n.i !== t.i && n.next.i !== t.i && n.i !== e.i && n.next.i !== e.i && zn(n, n.next, t, e)) return !0;
                n = n.next;
            }while (n !== t);
            return !1;
        }(t, e) && jn(t, e) && jn(e, t) && function(t, e) {
            var n = t, r = !1, i = (t.x + e.x) / 2, o = (t.y + e.y) / 2;
            do n.y > o != n.next.y > o && n.next.y !== n.y && i < (n.next.x - n.x) * (o - n.y) / (n.next.y - n.y) + n.x && (r = !r), n = n.next;
            while (n !== t);
            return r;
        }(t, e);
    }
    function qn(t, e, n) {
        return (e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y);
    }
    function Bn(t, e) {
        return t.x === e.x && t.y === e.y;
    }
    function zn(t, e, n, r) {
        return !!(Bn(t, e) && Bn(n, r) || Bn(t, r) && Bn(n, e)) || qn(t, e, n) > 0 != qn(t, e, r) > 0 && qn(n, r, t) > 0 != qn(n, r, e) > 0;
    }
    function jn(t, e) {
        return qn(t.prev, t, t.next) < 0 ? qn(t, e, t.next) >= 0 && qn(t, t.prev, e) >= 0 : qn(t, e, t.prev) < 0 || qn(t, t.next, e) < 0;
    }
    function Un(t, e) {
        var n = new Yn(t.i, t.x, t.y), r = new Yn(e.i, e.x, e.y), i = t.next, o = e.prev;
        return t.next = e, e.prev = t, n.next = i, i.prev = n, r.next = n, n.prev = r, o.next = r, r.prev = o, r;
    }
    function Vn(t, e, n, r) {
        var i = new Yn(t, e, n);
        return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
    }
    function Xn(t) {
        t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
    }
    function Yn(t, e, n) {
        this.i = t, this.x = e, this.y = n, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
    }
    function Hn(t, e, n, r) {
        for(var i = 0, o = e, s = n - r; o < n; o += r)i += (t[s] - t[o]) * (t[o + 1] + t[s + 1]), s = o;
        return i;
    }
    function Wn(t) {
        var e = function(t) {
            for(var e = t[0][0].length, n = {
                vertices: [],
                holes: [],
                dimensions: e
            }, r = 0, i = 0; i < t.length; i++){
                for(var o = 0; o < t[i].length; o++)for(var s = 0; s < e; s++)n.vertices.push(t[i][o][s]);
                i > 0 && (r += t[i - 1].length, n.holes.push(r));
            }
            return n;
        }(t), n = wn(e.vertices, e.holes, 2), r = [], i = [];
        n.forEach(function(t, r) {
            var o = n[r];
            i.push([
                e.vertices[2 * o],
                e.vertices[2 * o + 1]
            ]);
        });
        for(var o = 0; o < i.length; o += 3){
            var s = i.slice(o, o + 3);
            s.push(i[o]), r.push(l([
                s
            ]));
        }
        return r;
    }
    function Jn(t, e) {
        if (!t) throw new Error("targetPoint is required");
        if (!e) throw new Error("points is required");
        var n, r = 1 / 0, i = 0;
        return F(e, function(e, n) {
            var o = me(t, e);
            o < r && (i = n, r = o);
        }), (n = Ie(e.features[i])).properties.featureIndex = i, n.properties.distanceToPoint = r, n;
    }
    function Zn(t) {
        if (!t) throw new Error("geojson is required");
        var e = [];
        return z(t, function(t) {
            !function(t, e) {
                var n = [], r = t.geometry;
                if (null !== r) {
                    switch(r.type){
                        case "Polygon":
                            n = Q(r);
                            break;
                        case "LineString":
                            n = [
                                Q(r)
                            ];
                    }
                    n.forEach(function(n) {
                        (function(t, e) {
                            var n = [];
                            return t.reduce(function(t, r) {
                                var i = h([
                                    t,
                                    r
                                ], e);
                                return i.bbox = function(t, e) {
                                    var n = t[0], r = t[1], i = e[0], o = e[1];
                                    return [
                                        n < i ? n : i,
                                        r < o ? r : o,
                                        n > i ? n : i,
                                        r > o ? r : o
                                    ];
                                }(t, r), n.push(i), r;
                            }), n;
                        })(n, t.properties).forEach(function(t) {
                            t.id = e.length, e.push(t);
                        });
                    });
                }
            }(t, e);
        }), f(e);
    }
    Nn.deviation = function(t, e, n, r) {
        var i = e && e.length, o = i ? e[0] * n : t.length, s = Math.abs(Hn(t, 0, o, n));
        if (i) for(var a = 0, u = e.length; a < u; a++){
            var l = e[a] * n, c = a < u - 1 ? e[a + 1] * n : t.length;
            s -= Math.abs(Hn(t, l, c, n));
        }
        var h = 0;
        for(a = 0; a < r.length; a += 3){
            var p = r[a] * n, f = r[a + 1] * n, g = r[a + 2] * n;
            h += Math.abs((t[p] - t[g]) * (t[f + 1] - t[p + 1]) - (t[p] - t[f]) * (t[g + 1] - t[p + 1]));
        }
        return 0 === s && 0 === h ? 0 : Math.abs((h - s) / s);
    }, Nn.flatten = function(t) {
        for(var e = t[0][0].length, n = {
            vertices: [],
            holes: [],
            dimensions: e
        }, r = 0, i = 0; i < t.length; i++){
            for(var o = 0; o < t[i].length; o++)for(var s = 0; s < e; s++)n.vertices.push(t[i][o][s]);
            i > 0 && (r += t[i - 1].length, n.holes.push(r));
        }
        return n;
    }, wn.default = In;
    var Kn = Bt(function(t, e) {
        function n(t, e, n) {
            void 0 === n && (n = {});
            var r = {
                type: "Feature"
            };
            return (0 === n.id || n.id) && (r.id = n.id), n.bbox && (r.bbox = n.bbox), r.properties = e || {}, r.geometry = t, r;
        }
        function r(t, e, r) {
            if (void 0 === r && (r = {}), !t) throw new Error("coordinates is required");
            if (!Array.isArray(t)) throw new Error("coordinates must be an Array");
            if (t.length < 2) throw new Error("coordinates must be at least 2 numbers long");
            if (!f(t[0]) || !f(t[1])) throw new Error("coordinates must contain numbers");
            return n({
                type: "Point",
                coordinates: t
            }, e, r);
        }
        function i(t, e, r) {
            void 0 === r && (r = {});
            for(var i = 0, o = t; i < o.length; i++){
                var s = o[i];
                if (s.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
                for(var a = 0; a < s[s.length - 1].length; a++)if (s[s.length - 1][a] !== s[0][a]) throw new Error("First and last Position are not equivalent.");
            }
            return n({
                type: "Polygon",
                coordinates: t
            }, e, r);
        }
        function o(t, e, r) {
            if (void 0 === r && (r = {}), t.length < 2) throw new Error("coordinates must be an array of two or more positions");
            return n({
                type: "LineString",
                coordinates: t
            }, e, r);
        }
        function s(t, e) {
            void 0 === e && (e = {});
            var n = {
                type: "FeatureCollection"
            };
            return e.id && (n.id = e.id), e.bbox && (n.bbox = e.bbox), n.features = t, n;
        }
        function a(t, e, r) {
            return void 0 === r && (r = {}), n({
                type: "MultiLineString",
                coordinates: t
            }, e, r);
        }
        function u(t, e, r) {
            return void 0 === r && (r = {}), n({
                type: "MultiPoint",
                coordinates: t
            }, e, r);
        }
        function l(t, e, r) {
            return void 0 === r && (r = {}), n({
                type: "MultiPolygon",
                coordinates: t
            }, e, r);
        }
        function c(t, n) {
            void 0 === n && (n = "kilometers");
            var r = e.factors[n];
            if (!r) throw new Error(n + " units is invalid");
            return t * r;
        }
        function h(t, n) {
            void 0 === n && (n = "kilometers");
            var r = e.factors[n];
            if (!r) throw new Error(n + " units is invalid");
            return t / r;
        }
        function p(t) {
            return 180 * (t % (2 * Math.PI)) / Math.PI;
        }
        function f(t) {
            return !isNaN(t) && null !== t && !Array.isArray(t);
        }
        Object.defineProperty(e, "__esModule", {
            value: !0
        }), e.earthRadius = 6371008.8, e.factors = {
            centimeters: 100 * e.earthRadius,
            centimetres: 100 * e.earthRadius,
            degrees: e.earthRadius / 111325,
            feet: 3.28084 * e.earthRadius,
            inches: 39.37 * e.earthRadius,
            kilometers: e.earthRadius / 1e3,
            kilometres: e.earthRadius / 1e3,
            meters: e.earthRadius,
            metres: e.earthRadius,
            miles: e.earthRadius / 1609.344,
            millimeters: 1e3 * e.earthRadius,
            millimetres: 1e3 * e.earthRadius,
            nauticalmiles: e.earthRadius / 1852,
            radians: 1,
            yards: 1.0936 * e.earthRadius
        }, e.unitsFactors = {
            centimeters: 100,
            centimetres: 100,
            degrees: 1 / 111325,
            feet: 3.28084,
            inches: 39.37,
            kilometers: .001,
            kilometres: .001,
            meters: 1,
            metres: 1,
            miles: 1 / 1609.344,
            millimeters: 1e3,
            millimetres: 1e3,
            nauticalmiles: 1 / 1852,
            radians: 1 / e.earthRadius,
            yards: 1.0936133
        }, e.areaFactors = {
            acres: 247105e-9,
            centimeters: 1e4,
            centimetres: 1e4,
            feet: 10.763910417,
            hectares: 1e-4,
            inches: 1550.003100006,
            kilometers: 1e-6,
            kilometres: 1e-6,
            meters: 1,
            metres: 1,
            miles: 386e-9,
            millimeters: 1e6,
            millimetres: 1e6,
            yards: 1.195990046
        }, e.feature = n, e.geometry = function(t, e, n) {
            switch(t){
                case "Point":
                    return r(e).geometry;
                case "LineString":
                    return o(e).geometry;
                case "Polygon":
                    return i(e).geometry;
                case "MultiPoint":
                    return u(e).geometry;
                case "MultiLineString":
                    return a(e).geometry;
                case "MultiPolygon":
                    return l(e).geometry;
                default:
                    throw new Error(t + " is invalid");
            }
        }, e.point = r, e.points = function(t, e, n) {
            return void 0 === n && (n = {}), s(t.map(function(t) {
                return r(t, e);
            }), n);
        }, e.polygon = i, e.polygons = function(t, e, n) {
            return void 0 === n && (n = {}), s(t.map(function(t) {
                return i(t, e);
            }), n);
        }, e.lineString = o, e.lineStrings = function(t, e, n) {
            return void 0 === n && (n = {}), s(t.map(function(t) {
                return o(t, e);
            }), n);
        }, e.featureCollection = s, e.multiLineString = a, e.multiPoint = u, e.multiPolygon = l, e.geometryCollection = function(t, e, r) {
            return void 0 === r && (r = {}), n({
                type: "GeometryCollection",
                geometries: t
            }, e, r);
        }, e.round = function(t, e) {
            if (void 0 === e && (e = 0), e && !(e >= 0)) throw new Error("precision must be a positive number");
            var n = Math.pow(10, e || 0);
            return Math.round(t * n) / n;
        }, e.radiansToLength = c, e.lengthToRadians = h, e.lengthToDegrees = function(t, e) {
            return p(h(t, e));
        }, e.bearingToAzimuth = function(t) {
            var e = t % 360;
            return e < 0 && (e += 360), e;
        }, e.radiansToDegrees = p, e.degreesToRadians = function(t) {
            return t % 360 * Math.PI / 180;
        }, e.convertLength = function(t, e, n) {
            if (void 0 === e && (e = "kilometers"), void 0 === n && (n = "kilometers"), !(t >= 0)) throw new Error("length must be a positive number");
            return c(h(t, e), n);
        }, e.convertArea = function(t, n, r) {
            if (void 0 === n && (n = "meters"), void 0 === r && (r = "kilometers"), !(t >= 0)) throw new Error("area must be a positive number");
            var i = e.areaFactors[n];
            if (!i) throw new Error("invalid original units");
            var o = e.areaFactors[r];
            if (!o) throw new Error("invalid final units");
            return t / i * o;
        }, e.isNumber = f, e.isObject = function(t) {
            return !!t && t.constructor === Object;
        }, e.validateBBox = function(t) {
            if (!t) throw new Error("bbox is required");
            if (!Array.isArray(t)) throw new Error("bbox must be an Array");
            if (4 !== t.length && 6 !== t.length) throw new Error("bbox must be an Array of 4 or 6 numbers");
            t.forEach(function(t) {
                if (!f(t)) throw new Error("bbox must only contain numbers");
            });
        }, e.validateId = function(t) {
            if (!t) throw new Error("id is required");
            if (-1 === [
                "string",
                "number"
            ].indexOf(typeof t)) throw new Error("id must be a number or a string");
        };
    });
    function Qn(t, e, n) {
        if (null !== t) for(var r, i, o, s, a, u, l, c, h = 0, p = 0, f = t.type, g = "FeatureCollection" === f, d = "Feature" === f, y = g ? t.features.length : 1, v = 0; v < y; v++){
            a = (c = !!(l = g ? t.features[v].geometry : d ? t.geometry : t) && "GeometryCollection" === l.type) ? l.geometries.length : 1;
            for(var _ = 0; _ < a; _++){
                var m = 0, x = 0;
                if (null !== (s = c ? l.geometries[_] : l)) {
                    u = s.coordinates;
                    var E = s.type;
                    switch(h = !n || "Polygon" !== E && "MultiPolygon" !== E ? 0 : 1, E){
                        case null:
                            break;
                        case "Point":
                            if (!1 === e(u, p, v, m, x)) return !1;
                            p++, m++;
                            break;
                        case "LineString":
                        case "MultiPoint":
                            for(r = 0; r < u.length; r++){
                                if (!1 === e(u[r], p, v, m, x)) return !1;
                                p++, "MultiPoint" === E && m++;
                            }
                            "LineString" === E && m++;
                            break;
                        case "Polygon":
                        case "MultiLineString":
                            for(r = 0; r < u.length; r++){
                                for(i = 0; i < u[r].length - h; i++){
                                    if (!1 === e(u[r][i], p, v, m, x)) return !1;
                                    p++;
                                }
                                "MultiLineString" === E && m++, "Polygon" === E && x++;
                            }
                            "Polygon" === E && m++;
                            break;
                        case "MultiPolygon":
                            for(r = 0; r < u.length; r++){
                                for(x = 0, i = 0; i < u[r].length; i++){
                                    for(o = 0; o < u[r][i].length - h; o++){
                                        if (!1 === e(u[r][i][o], p, v, m, x)) return !1;
                                        p++;
                                    }
                                    x++;
                                }
                                m++;
                            }
                            break;
                        case "GeometryCollection":
                            for(r = 0; r < s.geometries.length; r++)if (!1 === Qn(s.geometries[r], e, n)) return !1;
                            break;
                        default:
                            throw new Error("Unknown Geometry Type");
                    }
                }
            }
        }
    }
    function $n(t, e) {
        var n;
        switch(t.type){
            case "FeatureCollection":
                for(n = 0; n < t.features.length && !1 !== e(t.features[n].properties, n); n++);
                break;
            case "Feature":
                e(t.properties, 0);
        }
    }
    function tr(t, e) {
        if ("Feature" === t.type) e(t, 0);
        else if ("FeatureCollection" === t.type) for(var n = 0; n < t.features.length && !1 !== e(t.features[n], n); n++);
    }
    function er(t, e) {
        var n, r, i, o, s, a, u, l, c, h, p = 0, f = "FeatureCollection" === t.type, g = "Feature" === t.type, d = f ? t.features.length : 1;
        for(n = 0; n < d; n++){
            for(a = f ? t.features[n].geometry : g ? t.geometry : t, l = f ? t.features[n].properties : g ? t.properties : {}, c = f ? t.features[n].bbox : g ? t.bbox : void 0, h = f ? t.features[n].id : g ? t.id : void 0, s = (u = !!a && "GeometryCollection" === a.type) ? a.geometries.length : 1, i = 0; i < s; i++)if (null !== (o = u ? a.geometries[i] : a)) switch(o.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (!1 === e(o, p, l, c, h)) return !1;
                    break;
                case "GeometryCollection":
                    for(r = 0; r < o.geometries.length; r++)if (!1 === e(o.geometries[r], p, l, c, h)) return !1;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
            else if (!1 === e(null, p, l, c, h)) return !1;
            p++;
        }
    }
    function nr(t, e) {
        er(t, function(t, n, r, i, o) {
            var s, a = null === t ? null : t.type;
            switch(a){
                case null:
                case "Point":
                case "LineString":
                case "Polygon":
                    return !1 !== e(Kn.feature(t, r, {
                        bbox: i,
                        id: o
                    }), n, 0) && void 0;
            }
            switch(a){
                case "MultiPoint":
                    s = "Point";
                    break;
                case "MultiLineString":
                    s = "LineString";
                    break;
                case "MultiPolygon":
                    s = "Polygon";
            }
            for(var u = 0; u < t.coordinates.length; u++){
                var l = {
                    type: s,
                    coordinates: t.coordinates[u]
                };
                if (!1 === e(Kn.feature(l, r), n, u)) return !1;
            }
        });
    }
    function rr(t, e) {
        nr(t, function(t, n, r) {
            var i = 0;
            if (t.geometry) {
                var o = t.geometry.type;
                if ("Point" !== o && "MultiPoint" !== o) {
                    var s, a = 0, u = 0, l = 0;
                    return !1 !== Qn(t, function(o, c, h, p, f) {
                        if (void 0 === s || n > a || p > u || f > l) return s = o, a = n, u = p, l = f, void (i = 0);
                        var g = Kn.lineString([
                            s,
                            o
                        ], t.properties);
                        if (!1 === e(g, n, r, f, i)) return !1;
                        i++, s = o;
                    }) && void 0;
                }
            }
        });
    }
    function ir(t, e) {
        if (!t) throw new Error("geojson is required");
        nr(t, function(t, n, r) {
            if (null !== t.geometry) {
                var i = t.geometry.type, o = t.geometry.coordinates;
                switch(i){
                    case "LineString":
                        if (!1 === e(t, n, r, 0, 0)) return !1;
                        break;
                    case "Polygon":
                        for(var s = 0; s < o.length; s++)if (!1 === e(Kn.lineString(o[s], t.properties), n, r, s)) return !1;
                }
            }
        });
    }
    var or = function(t) {
        var e = [];
        return Qn(t, function(t) {
            e.push(t);
        }), e;
    }, sr = Qn, ar = function(t, e, n, r) {
        var i = n;
        return Qn(t, function(t, r, o, s, a) {
            i = 0 === r && void 0 === n ? t : e(i, t, r, o, s, a);
        }, r), i;
    }, ur = tr, lr = function(t, e, n) {
        var r = n;
        return tr(t, function(t, i) {
            r = 0 === i && void 0 === n ? t : e(r, t, i);
        }), r;
    }, cr = function(t, e) {
        if (e = e || {}, !Kn.isObject(e)) throw new Error("options is invalid");
        var n, r = e.featureIndex || 0, i = e.multiFeatureIndex || 0, o = e.geometryIndex || 0, s = e.coordIndex || 0, a = e.properties;
        switch(t.type){
            case "FeatureCollection":
                r < 0 && (r = t.features.length + r), a = a || t.features[r].properties, n = t.features[r].geometry;
                break;
            case "Feature":
                a = a || t.properties, n = t.geometry;
                break;
            case "Point":
            case "MultiPoint":
                return null;
            case "LineString":
            case "Polygon":
            case "MultiLineString":
            case "MultiPolygon":
                n = t;
                break;
            default:
                throw new Error("geojson is invalid");
        }
        if (null === n) return null;
        var u = n.coordinates;
        switch(n.type){
            case "Point":
                return Kn.point(u, a, e);
            case "MultiPoint":
                return i < 0 && (i = u.length + i), Kn.point(u[i], a, e);
            case "LineString":
                return s < 0 && (s = u.length + s), Kn.point(u[s], a, e);
            case "Polygon":
                return o < 0 && (o = u.length + o), s < 0 && (s = u[o].length + s), Kn.point(u[o][s], a, e);
            case "MultiLineString":
                return i < 0 && (i = u.length + i), s < 0 && (s = u[i].length + s), Kn.point(u[i][s], a, e);
            case "MultiPolygon":
                return i < 0 && (i = u.length + i), o < 0 && (o = u[i].length + o), s < 0 && (s = u[i][o].length - s), Kn.point(u[i][o][s], a, e);
        }
        throw new Error("geojson is invalid");
    }, hr = function(t, e) {
        if (e = e || {}, !Kn.isObject(e)) throw new Error("options is invalid");
        var n, r = e.featureIndex || 0, i = e.multiFeatureIndex || 0, o = e.geometryIndex || 0, s = e.segmentIndex || 0, a = e.properties;
        switch(t.type){
            case "FeatureCollection":
                r < 0 && (r = t.features.length + r), a = a || t.features[r].properties, n = t.features[r].geometry;
                break;
            case "Feature":
                a = a || t.properties, n = t.geometry;
                break;
            case "Point":
            case "MultiPoint":
                return null;
            case "LineString":
            case "Polygon":
            case "MultiLineString":
            case "MultiPolygon":
                n = t;
                break;
            default:
                throw new Error("geojson is invalid");
        }
        if (null === n) return null;
        var u = n.coordinates;
        switch(n.type){
            case "Point":
            case "MultiPoint":
                return null;
            case "LineString":
                return s < 0 && (s = u.length + s - 1), Kn.lineString([
                    u[s],
                    u[s + 1]
                ], a, e);
            case "Polygon":
                return o < 0 && (o = u.length + o), s < 0 && (s = u[o].length + s - 1), Kn.lineString([
                    u[o][s],
                    u[o][s + 1]
                ], a, e);
            case "MultiLineString":
                return i < 0 && (i = u.length + i), s < 0 && (s = u[i].length + s - 1), Kn.lineString([
                    u[i][s],
                    u[i][s + 1]
                ], a, e);
            case "MultiPolygon":
                return i < 0 && (i = u.length + i), o < 0 && (o = u[i].length + o), s < 0 && (s = u[i][o].length - s - 1), Kn.lineString([
                    u[i][o][s],
                    u[i][o][s + 1]
                ], a, e);
        }
        throw new Error("geojson is invalid");
    }, pr = nr, fr = function(t, e, n) {
        var r = n;
        return nr(t, function(t, i, o) {
            r = 0 === i && 0 === o && void 0 === n ? t : e(r, t, i, o);
        }), r;
    }, gr = er, dr = function(t, e, n) {
        var r = n;
        return er(t, function(t, i, o, s, a) {
            r = 0 === i && void 0 === n ? t : e(r, t, i, o, s, a);
        }), r;
    }, yr = ir, vr = function(t, e, n) {
        var r = n;
        return ir(t, function(t, i, o, s) {
            r = 0 === i && void 0 === n ? t : e(r, t, i, o, s);
        }), r;
    }, _r = $n, mr = function(t, e, n) {
        var r = n;
        return $n(t, function(t, i) {
            r = 0 === i && void 0 === n ? t : e(r, t, i);
        }), r;
    }, xr = rr, Er = function(t, e, n) {
        var r = n, i = !1;
        return rr(t, function(t, o, s, a, u) {
            r = !1 === i && void 0 === n ? t : e(r, t, o, s, a, u), i = !0;
        }), r;
    }, br = Object.defineProperty({
        coordAll: or,
        coordEach: sr,
        coordReduce: ar,
        featureEach: ur,
        featureReduce: lr,
        findPoint: cr,
        findSegment: hr,
        flattenEach: pr,
        flattenReduce: fr,
        geomEach: gr,
        geomReduce: dr,
        lineEach: yr,
        lineReduce: vr,
        propEach: _r,
        propReduce: mr,
        segmentEach: xr,
        segmentReduce: Er
    }, "__esModule", {
        value: !0
    });
    function wr(t) {
        var e = [
            1 / 0,
            1 / 0,
            -1 / 0,
            -1 / 0
        ];
        return br.coordEach(t, function(t) {
            e[0] > t[0] && (e[0] = t[0]), e[1] > t[1] && (e[1] = t[1]), e[2] < t[0] && (e[2] = t[0]), e[3] < t[1] && (e[3] = t[1]);
        }), e;
    }
    wr.default = wr;
    var Ir = wr, Nr = Object.defineProperty({
        default: Ir
    }, "__esModule", {
        value: !0
    }).default, Sr = br.featureEach, Cr = (br.coordEach, Kn.polygon, Kn.featureCollection);
    function Pr(t) {
        var e = Nt(t);
        return e.insert = function(t) {
            if ("Feature" !== t.type) throw new Error("invalid feature");
            return t.bbox = t.bbox ? t.bbox : Nr(t), Nt.prototype.insert.call(this, t);
        }, e.load = function(t) {
            var e = [];
            return Array.isArray(t) ? t.forEach(function(t) {
                if ("Feature" !== t.type) throw new Error("invalid features");
                t.bbox = t.bbox ? t.bbox : Nr(t), e.push(t);
            }) : Sr(t, function(t) {
                if ("Feature" !== t.type) throw new Error("invalid features");
                t.bbox = t.bbox ? t.bbox : Nr(t), e.push(t);
            }), Nt.prototype.load.call(this, e);
        }, e.remove = function(t, e) {
            if ("Feature" !== t.type) throw new Error("invalid feature");
            return t.bbox = t.bbox ? t.bbox : Nr(t), Nt.prototype.remove.call(this, t, e);
        }, e.clear = function() {
            return Nt.prototype.clear.call(this);
        }, e.search = function(t) {
            var e = Nt.prototype.search.call(this, this.toBBox(t));
            return Cr(e);
        }, e.collides = function(t) {
            return Nt.prototype.collides.call(this, this.toBBox(t));
        }, e.all = function() {
            var t = Nt.prototype.all.call(this);
            return Cr(t);
        }, e.toJSON = function() {
            return Nt.prototype.toJSON.call(this);
        }, e.fromJSON = function(t) {
            return Nt.prototype.fromJSON.call(this, t);
        }, e.toBBox = function(t) {
            var e;
            if (t.bbox) e = t.bbox;
            else if (Array.isArray(t) && 4 === t.length) e = t;
            else if (Array.isArray(t) && 6 === t.length) e = [
                t[0],
                t[1],
                t[3],
                t[4]
            ];
            else if ("Feature" === t.type) e = Nr(t);
            else {
                if ("FeatureCollection" !== t.type) throw new Error("invalid geojson");
                e = Nr(t);
            }
            return {
                minX: e[0],
                minY: e[1],
                maxX: e[2],
                maxY: e[3]
            };
        }, e;
    }
    var Mr = Pr, Lr = Pr;
    function Or(t, e) {
        var n = {}, r = [];
        if ("LineString" === t.type && (t = o(t)), "LineString" === e.type && (e = o(e)), "Feature" === t.type && "Feature" === e.type && null !== t.geometry && null !== e.geometry && "LineString" === t.geometry.type && "LineString" === e.geometry.type && 2 === t.geometry.coordinates.length && 2 === e.geometry.coordinates.length) {
            var i = Rr(t, e);
            return i && r.push(i), f(r);
        }
        var s = Mr();
        return s.load(Zn(e)), F(Zn(t), function(t) {
            F(s.search(t), function(e) {
                var i = Rr(t, e);
                if (i) {
                    var o = Q(i).join(",");
                    n[o] || (n[o] = !0, r.push(i));
                }
            });
        }), f(r);
    }
    function Rr(t, e) {
        var n = Q(t), r = Q(e);
        if (2 !== n.length) throw new Error("<intersects> line1 must only contain 2 coordinates");
        if (2 !== r.length) throw new Error("<intersects> line2 must only contain 2 coordinates");
        var i = n[0][0], o = n[0][1], s = n[1][0], u = n[1][1], l = r[0][0], c = r[0][1], h = r[1][0], p = r[1][1], f = (p - c) * (s - i) - (h - l) * (u - o), g = (h - l) * (o - c) - (p - c) * (i - l), d = (s - i) * (o - c) - (u - o) * (i - l);
        if (0 === f) return null;
        var y = g / f, v = d / f;
        return y >= 0 && y <= 1 && v >= 0 && v <= 1 ? a([
            i + y * (s - i),
            o + y * (u - o)
        ]) : null;
    }
    function Tr(t, e, n) {
        void 0 === n && (n = {});
        var r = a([
            1 / 0,
            1 / 0
        ], {
            dist: 1 / 0
        }), i = 0;
        return z(t, function(t) {
            for(var o = Q(t), s = 0; s < o.length - 1; s++){
                var u = a(o[s]);
                u.properties.dist = me(e, u, n);
                var l = a(o[s + 1]);
                l.properties.dist = me(e, l, n);
                var c = me(u, l, n), p = Math.max(u.properties.dist, l.properties.dist), f = mn(u, l), g = vn(e, p, f + 90, n), d = vn(e, p, f - 90, n), y = Or(h([
                    g.geometry.coordinates,
                    d.geometry.coordinates
                ]), h([
                    u.geometry.coordinates,
                    l.geometry.coordinates
                ])), v = null;
                y.features.length > 0 && ((v = y.features[0]).properties.dist = me(e, v, n), v.properties.location = i + me(u, v, n)), u.properties.dist < r.properties.dist && ((r = u).properties.index = s, r.properties.location = i), l.properties.dist < r.properties.dist && ((r = l).properties.index = s + 1, r.properties.location = i + c), v && v.properties.dist < r.properties.dist && ((r = v).properties.index = s), i += c;
            }
        }), r;
    }
    function Ar(t, n, r) {
        void 0 === r && (r = {});
        var i = K(t), o = K(n);
        return o[0] += o[0] - i[0] > 180 ? -360 : i[0] - o[0] > 180 ? 360 : 0, N(function(t, n, r) {
            var i = r = void 0 === r ? e : Number(r), o = t[1] * Math.PI / 180, s = n[1] * Math.PI / 180, a = s - o, u = Math.abs(n[0] - t[0]) * Math.PI / 180;
            u > Math.PI && (u -= 2 * Math.PI);
            var l = Math.log(Math.tan(s / 2 + Math.PI / 4) / Math.tan(o / 2 + Math.PI / 4)), c = Math.abs(l) > 1e-11 ? a / l : Math.cos(o);
            return Math.sqrt(a * a + c * c * u * u) * i;
        }(i, o), "meters", r.units);
    }
    function Dr(t, e, n) {
        if (void 0 === n && (n = {}), n.method || (n.method = "geodesic"), n.units || (n.units = "kilometers"), !t) throw new Error("pt is required");
        if (Array.isArray(t) ? t = a(t) : "Point" === t.type ? t = o(t) : et(t, "Point", "point"), !e) throw new Error("line is required");
        Array.isArray(e) ? e = h(e) : "LineString" === e.type ? e = o(e) : et(e, "LineString", "line");
        var r = 1 / 0, i = t.geometry.coordinates;
        return U(e, function(t) {
            var e = t.geometry.coordinates[0], o = t.geometry.coordinates[1], s = function(t, e, n, r) {
                var i = [
                    n[0] - e[0],
                    n[1] - e[1]
                ], o = Fr([
                    t[0] - e[0],
                    t[1] - e[1]
                ], i);
                if (o <= 0) return kr(t, e, {
                    method: r.method,
                    units: "degrees"
                });
                var s = Fr(i, i);
                if (s <= o) return kr(t, n, {
                    method: r.method,
                    units: "degrees"
                });
                var a = o / s, u = [
                    e[0] + a * i[0],
                    e[1] + a * i[1]
                ];
                return kr(t, u, {
                    method: r.method,
                    units: "degrees"
                });
            }(i, e, o, n);
            s < r && (r = s);
        }), N(r, "degrees", n.units);
    }
    function Fr(t, e) {
        return t[0] * e[0] + t[1] * e[1];
    }
    function kr(t, e, n) {
        return "planar" === n.method ? Ar(t, e, n) : me(t, e, n);
    }
    function Gr(t, e, n, r, i, o, s, a) {
        var u, l, c, h, p = {
            x: null,
            y: null,
            onLine1: !1,
            onLine2: !1
        };
        return 0 === (u = (a - o) * (n - t) - (s - i) * (r - e)) ? null !== p.x && null !== p.y && p : (h = (n - t) * (l = e - o) - (r - e) * (c = t - i), l = ((s - i) * l - (a - o) * c) / u, c = h / u, p.x = t + l * (n - t), p.y = e + l * (r - e), l >= 0 && l <= 1 && (p.onLine1 = !0), c >= 0 && c <= 1 && (p.onLine2 = !0), !(!p.onLine1 || !p.onLine2) && [
            p.x,
            p.y
        ]);
    }
    function qr(t) {
        for(var e = function(t) {
            if ("FeatureCollection" !== t.type) return "Feature" !== t.type ? f([
                o(t)
            ]) : f([
                t
            ]);
            return t;
        }(t), n = xn(e), r = !1, i = 0; !r && i < e.features.length;){
            var s, u = e.features[i].geometry, l = !1;
            if ("Point" === u.type) n.geometry.coordinates[0] === u.coordinates[0] && n.geometry.coordinates[1] === u.coordinates[1] && (r = !0);
            else if ("MultiPoint" === u.type) {
                var c = !1;
                for(s = 0; !c && s < u.coordinates.length;)n.geometry.coordinates[0] === u.coordinates[s][0] && n.geometry.coordinates[1] === u.coordinates[s][1] && (r = !0, c = !0), s++;
            } else if ("LineString" === u.type) for(s = 0; !l && s < u.coordinates.length - 1;)Br(n.geometry.coordinates[0], n.geometry.coordinates[1], u.coordinates[s][0], u.coordinates[s][1], u.coordinates[s + 1][0], u.coordinates[s + 1][1]) && (l = !0, r = !0), s++;
            else if ("MultiLineString" === u.type) for(var h = 0; h < u.coordinates.length;){
                l = !1, s = 0;
                for(var p = u.coordinates[h]; !l && s < p.length - 1;)Br(n.geometry.coordinates[0], n.geometry.coordinates[1], p[s][0], p[s][1], p[s + 1][0], p[s + 1][1]) && (l = !0, r = !0), s++;
                h++;
            }
            else "Polygon" !== u.type && "MultiPolygon" !== u.type || ye(n, u) && (r = !0);
            i++;
        }
        if (r) return n;
        var g = f([]);
        for(i = 0; i < e.features.length; i++)g.features = g.features.concat(bn(e.features[i]).features);
        return a(Jn(n, g).geometry.coordinates);
    }
    function Br(t, e, n, r, i, o) {
        return Math.sqrt((i - n) * (i - n) + (o - r) * (o - r)) === Math.sqrt((t - n) * (t - n) + (e - r) * (e - r)) + Math.sqrt((i - t) * (i - t) + (o - e) * (o - e));
    }
    Mr.default = Lr;
    var zr = 6378137;
    function jr(t) {
        return B(t, function(t, e) {
            return t + function(t) {
                var e, n = 0;
                switch(t.type){
                    case "Polygon":
                        return Ur(t.coordinates);
                    case "MultiPolygon":
                        for(e = 0; e < t.coordinates.length; e++)n += Ur(t.coordinates[e]);
                        return n;
                    case "Point":
                    case "MultiPoint":
                    case "LineString":
                    case "MultiLineString":
                        return 0;
                }
                return 0;
            }(e);
        }, 0);
    }
    function Ur(t) {
        var e = 0;
        if (t && t.length > 0) {
            e += Math.abs(Vr(t[0]));
            for(var n = 1; n < t.length; n++)e -= Math.abs(Vr(t[n]));
        }
        return e;
    }
    function Vr(t) {
        var e, n, r, i, o, s, a = 0, u = t.length;
        if (u > 2) {
            for(s = 0; s < u; s++)s === u - 2 ? (r = u - 2, i = u - 1, o = 0) : s === u - 1 ? (r = u - 1, i = 0, o = 1) : (r = s, i = s + 1, o = s + 2), e = t[r], n = t[i], a += (Xr(t[o][0]) - Xr(e[0])) * Math.sin(Xr(n[1]));
            a = a * zr * zr / 2;
        }
        return a;
    }
    function Xr(t) {
        return t * Math.PI / 180;
    }
    function Yr(t, e) {
        return void 0 === e && (e = {}), V(t, function(t, n) {
            var r = n.geometry.coordinates;
            return t + me(r[0], r[1], e);
        }, 0);
    }
    function Hr(t, e, n, r) {
        if (!P(r = r || {})) throw new Error("options is invalid");
        var i, o = [];
        if ("Feature" === t.type) i = t.geometry.coordinates;
        else {
            if ("LineString" !== t.type) throw new Error("input must be a LineString Feature or Geometry");
            i = t.coordinates;
        }
        for(var s, a, u, l = i.length, c = 0, p = 0; p < i.length && !(e >= c && p === i.length - 1); p++){
            if (c > e && 0 === o.length) {
                if (!(s = e - c)) return o.push(i[p]), h(o);
                a = mn(i[p], i[p - 1]) - 180, u = vn(i[p], s, a, r), o.push(u.geometry.coordinates);
            }
            if (c >= n) return (s = n - c) ? (a = mn(i[p], i[p - 1]) - 180, u = vn(i[p], s, a, r), o.push(u.geometry.coordinates), h(o)) : (o.push(i[p]), h(o));
            if (c >= e && o.push(i[p]), p === i.length - 1) return h(o);
            c += me(i[p], i[p + 1], r);
        }
        if (c < e && i.length === l) throw new Error("Start position is beyond line");
        var f = i[i.length - 1];
        return h([
            f,
            f
        ]);
    }
    function Wr(t, e, n) {
        void 0 === n && (n = {});
        for(var r = K(t), i = Q(e), o = 0; o < i.length - 1; o++){
            var s = !1;
            if (n.ignoreEndVertices && (0 === o && (s = "start"), o === i.length - 2 && (s = "end"), 0 === o && o + 1 === i.length - 1 && (s = "both")), Jr(i[o], i[o + 1], r, s, void 0 === n.epsilon ? null : n.epsilon)) return !0;
        }
        return !1;
    }
    function Jr(t, e, n, r, i) {
        var o = n[0], s = n[1], a = t[0], u = t[1], l = e[0], c = e[1], h = l - a, p = c - u, f = (n[0] - a) * p - (n[1] - u) * h;
        if (null !== i) {
            if (Math.abs(f) > i) return !1;
        } else if (0 !== f) return !1;
        return r ? "start" === r ? Math.abs(h) >= Math.abs(p) ? h > 0 ? a < o && o <= l : l <= o && o < a : p > 0 ? u < s && s <= c : c <= s && s < u : "end" === r ? Math.abs(h) >= Math.abs(p) ? h > 0 ? a <= o && o < l : l < o && o <= a : p > 0 ? u <= s && s < c : c < s && s <= u : "both" === r && (Math.abs(h) >= Math.abs(p) ? h > 0 ? a < o && o < l : l < o && o < a : p > 0 ? u < s && s < c : c < s && s < u) : Math.abs(h) >= Math.abs(p) ? h > 0 ? a <= o && o <= l : l <= o && o <= a : p > 0 ? u <= s && s <= c : c <= s && s <= u;
    }
    function Zr(t, e) {
        var n = rt(t), r = rt(e), i = n.type, o = r.type;
        switch(i){
            case "Point":
                switch(o){
                    case "MultiPoint":
                        return function(t, e) {
                            var n, r = !1;
                            for(n = 0; n < e.coordinates.length; n++)if (Qr(e.coordinates[n], t.coordinates)) {
                                r = !0;
                                break;
                            }
                            return r;
                        }(n, r);
                    case "LineString":
                        return Wr(n, r, {
                            ignoreEndVertices: !0
                        });
                    case "Polygon":
                    case "MultiPolygon":
                        return ye(n, r, {
                            ignoreBoundary: !0
                        });
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "MultiPoint":
                switch(o){
                    case "MultiPoint":
                        return function(t, e) {
                            for(var n = 0; n < t.coordinates.length; n++){
                                for(var r = !1, i = 0; i < e.coordinates.length; i++)Qr(t.coordinates[n], e.coordinates[i]) && (r = !0);
                                if (!r) return !1;
                            }
                            return !0;
                        }(n, r);
                    case "LineString":
                        return function(t, e) {
                            for(var n = !1, r = 0; r < t.coordinates.length; r++){
                                if (!Wr(t.coordinates[r], e)) return !1;
                                n || (n = Wr(t.coordinates[r], e, {
                                    ignoreEndVertices: !0
                                }));
                            }
                            return n;
                        }(n, r);
                    case "Polygon":
                    case "MultiPolygon":
                        return function(t, e) {
                            for(var n = !0, r = !1, i = 0; i < t.coordinates.length; i++){
                                if (!(r = ye(t.coordinates[1], e))) {
                                    n = !1;
                                    break;
                                }
                                r = ye(t.coordinates[1], e, {
                                    ignoreBoundary: !0
                                });
                            }
                            return n && r;
                        }(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "LineString":
                switch(o){
                    case "LineString":
                        return function(t, e) {
                            for(var n = 0; n < t.coordinates.length; n++)if (!Wr(t.coordinates[n], e)) return !1;
                            return !0;
                        }(n, r);
                    case "Polygon":
                    case "MultiPolygon":
                        return function(t, e) {
                            var n = Z(e), r = Z(t);
                            if (!Kr(n, r)) return !1;
                            for(var i = !1, o = 0; o < t.coordinates.length - 1; o++){
                                if (!ye(t.coordinates[o], e)) return !1;
                                if (i || (i = ye(t.coordinates[o], e, {
                                    ignoreBoundary: !0
                                })), !i) i = ye($r(t.coordinates[o], t.coordinates[o + 1]), e, {
                                    ignoreBoundary: !0
                                });
                            }
                            return i;
                        }(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "Polygon":
                switch(o){
                    case "Polygon":
                    case "MultiPolygon":
                        return function(t, e) {
                            var n = Z(t);
                            if (!Kr(Z(e), n)) return !1;
                            for(var r = 0; r < t.coordinates[0].length; r++)if (!ye(t.coordinates[0][r], e)) return !1;
                            return !0;
                        }(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            default:
                throw new Error("feature1 " + i + " geometry not supported");
        }
    }
    function Kr(t, e) {
        return !(t[0] > e[0]) && !(t[2] < e[2]) && !(t[1] > e[1]) && !(t[3] < e[3]);
    }
    function Qr(t, e) {
        return t[0] === e[0] && t[1] === e[1];
    }
    function $r(t, e) {
        return [
            (t[0] + e[0]) / 2,
            (t[1] + e[1]) / 2
        ];
    }
    function ti(t, e, n) {
        void 0 === n && (n = {}), n.mask && !n.units && (n.units = "kilometers");
        for(var r = [], i = t[0], o = t[1], s = t[2], u = t[3], l = e / me([
            i,
            o
        ], [
            s,
            o
        ], n) * (s - i), c = e / me([
            i,
            o
        ], [
            i,
            u
        ], n) * (u - o), h = s - i, p = u - o, g = Math.floor(h / l), d = (p - Math.floor(p / c) * c) / 2, y = i + (h - g * l) / 2; y <= s;){
            for(var v = o + d; v <= u;){
                var _ = a([
                    y,
                    v
                ], n.properties);
                n.mask ? Zr(_, n.mask) && r.push(_) : r.push(_), v += c;
            }
            y += l;
        }
        return f(r);
    }
    function ei(t, e) {
        void 0 === e && (e = {});
        var n = e.precision, r = e.coordinates, i = e.mutate;
        if (n = null == n || isNaN(n) ? 6 : n, r = null == r || isNaN(r) ? 3 : r, !t) throw new Error("<geojson> is required");
        if ("number" != typeof n) throw new Error("<precision> must be a number");
        if ("number" != typeof r) throw new Error("<coordinates> must be a number");
        !1 !== i && void 0 !== i || (t = JSON.parse(JSON.stringify(t)));
        var o = Math.pow(10, n);
        return R(t, function(t) {
            !function(t, e, n) {
                t.length > n && t.splice(n, t.length);
                for(var r = 0; r < t.length; r++)t[r] = Math.round(t[r] * e) / e;
            }(t, o, r);
        }), t;
    }
    function ni(t) {
        if (!t) throw new Error("geojson is required");
        var e = [];
        return z(t, function(t) {
            e.push(t);
        }), f(e);
    }
    function ri(t, e, n) {
        if ("Polygon" !== t.geometry.type) throw new Error("The input feature must be a Polygon");
        void 0 === n && (n = 1);
        var r = t.geometry.coordinates, i = [], o = {};
        if (n) {
            for(var s = [], a = 0; a < r.length; a++)for(var u = 0; u < r[a].length - 1; u++)s.push(d(a, u));
            var l = Nt();
            l.load(s);
        }
        for(var c = 0; c < r.length; c++)for(var h = 0; h < r[c].length - 1; h++){
            if (n) l.search(d(c, h)).forEach(function(t) {
                var e = t.ring, n = t.edge;
                g(c, h, e, n);
            });
            else for(var p = 0; p < r.length; p++)for(var f = 0; f < r[p].length - 1; f++)g(c, h, p, f);
        }
        return e || (i = {
            type: "Feature",
            geometry: {
                type: "MultiPoint",
                coordinates: i
            }
        }), i;
        function g(t, n, s, a) {
            var u, l, c = r[t][n], h = r[t][n + 1], p = r[s][a], f = r[s][a + 1], g = function(t, e, n, r) {
                if (ii(t, n) || ii(t, r) || ii(e, n) || ii(r, n)) return null;
                var i = t[0], o = t[1], s = e[0], a = e[1], u = n[0], l = n[1], c = r[0], h = r[1], p = (i - s) * (l - h) - (o - a) * (u - c);
                return 0 === p ? null : [
                    ((i * a - o * s) * (u - c) - (i - s) * (u * h - l * c)) / p,
                    ((i * a - o * s) * (l - h) - (o - a) * (u * h - l * c)) / p
                ];
            }(c, h, p, f);
            if (null !== g && (u = h[0] !== c[0] ? (g[0] - c[0]) / (h[0] - c[0]) : (g[1] - c[1]) / (h[1] - c[1]), l = f[0] !== p[0] ? (g[0] - p[0]) / (f[0] - p[0]) : (g[1] - p[1]) / (f[1] - p[1]), !(u >= 1 || u <= 0 || l >= 1 || l <= 0))) {
                var d = g, y = !o[d];
                y && (o[d] = !0), e ? i.push(e(g, t, n, c, h, u, s, a, p, f, l, y)) : i.push(g);
            }
        }
        function d(t, e) {
            var n, i, o, s, a = r[t][e], u = r[t][e + 1];
            return a[0] < u[0] ? (n = a[0], i = u[0]) : (n = u[0], i = a[0]), a[1] < u[1] ? (o = a[1], s = u[1]) : (o = u[1], s = a[1]), {
                minX: n,
                minY: o,
                maxX: i,
                maxY: s,
                ring: t,
                edge: e
            };
        }
    }
    function ii(t, e) {
        if (!t || !e) return !1;
        if (t.length !== e.length) return !1;
        for(var n = 0, r = t.length; n < r; n++)if (t[n] instanceof Array && e[n] instanceof Array) {
            if (!ii(t[n], e[n])) return !1;
        } else if (t[n] !== e[n]) return !1;
        return !0;
    }
    function oi(t) {
        if ("Feature" != t.type) throw new Error("The input must a geojson object of type Feature");
        if (void 0 === t.geometry || null == t.geometry) throw new Error("The input must a geojson object with a non-empty geometry");
        if ("Polygon" != t.geometry.type) throw new Error("The input must be a geojson Polygon");
        for(var e = t.geometry.coordinates.length, n = [], r = 0; r < e; r++){
            var i = t.geometry.coordinates[r];
            ci(i[0], i[i.length - 1]) || i.push(i[0]), n.push.apply(n, i.slice(0, i.length - 1));
        }
        if (!function(t) {
            for(var e = {}, n = 1, r = 0, i = t.length; r < i; ++r){
                if (Object.prototype.hasOwnProperty.call(e, t[r])) {
                    n = 0;
                    break;
                }
                e[t[r]] = 1;
            }
            return n;
        }(n)) throw new Error("The input polygon may not have duplicate vertices (except for the first and last vertex of each ring)");
        var o = n.length, s = ri(t, function(t, e, n, r, i, o, s, a, u, l, c, h) {
            return [
                t,
                e,
                n,
                r,
                i,
                o,
                s,
                a,
                u,
                l,
                c,
                h
            ];
        }), a = s.length;
        if (0 == a) {
            var u = [];
            for(r = 0; r < e; r++)u.push(l([
                t.geometry.coordinates[r]
            ], {
                parent: -1,
                winding: li(t.geometry.coordinates[r])
            }));
            var c = f(u);
            return G(), q(), c;
        }
        var h = [], p = [];
        for(r = 0; r < e; r++){
            h.push([]);
            for(var g = 0; g < t.geometry.coordinates[r].length - 1; g++)h[r].push([
                new si(t.geometry.coordinates[r][hi(g + 1, t.geometry.coordinates[r].length - 1)], 1, [
                    r,
                    g
                ], [
                    r,
                    hi(g + 1, t.geometry.coordinates[r].length - 1)
                ], void 0)
            ]), p.push(new ai(t.geometry.coordinates[r][g], [
                r,
                hi(g - 1, t.geometry.coordinates[r].length - 1)
            ], [
                r,
                g
            ], void 0, void 0, !1, !0));
        }
        for(r = 0; r < a; r++)h[s[r][1]][s[r][2]].push(new si(s[r][0], s[r][5], [
            s[r][1],
            s[r][2]
        ], [
            s[r][6],
            s[r][7]
        ], void 0)), s[r][11] && p.push(new ai(s[r][0], [
            s[r][1],
            s[r][2]
        ], [
            s[r][6],
            s[r][7]
        ], void 0, void 0, !0, !0));
        var d = p.length;
        for(r = 0; r < h.length; r++)for(g = 0; g < h[r].length; g++)h[r][g].sort(function(t, e) {
            return t.param < e.param ? -1 : 1;
        });
        var y = [];
        for(r = 0; r < d; r++)y.push({
            minX: p[r].coord[0],
            minY: p[r].coord[1],
            maxX: p[r].coord[0],
            maxY: p[r].coord[1],
            index: r
        });
        var v = Nt();
        v.load(y);
        for(r = 0; r < h.length; r++)for(g = 0; g < h[r].length; g++)for(var _ = 0; _ < h[r][g].length; _++){
            x = _ == h[r][g].length - 1 ? h[r][hi(g + 1, t.geometry.coordinates[r].length - 1)][0].coord : h[r][g][_ + 1].coord;
            var m = v.search({
                minX: x[0],
                minY: x[1],
                maxX: x[0],
                maxY: x[1]
            })[0];
            h[r][g][_].nxtIsectAlongEdgeIn = m.index;
        }
        for(r = 0; r < h.length; r++)for(g = 0; g < h[r].length; g++)for(_ = 0; _ < h[r][g].length; _++){
            var x = h[r][g][_].coord, E = (m = v.search({
                minX: x[0],
                minY: x[1],
                maxX: x[0],
                maxY: x[1]
            })[0]).index;
            E < o ? p[E].nxtIsectAlongRingAndEdge2 = h[r][g][_].nxtIsectAlongEdgeIn : ci(p[E].ringAndEdge1, h[r][g][_].ringAndEdgeIn) ? p[E].nxtIsectAlongRingAndEdge1 = h[r][g][_].nxtIsectAlongEdgeIn : p[E].nxtIsectAlongRingAndEdge2 = h[r][g][_].nxtIsectAlongEdgeIn;
        }
        var b = [];
        for(r = 0, g = 0; g < e; g++){
            var w = r;
            for(_ = 0; _ < t.geometry.coordinates[g].length - 1; _++)p[r].coord[0] < p[w].coord[0] && (w = r), r++;
            var I = p[w].nxtIsectAlongRingAndEdge2;
            for(_ = 0; _ < p.length; _++)if (p[_].nxtIsectAlongRingAndEdge1 == w || p[_].nxtIsectAlongRingAndEdge2 == w) {
                var N = _;
                break;
            }
            var S = ui([
                p[N].coord,
                p[w].coord,
                p[I].coord
            ], !0) ? 1 : -1;
            b.push({
                isect: w,
                parent: -1,
                winding: S
            });
        }
        b.sort(function(t, e) {
            return p[t.isect].coord > p[e.isect].coord ? -1 : 1;
        });
        for(u = []; b.length > 0;){
            var C = b.pop(), P = C.isect, M = C.parent, L = C.winding, O = u.length, R = [
                p[P].coord
            ], T = P;
            if (p[P].ringAndEdge1Walkable) var A = p[P].ringAndEdge1, D = p[P].nxtIsectAlongRingAndEdge1;
            else A = p[P].ringAndEdge2, D = p[P].nxtIsectAlongRingAndEdge2;
            for(; !ci(p[P].coord, p[D].coord);){
                R.push(p[D].coord);
                var F = void 0;
                for(r = 0; r < b.length; r++)if (b[r].isect == D) {
                    F = r;
                    break;
                }
                if (null != F && b.splice(F, 1), ci(A, p[D].ringAndEdge1)) {
                    if (A = p[D].ringAndEdge2, p[D].ringAndEdge2Walkable = !1, p[D].ringAndEdge1Walkable) {
                        var k = {
                            isect: D
                        };
                        ui([
                            p[T].coord,
                            p[D].coord,
                            p[p[D].nxtIsectAlongRingAndEdge2].coord
                        ], 1 == L) ? (k.parent = M, k.winding = -L) : (k.parent = O, k.winding = L), b.push(k);
                    }
                    T = D, D = p[D].nxtIsectAlongRingAndEdge2;
                } else {
                    if (A = p[D].ringAndEdge1, p[D].ringAndEdge1Walkable = !1, p[D].ringAndEdge2Walkable) {
                        k = {
                            isect: D
                        };
                        ui([
                            p[T].coord,
                            p[D].coord,
                            p[p[D].nxtIsectAlongRingAndEdge1].coord
                        ], 1 == L) ? (k.parent = M, k.winding = -L) : (k.parent = O, k.winding = L), b.push(k);
                    }
                    T = D, D = p[D].nxtIsectAlongRingAndEdge1;
                }
            }
            R.push(p[D].coord), u.push(l([
                R
            ], {
                index: O,
                parent: M,
                winding: L,
                netWinding: void 0
            }));
        }
        c = f(u);
        function G() {
            for(var t = [], e = 0; e < c.features.length; e++)-1 == c.features[e].properties.parent && t.push(e);
            if (t.length > 1) for(e = 0; e < t.length; e++){
                for(var n = -1, r = 0; r < c.features.length; r++)t[e] != r && ye(c.features[t[e]].geometry.coordinates[0][0], c.features[r], {
                    ignoreBoundary: !0
                }) && jr(c.features[r]) < Infinity && (n = r);
                c.features[t[e]].properties.parent = n;
            }
        }
        function q() {
            for(var t = 0; t < c.features.length; t++)if (-1 == c.features[t].properties.parent) {
                var e = c.features[t].properties.winding;
                c.features[t].properties.netWinding = e, B(t, e);
            }
        }
        function B(t, e) {
            for(var n = 0; n < c.features.length; n++)if (c.features[n].properties.parent == t) {
                var r = e + c.features[n].properties.winding;
                c.features[n].properties.netWinding = r, B(n, r);
            }
        }
        return G(), q(), c;
    }
    var si = function(t, e, n, r, i) {
        this.coord = t, this.param = e, this.ringAndEdgeIn = n, this.ringAndEdgeOut = r, this.nxtIsectAlongEdgeIn = i;
    }, ai = function(t, e, n, r, i, o, s) {
        this.coord = t, this.ringAndEdge1 = e, this.ringAndEdge2 = n, this.nxtIsectAlongRingAndEdge1 = r, this.nxtIsectAlongRingAndEdge2 = i, this.ringAndEdge1Walkable = o, this.ringAndEdge2Walkable = s;
    };
    function ui(t, e) {
        if (void 0 === e && (e = !0), 3 != t.length) throw new Error("This function requires an array of three points [x,y]");
        return (t[1][0] - t[0][0]) * (t[2][1] - t[0][1]) - (t[1][1] - t[0][1]) * (t[2][0] - t[0][0]) >= 0 == e;
    }
    function li(t) {
        for(var e = 0, n = 0; n < t.length - 1; n++)t[n][0] < t[e][0] && (e = n);
        if (ui([
            t[hi(e - 1, t.length - 1)],
            t[e],
            t[hi(e + 1, t.length - 1)]
        ], !0)) var r = 1;
        else r = -1;
        return r;
    }
    function ci(t, e) {
        if (!t || !e) return !1;
        if (t.length != e.length) return !1;
        for(var n = 0, r = t.length; n < r; n++)if (t[n] instanceof Array && e[n] instanceof Array) {
            if (!ci(t[n], e[n])) return !1;
        } else if (t[n] != e[n]) return !1;
        return !0;
    }
    function hi(t, e) {
        return (t % e + e) % e;
    }
    var pi = Math.PI / 180, fi = 180 / Math.PI, gi = function(t, e) {
        this.lon = t, this.lat = e, this.x = pi * t, this.y = pi * e;
    };
    gi.prototype.view = function() {
        return String(this.lon).slice(0, 4) + "," + String(this.lat).slice(0, 4);
    }, gi.prototype.antipode = function() {
        var t = -1 * this.lat, e = this.lon < 0 ? 180 + this.lon : -1 * (180 - this.lon);
        return new gi(e, t);
    };
    var di = function() {
        this.coords = [], this.length = 0;
    };
    di.prototype.move_to = function(t) {
        this.length++, this.coords.push(t);
    };
    var yi = function(t) {
        this.properties = t || {}, this.geometries = [];
    };
    yi.prototype.json = function() {
        if (this.geometries.length <= 0) return {
            geometry: {
                type: "LineString",
                coordinates: null
            },
            type: "Feature",
            properties: this.properties
        };
        if (1 === this.geometries.length) return {
            geometry: {
                type: "LineString",
                coordinates: this.geometries[0].coords
            },
            type: "Feature",
            properties: this.properties
        };
        for(var t = [], e = 0; e < this.geometries.length; e++)t.push(this.geometries[e].coords);
        return {
            geometry: {
                type: "MultiLineString",
                coordinates: t
            },
            type: "Feature",
            properties: this.properties
        };
    }, yi.prototype.wkt = function() {
        for(var t = "", e = "LINESTRING(", n = function(t) {
            e += t[0] + " " + t[1] + ",";
        }, r = 0; r < this.geometries.length; r++){
            if (0 === this.geometries[r].coords.length) return "LINESTRING(empty)";
            this.geometries[r].coords.forEach(n), t += e.substring(0, e.length - 1) + ")";
        }
        return t;
    };
    var vi = function(t, e, n) {
        if (!t || void 0 === t.x || void 0 === t.y) throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");
        if (!e || void 0 === e.x || void 0 === e.y) throw new Error("GreatCircle constructor expects two args: start and end objects with x and y properties");
        this.start = new gi(t.x, t.y), this.end = new gi(e.x, e.y), this.properties = n || {};
        var r = this.start.x - this.end.x, i = this.start.y - this.end.y, o = Math.pow(Math.sin(i / 2), 2) + Math.cos(this.start.y) * Math.cos(this.end.y) * Math.pow(Math.sin(r / 2), 2);
        if (this.g = 2 * Math.asin(Math.sqrt(o)), this.g === Math.PI) throw new Error("it appears " + t.view() + " and " + e.view() + " are 'antipodal', e.g diametrically opposite, thus there is no single route but rather infinite");
        if (isNaN(this.g)) throw new Error("could not calculate great circle between " + t + " and " + e);
    };
    function _i(t, e) {
        var n = [], r = Mr();
        return z(e, function(e) {
            if (n.forEach(function(t, e) {
                t.id = e;
            }), n.length) {
                var i = r.search(e);
                if (i.features.length) {
                    var o = xi(e, i);
                    n = n.filter(function(t) {
                        return t.id !== o.id;
                    }), r.remove(o), F(mi(o, e), function(t) {
                        n.push(t), r.insert(t);
                    });
                }
            } else (n = mi(t, e).features).forEach(function(t) {
                t.bbox || (t.bbox = yn(Z(t)));
            }), r.load(f(n));
        }), f(n);
    }
    function mi(t, e) {
        var n = [], r = Q(t)[0], i = Q(t)[t.geometry.coordinates.length - 1];
        if (Ei(r, K(e)) || Ei(i, K(e))) return f([
            t
        ]);
        var o = Mr(), s = Zn(t);
        o.load(s);
        var a = o.search(e);
        if (!a.features.length) return f([
            t
        ]);
        var u = xi(e, a), l = k(s, function(t, r, i) {
            var o = Q(r)[1], s = K(e);
            return i === u.id ? (t.push(s), n.push(h(t)), Ei(s, o) ? [
                s
            ] : [
                s,
                o
            ]) : (t.push(o), t);
        }, [
            r
        ]);
        return l.length > 1 && n.push(h(l)), f(n);
    }
    function xi(t, e) {
        if (!e.features.length) throw new Error("lines must contain features");
        if (1 === e.features.length) return e.features[0];
        var n, r = 1 / 0;
        return F(e, function(e) {
            var i = Tr(e, t).properties.dist;
            i < r && (n = e, r = i);
        }), n;
    }
    function Ei(t, e) {
        return t[0] === e[0] && t[1] === e[1];
    }
    function bi(t, e, n, r, i) {
        void 0 === i && (i = {});
        var o = i.steps || 64, s = wi(n), a = wi(r), u = Array.isArray(t) || "Feature" !== t.type ? {} : t.properties;
        if (s === a) return h(_n(t, e, i).geometry.coordinates[0], u);
        for(var l = s, c = s < a ? a : a + 360, p = l, f = [], g = 0; p < c;)f.push(vn(t, e, p, i).geometry.coordinates), p = l + 360 * ++g / o;
        return p > c && f.push(vn(t, e, c, i).geometry.coordinates), h(f, u);
    }
    function wi(t) {
        var e = t % 360;
        return e < 0 && (e += 360), e;
    }
    function Ii(t, e) {
        void 0 === e && (e = {});
        var n = rt(t);
        switch(e.properties || "Feature" !== t.type || (e.properties = t.properties), n.type){
            case "Polygon":
                return Ni(n, e);
            case "MultiPolygon":
                return function(t, e) {
                    void 0 === e && (e = {});
                    var n = rt(t).coordinates, r = e.properties ? e.properties : "Feature" === t.type ? t.properties : {}, i = [];
                    return n.forEach(function(t) {
                        i.push(Si(t, r));
                    }), f(i);
                }(n, e);
            default:
                throw new Error("invalid poly");
        }
    }
    function Ni(t, e) {
        return void 0 === e && (e = {}), Si(rt(t).coordinates, e.properties ? e.properties : "Feature" === t.type ? t.properties : {});
    }
    function Si(t, e) {
        return t.length > 1 ? g(t, e) : h(t[0], e);
    }
    function Ci(t, e) {
        var n, r, i;
        void 0 === e && (e = {});
        var o = e.properties, s = null === (n = e.autoComplete) || void 0 === n || n, a = null === (r = e.orderCoords) || void 0 === r || r;
        switch(null !== (i = e.mutate) && void 0 !== i && i || (t = Ie(t)), t.type){
            case "FeatureCollection":
                var u = [];
                return t.features.forEach(function(t) {
                    u.push(Q(Pi(t, {}, s, a)));
                }), y(u, o);
            default:
                return Pi(t, o, s, a);
        }
    }
    function Pi(t, e, n, r) {
        e = e || ("Feature" === t.type ? t.properties : {});
        var i = rt(t), o = i.coordinates, s = i.type;
        if (!o.length) throw new Error("line must contain coordinates");
        switch(s){
            case "LineString":
                return n && (o = Mi(o)), l([
                    o
                ], e);
            case "MultiLineString":
                var a = [], u = 0;
                return o.forEach(function(t) {
                    if (n && (t = Mi(t)), r) {
                        var e = function(t) {
                            var e = t[0], n = t[1], r = t[2], i = t[3];
                            return Math.abs(e - r) * Math.abs(n - i);
                        }(Z(h(t)));
                        e > u ? (a.unshift(t), u = e) : a.push(t);
                    } else a.push(t);
                }), l(a, e);
            default:
                throw new Error("geometry type " + s + " is not supported");
        }
    }
    function Mi(t) {
        var e = t[0], n = e[0], r = e[1], i = t[t.length - 1], o = i[0], s = i[1];
        return n === o && r === s || t.push(e), t;
    }
    function Li(t, e) {
        var n, r, i, o, s, a, u;
        for(r = 1; r <= 8; r *= 2){
            for(n = [], o = !(Ri(i = t[t.length - 1], e) & r), s = 0; s < t.length; s++)(u = !(Ri(a = t[s], e) & r)) !== o && n.push(Oi(i, a, r, e)), u && n.push(a), i = a, o = u;
            if (!(t = n).length) break;
        }
        return n;
    }
    function Oi(t, e, n, r) {
        return 8 & n ? [
            t[0] + (e[0] - t[0]) * (r[3] - t[1]) / (e[1] - t[1]),
            r[3]
        ] : 4 & n ? [
            t[0] + (e[0] - t[0]) * (r[1] - t[1]) / (e[1] - t[1]),
            r[1]
        ] : 2 & n ? [
            r[2],
            t[1] + (e[1] - t[1]) * (r[2] - t[0]) / (e[0] - t[0])
        ] : 1 & n ? [
            r[0],
            t[1] + (e[1] - t[1]) * (r[0] - t[0]) / (e[0] - t[0])
        ] : null;
    }
    function Ri(t, e) {
        var n = 0;
        return t[0] < e[0] ? n |= 1 : t[0] > e[2] && (n |= 2), t[1] < e[1] ? n |= 4 : t[1] > e[3] && (n |= 8), n;
    }
    function Ti(t, e) {
        for(var n = [], r = 0, i = t; r < i.length; r++){
            var o = Li(i[r], e);
            o.length > 0 && (o[0][0] === o[o.length - 1][0] && o[0][1] === o[o.length - 1][1] || o.push(o[0]), o.length >= 4 && n.push(o));
        }
        return n;
    }
    vi.prototype.interpolate = function(t) {
        var e = Math.sin((1 - t) * this.g) / Math.sin(this.g), n = Math.sin(t * this.g) / Math.sin(this.g), r = e * Math.cos(this.start.y) * Math.cos(this.start.x) + n * Math.cos(this.end.y) * Math.cos(this.end.x), i = e * Math.cos(this.start.y) * Math.sin(this.start.x) + n * Math.cos(this.end.y) * Math.sin(this.end.x), o = e * Math.sin(this.start.y) + n * Math.sin(this.end.y), s = fi * Math.atan2(o, Math.sqrt(Math.pow(r, 2) + Math.pow(i, 2)));
        return [
            fi * Math.atan2(i, r),
            s
        ];
    }, vi.prototype.Arc = function(t, e) {
        var n = [];
        if (!t || t <= 2) n.push([
            this.start.lon,
            this.start.lat
        ]), n.push([
            this.end.lon,
            this.end.lat
        ]);
        else for(var r = 1 / (t - 1), i = 0; i < t; ++i){
            var o = r * i, s = this.interpolate(o);
            n.push(s);
        }
        for(var a = !1, u = 0, l = e && e.offset ? e.offset : 10, c = 180 - l, h = -180 + l, p = 360 - l, f = 1; f < n.length; ++f){
            var g = n[f - 1][0], d = n[f][0], y = Math.abs(d - g);
            y > p && (d > c && g < h || g > c && d < h) ? a = !0 : y > u && (u = y);
        }
        var v = [];
        if (a && u < l) {
            var _ = [];
            v.push(_);
            for(var m = 0; m < n.length; ++m){
                var x = parseFloat(n[m][0]);
                if (m > 0 && Math.abs(x - n[m - 1][0]) > p) {
                    var E = parseFloat(n[m - 1][0]), b = parseFloat(n[m - 1][1]), w = parseFloat(n[m][0]), I = parseFloat(n[m][1]);
                    if (E > -180 && E < h && 180 === w && m + 1 < n.length && n[m - 1][0] > -180 && n[m - 1][0] < h) {
                        _.push([
                            -180,
                            n[m][1]
                        ]), m++, _.push([
                            n[m][0],
                            n[m][1]
                        ]);
                        continue;
                    }
                    if (E > c && E < 180 && -180 === w && m + 1 < n.length && n[m - 1][0] > c && n[m - 1][0] < 180) {
                        _.push([
                            180,
                            n[m][1]
                        ]), m++, _.push([
                            n[m][0],
                            n[m][1]
                        ]);
                        continue;
                    }
                    if (E < h && w > c) {
                        var N = E;
                        E = w, w = N;
                        var S = b;
                        b = I, I = S;
                    }
                    if (E > c && w < h && (w += 360), E <= 180 && w >= 180 && E < w) {
                        var C = (180 - E) / (w - E), P = C * I + (1 - C) * b;
                        _.push([
                            n[m - 1][0] > c ? 180 : -180,
                            P
                        ]), (_ = []).push([
                            n[m - 1][0] > c ? -180 : 180,
                            P
                        ]), v.push(_);
                    } else _ = [], v.push(_);
                    _.push([
                        x,
                        n[m][1]
                    ]);
                } else _.push([
                    n[m][0],
                    n[m][1]
                ]);
            }
        } else {
            var M = [];
            v.push(M);
            for(var L = 0; L < n.length; ++L)M.push([
                n[L][0],
                n[L][1]
            ]);
        }
        for(var O = new yi(this.properties), R = 0; R < v.length; ++R){
            var T = new di;
            O.geometries.push(T);
            for(var A = v[R], D = 0; D < A.length; ++D)T.move_to(A[D]);
        }
        return O;
    };
    var Ai = Bt(function(t, e) {
        function n(t) {
            var e = [];
            for(var n in t)e.push(n);
            return e;
        }
        (t.exports = "function" == typeof Object.keys ? Object.keys : n).shim = n;
    }), Di = Bt(function(t, e) {
        var n = "[object Arguments]" == function() {
            return Object.prototype.toString.call(arguments);
        }();
        function r(t) {
            return "[object Arguments]" == Object.prototype.toString.call(t);
        }
        function i(t) {
            return t && "object" == typeof t && "number" == typeof t.length && Object.prototype.hasOwnProperty.call(t, "callee") && !Object.prototype.propertyIsEnumerable.call(t, "callee") || !1;
        }
        (e = t.exports = n ? r : i).supported = r, e.unsupported = i;
    }), Fi = Bt(function(t) {
        var e = Array.prototype.slice, n = t.exports = function(t, o, s) {
            return s || (s = {}), t === o || (t instanceof Date && o instanceof Date ? t.getTime() === o.getTime() : !t || !o || "object" != typeof t && "object" != typeof o ? s.strict ? t === o : t == o : function(t, o, s) {
                var a, u;
                if (r(t) || r(o)) return !1;
                if (t.prototype !== o.prototype) return !1;
                if (Di(t)) return !!Di(o) && (t = e.call(t), o = e.call(o), n(t, o, s));
                if (i(t)) {
                    if (!i(o)) return !1;
                    if (t.length !== o.length) return !1;
                    for(a = 0; a < t.length; a++)if (t[a] !== o[a]) return !1;
                    return !0;
                }
                try {
                    var l = Ai(t), c = Ai(o);
                } catch (t) {
                    return !1;
                }
                if (l.length != c.length) return !1;
                for(l.sort(), c.sort(), a = l.length - 1; a >= 0; a--)if (l[a] != c[a]) return !1;
                for(a = l.length - 1; a >= 0; a--)if (u = l[a], !n(t[u], o[u], s)) return !1;
                return typeof t == typeof o;
            }(t, o, s));
        };
        function r(t) {
            return null == t;
        }
        function i(t) {
            return !(!t || "object" != typeof t || "number" != typeof t.length) && "function" == typeof t.copy && "function" == typeof t.slice && !(t.length > 0 && "number" != typeof t[0]);
        }
    });
    function ki(t, e, n) {
        if (void 0 === n && (n = {}), !P(n = n || {})) throw new Error("options is invalid");
        var r, i = n.tolerance || 0, o = [], s = Mr(), a = Zn(t);
        return s.load(a), U(e, function(t) {
            var e = !1;
            t && (F(s.search(t), function(n) {
                if (!1 === e) {
                    var o = Q(t).sort(), s = Q(n).sort();
                    Fi(o, s) || (0 === i ? Wr(o[0], n) && Wr(o[1], n) : Tr(n, o[0]).properties.dist <= i && Tr(n, o[1]).properties.dist <= i) ? (e = !0, r = r ? Gi(r, t) : t) : (0 === i ? Wr(s[0], t) && Wr(s[1], t) : Tr(t, s[0]).properties.dist <= i && Tr(t, s[1]).properties.dist <= i) && (r = r ? Gi(r, n) : n);
                }
            }), !1 === e && r && (o.push(r), r = void 0));
        }), r && o.push(r), f(o);
    }
    function Gi(t, e) {
        var n = Q(e), r = Q(t), i = r[0], o = r[r.length - 1], s = t.geometry.coordinates;
        return Fi(n[0], i) ? s.unshift(n[1]) : Fi(n[0], o) ? s.push(n[1]) : Fi(n[1], i) ? s.unshift(n[0]) : Fi(n[1], o) && s.push(n[0]), t;
    }
    function qi(t) {
        var e = t % 360;
        return e < 0 && (e += 360), e;
    }
    function Bi(t, e, n) {
        var r;
        return void 0 === n && (n = {}), (r = n.final ? zi(K(e), K(t)) : zi(K(t), K(e))) > 180 ? -(360 - r) : r;
    }
    function zi(t, e) {
        var n = I(t[1]), r = I(e[1]), i = I(e[0] - t[0]);
        i > Math.PI && (i -= 2 * Math.PI), i < -Math.PI && (i += 2 * Math.PI);
        var o = Math.log(Math.tan(r / 2 + Math.PI / 4) / Math.tan(n / 2 + Math.PI / 4));
        return (w(Math.atan2(i, o)) + 360) % 360;
    }
    function ji(t, n, r, i) {
        void 0 === i && (i = {});
        var o = n < 0, s = N(Math.abs(n), i.units, "meters");
        o && (s = -Math.abs(s));
        var u = K(t), l = function(t, n, r, i) {
            i = void 0 === i ? e : Number(i);
            var o = n / i, s = t[0] * Math.PI / 180, a = I(t[1]), u = I(r), l = o * Math.cos(u), c = a + l;
            Math.abs(c) > Math.PI / 2 && (c = c > 0 ? Math.PI - c : -Math.PI - c);
            var h = Math.log(Math.tan(c / 2 + Math.PI / 4) / Math.tan(a / 2 + Math.PI / 4)), p = Math.abs(h) > 1e-11 ? l / h : Math.cos(a), f = o * Math.sin(u) / p;
            return [
                (180 * (s + f) / Math.PI + 540) % 360 - 180,
                180 * c / Math.PI
            ];
        }(u, s, r);
        return l[0] += l[0] - u[0] > 180 ? -360 : u[0] - l[0] > 180 ? 360 : 0, a(l, i.properties);
    }
    function Ui(t, e, n, r, i, o) {
        for(var s = 0; s < t.length; s++){
            var a = t[s], u = t[s + 1];
            s === t.length - 1 && (u = t[0]), r = Xi(a, u, e), n <= 0 && r > 0 ? Xi(e, a, i) < 0 || (i = a) : n > 0 && r <= 0 && (Vi(e, a, o) || (o = a)), n = r;
        }
        return [
            i,
            o
        ];
    }
    function Vi(t, e, n) {
        return Xi(t, e, n) > 0;
    }
    function Xi(t, e, n) {
        return (e[0] - t[0]) * (n[1] - t[1]) - (n[0] - t[0]) * (e[1] - t[1]);
    }
    function Yi(t) {
        for(var e, n, r = Q(t), i = 0, o = 1; o < r.length;)e = n || r[0], i += ((n = r[o])[0] - e[0]) * (n[1] + e[1]), o++;
        return i > 0;
    }
    function Hi(t, e) {
        switch("Feature" === t.type ? t.geometry.type : t.type){
            case "GeometryCollection":
                return q(t, function(t) {
                    Hi(t, e);
                }), t;
            case "LineString":
                return Wi(Q(t), e), t;
            case "Polygon":
                return Ji(Q(t), e), t;
            case "MultiLineString":
                return Q(t).forEach(function(t) {
                    Wi(t, e);
                }), t;
            case "MultiPolygon":
                return Q(t).forEach(function(t) {
                    Ji(t, e);
                }), t;
            case "Point":
            case "MultiPoint":
                return t;
        }
    }
    function Wi(t, e) {
        Yi(t) === e && t.reverse();
    }
    function Ji(t, e) {
        Yi(t[0]) !== e && t[0].reverse();
        for(var n = 1; n < t.length; n++)Yi(t[n]) === e && t[n].reverse();
    }
    function Zi(t, e) {
        if (!P(e = e || {})) throw new Error("options is invalid");
        var n = e.zProperty || "elevation", r = e.flip, i = e.flags;
        nt(t, "Point", "input must contain Points");
        for(var o = function(t, e) {
            var n = {};
            return F(t, function(t) {
                var e = Q(t)[1];
                n[e] || (n[e] = []), n[e].push(t);
            }), Object.keys(n).map(function(t) {
                return n[t].sort(function(t, e) {
                    return Q(t)[0] - Q(e)[0];
                });
            }).sort(function(t, n) {
                return e ? Q(t[0])[1] - Q(n[0])[1] : Q(n[0])[1] - Q(t[0])[1];
            });
        }(t, r), s = [], a = 0; a < o.length; a++){
            for(var u = o[a], l = [], c = 0; c < u.length; c++){
                var h = u[c];
                h.properties[n] ? l.push(h.properties[n]) : l.push(0), !0 === i && (h.properties.matrixPosition = [
                    a,
                    c
                ]);
            }
            s.push(l);
        }
        return s;
    }
    var Ki = {
        successCallback: null,
        verbose: !1,
        polygons: !1
    }, Qi = {};
    function $i(t, e, n, r) {
        r = r || {};
        for(var i = Object.keys(Ki), o = 0; o < i.length; o++){
            var s = i[o], a = r[s];
            a = null != a ? a : Ki[s], Qi[s] = a;
        }
        Qi.verbose && console.log("MarchingSquaresJS-isoBands: computing isobands for [" + e + ":" + (e + n) + "]");
        var u, l = function(t, e, n) {
            for(var r = t.length - 1, i = t[0].length - 1, o = {
                rows: r,
                cols: i,
                cells: []
            }, s = e + Math.abs(n), a = 0; a < r; ++a){
                o.cells[a] = [];
                for(var u = 0; u < i; ++u){
                    var l = 0, c = t[a + 1][u], h = t[a + 1][u + 1], p = t[a][u + 1], f = t[a][u];
                    if (!(isNaN(c) || isNaN(h) || isNaN(p) || isNaN(f))) {
                        l |= c < e ? 0 : c > s ? 128 : 64, l |= h < e ? 0 : h > s ? 32 : 16, l |= p < e ? 0 : p > s ? 8 : 4;
                        var g = +(l |= f < e ? 0 : f > s ? 2 : 1), d = 0;
                        if (17 === l || 18 === l || 33 === l || 34 === l || 38 === l || 68 === l || 72 === l || 98 === l || 102 === l || 132 === l || 136 === l || 137 === l || 152 === l || 153 === l) {
                            var y = (c + h + p + f) / 4;
                            d = y > s ? 2 : y < e ? 0 : 1, 34 === l ? 1 === d ? l = 35 : 0 === d && (l = 136) : 136 === l ? 1 === d ? (l = 35, d = 4) : 0 === d && (l = 34) : 17 === l ? 1 === d ? (l = 155, d = 4) : 0 === d && (l = 153) : 68 === l ? 1 === d ? (l = 103, d = 4) : 0 === d && (l = 102) : 153 === l ? 1 === d && (l = 155) : 102 === l ? 1 === d && (l = 103) : 152 === l ? d < 2 && (l = 156, d = 1) : 137 === l ? d < 2 && (l = 139, d = 1) : 98 === l ? d < 2 && (l = 99, d = 1) : 38 === l ? d < 2 && (l = 39, d = 1) : 18 === l ? d > 0 ? (l = 156, d = 4) : l = 152 : 33 === l ? d > 0 ? (l = 139, d = 4) : l = 137 : 72 === l ? d > 0 ? (l = 99, d = 4) : l = 98 : 132 === l && (d > 0 ? (l = 39, d = 4) : l = 38);
                        }
                        if (0 != l && 170 != l) {
                            var v, _, m, x, E, b, w, I;
                            v = _ = m = x = E = b = w = I = .5;
                            var N = [];
                            1 === l ? (m = 1 - Vo(e, p, f), I = 1 - Vo(e, c, f), N.push(Go[l])) : 169 === l ? (m = Vo(s, f, p), I = Vo(s, f, c), N.push(Go[l])) : 4 === l ? (b = 1 - Vo(e, h, p), x = Vo(e, f, p), N.push(Fo[l])) : 166 === l ? (b = Vo(s, p, h), x = 1 - Vo(s, p, f), N.push(Fo[l])) : 16 === l ? (E = Vo(e, p, h), _ = Vo(e, c, h), N.push(Do[l])) : 154 === l ? (E = 1 - Vo(s, h, p), _ = 1 - Vo(s, h, c), N.push(Do[l])) : 64 === l ? (w = Vo(e, f, c), v = 1 - Vo(e, h, c), N.push(Bo[l])) : 106 === l ? (w = 1 - Vo(s, c, f), v = Vo(s, c, h), N.push(Bo[l])) : 168 === l ? (x = Vo(s, f, p), m = Vo(e, f, p), I = Vo(e, f, c), w = Vo(s, f, c), N.push(ko[l]), N.push(Go[l])) : 2 === l ? (x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), N.push(ko[l]), N.push(Go[l])) : 162 === l ? (E = Vo(s, p, h), b = Vo(e, p, h), x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), N.push(ko[l]), N.push(Go[l])) : 8 === l ? (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), x = Vo(s, f, p), m = Vo(e, f, p), N.push(Do[l]), N.push(Fo[l])) : 138 === l ? (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c), N.push(Do[l]), N.push(Fo[l])) : 32 === l ? (E = Vo(s, p, h), b = Vo(e, p, h), v = Vo(e, c, h), _ = Vo(s, c, h), N.push(Do[l]), N.push(Fo[l])) : 42 === l ? (I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), v = Vo(e, c, h), _ = Vo(s, c, h), N.push(qo[l]), N.push(Bo[l])) : 128 === l && (I = Vo(e, f, c), w = Vo(s, f, c), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c), N.push(qo[l]), N.push(Bo[l])), 5 === l ? (b = 1 - Vo(e, h, p), I = 1 - Vo(e, c, f), N.push(Fo[l])) : 165 === l ? (b = Vo(s, p, h), I = Vo(s, f, c), N.push(Fo[l])) : 20 === l ? (x = Vo(e, f, p), _ = Vo(e, c, h), N.push(ko[l])) : 150 === l ? (x = 1 - Vo(s, p, f), _ = 1 - Vo(s, h, c), N.push(ko[l])) : 80 === l ? (E = Vo(e, p, h), w = Vo(e, f, c), N.push(Do[l])) : 90 === l ? (E = 1 - Vo(s, h, p), w = 1 - Vo(s, c, f), N.push(Do[l])) : 65 === l ? (m = 1 - Vo(e, p, f), v = 1 - Vo(e, h, c), N.push(Go[l])) : 105 === l ? (m = Vo(s, f, p), v = Vo(s, c, h), N.push(Go[l])) : 160 === l ? (E = Vo(s, p, h), b = Vo(e, p, h), I = Vo(e, f, c), w = Vo(s, f, c), N.push(Do[l]), N.push(Fo[l])) : 10 === l ? (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), N.push(Do[l]), N.push(Fo[l])) : 130 === l ? (x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c), N.push(ko[l]), N.push(Go[l])) : 40 === l ? (x = Vo(s, f, p), m = Vo(e, f, p), v = Vo(e, c, h), _ = Vo(s, c, h), N.push(ko[l]), N.push(Go[l])) : 101 === l ? (b = Vo(s, p, h), v = Vo(s, c, h), N.push(Fo[l])) : 69 === l ? (b = 1 - Vo(e, h, p), v = 1 - Vo(e, h, c), N.push(Fo[l])) : 149 === l ? (I = Vo(s, f, c), _ = 1 - Vo(s, h, c), N.push(qo[l])) : 21 === l ? (I = 1 - Vo(e, c, f), _ = Vo(e, c, h), N.push(qo[l])) : 86 === l ? (x = 1 - Vo(s, p, f), w = 1 - Vo(s, c, f), N.push(ko[l])) : 84 === l ? (x = Vo(e, f, p), w = Vo(e, f, c), N.push(ko[l])) : 89 === l ? (E = 1 - Vo(s, h, p), m = Vo(s, f, p), N.push(Go[l])) : 81 === l ? (E = Vo(e, p, h), m = 1 - Vo(e, p, f), N.push(Go[l])) : 96 === l ? (E = Vo(s, p, h), b = Vo(e, p, h), w = Vo(e, f, c), v = Vo(s, c, h), N.push(Do[l]), N.push(Fo[l])) : 74 === l ? (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), w = 1 - Vo(s, c, f), v = 1 - Vo(e, h, c), N.push(Do[l]), N.push(Fo[l])) : 24 === l ? (E = 1 - Vo(s, h, p), x = Vo(s, f, p), m = Vo(e, f, p), _ = Vo(e, c, h), N.push(Do[l]), N.push(Go[l])) : 146 === l ? (E = Vo(e, p, h), x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), _ = 1 - Vo(s, h, c), N.push(Do[l]), N.push(Go[l])) : 6 === l ? (b = 1 - Vo(e, h, p), x = 1 - Vo(s, p, f), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), N.push(Fo[l]), N.push(ko[l])) : 164 === l ? (b = Vo(s, p, h), x = Vo(e, f, p), I = Vo(e, f, c), w = Vo(s, f, c), N.push(Fo[l]), N.push(ko[l])) : 129 === l ? (m = 1 - Vo(e, p, f), I = Vo(s, f, c), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c), N.push(Go[l]), N.push(qo[l])) : 41 === l ? (m = Vo(s, f, p), I = 1 - Vo(e, c, f), v = Vo(e, c, h), _ = Vo(s, c, h), N.push(Go[l]), N.push(qo[l])) : 66 === l ? (x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), w = 1 - Vo(s, c, f), v = 1 - Vo(e, h, c), N.push(ko[l]), N.push(Go[l])) : 104 === l ? (x = Vo(s, f, p), m = Vo(e, f, p), w = Vo(e, f, c), v = Vo(s, c, h), N.push(Go[l]), N.push(zo[l])) : 144 === l ? (E = Vo(e, p, h), I = Vo(e, f, c), w = Vo(s, f, c), _ = 1 - Vo(s, h, c), N.push(Do[l]), N.push(Bo[l])) : 26 === l ? (E = 1 - Vo(s, h, p), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), _ = Vo(e, c, h), N.push(Do[l]), N.push(Bo[l])) : 36 === l ? (b = Vo(s, p, h), x = Vo(e, f, p), v = Vo(e, c, h), _ = Vo(s, c, h), N.push(Fo[l]), N.push(ko[l])) : 134 === l ? (b = 1 - Vo(e, h, p), x = 1 - Vo(s, p, f), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c), N.push(Fo[l]), N.push(ko[l])) : 9 === l ? (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), m = Vo(s, f, p), I = 1 - Vo(e, c, f), N.push(Do[l]), N.push(Fo[l])) : 161 === l ? (E = Vo(s, p, h), b = Vo(e, p, h), m = 1 - Vo(e, p, f), I = Vo(s, f, c), N.push(Do[l]), N.push(Fo[l])) : 37 === l ? (b = Vo(s, p, h), I = 1 - Vo(e, c, f), v = Vo(e, c, h), _ = Vo(s, c, h), N.push(Fo[l]), N.push(qo[l])) : 133 === l ? (b = 1 - Vo(e, h, p), I = Vo(s, f, c), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c), N.push(Fo[l]), N.push(qo[l])) : 148 === l ? (x = Vo(e, f, p), I = Vo(e, f, c), w = Vo(s, f, c), _ = 1 - Vo(s, h, c), N.push(ko[l]), N.push(Bo[l])) : 22 === l ? (x = 1 - Vo(s, p, f), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), _ = Vo(e, c, h), N.push(ko[l]), N.push(Bo[l])) : 82 === l ? (E = Vo(e, p, h), x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), w = 1 - Vo(s, c, f), N.push(Do[l]), N.push(Go[l])) : 88 === l ? (E = 1 - Vo(s, h, p), x = Vo(s, f, p), m = Vo(e, f, p), w = Vo(e, f, c), N.push(Do[l]), N.push(Go[l])) : 73 === l ? (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), m = Vo(s, f, p), v = 1 - Vo(e, h, c), N.push(Do[l]), N.push(Fo[l])) : 97 === l ? (E = Vo(s, p, h), b = Vo(e, p, h), m = 1 - Vo(e, p, f), v = Vo(s, c, h), N.push(Do[l]), N.push(Fo[l])) : 145 === l ? (E = Vo(e, p, h), m = 1 - Vo(e, p, f), I = Vo(s, f, c), _ = 1 - Vo(s, h, c), N.push(Do[l]), N.push(qo[l])) : 25 === l ? (E = 1 - Vo(s, h, p), m = Vo(s, f, p), I = 1 - Vo(e, c, f), _ = Vo(e, c, h), N.push(Do[l]), N.push(qo[l])) : 70 === l ? (b = 1 - Vo(e, h, p), x = 1 - Vo(s, p, f), w = 1 - Vo(s, c, f), v = 1 - Vo(e, h, c), N.push(Fo[l]), N.push(ko[l])) : 100 === l ? (b = Vo(s, p, h), x = Vo(e, f, p), w = Vo(e, f, c), v = Vo(s, c, h), N.push(Fo[l]), N.push(ko[l])) : 34 === l ? (0 === d ? (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), x = Vo(s, f, p), m = Vo(e, f, p), I = Vo(e, f, c), w = Vo(s, f, c), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c)) : (E = Vo(s, p, h), b = Vo(e, p, h), x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), v = Vo(e, c, h), _ = Vo(s, c, h)), N.push(Do[l]), N.push(Fo[l]), N.push(qo[l]), N.push(Bo[l])) : 35 === l ? (4 === d ? (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), x = Vo(s, f, p), m = Vo(e, f, p), I = Vo(e, f, c), w = Vo(s, f, c), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c)) : (E = Vo(s, p, h), b = Vo(e, p, h), x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), v = Vo(e, c, h), _ = Vo(s, c, h)), N.push(Do[l]), N.push(Fo[l]), N.push(Go[l]), N.push(Bo[l])) : 136 === l ? (0 === d ? (E = Vo(s, p, h), b = Vo(e, p, h), x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), v = Vo(e, c, h), _ = Vo(s, c, h)) : (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), x = Vo(s, f, p), m = Vo(e, f, p), I = Vo(e, f, c), w = Vo(s, f, c), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c)), N.push(Do[l]), N.push(Fo[l]), N.push(qo[l]), N.push(Bo[l])) : 153 === l ? (0 === d ? (E = Vo(e, p, h), m = 1 - Vo(e, p, f), I = 1 - Vo(e, c, f), _ = Vo(e, c, h)) : (E = 1 - Vo(s, h, p), m = Vo(s, f, p), I = Vo(s, f, c), _ = 1 - Vo(s, h, c)), N.push(Do[l]), N.push(Go[l])) : 102 === l ? (0 === d ? (b = 1 - Vo(e, h, p), x = Vo(e, f, p), w = Vo(e, f, c), v = 1 - Vo(e, h, c)) : (b = Vo(s, p, h), x = 1 - Vo(s, p, f), w = 1 - Vo(s, c, f), v = Vo(s, c, h)), N.push(Fo[l]), N.push(Bo[l])) : 155 === l ? (4 === d ? (E = Vo(e, p, h), m = 1 - Vo(e, p, f), I = 1 - Vo(e, c, f), _ = Vo(e, c, h)) : (E = 1 - Vo(s, h, p), m = Vo(s, f, p), I = Vo(s, f, c), _ = 1 - Vo(s, h, c)), N.push(Do[l]), N.push(qo[l])) : 103 === l ? (4 === d ? (b = 1 - Vo(e, h, p), x = Vo(e, f, p), w = Vo(e, f, c), v = 1 - Vo(e, h, c)) : (b = Vo(s, p, h), x = 1 - Vo(s, p, f), w = 1 - Vo(s, c, f), v = Vo(s, c, h)), N.push(Fo[l]), N.push(ko[l])) : 152 === l ? (0 === d ? (E = Vo(e, p, h), x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), _ = Vo(e, c, h)) : (E = 1 - Vo(s, h, p), x = Vo(s, f, p), m = Vo(e, f, p), I = Vo(e, f, c), w = Vo(s, f, c), _ = 1 - Vo(s, h, c)), N.push(Do[l]), N.push(ko[l]), N.push(Go[l])) : 156 === l ? (4 === d ? (E = Vo(e, p, h), x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), _ = Vo(e, c, h)) : (E = 1 - Vo(s, h, p), x = Vo(s, f, p), m = Vo(e, f, p), I = Vo(e, f, c), w = Vo(s, f, c), _ = 1 - Vo(s, h, c)), N.push(Do[l]), N.push(Go[l]), N.push(Bo[l])) : 137 === l ? (0 === d ? (E = Vo(s, p, h), b = Vo(e, p, h), m = 1 - Vo(e, p, f), I = 1 - Vo(e, c, f), v = Vo(e, c, h), _ = Vo(s, c, h)) : (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), m = Vo(s, f, p), I = Vo(s, f, c), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c)), N.push(Do[l]), N.push(Fo[l]), N.push(Go[l])) : 139 === l ? (4 === d ? (E = Vo(s, p, h), b = Vo(e, p, h), m = 1 - Vo(e, p, f), I = 1 - Vo(e, c, f), v = Vo(e, c, h), _ = Vo(s, c, h)) : (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), m = Vo(s, f, p), I = Vo(s, f, c), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c)), N.push(Do[l]), N.push(Fo[l]), N.push(qo[l])) : 98 === l ? (0 === d ? (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), x = Vo(s, f, p), m = Vo(e, f, p), w = Vo(e, f, c), v = 1 - Vo(e, h, c)) : (E = Vo(s, p, h), b = Vo(e, p, h), x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), w = 1 - Vo(s, c, f), v = Vo(s, c, h)), N.push(Do[l]), N.push(Fo[l]), N.push(Bo[l])) : 99 === l ? (4 === d ? (E = 1 - Vo(e, h, p), b = 1 - Vo(s, h, p), x = Vo(s, f, p), m = Vo(e, f, p), w = Vo(e, f, c), v = 1 - Vo(e, h, c)) : (E = Vo(s, p, h), b = Vo(e, p, h), x = 1 - Vo(e, p, f), m = 1 - Vo(s, p, f), w = 1 - Vo(s, c, f), v = Vo(s, c, h)), N.push(Do[l]), N.push(Fo[l]), N.push(Go[l])) : 38 === l ? (0 === d ? (b = 1 - Vo(e, h, p), x = Vo(e, f, p), I = Vo(e, f, c), w = Vo(s, f, c), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c)) : (b = Vo(s, p, h), x = 1 - Vo(s, p, f), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), v = Vo(e, c, h), _ = Vo(s, c, h)), N.push(Fo[l]), N.push(qo[l]), N.push(Bo[l])) : 39 === l ? (4 === d ? (b = 1 - Vo(e, h, p), x = Vo(e, f, p), I = Vo(e, f, c), w = Vo(s, f, c), v = 1 - Vo(s, h, c), _ = 1 - Vo(e, h, c)) : (b = Vo(s, p, h), x = 1 - Vo(s, p, f), I = 1 - Vo(s, c, f), w = 1 - Vo(e, c, f), v = Vo(e, c, h), _ = Vo(s, c, h)), N.push(Fo[l]), N.push(ko[l]), N.push(Bo[l])) : 85 === l && (E = 1, b = 0, x = 1, m = 0, I = 0, w = 1, v = 0, _ = 1), (v < 0 || v > 1 || _ < 0 || _ > 1 || E < 0 || E > 1 || x < 0 || x > 1 || I < 0 || I > 1 || w < 0 || w > 1) && console.log("MarchingSquaresJS-isoBands: " + l + " " + g + " " + c + "," + h + "," + p + "," + f + " " + d + " " + v + " " + _ + " " + E + " " + b + " " + x + " " + m + " " + I + " " + w), o.cells[a][u] = {
                                cval: l,
                                cval_real: g,
                                flipped: d,
                                topleft: v,
                                topright: _,
                                righttop: E,
                                rightbottom: b,
                                bottomright: x,
                                bottomleft: m,
                                leftbottom: I,
                                lefttop: w,
                                edges: N
                            };
                        }
                    }
                }
            }
            return o;
        }(t, e, n);
        return Qi.polygons ? (Qi.verbose && console.log("MarchingSquaresJS-isoBands: returning single polygons for each grid cell"), u = function(t) {
            var e = [], n = 0;
            return t.cells.forEach(function(t, r) {
                t.forEach(function(t, i) {
                    if (void 0 !== t) {
                        var o = Uo[t.cval](t);
                        "object" == typeof o && Xo(o) ? "object" == typeof o[0] && Xo(o[0]) ? "object" == typeof o[0][0] && Xo(o[0][0]) ? o.forEach(function(t) {
                            t.forEach(function(t) {
                                t[0] += i, t[1] += r;
                            }), e[n++] = t;
                        }) : (o.forEach(function(t) {
                            t[0] += i, t[1] += r;
                        }), e[n++] = o) : console.log("MarchingSquaresJS-isoBands: bandcell polygon with malformed coordinates") : console.log("MarchingSquaresJS-isoBands: bandcell polygon with null coordinates");
                    }
                });
            }), e;
        }(l)) : (Qi.verbose && console.log("MarchingSquaresJS-isoBands: returning polygon paths for entire data grid"), u = function(t) {
            for(var e = [], n = t.rows, r = t.cols, i = [], o = 0; o < n; o++)for(var s = 0; s < r; s++)if (void 0 !== t.cells[o][s] && t.cells[o][s].edges.length > 0) {
                var a = Ho(t.cells[o][s]), u = null, l = s, c = o;
                null !== a && i.push([
                    a.p[0] + l,
                    a.p[1] + c
                ]);
                do {
                    if (null === (u = Wo(t.cells[c][l], a.x, a.y, a.o))) break;
                    if (i.push([
                        u.p[0] + l,
                        u.p[1] + c
                    ]), l += u.x, a = u, (c += u.y) < 0 || c >= n || l < 0 || l >= r || void 0 === t.cells[c][l]) {
                        var h = Yo(t, l -= u.x, c -= u.y, u.x, u.y, u.o);
                        if (null === h) break;
                        h.path.forEach(function(t) {
                            i.push(t);
                        }), l = h.i, c = h.j, a = h;
                    }
                }while (void 0 !== t.cells[c][l] && t.cells[c][l].edges.length > 0);
                e.push(i), i = [], t.cells[o][s].edges.length > 0 && s--;
            }
            return e;
        }(l)), "function" == typeof Qi.successCallback && Qi.successCallback(u), u;
    }
    var to = 64, eo = 16, no = [], ro = [], io = [], oo = [], so = [], ao = [], uo = [], lo = [], co = [], ho = [], po = [], fo = [], go = [], yo = [], vo = [], _o = [], mo = [], xo = [], Eo = [], bo = [], wo = [], Io = [], No = [], So = [];
    uo[85] = ho[85] = -1, lo[85] = po[85] = 0, co[85] = fo[85] = 1, Eo[85] = Io[85] = 1, bo[85] = No[85] = 0, wo[85] = So[85] = 1, no[85] = oo[85] = 0, ro[85] = so[85] = -1, io[85] = vo[85] = 0, _o[85] = go[85] = 0, mo[85] = yo[85] = 1, ao[85] = xo[85] = 1, Io[1] = Io[169] = 0, No[1] = No[169] = -1, So[1] = So[169] = 0, go[1] = go[169] = -1, yo[1] = yo[169] = 0, vo[1] = vo[169] = 0, ho[4] = ho[166] = 0, po[4] = po[166] = -1, fo[4] = fo[166] = 1, _o[4] = _o[166] = 1, mo[4] = mo[166] = 0, xo[4] = xo[166] = 0, uo[16] = uo[154] = 0, lo[16] = lo[154] = 1, co[16] = co[154] = 1, oo[16] = oo[154] = 1, so[16] = so[154] = 0, ao[16] = ao[154] = 1, Eo[64] = Eo[106] = 0, bo[64] = bo[106] = 1, wo[64] = wo[106] = 0, no[64] = no[106] = -1, ro[64] = ro[106] = 0, io[64] = io[106] = 1, Eo[2] = Eo[168] = 0, bo[2] = bo[168] = -1, wo[2] = wo[168] = 1, Io[2] = Io[168] = 0, No[2] = No[168] = -1, So[2] = So[168] = 0, go[2] = go[168] = -1, yo[2] = yo[168] = 0, vo[2] = vo[168] = 0, _o[2] = _o[168] = -1, mo[2] = mo[168] = 0, xo[2] = xo[168] = 1, uo[8] = uo[162] = 0, lo[8] = lo[162] = -1, co[8] = co[162] = 0, ho[8] = ho[162] = 0, po[8] = po[162] = -1, fo[8] = fo[162] = 1, go[8] = go[162] = 1, yo[8] = yo[162] = 0, vo[8] = vo[162] = 1, _o[8] = _o[162] = 1, mo[8] = mo[162] = 0, xo[8] = xo[162] = 0, uo[32] = uo[138] = 0, lo[32] = lo[138] = 1, co[32] = co[138] = 1, ho[32] = ho[138] = 0, po[32] = po[138] = 1, fo[32] = fo[138] = 0, no[32] = no[138] = 1, ro[32] = ro[138] = 0, io[32] = io[138] = 0, oo[32] = oo[138] = 1, so[32] = so[138] = 0, ao[32] = ao[138] = 1, Io[128] = Io[42] = 0, No[128] = No[42] = 1, So[128] = So[42] = 1, Eo[128] = Eo[42] = 0, bo[128] = bo[42] = 1, wo[128] = wo[42] = 0, no[128] = no[42] = -1, ro[128] = ro[42] = 0, io[128] = io[42] = 1, oo[128] = oo[42] = -1, so[128] = so[42] = 0, ao[128] = ao[42] = 0, ho[5] = ho[165] = -1, po[5] = po[165] = 0, fo[5] = fo[165] = 0, Io[5] = Io[165] = 1, No[5] = No[165] = 0, So[5] = So[165] = 0, _o[20] = _o[150] = 0, mo[20] = mo[150] = 1, xo[20] = xo[150] = 1, oo[20] = oo[150] = 0, so[20] = so[150] = -1, ao[20] = ao[150] = 1, uo[80] = uo[90] = -1, lo[80] = lo[90] = 0, co[80] = co[90] = 1, Eo[80] = Eo[90] = 1, bo[80] = bo[90] = 0, wo[80] = wo[90] = 1, go[65] = go[105] = 0, yo[65] = yo[105] = 1, vo[65] = vo[105] = 0, no[65] = no[105] = 0, ro[65] = ro[105] = -1, io[65] = io[105] = 0, uo[160] = uo[10] = -1, lo[160] = lo[10] = 0, co[160] = co[10] = 1, ho[160] = ho[10] = -1, po[160] = po[10] = 0, fo[160] = fo[10] = 0, Io[160] = Io[10] = 1, No[160] = No[10] = 0, So[160] = So[10] = 0, Eo[160] = Eo[10] = 1, bo[160] = bo[10] = 0, wo[160] = wo[10] = 1, _o[130] = _o[40] = 0, mo[130] = mo[40] = 1, xo[130] = xo[40] = 1, go[130] = go[40] = 0, yo[130] = yo[40] = 1, vo[130] = vo[40] = 0, no[130] = no[40] = 0, ro[130] = ro[40] = -1, io[130] = io[40] = 0, oo[130] = oo[40] = 0, so[130] = so[40] = -1, ao[130] = ao[40] = 1, ho[37] = ho[133] = 0, po[37] = po[133] = 1, fo[37] = fo[133] = 1, Io[37] = Io[133] = 0, No[37] = No[133] = 1, So[37] = So[133] = 0, no[37] = no[133] = -1, ro[37] = ro[133] = 0, io[37] = io[133] = 0, oo[37] = oo[133] = 1, so[37] = so[133] = 0, ao[37] = ao[133] = 0, _o[148] = _o[22] = -1, mo[148] = mo[22] = 0, xo[148] = xo[22] = 0, Io[148] = Io[22] = 0, No[148] = No[22] = -1, So[148] = So[22] = 1, Eo[148] = Eo[22] = 0, bo[148] = bo[22] = 1, wo[148] = wo[22] = 1, oo[148] = oo[22] = -1, so[148] = so[22] = 0, ao[148] = ao[22] = 1, uo[82] = uo[88] = 0, lo[82] = lo[88] = -1, co[82] = co[88] = 1, _o[82] = _o[88] = 1, mo[82] = mo[88] = 0, xo[82] = xo[88] = 1, go[82] = go[88] = -1, yo[82] = yo[88] = 0, vo[82] = vo[88] = 1, Eo[82] = Eo[88] = 0, bo[82] = bo[88] = -1, wo[82] = wo[88] = 0, uo[73] = uo[97] = 0, lo[73] = lo[97] = 1, co[73] = co[97] = 0, ho[73] = ho[97] = 0, po[73] = po[97] = -1, fo[73] = fo[97] = 0, go[73] = go[97] = 1, yo[73] = yo[97] = 0, vo[73] = vo[97] = 0, no[73] = no[97] = 1, ro[73] = ro[97] = 0, io[73] = io[97] = 1, uo[145] = uo[25] = 0, lo[145] = lo[25] = -1, co[145] = co[25] = 0, go[145] = go[25] = 1, yo[145] = yo[25] = 0, vo[145] = vo[25] = 1, Io[145] = Io[25] = 0, No[145] = No[25] = 1, So[145] = So[25] = 1, oo[145] = oo[25] = -1, so[145] = so[25] = 0, ao[145] = ao[25] = 0, ho[70] = ho[100] = 0, po[70] = po[100] = 1, fo[70] = fo[100] = 0, _o[70] = _o[100] = -1, mo[70] = mo[100] = 0, xo[70] = xo[100] = 1, Eo[70] = Eo[100] = 0, bo[70] = bo[100] = -1, wo[70] = wo[100] = 1, no[70] = no[100] = 1, ro[70] = ro[100] = 0, io[70] = io[100] = 0, ho[101] = ho[69] = 0, po[101] = po[69] = 1, fo[101] = fo[69] = 0, no[101] = no[69] = 1, ro[101] = ro[69] = 0, io[101] = io[69] = 0, Io[149] = Io[21] = 0, No[149] = No[21] = 1, So[149] = So[21] = 1, oo[149] = oo[21] = -1, so[149] = so[21] = 0, ao[149] = ao[21] = 0, _o[86] = _o[84] = -1, mo[86] = mo[84] = 0, xo[86] = xo[84] = 1, Eo[86] = Eo[84] = 0, bo[86] = bo[84] = -1, wo[86] = wo[84] = 1, uo[89] = uo[81] = 0, lo[89] = lo[81] = -1, co[89] = co[81] = 0, go[89] = go[81] = 1, yo[89] = yo[81] = 0, vo[89] = vo[81] = 1, uo[96] = uo[74] = 0, lo[96] = lo[74] = 1, co[96] = co[74] = 0, ho[96] = ho[74] = -1, po[96] = po[74] = 0, fo[96] = fo[74] = 1, Eo[96] = Eo[74] = 1, bo[96] = bo[74] = 0, wo[96] = wo[74] = 0, no[96] = no[74] = 1, ro[96] = ro[74] = 0, io[96] = io[74] = 1, uo[24] = uo[146] = 0, lo[24] = lo[146] = -1, co[24] = co[146] = 1, _o[24] = _o[146] = 1, mo[24] = mo[146] = 0, xo[24] = xo[146] = 1, go[24] = go[146] = 0, yo[24] = yo[146] = 1, vo[24] = vo[146] = 1, oo[24] = oo[146] = 0, so[24] = so[146] = -1, ao[24] = ao[146] = 0, ho[6] = ho[164] = -1, po[6] = po[164] = 0, fo[6] = fo[164] = 1, _o[6] = _o[164] = -1, mo[6] = mo[164] = 0, xo[6] = xo[164] = 0, Io[6] = Io[164] = 0, No[6] = No[164] = -1, So[6] = So[164] = 1, Eo[6] = Eo[164] = 1, bo[6] = bo[164] = 0, wo[6] = wo[164] = 0, go[129] = go[41] = 0, yo[129] = yo[41] = 1, vo[129] = vo[41] = 1, Io[129] = Io[41] = 0, No[129] = No[41] = 1, So[129] = So[41] = 0, no[129] = no[41] = -1, ro[129] = ro[41] = 0, io[129] = io[41] = 0, oo[129] = oo[41] = 0, so[129] = so[41] = -1, ao[129] = ao[41] = 0, _o[66] = _o[104] = 0, mo[66] = mo[104] = 1, xo[66] = xo[104] = 0, go[66] = go[104] = -1, yo[66] = yo[104] = 0, vo[66] = vo[104] = 1, Eo[66] = Eo[104] = 0, bo[66] = bo[104] = -1, wo[66] = wo[104] = 0, no[66] = no[104] = 0, ro[66] = ro[104] = -1, io[66] = io[104] = 1, uo[144] = uo[26] = -1, lo[144] = lo[26] = 0, co[144] = co[26] = 0, Io[144] = Io[26] = 1, No[144] = No[26] = 0, So[144] = So[26] = 1, Eo[144] = Eo[26] = 0, bo[144] = bo[26] = 1, wo[144] = wo[26] = 1, oo[144] = oo[26] = -1, so[144] = so[26] = 0, ao[144] = ao[26] = 1, ho[36] = ho[134] = 0, po[36] = po[134] = 1, fo[36] = fo[134] = 1, _o[36] = _o[134] = 0, mo[36] = mo[134] = 1, xo[36] = xo[134] = 0, no[36] = no[134] = 0, ro[36] = ro[134] = -1, io[36] = io[134] = 1, oo[36] = oo[134] = 1, so[36] = so[134] = 0, ao[36] = ao[134] = 0, uo[9] = uo[161] = -1, lo[9] = lo[161] = 0, co[9] = co[161] = 0, ho[9] = ho[161] = 0, po[9] = po[161] = -1, fo[9] = fo[161] = 0, go[9] = go[161] = 1, yo[9] = yo[161] = 0, vo[9] = vo[161] = 0, Io[9] = Io[161] = 1, No[9] = No[161] = 0, So[9] = So[161] = 1, uo[136] = 0, lo[136] = 1, co[136] = 1, ho[136] = 0, po[136] = 1, fo[136] = 0, _o[136] = -1, mo[136] = 0, xo[136] = 1, go[136] = -1, yo[136] = 0, vo[136] = 0, Io[136] = 0, No[136] = -1, So[136] = 0, Eo[136] = 0, bo[136] = -1, wo[136] = 1, no[136] = 1, ro[136] = 0, io[136] = 0, oo[136] = 1, so[136] = 0, ao[136] = 1, uo[34] = 0, lo[34] = -1, co[34] = 0, ho[34] = 0, po[34] = -1, fo[34] = 1, _o[34] = 1, mo[34] = 0, xo[34] = 0, go[34] = 1, yo[34] = 0, vo[34] = 1, Io[34] = 0, No[34] = 1, So[34] = 1, Eo[34] = 0, bo[34] = 1, wo[34] = 0, no[34] = -1, ro[34] = 0, io[34] = 1, oo[34] = -1, so[34] = 0, ao[34] = 0, uo[35] = 0, lo[35] = 1, co[35] = 1, ho[35] = 0, po[35] = -1, fo[35] = 1, _o[35] = 1, mo[35] = 0, xo[35] = 0, go[35] = -1, yo[35] = 0, vo[35] = 0, Io[35] = 0, No[35] = -1, So[35] = 0, Eo[35] = 0, bo[35] = 1, wo[35] = 0, no[35] = -1, ro[35] = 0, io[35] = 1, oo[35] = 1, so[35] = 0, ao[35] = 1, uo[153] = 0, lo[153] = 1, co[153] = 1, go[153] = -1, yo[153] = 0, vo[153] = 0, Io[153] = 0, No[153] = -1, So[153] = 0, oo[153] = 1, so[153] = 0, ao[153] = 1, ho[102] = 0, po[102] = -1, fo[102] = 1, _o[102] = 1, mo[102] = 0, xo[102] = 0, Eo[102] = 0, bo[102] = 1, wo[102] = 0, no[102] = -1, ro[102] = 0, io[102] = 1, uo[155] = 0, lo[155] = -1, co[155] = 0, go[155] = 1, yo[155] = 0, vo[155] = 1, Io[155] = 0, No[155] = 1, So[155] = 1, oo[155] = -1, so[155] = 0, ao[155] = 0, ho[103] = 0, po[103] = 1, fo[103] = 0, _o[103] = -1, mo[103] = 0, xo[103] = 1, Eo[103] = 0, bo[103] = -1, wo[103] = 1, no[103] = 1, ro[103] = 0, io[103] = 0, uo[152] = 0, lo[152] = 1, co[152] = 1, _o[152] = -1, mo[152] = 0, xo[152] = 1, go[152] = -1, yo[152] = 0, vo[152] = 0, Io[152] = 0, No[152] = -1, So[152] = 0, Eo[152] = 0, bo[152] = -1, wo[152] = 1, oo[152] = 1, so[152] = 0, ao[152] = 1, uo[156] = 0, lo[156] = -1, co[156] = 1, _o[156] = 1, mo[156] = 0, xo[156] = 1, go[156] = -1, yo[156] = 0, vo[156] = 0, Io[156] = 0, No[156] = -1, So[156] = 0, Eo[156] = 0, bo[156] = 1, wo[156] = 1, oo[156] = -1, so[156] = 0, ao[156] = 1, uo[137] = 0, lo[137] = 1, co[137] = 1, ho[137] = 0, po[137] = 1, fo[137] = 0, go[137] = -1, yo[137] = 0, vo[137] = 0, Io[137] = 0, No[137] = -1, So[137] = 0, no[137] = 1, ro[137] = 0, io[137] = 0, oo[137] = 1, so[137] = 0, ao[137] = 1, uo[139] = 0, lo[139] = 1, co[139] = 1, ho[139] = 0, po[139] = -1, fo[139] = 0, go[139] = 1, yo[139] = 0, vo[139] = 0, Io[139] = 0, No[139] = 1, So[139] = 0, no[139] = -1, ro[139] = 0, io[139] = 0, oo[139] = 1, so[139] = 0, ao[139] = 1, uo[98] = 0, lo[98] = -1, co[98] = 0, ho[98] = 0, po[98] = -1, fo[98] = 1, _o[98] = 1, mo[98] = 0, xo[98] = 0, go[98] = 1, yo[98] = 0, vo[98] = 1, Eo[98] = 0, bo[98] = 1, wo[98] = 0, no[98] = -1, ro[98] = 0, io[98] = 1, uo[99] = 0, lo[99] = 1, co[99] = 0, ho[99] = 0, po[99] = -1, fo[99] = 1, _o[99] = 1, mo[99] = 0, xo[99] = 0, go[99] = -1, yo[99] = 0, vo[99] = 1, Eo[99] = 0, bo[99] = -1, wo[99] = 0, no[99] = 1, ro[99] = 0, io[99] = 1, ho[38] = 0, po[38] = -1, fo[38] = 1, _o[38] = 1, mo[38] = 0, xo[38] = 0, Io[38] = 0, No[38] = 1, So[38] = 1, Eo[38] = 0, bo[38] = 1, wo[38] = 0, no[38] = -1, ro[38] = 0, io[38] = 1, oo[38] = -1, so[38] = 0, ao[38] = 0, ho[39] = 0, po[39] = 1, fo[39] = 1, _o[39] = -1, mo[39] = 0, xo[39] = 0, Io[39] = 0, No[39] = -1, So[39] = 1, Eo[39] = 0, bo[39] = 1, wo[39] = 0, no[39] = -1, ro[39] = 0, io[39] = 1, oo[39] = 1, so[39] = 0, ao[39] = 0;
    var Co = function(t) {
        return [
            [
                t.bottomleft,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                t.leftbottom
            ]
        ];
    }, Po = function(t) {
        return [
            [
                1,
                t.rightbottom
            ],
            [
                1,
                0
            ],
            [
                t.bottomright,
                0
            ]
        ];
    }, Mo = function(t) {
        return [
            [
                t.topright,
                1
            ],
            [
                1,
                1
            ],
            [
                1,
                t.righttop
            ]
        ];
    }, Lo = function(t) {
        return [
            [
                0,
                t.lefttop
            ],
            [
                0,
                1
            ],
            [
                t.topleft,
                1
            ]
        ];
    }, Oo = function(t) {
        return [
            [
                t.bottomright,
                0
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                0,
                t.lefttop
            ]
        ];
    }, Ro = function(t) {
        return [
            [
                t.bottomright,
                0
            ],
            [
                t.bottomleft,
                0
            ],
            [
                1,
                t.righttop
            ],
            [
                1,
                t.rightbottom
            ]
        ];
    }, To = function(t) {
        return [
            [
                1,
                t.righttop
            ],
            [
                1,
                t.rightbottom
            ],
            [
                t.topleft,
                1
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Ao = function(t) {
        return [
            [
                0,
                t.leftbottom
            ],
            [
                0,
                t.lefttop
            ],
            [
                t.topleft,
                1
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Do = [], Fo = [], ko = [], Go = [], qo = [], Bo = [], zo = [], jo = [];
    Go[1] = qo[1] = 18, Go[169] = qo[169] = 18, ko[4] = Fo[4] = 12, ko[166] = Fo[166] = 12, Do[16] = jo[16] = 4, Do[154] = jo[154] = 4, Bo[64] = zo[64] = 22, Bo[106] = zo[106] = 22, ko[2] = Bo[2] = 17, Go[2] = qo[2] = 18, ko[168] = Bo[168] = 17, Go[168] = qo[168] = 18, Do[8] = Go[8] = 9, Fo[8] = ko[8] = 12, Do[162] = Go[162] = 9, Fo[162] = ko[162] = 12, Do[32] = jo[32] = 4, Fo[32] = zo[32] = 1, Do[138] = jo[138] = 4, Fo[138] = zo[138] = 1, qo[128] = jo[128] = 21, Bo[128] = zo[128] = 22, qo[42] = jo[42] = 21, Bo[42] = zo[42] = 22, Fo[5] = qo[5] = 14, Fo[165] = qo[165] = 14, ko[20] = jo[20] = 6, ko[150] = jo[150] = 6, Do[80] = Bo[80] = 11, Do[90] = Bo[90] = 11, Go[65] = zo[65] = 3, Go[105] = zo[105] = 3, Do[160] = Bo[160] = 11, Fo[160] = qo[160] = 14, Do[10] = Bo[10] = 11, Fo[10] = qo[10] = 14, ko[130] = jo[130] = 6, Go[130] = zo[130] = 3, ko[40] = jo[40] = 6, Go[40] = zo[40] = 3, Fo[101] = zo[101] = 1, Fo[69] = zo[69] = 1, qo[149] = jo[149] = 21, qo[21] = jo[21] = 21, ko[86] = Bo[86] = 17, ko[84] = Bo[84] = 17, Do[89] = Go[89] = 9, Do[81] = Go[81] = 9, Do[96] = zo[96] = 0, Fo[96] = Bo[96] = 15, Do[74] = zo[74] = 0, Fo[74] = Bo[74] = 15, Do[24] = ko[24] = 8, Go[24] = jo[24] = 7, Do[146] = ko[146] = 8, Go[146] = jo[146] = 7, Fo[6] = Bo[6] = 15, ko[6] = qo[6] = 16, Fo[164] = Bo[164] = 15, ko[164] = qo[164] = 16, Go[129] = jo[129] = 7, qo[129] = zo[129] = 20, Go[41] = jo[41] = 7, qo[41] = zo[41] = 20, ko[66] = zo[66] = 2, Go[66] = Bo[66] = 19, ko[104] = zo[104] = 2, Go[104] = Bo[104] = 19, Do[144] = qo[144] = 10, Bo[144] = jo[144] = 23, Do[26] = qo[26] = 10, Bo[26] = jo[26] = 23, Fo[36] = jo[36] = 5, ko[36] = zo[36] = 2, Fo[134] = jo[134] = 5, ko[134] = zo[134] = 2, Do[9] = qo[9] = 10, Fo[9] = Go[9] = 13, Do[161] = qo[161] = 10, Fo[161] = Go[161] = 13, Fo[37] = jo[37] = 5, qo[37] = zo[37] = 20, Fo[133] = jo[133] = 5, qo[133] = zo[133] = 20, ko[148] = qo[148] = 16, Bo[148] = jo[148] = 23, ko[22] = qo[22] = 16, Bo[22] = jo[22] = 23, Do[82] = ko[82] = 8, Go[82] = Bo[82] = 19, Do[88] = ko[88] = 8, Go[88] = Bo[88] = 19, Do[73] = zo[73] = 0, Fo[73] = Go[73] = 13, Do[97] = zo[97] = 0, Fo[97] = Go[97] = 13, Do[145] = Go[145] = 9, qo[145] = jo[145] = 21, Do[25] = Go[25] = 9, qo[25] = jo[25] = 21, Fo[70] = zo[70] = 1, ko[70] = Bo[70] = 17, Fo[100] = zo[100] = 1, ko[100] = Bo[100] = 17, Do[34] = Go[34] = 9, Fo[34] = ko[34] = 12, qo[34] = jo[34] = 21, Bo[34] = zo[34] = 22, Do[136] = jo[136] = 4, Fo[136] = zo[136] = 1, ko[136] = Bo[136] = 17, Go[136] = qo[136] = 18, Do[35] = jo[35] = 4, Fo[35] = ko[35] = 12, Go[35] = qo[35] = 18, Bo[35] = zo[35] = 22, Do[153] = jo[153] = 4, Go[153] = qo[153] = 18, Fo[102] = ko[102] = 12, Bo[102] = zo[102] = 22, Do[155] = Go[155] = 9, qo[155] = jo[155] = 23, Fo[103] = zo[103] = 1, ko[103] = Bo[103] = 17, Do[152] = jo[152] = 4, ko[152] = Bo[152] = 17, Go[152] = qo[152] = 18, Do[156] = ko[156] = 8, Go[156] = qo[156] = 18, Bo[156] = jo[156] = 23, Do[137] = jo[137] = 4, Fo[137] = zo[137] = 1, Go[137] = qo[137] = 18, Do[139] = jo[139] = 4, Fo[139] = Go[139] = 13, qo[139] = zo[139] = 20, Do[98] = Go[98] = 9, Fo[98] = ko[98] = 12, Bo[98] = zo[98] = 22, Do[99] = zo[99] = 0, Fo[99] = ko[99] = 12, Go[99] = Bo[99] = 19, Fo[38] = ko[38] = 12, qo[38] = jo[38] = 21, Bo[38] = zo[38] = 22, Fo[39] = jo[39] = 5, ko[39] = qo[39] = 16, Bo[39] = zo[39] = 22;
    var Uo = [];
    function Vo(t, e, n) {
        return (t - e) / (n - e);
    }
    function Xo(t) {
        return t.constructor.toString().indexOf("Array") > -1;
    }
    function Yo(t, e, n, r, i, o) {
        for(var s = t.cells[n][e], a = s.cval_real, u = e + r, l = n + i, c = [], h = !1; !h;){
            if (void 0 === t.cells[l] || void 0 === t.cells[l][u]) {
                if (l -= i, u -= r, a = (s = t.cells[l][u]).cval_real, -1 === i) {
                    if (0 === o) {
                        if (1 & a) c.push([
                            u,
                            l
                        ]), r = -1, i = 0, o = 0;
                        else {
                            if (!(4 & a)) {
                                c.push([
                                    u + s.bottomright,
                                    l
                                ]), r = 0, i = 1, o = 1, h = !0;
                                break;
                            }
                            c.push([
                                u + 1,
                                l
                            ]), r = 1, i = 0, o = 0;
                        }
                    } else {
                        if (!(1 & a)) {
                            if (4 & a) {
                                c.push([
                                    u + s.bottomright,
                                    l
                                ]), r = 0, i = 1, o = 1, h = !0;
                                break;
                            }
                            c.push([
                                u + s.bottomleft,
                                l
                            ]), r = 0, i = 1, o = 0, h = !0;
                            break;
                        }
                        c.push([
                            u,
                            l
                        ]), r = -1, i = 0, o = 0;
                    }
                } else if (1 === i) {
                    if (0 === o) {
                        if (!(a & eo)) {
                            if (a & to) {
                                c.push([
                                    u + s.topleft,
                                    l + 1
                                ]), r = 0, i = -1, o = 0, h = !0;
                                break;
                            }
                            c.push([
                                u + s.topright,
                                l + 1
                            ]), r = 0, i = -1, o = 1, h = !0;
                            break;
                        }
                        c.push([
                            u + 1,
                            l + 1
                        ]), r = 1, i = 0, o = 1;
                    } else c.push([
                        u + 1,
                        l + 1
                    ]), r = 1, i = 0, o = 1;
                } else if (-1 === r) {
                    if (0 === o) {
                        if (!(a & to)) {
                            if (1 & a) {
                                c.push([
                                    u,
                                    l + s.leftbottom
                                ]), r = 1, i = 0, o = 0, h = !0;
                                break;
                            }
                            c.push([
                                u,
                                l + s.lefttop
                            ]), r = 1, i = 0, o = 1, h = !0;
                            break;
                        }
                        c.push([
                            u,
                            l + 1
                        ]), r = 0, i = 1, o = 0;
                    } else {
                        if (!(a & to)) {
                            console.log("MarchingSquaresJS-isoBands: wtf");
                            break;
                        }
                        c.push([
                            u,
                            l + 1
                        ]), r = 0, i = 1, o = 0;
                    }
                } else {
                    if (1 !== r) {
                        console.log("MarchingSquaresJS-isoBands: we came from nowhere!");
                        break;
                    }
                    if (0 === o) {
                        if (!(4 & a)) {
                            c.push([
                                u + 1,
                                l + s.rightbottom
                            ]), r = -1, i = 0, o = 0, h = !0;
                            break;
                        }
                        c.push([
                            u + 1,
                            l
                        ]), r = 0, i = -1, o = 1;
                    } else {
                        if (!(4 & a)) {
                            if (a & eo) {
                                c.push([
                                    u + 1,
                                    l + s.righttop
                                ]), r = -1, i = 0, o = 1;
                                break;
                            }
                            c.push([
                                u + 1,
                                l + s.rightbottom
                            ]), r = -1, i = 0, o = 0, h = !0;
                            break;
                        }
                        c.push([
                            u + 1,
                            l
                        ]), r = 0, i = -1, o = 1;
                    }
                }
            } else if (a = (s = t.cells[l][u]).cval_real, -1 === r) {
                if (0 === o) {
                    if (void 0 !== t.cells[l - 1] && void 0 !== t.cells[l - 1][u]) r = 0, i = -1, o = 1;
                    else {
                        if (!(1 & a)) {
                            c.push([
                                u + s.bottomright,
                                l
                            ]), r = 0, i = 1, o = 1, h = !0;
                            break;
                        }
                        c.push([
                            u,
                            l
                        ]);
                    }
                } else {
                    if (!(a & to)) {
                        console.log("MarchingSquaresJS-isoBands: found entry from top at " + u + "," + l);
                        break;
                    }
                    console.log("MarchingSquaresJS-isoBands: proceeding in x-direction!");
                }
            } else if (1 === r) {
                if (0 === o) {
                    console.log("MarchingSquaresJS-isoBands: wtf");
                    break;
                }
                if (void 0 !== t.cells[l + 1] && void 0 !== t.cells[l + 1][u]) r = 0, i = 1, o = 0;
                else {
                    if (!(a & eo)) {
                        c.push([
                            u + s.topleft,
                            l + 1
                        ]), r = 0, i = -1, o = 0, h = !0;
                        break;
                    }
                    c.push([
                        u + 1,
                        l + 1
                    ]), r = 1, i = 0, o = 1;
                }
            } else if (-1 === i) {
                if (1 !== o) {
                    console.log("MarchingSquaresJS-isoBands: wtf");
                    break;
                }
                if (void 0 !== t.cells[l][u + 1]) r = 1, i = 0, o = 1;
                else {
                    if (!(4 & a)) {
                        c.push([
                            u + 1,
                            l + s.righttop
                        ]), r = -1, i = 0, o = 1, h = !0;
                        break;
                    }
                    c.push([
                        u + 1,
                        l
                    ]), r = 0, i = -1, o = 1;
                }
            } else {
                if (1 !== i) {
                    console.log("MarchingSquaresJS-isoBands: where did we came from???");
                    break;
                }
                if (0 !== o) {
                    console.log("MarchingSquaresJS-isoBands: wtf");
                    break;
                }
                if (void 0 !== t.cells[l][u - 1]) r = -1, i = 0, o = 0;
                else {
                    if (!(a & to)) {
                        c.push([
                            u,
                            l + s.leftbottom
                        ]), r = 1, i = 0, o = 0, h = !0;
                        break;
                    }
                    c.push([
                        u,
                        l + 1
                    ]), r = 0, i = 1, o = 0;
                }
            }
            if (l += i, (u += r) === e && l === n) break;
        }
        return {
            path: c,
            i: u,
            j: l,
            x: r,
            y: i,
            o: o
        };
    }
    function Ho(t) {
        if (t.edges.length > 0) {
            var e = t.edges[t.edges.length - 1], n = t.cval_real;
            switch(e){
                case 0:
                    return n & eo ? {
                        p: [
                            1,
                            t.righttop
                        ],
                        x: -1,
                        y: 0,
                        o: 1
                    } : {
                        p: [
                            t.topleft,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 0
                    };
                case 1:
                    return 4 & n ? {
                        p: [
                            t.topleft,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 0
                    } : {
                        p: [
                            1,
                            t.rightbottom
                        ],
                        x: -1,
                        y: 0,
                        o: 0
                    };
                case 2:
                    return 4 & n ? {
                        p: [
                            t.bottomright,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 1
                    } : {
                        p: [
                            t.topleft,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 0
                    };
                case 3:
                    return 1 & n ? {
                        p: [
                            t.topleft,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 0
                    } : {
                        p: [
                            t.bottomleft,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 0
                    };
                case 4:
                    return n & eo ? {
                        p: [
                            1,
                            t.righttop
                        ],
                        x: -1,
                        y: 0,
                        o: 1
                    } : {
                        p: [
                            t.topright,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 1
                    };
                case 5:
                    return 4 & n ? {
                        p: [
                            t.topright,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 1
                    } : {
                        p: [
                            1,
                            t.rightbottom
                        ],
                        x: -1,
                        y: 0,
                        o: 0
                    };
                case 6:
                    return 4 & n ? {
                        p: [
                            t.bottomright,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 1
                    } : {
                        p: [
                            t.topright,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 1
                    };
                case 7:
                    return 1 & n ? {
                        p: [
                            t.topright,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 1
                    } : {
                        p: [
                            t.bottomleft,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 0
                    };
                case 8:
                    return 4 & n ? {
                        p: [
                            t.bottomright,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 1
                    } : {
                        p: [
                            1,
                            t.righttop
                        ],
                        x: -1,
                        y: 0,
                        o: 1
                    };
                case 9:
                    return 1 & n ? {
                        p: [
                            1,
                            t.righttop
                        ],
                        x: -1,
                        y: 0,
                        o: 1
                    } : {
                        p: [
                            t.bottomleft,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 0
                    };
                case 10:
                    return 1 & n ? {
                        p: [
                            0,
                            t.leftbottom
                        ],
                        x: 1,
                        y: 0,
                        o: 0
                    } : {
                        p: [
                            1,
                            t.righttop
                        ],
                        x: -1,
                        y: 0,
                        o: 1
                    };
                case 11:
                    return n & to ? {
                        p: [
                            1,
                            t.righttop
                        ],
                        x: -1,
                        y: 0,
                        o: 1
                    } : {
                        p: [
                            0,
                            t.lefttop
                        ],
                        x: 1,
                        y: 0,
                        o: 1
                    };
                case 12:
                    return 4 & n ? {
                        p: [
                            t.bottomright,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 1
                    } : {
                        p: [
                            1,
                            t.rightbottom
                        ],
                        x: -1,
                        y: 0,
                        o: 0
                    };
                case 13:
                    return 1 & n ? {
                        p: [
                            1,
                            t.rightbottom
                        ],
                        x: -1,
                        y: 0,
                        o: 0
                    } : {
                        p: [
                            t.bottomleft,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 0
                    };
                case 14:
                    return 1 & n ? {
                        p: [
                            0,
                            t.leftbottom
                        ],
                        x: 1,
                        y: 0,
                        o: 0
                    } : {
                        p: [
                            1,
                            t.rightbottom
                        ],
                        x: -1,
                        y: 0,
                        o: 0
                    };
                case 15:
                    return n & to ? {
                        p: [
                            1,
                            t.rightbottom
                        ],
                        x: -1,
                        y: 0,
                        o: 0
                    } : {
                        p: [
                            0,
                            t.lefttop
                        ],
                        x: 1,
                        y: 0,
                        o: 1
                    };
                case 16:
                    return 4 & n ? {
                        p: [
                            t.bottomright,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 1
                    } : {
                        p: [
                            0,
                            t.leftbottom
                        ],
                        x: 1,
                        y: 0,
                        o: 0
                    };
                case 17:
                    return n & to ? {
                        p: [
                            t.bottomright,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 1
                    } : {
                        p: [
                            0,
                            t.lefttop
                        ],
                        x: 1,
                        y: 0,
                        o: 1
                    };
                case 18:
                    return 1 & n ? {
                        p: [
                            0,
                            t.leftbottom
                        ],
                        x: 1,
                        y: 0,
                        o: 0
                    } : {
                        p: [
                            t.bottomleft,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 0
                    };
                case 19:
                    return n & to ? {
                        p: [
                            t.bottomleft,
                            0
                        ],
                        x: 0,
                        y: 1,
                        o: 0
                    } : {
                        p: [
                            0,
                            t.lefttop
                        ],
                        x: 1,
                        y: 0,
                        o: 1
                    };
                case 20:
                    return n & to ? {
                        p: [
                            t.topleft,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 0
                    } : {
                        p: [
                            0,
                            t.leftbottom
                        ],
                        x: 1,
                        y: 0,
                        o: 0
                    };
                case 21:
                    return n & eo ? {
                        p: [
                            0,
                            t.leftbottom
                        ],
                        x: 1,
                        y: 0,
                        o: 0
                    } : {
                        p: [
                            t.topright,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 1
                    };
                case 22:
                    return n & to ? {
                        p: [
                            t.topleft,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 0
                    } : {
                        p: [
                            0,
                            t.lefttop
                        ],
                        x: 1,
                        y: 0,
                        o: 1
                    };
                case 23:
                    return n & eo ? {
                        p: [
                            0,
                            t.lefttop
                        ],
                        x: 1,
                        y: 0,
                        o: 1
                    } : {
                        p: [
                            t.topright,
                            1
                        ],
                        x: 0,
                        y: -1,
                        o: 1
                    };
                default:
                    console.log("MarchingSquaresJS-isoBands: edge index out of range!"), console.log(t);
            }
        }
        return null;
    }
    function Wo(t, e, n, r) {
        var i, o, s, a, u, l = t.cval;
        switch(e){
            case -1:
                switch(r){
                    case 0:
                        i = Fo[l], s = ho[l], a = po[l], u = fo[l];
                        break;
                    default:
                        i = Do[l], s = uo[l], a = lo[l], u = co[l];
                }
                break;
            case 1:
                switch(r){
                    case 0:
                        i = qo[l], s = Io[l], a = No[l], u = So[l];
                        break;
                    default:
                        i = Bo[l], s = Eo[l], a = bo[l], u = wo[l];
                }
                break;
            default:
                switch(n){
                    case -1:
                        switch(r){
                            case 0:
                                i = zo[l], s = no[l], a = ro[l], u = io[l];
                                break;
                            default:
                                i = jo[l], s = oo[l], a = so[l], u = ao[l];
                        }
                        break;
                    case 1:
                        switch(r){
                            case 0:
                                i = Go[l], s = go[l], a = yo[l], u = vo[l];
                                break;
                            default:
                                i = ko[l], s = _o[l], a = mo[l], u = xo[l];
                        }
                }
        }
        if (o = t.edges.indexOf(i), void 0 === t.edges[o]) return null;
        switch(function(t, e) {
            delete t.edges[e];
            for(var n = e + 1; n < t.edges.length; n++)t.edges[n - 1] = t.edges[n];
            t.edges.pop();
        }(t, o), l = t.cval_real, i){
            case 0:
                l & eo ? (e = t.topleft, n = 1) : (e = 1, n = t.righttop);
                break;
            case 1:
                4 & l ? (e = 1, n = t.rightbottom) : (e = t.topleft, n = 1);
                break;
            case 2:
                4 & l ? (e = t.topleft, n = 1) : (e = t.bottomright, n = 0);
                break;
            case 3:
                1 & l ? (e = t.bottomleft, n = 0) : (e = t.topleft, n = 1);
                break;
            case 4:
                l & eo ? (e = t.topright, n = 1) : (e = 1, n = t.righttop);
                break;
            case 5:
                4 & l ? (e = 1, n = t.rightbottom) : (e = t.topright, n = 1);
                break;
            case 6:
                4 & l ? (e = t.topright, n = 1) : (e = t.bottomright, n = 0);
                break;
            case 7:
                1 & l ? (e = t.bottomleft, n = 0) : (e = t.topright, n = 1);
                break;
            case 8:
                4 & l ? (e = 1, n = t.righttop) : (e = t.bottomright, n = 0);
                break;
            case 9:
                1 & l ? (e = t.bottomleft, n = 0) : (e = 1, n = t.righttop);
                break;
            case 10:
                1 & l ? (e = 1, n = t.righttop) : (e = 0, n = t.leftbottom);
                break;
            case 11:
                l & to ? (e = 0, n = t.lefttop) : (e = 1, n = t.righttop);
                break;
            case 12:
                4 & l ? (e = 1, n = t.rightbottom) : (e = t.bottomright, n = 0);
                break;
            case 13:
                1 & l ? (e = t.bottomleft, n = 0) : (e = 1, n = t.rightbottom);
                break;
            case 14:
                1 & l ? (e = 1, n = t.rightbottom) : (e = 0, n = t.leftbottom);
                break;
            case 15:
                l & to ? (e = 0, n = t.lefttop) : (e = 1, n = t.rightbottom);
                break;
            case 16:
                4 & l ? (e = 0, n = t.leftbottom) : (e = t.bottomright, n = 0);
                break;
            case 17:
                l & to ? (e = 0, n = t.lefttop) : (e = t.bottomright, n = 0);
                break;
            case 18:
                1 & l ? (e = t.bottomleft, n = 0) : (e = 0, n = t.leftbottom);
                break;
            case 19:
                l & to ? (e = 0, n = t.lefttop) : (e = t.bottomleft, n = 0);
                break;
            case 20:
                l & to ? (e = 0, n = t.leftbottom) : (e = t.topleft, n = 1);
                break;
            case 21:
                l & eo ? (e = t.topright, n = 1) : (e = 0, n = t.leftbottom);
                break;
            case 22:
                l & to ? (e = 0, n = t.lefttop) : (e = t.topleft, n = 1);
                break;
            case 23:
                l & eo ? (e = t.topright, n = 1) : (e = 0, n = t.lefttop);
                break;
            default:
                return console.log("MarchingSquaresJS-isoBands: edge index out of range!"), console.log(t), null;
        }
        return void 0 !== e && void 0 !== n && void 0 !== s && void 0 !== a && void 0 !== u || (console.log("MarchingSquaresJS-isoBands: undefined value!"), console.log(t), console.log(e + " " + n + " " + s + " " + a + " " + u)), {
            p: [
                e,
                n
            ],
            x: s,
            y: a,
            o: u
        };
    }
    function Jo(t) {
        var e = [], n = [];
        t.forEach(function(t) {
            var r = jr(l([
                t
            ]));
            n.push(r), e.push({
                ring: t,
                area: r
            });
        }), n.sort(function(t, e) {
            return e - t;
        });
        var r = [];
        return n.forEach(function(t) {
            for(var n = 0; n < e.length; n++)if (e[n].area === t) {
                r.push(e[n].ring), e.splice(n, 1);
                break;
            }
        }), r;
    }
    function Zo(t) {
        for(var e = t.map(function(t) {
            return {
                lrCoordinates: t,
                grouped: !1
            };
        }), n = []; !Qo(e);)for(var r = 0; r < e.length; r++)if (!e[r].grouped) {
            var i = [];
            i.push(e[r].lrCoordinates), e[r].grouped = !0;
            for(var o = l([
                e[r].lrCoordinates
            ]), s = r + 1; s < e.length; s++)if (!e[s].grouped) Ko(l([
                e[s].lrCoordinates
            ]), o) && (i.push(e[s].lrCoordinates), e[s].grouped = !0);
            n.push(i);
        }
        return n;
    }
    function Ko(t, e) {
        for(var n = bn(t), r = 0; r < n.features.length; r++)if (!ye(n.features[r], e)) return !1;
        return !0;
    }
    function Qo(t) {
        for(var e = 0; e < t.length; e++)if (!1 === t[e].grouped) return !1;
        return !0;
    }
    function $o(t, e, n) {
        if (!P(n = n || {})) throw new Error("options is invalid");
        var r = n.pivot, i = n.mutate;
        if (!t) throw new Error("geojson is required");
        if (null == e || isNaN(e)) throw new Error("angle is required");
        return 0 === e || (r || (r = En(t)), !1 !== i && void 0 !== i || (t = Ie(t)), R(t, function(t) {
            var n = Bi(r, t) + e, i = Ar(r, t), o = Q(ji(r, i, n));
            t[0] = o[0], t[1] = o[1];
        })), t;
    }
    function ts(t, e, n) {
        if (!P(n = n || {})) throw new Error("options is invalid");
        var r = n.origin, i = n.mutate;
        if (!t) throw new Error("geojson required");
        if ("number" != typeof e || 0 === e) throw new Error("invalid factor");
        var o = Array.isArray(r) || "object" == typeof r;
        return !0 !== i && (t = Ie(t)), "FeatureCollection" !== t.type || o ? es(t, e, r) : (F(t, function(n, i) {
            t.features[i] = es(n, e, r);
        }), t);
    }
    function es(t, e, n) {
        var r = "Point" === it(t);
        return n = function(t, e) {
            null == e && (e = "centroid");
            if (Array.isArray(e) || "object" == typeof e) return K(e);
            var n = t.bbox ? t.bbox : Z(t), r = n[0], i = n[1], o = n[2], s = n[3];
            switch(e){
                case "sw":
                case "southwest":
                case "westsouth":
                case "bottomleft":
                    return a([
                        r,
                        i
                    ]);
                case "se":
                case "southeast":
                case "eastsouth":
                case "bottomright":
                    return a([
                        o,
                        i
                    ]);
                case "nw":
                case "northwest":
                case "westnorth":
                case "topleft":
                    return a([
                        r,
                        s
                    ]);
                case "ne":
                case "northeast":
                case "eastnorth":
                case "topright":
                    return a([
                        o,
                        s
                    ]);
                case "center":
                    return xn(t);
                case void 0:
                case null:
                case "centroid":
                    return En(t);
                default:
                    throw new Error("invalid origin");
            }
        }(t, n), 1 === e || r || R(t, function(t) {
            var r = Ar(n, t), i = Bi(n, t), o = Q(ji(n, r * e, i));
            t[0] = o[0], t[1] = o[1], 3 === t.length && (t[2] *= e);
        }), t;
    }
    function ns(t) {
        var e = t[0], n = t[1];
        return [
            n[0] - e[0],
            n[1] - e[1]
        ];
    }
    function rs(t, e) {
        return t[0] * e[1] - e[0] * t[1];
    }
    function is(t, e) {
        return !function(t, e) {
            return 0 === rs(ns(t), ns(e));
        }(t, e) && function(t, e) {
            var n, r, i = t[0], o = ns(t), s = e[0], a = ns(e), u = rs(o, a);
            return function(t, e) {
                return [
                    t[0] + e[0],
                    t[1] + e[1]
                ];
            }(i, function(t, e) {
                return [
                    t * e[0],
                    t * e[1]
                ];
            }(rs((r = i, [
                (n = s)[0] - r[0],
                n[1] - r[1]
            ]), a) / u, o));
        }(t, e);
    }
    function os(t, e, n) {
        var r = [], i = E(e, n), o = Q(t), s = [];
        return o.forEach(function(t, e) {
            if (e !== o.length - 1) {
                var n = (l = t, c = o[e + 1], h = i, p = Math.sqrt((l[0] - c[0]) * (l[0] - c[0]) + (l[1] - c[1]) * (l[1] - c[1])), f = l[0] + h * (c[1] - l[1]) / p, g = c[0] + h * (c[1] - l[1]) / p, d = l[1] + h * (l[0] - c[0]) / p, y = c[1] + h * (l[0] - c[0]) / p, [
                    [
                        f,
                        d
                    ],
                    [
                        g,
                        y
                    ]
                ]);
                if (r.push(n), e > 0) {
                    var a = r[e - 1], u = is(n, a);
                    !1 !== u && (a[1] = u, n[0] = u), s.push(a[0]), e === o.length - 2 && (s.push(n[0]), s.push(n[1]));
                }
                2 === o.length && (s.push(n[0]), s.push(n[1]));
            }
            var l, c, h, p, f, g, d, y;
        }), h(s, t.properties);
    }
    function ss(t, e, n) {
        var r = e[0] - t[0], i = e[1] - t[1], o = n[0] - e[0];
        return function(t) {
            return (t > 0) - (t < 0) || +t;
        }(r * (n[1] - e[1]) - o * i);
    }
    function as(t, e) {
        return e.geometry.coordinates[0].every(function(e) {
            return ye(a(e), t);
        });
    }
    Uo[1] = Uo[169] = Co, Uo[4] = Uo[166] = Po, Uo[16] = Uo[154] = Mo, Uo[64] = Uo[106] = Lo, Uo[168] = Uo[2] = Oo, Uo[162] = Uo[8] = Ro, Uo[138] = Uo[32] = To, Uo[42] = Uo[128] = Ao, Uo[5] = Uo[165] = function(t) {
        return [
            [
                0,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                1,
                t.rightbottom
            ],
            [
                1,
                0
            ]
        ];
    }, Uo[20] = Uo[150] = function(t) {
        return [
            [
                1,
                0
            ],
            [
                t.bottomright,
                0
            ],
            [
                t.topright,
                1
            ],
            [
                1,
                1
            ]
        ];
    }, Uo[80] = Uo[90] = function(t) {
        return [
            [
                1,
                1
            ],
            [
                1,
                t.righttop
            ],
            [
                0,
                t.lefttop
            ],
            [
                0,
                1
            ]
        ];
    }, Uo[65] = Uo[105] = function(t) {
        return [
            [
                t.bottomleft,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                1
            ],
            [
                t.topleft,
                1
            ]
        ];
    }, Uo[160] = Uo[10] = function(t) {
        return [
            [
                1,
                t.righttop
            ],
            [
                1,
                t.rightbottom
            ],
            [
                0,
                t.leftbottom
            ],
            [
                0,
                t.lefttop
            ]
        ];
    }, Uo[130] = Uo[40] = function(t) {
        return [
            [
                t.topleft,
                1
            ],
            [
                t.topright,
                1
            ],
            [
                t.bottomright,
                0
            ],
            [
                t.bottomleft,
                0
            ]
        ];
    }, Uo[85] = function() {
        return [
            [
                0,
                0
            ],
            [
                0,
                1
            ],
            [
                1,
                1
            ],
            [
                1,
                0
            ]
        ];
    }, Uo[101] = Uo[69] = function(t) {
        return [
            [
                1,
                t.rightbottom
            ],
            [
                1,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                1
            ],
            [
                t.topleft,
                1
            ]
        ];
    }, Uo[149] = Uo[21] = function(t) {
        return [
            [
                t.topright,
                1
            ],
            [
                1,
                1
            ],
            [
                1,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                t.leftbottom
            ]
        ];
    }, Uo[86] = Uo[84] = function(t) {
        return [
            [
                1,
                0
            ],
            [
                t.bottomright,
                0
            ],
            [
                0,
                t.lefttop
            ],
            [
                0,
                1
            ],
            [
                1,
                1
            ]
        ];
    }, Uo[89] = Uo[81] = function(t) {
        return [
            [
                1,
                1
            ],
            [
                1,
                t.righttop
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                1
            ]
        ];
    }, Uo[96] = Uo[74] = function(t) {
        return [
            [
                1,
                t.righttop
            ],
            [
                1,
                t.rightbottom
            ],
            [
                0,
                t.lefttop
            ],
            [
                0,
                1
            ],
            [
                t.topleft,
                1
            ]
        ];
    }, Uo[24] = Uo[146] = function(t) {
        return [
            [
                1,
                1
            ],
            [
                1,
                t.righttop
            ],
            [
                t.bottomright,
                0
            ],
            [
                t.bottomleft,
                0
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Uo[6] = Uo[164] = function(t) {
        return [
            [
                1,
                t.rightbottom
            ],
            [
                1,
                0
            ],
            [
                t.bottomright,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                0,
                t.lefttop
            ]
        ];
    }, Uo[129] = Uo[41] = function(t) {
        return [
            [
                t.topright,
                1
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                t.topleft,
                1
            ]
        ];
    }, Uo[66] = Uo[104] = function(t) {
        return [
            [
                t.bottomright,
                0
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                t.lefttop
            ],
            [
                0,
                1
            ],
            [
                t.topleft,
                1
            ]
        ];
    }, Uo[144] = Uo[26] = function(t) {
        return [
            [
                1,
                1
            ],
            [
                1,
                t.righttop
            ],
            [
                0,
                t.leftbottom
            ],
            [
                0,
                t.lefttop
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Uo[36] = Uo[134] = function(t) {
        return [
            [
                1,
                t.rightbottom
            ],
            [
                1,
                0
            ],
            [
                t.bottomright,
                0
            ],
            [
                t.topleft,
                1
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Uo[9] = Uo[161] = function(t) {
        return [
            [
                1,
                t.righttop
            ],
            [
                1,
                t.rightbottom
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                t.leftbottom
            ]
        ];
    }, Uo[37] = Uo[133] = function(t) {
        return [
            [
                1,
                t.rightbottom
            ],
            [
                1,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                t.topleft,
                1
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Uo[148] = Uo[22] = function(t) {
        return [
            [
                1,
                1
            ],
            [
                1,
                0
            ],
            [
                t.bottomright,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                0,
                t.lefttop
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Uo[82] = Uo[88] = function(t) {
        return [
            [
                1,
                1
            ],
            [
                1,
                t.righttop
            ],
            [
                t.bottomright,
                0
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                t.lefttop
            ],
            [
                0,
                1
            ]
        ];
    }, Uo[73] = Uo[97] = function(t) {
        return [
            [
                1,
                t.righttop
            ],
            [
                1,
                t.rightbottom
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                1
            ],
            [
                t.topleft,
                1
            ]
        ];
    }, Uo[145] = Uo[25] = function(t) {
        return [
            [
                1,
                1
            ],
            [
                1,
                t.righttop
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Uo[70] = Uo[100] = function(t) {
        return [
            [
                1,
                t.rightbottom
            ],
            [
                1,
                0
            ],
            [
                t.bottomright,
                0
            ],
            [
                0,
                t.lefttop
            ],
            [
                0,
                1
            ],
            [
                t.topleft,
                1
            ]
        ];
    }, Uo[34] = function(t) {
        return [
            Ao(t),
            Ro(t)
        ];
    }, Uo[35] = function(t) {
        return [
            [
                1,
                t.righttop
            ],
            [
                1,
                t.rightbottom
            ],
            [
                t.bottomright,
                0
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                0,
                t.lefttop
            ],
            [
                t.topleft,
                1
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Uo[136] = function(t) {
        return [
            To(t),
            Oo(t)
        ];
    }, Uo[153] = function(t) {
        return [
            Mo(t),
            Co(t)
        ];
    }, Uo[102] = function(t) {
        return [
            Po(t),
            Lo(t)
        ];
    }, Uo[155] = function(t) {
        return [
            [
                1,
                1
            ],
            [
                1,
                t.righttop
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Uo[103] = function(t) {
        return [
            [
                1,
                t.rightbottom
            ],
            [
                1,
                0
            ],
            [
                t.bottomright,
                0
            ],
            [
                0,
                t.lefttop
            ],
            [
                0,
                1
            ],
            [
                t.topleft,
                1
            ]
        ];
    }, Uo[152] = function(t) {
        return [
            Mo(t),
            Oo(t)
        ];
    }, Uo[156] = function(t) {
        return [
            [
                1,
                1
            ],
            [
                1,
                t.righttop
            ],
            [
                t.bottomright,
                0
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                0,
                t.lefttop
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Uo[137] = function(t) {
        return [
            To(t),
            Co(t)
        ];
    }, Uo[139] = function(t) {
        return [
            [
                1,
                t.righttop
            ],
            [
                1,
                t.rightbottom
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                t.topleft,
                1
            ],
            [
                t.topright,
                1
            ]
        ];
    }, Uo[98] = function(t) {
        return [
            Ro(t),
            Lo(t)
        ];
    }, Uo[99] = function(t) {
        return [
            [
                1,
                t.righttop
            ],
            [
                1,
                t.rightbottom
            ],
            [
                t.bottomright,
                0
            ],
            [
                t.bottomleft,
                0
            ],
            [
                0,
                t.lefttop
            ],
            [
                0,
                1
            ],
            [
                t.topleft,
                1
            ]
        ];
    }, Uo[38] = function(t) {
        return [
            Po(t),
            Ao(t)
        ];
    }, Uo[39] = function(t) {
        return [
            [
                1,
                t.rightbottom
            ],
            [
                1,
                0
            ],
            [
                t.bottomright,
                0
            ],
            [
                0,
                t.leftbottom
            ],
            [
                0,
                t.lefttop
            ],
            [
                t.topleft,
                1
            ],
            [
                t.topright,
                1
            ]
        ];
    };
    var us = function() {
        function t(e) {
            this.id = t.buildId(e), this.coordinates = e, this.innerEdges = [], this.outerEdges = [], this.outerEdgesSorted = !1;
        }
        return t.buildId = function(t) {
            return t.join(",");
        }, t.prototype.removeInnerEdge = function(t) {
            this.innerEdges = this.innerEdges.filter(function(e) {
                return e.from.id !== t.from.id;
            });
        }, t.prototype.removeOuterEdge = function(t) {
            this.outerEdges = this.outerEdges.filter(function(e) {
                return e.to.id !== t.to.id;
            });
        }, t.prototype.addOuterEdge = function(t) {
            this.outerEdges.push(t), this.outerEdgesSorted = !1;
        }, t.prototype.sortOuterEdges = function() {
            var t = this;
            this.outerEdgesSorted || (this.outerEdges.sort(function(e, n) {
                var r = e.to, i = n.to;
                if (r.coordinates[0] - t.coordinates[0] >= 0 && i.coordinates[0] - t.coordinates[0] < 0) return 1;
                if (r.coordinates[0] - t.coordinates[0] < 0 && i.coordinates[0] - t.coordinates[0] >= 0) return -1;
                if (r.coordinates[0] - t.coordinates[0] == 0 && i.coordinates[0] - t.coordinates[0] == 0) return r.coordinates[1] - t.coordinates[1] >= 0 || i.coordinates[1] - t.coordinates[1] >= 0 ? r.coordinates[1] - i.coordinates[1] : i.coordinates[1] - r.coordinates[1];
                var o = ss(t.coordinates, r.coordinates, i.coordinates);
                return o < 0 ? 1 : o > 0 ? -1 : Math.pow(r.coordinates[0] - t.coordinates[0], 2) + Math.pow(r.coordinates[1] - t.coordinates[1], 2) - (Math.pow(i.coordinates[0] - t.coordinates[0], 2) + Math.pow(i.coordinates[1] - t.coordinates[1], 2));
            }), this.outerEdgesSorted = !0);
        }, t.prototype.getOuterEdges = function() {
            return this.sortOuterEdges(), this.outerEdges;
        }, t.prototype.getOuterEdge = function(t) {
            return this.sortOuterEdges(), this.outerEdges[t];
        }, t.prototype.addInnerEdge = function(t) {
            this.innerEdges.push(t);
        }, t;
    }(), ls = function() {
        function t(t, e) {
            this.from = t, this.to = e, this.next = void 0, this.label = void 0, this.symetric = void 0, this.ring = void 0, this.from.addOuterEdge(this), this.to.addInnerEdge(this);
        }
        return t.prototype.getSymetric = function() {
            return this.symetric || (this.symetric = new t(this.to, this.from), this.symetric.symetric = this), this.symetric;
        }, t.prototype.deleteEdge = function() {
            this.from.removeOuterEdge(this), this.to.removeInnerEdge(this);
        }, t.prototype.isEqual = function(t) {
            return this.from.id === t.from.id && this.to.id === t.to.id;
        }, t.prototype.toString = function() {
            return "Edge { " + this.from.id + " -> " + this.to.id + " }";
        }, t.prototype.toLineString = function() {
            return h([
                this.from.coordinates,
                this.to.coordinates
            ]);
        }, t.prototype.compareTo = function(t) {
            return ss(t.from.coordinates, t.to.coordinates, this.to.coordinates);
        }, t;
    }(), cs = function() {
        function t() {
            this.edges = [], this.polygon = void 0, this.envelope = void 0;
        }
        return t.prototype.push = function(t) {
            this.edges.push(t), this.polygon = this.envelope = void 0;
        }, t.prototype.get = function(t) {
            return this.edges[t];
        }, Object.defineProperty(t.prototype, "length", {
            get: function() {
                return this.edges.length;
            },
            enumerable: !0,
            configurable: !0
        }), t.prototype.forEach = function(t) {
            this.edges.forEach(t);
        }, t.prototype.map = function(t) {
            return this.edges.map(t);
        }, t.prototype.some = function(t) {
            return this.edges.some(t);
        }, t.prototype.isValid = function() {
            return !0;
        }, t.prototype.isHole = function() {
            var t = this, e = this.edges.reduce(function(e, n, r) {
                return n.from.coordinates[1] > t.edges[e].from.coordinates[1] && (e = r), e;
            }, 0), n = (0 === e ? this.length : e) - 1, r = (e + 1) % this.length, i = ss(this.edges[n].from.coordinates, this.edges[e].from.coordinates, this.edges[r].from.coordinates);
            return 0 === i ? this.edges[n].from.coordinates[0] > this.edges[r].from.coordinates[0] : i > 0;
        }, t.prototype.toMultiPoint = function() {
            return d(this.edges.map(function(t) {
                return t.from.coordinates;
            }));
        }, t.prototype.toPolygon = function() {
            if (this.polygon) return this.polygon;
            var t = this.edges.map(function(t) {
                return t.from.coordinates;
            });
            return t.push(this.edges[0].from.coordinates), this.polygon = l([
                t
            ]);
        }, t.prototype.getEnvelope = function() {
            return this.envelope ? this.envelope : this.envelope = dn(this.toPolygon());
        }, t.findEdgeRingContaining = function(t, e) {
            var n, r, i = t.getEnvelope();
            return e.forEach(function(e) {
                var o, s, u, l, c, h, p = e.getEnvelope();
                if ((r && (n = r.getEnvelope()), s = i, u = (o = p).geometry.coordinates[0].map(function(t) {
                    return t[0];
                }), l = o.geometry.coordinates[0].map(function(t) {
                    return t[1];
                }), c = s.geometry.coordinates[0].map(function(t) {
                    return t[0];
                }), h = s.geometry.coordinates[0].map(function(t) {
                    return t[1];
                }), Math.max.apply(null, u) !== Math.max.apply(null, c) || Math.max.apply(null, l) !== Math.max.apply(null, h) || Math.min.apply(null, u) !== Math.min.apply(null, c) || Math.min.apply(null, l) !== Math.min.apply(null, h)) && as(p, i)) {
                    for(var f = t.map(function(t) {
                        return t.from.coordinates;
                    }), g = void 0, d = function(t) {
                        e.some(function(e) {
                            var n, r;
                            return n = t, r = e.from.coordinates, n[0] === r[0] && n[1] === r[1];
                        }) || (g = t);
                    }, y = 0, v = f; y < v.length; y++)d(v[y]);
                    g && e.inside(a(g)) && (r && !as(n, p) || (r = e));
                }
            }), r;
        }, t.prototype.inside = function(t) {
            return ye(t, this.toPolygon());
        }, t;
    }();
    var hs = function() {
        function t() {
            this.edges = [], this.nodes = {};
        }
        return t.fromGeoJson = function(e) {
            !function(t) {
                if (!t) throw new Error("No geojson passed");
                if ("FeatureCollection" !== t.type && "GeometryCollection" !== t.type && "MultiLineString" !== t.type && "LineString" !== t.type && "Feature" !== t.type) throw new Error("Invalid input type '" + t.type + "'. Geojson must be FeatureCollection, GeometryCollection, LineString, MultiLineString or Feature");
            }(e);
            var n = new t;
            return z(e, function(t) {
                et(t, "LineString", "Graph::fromGeoJson"), T(t, function(t, e) {
                    if (t) {
                        var r = n.getNode(t), i = n.getNode(e);
                        n.addEdge(r, i);
                    }
                    return e;
                });
            }), n;
        }, t.prototype.getNode = function(t) {
            var e = us.buildId(t), n = this.nodes[e];
            return n || (n = this.nodes[e] = new us(t)), n;
        }, t.prototype.addEdge = function(t, e) {
            var n = new ls(t, e), r = n.getSymetric();
            this.edges.push(n), this.edges.push(r);
        }, t.prototype.deleteDangles = function() {
            var t = this;
            Object.keys(this.nodes).map(function(e) {
                return t.nodes[e];
            }).forEach(function(e) {
                return t._removeIfDangle(e);
            });
        }, t.prototype._removeIfDangle = function(t) {
            var e = this;
            if (t.innerEdges.length <= 1) {
                var n = t.getOuterEdges().map(function(t) {
                    return t.to;
                });
                this.removeNode(t), n.forEach(function(t) {
                    return e._removeIfDangle(t);
                });
            }
        }, t.prototype.deleteCutEdges = function() {
            var t = this;
            this._computeNextCWEdges(), this._findLabeledEdgeRings(), this.edges.forEach(function(e) {
                e.label === e.symetric.label && (t.removeEdge(e.symetric), t.removeEdge(e));
            });
        }, t.prototype._computeNextCWEdges = function(t) {
            var e = this;
            void 0 === t ? Object.keys(this.nodes).forEach(function(t) {
                return e._computeNextCWEdges(e.nodes[t]);
            }) : t.getOuterEdges().forEach(function(e, n) {
                t.getOuterEdge((0 === n ? t.getOuterEdges().length : n) - 1).symetric.next = e;
            });
        }, t.prototype._computeNextCCWEdges = function(t, e) {
            for(var n, r, i = t.getOuterEdges(), o = i.length - 1; o >= 0; --o){
                var s = i[o], a = s.symetric, u = void 0, l = void 0;
                s.label === e && (u = s), a.label === e && (l = a), u && l && (l && (r = l), u && (r && (r.next = u, r = void 0), n || (n = u)));
            }
            r && (r.next = n);
        }, t.prototype._findLabeledEdgeRings = function() {
            var t = [], e = 0;
            return this.edges.forEach(function(n) {
                if (!(n.label >= 0)) {
                    t.push(n);
                    var r = n;
                    do r.label = e, r = r.next;
                    while (!n.isEqual(r));
                    e++;
                }
            }), t;
        }, t.prototype.getEdgeRings = function() {
            var t = this;
            this._computeNextCWEdges(), this.edges.forEach(function(t) {
                t.label = void 0;
            }), this._findLabeledEdgeRings().forEach(function(e) {
                t._findIntersectionNodes(e).forEach(function(n) {
                    t._computeNextCCWEdges(n, e.label);
                });
            });
            var e = [];
            return this.edges.forEach(function(n) {
                n.ring || e.push(t._findEdgeRing(n));
            }), e;
        }, t.prototype._findIntersectionNodes = function(t) {
            var e = [], n = t, r = function() {
                var r = 0;
                n.from.getOuterEdges().forEach(function(e) {
                    e.label === t.label && ++r;
                }), r > 1 && e.push(n.from), n = n.next;
            };
            do r();
            while (!t.isEqual(n));
            return e;
        }, t.prototype._findEdgeRing = function(t) {
            var e = t, n = new cs;
            do n.push(e), e.ring = n, e = e.next;
            while (!t.isEqual(e));
            return n;
        }, t.prototype.removeNode = function(t) {
            var e = this;
            t.getOuterEdges().forEach(function(t) {
                return e.removeEdge(t);
            }), t.innerEdges.forEach(function(t) {
                return e.removeEdge(t);
            }), delete this.nodes[t.id];
        }, t.prototype.removeEdge = function(t) {
            this.edges = this.edges.filter(function(e) {
                return !e.isEqual(t);
            }), t.deleteEdge();
        }, t;
    }();
    function ps(t, e) {
        var n = !0;
        return z(t, function(t) {
            z(e, function(e) {
                if (!1 === n) return !1;
                n = function(t, e) {
                    switch(t.type){
                        case "Point":
                            switch(e.type){
                                case "Point":
                                    return n = t.coordinates, r = e.coordinates, !(n[0] === r[0] && n[1] === r[1]);
                                case "LineString":
                                    return !fs(e, t);
                                case "Polygon":
                                    return !ye(t, e);
                            }
                            break;
                        case "LineString":
                            switch(e.type){
                                case "Point":
                                    return !fs(t, e);
                                case "LineString":
                                    return !function(t, e) {
                                        if (Or(t, e).features.length > 0) return !0;
                                        return !1;
                                    }(t, e);
                                case "Polygon":
                                    return !gs(e, t);
                            }
                            break;
                        case "Polygon":
                            switch(e.type){
                                case "Point":
                                    return !ye(e, t);
                                case "LineString":
                                    return !gs(t, e);
                                case "Polygon":
                                    return !function(t, e) {
                                        for(var n = 0, r = t.coordinates[0]; n < r.length; n++){
                                            if (ye(r[n], e)) return !0;
                                        }
                                        for(var i = 0, o = e.coordinates[0]; i < o.length; i++){
                                            if (ye(o[i], t)) return !0;
                                        }
                                        if (Or(Ii(t), Ii(e)).features.length > 0) return !0;
                                        return !1;
                                    }(e, t);
                            }
                    }
                    var n, r;
                    return !1;
                }(t.geometry, e.geometry);
            });
        }), n;
    }
    function fs(t, e) {
        for(var n = 0; n < t.coordinates.length - 1; n++)if (ds(t.coordinates[n], t.coordinates[n + 1], e.coordinates)) return !0;
        return !1;
    }
    function gs(t, e) {
        for(var n = 0, r = e.coordinates; n < r.length; n++){
            if (ye(r[n], t)) return !0;
        }
        return Or(e, Ii(t)).features.length > 0;
    }
    function ds(t, e, n) {
        var r = n[0] - t[0], i = n[1] - t[1], o = e[0] - t[0], s = e[1] - t[1];
        return 0 == r * s - i * o && (Math.abs(o) >= Math.abs(s) ? o > 0 ? t[0] <= n[0] && n[0] <= e[0] : e[0] <= n[0] && n[0] <= t[0] : s > 0 ? t[1] <= n[1] && n[1] <= e[1] : e[1] <= n[1] && n[1] <= t[1]);
    }
    function ys(t, e) {
        return !(t[0] > e[0]) && !(t[2] < e[2]) && !(t[1] > e[1]) && !(t[3] < e[3]);
    }
    function vs(t, e) {
        return t[0] === e[0] && t[1] === e[1];
    }
    function _s(t, e) {
        return [
            (t[0] + e[0]) / 2,
            (t[1] + e[1]) / 2
        ];
    }
    function ms(t, e) {
        for(var n = !1, r = !1, i = t.coordinates.length, o = 0; o < i && !n && !r;){
            for(var s = 0; s < e.coordinates.length - 1; s++){
                var a = !0;
                0 !== s && s !== e.coordinates.length - 2 || (a = !1), bs(e.coordinates[s], e.coordinates[s + 1], t.coordinates[o], a) ? n = !0 : r = !0;
            }
            o++;
        }
        return n && r;
    }
    function xs(t, e) {
        return Or(t, Ni(e)).features.length > 0;
    }
    function Es(t, e) {
        for(var n = !1, r = !1, i = t.coordinates.length, o = 0; o < i && (!n || !r); o++)ye(a(t.coordinates[o]), e) ? n = !0 : r = !0;
        return r && n;
    }
    function bs(t, e, n, r) {
        var i = n[0] - t[0], o = n[1] - t[1], s = e[0] - t[0], a = e[1] - t[1];
        return 0 == i * a - o * s && (r ? Math.abs(s) >= Math.abs(a) ? s > 0 ? t[0] <= n[0] && n[0] <= e[0] : e[0] <= n[0] && n[0] <= t[0] : a > 0 ? t[1] <= n[1] && n[1] <= e[1] : e[1] <= n[1] && n[1] <= t[1] : Math.abs(s) >= Math.abs(a) ? s > 0 ? t[0] < n[0] && n[0] < e[0] : e[0] < n[0] && n[0] < t[0] : a > 0 ? t[1] < n[1] && n[1] < e[1] : e[1] < n[1] && n[1] < t[1]);
    }
    var ws = function(t) {
        this.precision = t && t.precision ? t.precision : 17, this.direction = !(!t || !t.direction) && t.direction, this.pseudoNode = !(!t || !t.pseudoNode) && t.pseudoNode, this.objectComparator = t && t.objectComparator ? t.objectComparator : Ss;
    };
    function Is(t) {
        return t.coordinates.map(function(e) {
            return {
                type: t.type.replace("Multi", ""),
                coordinates: e
            };
        });
    }
    function Ns(t, e) {
        return t.hasOwnProperty("coordinates") ? t.coordinates.length === e.coordinates.length : t.length === e.length;
    }
    function Ss(t, e) {
        return Fi(t, e, {
            strict: !0
        });
    }
    ws.prototype.compare = function(t, e) {
        if (t.type !== e.type || !Ns(t, e)) return !1;
        switch(t.type){
            case "Point":
                return this.compareCoord(t.coordinates, e.coordinates);
            case "LineString":
                return this.compareLine(t.coordinates, e.coordinates, 0, !1);
            case "Polygon":
                return this.comparePolygon(t, e);
            case "Feature":
                return this.compareFeature(t, e);
            default:
                if (0 === t.type.indexOf("Multi")) {
                    var n = this, r = Is(t), i = Is(e);
                    return r.every(function(t) {
                        return this.some(function(e) {
                            return n.compare(t, e);
                        });
                    }, i);
                }
        }
        return !1;
    }, ws.prototype.compareCoord = function(t, e) {
        if (t.length !== e.length) return !1;
        for(var n = 0; n < t.length; n++)if (t[n].toFixed(this.precision) !== e[n].toFixed(this.precision)) return !1;
        return !0;
    }, ws.prototype.compareLine = function(t, e, n, r) {
        if (!Ns(t, e)) return !1;
        var i = this.pseudoNode ? t : this.removePseudo(t), o = this.pseudoNode ? e : this.removePseudo(e);
        if (!r || this.compareCoord(i[0], o[0]) || (o = this.fixStartIndex(o, i))) {
            var s = this.compareCoord(i[n], o[n]);
            return this.direction || s ? this.comparePath(i, o) : !!this.compareCoord(i[n], o[o.length - (1 + n)]) && this.comparePath(i.slice().reverse(), o);
        }
    }, ws.prototype.fixStartIndex = function(t, e) {
        for(var n, r = -1, i = 0; i < t.length; i++)if (this.compareCoord(t[i], e[0])) {
            r = i;
            break;
        }
        return r >= 0 && (n = [].concat(t.slice(r, t.length), t.slice(1, r + 1))), n;
    }, ws.prototype.comparePath = function(t, e) {
        var n = this;
        return t.every(function(t, e) {
            return n.compareCoord(t, this[e]);
        }, e);
    }, ws.prototype.comparePolygon = function(t, e) {
        if (this.compareLine(t.coordinates[0], e.coordinates[0], 1, !0)) {
            var n = t.coordinates.slice(1, t.coordinates.length), r = e.coordinates.slice(1, e.coordinates.length), i = this;
            return n.every(function(t) {
                return this.some(function(e) {
                    return i.compareLine(t, e, 1, !0);
                });
            }, r);
        }
        return !1;
    }, ws.prototype.compareFeature = function(t, e) {
        return !(t.id !== e.id || !this.objectComparator(t.properties, e.properties) || !this.compareBBox(t, e)) && this.compare(t.geometry, e.geometry);
    }, ws.prototype.compareBBox = function(t, e) {
        return !!(!t.bbox && !e.bbox || t.bbox && e.bbox && this.compareCoord(t.bbox, e.bbox));
    }, ws.prototype.removePseudo = function(t) {
        return t;
    };
    var Cs = ws;
    function Ps(t, e) {
        var n = !1;
        return z(t, function(t) {
            z(e, function(e) {
                if (!0 === n) return !0;
                n = !ps(t.geometry, e.geometry);
            });
        }), n;
    }
    var Ms = Bt(function(t) {
        function e(t, e, n, r) {
            this.dataset = [], this.epsilon = 1, this.minPts = 2, this.distance = this._euclideanDistance, this.clusters = [], this.noise = [], this._visited = [], this._assigned = [], this._datasetLength = 0, this._init(t, e, n, r);
        }
        e.prototype.run = function(t, e, n, r) {
            this._init(t, e, n, r);
            for(var i = 0; i < this._datasetLength; i++)if (1 !== this._visited[i]) {
                this._visited[i] = 1;
                var o = this._regionQuery(i);
                if (o.length < this.minPts) this.noise.push(i);
                else {
                    var s = this.clusters.length;
                    this.clusters.push([]), this._addToCluster(i, s), this._expandCluster(s, o);
                }
            }
            return this.clusters;
        }, e.prototype._init = function(t, e, n, r) {
            if (t) {
                if (!(t instanceof Array)) throw Error("Dataset must be of type array, " + typeof t + " given");
                this.dataset = t, this.clusters = [], this.noise = [], this._datasetLength = t.length, this._visited = new Array(this._datasetLength), this._assigned = new Array(this._datasetLength);
            }
            e && (this.epsilon = e), n && (this.minPts = n), r && (this.distance = r);
        }, e.prototype._expandCluster = function(t, e) {
            for(var n = 0; n < e.length; n++){
                var r = e[n];
                if (1 !== this._visited[r]) {
                    this._visited[r] = 1;
                    var i = this._regionQuery(r);
                    i.length >= this.minPts && (e = this._mergeArrays(e, i));
                }
                1 !== this._assigned[r] && this._addToCluster(r, t);
            }
        }, e.prototype._addToCluster = function(t, e) {
            this.clusters[e].push(t), this._assigned[t] = 1;
        }, e.prototype._regionQuery = function(t) {
            for(var e = [], n = 0; n < this._datasetLength; n++)this.distance(this.dataset[t], this.dataset[n]) < this.epsilon && e.push(n);
            return e;
        }, e.prototype._mergeArrays = function(t, e) {
            for(var n = e.length, r = 0; r < n; r++){
                var i = e[r];
                t.indexOf(i) < 0 && t.push(i);
            }
            return t;
        }, e.prototype._euclideanDistance = function(t, e) {
            for(var n = 0, r = Math.min(t.length, e.length); r--;)n += (t[r] - e[r]) * (t[r] - e[r]);
            return Math.sqrt(n);
        }, t.exports && (t.exports = e);
    }), Ls = Bt(function(t) {
        function e(t, e, n) {
            this.k = 3, this.dataset = [], this.assignments = [], this.centroids = [], this.init(t, e, n);
        }
        e.prototype.init = function(t, e, n) {
            this.assignments = [], this.centroids = [], void 0 !== t && (this.dataset = t), void 0 !== e && (this.k = e), void 0 !== n && (this.distance = n);
        }, e.prototype.run = function(t, e) {
            this.init(t, e);
            for(var n = this.dataset.length, r = 0; r < this.k; r++)this.centroids[r] = this.randomCentroid();
            for(var i = !0; i;){
                i = this.assign();
                for(var o = 0; o < this.k; o++){
                    for(var s = new Array(c), a = 0, u = 0; u < c; u++)s[u] = 0;
                    for(var l = 0; l < n; l++){
                        var c = this.dataset[l].length;
                        if (o === this.assignments[l]) {
                            for(u = 0; u < c; u++)s[u] += this.dataset[l][u];
                            a++;
                        }
                    }
                    if (a > 0) {
                        for(u = 0; u < c; u++)s[u] /= a;
                        this.centroids[o] = s;
                    } else this.centroids[o] = this.randomCentroid(), i = !0;
                }
            }
            return this.getClusters();
        }, e.prototype.randomCentroid = function() {
            var t, e, n = this.dataset.length - 1;
            do e = Math.round(Math.random() * n), t = this.dataset[e];
            while (this.centroids.indexOf(t) >= 0);
            return t;
        }, e.prototype.assign = function() {
            for(var t, e = !1, n = this.dataset.length, r = 0; r < n; r++)(t = this.argmin(this.dataset[r], this.centroids, this.distance)) != this.assignments[r] && (this.assignments[r] = t, e = !0);
            return e;
        }, e.prototype.getClusters = function() {
            for(var t, e = new Array(this.k), n = 0; n < this.assignments.length; n++)void 0 === e[t = this.assignments[n]] && (e[t] = []), e[t].push(n);
            return e;
        }, e.prototype.argmin = function(t, e, n) {
            for(var r, i = Number.MAX_VALUE, o = 0, s = e.length, a = 0; a < s; a++)(r = n(t, e[a])) < i && (i = r, o = a);
            return o;
        }, e.prototype.distance = function(t, e) {
            for(var n = 0, r = Math.min(t.length, e.length); r--;){
                var i = t[r] - e[r];
                n += i * i;
            }
            return Math.sqrt(n);
        }, t.exports && (t.exports = e);
    }), Os = Bt(function(t) {
        function e(t, e, n) {
            this._queue = [], this._priorities = [], this._sorting = "desc", this._init(t, e, n);
        }
        e.prototype.insert = function(t, e) {
            for(var n = this._queue.length, r = n; r--;){
                var i = this._priorities[r];
                "desc" === this._sorting ? e > i && (n = r) : e < i && (n = r);
            }
            this._insertAt(t, e, n);
        }, e.prototype.remove = function(t) {
            for(var e = this._queue.length; e--;)if (t === this._queue[e]) {
                this._queue.splice(e, 1), this._priorities.splice(e, 1);
                break;
            }
        }, e.prototype.forEach = function(t) {
            this._queue.forEach(t);
        }, e.prototype.getElements = function() {
            return this._queue;
        }, e.prototype.getElementPriority = function(t) {
            return this._priorities[t];
        }, e.prototype.getPriorities = function() {
            return this._priorities;
        }, e.prototype.getElementsWithPriorities = function() {
            for(var t = [], e = 0, n = this._queue.length; e < n; e++)t.push([
                this._queue[e],
                this._priorities[e]
            ]);
            return t;
        }, e.prototype._init = function(t, e, n) {
            if (t && e) {
                if (this._queue = [], this._priorities = [], t.length !== e.length) throw new Error("Arrays must have the same length");
                for(var r = 0; r < t.length; r++)this.insert(t[r], e[r]);
            }
            n && (this._sorting = n);
        }, e.prototype._insertAt = function(t, e, n) {
            this._queue.length === n ? (this._queue.push(t), this._priorities.push(e)) : (this._queue.splice(n, 0, t), this._priorities.splice(n, 0, e));
        }, t.exports && (t.exports = e);
    }), Rs = Bt(function(t) {
        if (t.exports) var e = Os;
        function n(t, e, n, r) {
            this.epsilon = 1, this.minPts = 1, this.distance = this._euclideanDistance, this._reachability = [], this._processed = [], this._coreDistance = 0, this._orderedList = [], this._init(t, e, n, r);
        }
        n.prototype.run = function(t, n, r, i) {
            this._init(t, n, r, i);
            for(var o = 0, s = this.dataset.length; o < s; o++)if (1 !== this._processed[o]) {
                this._processed[o] = 1, this.clusters.push([
                    o
                ]);
                var a = this.clusters.length - 1;
                this._orderedList.push(o);
                var u = new e(null, null, "asc"), l = this._regionQuery(o);
                void 0 !== this._distanceToCore(o) && (this._updateQueue(o, l, u), this._expandCluster(a, u));
            }
            return this.clusters;
        }, n.prototype.getReachabilityPlot = function() {
            for(var t = [], e = 0, n = this._orderedList.length; e < n; e++){
                var r = this._orderedList[e], i = this._reachability[r];
                t.push([
                    r,
                    i
                ]);
            }
            return t;
        }, n.prototype._init = function(t, e, n, r) {
            if (t) {
                if (!(t instanceof Array)) throw Error("Dataset must be of type array, " + typeof t + " given");
                this.dataset = t, this.clusters = [], this._reachability = new Array(this.dataset.length), this._processed = new Array(this.dataset.length), this._coreDistance = 0, this._orderedList = [];
            }
            e && (this.epsilon = e), n && (this.minPts = n), r && (this.distance = r);
        }, n.prototype._updateQueue = function(t, e, n) {
            var r = this;
            this._coreDistance = this._distanceToCore(t), e.forEach(function(e) {
                if (void 0 === r._processed[e]) {
                    var i = r.distance(r.dataset[t], r.dataset[e]), o = Math.max(r._coreDistance, i);
                    void 0 === r._reachability[e] ? (r._reachability[e] = o, n.insert(e, o)) : o < r._reachability[e] && (r._reachability[e] = o, n.remove(e), n.insert(e, o));
                }
            });
        }, n.prototype._expandCluster = function(t, e) {
            for(var n = e.getElements(), r = 0, i = n.length; r < i; r++){
                var o = n[r];
                if (void 0 === this._processed[o]) {
                    var s = this._regionQuery(o);
                    this._processed[o] = 1, this.clusters[t].push(o), this._orderedList.push(o), void 0 !== this._distanceToCore(o) && (this._updateQueue(o, s, e), this._expandCluster(t, e));
                }
            }
        }, n.prototype._distanceToCore = function(t) {
            for(var e = this.epsilon, n = 0; n < e; n++){
                if (this._regionQuery(t, n).length >= this.minPts) return n;
            }
        }, n.prototype._regionQuery = function(t, e) {
            e = e || this.epsilon;
            for(var n = [], r = 0, i = this.dataset.length; r < i; r++)this.distance(this.dataset[t], this.dataset[r]) < e && n.push(r);
            return n;
        }, n.prototype._euclideanDistance = function(t, e) {
            for(var n = 0, r = Math.min(t.length, e.length); r--;)n += (t[r] - e[r]) * (t[r] - e[r]);
            return Math.sqrt(n);
        }, t.exports && (t.exports = n);
    }), Ts = Bt(function(t) {
        t.exports && (t.exports = {
            DBSCAN: Ms,
            KMEANS: Ls,
            OPTICS: Rs,
            PriorityQueue: Os
        });
    });
    var As = function(t, e, n) {
        for(var r = t.length, i = 0, o = 0; o < r; o++){
            var s = (t[o] || 0) - (e[o] || 0);
            i += s * s;
        }
        return n ? Math.sqrt(i) : i;
    }, Ds = As, Fs = function(t, e, n) {
        var r = Math.abs(t - e);
        return n ? r : r * r;
    }, ks = As, Gs = function(t, e) {
        for(var n = {}, r = [], i = e << 2, o = t.length, s = t[0].length > 0; r.length < e && i-- > 0;){
            var a = t[Math.floor(Math.random() * o)], u = s ? a.join("_") : "" + a;
            n[u] || (n[u] = !0, r.push(a));
        }
        if (r.length < e) throw new Error("Error initializating clusters");
        return r;
    }, qs = function(t, e) {
        var n = t[0].length ? Ds : Fs, r = [], i = t.length, o = t[0].length > 0, s = t[Math.floor(Math.random() * i)];
        o && s.join("_");
        for(r.push(s); r.length < e;){
            for(var a = [], u = r.length, l = 0, c = [], h = 0; h < i; h++){
                for(var p = 1 / 0, f = 0; f < u; f++){
                    var g = n(t[h], r[f]);
                    g <= p && (p = g);
                }
                a[h] = p;
            }
            for(var d = 0; d < i; d++)l += a[d];
            for(var y = 0; y < i; y++)c[y] = {
                i: y,
                v: t[y],
                pr: a[y] / l,
                cs: 0
            };
            c.sort(function(t, e) {
                return t.pr - e.pr;
            }), c[0].cs = c[0].pr;
            for(var v = 1; v < i; v++)c[v].cs = c[v - 1].cs + c[v].pr;
            for(var _ = Math.random(), m = 0; m < i - 1 && c[m++].cs < _;);
            r.push(c[m - 1].v);
        }
        return r;
    };
    function Bs(t, e, n) {
        n = n || [];
        for(var r = 0; r < t; r++)n[r] = e;
        return n;
    }
    var zs = function(t, e, n, r) {
        var i = [], o = [], s = [], a = [], u = !1, l = r || 1e4, c = t.length, h = t[0].length, p = h > 0, f = [];
        if (n) i = "kmrand" == n ? Gs(t, e) : "kmpp" == n ? qs(t, e) : n;
        else for(var g = {}; i.length < e;){
            var d = Math.floor(Math.random() * c);
            g[d] || (g[d] = !0, i.push(t[d]));
        }
        do {
            Bs(e, 0, f);
            for(var y = 0; y < c; y++){
                for(var v = 1 / 0, _ = 0, m = 0; m < e; m++)(a = p ? ks(t[y], i[m]) : Math.abs(t[y] - i[m])) <= v && (v = a, _ = m);
                s[y] = _, f[_]++;
            }
            for(var x = [], E = (o = [], 0); E < e; E++)x[E] = p ? Bs(h, 0, x[E]) : 0, o[E] = i[E];
            if (p) {
                for(var b = 0; b < e; b++)i[b] = [];
                for(var w = 0; w < c; w++)for(var I = x[s[w]], N = t[w], S = 0; S < h; S++)I[S] += N[S];
                u = !0;
                for(var C = 0; C < e; C++){
                    for(var P = i[C], M = x[C], L = o[C], O = f[C], R = 0; R < h; R++)P[R] = M[R] / O || 0;
                    if (u) {
                        for(var T = 0; T < h; T++)if (L[T] != P[T]) {
                            u = !1;
                            break;
                        }
                    }
                }
            } else {
                for(var A = 0; A < c; A++)x[s[A]] += t[A];
                for(var D = 0; D < e; D++)i[D] = x[D] / f[D] || 0;
                u = !0;
                for(var F = 0; F < e; F++)if (o[F] != i[F]) {
                    u = !1;
                    break;
                }
            }
            u = u || --l <= 0;
        }while (!u);
        return {
            it: 1e4 - l,
            k: e,
            idxs: s,
            centroids: i
        };
    };
    function js(t, e) {
        return b(Bi(t[0], t[1])) === b(Bi(e[0], e[1]));
    }
    function Us(t, e) {
        if (t.geometry && t.geometry.type) return t.geometry.type;
        if (t.type) return t.type;
        throw new Error("Invalid GeoJSON object for " + e);
    }
    function Vs(t) {
        for(var e = t, n = []; e.parent;)n.unshift(e), e = e.parent;
        return n;
    }
    var Xs = {
        search: function(t, e, n, r) {
            t.cleanDirty();
            var i = (r = r || {}).heuristic || Xs.heuristics.manhattan, o = r.closest || !1, s = new Ws(function(t) {
                return t.f;
            }), a = e;
            for(e.h = i(e, n), s.push(e); s.size() > 0;){
                var u = s.pop();
                if (u === n) return Vs(u);
                u.closed = !0;
                for(var l = t.neighbors(u), c = 0, h = l.length; c < h; ++c){
                    var p = l[c];
                    if (!p.closed && !p.isWall()) {
                        var f = u.g + p.getCost(u), g = p.visited;
                        (!g || f < p.g) && (p.visited = !0, p.parent = u, p.h = p.h || i(p, n), p.g = f, p.f = p.g + p.h, t.markDirty(p), o && (p.h < a.h || p.h === a.h && p.g < a.g) && (a = p), g ? s.rescoreElement(p) : s.push(p));
                    }
                }
            }
            return o ? Vs(a) : [];
        },
        heuristics: {
            manhattan: function(t, e) {
                return Math.abs(e.x - t.x) + Math.abs(e.y - t.y);
            },
            diagonal: function(t, e) {
                var n = Math.sqrt(2), r = Math.abs(e.x - t.x), i = Math.abs(e.y - t.y);
                return 1 * (r + i) + (n - 2) * Math.min(r, i);
            }
        },
        cleanNode: function(t) {
            t.f = 0, t.g = 0, t.h = 0, t.visited = !1, t.closed = !1, t.parent = null;
        }
    };
    function Ys(t, e) {
        e = e || {}, this.nodes = [], this.diagonal = !!e.diagonal, this.grid = [];
        for(var n = 0; n < t.length; n++){
            this.grid[n] = [];
            for(var r = 0, i = t[n]; r < i.length; r++){
                var o = new Hs(n, r, i[r]);
                this.grid[n][r] = o, this.nodes.push(o);
            }
        }
        this.init();
    }
    function Hs(t, e, n) {
        this.x = t, this.y = e, this.weight = n;
    }
    function Ws(t) {
        this.content = [], this.scoreFunction = t;
    }
    function Js(t, e) {
        for(var n = 0; n < e.features.length; n++)if (ye(t, e.features[n])) return !0;
        return !1;
    }
    function Zs(t) {
        return function() {
            return t;
        };
    }
    function Ks(t) {
        return t[0];
    }
    function Qs(t) {
        return t[1];
    }
    function $s() {
        this._ = null;
    }
    function ta(t) {
        t.U = t.C = t.L = t.R = t.P = t.N = null;
    }
    function ea(t, e) {
        var n = e, r = e.R, i = n.U;
        i ? i.L === n ? i.L = r : i.R = r : t._ = r, r.U = i, n.U = r, n.R = r.L, n.R && (n.R.U = n), r.L = n;
    }
    function na(t, e) {
        var n = e, r = e.L, i = n.U;
        i ? i.L === n ? i.L = r : i.R = r : t._ = r, r.U = i, n.U = r, n.L = r.R, n.L && (n.L.U = n), r.R = n;
    }
    function ra(t) {
        for(; t.L;)t = t.L;
        return t;
    }
    function ia(t, e, n, r) {
        var i = [
            null,
            null
        ], o = Pa.push(i) - 1;
        return i.left = t, i.right = e, n && sa(i, t, e, n), r && sa(i, e, t, r), Sa[t.index].halfedges.push(o), Sa[e.index].halfedges.push(o), i;
    }
    function oa(t, e, n) {
        var r = [
            e,
            n
        ];
        return r.left = t, r;
    }
    function sa(t, e, n, r) {
        t[0] || t[1] ? t.left === n ? t[1] = r : t[0] = r : (t[0] = r, t.left = e, t.right = n);
    }
    function aa(t, e, n, r, i) {
        var o, s = t[0], a = t[1], u = s[0], l = s[1], c = 0, h = 1, p = a[0] - u, f = a[1] - l;
        if (o = e - u, p || !(o > 0)) {
            if (o /= p, p < 0) {
                if (o < c) return;
                o < h && (h = o);
            } else if (p > 0) {
                if (o > h) return;
                o > c && (c = o);
            }
            if (o = r - u, p || !(o < 0)) {
                if (o /= p, p < 0) {
                    if (o > h) return;
                    o > c && (c = o);
                } else if (p > 0) {
                    if (o < c) return;
                    o < h && (h = o);
                }
                if (o = n - l, f || !(o > 0)) {
                    if (o /= f, f < 0) {
                        if (o < c) return;
                        o < h && (h = o);
                    } else if (f > 0) {
                        if (o > h) return;
                        o > c && (c = o);
                    }
                    if (o = i - l, f || !(o < 0)) {
                        if (o /= f, f < 0) {
                            if (o > h) return;
                            o > c && (c = o);
                        } else if (f > 0) {
                            if (o < c) return;
                            o < h && (h = o);
                        }
                        return !(c > 0 || h < 1) || (c > 0 && (t[0] = [
                            u + c * p,
                            l + c * f
                        ]), h < 1 && (t[1] = [
                            u + h * p,
                            l + h * f
                        ]), !0);
                    }
                }
            }
        }
    }
    function ua(t, e, n, r, i) {
        var o = t[1];
        if (o) return !0;
        var s, a, u = t[0], l = t.left, c = t.right, h = l[0], p = l[1], f = c[0], g = c[1], d = (h + f) / 2, y = (p + g) / 2;
        if (g === p) {
            if (d < e || d >= r) return;
            if (h > f) {
                if (u) {
                    if (u[1] >= i) return;
                } else u = [
                    d,
                    n
                ];
                o = [
                    d,
                    i
                ];
            } else {
                if (u) {
                    if (u[1] < n) return;
                } else u = [
                    d,
                    i
                ];
                o = [
                    d,
                    n
                ];
            }
        } else if (a = y - (s = (h - f) / (g - p)) * d, s < -1 || s > 1) {
            if (h > f) {
                if (u) {
                    if (u[1] >= i) return;
                } else u = [
                    (n - a) / s,
                    n
                ];
                o = [
                    (i - a) / s,
                    i
                ];
            } else {
                if (u) {
                    if (u[1] < n) return;
                } else u = [
                    (i - a) / s,
                    i
                ];
                o = [
                    (n - a) / s,
                    n
                ];
            }
        } else if (p < g) {
            if (u) {
                if (u[0] >= r) return;
            } else u = [
                e,
                s * e + a
            ];
            o = [
                r,
                s * r + a
            ];
        } else {
            if (u) {
                if (u[0] < e) return;
            } else u = [
                r,
                s * r + a
            ];
            o = [
                e,
                s * e + a
            ];
        }
        return t[0] = u, t[1] = o, !0;
    }
    function la(t, e) {
        var n = t.site, r = e.left, i = e.right;
        return n === i && (i = r, r = n), i ? Math.atan2(i[1] - r[1], i[0] - r[0]) : (n === r ? (r = e[1], i = e[0]) : (r = e[0], i = e[1]), Math.atan2(r[0] - i[0], i[1] - r[1]));
    }
    function ca(t, e) {
        return e[+(e.left !== t.site)];
    }
    function ha(t, e) {
        return e[+(e.left === t.site)];
    }
    Ys.prototype.init = function() {
        this.dirtyNodes = [];
        for(var t = 0; t < this.nodes.length; t++)Xs.cleanNode(this.nodes[t]);
    }, Ys.prototype.cleanDirty = function() {
        for(var t = 0; t < this.dirtyNodes.length; t++)Xs.cleanNode(this.dirtyNodes[t]);
        this.dirtyNodes = [];
    }, Ys.prototype.markDirty = function(t) {
        this.dirtyNodes.push(t);
    }, Ys.prototype.neighbors = function(t) {
        var e = [], n = t.x, r = t.y, i = this.grid;
        return i[n - 1] && i[n - 1][r] && e.push(i[n - 1][r]), i[n + 1] && i[n + 1][r] && e.push(i[n + 1][r]), i[n] && i[n][r - 1] && e.push(i[n][r - 1]), i[n] && i[n][r + 1] && e.push(i[n][r + 1]), this.diagonal && (i[n - 1] && i[n - 1][r - 1] && e.push(i[n - 1][r - 1]), i[n + 1] && i[n + 1][r - 1] && e.push(i[n + 1][r - 1]), i[n - 1] && i[n - 1][r + 1] && e.push(i[n - 1][r + 1]), i[n + 1] && i[n + 1][r + 1] && e.push(i[n + 1][r + 1])), e;
    }, Ys.prototype.toString = function() {
        for(var t, e, n, r, i = [], o = this.grid, s = 0, a = o.length; s < a; s++){
            for(t = [], n = 0, r = (e = o[s]).length; n < r; n++)t.push(e[n].weight);
            i.push(t.join(" "));
        }
        return i.join("\n");
    }, Hs.prototype.toString = function() {
        return "[" + this.x + " " + this.y + "]";
    }, Hs.prototype.getCost = function(t) {
        return t && t.x !== this.x && t.y !== this.y ? 1.41421 * this.weight : this.weight;
    }, Hs.prototype.isWall = function() {
        return 0 === this.weight;
    }, Ws.prototype = {
        push: function(t) {
            this.content.push(t), this.sinkDown(this.content.length - 1);
        },
        pop: function() {
            var t = this.content[0], e = this.content.pop();
            return this.content.length > 0 && (this.content[0] = e, this.bubbleUp(0)), t;
        },
        remove: function(t) {
            var e = this.content.indexOf(t), n = this.content.pop();
            e !== this.content.length - 1 && (this.content[e] = n, this.scoreFunction(n) < this.scoreFunction(t) ? this.sinkDown(e) : this.bubbleUp(e));
        },
        size: function() {
            return this.content.length;
        },
        rescoreElement: function(t) {
            this.sinkDown(this.content.indexOf(t));
        },
        sinkDown: function(t) {
            for(var e = this.content[t]; t > 0;){
                var n = (t + 1 >> 1) - 1, r = this.content[n];
                if (!(this.scoreFunction(e) < this.scoreFunction(r))) break;
                this.content[n] = e, this.content[t] = r, t = n;
            }
        },
        bubbleUp: function(t) {
            for(var e = this.content.length, n = this.content[t], r = this.scoreFunction(n);;){
                var i, o = t + 1 << 1, s = o - 1, a = null;
                if (s < e) {
                    var u = this.content[s];
                    (i = this.scoreFunction(u)) < r && (a = s);
                }
                if (o < e) {
                    var l = this.content[o];
                    this.scoreFunction(l) < (null === a ? r : i) && (a = o);
                }
                if (null === a) break;
                this.content[t] = this.content[a], this.content[a] = n, t = a;
            }
        }
    }, $s.prototype = {
        constructor: $s,
        insert: function(t, e) {
            var n, r, i;
            if (t) {
                if (e.P = t, e.N = t.N, t.N && (t.N.P = e), t.N = e, t.R) {
                    for(t = t.R; t.L;)t = t.L;
                    t.L = e;
                } else t.R = e;
                n = t;
            } else this._ ? (t = ra(this._), e.P = null, e.N = t, t.P = t.L = e, n = t) : (e.P = e.N = null, this._ = e, n = null);
            for(e.L = e.R = null, e.U = n, e.C = !0, t = e; n && n.C;)n === (r = n.U).L ? (i = r.R) && i.C ? (n.C = i.C = !1, r.C = !0, t = r) : (t === n.R && (ea(this, n), n = (t = n).U), n.C = !1, r.C = !0, na(this, r)) : (i = r.L) && i.C ? (n.C = i.C = !1, r.C = !0, t = r) : (t === n.L && (na(this, n), n = (t = n).U), n.C = !1, r.C = !0, ea(this, r)), n = t.U;
            this._.C = !1;
        },
        remove: function(t) {
            t.N && (t.N.P = t.P), t.P && (t.P.N = t.N), t.N = t.P = null;
            var e, n, r, i = t.U, o = t.L, s = t.R;
            if (n = o ? s ? ra(s) : o : s, i ? i.L === t ? i.L = n : i.R = n : this._ = n, o && s ? (r = n.C, n.C = t.C, n.L = o, o.U = n, n !== s ? (i = n.U, n.U = t.U, t = n.R, i.L = t, n.R = s, s.U = n) : (n.U = i, i = n, t = n.R)) : (r = t.C, t = n), t && (t.U = i), !r) {
                if (t && t.C) t.C = !1;
                else {
                    do {
                        if (t === this._) break;
                        if (t === i.L) {
                            if ((e = i.R).C && (e.C = !1, i.C = !0, ea(this, i), e = i.R), e.L && e.L.C || e.R && e.R.C) {
                                e.R && e.R.C || (e.L.C = !1, e.C = !0, na(this, e), e = i.R), e.C = i.C, i.C = e.R.C = !1, ea(this, i), t = this._;
                                break;
                            }
                        } else if ((e = i.L).C && (e.C = !1, i.C = !0, na(this, i), e = i.L), e.L && e.L.C || e.R && e.R.C) {
                            e.L && e.L.C || (e.R.C = !1, e.C = !0, ea(this, e), e = i.L), e.C = i.C, i.C = e.L.C = !1, na(this, i), t = this._;
                            break;
                        }
                        e.C = !0, t = i, i = i.U;
                    }while (!t.C);
                    t && (t.C = !1);
                }
            }
        }
    };
    var pa, fa = [];
    function ga() {
        ta(this), this.x = this.y = this.arc = this.site = this.cy = null;
    }
    function da(t) {
        var e = t.P, n = t.N;
        if (e && n) {
            var r = e.site, i = t.site, o = n.site;
            if (r !== o) {
                var s = i[0], a = i[1], u = r[0] - s, l = r[1] - a, c = o[0] - s, h = o[1] - a, p = 2 * (u * h - l * c);
                if (!(p >= -La)) {
                    var f = u * u + l * l, g = c * c + h * h, d = (h * f - l * g) / p, y = (u * g - c * f) / p, v = fa.pop() || new ga;
                    v.arc = t, v.site = i, v.x = d + s, v.y = (v.cy = y + a) + Math.sqrt(d * d + y * y), t.circle = v;
                    for(var _ = null, m = Ca._; m;)if (v.y < m.y || v.y === m.y && v.x <= m.x) {
                        if (!m.L) {
                            _ = m.P;
                            break;
                        }
                        m = m.L;
                    } else {
                        if (!m.R) {
                            _ = m;
                            break;
                        }
                        m = m.R;
                    }
                    Ca.insert(_, v), _ || (pa = v);
                }
            }
        }
    }
    function ya(t) {
        var e = t.circle;
        e && (e.P || (pa = e.N), Ca.remove(e), fa.push(e), ta(e), t.circle = null);
    }
    var va = [];
    function _a() {
        ta(this), this.edge = this.site = this.circle = null;
    }
    function ma(t) {
        var e = va.pop() || new _a;
        return e.site = t, e;
    }
    function xa(t) {
        ya(t), Na.remove(t), va.push(t), ta(t);
    }
    function Ea(t) {
        var e = t.circle, n = e.x, r = e.cy, i = [
            n,
            r
        ], o = t.P, s = t.N, a = [
            t
        ];
        xa(t);
        for(var u = o; u.circle && Math.abs(n - u.circle.x) < Ma && Math.abs(r - u.circle.cy) < Ma;)o = u.P, a.unshift(u), xa(u), u = o;
        a.unshift(u), ya(u);
        for(var l = s; l.circle && Math.abs(n - l.circle.x) < Ma && Math.abs(r - l.circle.cy) < Ma;)s = l.N, a.push(l), xa(l), l = s;
        a.push(l), ya(l);
        var c, h = a.length;
        for(c = 1; c < h; ++c)l = a[c], u = a[c - 1], sa(l.edge, u.site, l.site, i);
        u = a[0], (l = a[h - 1]).edge = ia(u.site, l.site, null, i), da(u), da(l);
    }
    function ba(t) {
        for(var e, n, r, i, o = t[0], s = t[1], a = Na._; a;)if ((r = wa(a, s) - o) > Ma) a = a.L;
        else {
            if (!((i = o - Ia(a, s)) > Ma)) {
                r > -Ma ? (e = a.P, n = a) : i > -Ma ? (e = a, n = a.N) : e = n = a;
                break;
            }
            if (!a.R) {
                e = a;
                break;
            }
            a = a.R;
        }
        !function(t) {
            Sa[t.index] = {
                site: t,
                halfedges: []
            };
        }(t);
        var u = ma(t);
        if (Na.insert(e, u), e || n) {
            if (e === n) return ya(e), n = ma(e.site), Na.insert(u, n), u.edge = n.edge = ia(e.site, u.site), da(e), void da(n);
            if (n) {
                ya(e), ya(n);
                var l = e.site, c = l[0], h = l[1], p = t[0] - c, f = t[1] - h, g = n.site, d = g[0] - c, y = g[1] - h, v = 2 * (p * y - f * d), _ = p * p + f * f, m = d * d + y * y, x = [
                    (y * _ - f * m) / v + c,
                    (p * m - d * _) / v + h
                ];
                sa(n.edge, l, g, x), u.edge = ia(l, t, null, x), n.edge = ia(t, g, null, x), da(e), da(n);
            } else u.edge = ia(e.site, u.site);
        }
    }
    function wa(t, e) {
        var n = t.site, r = n[0], i = n[1], o = i - e;
        if (!o) return r;
        var s = t.P;
        if (!s) return -1 / 0;
        var a = (n = s.site)[0], u = n[1], l = u - e;
        if (!l) return a;
        var c = a - r, h = 1 / o - 1 / l, p = c / l;
        return h ? (-p + Math.sqrt(p * p - 2 * h * (c * c / (-2 * l) - u + l / 2 + i - o / 2))) / h + r : (r + a) / 2;
    }
    function Ia(t, e) {
        var n = t.N;
        if (n) return wa(n, e);
        var r = t.site;
        return r[1] === e ? r[0] : 1 / 0;
    }
    var Na, Sa, Ca, Pa, Ma = 1e-6, La = 1e-12;
    function Oa(t, e) {
        return e[1] - t[1] || e[0] - t[0];
    }
    function Ra(t, e) {
        var n, r, i, o = t.sort(Oa).pop();
        for(Pa = [], Sa = new Array(t.length), Na = new $s, Ca = new $s;;)if (i = pa, o && (!i || o[1] < i.y || o[1] === i.y && o[0] < i.x)) o[0] === n && o[1] === r || (ba(o), n = o[0], r = o[1]), o = t.pop();
        else {
            if (!i) break;
            Ea(i.arc);
        }
        if (function() {
            for(var t, e, n, r, i = 0, o = Sa.length; i < o; ++i)if ((t = Sa[i]) && (r = (e = t.halfedges).length)) {
                var s = new Array(r), a = new Array(r);
                for(n = 0; n < r; ++n)s[n] = n, a[n] = la(t, Pa[e[n]]);
                for(s.sort(function(t, e) {
                    return a[e] - a[t];
                }), n = 0; n < r; ++n)a[n] = e[s[n]];
                for(n = 0; n < r; ++n)e[n] = a[n];
            }
        }(), e) {
            var s = +e[0][0], a = +e[0][1], u = +e[1][0], l = +e[1][1];
            !function(t, e, n, r) {
                for(var i, o = Pa.length; o--;)ua(i = Pa[o], t, e, n, r) && aa(i, t, e, n, r) && (Math.abs(i[0][0] - i[1][0]) > Ma || Math.abs(i[0][1] - i[1][1]) > Ma) || delete Pa[o];
            }(s, a, u, l), function(t, e, n, r) {
                var i, o, s, a, u, l, c, h, p, f, g, d, y = Sa.length, v = !0;
                for(i = 0; i < y; ++i)if (o = Sa[i]) {
                    for(s = o.site, a = (u = o.halfedges).length; a--;)Pa[u[a]] || u.splice(a, 1);
                    for(a = 0, l = u.length; a < l;)g = (f = ha(o, Pa[u[a]]))[0], d = f[1], h = (c = ca(o, Pa[u[++a % l]]))[0], p = c[1], (Math.abs(g - h) > Ma || Math.abs(d - p) > Ma) && (u.splice(a, 0, Pa.push(oa(s, f, Math.abs(g - t) < Ma && r - d > Ma ? [
                        t,
                        Math.abs(h - t) < Ma ? p : r
                    ] : Math.abs(d - r) < Ma && n - g > Ma ? [
                        Math.abs(p - r) < Ma ? h : n,
                        r
                    ] : Math.abs(g - n) < Ma && d - e > Ma ? [
                        n,
                        Math.abs(h - n) < Ma ? p : e
                    ] : Math.abs(d - e) < Ma && g - t > Ma ? [
                        Math.abs(p - e) < Ma ? h : t,
                        e
                    ] : null)) - 1), ++l);
                    l && (v = !1);
                }
                if (v) {
                    var _, m, x, E = 1 / 0;
                    for(i = 0, v = null; i < y; ++i)(o = Sa[i]) && (x = (_ = (s = o.site)[0] - t) * _ + (m = s[1] - e) * m) < E && (E = x, v = o);
                    if (v) {
                        var b = [
                            t,
                            e
                        ], w = [
                            t,
                            r
                        ], I = [
                            n,
                            r
                        ], N = [
                            n,
                            e
                        ];
                        v.halfedges.push(Pa.push(oa(s = v.site, b, w)) - 1, Pa.push(oa(s, w, I)) - 1, Pa.push(oa(s, I, N)) - 1, Pa.push(oa(s, N, b)) - 1);
                    }
                }
                for(i = 0; i < y; ++i)(o = Sa[i]) && (o.halfedges.length || delete Sa[i]);
            }(s, a, u, l);
        }
        this.edges = Pa, this.cells = Sa, Na = Ca = Pa = Sa = null;
    }
    function Ta(t) {
        return (t = t.slice()).push(t[0]), l([
            t
        ]);
    }
    function Aa(t, e, n, r) {
        var i = (r = r || {}).steps || 64, o = r.units || "kilometers", s = r.angle || 0, a = r.pivot || t, u = r.properties || t.properties || {};
        if (!t) throw new Error("center is required");
        if (!e) throw new Error("xSemiAxis is required");
        if (!n) throw new Error("ySemiAxis is required");
        if (!P(r)) throw new Error("options must be an object");
        if (!C(i)) throw new Error("steps must be a number");
        if (!C(s)) throw new Error("angle must be a number");
        var c = K(t);
        if ("degrees" === o) var h = I(s);
        else e = ji(t, e, 90, {
            units: o
        }), n = ji(t, n, 0, {
            units: o
        }), e = K(e)[0] - c[0], n = K(n)[1] - c[1];
        for(var p = [], f = 0; f < i; f += 1){
            var g = -360 * f / i, d = e * n / Math.sqrt(Math.pow(n, 2) + Math.pow(e, 2) * Math.pow(Da(g), 2)), y = e * n / Math.sqrt(Math.pow(e, 2) + Math.pow(n, 2) / Math.pow(Da(g), 2));
            if (g < -90 && g >= -270 && (d = -d), g < -180 && g >= -360 && (y = -y), "degrees" === o) {
                var v = d * Math.cos(h) + y * Math.sin(h), _ = y * Math.cos(h) - d * Math.sin(h);
                d = v, y = _;
            }
            p.push([
                d + c[0],
                y + c[1]
            ]);
        }
        return p.push(p[0]), "degrees" === o ? l([
            p
        ], u) : $o(l([
            p
        ], u), s, {
            pivot: a
        });
    }
    function Da(t) {
        var e = t * Math.PI / 180;
        return Math.tan(e);
    }
    function Fa(t, e) {
        void 0 === e && (e = {});
        var n = 0, r = 0, i = 0;
        return q(t, function(t, o, s) {
            var a = e.weight ? null == s ? void 0 : s[e.weight] : void 0;
            if (!C(a = null == a ? 1 : a)) throw new Error("weight value must be a number for feature index " + o);
            (a = Number(a)) > 0 && R(t, function(t) {
                n += t[0] * a, r += t[1] * a, i += a;
            });
        }), a([
            n / i,
            r / i
        ], e.properties, e);
    }
    function ka(t, e, n, r, i) {
        var o = r.tolerance || .001, s = 0, u = 0, l = 0, c = 0;
        if (F(n, function(e) {
            var n, r = null === (n = e.properties) || void 0 === n ? void 0 : n.weight, i = null == r ? 1 : r;
            if (!C(i = Number(i))) throw new Error("weight value must be a number");
            if (i > 0) {
                c += 1;
                var o = i * me(e, t);
                0 === o && (o = 1);
                var a = i / o;
                s += e.geometry.coordinates[0] * a, u += e.geometry.coordinates[1] * a, l += a;
            }
        }), c < 1) throw new Error("no features to measure");
        var h = s / l, p = u / l;
        return 1 === c || 0 === i || Math.abs(h - e[0]) < o && Math.abs(p - e[1]) < o ? a([
            h,
            p
        ], {
            medianCandidates: r.medianCandidates
        }) : (r.medianCandidates.push([
            h,
            p
        ]), ka([
            h,
            p
        ], t, n, r, i - 1));
    }
    function Ga(t, e) {
        return {
            x: t[0] - e[0],
            y: t[1] - e[1]
        };
    }
    function qa(t, e) {
        var n = 0, r = 0;
        R(t, function(i, o, s, a, u) {
            u > n && (n = u, r = o, e.push([]));
            var l = o - r, c = t.coordinates[u][l + 1], h = i[0], p = i[1], f = c[0], g = c[1];
            e[u].push([
                .75 * h + .25 * f,
                .75 * p + .25 * g
            ]), e[u].push([
                .25 * h + .75 * f,
                .25 * p + .75 * g
            ]);
        }, !0), e.forEach(function(t) {
            t.push(t[0]);
        });
    }
    function Ba(t, e) {
        var n = 0, r = 0, i = 0;
        R(t, function(o, s, a, u, l) {
            u > i && (i = u, r = s, e.push([
                []
            ])), l > n && (n = l, r = s, e[u].push([]));
            var c = s - r, h = t.coordinates[u][l][c + 1], p = o[0], f = o[1], g = h[0], d = h[1];
            e[u][l].push([
                .75 * p + .25 * g,
                .75 * f + .25 * d
            ]), e[u][l].push([
                .25 * p + .75 * g,
                .25 * f + .75 * d
            ]);
        }, !0), e.forEach(function(t) {
            t.forEach(function(t) {
                t.push(t[0]);
            });
        });
    }
    function za(t, e, n) {
        void 0 === n && (n = 2);
        var r = K(t), i = K(e), o = r[0] - i[0], s = r[1] - i[1];
        return 1 === n ? Math.abs(o) + Math.abs(s) : Math.pow(Math.pow(o, n) + Math.pow(s, n), 1 / n);
    }
    function ja(t, e) {
        var n = (e = e || {}).threshold || 1e4, r = e.p || 2, i = e.binary || !1, o = e.alpha || -1, s = e.standardization || !1, a = [];
        F(t, function(t) {
            a.push(En(t));
        });
        for(var u = [], l = 0; l < a.length; l++)u[l] = [];
        for(l = 0; l < a.length; l++)for(var c = l; c < a.length; c++){
            l === c && (u[l][c] = 0);
            var h = za(a[l], a[c], r);
            u[l][c] = h, u[c][l] = h;
        }
        for(l = 0; l < a.length; l++)for(c = 0; c < a.length; c++)0 !== (h = u[l][c]) && (u[l][c] = i ? h <= n ? 1 : 0 : h <= n ? Math.pow(h, o) : 0);
        if (s) for(l = 0; l < a.length; l++){
            var p = u[l].reduce(function(t, e) {
                return t + e;
            }, 0);
            for(c = 0; c < a.length; c++)u[l][c] = u[l][c] / p;
        }
        return u;
    }
    function Ua(t) {
        for(var e = 0, n = 0, r = t; n < r.length; n++)e += r[n];
        return e / t.length;
    }
    function Va(t, e) {
        return void 0 === e && (e = {}), Ya(t, "mercator", e);
    }
    function Xa(t, e) {
        return void 0 === e && (e = {}), Ya(t, "wgs84", e);
    }
    function Ya(t, e, n) {
        void 0 === n && (n = {});
        var r = (n = n || {}).mutate;
        if (!t) throw new Error("geojson is required");
        return Array.isArray(t) && C(t[0]) ? t = "mercator" === e ? Ha(t) : Wa(t) : (!0 !== r && (t = Ie(t)), R(t, function(t) {
            var n = "mercator" === e ? Ha(t) : Wa(t);
            t[0] = n[0], t[1] = n[1];
        })), t;
    }
    function Ha(t) {
        var e = Math.PI / 180, n = 6378137, r = 20037508.342789244, i = [
            n * (Math.abs(t[0]) <= 180 ? t[0] : t[0] - 360 * function(t) {
                return t < 0 ? -1 : t > 0 ? 1 : 0;
            }(t[0])) * e,
            n * Math.log(Math.tan(.25 * Math.PI + .5 * t[1] * e))
        ];
        return i[0] > r && (i[0] = r), i[0] < -r && (i[0] = -r), i[1] > r && (i[1] = r), i[1] < -r && (i[1] = -r), i;
    }
    function Wa(t) {
        var e = 180 / Math.PI, n = 6378137;
        return [
            t[0] * e / n,
            (.5 * Math.PI - 2 * Math.atan(Math.exp(-t[1] / n))) * e
        ];
    }
    Ra.prototype = {
        constructor: Ra,
        polygons: function() {
            var t = this.edges;
            return this.cells.map(function(e) {
                var n = e.halfedges.map(function(n) {
                    return ca(e, t[n]);
                });
                return n.data = e.site.data, n;
            });
        },
        triangles: function() {
            var t = [], e = this.edges;
            return this.cells.forEach(function(n, r) {
                if (o = (i = n.halfedges).length) for(var i, o, s, a, u, l, c = n.site, h = -1, p = e[i[o - 1]], f = p.left === c ? p.right : p.left; ++h < o;)s = f, f = (p = e[i[h]]).left === c ? p.right : p.left, s && f && r < s.index && r < f.index && (u = s, l = f, ((a = c)[0] - l[0]) * (u[1] - a[1]) - (a[0] - u[0]) * (l[1] - a[1]) < 0) && t.push([
                    c.data,
                    s.data,
                    f.data
                ]);
            }), t;
        },
        links: function() {
            return this.edges.filter(function(t) {
                return t.right;
            }).map(function(t) {
                return {
                    source: t.left.data,
                    target: t.right.data
                };
            });
        },
        find: function(t, e, n) {
            for(var r, i, o = this, s = o._found || 0, a = o.cells.length; !(i = o.cells[s]);)if (++s >= a) return null;
            var u = t - i.site[0], l = e - i.site[1], c = u * u + l * l;
            do i = o.cells[r = s], s = null, i.halfedges.forEach(function(n) {
                var r = o.edges[n], a = r.left;
                if (a !== i.site && a || (a = r.right)) {
                    var u = t - a[0], l = e - a[1], h = u * u + l * l;
                    h < c && (c = h, s = a.index);
                }
            });
            while (null !== s);
            return o._found = r, null == n || c <= n * n ? i.site : null;
        }
    };
    var Ja = Object.freeze({
        __proto__: null,
        toMercator: Va,
        toWgs84: Xa
    }), Za = function() {
        for(var t = 0, e = 0, n = arguments.length; e < n; e++)t += arguments[e].length;
        var r = Array(t), i = 0;
        for(e = 0; e < n; e++)for(var o = arguments[e], s = 0, a = o.length; s < a; s++, i++)r[i] = o[s];
        return r;
    };
    function Ka(t) {
        return Array.isArray(t) ? nu(t) : t && t.bbox ? nu(t.bbox) : [
            360 * eu(),
            180 * eu()
        ];
    }
    function Qa(t, e) {
        void 0 === e && (e = {}), null == t && (t = 1);
        for(var n = [], r = 0; r < t; r++)n.push(a(Ka(e.bbox)));
        return f(n);
    }
    function $a(t, e) {
        void 0 === e && (e = {}), null == t && (t = 1), C(e.num_vertices) && void 0 !== e.num_vertices || (e.num_vertices = 10), C(e.max_radial_length) && void 0 !== e.max_radial_length || (e.max_radial_length = 10);
        for(var n = [], r = function(t) {
            var r, i = [], o = Za(Array(e.num_vertices + 1)).map(Math.random);
            o.forEach(function(t, e, n) {
                n[e] = e > 0 ? t + n[e - 1] : t;
            }), o.forEach(function(t) {
                t = 2 * t * Math.PI / o[o.length - 1];
                var n = Math.random();
                i.push([
                    n * (e.max_radial_length || 10) * Math.sin(t),
                    n * (e.max_radial_length || 10) * Math.cos(t)
                ]);
            }), i[i.length - 1] = i[0], i = i.map((r = Ka(e.bbox), function(t) {
                return [
                    t[0] + r[0],
                    t[1] + r[1]
                ];
            })), n.push(l([
                i
            ]));
        }, i = 0; i < t; i++)r();
        return f(n);
    }
    function tu(t, e) {
        if (void 0 === e && (e = {}), !P(e = e || {})) throw new Error("options is invalid");
        var n = e.bbox, r = e.num_vertices, i = e.max_length, o = e.max_rotation;
        null == t && (t = 1), (!C(r) || void 0 === r || r < 2) && (r = 10), C(i) && void 0 !== i || (i = 1e-4), C(o) && void 0 !== o || (o = Math.PI / 8);
        for(var s = [], a = 0; a < t; a++){
            for(var u = [
                Ka(n)
            ], l = 0; l < r - 1; l++){
                var c = (0 === l ? 2 * Math.random() * Math.PI : Math.tan((u[l][1] - u[l - 1][1]) / (u[l][0] - u[l - 1][0]))) + (Math.random() - .5) * o * 2, p = Math.random() * i;
                u.push([
                    u[l][0] + p * Math.cos(c),
                    u[l][1] + p * Math.sin(c)
                ]);
            }
            s.push(h(u));
        }
        return f(s);
    }
    function eu() {
        return Math.random() - .5;
    }
    function nu(t) {
        return [
            Math.random() * (t[2] - t[0]) + t[0],
            Math.random() * (t[3] - t[1]) + t[1]
        ];
    }
    var ru = Object.freeze({
        __proto__: null,
        randomPosition: Ka,
        randomPoint: Qa,
        randomPolygon: $a,
        randomLineString: tu
    });
    function iu(t, e) {
        if (!t) throw new Error("geojson is required");
        if ("FeatureCollection" !== t.type) throw new Error("geojson must be a FeatureCollection");
        if (null == e) throw new Error("filter is required");
        var n = [];
        return F(t, function(t) {
            uu(t.properties, e) && n.push(t);
        }), f(n);
    }
    function ou(t, e, n) {
        if (!t) throw new Error("geojson is required");
        if ("FeatureCollection" !== t.type) throw new Error("geojson must be a FeatureCollection");
        if (null == e) throw new Error("property is required");
        for(var r = au(t, e), i = Object.keys(r), o = 0; o < i.length; o++){
            for(var s = i[o], a = r[s], u = [], l = 0; l < a.length; l++)u.push(t.features[a[l]]);
            n(f(u), s, o);
        }
    }
    function su(t, e, n, r) {
        var i = r;
        return ou(t, e, function(t, e, o) {
            i = 0 === o && void 0 === r ? t : n(i, t, e, o);
        }), i;
    }
    function au(t, e) {
        var n = {};
        return F(t, function(t, r) {
            var i = t.properties || {};
            if (Object.prototype.hasOwnProperty.call(i, String(e))) {
                var o = i[e];
                Object.prototype.hasOwnProperty.call(n, o) ? n[o].push(r) : n[o] = [
                    r
                ];
            }
        }), n;
    }
    function uu(t, e) {
        if (void 0 === t) return !1;
        var n = typeof e;
        if ("number" === n || "string" === n) return Object.prototype.hasOwnProperty.call(t, e);
        if (Array.isArray(e)) {
            for(var r = 0; r < e.length; r++)if (!uu(t, e[r])) return !1;
            return !0;
        }
        return lu(t, e);
    }
    function lu(t, e) {
        for(var n = Object.keys(e), r = 0; r < n.length; r++){
            var i = n[r];
            if (t[i] !== e[i]) return !1;
        }
        return !0;
    }
    function cu(t, e) {
        if (!e) return {};
        if (!e.length) return {};
        for(var n = {}, r = 0; r < e.length; r++){
            var i = e[r];
            Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
        }
        return n;
    }
    var hu = Object.freeze({
        __proto__: null,
        getCluster: iu,
        clusterEach: ou,
        clusterReduce: su,
        createBins: au,
        applyFilter: uu,
        propertiesContainsFilter: lu,
        filterProperties: cu
    }), pu = function(t, e) {
        this.next = null, this.key = t, this.data = e, this.left = null, this.right = null;
    };
    /**
     * splaytree v3.1.0
     * Fast Splay tree for Node and browser
     *
     * @author Alexander Milevski <info@w8r.name>
     * @license MIT
     * @preserve
     */ function fu(t, e) {
        return t > e ? 1 : t < e ? -1 : 0;
    }
    function gu(t, e, n) {
        for(var r = new pu(null, null), i = r, o = r;;){
            var s = n(t, e.key);
            if (s < 0) {
                if (null === e.left) break;
                if (n(t, e.left.key) < 0) {
                    var a = e.left;
                    if (e.left = a.right, a.right = e, null === (e = a).left) break;
                }
                o.left = e, o = e, e = e.left;
            } else {
                if (!(s > 0)) break;
                if (null === e.right) break;
                if (n(t, e.right.key) > 0) {
                    a = e.right;
                    if (e.right = a.left, a.left = e, null === (e = a).right) break;
                }
                i.right = e, i = e, e = e.right;
            }
        }
        return i.right = e.left, o.left = e.right, e.left = r.right, e.right = r.left, e;
    }
    function du(t, e, n, r) {
        var i = new pu(t, e);
        if (null === n) return i.left = i.right = null, i;
        var o = r(t, (n = gu(t, n, r)).key);
        return o < 0 ? (i.left = n.left, i.right = n, n.left = null) : o >= 0 && (i.right = n.right, i.left = n, n.right = null), i;
    }
    function yu(t, e, n) {
        var r = null, i = null;
        if (e) {
            var o = n((e = gu(t, e, n)).key, t);
            0 === o ? (r = e.left, i = e.right) : o < 0 ? (i = e.right, e.right = null, r = e) : (r = e.left, e.left = null, i = e);
        }
        return {
            left: r,
            right: i
        };
    }
    function vu(t, e, n, r, i) {
        if (t) {
            r(e + (n ? "\u2514\u2500\u2500 " : "\u251C\u2500\u2500 ") + i(t) + "\n");
            var o = e + (n ? "    " : "\u2502   ");
            t.left && vu(t.left, o, !1, r, i), t.right && vu(t.right, o, !0, r, i);
        }
    }
    var _u = function() {
        function t(t) {
            void 0 === t && (t = fu), this._root = null, this._size = 0, this._comparator = t;
        }
        return t.prototype.insert = function(t, e) {
            return this._size++, this._root = du(t, e, this._root, this._comparator);
        }, t.prototype.add = function(t, e) {
            var n = new pu(t, e);
            null === this._root && (n.left = n.right = null, this._size++, this._root = n);
            var r = this._comparator, i = gu(t, this._root, r), o = r(t, i.key);
            return 0 === o ? this._root = i : (o < 0 ? (n.left = i.left, n.right = i, i.left = null) : o > 0 && (n.right = i.right, n.left = i, i.right = null), this._size++, this._root = n), this._root;
        }, t.prototype.remove = function(t) {
            this._root = this._remove(t, this._root, this._comparator);
        }, t.prototype._remove = function(t, e, n) {
            var r;
            return null === e ? null : 0 === n(t, (e = gu(t, e, n)).key) ? (null === e.left ? r = e.right : (r = gu(t, e.left, n)).right = e.right, this._size--, r) : e;
        }, t.prototype.pop = function() {
            var t = this._root;
            if (t) {
                for(; t.left;)t = t.left;
                return this._root = gu(t.key, this._root, this._comparator), this._root = this._remove(t.key, this._root, this._comparator), {
                    key: t.key,
                    data: t.data
                };
            }
            return null;
        }, t.prototype.findStatic = function(t) {
            for(var e = this._root, n = this._comparator; e;){
                var r = n(t, e.key);
                if (0 === r) return e;
                e = r < 0 ? e.left : e.right;
            }
            return null;
        }, t.prototype.find = function(t) {
            return this._root && (this._root = gu(t, this._root, this._comparator), 0 !== this._comparator(t, this._root.key)) ? null : this._root;
        }, t.prototype.contains = function(t) {
            for(var e = this._root, n = this._comparator; e;){
                var r = n(t, e.key);
                if (0 === r) return !0;
                e = r < 0 ? e.left : e.right;
            }
            return !1;
        }, t.prototype.forEach = function(t, e) {
            for(var n = this._root, r = [], i = !1; !i;)null !== n ? (r.push(n), n = n.left) : 0 !== r.length ? (n = r.pop(), t.call(e, n), n = n.right) : i = !0;
            return this;
        }, t.prototype.range = function(t, e, n, r) {
            for(var i = [], o = this._comparator, s = this._root; 0 !== i.length || s;)if (s) i.push(s), s = s.left;
            else {
                if (o((s = i.pop()).key, e) > 0) break;
                if (o(s.key, t) >= 0 && n.call(r, s)) return this;
                s = s.right;
            }
            return this;
        }, t.prototype.keys = function() {
            var t = [];
            return this.forEach(function(e) {
                var n = e.key;
                return t.push(n);
            }), t;
        }, t.prototype.values = function() {
            var t = [];
            return this.forEach(function(e) {
                var n = e.data;
                return t.push(n);
            }), t;
        }, t.prototype.min = function() {
            return this._root ? this.minNode(this._root).key : null;
        }, t.prototype.max = function() {
            return this._root ? this.maxNode(this._root).key : null;
        }, t.prototype.minNode = function(t) {
            if (void 0 === t && (t = this._root), t) for(; t.left;)t = t.left;
            return t;
        }, t.prototype.maxNode = function(t) {
            if (void 0 === t && (t = this._root), t) for(; t.right;)t = t.right;
            return t;
        }, t.prototype.at = function(t) {
            for(var e = this._root, n = !1, r = 0, i = []; !n;)if (e) i.push(e), e = e.left;
            else if (i.length > 0) {
                if (e = i.pop(), r === t) return e;
                r++, e = e.right;
            } else n = !0;
            return null;
        }, t.prototype.next = function(t) {
            var e = this._root, n = null;
            if (t.right) {
                for(n = t.right; n.left;)n = n.left;
                return n;
            }
            for(var r = this._comparator; e;){
                var i = r(t.key, e.key);
                if (0 === i) break;
                i < 0 ? (n = e, e = e.left) : e = e.right;
            }
            return n;
        }, t.prototype.prev = function(t) {
            var e = this._root, n = null;
            if (null !== t.left) {
                for(n = t.left; n.right;)n = n.right;
                return n;
            }
            for(var r = this._comparator; e;){
                var i = r(t.key, e.key);
                if (0 === i) break;
                i < 0 ? e = e.left : (n = e, e = e.right);
            }
            return n;
        }, t.prototype.clear = function() {
            return this._root = null, this._size = 0, this;
        }, t.prototype.toList = function() {
            return function(t) {
                var e = t, n = [], r = !1, i = new pu(null, null), o = i;
                for(; !r;)e ? (n.push(e), e = e.left) : n.length > 0 ? e = (e = o = o.next = n.pop()).right : r = !0;
                return o.next = null, i.next;
            }(this._root);
        }, t.prototype.load = function(t, e, n) {
            void 0 === e && (e = []), void 0 === n && (n = !1);
            var r = t.length, i = this._comparator;
            if (n && Eu(t, e, 0, r - 1, i), null === this._root) this._root = mu(t, e, 0, r), this._size = r;
            else {
                var o = function(t, e, n) {
                    var r = new pu(null, null), i = r, o = t, s = e;
                    for(; null !== o && null !== s;)n(o.key, s.key) < 0 ? (i.next = o, o = o.next) : (i.next = s, s = s.next), i = i.next;
                    null !== o ? i.next = o : null !== s && (i.next = s);
                    return r.next;
                }(this.toList(), function(t, e) {
                    for(var n = new pu(null, null), r = n, i = 0; i < t.length; i++)r = r.next = new pu(t[i], e[i]);
                    return r.next = null, n.next;
                }(t, e), i);
                r = this._size + r, this._root = xu({
                    head: o
                }, 0, r);
            }
            return this;
        }, t.prototype.isEmpty = function() {
            return null === this._root;
        }, Object.defineProperty(t.prototype, "size", {
            get: function() {
                return this._size;
            },
            enumerable: !0,
            configurable: !0
        }), Object.defineProperty(t.prototype, "root", {
            get: function() {
                return this._root;
            },
            enumerable: !0,
            configurable: !0
        }), t.prototype.toString = function(t) {
            void 0 === t && (t = function(t) {
                return String(t.key);
            });
            var e = [];
            return vu(this._root, "", !0, function(t) {
                return e.push(t);
            }, t), e.join("");
        }, t.prototype.update = function(t, e, n) {
            var r = this._comparator, i = yu(t, this._root, r), o = i.left, s = i.right;
            r(t, e) < 0 ? s = du(e, n, s, r) : o = du(e, n, o, r), this._root = function(t, e, n) {
                return null === e ? t : (null === t || ((e = gu(t.key, e, n)).left = t), e);
            }(o, s, r);
        }, t.prototype.split = function(t) {
            return yu(t, this._root, this._comparator);
        }, t;
    }();
    function mu(t, e, n, r) {
        var i = r - n;
        if (i > 0) {
            var o = n + Math.floor(i / 2), s = t[o], a = e[o], u = new pu(s, a);
            return u.left = mu(t, e, n, o), u.right = mu(t, e, o + 1, r), u;
        }
        return null;
    }
    function xu(t, e, n) {
        var r = n - e;
        if (r > 0) {
            var i = e + Math.floor(r / 2), o = xu(t, e, i), s = t.head;
            return s.left = o, t.head = t.head.next, s.right = xu(t, i + 1, n), s;
        }
        return null;
    }
    function Eu(t, e, n, r, i) {
        if (!(n >= r)) {
            for(var o = t[n + r >> 1], s = n - 1, a = r + 1;;){
                do s++;
                while (i(t[s], o) < 0);
                do a--;
                while (i(t[a], o) > 0);
                if (s >= a) break;
                var u = t[s];
                t[s] = t[a], t[a] = u, u = e[s], e[s] = e[a], e[a] = u;
            }
            Eu(t, e, n, a, i), Eu(t, e, a + 1, r, i);
        }
    }
    function bu(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function wu(t, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
    }
    function Iu(t, e, n) {
        return e && wu(t.prototype, e), n && wu(t, n), t;
    }
    var Nu = function(t, e) {
        return t.ll.x <= e.x && e.x <= t.ur.x && t.ll.y <= e.y && e.y <= t.ur.y;
    }, Su = function(t, e) {
        if (e.ur.x < t.ll.x || t.ur.x < e.ll.x || e.ur.y < t.ll.y || t.ur.y < e.ll.y) return null;
        var n = t.ll.x < e.ll.x ? e.ll.x : t.ll.x, r = t.ur.x < e.ur.x ? t.ur.x : e.ur.x;
        return {
            ll: {
                x: n,
                y: t.ll.y < e.ll.y ? e.ll.y : t.ll.y
            },
            ur: {
                x: r,
                y: t.ur.y < e.ur.y ? t.ur.y : e.ur.y
            }
        };
    }, Cu = Number.EPSILON;
    void 0 === Cu && (Cu = Math.pow(2, -52));
    var Pu = Cu * Cu, Mu = function(t, e) {
        if (-Cu < t && t < Cu && -Cu < e && e < Cu) return 0;
        var n = t - e;
        return n * n < Pu * t * e ? 0 : t < e ? -1 : 1;
    }, Lu = function() {
        function t() {
            bu(this, t), this.reset();
        }
        return Iu(t, [
            {
                key: "reset",
                value: function() {
                    this.xRounder = new Ou, this.yRounder = new Ou;
                }
            },
            {
                key: "round",
                value: function(t, e) {
                    return {
                        x: this.xRounder.round(t),
                        y: this.yRounder.round(e)
                    };
                }
            }
        ]), t;
    }(), Ou = function() {
        function t() {
            bu(this, t), this.tree = new _u, this.round(0);
        }
        return Iu(t, [
            {
                key: "round",
                value: function(t) {
                    var e = this.tree.add(t), n = this.tree.prev(e);
                    if (null !== n && 0 === Mu(e.key, n.key)) return this.tree.remove(t), n.key;
                    var r = this.tree.next(e);
                    return null !== r && 0 === Mu(e.key, r.key) ? (this.tree.remove(t), r.key) : t;
                }
            }
        ]), t;
    }(), Ru = new Lu, Tu = function(t, e) {
        return t.x * e.y - t.y * e.x;
    }, Au = function(t, e) {
        return t.x * e.x + t.y * e.y;
    }, Du = function(t, e, n) {
        var r = {
            x: e.x - t.x,
            y: e.y - t.y
        }, i = {
            x: n.x - t.x,
            y: n.y - t.y
        }, o = Tu(r, i);
        return Mu(o, 0);
    }, Fu = function(t) {
        return Math.sqrt(Au(t, t));
    }, ku = function(t, e, n) {
        var r = {
            x: e.x - t.x,
            y: e.y - t.y
        }, i = {
            x: n.x - t.x,
            y: n.y - t.y
        };
        return Au(i, r) / Fu(i) / Fu(r);
    }, Gu = function(t, e, n) {
        return 0 === e.y ? null : {
            x: t.x + e.x / e.y * (n - t.y),
            y: n
        };
    }, qu = function(t, e, n) {
        return 0 === e.x ? null : {
            x: n,
            y: t.y + e.y / e.x * (n - t.x)
        };
    }, Bu = function() {
        function t(e, n) {
            bu(this, t), void 0 === e.events ? e.events = [
                this
            ] : e.events.push(this), this.point = e, this.isLeft = n;
        }
        return Iu(t, null, [
            {
                key: "compare",
                value: function(e, n) {
                    var r = t.comparePoints(e.point, n.point);
                    return 0 !== r ? r : (e.point !== n.point && e.link(n), e.isLeft !== n.isLeft ? e.isLeft ? 1 : -1 : ju.compare(e.segment, n.segment));
                }
            },
            {
                key: "comparePoints",
                value: function(t, e) {
                    return t.x < e.x ? -1 : t.x > e.x ? 1 : t.y < e.y ? -1 : t.y > e.y ? 1 : 0;
                }
            }
        ]), Iu(t, [
            {
                key: "link",
                value: function(t) {
                    if (t.point === this.point) throw new Error("Tried to link already linked events");
                    for(var e = t.point.events, n = 0, r = e.length; n < r; n++){
                        var i = e[n];
                        this.point.events.push(i), i.point = this.point;
                    }
                    this.checkForConsuming();
                }
            },
            {
                key: "checkForConsuming",
                value: function() {
                    for(var t = this.point.events.length, e = 0; e < t; e++){
                        var n = this.point.events[e];
                        if (void 0 === n.segment.consumedBy) for(var r = e + 1; r < t; r++){
                            var i = this.point.events[r];
                            void 0 === i.consumedBy && n.otherSE.point.events === i.otherSE.point.events && n.segment.consume(i.segment);
                        }
                    }
                }
            },
            {
                key: "getAvailableLinkedEvents",
                value: function() {
                    for(var t = [], e = 0, n = this.point.events.length; e < n; e++){
                        var r = this.point.events[e];
                        r !== this && !r.segment.ringOut && r.segment.isInResult() && t.push(r);
                    }
                    return t;
                }
            },
            {
                key: "getLeftmostComparator",
                value: function(t) {
                    var e = this, n = new Map, r = function(r) {
                        var i, o, s, a, u, l = r.otherSE;
                        n.set(r, {
                            sine: (i = e.point, o = t.point, s = l.point, a = {
                                x: o.x - i.x,
                                y: o.y - i.y
                            }, u = {
                                x: s.x - i.x,
                                y: s.y - i.y
                            }, Tu(u, a) / Fu(u) / Fu(a)),
                            cosine: ku(e.point, t.point, l.point)
                        });
                    };
                    return function(t, e) {
                        n.has(t) || r(t), n.has(e) || r(e);
                        var i = n.get(t), o = i.sine, s = i.cosine, a = n.get(e), u = a.sine, l = a.cosine;
                        return o >= 0 && u >= 0 ? s < l ? 1 : s > l ? -1 : 0 : o < 0 && u < 0 ? s < l ? -1 : s > l ? 1 : 0 : u < o ? -1 : u > o ? 1 : 0;
                    };
                }
            }
        ]), t;
    }(), zu = 0, ju = function() {
        function t(e, n, r, i) {
            bu(this, t), this.id = ++zu, this.leftSE = e, e.segment = this, e.otherSE = n, this.rightSE = n, n.segment = this, n.otherSE = e, this.rings = r, this.windings = i;
        }
        return Iu(t, null, [
            {
                key: "compare",
                value: function(t, e) {
                    var n = t.leftSE.point.x, r = e.leftSE.point.x, i = t.rightSE.point.x, o = e.rightSE.point.x;
                    if (o < n) return 1;
                    if (i < r) return -1;
                    var s = t.leftSE.point.y, a = e.leftSE.point.y, u = t.rightSE.point.y, l = e.rightSE.point.y;
                    if (n < r) {
                        if (a < s && a < u) return 1;
                        if (a > s && a > u) return -1;
                        var c = t.comparePoint(e.leftSE.point);
                        if (c < 0) return 1;
                        if (c > 0) return -1;
                        var h = e.comparePoint(t.rightSE.point);
                        return 0 !== h ? h : -1;
                    }
                    if (n > r) {
                        if (s < a && s < l) return -1;
                        if (s > a && s > l) return 1;
                        var p = e.comparePoint(t.leftSE.point);
                        if (0 !== p) return p;
                        var f = t.comparePoint(e.rightSE.point);
                        return f < 0 ? 1 : f > 0 ? -1 : 1;
                    }
                    if (s < a) return -1;
                    if (s > a) return 1;
                    if (i < o) {
                        var g = e.comparePoint(t.rightSE.point);
                        if (0 !== g) return g;
                    }
                    if (i > o) {
                        var d = t.comparePoint(e.rightSE.point);
                        if (d < 0) return 1;
                        if (d > 0) return -1;
                    }
                    if (i !== o) {
                        var y = u - s, v = i - n, _ = l - a, m = o - r;
                        if (y > v && _ < m) return 1;
                        if (y < v && _ > m) return -1;
                    }
                    return i > o ? 1 : i < o || u < l ? -1 : u > l ? 1 : t.id < e.id ? -1 : t.id > e.id ? 1 : 0;
                }
            }
        ]), Iu(t, [
            {
                key: "replaceRightSE",
                value: function(t) {
                    this.rightSE = t, this.rightSE.segment = this, this.rightSE.otherSE = this.leftSE, this.leftSE.otherSE = this.rightSE;
                }
            },
            {
                key: "bbox",
                value: function() {
                    var t = this.leftSE.point.y, e = this.rightSE.point.y;
                    return {
                        ll: {
                            x: this.leftSE.point.x,
                            y: t < e ? t : e
                        },
                        ur: {
                            x: this.rightSE.point.x,
                            y: t > e ? t : e
                        }
                    };
                }
            },
            {
                key: "vector",
                value: function() {
                    return {
                        x: this.rightSE.point.x - this.leftSE.point.x,
                        y: this.rightSE.point.y - this.leftSE.point.y
                    };
                }
            },
            {
                key: "isAnEndpoint",
                value: function(t) {
                    return t.x === this.leftSE.point.x && t.y === this.leftSE.point.y || t.x === this.rightSE.point.x && t.y === this.rightSE.point.y;
                }
            },
            {
                key: "comparePoint",
                value: function(t) {
                    if (this.isAnEndpoint(t)) return 0;
                    var e = this.leftSE.point, n = this.rightSE.point, r = this.vector();
                    if (e.x === n.x) return t.x === e.x ? 0 : t.x < e.x ? 1 : -1;
                    var i = (t.y - e.y) / r.y, o = e.x + i * r.x;
                    if (t.x === o) return 0;
                    var s = (t.x - e.x) / r.x, a = e.y + s * r.y;
                    return t.y === a ? 0 : t.y < a ? -1 : 1;
                }
            },
            {
                key: "getIntersection",
                value: function(t) {
                    var e = this.bbox(), n = t.bbox(), r = Su(e, n);
                    if (null === r) return null;
                    var i = this.leftSE.point, o = this.rightSE.point, s = t.leftSE.point, a = t.rightSE.point, u = Nu(e, s) && 0 === this.comparePoint(s), l = Nu(n, i) && 0 === t.comparePoint(i), c = Nu(e, a) && 0 === this.comparePoint(a), h = Nu(n, o) && 0 === t.comparePoint(o);
                    if (l && u) return h && !c ? o : !h && c ? a : null;
                    if (l) return c && i.x === a.x && i.y === a.y ? null : i;
                    if (u) return h && o.x === s.x && o.y === s.y ? null : s;
                    if (h && c) return null;
                    if (h) return o;
                    if (c) return a;
                    var p = function(t, e, n, r) {
                        if (0 === e.x) return qu(n, r, t.x);
                        if (0 === r.x) return qu(t, e, n.x);
                        if (0 === e.y) return Gu(n, r, t.y);
                        if (0 === r.y) return Gu(t, e, n.y);
                        var i = Tu(e, r);
                        if (0 == i) return null;
                        var o = {
                            x: n.x - t.x,
                            y: n.y - t.y
                        }, s = Tu(o, e) / i, a = Tu(o, r) / i;
                        return {
                            x: (t.x + a * e.x + (n.x + s * r.x)) / 2,
                            y: (t.y + a * e.y + (n.y + s * r.y)) / 2
                        };
                    }(i, this.vector(), s, t.vector());
                    return null === p ? null : Nu(r, p) ? Ru.round(p.x, p.y) : null;
                }
            },
            {
                key: "split",
                value: function(e) {
                    var n = [], r = void 0 !== e.events, i = new Bu(e, !0), o = new Bu(e, !1), s = this.rightSE;
                    this.replaceRightSE(o), n.push(o), n.push(i);
                    var a = new t(i, s, this.rings.slice(), this.windings.slice());
                    return Bu.comparePoints(a.leftSE.point, a.rightSE.point) > 0 && a.swapEvents(), Bu.comparePoints(this.leftSE.point, this.rightSE.point) > 0 && this.swapEvents(), r && (i.checkForConsuming(), o.checkForConsuming()), n;
                }
            },
            {
                key: "swapEvents",
                value: function() {
                    var t = this.rightSE;
                    this.rightSE = this.leftSE, this.leftSE = t, this.leftSE.isLeft = !0, this.rightSE.isLeft = !1;
                    for(var e = 0, n = this.windings.length; e < n; e++)this.windings[e] *= -1;
                }
            },
            {
                key: "consume",
                value: function(e) {
                    for(var n = this, r = e; n.consumedBy;)n = n.consumedBy;
                    for(; r.consumedBy;)r = r.consumedBy;
                    var i = t.compare(n, r);
                    if (0 !== i) {
                        if (i > 0) {
                            var o = n;
                            n = r, r = o;
                        }
                        if (n.prev === r) {
                            var s = n;
                            n = r, r = s;
                        }
                        for(var a = 0, u = r.rings.length; a < u; a++){
                            var l = r.rings[a], c = r.windings[a], h = n.rings.indexOf(l);
                            -1 === h ? (n.rings.push(l), n.windings.push(c)) : n.windings[h] += c;
                        }
                        r.rings = null, r.windings = null, r.consumedBy = n, r.leftSE.consumedBy = n.leftSE, r.rightSE.consumedBy = n.rightSE;
                    }
                }
            },
            {
                key: "prevInResult",
                value: function() {
                    return void 0 !== this._prevInResult || (this.prev ? this.prev.isInResult() ? this._prevInResult = this.prev : this._prevInResult = this.prev.prevInResult() : this._prevInResult = null), this._prevInResult;
                }
            },
            {
                key: "beforeState",
                value: function() {
                    if (void 0 !== this._beforeState) return this._beforeState;
                    if (this.prev) {
                        var t = this.prev.consumedBy || this.prev;
                        this._beforeState = t.afterState();
                    } else this._beforeState = {
                        rings: [],
                        windings: [],
                        multiPolys: []
                    };
                    return this._beforeState;
                }
            },
            {
                key: "afterState",
                value: function() {
                    if (void 0 !== this._afterState) return this._afterState;
                    var t = this.beforeState();
                    this._afterState = {
                        rings: t.rings.slice(0),
                        windings: t.windings.slice(0),
                        multiPolys: []
                    };
                    for(var e = this._afterState.rings, n = this._afterState.windings, r = this._afterState.multiPolys, i = 0, o = this.rings.length; i < o; i++){
                        var s = this.rings[i], a = this.windings[i], u = e.indexOf(s);
                        -1 === u ? (e.push(s), n.push(a)) : n[u] += a;
                    }
                    for(var l = [], c = [], h = 0, p = e.length; h < p; h++)if (0 !== n[h]) {
                        var f = e[h], g = f.poly;
                        if (-1 === c.indexOf(g)) {
                            if (f.isExterior) l.push(g);
                            else {
                                -1 === c.indexOf(g) && c.push(g);
                                var d = l.indexOf(f.poly);
                                -1 !== d && l.splice(d, 1);
                            }
                        }
                    }
                    for(var y = 0, v = l.length; y < v; y++){
                        var _ = l[y].multiPoly;
                        -1 === r.indexOf(_) && r.push(_);
                    }
                    return this._afterState;
                }
            },
            {
                key: "isInResult",
                value: function() {
                    if (this.consumedBy) return !1;
                    if (void 0 !== this._isInResult) return this._isInResult;
                    var t = this.beforeState().multiPolys, e = this.afterState().multiPolys;
                    switch(Qu.type){
                        case "union":
                            var n = 0 === t.length, r = 0 === e.length;
                            this._isInResult = n !== r;
                            break;
                        case "intersection":
                            var i, o;
                            t.length < e.length ? (i = t.length, o = e.length) : (i = e.length, o = t.length), this._isInResult = o === Qu.numMultiPolys && i < o;
                            break;
                        case "xor":
                            var s = Math.abs(t.length - e.length);
                            this._isInResult = s % 2 == 1;
                            break;
                        case "difference":
                            var a = function(t) {
                                return 1 === t.length && t[0].isSubject;
                            };
                            this._isInResult = a(t) !== a(e);
                            break;
                        default:
                            throw new Error("Unrecognized operation type found ".concat(Qu.type));
                    }
                    return this._isInResult;
                }
            }
        ], [
            {
                key: "fromRing",
                value: function(e, n, r) {
                    var i, o, s, a = Bu.comparePoints(e, n);
                    if (a < 0) i = e, o = n, s = 1;
                    else {
                        if (!(a > 0)) throw new Error("Tried to create degenerate segment at [".concat(e.x, ", ").concat(e.y, "]"));
                        i = n, o = e, s = -1;
                    }
                    return new t(new Bu(i, !0), new Bu(o, !1), [
                        r
                    ], [
                        s
                    ]);
                }
            }
        ]), t;
    }(), Uu = function() {
        function t(e, n, r) {
            if (bu(this, t), !Array.isArray(e) || 0 === e.length) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            if (this.poly = n, this.isExterior = r, this.segments = [], "number" != typeof e[0][0] || "number" != typeof e[0][1]) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            var i = Ru.round(e[0][0], e[0][1]);
            this.bbox = {
                ll: {
                    x: i.x,
                    y: i.y
                },
                ur: {
                    x: i.x,
                    y: i.y
                }
            };
            for(var o = i, s = 1, a = e.length; s < a; s++){
                if ("number" != typeof e[s][0] || "number" != typeof e[s][1]) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
                var u = Ru.round(e[s][0], e[s][1]);
                u.x === o.x && u.y === o.y || (this.segments.push(ju.fromRing(o, u, this)), u.x < this.bbox.ll.x && (this.bbox.ll.x = u.x), u.y < this.bbox.ll.y && (this.bbox.ll.y = u.y), u.x > this.bbox.ur.x && (this.bbox.ur.x = u.x), u.y > this.bbox.ur.y && (this.bbox.ur.y = u.y), o = u);
            }
            i.x === o.x && i.y === o.y || this.segments.push(ju.fromRing(o, i, this));
        }
        return Iu(t, [
            {
                key: "getSweepEvents",
                value: function() {
                    for(var t = [], e = 0, n = this.segments.length; e < n; e++){
                        var r = this.segments[e];
                        t.push(r.leftSE), t.push(r.rightSE);
                    }
                    return t;
                }
            }
        ]), t;
    }(), Vu = function() {
        function t(e, n) {
            if (bu(this, t), !Array.isArray(e)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            this.exteriorRing = new Uu(e[0], this, !0), this.bbox = {
                ll: {
                    x: this.exteriorRing.bbox.ll.x,
                    y: this.exteriorRing.bbox.ll.y
                },
                ur: {
                    x: this.exteriorRing.bbox.ur.x,
                    y: this.exteriorRing.bbox.ur.y
                }
            }, this.interiorRings = [];
            for(var r = 1, i = e.length; r < i; r++){
                var o = new Uu(e[r], this, !1);
                o.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = o.bbox.ll.x), o.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = o.bbox.ll.y), o.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = o.bbox.ur.x), o.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = o.bbox.ur.y), this.interiorRings.push(o);
            }
            this.multiPoly = n;
        }
        return Iu(t, [
            {
                key: "getSweepEvents",
                value: function() {
                    for(var t = this.exteriorRing.getSweepEvents(), e = 0, n = this.interiorRings.length; e < n; e++)for(var r = this.interiorRings[e].getSweepEvents(), i = 0, o = r.length; i < o; i++)t.push(r[i]);
                    return t;
                }
            }
        ]), t;
    }(), Xu = function() {
        function t(e, n) {
            if (bu(this, t), !Array.isArray(e)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            try {
                "number" == typeof e[0][0][0] && (e = [
                    e
                ]);
            } catch (t) {}
            this.polys = [], this.bbox = {
                ll: {
                    x: Number.POSITIVE_INFINITY,
                    y: Number.POSITIVE_INFINITY
                },
                ur: {
                    x: Number.NEGATIVE_INFINITY,
                    y: Number.NEGATIVE_INFINITY
                }
            };
            for(var r = 0, i = e.length; r < i; r++){
                var o = new Vu(e[r], this);
                o.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = o.bbox.ll.x), o.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = o.bbox.ll.y), o.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = o.bbox.ur.x), o.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = o.bbox.ur.y), this.polys.push(o);
            }
            this.isSubject = n;
        }
        return Iu(t, [
            {
                key: "getSweepEvents",
                value: function() {
                    for(var t = [], e = 0, n = this.polys.length; e < n; e++)for(var r = this.polys[e].getSweepEvents(), i = 0, o = r.length; i < o; i++)t.push(r[i]);
                    return t;
                }
            }
        ]), t;
    }(), Yu = function() {
        function t(e) {
            bu(this, t), this.events = e;
            for(var n = 0, r = e.length; n < r; n++)e[n].segment.ringOut = this;
            this.poly = null;
        }
        return Iu(t, null, [
            {
                key: "factory",
                value: function(e) {
                    for(var n = [], r = 0, i = e.length; r < i; r++){
                        var o = e[r];
                        if (o.isInResult() && !o.ringOut) {
                            for(var s = null, a = o.leftSE, u = o.rightSE, l = [
                                a
                            ], c = a.point, h = []; s = a, a = u, l.push(a), a.point !== c;)for(;;){
                                var p = a.getAvailableLinkedEvents();
                                if (0 === p.length) {
                                    var f = l[0].point, g = l[l.length - 1].point;
                                    throw new Error("Unable to complete output ring starting at [".concat(f.x, ",") + " ".concat(f.y, "]. Last matching segment found ends at") + " [".concat(g.x, ", ").concat(g.y, "]."));
                                }
                                if (1 === p.length) {
                                    u = p[0].otherSE;
                                    break;
                                }
                                for(var d = null, y = 0, v = h.length; y < v; y++)if (h[y].point === a.point) {
                                    d = y;
                                    break;
                                }
                                if (null === d) {
                                    h.push({
                                        index: l.length,
                                        point: a.point
                                    });
                                    var _ = a.getLeftmostComparator(s);
                                    u = p.sort(_)[0].otherSE;
                                    break;
                                }
                                var m = h.splice(d)[0], x = l.splice(m.index);
                                x.unshift(x[0].otherSE), n.push(new t(x.reverse()));
                            }
                            n.push(new t(l));
                        }
                    }
                    return n;
                }
            }
        ]), Iu(t, [
            {
                key: "getGeom",
                value: function() {
                    for(var t = this.events[0].point, e = [
                        t
                    ], n = 1, r = this.events.length - 1; n < r; n++){
                        var i = this.events[n].point, o = this.events[n + 1].point;
                        0 !== Du(i, t, o) && (e.push(i), t = i);
                    }
                    if (1 === e.length) return null;
                    var s = e[0], a = e[1];
                    0 === Du(s, t, a) && e.shift(), e.push(e[0]);
                    for(var u = this.isExteriorRing() ? 1 : -1, l = this.isExteriorRing() ? 0 : e.length - 1, c = this.isExteriorRing() ? e.length : -1, h = [], p = l; p != c; p += u)h.push([
                        e[p].x,
                        e[p].y
                    ]);
                    return h;
                }
            },
            {
                key: "isExteriorRing",
                value: function() {
                    if (void 0 === this._isExteriorRing) {
                        var t = this.enclosingRing();
                        this._isExteriorRing = !t || !t.isExteriorRing();
                    }
                    return this._isExteriorRing;
                }
            },
            {
                key: "enclosingRing",
                value: function() {
                    return void 0 === this._enclosingRing && (this._enclosingRing = this._calcEnclosingRing()), this._enclosingRing;
                }
            },
            {
                key: "_calcEnclosingRing",
                value: function() {
                    for(var t = this.events[0], e = 1, n = this.events.length; e < n; e++){
                        var r = this.events[e];
                        Bu.compare(t, r) > 0 && (t = r);
                    }
                    for(var i = t.segment.prevInResult(), o = i ? i.prevInResult() : null;;){
                        if (!i) return null;
                        if (!o) return i.ringOut;
                        if (o.ringOut !== i.ringOut) return o.ringOut.enclosingRing() !== i.ringOut ? i.ringOut : i.ringOut.enclosingRing();
                        i = o.prevInResult(), o = i ? i.prevInResult() : null;
                    }
                }
            }
        ]), t;
    }(), Hu = function() {
        function t(e) {
            bu(this, t), this.exteriorRing = e, e.poly = this, this.interiorRings = [];
        }
        return Iu(t, [
            {
                key: "addInterior",
                value: function(t) {
                    this.interiorRings.push(t), t.poly = this;
                }
            },
            {
                key: "getGeom",
                value: function() {
                    var t = [
                        this.exteriorRing.getGeom()
                    ];
                    if (null === t[0]) return null;
                    for(var e = 0, n = this.interiorRings.length; e < n; e++){
                        var r = this.interiorRings[e].getGeom();
                        null !== r && t.push(r);
                    }
                    return t;
                }
            }
        ]), t;
    }(), Wu = function() {
        function t(e) {
            bu(this, t), this.rings = e, this.polys = this._composePolys(e);
        }
        return Iu(t, [
            {
                key: "getGeom",
                value: function() {
                    for(var t = [], e = 0, n = this.polys.length; e < n; e++){
                        var r = this.polys[e].getGeom();
                        null !== r && t.push(r);
                    }
                    return t;
                }
            },
            {
                key: "_composePolys",
                value: function(t) {
                    for(var e = [], n = 0, r = t.length; n < r; n++){
                        var i = t[n];
                        if (!i.poly) {
                            if (i.isExteriorRing()) e.push(new Hu(i));
                            else {
                                var o = i.enclosingRing();
                                o.poly || e.push(new Hu(o)), o.poly.addInterior(i);
                            }
                        }
                    }
                    return e;
                }
            }
        ]), t;
    }(), Ju = function() {
        function t(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ju.compare;
            bu(this, t), this.queue = e, this.tree = new _u(n), this.segments = [];
        }
        return Iu(t, [
            {
                key: "process",
                value: function(t) {
                    var e = t.segment, n = [];
                    if (t.consumedBy) return t.isLeft ? this.queue.remove(t.otherSE) : this.tree.remove(e), n;
                    var r = t.isLeft ? this.tree.insert(e) : this.tree.find(e);
                    if (!r) throw new Error("Unable to find segment #".concat(e.id, " ") + "[".concat(e.leftSE.point.x, ", ").concat(e.leftSE.point.y, "] -> ") + "[".concat(e.rightSE.point.x, ", ").concat(e.rightSE.point.y, "] ") + "in SweepLine tree. Please submit a bug report.");
                    for(var i = r, o = r, s = void 0, a = void 0; void 0 === s;)null === (i = this.tree.prev(i)) ? s = null : void 0 === i.key.consumedBy && (s = i.key);
                    for(; void 0 === a;)null === (o = this.tree.next(o)) ? a = null : void 0 === o.key.consumedBy && (a = o.key);
                    if (t.isLeft) {
                        var u = null;
                        if (s) {
                            var l = s.getIntersection(e);
                            if (null !== l && (e.isAnEndpoint(l) || (u = l), !s.isAnEndpoint(l))) for(var c = this._splitSafely(s, l), h = 0, p = c.length; h < p; h++)n.push(c[h]);
                        }
                        var f = null;
                        if (a) {
                            var g = a.getIntersection(e);
                            if (null !== g && (e.isAnEndpoint(g) || (f = g), !a.isAnEndpoint(g))) for(var d = this._splitSafely(a, g), y = 0, v = d.length; y < v; y++)n.push(d[y]);
                        }
                        if (null !== u || null !== f) {
                            var _ = null;
                            if (null === u) _ = f;
                            else if (null === f) _ = u;
                            else _ = Bu.comparePoints(u, f) <= 0 ? u : f;
                            this.queue.remove(e.rightSE), n.push(e.rightSE);
                            for(var m = e.split(_), x = 0, E = m.length; x < E; x++)n.push(m[x]);
                        }
                        n.length > 0 ? (this.tree.remove(e), n.push(t)) : (this.segments.push(e), e.prev = s);
                    } else {
                        if (s && a) {
                            var b = s.getIntersection(a);
                            if (null !== b) {
                                if (!s.isAnEndpoint(b)) for(var w = this._splitSafely(s, b), I = 0, N = w.length; I < N; I++)n.push(w[I]);
                                if (!a.isAnEndpoint(b)) for(var S = this._splitSafely(a, b), C = 0, P = S.length; C < P; C++)n.push(S[C]);
                            }
                        }
                        this.tree.remove(e);
                    }
                    return n;
                }
            },
            {
                key: "_splitSafely",
                value: function(t, e) {
                    this.tree.remove(t);
                    var n = t.rightSE;
                    this.queue.remove(n);
                    var r = t.split(e);
                    return r.push(n), void 0 === t.consumedBy && this.tree.insert(t), r;
                }
            }
        ]), t;
    }(), Zu = ("undefined" != typeof $hPtJY && undefined, 1e6), Ku = ("undefined" != typeof $hPtJY && undefined, 1e6), Qu = new (function() {
        function t() {
            bu(this, t);
        }
        return Iu(t, [
            {
                key: "run",
                value: function(t, e, n) {
                    Qu.type = t, Ru.reset();
                    for(var r = [
                        new Xu(e, !0)
                    ], i = 0, o = n.length; i < o; i++)r.push(new Xu(n[i], !1));
                    if (Qu.numMultiPolys = r.length, "difference" === Qu.type) for(var s = r[0], a = 1; a < r.length;)null !== Su(r[a].bbox, s.bbox) ? a++ : r.splice(a, 1);
                    if ("intersection" === Qu.type) {
                        for(var u = 0, l = r.length; u < l; u++)for(var c = r[u], h = u + 1, p = r.length; h < p; h++)if (null === Su(c.bbox, r[h].bbox)) return [];
                    }
                    for(var f = new _u(Bu.compare), g = 0, d = r.length; g < d; g++)for(var y = r[g].getSweepEvents(), v = 0, _ = y.length; v < _; v++)if (f.insert(y[v]), f.size > Zu) throw new Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big). Please file a bug report.");
                    for(var m = new Ju(f), x = f.size, E = f.pop(); E;){
                        var b = E.key;
                        if (f.size === x) {
                            var w = b.segment;
                            throw new Error("Unable to pop() ".concat(b.isLeft ? "left" : "right", " SweepEvent ") + "[".concat(b.point.x, ", ").concat(b.point.y, "] from segment #").concat(w.id, " ") + "[".concat(w.leftSE.point.x, ", ").concat(w.leftSE.point.y, "] -> ") + "[".concat(w.rightSE.point.x, ", ").concat(w.rightSE.point.y, "] from queue. ") + "Please file a bug report.");
                        }
                        if (f.size > Zu) throw new Error("Infinite loop when passing sweep line over endpoints (queue size too big). Please file a bug report.");
                        if (m.segments.length > Ku) throw new Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments). Please file a bug report.");
                        for(var I = m.process(b), N = 0, S = I.length; N < S; N++){
                            var C = I[N];
                            void 0 === C.consumedBy && f.insert(C);
                        }
                        x = f.size, E = f.pop();
                    }
                    Ru.reset();
                    var P = Yu.factory(m.segments);
                    return new Wu(P).getGeom();
                }
            }
        ]), t;
    }()), $u = {
        union: function(t) {
            for(var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)n[r - 1] = arguments[r];
            return Qu.run("union", t, n);
        },
        intersection: function(t) {
            for(var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)n[r - 1] = arguments[r];
            return Qu.run("intersection", t, n);
        },
        xor: function(t) {
            for(var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)n[r - 1] = arguments[r];
            return Qu.run("xor", t, n);
        },
        difference: function(t) {
            for(var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)n[r - 1] = arguments[r];
            return Qu.run("difference", t, n);
        }
    };
    "fill" in Array.prototype || Object.defineProperty(Array.prototype, "fill", {
        configurable: !0,
        value: function(t) {
            if (null == this) throw new TypeError(this + " is not an object");
            var e = Object(this), n = Math.max(Math.min(e.length, 9007199254740991), 0) || 0, r = 1 in arguments && parseInt(Number(arguments[1]), 10) || 0;
            r = r < 0 ? Math.max(n + r, 0) : Math.min(r, n);
            var i = 2 in arguments && void 0 !== arguments[2] ? parseInt(Number(arguments[2]), 10) || 0 : n;
            for(i = i < 0 ? Math.max(n + arguments[2], 0) : Math.min(i, n); r < i;)e[r] = t, ++r;
            return e;
        },
        writable: !0
    }), Number.isFinite = Number.isFinite || function(t) {
        return "number" == typeof t && isFinite(t);
    }, Number.isInteger = Number.isInteger || function(t) {
        return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
    }, Number.parseFloat = Number.parseFloat || parseFloat, Number.isNaN = Number.isNaN || function(t) {
        return t != t;
    }, Math.trunc = Math.trunc || function(t) {
        return t < 0 ? Math.ceil(t) : Math.floor(t);
    };
    var tl = function() {};
    tl.prototype.interfaces_ = function() {
        return [];
    }, tl.prototype.getClass = function() {
        return tl;
    }, tl.prototype.equalsWithTolerance = function(t, e, n) {
        return Math.abs(t - e) <= n;
    };
    var el = function(t) {
        function e(e) {
            t.call(this, e), this.name = "IllegalArgumentException", this.message = e, this.stack = (new t).stack;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
    }(Error), nl = function() {}, rl = {
        MAX_VALUE: {
            configurable: !0
        }
    };
    nl.isNaN = function(t) {
        return Number.isNaN(t);
    }, nl.doubleToLongBits = function(t) {
        return t;
    }, nl.longBitsToDouble = function(t) {
        return t;
    }, nl.isInfinite = function(t) {
        return !Number.isFinite(t);
    }, rl.MAX_VALUE.get = function() {
        return Number.MAX_VALUE;
    }, Object.defineProperties(nl, rl);
    var il = function() {}, ol = function() {}, sl = function() {};
    function al() {}
    var ul = function t() {
        if (this.x = null, this.y = null, this.z = null, 0 === arguments.length) this.x = 0, this.y = 0, this.z = t.NULL_ORDINATE;
        else if (1 === arguments.length) {
            var e = arguments[0];
            this.x = e.x, this.y = e.y, this.z = e.z;
        } else 2 === arguments.length ? (this.x = arguments[0], this.y = arguments[1], this.z = t.NULL_ORDINATE) : 3 === arguments.length && (this.x = arguments[0], this.y = arguments[1], this.z = arguments[2]);
    }, ll = {
        DimensionalComparator: {
            configurable: !0
        },
        serialVersionUID: {
            configurable: !0
        },
        NULL_ORDINATE: {
            configurable: !0
        },
        X: {
            configurable: !0
        },
        Y: {
            configurable: !0
        },
        Z: {
            configurable: !0
        }
    };
    ul.prototype.setOrdinate = function(t, e) {
        switch(t){
            case ul.X:
                this.x = e;
                break;
            case ul.Y:
                this.y = e;
                break;
            case ul.Z:
                this.z = e;
                break;
            default:
                throw new el("Invalid ordinate index: " + t);
        }
    }, ul.prototype.equals2D = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this.x === t.x && this.y === t.y;
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return !!tl.equalsWithTolerance(this.x, e.x, n) && !!tl.equalsWithTolerance(this.y, e.y, n);
        }
    }, ul.prototype.getOrdinate = function(t) {
        switch(t){
            case ul.X:
                return this.x;
            case ul.Y:
                return this.y;
            case ul.Z:
                return this.z;
        }
        throw new el("Invalid ordinate index: " + t);
    }, ul.prototype.equals3D = function(t) {
        return this.x === t.x && this.y === t.y && (this.z === t.z || nl.isNaN(this.z)) && nl.isNaN(t.z);
    }, ul.prototype.equals = function(t) {
        return t instanceof ul && this.equals2D(t);
    }, ul.prototype.equalInZ = function(t, e) {
        return tl.equalsWithTolerance(this.z, t.z, e);
    }, ul.prototype.compareTo = function(t) {
        var e = t;
        return this.x < e.x ? -1 : this.x > e.x ? 1 : this.y < e.y ? -1 : this.y > e.y ? 1 : 0;
    }, ul.prototype.clone = function() {}, ul.prototype.copy = function() {
        return new ul(this);
    }, ul.prototype.toString = function() {
        return "(" + this.x + ", " + this.y + ", " + this.z + ")";
    }, ul.prototype.distance3D = function(t) {
        var e = this.x - t.x, n = this.y - t.y, r = this.z - t.z;
        return Math.sqrt(e * e + n * n + r * r);
    }, ul.prototype.distance = function(t) {
        var e = this.x - t.x, n = this.y - t.y;
        return Math.sqrt(e * e + n * n);
    }, ul.prototype.hashCode = function() {
        var t = 17;
        return t = 37 * (t = 37 * t + ul.hashCode(this.x)) + ul.hashCode(this.y);
    }, ul.prototype.setCoordinate = function(t) {
        this.x = t.x, this.y = t.y, this.z = t.z;
    }, ul.prototype.interfaces_ = function() {
        return [
            il,
            ol,
            al
        ];
    }, ul.prototype.getClass = function() {
        return ul;
    }, ul.hashCode = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = nl.doubleToLongBits(t);
            return Math.trunc((e ^ e) >>> 32);
        }
    }, ll.DimensionalComparator.get = function() {
        return cl;
    }, ll.serialVersionUID.get = function() {
        return 0x5cbf2c235c7e5800;
    }, ll.NULL_ORDINATE.get = function() {
        return nl.NaN;
    }, ll.X.get = function() {
        return 0;
    }, ll.Y.get = function() {
        return 1;
    }, ll.Z.get = function() {
        return 2;
    }, Object.defineProperties(ul, ll);
    var cl = function(t) {
        if (this._dimensionsToTest = 2, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var e = arguments[0];
            if (2 !== e && 3 !== e) throw new el("only 2 or 3 dimensions may be specified");
            this._dimensionsToTest = e;
        }
    };
    cl.prototype.compare = function(t, e) {
        var n = t, r = e, i = cl.compare(n.x, r.x);
        if (0 !== i) return i;
        var o = cl.compare(n.y, r.y);
        return 0 !== o ? o : this._dimensionsToTest <= 2 ? 0 : cl.compare(n.z, r.z);
    }, cl.prototype.interfaces_ = function() {
        return [
            sl
        ];
    }, cl.prototype.getClass = function() {
        return cl;
    }, cl.compare = function(t, e) {
        return t < e ? -1 : t > e ? 1 : nl.isNaN(t) ? nl.isNaN(e) ? 0 : -1 : nl.isNaN(e) ? 1 : 0;
    };
    var hl = function() {};
    hl.prototype.create = function() {}, hl.prototype.interfaces_ = function() {
        return [];
    }, hl.prototype.getClass = function() {
        return hl;
    };
    var pl = function() {}, fl = {
        INTERIOR: {
            configurable: !0
        },
        BOUNDARY: {
            configurable: !0
        },
        EXTERIOR: {
            configurable: !0
        },
        NONE: {
            configurable: !0
        }
    };
    pl.prototype.interfaces_ = function() {
        return [];
    }, pl.prototype.getClass = function() {
        return pl;
    }, pl.toLocationSymbol = function(t) {
        switch(t){
            case pl.EXTERIOR:
                return "e";
            case pl.BOUNDARY:
                return "b";
            case pl.INTERIOR:
                return "i";
            case pl.NONE:
                return "-";
        }
        throw new el("Unknown location value: " + t);
    }, fl.INTERIOR.get = function() {
        return 0;
    }, fl.BOUNDARY.get = function() {
        return 1;
    }, fl.EXTERIOR.get = function() {
        return 2;
    }, fl.NONE.get = function() {
        return -1;
    }, Object.defineProperties(pl, fl);
    var gl = function(t, e) {
        return t.interfaces_ && t.interfaces_().indexOf(e) > -1;
    }, dl = function() {}, yl = {
        LOG_10: {
            configurable: !0
        }
    };
    dl.prototype.interfaces_ = function() {
        return [];
    }, dl.prototype.getClass = function() {
        return dl;
    }, dl.log10 = function(t) {
        var e = Math.log(t);
        return nl.isInfinite(e) || nl.isNaN(e) ? e : e / dl.LOG_10;
    }, dl.min = function(t, e, n, r) {
        var i = t;
        return e < i && (i = e), n < i && (i = n), r < i && (i = r), i;
    }, dl.clamp = function() {
        if ("number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
            var t = arguments[0], e = arguments[1], n = arguments[2];
            return t < e ? e : t > n ? n : t;
        }
        if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
            var r = arguments[0], i = arguments[1], o = arguments[2];
            return r < i ? i : r > o ? o : r;
        }
    }, dl.wrap = function(t, e) {
        return t < 0 ? e - -t % e : t % e;
    }, dl.max = function() {
        if (3 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = arguments[2], r = t;
            return e > r && (r = e), n > r && (r = n), r;
        }
        if (4 === arguments.length) {
            var i = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3], u = i;
            return o > u && (u = o), s > u && (u = s), a > u && (u = a), u;
        }
    }, dl.average = function(t, e) {
        return (t + e) / 2;
    }, yl.LOG_10.get = function() {
        return Math.log(10);
    }, Object.defineProperties(dl, yl);
    var vl = function(t) {
        this.str = t;
    };
    vl.prototype.append = function(t) {
        this.str += t;
    }, vl.prototype.setCharAt = function(t, e) {
        this.str = this.str.substr(0, t) + e + this.str.substr(t + 1);
    }, vl.prototype.toString = function(t) {
        return this.str;
    };
    var _l = function(t) {
        this.value = t;
    };
    _l.prototype.intValue = function() {
        return this.value;
    }, _l.prototype.compareTo = function(t) {
        return this.value < t ? -1 : this.value > t ? 1 : 0;
    }, _l.isNaN = function(t) {
        return Number.isNaN(t);
    };
    var ml = function() {};
    ml.isWhitespace = function(t) {
        return t <= 32 && t >= 0 || 127 === t;
    }, ml.toUpperCase = function(t) {
        return t.toUpperCase();
    };
    var xl = function t() {
        if (this._hi = 0, this._lo = 0, 0 === arguments.length) this.init(0);
        else if (1 === arguments.length) {
            if ("number" == typeof arguments[0]) {
                var e = arguments[0];
                this.init(e);
            } else if (arguments[0] instanceof t) {
                var n = arguments[0];
                this.init(n);
            } else if ("string" == typeof arguments[0]) {
                var r = arguments[0];
                t.call(this, t.parse(r));
            }
        } else if (2 === arguments.length) {
            var i = arguments[0], o = arguments[1];
            this.init(i, o);
        }
    }, El = {
        PI: {
            configurable: !0
        },
        TWO_PI: {
            configurable: !0
        },
        PI_2: {
            configurable: !0
        },
        E: {
            configurable: !0
        },
        NaN: {
            configurable: !0
        },
        EPS: {
            configurable: !0
        },
        SPLIT: {
            configurable: !0
        },
        MAX_PRINT_DIGITS: {
            configurable: !0
        },
        TEN: {
            configurable: !0
        },
        ONE: {
            configurable: !0
        },
        SCI_NOT_EXPONENT_CHAR: {
            configurable: !0
        },
        SCI_NOT_ZERO: {
            configurable: !0
        }
    };
    xl.prototype.le = function(t) {
        return (this._hi < t._hi || this._hi === t._hi) && this._lo <= t._lo;
    }, xl.prototype.extractSignificantDigits = function(t, e) {
        var n = this.abs(), r = xl.magnitude(n._hi), i = xl.TEN.pow(r);
        (n = n.divide(i)).gt(xl.TEN) ? (n = n.divide(xl.TEN), r += 1) : n.lt(xl.ONE) && (n = n.multiply(xl.TEN), r -= 1);
        for(var o = r + 1, s = new vl, a = xl.MAX_PRINT_DIGITS - 1, u = 0; u <= a; u++){
            t && u === o && s.append(".");
            var l = Math.trunc(n._hi);
            if (l < 0) break;
            var c = !1, h = 0;
            l > 9 ? (c = !0, h = "9") : h = "0" + l, s.append(h), n = n.subtract(xl.valueOf(l)).multiply(xl.TEN), c && n.selfAdd(xl.TEN);
            var p = !0, f = xl.magnitude(n._hi);
            if (f < 0 && Math.abs(f) >= a - u && (p = !1), !p) break;
        }
        return e[0] = r, s.toString();
    }, xl.prototype.sqr = function() {
        return this.multiply(this);
    }, xl.prototype.doubleValue = function() {
        return this._hi + this._lo;
    }, xl.prototype.subtract = function() {
        if (arguments[0] instanceof xl) {
            var t = arguments[0];
            return this.add(t.negate());
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return this.add(-e);
        }
    }, xl.prototype.equals = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this._hi === t._hi && this._lo === t._lo;
        }
    }, xl.prototype.isZero = function() {
        return 0 === this._hi && 0 === this._lo;
    }, xl.prototype.selfSubtract = function() {
        if (arguments[0] instanceof xl) {
            var t = arguments[0];
            return this.isNaN() ? this : this.selfAdd(-t._hi, -t._lo);
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return this.isNaN() ? this : this.selfAdd(-e, 0);
        }
    }, xl.prototype.getSpecialNumberString = function() {
        return this.isZero() ? "0.0" : this.isNaN() ? "NaN " : null;
    }, xl.prototype.min = function(t) {
        return this.le(t) ? this : t;
    }, xl.prototype.selfDivide = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof xl) {
                var t = arguments[0];
                return this.selfDivide(t._hi, t._lo);
            }
            if ("number" == typeof arguments[0]) {
                var e = arguments[0];
                return this.selfDivide(e, 0);
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1], i = null, o = null, s = null, a = null, u = null, l = null, c = null, h = null;
            return u = this._hi / n, h = (i = (l = xl.SPLIT * u) - (i = l - u)) * (s = (h = xl.SPLIT * n) - (s = h - n)) - (c = u * n) + i * (a = n - s) + (o = u - i) * s + o * a, h = u + (l = (this._hi - c - h + this._lo - u * r) / n), this._hi = h, this._lo = u - h + l, this;
        }
    }, xl.prototype.dump = function() {
        return "DD<" + this._hi + ", " + this._lo + ">";
    }, xl.prototype.divide = function() {
        if (arguments[0] instanceof xl) {
            var t = arguments[0], e = null, n = null, r = null, i = null, o = null, s = null, a = null, u = null;
            n = (o = this._hi / t._hi) - (e = (s = xl.SPLIT * o) - (e = s - o)), u = e * (r = (u = xl.SPLIT * t._hi) - (r = u - t._hi)) - (a = o * t._hi) + e * (i = t._hi - r) + n * r + n * i;
            var l = u = o + (s = (this._hi - a - u + this._lo - o * t._lo) / t._hi), c = o - u + s;
            return new xl(l, c);
        }
        if ("number" == typeof arguments[0]) {
            var h = arguments[0];
            return nl.isNaN(h) ? xl.createNaN() : xl.copy(this).selfDivide(h, 0);
        }
    }, xl.prototype.ge = function(t) {
        return (this._hi > t._hi || this._hi === t._hi) && this._lo >= t._lo;
    }, xl.prototype.pow = function(t) {
        if (0 === t) return xl.valueOf(1);
        var e = new xl(this), n = xl.valueOf(1), r = Math.abs(t);
        if (r > 1) for(; r > 0;)r % 2 == 1 && n.selfMultiply(e), (r /= 2) > 0 && (e = e.sqr());
        else n = e;
        return t < 0 ? n.reciprocal() : n;
    }, xl.prototype.ceil = function() {
        if (this.isNaN()) return xl.NaN;
        var t = Math.ceil(this._hi), e = 0;
        return t === this._hi && (e = Math.ceil(this._lo)), new xl(t, e);
    }, xl.prototype.compareTo = function(t) {
        var e = t;
        return this._hi < e._hi ? -1 : this._hi > e._hi ? 1 : this._lo < e._lo ? -1 : this._lo > e._lo ? 1 : 0;
    }, xl.prototype.rint = function() {
        return this.isNaN() ? this : this.add(.5).floor();
    }, xl.prototype.setValue = function() {
        if (arguments[0] instanceof xl) {
            var t = arguments[0];
            return this.init(t), this;
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return this.init(e), this;
        }
    }, xl.prototype.max = function(t) {
        return this.ge(t) ? this : t;
    }, xl.prototype.sqrt = function() {
        if (this.isZero()) return xl.valueOf(0);
        if (this.isNegative()) return xl.NaN;
        var t = 1 / Math.sqrt(this._hi), e = this._hi * t, n = xl.valueOf(e), r = this.subtract(n.sqr())._hi * (.5 * t);
        return n.add(r);
    }, xl.prototype.selfAdd = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof xl) {
                var t = arguments[0];
                return this.selfAdd(t._hi, t._lo);
            }
            if ("number" == typeof arguments[0]) {
                var e = arguments[0], n = null, r = null, i = null, o = null, s = null, a = null;
                return o = (i = this._hi + e) - (s = i - this._hi), r = (a = (o = e - s + (this._hi - o)) + this._lo) + (i - (n = i + a)), this._hi = n + r, this._lo = r + (n - this._hi), this;
            }
        } else if (2 === arguments.length) {
            var u = arguments[0], l = arguments[1], c = null, h = null, p = null, f = null, g = null, d = null, y = null;
            f = this._hi + u, h = this._lo + l, g = f - (d = f - this._hi), p = h - (y = h - this._lo);
            var v = (c = f + (d = (g = u - d + (this._hi - g)) + h)) + (d = (p = l - y + (this._lo - p)) + (d + (f - c))), _ = d + (c - v);
            return this._hi = v, this._lo = _, this;
        }
    }, xl.prototype.selfMultiply = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof xl) {
                var t = arguments[0];
                return this.selfMultiply(t._hi, t._lo);
            }
            if ("number" == typeof arguments[0]) {
                var e = arguments[0];
                return this.selfMultiply(e, 0);
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1], i = null, o = null, s = null, a = null, u = null, l = null;
            i = (u = xl.SPLIT * this._hi) - this._hi, l = xl.SPLIT * n, i = u - i, o = this._hi - i, s = l - n;
            var c = (u = this._hi * n) + (l = i * (s = l - s) - u + i * (a = n - s) + o * s + o * a + (this._hi * r + this._lo * n)), h = l + (i = u - c);
            return this._hi = c, this._lo = h, this;
        }
    }, xl.prototype.selfSqr = function() {
        return this.selfMultiply(this);
    }, xl.prototype.floor = function() {
        if (this.isNaN()) return xl.NaN;
        var t = Math.floor(this._hi), e = 0;
        return t === this._hi && (e = Math.floor(this._lo)), new xl(t, e);
    }, xl.prototype.negate = function() {
        return this.isNaN() ? this : new xl(-this._hi, -this._lo);
    }, xl.prototype.clone = function() {}, xl.prototype.multiply = function() {
        if (arguments[0] instanceof xl) {
            var t = arguments[0];
            return t.isNaN() ? xl.createNaN() : xl.copy(this).selfMultiply(t);
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return nl.isNaN(e) ? xl.createNaN() : xl.copy(this).selfMultiply(e, 0);
        }
    }, xl.prototype.isNaN = function() {
        return nl.isNaN(this._hi);
    }, xl.prototype.intValue = function() {
        return Math.trunc(this._hi);
    }, xl.prototype.toString = function() {
        var t = xl.magnitude(this._hi);
        return t >= -3 && t <= 20 ? this.toStandardNotation() : this.toSciNotation();
    }, xl.prototype.toStandardNotation = function() {
        var t = this.getSpecialNumberString();
        if (null !== t) return t;
        var e = new Array(1).fill(null), n = this.extractSignificantDigits(!0, e), r = e[0] + 1, i = n;
        if ("." === n.charAt(0)) i = "0" + n;
        else if (r < 0) i = "0." + xl.stringOfChar("0", -r) + n;
        else if (-1 === n.indexOf(".")) {
            var o = r - n.length;
            i = n + xl.stringOfChar("0", o) + ".0";
        }
        return this.isNegative() ? "-" + i : i;
    }, xl.prototype.reciprocal = function() {
        var t, e, n, r, i = null, o = null, s = null, a = null;
        t = (n = 1 / this._hi) - (i = (s = xl.SPLIT * n) - (i = s - n)), o = (a = xl.SPLIT * this._hi) - this._hi;
        var u = n + (s = (1 - (r = n * this._hi) - (a = i * (o = a - o) - r + i * (e = this._hi - o) + t * o + t * e) - n * this._lo) / this._hi);
        return new xl(u, n - u + s);
    }, xl.prototype.toSciNotation = function() {
        if (this.isZero()) return xl.SCI_NOT_ZERO;
        var t = this.getSpecialNumberString();
        if (null !== t) return t;
        var e = new Array(1).fill(null), n = this.extractSignificantDigits(!1, e), r = xl.SCI_NOT_EXPONENT_CHAR + e[0];
        if ("0" === n.charAt(0)) throw new Error("Found leading zero: " + n);
        var i = "";
        n.length > 1 && (i = n.substring(1));
        var o = n.charAt(0) + "." + i;
        return this.isNegative() ? "-" + o + r : o + r;
    }, xl.prototype.abs = function() {
        return this.isNaN() ? xl.NaN : this.isNegative() ? this.negate() : new xl(this);
    }, xl.prototype.isPositive = function() {
        return (this._hi > 0 || 0 === this._hi) && this._lo > 0;
    }, xl.prototype.lt = function(t) {
        return (this._hi < t._hi || this._hi === t._hi) && this._lo < t._lo;
    }, xl.prototype.add = function() {
        if (arguments[0] instanceof xl) {
            var t = arguments[0];
            return xl.copy(this).selfAdd(t);
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return xl.copy(this).selfAdd(e);
        }
    }, xl.prototype.init = function() {
        if (1 === arguments.length) {
            if ("number" == typeof arguments[0]) {
                var t = arguments[0];
                this._hi = t, this._lo = 0;
            } else if (arguments[0] instanceof xl) {
                var e = arguments[0];
                this._hi = e._hi, this._lo = e._lo;
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1];
            this._hi = n, this._lo = r;
        }
    }, xl.prototype.gt = function(t) {
        return (this._hi > t._hi || this._hi === t._hi) && this._lo > t._lo;
    }, xl.prototype.isNegative = function() {
        return (this._hi < 0 || 0 === this._hi) && this._lo < 0;
    }, xl.prototype.trunc = function() {
        return this.isNaN() ? xl.NaN : this.isPositive() ? this.floor() : this.ceil();
    }, xl.prototype.signum = function() {
        return this._hi > 0 ? 1 : this._hi < 0 ? -1 : this._lo > 0 ? 1 : this._lo < 0 ? -1 : 0;
    }, xl.prototype.interfaces_ = function() {
        return [
            al,
            il,
            ol
        ];
    }, xl.prototype.getClass = function() {
        return xl;
    }, xl.sqr = function(t) {
        return xl.valueOf(t).selfMultiply(t);
    }, xl.valueOf = function() {
        if ("string" == typeof arguments[0]) {
            var t = arguments[0];
            return xl.parse(t);
        }
        if ("number" == typeof arguments[0]) {
            var e = arguments[0];
            return new xl(e);
        }
    }, xl.sqrt = function(t) {
        return xl.valueOf(t).sqrt();
    }, xl.parse = function(t) {
        for(var e = 0, n = t.length; ml.isWhitespace(t.charAt(e));)e++;
        var r = !1;
        if (e < n) {
            var i = t.charAt(e);
            "-" !== i && "+" !== i || (e++, "-" === i && (r = !0));
        }
        for(var o = new xl, s = 0, a = 0, u = 0; !(e >= n);){
            var l = t.charAt(e);
            if (e++, ml.isDigit(l)) {
                var c = l - "0";
                o.selfMultiply(xl.TEN), o.selfAdd(c), s++;
            } else {
                if ("." !== l) {
                    if ("e" === l || "E" === l) {
                        var h = t.substring(e);
                        try {
                            u = _l.parseInt(h);
                        } catch (e) {
                            throw e instanceof Error ? new Error("Invalid exponent " + h + " in string " + t) : e;
                        }
                        break;
                    }
                    throw new Error("Unexpected character '" + l + "' at position " + e + " in string " + t);
                }
                a = s;
            }
        }
        var p = o, f = s - a - u;
        if (0 === f) p = o;
        else if (f > 0) {
            var g = xl.TEN.pow(f);
            p = o.divide(g);
        } else if (f < 0) {
            var d = xl.TEN.pow(-f);
            p = o.multiply(d);
        }
        return r ? p.negate() : p;
    }, xl.createNaN = function() {
        return new xl(nl.NaN, nl.NaN);
    }, xl.copy = function(t) {
        return new xl(t);
    }, xl.magnitude = function(t) {
        var e = Math.abs(t), n = Math.log(e) / Math.log(10), r = Math.trunc(Math.floor(n));
        return 10 * Math.pow(10, r) <= e && (r += 1), r;
    }, xl.stringOfChar = function(t, e) {
        for(var n = new vl, r = 0; r < e; r++)n.append(t);
        return n.toString();
    }, El.PI.get = function() {
        return new xl(3.141592653589793, 12246467991473532e-32);
    }, El.TWO_PI.get = function() {
        return new xl(6.283185307179586, 24492935982947064e-32);
    }, El.PI_2.get = function() {
        return new xl(1.5707963267948966, 6123233995736766e-32);
    }, El.E.get = function() {
        return new xl(2.718281828459045, 14456468917292502e-32);
    }, El.NaN.get = function() {
        return new xl(nl.NaN, nl.NaN);
    }, El.EPS.get = function() {
        return 123259516440783e-46;
    }, El.SPLIT.get = function() {
        return 134217729;
    }, El.MAX_PRINT_DIGITS.get = function() {
        return 32;
    }, El.TEN.get = function() {
        return xl.valueOf(10);
    }, El.ONE.get = function() {
        return xl.valueOf(1);
    }, El.SCI_NOT_EXPONENT_CHAR.get = function() {
        return "E";
    }, El.SCI_NOT_ZERO.get = function() {
        return "0.0E0";
    }, Object.defineProperties(xl, El);
    var bl = function() {}, wl = {
        DP_SAFE_EPSILON: {
            configurable: !0
        }
    };
    bl.prototype.interfaces_ = function() {
        return [];
    }, bl.prototype.getClass = function() {
        return bl;
    }, bl.orientationIndex = function(t, e, n) {
        var r = bl.orientationIndexFilter(t, e, n);
        if (r <= 1) return r;
        var i = xl.valueOf(e.x).selfAdd(-t.x), o = xl.valueOf(e.y).selfAdd(-t.y), s = xl.valueOf(n.x).selfAdd(-e.x), a = xl.valueOf(n.y).selfAdd(-e.y);
        return i.selfMultiply(a).selfSubtract(o.selfMultiply(s)).signum();
    }, bl.signOfDet2x2 = function(t, e, n, r) {
        return t.multiply(r).selfSubtract(e.multiply(n)).signum();
    }, bl.intersection = function(t, e, n, r) {
        var i = xl.valueOf(r.y).selfSubtract(n.y).selfMultiply(xl.valueOf(e.x).selfSubtract(t.x)), o = xl.valueOf(r.x).selfSubtract(n.x).selfMultiply(xl.valueOf(e.y).selfSubtract(t.y)), s = i.subtract(o), a = xl.valueOf(r.x).selfSubtract(n.x).selfMultiply(xl.valueOf(t.y).selfSubtract(n.y)), u = xl.valueOf(r.y).selfSubtract(n.y).selfMultiply(xl.valueOf(t.x).selfSubtract(n.x)), l = a.subtract(u).selfDivide(s).doubleValue(), c = xl.valueOf(t.x).selfAdd(xl.valueOf(e.x).selfSubtract(t.x).selfMultiply(l)).doubleValue(), h = xl.valueOf(e.x).selfSubtract(t.x).selfMultiply(xl.valueOf(t.y).selfSubtract(n.y)), p = xl.valueOf(e.y).selfSubtract(t.y).selfMultiply(xl.valueOf(t.x).selfSubtract(n.x)), f = h.subtract(p).selfDivide(s).doubleValue(), g = xl.valueOf(n.y).selfAdd(xl.valueOf(r.y).selfSubtract(n.y).selfMultiply(f)).doubleValue();
        return new ul(c, g);
    }, bl.orientationIndexFilter = function(t, e, n) {
        var r = null, i = (t.x - n.x) * (e.y - n.y), o = (t.y - n.y) * (e.x - n.x), s = i - o;
        if (i > 0) {
            if (o <= 0) return bl.signum(s);
            r = i + o;
        } else {
            if (!(i < 0)) return bl.signum(s);
            if (o >= 0) return bl.signum(s);
            r = -i - o;
        }
        var a = bl.DP_SAFE_EPSILON * r;
        return s >= a || -s >= a ? bl.signum(s) : 2;
    }, bl.signum = function(t) {
        return t > 0 ? 1 : t < 0 ? -1 : 0;
    }, wl.DP_SAFE_EPSILON.get = function() {
        return 1e-15;
    }, Object.defineProperties(bl, wl);
    var Il = function() {}, Nl = {
        X: {
            configurable: !0
        },
        Y: {
            configurable: !0
        },
        Z: {
            configurable: !0
        },
        M: {
            configurable: !0
        }
    };
    Nl.X.get = function() {
        return 0;
    }, Nl.Y.get = function() {
        return 1;
    }, Nl.Z.get = function() {
        return 2;
    }, Nl.M.get = function() {
        return 3;
    }, Il.prototype.setOrdinate = function(t, e, n) {}, Il.prototype.size = function() {}, Il.prototype.getOrdinate = function(t, e) {}, Il.prototype.getCoordinate = function() {}, Il.prototype.getCoordinateCopy = function(t) {}, Il.prototype.getDimension = function() {}, Il.prototype.getX = function(t) {}, Il.prototype.clone = function() {}, Il.prototype.expandEnvelope = function(t) {}, Il.prototype.copy = function() {}, Il.prototype.getY = function(t) {}, Il.prototype.toCoordinateArray = function() {}, Il.prototype.interfaces_ = function() {
        return [
            ol
        ];
    }, Il.prototype.getClass = function() {
        return Il;
    }, Object.defineProperties(Il, Nl);
    var Sl = function() {}, Cl = function(t) {
        function e() {
            t.call(this, "Projective point not representable on the Cartesian plane.");
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Sl), Pl = function() {};
    Pl.arraycopy = function(t, e, n, r, i) {
        for(var o = 0, s = e; s < e + i; s++)n[r + o] = t[s], o++;
    }, Pl.getProperty = function(t) {
        return ({
            "line.separator": "\n"
        })[t];
    };
    var Ml = function t() {
        if (this.x = null, this.y = null, this.w = null, 0 === arguments.length) this.x = 0, this.y = 0, this.w = 1;
        else if (1 === arguments.length) {
            var e = arguments[0];
            this.x = e.x, this.y = e.y, this.w = 1;
        } else if (2 === arguments.length) {
            if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                var n = arguments[0], r = arguments[1];
                this.x = n, this.y = r, this.w = 1;
            } else if (arguments[0] instanceof t && arguments[1] instanceof t) {
                var i = arguments[0], o = arguments[1];
                this.x = i.y * o.w - o.y * i.w, this.y = o.x * i.w - i.x * o.w, this.w = i.x * o.y - o.x * i.y;
            } else if (arguments[0] instanceof ul && arguments[1] instanceof ul) {
                var s = arguments[0], a = arguments[1];
                this.x = s.y - a.y, this.y = a.x - s.x, this.w = s.x * a.y - a.x * s.y;
            }
        } else if (3 === arguments.length) {
            var u = arguments[0], l = arguments[1], c = arguments[2];
            this.x = u, this.y = l, this.w = c;
        } else if (4 === arguments.length) {
            var h = arguments[0], p = arguments[1], f = arguments[2], g = arguments[3], d = h.y - p.y, y = p.x - h.x, v = h.x * p.y - p.x * h.y, _ = f.y - g.y, m = g.x - f.x, x = f.x * g.y - g.x * f.y;
            this.x = y * x - m * v, this.y = _ * v - d * x, this.w = d * m - _ * y;
        }
    };
    Ml.prototype.getY = function() {
        var t = this.y / this.w;
        if (nl.isNaN(t) || nl.isInfinite(t)) throw new Cl;
        return t;
    }, Ml.prototype.getX = function() {
        var t = this.x / this.w;
        if (nl.isNaN(t) || nl.isInfinite(t)) throw new Cl;
        return t;
    }, Ml.prototype.getCoordinate = function() {
        var t = new ul;
        return t.x = this.getX(), t.y = this.getY(), t;
    }, Ml.prototype.interfaces_ = function() {
        return [];
    }, Ml.prototype.getClass = function() {
        return Ml;
    }, Ml.intersection = function(t, e, n, r) {
        var i = t.y - e.y, o = e.x - t.x, s = t.x * e.y - e.x * t.y, a = n.y - r.y, u = r.x - n.x, l = n.x * r.y - r.x * n.y, c = i * u - a * o, h = (o * l - u * s) / c, p = (a * s - i * l) / c;
        if (nl.isNaN(h) || nl.isInfinite(h) || nl.isNaN(p) || nl.isInfinite(p)) throw new Cl;
        return new ul(h, p);
    };
    var Ll = function t() {
        if (this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, 0 === arguments.length) this.init();
        else if (1 === arguments.length) {
            if (arguments[0] instanceof ul) {
                var e = arguments[0];
                this.init(e.x, e.x, e.y, e.y);
            } else if (arguments[0] instanceof t) {
                var n = arguments[0];
                this.init(n);
            }
        } else if (2 === arguments.length) {
            var r = arguments[0], i = arguments[1];
            this.init(r.x, i.x, r.y, i.y);
        } else if (4 === arguments.length) {
            var o = arguments[0], s = arguments[1], a = arguments[2], u = arguments[3];
            this.init(o, s, a, u);
        }
    }, Ol = {
        serialVersionUID: {
            configurable: !0
        }
    };
    Ll.prototype.getArea = function() {
        return this.getWidth() * this.getHeight();
    }, Ll.prototype.equals = function(t) {
        if (!(t instanceof Ll)) return !1;
        var e = t;
        return this.isNull() ? e.isNull() : this._maxx === e.getMaxX() && this._maxy === e.getMaxY() && this._minx === e.getMinX() && this._miny === e.getMinY();
    }, Ll.prototype.intersection = function(t) {
        if (this.isNull() || t.isNull() || !this.intersects(t)) return new Ll;
        var e = this._minx > t._minx ? this._minx : t._minx, n = this._miny > t._miny ? this._miny : t._miny, r = this._maxx < t._maxx ? this._maxx : t._maxx, i = this._maxy < t._maxy ? this._maxy : t._maxy;
        return new Ll(e, r, n, i);
    }, Ll.prototype.isNull = function() {
        return this._maxx < this._minx;
    }, Ll.prototype.getMaxX = function() {
        return this._maxx;
    }, Ll.prototype.covers = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof ul) {
                var t = arguments[0];
                return this.covers(t.x, t.y);
            }
            if (arguments[0] instanceof Ll) {
                var e = arguments[0];
                return !this.isNull() && !e.isNull() && e.getMinX() >= this._minx && e.getMaxX() <= this._maxx && e.getMinY() >= this._miny && e.getMaxY() <= this._maxy;
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1];
            return !this.isNull() && n >= this._minx && n <= this._maxx && r >= this._miny && r <= this._maxy;
        }
    }, Ll.prototype.intersects = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof Ll) {
                var t = arguments[0];
                return !this.isNull() && !t.isNull() && !(t._minx > this._maxx || t._maxx < this._minx || t._miny > this._maxy || t._maxy < this._miny);
            }
            if (arguments[0] instanceof ul) {
                var e = arguments[0];
                return this.intersects(e.x, e.y);
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1];
            return !this.isNull() && !(n > this._maxx || n < this._minx || r > this._maxy || r < this._miny);
        }
    }, Ll.prototype.getMinY = function() {
        return this._miny;
    }, Ll.prototype.getMinX = function() {
        return this._minx;
    }, Ll.prototype.expandToInclude = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof ul) {
                var t = arguments[0];
                this.expandToInclude(t.x, t.y);
            } else if (arguments[0] instanceof Ll) {
                var e = arguments[0];
                if (e.isNull()) return null;
                this.isNull() ? (this._minx = e.getMinX(), this._maxx = e.getMaxX(), this._miny = e.getMinY(), this._maxy = e.getMaxY()) : (e._minx < this._minx && (this._minx = e._minx), e._maxx > this._maxx && (this._maxx = e._maxx), e._miny < this._miny && (this._miny = e._miny), e._maxy > this._maxy && (this._maxy = e._maxy));
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1];
            this.isNull() ? (this._minx = n, this._maxx = n, this._miny = r, this._maxy = r) : (n < this._minx && (this._minx = n), n > this._maxx && (this._maxx = n), r < this._miny && (this._miny = r), r > this._maxy && (this._maxy = r));
        }
    }, Ll.prototype.minExtent = function() {
        if (this.isNull()) return 0;
        var t = this.getWidth(), e = this.getHeight();
        return t < e ? t : e;
    }, Ll.prototype.getWidth = function() {
        return this.isNull() ? 0 : this._maxx - this._minx;
    }, Ll.prototype.compareTo = function(t) {
        var e = t;
        return this.isNull() ? e.isNull() ? 0 : -1 : e.isNull() ? 1 : this._minx < e._minx ? -1 : this._minx > e._minx ? 1 : this._miny < e._miny ? -1 : this._miny > e._miny ? 1 : this._maxx < e._maxx ? -1 : this._maxx > e._maxx ? 1 : this._maxy < e._maxy ? -1 : this._maxy > e._maxy ? 1 : 0;
    }, Ll.prototype.translate = function(t, e) {
        if (this.isNull()) return null;
        this.init(this.getMinX() + t, this.getMaxX() + t, this.getMinY() + e, this.getMaxY() + e);
    }, Ll.prototype.toString = function() {
        return "Env[" + this._minx + " : " + this._maxx + ", " + this._miny + " : " + this._maxy + "]";
    }, Ll.prototype.setToNull = function() {
        this._minx = 0, this._maxx = -1, this._miny = 0, this._maxy = -1;
    }, Ll.prototype.getHeight = function() {
        return this.isNull() ? 0 : this._maxy - this._miny;
    }, Ll.prototype.maxExtent = function() {
        if (this.isNull()) return 0;
        var t = this.getWidth(), e = this.getHeight();
        return t > e ? t : e;
    }, Ll.prototype.expandBy = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.expandBy(t, t);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            if (this.isNull()) return null;
            this._minx -= e, this._maxx += e, this._miny -= n, this._maxy += n, (this._minx > this._maxx || this._miny > this._maxy) && this.setToNull();
        }
    }, Ll.prototype.contains = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof Ll) {
                var t = arguments[0];
                return this.covers(t);
            }
            if (arguments[0] instanceof ul) {
                var e = arguments[0];
                return this.covers(e);
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1];
            return this.covers(n, r);
        }
    }, Ll.prototype.centre = function() {
        return this.isNull() ? null : new ul((this.getMinX() + this.getMaxX()) / 2, (this.getMinY() + this.getMaxY()) / 2);
    }, Ll.prototype.init = function() {
        if (0 === arguments.length) this.setToNull();
        else if (1 === arguments.length) {
            if (arguments[0] instanceof ul) {
                var t = arguments[0];
                this.init(t.x, t.x, t.y, t.y);
            } else if (arguments[0] instanceof Ll) {
                var e = arguments[0];
                this._minx = e._minx, this._maxx = e._maxx, this._miny = e._miny, this._maxy = e._maxy;
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1];
            this.init(n.x, r.x, n.y, r.y);
        } else if (4 === arguments.length) {
            var i = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3];
            i < o ? (this._minx = i, this._maxx = o) : (this._minx = o, this._maxx = i), s < a ? (this._miny = s, this._maxy = a) : (this._miny = a, this._maxy = s);
        }
    }, Ll.prototype.getMaxY = function() {
        return this._maxy;
    }, Ll.prototype.distance = function(t) {
        if (this.intersects(t)) return 0;
        var e = 0;
        this._maxx < t._minx ? e = t._minx - this._maxx : this._minx > t._maxx && (e = this._minx - t._maxx);
        var n = 0;
        return this._maxy < t._miny ? n = t._miny - this._maxy : this._miny > t._maxy && (n = this._miny - t._maxy), 0 === e ? n : 0 === n ? e : Math.sqrt(e * e + n * n);
    }, Ll.prototype.hashCode = function() {
        var t = 17;
        return t = 37 * (t = 37 * (t = 37 * (t = 37 * t + ul.hashCode(this._minx)) + ul.hashCode(this._maxx)) + ul.hashCode(this._miny)) + ul.hashCode(this._maxy);
    }, Ll.prototype.interfaces_ = function() {
        return [
            il,
            al
        ];
    }, Ll.prototype.getClass = function() {
        return Ll;
    }, Ll.intersects = function() {
        if (3 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = arguments[2];
            return n.x >= (t.x < e.x ? t.x : e.x) && n.x <= (t.x > e.x ? t.x : e.x) && n.y >= (t.y < e.y ? t.y : e.y) && n.y <= (t.y > e.y ? t.y : e.y);
        }
        if (4 === arguments.length) {
            var r = arguments[0], i = arguments[1], o = arguments[2], s = arguments[3], a = Math.min(o.x, s.x), u = Math.max(o.x, s.x), l = Math.min(r.x, i.x), c = Math.max(r.x, i.x);
            return !(l > u) && !(c < a) && (a = Math.min(o.y, s.y), u = Math.max(o.y, s.y), l = Math.min(r.y, i.y), c = Math.max(r.y, i.y), !(l > u) && !(c < a));
        }
    }, Ol.serialVersionUID.get = function() {
        return 0x51845cd552189800;
    }, Object.defineProperties(Ll, Ol);
    var Rl = {
        typeStr: /^\s*(\w+)\s*\(\s*(.*)\s*\)\s*$/,
        emptyTypeStr: /^\s*(\w+)\s*EMPTY\s*$/,
        spaces: /\s+/,
        parenComma: /\)\s*,\s*\(/,
        doubleParenComma: /\)\s*\)\s*,\s*\(\s*\(/,
        trimParens: /^\s*\(?(.*?)\)?\s*$/
    }, Tl = function(t) {
        this.geometryFactory = t || new _h;
    };
    Tl.prototype.read = function(t) {
        var e, n, r;
        t = t.replace(/[\n\r]/g, " ");
        var i = Rl.typeStr.exec(t);
        if (-1 !== t.search("EMPTY") && ((i = Rl.emptyTypeStr.exec(t))[2] = void 0), i && (n = i[1].toLowerCase(), r = i[2], Dl[n] && (e = Dl[n].apply(this, [
            r
        ]))), void 0 === e) throw new Error("Could not parse WKT " + t);
        return e;
    }, Tl.prototype.write = function(t) {
        return this.extractGeometry(t);
    }, Tl.prototype.extractGeometry = function(t) {
        var e = t.getGeometryType().toLowerCase();
        if (!Al[e]) return null;
        var n = e.toUpperCase();
        return t.isEmpty() ? n + " EMPTY" : n + "(" + Al[e].apply(this, [
            t
        ]) + ")";
    };
    var Al = {
        coordinate: function(t) {
            return t.x + " " + t.y;
        },
        point: function(t) {
            return Al.coordinate.call(this, t._coordinates._coordinates[0]);
        },
        multipoint: function(t) {
            for(var e = [], n = 0, r = t._geometries.length; n < r; ++n)e.push("(" + Al.point.apply(this, [
                t._geometries[n]
            ]) + ")");
            return e.join(",");
        },
        linestring: function(t) {
            for(var e = [], n = 0, r = t._points._coordinates.length; n < r; ++n)e.push(Al.coordinate.apply(this, [
                t._points._coordinates[n]
            ]));
            return e.join(",");
        },
        linearring: function(t) {
            for(var e = [], n = 0, r = t._points._coordinates.length; n < r; ++n)e.push(Al.coordinate.apply(this, [
                t._points._coordinates[n]
            ]));
            return e.join(",");
        },
        multilinestring: function(t) {
            for(var e = [], n = 0, r = t._geometries.length; n < r; ++n)e.push("(" + Al.linestring.apply(this, [
                t._geometries[n]
            ]) + ")");
            return e.join(",");
        },
        polygon: function(t) {
            var e = [];
            e.push("(" + Al.linestring.apply(this, [
                t._shell
            ]) + ")");
            for(var n = 0, r = t._holes.length; n < r; ++n)e.push("(" + Al.linestring.apply(this, [
                t._holes[n]
            ]) + ")");
            return e.join(",");
        },
        multipolygon: function(t) {
            for(var e = [], n = 0, r = t._geometries.length; n < r; ++n)e.push("(" + Al.polygon.apply(this, [
                t._geometries[n]
            ]) + ")");
            return e.join(",");
        },
        geometrycollection: function(t) {
            for(var e = [], n = 0, r = t._geometries.length; n < r; ++n)e.push(this.extractGeometry(t._geometries[n]));
            return e.join(",");
        }
    }, Dl = {
        point: function(t) {
            if (void 0 === t) return this.geometryFactory.createPoint();
            var e = t.trim().split(Rl.spaces);
            return this.geometryFactory.createPoint(new ul(Number.parseFloat(e[0]), Number.parseFloat(e[1])));
        },
        multipoint: function(t) {
            var e;
            if (void 0 === t) return this.geometryFactory.createMultiPoint();
            for(var n = t.trim().split(","), r = [], i = 0, o = n.length; i < o; ++i)e = n[i].replace(Rl.trimParens, "$1"), r.push(Dl.point.apply(this, [
                e
            ]));
            return this.geometryFactory.createMultiPoint(r);
        },
        linestring: function(t) {
            if (void 0 === t) return this.geometryFactory.createLineString();
            for(var e, n = t.trim().split(","), r = [], i = 0, o = n.length; i < o; ++i)e = n[i].trim().split(Rl.spaces), r.push(new ul(Number.parseFloat(e[0]), Number.parseFloat(e[1])));
            return this.geometryFactory.createLineString(r);
        },
        linearring: function(t) {
            if (void 0 === t) return this.geometryFactory.createLinearRing();
            for(var e, n = t.trim().split(","), r = [], i = 0, o = n.length; i < o; ++i)e = n[i].trim().split(Rl.spaces), r.push(new ul(Number.parseFloat(e[0]), Number.parseFloat(e[1])));
            return this.geometryFactory.createLinearRing(r);
        },
        multilinestring: function(t) {
            var e;
            if (void 0 === t) return this.geometryFactory.createMultiLineString();
            for(var n = t.trim().split(Rl.parenComma), r = [], i = 0, o = n.length; i < o; ++i)e = n[i].replace(Rl.trimParens, "$1"), r.push(Dl.linestring.apply(this, [
                e
            ]));
            return this.geometryFactory.createMultiLineString(r);
        },
        polygon: function(t) {
            var e, n, r;
            if (void 0 === t) return this.geometryFactory.createPolygon();
            for(var i, o = t.trim().split(Rl.parenComma), s = [], a = 0, u = o.length; a < u; ++a)e = o[a].replace(Rl.trimParens, "$1"), n = Dl.linestring.apply(this, [
                e
            ]), r = this.geometryFactory.createLinearRing(n._points), 0 === a ? i = r : s.push(r);
            return this.geometryFactory.createPolygon(i, s);
        },
        multipolygon: function(t) {
            var e;
            if (void 0 === t) return this.geometryFactory.createMultiPolygon();
            for(var n = t.trim().split(Rl.doubleParenComma), r = [], i = 0, o = n.length; i < o; ++i)e = n[i].replace(Rl.trimParens, "$1"), r.push(Dl.polygon.apply(this, [
                e
            ]));
            return this.geometryFactory.createMultiPolygon(r);
        },
        geometrycollection: function(t) {
            if (void 0 === t) return this.geometryFactory.createGeometryCollection();
            for(var e = (t = t.replace(/,\s*([A-Za-z])/g, "|$1")).trim().split("|"), n = [], r = 0, i = e.length; r < i; ++r)n.push(this.read(e[r]));
            return this.geometryFactory.createGeometryCollection(n);
        }
    }, Fl = function(t) {
        this.parser = new Tl(t);
    };
    Fl.prototype.write = function(t) {
        return this.parser.write(t);
    }, Fl.toLineString = function(t, e) {
        if (2 !== arguments.length) throw new Error("Not implemented");
        return "LINESTRING ( " + t.x + " " + t.y + ", " + e.x + " " + e.y + " )";
    };
    var kl = function(t) {
        function e(e) {
            t.call(this, e), this.name = "RuntimeException", this.message = e, this.stack = (new t).stack;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
    }(Error), Gl = function(t) {
        function e() {
            if (t.call(this), 0 === arguments.length) t.call(this);
            else if (1 === arguments.length) {
                var e = arguments[0];
                t.call(this, e);
            }
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(kl), ql = function() {};
    ql.prototype.interfaces_ = function() {
        return [];
    }, ql.prototype.getClass = function() {
        return ql;
    }, ql.shouldNeverReachHere = function() {
        if (0 === arguments.length) ql.shouldNeverReachHere(null);
        else if (1 === arguments.length) {
            var t = arguments[0];
            throw new Gl("Should never reach here" + (null !== t ? ": " + t : ""));
        }
    }, ql.isTrue = function() {
        var t;
        if (1 === arguments.length) ql.isTrue(arguments[0], null);
        else if (2 === arguments.length && (t = arguments[1], !arguments[0])) throw null === t ? new Gl : new Gl(t);
    }, ql.equals = function() {
        var t, e, n;
        if (2 === arguments.length) ql.equals(t = arguments[0], e = arguments[1], null);
        else if (3 === arguments.length && (t = arguments[0], n = arguments[2], !(e = arguments[1]).equals(t))) throw new Gl("Expected " + t + " but encountered " + e + (null !== n ? ": " + n : ""));
    };
    var Bl = function() {
        this._result = null, this._inputLines = Array(2).fill().map(function() {
            return Array(2);
        }), this._intPt = new Array(2).fill(null), this._intLineIndex = null, this._isProper = null, this._pa = null, this._pb = null, this._precisionModel = null, this._intPt[0] = new ul, this._intPt[1] = new ul, this._pa = this._intPt[0], this._pb = this._intPt[1], this._result = 0;
    }, zl = {
        DONT_INTERSECT: {
            configurable: !0
        },
        DO_INTERSECT: {
            configurable: !0
        },
        COLLINEAR: {
            configurable: !0
        },
        NO_INTERSECTION: {
            configurable: !0
        },
        POINT_INTERSECTION: {
            configurable: !0
        },
        COLLINEAR_INTERSECTION: {
            configurable: !0
        }
    };
    Bl.prototype.getIndexAlongSegment = function(t, e) {
        return this.computeIntLineIndex(), this._intLineIndex[t][e];
    }, Bl.prototype.getTopologySummary = function() {
        var t = new vl;
        return this.isEndPoint() && t.append(" endpoint"), this._isProper && t.append(" proper"), this.isCollinear() && t.append(" collinear"), t.toString();
    }, Bl.prototype.computeIntersection = function(t, e, n, r) {
        this._inputLines[0][0] = t, this._inputLines[0][1] = e, this._inputLines[1][0] = n, this._inputLines[1][1] = r, this._result = this.computeIntersect(t, e, n, r);
    }, Bl.prototype.getIntersectionNum = function() {
        return this._result;
    }, Bl.prototype.computeIntLineIndex = function() {
        if (0 === arguments.length) null === this._intLineIndex && (this._intLineIndex = Array(2).fill().map(function() {
            return Array(2);
        }), this.computeIntLineIndex(0), this.computeIntLineIndex(1));
        else if (1 === arguments.length) {
            var t = arguments[0], e = this.getEdgeDistance(t, 0), n = this.getEdgeDistance(t, 1);
            e > n ? (this._intLineIndex[t][0] = 0, this._intLineIndex[t][1] = 1) : (this._intLineIndex[t][0] = 1, this._intLineIndex[t][1] = 0);
        }
    }, Bl.prototype.isProper = function() {
        return this.hasIntersection() && this._isProper;
    }, Bl.prototype.setPrecisionModel = function(t) {
        this._precisionModel = t;
    }, Bl.prototype.isInteriorIntersection = function() {
        var t = this;
        if (0 === arguments.length) return !!this.isInteriorIntersection(0) || !!this.isInteriorIntersection(1);
        if (1 === arguments.length) {
            for(var e = arguments[0], n = 0; n < this._result; n++)if (!t._intPt[n].equals2D(t._inputLines[e][0]) && !t._intPt[n].equals2D(t._inputLines[e][1])) return !0;
            return !1;
        }
    }, Bl.prototype.getIntersection = function(t) {
        return this._intPt[t];
    }, Bl.prototype.isEndPoint = function() {
        return this.hasIntersection() && !this._isProper;
    }, Bl.prototype.hasIntersection = function() {
        return this._result !== Bl.NO_INTERSECTION;
    }, Bl.prototype.getEdgeDistance = function(t, e) {
        return Bl.computeEdgeDistance(this._intPt[e], this._inputLines[t][0], this._inputLines[t][1]);
    }, Bl.prototype.isCollinear = function() {
        return this._result === Bl.COLLINEAR_INTERSECTION;
    }, Bl.prototype.toString = function() {
        return Fl.toLineString(this._inputLines[0][0], this._inputLines[0][1]) + " - " + Fl.toLineString(this._inputLines[1][0], this._inputLines[1][1]) + this.getTopologySummary();
    }, Bl.prototype.getEndpoint = function(t, e) {
        return this._inputLines[t][e];
    }, Bl.prototype.isIntersection = function(t) {
        for(var e = 0; e < this._result; e++)if (this._intPt[e].equals2D(t)) return !0;
        return !1;
    }, Bl.prototype.getIntersectionAlongSegment = function(t, e) {
        return this.computeIntLineIndex(), this._intPt[this._intLineIndex[t][e]];
    }, Bl.prototype.interfaces_ = function() {
        return [];
    }, Bl.prototype.getClass = function() {
        return Bl;
    }, Bl.computeEdgeDistance = function(t, e, n) {
        var r = Math.abs(n.x - e.x), i = Math.abs(n.y - e.y), o = -1;
        if (t.equals(e)) o = 0;
        else if (t.equals(n)) o = r > i ? r : i;
        else {
            var s = Math.abs(t.x - e.x), a = Math.abs(t.y - e.y);
            0 !== (o = r > i ? s : a) || t.equals(e) || (o = Math.max(s, a));
        }
        return ql.isTrue(!(0 === o && !t.equals(e)), "Bad distance calculation"), o;
    }, Bl.nonRobustComputeEdgeDistance = function(t, e, n) {
        var r = t.x - e.x, i = t.y - e.y, o = Math.sqrt(r * r + i * i);
        return ql.isTrue(!(0 === o && !t.equals(e)), "Invalid distance calculation"), o;
    }, zl.DONT_INTERSECT.get = function() {
        return 0;
    }, zl.DO_INTERSECT.get = function() {
        return 1;
    }, zl.COLLINEAR.get = function() {
        return 2;
    }, zl.NO_INTERSECTION.get = function() {
        return 0;
    }, zl.POINT_INTERSECTION.get = function() {
        return 1;
    }, zl.COLLINEAR_INTERSECTION.get = function() {
        return 2;
    }, Object.defineProperties(Bl, zl);
    var jl = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.isInSegmentEnvelopes = function(t) {
            var e = new Ll(this._inputLines[0][0], this._inputLines[0][1]), n = new Ll(this._inputLines[1][0], this._inputLines[1][1]);
            return e.contains(t) && n.contains(t);
        }, e.prototype.computeIntersection = function() {
            if (3 !== arguments.length) return t.prototype.computeIntersection.apply(this, arguments);
            var e = arguments[0], n = arguments[1], r = arguments[2];
            if (this._isProper = !1, Ll.intersects(n, r, e) && 0 === Xl.orientationIndex(n, r, e) && 0 === Xl.orientationIndex(r, n, e)) return this._isProper = !0, (e.equals(n) || e.equals(r)) && (this._isProper = !1), this._result = t.POINT_INTERSECTION, null;
            this._result = t.NO_INTERSECTION;
        }, e.prototype.normalizeToMinimum = function(t, e, n, r, i) {
            i.x = this.smallestInAbsValue(t.x, e.x, n.x, r.x), i.y = this.smallestInAbsValue(t.y, e.y, n.y, r.y), t.x -= i.x, t.y -= i.y, e.x -= i.x, e.y -= i.y, n.x -= i.x, n.y -= i.y, r.x -= i.x, r.y -= i.y;
        }, e.prototype.safeHCoordinateIntersection = function(t, n, r, i) {
            var o = null;
            try {
                o = Ml.intersection(t, n, r, i);
            } catch (s) {
                if (!(s instanceof Cl)) throw s;
                o = e.nearestEndpoint(t, n, r, i);
            }
            return o;
        }, e.prototype.intersection = function(t, n, r, i) {
            var o = this.intersectionWithNormalization(t, n, r, i);
            return this.isInSegmentEnvelopes(o) || (o = new ul(e.nearestEndpoint(t, n, r, i))), null !== this._precisionModel && this._precisionModel.makePrecise(o), o;
        }, e.prototype.smallestInAbsValue = function(t, e, n, r) {
            var i = t, o = Math.abs(i);
            return Math.abs(e) < o && (i = e, o = Math.abs(e)), Math.abs(n) < o && (i = n, o = Math.abs(n)), Math.abs(r) < o && (i = r), i;
        }, e.prototype.checkDD = function(t, e, n, r, i) {
            var o = bl.intersection(t, e, n, r), s = this.isInSegmentEnvelopes(o);
            Pl.out.println("DD in env = " + s + "  --------------------- " + o), i.distance(o) > 1e-4 && Pl.out.println("Distance = " + i.distance(o));
        }, e.prototype.intersectionWithNormalization = function(t, e, n, r) {
            var i = new ul(t), o = new ul(e), s = new ul(n), a = new ul(r), u = new ul;
            this.normalizeToEnvCentre(i, o, s, a, u);
            var l = this.safeHCoordinateIntersection(i, o, s, a);
            return l.x += u.x, l.y += u.y, l;
        }, e.prototype.computeCollinearIntersection = function(e, n, r, i) {
            var o = Ll.intersects(e, n, r), s = Ll.intersects(e, n, i), a = Ll.intersects(r, i, e), u = Ll.intersects(r, i, n);
            return o && s ? (this._intPt[0] = r, this._intPt[1] = i, t.COLLINEAR_INTERSECTION) : a && u ? (this._intPt[0] = e, this._intPt[1] = n, t.COLLINEAR_INTERSECTION) : o && a ? (this._intPt[0] = r, this._intPt[1] = e, !r.equals(e) || s || u ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : o && u ? (this._intPt[0] = r, this._intPt[1] = n, !r.equals(n) || s || a ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : s && a ? (this._intPt[0] = i, this._intPt[1] = e, !i.equals(e) || o || u ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : s && u ? (this._intPt[0] = i, this._intPt[1] = n, !i.equals(n) || o || a ? t.COLLINEAR_INTERSECTION : t.POINT_INTERSECTION) : t.NO_INTERSECTION;
        }, e.prototype.normalizeToEnvCentre = function(t, e, n, r, i) {
            var o = t.x < e.x ? t.x : e.x, s = t.y < e.y ? t.y : e.y, a = t.x > e.x ? t.x : e.x, u = t.y > e.y ? t.y : e.y, l = n.x < r.x ? n.x : r.x, c = n.y < r.y ? n.y : r.y, h = n.x > r.x ? n.x : r.x, p = n.y > r.y ? n.y : r.y, f = ((o > l ? o : l) + (a < h ? a : h)) / 2, g = ((s > c ? s : c) + (u < p ? u : p)) / 2;
            i.x = f, i.y = g, t.x -= i.x, t.y -= i.y, e.x -= i.x, e.y -= i.y, n.x -= i.x, n.y -= i.y, r.x -= i.x, r.y -= i.y;
        }, e.prototype.computeIntersect = function(e, n, r, i) {
            if (this._isProper = !1, !Ll.intersects(e, n, r, i)) return t.NO_INTERSECTION;
            var o = Xl.orientationIndex(e, n, r), s = Xl.orientationIndex(e, n, i);
            if (o > 0 && s > 0 || o < 0 && s < 0) return t.NO_INTERSECTION;
            var a = Xl.orientationIndex(r, i, e), u = Xl.orientationIndex(r, i, n);
            return a > 0 && u > 0 || a < 0 && u < 0 ? t.NO_INTERSECTION : 0 === o && 0 === s && 0 === a && 0 === u ? this.computeCollinearIntersection(e, n, r, i) : (0 === o || 0 === s || 0 === a || 0 === u ? (this._isProper = !1, e.equals2D(r) || e.equals2D(i) ? this._intPt[0] = e : n.equals2D(r) || n.equals2D(i) ? this._intPt[0] = n : 0 === o ? this._intPt[0] = new ul(r) : 0 === s ? this._intPt[0] = new ul(i) : 0 === a ? this._intPt[0] = new ul(e) : 0 === u && (this._intPt[0] = new ul(n))) : (this._isProper = !0, this._intPt[0] = this.intersection(e, n, r, i)), t.POINT_INTERSECTION);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e.nearestEndpoint = function(t, e, n, r) {
            var i = t, o = Xl.distancePointLine(t, n, r), s = Xl.distancePointLine(e, n, r);
            return s < o && (o = s, i = e), (s = Xl.distancePointLine(n, t, e)) < o && (o = s, i = n), (s = Xl.distancePointLine(r, t, e)) < o && (o = s, i = r), i;
        }, e;
    }(Bl), Ul = function() {};
    Ul.prototype.interfaces_ = function() {
        return [];
    }, Ul.prototype.getClass = function() {
        return Ul;
    }, Ul.orientationIndex = function(t, e, n) {
        var r = e.x - t.x, i = e.y - t.y, o = n.x - e.x, s = n.y - e.y;
        return Ul.signOfDet2x2(r, i, o, s);
    }, Ul.signOfDet2x2 = function(t, e, n, r) {
        var i = null, o = null, s = null;
        if (i = 1, 0 === t || 0 === r) return 0 === e || 0 === n ? 0 : e > 0 ? n > 0 ? -i : i : n > 0 ? i : -i;
        if (0 === e || 0 === n) return r > 0 ? t > 0 ? i : -i : t > 0 ? -i : i;
        if (e > 0 ? r > 0 ? e <= r || (i = -i, o = t, t = n, n = o, o = e, e = r, r = o) : e <= -r ? (i = -i, n = -n, r = -r) : (o = t, t = -n, n = o, o = e, e = -r, r = o) : r > 0 ? -e <= r ? (i = -i, t = -t, e = -e) : (o = -t, t = n, n = o, o = -e, e = r, r = o) : e >= r ? (t = -t, e = -e, n = -n, r = -r) : (i = -i, o = -t, t = -n, n = o, o = -e, e = -r, r = o), t > 0) {
            if (!(n > 0)) return i;
            if (!(t <= n)) return i;
        } else {
            if (n > 0) return -i;
            if (!(t >= n)) return -i;
            i = -i, t = -t, n = -n;
        }
        for(;;){
            if ((r -= (s = Math.floor(n / t)) * e) < 0) return -i;
            if (r > e) return i;
            if (t > (n -= s * t) + n) {
                if (e < r + r) return i;
            } else {
                if (e > r + r) return -i;
                n = t - n, r = e - r, i = -i;
            }
            if (0 === r) return 0 === n ? 0 : -i;
            if (0 === n) return i;
            if ((e -= (s = Math.floor(t / n)) * r) < 0) return i;
            if (e > r) return -i;
            if (n > (t -= s * n) + t) {
                if (r < e + e) return -i;
            } else {
                if (r > e + e) return i;
                t = n - t, e = r - e, i = -i;
            }
            if (0 === e) return 0 === t ? 0 : i;
            if (0 === t) return -i;
        }
    };
    var Vl = function() {
        this._p = null, this._crossingCount = 0, this._isPointOnSegment = !1;
        var t = arguments[0];
        this._p = t;
    };
    Vl.prototype.countSegment = function(t, e) {
        if (t.x < this._p.x && e.x < this._p.x) return null;
        if (this._p.x === e.x && this._p.y === e.y) return this._isPointOnSegment = !0, null;
        if (t.y === this._p.y && e.y === this._p.y) {
            var n = t.x, r = e.x;
            return n > r && (n = e.x, r = t.x), this._p.x >= n && this._p.x <= r && (this._isPointOnSegment = !0), null;
        }
        if (t.y > this._p.y && e.y <= this._p.y || e.y > this._p.y && t.y <= this._p.y) {
            var i = t.x - this._p.x, o = t.y - this._p.y, s = e.x - this._p.x, a = e.y - this._p.y, u = Ul.signOfDet2x2(i, o, s, a);
            if (0 === u) return this._isPointOnSegment = !0, null;
            a < o && (u = -u), u > 0 && this._crossingCount++;
        }
    }, Vl.prototype.isPointInPolygon = function() {
        return this.getLocation() !== pl.EXTERIOR;
    }, Vl.prototype.getLocation = function() {
        return this._isPointOnSegment ? pl.BOUNDARY : this._crossingCount % 2 == 1 ? pl.INTERIOR : pl.EXTERIOR;
    }, Vl.prototype.isOnSegment = function() {
        return this._isPointOnSegment;
    }, Vl.prototype.interfaces_ = function() {
        return [];
    }, Vl.prototype.getClass = function() {
        return Vl;
    }, Vl.locatePointInRing = function() {
        if (arguments[0] instanceof ul && gl(arguments[1], Il)) {
            for(var t = arguments[0], e = arguments[1], n = new Vl(t), r = new ul, i = new ul, o = 1; o < e.size(); o++)if (e.getCoordinate(o, r), e.getCoordinate(o - 1, i), n.countSegment(r, i), n.isOnSegment()) return n.getLocation();
            return n.getLocation();
        }
        if (arguments[0] instanceof ul && arguments[1] instanceof Array) {
            for(var s = arguments[0], a = arguments[1], u = new Vl(s), l = 1; l < a.length; l++){
                var c = a[l], h = a[l - 1];
                if (u.countSegment(c, h), u.isOnSegment()) return u.getLocation();
            }
            return u.getLocation();
        }
    };
    var Xl = function() {}, Yl = {
        CLOCKWISE: {
            configurable: !0
        },
        RIGHT: {
            configurable: !0
        },
        COUNTERCLOCKWISE: {
            configurable: !0
        },
        LEFT: {
            configurable: !0
        },
        COLLINEAR: {
            configurable: !0
        },
        STRAIGHT: {
            configurable: !0
        }
    };
    Xl.prototype.interfaces_ = function() {
        return [];
    }, Xl.prototype.getClass = function() {
        return Xl;
    }, Xl.orientationIndex = function(t, e, n) {
        return bl.orientationIndex(t, e, n);
    }, Xl.signedArea = function() {
        if (arguments[0] instanceof Array) {
            var t = arguments[0];
            if (t.length < 3) return 0;
            for(var e = 0, n = t[0].x, r = 1; r < t.length - 1; r++){
                var i = t[r].x - n, o = t[r + 1].y, s = t[r - 1].y;
                e += i * (s - o);
            }
            return e / 2;
        }
        if (gl(arguments[0], Il)) {
            var a = arguments[0], u = a.size();
            if (u < 3) return 0;
            var l = new ul, c = new ul, h = new ul;
            a.getCoordinate(0, c), a.getCoordinate(1, h);
            var p = c.x;
            h.x -= p;
            for(var f = 0, g = 1; g < u - 1; g++)l.y = c.y, c.x = h.x, c.y = h.y, a.getCoordinate(g + 1, h), h.x -= p, f += c.x * (l.y - h.y);
            return f / 2;
        }
    }, Xl.distanceLineLine = function(t, e, n, r) {
        if (t.equals(e)) return Xl.distancePointLine(t, n, r);
        if (n.equals(r)) return Xl.distancePointLine(r, t, e);
        var i = !1;
        if (Ll.intersects(t, e, n, r)) {
            var o = (e.x - t.x) * (r.y - n.y) - (e.y - t.y) * (r.x - n.x);
            if (0 === o) i = !0;
            else {
                var s = (t.y - n.y) * (r.x - n.x) - (t.x - n.x) * (r.y - n.y), a = ((t.y - n.y) * (e.x - t.x) - (t.x - n.x) * (e.y - t.y)) / o, u = s / o;
                (u < 0 || u > 1 || a < 0 || a > 1) && (i = !0);
            }
        } else i = !0;
        return i ? dl.min(Xl.distancePointLine(t, n, r), Xl.distancePointLine(e, n, r), Xl.distancePointLine(n, t, e), Xl.distancePointLine(r, t, e)) : 0;
    }, Xl.isPointInRing = function(t, e) {
        return Xl.locatePointInRing(t, e) !== pl.EXTERIOR;
    }, Xl.computeLength = function(t) {
        var e = t.size();
        if (e <= 1) return 0;
        var n = 0, r = new ul;
        t.getCoordinate(0, r);
        for(var i = r.x, o = r.y, s = 1; s < e; s++){
            t.getCoordinate(s, r);
            var a = r.x, u = r.y, l = a - i, c = u - o;
            n += Math.sqrt(l * l + c * c), i = a, o = u;
        }
        return n;
    }, Xl.isCCW = function(t) {
        var e = t.length - 1;
        if (e < 3) throw new el("Ring has fewer than 4 points, so orientation cannot be determined");
        for(var n = t[0], r = 0, i = 1; i <= e; i++){
            var o = t[i];
            o.y > n.y && (n = o, r = i);
        }
        var s = r;
        do (s -= 1) < 0 && (s = e);
        while (t[s].equals2D(n) && s !== r);
        var a = r;
        do a = (a + 1) % e;
        while (t[a].equals2D(n) && a !== r);
        var u = t[s], l = t[a];
        if (u.equals2D(n) || l.equals2D(n) || u.equals2D(l)) return !1;
        var c = Xl.computeOrientation(u, n, l), h = !1;
        return h = 0 === c ? u.x > l.x : c > 0, h;
    }, Xl.locatePointInRing = function(t, e) {
        return Vl.locatePointInRing(t, e);
    }, Xl.distancePointLinePerpendicular = function(t, e, n) {
        var r = (n.x - e.x) * (n.x - e.x) + (n.y - e.y) * (n.y - e.y), i = ((e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y)) / r;
        return Math.abs(i) * Math.sqrt(r);
    }, Xl.computeOrientation = function(t, e, n) {
        return Xl.orientationIndex(t, e, n);
    }, Xl.distancePointLine = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            if (0 === e.length) throw new el("Line array must contain at least one vertex");
            for(var n = t.distance(e[0]), r = 0; r < e.length - 1; r++){
                var i = Xl.distancePointLine(t, e[r], e[r + 1]);
                i < n && (n = i);
            }
            return n;
        }
        if (3 === arguments.length) {
            var o = arguments[0], s = arguments[1], a = arguments[2];
            if (s.x === a.x && s.y === a.y) return o.distance(s);
            var u = (a.x - s.x) * (a.x - s.x) + (a.y - s.y) * (a.y - s.y), l = ((o.x - s.x) * (a.x - s.x) + (o.y - s.y) * (a.y - s.y)) / u;
            if (l <= 0) return o.distance(s);
            if (l >= 1) return o.distance(a);
            var c = ((s.y - o.y) * (a.x - s.x) - (s.x - o.x) * (a.y - s.y)) / u;
            return Math.abs(c) * Math.sqrt(u);
        }
    }, Xl.isOnLine = function(t, e) {
        for(var n = new jl, r = 1; r < e.length; r++){
            var i = e[r - 1], o = e[r];
            if (n.computeIntersection(t, i, o), n.hasIntersection()) return !0;
        }
        return !1;
    }, Yl.CLOCKWISE.get = function() {
        return -1;
    }, Yl.RIGHT.get = function() {
        return Xl.CLOCKWISE;
    }, Yl.COUNTERCLOCKWISE.get = function() {
        return 1;
    }, Yl.LEFT.get = function() {
        return Xl.COUNTERCLOCKWISE;
    }, Yl.COLLINEAR.get = function() {
        return 0;
    }, Yl.STRAIGHT.get = function() {
        return Xl.COLLINEAR;
    }, Object.defineProperties(Xl, Yl);
    var Hl = function() {};
    Hl.prototype.filter = function(t) {}, Hl.prototype.interfaces_ = function() {
        return [];
    }, Hl.prototype.getClass = function() {
        return Hl;
    };
    var Wl = function() {
        var t = arguments[0];
        this._envelope = null, this._factory = null, this._SRID = null, this._userData = null, this._factory = t, this._SRID = t.getSRID();
    }, Jl = {
        serialVersionUID: {
            configurable: !0
        },
        SORTINDEX_POINT: {
            configurable: !0
        },
        SORTINDEX_MULTIPOINT: {
            configurable: !0
        },
        SORTINDEX_LINESTRING: {
            configurable: !0
        },
        SORTINDEX_LINEARRING: {
            configurable: !0
        },
        SORTINDEX_MULTILINESTRING: {
            configurable: !0
        },
        SORTINDEX_POLYGON: {
            configurable: !0
        },
        SORTINDEX_MULTIPOLYGON: {
            configurable: !0
        },
        SORTINDEX_GEOMETRYCOLLECTION: {
            configurable: !0
        },
        geometryChangedFilter: {
            configurable: !0
        }
    };
    Wl.prototype.isGeometryCollection = function() {
        return this.getSortIndex() === Wl.SORTINDEX_GEOMETRYCOLLECTION;
    }, Wl.prototype.getFactory = function() {
        return this._factory;
    }, Wl.prototype.getGeometryN = function(t) {
        return this;
    }, Wl.prototype.getArea = function() {
        return 0;
    }, Wl.prototype.isRectangle = function() {
        return !1;
    }, Wl.prototype.equals = function() {
        if (arguments[0] instanceof Wl) {
            var t = arguments[0];
            return null !== t && this.equalsTopo(t);
        }
        if (arguments[0] instanceof Object) {
            var e = arguments[0];
            if (!(e instanceof Wl)) return !1;
            var n = e;
            return this.equalsExact(n);
        }
    }, Wl.prototype.equalsExact = function(t) {
        return this === t || this.equalsExact(t, 0);
    }, Wl.prototype.geometryChanged = function() {
        this.apply(Wl.geometryChangedFilter);
    }, Wl.prototype.geometryChangedAction = function() {
        this._envelope = null;
    }, Wl.prototype.equalsNorm = function(t) {
        return null !== t && this.norm().equalsExact(t.norm());
    }, Wl.prototype.getLength = function() {
        return 0;
    }, Wl.prototype.getNumGeometries = function() {
        return 1;
    }, Wl.prototype.compareTo = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = t;
            return this.getSortIndex() !== e.getSortIndex() ? this.getSortIndex() - e.getSortIndex() : this.isEmpty() && e.isEmpty() ? 0 : this.isEmpty() ? -1 : e.isEmpty() ? 1 : this.compareToSameClass(t);
        }
        if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1];
            return this.getSortIndex() !== n.getSortIndex() ? this.getSortIndex() - n.getSortIndex() : this.isEmpty() && n.isEmpty() ? 0 : this.isEmpty() ? -1 : n.isEmpty() ? 1 : this.compareToSameClass(n, r);
        }
    }, Wl.prototype.getUserData = function() {
        return this._userData;
    }, Wl.prototype.getSRID = function() {
        return this._SRID;
    }, Wl.prototype.getEnvelope = function() {
        return this.getFactory().toGeometry(this.getEnvelopeInternal());
    }, Wl.prototype.checkNotGeometryCollection = function(t) {
        if (t.getSortIndex() === Wl.SORTINDEX_GEOMETRYCOLLECTION) throw new el("This method does not support GeometryCollection arguments");
    }, Wl.prototype.equal = function(t, e, n) {
        return 0 === n ? t.equals(e) : t.distance(e) <= n;
    }, Wl.prototype.norm = function() {
        var t = this.copy();
        return t.normalize(), t;
    }, Wl.prototype.getPrecisionModel = function() {
        return this._factory.getPrecisionModel();
    }, Wl.prototype.getEnvelopeInternal = function() {
        return null === this._envelope && (this._envelope = this.computeEnvelopeInternal()), new Ll(this._envelope);
    }, Wl.prototype.setSRID = function(t) {
        this._SRID = t;
    }, Wl.prototype.setUserData = function(t) {
        this._userData = t;
    }, Wl.prototype.compare = function(t, e) {
        for(var n = t.iterator(), r = e.iterator(); n.hasNext() && r.hasNext();){
            var i = n.next(), o = r.next(), s = i.compareTo(o);
            if (0 !== s) return s;
        }
        return n.hasNext() ? 1 : r.hasNext() ? -1 : 0;
    }, Wl.prototype.hashCode = function() {
        return this.getEnvelopeInternal().hashCode();
    }, Wl.prototype.isGeometryCollectionOrDerived = function() {
        return this.getSortIndex() === Wl.SORTINDEX_GEOMETRYCOLLECTION || this.getSortIndex() === Wl.SORTINDEX_MULTIPOINT || this.getSortIndex() === Wl.SORTINDEX_MULTILINESTRING || this.getSortIndex() === Wl.SORTINDEX_MULTIPOLYGON;
    }, Wl.prototype.interfaces_ = function() {
        return [
            ol,
            il,
            al
        ];
    }, Wl.prototype.getClass = function() {
        return Wl;
    }, Wl.hasNonEmptyElements = function(t) {
        for(var e = 0; e < t.length; e++)if (!t[e].isEmpty()) return !0;
        return !1;
    }, Wl.hasNullElements = function(t) {
        for(var e = 0; e < t.length; e++)if (null === t[e]) return !0;
        return !1;
    }, Jl.serialVersionUID.get = function() {
        return 0x799ea46522854c00;
    }, Jl.SORTINDEX_POINT.get = function() {
        return 0;
    }, Jl.SORTINDEX_MULTIPOINT.get = function() {
        return 1;
    }, Jl.SORTINDEX_LINESTRING.get = function() {
        return 2;
    }, Jl.SORTINDEX_LINEARRING.get = function() {
        return 3;
    }, Jl.SORTINDEX_MULTILINESTRING.get = function() {
        return 4;
    }, Jl.SORTINDEX_POLYGON.get = function() {
        return 5;
    }, Jl.SORTINDEX_MULTIPOLYGON.get = function() {
        return 6;
    }, Jl.SORTINDEX_GEOMETRYCOLLECTION.get = function() {
        return 7;
    }, Jl.geometryChangedFilter.get = function() {
        return Zl;
    }, Object.defineProperties(Wl, Jl);
    var Zl = function() {};
    Zl.interfaces_ = function() {
        return [
            Hl
        ];
    }, Zl.filter = function(t) {
        t.geometryChangedAction();
    };
    var Kl = function() {};
    Kl.prototype.filter = function(t) {}, Kl.prototype.interfaces_ = function() {
        return [];
    }, Kl.prototype.getClass = function() {
        return Kl;
    };
    var Ql = function() {}, $l = {
        Mod2BoundaryNodeRule: {
            configurable: !0
        },
        EndPointBoundaryNodeRule: {
            configurable: !0
        },
        MultiValentEndPointBoundaryNodeRule: {
            configurable: !0
        },
        MonoValentEndPointBoundaryNodeRule: {
            configurable: !0
        },
        MOD2_BOUNDARY_RULE: {
            configurable: !0
        },
        ENDPOINT_BOUNDARY_RULE: {
            configurable: !0
        },
        MULTIVALENT_ENDPOINT_BOUNDARY_RULE: {
            configurable: !0
        },
        MONOVALENT_ENDPOINT_BOUNDARY_RULE: {
            configurable: !0
        },
        OGC_SFS_BOUNDARY_RULE: {
            configurable: !0
        }
    };
    Ql.prototype.isInBoundary = function(t) {}, Ql.prototype.interfaces_ = function() {
        return [];
    }, Ql.prototype.getClass = function() {
        return Ql;
    }, $l.Mod2BoundaryNodeRule.get = function() {
        return tc;
    }, $l.EndPointBoundaryNodeRule.get = function() {
        return ec;
    }, $l.MultiValentEndPointBoundaryNodeRule.get = function() {
        return nc;
    }, $l.MonoValentEndPointBoundaryNodeRule.get = function() {
        return rc;
    }, $l.MOD2_BOUNDARY_RULE.get = function() {
        return new tc;
    }, $l.ENDPOINT_BOUNDARY_RULE.get = function() {
        return new ec;
    }, $l.MULTIVALENT_ENDPOINT_BOUNDARY_RULE.get = function() {
        return new nc;
    }, $l.MONOVALENT_ENDPOINT_BOUNDARY_RULE.get = function() {
        return new rc;
    }, $l.OGC_SFS_BOUNDARY_RULE.get = function() {
        return Ql.MOD2_BOUNDARY_RULE;
    }, Object.defineProperties(Ql, $l);
    var tc = function() {};
    tc.prototype.isInBoundary = function(t) {
        return t % 2 == 1;
    }, tc.prototype.interfaces_ = function() {
        return [
            Ql
        ];
    }, tc.prototype.getClass = function() {
        return tc;
    };
    var ec = function() {};
    ec.prototype.isInBoundary = function(t) {
        return t > 0;
    }, ec.prototype.interfaces_ = function() {
        return [
            Ql
        ];
    }, ec.prototype.getClass = function() {
        return ec;
    };
    var nc = function() {};
    nc.prototype.isInBoundary = function(t) {
        return t > 1;
    }, nc.prototype.interfaces_ = function() {
        return [
            Ql
        ];
    }, nc.prototype.getClass = function() {
        return nc;
    };
    var rc = function() {};
    rc.prototype.isInBoundary = function(t) {
        return 1 === t;
    }, rc.prototype.interfaces_ = function() {
        return [
            Ql
        ];
    }, rc.prototype.getClass = function() {
        return rc;
    };
    var ic = function() {};
    function oc(t) {
        this.message = t || "";
    }
    ic.prototype.add = function() {}, ic.prototype.addAll = function() {}, ic.prototype.isEmpty = function() {}, ic.prototype.iterator = function() {}, ic.prototype.size = function() {}, ic.prototype.toArray = function() {}, ic.prototype.remove = function() {}, oc.prototype = new Error, oc.prototype.name = "IndexOutOfBoundsException";
    var sc = function() {};
    sc.prototype.hasNext = function() {}, sc.prototype.next = function() {}, sc.prototype.remove = function() {};
    var ac = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function() {}, e.prototype.set = function() {}, e.prototype.isEmpty = function() {}, e;
    }(ic);
    function uc(t) {
        this.message = t || "";
    }
    uc.prototype = new Error, uc.prototype.name = "NoSuchElementException";
    var lc = function(t) {
        function e() {
            t.call(this), this.array_ = [], arguments[0] instanceof ic && this.addAll(arguments[0]);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.ensureCapacity = function() {}, e.prototype.interfaces_ = function() {
            return [
                t,
                ic
            ];
        }, e.prototype.add = function(t) {
            return 1 === arguments.length ? this.array_.push(t) : this.array_.splice(arguments[0], arguments[1]), !0;
        }, e.prototype.clear = function() {
            this.array_ = [];
        }, e.prototype.addAll = function(t) {
            for(var e = t.iterator(); e.hasNext();)this.add(e.next());
            return !0;
        }, e.prototype.set = function(t, e) {
            var n = this.array_[t];
            return this.array_[t] = e, n;
        }, e.prototype.iterator = function() {
            return new cc(this);
        }, e.prototype.get = function(t) {
            if (t < 0 || t >= this.size()) throw new oc;
            return this.array_[t];
        }, e.prototype.isEmpty = function() {
            return 0 === this.array_.length;
        }, e.prototype.size = function() {
            return this.array_.length;
        }, e.prototype.toArray = function() {
            for(var t = [], e = 0, n = this.array_.length; e < n; e++)t.push(this.array_[e]);
            return t;
        }, e.prototype.remove = function(t) {
            for(var e = !1, n = 0, r = this.array_.length; n < r; n++)if (this.array_[n] === t) {
                this.array_.splice(n, 1), e = !0;
                break;
            }
            return e;
        }, e;
    }(ac), cc = function(t) {
        function e(e) {
            t.call(this), this.arrayList_ = e, this.position_ = 0;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function() {
            if (this.position_ === this.arrayList_.size()) throw new uc;
            return this.arrayList_.get(this.position_++);
        }, e.prototype.hasNext = function() {
            return this.position_ < this.arrayList_.size();
        }, e.prototype.set = function(t) {
            return this.arrayList_.set(this.position_ - 1, t);
        }, e.prototype.remove = function() {
            this.arrayList_.remove(this.arrayList_.get(this.position_));
        }, e;
    }(sc), hc = function(t) {
        function e() {
            if (t.call(this), 0 === arguments.length) ;
            else if (1 === arguments.length) {
                var e = arguments[0];
                this.ensureCapacity(e.length), this.add(e, !0);
            } else if (2 === arguments.length) {
                var n = arguments[0], r = arguments[1];
                this.ensureCapacity(n.length), this.add(n, r);
            }
        }
        t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
        var n = {
            coordArrayType: {
                configurable: !0
            }
        };
        return n.coordArrayType.get = function() {
            return new Array(0).fill(null);
        }, e.prototype.getCoordinate = function(t) {
            return this.get(t);
        }, e.prototype.addAll = function() {
            var e = this;
            if (2 === arguments.length) {
                for(var n = arguments[0], r = arguments[1], i = !1, o = n.iterator(); o.hasNext();)e.add(o.next(), r), i = !0;
                return i;
            }
            return t.prototype.addAll.apply(this, arguments);
        }, e.prototype.clone = function() {
            for(var e = t.prototype.clone.call(this), n = 0; n < this.size(); n++)e.add(n, this.get(n).copy());
            return e;
        }, e.prototype.toCoordinateArray = function() {
            return this.toArray(e.coordArrayType);
        }, e.prototype.add = function() {
            var e = this;
            if (1 === arguments.length) {
                var n = arguments[0];
                t.prototype.add.call(this, n);
            } else if (2 === arguments.length) {
                if (arguments[0] instanceof Array && "boolean" == typeof arguments[1]) {
                    var r = arguments[0], i = arguments[1];
                    return this.add(r, i, !0), !0;
                }
                if (arguments[0] instanceof ul && "boolean" == typeof arguments[1]) {
                    var o = arguments[0], s = arguments[1];
                    if (!s && this.size() >= 1) {
                        var a = this.get(this.size() - 1);
                        if (a.equals2D(o)) return null;
                    }
                    t.prototype.add.call(this, o);
                } else if (arguments[0] instanceof Object && "boolean" == typeof arguments[1]) {
                    var u = arguments[0], l = arguments[1];
                    return this.add(u, l), !0;
                }
            } else if (3 === arguments.length) {
                if ("boolean" == typeof arguments[2] && arguments[0] instanceof Array && "boolean" == typeof arguments[1]) {
                    var c = arguments[0], h = arguments[1], p = arguments[2];
                    if (p) for(var f = 0; f < c.length; f++)e.add(c[f], h);
                    else for(var g = c.length - 1; g >= 0; g--)e.add(c[g], h);
                    return !0;
                }
                if ("boolean" == typeof arguments[2] && Number.isInteger(arguments[0]) && arguments[1] instanceof ul) {
                    var d = arguments[0], y = arguments[1], v = arguments[2];
                    if (!v) {
                        var _ = this.size();
                        if (_ > 0) {
                            if (d > 0) {
                                var m = this.get(d - 1);
                                if (m.equals2D(y)) return null;
                            }
                            if (d < _) {
                                var x = this.get(d);
                                if (x.equals2D(y)) return null;
                            }
                        }
                    }
                    t.prototype.add.call(this, d, y);
                }
            } else if (4 === arguments.length) {
                var E = arguments[0], b = arguments[1], w = arguments[2], I = arguments[3], N = 1;
                w > I && (N = -1);
                for(var S = w; S !== I; S += N)e.add(E[S], b);
                return !0;
            }
        }, e.prototype.closeRing = function() {
            this.size() > 0 && this.add(new ul(this.get(0)), !1);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, Object.defineProperties(e, n), e;
    }(lc), pc = function() {}, fc = {
        ForwardComparator: {
            configurable: !0
        },
        BidirectionalComparator: {
            configurable: !0
        },
        coordArrayType: {
            configurable: !0
        }
    };
    fc.ForwardComparator.get = function() {
        return gc;
    }, fc.BidirectionalComparator.get = function() {
        return dc;
    }, fc.coordArrayType.get = function() {
        return new Array(0).fill(null);
    }, pc.prototype.interfaces_ = function() {
        return [];
    }, pc.prototype.getClass = function() {
        return pc;
    }, pc.isRing = function(t) {
        return !(t.length < 4) && !!t[0].equals2D(t[t.length - 1]);
    }, pc.ptNotInList = function(t, e) {
        for(var n = 0; n < t.length; n++){
            var r = t[n];
            if (pc.indexOf(r, e) < 0) return r;
        }
        return null;
    }, pc.scroll = function(t, e) {
        var n = pc.indexOf(e, t);
        if (n < 0) return null;
        var r = new Array(t.length).fill(null);
        Pl.arraycopy(t, n, r, 0, t.length - n), Pl.arraycopy(t, 0, r, t.length - n, n), Pl.arraycopy(r, 0, t, 0, t.length);
    }, pc.equals = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            if (t === e) return !0;
            if (null === t || null === e) return !1;
            if (t.length !== e.length) return !1;
            for(var n = 0; n < t.length; n++)if (!t[n].equals(e[n])) return !1;
            return !0;
        }
        if (3 === arguments.length) {
            var r = arguments[0], i = arguments[1], o = arguments[2];
            if (r === i) return !0;
            if (null === r || null === i) return !1;
            if (r.length !== i.length) return !1;
            for(var s = 0; s < r.length; s++)if (0 !== o.compare(r[s], i[s])) return !1;
            return !0;
        }
    }, pc.intersection = function(t, e) {
        for(var n = new hc, r = 0; r < t.length; r++)e.intersects(t[r]) && n.add(t[r], !0);
        return n.toCoordinateArray();
    }, pc.hasRepeatedPoints = function(t) {
        for(var e = 1; e < t.length; e++)if (t[e - 1].equals(t[e])) return !0;
        return !1;
    }, pc.removeRepeatedPoints = function(t) {
        return pc.hasRepeatedPoints(t) ? new hc(t, !1).toCoordinateArray() : t;
    }, pc.reverse = function(t) {
        for(var e = t.length - 1, n = Math.trunc(e / 2), r = 0; r <= n; r++){
            var i = t[r];
            t[r] = t[e - r], t[e - r] = i;
        }
    }, pc.removeNull = function(t) {
        for(var e = 0, n = 0; n < t.length; n++)null !== t[n] && e++;
        var r = new Array(e).fill(null);
        if (0 === e) return r;
        for(var i = 0, o = 0; o < t.length; o++)null !== t[o] && (r[i++] = t[o]);
        return r;
    }, pc.copyDeep = function() {
        if (1 === arguments.length) {
            for(var t = arguments[0], e = new Array(t.length).fill(null), n = 0; n < t.length; n++)e[n] = new ul(t[n]);
            return e;
        }
        if (5 === arguments.length) for(var r = arguments[0], i = arguments[1], o = arguments[2], s = arguments[3], a = arguments[4], u = 0; u < a; u++)o[s + u] = new ul(r[i + u]);
    }, pc.isEqualReversed = function(t, e) {
        for(var n = 0; n < t.length; n++){
            var r = t[n], i = e[t.length - n - 1];
            if (0 !== r.compareTo(i)) return !1;
        }
        return !0;
    }, pc.envelope = function(t) {
        for(var e = new Ll, n = 0; n < t.length; n++)e.expandToInclude(t[n]);
        return e;
    }, pc.toCoordinateArray = function(t) {
        return t.toArray(pc.coordArrayType);
    }, pc.atLeastNCoordinatesOrNothing = function(t, e) {
        return e.length >= t ? e : [];
    }, pc.indexOf = function(t, e) {
        for(var n = 0; n < e.length; n++)if (t.equals(e[n])) return n;
        return -1;
    }, pc.increasingDirection = function(t) {
        for(var e = 0; e < Math.trunc(t.length / 2); e++){
            var n = t.length - 1 - e, r = t[e].compareTo(t[n]);
            if (0 !== r) return r;
        }
        return 1;
    }, pc.compare = function(t, e) {
        for(var n = 0; n < t.length && n < e.length;){
            var r = t[n].compareTo(e[n]);
            if (0 !== r) return r;
            n++;
        }
        return n < e.length ? -1 : n < t.length ? 1 : 0;
    }, pc.minCoordinate = function(t) {
        for(var e = null, n = 0; n < t.length; n++)(null === e || e.compareTo(t[n]) > 0) && (e = t[n]);
        return e;
    }, pc.extract = function(t, e, n) {
        e = dl.clamp(e, 0, t.length);
        var r = (n = dl.clamp(n, -1, t.length)) - e + 1;
        n < 0 && (r = 0), e >= t.length && (r = 0), n < e && (r = 0);
        var i = new Array(r).fill(null);
        if (0 === r) return i;
        for(var o = 0, s = e; s <= n; s++)i[o++] = t[s];
        return i;
    }, Object.defineProperties(pc, fc);
    var gc = function() {};
    gc.prototype.compare = function(t, e) {
        return pc.compare(t, e);
    }, gc.prototype.interfaces_ = function() {
        return [
            sl
        ];
    }, gc.prototype.getClass = function() {
        return gc;
    };
    var dc = function() {};
    dc.prototype.compare = function(t, e) {
        var n = t, r = e;
        if (n.length < r.length) return -1;
        if (n.length > r.length) return 1;
        if (0 === n.length) return 0;
        var i = pc.compare(n, r);
        return pc.isEqualReversed(n, r) ? 0 : i;
    }, dc.prototype.OLDcompare = function(t, e) {
        var n = t, r = e;
        if (n.length < r.length) return -1;
        if (n.length > r.length) return 1;
        if (0 === n.length) return 0;
        for(var i = pc.increasingDirection(n), o = pc.increasingDirection(r), s = i > 0 ? 0 : n.length - 1, a = o > 0 ? 0 : n.length - 1, u = 0; u < n.length; u++){
            var l = n[s].compareTo(r[a]);
            if (0 !== l) return l;
            s += i, a += o;
        }
        return 0;
    }, dc.prototype.interfaces_ = function() {
        return [
            sl
        ];
    }, dc.prototype.getClass = function() {
        return dc;
    };
    var yc = function() {};
    yc.prototype.get = function() {}, yc.prototype.put = function() {}, yc.prototype.size = function() {}, yc.prototype.values = function() {}, yc.prototype.entrySet = function() {};
    var vc = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
    }(yc);
    function _c(t) {
        this.message = t || "";
    }
    function mc() {}
    _c.prototype = new Error, _c.prototype.name = "OperationNotSupported", mc.prototype = new ic, mc.prototype.contains = function() {};
    var xc = function(t) {
        function e() {
            t.call(this), this.array_ = [], arguments[0] instanceof ic && this.addAll(arguments[0]);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.contains = function(t) {
            for(var e = 0, n = this.array_.length; e < n; e++){
                if (this.array_[e] === t) return !0;
            }
            return !1;
        }, e.prototype.add = function(t) {
            return !this.contains(t) && (this.array_.push(t), !0);
        }, e.prototype.addAll = function(t) {
            for(var e = t.iterator(); e.hasNext();)this.add(e.next());
            return !0;
        }, e.prototype.remove = function(t) {
            throw new Error;
        }, e.prototype.size = function() {
            return this.array_.length;
        }, e.prototype.isEmpty = function() {
            return 0 === this.array_.length;
        }, e.prototype.toArray = function() {
            for(var t = [], e = 0, n = this.array_.length; e < n; e++)t.push(this.array_[e]);
            return t;
        }, e.prototype.iterator = function() {
            return new Ec(this);
        }, e;
    }(mc), Ec = function(t) {
        function e(e) {
            t.call(this), this.hashSet_ = e, this.position_ = 0;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function() {
            if (this.position_ === this.hashSet_.size()) throw new uc;
            return this.hashSet_.array_[this.position_++];
        }, e.prototype.hasNext = function() {
            return this.position_ < this.hashSet_.size();
        }, e.prototype.remove = function() {
            throw new _c;
        }, e;
    }(sc);
    function bc(t) {
        return null === t ? 0 : t.color;
    }
    function wc(t) {
        return null === t ? null : t.parent;
    }
    function Ic(t, e) {
        null !== t && (t.color = e);
    }
    function Nc(t) {
        return null === t ? null : t.left;
    }
    function Sc(t) {
        return null === t ? null : t.right;
    }
    function Cc() {
        this.root_ = null, this.size_ = 0;
    }
    Cc.prototype = new vc, Cc.prototype.get = function(t) {
        for(var e = this.root_; null !== e;){
            var n = t.compareTo(e.key);
            if (n < 0) e = e.left;
            else {
                if (!(n > 0)) return e.value;
                e = e.right;
            }
        }
        return null;
    }, Cc.prototype.put = function(t, e) {
        if (null === this.root_) return this.root_ = {
            key: t,
            value: e,
            left: null,
            right: null,
            parent: null,
            color: 0,
            getValue: function() {
                return this.value;
            },
            getKey: function() {
                return this.key;
            }
        }, this.size_ = 1, null;
        var n, r, i = this.root_;
        do if (n = i, (r = t.compareTo(i.key)) < 0) i = i.left;
        else {
            if (!(r > 0)) {
                var o = i.value;
                return i.value = e, o;
            }
            i = i.right;
        }
        while (null !== i);
        var s = {
            key: t,
            left: null,
            right: null,
            value: e,
            parent: n,
            color: 0,
            getValue: function() {
                return this.value;
            },
            getKey: function() {
                return this.key;
            }
        };
        return r < 0 ? n.left = s : n.right = s, this.fixAfterInsertion(s), this.size_++, null;
    }, Cc.prototype.fixAfterInsertion = function(t) {
        var e = this;
        for(t.color = 1; null != t && t !== this.root_ && 1 === t.parent.color;)if (wc(t) === Nc(wc(wc(t)))) {
            var n = Sc(wc(wc(t)));
            1 === bc(n) ? (Ic(wc(t), 0), Ic(n, 0), Ic(wc(wc(t)), 1), t = wc(wc(t))) : (t === Sc(wc(t)) && (t = wc(t), e.rotateLeft(t)), Ic(wc(t), 0), Ic(wc(wc(t)), 1), e.rotateRight(wc(wc(t))));
        } else {
            var r = Nc(wc(wc(t)));
            1 === bc(r) ? (Ic(wc(t), 0), Ic(r, 0), Ic(wc(wc(t)), 1), t = wc(wc(t))) : (t === Nc(wc(t)) && (t = wc(t), e.rotateRight(t)), Ic(wc(t), 0), Ic(wc(wc(t)), 1), e.rotateLeft(wc(wc(t))));
        }
        this.root_.color = 0;
    }, Cc.prototype.values = function() {
        var t = new lc, e = this.getFirstEntry();
        if (null !== e) for(t.add(e.value); null !== (e = Cc.successor(e));)t.add(e.value);
        return t;
    }, Cc.prototype.entrySet = function() {
        var t = new xc, e = this.getFirstEntry();
        if (null !== e) for(t.add(e); null !== (e = Cc.successor(e));)t.add(e);
        return t;
    }, Cc.prototype.rotateLeft = function(t) {
        if (null != t) {
            var e = t.right;
            t.right = e.left, null != e.left && (e.left.parent = t), e.parent = t.parent, null === t.parent ? this.root_ = e : t.parent.left === t ? t.parent.left = e : t.parent.right = e, e.left = t, t.parent = e;
        }
    }, Cc.prototype.rotateRight = function(t) {
        if (null != t) {
            var e = t.left;
            t.left = e.right, null != e.right && (e.right.parent = t), e.parent = t.parent, null === t.parent ? this.root_ = e : t.parent.right === t ? t.parent.right = e : t.parent.left = e, e.right = t, t.parent = e;
        }
    }, Cc.prototype.getFirstEntry = function() {
        var t = this.root_;
        if (null != t) for(; null != t.left;)t = t.left;
        return t;
    }, Cc.successor = function(t) {
        if (null === t) return null;
        if (null !== t.right) {
            for(var e = t.right; null !== e.left;)e = e.left;
            return e;
        }
        for(var n = t.parent, r = t; null !== n && r === n.right;)r = n, n = n.parent;
        return n;
    }, Cc.prototype.size = function() {
        return this.size_;
    };
    var Pc = function() {};
    function Mc() {}
    function Lc() {
        this.array_ = [], arguments[0] instanceof ic && this.addAll(arguments[0]);
    }
    Pc.prototype.interfaces_ = function() {
        return [];
    }, Pc.prototype.getClass = function() {
        return Pc;
    }, Mc.prototype = new mc, Lc.prototype = new Mc, Lc.prototype.contains = function(t) {
        for(var e = 0, n = this.array_.length; e < n; e++){
            if (0 === this.array_[e].compareTo(t)) return !0;
        }
        return !1;
    }, Lc.prototype.add = function(t) {
        if (this.contains(t)) return !1;
        for(var e = 0, n = this.array_.length; e < n; e++){
            if (1 === this.array_[e].compareTo(t)) return this.array_.splice(e, 0, t), !0;
        }
        return this.array_.push(t), !0;
    }, Lc.prototype.addAll = function(t) {
        for(var e = t.iterator(); e.hasNext();)this.add(e.next());
        return !0;
    }, Lc.prototype.remove = function(t) {
        throw new _c;
    }, Lc.prototype.size = function() {
        return this.array_.length;
    }, Lc.prototype.isEmpty = function() {
        return 0 === this.array_.length;
    }, Lc.prototype.toArray = function() {
        for(var t = [], e = 0, n = this.array_.length; e < n; e++)t.push(this.array_[e]);
        return t;
    }, Lc.prototype.iterator = function() {
        return new Oc(this);
    };
    var Oc = function(t) {
        this.treeSet_ = t, this.position_ = 0;
    };
    Oc.prototype.next = function() {
        if (this.position_ === this.treeSet_.size()) throw new uc;
        return this.treeSet_.array_[this.position_++];
    }, Oc.prototype.hasNext = function() {
        return this.position_ < this.treeSet_.size();
    }, Oc.prototype.remove = function() {
        throw new _c;
    };
    var Rc = function() {};
    Rc.sort = function() {
        var t, e, n, r, i = arguments[0];
        if (1 === arguments.length) r = function(t, e) {
            return t.compareTo(e);
        }, i.sort(r);
        else if (2 === arguments.length) n = arguments[1], r = function(t, e) {
            return n.compare(t, e);
        }, i.sort(r);
        else if (3 === arguments.length) {
            (e = i.slice(arguments[1], arguments[2])).sort();
            var o = i.slice(0, arguments[1]).concat(e, i.slice(arguments[2], i.length));
            for(i.splice(0, i.length), t = 0; t < o.length; t++)i.push(o[t]);
        } else if (4 === arguments.length) for(e = i.slice(arguments[1], arguments[2]), n = arguments[3], r = function(t, e) {
            return n.compare(t, e);
        }, e.sort(r), o = i.slice(0, arguments[1]).concat(e, i.slice(arguments[2], i.length)), i.splice(0, i.length), t = 0; t < o.length; t++)i.push(o[t]);
    }, Rc.asList = function(t) {
        for(var e = new lc, n = 0, r = t.length; n < r; n++)e.add(t[n]);
        return e;
    };
    var Tc = function() {}, Ac = {
        P: {
            configurable: !0
        },
        L: {
            configurable: !0
        },
        A: {
            configurable: !0
        },
        FALSE: {
            configurable: !0
        },
        TRUE: {
            configurable: !0
        },
        DONTCARE: {
            configurable: !0
        },
        SYM_FALSE: {
            configurable: !0
        },
        SYM_TRUE: {
            configurable: !0
        },
        SYM_DONTCARE: {
            configurable: !0
        },
        SYM_P: {
            configurable: !0
        },
        SYM_L: {
            configurable: !0
        },
        SYM_A: {
            configurable: !0
        }
    };
    Ac.P.get = function() {
        return 0;
    }, Ac.L.get = function() {
        return 1;
    }, Ac.A.get = function() {
        return 2;
    }, Ac.FALSE.get = function() {
        return -1;
    }, Ac.TRUE.get = function() {
        return -2;
    }, Ac.DONTCARE.get = function() {
        return -3;
    }, Ac.SYM_FALSE.get = function() {
        return "F";
    }, Ac.SYM_TRUE.get = function() {
        return "T";
    }, Ac.SYM_DONTCARE.get = function() {
        return "*";
    }, Ac.SYM_P.get = function() {
        return "0";
    }, Ac.SYM_L.get = function() {
        return "1";
    }, Ac.SYM_A.get = function() {
        return "2";
    }, Tc.prototype.interfaces_ = function() {
        return [];
    }, Tc.prototype.getClass = function() {
        return Tc;
    }, Tc.toDimensionSymbol = function(t) {
        switch(t){
            case Tc.FALSE:
                return Tc.SYM_FALSE;
            case Tc.TRUE:
                return Tc.SYM_TRUE;
            case Tc.DONTCARE:
                return Tc.SYM_DONTCARE;
            case Tc.P:
                return Tc.SYM_P;
            case Tc.L:
                return Tc.SYM_L;
            case Tc.A:
                return Tc.SYM_A;
        }
        throw new el("Unknown dimension value: " + t);
    }, Tc.toDimensionValue = function(t) {
        switch(ml.toUpperCase(t)){
            case Tc.SYM_FALSE:
                return Tc.FALSE;
            case Tc.SYM_TRUE:
                return Tc.TRUE;
            case Tc.SYM_DONTCARE:
                return Tc.DONTCARE;
            case Tc.SYM_P:
                return Tc.P;
            case Tc.SYM_L:
                return Tc.L;
            case Tc.SYM_A:
                return Tc.A;
        }
        throw new el("Unknown dimension symbol: " + t);
    }, Object.defineProperties(Tc, Ac);
    var Dc = function() {};
    Dc.prototype.filter = function(t) {}, Dc.prototype.interfaces_ = function() {
        return [];
    }, Dc.prototype.getClass = function() {
        return Dc;
    };
    var Fc = function() {};
    Fc.prototype.filter = function(t, e) {}, Fc.prototype.isDone = function() {}, Fc.prototype.isGeometryChanged = function() {}, Fc.prototype.interfaces_ = function() {
        return [];
    }, Fc.prototype.getClass = function() {
        return Fc;
    };
    var kc = function(t) {
        function e(e, n) {
            if (t.call(this, n), this._geometries = e || [], t.hasNullElements(this._geometries)) throw new el("geometries must not contain null elements");
        }
        t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.computeEnvelopeInternal = function() {
            for(var t = new Ll, e = 0; e < this._geometries.length; e++)t.expandToInclude(this._geometries[e].getEnvelopeInternal());
            return t;
        }, e.prototype.getGeometryN = function(t) {
            return this._geometries[t];
        }, e.prototype.getSortIndex = function() {
            return t.SORTINDEX_GEOMETRYCOLLECTION;
        }, e.prototype.getCoordinates = function() {
            for(var t = new Array(this.getNumPoints()).fill(null), e = -1, n = 0; n < this._geometries.length; n++)for(var r = this._geometries[n].getCoordinates(), i = 0; i < r.length; i++)t[++e] = r[i];
            return t;
        }, e.prototype.getArea = function() {
            for(var t = 0, e = 0; e < this._geometries.length; e++)t += this._geometries[e].getArea();
            return t;
        }, e.prototype.equalsExact = function() {
            var e = this;
            if (2 === arguments.length) {
                var n = arguments[0], r = arguments[1];
                if (!this.isEquivalentClass(n)) return !1;
                var i = n;
                if (this._geometries.length !== i._geometries.length) return !1;
                for(var o = 0; o < this._geometries.length; o++)if (!e._geometries[o].equalsExact(i._geometries[o], r)) return !1;
                return !0;
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.normalize = function() {
            for(var t = 0; t < this._geometries.length; t++)this._geometries[t].normalize();
            Rc.sort(this._geometries);
        }, e.prototype.getCoordinate = function() {
            return this.isEmpty() ? null : this._geometries[0].getCoordinate();
        }, e.prototype.getBoundaryDimension = function() {
            for(var t = Tc.FALSE, e = 0; e < this._geometries.length; e++)t = Math.max(t, this._geometries[e].getBoundaryDimension());
            return t;
        }, e.prototype.getDimension = function() {
            for(var t = Tc.FALSE, e = 0; e < this._geometries.length; e++)t = Math.max(t, this._geometries[e].getDimension());
            return t;
        }, e.prototype.getLength = function() {
            for(var t = 0, e = 0; e < this._geometries.length; e++)t += this._geometries[e].getLength();
            return t;
        }, e.prototype.getNumPoints = function() {
            for(var t = 0, e = 0; e < this._geometries.length; e++)t += this._geometries[e].getNumPoints();
            return t;
        }, e.prototype.getNumGeometries = function() {
            return this._geometries.length;
        }, e.prototype.reverse = function() {
            for(var t = this._geometries.length, e = new Array(t).fill(null), n = 0; n < this._geometries.length; n++)e[n] = this._geometries[n].reverse();
            return this.getFactory().createGeometryCollection(e);
        }, e.prototype.compareToSameClass = function() {
            var t = this;
            if (1 === arguments.length) {
                var e = arguments[0], n = new Lc(Rc.asList(this._geometries)), r = new Lc(Rc.asList(e._geometries));
                return this.compare(n, r);
            }
            if (2 === arguments.length) {
                for(var i = arguments[0], o = arguments[1], s = i, a = this.getNumGeometries(), u = s.getNumGeometries(), l = 0; l < a && l < u;){
                    var c = t.getGeometryN(l), h = s.getGeometryN(l), p = c.compareToSameClass(h, o);
                    if (0 !== p) return p;
                    l++;
                }
                return l < a ? 1 : l < u ? -1 : 0;
            }
        }, e.prototype.apply = function() {
            var t = this;
            if (gl(arguments[0], Kl)) for(var e = arguments[0], n = 0; n < this._geometries.length; n++)t._geometries[n].apply(e);
            else if (gl(arguments[0], Fc)) {
                var r = arguments[0];
                if (0 === this._geometries.length) return null;
                for(var i = 0; i < this._geometries.length && (t._geometries[i].apply(r), !r.isDone()); i++);
                r.isGeometryChanged() && this.geometryChanged();
            } else if (gl(arguments[0], Dc)) {
                var o = arguments[0];
                o.filter(this);
                for(var s = 0; s < this._geometries.length; s++)t._geometries[s].apply(o);
            } else if (gl(arguments[0], Hl)) {
                var a = arguments[0];
                a.filter(this);
                for(var u = 0; u < this._geometries.length; u++)t._geometries[u].apply(a);
            }
        }, e.prototype.getBoundary = function() {
            return this.checkNotGeometryCollection(this), ql.shouldNeverReachHere(), null;
        }, e.prototype.clone = function() {
            var e = t.prototype.clone.call(this);
            e._geometries = new Array(this._geometries.length).fill(null);
            for(var n = 0; n < this._geometries.length; n++)e._geometries[n] = this._geometries[n].clone();
            return e;
        }, e.prototype.getGeometryType = function() {
            return "GeometryCollection";
        }, e.prototype.copy = function() {
            for(var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++)t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
        }, e.prototype.isEmpty = function() {
            for(var t = 0; t < this._geometries.length; t++)if (!this._geometries[t].isEmpty()) return !1;
            return !0;
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return -5694727726395021000;
        }, Object.defineProperties(e, n), e;
    }(Wl), Gc = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.getSortIndex = function() {
            return Wl.SORTINDEX_MULTILINESTRING;
        }, e.prototype.equalsExact = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                return !!this.isEquivalentClass(e) && t.prototype.equalsExact.call(this, e, n);
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.getBoundaryDimension = function() {
            return this.isClosed() ? Tc.FALSE : 0;
        }, e.prototype.isClosed = function() {
            if (this.isEmpty()) return !1;
            for(var t = 0; t < this._geometries.length; t++)if (!this._geometries[t].isClosed()) return !1;
            return !0;
        }, e.prototype.getDimension = function() {
            return 1;
        }, e.prototype.reverse = function() {
            for(var t = this._geometries.length, e = new Array(t).fill(null), n = 0; n < this._geometries.length; n++)e[t - 1 - n] = this._geometries[n].reverse();
            return this.getFactory().createMultiLineString(e);
        }, e.prototype.getBoundary = function() {
            return new qc(this).getBoundary();
        }, e.prototype.getGeometryType = function() {
            return "MultiLineString";
        }, e.prototype.copy = function() {
            for(var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++)t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
        }, e.prototype.interfaces_ = function() {
            return [
                Pc
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return 0x7155d2ab4afa8000;
        }, Object.defineProperties(e, n), e;
    }(kc), qc = function() {
        if (this._geom = null, this._geomFact = null, this._bnRule = null, this._endpointMap = null, 1 === arguments.length) {
            var t = arguments[0], e = Ql.MOD2_BOUNDARY_RULE;
            this._geom = t, this._geomFact = t.getFactory(), this._bnRule = e;
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1];
            this._geom = n, this._geomFact = n.getFactory(), this._bnRule = r;
        }
    };
    qc.prototype.boundaryMultiLineString = function(t) {
        if (this._geom.isEmpty()) return this.getEmptyMultiPoint();
        var e = this.computeBoundaryCoordinates(t);
        return 1 === e.length ? this._geomFact.createPoint(e[0]) : this._geomFact.createMultiPointFromCoords(e);
    }, qc.prototype.getBoundary = function() {
        return this._geom instanceof Zc ? this.boundaryLineString(this._geom) : this._geom instanceof Gc ? this.boundaryMultiLineString(this._geom) : this._geom.getBoundary();
    }, qc.prototype.boundaryLineString = function(t) {
        return this._geom.isEmpty() ? this.getEmptyMultiPoint() : t.isClosed() ? this._bnRule.isInBoundary(2) ? t.getStartPoint() : this._geomFact.createMultiPoint() : this._geomFact.createMultiPoint([
            t.getStartPoint(),
            t.getEndPoint()
        ]);
    }, qc.prototype.getEmptyMultiPoint = function() {
        return this._geomFact.createMultiPoint();
    }, qc.prototype.computeBoundaryCoordinates = function(t) {
        var e = this, n = new lc;
        this._endpointMap = new Cc;
        for(var r = 0; r < t.getNumGeometries(); r++){
            var i = t.getGeometryN(r);
            0 !== i.getNumPoints() && (e.addEndpoint(i.getCoordinateN(0)), e.addEndpoint(i.getCoordinateN(i.getNumPoints() - 1)));
        }
        for(var o = this._endpointMap.entrySet().iterator(); o.hasNext();){
            var s = o.next(), a = s.getValue().count;
            e._bnRule.isInBoundary(a) && n.add(s.getKey());
        }
        return pc.toCoordinateArray(n);
    }, qc.prototype.addEndpoint = function(t) {
        var e = this._endpointMap.get(t);
        null === e && (e = new Bc, this._endpointMap.put(t, e)), e.count++;
    }, qc.prototype.interfaces_ = function() {
        return [];
    }, qc.prototype.getClass = function() {
        return qc;
    }, qc.getBoundary = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = new qc(t);
            return e.getBoundary();
        }
        if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1], i = new qc(n, r);
            return i.getBoundary();
        }
    };
    var Bc = function() {
        this.count = null;
    };
    function zc() {}
    function jc() {}
    Bc.prototype.interfaces_ = function() {
        return [];
    }, Bc.prototype.getClass = function() {
        return Bc;
    };
    var Uc = function() {};
    function Vc() {}
    function Xc() {}
    function Yc() {}
    var Hc = function() {}, Wc = {
        NEWLINE: {
            configurable: !0
        },
        SIMPLE_ORDINATE_FORMAT: {
            configurable: !0
        }
    };
    Hc.prototype.interfaces_ = function() {
        return [];
    }, Hc.prototype.getClass = function() {
        return Hc;
    }, Hc.chars = function(t, e) {
        for(var n = new Array(e).fill(null), r = 0; r < e; r++)n[r] = t;
        return String(n);
    }, Hc.getStackTrace = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = new Vc, n = new zc(e);
            return t.printStackTrace(n), e.toString();
        }
        if (2 === arguments.length) {
            for(var r = arguments[0], i = arguments[1], o = "", s = new jc(Hc.getStackTrace(r)), a = new Yc(s), u = 0; u < i; u++)try {
                o += a.readLine() + Hc.NEWLINE;
            } catch (t) {
                if (!(t instanceof Xc)) throw t;
                ql.shouldNeverReachHere();
            }
            return o;
        }
    }, Hc.split = function(t, e) {
        for(var n = e.length, r = new lc, i = "" + t, o = i.indexOf(e); o >= 0;){
            var s = i.substring(0, o);
            r.add(s), o = (i = i.substring(o + n)).indexOf(e);
        }
        i.length > 0 && r.add(i);
        for(var a = new Array(r.size()).fill(null), u = 0; u < a.length; u++)a[u] = r.get(u);
        return a;
    }, Hc.toString = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return Hc.SIMPLE_ORDINATE_FORMAT.format(t);
        }
    }, Hc.spaces = function(t) {
        return Hc.chars(" ", t);
    }, Wc.NEWLINE.get = function() {
        return Pl.getProperty("line.separator");
    }, Wc.SIMPLE_ORDINATE_FORMAT.get = function() {
        return new Uc("0.#");
    }, Object.defineProperties(Hc, Wc);
    var Jc = function() {};
    Jc.prototype.interfaces_ = function() {
        return [];
    }, Jc.prototype.getClass = function() {
        return Jc;
    }, Jc.copyCoord = function(t, e, n, r) {
        for(var i = Math.min(t.getDimension(), n.getDimension()), o = 0; o < i; o++)n.setOrdinate(r, o, t.getOrdinate(e, o));
    }, Jc.isRing = function(t) {
        var e = t.size();
        return 0 === e || !(e <= 3) && t.getOrdinate(0, Il.X) === t.getOrdinate(e - 1, Il.X) && t.getOrdinate(0, Il.Y) === t.getOrdinate(e - 1, Il.Y);
    }, Jc.isEqual = function(t, e) {
        var n = t.size();
        if (n !== e.size()) return !1;
        for(var r = Math.min(t.getDimension(), e.getDimension()), i = 0; i < n; i++)for(var o = 0; o < r; o++){
            var s = t.getOrdinate(i, o), a = e.getOrdinate(i, o);
            if (t.getOrdinate(i, o) !== e.getOrdinate(i, o) && (!nl.isNaN(s) || !nl.isNaN(a))) return !1;
        }
        return !0;
    }, Jc.extend = function(t, e, n) {
        var r = t.create(n, e.getDimension()), i = e.size();
        if (Jc.copy(e, 0, r, 0, i), i > 0) for(var o = i; o < n; o++)Jc.copy(e, i - 1, r, o, 1);
        return r;
    }, Jc.reverse = function(t) {
        for(var e = t.size() - 1, n = Math.trunc(e / 2), r = 0; r <= n; r++)Jc.swap(t, r, e - r);
    }, Jc.swap = function(t, e, n) {
        if (e === n) return null;
        for(var r = 0; r < t.getDimension(); r++){
            var i = t.getOrdinate(e, r);
            t.setOrdinate(e, r, t.getOrdinate(n, r)), t.setOrdinate(n, r, i);
        }
    }, Jc.copy = function(t, e, n, r, i) {
        for(var o = 0; o < i; o++)Jc.copyCoord(t, e + o, n, r + o);
    }, Jc.toString = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = t.size();
            if (0 === e) return "()";
            var n = t.getDimension(), r = new vl;
            r.append("(");
            for(var i = 0; i < e; i++){
                i > 0 && r.append(" ");
                for(var o = 0; o < n; o++)o > 0 && r.append(","), r.append(Hc.toString(t.getOrdinate(i, o)));
            }
            return r.append(")"), r.toString();
        }
    }, Jc.ensureValidRing = function(t, e) {
        var n = e.size();
        return 0 === n ? e : n <= 3 ? Jc.createClosedRing(t, e, 4) : e.getOrdinate(0, Il.X) === e.getOrdinate(n - 1, Il.X) && e.getOrdinate(0, Il.Y) === e.getOrdinate(n - 1, Il.Y) ? e : Jc.createClosedRing(t, e, n + 1);
    }, Jc.createClosedRing = function(t, e, n) {
        var r = t.create(n, e.getDimension()), i = e.size();
        Jc.copy(e, 0, r, 0, i);
        for(var o = i; o < n; o++)Jc.copy(e, 0, r, o, 1);
        return r;
    };
    var Zc = function(t) {
        function e(e, n) {
            t.call(this, n), this._points = null, this.init(e);
        }
        t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.computeEnvelopeInternal = function() {
            return this.isEmpty() ? new Ll : this._points.expandEnvelope(new Ll);
        }, e.prototype.isRing = function() {
            return this.isClosed() && this.isSimple();
        }, e.prototype.getSortIndex = function() {
            return t.SORTINDEX_LINESTRING;
        }, e.prototype.getCoordinates = function() {
            return this._points.toCoordinateArray();
        }, e.prototype.equalsExact = function() {
            var e = this;
            if (2 === arguments.length) {
                var n = arguments[0], r = arguments[1];
                if (!this.isEquivalentClass(n)) return !1;
                var i = n;
                if (this._points.size() !== i._points.size()) return !1;
                for(var o = 0; o < this._points.size(); o++)if (!e.equal(e._points.getCoordinate(o), i._points.getCoordinate(o), r)) return !1;
                return !0;
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.normalize = function() {
            for(var t = this, e = 0; e < Math.trunc(this._points.size() / 2); e++){
                var n = t._points.size() - 1 - e;
                if (!t._points.getCoordinate(e).equals(t._points.getCoordinate(n))) return t._points.getCoordinate(e).compareTo(t._points.getCoordinate(n)) > 0 && Jc.reverse(t._points), null;
            }
        }, e.prototype.getCoordinate = function() {
            return this.isEmpty() ? null : this._points.getCoordinate(0);
        }, e.prototype.getBoundaryDimension = function() {
            return this.isClosed() ? Tc.FALSE : 0;
        }, e.prototype.isClosed = function() {
            return !this.isEmpty() && this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints() - 1));
        }, e.prototype.getEndPoint = function() {
            return this.isEmpty() ? null : this.getPointN(this.getNumPoints() - 1);
        }, e.prototype.getDimension = function() {
            return 1;
        }, e.prototype.getLength = function() {
            return Xl.computeLength(this._points);
        }, e.prototype.getNumPoints = function() {
            return this._points.size();
        }, e.prototype.reverse = function() {
            var t = this._points.copy();
            return Jc.reverse(t), this.getFactory().createLineString(t);
        }, e.prototype.compareToSameClass = function() {
            var t = this;
            if (1 === arguments.length) {
                for(var e = arguments[0], n = e, r = 0, i = 0; r < this._points.size() && i < n._points.size();){
                    var o = t._points.getCoordinate(r).compareTo(n._points.getCoordinate(i));
                    if (0 !== o) return o;
                    r++, i++;
                }
                return r < this._points.size() ? 1 : i < n._points.size() ? -1 : 0;
            }
            if (2 === arguments.length) {
                var s = arguments[0], a = arguments[1], u = s;
                return a.compare(this._points, u._points);
            }
        }, e.prototype.apply = function() {
            var t = this;
            if (gl(arguments[0], Kl)) for(var e = arguments[0], n = 0; n < this._points.size(); n++)e.filter(t._points.getCoordinate(n));
            else if (gl(arguments[0], Fc)) {
                var r = arguments[0];
                if (0 === this._points.size()) return null;
                for(var i = 0; i < this._points.size() && (r.filter(t._points, i), !r.isDone()); i++);
                r.isGeometryChanged() && this.geometryChanged();
            } else if (gl(arguments[0], Dc)) {
                var o = arguments[0];
                o.filter(this);
            } else if (gl(arguments[0], Hl)) {
                var s = arguments[0];
                s.filter(this);
            }
        }, e.prototype.getBoundary = function() {
            return new qc(this).getBoundary();
        }, e.prototype.isEquivalentClass = function(t) {
            return t instanceof e;
        }, e.prototype.clone = function() {
            var e = t.prototype.clone.call(this);
            return e._points = this._points.clone(), e;
        }, e.prototype.getCoordinateN = function(t) {
            return this._points.getCoordinate(t);
        }, e.prototype.getGeometryType = function() {
            return "LineString";
        }, e.prototype.copy = function() {
            return new e(this._points.copy(), this._factory);
        }, e.prototype.getCoordinateSequence = function() {
            return this._points;
        }, e.prototype.isEmpty = function() {
            return 0 === this._points.size();
        }, e.prototype.init = function(t) {
            if (null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), 1 === t.size()) throw new el("Invalid number of points in LineString (found " + t.size() + " - must be 0 or >= 2)");
            this._points = t;
        }, e.prototype.isCoordinate = function(t) {
            for(var e = 0; e < this._points.size(); e++)if (this._points.getCoordinate(e).equals(t)) return !0;
            return !1;
        }, e.prototype.getStartPoint = function() {
            return this.isEmpty() ? null : this.getPointN(0);
        }, e.prototype.getPointN = function(t) {
            return this.getFactory().createPoint(this._points.getCoordinate(t));
        }, e.prototype.interfaces_ = function() {
            return [
                Pc
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return 0x2b2b51ba435c8e00;
        }, Object.defineProperties(e, n), e;
    }(Wl), Kc = function() {};
    Kc.prototype.interfaces_ = function() {
        return [];
    }, Kc.prototype.getClass = function() {
        return Kc;
    };
    var Qc = function(t) {
        function e(e, n) {
            t.call(this, n), this._coordinates = e || null, this.init(this._coordinates);
        }
        t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.computeEnvelopeInternal = function() {
            if (this.isEmpty()) return new Ll;
            var t = new Ll;
            return t.expandToInclude(this._coordinates.getX(0), this._coordinates.getY(0)), t;
        }, e.prototype.getSortIndex = function() {
            return t.SORTINDEX_POINT;
        }, e.prototype.getCoordinates = function() {
            return this.isEmpty() ? [] : [
                this.getCoordinate()
            ];
        }, e.prototype.equalsExact = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                return !!this.isEquivalentClass(e) && (!(!this.isEmpty() || !e.isEmpty()) || this.isEmpty() === e.isEmpty() && this.equal(e.getCoordinate(), this.getCoordinate(), n));
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.normalize = function() {}, e.prototype.getCoordinate = function() {
            return 0 !== this._coordinates.size() ? this._coordinates.getCoordinate(0) : null;
        }, e.prototype.getBoundaryDimension = function() {
            return Tc.FALSE;
        }, e.prototype.getDimension = function() {
            return 0;
        }, e.prototype.getNumPoints = function() {
            return this.isEmpty() ? 0 : 1;
        }, e.prototype.reverse = function() {
            return this.copy();
        }, e.prototype.getX = function() {
            if (null === this.getCoordinate()) throw new Error("getX called on empty Point");
            return this.getCoordinate().x;
        }, e.prototype.compareToSameClass = function() {
            if (1 === arguments.length) {
                var t = arguments[0], e = t;
                return this.getCoordinate().compareTo(e.getCoordinate());
            }
            if (2 === arguments.length) {
                var n = arguments[0], r = arguments[1], i = n;
                return r.compare(this._coordinates, i._coordinates);
            }
        }, e.prototype.apply = function() {
            if (gl(arguments[0], Kl)) {
                var t = arguments[0];
                if (this.isEmpty()) return null;
                t.filter(this.getCoordinate());
            } else if (gl(arguments[0], Fc)) {
                var e = arguments[0];
                if (this.isEmpty()) return null;
                e.filter(this._coordinates, 0), e.isGeometryChanged() && this.geometryChanged();
            } else if (gl(arguments[0], Dc)) {
                var n = arguments[0];
                n.filter(this);
            } else if (gl(arguments[0], Hl)) {
                var r = arguments[0];
                r.filter(this);
            }
        }, e.prototype.getBoundary = function() {
            return this.getFactory().createGeometryCollection(null);
        }, e.prototype.clone = function() {
            var e = t.prototype.clone.call(this);
            return e._coordinates = this._coordinates.clone(), e;
        }, e.prototype.getGeometryType = function() {
            return "Point";
        }, e.prototype.copy = function() {
            return new e(this._coordinates.copy(), this._factory);
        }, e.prototype.getCoordinateSequence = function() {
            return this._coordinates;
        }, e.prototype.getY = function() {
            if (null === this.getCoordinate()) throw new Error("getY called on empty Point");
            return this.getCoordinate().y;
        }, e.prototype.isEmpty = function() {
            return 0 === this._coordinates.size();
        }, e.prototype.init = function(t) {
            null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), ql.isTrue(t.size() <= 1), this._coordinates = t;
        }, e.prototype.isSimple = function() {
            return !0;
        }, e.prototype.interfaces_ = function() {
            return [
                Kc
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return 0x44077bad161cbc00;
        }, Object.defineProperties(e, n), e;
    }(Wl), $c = function() {};
    $c.prototype.interfaces_ = function() {
        return [];
    }, $c.prototype.getClass = function() {
        return $c;
    };
    var th = function(t) {
        function e(e, n, r) {
            if (t.call(this, r), this._shell = null, this._holes = null, null === e && (e = this.getFactory().createLinearRing()), null === n && (n = []), t.hasNullElements(n)) throw new el("holes must not contain null elements");
            if (e.isEmpty() && t.hasNonEmptyElements(n)) throw new el("shell is empty but holes are not");
            this._shell = e, this._holes = n;
        }
        t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.computeEnvelopeInternal = function() {
            return this._shell.getEnvelopeInternal();
        }, e.prototype.getSortIndex = function() {
            return t.SORTINDEX_POLYGON;
        }, e.prototype.getCoordinates = function() {
            if (this.isEmpty()) return [];
            for(var t = new Array(this.getNumPoints()).fill(null), e = -1, n = this._shell.getCoordinates(), r = 0; r < n.length; r++)t[++e] = n[r];
            for(var i = 0; i < this._holes.length; i++)for(var o = this._holes[i].getCoordinates(), s = 0; s < o.length; s++)t[++e] = o[s];
            return t;
        }, e.prototype.getArea = function() {
            var t = 0;
            t += Math.abs(Xl.signedArea(this._shell.getCoordinateSequence()));
            for(var e = 0; e < this._holes.length; e++)t -= Math.abs(Xl.signedArea(this._holes[e].getCoordinateSequence()));
            return t;
        }, e.prototype.isRectangle = function() {
            if (0 !== this.getNumInteriorRing()) return !1;
            if (null === this._shell) return !1;
            if (5 !== this._shell.getNumPoints()) return !1;
            for(var t = this._shell.getCoordinateSequence(), e = this.getEnvelopeInternal(), n = 0; n < 5; n++){
                var r = t.getX(n);
                if (r !== e.getMinX() && r !== e.getMaxX()) return !1;
                var i = t.getY(n);
                if (i !== e.getMinY() && i !== e.getMaxY()) return !1;
            }
            for(var o = t.getX(0), s = t.getY(0), a = 1; a <= 4; a++){
                var u = t.getX(a), l = t.getY(a);
                if (u !== o === (l !== s)) return !1;
                o = u, s = l;
            }
            return !0;
        }, e.prototype.equalsExact = function() {
            var e = this;
            if (2 === arguments.length) {
                var n = arguments[0], r = arguments[1];
                if (!this.isEquivalentClass(n)) return !1;
                var i = n, o = this._shell, s = i._shell;
                if (!o.equalsExact(s, r)) return !1;
                if (this._holes.length !== i._holes.length) return !1;
                for(var a = 0; a < this._holes.length; a++)if (!e._holes[a].equalsExact(i._holes[a], r)) return !1;
                return !0;
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.normalize = function() {
            var t = this;
            if (0 === arguments.length) {
                this.normalize(this._shell, !0);
                for(var e = 0; e < this._holes.length; e++)t.normalize(t._holes[e], !1);
                Rc.sort(this._holes);
            } else if (2 === arguments.length) {
                var n = arguments[0], r = arguments[1];
                if (n.isEmpty()) return null;
                var i = new Array(n.getCoordinates().length - 1).fill(null);
                Pl.arraycopy(n.getCoordinates(), 0, i, 0, i.length);
                var o = pc.minCoordinate(n.getCoordinates());
                pc.scroll(i, o), Pl.arraycopy(i, 0, n.getCoordinates(), 0, i.length), n.getCoordinates()[i.length] = i[0], Xl.isCCW(n.getCoordinates()) === r && pc.reverse(n.getCoordinates());
            }
        }, e.prototype.getCoordinate = function() {
            return this._shell.getCoordinate();
        }, e.prototype.getNumInteriorRing = function() {
            return this._holes.length;
        }, e.prototype.getBoundaryDimension = function() {
            return 1;
        }, e.prototype.getDimension = function() {
            return 2;
        }, e.prototype.getLength = function() {
            var t = 0;
            t += this._shell.getLength();
            for(var e = 0; e < this._holes.length; e++)t += this._holes[e].getLength();
            return t;
        }, e.prototype.getNumPoints = function() {
            for(var t = this._shell.getNumPoints(), e = 0; e < this._holes.length; e++)t += this._holes[e].getNumPoints();
            return t;
        }, e.prototype.reverse = function() {
            var t = this.copy();
            t._shell = this._shell.copy().reverse(), t._holes = new Array(this._holes.length).fill(null);
            for(var e = 0; e < this._holes.length; e++)t._holes[e] = this._holes[e].copy().reverse();
            return t;
        }, e.prototype.convexHull = function() {
            return this.getExteriorRing().convexHull();
        }, e.prototype.compareToSameClass = function() {
            var t = this;
            if (1 === arguments.length) {
                var e = arguments[0], n = this._shell, r = e._shell;
                return n.compareToSameClass(r);
            }
            if (2 === arguments.length) {
                var i = arguments[0], o = arguments[1], s = i, a = this._shell, u = s._shell, l = a.compareToSameClass(u, o);
                if (0 !== l) return l;
                for(var c = this.getNumInteriorRing(), h = s.getNumInteriorRing(), p = 0; p < c && p < h;){
                    var f = t.getInteriorRingN(p), g = s.getInteriorRingN(p), d = f.compareToSameClass(g, o);
                    if (0 !== d) return d;
                    p++;
                }
                return p < c ? 1 : p < h ? -1 : 0;
            }
        }, e.prototype.apply = function(t) {
            var e = this;
            if (gl(t, Kl)) {
                this._shell.apply(t);
                for(var n = 0; n < this._holes.length; n++)e._holes[n].apply(t);
            } else if (gl(t, Fc)) {
                if (this._shell.apply(t), !t.isDone()) for(var r = 0; r < this._holes.length && (e._holes[r].apply(t), !t.isDone()); r++);
                t.isGeometryChanged() && this.geometryChanged();
            } else if (gl(t, Dc)) t.filter(this);
            else if (gl(t, Hl)) {
                t.filter(this), this._shell.apply(t);
                for(var i = 0; i < this._holes.length; i++)e._holes[i].apply(t);
            }
        }, e.prototype.getBoundary = function() {
            if (this.isEmpty()) return this.getFactory().createMultiLineString();
            var t = new Array(this._holes.length + 1).fill(null);
            t[0] = this._shell;
            for(var e = 0; e < this._holes.length; e++)t[e + 1] = this._holes[e];
            return t.length <= 1 ? this.getFactory().createLinearRing(t[0].getCoordinateSequence()) : this.getFactory().createMultiLineString(t);
        }, e.prototype.clone = function() {
            var e = t.prototype.clone.call(this);
            e._shell = this._shell.clone(), e._holes = new Array(this._holes.length).fill(null);
            for(var n = 0; n < this._holes.length; n++)e._holes[n] = this._holes[n].clone();
            return e;
        }, e.prototype.getGeometryType = function() {
            return "Polygon";
        }, e.prototype.copy = function() {
            for(var t = this._shell.copy(), n = new Array(this._holes.length).fill(null), r = 0; r < n.length; r++)n[r] = this._holes[r].copy();
            return new e(t, n, this._factory);
        }, e.prototype.getExteriorRing = function() {
            return this._shell;
        }, e.prototype.isEmpty = function() {
            return this._shell.isEmpty();
        }, e.prototype.getInteriorRingN = function(t) {
            return this._holes[t];
        }, e.prototype.interfaces_ = function() {
            return [
                $c
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return -3494792200821764600;
        }, Object.defineProperties(e, n), e;
    }(Wl), eh = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.getSortIndex = function() {
            return Wl.SORTINDEX_MULTIPOINT;
        }, e.prototype.isValid = function() {
            return !0;
        }, e.prototype.equalsExact = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                return !!this.isEquivalentClass(e) && t.prototype.equalsExact.call(this, e, n);
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.getCoordinate = function() {
            if (1 === arguments.length) {
                var e = arguments[0];
                return this._geometries[e].getCoordinate();
            }
            return t.prototype.getCoordinate.apply(this, arguments);
        }, e.prototype.getBoundaryDimension = function() {
            return Tc.FALSE;
        }, e.prototype.getDimension = function() {
            return 0;
        }, e.prototype.getBoundary = function() {
            return this.getFactory().createGeometryCollection(null);
        }, e.prototype.getGeometryType = function() {
            return "MultiPoint";
        }, e.prototype.copy = function() {
            for(var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++)t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
        }, e.prototype.interfaces_ = function() {
            return [
                Kc
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return -8048474874175356000;
        }, Object.defineProperties(e, n), e;
    }(kc), nh = function(t) {
        function e(e, n) {
            e instanceof ul && n instanceof _h && (e = n.getCoordinateSequenceFactory().create(e)), t.call(this, e, n), this.validateConstruction();
        }
        t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
        var n = {
            MINIMUM_VALID_SIZE: {
                configurable: !0
            },
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.getSortIndex = function() {
            return Wl.SORTINDEX_LINEARRING;
        }, e.prototype.getBoundaryDimension = function() {
            return Tc.FALSE;
        }, e.prototype.isClosed = function() {
            return !!this.isEmpty() || t.prototype.isClosed.call(this);
        }, e.prototype.reverse = function() {
            var t = this._points.copy();
            return Jc.reverse(t), this.getFactory().createLinearRing(t);
        }, e.prototype.validateConstruction = function() {
            if (!this.isEmpty() && !t.prototype.isClosed.call(this)) throw new el("Points of LinearRing do not form a closed linestring");
            if (this.getCoordinateSequence().size() >= 1 && this.getCoordinateSequence().size() < e.MINIMUM_VALID_SIZE) throw new el("Invalid number of points in LinearRing (found " + this.getCoordinateSequence().size() + " - must be 0 or >= 4)");
        }, e.prototype.getGeometryType = function() {
            return "LinearRing";
        }, e.prototype.copy = function() {
            return new e(this._points.copy(), this._factory);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, n.MINIMUM_VALID_SIZE.get = function() {
            return 4;
        }, n.serialVersionUID.get = function() {
            return -4261142084085851600;
        }, Object.defineProperties(e, n), e;
    }(Zc), rh = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
        var n = {
            serialVersionUID: {
                configurable: !0
            }
        };
        return e.prototype.getSortIndex = function() {
            return Wl.SORTINDEX_MULTIPOLYGON;
        }, e.prototype.equalsExact = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                return !!this.isEquivalentClass(e) && t.prototype.equalsExact.call(this, e, n);
            }
            return t.prototype.equalsExact.apply(this, arguments);
        }, e.prototype.getBoundaryDimension = function() {
            return 1;
        }, e.prototype.getDimension = function() {
            return 2;
        }, e.prototype.reverse = function() {
            for(var t = this._geometries.length, e = new Array(t).fill(null), n = 0; n < this._geometries.length; n++)e[n] = this._geometries[n].reverse();
            return this.getFactory().createMultiPolygon(e);
        }, e.prototype.getBoundary = function() {
            if (this.isEmpty()) return this.getFactory().createMultiLineString();
            for(var t = new lc, e = 0; e < this._geometries.length; e++)for(var n = this._geometries[e].getBoundary(), r = 0; r < n.getNumGeometries(); r++)t.add(n.getGeometryN(r));
            var i = new Array(t.size()).fill(null);
            return this.getFactory().createMultiLineString(t.toArray(i));
        }, e.prototype.getGeometryType = function() {
            return "MultiPolygon";
        }, e.prototype.copy = function() {
            for(var t = new Array(this._geometries.length).fill(null), n = 0; n < t.length; n++)t[n] = this._geometries[n].copy();
            return new e(t, this._factory);
        }, e.prototype.interfaces_ = function() {
            return [
                $c
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, n.serialVersionUID.get = function() {
            return -551033529766975900;
        }, Object.defineProperties(e, n), e;
    }(kc), ih = function(t) {
        this._factory = t || null, this._isUserDataCopied = !1;
    }, oh = {
        NoOpGeometryOperation: {
            configurable: !0
        },
        CoordinateOperation: {
            configurable: !0
        },
        CoordinateSequenceOperation: {
            configurable: !0
        }
    };
    ih.prototype.setCopyUserData = function(t) {
        this._isUserDataCopied = t;
    }, ih.prototype.edit = function(t, e) {
        if (null === t) return null;
        var n = this.editInternal(t, e);
        return this._isUserDataCopied && n.setUserData(t.getUserData()), n;
    }, ih.prototype.editInternal = function(t, e) {
        return null === this._factory && (this._factory = t.getFactory()), t instanceof kc ? this.editGeometryCollection(t, e) : t instanceof th ? this.editPolygon(t, e) : t instanceof Qc || t instanceof Zc ? e.edit(t, this._factory) : (ql.shouldNeverReachHere("Unsupported Geometry class: " + t.getClass().getName()), null);
    }, ih.prototype.editGeometryCollection = function(t, e) {
        for(var n = e.edit(t, this._factory), r = new lc, i = 0; i < n.getNumGeometries(); i++){
            var o = this.edit(n.getGeometryN(i), e);
            null === o || o.isEmpty() || r.add(o);
        }
        return n.getClass() === eh ? this._factory.createMultiPoint(r.toArray([])) : n.getClass() === Gc ? this._factory.createMultiLineString(r.toArray([])) : n.getClass() === rh ? this._factory.createMultiPolygon(r.toArray([])) : this._factory.createGeometryCollection(r.toArray([]));
    }, ih.prototype.editPolygon = function(t, e) {
        var n = e.edit(t, this._factory);
        if (null === n && (n = this._factory.createPolygon(null)), n.isEmpty()) return n;
        var r = this.edit(n.getExteriorRing(), e);
        if (null === r || r.isEmpty()) return this._factory.createPolygon();
        for(var i = new lc, o = 0; o < n.getNumInteriorRing(); o++){
            var s = this.edit(n.getInteriorRingN(o), e);
            null === s || s.isEmpty() || i.add(s);
        }
        return this._factory.createPolygon(r, i.toArray([]));
    }, ih.prototype.interfaces_ = function() {
        return [];
    }, ih.prototype.getClass = function() {
        return ih;
    }, ih.GeometryEditorOperation = function() {}, oh.NoOpGeometryOperation.get = function() {
        return sh;
    }, oh.CoordinateOperation.get = function() {
        return ah;
    }, oh.CoordinateSequenceOperation.get = function() {
        return uh;
    }, Object.defineProperties(ih, oh);
    var sh = function() {};
    sh.prototype.edit = function(t, e) {
        return t;
    }, sh.prototype.interfaces_ = function() {
        return [
            ih.GeometryEditorOperation
        ];
    }, sh.prototype.getClass = function() {
        return sh;
    };
    var ah = function() {};
    ah.prototype.edit = function(t, e) {
        var n = this.editCoordinates(t.getCoordinates(), t);
        return null === n ? t : t instanceof nh ? e.createLinearRing(n) : t instanceof Zc ? e.createLineString(n) : t instanceof Qc ? n.length > 0 ? e.createPoint(n[0]) : e.createPoint() : t;
    }, ah.prototype.interfaces_ = function() {
        return [
            ih.GeometryEditorOperation
        ];
    }, ah.prototype.getClass = function() {
        return ah;
    };
    var uh = function() {};
    uh.prototype.edit = function(t, e) {
        return t instanceof nh ? e.createLinearRing(this.edit(t.getCoordinateSequence(), t)) : t instanceof Zc ? e.createLineString(this.edit(t.getCoordinateSequence(), t)) : t instanceof Qc ? e.createPoint(this.edit(t.getCoordinateSequence(), t)) : t;
    }, uh.prototype.interfaces_ = function() {
        return [
            ih.GeometryEditorOperation
        ];
    }, uh.prototype.getClass = function() {
        return uh;
    };
    var lh = function() {
        var t = this;
        if (this._dimension = 3, this._coordinates = null, 1 === arguments.length) {
            if (arguments[0] instanceof Array) this._coordinates = arguments[0], this._dimension = 3;
            else if (Number.isInteger(arguments[0])) {
                var e = arguments[0];
                this._coordinates = new Array(e).fill(null);
                for(var n = 0; n < e; n++)t._coordinates[n] = new ul;
            } else if (gl(arguments[0], Il)) {
                var r = arguments[0];
                if (null === r) return this._coordinates = new Array(0).fill(null), null;
                this._dimension = r.getDimension(), this._coordinates = new Array(r.size()).fill(null);
                for(var i = 0; i < this._coordinates.length; i++)t._coordinates[i] = r.getCoordinateCopy(i);
            }
        } else if (2 === arguments.length) {
            if (arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
                var o = arguments[0], s = arguments[1];
                this._coordinates = o, this._dimension = s, null === o && (this._coordinates = new Array(0).fill(null));
            } else if (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
                var a = arguments[0], u = arguments[1];
                this._coordinates = new Array(a).fill(null), this._dimension = u;
                for(var l = 0; l < a; l++)t._coordinates[l] = new ul;
            }
        }
    }, ch = {
        serialVersionUID: {
            configurable: !0
        }
    };
    lh.prototype.setOrdinate = function(t, e, n) {
        switch(e){
            case Il.X:
                this._coordinates[t].x = n;
                break;
            case Il.Y:
                this._coordinates[t].y = n;
                break;
            case Il.Z:
                this._coordinates[t].z = n;
                break;
            default:
                throw new el("invalid ordinateIndex");
        }
    }, lh.prototype.size = function() {
        return this._coordinates.length;
    }, lh.prototype.getOrdinate = function(t, e) {
        switch(e){
            case Il.X:
                return this._coordinates[t].x;
            case Il.Y:
                return this._coordinates[t].y;
            case Il.Z:
                return this._coordinates[t].z;
        }
        return nl.NaN;
    }, lh.prototype.getCoordinate = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this._coordinates[t];
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            n.x = this._coordinates[e].x, n.y = this._coordinates[e].y, n.z = this._coordinates[e].z;
        }
    }, lh.prototype.getCoordinateCopy = function(t) {
        return new ul(this._coordinates[t]);
    }, lh.prototype.getDimension = function() {
        return this._dimension;
    }, lh.prototype.getX = function(t) {
        return this._coordinates[t].x;
    }, lh.prototype.clone = function() {
        for(var t = new Array(this.size()).fill(null), e = 0; e < this._coordinates.length; e++)t[e] = this._coordinates[e].clone();
        return new lh(t, this._dimension);
    }, lh.prototype.expandEnvelope = function(t) {
        for(var e = 0; e < this._coordinates.length; e++)t.expandToInclude(this._coordinates[e]);
        return t;
    }, lh.prototype.copy = function() {
        for(var t = new Array(this.size()).fill(null), e = 0; e < this._coordinates.length; e++)t[e] = this._coordinates[e].copy();
        return new lh(t, this._dimension);
    }, lh.prototype.toString = function() {
        if (this._coordinates.length > 0) {
            var t = new vl(17 * this._coordinates.length);
            t.append("("), t.append(this._coordinates[0]);
            for(var e = 1; e < this._coordinates.length; e++)t.append(", "), t.append(this._coordinates[e]);
            return t.append(")"), t.toString();
        }
        return "()";
    }, lh.prototype.getY = function(t) {
        return this._coordinates[t].y;
    }, lh.prototype.toCoordinateArray = function() {
        return this._coordinates;
    }, lh.prototype.interfaces_ = function() {
        return [
            Il,
            al
        ];
    }, lh.prototype.getClass = function() {
        return lh;
    }, ch.serialVersionUID.get = function() {
        return -915438501601840600;
    }, Object.defineProperties(lh, ch);
    var hh = function() {}, ph = {
        serialVersionUID: {
            configurable: !0
        },
        instanceObject: {
            configurable: !0
        }
    };
    hh.prototype.readResolve = function() {
        return hh.instance();
    }, hh.prototype.create = function() {
        if (1 === arguments.length) {
            if (arguments[0] instanceof Array) {
                var t = arguments[0];
                return new lh(t);
            }
            if (gl(arguments[0], Il)) {
                var e = arguments[0];
                return new lh(e);
            }
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1];
            return r > 3 && (r = 3), r < 2 ? new lh(n) : new lh(n, r);
        }
    }, hh.prototype.interfaces_ = function() {
        return [
            hl,
            al
        ];
    }, hh.prototype.getClass = function() {
        return hh;
    }, hh.instance = function() {
        return hh.instanceObject;
    }, ph.serialVersionUID.get = function() {
        return -4099577099607551500;
    }, ph.instanceObject.get = function() {
        return new hh;
    }, Object.defineProperties(hh, ph);
    var fh = function(t) {
        function e() {
            t.call(this), this.map_ = new Map;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(t) {
            return this.map_.get(t) || null;
        }, e.prototype.put = function(t, e) {
            return this.map_.set(t, e), e;
        }, e.prototype.values = function() {
            for(var t = new lc, e = this.map_.values(), n = e.next(); !n.done;)t.add(n.value), n = e.next();
            return t;
        }, e.prototype.entrySet = function() {
            var t = new xc;
            return this.map_.entries().forEach(function(e) {
                return t.add(e);
            }), t;
        }, e.prototype.size = function() {
            return this.map_.size();
        }, e;
    }(yc), gh = function t() {
        if (this._modelType = null, this._scale = null, 0 === arguments.length) this._modelType = t.FLOATING;
        else if (1 === arguments.length) {
            if (arguments[0] instanceof yh) {
                var e = arguments[0];
                this._modelType = e, e === t.FIXED && this.setScale(1);
            } else if ("number" == typeof arguments[0]) {
                var n = arguments[0];
                this._modelType = t.FIXED, this.setScale(n);
            } else if (arguments[0] instanceof t) {
                var r = arguments[0];
                this._modelType = r._modelType, this._scale = r._scale;
            }
        }
    }, dh = {
        serialVersionUID: {
            configurable: !0
        },
        maximumPreciseValue: {
            configurable: !0
        }
    };
    gh.prototype.equals = function(t) {
        if (!(t instanceof gh)) return !1;
        var e = t;
        return this._modelType === e._modelType && this._scale === e._scale;
    }, gh.prototype.compareTo = function(t) {
        var e = t, n = this.getMaximumSignificantDigits(), r = e.getMaximumSignificantDigits();
        return new _l(n).compareTo(new _l(r));
    }, gh.prototype.getScale = function() {
        return this._scale;
    }, gh.prototype.isFloating = function() {
        return this._modelType === gh.FLOATING || this._modelType === gh.FLOATING_SINGLE;
    }, gh.prototype.getType = function() {
        return this._modelType;
    }, gh.prototype.toString = function() {
        var t = "UNKNOWN";
        return this._modelType === gh.FLOATING ? t = "Floating" : this._modelType === gh.FLOATING_SINGLE ? t = "Floating-Single" : this._modelType === gh.FIXED && (t = "Fixed (Scale=" + this.getScale() + ")"), t;
    }, gh.prototype.makePrecise = function() {
        if ("number" == typeof arguments[0]) {
            var t = arguments[0];
            if (nl.isNaN(t)) return t;
            if (this._modelType === gh.FLOATING_SINGLE) return t;
            return this._modelType === gh.FIXED ? Math.round(t * this._scale) / this._scale : t;
        }
        if (arguments[0] instanceof ul) {
            var e = arguments[0];
            if (this._modelType === gh.FLOATING) return null;
            e.x = this.makePrecise(e.x), e.y = this.makePrecise(e.y);
        }
    }, gh.prototype.getMaximumSignificantDigits = function() {
        var t = 16;
        return this._modelType === gh.FLOATING ? t = 16 : this._modelType === gh.FLOATING_SINGLE ? t = 6 : this._modelType === gh.FIXED && (t = 1 + Math.trunc(Math.ceil(Math.log(this.getScale()) / Math.log(10)))), t;
    }, gh.prototype.setScale = function(t) {
        this._scale = Math.abs(t);
    }, gh.prototype.interfaces_ = function() {
        return [
            al,
            il
        ];
    }, gh.prototype.getClass = function() {
        return gh;
    }, gh.mostPrecise = function(t, e) {
        return t.compareTo(e) >= 0 ? t : e;
    }, dh.serialVersionUID.get = function() {
        return 0x6bee6404e9a25c00;
    }, dh.maximumPreciseValue.get = function() {
        return 9007199254740992;
    }, Object.defineProperties(gh, dh);
    var yh = function t(e) {
        this._name = e || null, t.nameToTypeMap.put(e, this);
    }, vh = {
        serialVersionUID: {
            configurable: !0
        },
        nameToTypeMap: {
            configurable: !0
        }
    };
    yh.prototype.readResolve = function() {
        return yh.nameToTypeMap.get(this._name);
    }, yh.prototype.toString = function() {
        return this._name;
    }, yh.prototype.interfaces_ = function() {
        return [
            al
        ];
    }, yh.prototype.getClass = function() {
        return yh;
    }, vh.serialVersionUID.get = function() {
        return -5528602631731590000;
    }, vh.nameToTypeMap.get = function() {
        return new fh;
    }, Object.defineProperties(yh, vh), gh.Type = yh, gh.FIXED = new yh("FIXED"), gh.FLOATING = new yh("FLOATING"), gh.FLOATING_SINGLE = new yh("FLOATING SINGLE");
    var _h = function t() {
        this._precisionModel = new gh, this._SRID = 0, this._coordinateSequenceFactory = t.getDefaultCoordinateSequenceFactory(), 0 === arguments.length || (1 === arguments.length ? gl(arguments[0], hl) ? this._coordinateSequenceFactory = arguments[0] : arguments[0] instanceof gh && (this._precisionModel = arguments[0]) : 2 === arguments.length ? (this._precisionModel = arguments[0], this._SRID = arguments[1]) : 3 === arguments.length && (this._precisionModel = arguments[0], this._SRID = arguments[1], this._coordinateSequenceFactory = arguments[2]));
    }, mh = {
        serialVersionUID: {
            configurable: !0
        }
    };
    _h.prototype.toGeometry = function(t) {
        return t.isNull() ? this.createPoint(null) : t.getMinX() === t.getMaxX() && t.getMinY() === t.getMaxY() ? this.createPoint(new ul(t.getMinX(), t.getMinY())) : t.getMinX() === t.getMaxX() || t.getMinY() === t.getMaxY() ? this.createLineString([
            new ul(t.getMinX(), t.getMinY()),
            new ul(t.getMaxX(), t.getMaxY())
        ]) : this.createPolygon(this.createLinearRing([
            new ul(t.getMinX(), t.getMinY()),
            new ul(t.getMinX(), t.getMaxY()),
            new ul(t.getMaxX(), t.getMaxY()),
            new ul(t.getMaxX(), t.getMinY()),
            new ul(t.getMinX(), t.getMinY())
        ]), null);
    }, _h.prototype.createLineString = function(t) {
        return t ? t instanceof Array ? new Zc(this.getCoordinateSequenceFactory().create(t), this) : gl(t, Il) ? new Zc(t, this) : void 0 : new Zc(this.getCoordinateSequenceFactory().create([]), this);
    }, _h.prototype.createMultiLineString = function() {
        if (0 === arguments.length) return new Gc(null, this);
        if (1 === arguments.length) {
            var t = arguments[0];
            return new Gc(t, this);
        }
    }, _h.prototype.buildGeometry = function(t) {
        for(var e = null, n = !1, r = !1, i = t.iterator(); i.hasNext();){
            var o = i.next(), s = o.getClass();
            null === e && (e = s), s !== e && (n = !0), o.isGeometryCollectionOrDerived() && (r = !0);
        }
        if (null === e) return this.createGeometryCollection();
        if (n || r) return this.createGeometryCollection(_h.toGeometryArray(t));
        var a = t.iterator().next();
        if (t.size() > 1) {
            if (a instanceof th) return this.createMultiPolygon(_h.toPolygonArray(t));
            if (a instanceof Zc) return this.createMultiLineString(_h.toLineStringArray(t));
            if (a instanceof Qc) return this.createMultiPoint(_h.toPointArray(t));
            ql.shouldNeverReachHere("Unhandled class: " + a.getClass().getName());
        }
        return a;
    }, _h.prototype.createMultiPointFromCoords = function(t) {
        return this.createMultiPoint(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
    }, _h.prototype.createPoint = function() {
        if (0 === arguments.length) return this.createPoint(this.getCoordinateSequenceFactory().create([]));
        if (1 === arguments.length) {
            if (arguments[0] instanceof ul) {
                var t = arguments[0];
                return this.createPoint(null !== t ? this.getCoordinateSequenceFactory().create([
                    t
                ]) : null);
            }
            if (gl(arguments[0], Il)) {
                var e = arguments[0];
                return new Qc(e, this);
            }
        }
    }, _h.prototype.getCoordinateSequenceFactory = function() {
        return this._coordinateSequenceFactory;
    }, _h.prototype.createPolygon = function() {
        if (0 === arguments.length) return new th(null, null, this);
        if (1 === arguments.length) {
            if (gl(arguments[0], Il)) {
                var t = arguments[0];
                return this.createPolygon(this.createLinearRing(t));
            }
            if (arguments[0] instanceof Array) {
                var e = arguments[0];
                return this.createPolygon(this.createLinearRing(e));
            }
            if (arguments[0] instanceof nh) {
                var n = arguments[0];
                return this.createPolygon(n, null);
            }
        } else if (2 === arguments.length) {
            var r = arguments[0], i = arguments[1];
            return new th(r, i, this);
        }
    }, _h.prototype.getSRID = function() {
        return this._SRID;
    }, _h.prototype.createGeometryCollection = function() {
        if (0 === arguments.length) return new kc(null, this);
        if (1 === arguments.length) {
            var t = arguments[0];
            return new kc(t, this);
        }
    }, _h.prototype.createGeometry = function(t) {
        return new ih(this).edit(t, {
            edit: function() {
                if (2 === arguments.length) {
                    var t = arguments[0];
                    return this._coordinateSequenceFactory.create(t);
                }
            }
        });
    }, _h.prototype.getPrecisionModel = function() {
        return this._precisionModel;
    }, _h.prototype.createLinearRing = function() {
        if (0 === arguments.length) return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));
        if (1 === arguments.length) {
            if (arguments[0] instanceof Array) {
                var t = arguments[0];
                return this.createLinearRing(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
            }
            if (gl(arguments[0], Il)) {
                var e = arguments[0];
                return new nh(e, this);
            }
        }
    }, _h.prototype.createMultiPolygon = function() {
        if (0 === arguments.length) return new rh(null, this);
        if (1 === arguments.length) {
            var t = arguments[0];
            return new rh(t, this);
        }
    }, _h.prototype.createMultiPoint = function() {
        var t = this;
        if (0 === arguments.length) return new eh(null, this);
        if (1 === arguments.length) {
            if (arguments[0] instanceof Array) {
                var e = arguments[0];
                return new eh(e, this);
            }
            if (arguments[0] instanceof Array) {
                var n = arguments[0];
                return this.createMultiPoint(null !== n ? this.getCoordinateSequenceFactory().create(n) : null);
            }
            if (gl(arguments[0], Il)) {
                var r = arguments[0];
                if (null === r) return this.createMultiPoint(new Array(0).fill(null));
                for(var i = new Array(r.size()).fill(null), o = 0; o < r.size(); o++){
                    var s = t.getCoordinateSequenceFactory().create(1, r.getDimension());
                    Jc.copy(r, o, s, 0, 1), i[o] = t.createPoint(s);
                }
                return this.createMultiPoint(i);
            }
        }
    }, _h.prototype.interfaces_ = function() {
        return [
            al
        ];
    }, _h.prototype.getClass = function() {
        return _h;
    }, _h.toMultiPolygonArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _h.toGeometryArray = function(t) {
        if (null === t) return null;
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _h.getDefaultCoordinateSequenceFactory = function() {
        return hh.instance();
    }, _h.toMultiLineStringArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _h.toLineStringArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _h.toMultiPointArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _h.toLinearRingArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _h.toPointArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _h.toPolygonArray = function(t) {
        var e = new Array(t.size()).fill(null);
        return t.toArray(e);
    }, _h.createPointFromInternalCoord = function(t, e) {
        return e.getPrecisionModel().makePrecise(t), e.getFactory().createPoint(t);
    }, mh.serialVersionUID.get = function() {
        return -6820524753094096000;
    }, Object.defineProperties(_h, mh);
    var xh = [
        "Point",
        "MultiPoint",
        "LineString",
        "MultiLineString",
        "Polygon",
        "MultiPolygon"
    ], Eh = function(t) {
        this.geometryFactory = t || new _h;
    };
    Eh.prototype.read = function(t) {
        var e, n = (e = "string" == typeof t ? JSON.parse(t) : t).type;
        if (!bh[n]) throw new Error("Unknown GeoJSON type: " + e.type);
        return -1 !== xh.indexOf(n) ? bh[n].apply(this, [
            e.coordinates
        ]) : "GeometryCollection" === n ? bh[n].apply(this, [
            e.geometries
        ]) : bh[n].apply(this, [
            e
        ]);
    }, Eh.prototype.write = function(t) {
        var e = t.getGeometryType();
        if (!wh[e]) throw new Error("Geometry is not supported");
        return wh[e].apply(this, [
            t
        ]);
    };
    var bh = {
        Feature: function(t) {
            var e = {};
            for(var n in t)e[n] = t[n];
            if (t.geometry) {
                var r = t.geometry.type;
                if (!bh[r]) throw new Error("Unknown GeoJSON type: " + t.type);
                e.geometry = this.read(t.geometry);
            }
            return t.bbox && (e.bbox = bh.bbox.apply(this, [
                t.bbox
            ])), e;
        },
        FeatureCollection: function(t) {
            var e = {};
            if (t.features) {
                e.features = [];
                for(var n = 0; n < t.features.length; ++n)e.features.push(this.read(t.features[n]));
            }
            return t.bbox && (e.bbox = this.parse.bbox.apply(this, [
                t.bbox
            ])), e;
        },
        coordinates: function(t) {
            for(var e = [], n = 0; n < t.length; ++n){
                var r = t[n];
                e.push(new ul(r[0], r[1]));
            }
            return e;
        },
        bbox: function(t) {
            return this.geometryFactory.createLinearRing([
                new ul(t[0], t[1]),
                new ul(t[2], t[1]),
                new ul(t[2], t[3]),
                new ul(t[0], t[3]),
                new ul(t[0], t[1])
            ]);
        },
        Point: function(t) {
            var e = new ul(t[0], t[1]);
            return this.geometryFactory.createPoint(e);
        },
        MultiPoint: function(t) {
            for(var e = [], n = 0; n < t.length; ++n)e.push(bh.Point.apply(this, [
                t[n]
            ]));
            return this.geometryFactory.createMultiPoint(e);
        },
        LineString: function(t) {
            var e = bh.coordinates.apply(this, [
                t
            ]);
            return this.geometryFactory.createLineString(e);
        },
        MultiLineString: function(t) {
            for(var e = [], n = 0; n < t.length; ++n)e.push(bh.LineString.apply(this, [
                t[n]
            ]));
            return this.geometryFactory.createMultiLineString(e);
        },
        Polygon: function(t) {
            for(var e = bh.coordinates.apply(this, [
                t[0]
            ]), n = this.geometryFactory.createLinearRing(e), r = [], i = 1; i < t.length; ++i){
                var o = t[i], s = bh.coordinates.apply(this, [
                    o
                ]), a = this.geometryFactory.createLinearRing(s);
                r.push(a);
            }
            return this.geometryFactory.createPolygon(n, r);
        },
        MultiPolygon: function(t) {
            for(var e = [], n = 0; n < t.length; ++n){
                var r = t[n];
                e.push(bh.Polygon.apply(this, [
                    r
                ]));
            }
            return this.geometryFactory.createMultiPolygon(e);
        },
        GeometryCollection: function(t) {
            for(var e = [], n = 0; n < t.length; ++n){
                var r = t[n];
                e.push(this.read(r));
            }
            return this.geometryFactory.createGeometryCollection(e);
        }
    }, wh = {
        coordinate: function(t) {
            return [
                t.x,
                t.y
            ];
        },
        Point: function(t) {
            return {
                type: "Point",
                coordinates: wh.coordinate.apply(this, [
                    t.getCoordinate()
                ])
            };
        },
        MultiPoint: function(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var r = t._geometries[n], i = wh.Point.apply(this, [
                    r
                ]);
                e.push(i.coordinates);
            }
            return {
                type: "MultiPoint",
                coordinates: e
            };
        },
        LineString: function(t) {
            for(var e = [], n = t.getCoordinates(), r = 0; r < n.length; ++r){
                var i = n[r];
                e.push(wh.coordinate.apply(this, [
                    i
                ]));
            }
            return {
                type: "LineString",
                coordinates: e
            };
        },
        MultiLineString: function(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var r = t._geometries[n], i = wh.LineString.apply(this, [
                    r
                ]);
                e.push(i.coordinates);
            }
            return {
                type: "MultiLineString",
                coordinates: e
            };
        },
        Polygon: function(t) {
            var e = [], n = wh.LineString.apply(this, [
                t._shell
            ]);
            e.push(n.coordinates);
            for(var r = 0; r < t._holes.length; ++r){
                var i = t._holes[r], o = wh.LineString.apply(this, [
                    i
                ]);
                e.push(o.coordinates);
            }
            return {
                type: "Polygon",
                coordinates: e
            };
        },
        MultiPolygon: function(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var r = t._geometries[n], i = wh.Polygon.apply(this, [
                    r
                ]);
                e.push(i.coordinates);
            }
            return {
                type: "MultiPolygon",
                coordinates: e
            };
        },
        GeometryCollection: function(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var r = t._geometries[n], i = r.getGeometryType();
                e.push(wh[i].apply(this, [
                    r
                ]));
            }
            return {
                type: "GeometryCollection",
                geometries: e
            };
        }
    }, Ih = function(t) {
        this.geometryFactory = t || new _h, this.precisionModel = this.geometryFactory.getPrecisionModel(), this.parser = new Eh(this.geometryFactory);
    };
    Ih.prototype.read = function(t) {
        var e = this.parser.read(t);
        return this.precisionModel.getType() === gh.FIXED && this.reducePrecision(e), e;
    }, Ih.prototype.reducePrecision = function(t) {
        var e, n;
        if (t.coordinate) this.precisionModel.makePrecise(t.coordinate);
        else if (t.points) for(e = 0, n = t.points.length; e < n; e++)this.precisionModel.makePrecise(t.points[e]);
        else if (t.geometries) for(e = 0, n = t.geometries.length; e < n; e++)this.reducePrecision(t.geometries[e]);
    };
    var Nh = function() {
        this.parser = new Eh(this.geometryFactory);
    };
    Nh.prototype.write = function(t) {
        return this.parser.write(t);
    };
    var Sh = function() {}, Ch = {
        ON: {
            configurable: !0
        },
        LEFT: {
            configurable: !0
        },
        RIGHT: {
            configurable: !0
        }
    };
    function Ph(t) {
        this.message = t || "";
    }
    function Mh() {
        this.array_ = [];
    }
    Sh.prototype.interfaces_ = function() {
        return [];
    }, Sh.prototype.getClass = function() {
        return Sh;
    }, Sh.opposite = function(t) {
        return t === Sh.LEFT ? Sh.RIGHT : t === Sh.RIGHT ? Sh.LEFT : t;
    }, Ch.ON.get = function() {
        return 0;
    }, Ch.LEFT.get = function() {
        return 1;
    }, Ch.RIGHT.get = function() {
        return 2;
    }, Object.defineProperties(Sh, Ch), Ph.prototype = new Error, Ph.prototype.name = "EmptyStackException", Mh.prototype = new ac, Mh.prototype.add = function(t) {
        return this.array_.push(t), !0;
    }, Mh.prototype.get = function(t) {
        if (t < 0 || t >= this.size()) throw new Error;
        return this.array_[t];
    }, Mh.prototype.push = function(t) {
        return this.array_.push(t), t;
    }, Mh.prototype.pop = function(t) {
        if (0 === this.array_.length) throw new Ph;
        return this.array_.pop();
    }, Mh.prototype.peek = function() {
        if (0 === this.array_.length) throw new Ph;
        return this.array_[this.array_.length - 1];
    }, Mh.prototype.empty = function() {
        return 0 === this.array_.length;
    }, Mh.prototype.isEmpty = function() {
        return this.empty();
    }, Mh.prototype.search = function(t) {
        return this.array_.indexOf(t);
    }, Mh.prototype.size = function() {
        return this.array_.length;
    }, Mh.prototype.toArray = function() {
        for(var t = [], e = 0, n = this.array_.length; e < n; e++)t.push(this.array_[e]);
        return t;
    };
    var Lh = function() {
        this._minIndex = -1, this._minCoord = null, this._minDe = null, this._orientedDe = null;
    };
    Lh.prototype.getCoordinate = function() {
        return this._minCoord;
    }, Lh.prototype.getRightmostSide = function(t, e) {
        var n = this.getRightmostSideOfSegment(t, e);
        return n < 0 && (n = this.getRightmostSideOfSegment(t, e - 1)), n < 0 && (this._minCoord = null, this.checkForRightmostCoordinate(t)), n;
    }, Lh.prototype.findRightmostEdgeAtVertex = function() {
        var t = this._minDe.getEdge().getCoordinates();
        ql.isTrue(this._minIndex > 0 && this._minIndex < t.length, "rightmost point expected to be interior vertex of edge");
        var e = t[this._minIndex - 1], n = t[this._minIndex + 1], r = Xl.computeOrientation(this._minCoord, n, e), i = !1;
        (e.y < this._minCoord.y && n.y < this._minCoord.y && r === Xl.COUNTERCLOCKWISE || e.y > this._minCoord.y && n.y > this._minCoord.y && r === Xl.CLOCKWISE) && (i = !0), i && (this._minIndex = this._minIndex - 1);
    }, Lh.prototype.getRightmostSideOfSegment = function(t, e) {
        var n = t.getEdge().getCoordinates();
        if (e < 0 || e + 1 >= n.length) return -1;
        if (n[e].y === n[e + 1].y) return -1;
        var r = Sh.LEFT;
        return n[e].y < n[e + 1].y && (r = Sh.RIGHT), r;
    }, Lh.prototype.getEdge = function() {
        return this._orientedDe;
    }, Lh.prototype.checkForRightmostCoordinate = function(t) {
        for(var e = this, n = t.getEdge().getCoordinates(), r = 0; r < n.length - 1; r++)(null === e._minCoord || n[r].x > e._minCoord.x) && (e._minDe = t, e._minIndex = r, e._minCoord = n[r]);
    }, Lh.prototype.findRightmostEdgeAtNode = function() {
        var t = this._minDe.getNode().getEdges();
        this._minDe = t.getRightmostEdge(), this._minDe.isForward() || (this._minDe = this._minDe.getSym(), this._minIndex = this._minDe.getEdge().getCoordinates().length - 1);
    }, Lh.prototype.findEdge = function(t) {
        for(var e = t.iterator(); e.hasNext();){
            var n = e.next();
            n.isForward() && this.checkForRightmostCoordinate(n);
        }
        ql.isTrue(0 !== this._minIndex || this._minCoord.equals(this._minDe.getCoordinate()), "inconsistency in rightmost processing"), 0 === this._minIndex ? this.findRightmostEdgeAtNode() : this.findRightmostEdgeAtVertex(), this._orientedDe = this._minDe, this.getRightmostSide(this._minDe, this._minIndex) === Sh.LEFT && (this._orientedDe = this._minDe.getSym());
    }, Lh.prototype.interfaces_ = function() {
        return [];
    }, Lh.prototype.getClass = function() {
        return Lh;
    };
    var Oh = function(t) {
        function e(n, r) {
            t.call(this, e.msgWithCoord(n, r)), this.pt = r ? new ul(r) : null, this.name = "TopologyException";
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getCoordinate = function() {
            return this.pt;
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e.msgWithCoord = function(t, e) {
            return e ? t : t + " [ " + e + " ]";
        }, e;
    }(kl), Rh = function() {
        this.array_ = [];
    };
    Rh.prototype.addLast = function(t) {
        this.array_.push(t);
    }, Rh.prototype.removeFirst = function() {
        return this.array_.shift();
    }, Rh.prototype.isEmpty = function() {
        return 0 === this.array_.length;
    };
    var Th = function() {
        this._finder = null, this._dirEdgeList = new lc, this._nodes = new lc, this._rightMostCoord = null, this._env = null, this._finder = new Lh;
    };
    Th.prototype.clearVisitedEdges = function() {
        for(var t = this._dirEdgeList.iterator(); t.hasNext();)t.next().setVisited(!1);
    }, Th.prototype.getRightmostCoordinate = function() {
        return this._rightMostCoord;
    }, Th.prototype.computeNodeDepth = function(t) {
        for(var e = null, n = t.getEdges().iterator(); n.hasNext();){
            var r = n.next();
            if (r.isVisited() || r.getSym().isVisited()) {
                e = r;
                break;
            }
        }
        if (null === e) throw new Oh("unable to find edge to compute depths at " + t.getCoordinate());
        t.getEdges().computeDepths(e);
        for(var i = t.getEdges().iterator(); i.hasNext();){
            var o = i.next();
            o.setVisited(!0), this.copySymDepths(o);
        }
    }, Th.prototype.computeDepth = function(t) {
        this.clearVisitedEdges();
        var e = this._finder.getEdge();
        e.setEdgeDepths(Sh.RIGHT, t), this.copySymDepths(e), this.computeDepths(e);
    }, Th.prototype.create = function(t) {
        this.addReachable(t), this._finder.findEdge(this._dirEdgeList), this._rightMostCoord = this._finder.getCoordinate();
    }, Th.prototype.findResultEdges = function() {
        for(var t = this._dirEdgeList.iterator(); t.hasNext();){
            var e = t.next();
            e.getDepth(Sh.RIGHT) >= 1 && e.getDepth(Sh.LEFT) <= 0 && !e.isInteriorAreaEdge() && e.setInResult(!0);
        }
    }, Th.prototype.computeDepths = function(t) {
        var e = new xc, n = new Rh, r = t.getNode();
        for(n.addLast(r), e.add(r), t.setVisited(!0); !n.isEmpty();){
            var i = n.removeFirst();
            e.add(i), this.computeNodeDepth(i);
            for(var o = i.getEdges().iterator(); o.hasNext();){
                var s = o.next().getSym();
                if (!s.isVisited()) {
                    var a = s.getNode();
                    e.contains(a) || (n.addLast(a), e.add(a));
                }
            }
        }
    }, Th.prototype.compareTo = function(t) {
        var e = t;
        return this._rightMostCoord.x < e._rightMostCoord.x ? -1 : this._rightMostCoord.x > e._rightMostCoord.x ? 1 : 0;
    }, Th.prototype.getEnvelope = function() {
        if (null === this._env) {
            for(var t = new Ll, e = this._dirEdgeList.iterator(); e.hasNext();)for(var n = e.next().getEdge().getCoordinates(), r = 0; r < n.length - 1; r++)t.expandToInclude(n[r]);
            this._env = t;
        }
        return this._env;
    }, Th.prototype.addReachable = function(t) {
        var e = new Mh;
        for(e.add(t); !e.empty();){
            var n = e.pop();
            this.add(n, e);
        }
    }, Th.prototype.copySymDepths = function(t) {
        var e = t.getSym();
        e.setDepth(Sh.LEFT, t.getDepth(Sh.RIGHT)), e.setDepth(Sh.RIGHT, t.getDepth(Sh.LEFT));
    }, Th.prototype.add = function(t, e) {
        t.setVisited(!0), this._nodes.add(t);
        for(var n = t.getEdges().iterator(); n.hasNext();){
            var r = n.next();
            this._dirEdgeList.add(r);
            var i = r.getSym().getNode();
            i.isVisited() || e.push(i);
        }
    }, Th.prototype.getNodes = function() {
        return this._nodes;
    }, Th.prototype.getDirectedEdges = function() {
        return this._dirEdgeList;
    }, Th.prototype.interfaces_ = function() {
        return [
            il
        ];
    }, Th.prototype.getClass = function() {
        return Th;
    };
    var Ah = function t() {
        var e = this;
        if (this.location = null, 1 === arguments.length) {
            if (arguments[0] instanceof Array) {
                var n = arguments[0];
                this.init(n.length);
            } else if (Number.isInteger(arguments[0])) {
                var r = arguments[0];
                this.init(1), this.location[Sh.ON] = r;
            } else if (arguments[0] instanceof t) {
                var i = arguments[0];
                if (this.init(i.location.length), null !== i) for(var o = 0; o < this.location.length; o++)e.location[o] = i.location[o];
            }
        } else if (3 === arguments.length) {
            var s = arguments[0], a = arguments[1], u = arguments[2];
            this.init(3), this.location[Sh.ON] = s, this.location[Sh.LEFT] = a, this.location[Sh.RIGHT] = u;
        }
    };
    Ah.prototype.setAllLocations = function(t) {
        for(var e = 0; e < this.location.length; e++)this.location[e] = t;
    }, Ah.prototype.isNull = function() {
        for(var t = 0; t < this.location.length; t++)if (this.location[t] !== pl.NONE) return !1;
        return !0;
    }, Ah.prototype.setAllLocationsIfNull = function(t) {
        for(var e = 0; e < this.location.length; e++)this.location[e] === pl.NONE && (this.location[e] = t);
    }, Ah.prototype.isLine = function() {
        return 1 === this.location.length;
    }, Ah.prototype.merge = function(t) {
        if (t.location.length > this.location.length) {
            var e = new Array(3).fill(null);
            e[Sh.ON] = this.location[Sh.ON], e[Sh.LEFT] = pl.NONE, e[Sh.RIGHT] = pl.NONE, this.location = e;
        }
        for(var n = 0; n < this.location.length; n++)this.location[n] === pl.NONE && n < t.location.length && (this.location[n] = t.location[n]);
    }, Ah.prototype.getLocations = function() {
        return this.location;
    }, Ah.prototype.flip = function() {
        if (this.location.length <= 1) return null;
        var t = this.location[Sh.LEFT];
        this.location[Sh.LEFT] = this.location[Sh.RIGHT], this.location[Sh.RIGHT] = t;
    }, Ah.prototype.toString = function() {
        var t = new vl;
        return this.location.length > 1 && t.append(pl.toLocationSymbol(this.location[Sh.LEFT])), t.append(pl.toLocationSymbol(this.location[Sh.ON])), this.location.length > 1 && t.append(pl.toLocationSymbol(this.location[Sh.RIGHT])), t.toString();
    }, Ah.prototype.setLocations = function(t, e, n) {
        this.location[Sh.ON] = t, this.location[Sh.LEFT] = e, this.location[Sh.RIGHT] = n;
    }, Ah.prototype.get = function(t) {
        return t < this.location.length ? this.location[t] : pl.NONE;
    }, Ah.prototype.isArea = function() {
        return this.location.length > 1;
    }, Ah.prototype.isAnyNull = function() {
        for(var t = 0; t < this.location.length; t++)if (this.location[t] === pl.NONE) return !0;
        return !1;
    }, Ah.prototype.setLocation = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setLocation(Sh.ON, t);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this.location[e] = n;
        }
    }, Ah.prototype.init = function(t) {
        this.location = new Array(t).fill(null), this.setAllLocations(pl.NONE);
    }, Ah.prototype.isEqualOnSide = function(t, e) {
        return this.location[e] === t.location[e];
    }, Ah.prototype.allPositionsEqual = function(t) {
        for(var e = 0; e < this.location.length; e++)if (this.location[e] !== t) return !1;
        return !0;
    }, Ah.prototype.interfaces_ = function() {
        return [];
    }, Ah.prototype.getClass = function() {
        return Ah;
    };
    var Dh = function t() {
        if (this.elt = new Array(2).fill(null), 1 === arguments.length) {
            if (Number.isInteger(arguments[0])) {
                var e = arguments[0];
                this.elt[0] = new Ah(e), this.elt[1] = new Ah(e);
            } else if (arguments[0] instanceof t) {
                var n = arguments[0];
                this.elt[0] = new Ah(n.elt[0]), this.elt[1] = new Ah(n.elt[1]);
            }
        } else if (2 === arguments.length) {
            var r = arguments[0], i = arguments[1];
            this.elt[0] = new Ah(pl.NONE), this.elt[1] = new Ah(pl.NONE), this.elt[r].setLocation(i);
        } else if (3 === arguments.length) {
            var o = arguments[0], s = arguments[1], a = arguments[2];
            this.elt[0] = new Ah(o, s, a), this.elt[1] = new Ah(o, s, a);
        } else if (4 === arguments.length) {
            var u = arguments[0], l = arguments[1], c = arguments[2], h = arguments[3];
            this.elt[0] = new Ah(pl.NONE, pl.NONE, pl.NONE), this.elt[1] = new Ah(pl.NONE, pl.NONE, pl.NONE), this.elt[u].setLocations(l, c, h);
        }
    };
    Dh.prototype.getGeometryCount = function() {
        var t = 0;
        return this.elt[0].isNull() || t++, this.elt[1].isNull() || t++, t;
    }, Dh.prototype.setAllLocations = function(t, e) {
        this.elt[t].setAllLocations(e);
    }, Dh.prototype.isNull = function(t) {
        return this.elt[t].isNull();
    }, Dh.prototype.setAllLocationsIfNull = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setAllLocationsIfNull(0, t), this.setAllLocationsIfNull(1, t);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this.elt[e].setAllLocationsIfNull(n);
        }
    }, Dh.prototype.isLine = function(t) {
        return this.elt[t].isLine();
    }, Dh.prototype.merge = function(t) {
        for(var e = this, n = 0; n < 2; n++)null === e.elt[n] && null !== t.elt[n] ? e.elt[n] = new Ah(t.elt[n]) : e.elt[n].merge(t.elt[n]);
    }, Dh.prototype.flip = function() {
        this.elt[0].flip(), this.elt[1].flip();
    }, Dh.prototype.getLocation = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this.elt[t].get(Sh.ON);
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return this.elt[e].get(n);
        }
    }, Dh.prototype.toString = function() {
        var t = new vl;
        return null !== this.elt[0] && (t.append("A:"), t.append(this.elt[0].toString())), null !== this.elt[1] && (t.append(" B:"), t.append(this.elt[1].toString())), t.toString();
    }, Dh.prototype.isArea = function() {
        if (0 === arguments.length) return this.elt[0].isArea() || this.elt[1].isArea();
        if (1 === arguments.length) {
            var t = arguments[0];
            return this.elt[t].isArea();
        }
    }, Dh.prototype.isAnyNull = function(t) {
        return this.elt[t].isAnyNull();
    }, Dh.prototype.setLocation = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this.elt[t].setLocation(Sh.ON, e);
        } else if (3 === arguments.length) {
            var n = arguments[0], r = arguments[1], i = arguments[2];
            this.elt[n].setLocation(r, i);
        }
    }, Dh.prototype.isEqualOnSide = function(t, e) {
        return this.elt[0].isEqualOnSide(t.elt[0], e) && this.elt[1].isEqualOnSide(t.elt[1], e);
    }, Dh.prototype.allPositionsEqual = function(t, e) {
        return this.elt[t].allPositionsEqual(e);
    }, Dh.prototype.toLine = function(t) {
        this.elt[t].isArea() && (this.elt[t] = new Ah(this.elt[t].location[0]));
    }, Dh.prototype.interfaces_ = function() {
        return [];
    }, Dh.prototype.getClass = function() {
        return Dh;
    }, Dh.toLineLabel = function(t) {
        for(var e = new Dh(pl.NONE), n = 0; n < 2; n++)e.setLocation(n, t.getLocation(n));
        return e;
    };
    var Fh = function() {
        this._startDe = null, this._maxNodeDegree = -1, this._edges = new lc, this._pts = new lc, this._label = new Dh(pl.NONE), this._ring = null, this._isHole = null, this._shell = null, this._holes = new lc, this._geometryFactory = null;
        var t = arguments[0], e = arguments[1];
        this._geometryFactory = e, this.computePoints(t), this.computeRing();
    };
    Fh.prototype.computeRing = function() {
        if (null !== this._ring) return null;
        for(var t = new Array(this._pts.size()).fill(null), e = 0; e < this._pts.size(); e++)t[e] = this._pts.get(e);
        this._ring = this._geometryFactory.createLinearRing(t), this._isHole = Xl.isCCW(this._ring.getCoordinates());
    }, Fh.prototype.isIsolated = function() {
        return 1 === this._label.getGeometryCount();
    }, Fh.prototype.computePoints = function(t) {
        var e = this;
        this._startDe = t;
        var n = t, r = !0;
        do {
            if (null === n) throw new Oh("Found null DirectedEdge");
            if (n.getEdgeRing() === e) throw new Oh("Directed Edge visited twice during ring-building at " + n.getCoordinate());
            e._edges.add(n);
            var i = n.getLabel();
            ql.isTrue(i.isArea()), e.mergeLabel(i), e.addPoints(n.getEdge(), n.isForward(), r), r = !1, e.setEdgeRing(n, e), n = e.getNext(n);
        }while (n !== this._startDe);
    }, Fh.prototype.getLinearRing = function() {
        return this._ring;
    }, Fh.prototype.getCoordinate = function(t) {
        return this._pts.get(t);
    }, Fh.prototype.computeMaxNodeDegree = function() {
        var t = this;
        this._maxNodeDegree = 0;
        var e = this._startDe;
        do {
            var n = e.getNode().getEdges().getOutgoingDegree(t);
            n > t._maxNodeDegree && (t._maxNodeDegree = n), e = t.getNext(e);
        }while (e !== this._startDe);
        this._maxNodeDegree *= 2;
    }, Fh.prototype.addPoints = function(t, e, n) {
        var r = t.getCoordinates();
        if (e) {
            var i = 1;
            n && (i = 0);
            for(var o = i; o < r.length; o++)this._pts.add(r[o]);
        } else {
            var s = r.length - 2;
            n && (s = r.length - 1);
            for(var a = s; a >= 0; a--)this._pts.add(r[a]);
        }
    }, Fh.prototype.isHole = function() {
        return this._isHole;
    }, Fh.prototype.setInResult = function() {
        var t = this._startDe;
        do t.getEdge().setInResult(!0), t = t.getNext();
        while (t !== this._startDe);
    }, Fh.prototype.containsPoint = function(t) {
        var e = this.getLinearRing();
        if (!e.getEnvelopeInternal().contains(t)) return !1;
        if (!Xl.isPointInRing(t, e.getCoordinates())) return !1;
        for(var n = this._holes.iterator(); n.hasNext();){
            if (n.next().containsPoint(t)) return !1;
        }
        return !0;
    }, Fh.prototype.addHole = function(t) {
        this._holes.add(t);
    }, Fh.prototype.isShell = function() {
        return null === this._shell;
    }, Fh.prototype.getLabel = function() {
        return this._label;
    }, Fh.prototype.getEdges = function() {
        return this._edges;
    }, Fh.prototype.getMaxNodeDegree = function() {
        return this._maxNodeDegree < 0 && this.computeMaxNodeDegree(), this._maxNodeDegree;
    }, Fh.prototype.getShell = function() {
        return this._shell;
    }, Fh.prototype.mergeLabel = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.mergeLabel(t, 0), this.mergeLabel(t, 1);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1], r = e.getLocation(n, Sh.RIGHT);
            if (r === pl.NONE) return null;
            if (this._label.getLocation(n) === pl.NONE) return this._label.setLocation(n, r), null;
        }
    }, Fh.prototype.setShell = function(t) {
        this._shell = t, null !== t && t.addHole(this);
    }, Fh.prototype.toPolygon = function(t) {
        for(var e = new Array(this._holes.size()).fill(null), n = 0; n < this._holes.size(); n++)e[n] = this._holes.get(n).getLinearRing();
        return t.createPolygon(this.getLinearRing(), e);
    }, Fh.prototype.interfaces_ = function() {
        return [];
    }, Fh.prototype.getClass = function() {
        return Fh;
    };
    var kh = function(t) {
        function e() {
            var e = arguments[0], n = arguments[1];
            t.call(this, e, n);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.setEdgeRing = function(t, e) {
            t.setMinEdgeRing(e);
        }, e.prototype.getNext = function(t) {
            return t.getNextMin();
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Fh), Gh = function(t) {
        function e() {
            var e = arguments[0], n = arguments[1];
            t.call(this, e, n);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.buildMinimalRings = function() {
            var t = new lc, e = this._startDe;
            do {
                if (null === e.getMinEdgeRing()) {
                    var n = new kh(e, this._geometryFactory);
                    t.add(n);
                }
                e = e.getNext();
            }while (e !== this._startDe);
            return t;
        }, e.prototype.setEdgeRing = function(t, e) {
            t.setEdgeRing(e);
        }, e.prototype.linkDirectedEdgesForMinimalEdgeRings = function() {
            var t = this._startDe;
            do t.getNode().getEdges().linkMinimalDirectedEdges(this), t = t.getNext();
            while (t !== this._startDe);
        }, e.prototype.getNext = function(t) {
            return t.getNext();
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Fh), qh = function() {
        if (this._label = null, this._isInResult = !1, this._isCovered = !1, this._isCoveredSet = !1, this._isVisited = !1, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var t = arguments[0];
            this._label = t;
        }
    };
    qh.prototype.setVisited = function(t) {
        this._isVisited = t;
    }, qh.prototype.setInResult = function(t) {
        this._isInResult = t;
    }, qh.prototype.isCovered = function() {
        return this._isCovered;
    }, qh.prototype.isCoveredSet = function() {
        return this._isCoveredSet;
    }, qh.prototype.setLabel = function(t) {
        this._label = t;
    }, qh.prototype.getLabel = function() {
        return this._label;
    }, qh.prototype.setCovered = function(t) {
        this._isCovered = t, this._isCoveredSet = !0;
    }, qh.prototype.updateIM = function(t) {
        ql.isTrue(this._label.getGeometryCount() >= 2, "found partial label"), this.computeIM(t);
    }, qh.prototype.isInResult = function() {
        return this._isInResult;
    }, qh.prototype.isVisited = function() {
        return this._isVisited;
    }, qh.prototype.interfaces_ = function() {
        return [];
    }, qh.prototype.getClass = function() {
        return qh;
    };
    var Bh = function(t) {
        function e() {
            t.call(this), this._coord = null, this._edges = null;
            var e = arguments[0], n = arguments[1];
            this._coord = e, this._edges = n, this._label = new Dh(0, pl.NONE);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.isIncidentEdgeInResult = function() {
            for(var t = this.getEdges().getEdges().iterator(); t.hasNext();){
                if (t.next().getEdge().isInResult()) return !0;
            }
            return !1;
        }, e.prototype.isIsolated = function() {
            return 1 === this._label.getGeometryCount();
        }, e.prototype.getCoordinate = function() {
            return this._coord;
        }, e.prototype.print = function(t) {
            t.println("node " + this._coord + " lbl: " + this._label);
        }, e.prototype.computeIM = function(t) {}, e.prototype.computeMergedLocation = function(t, e) {
            var n = pl.NONE;
            if (n = this._label.getLocation(e), !t.isNull(e)) {
                var r = t.getLocation(e);
                n !== pl.BOUNDARY && (n = r);
            }
            return n;
        }, e.prototype.setLabel = function() {
            if (2 !== arguments.length) return t.prototype.setLabel.apply(this, arguments);
            var e = arguments[0], n = arguments[1];
            null === this._label ? this._label = new Dh(e, n) : this._label.setLocation(e, n);
        }, e.prototype.getEdges = function() {
            return this._edges;
        }, e.prototype.mergeLabel = function() {
            var t = this;
            if (arguments[0] instanceof e) {
                var n = arguments[0];
                this.mergeLabel(n._label);
            } else if (arguments[0] instanceof Dh) for(var r = arguments[0], i = 0; i < 2; i++){
                var o = t.computeMergedLocation(r, i), s = t._label.getLocation(i);
                s === pl.NONE && t._label.setLocation(i, o);
            }
        }, e.prototype.add = function(t) {
            this._edges.insert(t), t.setNode(this);
        }, e.prototype.setLabelBoundary = function(t) {
            if (null === this._label) return null;
            var e = pl.NONE;
            null !== this._label && (e = this._label.getLocation(t));
            var n = null;
            switch(e){
                case pl.BOUNDARY:
                    n = pl.INTERIOR;
                    break;
                case pl.INTERIOR:
                default:
                    n = pl.BOUNDARY;
            }
            this._label.setLocation(t, n);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(qh), zh = function() {
        this.nodeMap = new Cc, this.nodeFact = null;
        var t = arguments[0];
        this.nodeFact = t;
    };
    zh.prototype.find = function(t) {
        return this.nodeMap.get(t);
    }, zh.prototype.addNode = function() {
        if (arguments[0] instanceof ul) {
            var t = arguments[0], e = this.nodeMap.get(t);
            return null === e && (e = this.nodeFact.createNode(t), this.nodeMap.put(t, e)), e;
        }
        if (arguments[0] instanceof Bh) {
            var n = arguments[0], r = this.nodeMap.get(n.getCoordinate());
            return null === r ? (this.nodeMap.put(n.getCoordinate(), n), n) : (r.mergeLabel(n), r);
        }
    }, zh.prototype.print = function(t) {
        for(var e = this.iterator(); e.hasNext();)e.next().print(t);
    }, zh.prototype.iterator = function() {
        return this.nodeMap.values().iterator();
    }, zh.prototype.values = function() {
        return this.nodeMap.values();
    }, zh.prototype.getBoundaryNodes = function(t) {
        for(var e = new lc, n = this.iterator(); n.hasNext();){
            var r = n.next();
            r.getLabel().getLocation(t) === pl.BOUNDARY && e.add(r);
        }
        return e;
    }, zh.prototype.add = function(t) {
        var e = t.getCoordinate();
        this.addNode(e).add(t);
    }, zh.prototype.interfaces_ = function() {
        return [];
    }, zh.prototype.getClass = function() {
        return zh;
    };
    var jh = function() {}, Uh = {
        NE: {
            configurable: !0
        },
        NW: {
            configurable: !0
        },
        SW: {
            configurable: !0
        },
        SE: {
            configurable: !0
        }
    };
    jh.prototype.interfaces_ = function() {
        return [];
    }, jh.prototype.getClass = function() {
        return jh;
    }, jh.isNorthern = function(t) {
        return t === jh.NE || t === jh.NW;
    }, jh.isOpposite = function(t, e) {
        return t !== e && 2 === (t - e + 4) % 4;
    }, jh.commonHalfPlane = function(t, e) {
        if (t === e) return t;
        if (2 === (t - e + 4) % 4) return -1;
        var n = t < e ? t : e;
        return 0 === n && 3 === (t > e ? t : e) ? 3 : n;
    }, jh.isInHalfPlane = function(t, e) {
        return e === jh.SE ? t === jh.SE || t === jh.SW : t === e || t === e + 1;
    }, jh.quadrant = function() {
        if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
            var t = arguments[0], e = arguments[1];
            if (0 === t && 0 === e) throw new el("Cannot compute the quadrant for point ( " + t + ", " + e + " )");
            return t >= 0 ? e >= 0 ? jh.NE : jh.SE : e >= 0 ? jh.NW : jh.SW;
        }
        if (arguments[0] instanceof ul && arguments[1] instanceof ul) {
            var n = arguments[0], r = arguments[1];
            if (r.x === n.x && r.y === n.y) throw new el("Cannot compute the quadrant for two identical points " + n);
            return r.x >= n.x ? r.y >= n.y ? jh.NE : jh.SE : r.y >= n.y ? jh.NW : jh.SW;
        }
    }, Uh.NE.get = function() {
        return 0;
    }, Uh.NW.get = function() {
        return 1;
    }, Uh.SW.get = function() {
        return 2;
    }, Uh.SE.get = function() {
        return 3;
    }, Object.defineProperties(jh, Uh);
    var Vh = function() {
        if (this._edge = null, this._label = null, this._node = null, this._p0 = null, this._p1 = null, this._dx = null, this._dy = null, this._quadrant = null, 1 === arguments.length) {
            var t = arguments[0];
            this._edge = t;
        } else if (3 === arguments.length) {
            var e = arguments[0], n = arguments[1], r = arguments[2], i = null;
            this._edge = e, this.init(n, r), this._label = i;
        } else if (4 === arguments.length) {
            var o = arguments[0], s = arguments[1], a = arguments[2], u = arguments[3];
            this._edge = o, this.init(s, a), this._label = u;
        }
    };
    Vh.prototype.compareDirection = function(t) {
        return this._dx === t._dx && this._dy === t._dy ? 0 : this._quadrant > t._quadrant ? 1 : this._quadrant < t._quadrant ? -1 : Xl.computeOrientation(t._p0, t._p1, this._p1);
    }, Vh.prototype.getDy = function() {
        return this._dy;
    }, Vh.prototype.getCoordinate = function() {
        return this._p0;
    }, Vh.prototype.setNode = function(t) {
        this._node = t;
    }, Vh.prototype.print = function(t) {
        var e = Math.atan2(this._dy, this._dx), n = this.getClass().getName(), r = n.lastIndexOf("."), i = n.substring(r + 1);
        t.print("  " + i + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + e + "   " + this._label);
    }, Vh.prototype.compareTo = function(t) {
        var e = t;
        return this.compareDirection(e);
    }, Vh.prototype.getDirectedCoordinate = function() {
        return this._p1;
    }, Vh.prototype.getDx = function() {
        return this._dx;
    }, Vh.prototype.getLabel = function() {
        return this._label;
    }, Vh.prototype.getEdge = function() {
        return this._edge;
    }, Vh.prototype.getQuadrant = function() {
        return this._quadrant;
    }, Vh.prototype.getNode = function() {
        return this._node;
    }, Vh.prototype.toString = function() {
        var t = Math.atan2(this._dy, this._dx), e = this.getClass().getName(), n = e.lastIndexOf(".");
        return "  " + e.substring(n + 1) + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + t + "   " + this._label;
    }, Vh.prototype.computeLabel = function(t) {}, Vh.prototype.init = function(t, e) {
        this._p0 = t, this._p1 = e, this._dx = e.x - t.x, this._dy = e.y - t.y, this._quadrant = jh.quadrant(this._dx, this._dy), ql.isTrue(!(0 === this._dx && 0 === this._dy), "EdgeEnd with identical endpoints found");
    }, Vh.prototype.interfaces_ = function() {
        return [
            il
        ];
    }, Vh.prototype.getClass = function() {
        return Vh;
    };
    var Xh = function(t) {
        function e() {
            var e = arguments[0], n = arguments[1];
            if (t.call(this, e), this._isForward = null, this._isInResult = !1, this._isVisited = !1, this._sym = null, this._next = null, this._nextMin = null, this._edgeRing = null, this._minEdgeRing = null, this._depth = [
                0,
                -999,
                -999
            ], this._isForward = n, n) this.init(e.getCoordinate(0), e.getCoordinate(1));
            else {
                var r = e.getNumPoints() - 1;
                this.init(e.getCoordinate(r), e.getCoordinate(r - 1));
            }
            this.computeDirectedLabel();
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getNextMin = function() {
            return this._nextMin;
        }, e.prototype.getDepth = function(t) {
            return this._depth[t];
        }, e.prototype.setVisited = function(t) {
            this._isVisited = t;
        }, e.prototype.computeDirectedLabel = function() {
            this._label = new Dh(this._edge.getLabel()), this._isForward || this._label.flip();
        }, e.prototype.getNext = function() {
            return this._next;
        }, e.prototype.setDepth = function(t, e) {
            if (-999 !== this._depth[t] && this._depth[t] !== e) throw new Oh("assigned depths do not match", this.getCoordinate());
            this._depth[t] = e;
        }, e.prototype.isInteriorAreaEdge = function() {
            for(var t = this, e = !0, n = 0; n < 2; n++)t._label.isArea(n) && t._label.getLocation(n, Sh.LEFT) === pl.INTERIOR && t._label.getLocation(n, Sh.RIGHT) === pl.INTERIOR || (e = !1);
            return e;
        }, e.prototype.setNextMin = function(t) {
            this._nextMin = t;
        }, e.prototype.print = function(e) {
            t.prototype.print.call(this, e), e.print(" " + this._depth[Sh.LEFT] + "/" + this._depth[Sh.RIGHT]), e.print(" (" + this.getDepthDelta() + ")"), this._isInResult && e.print(" inResult");
        }, e.prototype.setMinEdgeRing = function(t) {
            this._minEdgeRing = t;
        }, e.prototype.isLineEdge = function() {
            var t = this._label.isLine(0) || this._label.isLine(1), e = !this._label.isArea(0) || this._label.allPositionsEqual(0, pl.EXTERIOR), n = !this._label.isArea(1) || this._label.allPositionsEqual(1, pl.EXTERIOR);
            return t && e && n;
        }, e.prototype.setEdgeRing = function(t) {
            this._edgeRing = t;
        }, e.prototype.getMinEdgeRing = function() {
            return this._minEdgeRing;
        }, e.prototype.getDepthDelta = function() {
            var t = this._edge.getDepthDelta();
            return this._isForward || (t = -t), t;
        }, e.prototype.setInResult = function(t) {
            this._isInResult = t;
        }, e.prototype.getSym = function() {
            return this._sym;
        }, e.prototype.isForward = function() {
            return this._isForward;
        }, e.prototype.getEdge = function() {
            return this._edge;
        }, e.prototype.printEdge = function(t) {
            this.print(t), t.print(" "), this._isForward ? this._edge.print(t) : this._edge.printReverse(t);
        }, e.prototype.setSym = function(t) {
            this._sym = t;
        }, e.prototype.setVisitedEdge = function(t) {
            this.setVisited(t), this._sym.setVisited(t);
        }, e.prototype.setEdgeDepths = function(t, e) {
            var n = this.getEdge().getDepthDelta();
            this._isForward || (n = -n);
            var r = 1;
            t === Sh.LEFT && (r = -1);
            var i = Sh.opposite(t), o = e + n * r;
            this.setDepth(t, e), this.setDepth(i, o);
        }, e.prototype.getEdgeRing = function() {
            return this._edgeRing;
        }, e.prototype.isInResult = function() {
            return this._isInResult;
        }, e.prototype.setNext = function(t) {
            this._next = t;
        }, e.prototype.isVisited = function() {
            return this._isVisited;
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e.depthFactor = function(t, e) {
            return t === pl.EXTERIOR && e === pl.INTERIOR ? 1 : t === pl.INTERIOR && e === pl.EXTERIOR ? -1 : 0;
        }, e;
    }(Vh), Yh = function() {};
    Yh.prototype.createNode = function(t) {
        return new Bh(t, null);
    }, Yh.prototype.interfaces_ = function() {
        return [];
    }, Yh.prototype.getClass = function() {
        return Yh;
    };
    var Hh = function() {
        if (this._edges = new lc, this._nodes = null, this._edgeEndList = new lc, 0 === arguments.length) this._nodes = new zh(new Yh);
        else if (1 === arguments.length) {
            var t = arguments[0];
            this._nodes = new zh(t);
        }
    };
    Hh.prototype.printEdges = function(t) {
        t.println("Edges:");
        for(var e = 0; e < this._edges.size(); e++){
            t.println("edge " + e + ":");
            var n = this._edges.get(e);
            n.print(t), n.eiList.print(t);
        }
    }, Hh.prototype.find = function(t) {
        return this._nodes.find(t);
    }, Hh.prototype.addNode = function() {
        if (arguments[0] instanceof Bh) {
            var t = arguments[0];
            return this._nodes.addNode(t);
        }
        if (arguments[0] instanceof ul) {
            var e = arguments[0];
            return this._nodes.addNode(e);
        }
    }, Hh.prototype.getNodeIterator = function() {
        return this._nodes.iterator();
    }, Hh.prototype.linkResultDirectedEdges = function() {
        for(var t = this._nodes.iterator(); t.hasNext();)t.next().getEdges().linkResultDirectedEdges();
    }, Hh.prototype.debugPrintln = function(t) {
        Pl.out.println(t);
    }, Hh.prototype.isBoundaryNode = function(t, e) {
        var n = this._nodes.find(e);
        if (null === n) return !1;
        var r = n.getLabel();
        return null !== r && r.getLocation(t) === pl.BOUNDARY;
    }, Hh.prototype.linkAllDirectedEdges = function() {
        for(var t = this._nodes.iterator(); t.hasNext();)t.next().getEdges().linkAllDirectedEdges();
    }, Hh.prototype.matchInSameDirection = function(t, e, n, r) {
        return !!t.equals(n) && Xl.computeOrientation(t, e, r) === Xl.COLLINEAR && jh.quadrant(t, e) === jh.quadrant(n, r);
    }, Hh.prototype.getEdgeEnds = function() {
        return this._edgeEndList;
    }, Hh.prototype.debugPrint = function(t) {
        Pl.out.print(t);
    }, Hh.prototype.getEdgeIterator = function() {
        return this._edges.iterator();
    }, Hh.prototype.findEdgeInSameDirection = function(t, e) {
        for(var n = this, r = 0; r < this._edges.size(); r++){
            var i = n._edges.get(r), o = i.getCoordinates();
            if (n.matchInSameDirection(t, e, o[0], o[1])) return i;
            if (n.matchInSameDirection(t, e, o[o.length - 1], o[o.length - 2])) return i;
        }
        return null;
    }, Hh.prototype.insertEdge = function(t) {
        this._edges.add(t);
    }, Hh.prototype.findEdgeEnd = function(t) {
        for(var e = this.getEdgeEnds().iterator(); e.hasNext();){
            var n = e.next();
            if (n.getEdge() === t) return n;
        }
        return null;
    }, Hh.prototype.addEdges = function(t) {
        for(var e = this, n = t.iterator(); n.hasNext();){
            var r = n.next();
            e._edges.add(r);
            var i = new Xh(r, !0), o = new Xh(r, !1);
            i.setSym(o), o.setSym(i), e.add(i), e.add(o);
        }
    }, Hh.prototype.add = function(t) {
        this._nodes.add(t), this._edgeEndList.add(t);
    }, Hh.prototype.getNodes = function() {
        return this._nodes.values();
    }, Hh.prototype.findEdge = function(t, e) {
        for(var n = 0; n < this._edges.size(); n++){
            var r = this._edges.get(n), i = r.getCoordinates();
            if (t.equals(i[0]) && e.equals(i[1])) return r;
        }
        return null;
    }, Hh.prototype.interfaces_ = function() {
        return [];
    }, Hh.prototype.getClass = function() {
        return Hh;
    }, Hh.linkResultDirectedEdges = function(t) {
        for(var e = t.iterator(); e.hasNext();)e.next().getEdges().linkResultDirectedEdges();
    };
    var Wh = function() {
        this._geometryFactory = null, this._shellList = new lc;
        var t = arguments[0];
        this._geometryFactory = t;
    };
    Wh.prototype.sortShellsAndHoles = function(t, e, n) {
        for(var r = t.iterator(); r.hasNext();){
            var i = r.next();
            i.isHole() ? n.add(i) : e.add(i);
        }
    }, Wh.prototype.computePolygons = function(t) {
        for(var e = new lc, n = t.iterator(); n.hasNext();){
            var r = n.next().toPolygon(this._geometryFactory);
            e.add(r);
        }
        return e;
    }, Wh.prototype.placeFreeHoles = function(t, e) {
        for(var n = e.iterator(); n.hasNext();){
            var r = n.next();
            if (null === r.getShell()) {
                var i = this.findEdgeRingContaining(r, t);
                if (null === i) throw new Oh("unable to assign hole to a shell", r.getCoordinate(0));
                r.setShell(i);
            }
        }
    }, Wh.prototype.buildMinimalEdgeRings = function(t, e, n) {
        for(var r = new lc, i = t.iterator(); i.hasNext();){
            var o = i.next();
            if (o.getMaxNodeDegree() > 2) {
                o.linkDirectedEdgesForMinimalEdgeRings();
                var s = o.buildMinimalRings(), a = this.findShell(s);
                null !== a ? (this.placePolygonHoles(a, s), e.add(a)) : n.addAll(s);
            } else r.add(o);
        }
        return r;
    }, Wh.prototype.containsPoint = function(t) {
        for(var e = this._shellList.iterator(); e.hasNext();){
            if (e.next().containsPoint(t)) return !0;
        }
        return !1;
    }, Wh.prototype.buildMaximalEdgeRings = function(t) {
        for(var e = new lc, n = t.iterator(); n.hasNext();){
            var r = n.next();
            if (r.isInResult() && r.getLabel().isArea() && null === r.getEdgeRing()) {
                var i = new Gh(r, this._geometryFactory);
                e.add(i), i.setInResult();
            }
        }
        return e;
    }, Wh.prototype.placePolygonHoles = function(t, e) {
        for(var n = e.iterator(); n.hasNext();){
            var r = n.next();
            r.isHole() && r.setShell(t);
        }
    }, Wh.prototype.getPolygons = function() {
        return this.computePolygons(this._shellList);
    }, Wh.prototype.findEdgeRingContaining = function(t, e) {
        for(var n = t.getLinearRing(), r = n.getEnvelopeInternal(), i = n.getCoordinateN(0), o = null, s = null, a = e.iterator(); a.hasNext();){
            var u = a.next(), l = u.getLinearRing(), c = l.getEnvelopeInternal();
            null !== o && (s = o.getLinearRing().getEnvelopeInternal());
            var h = !1;
            c.contains(r) && Xl.isPointInRing(i, l.getCoordinates()) && (h = !0), h && (null === o || s.contains(c)) && (o = u);
        }
        return o;
    }, Wh.prototype.findShell = function(t) {
        for(var e = 0, n = null, r = t.iterator(); r.hasNext();){
            var i = r.next();
            i.isHole() || (n = i, e++);
        }
        return ql.isTrue(e <= 1, "found two shells in MinimalEdgeRing list"), n;
    }, Wh.prototype.add = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.add(t.getEdgeEnds(), t.getNodes());
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            Hh.linkResultDirectedEdges(n);
            var r = this.buildMaximalEdgeRings(e), i = new lc, o = this.buildMinimalEdgeRings(r, this._shellList, i);
            this.sortShellsAndHoles(o, this._shellList, i), this.placeFreeHoles(this._shellList, i);
        }
    }, Wh.prototype.interfaces_ = function() {
        return [];
    }, Wh.prototype.getClass = function() {
        return Wh;
    };
    var Jh = function() {};
    Jh.prototype.getBounds = function() {}, Jh.prototype.interfaces_ = function() {
        return [];
    }, Jh.prototype.getClass = function() {
        return Jh;
    };
    var Zh = function() {
        this._bounds = null, this._item = null;
        var t = arguments[0], e = arguments[1];
        this._bounds = t, this._item = e;
    };
    Zh.prototype.getItem = function() {
        return this._item;
    }, Zh.prototype.getBounds = function() {
        return this._bounds;
    }, Zh.prototype.interfaces_ = function() {
        return [
            Jh,
            al
        ];
    }, Zh.prototype.getClass = function() {
        return Zh;
    };
    var Kh = function() {
        this._size = null, this._items = null, this._size = 0, this._items = new lc, this._items.add(null);
    };
    Kh.prototype.poll = function() {
        if (this.isEmpty()) return null;
        var t = this._items.get(1);
        return this._items.set(1, this._items.get(this._size)), this._size -= 1, this.reorder(1), t;
    }, Kh.prototype.size = function() {
        return this._size;
    }, Kh.prototype.reorder = function(t) {
        for(var e = this, n = null, r = this._items.get(t); 2 * t <= this._size && ((n = 2 * t) !== e._size && e._items.get(n + 1).compareTo(e._items.get(n)) < 0 && n++, e._items.get(n).compareTo(r) < 0); t = n)e._items.set(t, e._items.get(n));
        this._items.set(t, r);
    }, Kh.prototype.clear = function() {
        this._size = 0, this._items.clear();
    }, Kh.prototype.isEmpty = function() {
        return 0 === this._size;
    }, Kh.prototype.add = function(t) {
        this._items.add(null), this._size += 1;
        var e = this._size;
        for(this._items.set(0, t); t.compareTo(this._items.get(Math.trunc(e / 2))) < 0; e /= 2)this._items.set(e, this._items.get(Math.trunc(e / 2)));
        this._items.set(e, t);
    }, Kh.prototype.interfaces_ = function() {
        return [];
    }, Kh.prototype.getClass = function() {
        return Kh;
    };
    var Qh = function() {};
    Qh.prototype.visitItem = function(t) {}, Qh.prototype.interfaces_ = function() {
        return [];
    }, Qh.prototype.getClass = function() {
        return Qh;
    };
    var $h = function() {};
    $h.prototype.insert = function(t, e) {}, $h.prototype.remove = function(t, e) {}, $h.prototype.query = function() {}, $h.prototype.interfaces_ = function() {
        return [];
    }, $h.prototype.getClass = function() {
        return $h;
    };
    var tp = function() {
        if (this._childBoundables = new lc, this._bounds = null, this._level = null, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var t = arguments[0];
            this._level = t;
        }
    }, ep = {
        serialVersionUID: {
            configurable: !0
        }
    };
    tp.prototype.getLevel = function() {
        return this._level;
    }, tp.prototype.size = function() {
        return this._childBoundables.size();
    }, tp.prototype.getChildBoundables = function() {
        return this._childBoundables;
    }, tp.prototype.addChildBoundable = function(t) {
        ql.isTrue(null === this._bounds), this._childBoundables.add(t);
    }, tp.prototype.isEmpty = function() {
        return this._childBoundables.isEmpty();
    }, tp.prototype.getBounds = function() {
        return null === this._bounds && (this._bounds = this.computeBounds()), this._bounds;
    }, tp.prototype.interfaces_ = function() {
        return [
            Jh,
            al
        ];
    }, tp.prototype.getClass = function() {
        return tp;
    }, ep.serialVersionUID.get = function() {
        return 0x5a1e55ec41369800;
    }, Object.defineProperties(tp, ep);
    var np = function() {};
    np.reverseOrder = function() {
        return {
            compare: function(t, e) {
                return e.compareTo(t);
            }
        };
    }, np.min = function(t) {
        return np.sort(t), t.get(0);
    }, np.sort = function(t, e) {
        var n = t.toArray();
        e ? Rc.sort(n, e) : Rc.sort(n);
        for(var r = t.iterator(), i = 0, o = n.length; i < o; i++)r.next(), r.set(n[i]);
    }, np.singletonList = function(t) {
        var e = new lc;
        return e.add(t), e;
    };
    var rp = function() {
        this._boundable1 = null, this._boundable2 = null, this._distance = null, this._itemDistance = null;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        this._boundable1 = t, this._boundable2 = e, this._itemDistance = n, this._distance = this.distance();
    };
    rp.prototype.expandToQueue = function(t, e) {
        var n = rp.isComposite(this._boundable1), r = rp.isComposite(this._boundable2);
        if (n && r) return rp.area(this._boundable1) > rp.area(this._boundable2) ? (this.expand(this._boundable1, this._boundable2, t, e), null) : (this.expand(this._boundable2, this._boundable1, t, e), null);
        if (n) return this.expand(this._boundable1, this._boundable2, t, e), null;
        if (r) return this.expand(this._boundable2, this._boundable1, t, e), null;
        throw new el("neither boundable is composite");
    }, rp.prototype.isLeaves = function() {
        return !(rp.isComposite(this._boundable1) || rp.isComposite(this._boundable2));
    }, rp.prototype.compareTo = function(t) {
        var e = t;
        return this._distance < e._distance ? -1 : this._distance > e._distance ? 1 : 0;
    }, rp.prototype.expand = function(t, e, n, r) {
        for(var i = t.getChildBoundables().iterator(); i.hasNext();){
            var o = i.next(), s = new rp(o, e, this._itemDistance);
            s.getDistance() < r && n.add(s);
        }
    }, rp.prototype.getBoundable = function(t) {
        return 0 === t ? this._boundable1 : this._boundable2;
    }, rp.prototype.getDistance = function() {
        return this._distance;
    }, rp.prototype.distance = function() {
        return this.isLeaves() ? this._itemDistance.distance(this._boundable1, this._boundable2) : this._boundable1.getBounds().distance(this._boundable2.getBounds());
    }, rp.prototype.interfaces_ = function() {
        return [
            il
        ];
    }, rp.prototype.getClass = function() {
        return rp;
    }, rp.area = function(t) {
        return t.getBounds().getArea();
    }, rp.isComposite = function(t) {
        return t instanceof tp;
    };
    var ip = function t() {
        if (this._root = null, this._built = !1, this._itemBoundables = new lc, this._nodeCapacity = null, 0 === arguments.length) {
            var e = t.DEFAULT_NODE_CAPACITY;
            this._nodeCapacity = e;
        } else if (1 === arguments.length) {
            var n = arguments[0];
            ql.isTrue(n > 1, "Node capacity must be greater than 1"), this._nodeCapacity = n;
        }
    }, op = {
        IntersectsOp: {
            configurable: !0
        },
        serialVersionUID: {
            configurable: !0
        },
        DEFAULT_NODE_CAPACITY: {
            configurable: !0
        }
    };
    ip.prototype.getNodeCapacity = function() {
        return this._nodeCapacity;
    }, ip.prototype.lastNode = function(t) {
        return t.get(t.size() - 1);
    }, ip.prototype.size = function() {
        var t = this;
        if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.size(this._root));
        if (1 === arguments.length) {
            for(var e = arguments[0], n = 0, r = e.getChildBoundables().iterator(); r.hasNext();){
                var i = r.next();
                i instanceof tp ? n += t.size(i) : i instanceof Zh && (n += 1);
            }
            return n;
        }
    }, ip.prototype.removeItem = function(t, e) {
        for(var n = null, r = t.getChildBoundables().iterator(); r.hasNext();){
            var i = r.next();
            i instanceof Zh && i.getItem() === e && (n = i);
        }
        return null !== n && (t.getChildBoundables().remove(n), !0);
    }, ip.prototype.itemsTree = function() {
        var t = this;
        if (0 === arguments.length) {
            this.build();
            var e = this.itemsTree(this._root);
            return null === e ? new lc : e;
        }
        if (1 === arguments.length) {
            for(var n = arguments[0], r = new lc, i = n.getChildBoundables().iterator(); i.hasNext();){
                var o = i.next();
                if (o instanceof tp) {
                    var s = t.itemsTree(o);
                    null !== s && r.add(s);
                } else o instanceof Zh ? r.add(o.getItem()) : ql.shouldNeverReachHere();
            }
            return r.size() <= 0 ? null : r;
        }
    }, ip.prototype.insert = function(t, e) {
        ql.isTrue(!this._built, "Cannot insert items into an STR packed R-tree after it has been built."), this._itemBoundables.add(new Zh(t, e));
    }, ip.prototype.boundablesAtLevel = function() {
        var t = this;
        if (1 === arguments.length) {
            var e = arguments[0], n = new lc;
            return this.boundablesAtLevel(e, this._root, n), n;
        }
        if (3 === arguments.length) {
            var r = arguments[0], i = arguments[1], o = arguments[2];
            if (ql.isTrue(r > -2), i.getLevel() === r) return o.add(i), null;
            for(var s = i.getChildBoundables().iterator(); s.hasNext();){
                var a = s.next();
                a instanceof tp ? t.boundablesAtLevel(r, a, o) : (ql.isTrue(a instanceof Zh), -1 === r && o.add(a));
            }
            return null;
        }
    }, ip.prototype.query = function() {
        var t = this;
        if (1 === arguments.length) {
            var e = arguments[0];
            this.build();
            var n = new lc;
            return this.isEmpty() || this.getIntersectsOp().intersects(this._root.getBounds(), e) && this.query(e, this._root, n), n;
        }
        if (2 === arguments.length) {
            var r = arguments[0], i = arguments[1];
            if (this.build(), this.isEmpty()) return null;
            this.getIntersectsOp().intersects(this._root.getBounds(), r) && this.query(r, this._root, i);
        } else if (3 === arguments.length) {
            if (gl(arguments[2], Qh) && arguments[0] instanceof Object && arguments[1] instanceof tp) for(var o = arguments[0], s = arguments[1], a = arguments[2], u = s.getChildBoundables(), l = 0; l < u.size(); l++){
                var c = u.get(l);
                t.getIntersectsOp().intersects(c.getBounds(), o) && (c instanceof tp ? t.query(o, c, a) : c instanceof Zh ? a.visitItem(c.getItem()) : ql.shouldNeverReachHere());
            }
            else if (gl(arguments[2], ac) && arguments[0] instanceof Object && arguments[1] instanceof tp) for(var h = arguments[0], p = arguments[1], f = arguments[2], g = p.getChildBoundables(), d = 0; d < g.size(); d++){
                var y = g.get(d);
                t.getIntersectsOp().intersects(y.getBounds(), h) && (y instanceof tp ? t.query(h, y, f) : y instanceof Zh ? f.add(y.getItem()) : ql.shouldNeverReachHere());
            }
        }
    }, ip.prototype.build = function() {
        if (this._built) return null;
        this._root = this._itemBoundables.isEmpty() ? this.createNode(0) : this.createHigherLevels(this._itemBoundables, -1), this._itemBoundables = null, this._built = !0;
    }, ip.prototype.getRoot = function() {
        return this.build(), this._root;
    }, ip.prototype.remove = function() {
        var t = this;
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return this.build(), !!this.getIntersectsOp().intersects(this._root.getBounds(), e) && this.remove(e, this._root, n);
        }
        if (3 === arguments.length) {
            var r = arguments[0], i = arguments[1], o = arguments[2], s = this.removeItem(i, o);
            if (s) return !0;
            for(var a = null, u = i.getChildBoundables().iterator(); u.hasNext();){
                var l = u.next();
                if (t.getIntersectsOp().intersects(l.getBounds(), r) && l instanceof tp && (s = t.remove(r, l, o))) {
                    a = l;
                    break;
                }
            }
            return null !== a && a.getChildBoundables().isEmpty() && i.getChildBoundables().remove(a), s;
        }
    }, ip.prototype.createHigherLevels = function(t, e) {
        ql.isTrue(!t.isEmpty());
        var n = this.createParentBoundables(t, e + 1);
        return 1 === n.size() ? n.get(0) : this.createHigherLevels(n, e + 1);
    }, ip.prototype.depth = function() {
        var t = this;
        if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.depth(this._root));
        if (1 === arguments.length) {
            for(var e = arguments[0], n = 0, r = e.getChildBoundables().iterator(); r.hasNext();){
                var i = r.next();
                if (i instanceof tp) {
                    var o = t.depth(i);
                    o > n && (n = o);
                }
            }
            return n + 1;
        }
    }, ip.prototype.createParentBoundables = function(t, e) {
        var n = this;
        ql.isTrue(!t.isEmpty());
        var r = new lc;
        r.add(this.createNode(e));
        var i = new lc(t);
        np.sort(i, this.getComparator());
        for(var o = i.iterator(); o.hasNext();){
            var s = o.next();
            n.lastNode(r).getChildBoundables().size() === n.getNodeCapacity() && r.add(n.createNode(e)), n.lastNode(r).addChildBoundable(s);
        }
        return r;
    }, ip.prototype.isEmpty = function() {
        return this._built ? this._root.isEmpty() : this._itemBoundables.isEmpty();
    }, ip.prototype.interfaces_ = function() {
        return [
            al
        ];
    }, ip.prototype.getClass = function() {
        return ip;
    }, ip.compareDoubles = function(t, e) {
        return t > e ? 1 : t < e ? -1 : 0;
    }, op.IntersectsOp.get = function() {
        return sp;
    }, op.serialVersionUID.get = function() {
        return -3886435814360241000;
    }, op.DEFAULT_NODE_CAPACITY.get = function() {
        return 10;
    }, Object.defineProperties(ip, op);
    var sp = function() {}, ap = function() {};
    ap.prototype.distance = function(t, e) {}, ap.prototype.interfaces_ = function() {
        return [];
    }, ap.prototype.getClass = function() {
        return ap;
    };
    var up = function(t) {
        function e(n) {
            n = n || e.DEFAULT_NODE_CAPACITY, t.call(this, n);
        }
        t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
        var n = {
            STRtreeNode: {
                configurable: !0
            },
            serialVersionUID: {
                configurable: !0
            },
            xComparator: {
                configurable: !0
            },
            yComparator: {
                configurable: !0
            },
            intersectsOp: {
                configurable: !0
            },
            DEFAULT_NODE_CAPACITY: {
                configurable: !0
            }
        };
        return e.prototype.createParentBoundablesFromVerticalSlices = function(t, e) {
            ql.isTrue(t.length > 0);
            for(var n = new lc, r = 0; r < t.length; r++)n.addAll(this.createParentBoundablesFromVerticalSlice(t[r], e));
            return n;
        }, e.prototype.createNode = function(t) {
            return new lp(t);
        }, e.prototype.size = function() {
            return 0 === arguments.length ? t.prototype.size.call(this) : t.prototype.size.apply(this, arguments);
        }, e.prototype.insert = function() {
            if (2 !== arguments.length) return t.prototype.insert.apply(this, arguments);
            var e = arguments[0], n = arguments[1];
            if (e.isNull()) return null;
            t.prototype.insert.call(this, e, n);
        }, e.prototype.getIntersectsOp = function() {
            return e.intersectsOp;
        }, e.prototype.verticalSlices = function(t, e) {
            for(var n = Math.trunc(Math.ceil(t.size() / e)), r = new Array(e).fill(null), i = t.iterator(), o = 0; o < e; o++){
                r[o] = new lc;
                for(var s = 0; i.hasNext() && s < n;){
                    var a = i.next();
                    r[o].add(a), s++;
                }
            }
            return r;
        }, e.prototype.query = function() {
            if (1 === arguments.length) {
                var e = arguments[0];
                return t.prototype.query.call(this, e);
            }
            if (2 === arguments.length) {
                var n = arguments[0], r = arguments[1];
                t.prototype.query.call(this, n, r);
            } else if (3 === arguments.length) {
                if (gl(arguments[2], Qh) && arguments[0] instanceof Object && arguments[1] instanceof tp) {
                    var i = arguments[0], o = arguments[1], s = arguments[2];
                    t.prototype.query.call(this, i, o, s);
                } else if (gl(arguments[2], ac) && arguments[0] instanceof Object && arguments[1] instanceof tp) {
                    var a = arguments[0], u = arguments[1], l = arguments[2];
                    t.prototype.query.call(this, a, u, l);
                }
            }
        }, e.prototype.getComparator = function() {
            return e.yComparator;
        }, e.prototype.createParentBoundablesFromVerticalSlice = function(e, n) {
            return t.prototype.createParentBoundables.call(this, e, n);
        }, e.prototype.remove = function() {
            if (2 === arguments.length) {
                var e = arguments[0], n = arguments[1];
                return t.prototype.remove.call(this, e, n);
            }
            return t.prototype.remove.apply(this, arguments);
        }, e.prototype.depth = function() {
            return 0 === arguments.length ? t.prototype.depth.call(this) : t.prototype.depth.apply(this, arguments);
        }, e.prototype.createParentBoundables = function(t, n) {
            ql.isTrue(!t.isEmpty());
            var r = Math.trunc(Math.ceil(t.size() / this.getNodeCapacity())), i = new lc(t);
            np.sort(i, e.xComparator);
            var o = this.verticalSlices(i, Math.trunc(Math.ceil(Math.sqrt(r))));
            return this.createParentBoundablesFromVerticalSlices(o, n);
        }, e.prototype.nearestNeighbour = function() {
            if (1 === arguments.length) {
                if (gl(arguments[0], ap)) {
                    var t = arguments[0], n = new rp(this.getRoot(), this.getRoot(), t);
                    return this.nearestNeighbour(n);
                }
                if (arguments[0] instanceof rp) {
                    var r = arguments[0];
                    return this.nearestNeighbour(r, nl.POSITIVE_INFINITY);
                }
            } else if (2 === arguments.length) {
                if (arguments[0] instanceof e && gl(arguments[1], ap)) {
                    var i = arguments[0], o = arguments[1], s = new rp(this.getRoot(), i.getRoot(), o);
                    return this.nearestNeighbour(s);
                }
                if (arguments[0] instanceof rp && "number" == typeof arguments[1]) {
                    var a = arguments[0], u = arguments[1], l = u, c = null, h = new Kh;
                    for(h.add(a); !h.isEmpty() && l > 0;){
                        var p = h.poll(), f = p.getDistance();
                        if (f >= l) break;
                        p.isLeaves() ? (l = f, c = p) : p.expandToQueue(h, l);
                    }
                    return [
                        c.getBoundable(0).getItem(),
                        c.getBoundable(1).getItem()
                    ];
                }
            } else if (3 === arguments.length) {
                var g = arguments[0], d = arguments[1], y = arguments[2], v = new Zh(g, d), _ = new rp(this.getRoot(), v, y);
                return this.nearestNeighbour(_)[0];
            }
        }, e.prototype.interfaces_ = function() {
            return [
                $h,
                al
            ];
        }, e.prototype.getClass = function() {
            return e;
        }, e.centreX = function(t) {
            return e.avg(t.getMinX(), t.getMaxX());
        }, e.avg = function(t, e) {
            return (t + e) / 2;
        }, e.centreY = function(t) {
            return e.avg(t.getMinY(), t.getMaxY());
        }, n.STRtreeNode.get = function() {
            return lp;
        }, n.serialVersionUID.get = function() {
            return 0x39920f7d5f261e0;
        }, n.xComparator.get = function() {
            return {
                interfaces_: function() {
                    return [
                        sl
                    ];
                },
                compare: function(n, r) {
                    return t.compareDoubles(e.centreX(n.getBounds()), e.centreX(r.getBounds()));
                }
            };
        }, n.yComparator.get = function() {
            return {
                interfaces_: function() {
                    return [
                        sl
                    ];
                },
                compare: function(n, r) {
                    return t.compareDoubles(e.centreY(n.getBounds()), e.centreY(r.getBounds()));
                }
            };
        }, n.intersectsOp.get = function() {
            return {
                interfaces_: function() {
                    return [
                        t.IntersectsOp
                    ];
                },
                intersects: function(t, e) {
                    return t.intersects(e);
                }
            };
        }, n.DEFAULT_NODE_CAPACITY.get = function() {
            return 10;
        }, Object.defineProperties(e, n), e;
    }(ip), lp = function(t) {
        function e() {
            var e = arguments[0];
            t.call(this, e);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.computeBounds = function() {
            for(var t = null, e = this.getChildBoundables().iterator(); e.hasNext();){
                var n = e.next();
                null === t ? t = new Ll(n.getBounds()) : t.expandToInclude(n.getBounds());
            }
            return t;
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(tp), cp = function() {};
    cp.prototype.interfaces_ = function() {
        return [];
    }, cp.prototype.getClass = function() {
        return cp;
    }, cp.relativeSign = function(t, e) {
        return t < e ? -1 : t > e ? 1 : 0;
    }, cp.compare = function(t, e, n) {
        if (e.equals2D(n)) return 0;
        var r = cp.relativeSign(e.x, n.x), i = cp.relativeSign(e.y, n.y);
        switch(t){
            case 0:
                return cp.compareValue(r, i);
            case 1:
                return cp.compareValue(i, r);
            case 2:
                return cp.compareValue(i, -r);
            case 3:
                return cp.compareValue(-r, i);
            case 4:
                return cp.compareValue(-r, -i);
            case 5:
                return cp.compareValue(-i, -r);
            case 6:
                return cp.compareValue(-i, r);
            case 7:
                return cp.compareValue(r, -i);
        }
        return ql.shouldNeverReachHere("invalid octant value"), 0;
    }, cp.compareValue = function(t, e) {
        return t < 0 ? -1 : t > 0 ? 1 : e < 0 ? -1 : e > 0 ? 1 : 0;
    };
    var hp = function() {
        this._segString = null, this.coord = null, this.segmentIndex = null, this._segmentOctant = null, this._isInterior = null;
        var t = arguments[0], e = arguments[1], n = arguments[2], r = arguments[3];
        this._segString = t, this.coord = new ul(e), this.segmentIndex = n, this._segmentOctant = r, this._isInterior = !e.equals2D(t.getCoordinate(n));
    };
    hp.prototype.getCoordinate = function() {
        return this.coord;
    }, hp.prototype.print = function(t) {
        t.print(this.coord), t.print(" seg # = " + this.segmentIndex);
    }, hp.prototype.compareTo = function(t) {
        var e = t;
        return this.segmentIndex < e.segmentIndex ? -1 : this.segmentIndex > e.segmentIndex ? 1 : this.coord.equals2D(e.coord) ? 0 : cp.compare(this._segmentOctant, this.coord, e.coord);
    }, hp.prototype.isEndPoint = function(t) {
        return 0 === this.segmentIndex && !this._isInterior || this.segmentIndex === t;
    }, hp.prototype.isInterior = function() {
        return this._isInterior;
    }, hp.prototype.interfaces_ = function() {
        return [
            il
        ];
    }, hp.prototype.getClass = function() {
        return hp;
    };
    var pp = function() {
        this._nodeMap = new Cc, this._edge = null;
        var t = arguments[0];
        this._edge = t;
    };
    pp.prototype.getSplitCoordinates = function() {
        var t = new hc;
        this.addEndpoints();
        for(var e = this.iterator(), n = e.next(); e.hasNext();){
            var r = e.next();
            this.addEdgeCoordinates(n, r, t), n = r;
        }
        return t.toCoordinateArray();
    }, pp.prototype.addCollapsedNodes = function() {
        var t = new lc;
        this.findCollapsesFromInsertedNodes(t), this.findCollapsesFromExistingVertices(t);
        for(var e = t.iterator(); e.hasNext();){
            var n = e.next().intValue();
            this.add(this._edge.getCoordinate(n), n);
        }
    }, pp.prototype.print = function(t) {
        t.println("Intersections:");
        for(var e = this.iterator(); e.hasNext();)e.next().print(t);
    }, pp.prototype.findCollapsesFromExistingVertices = function(t) {
        for(var e = 0; e < this._edge.size() - 2; e++){
            var n = this._edge.getCoordinate(e), r = this._edge.getCoordinate(e + 2);
            n.equals2D(r) && t.add(new _l(e + 1));
        }
    }, pp.prototype.addEdgeCoordinates = function(t, e, n) {
        var r = this._edge.getCoordinate(e.segmentIndex), i = e.isInterior() || !e.coord.equals2D(r);
        n.add(new ul(t.coord), !1);
        for(var o = t.segmentIndex + 1; o <= e.segmentIndex; o++)n.add(this._edge.getCoordinate(o));
        i && n.add(new ul(e.coord));
    }, pp.prototype.iterator = function() {
        return this._nodeMap.values().iterator();
    }, pp.prototype.addSplitEdges = function(t) {
        this.addEndpoints(), this.addCollapsedNodes();
        for(var e = this.iterator(), n = e.next(); e.hasNext();){
            var r = e.next(), i = this.createSplitEdge(n, r);
            t.add(i), n = r;
        }
    }, pp.prototype.findCollapseIndex = function(t, e, n) {
        if (!t.coord.equals2D(e.coord)) return !1;
        var r = e.segmentIndex - t.segmentIndex;
        return e.isInterior() || r--, 1 === r && (n[0] = t.segmentIndex + 1, !0);
    }, pp.prototype.findCollapsesFromInsertedNodes = function(t) {
        for(var e = new Array(1).fill(null), n = this.iterator(), r = n.next(); n.hasNext();){
            var i = n.next();
            this.findCollapseIndex(r, i, e) && t.add(new _l(e[0])), r = i;
        }
    }, pp.prototype.getEdge = function() {
        return this._edge;
    }, pp.prototype.addEndpoints = function() {
        var t = this._edge.size() - 1;
        this.add(this._edge.getCoordinate(0), 0), this.add(this._edge.getCoordinate(t), t);
    }, pp.prototype.createSplitEdge = function(t, e) {
        var n = e.segmentIndex - t.segmentIndex + 2, r = this._edge.getCoordinate(e.segmentIndex), i = e.isInterior() || !e.coord.equals2D(r);
        i || n--;
        var o = new Array(n).fill(null), s = 0;
        o[s++] = new ul(t.coord);
        for(var a = t.segmentIndex + 1; a <= e.segmentIndex; a++)o[s++] = this._edge.getCoordinate(a);
        return i && (o[s] = new ul(e.coord)), new yp(o, this._edge.getData());
    }, pp.prototype.add = function(t, e) {
        var n = new hp(this._edge, t, e, this._edge.getSegmentOctant(e)), r = this._nodeMap.get(n);
        return null !== r ? (ql.isTrue(r.coord.equals2D(t), "Found equal nodes with different coordinates"), r) : (this._nodeMap.put(n, n), n);
    }, pp.prototype.checkSplitEdgesCorrectness = function(t) {
        var e = this._edge.getCoordinates(), n = t.get(0).getCoordinate(0);
        if (!n.equals2D(e[0])) throw new kl("bad split edge start point at " + n);
        var r = t.get(t.size() - 1).getCoordinates(), i = r[r.length - 1];
        if (!i.equals2D(e[e.length - 1])) throw new kl("bad split edge end point at " + i);
    }, pp.prototype.interfaces_ = function() {
        return [];
    }, pp.prototype.getClass = function() {
        return pp;
    };
    var fp = function() {};
    fp.prototype.interfaces_ = function() {
        return [];
    }, fp.prototype.getClass = function() {
        return fp;
    }, fp.octant = function() {
        if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
            var t = arguments[0], e = arguments[1];
            if (0 === t && 0 === e) throw new el("Cannot compute the octant for point ( " + t + ", " + e + " )");
            var n = Math.abs(t), r = Math.abs(e);
            return t >= 0 ? e >= 0 ? n >= r ? 0 : 1 : n >= r ? 7 : 6 : e >= 0 ? n >= r ? 3 : 2 : n >= r ? 4 : 5;
        }
        if (arguments[0] instanceof ul && arguments[1] instanceof ul) {
            var i = arguments[0], o = arguments[1], s = o.x - i.x, a = o.y - i.y;
            if (0 === s && 0 === a) throw new el("Cannot compute the octant for two identical points " + i);
            return fp.octant(s, a);
        }
    };
    var gp = function() {};
    gp.prototype.getCoordinates = function() {}, gp.prototype.size = function() {}, gp.prototype.getCoordinate = function(t) {}, gp.prototype.isClosed = function() {}, gp.prototype.setData = function(t) {}, gp.prototype.getData = function() {}, gp.prototype.interfaces_ = function() {
        return [];
    }, gp.prototype.getClass = function() {
        return gp;
    };
    var dp = function() {};
    dp.prototype.addIntersection = function(t, e) {}, dp.prototype.interfaces_ = function() {
        return [
            gp
        ];
    }, dp.prototype.getClass = function() {
        return dp;
    };
    var yp = function() {
        this._nodeList = new pp(this), this._pts = null, this._data = null;
        var t = arguments[0], e = arguments[1];
        this._pts = t, this._data = e;
    };
    yp.prototype.getCoordinates = function() {
        return this._pts;
    }, yp.prototype.size = function() {
        return this._pts.length;
    }, yp.prototype.getCoordinate = function(t) {
        return this._pts[t];
    }, yp.prototype.isClosed = function() {
        return this._pts[0].equals(this._pts[this._pts.length - 1]);
    }, yp.prototype.getSegmentOctant = function(t) {
        return t === this._pts.length - 1 ? -1 : this.safeOctant(this.getCoordinate(t), this.getCoordinate(t + 1));
    }, yp.prototype.setData = function(t) {
        this._data = t;
    }, yp.prototype.safeOctant = function(t, e) {
        return t.equals2D(e) ? 0 : fp.octant(t, e);
    }, yp.prototype.getData = function() {
        return this._data;
    }, yp.prototype.addIntersection = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this.addIntersectionNode(t, e);
        } else if (4 === arguments.length) {
            var n = arguments[0], r = arguments[1], i = arguments[3], o = new ul(n.getIntersection(i));
            this.addIntersection(o, r);
        }
    }, yp.prototype.toString = function() {
        return Fl.toLineString(new lh(this._pts));
    }, yp.prototype.getNodeList = function() {
        return this._nodeList;
    }, yp.prototype.addIntersectionNode = function(t, e) {
        var n = e, r = n + 1;
        if (r < this._pts.length) {
            var i = this._pts[r];
            t.equals2D(i) && (n = r);
        }
        return this._nodeList.add(t, n);
    }, yp.prototype.addIntersections = function(t, e, n) {
        for(var r = 0; r < t.getIntersectionNum(); r++)this.addIntersection(t, e, n, r);
    }, yp.prototype.interfaces_ = function() {
        return [
            dp
        ];
    }, yp.prototype.getClass = function() {
        return yp;
    }, yp.getNodedSubstrings = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = new lc;
            return yp.getNodedSubstrings(t, e), e;
        }
        if (2 === arguments.length) for(var n = arguments[0], r = arguments[1], i = n.iterator(); i.hasNext();){
            var o = i.next();
            o.getNodeList().addSplitEdges(r);
        }
    };
    var vp = function() {
        if (this.p0 = null, this.p1 = null, 0 === arguments.length) this.p0 = new ul, this.p1 = new ul;
        else if (1 === arguments.length) {
            var t = arguments[0];
            this.p0 = new ul(t.p0), this.p1 = new ul(t.p1);
        } else if (2 === arguments.length) this.p0 = arguments[0], this.p1 = arguments[1];
        else if (4 === arguments.length) {
            var e = arguments[0], n = arguments[1], r = arguments[2], i = arguments[3];
            this.p0 = new ul(e, n), this.p1 = new ul(r, i);
        }
    }, _p = {
        serialVersionUID: {
            configurable: !0
        }
    };
    vp.prototype.minX = function() {
        return Math.min(this.p0.x, this.p1.x);
    }, vp.prototype.orientationIndex = function() {
        if (arguments[0] instanceof vp) {
            var t = arguments[0], e = Xl.orientationIndex(this.p0, this.p1, t.p0), n = Xl.orientationIndex(this.p0, this.p1, t.p1);
            return e >= 0 && n >= 0 || e <= 0 && n <= 0 ? Math.max(e, n) : 0;
        }
        if (arguments[0] instanceof ul) {
            var r = arguments[0];
            return Xl.orientationIndex(this.p0, this.p1, r);
        }
    }, vp.prototype.toGeometry = function(t) {
        return t.createLineString([
            this.p0,
            this.p1
        ]);
    }, vp.prototype.isVertical = function() {
        return this.p0.x === this.p1.x;
    }, vp.prototype.equals = function(t) {
        if (!(t instanceof vp)) return !1;
        var e = t;
        return this.p0.equals(e.p0) && this.p1.equals(e.p1);
    }, vp.prototype.intersection = function(t) {
        var e = new jl;
        return e.computeIntersection(this.p0, this.p1, t.p0, t.p1), e.hasIntersection() ? e.getIntersection(0) : null;
    }, vp.prototype.project = function() {
        if (arguments[0] instanceof ul) {
            var t = arguments[0];
            if (t.equals(this.p0) || t.equals(this.p1)) return new ul(t);
            var e = this.projectionFactor(t), n = new ul;
            return n.x = this.p0.x + e * (this.p1.x - this.p0.x), n.y = this.p0.y + e * (this.p1.y - this.p0.y), n;
        }
        if (arguments[0] instanceof vp) {
            var r = arguments[0], i = this.projectionFactor(r.p0), o = this.projectionFactor(r.p1);
            if (i >= 1 && o >= 1) return null;
            if (i <= 0 && o <= 0) return null;
            var s = this.project(r.p0);
            i < 0 && (s = this.p0), i > 1 && (s = this.p1);
            var a = this.project(r.p1);
            return o < 0 && (a = this.p0), o > 1 && (a = this.p1), new vp(s, a);
        }
    }, vp.prototype.normalize = function() {
        this.p1.compareTo(this.p0) < 0 && this.reverse();
    }, vp.prototype.angle = function() {
        return Math.atan2(this.p1.y - this.p0.y, this.p1.x - this.p0.x);
    }, vp.prototype.getCoordinate = function(t) {
        return 0 === t ? this.p0 : this.p1;
    }, vp.prototype.distancePerpendicular = function(t) {
        return Xl.distancePointLinePerpendicular(t, this.p0, this.p1);
    }, vp.prototype.minY = function() {
        return Math.min(this.p0.y, this.p1.y);
    }, vp.prototype.midPoint = function() {
        return vp.midPoint(this.p0, this.p1);
    }, vp.prototype.projectionFactor = function(t) {
        if (t.equals(this.p0)) return 0;
        if (t.equals(this.p1)) return 1;
        var e = this.p1.x - this.p0.x, n = this.p1.y - this.p0.y, r = e * e + n * n;
        return r <= 0 ? nl.NaN : ((t.x - this.p0.x) * e + (t.y - this.p0.y) * n) / r;
    }, vp.prototype.closestPoints = function(t) {
        var e = this.intersection(t);
        if (null !== e) return [
            e,
            e
        ];
        var n = new Array(2).fill(null), r = nl.MAX_VALUE, i = null, o = this.closestPoint(t.p0);
        r = o.distance(t.p0), n[0] = o, n[1] = t.p0;
        var s = this.closestPoint(t.p1);
        (i = s.distance(t.p1)) < r && (r = i, n[0] = s, n[1] = t.p1);
        var a = t.closestPoint(this.p0);
        (i = a.distance(this.p0)) < r && (r = i, n[0] = this.p0, n[1] = a);
        var u = t.closestPoint(this.p1);
        return (i = u.distance(this.p1)) < r && (r = i, n[0] = this.p1, n[1] = u), n;
    }, vp.prototype.closestPoint = function(t) {
        var e = this.projectionFactor(t);
        return e > 0 && e < 1 ? this.project(t) : this.p0.distance(t) < this.p1.distance(t) ? this.p0 : this.p1;
    }, vp.prototype.maxX = function() {
        return Math.max(this.p0.x, this.p1.x);
    }, vp.prototype.getLength = function() {
        return this.p0.distance(this.p1);
    }, vp.prototype.compareTo = function(t) {
        var e = t, n = this.p0.compareTo(e.p0);
        return 0 !== n ? n : this.p1.compareTo(e.p1);
    }, vp.prototype.reverse = function() {
        var t = this.p0;
        this.p0 = this.p1, this.p1 = t;
    }, vp.prototype.equalsTopo = function(t) {
        return this.p0.equals(t.p0) && (this.p1.equals(t.p1) || this.p0.equals(t.p1)) && this.p1.equals(t.p0);
    }, vp.prototype.lineIntersection = function(t) {
        try {
            return Ml.intersection(this.p0, this.p1, t.p0, t.p1);
        } catch (t) {
            if (!(t instanceof Cl)) throw t;
        }
        return null;
    }, vp.prototype.maxY = function() {
        return Math.max(this.p0.y, this.p1.y);
    }, vp.prototype.pointAlongOffset = function(t, e) {
        var n = this.p0.x + t * (this.p1.x - this.p0.x), r = this.p0.y + t * (this.p1.y - this.p0.y), i = this.p1.x - this.p0.x, o = this.p1.y - this.p0.y, s = Math.sqrt(i * i + o * o), a = 0, u = 0;
        if (0 !== e) {
            if (s <= 0) throw new Error("Cannot compute offset from zero-length line segment");
            a = e * i / s, u = e * o / s;
        }
        return new ul(n - u, r + a);
    }, vp.prototype.setCoordinates = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setCoordinates(t.p0, t.p1);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this.p0.x = e.x, this.p0.y = e.y, this.p1.x = n.x, this.p1.y = n.y;
        }
    }, vp.prototype.segmentFraction = function(t) {
        var e = this.projectionFactor(t);
        return e < 0 ? e = 0 : (e > 1 || nl.isNaN(e)) && (e = 1), e;
    }, vp.prototype.toString = function() {
        return "LINESTRING( " + this.p0.x + " " + this.p0.y + ", " + this.p1.x + " " + this.p1.y + ")";
    }, vp.prototype.isHorizontal = function() {
        return this.p0.y === this.p1.y;
    }, vp.prototype.distance = function() {
        if (arguments[0] instanceof vp) {
            var t = arguments[0];
            return Xl.distanceLineLine(this.p0, this.p1, t.p0, t.p1);
        }
        if (arguments[0] instanceof ul) {
            var e = arguments[0];
            return Xl.distancePointLine(e, this.p0, this.p1);
        }
    }, vp.prototype.pointAlong = function(t) {
        var e = new ul;
        return e.x = this.p0.x + t * (this.p1.x - this.p0.x), e.y = this.p0.y + t * (this.p1.y - this.p0.y), e;
    }, vp.prototype.hashCode = function() {
        var t = nl.doubleToLongBits(this.p0.x);
        t ^= 31 * nl.doubleToLongBits(this.p0.y);
        var e = Math.trunc(t) ^ Math.trunc(t >> 32), n = nl.doubleToLongBits(this.p1.x);
        return n ^= 31 * nl.doubleToLongBits(this.p1.y), e ^ (Math.trunc(n) ^ Math.trunc(n >> 32));
    }, vp.prototype.interfaces_ = function() {
        return [
            il,
            al
        ];
    }, vp.prototype.getClass = function() {
        return vp;
    }, vp.midPoint = function(t, e) {
        return new ul((t.x + e.x) / 2, (t.y + e.y) / 2);
    }, _p.serialVersionUID.get = function() {
        return 0x2d2172135f411c00;
    }, Object.defineProperties(vp, _p);
    var mp = function() {
        this.tempEnv1 = new Ll, this.tempEnv2 = new Ll, this._overlapSeg1 = new vp, this._overlapSeg2 = new vp;
    };
    mp.prototype.overlap = function() {
        if (2 === arguments.length) ;
        else if (4 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = arguments[2], r = arguments[3];
            t.getLineSegment(e, this._overlapSeg1), n.getLineSegment(r, this._overlapSeg2), this.overlap(this._overlapSeg1, this._overlapSeg2);
        }
    }, mp.prototype.interfaces_ = function() {
        return [];
    }, mp.prototype.getClass = function() {
        return mp;
    };
    var xp = function() {
        this._pts = null, this._start = null, this._end = null, this._env = null, this._context = null, this._id = null;
        var t = arguments[0], e = arguments[1], n = arguments[2], r = arguments[3];
        this._pts = t, this._start = e, this._end = n, this._context = r;
    };
    xp.prototype.getLineSegment = function(t, e) {
        e.p0 = this._pts[t], e.p1 = this._pts[t + 1];
    }, xp.prototype.computeSelect = function(t, e, n, r) {
        var i = this._pts[e], o = this._pts[n];
        if (r.tempEnv1.init(i, o), n - e == 1) return r.select(this, e), null;
        if (!t.intersects(r.tempEnv1)) return null;
        var s = Math.trunc((e + n) / 2);
        e < s && this.computeSelect(t, e, s, r), s < n && this.computeSelect(t, s, n, r);
    }, xp.prototype.getCoordinates = function() {
        for(var t = new Array(this._end - this._start + 1).fill(null), e = 0, n = this._start; n <= this._end; n++)t[e++] = this._pts[n];
        return t;
    }, xp.prototype.computeOverlaps = function(t, e) {
        this.computeOverlapsInternal(this._start, this._end, t, t._start, t._end, e);
    }, xp.prototype.setId = function(t) {
        this._id = t;
    }, xp.prototype.select = function(t, e) {
        this.computeSelect(t, this._start, this._end, e);
    }, xp.prototype.getEnvelope = function() {
        if (null === this._env) {
            var t = this._pts[this._start], e = this._pts[this._end];
            this._env = new Ll(t, e);
        }
        return this._env;
    }, xp.prototype.getEndIndex = function() {
        return this._end;
    }, xp.prototype.getStartIndex = function() {
        return this._start;
    }, xp.prototype.getContext = function() {
        return this._context;
    }, xp.prototype.getId = function() {
        return this._id;
    }, xp.prototype.computeOverlapsInternal = function(t, e, n, r, i, o) {
        var s = this._pts[t], a = this._pts[e], u = n._pts[r], l = n._pts[i];
        if (e - t == 1 && i - r == 1) return o.overlap(this, t, n, r), null;
        if (o.tempEnv1.init(s, a), o.tempEnv2.init(u, l), !o.tempEnv1.intersects(o.tempEnv2)) return null;
        var c = Math.trunc((t + e) / 2), h = Math.trunc((r + i) / 2);
        t < c && (r < h && this.computeOverlapsInternal(t, c, n, r, h, o), h < i && this.computeOverlapsInternal(t, c, n, h, i, o)), c < e && (r < h && this.computeOverlapsInternal(c, e, n, r, h, o), h < i && this.computeOverlapsInternal(c, e, n, h, i, o));
    }, xp.prototype.interfaces_ = function() {
        return [];
    }, xp.prototype.getClass = function() {
        return xp;
    };
    var Ep = function() {};
    Ep.prototype.interfaces_ = function() {
        return [];
    }, Ep.prototype.getClass = function() {
        return Ep;
    }, Ep.getChainStartIndices = function(t) {
        var e = 0, n = new lc;
        n.add(new _l(e));
        do {
            var r = Ep.findChainEnd(t, e);
            n.add(new _l(r)), e = r;
        }while (e < t.length - 1);
        return Ep.toIntArray(n);
    }, Ep.findChainEnd = function(t, e) {
        for(var n = e; n < t.length - 1 && t[n].equals2D(t[n + 1]);)n++;
        if (n >= t.length - 1) return t.length - 1;
        for(var r = jh.quadrant(t[n], t[n + 1]), i = e + 1; i < t.length;){
            if (!t[i - 1].equals2D(t[i])) {
                if (jh.quadrant(t[i - 1], t[i]) !== r) break;
            }
            i++;
        }
        return i - 1;
    }, Ep.getChains = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return Ep.getChains(t, null);
        }
        if (2 === arguments.length) {
            for(var e = arguments[0], n = arguments[1], r = new lc, i = Ep.getChainStartIndices(e), o = 0; o < i.length - 1; o++){
                var s = new xp(e, i[o], i[o + 1], n);
                r.add(s);
            }
            return r;
        }
    }, Ep.toIntArray = function(t) {
        for(var e = new Array(t.size()).fill(null), n = 0; n < e.length; n++)e[n] = t.get(n).intValue();
        return e;
    };
    var bp = function() {};
    bp.prototype.computeNodes = function(t) {}, bp.prototype.getNodedSubstrings = function() {}, bp.prototype.interfaces_ = function() {
        return [];
    }, bp.prototype.getClass = function() {
        return bp;
    };
    var wp = function() {
        if (this._segInt = null, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var t = arguments[0];
            this.setSegmentIntersector(t);
        }
    };
    wp.prototype.setSegmentIntersector = function(t) {
        this._segInt = t;
    }, wp.prototype.interfaces_ = function() {
        return [
            bp
        ];
    }, wp.prototype.getClass = function() {
        return wp;
    };
    var Ip = function(t) {
        function e(e) {
            e ? t.call(this, e) : t.call(this), this._monoChains = new lc, this._index = new up, this._idCounter = 0, this._nodedSegStrings = null, this._nOverlaps = 0;
        }
        t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
        var n = {
            SegmentOverlapAction: {
                configurable: !0
            }
        };
        return e.prototype.getMonotoneChains = function() {
            return this._monoChains;
        }, e.prototype.getNodedSubstrings = function() {
            return yp.getNodedSubstrings(this._nodedSegStrings);
        }, e.prototype.getIndex = function() {
            return this._index;
        }, e.prototype.add = function(t) {
            for(var e = this, n = Ep.getChains(t.getCoordinates(), t).iterator(); n.hasNext();){
                var r = n.next();
                r.setId(e._idCounter++), e._index.insert(r.getEnvelope(), r), e._monoChains.add(r);
            }
        }, e.prototype.computeNodes = function(t) {
            this._nodedSegStrings = t;
            for(var e = t.iterator(); e.hasNext();)this.add(e.next());
            this.intersectChains();
        }, e.prototype.intersectChains = function() {
            for(var t = this, e = new Np(this._segInt), n = this._monoChains.iterator(); n.hasNext();)for(var r = n.next(), i = t._index.query(r.getEnvelope()).iterator(); i.hasNext();){
                var o = i.next();
                if (o.getId() > r.getId() && (r.computeOverlaps(o, e), t._nOverlaps++), t._segInt.isDone()) return null;
            }
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, n.SegmentOverlapAction.get = function() {
            return Np;
        }, Object.defineProperties(e, n), e;
    }(wp), Np = function(t) {
        function e() {
            t.call(this), this._si = null;
            var e = arguments[0];
            this._si = e;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.overlap = function() {
            if (4 !== arguments.length) return t.prototype.overlap.apply(this, arguments);
            var e = arguments[0], n = arguments[1], r = arguments[2], i = arguments[3], o = e.getContext(), s = r.getContext();
            this._si.processIntersections(o, n, s, i);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(mp), Sp = function t() {
        if (this._quadrantSegments = t.DEFAULT_QUADRANT_SEGMENTS, this._endCapStyle = t.CAP_ROUND, this._joinStyle = t.JOIN_ROUND, this._mitreLimit = t.DEFAULT_MITRE_LIMIT, this._isSingleSided = !1, this._simplifyFactor = t.DEFAULT_SIMPLIFY_FACTOR, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var e = arguments[0];
            this.setQuadrantSegments(e);
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1];
            this.setQuadrantSegments(n), this.setEndCapStyle(r);
        } else if (4 === arguments.length) {
            var i = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3];
            this.setQuadrantSegments(i), this.setEndCapStyle(o), this.setJoinStyle(s), this.setMitreLimit(a);
        }
    }, Cp = {
        CAP_ROUND: {
            configurable: !0
        },
        CAP_FLAT: {
            configurable: !0
        },
        CAP_SQUARE: {
            configurable: !0
        },
        JOIN_ROUND: {
            configurable: !0
        },
        JOIN_MITRE: {
            configurable: !0
        },
        JOIN_BEVEL: {
            configurable: !0
        },
        DEFAULT_QUADRANT_SEGMENTS: {
            configurable: !0
        },
        DEFAULT_MITRE_LIMIT: {
            configurable: !0
        },
        DEFAULT_SIMPLIFY_FACTOR: {
            configurable: !0
        }
    };
    Sp.prototype.getEndCapStyle = function() {
        return this._endCapStyle;
    }, Sp.prototype.isSingleSided = function() {
        return this._isSingleSided;
    }, Sp.prototype.setQuadrantSegments = function(t) {
        this._quadrantSegments = t, 0 === this._quadrantSegments && (this._joinStyle = Sp.JOIN_BEVEL), this._quadrantSegments < 0 && (this._joinStyle = Sp.JOIN_MITRE, this._mitreLimit = Math.abs(this._quadrantSegments)), t <= 0 && (this._quadrantSegments = 1), this._joinStyle !== Sp.JOIN_ROUND && (this._quadrantSegments = Sp.DEFAULT_QUADRANT_SEGMENTS);
    }, Sp.prototype.getJoinStyle = function() {
        return this._joinStyle;
    }, Sp.prototype.setJoinStyle = function(t) {
        this._joinStyle = t;
    }, Sp.prototype.setSimplifyFactor = function(t) {
        this._simplifyFactor = t < 0 ? 0 : t;
    }, Sp.prototype.getSimplifyFactor = function() {
        return this._simplifyFactor;
    }, Sp.prototype.getQuadrantSegments = function() {
        return this._quadrantSegments;
    }, Sp.prototype.setEndCapStyle = function(t) {
        this._endCapStyle = t;
    }, Sp.prototype.getMitreLimit = function() {
        return this._mitreLimit;
    }, Sp.prototype.setMitreLimit = function(t) {
        this._mitreLimit = t;
    }, Sp.prototype.setSingleSided = function(t) {
        this._isSingleSided = t;
    }, Sp.prototype.interfaces_ = function() {
        return [];
    }, Sp.prototype.getClass = function() {
        return Sp;
    }, Sp.bufferDistanceError = function(t) {
        var e = Math.PI / 2 / t;
        return 1 - Math.cos(e / 2);
    }, Cp.CAP_ROUND.get = function() {
        return 1;
    }, Cp.CAP_FLAT.get = function() {
        return 2;
    }, Cp.CAP_SQUARE.get = function() {
        return 3;
    }, Cp.JOIN_ROUND.get = function() {
        return 1;
    }, Cp.JOIN_MITRE.get = function() {
        return 2;
    }, Cp.JOIN_BEVEL.get = function() {
        return 3;
    }, Cp.DEFAULT_QUADRANT_SEGMENTS.get = function() {
        return 8;
    }, Cp.DEFAULT_MITRE_LIMIT.get = function() {
        return 5;
    }, Cp.DEFAULT_SIMPLIFY_FACTOR.get = function() {
        return .01;
    }, Object.defineProperties(Sp, Cp);
    var Pp = function(t) {
        this._distanceTol = null, this._isDeleted = null, this._angleOrientation = Xl.COUNTERCLOCKWISE, this._inputLine = t || null;
    }, Mp = {
        INIT: {
            configurable: !0
        },
        DELETE: {
            configurable: !0
        },
        KEEP: {
            configurable: !0
        },
        NUM_PTS_TO_CHECK: {
            configurable: !0
        }
    };
    Pp.prototype.isDeletable = function(t, e, n, r) {
        var i = this._inputLine[t], o = this._inputLine[e], s = this._inputLine[n];
        return !!this.isConcave(i, o, s) && !!this.isShallow(i, o, s, r) && this.isShallowSampled(i, o, t, n, r);
    }, Pp.prototype.deleteShallowConcavities = function() {
        for(var t = this, e = 1, n = this.findNextNonDeletedIndex(e), r = this.findNextNonDeletedIndex(n), i = !1; r < this._inputLine.length;){
            var o = !1;
            t.isDeletable(e, n, r, t._distanceTol) && (t._isDeleted[n] = Pp.DELETE, o = !0, i = !0), e = o ? r : n, n = t.findNextNonDeletedIndex(e), r = t.findNextNonDeletedIndex(n);
        }
        return i;
    }, Pp.prototype.isShallowConcavity = function(t, e, n, r) {
        return Xl.computeOrientation(t, e, n) === this._angleOrientation && Xl.distancePointLine(e, t, n) < r;
    }, Pp.prototype.isShallowSampled = function(t, e, n, r, i) {
        var o = Math.trunc((r - n) / Pp.NUM_PTS_TO_CHECK);
        o <= 0 && (o = 1);
        for(var s = n; s < r; s += o)if (!this.isShallow(t, e, this._inputLine[s], i)) return !1;
        return !0;
    }, Pp.prototype.isConcave = function(t, e, n) {
        var r = Xl.computeOrientation(t, e, n) === this._angleOrientation;
        return r;
    }, Pp.prototype.simplify = function(t) {
        this._distanceTol = Math.abs(t), t < 0 && (this._angleOrientation = Xl.CLOCKWISE), this._isDeleted = new Array(this._inputLine.length).fill(null);
        var e = !1;
        do e = this.deleteShallowConcavities();
        while (e);
        return this.collapseLine();
    }, Pp.prototype.findNextNonDeletedIndex = function(t) {
        for(var e = t + 1; e < this._inputLine.length && this._isDeleted[e] === Pp.DELETE;)e++;
        return e;
    }, Pp.prototype.isShallow = function(t, e, n, r) {
        return Xl.distancePointLine(e, t, n) < r;
    }, Pp.prototype.collapseLine = function() {
        for(var t = new hc, e = 0; e < this._inputLine.length; e++)this._isDeleted[e] !== Pp.DELETE && t.add(this._inputLine[e]);
        return t.toCoordinateArray();
    }, Pp.prototype.interfaces_ = function() {
        return [];
    }, Pp.prototype.getClass = function() {
        return Pp;
    }, Pp.simplify = function(t, e) {
        return new Pp(t).simplify(e);
    }, Mp.INIT.get = function() {
        return 0;
    }, Mp.DELETE.get = function() {
        return 1;
    }, Mp.KEEP.get = function() {
        return 1;
    }, Mp.NUM_PTS_TO_CHECK.get = function() {
        return 10;
    }, Object.defineProperties(Pp, Mp);
    var Lp = function() {
        this._ptList = null, this._precisionModel = null, this._minimimVertexDistance = 0, this._ptList = new lc;
    }, Op = {
        COORDINATE_ARRAY_TYPE: {
            configurable: !0
        }
    };
    Lp.prototype.getCoordinates = function() {
        return this._ptList.toArray(Lp.COORDINATE_ARRAY_TYPE);
    }, Lp.prototype.setPrecisionModel = function(t) {
        this._precisionModel = t;
    }, Lp.prototype.addPt = function(t) {
        var e = new ul(t);
        if (this._precisionModel.makePrecise(e), this.isRedundant(e)) return null;
        this._ptList.add(e);
    }, Lp.prototype.revere = function() {}, Lp.prototype.addPts = function(t, e) {
        if (e) for(var n = 0; n < t.length; n++)this.addPt(t[n]);
        else for(var r = t.length - 1; r >= 0; r--)this.addPt(t[r]);
    }, Lp.prototype.isRedundant = function(t) {
        if (this._ptList.size() < 1) return !1;
        var e = this._ptList.get(this._ptList.size() - 1);
        return t.distance(e) < this._minimimVertexDistance;
    }, Lp.prototype.toString = function() {
        return (new _h).createLineString(this.getCoordinates()).toString();
    }, Lp.prototype.closeRing = function() {
        if (this._ptList.size() < 1) return null;
        var t = new ul(this._ptList.get(0)), e = this._ptList.get(this._ptList.size() - 1);
        if (t.equals(e)) return null;
        this._ptList.add(t);
    }, Lp.prototype.setMinimumVertexDistance = function(t) {
        this._minimimVertexDistance = t;
    }, Lp.prototype.interfaces_ = function() {
        return [];
    }, Lp.prototype.getClass = function() {
        return Lp;
    }, Op.COORDINATE_ARRAY_TYPE.get = function() {
        return new Array(0).fill(null);
    }, Object.defineProperties(Lp, Op);
    var Rp = function() {}, Tp = {
        PI_TIMES_2: {
            configurable: !0
        },
        PI_OVER_2: {
            configurable: !0
        },
        PI_OVER_4: {
            configurable: !0
        },
        COUNTERCLOCKWISE: {
            configurable: !0
        },
        CLOCKWISE: {
            configurable: !0
        },
        NONE: {
            configurable: !0
        }
    };
    Rp.prototype.interfaces_ = function() {
        return [];
    }, Rp.prototype.getClass = function() {
        return Rp;
    }, Rp.toDegrees = function(t) {
        return 180 * t / Math.PI;
    }, Rp.normalize = function(t) {
        for(; t > Math.PI;)t -= Rp.PI_TIMES_2;
        for(; t <= -Math.PI;)t += Rp.PI_TIMES_2;
        return t;
    }, Rp.angle = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return Math.atan2(t.y, t.x);
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1], r = n.x - e.x, i = n.y - e.y;
            return Math.atan2(i, r);
        }
    }, Rp.isAcute = function(t, e, n) {
        var r = t.x - e.x, i = t.y - e.y;
        return r * (n.x - e.x) + i * (n.y - e.y) > 0;
    }, Rp.isObtuse = function(t, e, n) {
        var r = t.x - e.x, i = t.y - e.y;
        return r * (n.x - e.x) + i * (n.y - e.y) < 0;
    }, Rp.interiorAngle = function(t, e, n) {
        var r = Rp.angle(e, t), i = Rp.angle(e, n);
        return Math.abs(i - r);
    }, Rp.normalizePositive = function(t) {
        if (t < 0) {
            for(; t < 0;)t += Rp.PI_TIMES_2;
            t >= Rp.PI_TIMES_2 && (t = 0);
        } else {
            for(; t >= Rp.PI_TIMES_2;)t -= Rp.PI_TIMES_2;
            t < 0 && (t = 0);
        }
        return t;
    }, Rp.angleBetween = function(t, e, n) {
        var r = Rp.angle(e, t), i = Rp.angle(e, n);
        return Rp.diff(r, i);
    }, Rp.diff = function(t, e) {
        var n = null;
        return (n = t < e ? e - t : t - e) > Math.PI && (n = 2 * Math.PI - n), n;
    }, Rp.toRadians = function(t) {
        return t * Math.PI / 180;
    }, Rp.getTurn = function(t, e) {
        var n = Math.sin(e - t);
        return n > 0 ? Rp.COUNTERCLOCKWISE : n < 0 ? Rp.CLOCKWISE : Rp.NONE;
    }, Rp.angleBetweenOriented = function(t, e, n) {
        var r = Rp.angle(e, t), i = Rp.angle(e, n) - r;
        return i <= -Math.PI ? i + Rp.PI_TIMES_2 : i > Math.PI ? i - Rp.PI_TIMES_2 : i;
    }, Tp.PI_TIMES_2.get = function() {
        return 2 * Math.PI;
    }, Tp.PI_OVER_2.get = function() {
        return Math.PI / 2;
    }, Tp.PI_OVER_4.get = function() {
        return Math.PI / 4;
    }, Tp.COUNTERCLOCKWISE.get = function() {
        return Xl.COUNTERCLOCKWISE;
    }, Tp.CLOCKWISE.get = function() {
        return Xl.CLOCKWISE;
    }, Tp.NONE.get = function() {
        return Xl.COLLINEAR;
    }, Object.defineProperties(Rp, Tp);
    var Ap = function t() {
        this._maxCurveSegmentError = 0, this._filletAngleQuantum = null, this._closingSegLengthFactor = 1, this._segList = null, this._distance = 0, this._precisionModel = null, this._bufParams = null, this._li = null, this._s0 = null, this._s1 = null, this._s2 = null, this._seg0 = new vp, this._seg1 = new vp, this._offset0 = new vp, this._offset1 = new vp, this._side = 0, this._hasNarrowConcaveAngle = !1;
        var e = arguments[0], n = arguments[1], r = arguments[2];
        this._precisionModel = e, this._bufParams = n, this._li = new jl, this._filletAngleQuantum = Math.PI / 2 / n.getQuadrantSegments(), n.getQuadrantSegments() >= 8 && n.getJoinStyle() === Sp.JOIN_ROUND && (this._closingSegLengthFactor = t.MAX_CLOSING_SEG_LEN_FACTOR), this.init(r);
    }, Dp = {
        OFFSET_SEGMENT_SEPARATION_FACTOR: {
            configurable: !0
        },
        INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR: {
            configurable: !0
        },
        CURVE_VERTEX_SNAP_DISTANCE_FACTOR: {
            configurable: !0
        },
        MAX_CLOSING_SEG_LEN_FACTOR: {
            configurable: !0
        }
    };
    Ap.prototype.addNextSegment = function(t, e) {
        if (this._s0 = this._s1, this._s1 = this._s2, this._s2 = t, this._seg0.setCoordinates(this._s0, this._s1), this.computeOffsetSegment(this._seg0, this._side, this._distance, this._offset0), this._seg1.setCoordinates(this._s1, this._s2), this.computeOffsetSegment(this._seg1, this._side, this._distance, this._offset1), this._s1.equals(this._s2)) return null;
        var n = Xl.computeOrientation(this._s0, this._s1, this._s2), r = n === Xl.CLOCKWISE && this._side === Sh.LEFT || n === Xl.COUNTERCLOCKWISE && this._side === Sh.RIGHT;
        0 === n ? this.addCollinear(e) : r ? this.addOutsideTurn(n, e) : this.addInsideTurn(n, e);
    }, Ap.prototype.addLineEndCap = function(t, e) {
        var n = new vp(t, e), r = new vp;
        this.computeOffsetSegment(n, Sh.LEFT, this._distance, r);
        var i = new vp;
        this.computeOffsetSegment(n, Sh.RIGHT, this._distance, i);
        var o = e.x - t.x, s = e.y - t.y, a = Math.atan2(s, o);
        switch(this._bufParams.getEndCapStyle()){
            case Sp.CAP_ROUND:
                this._segList.addPt(r.p1), this.addFilletArc(e, a + Math.PI / 2, a - Math.PI / 2, Xl.CLOCKWISE, this._distance), this._segList.addPt(i.p1);
                break;
            case Sp.CAP_FLAT:
                this._segList.addPt(r.p1), this._segList.addPt(i.p1);
                break;
            case Sp.CAP_SQUARE:
                var u = new ul;
                u.x = Math.abs(this._distance) * Math.cos(a), u.y = Math.abs(this._distance) * Math.sin(a);
                var l = new ul(r.p1.x + u.x, r.p1.y + u.y), c = new ul(i.p1.x + u.x, i.p1.y + u.y);
                this._segList.addPt(l), this._segList.addPt(c);
        }
    }, Ap.prototype.getCoordinates = function() {
        return this._segList.getCoordinates();
    }, Ap.prototype.addMitreJoin = function(t, e, n, r) {
        var i = !0, o = null;
        try {
            o = Ml.intersection(e.p0, e.p1, n.p0, n.p1), (r <= 0 ? 1 : o.distance(t) / Math.abs(r)) > this._bufParams.getMitreLimit() && (i = !1);
        } catch (t) {
            if (!(t instanceof Cl)) throw t;
            o = new ul(0, 0), i = !1;
        }
        i ? this._segList.addPt(o) : this.addLimitedMitreJoin(e, n, r, this._bufParams.getMitreLimit());
    }, Ap.prototype.addFilletCorner = function(t, e, n, r, i) {
        var o = e.x - t.x, s = e.y - t.y, a = Math.atan2(s, o), u = n.x - t.x, l = n.y - t.y, c = Math.atan2(l, u);
        r === Xl.CLOCKWISE ? a <= c && (a += 2 * Math.PI) : a >= c && (a -= 2 * Math.PI), this._segList.addPt(e), this.addFilletArc(t, a, c, r, i), this._segList.addPt(n);
    }, Ap.prototype.addOutsideTurn = function(t, e) {
        if (this._offset0.p1.distance(this._offset1.p0) < this._distance * Ap.OFFSET_SEGMENT_SEPARATION_FACTOR) return this._segList.addPt(this._offset0.p1), null;
        this._bufParams.getJoinStyle() === Sp.JOIN_MITRE ? this.addMitreJoin(this._s1, this._offset0, this._offset1, this._distance) : this._bufParams.getJoinStyle() === Sp.JOIN_BEVEL ? this.addBevelJoin(this._offset0, this._offset1) : (e && this._segList.addPt(this._offset0.p1), this.addFilletCorner(this._s1, this._offset0.p1, this._offset1.p0, t, this._distance), this._segList.addPt(this._offset1.p0));
    }, Ap.prototype.createSquare = function(t) {
        this._segList.addPt(new ul(t.x + this._distance, t.y + this._distance)), this._segList.addPt(new ul(t.x + this._distance, t.y - this._distance)), this._segList.addPt(new ul(t.x - this._distance, t.y - this._distance)), this._segList.addPt(new ul(t.x - this._distance, t.y + this._distance)), this._segList.closeRing();
    }, Ap.prototype.addSegments = function(t, e) {
        this._segList.addPts(t, e);
    }, Ap.prototype.addFirstSegment = function() {
        this._segList.addPt(this._offset1.p0);
    }, Ap.prototype.addLastSegment = function() {
        this._segList.addPt(this._offset1.p1);
    }, Ap.prototype.initSideSegments = function(t, e, n) {
        this._s1 = t, this._s2 = e, this._side = n, this._seg1.setCoordinates(t, e), this.computeOffsetSegment(this._seg1, n, this._distance, this._offset1);
    }, Ap.prototype.addLimitedMitreJoin = function(t, e, n, r) {
        var i = this._seg0.p1, o = Rp.angle(i, this._seg0.p0), s = Rp.angleBetweenOriented(this._seg0.p0, i, this._seg1.p1) / 2, a = Rp.normalize(o + s), u = Rp.normalize(a + Math.PI), l = r * n, c = n - l * Math.abs(Math.sin(s)), h = i.x + l * Math.cos(u), p = i.y + l * Math.sin(u), f = new ul(h, p), g = new vp(i, f), d = g.pointAlongOffset(1, c), y = g.pointAlongOffset(1, -c);
        this._side === Sh.LEFT ? (this._segList.addPt(d), this._segList.addPt(y)) : (this._segList.addPt(y), this._segList.addPt(d));
    }, Ap.prototype.computeOffsetSegment = function(t, e, n, r) {
        var i = e === Sh.LEFT ? 1 : -1, o = t.p1.x - t.p0.x, s = t.p1.y - t.p0.y, a = Math.sqrt(o * o + s * s), u = i * n * o / a, l = i * n * s / a;
        r.p0.x = t.p0.x - l, r.p0.y = t.p0.y + u, r.p1.x = t.p1.x - l, r.p1.y = t.p1.y + u;
    }, Ap.prototype.addFilletArc = function(t, e, n, r, i) {
        var o = r === Xl.CLOCKWISE ? -1 : 1, s = Math.abs(e - n), a = Math.trunc(s / this._filletAngleQuantum + .5);
        if (a < 1) return null;
        for(var u = s / a, l = 0, c = new ul; l < s;){
            var h = e + o * l;
            c.x = t.x + i * Math.cos(h), c.y = t.y + i * Math.sin(h), this._segList.addPt(c), l += u;
        }
    }, Ap.prototype.addInsideTurn = function(t, e) {
        if (this._li.computeIntersection(this._offset0.p0, this._offset0.p1, this._offset1.p0, this._offset1.p1), this._li.hasIntersection()) this._segList.addPt(this._li.getIntersection(0));
        else if (this._hasNarrowConcaveAngle = !0, this._offset0.p1.distance(this._offset1.p0) < this._distance * Ap.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR) this._segList.addPt(this._offset0.p1);
        else {
            if (this._segList.addPt(this._offset0.p1), this._closingSegLengthFactor > 0) {
                var n = new ul((this._closingSegLengthFactor * this._offset0.p1.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset0.p1.y + this._s1.y) / (this._closingSegLengthFactor + 1));
                this._segList.addPt(n);
                var r = new ul((this._closingSegLengthFactor * this._offset1.p0.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset1.p0.y + this._s1.y) / (this._closingSegLengthFactor + 1));
                this._segList.addPt(r);
            } else this._segList.addPt(this._s1);
            this._segList.addPt(this._offset1.p0);
        }
    }, Ap.prototype.createCircle = function(t) {
        var e = new ul(t.x + this._distance, t.y);
        this._segList.addPt(e), this.addFilletArc(t, 0, 2 * Math.PI, -1, this._distance), this._segList.closeRing();
    }, Ap.prototype.addBevelJoin = function(t, e) {
        this._segList.addPt(t.p1), this._segList.addPt(e.p0);
    }, Ap.prototype.init = function(t) {
        this._distance = t, this._maxCurveSegmentError = t * (1 - Math.cos(this._filletAngleQuantum / 2)), this._segList = new Lp, this._segList.setPrecisionModel(this._precisionModel), this._segList.setMinimumVertexDistance(t * Ap.CURVE_VERTEX_SNAP_DISTANCE_FACTOR);
    }, Ap.prototype.addCollinear = function(t) {
        this._li.computeIntersection(this._s0, this._s1, this._s1, this._s2), this._li.getIntersectionNum() >= 2 && (this._bufParams.getJoinStyle() === Sp.JOIN_BEVEL || this._bufParams.getJoinStyle() === Sp.JOIN_MITRE ? (t && this._segList.addPt(this._offset0.p1), this._segList.addPt(this._offset1.p0)) : this.addFilletCorner(this._s1, this._offset0.p1, this._offset1.p0, Xl.CLOCKWISE, this._distance));
    }, Ap.prototype.closeRing = function() {
        this._segList.closeRing();
    }, Ap.prototype.hasNarrowConcaveAngle = function() {
        return this._hasNarrowConcaveAngle;
    }, Ap.prototype.interfaces_ = function() {
        return [];
    }, Ap.prototype.getClass = function() {
        return Ap;
    }, Dp.OFFSET_SEGMENT_SEPARATION_FACTOR.get = function() {
        return .001;
    }, Dp.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR.get = function() {
        return .001;
    }, Dp.CURVE_VERTEX_SNAP_DISTANCE_FACTOR.get = function() {
        return 1e-6;
    }, Dp.MAX_CLOSING_SEG_LEN_FACTOR.get = function() {
        return 80;
    }, Object.defineProperties(Ap, Dp);
    var Fp = function() {
        this._distance = 0, this._precisionModel = null, this._bufParams = null;
        var t = arguments[0], e = arguments[1];
        this._precisionModel = t, this._bufParams = e;
    };
    Fp.prototype.getOffsetCurve = function(t, e) {
        if (this._distance = e, 0 === e) return null;
        var n = e < 0, r = Math.abs(e), i = this.getSegGen(r);
        t.length <= 1 ? this.computePointCurve(t[0], i) : this.computeOffsetCurve(t, n, i);
        var o = i.getCoordinates();
        return n && pc.reverse(o), o;
    }, Fp.prototype.computeSingleSidedBufferCurve = function(t, e, n) {
        var r = this.simplifyTolerance(this._distance);
        if (e) {
            n.addSegments(t, !0);
            var i = Pp.simplify(t, -r), o = i.length - 1;
            n.initSideSegments(i[o], i[o - 1], Sh.LEFT), n.addFirstSegment();
            for(var s = o - 2; s >= 0; s--)n.addNextSegment(i[s], !0);
        } else {
            n.addSegments(t, !1);
            var a = Pp.simplify(t, r), u = a.length - 1;
            n.initSideSegments(a[0], a[1], Sh.LEFT), n.addFirstSegment();
            for(var l = 2; l <= u; l++)n.addNextSegment(a[l], !0);
        }
        n.addLastSegment(), n.closeRing();
    }, Fp.prototype.computeRingBufferCurve = function(t, e, n) {
        var r = this.simplifyTolerance(this._distance);
        e === Sh.RIGHT && (r = -r);
        var i = Pp.simplify(t, r), o = i.length - 1;
        n.initSideSegments(i[o - 1], i[0], e);
        for(var s = 1; s <= o; s++){
            var a = 1 !== s;
            n.addNextSegment(i[s], a);
        }
        n.closeRing();
    }, Fp.prototype.computeLineBufferCurve = function(t, e) {
        var n = this.simplifyTolerance(this._distance), r = Pp.simplify(t, n), i = r.length - 1;
        e.initSideSegments(r[0], r[1], Sh.LEFT);
        for(var o = 2; o <= i; o++)e.addNextSegment(r[o], !0);
        e.addLastSegment(), e.addLineEndCap(r[i - 1], r[i]);
        var s = Pp.simplify(t, -n), a = s.length - 1;
        e.initSideSegments(s[a], s[a - 1], Sh.LEFT);
        for(var u = a - 2; u >= 0; u--)e.addNextSegment(s[u], !0);
        e.addLastSegment(), e.addLineEndCap(s[1], s[0]), e.closeRing();
    }, Fp.prototype.computePointCurve = function(t, e) {
        switch(this._bufParams.getEndCapStyle()){
            case Sp.CAP_ROUND:
                e.createCircle(t);
                break;
            case Sp.CAP_SQUARE:
                e.createSquare(t);
        }
    }, Fp.prototype.getLineCurve = function(t, e) {
        if (this._distance = e, e < 0 && !this._bufParams.isSingleSided()) return null;
        if (0 === e) return null;
        var n = Math.abs(e), r = this.getSegGen(n);
        if (t.length <= 1) this.computePointCurve(t[0], r);
        else if (this._bufParams.isSingleSided()) {
            var i = e < 0;
            this.computeSingleSidedBufferCurve(t, i, r);
        } else this.computeLineBufferCurve(t, r);
        return r.getCoordinates();
    }, Fp.prototype.getBufferParameters = function() {
        return this._bufParams;
    }, Fp.prototype.simplifyTolerance = function(t) {
        return t * this._bufParams.getSimplifyFactor();
    }, Fp.prototype.getRingCurve = function(t, e, n) {
        if (this._distance = n, t.length <= 2) return this.getLineCurve(t, n);
        if (0 === n) return Fp.copyCoordinates(t);
        var r = this.getSegGen(n);
        return this.computeRingBufferCurve(t, e, r), r.getCoordinates();
    }, Fp.prototype.computeOffsetCurve = function(t, e, n) {
        var r = this.simplifyTolerance(this._distance);
        if (e) {
            var i = Pp.simplify(t, -r), o = i.length - 1;
            n.initSideSegments(i[o], i[o - 1], Sh.LEFT), n.addFirstSegment();
            for(var s = o - 2; s >= 0; s--)n.addNextSegment(i[s], !0);
        } else {
            var a = Pp.simplify(t, r), u = a.length - 1;
            n.initSideSegments(a[0], a[1], Sh.LEFT), n.addFirstSegment();
            for(var l = 2; l <= u; l++)n.addNextSegment(a[l], !0);
        }
        n.addLastSegment();
    }, Fp.prototype.getSegGen = function(t) {
        return new Ap(this._precisionModel, this._bufParams, t);
    }, Fp.prototype.interfaces_ = function() {
        return [];
    }, Fp.prototype.getClass = function() {
        return Fp;
    }, Fp.copyCoordinates = function(t) {
        for(var e = new Array(t.length).fill(null), n = 0; n < e.length; n++)e[n] = new ul(t[n]);
        return e;
    };
    var kp = function() {
        this._subgraphs = null, this._seg = new vp, this._cga = new Xl;
        var t = arguments[0];
        this._subgraphs = t;
    }, Gp = {
        DepthSegment: {
            configurable: !0
        }
    };
    kp.prototype.findStabbedSegments = function() {
        var t = this;
        if (1 === arguments.length) {
            for(var e = arguments[0], n = new lc, r = this._subgraphs.iterator(); r.hasNext();){
                var i = r.next(), o = i.getEnvelope();
                e.y < o.getMinY() || e.y > o.getMaxY() || t.findStabbedSegments(e, i.getDirectedEdges(), n);
            }
            return n;
        }
        if (3 === arguments.length) {
            if (gl(arguments[2], ac) && arguments[0] instanceof ul && arguments[1] instanceof Xh) for(var s = arguments[0], a = arguments[1], u = arguments[2], l = a.getEdge().getCoordinates(), c = 0; c < l.length - 1; c++){
                t._seg.p0 = l[c], t._seg.p1 = l[c + 1], t._seg.p0.y > t._seg.p1.y && t._seg.reverse();
                var h = Math.max(t._seg.p0.x, t._seg.p1.x);
                if (!(h < s.x) && !(t._seg.isHorizontal() || s.y < t._seg.p0.y || s.y > t._seg.p1.y || Xl.computeOrientation(t._seg.p0, t._seg.p1, s) === Xl.RIGHT)) {
                    var p = a.getDepth(Sh.LEFT);
                    t._seg.p0.equals(l[c]) || (p = a.getDepth(Sh.RIGHT));
                    var f = new qp(t._seg, p);
                    u.add(f);
                }
            }
            else if (gl(arguments[2], ac) && arguments[0] instanceof ul && gl(arguments[1], ac)) for(var g = arguments[0], d = arguments[1], y = arguments[2], v = d.iterator(); v.hasNext();){
                var _ = v.next();
                _.isForward() && t.findStabbedSegments(g, _, y);
            }
        }
    }, kp.prototype.getDepth = function(t) {
        var e = this.findStabbedSegments(t);
        return 0 === e.size() ? 0 : np.min(e)._leftDepth;
    }, kp.prototype.interfaces_ = function() {
        return [];
    }, kp.prototype.getClass = function() {
        return kp;
    }, Gp.DepthSegment.get = function() {
        return qp;
    }, Object.defineProperties(kp, Gp);
    var qp = function() {
        this._upwardSeg = null, this._leftDepth = null;
        var t = arguments[0], e = arguments[1];
        this._upwardSeg = new vp(t), this._leftDepth = e;
    };
    qp.prototype.compareTo = function(t) {
        var e = t;
        if (this._upwardSeg.minX() >= e._upwardSeg.maxX()) return 1;
        if (this._upwardSeg.maxX() <= e._upwardSeg.minX()) return -1;
        var n = this._upwardSeg.orientationIndex(e._upwardSeg);
        return 0 !== n || 0 !== (n = -1 * e._upwardSeg.orientationIndex(this._upwardSeg)) ? n : this._upwardSeg.compareTo(e._upwardSeg);
    }, qp.prototype.compareX = function(t, e) {
        var n = t.p0.compareTo(e.p0);
        return 0 !== n ? n : t.p1.compareTo(e.p1);
    }, qp.prototype.toString = function() {
        return this._upwardSeg.toString();
    }, qp.prototype.interfaces_ = function() {
        return [
            il
        ];
    }, qp.prototype.getClass = function() {
        return qp;
    };
    var Bp = function(t, e, n) {
        this.p0 = t || null, this.p1 = e || null, this.p2 = n || null;
    };
    Bp.prototype.area = function() {
        return Bp.area(this.p0, this.p1, this.p2);
    }, Bp.prototype.signedArea = function() {
        return Bp.signedArea(this.p0, this.p1, this.p2);
    }, Bp.prototype.interpolateZ = function(t) {
        if (null === t) throw new el("Supplied point is null.");
        return Bp.interpolateZ(t, this.p0, this.p1, this.p2);
    }, Bp.prototype.longestSideLength = function() {
        return Bp.longestSideLength(this.p0, this.p1, this.p2);
    }, Bp.prototype.isAcute = function() {
        return Bp.isAcute(this.p0, this.p1, this.p2);
    }, Bp.prototype.circumcentre = function() {
        return Bp.circumcentre(this.p0, this.p1, this.p2);
    }, Bp.prototype.area3D = function() {
        return Bp.area3D(this.p0, this.p1, this.p2);
    }, Bp.prototype.centroid = function() {
        return Bp.centroid(this.p0, this.p1, this.p2);
    }, Bp.prototype.inCentre = function() {
        return Bp.inCentre(this.p0, this.p1, this.p2);
    }, Bp.prototype.interfaces_ = function() {
        return [];
    }, Bp.prototype.getClass = function() {
        return Bp;
    }, Bp.area = function(t, e, n) {
        return Math.abs(((n.x - t.x) * (e.y - t.y) - (e.x - t.x) * (n.y - t.y)) / 2);
    }, Bp.signedArea = function(t, e, n) {
        return ((n.x - t.x) * (e.y - t.y) - (e.x - t.x) * (n.y - t.y)) / 2;
    }, Bp.det = function(t, e, n, r) {
        return t * r - e * n;
    }, Bp.interpolateZ = function(t, e, n, r) {
        var i = e.x, o = e.y, s = n.x - i, a = r.x - i, u = n.y - o, l = r.y - o, c = s * l - a * u, h = t.x - i, p = t.y - o, f = (l * h - a * p) / c, g = (-u * h + s * p) / c;
        return e.z + f * (n.z - e.z) + g * (r.z - e.z);
    }, Bp.longestSideLength = function(t, e, n) {
        var r = t.distance(e), i = e.distance(n), o = n.distance(t), s = r;
        return i > s && (s = i), o > s && (s = o), s;
    }, Bp.isAcute = function(t, e, n) {
        return !!Rp.isAcute(t, e, n) && !!Rp.isAcute(e, n, t) && !!Rp.isAcute(n, t, e);
    }, Bp.circumcentre = function(t, e, n) {
        var r = n.x, i = n.y, o = t.x - r, s = t.y - i, a = e.x - r, u = e.y - i, l = 2 * Bp.det(o, s, a, u), c = Bp.det(s, o * o + s * s, u, a * a + u * u), h = Bp.det(o, o * o + s * s, a, a * a + u * u);
        return new ul(r - c / l, i + h / l);
    }, Bp.perpendicularBisector = function(t, e) {
        var n = e.x - t.x, r = e.y - t.y, i = new Ml(t.x + n / 2, t.y + r / 2, 1), o = new Ml(t.x - r + n / 2, t.y + n + r / 2, 1);
        return new Ml(i, o);
    }, Bp.angleBisector = function(t, e, n) {
        var r = e.distance(t), i = r / (r + e.distance(n)), o = n.x - t.x, s = n.y - t.y;
        return new ul(t.x + i * o, t.y + i * s);
    }, Bp.area3D = function(t, e, n) {
        var r = e.x - t.x, i = e.y - t.y, o = e.z - t.z, s = n.x - t.x, a = n.y - t.y, u = n.z - t.z, l = i * u - o * a, c = o * s - r * u, h = r * a - i * s, p = l * l + c * c + h * h, f = Math.sqrt(p) / 2;
        return f;
    }, Bp.centroid = function(t, e, n) {
        var r = (t.x + e.x + n.x) / 3, i = (t.y + e.y + n.y) / 3;
        return new ul(r, i);
    }, Bp.inCentre = function(t, e, n) {
        var r = e.distance(n), i = t.distance(n), o = t.distance(e), s = r + i + o, a = (r * t.x + i * e.x + o * n.x) / s, u = (r * t.y + i * e.y + o * n.y) / s;
        return new ul(a, u);
    };
    var zp = function() {
        this._inputGeom = null, this._distance = null, this._curveBuilder = null, this._curveList = new lc;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        this._inputGeom = t, this._distance = e, this._curveBuilder = n;
    };
    zp.prototype.addPoint = function(t) {
        if (this._distance <= 0) return null;
        var e = t.getCoordinates(), n = this._curveBuilder.getLineCurve(e, this._distance);
        this.addCurve(n, pl.EXTERIOR, pl.INTERIOR);
    }, zp.prototype.addPolygon = function(t) {
        var e = this, n = this._distance, r = Sh.LEFT;
        this._distance < 0 && (n = -this._distance, r = Sh.RIGHT);
        var i = t.getExteriorRing(), o = pc.removeRepeatedPoints(i.getCoordinates());
        if (this._distance < 0 && this.isErodedCompletely(i, this._distance)) return null;
        if (this._distance <= 0 && o.length < 3) return null;
        this.addPolygonRing(o, n, r, pl.EXTERIOR, pl.INTERIOR);
        for(var s = 0; s < t.getNumInteriorRing(); s++){
            var a = t.getInteriorRingN(s), u = pc.removeRepeatedPoints(a.getCoordinates());
            e._distance > 0 && e.isErodedCompletely(a, -e._distance) || e.addPolygonRing(u, n, Sh.opposite(r), pl.INTERIOR, pl.EXTERIOR);
        }
    }, zp.prototype.isTriangleErodedCompletely = function(t, e) {
        var n = new Bp(t[0], t[1], t[2]), r = n.inCentre();
        return Xl.distancePointLine(r, n.p0, n.p1) < Math.abs(e);
    }, zp.prototype.addLineString = function(t) {
        if (this._distance <= 0 && !this._curveBuilder.getBufferParameters().isSingleSided()) return null;
        var e = pc.removeRepeatedPoints(t.getCoordinates()), n = this._curveBuilder.getLineCurve(e, this._distance);
        this.addCurve(n, pl.EXTERIOR, pl.INTERIOR);
    }, zp.prototype.addCurve = function(t, e, n) {
        if (null === t || t.length < 2) return null;
        var r = new yp(t, new Dh(0, pl.BOUNDARY, e, n));
        this._curveList.add(r);
    }, zp.prototype.getCurves = function() {
        return this.add(this._inputGeom), this._curveList;
    }, zp.prototype.addPolygonRing = function(t, e, n, r, i) {
        if (0 === e && t.length < nh.MINIMUM_VALID_SIZE) return null;
        var o = r, s = i;
        t.length >= nh.MINIMUM_VALID_SIZE && Xl.isCCW(t) && (o = i, s = r, n = Sh.opposite(n));
        var a = this._curveBuilder.getRingCurve(t, n, e);
        this.addCurve(a, o, s);
    }, zp.prototype.add = function(t) {
        if (t.isEmpty()) return null;
        t instanceof th ? this.addPolygon(t) : t instanceof Zc ? this.addLineString(t) : t instanceof Qc ? this.addPoint(t) : (t instanceof eh || t instanceof Gc || t instanceof rh || t instanceof kc) && this.addCollection(t);
    }, zp.prototype.isErodedCompletely = function(t, e) {
        var n = t.getCoordinates();
        if (n.length < 4) return e < 0;
        if (4 === n.length) return this.isTriangleErodedCompletely(n, e);
        var r = t.getEnvelopeInternal(), i = Math.min(r.getHeight(), r.getWidth());
        return e < 0 && 2 * Math.abs(e) > i;
    }, zp.prototype.addCollection = function(t) {
        for(var e = 0; e < t.getNumGeometries(); e++){
            var n = t.getGeometryN(e);
            this.add(n);
        }
    }, zp.prototype.interfaces_ = function() {
        return [];
    }, zp.prototype.getClass = function() {
        return zp;
    };
    var jp = function() {};
    jp.prototype.locate = function(t) {}, jp.prototype.interfaces_ = function() {
        return [];
    }, jp.prototype.getClass = function() {
        return jp;
    };
    var Up = function() {
        this._parent = null, this._atStart = null, this._max = null, this._index = null, this._subcollectionIterator = null;
        var t = arguments[0];
        this._parent = t, this._atStart = !0, this._index = 0, this._max = t.getNumGeometries();
    };
    Up.prototype.next = function() {
        if (this._atStart) return this._atStart = !1, Up.isAtomic(this._parent) && this._index++, this._parent;
        if (null !== this._subcollectionIterator) {
            if (this._subcollectionIterator.hasNext()) return this._subcollectionIterator.next();
            this._subcollectionIterator = null;
        }
        if (this._index >= this._max) throw new uc;
        var t = this._parent.getGeometryN(this._index++);
        return t instanceof kc ? (this._subcollectionIterator = new Up(t), this._subcollectionIterator.next()) : t;
    }, Up.prototype.remove = function() {
        throw new Error(this.getClass().getName());
    }, Up.prototype.hasNext = function() {
        if (this._atStart) return !0;
        if (null !== this._subcollectionIterator) {
            if (this._subcollectionIterator.hasNext()) return !0;
            this._subcollectionIterator = null;
        }
        return !(this._index >= this._max);
    }, Up.prototype.interfaces_ = function() {
        return [
            sc
        ];
    }, Up.prototype.getClass = function() {
        return Up;
    }, Up.isAtomic = function(t) {
        return !(t instanceof kc);
    };
    var Vp = function() {
        this._geom = null;
        var t = arguments[0];
        this._geom = t;
    };
    Vp.prototype.locate = function(t) {
        return Vp.locate(t, this._geom);
    }, Vp.prototype.interfaces_ = function() {
        return [
            jp
        ];
    }, Vp.prototype.getClass = function() {
        return Vp;
    }, Vp.isPointInRing = function(t, e) {
        return !!e.getEnvelopeInternal().intersects(t) && Xl.isPointInRing(t, e.getCoordinates());
    }, Vp.containsPointInPolygon = function(t, e) {
        if (e.isEmpty()) return !1;
        var n = e.getExteriorRing();
        if (!Vp.isPointInRing(t, n)) return !1;
        for(var r = 0; r < e.getNumInteriorRing(); r++){
            var i = e.getInteriorRingN(r);
            if (Vp.isPointInRing(t, i)) return !1;
        }
        return !0;
    }, Vp.containsPoint = function(t, e) {
        if (e instanceof th) return Vp.containsPointInPolygon(t, e);
        if (e instanceof kc) for(var n = new Up(e); n.hasNext();){
            var r = n.next();
            if (r !== e && Vp.containsPoint(t, r)) return !0;
        }
        return !1;
    }, Vp.locate = function(t, e) {
        return e.isEmpty() ? pl.EXTERIOR : Vp.containsPoint(t, e) ? pl.INTERIOR : pl.EXTERIOR;
    };
    var Xp = function() {
        this._edgeMap = new Cc, this._edgeList = null, this._ptInAreaLocation = [
            pl.NONE,
            pl.NONE
        ];
    };
    Xp.prototype.getNextCW = function(t) {
        this.getEdges();
        var e = this._edgeList.indexOf(t), n = e - 1;
        return 0 === e && (n = this._edgeList.size() - 1), this._edgeList.get(n);
    }, Xp.prototype.propagateSideLabels = function(t) {
        for(var e = pl.NONE, n = this.iterator(); n.hasNext();){
            var r = n.next().getLabel();
            r.isArea(t) && r.getLocation(t, Sh.LEFT) !== pl.NONE && (e = r.getLocation(t, Sh.LEFT));
        }
        if (e === pl.NONE) return null;
        for(var i = e, o = this.iterator(); o.hasNext();){
            var s = o.next(), a = s.getLabel();
            if (a.getLocation(t, Sh.ON) === pl.NONE && a.setLocation(t, Sh.ON, i), a.isArea(t)) {
                var u = a.getLocation(t, Sh.LEFT), l = a.getLocation(t, Sh.RIGHT);
                if (l !== pl.NONE) {
                    if (l !== i) throw new Oh("side location conflict", s.getCoordinate());
                    u === pl.NONE && ql.shouldNeverReachHere("found single null side (at " + s.getCoordinate() + ")"), i = u;
                } else ql.isTrue(a.getLocation(t, Sh.LEFT) === pl.NONE, "found single null side"), a.setLocation(t, Sh.RIGHT, i), a.setLocation(t, Sh.LEFT, i);
            }
        }
    }, Xp.prototype.getCoordinate = function() {
        var t = this.iterator();
        return t.hasNext() ? t.next().getCoordinate() : null;
    }, Xp.prototype.print = function(t) {
        Pl.out.println("EdgeEndStar:   " + this.getCoordinate());
        for(var e = this.iterator(); e.hasNext();)e.next().print(t);
    }, Xp.prototype.isAreaLabelsConsistent = function(t) {
        return this.computeEdgeEndLabels(t.getBoundaryNodeRule()), this.checkAreaLabelsConsistent(0);
    }, Xp.prototype.checkAreaLabelsConsistent = function(t) {
        var e = this.getEdges();
        if (e.size() <= 0) return !0;
        var n = e.size() - 1, r = e.get(n).getLabel().getLocation(t, Sh.LEFT);
        ql.isTrue(r !== pl.NONE, "Found unlabelled area edge");
        for(var i = r, o = this.iterator(); o.hasNext();){
            var s = o.next().getLabel();
            ql.isTrue(s.isArea(t), "Found non-area edge");
            var a = s.getLocation(t, Sh.LEFT), u = s.getLocation(t, Sh.RIGHT);
            if (a === u) return !1;
            if (u !== i) return !1;
            i = a;
        }
        return !0;
    }, Xp.prototype.findIndex = function(t) {
        this.iterator();
        for(var e = 0; e < this._edgeList.size(); e++){
            if (this._edgeList.get(e) === t) return e;
        }
        return -1;
    }, Xp.prototype.iterator = function() {
        return this.getEdges().iterator();
    }, Xp.prototype.getEdges = function() {
        return null === this._edgeList && (this._edgeList = new lc(this._edgeMap.values())), this._edgeList;
    }, Xp.prototype.getLocation = function(t, e, n) {
        return this._ptInAreaLocation[t] === pl.NONE && (this._ptInAreaLocation[t] = Vp.locate(e, n[t].getGeometry())), this._ptInAreaLocation[t];
    }, Xp.prototype.toString = function() {
        var t = new vl;
        t.append("EdgeEndStar:   " + this.getCoordinate()), t.append("\n");
        for(var e = this.iterator(); e.hasNext();){
            var n = e.next();
            t.append(n), t.append("\n");
        }
        return t.toString();
    }, Xp.prototype.computeEdgeEndLabels = function(t) {
        for(var e = this.iterator(); e.hasNext();)e.next().computeLabel(t);
    }, Xp.prototype.computeLabelling = function(t) {
        this.computeEdgeEndLabels(t[0].getBoundaryNodeRule()), this.propagateSideLabels(0), this.propagateSideLabels(1);
        for(var e = [
            !1,
            !1
        ], n = this.iterator(); n.hasNext();)for(var r = n.next().getLabel(), i = 0; i < 2; i++)r.isLine(i) && r.getLocation(i) === pl.BOUNDARY && (e[i] = !0);
        for(var o = this.iterator(); o.hasNext();)for(var s = o.next(), a = s.getLabel(), u = 0; u < 2; u++)if (a.isAnyNull(u)) {
            var l = pl.NONE;
            if (e[u]) l = pl.EXTERIOR;
            else {
                var c = s.getCoordinate();
                l = this.getLocation(u, c, t);
            }
            a.setAllLocationsIfNull(u, l);
        }
    }, Xp.prototype.getDegree = function() {
        return this._edgeMap.size();
    }, Xp.prototype.insertEdgeEnd = function(t, e) {
        this._edgeMap.put(t, e), this._edgeList = null;
    }, Xp.prototype.interfaces_ = function() {
        return [];
    }, Xp.prototype.getClass = function() {
        return Xp;
    };
    var Yp = function(t) {
        function e() {
            t.call(this), this._resultAreaEdgeList = null, this._label = null, this._SCANNING_FOR_INCOMING = 1, this._LINKING_TO_OUTGOING = 2;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.linkResultDirectedEdges = function() {
            var t = this;
            this.getResultAreaEdges();
            for(var e = null, n = null, r = this._SCANNING_FOR_INCOMING, i = 0; i < this._resultAreaEdgeList.size(); i++){
                var o = t._resultAreaEdgeList.get(i), s = o.getSym();
                if (o.getLabel().isArea()) switch(null === e && o.isInResult() && (e = o), r){
                    case t._SCANNING_FOR_INCOMING:
                        if (!s.isInResult()) continue;
                        n = s, r = t._LINKING_TO_OUTGOING;
                        break;
                    case t._LINKING_TO_OUTGOING:
                        if (!o.isInResult()) continue;
                        n.setNext(o), r = t._SCANNING_FOR_INCOMING;
                }
            }
            if (r === this._LINKING_TO_OUTGOING) {
                if (null === e) throw new Oh("no outgoing dirEdge found", this.getCoordinate());
                ql.isTrue(e.isInResult(), "unable to link last incoming dirEdge"), n.setNext(e);
            }
        }, e.prototype.insert = function(t) {
            var e = t;
            this.insertEdgeEnd(e, e);
        }, e.prototype.getRightmostEdge = function() {
            var t = this.getEdges(), e = t.size();
            if (e < 1) return null;
            var n = t.get(0);
            if (1 === e) return n;
            var r = t.get(e - 1), i = n.getQuadrant(), o = r.getQuadrant();
            return jh.isNorthern(i) && jh.isNorthern(o) ? n : jh.isNorthern(i) || jh.isNorthern(o) ? 0 !== n.getDy() ? n : 0 !== r.getDy() ? r : (ql.shouldNeverReachHere("found two horizontal edges incident on node"), null) : r;
        }, e.prototype.print = function(t) {
            Pl.out.println("DirectedEdgeStar: " + this.getCoordinate());
            for(var e = this.iterator(); e.hasNext();){
                var n = e.next();
                t.print("out "), n.print(t), t.println(), t.print("in "), n.getSym().print(t), t.println();
            }
        }, e.prototype.getResultAreaEdges = function() {
            if (null !== this._resultAreaEdgeList) return this._resultAreaEdgeList;
            this._resultAreaEdgeList = new lc;
            for(var t = this.iterator(); t.hasNext();){
                var e = t.next();
                (e.isInResult() || e.getSym().isInResult()) && this._resultAreaEdgeList.add(e);
            }
            return this._resultAreaEdgeList;
        }, e.prototype.updateLabelling = function(t) {
            for(var e = this.iterator(); e.hasNext();){
                var n = e.next().getLabel();
                n.setAllLocationsIfNull(0, t.getLocation(0)), n.setAllLocationsIfNull(1, t.getLocation(1));
            }
        }, e.prototype.linkAllDirectedEdges = function() {
            this.getEdges();
            for(var t = null, e = null, n = this._edgeList.size() - 1; n >= 0; n--){
                var r = this._edgeList.get(n), i = r.getSym();
                null === e && (e = i), null !== t && i.setNext(t), t = r;
            }
            e.setNext(t);
        }, e.prototype.computeDepths = function() {
            var t = this;
            if (1 === arguments.length) {
                var e = arguments[0], n = this.findIndex(e), r = e.getDepth(Sh.LEFT), i = e.getDepth(Sh.RIGHT), o = this.computeDepths(n + 1, this._edgeList.size(), r), s = this.computeDepths(0, n, o);
                if (s !== i) throw new Oh("depth mismatch at " + e.getCoordinate());
            } else if (3 === arguments.length) {
                for(var a = arguments[0], u = arguments[1], l = arguments[2], c = l, h = a; h < u; h++){
                    var p = t._edgeList.get(h);
                    p.setEdgeDepths(Sh.RIGHT, c), c = p.getDepth(Sh.LEFT);
                }
                return c;
            }
        }, e.prototype.mergeSymLabels = function() {
            for(var t = this.iterator(); t.hasNext();){
                var e = t.next();
                e.getLabel().merge(e.getSym().getLabel());
            }
        }, e.prototype.linkMinimalDirectedEdges = function(t) {
            for(var e = this, n = null, r = null, i = this._SCANNING_FOR_INCOMING, o = this._resultAreaEdgeList.size() - 1; o >= 0; o--){
                var s = e._resultAreaEdgeList.get(o), a = s.getSym();
                switch(null === n && s.getEdgeRing() === t && (n = s), i){
                    case e._SCANNING_FOR_INCOMING:
                        if (a.getEdgeRing() !== t) continue;
                        r = a, i = e._LINKING_TO_OUTGOING;
                        break;
                    case e._LINKING_TO_OUTGOING:
                        if (s.getEdgeRing() !== t) continue;
                        r.setNextMin(s), i = e._SCANNING_FOR_INCOMING;
                }
            }
            i === this._LINKING_TO_OUTGOING && (ql.isTrue(null !== n, "found null for first outgoing dirEdge"), ql.isTrue(n.getEdgeRing() === t, "unable to link last incoming dirEdge"), r.setNextMin(n));
        }, e.prototype.getOutgoingDegree = function() {
            if (0 === arguments.length) {
                for(var t = 0, e = this.iterator(); e.hasNext();){
                    var n = e.next();
                    n.isInResult() && t++;
                }
                return t;
            }
            if (1 === arguments.length) {
                for(var r = arguments[0], i = 0, o = this.iterator(); o.hasNext();){
                    var s = o.next();
                    s.getEdgeRing() === r && i++;
                }
                return i;
            }
        }, e.prototype.getLabel = function() {
            return this._label;
        }, e.prototype.findCoveredLineEdges = function() {
            for(var t = pl.NONE, e = this.iterator(); e.hasNext();){
                var n = e.next(), r = n.getSym();
                if (!n.isLineEdge()) {
                    if (n.isInResult()) {
                        t = pl.INTERIOR;
                        break;
                    }
                    if (r.isInResult()) {
                        t = pl.EXTERIOR;
                        break;
                    }
                }
            }
            if (t === pl.NONE) return null;
            for(var i = t, o = this.iterator(); o.hasNext();){
                var s = o.next(), a = s.getSym();
                s.isLineEdge() ? s.getEdge().setCovered(i === pl.INTERIOR) : (s.isInResult() && (i = pl.EXTERIOR), a.isInResult() && (i = pl.INTERIOR));
            }
        }, e.prototype.computeLabelling = function(e) {
            t.prototype.computeLabelling.call(this, e), this._label = new Dh(pl.NONE);
            for(var n = this.iterator(); n.hasNext();)for(var r = n.next().getEdge().getLabel(), i = 0; i < 2; i++){
                var o = r.getLocation(i);
                o !== pl.INTERIOR && o !== pl.BOUNDARY || this._label.setLocation(i, pl.INTERIOR);
            }
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Xp), Hp = function(t) {
        function e() {
            t.apply(this, arguments);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.createNode = function(t) {
            return new Bh(t, new Yp);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Yh), Wp = function t() {
        this._pts = null, this._orientation = null;
        var e = arguments[0];
        this._pts = e, this._orientation = t.orientation(e);
    };
    Wp.prototype.compareTo = function(t) {
        var e = t;
        return Wp.compareOriented(this._pts, this._orientation, e._pts, e._orientation);
    }, Wp.prototype.interfaces_ = function() {
        return [
            il
        ];
    }, Wp.prototype.getClass = function() {
        return Wp;
    }, Wp.orientation = function(t) {
        return 1 === pc.increasingDirection(t);
    }, Wp.compareOriented = function(t, e, n, r) {
        for(var i = e ? 1 : -1, o = r ? 1 : -1, s = e ? t.length : -1, a = r ? n.length : -1, u = e ? 0 : t.length - 1, l = r ? 0 : n.length - 1;;){
            var c = t[u].compareTo(n[l]);
            if (0 !== c) return c;
            var h = (u += i) === s, p = (l += o) === a;
            if (h && !p) return -1;
            if (!h && p) return 1;
            if (h && p) return 0;
        }
    };
    var Jp = function() {
        this._edges = new lc, this._ocaMap = new Cc;
    };
    Jp.prototype.print = function(t) {
        t.print("MULTILINESTRING ( ");
        for(var e = 0; e < this._edges.size(); e++){
            var n = this._edges.get(e);
            e > 0 && t.print(","), t.print("(");
            for(var r = n.getCoordinates(), i = 0; i < r.length; i++)i > 0 && t.print(","), t.print(r[i].x + " " + r[i].y);
            t.println(")");
        }
        t.print(")  ");
    }, Jp.prototype.addAll = function(t) {
        for(var e = t.iterator(); e.hasNext();)this.add(e.next());
    }, Jp.prototype.findEdgeIndex = function(t) {
        for(var e = 0; e < this._edges.size(); e++)if (this._edges.get(e).equals(t)) return e;
        return -1;
    }, Jp.prototype.iterator = function() {
        return this._edges.iterator();
    }, Jp.prototype.getEdges = function() {
        return this._edges;
    }, Jp.prototype.get = function(t) {
        return this._edges.get(t);
    }, Jp.prototype.findEqualEdge = function(t) {
        var e = new Wp(t.getCoordinates());
        return this._ocaMap.get(e);
    }, Jp.prototype.add = function(t) {
        this._edges.add(t);
        var e = new Wp(t.getCoordinates());
        this._ocaMap.put(e, t);
    }, Jp.prototype.interfaces_ = function() {
        return [];
    }, Jp.prototype.getClass = function() {
        return Jp;
    };
    var Zp = function() {};
    Zp.prototype.processIntersections = function(t, e, n, r) {}, Zp.prototype.isDone = function() {}, Zp.prototype.interfaces_ = function() {
        return [];
    }, Zp.prototype.getClass = function() {
        return Zp;
    };
    var Kp = function() {
        this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._hasInterior = !1, this._properIntersectionPoint = null, this._li = null, this._isSelfIntersection = null, this.numIntersections = 0, this.numInteriorIntersections = 0, this.numProperIntersections = 0, this.numTests = 0;
        var t = arguments[0];
        this._li = t;
    };
    Kp.prototype.isTrivialIntersection = function(t, e, n, r) {
        if (t === n && 1 === this._li.getIntersectionNum()) {
            if (Kp.isAdjacentSegments(e, r)) return !0;
            if (t.isClosed()) {
                var i = t.size() - 1;
                if (0 === e && r === i || 0 === r && e === i) return !0;
            }
        }
        return !1;
    }, Kp.prototype.getProperIntersectionPoint = function() {
        return this._properIntersectionPoint;
    }, Kp.prototype.hasProperInteriorIntersection = function() {
        return this._hasProperInterior;
    }, Kp.prototype.getLineIntersector = function() {
        return this._li;
    }, Kp.prototype.hasProperIntersection = function() {
        return this._hasProper;
    }, Kp.prototype.processIntersections = function(t, e, n, r) {
        if (t === n && e === r) return null;
        this.numTests++;
        var i = t.getCoordinates()[e], o = t.getCoordinates()[e + 1], s = n.getCoordinates()[r], a = n.getCoordinates()[r + 1];
        this._li.computeIntersection(i, o, s, a), this._li.hasIntersection() && (this.numIntersections++, this._li.isInteriorIntersection() && (this.numInteriorIntersections++, this._hasInterior = !0), this.isTrivialIntersection(t, e, n, r) || (this._hasIntersection = !0, t.addIntersections(this._li, e, 0), n.addIntersections(this._li, r, 1), this._li.isProper() && (this.numProperIntersections++, this._hasProper = !0, this._hasProperInterior = !0)));
    }, Kp.prototype.hasIntersection = function() {
        return this._hasIntersection;
    }, Kp.prototype.isDone = function() {
        return !1;
    }, Kp.prototype.hasInteriorIntersection = function() {
        return this._hasInterior;
    }, Kp.prototype.interfaces_ = function() {
        return [
            Zp
        ];
    }, Kp.prototype.getClass = function() {
        return Kp;
    }, Kp.isAdjacentSegments = function(t, e) {
        return 1 === Math.abs(t - e);
    };
    var Qp = function() {
        this.coord = null, this.segmentIndex = null, this.dist = null;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        this.coord = new ul(t), this.segmentIndex = e, this.dist = n;
    };
    Qp.prototype.getSegmentIndex = function() {
        return this.segmentIndex;
    }, Qp.prototype.getCoordinate = function() {
        return this.coord;
    }, Qp.prototype.print = function(t) {
        t.print(this.coord), t.print(" seg # = " + this.segmentIndex), t.println(" dist = " + this.dist);
    }, Qp.prototype.compareTo = function(t) {
        var e = t;
        return this.compare(e.segmentIndex, e.dist);
    }, Qp.prototype.isEndPoint = function(t) {
        return 0 === this.segmentIndex && 0 === this.dist || this.segmentIndex === t;
    }, Qp.prototype.toString = function() {
        return this.coord + " seg # = " + this.segmentIndex + " dist = " + this.dist;
    }, Qp.prototype.getDistance = function() {
        return this.dist;
    }, Qp.prototype.compare = function(t, e) {
        return this.segmentIndex < t ? -1 : this.segmentIndex > t ? 1 : this.dist < e ? -1 : this.dist > e ? 1 : 0;
    }, Qp.prototype.interfaces_ = function() {
        return [
            il
        ];
    }, Qp.prototype.getClass = function() {
        return Qp;
    };
    var $p = function() {
        this._nodeMap = new Cc, this.edge = null;
        var t = arguments[0];
        this.edge = t;
    };
    $p.prototype.print = function(t) {
        t.println("Intersections:");
        for(var e = this.iterator(); e.hasNext();)e.next().print(t);
    }, $p.prototype.iterator = function() {
        return this._nodeMap.values().iterator();
    }, $p.prototype.addSplitEdges = function(t) {
        this.addEndpoints();
        for(var e = this.iterator(), n = e.next(); e.hasNext();){
            var r = e.next(), i = this.createSplitEdge(n, r);
            t.add(i), n = r;
        }
    }, $p.prototype.addEndpoints = function() {
        var t = this.edge.pts.length - 1;
        this.add(this.edge.pts[0], 0, 0), this.add(this.edge.pts[t], t, 0);
    }, $p.prototype.createSplitEdge = function(t, e) {
        var n = e.segmentIndex - t.segmentIndex + 2, r = this.edge.pts[e.segmentIndex], i = e.dist > 0 || !e.coord.equals2D(r);
        i || n--;
        var o = new Array(n).fill(null), s = 0;
        o[s++] = new ul(t.coord);
        for(var a = t.segmentIndex + 1; a <= e.segmentIndex; a++)o[s++] = this.edge.pts[a];
        return i && (o[s] = e.coord), new of(o, new Dh(this.edge._label));
    }, $p.prototype.add = function(t, e, n) {
        var r = new Qp(t, e, n), i = this._nodeMap.get(r);
        return null !== i ? i : (this._nodeMap.put(r, r), r);
    }, $p.prototype.isIntersection = function(t) {
        for(var e = this.iterator(); e.hasNext();){
            if (e.next().coord.equals(t)) return !0;
        }
        return !1;
    }, $p.prototype.interfaces_ = function() {
        return [];
    }, $p.prototype.getClass = function() {
        return $p;
    };
    var tf = function() {};
    tf.prototype.getChainStartIndices = function(t) {
        var e = 0, n = new lc;
        n.add(new _l(e));
        do {
            var r = this.findChainEnd(t, e);
            n.add(new _l(r)), e = r;
        }while (e < t.length - 1);
        return tf.toIntArray(n);
    }, tf.prototype.findChainEnd = function(t, e) {
        for(var n = jh.quadrant(t[e], t[e + 1]), r = e + 1; r < t.length;){
            if (jh.quadrant(t[r - 1], t[r]) !== n) break;
            r++;
        }
        return r - 1;
    }, tf.prototype.interfaces_ = function() {
        return [];
    }, tf.prototype.getClass = function() {
        return tf;
    }, tf.toIntArray = function(t) {
        for(var e = new Array(t.size()).fill(null), n = 0; n < e.length; n++)e[n] = t.get(n).intValue();
        return e;
    };
    var ef = function() {
        this.e = null, this.pts = null, this.startIndex = null, this.env1 = new Ll, this.env2 = new Ll;
        var t = arguments[0];
        this.e = t, this.pts = t.getCoordinates();
        var e = new tf;
        this.startIndex = e.getChainStartIndices(this.pts);
    };
    ef.prototype.getCoordinates = function() {
        return this.pts;
    }, ef.prototype.getMaxX = function(t) {
        var e = this.pts[this.startIndex[t]].x, n = this.pts[this.startIndex[t + 1]].x;
        return e > n ? e : n;
    }, ef.prototype.getMinX = function(t) {
        var e = this.pts[this.startIndex[t]].x, n = this.pts[this.startIndex[t + 1]].x;
        return e < n ? e : n;
    }, ef.prototype.computeIntersectsForChain = function() {
        if (4 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = arguments[2], r = arguments[3];
            this.computeIntersectsForChain(this.startIndex[t], this.startIndex[t + 1], e, e.startIndex[n], e.startIndex[n + 1], r);
        } else if (6 === arguments.length) {
            var i = arguments[0], o = arguments[1], s = arguments[2], a = arguments[3], u = arguments[4], l = arguments[5], c = this.pts[i], h = this.pts[o], p = s.pts[a], f = s.pts[u];
            if (o - i == 1 && u - a == 1) return l.addIntersections(this.e, i, s.e, a), null;
            if (this.env1.init(c, h), this.env2.init(p, f), !this.env1.intersects(this.env2)) return null;
            var g = Math.trunc((i + o) / 2), d = Math.trunc((a + u) / 2);
            i < g && (a < d && this.computeIntersectsForChain(i, g, s, a, d, l), d < u && this.computeIntersectsForChain(i, g, s, d, u, l)), g < o && (a < d && this.computeIntersectsForChain(g, o, s, a, d, l), d < u && this.computeIntersectsForChain(g, o, s, d, u, l));
        }
    }, ef.prototype.getStartIndexes = function() {
        return this.startIndex;
    }, ef.prototype.computeIntersects = function(t, e) {
        for(var n = 0; n < this.startIndex.length - 1; n++)for(var r = 0; r < t.startIndex.length - 1; r++)this.computeIntersectsForChain(n, t, r, e);
    }, ef.prototype.interfaces_ = function() {
        return [];
    }, ef.prototype.getClass = function() {
        return ef;
    };
    var nf = function t() {
        this._depth = Array(2).fill().map(function() {
            return Array(3);
        });
        for(var e = 0; e < 2; e++)for(var n = 0; n < 3; n++)this._depth[e][n] = t.NULL_VALUE;
    }, rf = {
        NULL_VALUE: {
            configurable: !0
        }
    };
    nf.prototype.getDepth = function(t, e) {
        return this._depth[t][e];
    }, nf.prototype.setDepth = function(t, e, n) {
        this._depth[t][e] = n;
    }, nf.prototype.isNull = function() {
        var t = this;
        if (0 === arguments.length) {
            for(var e = 0; e < 2; e++)for(var n = 0; n < 3; n++)if (t._depth[e][n] !== nf.NULL_VALUE) return !1;
            return !0;
        }
        if (1 === arguments.length) {
            var r = arguments[0];
            return this._depth[r][1] === nf.NULL_VALUE;
        }
        if (2 === arguments.length) {
            var i = arguments[0], o = arguments[1];
            return this._depth[i][o] === nf.NULL_VALUE;
        }
    }, nf.prototype.normalize = function() {
        for(var t = this, e = 0; e < 2; e++)if (!t.isNull(e)) {
            var n = t._depth[e][1];
            t._depth[e][2] < n && (n = t._depth[e][2]), n < 0 && (n = 0);
            for(var r = 1; r < 3; r++){
                var i = 0;
                t._depth[e][r] > n && (i = 1), t._depth[e][r] = i;
            }
        }
    }, nf.prototype.getDelta = function(t) {
        return this._depth[t][Sh.RIGHT] - this._depth[t][Sh.LEFT];
    }, nf.prototype.getLocation = function(t, e) {
        return this._depth[t][e] <= 0 ? pl.EXTERIOR : pl.INTERIOR;
    }, nf.prototype.toString = function() {
        return "A: " + this._depth[0][1] + "," + this._depth[0][2] + " B: " + this._depth[1][1] + "," + this._depth[1][2];
    }, nf.prototype.add = function() {
        var t = this;
        if (1 === arguments.length) for(var e = arguments[0], n = 0; n < 2; n++)for(var r = 1; r < 3; r++){
            var i = e.getLocation(n, r);
            i !== pl.EXTERIOR && i !== pl.INTERIOR || (t.isNull(n, r) ? t._depth[n][r] = nf.depthAtLocation(i) : t._depth[n][r] += nf.depthAtLocation(i));
        }
        else if (3 === arguments.length) {
            var o = arguments[0], s = arguments[1], a = arguments[2];
            a === pl.INTERIOR && this._depth[o][s]++;
        }
    }, nf.prototype.interfaces_ = function() {
        return [];
    }, nf.prototype.getClass = function() {
        return nf;
    }, nf.depthAtLocation = function(t) {
        return t === pl.EXTERIOR ? 0 : t === pl.INTERIOR ? 1 : nf.NULL_VALUE;
    }, rf.NULL_VALUE.get = function() {
        return -1;
    }, Object.defineProperties(nf, rf);
    var of = function(t) {
        function e() {
            if (t.call(this), this.pts = null, this._env = null, this.eiList = new $p(this), this._name = null, this._mce = null, this._isIsolated = !0, this._depth = new nf, this._depthDelta = 0, 1 === arguments.length) {
                var n = arguments[0];
                e.call(this, n, null);
            } else if (2 === arguments.length) {
                var r = arguments[0], i = arguments[1];
                this.pts = r, this._label = i;
            }
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.getDepth = function() {
            return this._depth;
        }, e.prototype.getCollapsedEdge = function() {
            var t = new Array(2).fill(null);
            return t[0] = this.pts[0], t[1] = this.pts[1], new e(t, Dh.toLineLabel(this._label));
        }, e.prototype.isIsolated = function() {
            return this._isIsolated;
        }, e.prototype.getCoordinates = function() {
            return this.pts;
        }, e.prototype.setIsolated = function(t) {
            this._isIsolated = t;
        }, e.prototype.setName = function(t) {
            this._name = t;
        }, e.prototype.equals = function(t) {
            if (!(t instanceof e)) return !1;
            var n = t;
            if (this.pts.length !== n.pts.length) return !1;
            for(var r = !0, i = !0, o = this.pts.length, s = 0; s < this.pts.length; s++)if (this.pts[s].equals2D(n.pts[s]) || (r = !1), this.pts[s].equals2D(n.pts[--o]) || (i = !1), !r && !i) return !1;
            return !0;
        }, e.prototype.getCoordinate = function() {
            if (0 === arguments.length) return this.pts.length > 0 ? this.pts[0] : null;
            if (1 === arguments.length) {
                var t = arguments[0];
                return this.pts[t];
            }
        }, e.prototype.print = function(t) {
            t.print("edge " + this._name + ": "), t.print("LINESTRING (");
            for(var e = 0; e < this.pts.length; e++)e > 0 && t.print(","), t.print(this.pts[e].x + " " + this.pts[e].y);
            t.print(")  " + this._label + " " + this._depthDelta);
        }, e.prototype.computeIM = function(t) {
            e.updateIM(this._label, t);
        }, e.prototype.isCollapsed = function() {
            return !!this._label.isArea() && 3 === this.pts.length && !!this.pts[0].equals(this.pts[2]);
        }, e.prototype.isClosed = function() {
            return this.pts[0].equals(this.pts[this.pts.length - 1]);
        }, e.prototype.getMaximumSegmentIndex = function() {
            return this.pts.length - 1;
        }, e.prototype.getDepthDelta = function() {
            return this._depthDelta;
        }, e.prototype.getNumPoints = function() {
            return this.pts.length;
        }, e.prototype.printReverse = function(t) {
            t.print("edge " + this._name + ": ");
            for(var e = this.pts.length - 1; e >= 0; e--)t.print(this.pts[e] + " ");
            t.println("");
        }, e.prototype.getMonotoneChainEdge = function() {
            return null === this._mce && (this._mce = new ef(this)), this._mce;
        }, e.prototype.getEnvelope = function() {
            if (null === this._env) {
                this._env = new Ll;
                for(var t = 0; t < this.pts.length; t++)this._env.expandToInclude(this.pts[t]);
            }
            return this._env;
        }, e.prototype.addIntersection = function(t, e, n, r) {
            var i = new ul(t.getIntersection(r)), o = e, s = t.getEdgeDistance(n, r), a = o + 1;
            if (a < this.pts.length) {
                var u = this.pts[a];
                i.equals2D(u) && (o = a, s = 0);
            }
            this.eiList.add(i, o, s);
        }, e.prototype.toString = function() {
            var t = new vl;
            t.append("edge " + this._name + ": "), t.append("LINESTRING (");
            for(var e = 0; e < this.pts.length; e++)e > 0 && t.append(","), t.append(this.pts[e].x + " " + this.pts[e].y);
            return t.append(")  " + this._label + " " + this._depthDelta), t.toString();
        }, e.prototype.isPointwiseEqual = function(t) {
            if (this.pts.length !== t.pts.length) return !1;
            for(var e = 0; e < this.pts.length; e++)if (!this.pts[e].equals2D(t.pts[e])) return !1;
            return !0;
        }, e.prototype.setDepthDelta = function(t) {
            this._depthDelta = t;
        }, e.prototype.getEdgeIntersectionList = function() {
            return this.eiList;
        }, e.prototype.addIntersections = function(t, e, n) {
            for(var r = 0; r < t.getIntersectionNum(); r++)this.addIntersection(t, e, n, r);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e.updateIM = function() {
            if (2 !== arguments.length) return t.prototype.updateIM.apply(this, arguments);
            var e = arguments[0], n = arguments[1];
            n.setAtLeastIfValid(e.getLocation(0, Sh.ON), e.getLocation(1, Sh.ON), 1), e.isArea() && (n.setAtLeastIfValid(e.getLocation(0, Sh.LEFT), e.getLocation(1, Sh.LEFT), 2), n.setAtLeastIfValid(e.getLocation(0, Sh.RIGHT), e.getLocation(1, Sh.RIGHT), 2));
        }, e;
    }(qh), sf = function(t) {
        this._workingPrecisionModel = null, this._workingNoder = null, this._geomFact = null, this._graph = null, this._edgeList = new Jp, this._bufParams = t || null;
    };
    sf.prototype.setWorkingPrecisionModel = function(t) {
        this._workingPrecisionModel = t;
    }, sf.prototype.insertUniqueEdge = function(t) {
        var e = this._edgeList.findEqualEdge(t);
        if (null !== e) {
            var n = e.getLabel(), r = t.getLabel();
            e.isPointwiseEqual(t) || (r = new Dh(t.getLabel())).flip(), n.merge(r);
            var i = sf.depthDelta(r), o = e.getDepthDelta() + i;
            e.setDepthDelta(o);
        } else this._edgeList.add(t), t.setDepthDelta(sf.depthDelta(t.getLabel()));
    }, sf.prototype.buildSubgraphs = function(t, e) {
        for(var n = new lc, r = t.iterator(); r.hasNext();){
            var i = r.next(), o = i.getRightmostCoordinate(), s = new kp(n).getDepth(o);
            i.computeDepth(s), i.findResultEdges(), n.add(i), e.add(i.getDirectedEdges(), i.getNodes());
        }
    }, sf.prototype.createSubgraphs = function(t) {
        for(var e = new lc, n = t.getNodes().iterator(); n.hasNext();){
            var r = n.next();
            if (!r.isVisited()) {
                var i = new Th;
                i.create(r), e.add(i);
            }
        }
        return np.sort(e, np.reverseOrder()), e;
    }, sf.prototype.createEmptyResultGeometry = function() {
        return this._geomFact.createPolygon();
    }, sf.prototype.getNoder = function(t) {
        if (null !== this._workingNoder) return this._workingNoder;
        var e = new Ip, n = new jl;
        return n.setPrecisionModel(t), e.setSegmentIntersector(new Kp(n)), e;
    }, sf.prototype.buffer = function(t, e) {
        var n = this._workingPrecisionModel;
        null === n && (n = t.getPrecisionModel()), this._geomFact = t.getFactory();
        var r = new Fp(n, this._bufParams), i = new zp(t, e, r).getCurves();
        if (i.size() <= 0) return this.createEmptyResultGeometry();
        this.computeNodedEdges(i, n), this._graph = new Hh(new Hp), this._graph.addEdges(this._edgeList.getEdges());
        var o = this.createSubgraphs(this._graph), s = new Wh(this._geomFact);
        this.buildSubgraphs(o, s);
        var a = s.getPolygons();
        return a.size() <= 0 ? this.createEmptyResultGeometry() : this._geomFact.buildGeometry(a);
    }, sf.prototype.computeNodedEdges = function(t, e) {
        var n = this.getNoder(e);
        n.computeNodes(t);
        for(var r = n.getNodedSubstrings().iterator(); r.hasNext();){
            var i = r.next(), o = i.getCoordinates();
            if (2 !== o.length || !o[0].equals2D(o[1])) {
                var s = i.getData(), a = new of(i.getCoordinates(), new Dh(s));
                this.insertUniqueEdge(a);
            }
        }
    }, sf.prototype.setNoder = function(t) {
        this._workingNoder = t;
    }, sf.prototype.interfaces_ = function() {
        return [];
    }, sf.prototype.getClass = function() {
        return sf;
    }, sf.depthDelta = function(t) {
        var e = t.getLocation(0, Sh.LEFT), n = t.getLocation(0, Sh.RIGHT);
        return e === pl.INTERIOR && n === pl.EXTERIOR ? 1 : e === pl.EXTERIOR && n === pl.INTERIOR ? -1 : 0;
    }, sf.convertSegStrings = function(t) {
        for(var e = new _h, n = new lc; t.hasNext();){
            var r = t.next(), i = e.createLineString(r.getCoordinates());
            n.add(i);
        }
        return e.buildGeometry(n);
    };
    var af = function() {
        if (this._noder = null, this._scaleFactor = null, this._offsetX = null, this._offsetY = null, this._isScaled = !1, 2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this._noder = t, this._scaleFactor = e, this._offsetX = 0, this._offsetY = 0, this._isScaled = !this.isIntegerPrecision();
        } else if (4 === arguments.length) {
            var n = arguments[0], r = arguments[1], i = arguments[2], o = arguments[3];
            this._noder = n, this._scaleFactor = r, this._offsetX = i, this._offsetY = o, this._isScaled = !this.isIntegerPrecision();
        }
    };
    af.prototype.rescale = function() {
        var t = this;
        if (gl(arguments[0], ic)) for(var e = arguments[0], n = e.iterator(); n.hasNext();){
            var r = n.next();
            t.rescale(r.getCoordinates());
        }
        else if (arguments[0] instanceof Array) {
            for(var i = arguments[0], o = 0; o < i.length; o++)i[o].x = i[o].x / t._scaleFactor + t._offsetX, i[o].y = i[o].y / t._scaleFactor + t._offsetY;
            2 === i.length && i[0].equals2D(i[1]) && Pl.out.println(i);
        }
    }, af.prototype.scale = function() {
        var t = this;
        if (gl(arguments[0], ic)) {
            for(var e = arguments[0], n = new lc, r = e.iterator(); r.hasNext();){
                var i = r.next();
                n.add(new yp(t.scale(i.getCoordinates()), i.getData()));
            }
            return n;
        }
        if (arguments[0] instanceof Array) {
            for(var o = arguments[0], s = new Array(o.length).fill(null), a = 0; a < o.length; a++)s[a] = new ul(Math.round((o[a].x - t._offsetX) * t._scaleFactor), Math.round((o[a].y - t._offsetY) * t._scaleFactor), o[a].z);
            var u = pc.removeRepeatedPoints(s);
            return u;
        }
    }, af.prototype.isIntegerPrecision = function() {
        return 1 === this._scaleFactor;
    }, af.prototype.getNodedSubstrings = function() {
        var t = this._noder.getNodedSubstrings();
        return this._isScaled && this.rescale(t), t;
    }, af.prototype.computeNodes = function(t) {
        var e = t;
        this._isScaled && (e = this.scale(t)), this._noder.computeNodes(e);
    }, af.prototype.interfaces_ = function() {
        return [
            bp
        ];
    }, af.prototype.getClass = function() {
        return af;
    };
    var uf = function() {
        this._li = new jl, this._segStrings = null;
        var t = arguments[0];
        this._segStrings = t;
    }, lf = {
        fact: {
            configurable: !0
        }
    };
    uf.prototype.checkEndPtVertexIntersections = function() {
        var t = this;
        if (0 === arguments.length) for(var e = this._segStrings.iterator(); e.hasNext();){
            var n = e.next(), r = n.getCoordinates();
            t.checkEndPtVertexIntersections(r[0], t._segStrings), t.checkEndPtVertexIntersections(r[r.length - 1], t._segStrings);
        }
        else if (2 === arguments.length) {
            for(var i = arguments[0], o = arguments[1], s = o.iterator(); s.hasNext();)for(var a = s.next(), u = a.getCoordinates(), l = 1; l < u.length - 1; l++)if (u[l].equals(i)) throw new kl("found endpt/interior pt intersection at index " + l + " :pt " + i);
        }
    }, uf.prototype.checkInteriorIntersections = function() {
        var t = this;
        if (0 === arguments.length) for(var e = this._segStrings.iterator(); e.hasNext();)for(var n = e.next(), r = this._segStrings.iterator(); r.hasNext();){
            var i = r.next();
            t.checkInteriorIntersections(n, i);
        }
        else if (2 === arguments.length) for(var o = arguments[0], s = arguments[1], a = o.getCoordinates(), u = s.getCoordinates(), l = 0; l < a.length - 1; l++)for(var c = 0; c < u.length - 1; c++)t.checkInteriorIntersections(o, l, s, c);
        else if (4 === arguments.length) {
            var h = arguments[0], p = arguments[1], f = arguments[2], g = arguments[3];
            if (h === f && p === g) return null;
            var d = h.getCoordinates()[p], y = h.getCoordinates()[p + 1], v = f.getCoordinates()[g], _ = f.getCoordinates()[g + 1];
            if (this._li.computeIntersection(d, y, v, _), this._li.hasIntersection() && (this._li.isProper() || this.hasInteriorIntersection(this._li, d, y) || this.hasInteriorIntersection(this._li, v, _))) throw new kl("found non-noded intersection at " + d + "-" + y + " and " + v + "-" + _);
        }
    }, uf.prototype.checkValid = function() {
        this.checkEndPtVertexIntersections(), this.checkInteriorIntersections(), this.checkCollapses();
    }, uf.prototype.checkCollapses = function() {
        var t = this;
        if (0 === arguments.length) for(var e = this._segStrings.iterator(); e.hasNext();){
            var n = e.next();
            t.checkCollapses(n);
        }
        else if (1 === arguments.length) for(var r = arguments[0], i = r.getCoordinates(), o = 0; o < i.length - 2; o++)t.checkCollapse(i[o], i[o + 1], i[o + 2]);
    }, uf.prototype.hasInteriorIntersection = function(t, e, n) {
        for(var r = 0; r < t.getIntersectionNum(); r++){
            var i = t.getIntersection(r);
            if (!i.equals(e) && !i.equals(n)) return !0;
        }
        return !1;
    }, uf.prototype.checkCollapse = function(t, e, n) {
        if (t.equals(n)) throw new kl("found non-noded collapse at " + uf.fact.createLineString([
            t,
            e,
            n
        ]));
    }, uf.prototype.interfaces_ = function() {
        return [];
    }, uf.prototype.getClass = function() {
        return uf;
    }, lf.fact.get = function() {
        return new _h;
    }, Object.defineProperties(uf, lf);
    var cf = function() {
        this._li = null, this._pt = null, this._originalPt = null, this._ptScaled = null, this._p0Scaled = null, this._p1Scaled = null, this._scaleFactor = null, this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, this._corner = new Array(4).fill(null), this._safeEnv = null;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        if (this._originalPt = t, this._pt = t, this._scaleFactor = e, this._li = n, e <= 0) throw new el("Scale factor must be non-zero");
        1 !== e && (this._pt = new ul(this.scale(t.x), this.scale(t.y)), this._p0Scaled = new ul, this._p1Scaled = new ul), this.initCorners(this._pt);
    }, hf = {
        SAFE_ENV_EXPANSION_FACTOR: {
            configurable: !0
        }
    };
    cf.prototype.intersectsScaled = function(t, e) {
        var n = Math.min(t.x, e.x), r = Math.max(t.x, e.x), i = Math.min(t.y, e.y), o = Math.max(t.y, e.y), s = this._maxx < n || this._minx > r || this._maxy < i || this._miny > o;
        if (s) return !1;
        var a = this.intersectsToleranceSquare(t, e);
        return ql.isTrue(!(s && a), "Found bad envelope test"), a;
    }, cf.prototype.initCorners = function(t) {
        var e = .5;
        this._minx = t.x - e, this._maxx = t.x + e, this._miny = t.y - e, this._maxy = t.y + e, this._corner[0] = new ul(this._maxx, this._maxy), this._corner[1] = new ul(this._minx, this._maxy), this._corner[2] = new ul(this._minx, this._miny), this._corner[3] = new ul(this._maxx, this._miny);
    }, cf.prototype.intersects = function(t, e) {
        return 1 === this._scaleFactor ? this.intersectsScaled(t, e) : (this.copyScaled(t, this._p0Scaled), this.copyScaled(e, this._p1Scaled), this.intersectsScaled(this._p0Scaled, this._p1Scaled));
    }, cf.prototype.scale = function(t) {
        return Math.round(t * this._scaleFactor);
    }, cf.prototype.getCoordinate = function() {
        return this._originalPt;
    }, cf.prototype.copyScaled = function(t, e) {
        e.x = this.scale(t.x), e.y = this.scale(t.y);
    }, cf.prototype.getSafeEnvelope = function() {
        if (null === this._safeEnv) {
            var t = cf.SAFE_ENV_EXPANSION_FACTOR / this._scaleFactor;
            this._safeEnv = new Ll(this._originalPt.x - t, this._originalPt.x + t, this._originalPt.y - t, this._originalPt.y + t);
        }
        return this._safeEnv;
    }, cf.prototype.intersectsPixelClosure = function(t, e) {
        return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), !!this._li.hasIntersection())));
    }, cf.prototype.intersectsToleranceSquare = function(t, e) {
        var n = !1, r = !1;
        return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!this._li.isProper() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), !!this._li.isProper() || (this._li.hasIntersection() && (n = !0), this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), !!this._li.isProper() || (this._li.hasIntersection() && (r = !0), this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), !!this._li.isProper() || !(!n || !r) || !!t.equals(this._pt) || !!e.equals(this._pt))));
    }, cf.prototype.addSnappedNode = function(t, e) {
        var n = t.getCoordinate(e), r = t.getCoordinate(e + 1);
        return !!this.intersects(n, r) && (t.addIntersection(this.getCoordinate(), e), !0);
    }, cf.prototype.interfaces_ = function() {
        return [];
    }, cf.prototype.getClass = function() {
        return cf;
    }, hf.SAFE_ENV_EXPANSION_FACTOR.get = function() {
        return .75;
    }, Object.defineProperties(cf, hf);
    var pf = function() {
        this.tempEnv1 = new Ll, this.selectedSegment = new vp;
    };
    pf.prototype.select = function() {
        if (1 === arguments.length) ;
        else if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            t.getLineSegment(e, this.selectedSegment), this.select(this.selectedSegment);
        }
    }, pf.prototype.interfaces_ = function() {
        return [];
    }, pf.prototype.getClass = function() {
        return pf;
    };
    var ff = function() {
        this._index = null;
        var t = arguments[0];
        this._index = t;
    }, gf = {
        HotPixelSnapAction: {
            configurable: !0
        }
    };
    ff.prototype.snap = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this.snap(t, null, -1);
        }
        if (3 === arguments.length) {
            var e = arguments[0], n = arguments[1], r = arguments[2], i = e.getSafeEnvelope(), o = new df(e, n, r);
            return this._index.query(i, {
                interfaces_: function() {
                    return [
                        Qh
                    ];
                },
                visitItem: function(t) {
                    t.select(i, o);
                }
            }), o.isNodeAdded();
        }
    }, ff.prototype.interfaces_ = function() {
        return [];
    }, ff.prototype.getClass = function() {
        return ff;
    }, gf.HotPixelSnapAction.get = function() {
        return df;
    }, Object.defineProperties(ff, gf);
    var df = function(t) {
        function e() {
            t.call(this), this._hotPixel = null, this._parentEdge = null, this._hotPixelVertexIndex = null, this._isNodeAdded = !1;
            var e = arguments[0], n = arguments[1], r = arguments[2];
            this._hotPixel = e, this._parentEdge = n, this._hotPixelVertexIndex = r;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.isNodeAdded = function() {
            return this._isNodeAdded;
        }, e.prototype.select = function() {
            if (2 !== arguments.length) return t.prototype.select.apply(this, arguments);
            var e = arguments[0], n = arguments[1], r = e.getContext();
            if (null !== this._parentEdge && r === this._parentEdge && n === this._hotPixelVertexIndex) return null;
            this._isNodeAdded = this._hotPixel.addSnappedNode(r, n);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(pf), yf = function() {
        this._li = null, this._interiorIntersections = null;
        var t = arguments[0];
        this._li = t, this._interiorIntersections = new lc;
    };
    yf.prototype.processIntersections = function(t, e, n, r) {
        if (t === n && e === r) return null;
        var i = t.getCoordinates()[e], o = t.getCoordinates()[e + 1], s = n.getCoordinates()[r], a = n.getCoordinates()[r + 1];
        if (this._li.computeIntersection(i, o, s, a), this._li.hasIntersection() && this._li.isInteriorIntersection()) {
            for(var u = 0; u < this._li.getIntersectionNum(); u++)this._interiorIntersections.add(this._li.getIntersection(u));
            t.addIntersections(this._li, e, 0), n.addIntersections(this._li, r, 1);
        }
    }, yf.prototype.isDone = function() {
        return !1;
    }, yf.prototype.getInteriorIntersections = function() {
        return this._interiorIntersections;
    }, yf.prototype.interfaces_ = function() {
        return [
            Zp
        ];
    }, yf.prototype.getClass = function() {
        return yf;
    };
    var vf = function() {
        this._pm = null, this._li = null, this._scaleFactor = null, this._noder = null, this._pointSnapper = null, this._nodedSegStrings = null;
        var t = arguments[0];
        this._pm = t, this._li = new jl, this._li.setPrecisionModel(t), this._scaleFactor = t.getScale();
    };
    vf.prototype.checkCorrectness = function(t) {
        var e = yp.getNodedSubstrings(t), n = new uf(e);
        try {
            n.checkValid();
        } catch (t) {
            if (!(t instanceof Sl)) throw t;
            t.printStackTrace();
        }
    }, vf.prototype.getNodedSubstrings = function() {
        return yp.getNodedSubstrings(this._nodedSegStrings);
    }, vf.prototype.snapRound = function(t, e) {
        var n = this.findInteriorIntersections(t, e);
        this.computeIntersectionSnaps(n), this.computeVertexSnaps(t);
    }, vf.prototype.findInteriorIntersections = function(t, e) {
        var n = new yf(e);
        return this._noder.setSegmentIntersector(n), this._noder.computeNodes(t), n.getInteriorIntersections();
    }, vf.prototype.computeVertexSnaps = function() {
        var t = this;
        if (gl(arguments[0], ic)) for(var e = arguments[0], n = e.iterator(); n.hasNext();){
            var r = n.next();
            t.computeVertexSnaps(r);
        }
        else if (arguments[0] instanceof yp) for(var i = arguments[0], o = i.getCoordinates(), s = 0; s < o.length; s++){
            var a = new cf(o[s], t._scaleFactor, t._li), u = t._pointSnapper.snap(a, i, s);
            u && i.addIntersection(o[s], s);
        }
    }, vf.prototype.computeNodes = function(t) {
        this._nodedSegStrings = t, this._noder = new Ip, this._pointSnapper = new ff(this._noder.getIndex()), this.snapRound(t, this._li);
    }, vf.prototype.computeIntersectionSnaps = function(t) {
        for(var e = this, n = t.iterator(); n.hasNext();){
            var r = n.next(), i = new cf(r, e._scaleFactor, e._li);
            e._pointSnapper.snap(i);
        }
    }, vf.prototype.interfaces_ = function() {
        return [
            bp
        ];
    }, vf.prototype.getClass = function() {
        return vf;
    };
    var _f = function() {
        if (this._argGeom = null, this._distance = null, this._bufParams = new Sp, this._resultGeometry = null, this._saveException = null, 1 === arguments.length) {
            var t = arguments[0];
            this._argGeom = t;
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this._argGeom = e, this._bufParams = n;
        }
    }, mf = {
        CAP_ROUND: {
            configurable: !0
        },
        CAP_BUTT: {
            configurable: !0
        },
        CAP_FLAT: {
            configurable: !0
        },
        CAP_SQUARE: {
            configurable: !0
        },
        MAX_PRECISION_DIGITS: {
            configurable: !0
        }
    };
    _f.prototype.bufferFixedPrecision = function(t) {
        var e = new af(new vf(new gh(1)), t.getScale()), n = new sf(this._bufParams);
        n.setWorkingPrecisionModel(t), n.setNoder(e), this._resultGeometry = n.buffer(this._argGeom, this._distance);
    }, _f.prototype.bufferReducedPrecision = function() {
        var t = this;
        if (0 === arguments.length) {
            for(var e = _f.MAX_PRECISION_DIGITS; e >= 0; e--){
                try {
                    t.bufferReducedPrecision(e);
                } catch (e) {
                    if (!(e instanceof Oh)) throw e;
                    t._saveException = e;
                }
                if (null !== t._resultGeometry) return null;
            }
            throw this._saveException;
        }
        if (1 === arguments.length) {
            var n = arguments[0], r = _f.precisionScaleFactor(this._argGeom, this._distance, n), i = new gh(r);
            this.bufferFixedPrecision(i);
        }
    }, _f.prototype.computeGeometry = function() {
        if (this.bufferOriginalPrecision(), null !== this._resultGeometry) return null;
        var t = this._argGeom.getFactory().getPrecisionModel();
        t.getType() === gh.FIXED ? this.bufferFixedPrecision(t) : this.bufferReducedPrecision();
    }, _f.prototype.setQuadrantSegments = function(t) {
        this._bufParams.setQuadrantSegments(t);
    }, _f.prototype.bufferOriginalPrecision = function() {
        try {
            var t = new sf(this._bufParams);
            this._resultGeometry = t.buffer(this._argGeom, this._distance);
        } catch (t) {
            if (!(t instanceof kl)) throw t;
            this._saveException = t;
        }
    }, _f.prototype.getResultGeometry = function(t) {
        return this._distance = t, this.computeGeometry(), this._resultGeometry;
    }, _f.prototype.setEndCapStyle = function(t) {
        this._bufParams.setEndCapStyle(t);
    }, _f.prototype.interfaces_ = function() {
        return [];
    }, _f.prototype.getClass = function() {
        return _f;
    }, _f.bufferOp = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = new _f(t), r = n.getResultGeometry(e);
            return r;
        }
        if (3 === arguments.length) {
            if (Number.isInteger(arguments[2]) && arguments[0] instanceof Wl && "number" == typeof arguments[1]) {
                var i = arguments[0], o = arguments[1], s = arguments[2], a = new _f(i);
                a.setQuadrantSegments(s);
                var u = a.getResultGeometry(o);
                return u;
            }
            if (arguments[2] instanceof Sp && arguments[0] instanceof Wl && "number" == typeof arguments[1]) {
                var l = arguments[0], c = arguments[1], h = arguments[2], p = new _f(l, h), f = p.getResultGeometry(c);
                return f;
            }
        } else if (4 === arguments.length) {
            var g = arguments[0], d = arguments[1], y = arguments[2], v = arguments[3], _ = new _f(g);
            _.setQuadrantSegments(y), _.setEndCapStyle(v);
            var m = _.getResultGeometry(d);
            return m;
        }
    }, _f.precisionScaleFactor = function(t, e, n) {
        var r = t.getEnvelopeInternal(), i = dl.max(Math.abs(r.getMaxX()), Math.abs(r.getMaxY()), Math.abs(r.getMinX()), Math.abs(r.getMinY())) + 2 * (e > 0 ? e : 0), o = n - Math.trunc(Math.log(i) / Math.log(10) + 1);
        return Math.pow(10, o);
    }, mf.CAP_ROUND.get = function() {
        return Sp.CAP_ROUND;
    }, mf.CAP_BUTT.get = function() {
        return Sp.CAP_FLAT;
    }, mf.CAP_FLAT.get = function() {
        return Sp.CAP_FLAT;
    }, mf.CAP_SQUARE.get = function() {
        return Sp.CAP_SQUARE;
    }, mf.MAX_PRECISION_DIGITS.get = function() {
        return 12;
    }, Object.defineProperties(_f, mf);
    var xf = function() {
        this._pt = [
            new ul,
            new ul
        ], this._distance = nl.NaN, this._isNull = !0;
    };
    xf.prototype.getCoordinates = function() {
        return this._pt;
    }, xf.prototype.getCoordinate = function(t) {
        return this._pt[t];
    }, xf.prototype.setMinimum = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setMinimum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            if (this._isNull) return this.initialize(e, n), null;
            var r = e.distance(n);
            r < this._distance && this.initialize(e, n, r);
        }
    }, xf.prototype.initialize = function() {
        if (0 === arguments.length) this._isNull = !0;
        else if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this._pt[0].setCoordinate(t), this._pt[1].setCoordinate(e), this._distance = t.distance(e), this._isNull = !1;
        } else if (3 === arguments.length) {
            var n = arguments[0], r = arguments[1], i = arguments[2];
            this._pt[0].setCoordinate(n), this._pt[1].setCoordinate(r), this._distance = i, this._isNull = !1;
        }
    }, xf.prototype.getDistance = function() {
        return this._distance;
    }, xf.prototype.setMaximum = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setMaximum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            if (this._isNull) return this.initialize(e, n), null;
            var r = e.distance(n);
            r > this._distance && this.initialize(e, n, r);
        }
    }, xf.prototype.interfaces_ = function() {
        return [];
    }, xf.prototype.getClass = function() {
        return xf;
    };
    var Ef = function() {};
    Ef.prototype.interfaces_ = function() {
        return [];
    }, Ef.prototype.getClass = function() {
        return Ef;
    }, Ef.computeDistance = function() {
        if (arguments[2] instanceof xf && arguments[0] instanceof Zc && arguments[1] instanceof ul) for(var t = arguments[0], e = arguments[1], n = arguments[2], r = t.getCoordinates(), i = new vp, o = 0; o < r.length - 1; o++){
            i.setCoordinates(r[o], r[o + 1]);
            var s = i.closestPoint(e);
            n.setMinimum(s, e);
        }
        else if (arguments[2] instanceof xf && arguments[0] instanceof th && arguments[1] instanceof ul) {
            var a = arguments[0], u = arguments[1], l = arguments[2];
            Ef.computeDistance(a.getExteriorRing(), u, l);
            for(var c = 0; c < a.getNumInteriorRing(); c++)Ef.computeDistance(a.getInteriorRingN(c), u, l);
        } else if (arguments[2] instanceof xf && arguments[0] instanceof Wl && arguments[1] instanceof ul) {
            var h = arguments[0], p = arguments[1], f = arguments[2];
            if (h instanceof Zc) Ef.computeDistance(h, p, f);
            else if (h instanceof th) Ef.computeDistance(h, p, f);
            else if (h instanceof kc) for(var g = h, d = 0; d < g.getNumGeometries(); d++){
                var y = g.getGeometryN(d);
                Ef.computeDistance(y, p, f);
            }
            else f.setMinimum(h.getCoordinate(), p);
        } else if (arguments[2] instanceof xf && arguments[0] instanceof vp && arguments[1] instanceof ul) {
            var v = arguments[0], _ = arguments[1], m = arguments[2], x = v.closestPoint(_);
            m.setMinimum(x, _);
        }
    };
    var bf = function(t) {
        this._maxPtDist = new xf, this._inputGeom = t || null;
    }, wf = {
        MaxPointDistanceFilter: {
            configurable: !0
        },
        MaxMidpointDistanceFilter: {
            configurable: !0
        }
    };
    bf.prototype.computeMaxMidpointDistance = function(t) {
        var e = new Nf(this._inputGeom);
        t.apply(e), this._maxPtDist.setMaximum(e.getMaxPointDistance());
    }, bf.prototype.computeMaxVertexDistance = function(t) {
        var e = new If(this._inputGeom);
        t.apply(e), this._maxPtDist.setMaximum(e.getMaxPointDistance());
    }, bf.prototype.findDistance = function(t) {
        return this.computeMaxVertexDistance(t), this.computeMaxMidpointDistance(t), this._maxPtDist.getDistance();
    }, bf.prototype.getDistancePoints = function() {
        return this._maxPtDist;
    }, bf.prototype.interfaces_ = function() {
        return [];
    }, bf.prototype.getClass = function() {
        return bf;
    }, wf.MaxPointDistanceFilter.get = function() {
        return If;
    }, wf.MaxMidpointDistanceFilter.get = function() {
        return Nf;
    }, Object.defineProperties(bf, wf);
    var If = function(t) {
        this._maxPtDist = new xf, this._minPtDist = new xf, this._geom = t || null;
    };
    If.prototype.filter = function(t) {
        this._minPtDist.initialize(), Ef.computeDistance(this._geom, t, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
    }, If.prototype.getMaxPointDistance = function() {
        return this._maxPtDist;
    }, If.prototype.interfaces_ = function() {
        return [
            Kl
        ];
    }, If.prototype.getClass = function() {
        return If;
    };
    var Nf = function(t) {
        this._maxPtDist = new xf, this._minPtDist = new xf, this._geom = t || null;
    };
    Nf.prototype.filter = function(t, e) {
        if (0 === e) return null;
        var n = t.getCoordinate(e - 1), r = t.getCoordinate(e), i = new ul((n.x + r.x) / 2, (n.y + r.y) / 2);
        this._minPtDist.initialize(), Ef.computeDistance(this._geom, i, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
    }, Nf.prototype.isDone = function() {
        return !1;
    }, Nf.prototype.isGeometryChanged = function() {
        return !1;
    }, Nf.prototype.getMaxPointDistance = function() {
        return this._maxPtDist;
    }, Nf.prototype.interfaces_ = function() {
        return [
            Fc
        ];
    }, Nf.prototype.getClass = function() {
        return Nf;
    };
    var Sf = function(t) {
        this._comps = t || null;
    };
    Sf.prototype.filter = function(t) {
        t instanceof th && this._comps.add(t);
    }, Sf.prototype.interfaces_ = function() {
        return [
            Dc
        ];
    }, Sf.prototype.getClass = function() {
        return Sf;
    }, Sf.getPolygons = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return Sf.getPolygons(t, new lc);
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return e instanceof th ? n.add(e) : e instanceof kc && e.apply(new Sf(n)), n;
        }
    };
    var Cf = function() {
        if (this._lines = null, this._isForcedToLineString = !1, 1 === arguments.length) {
            var t = arguments[0];
            this._lines = t;
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this._lines = e, this._isForcedToLineString = n;
        }
    };
    Cf.prototype.filter = function(t) {
        if (this._isForcedToLineString && t instanceof nh) {
            var e = t.getFactory().createLineString(t.getCoordinateSequence());
            return this._lines.add(e), null;
        }
        t instanceof Zc && this._lines.add(t);
    }, Cf.prototype.setForceToLineString = function(t) {
        this._isForcedToLineString = t;
    }, Cf.prototype.interfaces_ = function() {
        return [
            Hl
        ];
    }, Cf.prototype.getClass = function() {
        return Cf;
    }, Cf.getGeometry = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return t.getFactory().buildGeometry(Cf.getLines(t));
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return e.getFactory().buildGeometry(Cf.getLines(e, n));
        }
    }, Cf.getLines = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return Cf.getLines(t, !1);
        }
        if (2 === arguments.length) {
            if (gl(arguments[0], ic) && gl(arguments[1], ic)) {
                for(var e = arguments[0], n = arguments[1], r = e.iterator(); r.hasNext();){
                    var i = r.next();
                    Cf.getLines(i, n);
                }
                return n;
            }
            if (arguments[0] instanceof Wl && "boolean" == typeof arguments[1]) {
                var o = arguments[0], s = arguments[1], a = new lc;
                return o.apply(new Cf(a, s)), a;
            }
            if (arguments[0] instanceof Wl && gl(arguments[1], ic)) {
                var u = arguments[0], l = arguments[1];
                return u instanceof Zc ? l.add(u) : u.apply(new Cf(l)), l;
            }
        } else if (3 === arguments.length) {
            if ("boolean" == typeof arguments[2] && gl(arguments[0], ic) && gl(arguments[1], ic)) {
                for(var c = arguments[0], h = arguments[1], p = arguments[2], f = c.iterator(); f.hasNext();){
                    var g = f.next();
                    Cf.getLines(g, h, p);
                }
                return h;
            }
            if ("boolean" == typeof arguments[2] && arguments[0] instanceof Wl && gl(arguments[1], ic)) {
                var d = arguments[0], y = arguments[1], v = arguments[2];
                return d.apply(new Cf(y, v)), y;
            }
        }
    };
    var Pf = function() {
        if (this._boundaryRule = Ql.OGC_SFS_BOUNDARY_RULE, this._isIn = null, this._numBoundaries = null, 0 === arguments.length) ;
        else if (1 === arguments.length) {
            var t = arguments[0];
            if (null === t) throw new el("Rule must be non-null");
            this._boundaryRule = t;
        }
    };
    Pf.prototype.locateInternal = function() {
        var t = this;
        if (arguments[0] instanceof ul && arguments[1] instanceof th) {
            var e = arguments[0], n = arguments[1];
            if (n.isEmpty()) return pl.EXTERIOR;
            var r = n.getExteriorRing(), i = this.locateInPolygonRing(e, r);
            if (i === pl.EXTERIOR) return pl.EXTERIOR;
            if (i === pl.BOUNDARY) return pl.BOUNDARY;
            for(var o = 0; o < n.getNumInteriorRing(); o++){
                var s = n.getInteriorRingN(o), a = t.locateInPolygonRing(e, s);
                if (a === pl.INTERIOR) return pl.EXTERIOR;
                if (a === pl.BOUNDARY) return pl.BOUNDARY;
            }
            return pl.INTERIOR;
        }
        if (arguments[0] instanceof ul && arguments[1] instanceof Zc) {
            var u = arguments[0], l = arguments[1];
            if (!l.getEnvelopeInternal().intersects(u)) return pl.EXTERIOR;
            var c = l.getCoordinates();
            return l.isClosed() || !u.equals(c[0]) && !u.equals(c[c.length - 1]) ? Xl.isOnLine(u, c) ? pl.INTERIOR : pl.EXTERIOR : pl.BOUNDARY;
        }
        if (arguments[0] instanceof ul && arguments[1] instanceof Qc) {
            var h = arguments[0], p = arguments[1], f = p.getCoordinate();
            return f.equals2D(h) ? pl.INTERIOR : pl.EXTERIOR;
        }
    }, Pf.prototype.locateInPolygonRing = function(t, e) {
        return e.getEnvelopeInternal().intersects(t) ? Xl.locatePointInRing(t, e.getCoordinates()) : pl.EXTERIOR;
    }, Pf.prototype.intersects = function(t, e) {
        return this.locate(t, e) !== pl.EXTERIOR;
    }, Pf.prototype.updateLocationInfo = function(t) {
        t === pl.INTERIOR && (this._isIn = !0), t === pl.BOUNDARY && this._numBoundaries++;
    }, Pf.prototype.computeLocation = function(t, e) {
        var n = this;
        if (e instanceof Qc && this.updateLocationInfo(this.locateInternal(t, e)), e instanceof Zc) this.updateLocationInfo(this.locateInternal(t, e));
        else if (e instanceof th) this.updateLocationInfo(this.locateInternal(t, e));
        else if (e instanceof Gc) for(var r = e, i = 0; i < r.getNumGeometries(); i++){
            var o = r.getGeometryN(i);
            n.updateLocationInfo(n.locateInternal(t, o));
        }
        else if (e instanceof rh) for(var s = e, a = 0; a < s.getNumGeometries(); a++){
            var u = s.getGeometryN(a);
            n.updateLocationInfo(n.locateInternal(t, u));
        }
        else if (e instanceof kc) for(var l = new Up(e); l.hasNext();){
            var c = l.next();
            c !== e && n.computeLocation(t, c);
        }
    }, Pf.prototype.locate = function(t, e) {
        return e.isEmpty() ? pl.EXTERIOR : e instanceof Zc || e instanceof th ? this.locateInternal(t, e) : (this._isIn = !1, this._numBoundaries = 0, this.computeLocation(t, e), this._boundaryRule.isInBoundary(this._numBoundaries) ? pl.BOUNDARY : this._numBoundaries > 0 || this._isIn ? pl.INTERIOR : pl.EXTERIOR);
    }, Pf.prototype.interfaces_ = function() {
        return [];
    }, Pf.prototype.getClass = function() {
        return Pf;
    };
    var Mf = function t() {
        if (this._component = null, this._segIndex = null, this._pt = null, 2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            t.call(this, e, t.INSIDE_AREA, n);
        } else if (3 === arguments.length) {
            var r = arguments[0], i = arguments[1], o = arguments[2];
            this._component = r, this._segIndex = i, this._pt = o;
        }
    }, Lf = {
        INSIDE_AREA: {
            configurable: !0
        }
    };
    Mf.prototype.isInsideArea = function() {
        return this._segIndex === Mf.INSIDE_AREA;
    }, Mf.prototype.getCoordinate = function() {
        return this._pt;
    }, Mf.prototype.getGeometryComponent = function() {
        return this._component;
    }, Mf.prototype.getSegmentIndex = function() {
        return this._segIndex;
    }, Mf.prototype.interfaces_ = function() {
        return [];
    }, Mf.prototype.getClass = function() {
        return Mf;
    }, Lf.INSIDE_AREA.get = function() {
        return -1;
    }, Object.defineProperties(Mf, Lf);
    var Of = function(t) {
        this._pts = t || null;
    };
    Of.prototype.filter = function(t) {
        t instanceof Qc && this._pts.add(t);
    }, Of.prototype.interfaces_ = function() {
        return [
            Dc
        ];
    }, Of.prototype.getClass = function() {
        return Of;
    }, Of.getPoints = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return t instanceof Qc ? np.singletonList(t) : Of.getPoints(t, new lc);
        }
        if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            return e instanceof Qc ? n.add(e) : e instanceof kc && e.apply(new Of(n)), n;
        }
    };
    var Rf = function() {
        this._locations = null;
        var t = arguments[0];
        this._locations = t;
    };
    Rf.prototype.filter = function(t) {
        (t instanceof Qc || t instanceof Zc || t instanceof th) && this._locations.add(new Mf(t, 0, t.getCoordinate()));
    }, Rf.prototype.interfaces_ = function() {
        return [
            Dc
        ];
    }, Rf.prototype.getClass = function() {
        return Rf;
    }, Rf.getLocations = function(t) {
        var e = new lc;
        return t.apply(new Rf(e)), e;
    };
    var Tf = function() {
        if (this._geom = null, this._terminateDistance = 0, this._ptLocator = new Pf, this._minDistanceLocation = null, this._minDistance = nl.MAX_VALUE, 2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this._geom = [
                t,
                e
            ], this._terminateDistance = 0;
        } else if (3 === arguments.length) {
            var n = arguments[0], r = arguments[1], i = arguments[2];
            this._geom = new Array(2).fill(null), this._geom[0] = n, this._geom[1] = r, this._terminateDistance = i;
        }
    };
    Tf.prototype.computeContainmentDistance = function() {
        var t = this;
        if (0 === arguments.length) {
            var e = new Array(2).fill(null);
            if (this.computeContainmentDistance(0, e), this._minDistance <= this._terminateDistance) return null;
            this.computeContainmentDistance(1, e);
        } else if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1], i = 1 - n, o = Sf.getPolygons(this._geom[n]);
            if (o.size() > 0) {
                var s = Rf.getLocations(this._geom[i]);
                if (this.computeContainmentDistance(s, o, r), this._minDistance <= this._terminateDistance) return this._minDistanceLocation[i] = r[0], this._minDistanceLocation[n] = r[1], null;
            }
        } else if (3 === arguments.length) {
            if (arguments[2] instanceof Array && gl(arguments[0], ac) && gl(arguments[1], ac)) {
                for(var a = arguments[0], u = arguments[1], l = arguments[2], c = 0; c < a.size(); c++)for(var h = a.get(c), p = 0; p < u.size(); p++)if (t.computeContainmentDistance(h, u.get(p), l), t._minDistance <= t._terminateDistance) return null;
            } else if (arguments[2] instanceof Array && arguments[0] instanceof Mf && arguments[1] instanceof th) {
                var f = arguments[0], g = arguments[1], d = arguments[2], y = f.getCoordinate();
                if (pl.EXTERIOR !== this._ptLocator.locate(y, g)) return this._minDistance = 0, d[0] = f, d[1] = new Mf(g, y), null;
            }
        }
    }, Tf.prototype.computeMinDistanceLinesPoints = function(t, e, n) {
        for(var r = this, i = 0; i < t.size(); i++)for(var o = t.get(i), s = 0; s < e.size(); s++){
            var a = e.get(s);
            if (r.computeMinDistance(o, a, n), r._minDistance <= r._terminateDistance) return null;
        }
    }, Tf.prototype.computeFacetDistance = function() {
        var t = new Array(2).fill(null), e = Cf.getLines(this._geom[0]), n = Cf.getLines(this._geom[1]), r = Of.getPoints(this._geom[0]), i = Of.getPoints(this._geom[1]);
        return this.computeMinDistanceLines(e, n, t), this.updateMinDistance(t, !1), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistanceLinesPoints(e, i, t), this.updateMinDistance(t, !1), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistanceLinesPoints(n, r, t), this.updateMinDistance(t, !0), this._minDistance <= this._terminateDistance ? null : (t[0] = null, t[1] = null, this.computeMinDistancePoints(r, i, t), void this.updateMinDistance(t, !1))));
    }, Tf.prototype.nearestLocations = function() {
        return this.computeMinDistance(), this._minDistanceLocation;
    }, Tf.prototype.updateMinDistance = function(t, e) {
        if (null === t[0]) return null;
        e ? (this._minDistanceLocation[0] = t[1], this._minDistanceLocation[1] = t[0]) : (this._minDistanceLocation[0] = t[0], this._minDistanceLocation[1] = t[1]);
    }, Tf.prototype.nearestPoints = function() {
        return this.computeMinDistance(), [
            this._minDistanceLocation[0].getCoordinate(),
            this._minDistanceLocation[1].getCoordinate()
        ];
    }, Tf.prototype.computeMinDistance = function() {
        var t = this;
        if (0 === arguments.length) {
            if (null !== this._minDistanceLocation) return null;
            if (this._minDistanceLocation = new Array(2).fill(null), this.computeContainmentDistance(), this._minDistance <= this._terminateDistance) return null;
            this.computeFacetDistance();
        } else if (3 === arguments.length) {
            if (arguments[2] instanceof Array && arguments[0] instanceof Zc && arguments[1] instanceof Qc) {
                var e = arguments[0], n = arguments[1], r = arguments[2];
                if (e.getEnvelopeInternal().distance(n.getEnvelopeInternal()) > this._minDistance) return null;
                for(var i = e.getCoordinates(), o = n.getCoordinate(), s = 0; s < i.length - 1; s++){
                    var a = Xl.distancePointLine(o, i[s], i[s + 1]);
                    if (a < t._minDistance) {
                        t._minDistance = a;
                        var u = new vp(i[s], i[s + 1]), l = u.closestPoint(o);
                        r[0] = new Mf(e, s, l), r[1] = new Mf(n, 0, o);
                    }
                    if (t._minDistance <= t._terminateDistance) return null;
                }
            } else if (arguments[2] instanceof Array && arguments[0] instanceof Zc && arguments[1] instanceof Zc) {
                var c = arguments[0], h = arguments[1], p = arguments[2];
                if (c.getEnvelopeInternal().distance(h.getEnvelopeInternal()) > this._minDistance) return null;
                for(var f = c.getCoordinates(), g = h.getCoordinates(), d = 0; d < f.length - 1; d++)for(var y = 0; y < g.length - 1; y++){
                    var v = Xl.distanceLineLine(f[d], f[d + 1], g[y], g[y + 1]);
                    if (v < t._minDistance) {
                        t._minDistance = v;
                        var _ = new vp(f[d], f[d + 1]), m = new vp(g[y], g[y + 1]), x = _.closestPoints(m);
                        p[0] = new Mf(c, d, x[0]), p[1] = new Mf(h, y, x[1]);
                    }
                    if (t._minDistance <= t._terminateDistance) return null;
                }
            }
        }
    }, Tf.prototype.computeMinDistancePoints = function(t, e, n) {
        for(var r = this, i = 0; i < t.size(); i++)for(var o = t.get(i), s = 0; s < e.size(); s++){
            var a = e.get(s), u = o.getCoordinate().distance(a.getCoordinate());
            if (u < r._minDistance && (r._minDistance = u, n[0] = new Mf(o, 0, o.getCoordinate()), n[1] = new Mf(a, 0, a.getCoordinate())), r._minDistance <= r._terminateDistance) return null;
        }
    }, Tf.prototype.distance = function() {
        if (null === this._geom[0] || null === this._geom[1]) throw new el("null geometries are not supported");
        return this._geom[0].isEmpty() || this._geom[1].isEmpty() ? 0 : (this.computeMinDistance(), this._minDistance);
    }, Tf.prototype.computeMinDistanceLines = function(t, e, n) {
        for(var r = this, i = 0; i < t.size(); i++)for(var o = t.get(i), s = 0; s < e.size(); s++){
            var a = e.get(s);
            if (r.computeMinDistance(o, a, n), r._minDistance <= r._terminateDistance) return null;
        }
    }, Tf.prototype.interfaces_ = function() {
        return [];
    }, Tf.prototype.getClass = function() {
        return Tf;
    }, Tf.distance = function(t, e) {
        return new Tf(t, e).distance();
    }, Tf.isWithinDistance = function(t, e, n) {
        return new Tf(t, e, n).distance() <= n;
    }, Tf.nearestPoints = function(t, e) {
        return new Tf(t, e).nearestPoints();
    };
    var Af = function() {
        this._pt = [
            new ul,
            new ul
        ], this._distance = nl.NaN, this._isNull = !0;
    };
    Af.prototype.getCoordinates = function() {
        return this._pt;
    }, Af.prototype.getCoordinate = function(t) {
        return this._pt[t];
    }, Af.prototype.setMinimum = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setMinimum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            if (this._isNull) return this.initialize(e, n), null;
            var r = e.distance(n);
            r < this._distance && this.initialize(e, n, r);
        }
    }, Af.prototype.initialize = function() {
        if (0 === arguments.length) this._isNull = !0;
        else if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1];
            this._pt[0].setCoordinate(t), this._pt[1].setCoordinate(e), this._distance = t.distance(e), this._isNull = !1;
        } else if (3 === arguments.length) {
            var n = arguments[0], r = arguments[1], i = arguments[2];
            this._pt[0].setCoordinate(n), this._pt[1].setCoordinate(r), this._distance = i, this._isNull = !1;
        }
    }, Af.prototype.toString = function() {
        return Fl.toLineString(this._pt[0], this._pt[1]);
    }, Af.prototype.getDistance = function() {
        return this._distance;
    }, Af.prototype.setMaximum = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            this.setMaximum(t._pt[0], t._pt[1]);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            if (this._isNull) return this.initialize(e, n), null;
            var r = e.distance(n);
            r > this._distance && this.initialize(e, n, r);
        }
    }, Af.prototype.interfaces_ = function() {
        return [];
    }, Af.prototype.getClass = function() {
        return Af;
    };
    var Df = function() {};
    Df.prototype.interfaces_ = function() {
        return [];
    }, Df.prototype.getClass = function() {
        return Df;
    }, Df.computeDistance = function() {
        if (arguments[2] instanceof Af && arguments[0] instanceof Zc && arguments[1] instanceof ul) for(var t = arguments[0], e = arguments[1], n = arguments[2], r = new vp, i = t.getCoordinates(), o = 0; o < i.length - 1; o++){
            r.setCoordinates(i[o], i[o + 1]);
            var s = r.closestPoint(e);
            n.setMinimum(s, e);
        }
        else if (arguments[2] instanceof Af && arguments[0] instanceof th && arguments[1] instanceof ul) {
            var a = arguments[0], u = arguments[1], l = arguments[2];
            Df.computeDistance(a.getExteriorRing(), u, l);
            for(var c = 0; c < a.getNumInteriorRing(); c++)Df.computeDistance(a.getInteriorRingN(c), u, l);
        } else if (arguments[2] instanceof Af && arguments[0] instanceof Wl && arguments[1] instanceof ul) {
            var h = arguments[0], p = arguments[1], f = arguments[2];
            if (h instanceof Zc) Df.computeDistance(h, p, f);
            else if (h instanceof th) Df.computeDistance(h, p, f);
            else if (h instanceof kc) for(var g = h, d = 0; d < g.getNumGeometries(); d++){
                var y = g.getGeometryN(d);
                Df.computeDistance(y, p, f);
            }
            else f.setMinimum(h.getCoordinate(), p);
        } else if (arguments[2] instanceof Af && arguments[0] instanceof vp && arguments[1] instanceof ul) {
            var v = arguments[0], _ = arguments[1], m = arguments[2], x = v.closestPoint(_);
            m.setMinimum(x, _);
        }
    };
    var Ff = function() {
        this._g0 = null, this._g1 = null, this._ptDist = new Af, this._densifyFrac = 0;
        var t = arguments[0], e = arguments[1];
        this._g0 = t, this._g1 = e;
    }, kf = {
        MaxPointDistanceFilter: {
            configurable: !0
        },
        MaxDensifiedByFractionDistanceFilter: {
            configurable: !0
        }
    };
    Ff.prototype.getCoordinates = function() {
        return this._ptDist.getCoordinates();
    }, Ff.prototype.setDensifyFraction = function(t) {
        if (t > 1 || t <= 0) throw new el("Fraction is not in range (0.0 - 1.0]");
        this._densifyFrac = t;
    }, Ff.prototype.compute = function(t, e) {
        this.computeOrientedDistance(t, e, this._ptDist), this.computeOrientedDistance(e, t, this._ptDist);
    }, Ff.prototype.distance = function() {
        return this.compute(this._g0, this._g1), this._ptDist.getDistance();
    }, Ff.prototype.computeOrientedDistance = function(t, e, n) {
        var r = new Gf(e);
        if (t.apply(r), n.setMaximum(r.getMaxPointDistance()), this._densifyFrac > 0) {
            var i = new qf(e, this._densifyFrac);
            t.apply(i), n.setMaximum(i.getMaxPointDistance());
        }
    }, Ff.prototype.orientedDistance = function() {
        return this.computeOrientedDistance(this._g0, this._g1, this._ptDist), this._ptDist.getDistance();
    }, Ff.prototype.interfaces_ = function() {
        return [];
    }, Ff.prototype.getClass = function() {
        return Ff;
    }, Ff.distance = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = new Ff(t, e);
            return n.distance();
        }
        if (3 === arguments.length) {
            var r = arguments[0], i = arguments[1], o = arguments[2], s = new Ff(r, i);
            return s.setDensifyFraction(o), s.distance();
        }
    }, kf.MaxPointDistanceFilter.get = function() {
        return Gf;
    }, kf.MaxDensifiedByFractionDistanceFilter.get = function() {
        return qf;
    }, Object.defineProperties(Ff, kf);
    var Gf = function() {
        this._maxPtDist = new Af, this._minPtDist = new Af, this._euclideanDist = new Df, this._geom = null;
        var t = arguments[0];
        this._geom = t;
    };
    Gf.prototype.filter = function(t) {
        this._minPtDist.initialize(), Df.computeDistance(this._geom, t, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
    }, Gf.prototype.getMaxPointDistance = function() {
        return this._maxPtDist;
    }, Gf.prototype.interfaces_ = function() {
        return [
            Kl
        ];
    }, Gf.prototype.getClass = function() {
        return Gf;
    };
    var qf = function() {
        this._maxPtDist = new Af, this._minPtDist = new Af, this._geom = null, this._numSubSegs = 0;
        var t = arguments[0], e = arguments[1];
        this._geom = t, this._numSubSegs = Math.trunc(Math.round(1 / e));
    };
    qf.prototype.filter = function(t, e) {
        var n = this;
        if (0 === e) return null;
        for(var r = t.getCoordinate(e - 1), i = t.getCoordinate(e), o = (i.x - r.x) / this._numSubSegs, s = (i.y - r.y) / this._numSubSegs, a = 0; a < this._numSubSegs; a++){
            var u = r.x + a * o, l = r.y + a * s, c = new ul(u, l);
            n._minPtDist.initialize(), Df.computeDistance(n._geom, c, n._minPtDist), n._maxPtDist.setMaximum(n._minPtDist);
        }
    }, qf.prototype.isDone = function() {
        return !1;
    }, qf.prototype.isGeometryChanged = function() {
        return !1;
    }, qf.prototype.getMaxPointDistance = function() {
        return this._maxPtDist;
    }, qf.prototype.interfaces_ = function() {
        return [
            Fc
        ];
    }, qf.prototype.getClass = function() {
        return qf;
    };
    var Bf = function(t, e, n) {
        this._minValidDistance = null, this._maxValidDistance = null, this._minDistanceFound = null, this._maxDistanceFound = null, this._isValid = !0, this._errMsg = null, this._errorLocation = null, this._errorIndicator = null, this._input = t || null, this._bufDistance = e || null, this._result = n || null;
    }, zf = {
        VERBOSE: {
            configurable: !0
        },
        MAX_DISTANCE_DIFF_FRAC: {
            configurable: !0
        }
    };
    Bf.prototype.checkMaximumDistance = function(t, e, n) {
        var r = new Ff(e, t);
        if (r.setDensifyFraction(.25), this._maxDistanceFound = r.orientedDistance(), this._maxDistanceFound > n) {
            this._isValid = !1;
            var i = r.getCoordinates();
            this._errorLocation = i[1], this._errorIndicator = t.getFactory().createLineString(i), this._errMsg = "Distance between buffer curve and input is too large (" + this._maxDistanceFound + " at " + Fl.toLineString(i[0], i[1]) + ")";
        }
    }, Bf.prototype.isValid = function() {
        var t = Math.abs(this._bufDistance), e = Bf.MAX_DISTANCE_DIFF_FRAC * t;
        return this._minValidDistance = t - e, this._maxValidDistance = t + e, !(!this._input.isEmpty() && !this._result.isEmpty()) || (this._bufDistance > 0 ? this.checkPositiveValid() : this.checkNegativeValid(), Bf.VERBOSE && Pl.out.println("Min Dist= " + this._minDistanceFound + "  err= " + (1 - this._minDistanceFound / this._bufDistance) + "  Max Dist= " + this._maxDistanceFound + "  err= " + (this._maxDistanceFound / this._bufDistance - 1)), this._isValid);
    }, Bf.prototype.checkNegativeValid = function() {
        if (!(this._input instanceof th || this._input instanceof rh || this._input instanceof kc)) return null;
        var t = this.getPolygonLines(this._input);
        if (this.checkMinimumDistance(t, this._result, this._minValidDistance), !this._isValid) return null;
        this.checkMaximumDistance(t, this._result, this._maxValidDistance);
    }, Bf.prototype.getErrorIndicator = function() {
        return this._errorIndicator;
    }, Bf.prototype.checkMinimumDistance = function(t, e, n) {
        var r = new Tf(t, e, n);
        if (this._minDistanceFound = r.distance(), this._minDistanceFound < n) {
            this._isValid = !1;
            var i = r.nearestPoints();
            this._errorLocation = r.nearestPoints()[1], this._errorIndicator = t.getFactory().createLineString(i), this._errMsg = "Distance between buffer curve and input is too small (" + this._minDistanceFound + " at " + Fl.toLineString(i[0], i[1]) + " )";
        }
    }, Bf.prototype.checkPositiveValid = function() {
        var t = this._result.getBoundary();
        if (this.checkMinimumDistance(this._input, t, this._minValidDistance), !this._isValid) return null;
        this.checkMaximumDistance(this._input, t, this._maxValidDistance);
    }, Bf.prototype.getErrorLocation = function() {
        return this._errorLocation;
    }, Bf.prototype.getPolygonLines = function(t) {
        for(var e = new lc, n = new Cf(e), r = Sf.getPolygons(t).iterator(); r.hasNext();)r.next().apply(n);
        return t.getFactory().buildGeometry(e);
    }, Bf.prototype.getErrorMessage = function() {
        return this._errMsg;
    }, Bf.prototype.interfaces_ = function() {
        return [];
    }, Bf.prototype.getClass = function() {
        return Bf;
    }, zf.VERBOSE.get = function() {
        return !1;
    }, zf.MAX_DISTANCE_DIFF_FRAC.get = function() {
        return .012;
    }, Object.defineProperties(Bf, zf);
    var jf = function(t, e, n) {
        this._isValid = !0, this._errorMsg = null, this._errorLocation = null, this._errorIndicator = null, this._input = t || null, this._distance = e || null, this._result = n || null;
    }, Uf = {
        VERBOSE: {
            configurable: !0
        },
        MAX_ENV_DIFF_FRAC: {
            configurable: !0
        }
    };
    jf.prototype.isValid = function() {
        return this.checkPolygonal(), this._isValid ? (this.checkExpectedEmpty(), this._isValid ? (this.checkEnvelope(), this._isValid ? (this.checkArea(), this._isValid ? (this.checkDistance(), this._isValid) : this._isValid) : this._isValid) : this._isValid) : this._isValid;
    }, jf.prototype.checkEnvelope = function() {
        if (this._distance < 0) return null;
        var t = this._distance * jf.MAX_ENV_DIFF_FRAC;
        0 === t && (t = .001);
        var e = new Ll(this._input.getEnvelopeInternal());
        e.expandBy(this._distance);
        var n = new Ll(this._result.getEnvelopeInternal());
        n.expandBy(t), n.contains(e) || (this._isValid = !1, this._errorMsg = "Buffer envelope is incorrect", this._errorIndicator = this._input.getFactory().toGeometry(n)), this.report("Envelope");
    }, jf.prototype.checkDistance = function() {
        var t = new Bf(this._input, this._distance, this._result);
        t.isValid() || (this._isValid = !1, this._errorMsg = t.getErrorMessage(), this._errorLocation = t.getErrorLocation(), this._errorIndicator = t.getErrorIndicator()), this.report("Distance");
    }, jf.prototype.checkArea = function() {
        var t = this._input.getArea(), e = this._result.getArea();
        this._distance > 0 && t > e && (this._isValid = !1, this._errorMsg = "Area of positive buffer is smaller than input", this._errorIndicator = this._result), this._distance < 0 && t < e && (this._isValid = !1, this._errorMsg = "Area of negative buffer is larger than input", this._errorIndicator = this._result), this.report("Area");
    }, jf.prototype.checkPolygonal = function() {
        this._result instanceof th || this._result instanceof rh || (this._isValid = !1), this._errorMsg = "Result is not polygonal", this._errorIndicator = this._result, this.report("Polygonal");
    }, jf.prototype.getErrorIndicator = function() {
        return this._errorIndicator;
    }, jf.prototype.getErrorLocation = function() {
        return this._errorLocation;
    }, jf.prototype.checkExpectedEmpty = function() {
        return this._input.getDimension() >= 2 || this._distance > 0 ? null : (this._result.isEmpty() || (this._isValid = !1, this._errorMsg = "Result is non-empty", this._errorIndicator = this._result), void this.report("ExpectedEmpty"));
    }, jf.prototype.report = function(t) {
        if (!jf.VERBOSE) return null;
        Pl.out.println("Check " + t + ": " + (this._isValid ? "passed" : "FAILED"));
    }, jf.prototype.getErrorMessage = function() {
        return this._errorMsg;
    }, jf.prototype.interfaces_ = function() {
        return [];
    }, jf.prototype.getClass = function() {
        return jf;
    }, jf.isValidMsg = function(t, e, n) {
        var r = new jf(t, e, n);
        return r.isValid() ? null : r.getErrorMessage();
    }, jf.isValid = function(t, e, n) {
        return !!new jf(t, e, n).isValid();
    }, Uf.VERBOSE.get = function() {
        return !1;
    }, Uf.MAX_ENV_DIFF_FRAC.get = function() {
        return .012;
    }, Object.defineProperties(jf, Uf);
    var Vf = function() {
        this._pts = null, this._data = null;
        var t = arguments[0], e = arguments[1];
        this._pts = t, this._data = e;
    };
    Vf.prototype.getCoordinates = function() {
        return this._pts;
    }, Vf.prototype.size = function() {
        return this._pts.length;
    }, Vf.prototype.getCoordinate = function(t) {
        return this._pts[t];
    }, Vf.prototype.isClosed = function() {
        return this._pts[0].equals(this._pts[this._pts.length - 1]);
    }, Vf.prototype.getSegmentOctant = function(t) {
        return t === this._pts.length - 1 ? -1 : fp.octant(this.getCoordinate(t), this.getCoordinate(t + 1));
    }, Vf.prototype.setData = function(t) {
        this._data = t;
    }, Vf.prototype.getData = function() {
        return this._data;
    }, Vf.prototype.toString = function() {
        return Fl.toLineString(new lh(this._pts));
    }, Vf.prototype.interfaces_ = function() {
        return [
            gp
        ];
    }, Vf.prototype.getClass = function() {
        return Vf;
    };
    var Xf = function() {
        this._findAllIntersections = !1, this._isCheckEndSegmentsOnly = !1, this._li = null, this._interiorIntersection = null, this._intSegments = null, this._intersections = new lc, this._intersectionCount = 0, this._keepIntersections = !0;
        var t = arguments[0];
        this._li = t, this._interiorIntersection = null;
    };
    Xf.prototype.getInteriorIntersection = function() {
        return this._interiorIntersection;
    }, Xf.prototype.setCheckEndSegmentsOnly = function(t) {
        this._isCheckEndSegmentsOnly = t;
    }, Xf.prototype.getIntersectionSegments = function() {
        return this._intSegments;
    }, Xf.prototype.count = function() {
        return this._intersectionCount;
    }, Xf.prototype.getIntersections = function() {
        return this._intersections;
    }, Xf.prototype.setFindAllIntersections = function(t) {
        this._findAllIntersections = t;
    }, Xf.prototype.setKeepIntersections = function(t) {
        this._keepIntersections = t;
    }, Xf.prototype.processIntersections = function(t, e, n, r) {
        if (!this._findAllIntersections && this.hasIntersection()) return null;
        if (t === n && e === r) return null;
        if (this._isCheckEndSegmentsOnly && !(this.isEndSegment(t, e) || this.isEndSegment(n, r))) return null;
        var i = t.getCoordinates()[e], o = t.getCoordinates()[e + 1], s = n.getCoordinates()[r], a = n.getCoordinates()[r + 1];
        this._li.computeIntersection(i, o, s, a), this._li.hasIntersection() && this._li.isInteriorIntersection() && (this._intSegments = new Array(4).fill(null), this._intSegments[0] = i, this._intSegments[1] = o, this._intSegments[2] = s, this._intSegments[3] = a, this._interiorIntersection = this._li.getIntersection(0), this._keepIntersections && this._intersections.add(this._interiorIntersection), this._intersectionCount++);
    }, Xf.prototype.isEndSegment = function(t, e) {
        return 0 === e || e >= t.size() - 2;
    }, Xf.prototype.hasIntersection = function() {
        return null !== this._interiorIntersection;
    }, Xf.prototype.isDone = function() {
        return !this._findAllIntersections && null !== this._interiorIntersection;
    }, Xf.prototype.interfaces_ = function() {
        return [
            Zp
        ];
    }, Xf.prototype.getClass = function() {
        return Xf;
    }, Xf.createAllIntersectionsFinder = function(t) {
        var e = new Xf(t);
        return e.setFindAllIntersections(!0), e;
    }, Xf.createAnyIntersectionFinder = function(t) {
        return new Xf(t);
    }, Xf.createIntersectionCounter = function(t) {
        var e = new Xf(t);
        return e.setFindAllIntersections(!0), e.setKeepIntersections(!1), e;
    };
    var Yf = function() {
        this._li = new jl, this._segStrings = null, this._findAllIntersections = !1, this._segInt = null, this._isValid = !0;
        var t = arguments[0];
        this._segStrings = t;
    };
    Yf.prototype.execute = function() {
        if (null !== this._segInt) return null;
        this.checkInteriorIntersections();
    }, Yf.prototype.getIntersections = function() {
        return this._segInt.getIntersections();
    }, Yf.prototype.isValid = function() {
        return this.execute(), this._isValid;
    }, Yf.prototype.setFindAllIntersections = function(t) {
        this._findAllIntersections = t;
    }, Yf.prototype.checkInteriorIntersections = function() {
        this._isValid = !0, this._segInt = new Xf(this._li), this._segInt.setFindAllIntersections(this._findAllIntersections);
        var t = new Ip;
        if (t.setSegmentIntersector(this._segInt), t.computeNodes(this._segStrings), this._segInt.hasIntersection()) return this._isValid = !1, null;
    }, Yf.prototype.checkValid = function() {
        if (this.execute(), !this._isValid) throw new Oh(this.getErrorMessage(), this._segInt.getInteriorIntersection());
    }, Yf.prototype.getErrorMessage = function() {
        if (this._isValid) return "no intersections found";
        var t = this._segInt.getIntersectionSegments();
        return "found non-noded intersection between " + Fl.toLineString(t[0], t[1]) + " and " + Fl.toLineString(t[2], t[3]);
    }, Yf.prototype.interfaces_ = function() {
        return [];
    }, Yf.prototype.getClass = function() {
        return Yf;
    }, Yf.computeIntersections = function(t) {
        var e = new Yf(t);
        return e.setFindAllIntersections(!0), e.isValid(), e.getIntersections();
    };
    var Hf = function t() {
        this._nv = null;
        var e = arguments[0];
        this._nv = new Yf(t.toSegmentStrings(e));
    };
    Hf.prototype.checkValid = function() {
        this._nv.checkValid();
    }, Hf.prototype.interfaces_ = function() {
        return [];
    }, Hf.prototype.getClass = function() {
        return Hf;
    }, Hf.toSegmentStrings = function(t) {
        for(var e = new lc, n = t.iterator(); n.hasNext();){
            var r = n.next();
            e.add(new Vf(r.getCoordinates(), r));
        }
        return e;
    }, Hf.checkValid = function(t) {
        new Hf(t).checkValid();
    };
    var Wf = function(t) {
        this._mapOp = t;
    };
    Wf.prototype.map = function(t) {
        for(var e = new lc, n = 0; n < t.getNumGeometries(); n++){
            var r = this._mapOp.map(t.getGeometryN(n));
            r.isEmpty() || e.add(r);
        }
        return t.getFactory().createGeometryCollection(_h.toGeometryArray(e));
    }, Wf.prototype.interfaces_ = function() {
        return [];
    }, Wf.prototype.getClass = function() {
        return Wf;
    }, Wf.map = function(t, e) {
        return new Wf(e).map(t);
    };
    var Jf = function() {
        this._op = null, this._geometryFactory = null, this._ptLocator = null, this._lineEdgesList = new lc, this._resultLineList = new lc;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        this._op = t, this._geometryFactory = e, this._ptLocator = n;
    };
    Jf.prototype.collectLines = function(t) {
        for(var e = this, n = this._op.getGraph().getEdgeEnds().iterator(); n.hasNext();){
            var r = n.next();
            e.collectLineEdge(r, t, e._lineEdgesList), e.collectBoundaryTouchEdge(r, t, e._lineEdgesList);
        }
    }, Jf.prototype.labelIsolatedLine = function(t, e) {
        var n = this._ptLocator.locate(t.getCoordinate(), this._op.getArgGeometry(e));
        t.getLabel().setLocation(e, n);
    }, Jf.prototype.build = function(t) {
        return this.findCoveredLineEdges(), this.collectLines(t), this.buildLines(t), this._resultLineList;
    }, Jf.prototype.collectLineEdge = function(t, e, n) {
        var r = t.getLabel(), i = t.getEdge();
        t.isLineEdge() && (t.isVisited() || !Mg.isResultOfOp(r, e) || i.isCovered() || (n.add(i), t.setVisitedEdge(!0)));
    }, Jf.prototype.findCoveredLineEdges = function() {
        for(var t = this._op.getGraph().getNodes().iterator(); t.hasNext();)t.next().getEdges().findCoveredLineEdges();
        for(var e = this._op.getGraph().getEdgeEnds().iterator(); e.hasNext();){
            var n = e.next(), r = n.getEdge();
            if (n.isLineEdge() && !r.isCoveredSet()) {
                var i = this._op.isCoveredByA(n.getCoordinate());
                r.setCovered(i);
            }
        }
    }, Jf.prototype.labelIsolatedLines = function(t) {
        for(var e = t.iterator(); e.hasNext();){
            var n = e.next(), r = n.getLabel();
            n.isIsolated() && (r.isNull(0) ? this.labelIsolatedLine(n, 0) : this.labelIsolatedLine(n, 1));
        }
    }, Jf.prototype.buildLines = function(t) {
        for(var e = this._lineEdgesList.iterator(); e.hasNext();){
            var n = e.next(), r = this._geometryFactory.createLineString(n.getCoordinates());
            this._resultLineList.add(r), n.setInResult(!0);
        }
    }, Jf.prototype.collectBoundaryTouchEdge = function(t, e, n) {
        var r = t.getLabel();
        return t.isLineEdge() || t.isVisited() || t.isInteriorAreaEdge() || t.getEdge().isInResult() ? null : (ql.isTrue(!(t.isInResult() || t.getSym().isInResult()) || !t.getEdge().isInResult()), void (Mg.isResultOfOp(r, e) && e === Mg.INTERSECTION && (n.add(t.getEdge()), t.setVisitedEdge(!0))));
    }, Jf.prototype.interfaces_ = function() {
        return [];
    }, Jf.prototype.getClass = function() {
        return Jf;
    };
    var Zf = function() {
        this._op = null, this._geometryFactory = null, this._resultPointList = new lc;
        var t = arguments[0], e = arguments[1];
        this._op = t, this._geometryFactory = e;
    };
    Zf.prototype.filterCoveredNodeToPoint = function(t) {
        var e = t.getCoordinate();
        if (!this._op.isCoveredByLA(e)) {
            var n = this._geometryFactory.createPoint(e);
            this._resultPointList.add(n);
        }
    }, Zf.prototype.extractNonCoveredResultNodes = function(t) {
        for(var e = this._op.getGraph().getNodes().iterator(); e.hasNext();){
            var n = e.next();
            if (!n.isInResult() && !n.isIncidentEdgeInResult() && (0 === n.getEdges().getDegree() || t === Mg.INTERSECTION)) {
                var r = n.getLabel();
                Mg.isResultOfOp(r, t) && this.filterCoveredNodeToPoint(n);
            }
        }
    }, Zf.prototype.build = function(t) {
        return this.extractNonCoveredResultNodes(t), this._resultPointList;
    }, Zf.prototype.interfaces_ = function() {
        return [];
    }, Zf.prototype.getClass = function() {
        return Zf;
    };
    var Kf = function() {
        this._inputGeom = null, this._factory = null, this._pruneEmptyGeometry = !0, this._preserveGeometryCollectionType = !0, this._preserveCollections = !1, this._preserveType = !1;
    };
    Kf.prototype.transformPoint = function(t, e) {
        return this._factory.createPoint(this.transformCoordinates(t.getCoordinateSequence(), t));
    }, Kf.prototype.transformPolygon = function(t, e) {
        var n = !0, r = this.transformLinearRing(t.getExteriorRing(), t);
        null !== r && r instanceof nh && !r.isEmpty() || (n = !1);
        for(var i = new lc, o = 0; o < t.getNumInteriorRing(); o++){
            var s = this.transformLinearRing(t.getInteriorRingN(o), t);
            null === s || s.isEmpty() || (s instanceof nh || (n = !1), i.add(s));
        }
        if (n) return this._factory.createPolygon(r, i.toArray([]));
        var a = new lc;
        return null !== r && a.add(r), a.addAll(i), this._factory.buildGeometry(a);
    }, Kf.prototype.createCoordinateSequence = function(t) {
        return this._factory.getCoordinateSequenceFactory().create(t);
    }, Kf.prototype.getInputGeometry = function() {
        return this._inputGeom;
    }, Kf.prototype.transformMultiLineString = function(t, e) {
        for(var n = new lc, r = 0; r < t.getNumGeometries(); r++){
            var i = this.transformLineString(t.getGeometryN(r), t);
            null !== i && (i.isEmpty() || n.add(i));
        }
        return this._factory.buildGeometry(n);
    }, Kf.prototype.transformCoordinates = function(t, e) {
        return this.copy(t);
    }, Kf.prototype.transformLineString = function(t, e) {
        return this._factory.createLineString(this.transformCoordinates(t.getCoordinateSequence(), t));
    }, Kf.prototype.transformMultiPoint = function(t, e) {
        for(var n = new lc, r = 0; r < t.getNumGeometries(); r++){
            var i = this.transformPoint(t.getGeometryN(r), t);
            null !== i && (i.isEmpty() || n.add(i));
        }
        return this._factory.buildGeometry(n);
    }, Kf.prototype.transformMultiPolygon = function(t, e) {
        for(var n = new lc, r = 0; r < t.getNumGeometries(); r++){
            var i = this.transformPolygon(t.getGeometryN(r), t);
            null !== i && (i.isEmpty() || n.add(i));
        }
        return this._factory.buildGeometry(n);
    }, Kf.prototype.copy = function(t) {
        return t.copy();
    }, Kf.prototype.transformGeometryCollection = function(t, e) {
        for(var n = new lc, r = 0; r < t.getNumGeometries(); r++){
            var i = this.transform(t.getGeometryN(r));
            null !== i && (this._pruneEmptyGeometry && i.isEmpty() || n.add(i));
        }
        return this._preserveGeometryCollectionType ? this._factory.createGeometryCollection(_h.toGeometryArray(n)) : this._factory.buildGeometry(n);
    }, Kf.prototype.transform = function(t) {
        if (this._inputGeom = t, this._factory = t.getFactory(), t instanceof Qc) return this.transformPoint(t, null);
        if (t instanceof eh) return this.transformMultiPoint(t, null);
        if (t instanceof nh) return this.transformLinearRing(t, null);
        if (t instanceof Zc) return this.transformLineString(t, null);
        if (t instanceof Gc) return this.transformMultiLineString(t, null);
        if (t instanceof th) return this.transformPolygon(t, null);
        if (t instanceof rh) return this.transformMultiPolygon(t, null);
        if (t instanceof kc) return this.transformGeometryCollection(t, null);
        throw new el("Unknown Geometry subtype: " + t.getClass().getName());
    }, Kf.prototype.transformLinearRing = function(t, e) {
        var n = this.transformCoordinates(t.getCoordinateSequence(), t);
        if (null === n) return this._factory.createLinearRing(null);
        var r = n.size();
        return r > 0 && r < 4 && !this._preserveType ? this._factory.createLineString(n) : this._factory.createLinearRing(n);
    }, Kf.prototype.interfaces_ = function() {
        return [];
    }, Kf.prototype.getClass = function() {
        return Kf;
    };
    var Qf = function t() {
        if (this._snapTolerance = 0, this._srcPts = null, this._seg = new vp, this._allowSnappingToSourceVertices = !1, this._isClosed = !1, arguments[0] instanceof Zc && "number" == typeof arguments[1]) {
            var e = arguments[0], n = arguments[1];
            t.call(this, e.getCoordinates(), n);
        } else if (arguments[0] instanceof Array && "number" == typeof arguments[1]) {
            var r = arguments[0], i = arguments[1];
            this._srcPts = r, this._isClosed = t.isClosed(r), this._snapTolerance = i;
        }
    };
    Qf.prototype.snapVertices = function(t, e) {
        for(var n = this._isClosed ? t.size() - 1 : t.size(), r = 0; r < n; r++){
            var i = t.get(r), o = this.findSnapForVertex(i, e);
            null !== o && (t.set(r, new ul(o)), 0 === r && this._isClosed && t.set(t.size() - 1, new ul(o)));
        }
    }, Qf.prototype.findSnapForVertex = function(t, e) {
        for(var n = 0; n < e.length; n++){
            if (t.equals2D(e[n])) return null;
            if (t.distance(e[n]) < this._snapTolerance) return e[n];
        }
        return null;
    }, Qf.prototype.snapTo = function(t) {
        var e = new hc(this._srcPts);
        return this.snapVertices(e, t), this.snapSegments(e, t), e.toCoordinateArray();
    }, Qf.prototype.snapSegments = function(t, e) {
        if (0 === e.length) return null;
        var n = e.length;
        e[0].equals2D(e[e.length - 1]) && (n = e.length - 1);
        for(var r = 0; r < n; r++){
            var i = e[r], o = this.findSegmentIndexToSnap(i, t);
            o >= 0 && t.add(o + 1, new ul(i), !1);
        }
    }, Qf.prototype.findSegmentIndexToSnap = function(t, e) {
        for(var n = this, r = nl.MAX_VALUE, i = -1, o = 0; o < e.size() - 1; o++){
            if (n._seg.p0 = e.get(o), n._seg.p1 = e.get(o + 1), n._seg.p0.equals2D(t) || n._seg.p1.equals2D(t)) {
                if (n._allowSnappingToSourceVertices) continue;
                return -1;
            }
            var s = n._seg.distance(t);
            s < n._snapTolerance && s < r && (r = s, i = o);
        }
        return i;
    }, Qf.prototype.setAllowSnappingToSourceVertices = function(t) {
        this._allowSnappingToSourceVertices = t;
    }, Qf.prototype.interfaces_ = function() {
        return [];
    }, Qf.prototype.getClass = function() {
        return Qf;
    }, Qf.isClosed = function(t) {
        return !(t.length <= 1) && t[0].equals2D(t[t.length - 1]);
    };
    var $f = function(t) {
        this._srcGeom = t || null;
    }, tg = {
        SNAP_PRECISION_FACTOR: {
            configurable: !0
        }
    };
    $f.prototype.snapTo = function(t, e) {
        var n = this.extractTargetCoordinates(t);
        return new eg(e, n).transform(this._srcGeom);
    }, $f.prototype.snapToSelf = function(t, e) {
        var n = this.extractTargetCoordinates(this._srcGeom), r = new eg(t, n, !0).transform(this._srcGeom), i = r;
        return e && gl(i, $c) && (i = r.buffer(0)), i;
    }, $f.prototype.computeSnapTolerance = function(t) {
        return this.computeMinimumSegmentLength(t) / 10;
    }, $f.prototype.extractTargetCoordinates = function(t) {
        for(var e = new Lc, n = t.getCoordinates(), r = 0; r < n.length; r++)e.add(n[r]);
        return e.toArray(new Array(0).fill(null));
    }, $f.prototype.computeMinimumSegmentLength = function(t) {
        for(var e = nl.MAX_VALUE, n = 0; n < t.length - 1; n++){
            var r = t[n].distance(t[n + 1]);
            r < e && (e = r);
        }
        return e;
    }, $f.prototype.interfaces_ = function() {
        return [];
    }, $f.prototype.getClass = function() {
        return $f;
    }, $f.snap = function(t, e, n) {
        var r = new Array(2).fill(null), i = new $f(t);
        r[0] = i.snapTo(e, n);
        var o = new $f(e);
        return r[1] = o.snapTo(r[0], n), r;
    }, $f.computeOverlaySnapTolerance = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = $f.computeSizeBasedSnapTolerance(t), n = t.getPrecisionModel();
            if (n.getType() === gh.FIXED) {
                var r = 1 / n.getScale() * 2 / 1.415;
                r > e && (e = r);
            }
            return e;
        }
        if (2 === arguments.length) {
            var i = arguments[0], o = arguments[1];
            return Math.min($f.computeOverlaySnapTolerance(i), $f.computeOverlaySnapTolerance(o));
        }
    }, $f.computeSizeBasedSnapTolerance = function(t) {
        var e = t.getEnvelopeInternal();
        return Math.min(e.getHeight(), e.getWidth()) * $f.SNAP_PRECISION_FACTOR;
    }, $f.snapToSelf = function(t, e, n) {
        return new $f(t).snapToSelf(e, n);
    }, tg.SNAP_PRECISION_FACTOR.get = function() {
        return 1e-9;
    }, Object.defineProperties($f, tg);
    var eg = function(t) {
        function e(e, n, r) {
            t.call(this), this._snapTolerance = e || null, this._snapPts = n || null, this._isSelfSnap = void 0 !== r && r;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.snapLine = function(t, e) {
            var n = new Qf(t, this._snapTolerance);
            return n.setAllowSnappingToSourceVertices(this._isSelfSnap), n.snapTo(e);
        }, e.prototype.transformCoordinates = function(t, e) {
            var n = t.toCoordinateArray(), r = this.snapLine(n, this._snapPts);
            return this._factory.getCoordinateSequenceFactory().create(r);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Kf), ng = function() {
        this._isFirst = !0, this._commonMantissaBitsCount = 53, this._commonBits = 0, this._commonSignExp = null;
    };
    ng.prototype.getCommon = function() {
        return nl.longBitsToDouble(this._commonBits);
    }, ng.prototype.add = function(t) {
        var e = nl.doubleToLongBits(t);
        return this._isFirst ? (this._commonBits = e, this._commonSignExp = ng.signExpBits(this._commonBits), this._isFirst = !1, null) : ng.signExpBits(e) !== this._commonSignExp ? (this._commonBits = 0, null) : (this._commonMantissaBitsCount = ng.numCommonMostSigMantissaBits(this._commonBits, e), void (this._commonBits = ng.zeroLowerBits(this._commonBits, 64 - (12 + this._commonMantissaBitsCount))));
    }, ng.prototype.toString = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = nl.longBitsToDouble(t), n = nl.toBinaryString(t), r = "0000000000000000000000000000000000000000000000000000000000000000" + n, i = r.substring(r.length - 64), o = i.substring(0, 1) + "  " + i.substring(1, 12) + "(exp) " + i.substring(12) + " [ " + e + " ]";
            return o;
        }
    }, ng.prototype.interfaces_ = function() {
        return [];
    }, ng.prototype.getClass = function() {
        return ng;
    }, ng.getBit = function(t, e) {
        return 0 != (t & 1 << e) ? 1 : 0;
    }, ng.signExpBits = function(t) {
        return t >> 52;
    }, ng.zeroLowerBits = function(t, e) {
        return t & ~((1 << e) - 1);
    }, ng.numCommonMostSigMantissaBits = function(t, e) {
        for(var n = 0, r = 52; r >= 0; r--){
            if (ng.getBit(t, r) !== ng.getBit(e, r)) return n;
            n++;
        }
        return 52;
    };
    var rg = function() {
        this._commonCoord = null, this._ccFilter = new og;
    }, ig = {
        CommonCoordinateFilter: {
            configurable: !0
        },
        Translater: {
            configurable: !0
        }
    };
    rg.prototype.addCommonBits = function(t) {
        var e = new sg(this._commonCoord);
        t.apply(e), t.geometryChanged();
    }, rg.prototype.removeCommonBits = function(t) {
        if (0 === this._commonCoord.x && 0 === this._commonCoord.y) return t;
        var e = new ul(this._commonCoord);
        e.x = -e.x, e.y = -e.y;
        var n = new sg(e);
        return t.apply(n), t.geometryChanged(), t;
    }, rg.prototype.getCommonCoordinate = function() {
        return this._commonCoord;
    }, rg.prototype.add = function(t) {
        t.apply(this._ccFilter), this._commonCoord = this._ccFilter.getCommonCoordinate();
    }, rg.prototype.interfaces_ = function() {
        return [];
    }, rg.prototype.getClass = function() {
        return rg;
    }, ig.CommonCoordinateFilter.get = function() {
        return og;
    }, ig.Translater.get = function() {
        return sg;
    }, Object.defineProperties(rg, ig);
    var og = function() {
        this._commonBitsX = new ng, this._commonBitsY = new ng;
    };
    og.prototype.filter = function(t) {
        this._commonBitsX.add(t.x), this._commonBitsY.add(t.y);
    }, og.prototype.getCommonCoordinate = function() {
        return new ul(this._commonBitsX.getCommon(), this._commonBitsY.getCommon());
    }, og.prototype.interfaces_ = function() {
        return [
            Kl
        ];
    }, og.prototype.getClass = function() {
        return og;
    };
    var sg = function() {
        this.trans = null;
        var t = arguments[0];
        this.trans = t;
    };
    sg.prototype.filter = function(t, e) {
        var n = t.getOrdinate(e, 0) + this.trans.x, r = t.getOrdinate(e, 1) + this.trans.y;
        t.setOrdinate(e, 0, n), t.setOrdinate(e, 1, r);
    }, sg.prototype.isDone = function() {
        return !1;
    }, sg.prototype.isGeometryChanged = function() {
        return !0;
    }, sg.prototype.interfaces_ = function() {
        return [
            Fc
        ];
    }, sg.prototype.getClass = function() {
        return sg;
    };
    var ag = function(t, e) {
        this._geom = new Array(2).fill(null), this._snapTolerance = null, this._cbr = null, this._geom[0] = t, this._geom[1] = e, this.computeSnapTolerance();
    };
    ag.prototype.selfSnap = function(t) {
        return new $f(t).snapTo(t, this._snapTolerance);
    }, ag.prototype.removeCommonBits = function(t) {
        this._cbr = new rg, this._cbr.add(t[0]), this._cbr.add(t[1]);
        var e = new Array(2).fill(null);
        return e[0] = this._cbr.removeCommonBits(t[0].copy()), e[1] = this._cbr.removeCommonBits(t[1].copy()), e;
    }, ag.prototype.prepareResult = function(t) {
        return this._cbr.addCommonBits(t), t;
    }, ag.prototype.getResultGeometry = function(t) {
        var e = this.snap(this._geom), n = Mg.overlayOp(e[0], e[1], t);
        return this.prepareResult(n);
    }, ag.prototype.checkValid = function(t) {
        t.isValid() || Pl.out.println("Snapped geometry is invalid");
    }, ag.prototype.computeSnapTolerance = function() {
        this._snapTolerance = $f.computeOverlaySnapTolerance(this._geom[0], this._geom[1]);
    }, ag.prototype.snap = function(t) {
        var e = this.removeCommonBits(t);
        return $f.snap(e[0], e[1], this._snapTolerance);
    }, ag.prototype.interfaces_ = function() {
        return [];
    }, ag.prototype.getClass = function() {
        return ag;
    }, ag.overlayOp = function(t, e, n) {
        return new ag(t, e).getResultGeometry(n);
    }, ag.union = function(t, e) {
        return ag.overlayOp(t, e, Mg.UNION);
    }, ag.intersection = function(t, e) {
        return ag.overlayOp(t, e, Mg.INTERSECTION);
    }, ag.symDifference = function(t, e) {
        return ag.overlayOp(t, e, Mg.SYMDIFFERENCE);
    }, ag.difference = function(t, e) {
        return ag.overlayOp(t, e, Mg.DIFFERENCE);
    };
    var ug = function(t, e) {
        this._geom = new Array(2).fill(null), this._geom[0] = t, this._geom[1] = e;
    };
    ug.prototype.getResultGeometry = function(t) {
        var e = null, n = !1, r = null;
        try {
            e = Mg.overlayOp(this._geom[0], this._geom[1], t);
            n = !0;
        } catch (t) {
            if (!(t instanceof kl)) throw t;
            r = t;
        }
        if (!n) try {
            e = ag.overlayOp(this._geom[0], this._geom[1], t);
        } catch (t) {
            throw t instanceof kl ? r : t;
        }
        return e;
    }, ug.prototype.interfaces_ = function() {
        return [];
    }, ug.prototype.getClass = function() {
        return ug;
    }, ug.overlayOp = function(t, e, n) {
        return new ug(t, e).getResultGeometry(n);
    }, ug.union = function(t, e) {
        return ug.overlayOp(t, e, Mg.UNION);
    }, ug.intersection = function(t, e) {
        return ug.overlayOp(t, e, Mg.INTERSECTION);
    }, ug.symDifference = function(t, e) {
        return ug.overlayOp(t, e, Mg.SYMDIFFERENCE);
    }, ug.difference = function(t, e) {
        return ug.overlayOp(t, e, Mg.DIFFERENCE);
    };
    var lg = function() {
        this.mce = null, this.chainIndex = null;
        var t = arguments[0], e = arguments[1];
        this.mce = t, this.chainIndex = e;
    };
    lg.prototype.computeIntersections = function(t, e) {
        this.mce.computeIntersectsForChain(this.chainIndex, t.mce, t.chainIndex, e);
    }, lg.prototype.interfaces_ = function() {
        return [];
    }, lg.prototype.getClass = function() {
        return lg;
    };
    var cg = function t() {
        if (this._label = null, this._xValue = null, this._eventType = null, this._insertEvent = null, this._deleteEventIndex = null, this._obj = null, 2 === arguments.length) {
            var e = arguments[0], n = arguments[1];
            this._eventType = t.DELETE, this._xValue = e, this._insertEvent = n;
        } else if (3 === arguments.length) {
            var r = arguments[0], i = arguments[1], o = arguments[2];
            this._eventType = t.INSERT, this._label = r, this._xValue = i, this._obj = o;
        }
    }, hg = {
        INSERT: {
            configurable: !0
        },
        DELETE: {
            configurable: !0
        }
    };
    cg.prototype.isDelete = function() {
        return this._eventType === cg.DELETE;
    }, cg.prototype.setDeleteEventIndex = function(t) {
        this._deleteEventIndex = t;
    }, cg.prototype.getObject = function() {
        return this._obj;
    }, cg.prototype.compareTo = function(t) {
        var e = t;
        return this._xValue < e._xValue ? -1 : this._xValue > e._xValue ? 1 : this._eventType < e._eventType ? -1 : this._eventType > e._eventType ? 1 : 0;
    }, cg.prototype.getInsertEvent = function() {
        return this._insertEvent;
    }, cg.prototype.isInsert = function() {
        return this._eventType === cg.INSERT;
    }, cg.prototype.isSameLabel = function(t) {
        return null !== this._label && this._label === t._label;
    }, cg.prototype.getDeleteEventIndex = function() {
        return this._deleteEventIndex;
    }, cg.prototype.interfaces_ = function() {
        return [
            il
        ];
    }, cg.prototype.getClass = function() {
        return cg;
    }, hg.INSERT.get = function() {
        return 1;
    }, hg.DELETE.get = function() {
        return 2;
    }, Object.defineProperties(cg, hg);
    var pg = function() {};
    pg.prototype.interfaces_ = function() {
        return [];
    }, pg.prototype.getClass = function() {
        return pg;
    };
    var fg = function() {
        this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._properIntersectionPoint = null, this._li = null, this._includeProper = null, this._recordIsolated = null, this._isSelfIntersection = null, this._numIntersections = 0, this.numTests = 0, this._bdyNodes = null, this._isDone = !1, this._isDoneWhenProperInt = !1;
        var t = arguments[0], e = arguments[1], n = arguments[2];
        this._li = t, this._includeProper = e, this._recordIsolated = n;
    };
    fg.prototype.isTrivialIntersection = function(t, e, n, r) {
        if (t === n && 1 === this._li.getIntersectionNum()) {
            if (fg.isAdjacentSegments(e, r)) return !0;
            if (t.isClosed()) {
                var i = t.getNumPoints() - 1;
                if (0 === e && r === i || 0 === r && e === i) return !0;
            }
        }
        return !1;
    }, fg.prototype.getProperIntersectionPoint = function() {
        return this._properIntersectionPoint;
    }, fg.prototype.setIsDoneIfProperInt = function(t) {
        this._isDoneWhenProperInt = t;
    }, fg.prototype.hasProperInteriorIntersection = function() {
        return this._hasProperInterior;
    }, fg.prototype.isBoundaryPointInternal = function(t, e) {
        for(var n = e.iterator(); n.hasNext();){
            var r = n.next().getCoordinate();
            if (t.isIntersection(r)) return !0;
        }
        return !1;
    }, fg.prototype.hasProperIntersection = function() {
        return this._hasProper;
    }, fg.prototype.hasIntersection = function() {
        return this._hasIntersection;
    }, fg.prototype.isDone = function() {
        return this._isDone;
    }, fg.prototype.isBoundaryPoint = function(t, e) {
        return null !== e && (!!this.isBoundaryPointInternal(t, e[0]) || !!this.isBoundaryPointInternal(t, e[1]));
    }, fg.prototype.setBoundaryNodes = function(t, e) {
        this._bdyNodes = new Array(2).fill(null), this._bdyNodes[0] = t, this._bdyNodes[1] = e;
    }, fg.prototype.addIntersections = function(t, e, n, r) {
        if (t === n && e === r) return null;
        this.numTests++;
        var i = t.getCoordinates()[e], o = t.getCoordinates()[e + 1], s = n.getCoordinates()[r], a = n.getCoordinates()[r + 1];
        this._li.computeIntersection(i, o, s, a), this._li.hasIntersection() && (this._recordIsolated && (t.setIsolated(!1), n.setIsolated(!1)), this._numIntersections++, this.isTrivialIntersection(t, e, n, r) || (this._hasIntersection = !0, !this._includeProper && this._li.isProper() || (t.addIntersections(this._li, e, 0), n.addIntersections(this._li, r, 1)), this._li.isProper() && (this._properIntersectionPoint = this._li.getIntersection(0).copy(), this._hasProper = !0, this._isDoneWhenProperInt && (this._isDone = !0), this.isBoundaryPoint(this._li, this._bdyNodes) || (this._hasProperInterior = !0))));
    }, fg.prototype.interfaces_ = function() {
        return [];
    }, fg.prototype.getClass = function() {
        return fg;
    }, fg.isAdjacentSegments = function(t, e) {
        return 1 === Math.abs(t - e);
    };
    var gg = function(t) {
        function e() {
            t.call(this), this.events = new lc, this.nOverlaps = null;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.prepareEvents = function() {
            np.sort(this.events);
            for(var t = 0; t < this.events.size(); t++){
                var e = this.events.get(t);
                e.isDelete() && e.getInsertEvent().setDeleteEventIndex(t);
            }
        }, e.prototype.computeIntersections = function() {
            var t = this;
            if (1 === arguments.length) {
                var e = arguments[0];
                this.nOverlaps = 0, this.prepareEvents();
                for(var n = 0; n < this.events.size(); n++){
                    var r = t.events.get(n);
                    if (r.isInsert() && t.processOverlaps(n, r.getDeleteEventIndex(), r, e), e.isDone()) break;
                }
            } else if (3 === arguments.length) {
                if (arguments[2] instanceof fg && gl(arguments[0], ac) && gl(arguments[1], ac)) {
                    var i = arguments[0], o = arguments[1], s = arguments[2];
                    this.addEdges(i, i), this.addEdges(o, o), this.computeIntersections(s);
                } else if ("boolean" == typeof arguments[2] && gl(arguments[0], ac) && arguments[1] instanceof fg) {
                    var a = arguments[0], u = arguments[1], l = arguments[2];
                    l ? this.addEdges(a, null) : this.addEdges(a), this.computeIntersections(u);
                }
            }
        }, e.prototype.addEdge = function(t, e) {
            for(var n = t.getMonotoneChainEdge(), r = n.getStartIndexes(), i = 0; i < r.length - 1; i++){
                var o = new lg(n, i), s = new cg(e, n.getMinX(i), o);
                this.events.add(s), this.events.add(new cg(n.getMaxX(i), s));
            }
        }, e.prototype.processOverlaps = function(t, e, n, r) {
            for(var i = n.getObject(), o = t; o < e; o++){
                var s = this.events.get(o);
                if (s.isInsert()) {
                    var a = s.getObject();
                    n.isSameLabel(s) || (i.computeIntersections(a, r), this.nOverlaps++);
                }
            }
        }, e.prototype.addEdges = function() {
            var t = this;
            if (1 === arguments.length) for(var e = arguments[0], n = e.iterator(); n.hasNext();){
                var r = n.next();
                t.addEdge(r, r);
            }
            else if (2 === arguments.length) for(var i = arguments[0], o = arguments[1], s = i.iterator(); s.hasNext();){
                var a = s.next();
                t.addEdge(a, o);
            }
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(pg), dg = function() {
        this._min = nl.POSITIVE_INFINITY, this._max = nl.NEGATIVE_INFINITY;
    }, yg = {
        NodeComparator: {
            configurable: !0
        }
    };
    dg.prototype.getMin = function() {
        return this._min;
    }, dg.prototype.intersects = function(t, e) {
        return !(this._min > e || this._max < t);
    }, dg.prototype.getMax = function() {
        return this._max;
    }, dg.prototype.toString = function() {
        return Fl.toLineString(new ul(this._min, 0), new ul(this._max, 0));
    }, dg.prototype.interfaces_ = function() {
        return [];
    }, dg.prototype.getClass = function() {
        return dg;
    }, yg.NodeComparator.get = function() {
        return vg;
    }, Object.defineProperties(dg, yg);
    var vg = function() {};
    vg.prototype.compare = function(t, e) {
        var n = t, r = e, i = (n._min + n._max) / 2, o = (r._min + r._max) / 2;
        return i < o ? -1 : i > o ? 1 : 0;
    }, vg.prototype.interfaces_ = function() {
        return [
            sl
        ];
    }, vg.prototype.getClass = function() {
        return vg;
    };
    var _g = function(t) {
        function e() {
            t.call(this), this._item = null;
            var e = arguments[0], n = arguments[1], r = arguments[2];
            this._min = e, this._max = n, this._item = r;
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.query = function(t, e, n) {
            if (!this.intersects(t, e)) return null;
            n.visitItem(this._item);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(dg), mg = function(t) {
        function e() {
            t.call(this), this._node1 = null, this._node2 = null;
            var e = arguments[0], n = arguments[1];
            this._node1 = e, this._node2 = n, this.buildExtent(this._node1, this._node2);
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.buildExtent = function(t, e) {
            this._min = Math.min(t._min, e._min), this._max = Math.max(t._max, e._max);
        }, e.prototype.query = function(t, e, n) {
            if (!this.intersects(t, e)) return null;
            null !== this._node1 && this._node1.query(t, e, n), null !== this._node2 && this._node2.query(t, e, n);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(dg), xg = function() {
        this._leaves = new lc, this._root = null, this._level = 0;
    };
    xg.prototype.buildTree = function() {
        np.sort(this._leaves, new dg.NodeComparator);
        for(var t = this._leaves, e = null, n = new lc;;){
            if (this.buildLevel(t, n), 1 === n.size()) return n.get(0);
            e = t, t = n, n = e;
        }
    }, xg.prototype.insert = function(t, e, n) {
        if (null !== this._root) throw new Error("Index cannot be added to once it has been queried");
        this._leaves.add(new _g(t, e, n));
    }, xg.prototype.query = function(t, e, n) {
        this.init(), this._root.query(t, e, n);
    }, xg.prototype.buildRoot = function() {
        if (null !== this._root) return null;
        this._root = this.buildTree();
    }, xg.prototype.printNode = function(t) {
        Pl.out.println(Fl.toLineString(new ul(t._min, this._level), new ul(t._max, this._level)));
    }, xg.prototype.init = function() {
        if (null !== this._root) return null;
        this.buildRoot();
    }, xg.prototype.buildLevel = function(t, e) {
        this._level++, e.clear();
        for(var n = 0; n < t.size(); n += 2){
            var r = t.get(n);
            if (null === (n + 1 < t.size() ? t.get(n) : null)) e.add(r);
            else {
                var i = new mg(t.get(n), t.get(n + 1));
                e.add(i);
            }
        }
    }, xg.prototype.interfaces_ = function() {
        return [];
    }, xg.prototype.getClass = function() {
        return xg;
    };
    var Eg = function() {
        this._items = new lc;
    };
    Eg.prototype.visitItem = function(t) {
        this._items.add(t);
    }, Eg.prototype.getItems = function() {
        return this._items;
    }, Eg.prototype.interfaces_ = function() {
        return [
            Qh
        ];
    }, Eg.prototype.getClass = function() {
        return Eg;
    };
    var bg = function() {
        this._index = null;
        var t = arguments[0];
        if (!gl(t, $c)) throw new el("Argument must be Polygonal");
        this._index = new Ng(t);
    }, wg = {
        SegmentVisitor: {
            configurable: !0
        },
        IntervalIndexedGeometry: {
            configurable: !0
        }
    };
    bg.prototype.locate = function(t) {
        var e = new Vl(t), n = new Ig(e);
        return this._index.query(t.y, t.y, n), e.getLocation();
    }, bg.prototype.interfaces_ = function() {
        return [
            jp
        ];
    }, bg.prototype.getClass = function() {
        return bg;
    }, wg.SegmentVisitor.get = function() {
        return Ig;
    }, wg.IntervalIndexedGeometry.get = function() {
        return Ng;
    }, Object.defineProperties(bg, wg);
    var Ig = function() {
        this._counter = null;
        var t = arguments[0];
        this._counter = t;
    };
    Ig.prototype.visitItem = function(t) {
        var e = t;
        this._counter.countSegment(e.getCoordinate(0), e.getCoordinate(1));
    }, Ig.prototype.interfaces_ = function() {
        return [
            Qh
        ];
    }, Ig.prototype.getClass = function() {
        return Ig;
    };
    var Ng = function() {
        this._index = new xg;
        var t = arguments[0];
        this.init(t);
    };
    Ng.prototype.init = function(t) {
        for(var e = Cf.getLines(t).iterator(); e.hasNext();){
            var n = e.next().getCoordinates();
            this.addLine(n);
        }
    }, Ng.prototype.addLine = function(t) {
        for(var e = 1; e < t.length; e++){
            var n = new vp(t[e - 1], t[e]), r = Math.min(n.p0.y, n.p1.y), i = Math.max(n.p0.y, n.p1.y);
            this._index.insert(r, i, n);
        }
    }, Ng.prototype.query = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = new Eg;
            return this._index.query(t, e, n), n.getItems();
        }
        if (3 === arguments.length) {
            var r = arguments[0], i = arguments[1], o = arguments[2];
            this._index.query(r, i, o);
        }
    }, Ng.prototype.interfaces_ = function() {
        return [];
    }, Ng.prototype.getClass = function() {
        return Ng;
    };
    var Sg = function(t) {
        function e() {
            if (t.call(this), this._parentGeom = null, this._lineEdgeMap = new fh, this._boundaryNodeRule = null, this._useBoundaryDeterminationRule = !0, this._argIndex = null, this._boundaryNodes = null, this._hasTooFewPoints = !1, this._invalidPoint = null, this._areaPtLocator = null, this._ptLocator = new Pf, 2 === arguments.length) {
                var e = arguments[0], n = arguments[1], r = Ql.OGC_SFS_BOUNDARY_RULE;
                this._argIndex = e, this._parentGeom = n, this._boundaryNodeRule = r, null !== n && this.add(n);
            } else if (3 === arguments.length) {
                var i = arguments[0], o = arguments[1], s = arguments[2];
                this._argIndex = i, this._parentGeom = o, this._boundaryNodeRule = s, null !== o && this.add(o);
            }
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.insertBoundaryPoint = function(t, n) {
            var r = this._nodes.addNode(n).getLabel(), i = 1;
            r.getLocation(t, Sh.ON) === pl.BOUNDARY && i++;
            var o = e.determineBoundary(this._boundaryNodeRule, i);
            r.setLocation(t, o);
        }, e.prototype.computeSelfNodes = function() {
            if (2 === arguments.length) {
                var t = arguments[0], e = arguments[1];
                return this.computeSelfNodes(t, e, !1);
            }
            if (3 === arguments.length) {
                var n = arguments[0], r = arguments[1], i = arguments[2], o = new fg(n, !0, !1);
                o.setIsDoneIfProperInt(i);
                var s = this.createEdgeSetIntersector(), a = this._parentGeom instanceof nh || this._parentGeom instanceof th || this._parentGeom instanceof rh, u = r || !a;
                return s.computeIntersections(this._edges, o, u), this.addSelfIntersectionNodes(this._argIndex), o;
            }
        }, e.prototype.computeSplitEdges = function(t) {
            for(var e = this._edges.iterator(); e.hasNext();)e.next().eiList.addSplitEdges(t);
        }, e.prototype.computeEdgeIntersections = function(t, e, n) {
            var r = new fg(e, n, !0);
            return r.setBoundaryNodes(this.getBoundaryNodes(), t.getBoundaryNodes()), this.createEdgeSetIntersector().computeIntersections(this._edges, t._edges, r), r;
        }, e.prototype.getGeometry = function() {
            return this._parentGeom;
        }, e.prototype.getBoundaryNodeRule = function() {
            return this._boundaryNodeRule;
        }, e.prototype.hasTooFewPoints = function() {
            return this._hasTooFewPoints;
        }, e.prototype.addPoint = function() {
            if (arguments[0] instanceof Qc) {
                var t = arguments[0], e = t.getCoordinate();
                this.insertPoint(this._argIndex, e, pl.INTERIOR);
            } else if (arguments[0] instanceof ul) {
                var n = arguments[0];
                this.insertPoint(this._argIndex, n, pl.INTERIOR);
            }
        }, e.prototype.addPolygon = function(t) {
            this.addPolygonRing(t.getExteriorRing(), pl.EXTERIOR, pl.INTERIOR);
            for(var e = 0; e < t.getNumInteriorRing(); e++){
                var n = t.getInteriorRingN(e);
                this.addPolygonRing(n, pl.INTERIOR, pl.EXTERIOR);
            }
        }, e.prototype.addEdge = function(t) {
            this.insertEdge(t);
            var e = t.getCoordinates();
            this.insertPoint(this._argIndex, e[0], pl.BOUNDARY), this.insertPoint(this._argIndex, e[e.length - 1], pl.BOUNDARY);
        }, e.prototype.addLineString = function(t) {
            var e = pc.removeRepeatedPoints(t.getCoordinates());
            if (e.length < 2) return this._hasTooFewPoints = !0, this._invalidPoint = e[0], null;
            var n = new of(e, new Dh(this._argIndex, pl.INTERIOR));
            this._lineEdgeMap.put(t, n), this.insertEdge(n), ql.isTrue(e.length >= 2, "found LineString with single point"), this.insertBoundaryPoint(this._argIndex, e[0]), this.insertBoundaryPoint(this._argIndex, e[e.length - 1]);
        }, e.prototype.getInvalidPoint = function() {
            return this._invalidPoint;
        }, e.prototype.getBoundaryPoints = function() {
            for(var t = this.getBoundaryNodes(), e = new Array(t.size()).fill(null), n = 0, r = t.iterator(); r.hasNext();){
                var i = r.next();
                e[n++] = i.getCoordinate().copy();
            }
            return e;
        }, e.prototype.getBoundaryNodes = function() {
            return null === this._boundaryNodes && (this._boundaryNodes = this._nodes.getBoundaryNodes(this._argIndex)), this._boundaryNodes;
        }, e.prototype.addSelfIntersectionNode = function(t, e, n) {
            if (this.isBoundaryNode(t, e)) return null;
            n === pl.BOUNDARY && this._useBoundaryDeterminationRule ? this.insertBoundaryPoint(t, e) : this.insertPoint(t, e, n);
        }, e.prototype.addPolygonRing = function(t, e, n) {
            if (t.isEmpty()) return null;
            var r = pc.removeRepeatedPoints(t.getCoordinates());
            if (r.length < 4) return this._hasTooFewPoints = !0, this._invalidPoint = r[0], null;
            var i = e, o = n;
            Xl.isCCW(r) && (i = n, o = e);
            var s = new of(r, new Dh(this._argIndex, pl.BOUNDARY, i, o));
            this._lineEdgeMap.put(t, s), this.insertEdge(s), this.insertPoint(this._argIndex, r[0], pl.BOUNDARY);
        }, e.prototype.insertPoint = function(t, e, n) {
            var r = this._nodes.addNode(e), i = r.getLabel();
            null === i ? r._label = new Dh(t, n) : i.setLocation(t, n);
        }, e.prototype.createEdgeSetIntersector = function() {
            return new gg;
        }, e.prototype.addSelfIntersectionNodes = function(t) {
            for(var e = this._edges.iterator(); e.hasNext();)for(var n = e.next(), r = n.getLabel().getLocation(t), i = n.eiList.iterator(); i.hasNext();){
                var o = i.next();
                this.addSelfIntersectionNode(t, o.coord, r);
            }
        }, e.prototype.add = function() {
            if (1 !== arguments.length) return t.prototype.add.apply(this, arguments);
            var e = arguments[0];
            if (e.isEmpty()) return null;
            if (e instanceof rh && (this._useBoundaryDeterminationRule = !1), e instanceof th) this.addPolygon(e);
            else if (e instanceof Zc) this.addLineString(e);
            else if (e instanceof Qc) this.addPoint(e);
            else if (e instanceof eh) this.addCollection(e);
            else if (e instanceof Gc) this.addCollection(e);
            else if (e instanceof rh) this.addCollection(e);
            else {
                if (!(e instanceof kc)) throw new Error(e.getClass().getName());
                this.addCollection(e);
            }
        }, e.prototype.addCollection = function(t) {
            for(var e = 0; e < t.getNumGeometries(); e++){
                var n = t.getGeometryN(e);
                this.add(n);
            }
        }, e.prototype.locate = function(t) {
            return gl(this._parentGeom, $c) && this._parentGeom.getNumGeometries() > 50 ? (null === this._areaPtLocator && (this._areaPtLocator = new bg(this._parentGeom)), this._areaPtLocator.locate(t)) : this._ptLocator.locate(t, this._parentGeom);
        }, e.prototype.findEdge = function() {
            if (1 === arguments.length) {
                var e = arguments[0];
                return this._lineEdgeMap.get(e);
            }
            return t.prototype.findEdge.apply(this, arguments);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e.determineBoundary = function(t, e) {
            return t.isInBoundary(e) ? pl.BOUNDARY : pl.INTERIOR;
        }, e;
    }(Hh), Cg = function() {
        if (this._li = new jl, this._resultPrecisionModel = null, this._arg = null, 1 === arguments.length) {
            var t = arguments[0];
            this.setComputationPrecision(t.getPrecisionModel()), this._arg = new Array(1).fill(null), this._arg[0] = new Sg(0, t);
        } else if (2 === arguments.length) {
            var e = arguments[0], n = arguments[1], r = Ql.OGC_SFS_BOUNDARY_RULE;
            e.getPrecisionModel().compareTo(n.getPrecisionModel()) >= 0 ? this.setComputationPrecision(e.getPrecisionModel()) : this.setComputationPrecision(n.getPrecisionModel()), this._arg = new Array(2).fill(null), this._arg[0] = new Sg(0, e, r), this._arg[1] = new Sg(1, n, r);
        } else if (3 === arguments.length) {
            var i = arguments[0], o = arguments[1], s = arguments[2];
            i.getPrecisionModel().compareTo(o.getPrecisionModel()) >= 0 ? this.setComputationPrecision(i.getPrecisionModel()) : this.setComputationPrecision(o.getPrecisionModel()), this._arg = new Array(2).fill(null), this._arg[0] = new Sg(0, i, s), this._arg[1] = new Sg(1, o, s);
        }
    };
    Cg.prototype.getArgGeometry = function(t) {
        return this._arg[t].getGeometry();
    }, Cg.prototype.setComputationPrecision = function(t) {
        this._resultPrecisionModel = t, this._li.setPrecisionModel(this._resultPrecisionModel);
    }, Cg.prototype.interfaces_ = function() {
        return [];
    }, Cg.prototype.getClass = function() {
        return Cg;
    };
    var Pg = function() {};
    Pg.prototype.interfaces_ = function() {
        return [];
    }, Pg.prototype.getClass = function() {
        return Pg;
    }, Pg.map = function() {
        if (arguments[0] instanceof Wl && gl(arguments[1], Pg.MapOp)) {
            for(var t = arguments[0], e = arguments[1], n = new lc, r = 0; r < t.getNumGeometries(); r++){
                var i = e.map(t.getGeometryN(r));
                null !== i && n.add(i);
            }
            return t.getFactory().buildGeometry(n);
        }
        if (gl(arguments[0], ic) && gl(arguments[1], Pg.MapOp)) {
            for(var o = arguments[0], s = arguments[1], a = new lc, u = o.iterator(); u.hasNext();){
                var l = u.next(), c = s.map(l);
                null !== c && a.add(c);
            }
            return a;
        }
    }, Pg.MapOp = function() {};
    var Mg = function(t) {
        function e() {
            var e = arguments[0], n = arguments[1];
            t.call(this, e, n), this._ptLocator = new Pf, this._geomFact = null, this._resultGeom = null, this._graph = null, this._edgeList = new Jp, this._resultPolyList = new lc, this._resultLineList = new lc, this._resultPointList = new lc, this._graph = new Hh(new Hp), this._geomFact = e.getFactory();
        }
        return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.insertUniqueEdge = function(t) {
            var e = this._edgeList.findEqualEdge(t);
            if (null !== e) {
                var n = e.getLabel(), r = t.getLabel();
                e.isPointwiseEqual(t) || (r = new Dh(t.getLabel())).flip();
                var i = e.getDepth();
                i.isNull() && i.add(n), i.add(r), n.merge(r);
            } else this._edgeList.add(t);
        }, e.prototype.getGraph = function() {
            return this._graph;
        }, e.prototype.cancelDuplicateResultEdges = function() {
            for(var t = this._graph.getEdgeEnds().iterator(); t.hasNext();){
                var e = t.next(), n = e.getSym();
                e.isInResult() && n.isInResult() && (e.setInResult(!1), n.setInResult(!1));
            }
        }, e.prototype.isCoveredByLA = function(t) {
            return !!this.isCovered(t, this._resultLineList) || !!this.isCovered(t, this._resultPolyList);
        }, e.prototype.computeGeometry = function(t, n, r, i) {
            var o = new lc;
            return o.addAll(t), o.addAll(n), o.addAll(r), o.isEmpty() ? e.createEmptyResult(i, this._arg[0].getGeometry(), this._arg[1].getGeometry(), this._geomFact) : this._geomFact.buildGeometry(o);
        }, e.prototype.mergeSymLabels = function() {
            for(var t = this._graph.getNodes().iterator(); t.hasNext();)t.next().getEdges().mergeSymLabels();
        }, e.prototype.isCovered = function(t, e) {
            for(var n = e.iterator(); n.hasNext();){
                var r = n.next();
                if (this._ptLocator.locate(t, r) !== pl.EXTERIOR) return !0;
            }
            return !1;
        }, e.prototype.replaceCollapsedEdges = function() {
            for(var t = new lc, e = this._edgeList.iterator(); e.hasNext();){
                var n = e.next();
                n.isCollapsed() && (e.remove(), t.add(n.getCollapsedEdge()));
            }
            this._edgeList.addAll(t);
        }, e.prototype.updateNodeLabelling = function() {
            for(var t = this._graph.getNodes().iterator(); t.hasNext();){
                var e = t.next(), n = e.getEdges().getLabel();
                e.getLabel().merge(n);
            }
        }, e.prototype.getResultGeometry = function(t) {
            return this.computeOverlay(t), this._resultGeom;
        }, e.prototype.insertUniqueEdges = function(t) {
            for(var e = t.iterator(); e.hasNext();){
                var n = e.next();
                this.insertUniqueEdge(n);
            }
        }, e.prototype.computeOverlay = function(t) {
            this.copyPoints(0), this.copyPoints(1), this._arg[0].computeSelfNodes(this._li, !1), this._arg[1].computeSelfNodes(this._li, !1), this._arg[0].computeEdgeIntersections(this._arg[1], this._li, !0);
            var e = new lc;
            this._arg[0].computeSplitEdges(e), this._arg[1].computeSplitEdges(e), this.insertUniqueEdges(e), this.computeLabelsFromDepths(), this.replaceCollapsedEdges(), Hf.checkValid(this._edgeList.getEdges()), this._graph.addEdges(this._edgeList.getEdges()), this.computeLabelling(), this.labelIncompleteNodes(), this.findResultAreaEdges(t), this.cancelDuplicateResultEdges();
            var n = new Wh(this._geomFact);
            n.add(this._graph), this._resultPolyList = n.getPolygons();
            var r = new Jf(this, this._geomFact, this._ptLocator);
            this._resultLineList = r.build(t);
            var i = new Zf(this, this._geomFact, this._ptLocator);
            this._resultPointList = i.build(t), this._resultGeom = this.computeGeometry(this._resultPointList, this._resultLineList, this._resultPolyList, t);
        }, e.prototype.labelIncompleteNode = function(t, e) {
            var n = this._ptLocator.locate(t.getCoordinate(), this._arg[e].getGeometry());
            t.getLabel().setLocation(e, n);
        }, e.prototype.copyPoints = function(t) {
            for(var e = this._arg[t].getNodeIterator(); e.hasNext();){
                var n = e.next();
                this._graph.addNode(n.getCoordinate()).setLabel(t, n.getLabel().getLocation(t));
            }
        }, e.prototype.findResultAreaEdges = function(t) {
            for(var n = this._graph.getEdgeEnds().iterator(); n.hasNext();){
                var r = n.next(), i = r.getLabel();
                i.isArea() && !r.isInteriorAreaEdge() && e.isResultOfOp(i.getLocation(0, Sh.RIGHT), i.getLocation(1, Sh.RIGHT), t) && r.setInResult(!0);
            }
        }, e.prototype.computeLabelsFromDepths = function() {
            for(var t = this._edgeList.iterator(); t.hasNext();){
                var e = t.next(), n = e.getLabel(), r = e.getDepth();
                if (!r.isNull()) {
                    r.normalize();
                    for(var i = 0; i < 2; i++)n.isNull(i) || !n.isArea() || r.isNull(i) || (0 === r.getDelta(i) ? n.toLine(i) : (ql.isTrue(!r.isNull(i, Sh.LEFT), "depth of LEFT side has not been initialized"), n.setLocation(i, Sh.LEFT, r.getLocation(i, Sh.LEFT)), ql.isTrue(!r.isNull(i, Sh.RIGHT), "depth of RIGHT side has not been initialized"), n.setLocation(i, Sh.RIGHT, r.getLocation(i, Sh.RIGHT))));
                }
            }
        }, e.prototype.computeLabelling = function() {
            for(var t = this._graph.getNodes().iterator(); t.hasNext();)t.next().getEdges().computeLabelling(this._arg);
            this.mergeSymLabels(), this.updateNodeLabelling();
        }, e.prototype.labelIncompleteNodes = function() {
            for(var t = this._graph.getNodes().iterator(); t.hasNext();){
                var e = t.next(), n = e.getLabel();
                e.isIsolated() && (n.isNull(0) ? this.labelIncompleteNode(e, 0) : this.labelIncompleteNode(e, 1)), e.getEdges().updateLabelling(n);
            }
        }, e.prototype.isCoveredByA = function(t) {
            return !!this.isCovered(t, this._resultPolyList);
        }, e.prototype.interfaces_ = function() {
            return [];
        }, e.prototype.getClass = function() {
            return e;
        }, e;
    }(Cg);
    Mg.overlayOp = function(t, e, n) {
        return new Mg(t, e).getResultGeometry(n);
    }, Mg.intersection = function(t, e) {
        if (t.isEmpty() || e.isEmpty()) return Mg.createEmptyResult(Mg.INTERSECTION, t, e, t.getFactory());
        if (t.isGeometryCollection()) {
            var n = e;
            return Wf.map(t, {
                interfaces_: function() {
                    return [
                        Pg.MapOp
                    ];
                },
                map: function(t) {
                    return t.intersection(n);
                }
            });
        }
        return t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), ug.overlayOp(t, e, Mg.INTERSECTION);
    }, Mg.symDifference = function(t, e) {
        if (t.isEmpty() || e.isEmpty()) {
            if (t.isEmpty() && e.isEmpty()) return Mg.createEmptyResult(Mg.SYMDIFFERENCE, t, e, t.getFactory());
            if (t.isEmpty()) return e.copy();
            if (e.isEmpty()) return t.copy();
        }
        return t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), ug.overlayOp(t, e, Mg.SYMDIFFERENCE);
    }, Mg.resultDimension = function(t, e, n) {
        var r = e.getDimension(), i = n.getDimension(), o = -1;
        switch(t){
            case Mg.INTERSECTION:
                o = Math.min(r, i);
                break;
            case Mg.UNION:
                o = Math.max(r, i);
                break;
            case Mg.DIFFERENCE:
                o = r;
                break;
            case Mg.SYMDIFFERENCE:
                o = Math.max(r, i);
        }
        return o;
    }, Mg.createEmptyResult = function(t, e, n, r) {
        var i = null;
        switch(Mg.resultDimension(t, e, n)){
            case -1:
                i = r.createGeometryCollection(new Array(0).fill(null));
                break;
            case 0:
                i = r.createPoint();
                break;
            case 1:
                i = r.createLineString();
                break;
            case 2:
                i = r.createPolygon();
        }
        return i;
    }, Mg.difference = function(t, e) {
        return t.isEmpty() ? Mg.createEmptyResult(Mg.DIFFERENCE, t, e, t.getFactory()) : e.isEmpty() ? t.copy() : (t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), ug.overlayOp(t, e, Mg.DIFFERENCE));
    }, Mg.isResultOfOp = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = t.getLocation(0), r = t.getLocation(1);
            return Mg.isResultOfOp(n, r, e);
        }
        if (3 === arguments.length) {
            var i = arguments[0], o = arguments[1], s = arguments[2];
            switch(i === pl.BOUNDARY && (i = pl.INTERIOR), o === pl.BOUNDARY && (o = pl.INTERIOR), s){
                case Mg.INTERSECTION:
                    return i === pl.INTERIOR && o === pl.INTERIOR;
                case Mg.UNION:
                    return i === pl.INTERIOR || o === pl.INTERIOR;
                case Mg.DIFFERENCE:
                    return i === pl.INTERIOR && o !== pl.INTERIOR;
                case Mg.SYMDIFFERENCE:
                    return i === pl.INTERIOR && o !== pl.INTERIOR || i !== pl.INTERIOR && o === pl.INTERIOR;
            }
            return !1;
        }
    }, Mg.INTERSECTION = 1, Mg.UNION = 2, Mg.DIFFERENCE = 3, Mg.SYMDIFFERENCE = 4;
    var Lg = function() {
        this._g = null, this._boundaryDistanceTolerance = null, this._linework = null, this._ptLocator = new Pf, this._seg = new vp;
        var t = arguments[0], e = arguments[1];
        this._g = t, this._boundaryDistanceTolerance = e, this._linework = this.extractLinework(t);
    };
    Lg.prototype.isWithinToleranceOfBoundary = function(t) {
        for(var e = this, n = 0; n < this._linework.getNumGeometries(); n++)for(var r = e._linework.getGeometryN(n).getCoordinateSequence(), i = 0; i < r.size() - 1; i++){
            if (r.getCoordinate(i, e._seg.p0), r.getCoordinate(i + 1, e._seg.p1), e._seg.distance(t) <= e._boundaryDistanceTolerance) return !0;
        }
        return !1;
    }, Lg.prototype.getLocation = function(t) {
        return this.isWithinToleranceOfBoundary(t) ? pl.BOUNDARY : this._ptLocator.locate(t, this._g);
    }, Lg.prototype.extractLinework = function(t) {
        var e = new Og;
        t.apply(e);
        var n = e.getLinework(), r = _h.toLineStringArray(n);
        return t.getFactory().createMultiLineString(r);
    }, Lg.prototype.interfaces_ = function() {
        return [];
    }, Lg.prototype.getClass = function() {
        return Lg;
    };
    var Og = function() {
        this._linework = null, this._linework = new lc;
    };
    Og.prototype.getLinework = function() {
        return this._linework;
    }, Og.prototype.filter = function(t) {
        if (t instanceof th) {
            var e = t;
            this._linework.add(e.getExteriorRing());
            for(var n = 0; n < e.getNumInteriorRing(); n++)this._linework.add(e.getInteriorRingN(n));
        }
    }, Og.prototype.interfaces_ = function() {
        return [
            Dc
        ];
    }, Og.prototype.getClass = function() {
        return Og;
    };
    var Rg = function() {
        this._g = null, this._doLeft = !0, this._doRight = !0;
        var t = arguments[0];
        this._g = t;
    };
    Rg.prototype.extractPoints = function(t, e, n) {
        for(var r = t.getCoordinates(), i = 0; i < r.length - 1; i++)this.computeOffsetPoints(r[i], r[i + 1], e, n);
    }, Rg.prototype.setSidesToGenerate = function(t, e) {
        this._doLeft = t, this._doRight = e;
    }, Rg.prototype.getPoints = function(t) {
        for(var e = new lc, n = Cf.getLines(this._g).iterator(); n.hasNext();){
            var r = n.next();
            this.extractPoints(r, t, e);
        }
        return e;
    }, Rg.prototype.computeOffsetPoints = function(t, e, n, r) {
        var i = e.x - t.x, o = e.y - t.y, s = Math.sqrt(i * i + o * o), a = n * i / s, u = n * o / s, l = (e.x + t.x) / 2, c = (e.y + t.y) / 2;
        if (this._doLeft) {
            var h = new ul(l - u, c + a);
            r.add(h);
        }
        if (this._doRight) {
            var p = new ul(l + u, c - a);
            r.add(p);
        }
    }, Rg.prototype.interfaces_ = function() {
        return [];
    }, Rg.prototype.getClass = function() {
        return Rg;
    };
    var Tg = function t() {
        this._geom = null, this._locFinder = null, this._location = new Array(3).fill(null), this._invalidLocation = null, this._boundaryDistanceTolerance = t.TOLERANCE, this._testCoords = new lc;
        var e = arguments[0], n = arguments[1], r = arguments[2];
        this._boundaryDistanceTolerance = t.computeBoundaryDistanceTolerance(e, n), this._geom = [
            e,
            n,
            r
        ], this._locFinder = [
            new Lg(this._geom[0], this._boundaryDistanceTolerance),
            new Lg(this._geom[1], this._boundaryDistanceTolerance),
            new Lg(this._geom[2], this._boundaryDistanceTolerance)
        ];
    }, Ag = {
        TOLERANCE: {
            configurable: !0
        }
    };
    Tg.prototype.reportResult = function(t, e, n) {
        Pl.out.println("Overlay result invalid - A:" + pl.toLocationSymbol(e[0]) + " B:" + pl.toLocationSymbol(e[1]) + " expected:" + (n ? "i" : "e") + " actual:" + pl.toLocationSymbol(e[2]));
    }, Tg.prototype.isValid = function(t) {
        this.addTestPts(this._geom[0]), this.addTestPts(this._geom[1]);
        var e = this.checkValid(t);
        return e;
    }, Tg.prototype.checkValid = function() {
        var t = this;
        if (1 === arguments.length) {
            for(var e = arguments[0], n = 0; n < this._testCoords.size(); n++){
                var r = t._testCoords.get(n);
                if (!t.checkValid(e, r)) return t._invalidLocation = r, !1;
            }
            return !0;
        }
        if (2 === arguments.length) {
            var i = arguments[0], o = arguments[1];
            return this._location[0] = this._locFinder[0].getLocation(o), this._location[1] = this._locFinder[1].getLocation(o), this._location[2] = this._locFinder[2].getLocation(o), !!Tg.hasLocation(this._location, pl.BOUNDARY) || this.isValidResult(i, this._location);
        }
    }, Tg.prototype.addTestPts = function(t) {
        var e = new Rg(t);
        this._testCoords.addAll(e.getPoints(5 * this._boundaryDistanceTolerance));
    }, Tg.prototype.isValidResult = function(t, e) {
        var n = Mg.isResultOfOp(e[0], e[1], t), r = !(n ^ e[2] === pl.INTERIOR);
        return r || this.reportResult(t, e, n), r;
    }, Tg.prototype.getInvalidLocation = function() {
        return this._invalidLocation;
    }, Tg.prototype.interfaces_ = function() {
        return [];
    }, Tg.prototype.getClass = function() {
        return Tg;
    }, Tg.hasLocation = function(t, e) {
        for(var n = 0; n < 3; n++)if (t[n] === e) return !0;
        return !1;
    }, Tg.computeBoundaryDistanceTolerance = function(t, e) {
        return Math.min($f.computeSizeBasedSnapTolerance(t), $f.computeSizeBasedSnapTolerance(e));
    }, Tg.isValid = function(t, e, n, r) {
        return new Tg(t, e, r).isValid(n);
    }, Ag.TOLERANCE.get = function() {
        return 1e-6;
    }, Object.defineProperties(Tg, Ag);
    var Dg = function t(e) {
        this._geomFactory = null, this._skipEmpty = !1, this._inputGeoms = null, this._geomFactory = t.extractFactory(e), this._inputGeoms = e;
    };
    Dg.prototype.extractElements = function(t, e) {
        if (null === t) return null;
        for(var n = 0; n < t.getNumGeometries(); n++){
            var r = t.getGeometryN(n);
            this._skipEmpty && r.isEmpty() || e.add(r);
        }
    }, Dg.prototype.combine = function() {
        for(var t = new lc, e = this._inputGeoms.iterator(); e.hasNext();){
            var n = e.next();
            this.extractElements(n, t);
        }
        return 0 === t.size() ? null !== this._geomFactory ? this._geomFactory.createGeometryCollection(null) : null : this._geomFactory.buildGeometry(t);
    }, Dg.prototype.interfaces_ = function() {
        return [];
    }, Dg.prototype.getClass = function() {
        return Dg;
    }, Dg.combine = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = new Dg(t);
            return e.combine();
        }
        if (2 === arguments.length) {
            var n = arguments[0], r = arguments[1], i = new Dg(Dg.createList(n, r));
            return i.combine();
        }
        if (3 === arguments.length) {
            var o = arguments[0], s = arguments[1], a = arguments[2], u = new Dg(Dg.createList(o, s, a));
            return u.combine();
        }
    }, Dg.extractFactory = function(t) {
        return t.isEmpty() ? null : t.iterator().next().getFactory();
    }, Dg.createList = function() {
        if (2 === arguments.length) {
            var t = arguments[0], e = arguments[1], n = new lc;
            return n.add(t), n.add(e), n;
        }
        if (3 === arguments.length) {
            var r = arguments[0], i = arguments[1], o = arguments[2], s = new lc;
            return s.add(r), s.add(i), s.add(o), s;
        }
    };
    var Fg = function() {
        this._inputPolys = null, this._geomFactory = null;
        var t = arguments[0];
        this._inputPolys = t, null === this._inputPolys && (this._inputPolys = new lc);
    }, kg = {
        STRTREE_NODE_CAPACITY: {
            configurable: !0
        }
    };
    Fg.prototype.reduceToGeometries = function(t) {
        for(var e = new lc, n = t.iterator(); n.hasNext();){
            var r = n.next(), i = null;
            gl(r, ac) ? i = this.unionTree(r) : r instanceof Wl && (i = r), e.add(i);
        }
        return e;
    }, Fg.prototype.extractByEnvelope = function(t, e, n) {
        for(var r = new lc, i = 0; i < e.getNumGeometries(); i++){
            var o = e.getGeometryN(i);
            o.getEnvelopeInternal().intersects(t) ? r.add(o) : n.add(o);
        }
        return this._geomFactory.buildGeometry(r);
    }, Fg.prototype.unionOptimized = function(t, e) {
        var n = t.getEnvelopeInternal(), r = e.getEnvelopeInternal();
        if (!n.intersects(r)) return Dg.combine(t, e);
        if (t.getNumGeometries() <= 1 && e.getNumGeometries() <= 1) return this.unionActual(t, e);
        var i = n.intersection(r);
        return this.unionUsingEnvelopeIntersection(t, e, i);
    }, Fg.prototype.union = function() {
        if (null === this._inputPolys) throw new Error("union() method cannot be called twice");
        if (this._inputPolys.isEmpty()) return null;
        this._geomFactory = this._inputPolys.iterator().next().getFactory();
        for(var t = new up(Fg.STRTREE_NODE_CAPACITY), e = this._inputPolys.iterator(); e.hasNext();){
            var n = e.next();
            t.insert(n.getEnvelopeInternal(), n);
        }
        this._inputPolys = null;
        var r = t.itemsTree();
        return this.unionTree(r);
    }, Fg.prototype.binaryUnion = function() {
        if (1 === arguments.length) {
            var t = arguments[0];
            return this.binaryUnion(t, 0, t.size());
        }
        if (3 === arguments.length) {
            var e = arguments[0], n = arguments[1], r = arguments[2];
            if (r - n <= 1) {
                var i = Fg.getGeometry(e, n);
                return this.unionSafe(i, null);
            }
            if (r - n == 2) return this.unionSafe(Fg.getGeometry(e, n), Fg.getGeometry(e, n + 1));
            var o = Math.trunc((r + n) / 2), s = this.binaryUnion(e, n, o), a = this.binaryUnion(e, o, r);
            return this.unionSafe(s, a);
        }
    }, Fg.prototype.repeatedUnion = function(t) {
        for(var e = null, n = t.iterator(); n.hasNext();){
            var r = n.next();
            e = null === e ? r.copy() : e.union(r);
        }
        return e;
    }, Fg.prototype.unionSafe = function(t, e) {
        return null === t && null === e ? null : null === t ? e.copy() : null === e ? t.copy() : this.unionOptimized(t, e);
    }, Fg.prototype.unionActual = function(t, e) {
        return Fg.restrictToPolygons(t.union(e));
    }, Fg.prototype.unionTree = function(t) {
        var e = this.reduceToGeometries(t);
        return this.binaryUnion(e);
    }, Fg.prototype.unionUsingEnvelopeIntersection = function(t, e, n) {
        var r = new lc, i = this.extractByEnvelope(n, t, r), o = this.extractByEnvelope(n, e, r), s = this.unionActual(i, o);
        return r.add(s), Dg.combine(r);
    }, Fg.prototype.bufferUnion = function() {
        if (1 === arguments.length) {
            var t = arguments[0], e = t.get(0).getFactory(), n = e.buildGeometry(t), r = n.buffer(0);
            return r;
        }
        if (2 === arguments.length) {
            var i = arguments[0], o = arguments[1], s = i.getFactory(), a = s.createGeometryCollection([
                i,
                o
            ]), u = a.buffer(0);
            return u;
        }
    }, Fg.prototype.interfaces_ = function() {
        return [];
    }, Fg.prototype.getClass = function() {
        return Fg;
    }, Fg.restrictToPolygons = function(t) {
        if (gl(t, $c)) return t;
        var e = Sf.getPolygons(t);
        return 1 === e.size() ? e.get(0) : t.getFactory().createMultiPolygon(_h.toPolygonArray(e));
    }, Fg.getGeometry = function(t, e) {
        return e >= t.size() ? null : t.get(e);
    }, Fg.union = function(t) {
        return new Fg(t).union();
    }, kg.STRTREE_NODE_CAPACITY.get = function() {
        return 4;
    }, Object.defineProperties(Fg, kg);
    var Gg = function() {};
    function qg() {
        return new Bg;
    }
    function Bg() {
        this.reset();
    }
    Gg.prototype.interfaces_ = function() {
        return [];
    }, Gg.prototype.getClass = function() {
        return Gg;
    }, Gg.union = function(t, e) {
        if (t.isEmpty() || e.isEmpty()) {
            if (t.isEmpty() && e.isEmpty()) return Mg.createEmptyResult(Mg.UNION, t, e, t.getFactory());
            if (t.isEmpty()) return e.copy();
            if (e.isEmpty()) return t.copy();
        }
        return t.checkNotGeometryCollection(t), t.checkNotGeometryCollection(e), ug.overlayOp(t, e, Mg.UNION);
    }, Bg.prototype = {
        constructor: Bg,
        reset: function() {
            this.s = this.t = 0;
        },
        add: function(t) {
            jg(zg, t, this.t), jg(this, zg.s, this.s), this.s ? this.t += zg.t : this.s = zg.t;
        },
        valueOf: function() {
            return this.s;
        }
    };
    var zg = new Bg;
    function jg(t, e, n) {
        var r = t.s = e + n, i = r - e, o = r - i;
        t.t = e - o + (n - i);
    }
    var Ug = 1e-6, Vg = Math.PI, Xg = Vg / 2, Yg = Vg / 4, Hg = 2 * Vg, Wg = 180 / Vg, Jg = Vg / 180, Zg = Math.abs, Kg = Math.atan, Qg = Math.atan2, $g = Math.cos, td = Math.sin, ed = Math.sqrt;
    function nd(t) {
        return t > 1 ? 0 : t < -1 ? Vg : Math.acos(t);
    }
    function rd(t) {
        return t > 1 ? Xg : t < -1 ? -Xg : Math.asin(t);
    }
    function id() {}
    function od(t, e) {
        t && ad.hasOwnProperty(t.type) && ad[t.type](t, e);
    }
    var sd = {
        Feature: function(t, e) {
            od(t.geometry, e);
        },
        FeatureCollection: function(t, e) {
            for(var n = t.features, r = -1, i = n.length; ++r < i;)od(n[r].geometry, e);
        }
    }, ad = {
        Sphere: function(t, e) {
            e.sphere();
        },
        Point: function(t, e) {
            t = t.coordinates, e.point(t[0], t[1], t[2]);
        },
        MultiPoint: function(t, e) {
            for(var n = t.coordinates, r = -1, i = n.length; ++r < i;)t = n[r], e.point(t[0], t[1], t[2]);
        },
        LineString: function(t, e) {
            ud(t.coordinates, e, 0);
        },
        MultiLineString: function(t, e) {
            for(var n = t.coordinates, r = -1, i = n.length; ++r < i;)ud(n[r], e, 0);
        },
        Polygon: function(t, e) {
            ld(t.coordinates, e);
        },
        MultiPolygon: function(t, e) {
            for(var n = t.coordinates, r = -1, i = n.length; ++r < i;)ld(n[r], e);
        },
        GeometryCollection: function(t, e) {
            for(var n = t.geometries, r = -1, i = n.length; ++r < i;)od(n[r], e);
        }
    };
    function ud(t, e, n) {
        var r, i = -1, o = t.length - n;
        for(e.lineStart(); ++i < o;)r = t[i], e.point(r[0], r[1], r[2]);
        e.lineEnd();
    }
    function ld(t, e) {
        var n = -1, r = t.length;
        for(e.polygonStart(); ++n < r;)ud(t[n], e, 1);
        e.polygonEnd();
    }
    qg(), qg();
    function cd(t) {
        return [
            Qg(t[1], t[0]),
            rd(t[2])
        ];
    }
    function hd(t) {
        var e = t[0], n = t[1], r = $g(n);
        return [
            r * $g(e),
            r * td(e),
            td(n)
        ];
    }
    function pd(t, e) {
        return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
    }
    function fd(t, e) {
        return [
            t[1] * e[2] - t[2] * e[1],
            t[2] * e[0] - t[0] * e[2],
            t[0] * e[1] - t[1] * e[0]
        ];
    }
    function gd(t, e) {
        t[0] += e[0], t[1] += e[1], t[2] += e[2];
    }
    function dd(t, e) {
        return [
            t[0] * e,
            t[1] * e,
            t[2] * e
        ];
    }
    function yd(t) {
        var e = ed(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
        t[0] /= e, t[1] /= e, t[2] /= e;
    }
    qg();
    function vd(t, e) {
        function n(n, r) {
            return n = t(n, r), e(n[0], n[1]);
        }
        return t.invert && e.invert && (n.invert = function(n, r) {
            return (n = e.invert(n, r)) && t.invert(n[0], n[1]);
        }), n;
    }
    function _d(t, e) {
        return [
            t > Vg ? t - Hg : t < -Vg ? t + Hg : t,
            e
        ];
    }
    function md(t) {
        return function(e, n) {
            return [
                (e += t) > Vg ? e - Hg : e < -Vg ? e + Hg : e,
                n
            ];
        };
    }
    function xd(t) {
        var e = md(t);
        return e.invert = md(-t), e;
    }
    function Ed(t, e) {
        var n = $g(t), r = td(t), i = $g(e), o = td(e);
        function s(t, e) {
            var s = $g(e), a = $g(t) * s, u = td(t) * s, l = td(e), c = l * n + a * r;
            return [
                Qg(u * i - c * o, a * n - l * r),
                rd(c * i + u * o)
            ];
        }
        return s.invert = function(t, e) {
            var s = $g(e), a = $g(t) * s, u = td(t) * s, l = td(e), c = l * i - u * o;
            return [
                Qg(u * i + l * o, a * n + c * r),
                rd(c * n - a * r)
            ];
        }, s;
    }
    function bd(t, e) {
        (e = hd(e))[0] -= t, yd(e);
        var n = nd(-e[1]);
        return ((-e[2] < 0 ? -n : n) + Hg - Ug) % Hg;
    }
    function wd() {
        var t, e = [];
        return {
            point: function(e, n) {
                t.push([
                    e,
                    n
                ]);
            },
            lineStart: function() {
                e.push(t = []);
            },
            lineEnd: id,
            rejoin: function() {
                e.length > 1 && e.push(e.pop().concat(e.shift()));
            },
            result: function() {
                var n = e;
                return e = [], t = null, n;
            }
        };
    }
    function Id(t, e) {
        return Zg(t[0] - e[0]) < Ug && Zg(t[1] - e[1]) < Ug;
    }
    function Nd(t, e, n, r) {
        this.x = t, this.z = e, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
    }
    function Sd(t, e, n, r, i) {
        var o, s, a = [], u = [];
        if (t.forEach(function(t) {
            if (!((e = t.length - 1) <= 0)) {
                var e, n, r = t[0], s = t[e];
                if (Id(r, s)) {
                    for(i.lineStart(), o = 0; o < e; ++o)i.point((r = t[o])[0], r[1]);
                    i.lineEnd();
                } else a.push(n = new Nd(r, t, null, !0)), u.push(n.o = new Nd(r, null, n, !1)), a.push(n = new Nd(s, t, null, !1)), u.push(n.o = new Nd(s, null, n, !0));
            }
        }), a.length) {
            for(u.sort(e), Cd(a), Cd(u), o = 0, s = u.length; o < s; ++o)u[o].e = n = !n;
            for(var l, c, h = a[0];;){
                for(var p = h, f = !0; p.v;)if ((p = p.n) === h) return;
                l = p.z, i.lineStart();
                do {
                    if (p.v = p.o.v = !0, p.e) {
                        if (f) for(o = 0, s = l.length; o < s; ++o)i.point((c = l[o])[0], c[1]);
                        else r(p.x, p.n.x, 1, i);
                        p = p.n;
                    } else {
                        if (f) for(l = p.p.z, o = l.length - 1; o >= 0; --o)i.point((c = l[o])[0], c[1]);
                        else r(p.x, p.p.x, -1, i);
                        p = p.p;
                    }
                    l = (p = p.o).z, f = !f;
                }while (!p.v);
                i.lineEnd();
            }
        }
    }
    function Cd(t) {
        if (e = t.length) {
            for(var e, n, r = 0, i = t[0]; ++r < e;)i.n = n = t[r], n.p = i, i = n;
            i.n = n = t[0], n.p = i;
        }
    }
    function Pd(t, e) {
        return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
    }
    _d.invert = _d;
    var Md, Ld;
    1 === (Md = Pd).length && (Ld = Md, Md = function(t, e) {
        return Pd(Ld(t), e);
    });
    function Od(t) {
        for(var e, n, r, i = t.length, o = -1, s = 0; ++o < i;)s += t[o].length;
        for(n = new Array(s); --i >= 0;)for(e = (r = t[i]).length; --e >= 0;)n[--s] = r[e];
        return n;
    }
    var Rd = 1e9, Td = -Rd;
    function Ad(t, e, n, r) {
        function i(i, o) {
            return t <= i && i <= n && e <= o && o <= r;
        }
        function o(i, o, a, l) {
            var c = 0, h = 0;
            if (null == i || (c = s(i, a)) !== (h = s(o, a)) || u(i, o) < 0 ^ a > 0) do l.point(0 === c || 3 === c ? t : n, c > 1 ? r : e);
            while ((c = (c + a + 4) % 4) !== h);
            else l.point(o[0], o[1]);
        }
        function s(r, i) {
            return Zg(r[0] - t) < Ug ? i > 0 ? 0 : 3 : Zg(r[0] - n) < Ug ? i > 0 ? 2 : 1 : Zg(r[1] - e) < Ug ? i > 0 ? 1 : 0 : i > 0 ? 3 : 2;
        }
        function a(t, e) {
            return u(t.x, e.x);
        }
        function u(t, e) {
            var n = s(t, 1), r = s(e, 1);
            return n !== r ? n - r : 0 === n ? e[1] - t[1] : 1 === n ? t[0] - e[0] : 2 === n ? t[1] - e[1] : e[0] - t[0];
        }
        return function(s) {
            var u, l, c, h, p, f, g, d, y, v, _, m = s, x = wd(), E = {
                point: b,
                lineStart: function() {
                    E.point = w, l && l.push(c = []);
                    v = !0, y = !1, g = d = NaN;
                },
                lineEnd: function() {
                    u && (w(h, p), f && y && x.rejoin(), u.push(x.result()));
                    E.point = b, y && m.lineEnd();
                },
                polygonStart: function() {
                    m = x, u = [], l = [], _ = !0;
                },
                polygonEnd: function() {
                    var e = function() {
                        for(var e = 0, n = 0, i = l.length; n < i; ++n)for(var o, s, a = l[n], u = 1, c = a.length, h = a[0], p = h[0], f = h[1]; u < c; ++u)o = p, s = f, p = (h = a[u])[0], f = h[1], s <= r ? f > r && (p - o) * (r - s) > (f - s) * (t - o) && ++e : f <= r && (p - o) * (r - s) < (f - s) * (t - o) && --e;
                        return e;
                    }(), n = _ && e, i = (u = Od(u)).length;
                    (n || i) && (s.polygonStart(), n && (s.lineStart(), o(null, null, 1, s), s.lineEnd()), i && Sd(u, a, e, o, s), s.polygonEnd());
                    m = s, u = l = c = null;
                }
            };
            function b(t, e) {
                i(t, e) && m.point(t, e);
            }
            function w(o, s) {
                var a = i(o, s);
                if (l && c.push([
                    o,
                    s
                ]), v) h = o, p = s, f = a, v = !1, a && (m.lineStart(), m.point(o, s));
                else if (a && y) m.point(o, s);
                else {
                    var u = [
                        g = Math.max(Td, Math.min(Rd, g)),
                        d = Math.max(Td, Math.min(Rd, d))
                    ], x = [
                        o = Math.max(Td, Math.min(Rd, o)),
                        s = Math.max(Td, Math.min(Rd, s))
                    ];
                    !function(t, e, n, r, i, o) {
                        var s, a = t[0], u = t[1], l = 0, c = 1, h = e[0] - a, p = e[1] - u;
                        if (s = n - a, h || !(s > 0)) {
                            if (s /= h, h < 0) {
                                if (s < l) return;
                                s < c && (c = s);
                            } else if (h > 0) {
                                if (s > c) return;
                                s > l && (l = s);
                            }
                            if (s = i - a, h || !(s < 0)) {
                                if (s /= h, h < 0) {
                                    if (s > c) return;
                                    s > l && (l = s);
                                } else if (h > 0) {
                                    if (s < l) return;
                                    s < c && (c = s);
                                }
                                if (s = r - u, p || !(s > 0)) {
                                    if (s /= p, p < 0) {
                                        if (s < l) return;
                                        s < c && (c = s);
                                    } else if (p > 0) {
                                        if (s > c) return;
                                        s > l && (l = s);
                                    }
                                    if (s = o - u, p || !(s < 0)) {
                                        if (s /= p, p < 0) {
                                            if (s > c) return;
                                            s > l && (l = s);
                                        } else if (p > 0) {
                                            if (s < l) return;
                                            s < c && (c = s);
                                        }
                                        return l > 0 && (t[0] = a + l * h, t[1] = u + l * p), c < 1 && (e[0] = a + c * h, e[1] = u + c * p), !0;
                                    }
                                }
                            }
                        }
                    }(u, x, t, e, n, r) ? a && (m.lineStart(), m.point(o, s), _ = !1) : (y || (m.lineStart(), m.point(u[0], u[1])), m.point(x[0], x[1]), a || m.lineEnd(), _ = !1);
                }
                g = o, d = s, y = a;
            }
            return E;
        };
    }
    var Dd = qg();
    qg();
    function Fd(t) {
        return t;
    }
    qg(), qg();
    var kd = 1 / 0, Gd = kd, qd = -kd, Bd = qd, zd = {
        point: function(t, e) {
            t < kd && (kd = t);
            t > qd && (qd = t);
            e < Gd && (Gd = e);
            e > Bd && (Bd = e);
        },
        lineStart: id,
        lineEnd: id,
        polygonStart: id,
        polygonEnd: id,
        result: function() {
            var t = [
                [
                    kd,
                    Gd
                ],
                [
                    qd,
                    Bd
                ]
            ];
            return qd = Bd = -(Gd = kd = 1 / 0), t;
        }
    };
    qg();
    function jd(t, e, n, r) {
        return function(i, o) {
            var s, a, u, l = e(o), c = i.invert(r[0], r[1]), h = wd(), p = e(h), f = !1, g = {
                point: d,
                lineStart: v,
                lineEnd: _,
                polygonStart: function() {
                    g.point = m, g.lineStart = x, g.lineEnd = E, a = [], s = [];
                },
                polygonEnd: function() {
                    g.point = d, g.lineStart = v, g.lineEnd = _, a = Od(a);
                    var t = function(t, e) {
                        var n = e[0], r = e[1], i = [
                            td(n),
                            -$g(n),
                            0
                        ], o = 0, s = 0;
                        Dd.reset();
                        for(var a = 0, u = t.length; a < u; ++a)if (c = (l = t[a]).length) for(var l, c, h = l[c - 1], p = h[0], f = h[1] / 2 + Yg, g = td(f), d = $g(f), y = 0; y < c; ++y, p = _, g = x, d = E, h = v){
                            var v = l[y], _ = v[0], m = v[1] / 2 + Yg, x = td(m), E = $g(m), b = _ - p, w = b >= 0 ? 1 : -1, I = w * b, N = I > Vg, S = g * x;
                            if (Dd.add(Qg(S * w * td(I), d * E + S * $g(I))), o += N ? b + w * Hg : b, N ^ p >= n ^ _ >= n) {
                                var C = fd(hd(h), hd(v));
                                yd(C);
                                var P = fd(i, C);
                                yd(P);
                                var M = (N ^ b >= 0 ? -1 : 1) * rd(P[2]);
                                (r > M || r === M && (C[0] || C[1])) && (s += N ^ b >= 0 ? 1 : -1);
                            }
                        }
                        return (o < -0.000001 || o < Ug && Dd < -0.000001) ^ 1 & s;
                    }(s, c);
                    a.length ? (f || (o.polygonStart(), f = !0), Sd(a, Vd, t, n, o)) : t && (f || (o.polygonStart(), f = !0), o.lineStart(), n(null, null, 1, o), o.lineEnd()), f && (o.polygonEnd(), f = !1), a = s = null;
                },
                sphere: function() {
                    o.polygonStart(), o.lineStart(), n(null, null, 1, o), o.lineEnd(), o.polygonEnd();
                }
            };
            function d(e, n) {
                var r = i(e, n);
                t(e = r[0], n = r[1]) && o.point(e, n);
            }
            function y(t, e) {
                var n = i(t, e);
                l.point(n[0], n[1]);
            }
            function v() {
                g.point = y, l.lineStart();
            }
            function _() {
                g.point = d, l.lineEnd();
            }
            function m(t, e) {
                u.push([
                    t,
                    e
                ]);
                var n = i(t, e);
                p.point(n[0], n[1]);
            }
            function x() {
                p.lineStart(), u = [];
            }
            function E() {
                m(u[0][0], u[0][1]), p.lineEnd();
                var t, e, n, r, i = p.clean(), l = h.result(), c = l.length;
                if (u.pop(), s.push(u), u = null, c) {
                    if (1 & i) {
                        if ((e = (n = l[0]).length - 1) > 0) {
                            for(f || (o.polygonStart(), f = !0), o.lineStart(), t = 0; t < e; ++t)o.point((r = n[t])[0], r[1]);
                            o.lineEnd();
                        }
                    } else c > 1 && 2 & i && l.push(l.pop().concat(l.shift())), a.push(l.filter(Ud));
                }
            }
            return g;
        };
    }
    function Ud(t) {
        return t.length > 1;
    }
    function Vd(t, e) {
        return ((t = t.x)[0] < 0 ? t[1] - Xg - Ug : Xg - t[1]) - ((e = e.x)[0] < 0 ? e[1] - Xg - Ug : Xg - e[1]);
    }
    var Xd = jd(function() {
        return !0;
    }, function(t) {
        var e, n = NaN, r = NaN, i = NaN;
        return {
            lineStart: function() {
                t.lineStart(), e = 1;
            },
            point: function(o, s) {
                var a = o > 0 ? Vg : -Vg, u = Zg(o - n);
                Zg(u - Vg) < Ug ? (t.point(n, r = (r + s) / 2 > 0 ? Xg : -Xg), t.point(i, r), t.lineEnd(), t.lineStart(), t.point(a, r), t.point(o, r), e = 0) : i !== a && u >= Vg && (Zg(n - i) < Ug && (n -= i * Ug), Zg(o - a) < Ug && (o -= a * Ug), r = function(t, e, n, r) {
                    var i, o, s = td(t - n);
                    return Zg(s) > Ug ? Kg((td(e) * (o = $g(r)) * td(n) - td(r) * (i = $g(e)) * td(t)) / (i * o * s)) : (e + r) / 2;
                }(n, r, o, s), t.point(i, r), t.lineEnd(), t.lineStart(), t.point(a, r), e = 0), t.point(n = o, r = s), i = a;
            },
            lineEnd: function() {
                t.lineEnd(), n = r = NaN;
            },
            clean: function() {
                return 2 - e;
            }
        };
    }, function(t, e, n, r) {
        var i;
        if (null == t) i = n * Xg, r.point(-Vg, i), r.point(0, i), r.point(Vg, i), r.point(Vg, 0), r.point(Vg, -i), r.point(0, -i), r.point(-Vg, -i), r.point(-Vg, 0), r.point(-Vg, i);
        else if (Zg(t[0] - e[0]) > Ug) {
            var o = t[0] < e[0] ? Vg : -Vg;
            i = n * o / 2, r.point(-o, i), r.point(0, i), r.point(o, i);
        } else r.point(e[0], e[1]);
    }, [
        -Vg,
        -Xg
    ]);
    function Yd(t, e) {
        var n = $g(t), r = n > 0, i = Zg(n) > Ug;
        function o(t, e) {
            return $g(t) * $g(e) > n;
        }
        function s(t, e, r) {
            var i = [
                1,
                0,
                0
            ], o = fd(hd(t), hd(e)), s = pd(o, o), a = o[0], u = s - a * a;
            if (!u) return !r && t;
            var l = n * s / u, c = -n * a / u, h = fd(i, o), p = dd(i, l);
            gd(p, dd(o, c));
            var f = h, g = pd(p, f), d = pd(f, f), y = g * g - d * (pd(p, p) - 1);
            if (!(y < 0)) {
                var v = ed(y), _ = dd(f, (-g - v) / d);
                if (gd(_, p), _ = cd(_), !r) return _;
                var m, x = t[0], E = e[0], b = t[1], w = e[1];
                E < x && (m = x, x = E, E = m);
                var I = E - x, N = Zg(I - Vg) < Ug;
                if (!N && w < b && (m = b, b = w, w = m), N || I < Ug ? N ? b + w > 0 ^ _[1] < (Zg(_[0] - x) < Ug ? b : w) : b <= _[1] && _[1] <= w : I > Vg ^ (x <= _[0] && _[0] <= E)) {
                    var S = dd(f, (-g + v) / d);
                    return gd(S, p), [
                        _,
                        cd(S)
                    ];
                }
            }
        }
        function a(e, n) {
            var i = r ? t : Vg - t, o = 0;
            return e < -i ? o |= 1 : e > i && (o |= 2), n < -i ? o |= 4 : n > i && (o |= 8), o;
        }
        return jd(o, function(t) {
            var e, n, u, l, c;
            return {
                lineStart: function() {
                    l = u = !1, c = 1;
                },
                point: function(h, p) {
                    var f, g = [
                        h,
                        p
                    ], d = o(h, p), y = r ? d ? 0 : a(h, p) : d ? a(h + (h < 0 ? Vg : -Vg), p) : 0;
                    if (!e && (l = u = d) && t.lineStart(), d !== u && (!(f = s(e, g)) || Id(e, f) || Id(g, f)) && (g[0] += Ug, g[1] += Ug, d = o(g[0], g[1])), d !== u) c = 0, d ? (t.lineStart(), f = s(g, e), t.point(f[0], f[1])) : (f = s(e, g), t.point(f[0], f[1]), t.lineEnd()), e = f;
                    else if (i && e && r ^ d) {
                        var v;
                        y & n || !(v = s(g, e, !0)) || (c = 0, r ? (t.lineStart(), t.point(v[0][0], v[0][1]), t.point(v[1][0], v[1][1]), t.lineEnd()) : (t.point(v[1][0], v[1][1]), t.lineEnd(), t.lineStart(), t.point(v[0][0], v[0][1])));
                    }
                    !d || e && Id(e, g) || t.point(g[0], g[1]), e = g, u = d, n = y;
                },
                lineEnd: function() {
                    u && t.lineEnd(), e = null;
                },
                clean: function() {
                    return c | (l && u) << 1;
                }
            };
        }, function(n, r, i, o) {
            !function(t, e, n, r, i, o) {
                if (n) {
                    var s = $g(e), a = td(e), u = r * n;
                    null == i ? (i = e + r * Hg, o = e - u / 2) : (i = bd(s, i), o = bd(s, o), (r > 0 ? i < o : i > o) && (i += r * Hg));
                    for(var l, c = i; r > 0 ? c > o : c < o; c -= u)l = cd([
                        s,
                        -a * $g(c),
                        -a * td(c)
                    ]), t.point(l[0], l[1]);
                }
            }(o, t, e, i, n, r);
        }, r ? [
            0,
            -t
        ] : [
            -Vg,
            t - Vg
        ]);
    }
    function Hd(t) {
        return function(e) {
            var n = new Wd;
            for(var r in t)n[r] = t[r];
            return n.stream = e, n;
        };
    }
    function Wd() {}
    function Jd(t, e, n) {
        var r = e[1][0] - e[0][0], i = e[1][1] - e[0][1], o = t.clipExtent && t.clipExtent();
        t.scale(150).translate([
            0,
            0
        ]), null != o && t.clipExtent(null), function(t, e) {
            t && sd.hasOwnProperty(t.type) ? sd[t.type](t, e) : od(t, e);
        }(n, t.stream(zd));
        var s = zd.result(), a = Math.min(r / (s[1][0] - s[0][0]), i / (s[1][1] - s[0][1])), u = +e[0][0] + (r - a * (s[1][0] + s[0][0])) / 2, l = +e[0][1] + (i - a * (s[1][1] + s[0][1])) / 2;
        return null != o && t.clipExtent(o), t.scale(150 * a).translate([
            u,
            l
        ]);
    }
    Wd.prototype = {
        constructor: Wd,
        point: function(t, e) {
            this.stream.point(t, e);
        },
        sphere: function() {
            this.stream.sphere();
        },
        lineStart: function() {
            this.stream.lineStart();
        },
        lineEnd: function() {
            this.stream.lineEnd();
        },
        polygonStart: function() {
            this.stream.polygonStart();
        },
        polygonEnd: function() {
            this.stream.polygonEnd();
        }
    };
    var Zd = $g(30 * Jg);
    function Kd(t, e) {
        return +e ? function(t, e) {
            function n(r, i, o, s, a, u, l, c, h, p, f, g, d, y) {
                var v = l - r, _ = c - i, m = v * v + _ * _;
                if (m > 4 * e && d--) {
                    var x = s + p, E = a + f, b = u + g, w = ed(x * x + E * E + b * b), I = rd(b /= w), N = Zg(Zg(b) - 1) < Ug || Zg(o - h) < Ug ? (o + h) / 2 : Qg(E, x), S = t(N, I), C = S[0], P = S[1], M = C - r, L = P - i, O = _ * M - v * L;
                    (O * O / m > e || Zg((v * M + _ * L) / m - .5) > .3 || s * p + a * f + u * g < Zd) && (n(r, i, o, s, a, u, C, P, N, x /= w, E /= w, b, d, y), y.point(C, P), n(C, P, N, x, E, b, l, c, h, p, f, g, d, y));
                }
            }
            return function(e) {
                var r, i, o, s, a, u, l, c, h, p, f, g, d = {
                    point: y,
                    lineStart: v,
                    lineEnd: m,
                    polygonStart: function() {
                        e.polygonStart(), d.lineStart = x;
                    },
                    polygonEnd: function() {
                        e.polygonEnd(), d.lineStart = v;
                    }
                };
                function y(n, r) {
                    n = t(n, r), e.point(n[0], n[1]);
                }
                function v() {
                    c = NaN, d.point = _, e.lineStart();
                }
                function _(r, i) {
                    var o = hd([
                        r,
                        i
                    ]), s = t(r, i);
                    n(c, h, l, p, f, g, c = s[0], h = s[1], l = r, p = o[0], f = o[1], g = o[2], 16, e), e.point(c, h);
                }
                function m() {
                    d.point = y, e.lineEnd();
                }
                function x() {
                    v(), d.point = E, d.lineEnd = b;
                }
                function E(t, e) {
                    _(r = t, e), i = c, o = h, s = p, a = f, u = g, d.point = _;
                }
                function b() {
                    n(c, h, l, p, f, g, i, o, r, s, a, u, 16, e), d.lineEnd = m, m();
                }
                return d;
            };
        }(t, e) : function(t) {
            return Hd({
                point: function(e, n) {
                    e = t(e, n), this.stream.point(e[0], e[1]);
                }
            });
        }(t);
    }
    var Qd = Hd({
        point: function(t, e) {
            this.stream.point(t * Jg, e * Jg);
        }
    });
    function $d(t) {
        return (function(t) {
            var e, n, r, i, o, s, a, u, l, c, h = 150, p = 480, f = 250, g = 0, d = 0, y = 0, v = 0, _ = 0, m = null, x = Xd, E = null, b = Fd, w = .5, I = Kd(C, w);
            function N(t) {
                return [
                    (t = o(t[0] * Jg, t[1] * Jg))[0] * h + n,
                    r - t[1] * h
                ];
            }
            function S(t) {
                return (t = o.invert((t[0] - n) / h, (r - t[1]) / h)) && [
                    t[0] * Wg,
                    t[1] * Wg
                ];
            }
            function C(t, i) {
                return [
                    (t = e(t, i))[0] * h + n,
                    r - t[1] * h
                ];
            }
            function P() {
                o = vd(i = function(t, e, n) {
                    return (t %= Hg) ? e || n ? vd(xd(t), Ed(e, n)) : xd(t) : e || n ? Ed(e, n) : _d;
                }(y, v, _), e);
                var t = e(g, d);
                return n = p - t[0] * h, r = f + t[1] * h, M();
            }
            function M() {
                return l = c = null, N;
            }
            return N.stream = function(t) {
                return l && c === t ? l : l = Qd(x(i, I(b(c = t))));
            }, N.clipAngle = function(t) {
                return arguments.length ? (x = +t ? Yd(m = t * Jg, 6 * Jg) : (m = null, Xd), M()) : m * Wg;
            }, N.clipExtent = function(t) {
                return arguments.length ? (b = null == t ? (E = s = a = u = null, Fd) : Ad(E = +t[0][0], s = +t[0][1], a = +t[1][0], u = +t[1][1]), M()) : null == E ? null : [
                    [
                        E,
                        s
                    ],
                    [
                        a,
                        u
                    ]
                ];
            }, N.scale = function(t) {
                return arguments.length ? (h = +t, P()) : h;
            }, N.translate = function(t) {
                return arguments.length ? (p = +t[0], f = +t[1], P()) : [
                    p,
                    f
                ];
            }, N.center = function(t) {
                return arguments.length ? (g = t[0] % 360 * Jg, d = t[1] % 360 * Jg, P()) : [
                    g * Wg,
                    d * Wg
                ];
            }, N.rotate = function(t) {
                return arguments.length ? (y = t[0] % 360 * Jg, v = t[1] % 360 * Jg, _ = t.length > 2 ? t[2] % 360 * Jg : 0, P()) : [
                    y * Wg,
                    v * Wg,
                    _ * Wg
                ];
            }, N.precision = function(t) {
                return arguments.length ? (I = Kd(C, w = t * t), M()) : ed(w);
            }, N.fitExtent = function(t, e) {
                return Jd(N, t, e);
            }, N.fitSize = function(t, e) {
                return function(t, e, n) {
                    return Jd(t, [
                        [
                            0,
                            0
                        ],
                        e
                    ], n);
                }(N, t, e);
            }, function() {
                return e = t.apply(this, arguments), N.invert = e.invert && S, P();
            };
        })(function() {
            return t;
        })();
    }
    var ty = function(t) {
        return function(e, n) {
            var r = $g(e), i = $g(n), o = t(r * i);
            return [
                o * i * td(e),
                o * td(n)
            ];
        };
    }(function(t) {
        return (t = nd(t)) && t / td(t);
    });
    function ey() {
        return $d(ty).scale(79.4188).clipAngle(179.999);
    }
    function ny(t, n, r, i) {
        var s = t.properties || {}, a = "Feature" === t.type ? t.geometry : t;
        if ("GeometryCollection" === a.type) {
            var u = [];
            return q(t, function(t) {
                var e = ny(t, n, r, i);
                e && u.push(e);
            }), f(u);
        }
        var l = function(t) {
            var n = xn(t).geometry.coordinates, r = [
                -n[0],
                -n[1]
            ];
            return ey().rotate(r).scale(e);
        }(a), c = {
            type: a.type,
            coordinates: iy(a.coordinates, l)
        }, h = (new Ih).read(c), p = m(x(n, r), "meters"), g = _f.bufferOp(h, p, i);
        if (!ry((g = (new Nh).write(g)).coordinates)) return o({
            type: g.type,
            coordinates: oy(g.coordinates, l)
        }, s);
    }
    function ry(t) {
        return Array.isArray(t[0]) ? ry(t[0]) : isNaN(t[0]);
    }
    function iy(t, e) {
        return "object" != typeof t[0] ? e(t) : t.map(function(t) {
            return iy(t, e);
        });
    }
    function oy(t, e) {
        return "object" != typeof t[0] ? e.invert(t) : t.map(function(t) {
            return oy(t, e);
        });
    }
    function sy(t, e, n) {
        void 0 === n && (n = {});
        var r = rt(t), i = rt(e), o = $u.intersection(r.coordinates, i.coordinates);
        return 0 === o.length ? null : 1 === o.length ? l(o[0], n.properties) : y(o, n.properties);
    }
    function ay(t, e, n) {
        void 0 === n && (n = {});
        var r = JSON.stringify(n.properties || {}), i = t[0], o = t[1], s = t[2], a = t[3], u = (o + a) / 2, l = (i + s) / 2, c = 2 * e / me([
            i,
            u
        ], [
            s,
            u
        ], n) * (s - i), h = 2 * e / me([
            l,
            o
        ], [
            l,
            a
        ], n) * (a - o), p = c / 2, g = 2 * p, d = Math.sqrt(3) / 2 * h, y = s - i, v = a - o, _ = 3 / 4 * g, m = d, x = (y - g) / (g - p / 2), E = Math.floor(x), b = (E * _ - p / 2 - y) / 2 - p / 2 + _ / 2, w = Math.floor((v - d) / d), I = (v - w * d) / 2, N = w * d - v > d / 2;
        N && (I -= d / 4);
        for(var S = [], C = [], P = 0; P < 6; P++){
            var M = 2 * Math.PI / 6 * P;
            S.push(Math.cos(M)), C.push(Math.sin(M));
        }
        for(var L = [], O = 0; O <= E; O++)for(var R = 0; R <= w; R++){
            var T = O % 2 == 1;
            if ((0 !== R || !T) && (0 !== R || !N)) {
                var A = O * _ + i - b, D = R * m + o + I;
                if (T && (D -= d / 2), !0 === n.triangles) ly([
                    A,
                    D
                ], c / 2, h / 2, JSON.parse(r), S, C).forEach(function(t) {
                    n.mask ? sy(n.mask, t) && L.push(t) : L.push(t);
                });
                else {
                    var F = uy([
                        A,
                        D
                    ], c / 2, h / 2, JSON.parse(r), S, C);
                    n.mask ? sy(n.mask, F) && L.push(F) : L.push(F);
                }
            }
        }
        return f(L);
    }
    function uy(t, e, n, r, i, o) {
        for(var s = [], a = 0; a < 6; a++){
            var u = t[0] + e * i[a], c = t[1] + n * o[a];
            s.push([
                u,
                c
            ]);
        }
        return s.push(s[0].slice()), l([
            s
        ], r);
    }
    function ly(t, e, n, r, i, o) {
        for(var s = [], a = 0; a < 6; a++){
            var u = [];
            u.push(t), u.push([
                t[0] + e * i[a],
                t[1] + n * o[a]
            ]), u.push([
                t[0] + e * i[(a + 1) % 6],
                t[1] + n * o[(a + 1) % 6]
            ]), u.push(t), s.push(l([
                u
            ], r));
        }
        return s;
    }
    function cy(t) {
        return y(t);
    }
    function hy(t) {
        return l(t && t.geometry.coordinates || [
            [
                [
                    180,
                    90
                ],
                [
                    -180,
                    90
                ],
                [
                    -180,
                    -90
                ],
                [
                    180,
                    -90
                ],
                [
                    180,
                    90
                ]
            ]
        ]);
    }
    function py(t, e, n) {
        return void 0 === n && (n = {}), function(t, e, n, r) {
            void 0 === r && (r = {});
            for(var i = [], o = t[0], s = t[1], a = t[2], u = t[3], c = e / me([
                o,
                s
            ], [
                a,
                s
            ], r) * (a - o), h = n / me([
                o,
                s
            ], [
                o,
                u
            ], r) * (u - s), p = a - o, g = u - s, d = Math.floor(p / c), y = Math.floor(g / h), v = (g - y * h) / 2, _ = o + (p - d * c) / 2, m = 0; m < d; m++){
                for(var x = s + v, E = 0; E < y; E++){
                    var b = l([
                        [
                            [
                                _,
                                x
                            ],
                            [
                                _,
                                x + h
                            ],
                            [
                                _ + c,
                                x + h
                            ],
                            [
                                _ + c,
                                x
                            ],
                            [
                                _,
                                x
                            ]
                        ]
                    ], r.properties);
                    r.mask ? Ps(r.mask, b) && i.push(b) : i.push(b), x += h;
                }
                _ += c;
            }
            return f(i);
        }(t, e, e, n);
    }
    function fy(t, e, n) {
        void 0 === n && (n = {});
        for(var r = [], i = e / me([
            t[0],
            t[1]
        ], [
            t[2],
            t[1]
        ], n) * (t[2] - t[0]), o = e / me([
            t[0],
            t[1]
        ], [
            t[0],
            t[3]
        ], n) * (t[3] - t[1]), s = 0, a = t[0]; a <= t[2];){
            for(var u = 0, c = t[1]; c <= t[3];){
                var h = null, p = null;
                s % 2 == 0 && u % 2 == 0 ? (h = l([
                    [
                        [
                            a,
                            c
                        ],
                        [
                            a,
                            c + o
                        ],
                        [
                            a + i,
                            c
                        ],
                        [
                            a,
                            c
                        ]
                    ]
                ], n.properties), p = l([
                    [
                        [
                            a,
                            c + o
                        ],
                        [
                            a + i,
                            c + o
                        ],
                        [
                            a + i,
                            c
                        ],
                        [
                            a,
                            c + o
                        ]
                    ]
                ], n.properties)) : s % 2 == 0 && u % 2 == 1 ? (h = l([
                    [
                        [
                            a,
                            c
                        ],
                        [
                            a + i,
                            c + o
                        ],
                        [
                            a + i,
                            c
                        ],
                        [
                            a,
                            c
                        ]
                    ]
                ], n.properties), p = l([
                    [
                        [
                            a,
                            c
                        ],
                        [
                            a,
                            c + o
                        ],
                        [
                            a + i,
                            c + o
                        ],
                        [
                            a,
                            c
                        ]
                    ]
                ], n.properties)) : u % 2 == 0 && s % 2 == 1 ? (h = l([
                    [
                        [
                            a,
                            c
                        ],
                        [
                            a,
                            c + o
                        ],
                        [
                            a + i,
                            c + o
                        ],
                        [
                            a,
                            c
                        ]
                    ]
                ], n.properties), p = l([
                    [
                        [
                            a,
                            c
                        ],
                        [
                            a + i,
                            c + o
                        ],
                        [
                            a + i,
                            c
                        ],
                        [
                            a,
                            c
                        ]
                    ]
                ], n.properties)) : u % 2 == 1 && s % 2 == 1 && (h = l([
                    [
                        [
                            a,
                            c
                        ],
                        [
                            a,
                            c + o
                        ],
                        [
                            a + i,
                            c
                        ],
                        [
                            a,
                            c
                        ]
                    ]
                ], n.properties), p = l([
                    [
                        [
                            a,
                            c + o
                        ],
                        [
                            a + i,
                            c + o
                        ],
                        [
                            a + i,
                            c
                        ],
                        [
                            a,
                            c + o
                        ]
                    ]
                ], n.properties)), n.mask ? (sy(n.mask, h) && r.push(h), sy(n.mask, p) && r.push(p)) : (r.push(h), r.push(p)), c += o, u++;
            }
            s++, a += i;
        }
        return f(r);
    }
    ty.invert = function(t) {
        return function(e, n) {
            var r = ed(e * e + n * n), i = t(r), o = td(i), s = $g(i);
            return [
                Qg(e * o, r * s),
                rd(r && n * o / r)
            ];
        };
    }(function(t) {
        return t;
    }), t.along = function(t, e, n) {
        void 0 === n && (n = {});
        for(var r = rt(t).coordinates, i = 0, o = 0; o < r.length && !(e >= i && o === r.length - 1); o++){
            if (i >= e) {
                var s = e - i;
                if (s) {
                    var u = mn(r[o], r[o - 1]) - 180;
                    return vn(r[o], s, u, n);
                }
                return a(r[o]);
            }
            i += me(r[o], r[o + 1], n);
        }
        return a(r[r.length - 1]);
    }, t.angle = function(t, e, n, r) {
        if (void 0 === r && (r = {}), !P(r)) throw new Error("options is invalid");
        if (!t) throw new Error("startPoint is required");
        if (!e) throw new Error("midPoint is required");
        if (!n) throw new Error("endPoint is required");
        var i = t, o = e, s = n, a = b(!0 !== r.mercator ? mn(i, o) : Bi(i, o)), u = b(!0 !== r.mercator ? mn(s, o) : Bi(s, o)), l = Math.abs(a - u);
        return !0 === r.explementary ? 360 - l : l;
    }, t.applyFilter = uu, t.area = jr, t.areaFactors = i, t.bbox = Z, t.bboxClip = function(t, e) {
        var n = rt(t), r = n.type, i = "Feature" === t.type ? t.properties : {}, o = n.coordinates;
        switch(r){
            case "LineString":
            case "MultiLineString":
                var s = [];
                return "LineString" === r && (o = [
                    o
                ]), o.forEach(function(t) {
                    !function(t, e, n) {
                        var r, i, o, s, a, u = t.length, l = Ri(t[0], e), c = [];
                        for(n || (n = []), r = 1; r < u; r++){
                            for(s = t[r - 1], i = o = Ri(a = t[r], e);;){
                                if (!(l | i)) {
                                    c.push(s), i !== o ? (c.push(a), r < u - 1 && (n.push(c), c = [])) : r === u - 1 && c.push(a);
                                    break;
                                }
                                if (l & i) break;
                                l ? l = Ri(s = Oi(s, a, l, e), e) : i = Ri(a = Oi(s, a, i, e), e);
                            }
                            l = o;
                        }
                        c.length && n.push(c);
                    }(t, e, s);
                }), 1 === s.length ? h(s[0], i) : g(s, i);
            case "Polygon":
                return l(Ti(o, e), i);
            case "MultiPolygon":
                return y(o.map(function(t) {
                    return Ti(t, e);
                }), i);
            default:
                throw new Error("geometry " + r + " not supported");
        }
    }, t.bboxPolygon = gn, t.bearing = mn, t.bearingToAngle = b, t.bearingToAzimuth = b, t.bezier = fn, t.bezierSpline = fn, t.booleanClockwise = Yi, t.booleanContains = function(t, e) {
        var n = rt(t), r = rt(e), i = n.type, o = r.type, s = n.coordinates, a = r.coordinates;
        switch(i){
            case "Point":
                switch(o){
                    case "Point":
                        return vs(s, a);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "MultiPoint":
                switch(o){
                    case "Point":
                        return function(t, e) {
                            var n, r = !1;
                            for(n = 0; n < t.coordinates.length; n++)if (vs(t.coordinates[n], e.coordinates)) {
                                r = !0;
                                break;
                            }
                            return r;
                        }(n, r);
                    case "MultiPoint":
                        return function(t, e) {
                            for(var n = 0, r = e.coordinates; n < r.length; n++){
                                for(var i = r[n], o = !1, s = 0, a = t.coordinates; s < a.length; s++)if (vs(i, a[s])) {
                                    o = !0;
                                    break;
                                }
                                if (!o) return !1;
                            }
                            return !0;
                        }(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "LineString":
                switch(o){
                    case "Point":
                        return Wr(r, n, {
                            ignoreEndVertices: !0
                        });
                    case "LineString":
                        return function(t, e) {
                            for(var n = !1, r = 0, i = e.coordinates; r < i.length; r++){
                                var o = i[r];
                                if (Wr({
                                    type: "Point",
                                    coordinates: o
                                }, t, {
                                    ignoreEndVertices: !0
                                }) && (n = !0), !Wr({
                                    type: "Point",
                                    coordinates: o
                                }, t, {
                                    ignoreEndVertices: !1
                                })) return !1;
                            }
                            return n;
                        }(n, r);
                    case "MultiPoint":
                        return function(t, e) {
                            for(var n = !1, r = 0, i = e.coordinates; r < i.length; r++){
                                var o = i[r];
                                if (Wr(o, t, {
                                    ignoreEndVertices: !0
                                }) && (n = !0), !Wr(o, t)) return !1;
                            }
                            if (n) return !0;
                            return !1;
                        }(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "Polygon":
                switch(o){
                    case "Point":
                        return ye(r, n, {
                            ignoreBoundary: !0
                        });
                    case "LineString":
                        return function(t, e) {
                            var n = !1, r = 0, i = Z(t), o = Z(e);
                            if (!ys(i, o)) return !1;
                            for(; r < e.coordinates.length - 1; r++)if (ye({
                                type: "Point",
                                coordinates: _s(e.coordinates[r], e.coordinates[r + 1])
                            }, t, {
                                ignoreBoundary: !0
                            })) {
                                n = !0;
                                break;
                            }
                            return n;
                        }(n, r);
                    case "Polygon":
                        return function(t, e) {
                            if ("Feature" === t.type && null === t.geometry) return !1;
                            if ("Feature" === e.type && null === e.geometry) return !1;
                            var n = Z(t), r = Z(e);
                            if (!ys(n, r)) return !1;
                            for(var i = rt(e).coordinates, o = 0, s = i; o < s.length; o++)for(var a = 0, u = s[o]; a < u.length; a++){
                                if (!ye(u[a], t)) return !1;
                            }
                            return !0;
                        }(n, r);
                    case "MultiPoint":
                        return function(t, e) {
                            for(var n = 0, r = e.coordinates; n < r.length; n++){
                                if (!ye(r[n], t, {
                                    ignoreBoundary: !0
                                })) return !1;
                            }
                            return !0;
                        }(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            default:
                throw new Error("feature1 " + i + " geometry not supported");
        }
    }, t.booleanCrosses = function(t, e) {
        var n = rt(t), r = rt(e), i = n.type, o = r.type;
        switch(i){
            case "MultiPoint":
                switch(o){
                    case "LineString":
                        return ms(n, r);
                    case "Polygon":
                        return Es(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "LineString":
                switch(o){
                    case "MultiPoint":
                        return ms(r, n);
                    case "LineString":
                        return function(t, e) {
                            if (Or(t, e).features.length > 0) for(var n = 0; n < t.coordinates.length - 1; n++)for(var r = 0; r < e.coordinates.length - 1; r++){
                                var i = !0;
                                if (0 !== r && r !== e.coordinates.length - 2 || (i = !1), bs(t.coordinates[n], t.coordinates[n + 1], e.coordinates[r], i)) return !0;
                            }
                            return !1;
                        }(n, r);
                    case "Polygon":
                        return xs(n, r);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            case "Polygon":
                switch(o){
                    case "MultiPoint":
                        return Es(r, n);
                    case "LineString":
                        return xs(r, n);
                    default:
                        throw new Error("feature2 " + o + " geometry not supported");
                }
            default:
                throw new Error("feature1 " + i + " geometry not supported");
        }
    }, t.booleanDisjoint = ps, t.booleanEqual = function(t, e) {
        return rt(t).type === rt(e).type && new Cs({
            precision: 6
        }).compare(tn(t), tn(e));
    }, t.booleanIntersects = Ps, t.booleanOverlap = function(t, e) {
        var n = rt(t), r = rt(e), i = n.type, o = r.type;
        if ("MultiPoint" === i && "MultiPoint" !== o || ("LineString" === i || "MultiLineString" === i) && "LineString" !== o && "MultiLineString" !== o || ("Polygon" === i || "MultiPolygon" === i) && "Polygon" !== o && "MultiPolygon" !== o) throw new Error("features must be of the same type");
        if ("Point" === i) throw new Error("Point geometry not supported");
        if (new Cs({
            precision: 6
        }).compare(t, e)) return !1;
        var s = 0;
        switch(i){
            case "MultiPoint":
                for(var a = 0; a < n.coordinates.length; a++)for(var u = 0; u < r.coordinates.length; u++){
                    var l = n.coordinates[a], c = r.coordinates[u];
                    if (l[0] === c[0] && l[1] === c[1]) return !0;
                }
                return !1;
            case "LineString":
            case "MultiLineString":
                U(t, function(t) {
                    U(e, function(e) {
                        ki(t, e).features.length && s++;
                    });
                });
                break;
            case "Polygon":
            case "MultiPolygon":
                U(t, function(t) {
                    U(e, function(e) {
                        Or(t, e).features.length && s++;
                    });
                });
        }
        return s > 0;
    }, t.booleanParallel = function(t, e) {
        if (!t) throw new Error("line1 is required");
        if (!e) throw new Error("line2 is required");
        if ("LineString" !== Us(t, "line1")) throw new Error("line1 must be a LineString");
        if ("LineString" !== Us(e, "line2")) throw new Error("line2 must be a LineString");
        for(var n = Zn(tn(t)).features, r = Zn(tn(e)).features, i = 0; i < n.length; i++){
            var o = n[i].geometry.coordinates;
            if (!r[i]) break;
            if (!js(o, r[i].geometry.coordinates)) return !1;
        }
        return !0;
    }, t.booleanPointInPolygon = ye, t.booleanPointOnLine = Wr, t.booleanWithin = Zr, t.buffer = function(t, e, n) {
        var r = (n = n || {}).units || "kilometers", i = n.steps || 8;
        if (!t) throw new Error("geojson is required");
        if ("object" != typeof n) throw new Error("options must be an object");
        if ("number" != typeof i) throw new Error("steps must be an number");
        if (void 0 === e) throw new Error("radius is required");
        if (i <= 0) throw new Error("steps must be greater than 0");
        var o = [];
        switch(t.type){
            case "GeometryCollection":
                return q(t, function(t) {
                    var n = ny(t, e, r, i);
                    n && o.push(n);
                }), f(o);
            case "FeatureCollection":
                return F(t, function(t) {
                    var n = ny(t, e, r, i);
                    n && F(n, function(t) {
                        t && o.push(t);
                    });
                }), f(o);
        }
        return ny(t, e, r, i);
    }, t.center = xn, t.centerMean = Fa, t.centerMedian = function(t, e) {
        if (void 0 === e && (e = {}), !P(e = e || {})) throw new Error("options is invalid");
        var n = e.counter || 10;
        if (!C(n)) throw new Error("counter must be a number");
        var r = e.weight, i = Fa(t, {
            weight: e.weight
        }), o = f([]);
        F(t, function(t) {
            var e;
            o.features.push(En(t, {
                properties: {
                    weight: null === (e = t.properties) || void 0 === e ? void 0 : e[r]
                }
            }));
        });
        var s = {
            tolerance: e.tolerance,
            medianCandidates: []
        };
        return ka(i.geometry.coordinates, [
            0,
            0
        ], o, s, n);
    }, t.centerOfMass = function t(e, n) {
        switch(void 0 === n && (n = {}), it(e)){
            case "Point":
                return a(K(e), n.properties);
            case "Polygon":
                var r = [];
                R(e, function(t) {
                    r.push(t);
                });
                var i, o, s, u, l, c, h, p, f = En(e, {
                    properties: n.properties
                }), g = f.geometry.coordinates, d = 0, y = 0, v = 0, _ = r.map(function(t) {
                    return [
                        t[0] - g[0],
                        t[1] - g[1]
                    ];
                });
                for(i = 0; i < r.length - 1; i++)u = (o = _[i])[0], c = o[1], l = (s = _[i + 1])[0], v += p = u * (h = s[1]) - l * c, d += (u + l) * p, y += (c + h) * p;
                if (0 === v) return f;
                var m = 1 / (6 * (.5 * v));
                return a([
                    g[0] + m * d,
                    g[1] + m * y
                ], n.properties);
            default:
                var x = de(e);
                return x ? t(x, {
                    properties: n.properties
                }) : En(e, {
                    properties: n.properties
                });
        }
    }, t.centroid = En, t.circle = _n, t.cleanCoords = tn, t.clone = Ie, t.clusterEach = ou, t.clusterReduce = su, t.clusters = hu, t.clustersDbscan = function(t, e, n) {
        void 0 === n && (n = {}), !0 !== n.mutate && (t = Ie(t)), n.minPoints = n.minPoints || 3;
        var r = new Ts.DBSCAN, i = r.run(G(t), N(e, n.units), n.minPoints, me), o = -1;
        return i.forEach(function(e) {
            o++, e.forEach(function(e) {
                var n = t.features[e];
                n.properties || (n.properties = {}), n.properties.cluster = o, n.properties.dbscan = "core";
            });
        }), r.noise.forEach(function(e) {
            var n = t.features[e];
            n.properties || (n.properties = {}), n.properties.cluster ? n.properties.dbscan = "edge" : n.properties.dbscan = "noise";
        }), t;
    }, t.clustersKmeans = function(t, e) {
        void 0 === e && (e = {});
        var n = t.features.length;
        e.numberOfClusters = e.numberOfClusters || Math.round(Math.sqrt(n / 2)), e.numberOfClusters > n && (e.numberOfClusters = n), !0 !== e.mutate && (t = Ie(t));
        var r = G(t), i = r.slice(0, e.numberOfClusters), o = zs(r, e.numberOfClusters, i), s = {};
        return o.centroids.forEach(function(t, e) {
            s[e] = t;
        }), F(t, function(t, e) {
            var n = o.idxs[e];
            t.properties.cluster = n, t.properties.centroid = s[n];
        }), t;
    }, t.collect = function(t, e, n, r) {
        var i = Nt(6), o = e.features.map(function(t) {
            var e;
            return {
                minX: t.geometry.coordinates[0],
                minY: t.geometry.coordinates[1],
                maxX: t.geometry.coordinates[0],
                maxY: t.geometry.coordinates[1],
                property: null === (e = t.properties) || void 0 === e ? void 0 : e[n]
            };
        });
        return i.load(o), t.features.forEach(function(t) {
            t.properties || (t.properties = {});
            var e = Z(t), n = i.search({
                minX: e[0],
                minY: e[1],
                maxX: e[2],
                maxY: e[3]
            }), o = [];
            n.forEach(function(e) {
                ye([
                    e.minX,
                    e.minY
                ], t) && o.push(e.property);
            }), t.properties[r] = o;
        }), t;
    }, t.collectionOf = nt, t.combine = function(t) {
        var e = {
            MultiPoint: {
                coordinates: [],
                properties: []
            },
            MultiLineString: {
                coordinates: [],
                properties: []
            },
            MultiPolygon: {
                coordinates: [],
                properties: []
            }
        };
        return F(t, function(t) {
            var n, r, i, o;
            switch(null === (o = t.geometry) || void 0 === o ? void 0 : o.type){
                case "Point":
                    e.MultiPoint.coordinates.push(t.geometry.coordinates), e.MultiPoint.properties.push(t.properties);
                    break;
                case "MultiPoint":
                    (n = e.MultiPoint.coordinates).push.apply(n, t.geometry.coordinates), e.MultiPoint.properties.push(t.properties);
                    break;
                case "LineString":
                    e.MultiLineString.coordinates.push(t.geometry.coordinates), e.MultiLineString.properties.push(t.properties);
                    break;
                case "MultiLineString":
                    (r = e.MultiLineString.coordinates).push.apply(r, t.geometry.coordinates), e.MultiLineString.properties.push(t.properties);
                    break;
                case "Polygon":
                    e.MultiPolygon.coordinates.push(t.geometry.coordinates), e.MultiPolygon.properties.push(t.properties);
                    break;
                case "MultiPolygon":
                    (i = e.MultiPolygon.coordinates).push.apply(i, t.geometry.coordinates), e.MultiPolygon.properties.push(t.properties);
            }
        }), f(Object.keys(e).filter(function(t) {
            return e[t].coordinates.length;
        }).sort().map(function(t) {
            return o({
                type: t,
                coordinates: e[t].coordinates
            }, {
                collectedProperties: e[t].properties
            });
        }));
    }, t.concave = function(t, e) {
        void 0 === e && (e = {});
        var n = e.maxEdge || 1 / 0, r = xe(function(t) {
            var e = [], n = {};
            return F(t, function(t) {
                if (t.geometry) {
                    var r = t.geometry.coordinates.join("-");
                    Object.prototype.hasOwnProperty.call(n, r) || (e.push(t), n[r] = !0);
                }
            }), f(e);
        }(t));
        if (r.features = r.features.filter(function(t) {
            var r = t.geometry.coordinates[0][0], i = t.geometry.coordinates[0][1], o = t.geometry.coordinates[0][2], s = me(r, i, e), a = me(i, o, e), u = me(r, o, e);
            return s <= n && a <= n && u <= n;
        }), r.features.length < 1) return null;
        var i = $e(r);
        return 1 === i.coordinates.length && (i.coordinates = i.coordinates[0], i.type = "Polygon"), o(i);
    }, t.containsNumber = $, t.convertArea = S, t.convertDistance = N, t.convertLength = N, t.convex = de, t.coordAll = G, t.coordEach = R, t.coordReduce = T, t.createBins = au, t.degrees2radians = I, t.degreesToRadians = I, t.destination = vn, t.difference = function(t, e) {
        var n = rt(t), r = rt(e), i = t.properties || {}, o = $u.difference(n.coordinates, r.coordinates);
        return 0 === o.length ? null : 1 === o.length ? l(o[0], i) : y(o, i);
    }, t.dissolve = function(t, e) {
        if (!P(e = e || {})) throw new Error("options is invalid");
        var n = e.propertyName;
        nt(t, "Polygon", "dissolve");
        var r = [];
        if (!e.propertyName) return ni(y($u.union.apply(null, t.features.map(function(t) {
            return t.geometry.coordinates;
        }))));
        var i = {};
        F(t, function(t) {
            Object.prototype.hasOwnProperty.call(i, t.properties[n]) || (i[t.properties[n]] = []), i[t.properties[n]].push(t);
        });
        for(var o = Object.keys(i), s = 0; s < o.length; s++){
            var a = y($u.union.apply(null, i[o[s]].map(function(t) {
                return t.geometry.coordinates;
            })));
            a.properties[n] = o[s], r.push(a);
        }
        return ni(f(r));
    }, t.distance = me, t.distanceToDegrees = E, t.distanceToRadians = x, t.distanceWeight = ja, t.earthRadius = e, t.ellipse = Aa, t.envelope = dn, t.explode = bn, t.factors = n, t.feature = o, t.featureCollection = f, t.featureEach = F, t.featureOf = et, t.featureReduce = k, t.filterProperties = cu, t.findPoint = W, t.findSegment = H, t.flatten = ni, t.flattenEach = z, t.flattenReduce = j, t.flip = function(t, e) {
        if (!P(e = e || {})) throw new Error("options is invalid");
        var n = e.mutate;
        if (!t) throw new Error("geojson is required");
        return !1 !== n && void 0 !== n || (t = Ie(t)), R(t, function(t) {
            var e = t[0], n = t[1];
            t[0] = n, t[1] = e;
        }), t;
    }, t.geojsonType = tt, t.geomEach = q, t.geomReduce = B, t.geometry = s, t.geometryCollection = v, t.getCluster = iu, t.getCoord = K, t.getCoords = Q, t.getGeom = rt, t.getType = it, t.greatCircle = function(t, e, n) {
        if ("object" != typeof (n = n || {})) throw new Error("options is invalid");
        var r = n.properties, i = n.npoints, o = n.offset;
        return t = K(t), e = K(e), r = r || {}, i = i || 100, o = o || 10, new vi({
            x: t[0],
            y: t[1]
        }, {
            x: e[0],
            y: e[1]
        }, r).Arc(i, {
            offset: o
        }).json();
    }, t.helpers = O, t.hexGrid = ay, t.inside = ye, t.interpolate = function(t, e, n) {
        if ("object" != typeof (n = n || {})) throw new Error("options is invalid");
        var r = n.gridType, i = n.property, o = n.weight;
        if (!t) throw new Error("points is required");
        if (nt(t, "Point", "input must contain Points"), !e) throw new Error("cellSize is required");
        if (void 0 !== o && "number" != typeof o) throw new Error("weight must be a number");
        i = i || "elevation", r = r || "square", o = o || 1;
        var s, a = Z(t);
        switch(r){
            case "point":
            case "points":
                s = ti(a, e, n);
                break;
            case "square":
            case "squares":
                s = py(a, e, n);
                break;
            case "hex":
            case "hexes":
                s = ay(a, e, n);
                break;
            case "triangle":
            case "triangles":
                s = fy(a, e, n);
                break;
            default:
                throw new Error("invalid gridType");
        }
        var u = [];
        return F(s, function(e) {
            var s = 0, a = 0;
            F(t, function(t) {
                var u, l = me("point" === r ? e : En(e), t, n);
                if (void 0 !== i && (u = t.properties[i]), void 0 === u && (u = t.geometry.coordinates[2]), void 0 === u) throw new Error("zValue is missing");
                0 === l && (s = u);
                var c = 1 / Math.pow(l, o);
                a += c, s += c * u;
            });
            var l = Ie(e);
            l.properties[i] = s / a, u.push(l);
        }), f(u);
    }, t.intersect = sy, t.invariant = ot, t.isNumber = C, t.isObject = P, t.isobands = function(t, e, n) {
        if (!P(n = n || {})) throw new Error("options is invalid");
        var r = n.zProperty || "elevation", i = n.commonProperties || {}, o = n.breaksProperties || [];
        if (nt(t, "Point", "Input must contain Points"), !e) throw new Error("breaks is required");
        if (!Array.isArray(e)) throw new Error("breaks is not an Array");
        if (!P(i)) throw new Error("commonProperties is not an Object");
        if (!Array.isArray(o)) throw new Error("breaksProperties is not an Array");
        var s = Zi(t, {
            zProperty: r,
            flip: !0
        }), a = function(t, e, n) {
            for(var r = [], i = 1; i < e.length; i++){
                var o = +e[i - 1], s = +e[i], a = Zo(Jo($i(t, o, s - o))), u = {};
                u.groupedRings = a, u[n] = o + "-" + s, r.push(u);
            }
            return r;
        }(s, e, r);
        return f((a = function(t, e, n) {
            var r = Z(n), i = r[2] - r[0], o = r[3] - r[1], s = r[0], a = r[1], u = e[0].length - 1, l = e.length - 1, c = i / u, h = o / l, p = function(t) {
                t[0] = t[0] * c + s, t[1] = t[1] * h + a;
            };
            return t.forEach(function(t) {
                t.groupedRings.forEach(function(t) {
                    t.forEach(function(t) {
                        t.forEach(p);
                    });
                });
            }), t;
        }(a, s, t)).map(function(t, e) {
            if (o[e] && !P(o[e])) throw new Error("Each mappedProperty is required to be an Object");
            var n = ct({}, i, o[e]);
            return n[r] = t[r], y(t.groupedRings, n);
        }));
    }, t.isolines = function(t, e, n) {
        if (!P(n = n || {})) throw new Error("options is invalid");
        var r = n.zProperty || "elevation", i = n.commonProperties || {}, o = n.breaksProperties || [];
        if (nt(t, "Point", "Input must contain Points"), !e) throw new Error("breaks is required");
        if (!Array.isArray(e)) throw new Error("breaks must be an Array");
        if (!P(i)) throw new Error("commonProperties must be an Object");
        if (!Array.isArray(o)) throw new Error("breaksProperties must be an Array");
        var s = _t(t, {
            zProperty: r,
            flip: !0
        });
        return f(function(t, e, n) {
            var r = Z(n), i = r[2] - r[0], o = r[3] - r[1], s = r[0], a = r[1], u = e[0].length - 1, l = e.length - 1, c = i / u, h = o / l, p = function(t) {
                t[0] = t[0] * c + s, t[1] = t[1] * h + a;
            };
            return t.forEach(function(t) {
                R(t, p);
            }), t;
        }(function(t, e, n, r, i) {
            for(var o = [], s = 1; s < e.length; s++){
                var a = +e[s], u = ct({}, r, i[s]);
                u[n] = a;
                var l = g(ft(t, a), u);
                o.push(l);
            }
            return o;
        }(s, e, r, i, o), s, t));
    }, t.kinks = function(t) {
        var e, n, r = {
            type: "FeatureCollection",
            features: []
        };
        if ("LineString" === (n = "Feature" === t.type ? t.geometry : t).type) e = [
            n.coordinates
        ];
        else if ("MultiLineString" === n.type) e = n.coordinates;
        else if ("MultiPolygon" === n.type) e = [].concat.apply([], n.coordinates);
        else {
            if ("Polygon" !== n.type) throw new Error("Input must be a LineString, MultiLineString, Polygon, or MultiPolygon Feature or Geometry");
            e = n.coordinates;
        }
        return e.forEach(function(t) {
            e.forEach(function(e) {
                for(var n = 0; n < t.length - 1; n++)for(var i = n; i < e.length - 1; i++){
                    if (t === e) {
                        if (1 === Math.abs(n - i)) continue;
                        if (0 === n && i === t.length - 2 && t[n][0] === t[t.length - 1][0] && t[n][1] === t[t.length - 1][1]) continue;
                    }
                    var o = Gr(t[n][0], t[n][1], t[n + 1][0], t[n + 1][1], e[i][0], e[i][1], e[i + 1][0], e[i + 1][1]);
                    o && r.features.push(a([
                        o[0],
                        o[1]
                    ]));
                }
            });
        }), r;
    }, t.length = Yr, t.lengthToDegrees = E, t.lengthToRadians = x, t.lineArc = bi, t.lineChunk = function(t, e, n) {
        if (!P(n = n || {})) throw new Error("options is invalid");
        var r = n.units, i = n.reverse;
        if (!t) throw new Error("geojson is required");
        if (e <= 0) throw new Error("segmentLength must be greater than 0");
        var o = [];
        return z(t, function(t) {
            i && (t.geometry.coordinates = t.geometry.coordinates.reverse()), function(t, e, n, r) {
                var i = Yr(t, {
                    units: n
                });
                if (i <= e) return r(t);
                var o = i / e;
                Number.isInteger(o) || (o = Math.floor(o) + 1);
                for(var s = 0; s < o; s++)r(Hr(t, e * s, e * (s + 1), {
                    units: n
                }), s);
            }(t, e, r, function(t) {
                o.push(t);
            });
        }), f(o);
    }, t.lineDistance = Yr, t.lineEach = X, t.lineIntersect = Or, t.lineOffset = function(t, e, n) {
        if (!P(n = n || {})) throw new Error("options is invalid");
        var r = n.units;
        if (!t) throw new Error("geojson is required");
        if (null == e || isNaN(e)) throw new Error("distance is required");
        var i = it(t), o = t.properties;
        switch(i){
            case "LineString":
                return os(t, e, r);
            case "MultiLineString":
                var s = [];
                return z(t, function(t) {
                    s.push(os(t, e, r).geometry.coordinates);
                }), g(s, o);
            default:
                throw new Error("geometry " + i + " is not supported");
        }
    }, t.lineOverlap = ki, t.lineReduce = Y, t.lineSegment = Zn, t.lineSlice = function(t, e, n) {
        var r = Q(n);
        if ("LineString" !== it(n)) throw new Error("line must be a LineString");
        for(var i, o = Tr(n, t), s = Tr(n, e), a = [
            (i = o.properties.index <= s.properties.index ? [
                o,
                s
            ] : [
                s,
                o
            ])[0].geometry.coordinates
        ], u = i[0].properties.index + 1; u < i[1].properties.index + 1; u++)a.push(r[u]);
        return a.push(i[1].geometry.coordinates), h(a, n.properties);
    }, t.lineSliceAlong = Hr, t.lineSplit = function(t, e) {
        if (!t) throw new Error("line is required");
        if (!e) throw new Error("splitter is required");
        var n = it(t), r = it(e);
        if ("LineString" !== n) throw new Error("line must be LineString");
        if ("FeatureCollection" === r) throw new Error("splitter cannot be a FeatureCollection");
        if ("GeometryCollection" === r) throw new Error("splitter cannot be a GeometryCollection");
        var i = ei(e, {
            precision: 7
        });
        switch(r){
            case "Point":
                return mi(t, i);
            case "MultiPoint":
                return _i(t, i);
            case "LineString":
            case "MultiLineString":
            case "Polygon":
            case "MultiPolygon":
                return _i(t, Or(t, i));
        }
    }, t.lineString = h, t.lineStringToPolygon = Ci, t.lineStrings = p, t.lineToPolygon = Ci, t.mask = function(t, e) {
        var n, r = hy(e), i = null;
        return "FeatureCollection" === t.type ? i = cy(2 === (n = t).features.length ? $u.union(n.features[0].geometry.coordinates, n.features[1].geometry.coordinates) : $u.union.apply($u, n.features.map(function(t) {
            return t.geometry.coordinates;
        }))) : i = cy($u.union(t.geometry.coordinates)), i.geometry.coordinates.forEach(function(t) {
            r.geometry.coordinates.push(t[0]);
        }), r;
    }, t.meta = J, t.midpoint = function(t, e) {
        return vn(t, me(t, e) / 2, mn(t, e));
    }, t.moranIndex = function(t, e) {
        var n = e.inputField, r = e.threshold || 1e5, i = e.p || 2, o = e.binary || !1, s = ja(t, {
            alpha: e.alpha || -1,
            binary: o,
            p: i,
            standardization: e.standardization || !0,
            threshold: r
        }), a = [];
        F(t, function(t) {
            var e = t.properties || {};
            a.push(e[n]);
        });
        for(var u = Ua(a), l = function(t) {
            for(var e = Ua(t), n = 0, r = 0, i = t; r < i.length; r++){
                var o = i[r];
                n += Math.pow(o - e, 2);
            }
            return n / t.length;
        }(a), c = 0, h = 0, p = 0, f = 0, g = s.length, d = 0; d < g; d++){
            for(var y = 0, v = 0; v < g; v++)c += s[d][v] * (a[d] - u) * (a[v] - u), h += s[d][v], p += Math.pow(s[d][v] + s[v][d], 2), y += s[d][v] + s[v][d];
            f += Math.pow(y, 2);
        }
        var _ = c / h / l, m = -1 / (g - 1), x = (g * g * (p *= .5) - g * f + h * h * 3) / ((g - 1) * (g + 1) * (h * h)) - m * m, E = Math.sqrt(x);
        return {
            expectedMoranIndex: m,
            moranIndex: _,
            stdNorm: E,
            zNorm: (_ - m) / E
        };
    }, t.multiLineString = g, t.multiPoint = d, t.multiPolygon = y, t.nearest = Jn, t.nearestPoint = Jn, t.nearestPointOnLine = Tr, t.nearestPointToLine = function(t, e, n) {
        void 0 === n && (n = {});
        var r = n.units, i = n.properties || {}, o = function(t) {
            var e = [];
            switch(t.geometry ? t.geometry.type : t.type){
                case "GeometryCollection":
                    return q(t, function(t) {
                        "Point" === t.type && e.push({
                            type: "Feature",
                            properties: {},
                            geometry: t
                        });
                    }), {
                        type: "FeatureCollection",
                        features: e
                    };
                case "FeatureCollection":
                    return t.features = t.features.filter(function(t) {
                        return "Point" === t.geometry.type;
                    }), t;
                default:
                    throw new Error("points must be a Point Collection");
            }
        }(t);
        if (!o.features.length) throw new Error("points must contain features");
        if (!e) throw new Error("line is required");
        if ("LineString" !== it(e)) throw new Error("line must be a LineString");
        var s = 1 / 0, a = null;
        return F(o, function(t) {
            var n = Dr(t, e, {
                units: r
            });
            n < s && (s = n, a = t);
        }), a && (a.properties = ct({
            dist: s
        }, a.properties, i)), a;
    }, t.planepoint = function(t, e) {
        var n = K(t), r = rt(e).coordinates[0];
        if (r.length < 4) throw new Error("OuterRing of a Polygon must have 4 or more Positions.");
        var i = e.properties || {}, o = i.a, s = i.b, a = i.c, u = n[0], l = n[1], c = r[0][0], h = r[0][1], p = void 0 !== o ? o : r[0][2], f = r[1][0], g = r[1][1], d = void 0 !== s ? s : r[1][2], y = r[2][0], v = r[2][1], _ = void 0 !== a ? a : r[2][2];
        return (_ * (u - c) * (l - g) + p * (u - f) * (l - v) + d * (u - y) * (l - h) - d * (u - c) * (l - v) - _ * (u - f) * (l - h) - p * (u - y) * (l - g)) / ((u - c) * (l - g) + (u - f) * (l - v) + (u - y) * (l - h) - (u - c) * (l - v) - (u - f) * (l - h) - (u - y) * (l - g));
    }, t.point = a, t.pointGrid = ti, t.pointOnFeature = qr, t.pointOnLine = Tr, t.pointOnSurface = qr, t.pointToLineDistance = Dr, t.points = u, t.pointsWithinPolygon = _e, t.polygon = l, t.polygonSmooth = function(t, e) {
        var n = [], r = e.iterations || 1;
        if (!t) throw new Error("inputPolys is required");
        return q(t, function(t, e, i) {
            var o, s, a;
            switch(t.type){
                case "Polygon":
                    o = [
                        []
                    ];
                    for(var u = 0; u < r; u++)a = [
                        []
                    ], s = t, u > 0 && (s = l(o).geometry), qa(s, a), o = a.slice(0);
                    n.push(l(o, i));
                    break;
                case "MultiPolygon":
                    o = [
                        [
                            []
                        ]
                    ];
                    for(var c = 0; c < r; c++)a = [
                        [
                            []
                        ]
                    ], s = t, c > 0 && (s = y(o).geometry), Ba(s, a), o = a.slice(0);
                    n.push(y(o, i));
                    break;
                default:
                    throw new Error("geometry is invalid, must be Polygon or MultiPolygon");
            }
        }), f(n);
    }, t.polygonTangents = function(t, e) {
        var n, r, i, o, s = Q(t), u = Q(e), l = Z(e), c = 0, h = null;
        switch(s[0] > l[0] && s[0] < l[2] && s[1] > l[1] && s[1] < l[3] && (c = (h = Jn(t, bn(e))).properties.featureIndex), it(e)){
            case "Polygon":
                n = u[0][c], r = u[0][0], null !== h && h.geometry.coordinates[1] < s[1] && (r = u[0][c]), o = Xi(u[0][0], u[0][u[0].length - 1], s);
                var p = Ui(u[0], s, o, i, n, r);
                n = p[0], r = p[1];
                break;
            case "MultiPolygon":
                for(var g = 0, d = 0, y = 0, v = 0; v < u[0].length; v++){
                    g = v;
                    for(var _ = !1, m = 0; m < u[0][v].length; m++){
                        if (d = m, y === c) {
                            _ = !0;
                            break;
                        }
                        y++;
                    }
                    if (_) break;
                }
                n = u[0][g][d], r = u[0][g][d], o = Xi(u[0][0][0], u[0][0][u[0][0].length - 1], s), u.forEach(function(t) {
                    var e = Ui(t[0], s, o, i, n, r);
                    n = e[0], r = e[1];
                });
        }
        return f([
            a(n),
            a(r)
        ]);
    }, t.polygonToLine = Ii, t.polygonToLineString = Ii, t.polygonize = function(t) {
        var e = hs.fromGeoJson(t);
        e.deleteDangles(), e.deleteCutEdges();
        var n = [], r = [];
        return e.getEdgeRings().filter(function(t) {
            return t.isValid();
        }).forEach(function(t) {
            t.isHole() ? n.push(t) : r.push(t);
        }), n.forEach(function(t) {
            cs.findEdgeRingContaining(t, r) && r.push(t);
        }), f(r.map(function(t) {
            return t.toPolygon();
        }));
    }, t.polygons = c, t.projection = Ja, t.propEach = A, t.propReduce = D, t.propertiesContainsFilter = lu, t.radians2degrees = w, t.radiansToDegrees = w, t.radiansToDistance = m, t.radiansToLength = m, t.random = ru, t.randomLineString = tu, t.randomPoint = Qa, t.randomPolygon = $a, t.randomPosition = Ka, t.rewind = function(t, e) {
        if (!P(e = e || {})) throw new Error("options is invalid");
        var n = e.reverse || !1, r = e.mutate || !1;
        if (!t) throw new Error("<geojson> is required");
        if ("boolean" != typeof n) throw new Error("<reverse> must be a boolean");
        if ("boolean" != typeof r) throw new Error("<mutate> must be a boolean");
        !1 === r && (t = Ie(t));
        var i = [];
        switch(t.type){
            case "GeometryCollection":
                return q(t, function(t) {
                    Hi(t, n);
                }), t;
            case "FeatureCollection":
                return F(t, function(t) {
                    F(Hi(t, n), function(t) {
                        i.push(t);
                    });
                }), f(i);
        }
        return Hi(t, n);
    }, t.rhumbBearing = Bi, t.rhumbDestination = ji, t.rhumbDistance = Ar, t.round = _, t.sample = function(t, e) {
        if (!t) throw new Error("featurecollection is required");
        if (null == e) throw new Error("num is required");
        if ("number" != typeof e) throw new Error("num must be a number");
        return f(function(t, e) {
            var n, r, i = t.slice(0), o = t.length, s = o - e;
            for(; o-- > s;)n = i[r = Math.floor((o + 1) * Math.random())], i[r] = i[o], i[o] = n;
            return i.slice(s);
        }(t.features, e));
    }, t.sector = function(t, e, n, r, i) {
        if (!P(i = i || {})) throw new Error("options is invalid");
        var o = i.properties;
        if (!t) throw new Error("center is required");
        if (null == n) throw new Error("bearing1 is required");
        if (null == r) throw new Error("bearing2 is required");
        if (!e) throw new Error("radius is required");
        if ("object" != typeof i) throw new Error("options must be an object");
        if (qi(n) === qi(r)) return _n(t, e, i);
        var s = Q(t), a = bi(t, e, n, r, i), u = [
            [
                s
            ]
        ];
        return R(a, function(t) {
            u[0].push(t);
        }), u[0].push(s), l(u, o);
    }, t.segmentEach = U, t.segmentReduce = V, t.shortestPath = function(t, e, n) {
        if (!P(n = n || {})) throw new Error("options is invalid");
        var r = n.resolution, i = n.minDistance, s = n.obstacles || f([]);
        if (!t) throw new Error("start is required");
        if (!e) throw new Error("end is required");
        if (r && !C(r) || r <= 0) throw new Error("options.resolution must be a number, greater than 0");
        if (i) throw new Error("options.minDistance is not yet implemented");
        var u = K(t), l = K(e);
        switch(t = a(u), e = a(l), it(s)){
            case "FeatureCollection":
                if (0 === s.features.length) return h([
                    u,
                    l
                ]);
                break;
            case "Polygon":
                s = f([
                    o(rt(s))
                ]);
                break;
            default:
                throw new Error("invalid obstacles");
        }
        var c = s;
        c.features.push(t), c.features.push(e);
        var p = Z(ts(gn(Z(c)), 1.15));
        r || (r = me([
            p[0],
            p[1]
        ], [
            p[2],
            p[1]
        ], n) / 100), c.features.pop(), c.features.pop();
        for(var g = p[0], d = p[1], y = p[2], v = p[3], _ = r / me([
            g,
            d
        ], [
            y,
            d
        ], n) * (y - g), m = r / me([
            g,
            d
        ], [
            g,
            v
        ], n) * (v - d), x = y - g, E = v - d, b = Math.floor(x / _), w = Math.floor(E / m), I = (x - b * _) / 2, N = [], S = [], M = [], L = [], O = 1 / 0, R = 1 / 0, T = v - (E - w * m) / 2, A = 0; T >= d;){
            for(var D = [], F = [], k = g + I, G = 0; k <= y;){
                var q = a([
                    k,
                    T
                ]), B = Js(q, s);
                D.push(B ? 0 : 1), F.push(k + "|" + T);
                var z = me(q, t);
                !B && z < O && (O = z, M = {
                    x: G,
                    y: A
                });
                var j = me(q, e);
                !B && j < R && (R = j, L = {
                    x: G,
                    y: A
                }), k += _, G++;
            }
            S.push(D), N.push(F), T -= m, A++;
        }
        var U = new Ys(S, {
            diagonal: !0
        }), V = U.grid[M.y][M.x], X = U.grid[L.y][L.x], Y = Xs.search(U, V, X), H = [
            u
        ];
        return Y.forEach(function(t) {
            var e = N[t.x][t.y].split("|");
            H.push([
                +e[0],
                +e[1]
            ]);
        }), H.push(l), tn(h(H));
    }, t.simplify = function(t, e) {
        if (!P(e = e || {})) throw new Error("options is invalid");
        var n = void 0 !== e.tolerance ? e.tolerance : 1, r = e.highQuality || !1, i = e.mutate || !1;
        if (!t) throw new Error("geojson is required");
        if (n && n < 0) throw new Error("invalid tolerance");
        return !0 !== i && (t = Ie(t)), q(t, function(t) {
            !function(t, e, n) {
                var r = t.type;
                if ("Point" === r || "MultiPoint" === r) return t;
                tn(t, !0);
                var i = t.coordinates;
                switch(r){
                    case "LineString":
                        t.coordinates = ln(i, e, n);
                        break;
                    case "MultiLineString":
                        t.coordinates = i.map(function(t) {
                            return ln(t, e, n);
                        });
                        break;
                    case "Polygon":
                        t.coordinates = cn(i, e, n);
                        break;
                    case "MultiPolygon":
                        t.coordinates = i.map(function(t) {
                            return cn(t, e, n);
                        });
                }
            }(t, n, r);
        }), t;
    }, t.square = yn, t.squareGrid = py, t.standardDeviationalEllipse = function(t, e) {
        if (!P(e = e || {})) throw new Error("options is invalid");
        var n = e.steps || 64, r = e.weight, i = e.properties || {};
        if (!C(n)) throw new Error("steps must be a number");
        if (!P(i)) throw new Error("properties must be a number");
        var o = G(t).length, s = Fa(t, {
            weight: r
        }), a = 0, u = 0, l = 0;
        F(t, function(t) {
            var e = t.properties[r] || 1, n = Ga(Q(t), Q(s));
            a += Math.pow(n.x, 2) * e, u += Math.pow(n.y, 2) * e, l += n.x * n.y * e;
        });
        var c = a - u, h = Math.sqrt(Math.pow(c, 2) + 4 * Math.pow(l, 2)), p = 2 * l, g = Math.atan((c + h) / p), d = 180 * g / Math.PI, y = 0, v = 0, _ = 0;
        F(t, function(t) {
            var e = t.properties[r] || 1, n = Ga(Q(t), Q(s));
            y += Math.pow(n.x * Math.cos(g) - n.y * Math.sin(g), 2) * e, v += Math.pow(n.x * Math.sin(g) + n.y * Math.cos(g), 2) * e, _ += e;
        });
        var m = Math.sqrt(2 * y / _), x = Math.sqrt(2 * v / _), E = Aa(s, m, x, {
            units: "degrees",
            angle: d,
            steps: n,
            properties: i
        }), b = _e(t, f([
            E
        ])), w = {
            meanCenterCoordinates: Q(s),
            semiMajorAxis: m,
            semiMinorAxis: x,
            numberOfFeatures: o,
            angle: d,
            percentageWithinEllipse: 100 * G(b).length / o
        };
        return E.properties.standardDeviationalEllipse = w, E;
    }, t.tag = function(t, e, n, r) {
        return t = Ie(t), e = Ie(e), F(t, function(t) {
            t.properties || (t.properties = {}), F(e, function(e) {
                void 0 === t.properties[r] && ye(t, e) && (t.properties[r] = e.properties[n]);
            });
        }), t;
    }, t.tesselate = function(t) {
        if (!t.geometry || "Polygon" !== t.geometry.type && "MultiPolygon" !== t.geometry.type) throw new Error("input must be a Polygon or MultiPolygon");
        var e = {
            type: "FeatureCollection",
            features: []
        };
        return "Polygon" === t.geometry.type ? e.features = Wn(t.geometry.coordinates) : t.geometry.coordinates.forEach(function(t) {
            e.features = e.features.concat(Wn(t));
        }), e;
    }, t.tin = xe, t.toMercator = Va, t.toWgs84 = Xa, t.transformRotate = $o, t.transformScale = ts, t.transformTranslate = function(t, e, n, r) {
        if (!P(r = r || {})) throw new Error("options is invalid");
        var i = r.units, o = r.zTranslation, s = r.mutate;
        if (!t) throw new Error("geojson is required");
        if (null == e || isNaN(e)) throw new Error("distance is required");
        if (o && "number" != typeof o && isNaN(o)) throw new Error("zTranslation is not a number");
        if (o = void 0 !== o ? o : 0, 0 === e && 0 === o) return t;
        if (null == n || isNaN(n)) throw new Error("direction is required");
        return e < 0 && (e = -e, n += 180), !1 !== s && void 0 !== s || (t = Ie(t)), R(t, function(t) {
            var r = Q(ji(t, e, n, {
                units: i
            }));
            t[0] = r[0], t[1] = r[1], o && 3 === t.length && (t[2] += o);
        }), t;
    }, t.triangleGrid = fy, t.truncate = ei, t.union = function(t, e, n) {
        void 0 === n && (n = {});
        var r = rt(t), i = rt(e), o = $u.union(r.coordinates, i.coordinates);
        return 0 === o.length ? null : 1 === o.length ? l(o[0], n.properties) : y(o, n.properties);
    }, t.unitsFactors = r, t.unkinkPolygon = function(t) {
        var e = [];
        return z(t, function(t) {
            "Polygon" === t.geometry.type && F(oi(t), function(n) {
                e.push(l(n.geometry.coordinates, t.properties));
            });
        }), f(e);
    }, t.validateBBox = M, t.validateId = L, t.voronoi = function(t, e) {
        if (!P(e = e || {})) throw new Error("options is invalid");
        var n = e.bbox || [
            -180,
            -85,
            180,
            85
        ];
        if (!t) throw new Error("points is required");
        if (!Array.isArray(n)) throw new Error("bbox is invalid");
        return nt(t, "Point", "points"), f((function() {
            var t = Ks, e = Qs, n = null;
            function r(r) {
                return new Ra(r.map(function(n, i) {
                    var o = [
                        Math.round(t(n, i, r) / Ma) * Ma,
                        Math.round(e(n, i, r) / Ma) * Ma
                    ];
                    return o.index = i, o.data = n, o;
                }), n);
            }
            return r.polygons = function(t) {
                return r(t).polygons();
            }, r.links = function(t) {
                return r(t).links();
            }, r.triangles = function(t) {
                return r(t).triangles();
            }, r.x = function(e) {
                return arguments.length ? (t = "function" == typeof e ? e : Zs(+e), r) : t;
            }, r.y = function(t) {
                return arguments.length ? (e = "function" == typeof t ? t : Zs(+t), r) : e;
            }, r.extent = function(t) {
                return arguments.length ? (n = null == t ? null : [
                    [
                        +t[0][0],
                        +t[0][1]
                    ],
                    [
                        +t[1][0],
                        +t[1][1]
                    ]
                ], r) : n && [
                    [
                        n[0][0],
                        n[0][1]
                    ],
                    [
                        n[1][0],
                        n[1][1]
                    ]
                ];
            }, r.size = function(t) {
                return arguments.length ? (n = null == t ? null : [
                    [
                        0,
                        0
                    ],
                    [
                        +t[0],
                        +t[1]
                    ]
                ], r) : n && [
                    n[1][0] - n[0][0],
                    n[1][1] - n[0][1]
                ];
            }, r;
        })().x(function(t) {
            return t.geometry.coordinates[0];
        }).y(function(t) {
            return t.geometry.coordinates[1];
        }).extent([
            [
                n[0],
                n[1]
            ],
            [
                n[2],
                n[3]
            ]
        ]).polygons(t.features).map(Ta));
    }, t.within = _e, Object.defineProperty(t, "__esModule", {
        value: !0
    });
});


var $90f256c567e4c320$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($90f256c567e4c320$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $90f256c567e4c320$exports = g;
});









function $f3cfa07bad7ee5f4$export$6bf11ff3cfb953a7() {
    // obtengo zoom del mapa
    const zoomCelda = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda : (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom;
    // obtengo grid a partir del polígono
    if ((0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer.getLayers().length == 0) return; // nada que hacer	
    const polygon = (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer.getLayers()[0]; // sólo debería haber un polígono
    const geojsonpoly = polygon.toGeoJSON();
    const grid = (0, $0a5d75214fa44e03$export$85a47b3ccce199ed)(polygon.getBounds(), zoomCelda);
    // inicialización modal con petición de confirmación
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadData), (0, $646ceeeec66fabd8$export$ce041e830841d411), (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).descargaDatos);
    // muestro el modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    // listener al modal para que borre el polígono al cerrar
    document.getElementById("mimodal").addEventListener("hidden.bs.modal", (event)=>{
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer.clearLayers();
    });
    // pongo listener a los checks de descarga para mensajillo y para habilitar el botón de descarga
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".check-download").on("change", function() {
        const alguncheck = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".check-download").is(":checked");
        if (alguncheck) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadNothing").addClass("d-none");
            const algunradio = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".downloadRadio").is(":checked");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadData").prop("disabled", !algunradio);
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadNothing").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadData").prop("disabled", true);
        }
    });
    // pongo listener al radio para habilitar el botón de descarga
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".downloadRadio").on("change", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadNoFormat").addClass("d-none");
        const alguncheck = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".check-download").is(":checked");
        if (alguncheck) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadData").prop("disabled", false);
    });
    // listener al botón de descarga
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadData").click(function() {
        // miro qué cosas quiere descargar
        let cosasDescargar = {
            trees: (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkTrees").is(":checked"),
            annotations: (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkAnnotations").is(":checked")
        };
        // detecto el formato de descarga y preparo nombre del fichero
        let format = "GeoJSON"; // valor por defecto
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#CSV").is(":checked")) format = "CSV";
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#KML").is(":checked")) format = "KML";
        // llamo a descargar los datos
        $f3cfa07bad7ee5f4$var$descargarDatos(cosasDescargar, grid, zoomCelda, format, geojsonpoly);
    });
}
async function $f3cfa07bad7ee5f4$var$descargarDatos(cosasDescargar, grid, zoomCelda, format, geojsonpoly) {
    // actualizo modal
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true,
        nofooter: true
    }, null, (0, $646ceeeec66fabd8$export$9fac9ed2fe46e816));
    // inicializo array de salidas
    const outputs = [];
    // obtengo los educatrees de las celdas del polígono
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadingTrees").removeClass("d-none");
    // inicializaciones celdas
    let promesasCeldas = [];
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas = {
        total: (1 + grid.cellE - grid.cellW) * (1 + grid.cellN - grid.cellS),
        finalizadas: [],
        cacheadas: [],
        npc: [],
        ifn: false
    };
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar = 0; // para que no salten timeouts
    // pregenero los taxones más generales y más específicos para el cacheo
    let txgen = [
        "undefined"
    ];
    let txesp = [
        "undefined",
        ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies))
    ];
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx != undefined) {
        txgen = [
            "undefined",
            ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx].superexpuris)
        ];
        txesp = (0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx].expuris);
    }
    // descarga de educatrees celda a celda
    for(let x = grid.cellW; x <= grid.cellE; x++)for(let y = grid.cellS; y <= grid.cellN; y++){
        // preparo objeto de la celda
        const objcelda = {
            zoomout: false,
            taxon: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx,
            txgen: txgen,
            txesp: txesp,
            zoom: zoomCelda,
            cellX: x,
            cellY: y,
            npc: [],
            et: "z" + zoomCelda + "_x" + x + "_y" + y + "_" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx,
            ifn: false,
            idtimeout: 0 // predefino el id de timeout
        };
        // enchufo el progreso
        objcelda.progreso = $f3cfa07bad7ee5f4$var$pintarBarraProgresoDescarga;
        // hago la petición de datos
        promesasCeldas.push((0, $174d363c054274ef$export$2579cebb92311e97)(objcelda));
    }
    await Promise.all(promesasCeldas);
    // logging celdas parcelas
    const tcc = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.cacheadas, function(memo, num) {
        return memo + num;
    }, 0);
    const npc = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.npc, function(memo, num) {
        return memo + num;
    }, 0);
    console.info("#celdas download total: " + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total + " - cacheadas: " + tcc + " - #npc: " + npc);
    // obtengo iris de educatrees y preparo clusters
    let ediris = [];
    let clusters = [];
    for(let x = grid.cellW; x <= grid.cellE; x++)for(let y = grid.cellS; y <= grid.cellN; y++){
        const et = "z" + zoomCelda + "_x" + x + "_y" + y + "_" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx;
        const celda = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et];
        if (celda.edu.trees) ediris = (0, $2q7Wm.default).union(ediris, celda.edu.trees);
        else if (celda.edu.mmil || celda.edu.ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold) {
            const bounds = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(x, y, zoomCelda);
            const lat = celda.edu.locCluster ? celda.edu.locCluster.lat : bounds.getCenter().lat;
            const lng = celda.edu.locCluster ? celda.edu.locCluster.lng : bounds.getCenter().lng;
            const taxon = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx ? {
                id: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx,
                scientificName: (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx].scientificName))
            } : "any";
            clusters.push({
                id: "cluster_z" + zoomCelda + "_x" + x + "_y" + y,
                type: "cluster",
                clusterValue: celda.edu.mmil ? "+1K" : celda.edu.ntrees,
                latWGS84: lat,
                lngWGS84: lng,
                taxon: taxon
            });
        }
    }
    // filtro con turf los educatrees que caen dentro del polígono
    //console.log("#educatrees inicio: " + ediris.length);
    ediris = (0, $2q7Wm.default).filter(ediris, function(ediri) {
        const turfpoint = (0, $cd948d9b215c1263$exports.point)([
            (0, $69f04ba581843b2d$export$a4829058f9fe1646)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[ediri].lng, grid.cellW, zoomCelda),
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[ediri].lat
        ]);
        return (0, $cd948d9b215c1263$exports.booleanPointInPolygon)(turfpoint, geojsonpoly);
    });
    //console.log("#educatrees fin: " + ediris.length);		
    // ordeno
    ediris = (0, $2q7Wm.default).sortBy(ediris);
    // filtro con turf los clusters que caen dentro del polígono
    //console.log("#clusters inicio: " + clusters.length);
    clusters = (0, $2q7Wm.default).filter(clusters, function(cluster) {
        const turfpoint = (0, $cd948d9b215c1263$exports.point)([
            (0, $69f04ba581843b2d$export$a4829058f9fe1646)(cluster.lngWGS84, grid.cellW, zoomCelda),
            cluster.latWGS84
        ]);
        return (0, $cd948d9b215c1263$exports.booleanPointInPolygon)(turfpoint, geojsonpoly);
    });
    //console.log("#clusters fin: " + clusters.length);
    // quito mensajillo de descargando árboles
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadingTrees").addClass("d-none");
    // procesamiento árboles y clusters
    if (cosasDescargar.trees) {
        let arbcls = [];
        // preparo los edutrees
        for (let ediri of ediris){
            const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[ediri];
            const txarb = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
            // preparo objeto
            const objarb = {
                id: ediri,
                type: "tree",
                creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(arb),
                created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(arb),
                latWGS84: arb.lat,
                lngWGS84: arb.lng
            };
            if (arb.nick) objarb.nick = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.nick);
            if (txarb) objarb.taxon = {
                id: txarb,
                scientificName: (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txarb].scientificName))
            };
            if (arb.height) objarb.heightMeters = Number(Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.height)).toFixed(2));
            if (arb.dbh) objarb.dbhMillimeters = Number(Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(arb.dbh)).toFixed(0));
            if (arb.treeStatus) {
                const ts = (0, $2q7Wm.default).find((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles, function(el) {
                    return el.iri === arb.treeStatus;
                });
                if (ts) objarb.treeStatus = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(ts.label);
            }
            const images = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(arb, [
                "images"
            ]);
            if (images.length) objarb.photos = images;
            const observations = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(arb, [
                "observations"
            ]);
            if (observations.length) {
                objarb.observations = [];
                for (let obs of observations)objarb.observations.push((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(obs));
            }
            // guardo
            arbcls.push(objarb);
        }
        // agrego los clusters
        arbcls = arbcls.concat(clusters);
        // generación datos descarga
        if (arbcls.length > 0) {
            // preparo la salida y guardo
            const output = {
                data: $f3cfa07bad7ee5f4$var$formatearArbolesClusters(arbcls, format),
                nfich: format === "GeoJSON" ? "EducaWood_trees.json" : format === "CSV" ? "EducaWood_trees.csv" : "EducaWood_trees.kml"
            };
            outputs.push(output);
            // preparo mensaje de info con el número de árboles y clusters
            let mens = ediris.length > 0 ? '<i class="bi bi-hand-thumbs-up"></i>' + ediris.length + " " + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).educawoodTrees) : "";
            if (clusters.length > 0) mens += mens === "" ? '<i class="bi bi-hand-thumbs-up"></i>' + clusters.length + " " + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).educawoodClusters) : '<br><i class="bi bi-hand-thumbs-up"></i>' + clusters.length + " " + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).educawoodClusters);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treesDownloaded").html(mens);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treesDownloaded").removeClass("d-none");
        } else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#noTreesDownloaded").removeClass("d-none");
    }
    // si pidió las anotaciones extraigo los educatrees completos
    if (cosasDescargar.annotations) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadingAnnotations").removeClass("d-none");
        // para el progreso
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas = {
            total: 10,
            finalizadas: [],
            cacheadas: [],
            npc: [],
            ifn: false
        };
        // pido los educawoods completos
        await (0, $174d363c054274ef$export$88055805f25eda73)(ediris, $f3cfa07bad7ee5f4$var$pintarBarraProgresoDescarga);
        // preparo las anotaciones
        let geojsonAnns = []; // para geoJSON
        let allAnss = []; // para CSV o KML
        for (let ediri of ediris){
            // extraigo edutree
            const edutree = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[ediri];
            // inicializo objeto de anotaciones del edutree para GeoJSON
            let geojsonObjann = {
                id: ediri,
                type: "tree",
                creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(edutree),
                created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(edutree),
                latWGS84: edutree.position.latWGS84,
                lngWGS84: edutree.position.lngWGS84,
                positionAnnotations: [],
                treeStatusAnnotations: [],
                speciesAnnotations: [],
                diameterAnnotations: [],
                heightAnnotations: [],
                imageAnnotations: [],
                observations: []
            };
            if (edutree.nick) geojsonObjann.nick = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(edutree.nick);
            // preparo extracto común para CSV y KML
            const anncomun = {
                treeId: ediri,
                latWGS84: edutree.position.latWGS84,
                lngWGS84: edutree.position.lngWGS84
            };
            // posiciones
            if (edutree.positionAnnotations) {
                const posanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "positionAnnotations"
                ]);
                for (let annel of posanns){
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "PositionAnnotation",
                        primary: edutree.position && annel.iri === edutree.position.iri,
                        value: {
                            latWGS84: annel.latWGS84,
                            lngWGS84: annel.lngWGS84
                        }
                    };
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.positionAnnotations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // tree status
            if (edutree.treeStatusAnnotations) {
                const tsanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "treeStatusAnnotations"
                ]);
                for (let annel of tsanns){
                    const ts = (0, $2q7Wm.default).find((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles, function(el) {
                        return el.iri === annel.treeStatus;
                    });
                    if (ts) {
                        // preparo objetos
                        let annbas = {
                            id: annel.iri,
                            creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                            created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                            type: "TreeStatusAnnotation",
                            primary: edutree.treeStatus && annel.iri === edutree.treeStatus.iri,
                            value: {
                                ts: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(ts.label)
                            }
                        };
                        let ann = Object.assign({}, annbas, anncomun);
                        // guardo
                        geojsonObjann.treeStatusAnnotations.push(annbas);
                        allAnss.push(ann);
                    }
                }
            }
            // especies
            if (edutree.speciesAnnotations) {
                const spanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "speciesAnnotations"
                ]);
                for (let annel of spanns){
                    const txarb = (0, $1ee989753a15371d$export$fa0799b379eb3758)(annel.species.iri);
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "SpeciesAnnotation",
                        primary: edutree.species && annel.iri === edutree.species.iri,
                        value: {
                            id: txarb,
                            scientificName: (0, $96abbdd7193a3c4b$export$57fe19e45e887809)((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txarb].scientificName))
                        }
                    };
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.speciesAnnotations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // diámetros
            if (edutree.diameterAnnotations) {
                const diamanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "diameterAnnotations"
                ]);
                for (let annel of diamanns){
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "DiameterAnnotation",
                        primary: edutree.diameter && annel.iri === edutree.diameter.iri,
                        value: {
                            dbhMillimeters: Number(Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(annel.millimeters)).toFixed(0))
                        }
                    };
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.diameterAnnotations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // alturas
            if (edutree.heightAnnotations) {
                const posanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "heightAnnotations"
                ]);
                for (let annel of posanns){
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "HeightAnnotation",
                        primary: edutree.height && annel.iri === edutree.height.iri,
                        value: {
                            heightMeters: Number(Number((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(annel.meters)).toFixed(2))
                        }
                    };
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.heightAnnotations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // fotos
            if (edutree.imageAnnotations) {
                const posanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "imageAnnotations"
                ]);
                for (let annel of posanns){
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "ImageAnnotation",
                        value: {
                            imageURL: annel.image.imageURL
                        }
                    };
                    if (annel.image.plantPart && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[annel.image.plantPart]) annbas.value.plantPart = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[annel.image.plantPart].label);
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.imageAnnotations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // observaciones
            if (edutree.observations) {
                const posanns = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(edutree, [
                    "observations"
                ]);
                for (let annel of posanns){
                    // preparo objetos
                    let annbas = {
                        id: annel.iri,
                        creator: (0, $96abbdd7193a3c4b$export$f91175dce0722b24)(annel),
                        created: (0, $96abbdd7193a3c4b$export$daf0fdd0a2e008c2)(annel),
                        type: "ObservationAnnotation",
                        value: {
                            text: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(annel.text)
                        }
                    };
                    let ann = Object.assign({}, annbas, anncomun);
                    // guardo
                    geojsonObjann.observations.push(annbas);
                    allAnss.push(ann);
                }
            }
            // guardo todas las anotaciones del edutree en geojsonAnns
            geojsonAnns.push(geojsonObjann);
        }
        // generación datos descarga
        if (allAnss.length > 0) {
            // preparo la salida y guardo
            const output = {
                data: $f3cfa07bad7ee5f4$var$formatearAnotacionesArboles(geojsonAnns, allAnss, format),
                nfich: format === "GeoJSON" ? "EducaWood_annotations.json" : format === "CSV" ? "EducaWood_annotations.csv" : "EducaWood_annotations.kml"
            };
            outputs.push(output);
            // preparo mensaje de info con el número de anotaciones
            let mens = '<i class="bi bi-hand-thumbs-up"></i>' + allAnss.length + " " + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).educawoodAnnotations);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#annotationsDownloaded").html(mens);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#annotationsDownloaded").removeClass("d-none");
        } else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#noAnnotationsDownloaded").removeClass("d-none");
        // actualizo mensajillos de info
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadingAnnotations").addClass("d-none");
    }
    // hago las descargas
    for (let out of outputs){
        const blob = new Blob([
            out.data
        ], {
            type: "text/plain;charset=utf-8"
        });
        (0, $90f256c567e4c320$exports.saveAs)(blob, out.nfich);
    }
    // actualizo mensajillo de info
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#downloadSuccess").removeClass("d-none");
    // escondo barra de progreso
    $f3cfa07bad7ee5f4$var$pintarBarraProgresoDescarga(false);
    // envío evento GA descarga datos
    const datosga = {
        content_type: "download_" + format,
        trees: cosasDescargar.trees,
        annotations: cosasDescargar.annotations
    };
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon) datosga.taxon = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon;
    (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", datosga);
    // actualizo modal
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgDownload").removeClass("d-none");
    const nuevotit = outputs.length == 0 ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadNothing) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadSuccess);
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, nuevotit, null, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionExito);
}
function $f3cfa07bad7ee5f4$var$formatearAnotacionesArboles(geojsonAnns, allAnss, format) {
    let output;
    switch(format){
        case "GeoJSON":
            const features = [];
            for (const feat of geojsonAnns){
                // Extract relevant properties from each feature
                const { id: id, type: type, latWGS84: latWGS84, lngWGS84: lngWGS84, nick: nick, creator: creator, created: created, positionAnnotations: positionAnnotations, treeStatusAnnotations: treeStatusAnnotations, speciesAnnotations: speciesAnnotations, diameterAnnotations: diameterAnnotations, heightAnnotations: heightAnnotations, imageAnnotations: imageAnnotations, observations: observations } = feat;
                // Create a GeoJSON feature object
                const feature = {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [
                            lngWGS84,
                            latWGS84
                        ] // [longitude, latitude]
                    },
                    properties: {
                        id: id,
                        type: type,
                        nick: nick,
                        creator: creator,
                        created: created,
                        positionAnnotations: positionAnnotations,
                        treeStatusAnnotations: treeStatusAnnotations,
                        speciesAnnotations: speciesAnnotations,
                        diameterAnnotations: diameterAnnotations,
                        heightAnnotations: heightAnnotations,
                        imageAnnotations: imageAnnotations,
                        observations: observations
                    }
                };
                features.push(feature);
            }
            // Create the GeoJSON object
            const geoJSON = {
                type: "FeatureCollection",
                features: features
            };
            output = JSON.stringify(geoJSON, null, 2);
            break;
        case "CSV":
            // Extract the keys from the first tree object to create the CSV header
            const header = [
                "id",
                "treeId",
                "latWGS84",
                "lngWGS84",
                "creator.id",
                "creator.nick",
                "created",
                "type",
                "primary",
                "value.latWGS84",
                "value.lngWGS84",
                "value.ts",
                "value.id",
                "value.scientificName",
                "value.dbhMillimeters",
                "value.heightMeters",
                "value.imageURL",
                "value.plantPart",
                "value.text"
            ];
            // Generate the CSV rows
            // feb-2024 rehago para tratar las cadenas incluyendo "" y para escapar las "
            const rows = Object.values(allAnss).map((feature)=>{
                return header.map((key)=>{
                    let row = undefined;
                    if (key.indexOf(".") !== -1) {
                        // caso anidado, extraigo las dos claves
                        const subkeys = key.split(".");
                        if (feature[subkeys[0]] && feature[subkeys[0]][subkeys[1]]) row = feature[subkeys[0]][subkeys[1]];
                    // en otro caso no está definido
                    } else if (Array.isArray(feature[key])) row = feature[key].join("\n");
                    else if (typeof feature[key] === "object") row = JSON.stringify(feature[key]);
                    else row = feature[key];
                    // procesamiento cadenas
                    if (typeof row === "string" || row instanceof String) row = '"' + row.replace('"', '""') + '"';
                    // devuelvo
                    return row;
                });
            });
            // Combine the header and rows into a single CSV string
            output = [
                header.join(",")
            ].concat(rows.map((row)=>row.join(","))).join("\n");
            break;
        case "KML":
            output = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>`;
            for (const feat of allAnss){
                // Extract relevant properties from each feature
                const { id: id, treeId: treeId, latWGS84: latWGS84, lngWGS84: lngWGS84, creator: creator, created: created, type: type, primary: primary, value: value } = feat;
                // preparo extendedData de las cosas opcionales
                const extendedData = [];
                if (creator && creator.id) extendedData.push(`        <Data name="creator.id"><value>${creator.id}</value></Data>`);
                if (creator && creator.nick) extendedData.push(`        <Data name="creator.nick"><value>${creator.nick}</value></Data>`);
                if (created) extendedData.push(`        <Data name="created"><value>${created}</value></Data>`);
                if (value.latWGS84) extendedData.push(`        <Data name="value.latWGS84"><value>${value.latWGS84}</value></Data>`);
                if (value.lngWGS84) extendedData.push(`        <Data name="value.lngWGS84"><value>${value.lngWGS84}</value></Data>`);
                if (value.ts) extendedData.push(`        <Data name="value.ts"><value>${value.ts}</value></Data>`);
                if (value.id) extendedData.push(`        <Data name="value.id"><value>${value.id}</value></Data>`);
                if (value.scientificName) extendedData.push(`        <Data name="value.scientificName"><value>${value.scientificName}</value></Data>`);
                if (value.dbhMillimeters) extendedData.push(`        <Data name="value.dbhMillimeters"><value>${value.dbhMillimeters}</value></Data>`);
                if (value.heightMeters) extendedData.push(`        <Data name="value.heightMeters"><value>${value.heightMeters}</value></Data>`);
                if (value.imageURL) extendedData.push(`        <Data name="value.imageURL"><value>${value.imageURL}</value></Data>`);
                if (value.plantPart) extendedData.push(`        <Data name="value.plantPart"><value>${value.plantPart}</value></Data>`);
                if (value.text) extendedData.push(`        <Data name="value.text"><value>${value.text}</value></Data>`);
                // Generate the Placemark element for each feature
                const placemark = `
    <Placemark>
      <Point>
        <coordinates>${lngWGS84},${latWGS84}</coordinates>
      </Point>
      <ExtendedData>
        <Data name="id"><value>${id}</value></Data>
        <Data name="treeId"><value>${treeId}</value></Data>
        <Data name="type"><value>${type}</value></Data>
${extendedData.join("\n")}
      </ExtendedData>
    </Placemark>`;
                output += placemark;
            }
            output += `
  </Document>
</kml>`;
            break;
    }
    return output;
}
function $f3cfa07bad7ee5f4$var$formatearArbolesClusters(arbcls, format) {
    let output;
    switch(format){
        case "GeoJSON":
            const features = [];
            for (const feat of arbcls){
                // Extract relevant properties from each feature
                const { id: id, type: type, latWGS84: latWGS84, lngWGS84: lngWGS84, nick: nick, taxon: taxon, clusterValue: clusterValue, creator: creator, created: created, heightMeters: heightMeters, dbhMillimeters: dbhMillimeters, treeStatus: treeStatus, photos: photos, observations: observations } = feat;
                // Create a GeoJSON feature object
                const feature = {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [
                            lngWGS84,
                            latWGS84
                        ] // [longitude, latitude]
                    },
                    properties: {
                        id: id,
                        type: type,
                        clusterValue: clusterValue,
                        nick: nick,
                        taxon: taxon,
                        creator: creator,
                        created: created,
                        heightMeters: heightMeters,
                        dbhMillimeters: dbhMillimeters,
                        treeStatus: treeStatus,
                        observations: observations,
                        photos: photos
                    }
                };
                features.push(feature);
            }
            // Create the GeoJSON object
            const geoJSON = {
                type: "FeatureCollection",
                features: features
            };
            output = JSON.stringify(geoJSON, null, 2);
            break;
        case "CSV":
            // Extract the keys from the first tree object to create the CSV header
            const header = [
                "id",
                "type",
                "latWGS84",
                "lngWGS84",
                "nick",
                "taxon.id",
                "taxon.scientificName",
                "clusterValue",
                "creator.id",
                "creator.nick",
                "created",
                "heightMeters",
                "dbhMillimeters",
                "treeStatus",
                "observations",
                "photos"
            ];
            // Generate the CSV rows
            // feb-2024 rehago para tratar las cadenas incluyendo "" y para escapar las "
            const rows = Object.values(arbcls).map((feature)=>{
                return header.map((key)=>{
                    let row = undefined;
                    if (key.indexOf(".") !== -1) {
                        // caso anidado, extraigo las dos claves
                        const subkeys = key.split(".");
                        if (feature[subkeys[0]] && feature[subkeys[0]][subkeys[1]]) row = feature[subkeys[0]][subkeys[1]];
                    // en otro caso no está definido
                    } else if (Array.isArray(feature[key])) row = feature[key].join("\n");
                    else if (typeof feature[key] === "object") row = JSON.stringify(feature[key]);
                    else row = feature[key];
                    // procesamiento cadenas
                    if (typeof row === "string" || row instanceof String) row = '"' + row.replace('"', '""') + '"';
                    // devuelvo
                    return row;
                });
            });
            // Combine the header and rows into a single CSV string
            output = [
                header.join(",")
            ].concat(rows.map((row)=>row.join(","))).join("\n");
            break;
        case "KML":
            output = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>`;
            for (const feat of arbcls){
                // Extract relevant properties from each feature
                const { id: id, type: type, latWGS84: latWGS84, lngWGS84: lngWGS84, nick: nick, taxon: taxon, clusterValue: clusterValue, creator: creator, created: created, heightMeters: heightMeters, dbhMillimeters: dbhMillimeters, treeStatus: treeStatus, photos: photos, observations: observations } = feat;
                // preparo extendedData de las cosas opcionales
                const extendedData = [];
                if (nick) extendedData.push(`        <Data name="nick"><value>${nick}</value></Data>`);
                if (taxon && taxon.id) extendedData.push(`        <Data name="taxon.id"><value>${taxon.id}</value></Data>`);
                if (taxon && taxon.scientificName) extendedData.push(`        <Data name="taxon.scientificName"><value>${taxon.scientificName}</value></Data>`);
                if (clusterValue) extendedData.push(`        <Data name="clusterValue"><value>${clusterValue}</value></Data>`);
                if (creator && creator.id) extendedData.push(`        <Data name="creator.id"><value>${creator.id}</value></Data>`);
                if (creator && creator.nick) extendedData.push(`        <Data name="creator.nick"><value>${creator.nick}</value></Data>`);
                if (created) extendedData.push(`        <Data name="created"><value>${created}</value></Data>`);
                if (heightMeters) extendedData.push(`        <Data name="heightMeters"><value>${heightMeters}</value></Data>`);
                if (dbhMillimeters) extendedData.push(`        <Data name="dbhMillimeters"><value>${dbhMillimeters}</value></Data>`);
                if (treeStatus) extendedData.push(`        <Data name="treeStatus"><value>${treeStatus}</value></Data>`);
                if (observations) extendedData.push(`        <Data name="observations"><value>${Array.isArray(observations) ? observations.join("; ") : observations}</value></Data>`);
                if (photos) extendedData.push(`        <Data name="photos"><value>${Array.isArray(photos) ? photos.join("; ") : photos}</value></Data>`);
                // Generate the Placemark element for each feature
                const placemark = `
    <Placemark>
      <Point>
        <coordinates>${lngWGS84},${latWGS84}</coordinates>
      </Point>
      <ExtendedData>
        <Data name="id"><value>${id}</value></Data>
        <Data name="type"><value>${type}</value></Data>
${extendedData.join("\n")}
      </ExtendedData>
    </Placemark>`;
                output += placemark;
            }
            output += `
  </Document>
</kml>`;
            break;
    }
    return output;
}
function $f3cfa07bad7ee5f4$var$pintarBarraProgresoDescarga(mostrar) {
    // variante sin JQuery para que vaya más rápida la actualización de la barra
    const mibarradiv = document.getElementById("mibarradescarga_div");
    if (mostrar) {
        // obtengo celdas completadas
        const celdascomp = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.finalizadas, function(memo, num) {
            return memo + num;
        }, 0);
        // calculo porc (hasta 99)
        const porc = Math.floor(99 * celdascomp / (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total);
        // ajusto barra
        let mibarra = document.getElementById("mibarradescarga");
        mibarradiv.setAttribute("aria-valuenow", porc);
        mibarra.style.width = porc + "%";
        mibarra.innerHTML = porc + "%";
        // muestro la barra de progreso
        mibarradiv.classList.remove("d-none");
    } else mibarradiv.classList.add("d-none");
}



let $c853be3628706c6e$var$drawControl;
// PANEL DE CONTROL
function $c853be3628706c6e$export$4412c4bf37c8e3a8() {
    // creo div con clase "usuario" sólo para dispositivos grandes
    const panuser = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control({
        "position": "topright"
    });
    panuser.onAdd = function(map) {
        // creo div con clase "usuario"	
        const container = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "usuario me-2 mt-2 d-none d-sm-block"); // versión 5.3 bootstrap
        return container;
    };
    panuser.addTo((0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee));
    //  panel de control de info
    let panelInfo = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control({
        "position": "topleft"
    });
    panelInfo.onAdd = function(map) {
        // creo div con clase "card" de bootstrap
        this._div = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "card ms-1 ms-sm-2 mt-1 mt-sm-2"); // versión 5.3 bootstrap
        return this._div;
    };
    panelInfo.init = function() {
        // inicializo el panel detectando si es móvil para poner padding
        // no consigo ajustar el padding por defecto, así que uso Mustache
        const obj = {
            esmovil: screen.width < 576,
            nomci: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci
        };
        const cardhtml = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$f3d44414f0a0d0b1), obj);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".card").html(cardhtml);
        // pongo nombres localizados a los colores al filtro de taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".dropdown_color_taxon").each(function() {
            let cind = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("cind");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports)))["color" + cind]));
        });
        // pongo color al filtro de taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#filtro_taxon").css("background-color", (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).colores[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txcolor][1]);
        // quitar filtro de taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_quitar_taxon").click(function() {
            // mando evento de quitar filtro de taxón a GA (sólo si hay filtro activo)
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon) (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
                content_type: "remove_taxon_filter",
                content_id: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon
            });
            // elimino el taxón en la sesión y reajusto URL
            delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon;
            history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
            // cargo la URL
            (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
        });
        // handler del nombre científico
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".nomci").change((0, $1ee989753a15371d$export$d67e2296dd6db17d));
        // handler del popover taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_info_filtro_taxon").click((0, $1ee989753a15371d$export$2c4bbd56989782d8));
        // cambio color del filtro de taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".dropdown_color_taxon").click(function() {
            // actualizo el color
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txcolor = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("cind"));
            // cambio el color del filtro de taxón
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#filtro_taxon").css("background-color", (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).colores[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txcolor][1]);
            // actualizo iconos de los árboles pintados
            const arburis = Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados);
            for (let arburi of arburis){
                // recupero el árbol
                const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arburi];
                // obtengo su icono
                const ticon = (0, $7b115b3c2cee4b53$export$6274df672a45c12d)(arb);
                // cambio el icono si no coincide
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[arburi].getIcon() != ticon) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[arburi].setIcon(ticon);
            }
        });
        // detecto cambios en la entrada de lugares
        // "search" es para detectar si el usuario hizo click en la X del formulario (clear button)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_lugares").on("keyup search", async function(e) {
            // trato las teclas de arriba, abajo y enter			
            if (e.which == 13) // sólo actúo si hay al menos una sugerencia (y habilitada)
            {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").children(":enabled").length > 0) {
                    // si no había ninguna sugerencia seleccionada activo la primera
                    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus == -1) {
                        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus = 0;
                        (0, $d1e0875cf0f68e21$export$41334320f2c99869)();
                    }
                    // y ahora vamos al lugar seleccionado
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").children(":enabled").eq((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus).click();
                }
            } else if (e.which == 40) {
                // incremento focus
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus++;
                (0, $d1e0875cf0f68e21$export$41334320f2c99869)();
            } else if (e.which == 38) {
                // decremento focus
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarfocus--;
                (0, $d1e0875cf0f68e21$export$41334320f2c99869)();
            } else if (e.which != undefined) {
                // si había marcador de municipio, lo quito
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker != null) {
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker.remove();
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker = null;
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugar = null;
                }
                // actúo según la entrada
                let entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
                if (entrada.length == 0) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").html("");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").addClass("d-none");
                } else {
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").removeClass("d-none");
                    const sugs = await (0, $d1e0875cf0f68e21$export$a80214d90d6317cd)(entrada);
                    (0, $d1e0875cf0f68e21$export$49f32269b97f95f9)(sugs);
                    // mando evento GA si la entrada > 2
                    if (entrada.length > 2) (0, $067277e156f7a571$export$7329bcdc3edcd90e)("search", {
                        search_term: entrada,
                        content_type: "places"
                    });
                }
            } else {
                // caso de la X del formulario... (quito las sugerencias y el marcador si lo hay)
                let entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
                if (entrada.length == 0) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").html("");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").addClass("d-none");
                    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker != null) {
                        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker.remove();
                        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugarmarker = null;
                        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).lugar = null;
                    }
                }
            }
        }).focusin(function() {
            // vuelve el focus, muestro las sugerencias si hay algo
            let entrada = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).val();
            if (entrada.length > 0) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").removeClass("d-none");
        }).focusout(function() {
            // si pierde el focus escondemos las sugerencias tras un delay
            // el delay es importante para que se pueda clickar un botón antes de eliminar las sugerencias
            setTimeout(function() {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_lugares").is(":focus")) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#sugelugares").addClass("d-none");
            }, 300);
        });
        // handler de taxón
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").click((0, $1ee989753a15371d$export$79e952b071e79fc8));
    };
    // incluyo el panel en el mapa
    panelInfo.addTo((0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee));
    // si es terminal táctil desactivo los eventos de dragging del mapa en el panel del formulario
    if ("ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
        panelInfo.getContainer().addEventListener("touchstart", function() {
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).dragging.disable();
        });
        panelInfo.getContainer().addEventListener("touchend", function() {
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).dragging.enable();
        });
    } else {
        // Disable dragging, scrollWheelZoom and doubleClickZoom when user's cursor enters the element
        panelInfo.getContainer().addEventListener("mouseover", function() {
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).dragging.disable();
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).scrollWheelZoom.disable();
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).doubleClickZoom.disable();
        });
        // Re-enable dragging, scrollWheelZoom and doubleClickZoom when user's cursor leaves the element
        panelInfo.getContainer().addEventListener("mouseout", function() {
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).dragging.enable();
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).scrollWheelZoom.enable();
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).doubleClickZoom.enable();
        });
    }
    // inicializo panel
    panelInfo.init();
}
function $c853be3628706c6e$export$a54a51eb35d48691(mm, mapas, tilelayers, volverMapa) {
    const controlBotones = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
        options: {
            position: "bottomright"
        },
        onAdd: function(map) {
            // preparo botonera vertical
            const container = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-bar leaflet-control btn-group-vertical");
            container.setAttribute("role", "group");
            // link esri
            const le = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single esri", container);
            le.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).esri);
            le.href = "#";
            le.setAttribute("role", "button");
            const les = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("span", "bi bi-layers-fill", le);
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri) {
                le.setAttribute("style", "background-color: #6c757d;");
                les.setAttribute("style", "color: white;");
            }
            // listener esri
            le.addEventListener("click", function(e) {
                event.preventDefault(); // Prevent the default behavior of the hyperlink
                // actualizo Sesion.estado.esri y reajusto URL
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri;
                history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
                // actualizo mapas y tilelayers con URL y atribución
                const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(true);
                for (let tl of tilelayers)tl.setUrl(url);
                for (let ma of mapas){
                    ma.attributionControl.removeAttribution((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMap.options.attribution);
                    ma.attributionControl.removeAttribution((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMap.options.attribution);
                    ma.attributionControl.addAttribution(opts.attribution);
                }
                // actualizo aspecto botón y mando evento de esri a GA
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri").attr("style", "background-color: #6c757d;");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri span").attr("style", "color: white;");
                    (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
                        content_type: "show_esri"
                    });
                } else {
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri").removeAttr("style");
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri span").removeAttr("style");
                    (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
                        content_type: "show_osm"
                    });
                }
            });
            if (volverMapa) {
                // link volver mapa
                const lm = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single", container);
                lm.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).fullmap);
                lm.href = "#";
                lm.setAttribute("role", "button");
                (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("span", "bi bi-fullscreen", lm);
                // listener volver mapa
                lm.addEventListener("click", function(e) {
                    event.preventDefault(); // Prevent the default behavior of the hyperlink
                    // actualizo path
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path = "map";
                    // reajusto url y creo nueva página en la historia
                    history.pushState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).npags++; // una página más
                    // cargoURL => me llevará a verLasttrees
                    (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
                });
            }
            return container;
        }
    });
    mm.addControl(new controlBotones());
}
// IDIOMA
function $c853be3628706c6e$export$789fff39a6a81ff3() {
    // actualizo etiquetas panel mapa
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#tarjeta-home").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).home));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#tarjeta-lasttrees").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastTrees));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).taxonfilter));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_lugares").attr("placeholder", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchplace));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#in_lugares").attr("aria-label", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).searchplace));
    // cierro bot_taxones e inicializo a "" el navegador de taxones
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").hasClass("active")) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").click();
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block").html("");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block").addClass("d-none");
    // actualizo botones usuario mapa
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewProfile));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).signout));
    // actualización tooltips panel lateral
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createtree));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".verifn").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewIFN));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).esri));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".refresh").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).refresh));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadData));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".tour").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tour));
    // actualizamos etiquetas Leaflet Draw
    $c853be3628706c6e$var$actualizarEtiquetasLDraw();
}
var $6220e9ce3896734a$exports = {};
$6220e9ce3896734a$exports = new URL("../iconoIFNpushed.6674fb99.svg", import.meta.url).toString();


var $31341be8bc52445e$exports = {};
$31341be8bc52445e$exports = new URL("../iconoIFN.89400e25.svg", import.meta.url).toString();


// BOTONES LATERALES MAPA
function $c853be3628706c6e$export$9e6c68482d899bf0() {
    // preparo botón de descarga con Leaflet Draw
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).FeatureGroup();
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).addLayer((0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer);
    const ldo = {
        position: "bottomright",
        draw: {
            polyline: false,
            polygon: {
                allowIntersection: false,
                drawError: {
                    //color: '#e1e100', // Color the shape will turn when intersects
                    message: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorPolygon)
                },
                shapeOptions: {
                }
            },
            circle: false,
            rectangle: false,
            marker: false,
            circlemarker: false
        },
        edit: false
    };
    $c853be3628706c6e$var$drawControl = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.Draw(ldo);
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).addControl($c853be3628706c6e$var$drawControl);
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).on((0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Draw.Event.CREATED, function(e) {
        // actualizo flag
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).poligonero = false;
        // actualizo aspecto botón (sin pulsar)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download").removeAttr("style");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download span").removeAttr("style");
        // añado el polígono a la capa editable
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).editableLayer.addLayer(e.layer);
        // desde aquí llamo a la descarga de datos
        (0, $f3cfa07bad7ee5f4$export$6bf11ff3cfb953a7)();
    });
    // cambio icono polígono
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-draw-draw-polygon").html('<span class="bi bi-cloud-download"></span>');
    // añado clase inicial "download"
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-draw-draw-polygon").addClass("download");
    // llamo a actualizar las etiquetas de Leaflet Draw
    $c853be3628706c6e$var$actualizarEtiquetasLDraw();
    // listener botón
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download").on("click", function(e) {
        // cojo ref al botón de cancelar
        //let cancelAnchor = $('ul.leaflet-draw-actions').find('li:eq(2) a');	
        let cancelAnchor = document.querySelector("ul.leaflet-draw-actions").querySelector("li:nth-child(3) a");
        // cambio el flag de poligonero
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).poligonero = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).poligonero;
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).poligonero) {
            // muestro tostada
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mitostadaBody").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).toastDownloadPolygon));
            const tostada = (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Toast.getOrCreateInstance(document.getElementById("mitostada"));
            tostada.show();
            // actualizo aspecto botón (pulsado)
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download").attr("style", "background-color: #6c757d;");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download span").attr("style", "color: white;");
            // pongo listener para que quede bien el flag de poligonero
            cancelAnchor.addEventListener("click", function(event1) {
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).poligonero = false;
                // actualizo aspecto botón (sin pulsar)
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download").removeAttr("style");
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".download span").removeAttr("style");
            });
        } else cancelAnchor.click();
    });
    // BOTONERA (sin download)
    const controlBotones = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Control.extend({
        options: {
            position: "bottomright"
        },
        onAdd: function(map) {
            // preparo botonera vertical
            const container = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("div", "leaflet-bar leaflet-control btn-group-vertical");
            container.setAttribute("role", "group");
            // link arbol
            const la = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single createtree disabled", container);
            la.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createtree);
            la.href = "#";
            la.setAttribute("role", "button");
            (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("span", "bi bi-tree-fill", la);
            // link IFN
            const li = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single verifn", container);
            li.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).viewIFN);
            li.href = "#";
            li.setAttribute("role", "button");
            const licon = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("img", "", li);
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn) {
                li.setAttribute("style", "background-color: #6c757d;");
                licon.setAttribute("src", new URL($6220e9ce3896734a$exports));
            //licon.setAttribute("src", "/app/images/iconoIFNpushed.svg");
            } else licon.setAttribute("src", new URL($31341be8bc52445e$exports));
            //licon.setAttribute("src", "/app/images/iconoIFN.svg");
            // link esri
            const le = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single esri", container);
            le.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).esri);
            le.href = "#";
            le.setAttribute("role", "button");
            const les = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("span", "bi bi-layers-fill", le);
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri) {
                le.setAttribute("style", "background-color: #6c757d;");
                les.setAttribute("style", "color: white;");
            }
            // link refresh
            const lr = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single refresh", container);
            lr.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).refresh);
            lr.href = "#";
            lr.setAttribute("role", "button");
            (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("span", "bi bi-arrow-clockwise", lr);
            // link tour
            const lt = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single tour", container);
            lt.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tour);
            lt.href = "#";
            lt.setAttribute("role", "button");
            (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.create("span", "bi bi-question-lg", lt);
            // listener árbol
            la.addEventListener("click", function(e) {
                event.preventDefault(); // Prevent the default behavior of the hyperlink
                // si está deshabilitado muestro tostada
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree:first").hasClass("disabled")) {
                    const mensaje = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).toastZoom) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).toastUser);
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mitostadaBody").html(mensaje);
                    const tostada = (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Toast.getOrCreateInstance(document.getElementById("mitostada"));
                    tostada.show();
                } else {
                    // cambio flag
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol;
                    // tostada de ayuda si estoy creando
                    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mitostadaBody").html((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).toastCreateTree));
                        const tostada = (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Toast.getOrCreateInstance(document.getElementById("mitostada"));
                        tostada.show();
                    }
                    // llamo a renderAjustesCreacionArbolMapa
                    (0, $3a9989d46007ef73$export$7c626a07c7c69914)(true);
                }
            });
            // listener ifn
            li.addEventListener("click", function(e) {
                event.preventDefault(); // Prevent the default behavior of the hyperlink
                // actualizo Sesion.estado.ifn y reajusto URL
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn;
                history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
                // llamo a actualizar la info del IFN
                $c853be3628706c6e$export$87931b6598ef9316();
            });
            // listener esri
            le.addEventListener("click", function(e) {
                event.preventDefault(); // Prevent the default behavior of the hyperlink
                // actualizo Sesion.estado.esri y reajusto URL
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri = !(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri;
                history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
                // llamo a actualizar el mapa base
                $c853be3628706c6e$export$1319329b668abb17();
            });
            // listener refresh
            lr.addEventListener("click", function(e) {
                event.preventDefault(); // Prevent the default behavior of the hyperlink
                // borro datos
                // sólo me quedo con el usuario de la sesión
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario) {
                    const dus = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios = {};
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid] = dus;
                } else (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios = {};
                // fuera taxones
                (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies = {};
                // fuera educatrees
                (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees = {};
                // sólo me quedo con los árboles del ifn (con 'uri' en vez de 'iri')
                (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles = Object.fromEntries(Object.entries((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles).filter(([key, value])=>"uri" in value));
                // fuera últimos educatrees y últimas anotaciones (salvo los del usuario)
                if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario) {
                    const uetus = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees = {};
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid] = uetus;
                    const uanus = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones = {};
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid] = uanus;
                } else {
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees = {};
                    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones = {};
                }
                // elimino datos de educatrees de las celdas				
                for(const key in (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles)delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[key].edu;
                // borro clusters y árboles
                (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
                (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
                (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol				
                // desactivo temporalmente el botón de taxones
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").hasClass("active")) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").click();
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").prop("disabled", true);
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#taxones_block").html(""); // y vacío para que repinte
                // espero a que cargue los taxones de nuevo
                (0, $174d363c054274ef$export$40a5140e3d2b7b8d)().then(()=>{
                    // habilito de nuevo el botón
                    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").removeAttr("disabled");
                    // llamo a mover el mapa para que repinte
                    (0, $69f04ba581843b2d$export$c8207d40f45dcd81)();
                }).catch((error)=>console.error(error));
                // mando evento de refrescar mapa a GA
                (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
                    content_type: "refresh_map"
                });
            });
            // listener tour
            lt.addEventListener("click", function(e) {
                (0, $2fa03f5d455d6f0a$export$cdda91dfb91997f3)();
            });
            return container;
        }
    });
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).addControl(new controlBotones());
}


// soporte IFN
function $c853be3628706c6e$export$87931b6598ef9316() {
    // borro clusters y árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol				
    // llamo a mover el mapa para que repinte
    (0, $69f04ba581843b2d$export$c8207d40f45dcd81)();
    // actualizo aspecto botón y mando evento de IFN (show o hide) a GA
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".verifn").attr("style", "background-color: #6c757d;");
        //$(".verifn img").attr("src", "/app/images/iconoIFNpushed.svg");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".verifn img").attr("src", new URL($6220e9ce3896734a$exports));
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
            content_type: "show_IFN"
        });
    } else {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".verifn").removeAttr("style");
        //$(".verifn img").attr("src", "/app/images/iconoIFN.svg");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".verifn img").attr("src", new URL($31341be8bc52445e$exports));
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
            content_type: "hide_IFN"
        });
    }
}
// soporte mapa base
function $c853be3628706c6e$export$1319329b668abb17() {
    // actualizo Mitilelayer: URL y atribución
    const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(false);
    (0, $ffd94e1d81f19b1c$export$6573f87b6f05c3d2).setUrl(url);
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).attributionControl.removeAttribution((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMap.options.attribution);
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).attributionControl.removeAttribution((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMap.options.attribution);
    (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).attributionControl.addAttribution(opts.attribution);
    // actualizo aspecto botón y mando evento de IFN (show o hide) a GA
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri").attr("style", "background-color: #6c757d;");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri span").attr("style", "color: white;");
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
            content_type: "show_esri"
        });
    } else {
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri").removeAttr("style");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".esri span").removeAttr("style");
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
            content_type: "show_osm"
        });
    }
}
// etiquetas Leaflet.Draw
function $c853be3628706c6e$var$actualizarEtiquetasLDraw() {
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-draw-draw-polygon").attr("title", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadData));
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.actions.text = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancel);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.actions.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).cancelPolygon);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.finish.text = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).finish);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.finish.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).finishPolygon);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.undo.text = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteLastPoint);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.undo.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).deleteLastPointDrawn);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.toolbar.buttons.polygon = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).downloadData);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.handlers.polygon.tooltip.start = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).startPolygon);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.handlers.polygon.tooltip.cont = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).contPolygon);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.handlers.polygon.tooltip.end = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).endPolygon);
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).drawLocal.draw.handlers.polyline.error = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorPolygon);
    $c853be3628706c6e$var$drawControl.options.draw.polygon.drawError.message = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorPolygon);
}








/////////////////////// 
// BOTÓN DE CREAR ÁRBOL
///////////////////////
let $3a9989d46007ef73$export$c37f872725571dfc, $3a9989d46007ef73$var$Minitilelayer;
// función clave para comprobar si se habilita el botón (si hay usuario logueado y suficiente zoom)
// y para hacer los ajustes en la vista del mapa
function $3a9989d46007ef73$export$7c626a07c7c69914(huboclick) {
    // 1) inicializo hayajuste a si hubo click en el botón (o undefined en caso contrario)
    let hayajuste = huboclick;
    // 2) detecto si hay que mostrar el botón de crear árbol o no
    const hayboton = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario && (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getZoom() >= (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zCreacion;
    if (hayboton) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree").removeClass("disabled"); //.removeClass("d-none");
    else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree").addClass("disabled"); //.addClass("d-none");
    // 3) si no hay botón y está en modo creando árbol, hay que cambiar de estado y hacer ajuste
    if (!hayboton && (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol) {
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol = false;
        hayajuste = true;
    }
    // 4) hago los ajustes si es necesario
    if (hayajuste) {
        // ajusto popups, tooltips y cursor en árboles pintados (autoajustado con Sesion.creandoArbol)
        for(const auri in (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados)(0, $82a71c896f160eac$export$1f29254b983d0b7)(auri);
        // ajusto handler click, tooltips y cursor en clusters
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.eachLayer(function(cpint) {
            (0, $82a71c896f160eac$export$19f9855b4b37efc4)(cpint);
        });
        // si estamos en modo creación de árbol...
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol) {
            // estilo botón en modo edición	
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree").attr("style", "background-color: #6c757d;");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree span").attr("style", "color: white;");
            // estilo cursor creación árbol en mapa
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getContainer().style.cursor = "crosshair";
            // pongo listener para capturar la posición y abrir una pantalla de creación de Educatree
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).on("click", $3a9989d46007ef73$var$onTreeCreationClick);
        } else {
            // estilo botón normal
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree").removeAttr("style");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".createtree span").removeAttr("style");
            // estilo cursor normal
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getContainer().style.cursor = "";
            // quito listener onTreeCreationClick
            (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).off("click", $3a9989d46007ef73$var$onTreeCreationClick);
        }
    }
}
//////////////////////////
// PANTALLA CREACIÓN ÁRBOL
//////////////////////////
function $3a9989d46007ef73$var$onTreeCreationClick(e) {
    // detecto si el click se hace en un control del mapa
    const target = e.originalEvent.target;
    const escontrol = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).DomUtil.hasClass(target, "leaflet-control") || target.closest(".leaflet-control") !== null;
    // en tal caso, no hago nada
    if (escontrol) return;
    // The event object (e) contains information about the clicked location
    //console.warn('Clicked at ' + e.latlng);
    // desactivo modo edición en el mapa
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).creandoArbol = false;
    // llamo a renderAjustesCreacionArbolMapa para actualizar vista mapa grande
    $3a9989d46007ef73$export$7c626a07c7c69914(true);
    // actualizo estado con la posición y el path de creación de educatree
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat = e.latlng.lat;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng = e.latlng.lng;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.z = (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getZoom();
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path = "newtree";
    // reajusto url y creo nueva página en la historia
    history.pushState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).npags++; // una página más
    // cargoURL => me llevará a iniciarCreacionArbol
    (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
}
function $3a9989d46007ef73$export$966d5c02a501e12b() {
    // cambio el zoom a 20 y reajusto la URL
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.z = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMiniMapa;
    history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    // mando evento de creando árbol a GA
    (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
        content_type: "create_tree_form",
        content_id: (0, $96abbdd7193a3c4b$export$4a32c72e9ff1d1e0)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc)
    });
    console.info("Creando \xe1rbol en posici\xf3n: " + (0, $96abbdd7193a3c4b$export$4a32c72e9ff1d1e0)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc));
    // llamo al render
    $3a9989d46007ef73$export$da02fee09afb84d();
}
async function $3a9989d46007ef73$export$da02fee09afb84d() {
    // 1) cargo formulario y realizo ajustes
    // preparo objeto plantilla
    const ocat = {
        usuario: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario != undefined,
        usuarioImg: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL : null,
        esMovil: (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile,
        camera: localStorage.getItem("camera") === "false" ? false : true // por defecto true
    };
    const htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$f3dc3f942ad7cadb), ocat);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(htmlcontent);
    // pongo listeners a clickViewprofile, clickSignin y clickSignout
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").click((0, $c0304d280c7b00cb$export$f98b6673fafc0e20));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignin").click((0, $c0304d280c7b00cb$export$9ffe63492d76c086));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").click((0, $c0304d280c7b00cb$export$daa0a882204fd973));
    // ajusto crchecknomci 
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#crchecknomci").prop("checked", (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).nomci);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#crchecknomci").change((0, $1ee989753a15371d$export$d67e2296dd6db17d));
    // pongo etiqueta de posición
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputPosition").val((0, $96abbdd7193a3c4b$export$1690e12b840569b9)({
        latWGS84: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
        lngWGS84: (0, $69f04ba581843b2d$export$9f306b5167a85c73)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng)
    }));
    // listener info de estado árbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botTreeStatusInfo").click($3a9989d46007ef73$export$4ee351339f0443f3);
    // cambio de diámetro a perímetro
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").change($3a9989d46007ef73$export$1db9de3e81675e92);
    // cambio de modo a cámara (sólo valdrá para móvil)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkCamera").change($3a9989d46007ef73$export$cd64dd1ec39c266d);
    // quito el envío preventivo del formulario
    // esto es para evitar que envíe el formulario,
    // afecta al navegar por las sugerencias de taxones
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#createTreeForm").on("keypress", function(event) {
        if (event.keyCode == 13) event.preventDefault();
    });
    // listener de cambio de nick
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeNick").change(function() {
        const treenick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeNick").val();
        // preinicializo
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").removeClass("d-none");
        if (!treenick) //console.log("No hay nada");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick));
        else if (treenick.length < 3) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickTooshort));
        else if (treenick.length > 30) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickToolong));
        else //console.log("Todo OK");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").addClass("d-none");
    });
    // listeners taxón
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#setTreeTaxonEd").click((0, $1ee989753a15371d$export$2d3916a1f0ae58c1));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreeTaxon").click((0, $1ee989753a15371d$export$e644c8daeec4ef49));
    // cargo tipos de estado del árbol en #selectTreeStatus
    let testarb = [];
    for (const el of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).estadoArboles)testarb.push({
        "iri": el.iri,
        "label": (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(el.label),
        "pref": el.pref
    });
    const htmltest = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$170c21d6f8f459cf), testarb);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreeStatus").html(htmltest);
    // listener de la foto => compresión en #resizedTreePhoto y muestro thumbnail
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treePhoto").change($3a9989d46007ef73$export$3a52a69d9f94a42b);
    // listener borrar foto (antes de subir a Firebase)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreePhoto").click($3a9989d46007ef73$export$e7db0c08a7276967);
    // cargo partes de árboles fotos en #selectTreePartPhoto
    let parbfotos = [];
    for(const paf in (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto)parbfotos.push({
        "uri": paf,
        "label": (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[paf].label)
    });
    const htmlpaf = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$afb205d6a878a5e7), parbfotos);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreePartPhoto").html(htmlpaf);
    // botones finales
    // pongo listener del botón de crear árbol
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#createTreeButton").on("click", $3a9989d46007ef73$var$handlerCreateTree);
    // pongo listener del botón de volver
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#goBackButton").on("click", (0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
    // 2) cargo mapa
    // preparo primero los bounds para que no se vaya a Cuenca
    const offset = 0.0004; // 1km es aproximadamente 0,008 grados en WGS84
    const bounds = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLngBounds((0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat - offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng - 3 * offset), (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).latLng((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat + offset, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng + 3 * offset)); //northEast	
    // meto tap: false, que parece es una fuente de problemas
    // meto scrollWheelZoom: 'center' para que no dé saltos raros la diana al cambiar el zoom
    $3a9989d46007ef73$export$c37f872725571dfc = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).map("mapaedutree", {
        maxBounds: bounds,
        maxBoundsViscosity: 1.0,
        zoomControl: false,
        tap: false,
        scrollWheelZoom: "center",
        preferCanvas: true
    }).setView([
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
    ], (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMiniMapa);
    // cargo el tile layer que corresponda
    const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(true);
    $3a9989d46007ef73$var$Minitilelayer = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).tileLayer(url, opts).addTo($3a9989d46007ef73$export$c37f872725571dfc);
    // muestro escala del mapa
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.scale({
        imperial: false,
        position: "bottomright"
    }).addTo($3a9989d46007ef73$export$c37f872725571dfc); // sin la escala imperial
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile) (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.zoom({
        position: "bottomright",
        zoomInTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomin),
        zoomOutTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomout)
    }).addTo($3a9989d46007ef73$export$c37f872725571dfc);
    // Disable dragging
    $3a9989d46007ef73$export$c37f872725571dfc.dragging.disable();
    // cargo botón esri
    (0, $c853be3628706c6e$export$a54a51eb35d48691)($3a9989d46007ef73$export$c37f872725571dfc, [
        $3a9989d46007ef73$export$c37f872725571dfc,
        (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee)
    ], [
        $3a9989d46007ef73$var$Minitilelayer,
        (0, $ffd94e1d81f19b1c$export$6573f87b6f05c3d2)
    ]);
    // 3) pido ifntrees y edutrees del mapa y pinto
    await $3a9989d46007ef73$export$d3be837b79c08382($3a9989d46007ef73$export$c37f872725571dfc, bounds);
    // 4) al acabar quito el overlay con el que escondía el mapa, pongo la pista y habilito el dragging
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#overlay").addClass("d-none");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mapclue").removeClass("d-none");
    $3a9989d46007ef73$export$c37f872725571dfc.dragging.enable();
    // 5) pinto marcador de diana
    const diana = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).marker([
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng
    ], {
        icon: (0, $7b115b3c2cee4b53$export$757419e715bb5039)(),
        zIndexOffset: 100
    }).addTo($3a9989d46007ef73$export$c37f872725571dfc);
    // 6) detecto eventos "move" y ajusto la diana	
    $3a9989d46007ef73$export$c37f872725571dfc.on("move", function(event) {
        const center = $3a9989d46007ef73$export$c37f872725571dfc.getCenter(); // Get the new center position of the map
        diana.setLatLng(center); // Set the marker position to the new center
    });
    // como hay muchos eventos 'move', actualizo cosas sólo con 'moveend'
    $3a9989d46007ef73$export$c37f872725571dfc.on("moveend", function(event) {
        const center = $3a9989d46007ef73$export$c37f872725571dfc.getCenter(); // Get the new center position of the map
        diana.setLatLng(center); // Set the marker position to the new center
        // ajusto localización en el estado de la sesión
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat = center.lat;
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng = center.lng;
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.z = $3a9989d46007ef73$export$c37f872725571dfc.getZoom();
        // ajusto texto
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputPosition").val((0, $96abbdd7193a3c4b$export$1690e12b840569b9)({
            latWGS84: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat,
            lngWGS84: (0, $69f04ba581843b2d$export$9f306b5167a85c73)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng)
        }));
        // reajusto también la URL
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    });
}
function $3a9989d46007ef73$export$3a52a69d9f94a42b() {
    // recupero fichero
    const file = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).prop("files")[0];
    //console.log(file);	
    if (file) {
        // muestro botón de borrar foto
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreePhoto").removeClass("d-none");
        // preparo imagen a diferente resolución con thumbnail
        const image = new Image();
        image.onload = function() {
            // creo una imagen png de 400 píxeles de ancho, misma relación de aspecto y resolución 0.5 
            const aspectRatio = image.height / image.width;
            const canvas = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("<canvas>")[0];
            canvas.width = image.width < 400 ? image.width : 400;
            canvas.height = canvas.width * aspectRatio;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
            const dataUrl = canvas.toDataURL("image/png", 0.5);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#resizedTreePhoto").val(dataUrl);
            // actualizo mensaje imagen
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#textTreePhoto").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).photouploaded));
            // muestro #selectTreePartPhoto
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreePartPhoto").removeClass("d-none");
            // muestro thumbnail a partir de la imagen redimensionada creada
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeThumbnail").removeClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeThumbnail").attr("src", dataUrl);
        };
        const reader = new FileReader();
        reader.onload = function(event) {
            image.src = event.target.result;
        };
        reader.readAsDataURL(file);
        // actualización estado anotación		
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", false);
    } else $3a9989d46007ef73$export$e7db0c08a7276967();
}
function $3a9989d46007ef73$export$e7db0c08a7276967() {
    // elimino entrada foto
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treePhoto").val("");
    // eliminado entrada foto redimensionada
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#resizedTreePhoto").val("");
    // actualizo mensaje imagen y escondo thumbnail y selectTreePartPhoto
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#textTreePhoto").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nophoto));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeThumbnail").addClass("d-none");
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreePartPhoto").addClass("d-none");
    // escondo botón borrar foto
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#deleteTreePhoto").addClass("d-none");
    // actualización estado anotación 
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botcreatemodalannotation").prop("disabled", true);
}
var $09e243a186db839c$exports = {};
$09e243a186db839c$exports = new URL("../treeStatus_es.9f90465a.png", import.meta.url).toString();


var $01197063e997be4d$exports = {};
$01197063e997be4d$exports = new URL("../treeStatus_en.88b580a5.png", import.meta.url).toString();


// preparo contenido modal botón ayuda
function $3a9989d46007ef73$export$4ee351339f0443f3() {
    // preparo contenido modal
    let tit = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treeStatus);
    //let hmtlcontent = '<img class="img-fluid" src="'+getLiteral(dict.treeStatusFile)+'">';	
    let hmtlcontent = '<img id="imgTreeStatusInfo" class="img-fluid" src="">';
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        nofooter: true
    }, tit, hmtlcontent, null);
    // muestro modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    if ((0, $96abbdd7193a3c4b$export$350964a2fface462)() === "es") (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeStatusInfo").attr("src", new URL($09e243a186db839c$exports));
    else (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeStatusInfo").attr("src", new URL($01197063e997be4d$exports));
}
// reajuste de diámetro a perímetro y viceversa
function $3a9989d46007ef73$export$1db9de3e81675e92() {
    // recupero el valor
    const valor = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").val());
    // reajusto según el modo
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").prop("checked")) {
        //console.log("CAMBIO A PERÍMETRO");
        // cambio a perímetro
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#labelTreeDiameter").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).perimetermm));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").prop("placeholder", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterperimetermm));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").prop("max", (20000 * Math.PI).toFixed(0));
        if (valor) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").val((valor * Math.PI).toFixed(0));
    } else {
        //console.log("CAMBIO A DIÁMETRO");
        // cambio a diámetro
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#labelTreeDiameter").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).diametermm));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").prop("placeholder", (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).enterdiametermm));
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").prop("max", 20000);
        if (valor) (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").val((valor / Math.PI).toFixed(0));
    }
}
// reajuste modo cámara
function $3a9989d46007ef73$export$cd64dd1ec39c266d() {
    // reajusto según el modo
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkCamera").prop("checked")) {
        // ajusto localStorage
        localStorage.setItem("camera", "true");
        // atributo capture a "environment"
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treePhoto").attr("capture", "environment");
    } else {
        // ajusto localStorage
        localStorage.setItem("camera", "false");
        // borro atributo capture
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treePhoto").removeAttr("capture");
    }
}
var $df6ce3c1c8ff32d2$exports = {};
$df6ce3c1c8ff32d2$exports = new URL("../treeCreation.d0b17783.png", import.meta.url).toString();


/////////////////////////////
// CREO ÁRBOL CON LO QUE HAYA
/////////////////////////////
async function $3a9989d46007ef73$var$handlerCreateTree(e) {
    if (e != undefined) {
        // Consume the click event
        e.preventDefault(); // Prevents the default behavior of the click event
        e.stopPropagation(); // Stops the propagation of the click event
    }
    // 1) pongo el modal: estático, con spinner y sin footer
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true,
        spinner: true,
        spinnerMessage: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).pleasewait),
        nofooter: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).creatingtree), null, null);
    // muestro modal		
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    // 2) genero un id de árbol => nanoid de 12 caracteres
    const etid = (0, $96abbdd7193a3c4b$export$567fc7097e064344)(12);
    const ahora = new Date().toISOString();
    const creador = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid; // cojo el uid del usuario en firebase
    // inicializo evento de creación de árbol a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: "tree",
        content_id: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + etid,
        uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid,
        crafts_reqs: 0
    });
    // 3) si hay foto la guardo primero en Firebase
    const imgDataUrl = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#resizedTreePhoto").val();
    let imgDownloadURL = null;
    let imgFirebasePath = null;
    if (imgDataUrl) {
        //console.log("hay imagen");
        // Get a reference to the storage service, which is used to create references in your storage bucket
        const storage = (0, $df9a6d7fd06616c9$export$fbd9b57a66480737)((0, $c0304d280c7b00cb$export$54387eca9e368edc)());
        // Create a storage reference from our storage service
        //const storageRef = ref();
        // preparo referencia a imagen para guardar
        imgFirebasePath = "images/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid + "/" + etid + ".png";
        const imgRef = (0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)(storage, imgFirebasePath);
        // guardo foto del árbol
        try {
            //const snapshot = await imgRef.putString(imgDataUrl, 'data_url');			
            //imgDownloadURL = await snapshot.ref.getDownloadURL();
            const snapshot = await (0, $df9a6d7fd06616c9$export$d885b2eb178808b3)(imgRef, imgDataUrl, "data_url");
            imgDownloadURL = await (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(snapshot.ref);
            // mando evento de creación de foto en firebase a GA
            (0, $067277e156f7a571$export$7329bcdc3edcd90e)("create_content", {
                content_type: "photo",
                content_id: imgDownloadURL,
                uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid
            });
            console.info("Foto subida a Firebase: " + imgDownloadURL);
        } catch (error) {
            console.error("Error: " + error.message);
            const be = "<code>" + error + "</code>";
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                static: true,
                vertcent: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).uploadingphotoerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).creacionError);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
            return; // terminamos
        }
    }
    // 4) preparo objetos JSON con los datos del árbol a crear
    // tobj de tipo EducaTree y bobj de tipo BasicEducaTree (éste es para actualizar los datos guardados)
    // datos básicos y posición
    let tobj = {
        "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + etid,
        "creator": creador,
        "created": ahora,
        "position": {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/posann/" + etid,
            "creator": creador,
            "created": ahora,
            "latWGS84": Number((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat),
            "lngWGS84": (0, $69f04ba581843b2d$export$9f306b5167a85c73)(Number((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng)),
            "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/PositionAnnotation"
        },
        "positionAnnotations": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/posann/" + etid,
        "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/Tree"
    };
    let bobj = {
        "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + etid,
        "creator": creador,
        "created": ahora,
        "lat": Number((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat),
        "lng": (0, $69f04ba581843b2d$export$9f306b5167a85c73)(Number((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng))
    };
    // nick
    const treenick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeNick").val();
    if (treenick && treenick.length >= 3) {
        tobj.nick = treenick;
        bobj.nick = treenick;
    }
    // taxón
    const turi = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#inputTreeTaxonEd").attr("iri");
    if (turi != undefined) {
        tobj.species = {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/spann/" + etid,
            "creator": creador,
            "created": ahora,
            "species": turi,
            "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/SpeciesAnnotation"
        };
        tobj.speciesAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/spann/" + etid;
        // el básico...
        bobj.species = turi;
    }
    // estado árbol
    const tstiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreeStatus").val();
    if (tstiri !== "") {
        tobj.treeStatus = {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/treestann/" + etid,
            "creator": creador,
            "created": ahora,
            "treeStatus": tstiri
        };
        tobj.treeStatusAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/treestann/" + etid;
        // el básico... 
        bobj.treeStatus = tstiri;
    }
    // foto
    if (imgDownloadURL) {
        tobj.imageAnnotations = {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/imgann/" + etid,
            "creator": creador,
            "created": ahora,
            "image": {
                "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/img/" + etid,
                "imageURL": imgDownloadURL,
                "firebasePath": imgFirebasePath,
                "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/Image"
            },
            "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/ImageAnnotation"
        };
        // si ha seleccionado el tipo de foto...
        const tppiri = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#selectTreePartPhoto").val();
        if (tppiri !== "") tobj.imageAnnotations.image.plantPart = tppiri;
        // el básico...
        bobj.images = imgDownloadURL;
    }
    // altura
    const alt = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeHeight").val());
    if (alt && alt > 0 && alt < 150) {
        // hay altura y tiene un valor correcto
        tobj.height = {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/heightann/" + etid,
            "creator": creador,
            "created": ahora,
            "meters": alt,
            "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/HeightAnnotation"
        };
        tobj.heightAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/heightann/" + etid;
        // el básico...
        bobj.height = alt;
    }
    // diámetro
    let diam = Number((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeDiameter").val());
    if (diam) {
        // reajuste por el modo perímetro
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#checkPerimeter").prop("checked")) diam = Number((diam / Math.PI).toFixed(0));
        if (diam > 0 && diam < 20000) {
            // hay diámetro y tiene un valor correcto
            tobj.diameter = {
                "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/diamann/" + etid,
                "creator": creador,
                "created": ahora,
                "millimeters": diam,
                "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/DiameterAnnotation"
            };
            tobj.diameterAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/diamann/" + etid;
            // el básico...
            bobj.dbh = diam;
        }
    }
    // observación
    const observation = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#treeObservation").val();
    if (observation && observation.length > 4) {
        // hay una observación
        tobj.observations = {
            "iri": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/observann/" + etid,
            "creator": creador,
            "created": ahora,
            "text": {
                [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: observation
            },
            "types": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/sta/ontology/ObservationAnnotation"
        };
        // el básico...
        bobj.observations = {
            [(0, $96abbdd7193a3c4b$export$350964a2fface462)()]: observation
        };
    }
    //console.log(tobj);
    //console.log(bobj);
    // 5) hago la llamada para crear el educatree
    try {
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)(null, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).creatingtree), null, null);
        await (0, $174d363c054274ef$export$12a337954d57ecd1)(tobj, bobj); // aquí se hace la creación y la sincronización con el mapa si tiene éxito		
        // envío datos creación del árbol a GA
        (0, $067277e156f7a571$export$6adbd77fe07ba13)("create_content");
        console.info("\xc1rbol creado con IRI: " + (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/tree/" + etid); // log
    } catch (err) {
        console.error(err.message);
        // actualizo modal
        const be = "<code>" + err.message + "<br>" + JSON.stringify(err.error) + "</code>";
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            static: true,
            vertcent: true
        }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treecreationerror), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).creacionError);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
        return; // terminamos
    }
    // 6) dejo preparada la URL para ir a la página del educatree creado
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path = "tree";
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid = etid;
    history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    // 7) ajustes finales modal
    // /app/images/treeCreation.png
    const htmlbody = '<img id="imgTreeCreation" src="" class="d-block w-100">';
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        static: true,
        vertcent: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).treecreationsuccess), htmlbody, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).creacionExito);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgTreeCreation").attr("src", new URL($df6ce3c1c8ff32d2$exports));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goBack").click((0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".cargarURL").click(function() {
        (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
    });
}
//////////////////////////
// MINIMAPA CREACIÓN ÁRBOL
//////////////////////////
async function $3a9989d46007ef73$export$d3be837b79c08382(mm, bounds) {
    // reajusto zoom a config.zMaxCelda (18) para reducir peticiones (respecto a 20)
    const zoom = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda; // 18;
    // incluyo zoom para el cacheo
    //Sesion.zoomUsados[Sesion.estado.loc.z] = true; 
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomUsados[zoom] = true;
    // obtengo grid de celdas para el mapa
    //const grid = getGrid(bounds, Sesion.estado.loc.z);
    const grid = (0, $0a5d75214fa44e03$export$85a47b3ccce199ed)(bounds, zoom);
    // inicializo infoCeldas
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas = {
        total: (1 + grid.cellE - grid.cellW) * (1 + grid.cellN - grid.cellS),
        finalizadas: [],
        cacheadas: [],
        npc: [] // número de peticiones a crafts
    };
    // inicializo arbsPintados en Minimapa
    mm.arbsPintados = {};
    // inicializo promesas
    let promesas = [];
    // trabajo celda a celda
    for(let x = grid.cellW; x <= grid.cellE; x++)for(let y = grid.cellS; y <= grid.cellN; y++){
        // preparo objeto de la celda
        const objcelda = {
            zoom: zoom,
            txgen: [
                "undefined"
            ],
            txesp: [
                "undefined",
                ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies))
            ],
            cellX: x,
            cellY: y,
            npc: [],
            minimapa: mm,
            ifn: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.ifn,
            et: "z" + zoom + "_x" + x + "_y" + y + "_undefined"
        };
        // enchufo el render
        objcelda.render = $3a9989d46007ef73$var$pintarCeldaMinimapa;
        // hago la petición de datos de árboles de la celda
        promesas.push((0, $174d363c054274ef$export$2579cebb92311e97)(objcelda));
    }
    // espero a que terminen todas las promesas
    await Promise.all(promesas);
}
function $3a9989d46007ef73$var$pintarCeldaMinimapa(objcelda) {
    // referencia a la celda
    const celda = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[objcelda.et];
    // objeto bounds de la celda
    const bounds = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(objcelda.cellX, objcelda.cellY, objcelda.zoom);
    // detecto si hay cluster, ajustando etiqueta y z-index
    let etCluster = null;
    let zCluster = null;
    if (celda.edu.mmil || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.ifn.mmil) {
        etCluster = "+1K";
        zCluster = 1000;
    } else if (celda.edu.ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold || (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.edu.ntrees + celda.ifn.ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold) {
        etCluster = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn ? celda.edu.ntrees + celda.ifn.ntrees : celda.edu.ntrees;
        zCluster = etCluster;
    }
    // CLUSTERS
    if (etCluster != undefined) {
        // pongo el cluster en el centro de la celda
        const mLatLng = bounds.getCenter();
        // preparo icono
        const micon = new (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).divIcon({
            html: '<div class="marcadorTexto"><span>' + etCluster + "</span></div>",
            className: "",
            iconSize: [
                52,
                52
            ],
            iconAnchor: [
                26,
                26
            ],
            tooltipAnchor: [
                12,
                0
            ] // point from which tooltips will "open", relative to the icon anchor
        });
        // creo marcador y añado al minimapa
        const cpint = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).marker(mLatLng, {
            icon: micon
        }).addTo(objcelda.minimapa);
        // añado tooltip si no es táctil
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).hayTooltips) cpint.bindTooltip(etCluster + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).ntrees));
    } else {
        // no es un cluster, agrego los dos arrays de árboles y los trato de manera indiferente
        const alltrees = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celda.ifn.trees ? celda.edu.trees ? celda.ifn.trees.concat(celda.edu.trees) : celda.ifn.trees : celda.edu.trees ? celda.edu.trees : [];
        // pinto árbol a árbol
        for (const turi of alltrees)// sólo pinto árbol si no estaba libre (para evitar efectos borde entre celdas)
        if (objcelda.minimapa.arbsPintados[turi] == undefined) {
            // recupero el árbol
            const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[turi];
            // obtengo icono
            const aicon = (0, $7b115b3c2cee4b53$export$6274df672a45c12d)(arb);
            // reajuste de longitud por el antimeridiano
            const lng = (0, $69f04ba581843b2d$export$a4829058f9fe1646)(arb.lng, objcelda.cellX, objcelda.zoom);
            // pinto el marcador del árbol
            let apint = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).marker([
                arb.lat,
                lng
            ], {
                icon: aicon
            }).addTo(objcelda.minimapa);
            // y lo guardo
            objcelda.minimapa.arbsPintados[turi] = apint;
            // pongo tooltips en cualquier caso y a volar
            apint.bindTooltip((0, $82a71c896f160eac$export$924c9d361ba12beb)(arb));
        }
    }
}




////////////
// MAPA BASE
function $69f04ba581843b2d$export$c1c1414601191e71(esMini) {
    if (esMini) {
        const url = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMinimap.url : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMinimap.url;
        const opts = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMinimap.options : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMinimap.options;
        return {
            url: url,
            opts: opts
        };
    } else {
        const url = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMap.url : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMap.url;
        const opts = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.esri ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.esriMap.options : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geoConfigs.osmMap.options;
        return {
            url: url,
            opts: opts
        };
    }
}
/////////////////
// ANTIMERIDIANO
// conversión Leaflet a las consultas al triplestore
function $69f04ba581843b2d$export$9f306b5167a85c73(lng) {
    // OJO CON EL ANTIMERIDIANO: en Leaflet los bounds pueden estar fuera del rango de longitud [-180, 180]
    // https://stackoverflow.com/questions/40532496/wrapping-lines-polygons-across-the-antimeridian-in-leaflet-js		
    // solución para el antimeridiano
    while(lng < -180)lng += 360;
    while(lng > 180)lng -= 360;
    return lng;
}
// conversión coordenadas triplestore a Leaflet
function $69f04ba581843b2d$export$a4829058f9fe1646(lng, cellX, zoom) {
    // recupero cellSide
    const cellSide = (0, $0a5d75214fa44e03$export$c7c0bc1741de0bee)(zoom);
    // nciclos será un entero menor que 0 para longitudes menores de -180
    // nciclos será un entero mayor que 0 para longitudes mayores de -180
    const nciclos = Math.floor((cellX * cellSide + cellSide / 2 + 180) / 360);
    // devuelvo lng ajustada
    return lng + nciclos * 360;
}
////////////////////////////
// BUCLE DE CONTROL DEL MAPA
function $69f04ba581843b2d$export$c8207d40f45dcd81() {
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).errordataprov == undefined) {
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).actualizandoMapa) {
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).mapaMovido = true; // pendiente de actualizar el mapa...
            console.log("Mapa movido: actualizaci\xf3n de mapa pendiente...");
        } else $69f04ba581843b2d$var$actualizarMapa();
    }
}
async function $69f04ba581843b2d$var$actualizarMapa() {
    // si no estoy en modo mapa no continúo con la actualización
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path !== "map") return;
    // desactivo botón de descarga (no se reactivará hasta que termine felizmente finActualizarMapa)
    //$(".download").addClass("disabled");
    // ajustes en la sesión
    // actualizo info de filtro de taxón
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txPrevio = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.taxon;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx] = true; // para el cacheo
    // actualizo zoom
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomPrevio = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom = (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getZoom();
    // si hubo cambio de zoom aplico ajustes del mapa botón de creación
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomPrevio !== (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom) (0, $3a9989d46007ef73$export$7c626a07c7c69914)();
    // limito el zoom en las celdas para evitar explosión en zooms muy altos que no aportan nada
    const zoomCelda = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda : (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomUsados[zoomCelda] = true; // para el cacheo	
    // obtengo grid de celdas para el mapa
    const grid = (0, $0a5d75214fa44e03$export$85a47b3ccce199ed)((0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getBounds(), zoomCelda);
    // inicializaciones progreso y estadísticos celdas
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas = {
        total: (1 + grid.cellE - grid.cellW) * (1 + grid.cellN - grid.cellS),
        finalizadas: [],
        cacheadas: [],
        npc: [],
        ifn: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn // sólo pediré datos de ifn si está activado
    };
    // inicialización primordial
    $69f04ba581843b2d$var$inicioActualizarMapa();
    const idtimeout = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar;
    //
    // CELDAS ÁRBOLES
    //	
    // inicializo promesas de las celdas
    let promesasCeldas = [];
    // actualizo info celdas para GA
    (0, $067277e156f7a571$export$2db6ab9500fc86e)("num_cells", (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total);
    // inicializo zoomout
    let zoomout = false;
    // si hubo un cambio de filtro de taxón borro todo
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx !== (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txPrevio) {
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol
    } else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom != (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomPrevio) {
        (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // obligo a pintar cada celda
        // marco zoomout
        if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoom < (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomPrevio) zoomout = true;
    }
    // pregenero los taxones más generales y más específicos para el cacheo
    let txgen = [
        "undefined"
    ];
    let txesp = [
        "undefined",
        ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies))
    ];
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx != undefined) {
        txgen = [
            "undefined",
            ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx].superexpuris)
        ];
        txesp = (0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx].expuris);
    }
    // trabajo celda a celda
    for(let x = grid.cellW; x <= grid.cellE; x++)for(let y = grid.cellS; y <= grid.cellN; y++){
        // preparo objeto de la celda
        const objcelda = {
            zoomout: zoomout,
            taxon: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx,
            txgen: txgen,
            txesp: txesp,
            zoom: zoomCelda,
            cellX: x,
            cellY: y,
            npc: [],
            et: "z" + zoomCelda + "_x" + x + "_y" + y + "_" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).tx,
            ifn: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.ifn,
            idtimeout: idtimeout // para actualizar Sesion.infoCeldas sólo si toca
        };
        // enchufo el progreso
        objcelda.progreso = $69f04ba581843b2d$var$pintarBarraProgreso;
        // enchufo el render
        objcelda.render = (0, $82a71c896f160eac$export$b07097befa6136ca);
        // hago la petición de datos de sitios de la celda
        promesasCeldas.push((0, $174d363c054274ef$export$2579cebb92311e97)(objcelda));
    }
    // hago borrado de los árboles no visibles (para evitar problemas con el antimeridiano:
    //	-> un árbol sólo puede estar pintado una vez)
    //	-> no me preocupo por el borrado de los clusters
    //console.time("Borrado de árboles en celdas no visibles");
    const gridBounds = (0, $0a5d75214fa44e03$export$bcb885fb505ac675)(grid, zoomCelda); // bounds del grid
    //let numCellsBorradas = 0;
    //let numArbsBorrados = 0;	
    for(const cpet in (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas){
        // extraigo z, x, y de cpet
        const cpetZ = Number(cpet.substring(1, cpet.indexOf("_")));
        const cpetX = Number(cpet.substring(cpet.indexOf("_x") + 2, cpet.indexOf("_", cpet.indexOf("_x") + 1)));
        const cpetY = Number(cpet.substring(cpet.indexOf("_y") + 2, cpet.indexOf("_", cpet.indexOf("_y") + 1)));
        const cpgrid = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(cpetX, cpetY, cpetZ);
        // si no lo contiene...
        if (!gridBounds.contains(cpgrid)) {
            const celdaborrar = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[cpet];
            const alltreesborrar = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.ifn && celdaborrar.ifn.trees ? celdaborrar.edu.trees ? celdaborrar.ifn.trees.concat(celdaborrar.edu.trees) : celdaborrar.ifn.trees : celdaborrar.edu.trees ? celdaborrar.edu.trees : [];
            for (const airi of alltreesborrar)if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[airi]) {
                (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.removeLayer((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[airi]);
                delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados[airi];
            //numArbsBorrados++;
            }
            // la celda ya no está pintada
            delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas[cpet];
        // estadístico celdas
        //numCellsBorradas++;
        }
    }
    //console.log("#celdas borradas: " + numCellsBorradas);
    //console.log("#árboles borrados: " + numArbsBorrados);
    //console.timeEnd("Borrado de árboles en celdas no visibles");
    // espero a que terminen todas las promesas de las celdas para hacer logging
    await Promise.all(promesasCeldas);
    // logging celdas si no ha vencido el temporizador de actualización...
    if (idtimeout == (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar) {
        // logging celdas
        //console.log("Celdas totales: " + infoceldas.npc.length);
        //console.log("Celdas cacheadas: " + infoceldas.cacheadas.length);
        const tcc = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.cacheadas, function(memo, num) {
            return memo + num;
        }, 0);
        const npc = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.npc, function(memo, num) {
            return memo + num;
        }, 0);
        console.info("#celdas I" + idtimeout + " total: " + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total + " - cacheadas: " + tcc + " - #npc: " + npc);
        // actualizo info celdas cacheadas para GA
        (0, $067277e156f7a571$export$2db6ab9500fc86e)("cached_cells", tcc);
    }
    // rutina fin actualización del mapa si no ha vencido el temporizador de actualización
    if (idtimeout == (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar) $69f04ba581843b2d$export$7a39c88e7f3f42da();
}
function $69f04ba581843b2d$var$inicioActualizarMapa() {
    // mapa actual
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).mapaMovido = false;
    // quito timeout anterior (importante llamar tras Sesion.mapaMovido = false)
    $69f04ba581843b2d$export$7a39c88e7f3f42da();
    // pongo bloqueo a actualizaciones
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).actualizandoMapa = true;
    // pinto la barra de progreso
    $69f04ba581843b2d$var$pintarBarraProgreso(true);
    // actualizo la localización del estado de la sesión
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lat = (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getCenter().lat;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.lng = (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getCenter().lng;
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.loc.z = (0, $ffd94e1d81f19b1c$export$aabd6129ce9bddee).getZoom();
    // reajusto url y actualizo página en la historia si hay cambio en URL
    if (window.location !== (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)()) history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    // ajuste propiedad meta de la url
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:url']").attr("content", window.location);
    // pongo timeout para que quite el bloqueo tras 10 segundos (por si acaso se bloquea indefinidamente)
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar = setTimeout(function() {
        // mando evento de timeout a GA	
        (0, $067277e156f7a571$export$cfc545666c0ce6d8)();
        console.warn("Venci\xf3 el temporizador de " + Math.round((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout / 1000) + " segundos antes de terminar de actualizar el mapa");
        console.groupEnd();
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).actualizandoMapa = false;
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar = null;
        // actualizo timeout
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout += (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).timeoutStep;
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).huboTimeout = true;
        // y llamo a mapaMovido
        $69f04ba581843b2d$export$c8207d40f45dcd81();
    }, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout);
    // logging
    console.group("I" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar + " - Actualizando mapa");
    console.time("Actualizaci\xf3n I" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar);
    console.log("URL: " + window.location);
    console.log("Temporizador actualizaci\xf3n: " + Math.round((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout / 1000) + " segundos");
    //console.log(" -> bloqueando actualizaciones y poniendo temporizador antibloqueo: " + Sesion.idTimeoutActualizar);
    // inicializo el evento para enviar a Google Analytics
    (0, $067277e156f7a571$export$626fff8d65416420)();
}
function $69f04ba581843b2d$export$7a39c88e7f3f42da() {
    //console.log(" -> fin de actualización del mapa, quito temporizador antibloqueo");
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).actualizandoMapa = false; // quito bloqueo
    // cancelo timeout anterior (si existiera)
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar != null) {
        clearTimeout((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar);
        console.timeEnd("Actualizaci\xf3n I" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar);
        console.info("I" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar + " - Fin actualizaci\xf3n del mapa");
        console.groupEnd();
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar = null;
        // activo botón de descarga
        //$(".download").removeClass("disabled");		
        // escondo la barra de progreso
        $69f04ba581843b2d$var$pintarBarraProgreso(false);
        // actualización timeout
        if (!(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).huboTimeout && (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).timeout) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).timeout -= (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).timeoutStep;
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).huboTimeout = false; // inicializo para la siguiente
        // mando evento de fin de actualización del mapa
        (0, $067277e156f7a571$export$6adbd77fe07ba13)();
    }
    // llamo a actualizar el mapa si es necesario
    if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).mapaMovido) {
        console.info("El mapa se hab\xeda movido, vuelvo a actualizar");
        $69f04ba581843b2d$export$c8207d40f45dcd81();
    } else if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).ponerAlertaCuestionario) {
        // miro si pongo el cuestionario
        const ahora = Date.now();
        if (ahora - (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).inicioSesion > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).intraSessionQGap) {
            // pongo el cuestionario
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mapid").append((0, $646ceeeec66fabd8$export$c75e99c9076bb133));
            // ya no lo vuelvo a poner en la sesión
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).ponerAlertaCuestionario = false;
            // y pongo los handlers de los botones
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questbotyes").click(function() {
                // vamos al questionario (nueva pestaña)
                const questurl = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("questurl");
                const win = window.open(questurl, "_blank");
                win.focus();
                // no más cuestionarios
                localStorage.setItem("cuestionarioNo", true);
                // quito la alerta
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questalert").alert("close");
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questbotno").click(function() {
                // no más cuestionarios
                localStorage.setItem("cuestionarioNo", true);
                // quito la alerta
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questalert").alert("close");
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questbotlater").click(function() {
                // reajusto a ahora 
                localStorage.setItem("timestampPrimeraSesion", ahora);
                // quito la alerta
                (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#questalert").alert("close");
            });
        }
    }
}
function $69f04ba581843b2d$var$pintarBarraProgreso(mostrar) {
    // variante sin JQuery para que vaya más rápida la actualización de la barra
    const mibarradiv = document.getElementById("mibarradiv");
    if (mostrar) {
        // obtengo celdas completadas
        const celdascomp = (0, $2q7Wm.default).reduce((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.finalizadas, function(memo, num) {
            return memo + num;
        }, 0);
        // calculo porc (hasta 99)
        const porc = Math.floor(99 * celdascomp / (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total);
        // ajusto barra
        let mibarra = document.getElementById("mibarra");
        mibarradiv.setAttribute("aria-valuenow", porc);
        mibarra.style.width = porc + "%";
        mibarra.innerHTML = porc + "%";
        // mensajillo de cargando
        let mibarraLoading = document.getElementById("mibarra_loading");
        const porcLoading = 100 - porc;
        if (porcLoading > 30) {
            mibarraLoading.classList.remove("d-none");
            mibarraLoading.style.width = porcLoading + "%";
        } else mibarraLoading.classList.add("d-none");
        // muestro la barra de progreso
        mibarradiv.classList.remove("d-none");
    } else mibarradiv.classList.add("d-none");
}





// DESCOMPOSICIÓN LLAMADA RESOURCES
function $174d363c054274ef$var$descomponerCraftsResources(id, uris) {
    // array a devolver con la descomposición
    let devolver = [];
    // array de huérfanos (para combinar)
    let huerfanos = [];
    // organizo las uris por sus namespaces
    let nsuris = {};
    // analizo cada uri y la meto por su namespace
    for(let i = 0; i < uris.length; i++){
        const uri = uris[i];
        // obtengo namespace
        const indfin = Math.max(uri.lastIndexOf("/"), uri.lastIndexOf("#"));
        const ns = uri.substring(0, indfin + 1);
        // guardo
        if (nsuris[ns] == undefined) nsuris[ns] = [];
        nsuris[ns].push(uri);
    }
    // analizo cada namespace encontrado
    const nss = Object.keys(nsuris);
    for(let i = 0; i < nss.length; i++){
        // obtengo el namespace y sus uris
        const mins = nss[i];
        const misuris = nsuris[mins];
        // preparo lotes de 200
        const lote = 200;
        for(let ind = 0; misuris.length > ind * lote; ind++){
            const begin = ind * lote;
            const end = misuris.length > (ind + 1) * lote ? (ind + 1) * lote : misuris.length;
            // si este lote es inferior a 10, los meto en huérfanos
            if (end - begin < 10) huerfanos = huerfanos.concat(misuris.slice(begin, end));
            else {
                // creo un objeto para este lote
                let obj = {};
                obj.id = id;
                obj.ns = mins;
                obj.nspref = "p"; // arbitrario
                obj.iris = [];
                // meto cada iri con prefijo en el lote
                for(let j = begin; j < end; j++){
                    const uri = misuris[j];
                    const prefuri = "p:" + uri.substring(mins.length);
                    obj.iris.push(prefuri);
                }
                // y guardo el objeto en devolver
                devolver.push(obj);
            }
        }
    }
    // proceso los huérfanos en lotes de 40
    const lote = 40;
    for(let ind = 0; huerfanos.length > ind * lote; ind++){
        const begin = ind * lote;
        const end = huerfanos.length > (ind + 1) * lote ? (ind + 1) * lote : huerfanos.length;
        // creo un objeto para este lote
        let obj = {};
        obj.id = id;
        obj.iris = huerfanos.slice(begin, end);
        // y guardo el objeto en devolver
        devolver.push(obj);
    }
    // devuelvo la descomposición
    return devolver;
}
// INICIALIZACIONES PROVEEDOR DE DATOS
// datos tipos de partes de plantas para fotos
async function $174d363c054274ef$export$c2cc3ce4ebc083ee() {
    // preparo objeto para la petición a CRAFTS de pares de superclase-subclase a partir de config.usoTop
    const qobj = {
        "ancestor": (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).plantPartPhoto
    };
    const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryInfoClasses, qobj);
    // fue todo bien, guardo partes de plantas de fotos
    // analizo fila a fila
    for (const row of datos.results.bindings){
        // preparo objeto
        let obj = {
            uri: row.class.value,
            label: {}
        };
        // guardo labeles
        if (row.labes.value != undefined) obj.label.es = row.labes.value;
        // guardo labelen
        if (row.laben.value != undefined) obj.label.en = row.laben.value;
        // y guardo en los datos
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).partesPlantasFoto[obj.uri] = obj;
    }
}
// info de todas las especies
async function $174d363c054274ef$export$40a5140e3d2b7b8d() {
    // obtengo info de subclases de las especies
    for (let espTop of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).especiesTop){
        // preparo objeto para la petición a CRAFTS de pares de superclase-subclase a partir de config.especiesTop
        const qobj = {
            "ancestor": espTop
        };
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.querySubclasses, qobj);
        // fue todo bien, inicializo clase config.especiesTop[i]		
        $174d363c054274ef$export$25fe61d80318b90d((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies, espTop);
        // analizo cada fila de los resultados
        for (let row of datos.results.bindings){
            // obtengo datos
            const supuri = row.sup.value;
            const suburi = row.sub.value;
            // inicializo clases
            $174d363c054274ef$export$25fe61d80318b90d((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies, supuri);
            $174d363c054274ef$export$25fe61d80318b90d((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies, suburi);
            // guardo subclase
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[supuri].subclasses.push(suburi);
            // guardo superclase
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suburi].superclasses.push(supuri);
        }
    }
    // obtengo especies expandidas
    $174d363c054274ef$export$14ba48f8fbb8469();
    // ahora pido a CRAFTS la info de cada especie
    const suris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies);
    let promesas = []; // inicializo promesas
    // pido descomponer en objetos para la llamada resources de CRAFTS
    const objrs = $174d363c054274ef$var$descomponerCraftsResources("Species", suris);
    // ya tengo los objetos a pedir, lanzo las peticiones en paralelo a CRAFTS
    for (const objr of objrs)// creo una promesa para cada petición
    promesas.push(new Promise(async function(resolve, reject) {
        try {
            // hago la llamada a CRAFTS	y espero resultados
            let datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourcesTemplate, objr);
            // convierto en array si es necesario
            if (!Array.isArray(datos)) datos = [
                datos
            ];
            // actualizo especie a especie, fusionando con lo que tenía
            for (let dato of datos)Object.assign((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[dato.iri], dato);
            // resuelvo la promesa
            resolve(true);
        } catch (err) {
            reject(err);
        }
    }));
    // espero a que terminen todas las promesas
    await Promise.all(promesas);
}
// util para usos y especies
function $174d363c054274ef$export$25fe61d80318b90d(objbase, cluri) {
    if (objbase[cluri] == undefined) objbase[cluri] = {
        "uri": cluri,
        "subclasses": [],
        "superclasses": []
    };
}
function $174d363c054274ef$export$14ba48f8fbb8469(borrar) {
    // obtengo las uris
    let evsuris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies);
    if (borrar) // borro la info inicial que tuviera de nivel y especies expandidas
    for (let txuri of evsuris){
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].nivel;
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].expuris;
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[txuri].superexpuris;
    }
    // obtengo las especies expandidas
    while(evsuris.length > 0){
        let newevsuris = [];
        for (let suri of evsuris){
            // recupero especie
            const especie = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suri];
            // ajusto nivel (para determinar si es especie/género/familia/clase)
            if (especie.nivel == undefined) especie.nivel = 0;
            else especie.nivel++;
            // obtengo la uri de cualquier subespecie sin expandir
            const algsubsuri = (0, $2q7Wm.default).find(especie.subclasses, function(subsuri) {
                return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[subsuri].expuris == undefined;
            });
            // si no está definida, puedo hacer la expansión de uris
            if (algsubsuri == undefined) {
                // inicializo con la uri de la propia especie
                especie.expuris = [
                    suri
                ];
                // y ahora incluimos las de la subclases
                for (let subsuri of especie.subclasses)especie.expuris = (0, $2q7Wm.default).union(especie.expuris, (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[subsuri].expuris);
            } else newevsuris.push(suri);
        }
        // actualizo lista de tipos a evaluar
        evsuris = newevsuris;
    }
    // recalculo para obtener especies expandidas superiores
    evsuris = Object.keys((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies);
    while(evsuris.length > 0){
        let newevsuris = [];
        for (let suri of evsuris){
            // recupero especie
            const especie = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[suri];
            // obtengo la uri de cualquier superespecie sin expandir
            const algsupersuri = (0, $2q7Wm.default).find(especie.superclasses, function(supersuri) {
                return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[supersuri].superexpuris == undefined;
            });
            // si no está definida, puedo hacer la expansión de uris
            if (algsupersuri == undefined) {
                // inicializo con la uri de la propia especie
                especie.superexpuris = [
                    suri
                ];
                // y ahora incluimos las de la superclases
                for (let supersuri of especie.superclasses)especie.superexpuris = (0, $2q7Wm.default).union(especie.superexpuris, (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[supersuri].superexpuris);
            } else newevsuris.push(suri);
        }
        // actualizo lista de tipos a evaluar
        evsuris = newevsuris;
    }
}
/////////
// TAXONS
/////////
async function $174d363c054274ef$export$ad969a5713b03ee4(resAPI) {
    // extraigo las IRIS de las entidades
    const entsWD = (0, $2q7Wm.default).pluck(resAPI, "concepturi");
    // extraigo las entidades que requieren consulta a Wikidata
    const entsconsultar = (0, $2q7Wm.default).filter(entsWD, function(ent) {
        return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[ent] == undefined;
    });
    if (entsconsultar.length > 0) {
        // hago la llamada a CRAFTS
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryValidTaxons, {
            eiri: entsconsultar
        });
        // guardo fila a fila (resultados positivos)
        for (const row of datos.results.bindings){
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[row.taxon.value] = true;
            // incluyo los datos del punto SPARQL y de la API
            const res = (0, $2q7Wm.default).find(resAPI, function(el) {
                return el.concepturi === row.taxon.value;
            });
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[row.taxon.value] = {
                iri: row.taxon.value,
                label: res.display.label.value,
                description: res.description,
                sitelinks: Number(row.sitelinks.value),
                statements: Number(row.statements.value),
                pending: true
            };
        }
        // y ahora guardo los resultados negativos
        for (let ent of entsconsultar)if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[ent]) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[ent] = false;
    }
    // extraigo los taxones válidos (ya está todo listo en Datos.esTaxonWD)
    return (0, $2q7Wm.default).filter(entsWD, function(ent) {
        return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[ent];
    });
}
async function $174d363c054274ef$export$2389aabfa4796a70(wdiri) {
    // detecto si tengo los datos de la llamada getValidTaxons
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri]) {
        // hago la llamada a CRAFTS
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryValidTaxons, {
            eiri: wdiri
        });
        // guardo el resultado (habrá al menos uno)
        for (const row of datos.results.bindings){
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).esTaxonWD[row.taxon.value] = true;
            // incluyo los datos del punto SPARQL
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[row.taxon.value] = {
                iri: row.taxon.value,
                sitelinks: Number(row.sitelinks.value),
                statements: Number(row.statements.value),
                pending: true
            };
        }
    }
    // luego detecto si tengo los datos completos
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri].pending) {
        // debería tener ya algo en Datos.taxonesWD[wdiri], si no, no hago nada
        // hago la llamada a CRAFTS	y espero resultados
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, {
            id: "WikidataTaxon",
            iri: wdiri
        });
        // fusiono con lo que tenía
        Object.assign((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri], datos);
        // caso especial si no vino de getValidTaxons para rellenar label
        if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri].label) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri].label = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(datos.scientificName);
        // borro el flag de pending
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).taxonesWD[wdiri].pending;
    }
}
async function $174d363c054274ef$export$5e6ebc4b1b859630(wdiris) {
    let existing = [];
    if (wdiris.length > 0) {
        // hago la llamada a CRAFTS
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryExistingWikidataTaxons, {
            wdiri: wdiris
        });
        // guardo fila a fila
        for (const row of datos.results.bindings)existing.push(row.wdiri.value);
    }
    return existing;
}
// CREACIÓN DEL TAXÓN
async function $174d363c054274ef$export$f4b4fb77e87b331a(txobj) {
    // preparo objeto parámetros plantilla
    const objpars = {
        iri: txobj.iri,
        id: "Species"
    };
    // hago la llamada a CRAFTS
    // creo el árbol y sus anotaciones asociadas
    //console.log("CREANDO EDUCATREE...");
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).putData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, txobj);
    // todo OK
    return Promise.resolve(true);
}
////////
// USERS
////////
async function $174d363c054274ef$export$3f90b926bc531097(uid) {
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid] != undefined) return Promise.resolve(true); // ya los tenía
    // preparo objeto parámetros consulta
    const objpars = {
        iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + uid,
        id: "Person"
    };
    try {
        // hago la llamada a CRAFTS
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars);
        // guardo datos
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid] = datos;
        // todo OK
        return Promise.resolve(true);
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
}
async function $174d363c054274ef$export$9efbb920d7dd157b(nick) {
    // nunca cacheo esta petición
    // preparo objeto parámetros consulta
    let qobj = {
        nick: nick
    };
    try {
        // hago la llamada a CRAFTS
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryUsernick, qobj);
        // extraigo resultado
        const existe = datos.results.bindings.length;
        // todo OK
        return Promise.resolve(existe);
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
}
async function $174d363c054274ef$export$b5be548bb8509ea6(uid, patch) {
    // preparo objeto plantilla recurso
    const objpars = {
        iri: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + uid,
        id: "Person"
    };
    // hago la llamada a CRAFTS con el patch
    //console.log("CAMBIANDO NICK...");
    try {
        await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).patchData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, patch);
        // actualizo nick
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[uid].nick = patch[0].value;
        // todo OK
        return Promise.resolve(true);
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
}
async function $174d363c054274ef$export$5f671086e5404234(pe, pae, uid) {
    // si no hay uid, entonces las páginas son de todos (global)
    // tamaño de página depende de si es de usuario o de todos (global)
    const page = uid ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).pageus : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).page;
    // preparo objeto parámetros consulta
    let qobj = {
        limit: page + 1,
        offset: page * pe
    };
    if (uid) qobj.user = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + uid;
    // NOTA: el límite está preconfigurado a 11 para saber si hay datos en la siguiente página (que son de 10 elementos)
    // selecciono el objeto adecuado dependiendo de si es petición del usuario  o si es global
    const clave = uid ? uid : "global";
    // petición ultEducatrees
    // inicializo el array
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[clave]) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[clave] = [];
    // compruebo si está cacheada
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[clave][pe]) try {
        // hago la llamada a CRAFTS		
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryMostRecentEducatrees, qobj);
        // inicializo array resultados
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[clave][pe] = [];
        // guardo fila a fila
        for (const row of datos.results.bindings)(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[clave][pe].push({
            iri: row.tree.value,
            created: row.date.value,
            nick: row.tnick ? row.tnick.value : undefined,
            creator: {
                iri: row.creator.value,
                nick: row.unick ? row.unick.value : undefined
            }
        });
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
    // petición ultAnotaciones
    // actualizo offset
    qobj.offset = page * pae;
    // inicializo el array	
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[clave]) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[clave] = [];
    // compruebo si está cacheada
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[clave][pae]) try {
        // hago la llamada a CRAFTS		
        const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryMostRecentAnnotations, qobj);
        // inicializo array resultados
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[clave][pae] = [];
        // guardo fila a fila
        for (const row of datos.results.bindings)(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[clave][pae].push({
            iri: row.tree.value,
            created: row.date.value,
            type: row.annType.value,
            nick: row.tnick ? row.tnick.value : undefined,
            creator: {
                iri: row.annotator.value,
                nick: row.unick ? row.unick.value : undefined
            }
        });
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
    // todo OK
    return Promise.resolve(true);
}
////////
// TREES
////////
// cambio del nick del árbol
async function $174d363c054274ef$export$56e5489c2f38300e(iri, patch) {
    // preparo objeto plantilla recurso
    const objpars = {
        iri: iri,
        id: "EducaTree"
    };
    // hago la llamada a CRAFTS con el patch
    //console.log("CAMBIANDO NICK...");
    try {
        await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).patchData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, patch);
        // actualizo nick
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri].nick = patch[0].value;
        // todo OK
        return Promise.resolve(true);
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
}
// RECUPERACIÓN DE EDUCATREE
async function $174d363c054274ef$export$92baecf29370dcf(iri) {
    // no hago nada si ya están los datos
    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri] !== undefined) return;
    // preparo objeto para la llamada
    const objr = {
        id: "EducaTree",
        iri: iri
    };
    // hago la llamada a CRAFTS	y espero resultados
    let datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objr);
    // guardo y a volar
    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri] = datos;
}
// lote de educatrees (para la descarga de anotaciones de educatrees)
async function $174d363c054274ef$export$88055805f25eda73(iris, progreso) {
    // obtengo los educatrees de los que no tengo datos
    let pendingiris = (0, $2q7Wm.default).filter(iris, function(iri) {
        return (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri] == undefined;
    });
    if (pendingiris.length > 0) {
        // pido descomponer en objetos para la llamada resources de CRAFTS	
        const objrs = $174d363c054274ef$var$descomponerCraftsResources("EducaTree", pendingiris);
        // actualizo progreso
        if (progreso) {
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.total = objrs.length; // aquí tengo el total
            progreso(true);
        }
        // pido en secuencia
        try {
            for (let objr of objrs){
                // hago la llamada a CRAFTS	y espero resultados
                let datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourcesTemplate, objr);
                // convierto en array si es necesario
                if (!Array.isArray(datos)) datos = [
                    datos
                ];
                // actualizo educatree a educatree
                for (let dato of datos)(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[dato.iri] = dato;
                // actualizo progreso
                if (progreso) {
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.npc.push(1);
                    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.finalizadas.push(1);
                    progreso(true);
                }
            }
        } catch (err) {
            console.error(err);
            return;
        }
    }
}
// CREACIÓN DE EDUCATREE
// tobj es el árbol en formato EducaTree y bobj en formato BasicEducaTree
async function $174d363c054274ef$export$12a337954d57ecd1(tobj, bobj) {
    // preparo objeto parámetros plantilla
    const objpars = {
        iri: tobj.iri,
        id: "EducaTree"
    };
    // hago la llamada a CRAFTS
    // creo el árbol y sus anotaciones asociadas
    //console.log("CREANDO EDUCATREE...");
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).putData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, tobj);
    // actualizo datos usuario para que cuente la nueva anotación
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    await $174d363c054274ef$export$3f90b926bc531097((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid);
    // guardo árbol básico y me aseguro de borrar el árbol en formato EducaTree
    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[bobj.iri] = bobj;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[bobj.iri]; // para obligar a recuperar la info completa si quiere visualizarlo
    // borro también las páginas de árboles del usuario y globales
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    // obtengo los taxones candidatos (igual o más generales que los del árbol 
    // y encajándolos con los filtros de taxón usados en la sesión)
    let txcands = [
        "undefined"
    ];
    if (bobj.species) txcands = [
        "undefined",
        ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[bobj.species].superexpuris)
    ];
    // inserto el árbol de las celdas
    $174d363c054274ef$var$insertarArbolCeldas(bobj.iri, txcands);
    // borro clusters y árboles pintados en el mapa
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol
    // todo OK
    return Promise.resolve(true);
}
// ANOTACIÓN DE EDUCATREE
async function $174d363c054274ef$export$f78fa04d07774c6b(iri, patch, tobjclon, bobjclon) {
    // preparo objeto parámetros plantilla
    const objpars = {
        iri: iri,
        id: "EducaTree"
    };
    // hago la llamada a CRAFTS con el patch
    //console.log("ANOTANDO EDUCATREE...");	
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).patchData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, patch);
    // actualizo datos usuario para que cuente la nueva anotación
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    await $174d363c054274ef$export$3f90b926bc531097((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid);
    // actualizo datos del árbol
    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri] = tobjclon;
    if (bobjclon) {
        // detecto cambio de posición o de taxón 
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].lat != bobjclon.lat || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].lng != bobjclon.lng || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species !== bobjclon.species)) {
            // elimino el árbol "previo" de las celdas
            let txcands = [
                "undefined"
            ];
            if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species) txcands = [
                "undefined",
                ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species].superexpuris)
            ];
            $174d363c054274ef$var$eliminarArbolCeldas(iri, txcands);
            // ahora actualizo el árbol básico para que coja bien los cambios de posición
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] = bobjclon;
            // inserto el árbol "nuevo" de las celdas
            txcands = [
                "undefined"
            ];
            if (bobjclon.species) txcands = [
                "undefined",
                ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[bobjclon.species].superexpuris)
            ];
            $174d363c054274ef$var$insertarArbolCeldas(iri, txcands);
        }
        // y ahora actualizo el árbol básico (para resto de casos)
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] = bobjclon;
    }
    // borro también las páginas de árboles del usuario y globales
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    // borro clusters y árboles pintados en el mapa
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol
    // todo OK
    return Promise.resolve(true);
}
// BORRADO DE ANOTACIÓN DE EDUCATREE
async function $174d363c054274ef$export$e2dbe74809c0905f(iri, patch, objsborrar, tobjclon, bobjclon) {
    // preparo objeto parámetros plantilla
    const objpars = {
        iri: iri,
        id: "EducaTree"
    };
    // hago la llamada a CRAFTS con el patch
    //console.log("BORRANDO ANOTACIÓN DE EDUCATREE...");
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).patchData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, objpars, patch);
    // llamadas a CRAFTS para borrar las anotaciones
    for (const elobj of objsborrar)//console.log("Borrando IRI "  + elobj.iri + " de tipo " + elobj.id);
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).deleteData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, elobj);
    // actualizo datos usuario para que actualice anotaciones
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    await $174d363c054274ef$export$3f90b926bc531097((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid);
    // actualizo datos del árbol
    (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri] = tobjclon;
    if (bobjclon) {
        // detecto cambio de posición o de taxón 
        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] && ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].lat != bobjclon.lat || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].lng != bobjclon.lng || (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species !== bobjclon.species)) {
            // elimino el árbol "previo" de las celdas
            let txcands = [
                "undefined"
            ];
            if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species) txcands = [
                "undefined",
                ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri].species].superexpuris)
            ];
            $174d363c054274ef$var$eliminarArbolCeldas(iri, txcands);
            // ahora actualizo el árbol básico para que coja bien los cambios de posición
            (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] = bobjclon;
            // inserto el árbol "nuevo" de las celdas
            txcands = [
                "undefined"
            ];
            if (bobjclon.species) txcands = [
                "undefined",
                ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[bobjclon.species].superexpuris)
            ];
            $174d363c054274ef$var$insertarArbolCeldas(iri, txcands);
        }
        // y ahora actualizo el árbol básico (para resto de casos)
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri] = bobjclon;
    }
    // borro también las páginas de árboles del usuario y globales
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    // borro clusters y árboles pintados en el mapa
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol
    // todo OK
    return Promise.resolve(true);
}
// BORRADO DE EDUCATREE
async function $174d363c054274ef$export$c4e23ce322fddcd9(iri) {
    // pido datos a CRAFTS del educatree (ya debería tenerlos)
    await $174d363c054274ef$export$92baecf29370dcf(iri);
    const et = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri];
    // analizo los datos para preparar los borrados con CRAFTS
    const objpars = [
        {
            iri: iri,
            id: "EducaTree"
        }
    ];
    // posiciones (funciona aunque no existan posiciones)
    const piris = (0, $2q7Wm.default).union((0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "position",
        "iri"
    ]), (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "positionAnnotations",
        "iri"
    ]));
    for (const piri of piris)objpars.push({
        iri: piri,
        id: "PositionAnnotation"
    });
    // especies (funciona aunque no existan especies)
    const eiris = (0, $2q7Wm.default).union((0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "species",
        "iri"
    ]), (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "speciesAnnotations",
        "iri"
    ]));
    for (const eiri of eiris)objpars.push({
        iri: eiri,
        id: "SpeciesAnnotation"
    });
    // tree status (funciona aunque no existan)
    const tsiris = (0, $2q7Wm.default).union((0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "treeStatus",
        "iri"
    ]), (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "treeStatusAnnotations",
        "iri"
    ]));
    for (const tsiri of tsiris)objpars.push({
        iri: tsiri,
        id: "TreeStatusAnnotation"
    });
    // fotos (funciona aunque no existan)
    const firis = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "imageAnnotations",
        "iri"
    ]);
    for (const firi of firis)objpars.push({
        iri: firi,
        id: "ImageAnnotation"
    });
    // imágenes de las fotos (funciona aunque no existan)
    const iiris = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "imageAnnotations",
        "image",
        "iri"
    ]);
    for (const iiri of iiris)objpars.push({
        iri: iiri,
        id: "Image"
    });
    // alturas (funciona aunque no existan)
    const airis = (0, $2q7Wm.default).union((0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "height",
        "iri"
    ]), (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "heightAnnotations",
        "iri"
    ]));
    for (const airi of airis)objpars.push({
        iri: airi,
        id: "HeightAnnotation"
    });
    // diámetros (funciona aunque no existan)
    const diris = (0, $2q7Wm.default).union((0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "diameter",
        "iri"
    ]), (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "diameterAnnotations",
        "iri"
    ]));
    for (const diri of diris)objpars.push({
        iri: diri,
        id: "DiameterAnnotation"
    });
    // observaciones (funciona aunque no existan)
    const oiris = (0, $96abbdd7193a3c4b$export$326843c69d38a183)(et, [
        "observations",
        "iri"
    ]);
    for (const oiri of oiris)objpars.push({
        iri: oiri,
        id: "ObservationAnnotation"
    });
    //console.log(objpars);
    // borrados en CRAFTS
    //console.log("BORRANDO EDUCATREE...");
    for (const elobj of objpars)//console.log("Borrando IRI "  + elobj.iri + " de tipo " + elobj.id);
    await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).deleteData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourceTemplate, elobj);
    // obtengo los taxones candidatos (igual o más generales que los del árbol 
    // y encajándolos con los filtros de taxón usados en la sesión)
    let txcands = [
        "undefined"
    ];
    if (et.species && et.species.species) txcands = [
        "undefined",
        ...(0, $2q7Wm.default).intersection(Object.keys((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).txUsados), (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[et.species.species.iri].superexpuris)
    ];
    // elimino el árbol de las celdas
    $174d363c054274ef$var$eliminarArbolCeldas(iri, txcands);
    // elimino los datos del árbol
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[iri];
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri];
    // borro también las páginas de árboles del usuario y globales
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones.global;
    delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid];
    // por último borro clusters y árboles pintados en el mapa
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).arbs.clearLayers(); // quito marcadores árboles
    (0, $ffd94e1d81f19b1c$export$89312ce47c0ca777).clarbs.clearLayers(); // quito marcadores clusters
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).celdasPintadas = {}; // ninguna celda pintada
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).arbsPintados = {}; // ningún marcador de árbol
}
// ACTUALIZACIÓN CELDAS POR INSERCIÓN ÁRBOL
function $174d363c054274ef$var$insertarArbolCeldas(iri, txcands) {
    const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri];
    if (arb) {
        // obtengo bounds con la posición del árbol
        const bounds = L.latLngBounds([
            [
                arb.lat,
                arb.lng
            ],
            [
                arb.lat,
                arb.lng
            ]
        ]);
        // recorro todos los niveles de zoom usados en el mapa
        for(const z in (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomUsados){
            // obtengo el grid (siempre se corresponderá con una celda al ser bounds un punto)
            const grid = (0, $0a5d75214fa44e03$export$85a47b3ccce199ed)(bounds, z);
            //console.log(" - Zoom: " + z + " - S: " + grid.cellS+ " - N: " + grid.cellN
            //	+ " - W: " + grid.cellW+ " - E: " + grid.cellE);
            // recorro txcands
            for (const tx of txcands){
                // genero etiqueta de celda
                const et = "z" + z + "_x" + grid.cellW + "_y" + grid.cellN + "_" + tx;
                // si la celda existe...
                let celda = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et];
                if (celda) {
                    if (celda.edu && !celda.edu.mmil) {
                        // actualización array edutrees
                        if (!celda.edu.trees) celda.edu.trees = [];
                        celda.edu.trees.push(iri);
                        // actualización ntrees
                        if (!celda.edu.ntrees) celda.edu.ntrees = 0;
                        celda.edu.ntrees++;
                    }
                }
            }
        }
    }
}
// ACTUALIZACIÓN CELDAS POR ELIMINACIÓN ÁRBOL
function $174d363c054274ef$var$eliminarArbolCeldas(iri, txcands) {
    const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[iri];
    if (arb) {
        // obtengo bounds con la posición del árbol
        const bounds = L.latLngBounds([
            [
                arb.lat,
                arb.lng
            ],
            [
                arb.lat,
                arb.lng
            ]
        ]);
        // elimino árbol en las celdas pertinentes
        // recorriendo todos los niveles de zoom usados en el mapa
        for(const z in (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomUsados){
            // obtengo el grid (siempre se corresponderá con una celda al ser bounds un punto)
            const grid = (0, $0a5d75214fa44e03$export$85a47b3ccce199ed)(bounds, z);
            // recorro txcands
            for (const tx of txcands){
                // genero etiqueta de celda
                const et = "z" + z + "_x" + grid.cellW + "_y" + grid.cellN + "_" + tx;
                // si la celda existe...
                let celda = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et];
                if (celda) {
                    if (celda.edu && !celda.edu.mmil) {
                        // actualización array edutrees => elimino árbol
                        if (celda.edu.trees) celda.edu.trees = celda.edu.trees.filter((item)=>item !== iri);
                        // actualización ntrees
                        if (!celda.edu.ntrees && celda.edu.ntrees != 0) celda.edu.ntrees--;
                    }
                }
            }
        }
    }
}
///////////////////////
// PROCESAMIENTO CELDAS
///////////////////////
// función clave para obtener los candidatos para cachear datos
function $174d363c054274ef$var$getCeldasCandidatas(arriba, ocgm, cz, taxones) {
    // calculo rango de zooms permitidos
    const zini = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).minZoom;
    // hacia abajo permito un máximo de 3 niveles para evitar explosión
    const zfin = cz + 3 > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zMaxCelda : cz + 3;
    // obtengo candidatos sin incluir el zoom cz
    let objc = {};
    for(let z = zini; z <= zfin; z++){
        // aquí es donde miro si es hacia arriba o hacia abajo
        if (arriba && z < cz || !arriba && z > cz) {
            if (ocgm[z]) {
                objc[z] = {}; // un objeto por nivel de zoom
                for (const tx of taxones){
                    objc[z][tx] = []; // un array por taxón
                    for(let x = ocgm[z].cellW; x <= ocgm[z].cellE; x++)for(let y = ocgm[z].cellS; y <= ocgm[z].cellN; y++){
                        const et = "z" + z + "_x" + x + "_y" + y + "_" + tx;
                        objc[z][tx].push(et); // le enchufo la etiqueta
                    }
                }
            }
        }
    }
    return objc;
}
function $174d363c054274ef$var$getQueryCeldaBounds(cellX, cellY, z) {
    // obtengo primero los bounds
    const bounds = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(cellX, cellY, z);
    // preparo objeto consulta celda quitando ciclos por el antimeridiano
    let qobj = {
        "latsouth": bounds.getSouth(),
        "latnorth": bounds.getNorth(),
        "lngwest": (0, $69f04ba581843b2d$export$9f306b5167a85c73)(bounds.getWest()),
        "lngeast": (0, $69f04ba581843b2d$export$9f306b5167a85c73)(bounds.getEast())
    };
    // devuelvo
    return qobj;
}
// RECUPERAR IFNTREES Y EDUCATREES POR CELDA
async function $174d363c054274ef$export$2579cebb92311e97(objcell) {
    // preparo qobj por si tengo que hacer una petición a CRAFTS
    let qobj = $174d363c054274ef$var$getQueryCeldaBounds(objcell.cellX, objcell.cellY, objcell.zoom);
    qobj.species = objcell.taxon;
    // referencia a mi celda
    let mycell = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[objcell.et];
    // OBTENGO CANDIDATOS PARA EL CACHEO
    // obtengo matriz de grids para esta celda (pero sólo para los zooms usados)
    const ocgm = (0, $0a5d75214fa44e03$export$bed42eae0b34c43c)(objcell.cellX, objcell.cellY, objcell.zoom, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).zoomUsados);
    // aquí tengo las celdas candidatas por nivel de zoom y taxón (generales y específicas, incluyendo la etiqueta de mycell)
    const candgen = $174d363c054274ef$var$getCeldasCandidatas(true, ocgm, objcell.zoom, objcell.txgen);
    const candesp = $174d363c054274ef$var$getCeldasCandidatas(false, ocgm, objcell.zoom, objcell.txesp);
    // preinicializo la celda si no existe
    if (mycell == undefined) {
        (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[objcell.et] = {};
        mycell = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[objcell.et];
    }
    // detección +1000 árboles para caso ("ifn" y "edu"")  si no hay nada
    const casos = objcell.ifn ? [
        "ifn",
        "edu"
    ] : [
        "edu"
    ];
    for (const caso of casos)if (!mycell[caso]) {
        // comprobación especial de zona para el IFN
        if (caso === "ifn") {
            // compruebo primero si la celda cae en España
            // (si no, no tiene sentido pedir datos del IFN)
            let hayIFN = false;
            const celdabounds = (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(objcell.cellX, objcell.cellY, objcell.zoom);
            for (const zona of (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zonasIFN){
                // reajusto zona por el antimeridiano
                const zonareajustada = [
                    [
                        zona[0][0],
                        (0, $69f04ba581843b2d$export$a4829058f9fe1646)(zona[0][1], objcell.cellX, objcell.zoom)
                    ],
                    [
                        zona[1][0],
                        (0, $69f04ba581843b2d$export$a4829058f9fe1646)(zona[1][1], objcell.cellX, objcell.zoom)
                    ]
                ];
                const zonabounds = L.latLngBounds(zonareajustada);
                if (zonabounds.intersects(celdabounds)) hayIFN = true;
            }
            // si no está en España, asigno mmil a false y ntrees a 0
            if (!hayIFN) mycell[caso] = {
                mmil: false,
                ntrees: 0
            };
        }
        // si no hay datos sigo
        if (!mycell[caso]) {
            // inicializo
            mycell[caso] = {};
            // CACHEO: miro si me puedo ahorrar la petición
            let bingo = false;
            hayMmilLoop: for(const z in candesp)for(const tx in candesp[z]){
                for (const et of candesp[z][tx])if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].mmil) {
                    bingo = true;
                    mycell[caso].mmil = true;
                    mycell[caso].locCluster = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].locCluster;
                    break hayMmilLoop;
                }
            }
            if (!bingo) noHayMmilLoop: for(const z in candgen)for(const tx in candgen[z]){
                for (const et of candgen[z][tx])if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].mmil != undefined && !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].mmil) {
                    bingo = true;
                    mycell[caso].mmil = false;
                    break noHayMmilLoop;
                }
            }
            // FIN CACHEO	
            if (!bingo) {
                qobj.limit = 1;
                qobj.offset = 1000;
                const template = caso === "ifn" ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryTreesinboxbasico : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryEducatreesinbox;
                // hago la llamada a CRAFTS	y espero resultados
                objcell.npc.push(1);
                const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData(template, qobj);
                // inicializo mmil a false
                mycell[caso].mmil = false;
                // analizo primera fila, si la hay
                if (datos.results.bindings.length > 0) {
                    // si hay datos es que hay más de mil árboles
                    mycell[caso].mmil = true;
                    // aprovecho para guardar esa localización para posicionar el cluster
                    mycell[caso].locCluster = {
                        lat: Number(datos.results.bindings[0].lat.value),
                        lng: Number(datos.results.bindings[0].lng.value)
                    };
                }
            }
        }
    }
    // aquí hago un split de ifntrees y de educatrees
    let promesas = [];
    for (let caso of casos)promesas.push($174d363c054274ef$var$getCellTrees(mycell, candgen, objcell, qobj, caso));
    // espero a que terminen todas las promesas
    await Promise.all(promesas);
    // actualizo info del número de consultas y si la celda estaba cacheada (si no hizo falta hacer consultas)
    if (objcell.idtimeout == (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).idTimeoutActualizar) {
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.finalizadas.push(1);
        const totnpc = (0, $2q7Wm.default).reduce(objcell.npc, function(memo, num) {
            return memo + num;
        }, 0);
        if (totnpc == 0) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.cacheadas.push(1);
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).infoCeldas.npc.push(totnpc);
        // actualizo la barra de progreso (sólo si no ha vencido el temporizador)
        if (objcell.progreso) objcell.progreso(true);
    }
    // hacemos el render
    if (objcell.render) objcell.render(objcell);
    // fue todo bien, resuelvo la promesa
    return Promise.resolve();
}
async function $174d363c054274ef$var$getCellTrees(mycell, candgen, objcell, qobj, caso) {
    try {
        // si hay menos de mil árboles y no hay cuenta de trees, hay que calcularlo
        if (!mycell[caso].mmil && mycell[caso].ntrees == undefined) {
            // CACHEO: miro si me puedo ahorrar la petición
            let bingo = false;
            // obtengo los zooms de candgen de mayor a menor
            // (para empezar por las celdas de similar tamaño y así ahorrarme la comprobación del bounds)
            const zooms = Object.keys(candgen).map(Number).sort((a, b)=>b - a);
            cuentaLoop: for (const z of zooms){
                for(const tx in candgen[z])for (const et of candgen[z][tx]){
                    // compruebo si la cuenta de una celda más general es 0											
                    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].ntrees == 0) {
                        bingo = true;
                        mycell[caso].ntrees = 0;
                        break cuentaLoop;
                    } else if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].trees != undefined) {
                        bingo = true;
                        // inicializo datos
                        mycell[caso].trees = [];
                        mycell[caso].ntrees = 0;
                        // si no coincide el zoom obtengo los bounds para comprobar si el árbol cae dentro
                        const bounds = z != objcell.zoom ? (0, $0a5d75214fa44e03$export$4e23e15d2ccb71f7)(objcell.cellX, objcell.cellY, objcell.zoom) : null;
                        // miro árbol a árbol en la celda más general en la que me baso							
                        for (const arbiri of (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).celdasArboles[et][caso].trees){
                            const arb = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri];
                            // si no coincide el zoom tengo que comprobar que el árbol esté contenido en la celda
                            const llarb = L.latLng(arb.lat, (0, $69f04ba581843b2d$export$a4829058f9fe1646)(arb.lng, objcell.cellX, objcell.zoom));
                            if (bounds && !bounds.contains(llarb)) continue; // siguiente árbol...
                            // si hay filtro de taxón compruebo que esté incluido
                            if (objcell.taxon) {
                                const spuri = (0, $1ee989753a15371d$export$fa0799b379eb3758)(arb.species);
                                if (spuri == undefined || !(0, $2q7Wm.default).contains((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).especies[objcell.taxon].expuris, spuri)) continue; // siguiente árbol...
                            }
                            // si llega aquí está todo bien e incluyo los datos
                            mycell[caso].trees.push(arbiri);
                            mycell[caso].ntrees++;
                        }
                        break cuentaLoop;
                    }
                }
            }
            // FIN CACHEO			
            if (!bingo) {
                // pido número de árboles de la celda
                // hago la llamada a CRAFTS	y espero resultados
                objcell.npc.push(1);
                const temp = caso === "ifn" ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryCountTreesinbox : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryCountEducatreesinbox;
                const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData(temp, qobj);
                // inicializo (por si acaso, pero no debería hacer falta)
                mycell[caso].ntrees = 0;
                // guardo el dato de la cuenta
                for (const row of datos.results.bindings)mycell[caso].ntrees = Number(row.count.value);
            }
        }
        // pido los datos de los árboles de la celda si no los tiene y si pasa el umbral
        if (!mycell[caso].mmil && mycell[caso].ntrees <= (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold && mycell[caso].ntrees > 0 && mycell[caso].trees == undefined) {
            // quito offset y pongo un límite de  1000, más que suficiente para la petición
            delete qobj.offset;
            qobj.limit = 1000;
            // hago la llamada a CRAFTS	y espero resultados
            objcell.npc.push(1);
            const temp = caso === "ifn" ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryTreesinbox : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryEducatreesinbox;
            const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData(temp, qobj);
            // inicializo array resultados
            mycell[caso].trees = [];
            // analizo fila a fila
            for (const row of datos.results.bindings){
                // uri del árbol
                const arbiri = row.tree.value;
                // incluyo en la celda si no estaba
                if (!(0, $2q7Wm.default).contains(mycell[caso].trees, arbiri)) mycell[caso].trees.push(arbiri);
                // guardo objeto con datos del árbol si no estaba
                if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri] == undefined) {
                    // aquí divido el procesamiento según el caso
                    if (caso === "ifn") {
                        if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri] == undefined) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri] = {};
                        let arbobj = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri];
                        // guardo uri (sólo si no existía)
                        // NOTA: para árboles del IFN uso clave "uri" en vez de "iri"
                        // así los distingo fácilmente de los edutrees
                        if (arbobj.uri == undefined) arbobj.uri = arbiri;
                        // guardo posición (sólo si no existía)
                        if (arbobj.lat == undefined) arbobj.lat = Number(row.lat.value);
                        if (arbobj.lng == undefined) arbobj.lng = Number(row.lng.value);
                        // guardo cada medida (sólo si no existían)
                        if (arbobj.dbh1mm == undefined) arbobj.dbh1mm = Number(row.dbh1mm.value);
                        if (arbobj.dbh2mm == undefined) arbobj.dbh2mm = Number(row.dbh2mm.value);
                        if (arbobj.heightM == undefined) arbobj.heightM = Number(row.heightM.value);
                        // guardo especie (sólo si no existía)
                        if (arbobj.species == undefined && row.type != undefined) arbobj.species = row.type.value;
                    } else (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[arbiri] = {
                        "iri": arbiri,
                        "lat": Number(row.lat.value),
                        "lng": Number(row.lng.value),
                        "pending": true // clave para recuperar los datos en la siguiente petición
                    };
                }
            }
        }
        // caso "edu", recupero árboles si es necesario
        if (caso === "edu" && mycell[caso].trees != undefined) {
            // obtengo los edutrees pendientes de recuperar
            let eiris = [];
            for (const eiri of mycell[caso].trees)if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[eiri].pending) eiris.push(eiri);
            // pido descomponer en objetos para la llamada resources de CRAFTS	
            const objrs = $174d363c054274ef$var$descomponerCraftsResources("BasicEducaTree", eiris);
            // ya tengo los objetos a pedir, lanzo las peticiones en paralelo a CRAFTS
            let promesas = [];
            for (const objr of objrs)// creo una promesa para cada petición
            promesas.push(new Promise(async function(resolve, reject) {
                try {
                    // hago la llamada a CRAFTS	y espero resultados
                    objcell.npc.push(1);
                    let datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.resourcesTemplate, objr);
                    // convierto en array si es necesario
                    if (!Array.isArray(datos)) datos = [
                        datos
                    ];
                    // y actualizo educatree a educatree
                    for (const eobj of datos)// si está pendiente reemplazo y a volar
                    if ((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[eobj.iri].pending) (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).arboles[eobj.iri] = eobj;
                    // resuelvo la promesa
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }));
            try {
                // espero a que terminen todas las promesas
                await Promise.all(promesas);
            } catch (err) {
                console.error(err);
            }
        }
        // si hay que colocar un cluster entonces obtengo la localización de un árbol aleatorio de 0 a config.treeThreshold
        if (!mycell[caso].mmil && mycell[caso].ntrees > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).treeThreshold && mycell[caso].locCluster == undefined) {
            // número aleatorio entre 0 y mycell[caso].ntrees (en vez de config.treeThreshold)
            qobj.offset = Math.floor(Math.random() * mycell[caso].ntrees);
            qobj.limit = 1; // sólo quiero un árbol
            // hago la llamada a CRAFTS	y espero resultados
            objcell.npc.push(1);
            const template = caso === "ifn" ? (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryTreesinboxbasico : (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig.queryEducatreesinbox;
            const datos = await (0, $ffd94e1d81f19b1c$export$afbe3be7a2115be4).getData(template, qobj);
            // inicializo la localización
            mycell[caso].locCluster = null;
            // analizo primera fila, si la hay
            if (datos.results.bindings.length > 0) mycell[caso].locCluster = {
                lat: Number(datos.results.bindings[0].lat.value),
                lng: Number(datos.results.bindings[0].lng.value)
            };
        }
        // fue todo bien, resuelvo la promesa
        return Promise.resolve();
    } catch (err) {
        // si hay algún error rechazo la promesa
        console.error(err);
        return Promise.reject(err);
    }
}







/////////////////////////
// INICIALIZACIÓN FIREBASE
/////////////////////////
let $c0304d280c7b00cb$var$app;
let $c0304d280c7b00cb$var$provider;
function $c0304d280c7b00cb$export$54387eca9e368edc() {
    // TODO: config.firebaseConfig.authDomain: "localhost", // cambiar en producción a "educawood.gsic.uva.es",
    if (!$c0304d280c7b00cb$var$app) $c0304d280c7b00cb$var$app = (0, $fhN3L.initializeApp)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).firebaseConfig);
    return $c0304d280c7b00cb$var$app;
}
/////////////////////////
// AUTENTICACIÓN FIREBASE
/////////////////////////
function $c0304d280c7b00cb$export$bba3f520b3fdb18() {
    // inicialización
    $c0304d280c7b00cb$var$provider = new (0, $6AR8M.GoogleAuthProvider)();
    const auth = (0, $6AR8M.getAuth)();
    auth.useDeviceLanguage();
    // handler para detectar si hay usuario
    (0, $6AR8M.onAuthStateChanged)(auth, async (user)=>{
        if (user) {
            // User is signed in, see docs for a list of available properties
            // https://firebase.google.com/docs/reference/js/firebase.User
            //var uid = user.uid;
            // ...
            console.info("Usuario conectado: " + user.uid);
            // guardo el usuario en la sesión
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario = user;
            // envío datos signin a GA
            (0, $067277e156f7a571$export$7329bcdc3edcd90e)("login", {
                method: "Google",
                uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid
            });
            // muestro avatar con dropdown de signout (MAPA)
            const htmluser = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$d4de91556d149ac6), {
                "img": (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usuario").html(htmluser);
            // pido a CRAFTS los datos del usuario si no lo tengo
            await (0, $174d363c054274ef$export$3f90b926bc531097)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid);
        } else {
            //console.warn("EL USUARIO SE SALIÓ..."); // 
            console.info("El usuario se sali\xf3...");
            // envío datos signout a GA
            (0, $067277e156f7a571$export$7329bcdc3edcd90e)("sign_out");
            // borro usuario de la sesión
            delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario;
            // muestro botón de signin (MAPA)
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usuario").html((0, $646ceeeec66fabd8$export$eaebbbf45ac961b6));
        }
        // pongo listeners a clickViewprofile, clickSignin y clickSignout
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").click($c0304d280c7b00cb$export$f98b6673fafc0e20);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignin").click($c0304d280c7b00cb$export$9ffe63492d76c086);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").click($c0304d280c7b00cb$export$daa0a882204fd973);
        // ajustes del mapa botón de creación
        (0, $3a9989d46007ef73$export$7c626a07c7c69914)();
        // AJUSTES SEGÚN LA PANTALLA
        switch((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path){
            case "user":
                // regenero página usuario
                $c0304d280c7b00cb$var$renderUsuario();
                break;
            case "lasttrees":
                // regenero página lasttrees
                (0, $82a71c896f160eac$export$afe524c3a091be69)();
                break;
            case "tree":
                // regenero página árbol
                (0, $27fe9e683b34e1a0$export$d096c03518bc83df)();
                break;
            case "newtree":
                // regenero formulario creación árbol
                (0, $3a9989d46007ef73$export$da02fee09afb84d)();
                break;
        } // fin del switch		
    });
}
function $c0304d280c7b00cb$export$9ffe63492d76c086(e) {
    e.preventDefault(); // Prevent the default behavior of the hyperlink
    const auth = (0, $6AR8M.getAuth)();
    (0, $6AR8M.signInWithRedirect)(auth, $c0304d280c7b00cb$var$provider);
}
function $c0304d280c7b00cb$export$daa0a882204fd973(e) {
    e.preventDefault(); // Prevent the default behavior of the hyperlink
    const auth = (0, $6AR8M.getAuth)();
    (0, $6AR8M.signOut)(auth);
}
function $c0304d280c7b00cb$export$f98b6673fafc0e20() {
    // voy a la página del usuario							
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.path = "user";
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid;
    // reajusto url y creo nueva página en la historia
    history.pushState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
    (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).npags++; // una página más
    // cargoURL => me llevará a verUsuario
    (0, $ffd94e1d81f19b1c$export$db4341b92d8f97b0)();
}
////////////////////
// PÁGINA DE USUARIO
////////////////////
async function $c0304d280c7b00cb$export$d4acb3475854cdbb(noborrarcache) {
    // pongo spinner con mensaje de cargando	
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html((0, $646ceeeec66fabd8$export$27eb5f8cf2bf64a7));
    window.scrollTo(0, 0);
    // inicializo el evento para enviar a GA
    (0, $067277e156f7a571$export$639f48199cd2287d)({
        content_type: "user",
        content_id: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid,
        crafts_reqs: 0
    });
    // quito el cacheo si se trata del usuario de la sesión (porque puede haber producido datos nuevos)
    if (!noborrarcache && (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario && (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid === (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid) {
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid];
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid];
        delete (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid];
    }
    // pido datos a CRAFTS del usuario
    await (0, $174d363c054274ef$export$3f90b926bc531097)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid);
    // pido datos a CRAFTS de las páginas de educatrees del usuario
    const pe = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe : 0; // por defecto la 0
    const pae = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae : 0; // por defecto la 0
    await (0, $174d363c054274ef$export$5f671086e5404234)(pe, pae, (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid);
    // si están mal ajustadas las páginas (por no tener resultados y no ser 0), reajusto la URL
    let actualizar = false;
    if (pe > 0 && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid][pe].length == 0) {
        delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe;
        actualizar = true;
    }
    if (pae > 0 && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid][pae].length == 0) {
        delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae;
        actualizar = true;
    }
    if (actualizar) {
        //console.log("URL nueva: "+obtenerURL());
        // actualizo URL
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
        // y cargo la URL para que obtenga los datos de nuevo
        //cargarURL();
        $c0304d280c7b00cb$export$d4acb3475854cdbb(true);
        return;
    }
    // caso normal: hago el render
    $c0304d280c7b00cb$var$renderUsuario();
}
async function $c0304d280c7b00cb$var$renderUsuario() {
    // detecto llamada espúrea por la autenticación
    if (!(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid] || !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid] || !(0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid]) return;
    // obtengo info básica del usuario
    const iri = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).edubase + "/user/" + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    const udata = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid];
    const uname = (0, $96abbdd7193a3c4b$export$6efd817d0963408a)(udata);
    const usesion = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario && (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.uid === (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid;
    const ufecha = (0, $96abbdd7193a3c4b$export$aa350b96d91cd94)(udata);
    const pe = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pe : 0; // por defecto la 0
    const pae = (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.pae : 0; // por defecto la 0
    // resto el número de árboles del de anotaciones (incluidas en las consultas)
    const numanots = udata.numberOfAnnotations ? udata.numberOfEducatrees ? udata.numberOfAnnotations - udata.numberOfEducatrees : udata.numberOfAnnotations : null;
    // si hay nick reajusto título de la página
    if (udata.nick) document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(udata.nick) + " - EducaWood";
    // si no tiene ninguna anotación y no es el usuario de la sesión, asumo que no existe
    if (!udata.numberOfAnnotations && !udata.numberOfEducatrees && !usesion) {
        $c0304d280c7b00cb$var$usuarioNoExiste();
        return;
    }
    // preparo objeto plantilla
    const objut = {
        uid: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid,
        usuario: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario != undefined,
        usuarioImg: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL : null,
        name: uname,
        nickButtonLabel: usesion ? udata.nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeNick) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newNick) : null,
        img: usesion ? (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).usuario.photoURL : null,
        activeLabel: udata.created ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).userActive) + ufecha : null,
        master: udata.isMasterAnnotator,
        cannotAnnotate: udata.cannotAnnotate,
        edutreesLabel: udata.numberOfEducatrees ? udata.numberOfEducatrees == 1 ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).oneTreeCreated) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).multipleTreesCreated).replace("%d", udata.numberOfEducatrees) : null,
        annotationsLabel: numanots ? numanots == 1 ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).oneAnnotation) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).multipleAnnotations).replace("%d", numanots) : null,
        showann: (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.showann
    };
    // ultEducatrees
    const uet = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultEducatrees[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid][pe];
    objut.hayUltedutrees = uet.length > 0;
    objut.hayUltedutreesPrev = pe > 0;
    objut.hayUltedutreesSig = uet.length > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).pageus;
    objut.pagUltedutrees = pe + 1;
    objut.ultedutrees = [];
    for(let i = 0; i < uet.length && i < (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).pageus; i++){
        const uetel = uet[i];
        const etid = uetel.iri.split("/")[uetel.iri.split("/").length - 1];
        // cojo primero el nick en Datos.educatrees[iri] (por si actualizó su nick),
        // en segunda opción el nick del objeto y si no, el etid
        const etl = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uetel.iri].nick) : uetel.nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(uetel.nick) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + " " + etid;
        const htmledutree = '<a href="/tree/' + etid + '" etid="' + etid + '" class="educatree">' + etl + '</a><div class="text-muted">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).createdOn) + (0, $96abbdd7193a3c4b$export$aa350b96d91cd94)(uetel) + "</div>";
        objut.ultedutrees.push(htmledutree);
    }
    // ultAnotaciones
    const uaet = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).ultAnotaciones[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid][pae];
    objut.hayUltanns = uaet.length > 0;
    objut.hayUltannsPrev = pae > 0;
    objut.hayUltannsSig = uaet.length > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).pageus;
    objut.pagUltanns = pae + 1;
    objut.ultanns = [];
    for(let i = 0; i < uaet.length && i < (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).pageus; i++){
        const uaetel = uaet[i];
        const etid = uaetel.iri.split("/")[uaetel.iri.split("/").length - 1];
        // cojo primero el nick en Datos.educatrees[iri] (por si actualizó su nick),
        // en segunda opción el nick del objeto y si no, el etid
        const etl = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri] && (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri].nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).educatrees[uaetel.iri].nick) : uaetel.nick ? (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(uaetel.nick) : (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + " " + etid;
        // preparo htmlann con cuidado
        //const label = getLiteral(config.annotationTypeLabels.[uaetel.type], getLiteral(config.annotationTypeLabels.pordefecto))
        const atl = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).annotationTypeLabels[uaetel.type];
        const htmlann = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)(atl, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).annotationTypeLabels.pordefecto)) + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).ofTree) + ' <a href="/tree/' + etid + '" etid="' + etid + '" class="educatree">' + etl + '</a><div class="text-muted">' + (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).annotatedOn) + (0, $96abbdd7193a3c4b$export$aa350b96d91cd94)(uaetel) + "</div>";
        objut.ultanns.push(htmlann);
    }
    // renderizo
    const htmlcontent = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, $646ceeeec66fabd8$export$a76d078e0f25e96f), objut);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(htmlcontent);
    // envío GA evento ver página usuario
    (0, $067277e156f7a571$export$6adbd77fe07ba13)();
    console.info("P\xe1gina usuario cargada: " + iri);
    // pongo listener de botones de volver
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".goback").on("click", (0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f));
    // pongo listeners a clickViewprofile, clickSignin y clickSignout
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".userprofile").click($c0304d280c7b00cb$export$f98b6673fafc0e20);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignin").click($c0304d280c7b00cb$export$9ffe63492d76c086);
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".usersignout").click($c0304d280c7b00cb$export$daa0a882204fd973);
    // listener a changeNick
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#changeNick").click($c0304d280c7b00cb$var$changeNick);
    // handlers de páginas
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".pagina").click(function() {
        // detecto target de la página
        let target = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("created") ? "pe" : "pae";
        (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.showann = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("annotated");
        // detecto si retrocedo o avanzo
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("prev")) {
            (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]--;
            if ((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target] == 0) delete (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target];
        } else if (!(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]) (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target] = 1;
        else (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado[target]++;
        // actualizo URL
        history.replaceState((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado, "", (0, $ffd94e1d81f19b1c$export$e5c8c113a1c69275)());
        // y cargo la URL para que obtenga los datos de nuevo
        $c0304d280c7b00cb$export$d4acb3475854cdbb(true);
    });
}

function $c0304d280c7b00cb$var$changeNick() {
    // preparo contenido modal
    let tit = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newNick);
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        static: true
    }, tit, (0, $646ceeeec66fabd8$export$af3959eda01cc433), (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).cambiarNick);
    // muestro modal
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    // listener de cambio de nick
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newNick").change(function() {
        const newnick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newNick").val();
        // preinicializo
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").removeClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").prop("disabled", true);
        if (!newnick) //console.log("No hay nada");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).noNick));
        else if (newnick.length < 3) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickTooshort));
        else if (newnick.length > 20) //console.log("Fuera de rango");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickToolong));
        else {
            //console.log("Todo OK");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").addClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").prop("disabled", false);
        }
    });
    // listener del botón de cambio de nick
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").click(async function() {
        // desabilito la entrada, cambio el tip y quito el footer
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newNick").prop("disabled", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").removeClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).checkingNick));
        (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
            vertcent: true,
            static: true,
            nofooter: true
        }, null, null, null);
        // recupero el nick y compruebo si existe
        const newnick = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newNick").val();
        const existe = await (0, $174d363c054274ef$export$9efbb920d7dd157b)(newnick);
        if (existe) {
            // no puede hacerse el cambio
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                vertcent: true,
                static: true,
                nofooter: false
            }, null, null, null);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newNick").prop("disabled", false);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").text((0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).nickTaken));
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#botonCambioNick").prop("disabled", true);
        } else {
            // inicializo evento nuevo nick a GA
            (0, $067277e156f7a571$export$639f48199cd2287d)({
                value: newnick,
                crafts_reqs: 0
            });
            // vamos con el cambio
            try {
                // preparo patch con el cambio de nick
                const patch = [];
                const oper = (0, $ffd94e1d81f19b1c$export$af4650068b70eb5d).usuarios[(0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid].nick ? "replace" : "add";
                patch.push({
                    op: oper,
                    path: "/nick",
                    value: newnick
                });
                //console.log(patch);
                await (0, $174d363c054274ef$export$b5be548bb8509ea6)((0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid, patch);
                // envío evento nuevo nick a GA
                (0, $067277e156f7a571$export$6adbd77fe07ba13)("new_nick");
                console.info("Nick del usuario cambiado: " + newnick);
            } catch (err) {
                console.error(err.message);
                // actualizo modal
                const be = "<code>" + err.message + "\n" + JSON.stringify(err.error) + "</code>";
                (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                    static: true,
                    vertcent: true
                }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeNickFailure), be, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).anotacionError);
                return; // terminamos
            }
            // modal de éxito
            // escondo campos y muestro imagen
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#newNick").addClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#statusNick").addClass("d-none");
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgNewNick").attr("src", new URL($b77e1f82c366e25b$exports));
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#imgNewNick").removeClass("d-none");
            //const htmlbody = '<img src="/app/images/newNick.png" class="d-block w-100">';
            (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
                vertcent: true,
                static: true
            }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).changeNickSuccess), null, (0, $646ceeeec66fabd8$export$3fc5053bf2a10407).nickCambiado);
            // listener cierre modal
            document.getElementById("mimodal").addEventListener("hidden.bs.modal", (event)=>{
                $c0304d280c7b00cb$var$renderUsuario();
            }, {
                once: true
            });
        }
    });
}
function $c0304d280c7b00cb$var$usuarioNoExiste() {
    // pongo página en blanco
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html("");
    // pongo un modal
    const body = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorUserText) + ' "' + (0, $ffd94e1d81f19b1c$export$7d414ec76c8c1259).estado.etid + '".';
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        nofooter: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorUserTitle), body, null);
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    // handler al esconderse
    document.getElementById("mimodal").addEventListener("hidden.bs.modal", (event)=>{
        // voy para atrás
        (0, $ffd94e1d81f19b1c$export$28fca2ccfd38b8f)();
    }, {
        "once": true
    });
}


/*
   Copyright 2023, Guillermo Vega-Gorgojo
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at
       http://www.apache.org/licenses/LICENSE-2.0
   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ 
var $33Kba = parcelRequire("33Kba");


/////////////// SOLR
function $3d46cc2f44b0084a$export$cb8a624b93d2efe9(suggestPath, selectPath) {
    // inicialización de opciones
    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    };
    // test 
    this.test = async function() {
        // pruebo las sugerencias
        //console.debug(suggestPath);
        const sug = await fetch(suggestPath, options);
        if (sug.ok) {
            // fue bien, pruebo la selección
            //console.debug(selectPath);
            const sel = await fetch(selectPath, options);
            if (sel.ok) return Promise.resolve(true);
            else {
                // logging del error
                const mens = "SOLR error - url: " + selectPath + " - code: " + sel.status + " - mens: " + sel.statusText;
                // rechazo la promesa
                return Promise.reject(mens);
            }
        } else {
            // logging del error
            const mens = "SOLR error - url: " + suggestPath + " - code: " + sug.status + " - mens: " + sug.statusText;
            // rechazo la promesa
            return Promise.reject(mens);
        }
    };
    // petición sugerencias
    this.getSuggestions = async function(input) {
        // preparo la url de la petición
        const url = suggestPath + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.suggestTemplate, {
            "input": input
        });
        // hago petición
        const datos = await this.getData(url);
        return datos;
    };
    // petición documento
    this.getDocument = async function(id) {
        // preparo la url de la petición
        const url = selectPath + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.selectTemplate, {
            "id": id
        });
        // hago petición
        const datos = await this.getData(url);
        return datos;
    };
    this.getData = async function(url) {
        // hago log de la url
        //console.debug(url);
        // hago la petición
        const response = await fetch(url, options);
        if (response.ok) {
            // petición exitosa
            const datos = await response.json();
            // devuelvo los datos
            return Promise.resolve(datos);
        } else {
            const eobj = {
                status: response.status,
                url: url,
                mens: "SOLR error - url: " + url + " - code: " + response.status + " - mens: " + response.statusText
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
}
/////////////// CRAFTS
function $3d46cc2f44b0084a$export$c5d3759345e26cd8(craftsConfig) {
    // inicialización de opciones
    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": craftsConfig.auth
        }
    };
    // test 
    this.test = async function() {
        // ajusto método
        options.method = "GET";
        // hago log de la url de prueba
        console.debug(craftsConfig.api);
        const response = await fetch(craftsConfig.api, options);
        if (response.ok) return Promise.resolve(true);
        else {
            // logging del error
            // leo la respuesta del error
            const resperr = await response.json();
            const eobj = {
                message: "CRAFTS error: " + resperr.message,
                error: {
                    url: craftsConfig.api,
                    status: response.status,
                    statusText: response.statusText
                }
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
    // petición tipo GET de CRAFTS
    this.getData = async function(template, objpars) {
        // ajusto método y body
        options.method = "GET";
        delete options.body;
        // preparo la url de la petición
        const url = craftsConfig.api + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(template, objpars);
        // hago log de la url
        console.debug(url);
        // info para GA
        (0, $067277e156f7a571$export$2db6ab9500fc86e)("crafts_reqs", 1);
        // hago la petición
        const response = await fetch(url, options);
        if (response.ok) {
            // petición exitosa
            const datos = await response.json();
            // devuelvo los datos
            return Promise.resolve(datos);
        } else {
            // leo la respuesta del error
            const resperr = await response.json();
            const eobj = {
                message: "CRAFTS error: " + resperr.message,
                error: {
                    url: url,
                    status: response.status,
                    statusText: response.statusText
                }
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
    // petición tipo PUT de CRAFTS
    this.putData = async function(template, objpars, objdata) {
        // ajusto método y body
        options.method = "PUT";
        if (objdata) options.body = JSON.stringify(objdata);
        // preparo la url de la petición
        const url = craftsConfig.api + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(template, objpars);
        // hago log de la url
        console.debug(url);
        // info para GA
        (0, $067277e156f7a571$export$2db6ab9500fc86e)("crafts_reqs", 1);
        // hago la petición
        const response = await fetch(url, options);
        if (response.ok) // devuelvo la respuesta
        return Promise.resolve(response);
        else {
            // leo la respuesta del error
            const resperr = await response.json();
            const eobj = {
                message: "CRAFTS error: " + resperr.message,
                error: {
                    url: url,
                    status: response.status,
                    statusText: response.statusText
                }
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
    // petición tipo PATCH de CRAFTS
    this.patchData = async function(template, objpars, objdata) {
        // ajusto método y body
        options.method = "PATCH";
        if (objdata) options.body = JSON.stringify(objdata);
        // preparo la url de la petición
        const url = craftsConfig.api + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(template, objpars);
        // hago log de la url
        console.debug(url);
        // info para GA
        (0, $067277e156f7a571$export$2db6ab9500fc86e)("crafts_reqs", 1);
        // hago la petición
        const response = await fetch(url, options);
        if (response.ok) // devuelvo la respuesta
        return Promise.resolve(response);
        else {
            // leo la respuesta del error
            const resperr = await response.json();
            const eobj = {
                message: "CRAFTS error: " + resperr.message,
                error: {
                    url: url,
                    status: response.status,
                    statusText: response.statusText
                }
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
    // petición tipo DELETE de CRAFTS
    this.deleteData = async function(template, objpars) {
        // ajusto método y body
        options.method = "DELETE";
        delete options.body;
        // preparo la url de la petición
        const url = craftsConfig.api + (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(template, objpars);
        // hago log de la url
        console.debug(url);
        // info para GA
        (0, $067277e156f7a571$export$2db6ab9500fc86e)("crafts_reqs", 1);
        // hago la petición
        const response = await fetch(url, options);
        if (response.ok) // devuelvo la respuesta
        return Promise.resolve(response);
        else {
            // leo la respuesta del error
            const resperr = await response.json();
            const eobj = {
                message: "CRAFTS error: " + resperr.message,
                error: {
                    url: url,
                    status: response.status,
                    statusText: response.statusText
                }
            };
            // rechazo la promesa
            return Promise.reject(eobj);
        }
    };
}













// variables globales
let $ffd94e1d81f19b1c$export$7d414ec76c8c1259, $ffd94e1d81f19b1c$export$af4650068b70eb5d, $ffd94e1d81f19b1c$export$89312ce47c0ca777, $ffd94e1d81f19b1c$export$aabd6129ce9bddee, $ffd94e1d81f19b1c$export$6573f87b6f05c3d2, $ffd94e1d81f19b1c$export$afbe3be7a2115be4, $ffd94e1d81f19b1c$export$c398d137cd63b259;
// llamo a inicializar
$ffd94e1d81f19b1c$var$inicializar();
// INICIALIZACIÓN APLICACIÓN
async function $ffd94e1d81f19b1c$var$inicializar() {
    // genero plantillas HTML
    (0, $646ceeeec66fabd8$export$5e43259f1480bd05)();
    // INICIALIZO Layers
    $ffd94e1d81f19b1c$export$89312ce47c0ca777 = {};
    // INICIALIZACIÓN SESIÓN
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259 = {};
    // inicializo número de páginas en la historia para controlar el ir hacia atrás
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags = 0;
    // inicializo timeouts
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.timeout = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).timeout;
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.huboTimeout = false;
    // bloqueo para pintar
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = false; // bloqueo si se está actualizando el mapa
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.mapaMovido = false; // detecto si el mapa se movió para actualizar
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.idTimeoutActualizar = null; // id del timeout para actualización automática (para que no se bloquee)
    // no está dibujando el polígono de descarga
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.poligonero = false;
    // flag creación árbol
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.creandoArbol = false;
    // estado de la sesión (construido a partir de la URL)
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado = {};
    // inicialización zoom
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.zoom = undefined;
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.zoomPrevio = undefined;
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.zoomUsados = {}; // guardo los zooms usados en el mapa para facilitar el cacheo
    // progreso y estadísticos
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.infoCeldas = {};
    // inicializo nombres científicos con el valor de nomci en local storage o false
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.nomci = localStorage.getItem("nomci") === "true" ? true : false;
    //datos del filtro de taxón
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.tx = undefined;
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.txPrevio = undefined;
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.txUsados = {}; // guardo los taxones usados en el mapa para facilitar el cacheo
    // inicializo sugerencias taxones 
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.txfocus = -1;
    // inicializo color a uno de los posibles
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.txcolor = (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).coltxinds[Math.floor(Math.random() * (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).coltxinds.length)];
    // inicializo las celdas y árboles pintados
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.celdasPintadas = {};
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.arbsPintados = {};
    // muestro tooltips si no es un touchscreen
    //Sesion.hayTooltips = 'ontouchstart' in window? false : true;
    // INICIALIZO DATOS
    $ffd94e1d81f19b1c$export$af4650068b70eb5d = {};
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.especies = {};
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.partesPlantasFoto = {};
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.arboles = {}; // aquí meto la información de cada árbol del mapa
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.educatrees = {}; // aquí meto la información de los educatrees para edición
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.cellSide = {}; // aquí calculo el lado de cada celda por nivel de zoom
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.celdasArboles = {}; // aquí meto la info de árboles de cada celda
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.usuarios = {}; // aquí obtengo los datos de los usuarios (posiblemente 0 o 1)
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.ultEducatrees = {}; // aquí obtengo el listado paginado de los últimos educatrees creados tanto globales (key: "global") como por usuario (key: uid) 
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.ultAnotaciones = {}; // aquí obtengo el listado paginado de las últimas anotaciones a educatrees anotados tanto globales (key: "global") como por usuario (key: uid) 
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.urlAPIWD = {}; // aquí guardo las respuestas de la API de Wikidata
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.esTaxonWD = {}; // aquí guardo si una entidad de Wikidata es un taxón (según la consulta validTaxons)
    $ffd94e1d81f19b1c$export$af4650068b70eb5d.taxonesWD = {}; // aquí guardo los datos de los taxones extraídos de Wikidata (recurso WikidataTaxon)
    // CARGA INICIAL DE LA URL
    // 1) carga localización si la hay
    // 2) carga taxon sin comprobar existencia
    // 3) ajusta vista
    // 4) no hace nada en el mapa (que no está aún creado)
    $ffd94e1d81f19b1c$export$db4341b92d8f97b0(true);
    // SI NO HAY POSICIÓN INICIAL Y ESTÁ EN MODO MAPA, CARGO LA DE LA CONFIGURACIÓN Y PEDIRÉ GEOPOSICIONAR
    let pedirgeopos = false;
    if (!$ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc) {
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc = {
            lat: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geolocstart[0],
            lng: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).geolocstart[1],
            z: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zStart
        };
        if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "map" && !localStorage.getItem("tourCompletado")) pedirgeopos = true;
    }
    // CARGO MAPA CON LA LOCALIZACIÓN DE LA CONFIGURACIÓN
    // meto tap: false, que parece es una fuente de problemas
    // dec-23: incluyo scrollWheelZoom: 'center' para reducir saltos raros con el zoom en el ratón de Apple
    // dec-23: pongo preferCanvas: true que mejora mucho el borrado (y el resto parece que sigue bien)	
    $ffd94e1d81f19b1c$export$aabd6129ce9bddee = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).map("mimapa", {
        zoomControl: false,
        tap: false,
        scrollWheelZoom: "center",
        preferCanvas: true
    }).setView([
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.lat,
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.lng
    ], $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.z);
    // cargo el tile layer que corresponda tras cargar la URL
    const { url: url, opts: opts } = (0, $69f04ba581843b2d$export$c1c1414601191e71)(false);
    $ffd94e1d81f19b1c$export$6573f87b6f05c3d2 = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).tileLayer(url, opts).addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee);
    // REPOSICIONO CONTROLES DE ZOOM Y MUESTRO ESCALA DEL MAPA
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.scale({
        imperial: false,
        position: "bottomright"
    }).addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee); // sin la escala imperial
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).Browser.mobile) (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.zoom({
        position: "bottomright",
        zoomInTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomin),
        zoomOutTitle: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).zoomout)
    }).addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee);
    // INCLUYO BOTÓN DE MI LOCALIZACIÓN CON Leaflet.Locate (ver https://github.com/domoritz/leaflet-locatecontrol)
    (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).control.locate({
        position: "bottomright",
        icon: "bi bi-geo-fill",
        locateOptions: {
            animate: true,
            duration: 1
        },
        initialZoomLevel: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zCreacion,
        flyTo: true,
        showPopup: false,
        drawCircle: false,
        showCompass: true,
        strings: {
            title: (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).mylocation)
        }
    }).addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee);
    // cambio estilo del control de mi posición y mando evento de activate_my_location o deactivate_my_location a GA
    $ffd94e1d81f19b1c$export$aabd6129ce9bddee.on("locateactivate", function(e) {
        // estilo botón en modo edición
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-control-locate a").attr("style", "background-color: #6c757d;");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-control-locate a span").attr("style", "color: white;");
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
            content_type: "activate_my_location"
        });
    });
    $ffd94e1d81f19b1c$export$aabd6129ce9bddee.on("locatedeactivate", function(e) {
        // estilo botón normal
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-control-locate a").removeAttr("style");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(".leaflet-control-locate a span").removeAttr("style");
        (0, $067277e156f7a571$export$7329bcdc3edcd90e)("select_content", {
            content_type: "deactivate_my_location"
        });
    });
    // INCLUYO BOTONES DEL MAPA
    (0, $c853be3628706c6e$export$9e6c68482d899bf0)();
    // INICIALIZACIÓN FIREBASE
    (0, $c0304d280c7b00cb$export$54387eca9e368edc)();
    // INICIALIZACIÓN CRAFTS
    console.time("Configuraci\xf3n proveedor de datos");
    $ffd94e1d81f19b1c$export$afbe3be7a2115be4 = new (0, $3d46cc2f44b0084a$export$c5d3759345e26cd8)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).craftsConfig);
    $ffd94e1d81f19b1c$export$afbe3be7a2115be4.test().then(()=>{
        // OK
        console.info("Proveedor de datos funciona");
        console.timeEnd("Configuraci\xf3n proveedor de datos");
        // CARGO PANEL (inicialmente desactivado el filtro de taxón)
        (0, $c853be3628706c6e$export$4412c4bf37c8e3a8)();
        // INICIALIZACIÓN AUTENTICACIÓN FIREBASE
        (0, $c0304d280c7b00cb$export$bba3f520b3fdb18)();
        // CONFIGURACIÓN SOLR
        $ffd94e1d81f19b1c$var$configurarSolr();
        // TODO: ¿hacer lo del puppeteer?
        // DETECCIÓN DE CAMBIOS EN EL MAPA
        $ffd94e1d81f19b1c$export$aabd6129ce9bddee.on("moveend", (0, $69f04ba581843b2d$export$c8207d40f45dcd81));
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.listenerMoveend = true; // para ajustar localización si hay que inicializar a la posición del usuario
        // INICIALIZACIONES CRAFTS
        console.group("Inicializaci\xf3n de datos");
        // obtengo datos de los usos para las teselas
        console.time("Carga de datos partes plantas para fotos");
        (0, $174d363c054274ef$export$c2cc3ce4ebc083ee)().then(()=>{
            console.info("Info de partes plantas para fotos cargada");
            console.timeEnd("Carga de datos partes plantas para fotos");
        }).catch((error)=>console.error(error));
        // obtengo datos de todas las especies	
        console.time("Carga de datos de especies");
        (0, $174d363c054274ef$export$40a5140e3d2b7b8d)().then(()=>{
            console.info("Info de especies cargada");
            console.timeEnd("Carga de datos de especies");
            console.groupEnd();
            // habilito el botón de filtrar por taxón (desactivado hasta ahora)
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#bot_taxones").removeAttr("disabled");
            // AQUÍ SE HACE LA PRIMERA ACTUALIZACIÓN COMPLETA DEL MAPA
            // trato el caso de filtro de taxón
            if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon != undefined && $ffd94e1d81f19b1c$export$af4650068b70eb5d.especies[$ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon] != undefined) (0, $1ee989753a15371d$export$17cdb3d0a52387b4)($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon);
            else $ffd94e1d81f19b1c$export$db4341b92d8f97b0(); // aquí se eliminará el taxon espúreo si lo hubiera
        }).catch((error)=>console.error(error));
    }).catch((error)=>{
        console.error(error);
        console.timeEnd("Configuraci\xf3n proveedor de datos");
        // aviso error
        $ffd94e1d81f19b1c$var$errorProveedorDatosIrrecuperable(error);
    });
    // DETECCIÓN EVENTOS POPSTATE
    // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
    window.onpopstate = function(event) {
        // cargo la URL
        $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
    };
    // DETECCIÓN CLICKS EN ENLACES NAVBAR Y BOTÓN SANDWICH (con event delegation)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(document).on("click", ".navbar-brand", function(e) {
        e.preventDefault(); // Prevents the default behavior of the click event
        e.stopPropagation(); // Stops the propagation of the click event
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(document).on("click", ".nav-link, .dropdown-item", function(event) {
        event.preventDefault(); // Prevent the default behavior of the hyperlink
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("lasttrees")) {
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "lasttrees";
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann;
            // reajusto url y creo nueva página en la historia
            history.pushState($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado, "", $ffd94e1d81f19b1c$export$e5c8c113a1c69275());
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags++; // una página más
            // cargoURL => me llevará a verLasttrees
            $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("map")) {
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe;
            delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann;
            // reajusto url y creo nueva página en la historia
            history.pushState($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado, "", $ffd94e1d81f19b1c$export$e5c8c113a1c69275());
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags++; // una página más
            // cargoURL => me llevará al mapa
            $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("home")) // landing page
        window.location.href = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).homelocrel); //'..';		
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).hasClass("lang")) {
            // recupero y actualizo idioma
            let nlang = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("tag");
            localStorage.setItem("lang", nlang);
            // actualizo plantillas HTML
            (0, $646ceeeec66fabd8$export$5e43259f1480bd05)();
            // actualizo etiquetas mapa
            (0, $c853be3628706c6e$export$789fff39a6a81ff3)();
            // y cargo la URL (para las páginas no mapa)
            $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
        }
    });
    // DETECCIÓN CLICKS EN ENLACES DE USUARIO (con event delegation)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(document).on("click", ".pagusuario", function(event) {
        event.preventDefault(); // Prevent the default behavior of the hyperlink
        // voy a la página del usuario							
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "user";
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("uid");
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae;
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe;
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann;
        // reajusto url y creo nueva página en la historia
        history.pushState($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado, "", $ffd94e1d81f19b1c$export$e5c8c113a1c69275());
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags++; // una página más
        // cargoURL => me llevará a verUsuario
        $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
    });
    // DETECCIÓN CLICKS EN ENLACES DE EDUCATREES (con event delegation)
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(document).on("click", ".educatree", function(event) {
        event.preventDefault(); // Prevent the default behavior of the hyperlink
        // voy a la página del usuario							
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "tree";
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid = (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))(this).attr("etid");
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae;
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe;
        delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann;
        // reajusto url y creo nueva página en la historia
        history.pushState($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado, "", $ffd94e1d81f19b1c$export$e5c8c113a1c69275());
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags++; // una página más
        // cargoURL => me llevará a verEducatree
        $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
    });
    // INICIALIZO LayerGroup DE ÁRBOLES
    $ffd94e1d81f19b1c$export$89312ce47c0ca777.arbs = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).layerGroup().addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee);
    // INICIALIZO LayerGroup DE CLUSTERS DE ÁRBOLES
    $ffd94e1d81f19b1c$export$89312ce47c0ca777.clarbs = (0, (/*@__PURE__*/$parcel$interopDefault($8JYDX))).layerGroup().addTo($ffd94e1d81f19b1c$export$aabd6129ce9bddee);
    // GENERO ICONOS
    (0, $7b115b3c2cee4b53$export$a207d0a28bdc4e1b)();
    // TIMESTAMP ACTUAL (para geoposición y para formulario)
    const ahora = Date.now();
    // VUELO A LA POSICIÓN DEL USUARIO SI QUIERE
    // sólo si usuario no dijo que no anteriormente o ha pasado el barbecho
    if (pedirgeopos && (!localStorage.getItem("timestampPedirLoc") || Number(localStorage.getItem("timestampPedirLoc")) < ahora)) navigator.geolocation.getCurrentPosition(function(pos) {
        // vamos a la localización del usuario
        $ffd94e1d81f19b1c$export$aabd6129ce9bddee.flyTo([
            pos.coords.latitude,
            pos.coords.longitude
        ], (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zLugar, {
            animate: true,
            duration: 1
        });
        // reajusto la localización (si aún no se ha llamado al listener de 'moveend')
        if (!$ffd94e1d81f19b1c$export$7d414ec76c8c1259.listenerMoveend) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
            z: (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).zLugar
        };
    }, function(err) {
        // pongo barbecho si el usuario dijo que no
        // err.code 1 => https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError
        if (err.code == 1) localStorage.setItem("timestampPedirLoc", ahora + (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).mediumQuestGap); // barbecho de 4 días
    }, {
        timeout: 5000,
        maximumAge: 600000
    });
    // INICIALIZACIÓN CUESTIONARIO
    // variables en localStorage
    // timestampPrimeraSesion: timestamp de la primera vez que utilizó el explorador (o que pulsó el botón más tarde)
    // cuestionarioNo: no mostrar más el cuestionario
    // si no había, guardo timestamp primera sesión
    if (!localStorage.getItem("timestampPrimeraSesion")) localStorage.setItem("timestampPrimeraSesion", Date.now());
    // detecto si debo mostrar el cuestionario en la sesión
    const gapinicio = Date.now() - Number(localStorage.getItem("timestampPrimeraSesion"));
    if (gapinicio > (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).interSessionQGap && !localStorage.getItem("cuestionarioNo")) {
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.ponerAlertaCuestionario = true; // puede ponerse el cuestionario en la sesión
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.inicioSesion = Date.now(); // guardo inicio sesión
    } else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.ponerAlertaCuestionario = false;
}
/////////////////////
// CONFIGURACIÓN SOLR
/////////////////////
function $ffd94e1d81f19b1c$var$configurarSolr() {
    //console.group("Inicialización motor de texto");
    console.time("Configuraci\xf3n motor de texto");
    // inicializo Solr
    $ffd94e1d81f19b1c$export$c398d137cd63b259 = new (0, $3d46cc2f44b0084a$export$cb8a624b93d2efe9)((0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.path + (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.suggestHandler, (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.path + (0, (/*@__PURE__*/$parcel$interopDefault($33Kba))).solrConfig.selectHandler);
    $ffd94e1d81f19b1c$export$c398d137cd63b259.test().then(()=>{
        // OK
        console.info("Motor de texto funciona");
        console.timeEnd("Configuraci\xf3n motor de texto");
        // muestro la entrada de los lugares
        (0, $d1e0875cf0f68e21$export$24073cf807c9abc3)(true);
    }).catch((messageError)=>{
        // log del error
        console.error(messageError);
        console.timeEnd("Configuraci\xf3n motor de texto");
        // pongo Solr a null y escondo la entrada de los lugares
        $ffd94e1d81f19b1c$export$c398d137cd63b259 = null;
        (0, $d1e0875cf0f68e21$export$24073cf807c9abc3)(true);
    });
}
////////////////////////
// ERROR PROVEEDOR DATOS
////////////////////////
function $ffd94e1d81f19b1c$var$errorProveedorDatosIrrecuperable(messageError) {
    // ya no tiene sentido pedir datos
    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.errordataprov = true;
    // pongo un modal para avisar de que no se puede explorar el inventario	
    (0, $96abbdd7193a3c4b$export$859065cca4d855fc)({
        vertcent: true,
        nofooter: true
    }, (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorEndpointTitle), (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).errorEndpointText), null);
    const mimodal = new (0, (/*@__PURE__*/$parcel$interopDefault($dktVJ))).Modal(document.getElementById("mimodal"));
    mimodal.show();
    // quito temporizador
    (0, $69f04ba581843b2d$export$7a39c88e7f3f42da)();
}
///////////////////
// CARGA DE LA URL
// la función clave
///////////////////
function $ffd94e1d81f19b1c$export$db4341b92d8f97b0(inicial) {
    //console.warn(window.location);
    // 1) elimino alguna info del estado de la sesión
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path;
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon; // quizá no sea adecuado borrarlo
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid;
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe;
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae;
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann;
    delete $ffd94e1d81f19b1c$export$7d414ec76c8c1259.zoom; // no es estado, pero lo borro para evitar desajustes en las celdas
    // 2) actualizo el estado de la sesión a partir de la URL	
    // parseo del querystring de la URL
    const urlParams = new URLSearchParams(window.location.search);
    // actualizo localización si hay localización y está bien
    // en otro caso no borro la localización que hubiera
    const cadloc = urlParams.get("loc");
    if (cadloc != null) {
        const loc = (0, $96abbdd7193a3c4b$export$6f6326edee345e29)(cadloc);
        if (loc != null) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc = loc;
    }
    // obtengo el path y valido
    const pathels = window.location.pathname.split("/");
    switch(pathels[1]){
        case "user":
            if (pathels[2] != undefined) {
                $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = pathels[1];
                $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid = pathels[2];
                // puede haber como query parámetros pe (num página educatree) y pae (num página educatree anotado)
                if (urlParams.get("pe") != null && /^[1-9]\d*$/.test(urlParams.get("pe"))) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe = Number(urlParams.get("pe"));
                if (urlParams.get("pae") != null && /^[1-9]\d*$/.test(urlParams.get("pae"))) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae = Number(urlParams.get("pae"));
                // también puede haber showann para mostrar las anotaciones
                if (urlParams.get("showann")) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann = true;
            } else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
            break;
        case "lasttrees":
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = pathels[1];
            // puede haber como query parámetros pe (num página educatree) y pae (num página educatree anotado)
            if (urlParams.get("pe") != null && /^[1-9]\d*$/.test(urlParams.get("pe"))) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe = Number(urlParams.get("pe"));
            if (urlParams.get("pae") != null && /^[1-9]\d*$/.test(urlParams.get("pae"))) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae = Number(urlParams.get("pae"));
            // también puede haber showann para mostrar las anotaciones
            if (urlParams.get("showann")) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann = true;
            break;
        case "map":
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = pathels[1];
            if (urlParams.get("ifn") != null && urlParams.get("ifn") === "true") $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.ifn = true;
            else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.ifn = false;
            if (urlParams.get("esri") != null && urlParams.get("esri") === "true") $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.esri = true;
            else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.esri = false;
            break;
        case "tree":
            if (pathels[2] != undefined) {
                $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = pathels[1];
                $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid = pathels[2];
            } else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
            break;
        case "newtree":
            // sólo permito ir si el usuario está logueado y si hay localización
            if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.usuario && $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc != undefined) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = pathels[1];
            else $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
            break;
        default:
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
            break;
    }
    // en modo mapa incluyo filtro de taxón si está presente o si es el caso inicial (antes de cargar las especies)
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "map" && urlParams.get("taxon") != undefined) {
        let tx = urlParams.get("taxon");
        // incluyo el filtro de taxón si caso inicial o si existe
        if (inicial || $ffd94e1d81f19b1c$export$af4650068b70eb5d.especies[tx] != undefined) $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon = tx;
    }
    //3) ajusto vista según el estado del path cargado
    switch($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path){
        case "user":
            // bloqueo actualizaciones del mapa
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = true;
            // quito vista mapa
            $ffd94e1d81f19b1c$var$vistaMapa(false);
            // actualizo título de la página
            document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).user) + " " + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid + " - EducaWood";
            // propiedades meta
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:title']").attr("content", document.title);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:description']").attr("content", "Page of user " + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid + " in EducaWood.");
            // llamo a mostrar la página del usuario
            if (!inicial) (0, $c0304d280c7b00cb$export$d4acb3475854cdbb)();
            break;
        case "lasttrees":
            // bloqueo actualizaciones del mapa
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = true;
            // quito vista mapa
            $ffd94e1d81f19b1c$var$vistaMapa(false);
            // actualizo título de la página
            document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).lastTrees) + " - EducaWood";
            // propiedades meta
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:title']").attr("content", document.title);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:description']").attr("content", "Last trees created in EducaWood.");
            // llamo a mostrar la página de lasttrees
            if (!inicial) (0, $82a71c896f160eac$export$eca36acb6faff6b4)();
            break;
        case "tree":
            // bloqueo actualizaciones del mapa
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = true;
            // quito vista mapa
            $ffd94e1d81f19b1c$var$vistaMapa(false);
            // actualizo título de la página
            document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).tree) + " " + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid + " - EducaWood";
            // propiedades meta
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:title']").attr("content", document.title);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:description']").attr("content", "Page of tree " + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid + " in EducaWood.");
            // llamo a mostrar la página del árbol
            if (!inicial) (0, $27fe9e683b34e1a0$export$c2e76fbffb5b7346)();
            break;
        case "newtree":
            // bloqueo actualizaciones del mapa
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = true;
            // quito vista mapa
            $ffd94e1d81f19b1c$var$vistaMapa(false);
            // actualizo título de la página
            document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).newtree) + " - EducaWood";
            // propiedades meta
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:title']").attr("content", document.title);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:description']").attr("content", "Form for creating a tree in EducaWood.");
            // llamo a mostrar la página de creación del árbol
            if (!inicial) (0, $3a9989d46007ef73$export$966d5c02a501e12b)();
            break;
        case "map":
            // desbloqueo actualizaciones del mapa 
            $ffd94e1d81f19b1c$export$7d414ec76c8c1259.actualizandoMapa = false;
            // pongo vista mapa
            $ffd94e1d81f19b1c$var$vistaMapa(true);
            // actualizo título de la página
            document.title = (0, $96abbdd7193a3c4b$export$177dc95d91ec95d1)((0, (/*@__PURE__*/$parcel$interopDefault($ab6076c88a029044$exports))).map) + " - EducaWood";
            // propiedades meta
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:title']").attr("content", document.title);
            (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:description']").attr("content", "Navigating the map of EducaWood.");
            // si no es la llamada inicial hago más cosas...
            if (!inicial) {
                // centro el mapa en la localización de la sesión
                // esto dispara un evento de mapa movido, disparando su actualización en MODO MAPA
                $ffd94e1d81f19b1c$export$aabd6129ce9bddee.setView([
                    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.lat,
                    $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.lng
                ], $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc.z);
                // incluyo esto para que el mapa se reajuste
                // parece que así se resuelve el problema que había al pasar de recurso a mapa
                // tengo que poner esto después del setview, en otro caso no reacciona al setview
                $ffd94e1d81f19b1c$export$aabd6129ce9bddee.invalidateSize();
                // visualización filtro de taxón
                (0, $1ee989753a15371d$export$99e344fe0d6549db)();
                // actualizo datos IFN
                (0, $c853be3628706c6e$export$87931b6598ef9316)();
                // actualizo mapa base
                (0, $c853be3628706c6e$export$1319329b668abb17)();
                // tour inicial
                if (!localStorage.getItem("tourCompletado")) (0, $2fa03f5d455d6f0a$export$cdda91dfb91997f3)();
            }
            break;
    } // fin del switch
}
function $ffd94e1d81f19b1c$var$vistaMapa(esmapa) {
    // ajuste propiedad meta de la url
    (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("meta[property='og:url']").attr("content", window.location.href);
    if (esmapa) {
        // actualizo viewport (escala fijada)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miviewport").attr("content", "width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no");
        // escondo miarbol y muestro mapa
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(""); // borro contenido página
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimapa").removeClass("d-none");
    } else {
        // actualizo viewport (puede ampliarse)
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miviewport").attr("content", "width=device-width, initial-scale=1, shrink-to-fit=no");
        // escondo mapa y muestro página del árbol
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#mimapa").addClass("d-none");
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").html(""); // borro contenido página
        (0, (/*@__PURE__*/$parcel$interopDefault($6KOho)))("#miarbol").removeClass("d-none");
    }
}
//////////////////////////////////////////////
// GENERACIÓN DE LA URL A PARTIR DE LA SESIÓN
//////////////////////////////////////////////
function $ffd94e1d81f19b1c$export$e5c8c113a1c69275() {
    // preparo la URL base con el path de Sesion.estado.path
    const { protocol: protocol, host: host } = window.location;
    let url = protocol + "//" + host + "/" + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path;
    // caso etid (segunda variable de path)
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid) url += "/" + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.etid;
    // preparo searchpars
    const searchpars = [];
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc && ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "map" || $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "newtree")) searchpars.push("loc=" + (0, $96abbdd7193a3c4b$export$4a32c72e9ff1d1e0)($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.loc));
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.ifn && $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "map") searchpars.push("ifn=true");
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.esri && $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "map") searchpars.push("esri=true");
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon && $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "map") searchpars.push("taxon=" + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.taxon);
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe && ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "user" || $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "lasttrees")) searchpars.push("pe=" + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pe);
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae && ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "user" || $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "lasttrees")) searchpars.push("pae=" + $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.pae);
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.showann && ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "user" || $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path === "lasttrees")) searchpars.push("showann=true");
    // incluyo los searchpars
    for(let i = 0; i < searchpars.length; i++){
        const sep = i == 0 ? "?" : "&";
        url += sep + searchpars[i];
    }
    return url;
}
/////////////////////////////////////////
// PARA IR ATRÁS O AL MAPA SI NO HAY NADA
/////////////////////////////////////////
function $ffd94e1d81f19b1c$export$28fca2ccfd38b8f() {
    // si hay más páginas en la historia simplemente voy para atrás
    if ($ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags > 0) {
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.npags--;
        history.back();
    } else {
        // actualizo path y URL
        $ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado.path = "map";
        history.replaceState($ffd94e1d81f19b1c$export$7d414ec76c8c1259.estado, "", $ffd94e1d81f19b1c$export$e5c8c113a1c69275());
        // y cargo la URL para que me lleve al mapa completo
        $ffd94e1d81f19b1c$export$db4341b92d8f97b0();
    }
}


//# sourceMappingURL=index.09e92034.js.map
